
(function() {
'use strict';

function F2(fun)
{
  function wrapper(a) { return function(b) { return fun(a,b); }; }
  wrapper.arity = 2;
  wrapper.func = fun;
  return wrapper;
}

function F3(fun)
{
  function wrapper(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  }
  wrapper.arity = 3;
  wrapper.func = fun;
  return wrapper;
}

function F4(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  }
  wrapper.arity = 4;
  wrapper.func = fun;
  return wrapper;
}

function F5(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  }
  wrapper.arity = 5;
  wrapper.func = fun;
  return wrapper;
}

function F6(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  }
  wrapper.arity = 6;
  wrapper.func = fun;
  return wrapper;
}

function F7(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  }
  wrapper.arity = 7;
  wrapper.func = fun;
  return wrapper;
}

function F8(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  }
  wrapper.arity = 8;
  wrapper.func = fun;
  return wrapper;
}

function F9(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  }
  wrapper.arity = 9;
  wrapper.func = fun;
  return wrapper;
}

function A2(fun, a, b)
{
  return fun.arity === 2
    ? fun.func(a, b)
    : fun(a)(b);
}
function A3(fun, a, b, c)
{
  return fun.arity === 3
    ? fun.func(a, b, c)
    : fun(a)(b)(c);
}
function A4(fun, a, b, c, d)
{
  return fun.arity === 4
    ? fun.func(a, b, c, d)
    : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e)
{
  return fun.arity === 5
    ? fun.func(a, b, c, d, e)
    : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f)
{
  return fun.arity === 6
    ? fun.func(a, b, c, d, e, f)
    : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g)
{
  return fun.arity === 7
    ? fun.func(a, b, c, d, e, f, g)
    : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h)
{
  return fun.arity === 8
    ? fun.func(a, b, c, d, e, f, g, h)
    : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i)
{
  return fun.arity === 9
    ? fun.func(a, b, c, d, e, f, g, h, i)
    : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

var _elm_lang$core$Native_Bitwise = function() {

return {
	and: F2(function and(a, b) { return a & b; }),
	or: F2(function or(a, b) { return a | b; }),
	xor: F2(function xor(a, b) { return a ^ b; }),
	complement: function complement(a) { return ~a; },
	shiftLeftBy: F2(function(offset, a) { return a << offset; }),
	shiftRightBy: F2(function(offset, a) { return a >> offset; }),
	shiftRightZfBy: F2(function(offset, a) { return a >>> offset; })
};

}();

var _elm_lang$core$Bitwise$shiftRightZfBy = _elm_lang$core$Native_Bitwise.shiftRightZfBy;
var _elm_lang$core$Bitwise$shiftRightBy = _elm_lang$core$Native_Bitwise.shiftRightBy;
var _elm_lang$core$Bitwise$shiftLeftBy = _elm_lang$core$Native_Bitwise.shiftLeftBy;
var _elm_lang$core$Bitwise$complement = _elm_lang$core$Native_Bitwise.complement;
var _elm_lang$core$Bitwise$xor = _elm_lang$core$Native_Bitwise.xor;
var _elm_lang$core$Bitwise$or = _elm_lang$core$Native_Bitwise.or;
var _elm_lang$core$Bitwise$and = _elm_lang$core$Native_Bitwise.and;

//import Native.Utils //

var _elm_lang$core$Native_Char = function() {

return {
	fromCode: function(c) { return _elm_lang$core$Native_Utils.chr(String.fromCharCode(c)); },
	toCode: function(c) { return c.charCodeAt(0); },
	toUpper: function(c) { return _elm_lang$core$Native_Utils.chr(c.toUpperCase()); },
	toLower: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLowerCase()); },
	toLocaleUpper: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLocaleUpperCase()); },
	toLocaleLower: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLocaleLowerCase()); }
};

}();
//import Native.Utils //

var _elm_lang$core$Native_Basics = function() {

function div(a, b)
{
	return (a / b) | 0;
}
function rem(a, b)
{
	return a % b;
}
function mod(a, b)
{
	if (b === 0)
	{
		throw new Error('Cannot perform mod 0. Division by zero error.');
	}
	var r = a % b;
	var m = a === 0 ? 0 : (b > 0 ? (a >= 0 ? r : r + b) : -mod(-a, -b));

	return m === b ? 0 : m;
}
function logBase(base, n)
{
	return Math.log(n) / Math.log(base);
}
function negate(n)
{
	return -n;
}
function abs(n)
{
	return n < 0 ? -n : n;
}

function min(a, b)
{
	return _elm_lang$core$Native_Utils.cmp(a, b) < 0 ? a : b;
}
function max(a, b)
{
	return _elm_lang$core$Native_Utils.cmp(a, b) > 0 ? a : b;
}
function clamp(lo, hi, n)
{
	return _elm_lang$core$Native_Utils.cmp(n, lo) < 0
		? lo
		: _elm_lang$core$Native_Utils.cmp(n, hi) > 0
			? hi
			: n;
}

var ord = ['LT', 'EQ', 'GT'];

function compare(x, y)
{
	return { ctor: ord[_elm_lang$core$Native_Utils.cmp(x, y) + 1] };
}

function xor(a, b)
{
	return a !== b;
}
function not(b)
{
	return !b;
}
function isInfinite(n)
{
	return n === Infinity || n === -Infinity;
}

function truncate(n)
{
	return n | 0;
}

function degrees(d)
{
	return d * Math.PI / 180;
}
function turns(t)
{
	return 2 * Math.PI * t;
}
function fromPolar(point)
{
	var r = point._0;
	var t = point._1;
	return _elm_lang$core$Native_Utils.Tuple2(r * Math.cos(t), r * Math.sin(t));
}
function toPolar(point)
{
	var x = point._0;
	var y = point._1;
	return _elm_lang$core$Native_Utils.Tuple2(Math.sqrt(x * x + y * y), Math.atan2(y, x));
}

return {
	div: F2(div),
	rem: F2(rem),
	mod: F2(mod),

	pi: Math.PI,
	e: Math.E,
	cos: Math.cos,
	sin: Math.sin,
	tan: Math.tan,
	acos: Math.acos,
	asin: Math.asin,
	atan: Math.atan,
	atan2: F2(Math.atan2),

	degrees: degrees,
	turns: turns,
	fromPolar: fromPolar,
	toPolar: toPolar,

	sqrt: Math.sqrt,
	logBase: F2(logBase),
	negate: negate,
	abs: abs,
	min: F2(min),
	max: F2(max),
	clamp: F3(clamp),
	compare: F2(compare),

	xor: F2(xor),
	not: not,

	truncate: truncate,
	ceiling: Math.ceil,
	floor: Math.floor,
	round: Math.round,
	toFloat: function(x) { return x; },
	isNaN: isNaN,
	isInfinite: isInfinite
};

}();
//import //

var _elm_lang$core$Native_Utils = function() {

// COMPARISONS

function eq(x, y)
{
	var stack = [];
	var isEqual = eqHelp(x, y, 0, stack);
	var pair;
	while (isEqual && (pair = stack.pop()))
	{
		isEqual = eqHelp(pair.x, pair.y, 0, stack);
	}
	return isEqual;
}


function eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push({ x: x, y: y });
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object')
	{
		if (typeof x === 'function')
		{
			throw new Error(
				'Trying to use `(==)` on functions. There is no way to know if functions are "the same" in the Elm sense.'
				+ ' Read more about this at http://package.elm-lang.org/packages/elm-lang/core/latest/Basics#=='
				+ ' which describes why it is this way and what the better version will look like.'
			);
		}
		return false;
	}

	if (x === null || y === null)
	{
		return false
	}

	if (x instanceof Date)
	{
		return x.getTime() === y.getTime();
	}

	if (!('ctor' in x))
	{
		for (var key in x)
		{
			if (!eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}

	// convert Dicts and Sets to lists
	if (x.ctor === 'RBNode_elm_builtin' || x.ctor === 'RBEmpty_elm_builtin')
	{
		x = _elm_lang$core$Dict$toList(x);
		y = _elm_lang$core$Dict$toList(y);
	}
	if (x.ctor === 'Set_elm_builtin')
	{
		x = _elm_lang$core$Set$toList(x);
		y = _elm_lang$core$Set$toList(y);
	}

	// check if lists are equal without recursion
	if (x.ctor === '::')
	{
		var a = x;
		var b = y;
		while (a.ctor === '::' && b.ctor === '::')
		{
			if (!eqHelp(a._0, b._0, depth + 1, stack))
			{
				return false;
			}
			a = a._1;
			b = b._1;
		}
		return a.ctor === b.ctor;
	}

	// check if Arrays are equal
	if (x.ctor === '_Array')
	{
		var xs = _elm_lang$core$Native_Array.toJSArray(x);
		var ys = _elm_lang$core$Native_Array.toJSArray(y);
		if (xs.length !== ys.length)
		{
			return false;
		}
		for (var i = 0; i < xs.length; i++)
		{
			if (!eqHelp(xs[i], ys[i], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}

	if (!eqHelp(x.ctor, y.ctor, depth + 1, stack))
	{
		return false;
	}

	for (var key in x)
	{
		if (!eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

var LT = -1, EQ = 0, GT = 1;

function cmp(x, y)
{
	if (typeof x !== 'object')
	{
		return x === y ? EQ : x < y ? LT : GT;
	}

	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? EQ : a < b ? LT : GT;
	}

	if (x.ctor === '::' || x.ctor === '[]')
	{
		while (x.ctor === '::' && y.ctor === '::')
		{
			var ord = cmp(x._0, y._0);
			if (ord !== EQ)
			{
				return ord;
			}
			x = x._1;
			y = y._1;
		}
		return x.ctor === y.ctor ? EQ : x.ctor === '[]' ? LT : GT;
	}

	if (x.ctor.slice(0, 6) === '_Tuple')
	{
		var ord;
		var n = x.ctor.slice(6) - 0;
		var err = 'cannot compare tuples with more than 6 elements.';
		if (n === 0) return EQ;
		if (n >= 1) { ord = cmp(x._0, y._0); if (ord !== EQ) return ord;
		if (n >= 2) { ord = cmp(x._1, y._1); if (ord !== EQ) return ord;
		if (n >= 3) { ord = cmp(x._2, y._2); if (ord !== EQ) return ord;
		if (n >= 4) { ord = cmp(x._3, y._3); if (ord !== EQ) return ord;
		if (n >= 5) { ord = cmp(x._4, y._4); if (ord !== EQ) return ord;
		if (n >= 6) { ord = cmp(x._5, y._5); if (ord !== EQ) return ord;
		if (n >= 7) throw new Error('Comparison error: ' + err); } } } } } }
		return EQ;
	}

	throw new Error(
		'Comparison error: comparison is only defined on ints, '
		+ 'floats, times, chars, strings, lists of comparable values, '
		+ 'and tuples of comparable values.'
	);
}


// COMMON VALUES

var Tuple0 = {
	ctor: '_Tuple0'
};

function Tuple2(x, y)
{
	return {
		ctor: '_Tuple2',
		_0: x,
		_1: y
	};
}

function chr(c)
{
	return new String(c);
}


// GUID

var count = 0;
function guid(_)
{
	return count++;
}


// RECORDS

function update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


//// LIST STUFF ////

var Nil = { ctor: '[]' };

function Cons(hd, tl)
{
	return {
		ctor: '::',
		_0: hd,
		_1: tl
	};
}

function append(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (xs.ctor === '[]')
	{
		return ys;
	}
	var root = Cons(xs._0, Nil);
	var curr = root;
	xs = xs._1;
	while (xs.ctor !== '[]')
	{
		curr._1 = Cons(xs._0, Nil);
		xs = xs._1;
		curr = curr._1;
	}
	curr._1 = ys;
	return root;
}


// CRASHES

function crash(moduleName, region)
{
	return function(message) {
		throw new Error(
			'Ran into a `Debug.crash` in module `' + moduleName + '` ' + regionToString(region) + '\n'
			+ 'The message provided by the code author is:\n\n    '
			+ message
		);
	};
}

function crashCase(moduleName, region, value)
{
	return function(message) {
		throw new Error(
			'Ran into a `Debug.crash` in module `' + moduleName + '`\n\n'
			+ 'This was caused by the `case` expression ' + regionToString(region) + '.\n'
			+ 'One of the branches ended with a crash and the following value got through:\n\n    ' + toString(value) + '\n\n'
			+ 'The message provided by the code author is:\n\n    '
			+ message
		);
	};
}

function regionToString(region)
{
	if (region.start.line == region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'between lines ' + region.start.line + ' and ' + region.end.line;
}


// TO STRING

function toString(v)
{
	var type = typeof v;
	if (type === 'function')
	{
		return '<function>';
	}

	if (type === 'boolean')
	{
		return v ? 'True' : 'False';
	}

	if (type === 'number')
	{
		return v + '';
	}

	if (v instanceof String)
	{
		return '\'' + addSlashes(v, true) + '\'';
	}

	if (type === 'string')
	{
		return '"' + addSlashes(v, false) + '"';
	}

	if (v === null)
	{
		return 'null';
	}

	if (type === 'object' && 'ctor' in v)
	{
		var ctorStarter = v.ctor.substring(0, 5);

		if (ctorStarter === '_Tupl')
		{
			var output = [];
			for (var k in v)
			{
				if (k === 'ctor') continue;
				output.push(toString(v[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (ctorStarter === '_Task')
		{
			return '<task>'
		}

		if (v.ctor === '_Array')
		{
			var list = _elm_lang$core$Array$toList(v);
			return 'Array.fromList ' + toString(list);
		}

		if (v.ctor === '<decoder>')
		{
			return '<decoder>';
		}

		if (v.ctor === '_Process')
		{
			return '<process:' + v.id + '>';
		}

		if (v.ctor === '::')
		{
			var output = '[' + toString(v._0);
			v = v._1;
			while (v.ctor === '::')
			{
				output += ',' + toString(v._0);
				v = v._1;
			}
			return output + ']';
		}

		if (v.ctor === '[]')
		{
			return '[]';
		}

		if (v.ctor === 'Set_elm_builtin')
		{
			return 'Set.fromList ' + toString(_elm_lang$core$Set$toList(v));
		}

		if (v.ctor === 'RBNode_elm_builtin' || v.ctor === 'RBEmpty_elm_builtin')
		{
			return 'Dict.fromList ' + toString(_elm_lang$core$Dict$toList(v));
		}

		var output = '';
		for (var i in v)
		{
			if (i === 'ctor') continue;
			var str = toString(v[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return v.ctor + output;
	}

	if (type === 'object')
	{
		if (v instanceof Date)
		{
			return '<' + v.toString() + '>';
		}

		if (v.elm_web_socket)
		{
			return '<websocket>';
		}

		var output = [];
		for (var k in v)
		{
			output.push(k + ' = ' + toString(v[k]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return '<internal structure>';
}

function addSlashes(str, isChar)
{
	var s = str.replace(/\\/g, '\\\\')
			  .replace(/\n/g, '\\n')
			  .replace(/\t/g, '\\t')
			  .replace(/\r/g, '\\r')
			  .replace(/\v/g, '\\v')
			  .replace(/\0/g, '\\0');
	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}


return {
	eq: eq,
	cmp: cmp,
	Tuple0: Tuple0,
	Tuple2: Tuple2,
	chr: chr,
	update: update,
	guid: guid,

	append: F2(append),

	crash: crash,
	crashCase: crashCase,

	toString: toString
};

}();
var _elm_lang$core$Basics$never = function (_p0) {
	never:
	while (true) {
		var _p1 = _p0;
		var _v1 = _p1._0;
		_p0 = _v1;
		continue never;
	}
};
var _elm_lang$core$Basics$uncurry = F2(
	function (f, _p2) {
		var _p3 = _p2;
		return A2(f, _p3._0, _p3._1);
	});
var _elm_lang$core$Basics$curry = F3(
	function (f, a, b) {
		return f(
			{ctor: '_Tuple2', _0: a, _1: b});
	});
var _elm_lang$core$Basics$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var _elm_lang$core$Basics$always = F2(
	function (a, _p4) {
		return a;
	});
var _elm_lang$core$Basics$identity = function (x) {
	return x;
};
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<|'] = F2(
	function (f, x) {
		return f(x);
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['|>'] = F2(
	function (x, f) {
		return f(x);
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>>'] = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<<'] = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['++'] = _elm_lang$core$Native_Utils.append;
var _elm_lang$core$Basics$toString = _elm_lang$core$Native_Utils.toString;
var _elm_lang$core$Basics$isInfinite = _elm_lang$core$Native_Basics.isInfinite;
var _elm_lang$core$Basics$isNaN = _elm_lang$core$Native_Basics.isNaN;
var _elm_lang$core$Basics$toFloat = _elm_lang$core$Native_Basics.toFloat;
var _elm_lang$core$Basics$ceiling = _elm_lang$core$Native_Basics.ceiling;
var _elm_lang$core$Basics$floor = _elm_lang$core$Native_Basics.floor;
var _elm_lang$core$Basics$truncate = _elm_lang$core$Native_Basics.truncate;
var _elm_lang$core$Basics$round = _elm_lang$core$Native_Basics.round;
var _elm_lang$core$Basics$not = _elm_lang$core$Native_Basics.not;
var _elm_lang$core$Basics$xor = _elm_lang$core$Native_Basics.xor;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['||'] = _elm_lang$core$Native_Basics.or;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['&&'] = _elm_lang$core$Native_Basics.and;
var _elm_lang$core$Basics$max = _elm_lang$core$Native_Basics.max;
var _elm_lang$core$Basics$min = _elm_lang$core$Native_Basics.min;
var _elm_lang$core$Basics$compare = _elm_lang$core$Native_Basics.compare;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>='] = _elm_lang$core$Native_Basics.ge;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<='] = _elm_lang$core$Native_Basics.le;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>'] = _elm_lang$core$Native_Basics.gt;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<'] = _elm_lang$core$Native_Basics.lt;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['/='] = _elm_lang$core$Native_Basics.neq;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['=='] = _elm_lang$core$Native_Basics.eq;
var _elm_lang$core$Basics$e = _elm_lang$core$Native_Basics.e;
var _elm_lang$core$Basics$pi = _elm_lang$core$Native_Basics.pi;
var _elm_lang$core$Basics$clamp = _elm_lang$core$Native_Basics.clamp;
var _elm_lang$core$Basics$logBase = _elm_lang$core$Native_Basics.logBase;
var _elm_lang$core$Basics$abs = _elm_lang$core$Native_Basics.abs;
var _elm_lang$core$Basics$negate = _elm_lang$core$Native_Basics.negate;
var _elm_lang$core$Basics$sqrt = _elm_lang$core$Native_Basics.sqrt;
var _elm_lang$core$Basics$atan2 = _elm_lang$core$Native_Basics.atan2;
var _elm_lang$core$Basics$atan = _elm_lang$core$Native_Basics.atan;
var _elm_lang$core$Basics$asin = _elm_lang$core$Native_Basics.asin;
var _elm_lang$core$Basics$acos = _elm_lang$core$Native_Basics.acos;
var _elm_lang$core$Basics$tan = _elm_lang$core$Native_Basics.tan;
var _elm_lang$core$Basics$sin = _elm_lang$core$Native_Basics.sin;
var _elm_lang$core$Basics$cos = _elm_lang$core$Native_Basics.cos;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['^'] = _elm_lang$core$Native_Basics.exp;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['%'] = _elm_lang$core$Native_Basics.mod;
var _elm_lang$core$Basics$rem = _elm_lang$core$Native_Basics.rem;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['//'] = _elm_lang$core$Native_Basics.div;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['/'] = _elm_lang$core$Native_Basics.floatDiv;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['*'] = _elm_lang$core$Native_Basics.mul;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['-'] = _elm_lang$core$Native_Basics.sub;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['+'] = _elm_lang$core$Native_Basics.add;
var _elm_lang$core$Basics$toPolar = _elm_lang$core$Native_Basics.toPolar;
var _elm_lang$core$Basics$fromPolar = _elm_lang$core$Native_Basics.fromPolar;
var _elm_lang$core$Basics$turns = _elm_lang$core$Native_Basics.turns;
var _elm_lang$core$Basics$degrees = _elm_lang$core$Native_Basics.degrees;
var _elm_lang$core$Basics$radians = function (t) {
	return t;
};
var _elm_lang$core$Basics$GT = {ctor: 'GT'};
var _elm_lang$core$Basics$EQ = {ctor: 'EQ'};
var _elm_lang$core$Basics$LT = {ctor: 'LT'};
var _elm_lang$core$Basics$JustOneMore = function (a) {
	return {ctor: 'JustOneMore', _0: a};
};

var _elm_lang$core$Char$fromCode = _elm_lang$core$Native_Char.fromCode;
var _elm_lang$core$Char$toCode = _elm_lang$core$Native_Char.toCode;
var _elm_lang$core$Char$toLocaleLower = _elm_lang$core$Native_Char.toLocaleLower;
var _elm_lang$core$Char$toLocaleUpper = _elm_lang$core$Native_Char.toLocaleUpper;
var _elm_lang$core$Char$toLower = _elm_lang$core$Native_Char.toLower;
var _elm_lang$core$Char$toUpper = _elm_lang$core$Native_Char.toUpper;
var _elm_lang$core$Char$isBetween = F3(
	function (low, high, $char) {
		var code = _elm_lang$core$Char$toCode($char);
		return (_elm_lang$core$Native_Utils.cmp(
			code,
			_elm_lang$core$Char$toCode(low)) > -1) && (_elm_lang$core$Native_Utils.cmp(
			code,
			_elm_lang$core$Char$toCode(high)) < 1);
	});
var _elm_lang$core$Char$isUpper = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('A'),
	_elm_lang$core$Native_Utils.chr('Z'));
var _elm_lang$core$Char$isLower = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('a'),
	_elm_lang$core$Native_Utils.chr('z'));
var _elm_lang$core$Char$isDigit = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('0'),
	_elm_lang$core$Native_Utils.chr('9'));
var _elm_lang$core$Char$isOctDigit = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('0'),
	_elm_lang$core$Native_Utils.chr('7'));
var _elm_lang$core$Char$isHexDigit = function ($char) {
	return _elm_lang$core$Char$isDigit($char) || (A3(
		_elm_lang$core$Char$isBetween,
		_elm_lang$core$Native_Utils.chr('a'),
		_elm_lang$core$Native_Utils.chr('f'),
		$char) || A3(
		_elm_lang$core$Char$isBetween,
		_elm_lang$core$Native_Utils.chr('A'),
		_elm_lang$core$Native_Utils.chr('F'),
		$char));
};

//import Native.Utils //

var _elm_lang$core$Native_Debug = function() {

function log(tag, value)
{
	var msg = tag + ': ' + _elm_lang$core$Native_Utils.toString(value);
	var process = process || {};
	if (process.stdout)
	{
		process.stdout.write(msg);
	}
	else
	{
		console.log(msg);
	}
	return value;
}

function crash(message)
{
	throw new Error(message);
}

return {
	crash: crash,
	log: F2(log)
};

}();
var _elm_lang$core$Debug$crash = _elm_lang$core$Native_Debug.crash;
var _elm_lang$core$Debug$log = _elm_lang$core$Native_Debug.log;

var _elm_lang$core$Maybe$withDefault = F2(
	function ($default, maybe) {
		var _p0 = maybe;
		if (_p0.ctor === 'Just') {
			return _p0._0;
		} else {
			return $default;
		}
	});
var _elm_lang$core$Maybe$Nothing = {ctor: 'Nothing'};
var _elm_lang$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		var _p1 = maybeValue;
		if (_p1.ctor === 'Just') {
			return callback(_p1._0);
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$Just = function (a) {
	return {ctor: 'Just', _0: a};
};
var _elm_lang$core$Maybe$map = F2(
	function (f, maybe) {
		var _p2 = maybe;
		if (_p2.ctor === 'Just') {
			return _elm_lang$core$Maybe$Just(
				f(_p2._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		var _p3 = {ctor: '_Tuple2', _0: ma, _1: mb};
		if (((_p3.ctor === '_Tuple2') && (_p3._0.ctor === 'Just')) && (_p3._1.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A2(func, _p3._0._0, _p3._1._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		var _p4 = {ctor: '_Tuple3', _0: ma, _1: mb, _2: mc};
		if ((((_p4.ctor === '_Tuple3') && (_p4._0.ctor === 'Just')) && (_p4._1.ctor === 'Just')) && (_p4._2.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A3(func, _p4._0._0, _p4._1._0, _p4._2._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		var _p5 = {ctor: '_Tuple4', _0: ma, _1: mb, _2: mc, _3: md};
		if (((((_p5.ctor === '_Tuple4') && (_p5._0.ctor === 'Just')) && (_p5._1.ctor === 'Just')) && (_p5._2.ctor === 'Just')) && (_p5._3.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A4(func, _p5._0._0, _p5._1._0, _p5._2._0, _p5._3._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map5 = F6(
	function (func, ma, mb, mc, md, me) {
		var _p6 = {ctor: '_Tuple5', _0: ma, _1: mb, _2: mc, _3: md, _4: me};
		if ((((((_p6.ctor === '_Tuple5') && (_p6._0.ctor === 'Just')) && (_p6._1.ctor === 'Just')) && (_p6._2.ctor === 'Just')) && (_p6._3.ctor === 'Just')) && (_p6._4.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A5(func, _p6._0._0, _p6._1._0, _p6._2._0, _p6._3._0, _p6._4._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});

//import Native.Utils //

var _elm_lang$core$Native_List = function() {

var Nil = { ctor: '[]' };

function Cons(hd, tl)
{
	return { ctor: '::', _0: hd, _1: tl };
}

function fromArray(arr)
{
	var out = Nil;
	for (var i = arr.length; i--; )
	{
		out = Cons(arr[i], out);
	}
	return out;
}

function toArray(xs)
{
	var out = [];
	while (xs.ctor !== '[]')
	{
		out.push(xs._0);
		xs = xs._1;
	}
	return out;
}

function foldr(f, b, xs)
{
	var arr = toArray(xs);
	var acc = b;
	for (var i = arr.length; i--; )
	{
		acc = A2(f, arr[i], acc);
	}
	return acc;
}

function map2(f, xs, ys)
{
	var arr = [];
	while (xs.ctor !== '[]' && ys.ctor !== '[]')
	{
		arr.push(A2(f, xs._0, ys._0));
		xs = xs._1;
		ys = ys._1;
	}
	return fromArray(arr);
}

function map3(f, xs, ys, zs)
{
	var arr = [];
	while (xs.ctor !== '[]' && ys.ctor !== '[]' && zs.ctor !== '[]')
	{
		arr.push(A3(f, xs._0, ys._0, zs._0));
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function map4(f, ws, xs, ys, zs)
{
	var arr = [];
	while (   ws.ctor !== '[]'
		   && xs.ctor !== '[]'
		   && ys.ctor !== '[]'
		   && zs.ctor !== '[]')
	{
		arr.push(A4(f, ws._0, xs._0, ys._0, zs._0));
		ws = ws._1;
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function map5(f, vs, ws, xs, ys, zs)
{
	var arr = [];
	while (   vs.ctor !== '[]'
		   && ws.ctor !== '[]'
		   && xs.ctor !== '[]'
		   && ys.ctor !== '[]'
		   && zs.ctor !== '[]')
	{
		arr.push(A5(f, vs._0, ws._0, xs._0, ys._0, zs._0));
		vs = vs._1;
		ws = ws._1;
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function sortBy(f, xs)
{
	return fromArray(toArray(xs).sort(function(a, b) {
		return _elm_lang$core$Native_Utils.cmp(f(a), f(b));
	}));
}

function sortWith(f, xs)
{
	return fromArray(toArray(xs).sort(function(a, b) {
		var ord = f(a)(b).ctor;
		return ord === 'EQ' ? 0 : ord === 'LT' ? -1 : 1;
	}));
}

return {
	Nil: Nil,
	Cons: Cons,
	cons: F2(Cons),
	toArray: toArray,
	fromArray: fromArray,

	foldr: F3(foldr),

	map2: F3(map2),
	map3: F4(map3),
	map4: F5(map4),
	map5: F6(map5),
	sortBy: F2(sortBy),
	sortWith: F2(sortWith)
};

}();
var _elm_lang$core$List$sortWith = _elm_lang$core$Native_List.sortWith;
var _elm_lang$core$List$sortBy = _elm_lang$core$Native_List.sortBy;
var _elm_lang$core$List$sort = function (xs) {
	return A2(_elm_lang$core$List$sortBy, _elm_lang$core$Basics$identity, xs);
};
var _elm_lang$core$List$singleton = function (value) {
	return {
		ctor: '::',
		_0: value,
		_1: {ctor: '[]'}
	};
};
var _elm_lang$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return list;
			} else {
				var _p0 = list;
				if (_p0.ctor === '[]') {
					return list;
				} else {
					var _v1 = n - 1,
						_v2 = _p0._1;
					n = _v1;
					list = _v2;
					continue drop;
				}
			}
		}
	});
var _elm_lang$core$List$map5 = _elm_lang$core$Native_List.map5;
var _elm_lang$core$List$map4 = _elm_lang$core$Native_List.map4;
var _elm_lang$core$List$map3 = _elm_lang$core$Native_List.map3;
var _elm_lang$core$List$map2 = _elm_lang$core$Native_List.map2;
var _elm_lang$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			var _p1 = list;
			if (_p1.ctor === '[]') {
				return false;
			} else {
				if (isOkay(_p1._0)) {
					return true;
				} else {
					var _v4 = isOkay,
						_v5 = _p1._1;
					isOkay = _v4;
					list = _v5;
					continue any;
				}
			}
		}
	});
var _elm_lang$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			_elm_lang$core$List$any,
			function (_p2) {
				return !isOkay(_p2);
			},
			list);
	});
var _elm_lang$core$List$foldr = _elm_lang$core$Native_List.foldr;
var _elm_lang$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			var _p3 = list;
			if (_p3.ctor === '[]') {
				return acc;
			} else {
				var _v7 = func,
					_v8 = A2(func, _p3._0, acc),
					_v9 = _p3._1;
				func = _v7;
				acc = _v8;
				list = _v9;
				continue foldl;
			}
		}
	});
var _elm_lang$core$List$length = function (xs) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (_p4, i) {
				return i + 1;
			}),
		0,
		xs);
};
var _elm_lang$core$List$sum = function (numbers) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return x + y;
			}),
		0,
		numbers);
};
var _elm_lang$core$List$product = function (numbers) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return x * y;
			}),
		1,
		numbers);
};
var _elm_lang$core$List$maximum = function (list) {
	var _p5 = list;
	if (_p5.ctor === '::') {
		return _elm_lang$core$Maybe$Just(
			A3(_elm_lang$core$List$foldl, _elm_lang$core$Basics$max, _p5._0, _p5._1));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$minimum = function (list) {
	var _p6 = list;
	if (_p6.ctor === '::') {
		return _elm_lang$core$Maybe$Just(
			A3(_elm_lang$core$List$foldl, _elm_lang$core$Basics$min, _p6._0, _p6._1));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$member = F2(
	function (x, xs) {
		return A2(
			_elm_lang$core$List$any,
			function (a) {
				return _elm_lang$core$Native_Utils.eq(a, x);
			},
			xs);
	});
var _elm_lang$core$List$isEmpty = function (xs) {
	var _p7 = xs;
	if (_p7.ctor === '[]') {
		return true;
	} else {
		return false;
	}
};
var _elm_lang$core$List$tail = function (list) {
	var _p8 = list;
	if (_p8.ctor === '::') {
		return _elm_lang$core$Maybe$Just(_p8._1);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$head = function (list) {
	var _p9 = list;
	if (_p9.ctor === '::') {
		return _elm_lang$core$Maybe$Just(_p9._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List_ops = _elm_lang$core$List_ops || {};
_elm_lang$core$List_ops['::'] = _elm_lang$core$Native_List.cons;
var _elm_lang$core$List$map = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$foldr,
			F2(
				function (x, acc) {
					return {
						ctor: '::',
						_0: f(x),
						_1: acc
					};
				}),
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$filter = F2(
	function (pred, xs) {
		var conditionalCons = F2(
			function (front, back) {
				return pred(front) ? {ctor: '::', _0: front, _1: back} : back;
			});
		return A3(
			_elm_lang$core$List$foldr,
			conditionalCons,
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _p10 = f(mx);
		if (_p10.ctor === 'Just') {
			return {ctor: '::', _0: _p10._0, _1: xs};
		} else {
			return xs;
		}
	});
var _elm_lang$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$foldr,
			_elm_lang$core$List$maybeCons(f),
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$reverse = function (list) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return {ctor: '::', _0: x, _1: y};
			}),
		{ctor: '[]'},
		list);
};
var _elm_lang$core$List$scanl = F3(
	function (f, b, xs) {
		var scan1 = F2(
			function (x, accAcc) {
				var _p11 = accAcc;
				if (_p11.ctor === '::') {
					return {
						ctor: '::',
						_0: A2(f, x, _p11._0),
						_1: accAcc
					};
				} else {
					return {ctor: '[]'};
				}
			});
		return _elm_lang$core$List$reverse(
			A3(
				_elm_lang$core$List$foldl,
				scan1,
				{
					ctor: '::',
					_0: b,
					_1: {ctor: '[]'}
				},
				xs));
	});
var _elm_lang$core$List$append = F2(
	function (xs, ys) {
		var _p12 = ys;
		if (_p12.ctor === '[]') {
			return xs;
		} else {
			return A3(
				_elm_lang$core$List$foldr,
				F2(
					function (x, y) {
						return {ctor: '::', _0: x, _1: y};
					}),
				ys,
				xs);
		}
	});
var _elm_lang$core$List$concat = function (lists) {
	return A3(
		_elm_lang$core$List$foldr,
		_elm_lang$core$List$append,
		{ctor: '[]'},
		lists);
};
var _elm_lang$core$List$concatMap = F2(
	function (f, list) {
		return _elm_lang$core$List$concat(
			A2(_elm_lang$core$List$map, f, list));
	});
var _elm_lang$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _p13) {
				var _p14 = _p13;
				var _p16 = _p14._0;
				var _p15 = _p14._1;
				return pred(x) ? {
					ctor: '_Tuple2',
					_0: {ctor: '::', _0: x, _1: _p16},
					_1: _p15
				} : {
					ctor: '_Tuple2',
					_0: _p16,
					_1: {ctor: '::', _0: x, _1: _p15}
				};
			});
		return A3(
			_elm_lang$core$List$foldr,
			step,
			{
				ctor: '_Tuple2',
				_0: {ctor: '[]'},
				_1: {ctor: '[]'}
			},
			list);
	});
var _elm_lang$core$List$unzip = function (pairs) {
	var step = F2(
		function (_p18, _p17) {
			var _p19 = _p18;
			var _p20 = _p17;
			return {
				ctor: '_Tuple2',
				_0: {ctor: '::', _0: _p19._0, _1: _p20._0},
				_1: {ctor: '::', _0: _p19._1, _1: _p20._1}
			};
		});
	return A3(
		_elm_lang$core$List$foldr,
		step,
		{
			ctor: '_Tuple2',
			_0: {ctor: '[]'},
			_1: {ctor: '[]'}
		},
		pairs);
};
var _elm_lang$core$List$intersperse = F2(
	function (sep, xs) {
		var _p21 = xs;
		if (_p21.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var step = F2(
				function (x, rest) {
					return {
						ctor: '::',
						_0: sep,
						_1: {ctor: '::', _0: x, _1: rest}
					};
				});
			var spersed = A3(
				_elm_lang$core$List$foldr,
				step,
				{ctor: '[]'},
				_p21._1);
			return {ctor: '::', _0: _p21._0, _1: spersed};
		}
	});
var _elm_lang$core$List$takeReverse = F3(
	function (n, list, taken) {
		takeReverse:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return taken;
			} else {
				var _p22 = list;
				if (_p22.ctor === '[]') {
					return taken;
				} else {
					var _v23 = n - 1,
						_v24 = _p22._1,
						_v25 = {ctor: '::', _0: _p22._0, _1: taken};
					n = _v23;
					list = _v24;
					taken = _v25;
					continue takeReverse;
				}
			}
		}
	});
var _elm_lang$core$List$takeTailRec = F2(
	function (n, list) {
		return _elm_lang$core$List$reverse(
			A3(
				_elm_lang$core$List$takeReverse,
				n,
				list,
				{ctor: '[]'}));
	});
var _elm_lang$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
			return {ctor: '[]'};
		} else {
			var _p23 = {ctor: '_Tuple2', _0: n, _1: list};
			_v26_5:
			do {
				_v26_1:
				do {
					if (_p23.ctor === '_Tuple2') {
						if (_p23._1.ctor === '[]') {
							return list;
						} else {
							if (_p23._1._1.ctor === '::') {
								switch (_p23._0) {
									case 1:
										break _v26_1;
									case 2:
										return {
											ctor: '::',
											_0: _p23._1._0,
											_1: {
												ctor: '::',
												_0: _p23._1._1._0,
												_1: {ctor: '[]'}
											}
										};
									case 3:
										if (_p23._1._1._1.ctor === '::') {
											return {
												ctor: '::',
												_0: _p23._1._0,
												_1: {
													ctor: '::',
													_0: _p23._1._1._0,
													_1: {
														ctor: '::',
														_0: _p23._1._1._1._0,
														_1: {ctor: '[]'}
													}
												}
											};
										} else {
											break _v26_5;
										}
									default:
										if ((_p23._1._1._1.ctor === '::') && (_p23._1._1._1._1.ctor === '::')) {
											var _p28 = _p23._1._1._1._0;
											var _p27 = _p23._1._1._0;
											var _p26 = _p23._1._0;
											var _p25 = _p23._1._1._1._1._0;
											var _p24 = _p23._1._1._1._1._1;
											return (_elm_lang$core$Native_Utils.cmp(ctr, 1000) > 0) ? {
												ctor: '::',
												_0: _p26,
												_1: {
													ctor: '::',
													_0: _p27,
													_1: {
														ctor: '::',
														_0: _p28,
														_1: {
															ctor: '::',
															_0: _p25,
															_1: A2(_elm_lang$core$List$takeTailRec, n - 4, _p24)
														}
													}
												}
											} : {
												ctor: '::',
												_0: _p26,
												_1: {
													ctor: '::',
													_0: _p27,
													_1: {
														ctor: '::',
														_0: _p28,
														_1: {
															ctor: '::',
															_0: _p25,
															_1: A3(_elm_lang$core$List$takeFast, ctr + 1, n - 4, _p24)
														}
													}
												}
											};
										} else {
											break _v26_5;
										}
								}
							} else {
								if (_p23._0 === 1) {
									break _v26_1;
								} else {
									break _v26_5;
								}
							}
						}
					} else {
						break _v26_5;
					}
				} while(false);
				return {
					ctor: '::',
					_0: _p23._1._0,
					_1: {ctor: '[]'}
				};
			} while(false);
			return list;
		}
	});
var _elm_lang$core$List$take = F2(
	function (n, list) {
		return A3(_elm_lang$core$List$takeFast, 0, n, list);
	});
var _elm_lang$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return result;
			} else {
				var _v27 = {ctor: '::', _0: value, _1: result},
					_v28 = n - 1,
					_v29 = value;
				result = _v27;
				n = _v28;
				value = _v29;
				continue repeatHelp;
			}
		}
	});
var _elm_lang$core$List$repeat = F2(
	function (n, value) {
		return A3(
			_elm_lang$core$List$repeatHelp,
			{ctor: '[]'},
			n,
			value);
	});
var _elm_lang$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(lo, hi) < 1) {
				var _v30 = lo,
					_v31 = hi - 1,
					_v32 = {ctor: '::', _0: hi, _1: list};
				lo = _v30;
				hi = _v31;
				list = _v32;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var _elm_lang$core$List$range = F2(
	function (lo, hi) {
		return A3(
			_elm_lang$core$List$rangeHelp,
			lo,
			hi,
			{ctor: '[]'});
	});
var _elm_lang$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$map2,
			f,
			A2(
				_elm_lang$core$List$range,
				0,
				_elm_lang$core$List$length(xs) - 1),
			xs);
	});

var _elm_lang$core$Result$toMaybe = function (result) {
	var _p0 = result;
	if (_p0.ctor === 'Ok') {
		return _elm_lang$core$Maybe$Just(_p0._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$Result$withDefault = F2(
	function (def, result) {
		var _p1 = result;
		if (_p1.ctor === 'Ok') {
			return _p1._0;
		} else {
			return def;
		}
	});
var _elm_lang$core$Result$Err = function (a) {
	return {ctor: 'Err', _0: a};
};
var _elm_lang$core$Result$andThen = F2(
	function (callback, result) {
		var _p2 = result;
		if (_p2.ctor === 'Ok') {
			return callback(_p2._0);
		} else {
			return _elm_lang$core$Result$Err(_p2._0);
		}
	});
var _elm_lang$core$Result$Ok = function (a) {
	return {ctor: 'Ok', _0: a};
};
var _elm_lang$core$Result$map = F2(
	function (func, ra) {
		var _p3 = ra;
		if (_p3.ctor === 'Ok') {
			return _elm_lang$core$Result$Ok(
				func(_p3._0));
		} else {
			return _elm_lang$core$Result$Err(_p3._0);
		}
	});
var _elm_lang$core$Result$map2 = F3(
	function (func, ra, rb) {
		var _p4 = {ctor: '_Tuple2', _0: ra, _1: rb};
		if (_p4._0.ctor === 'Ok') {
			if (_p4._1.ctor === 'Ok') {
				return _elm_lang$core$Result$Ok(
					A2(func, _p4._0._0, _p4._1._0));
			} else {
				return _elm_lang$core$Result$Err(_p4._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p4._0._0);
		}
	});
var _elm_lang$core$Result$map3 = F4(
	function (func, ra, rb, rc) {
		var _p5 = {ctor: '_Tuple3', _0: ra, _1: rb, _2: rc};
		if (_p5._0.ctor === 'Ok') {
			if (_p5._1.ctor === 'Ok') {
				if (_p5._2.ctor === 'Ok') {
					return _elm_lang$core$Result$Ok(
						A3(func, _p5._0._0, _p5._1._0, _p5._2._0));
				} else {
					return _elm_lang$core$Result$Err(_p5._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p5._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p5._0._0);
		}
	});
var _elm_lang$core$Result$map4 = F5(
	function (func, ra, rb, rc, rd) {
		var _p6 = {ctor: '_Tuple4', _0: ra, _1: rb, _2: rc, _3: rd};
		if (_p6._0.ctor === 'Ok') {
			if (_p6._1.ctor === 'Ok') {
				if (_p6._2.ctor === 'Ok') {
					if (_p6._3.ctor === 'Ok') {
						return _elm_lang$core$Result$Ok(
							A4(func, _p6._0._0, _p6._1._0, _p6._2._0, _p6._3._0));
					} else {
						return _elm_lang$core$Result$Err(_p6._3._0);
					}
				} else {
					return _elm_lang$core$Result$Err(_p6._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p6._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p6._0._0);
		}
	});
var _elm_lang$core$Result$map5 = F6(
	function (func, ra, rb, rc, rd, re) {
		var _p7 = {ctor: '_Tuple5', _0: ra, _1: rb, _2: rc, _3: rd, _4: re};
		if (_p7._0.ctor === 'Ok') {
			if (_p7._1.ctor === 'Ok') {
				if (_p7._2.ctor === 'Ok') {
					if (_p7._3.ctor === 'Ok') {
						if (_p7._4.ctor === 'Ok') {
							return _elm_lang$core$Result$Ok(
								A5(func, _p7._0._0, _p7._1._0, _p7._2._0, _p7._3._0, _p7._4._0));
						} else {
							return _elm_lang$core$Result$Err(_p7._4._0);
						}
					} else {
						return _elm_lang$core$Result$Err(_p7._3._0);
					}
				} else {
					return _elm_lang$core$Result$Err(_p7._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p7._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p7._0._0);
		}
	});
var _elm_lang$core$Result$mapError = F2(
	function (f, result) {
		var _p8 = result;
		if (_p8.ctor === 'Ok') {
			return _elm_lang$core$Result$Ok(_p8._0);
		} else {
			return _elm_lang$core$Result$Err(
				f(_p8._0));
		}
	});
var _elm_lang$core$Result$fromMaybe = F2(
	function (err, maybe) {
		var _p9 = maybe;
		if (_p9.ctor === 'Just') {
			return _elm_lang$core$Result$Ok(_p9._0);
		} else {
			return _elm_lang$core$Result$Err(err);
		}
	});

//import Maybe, Native.List, Native.Utils, Result //

var _elm_lang$core$Native_String = function() {

function isEmpty(str)
{
	return str.length === 0;
}
function cons(chr, str)
{
	return chr + str;
}
function uncons(str)
{
	var hd = str[0];
	if (hd)
	{
		return _elm_lang$core$Maybe$Just(_elm_lang$core$Native_Utils.Tuple2(_elm_lang$core$Native_Utils.chr(hd), str.slice(1)));
	}
	return _elm_lang$core$Maybe$Nothing;
}
function append(a, b)
{
	return a + b;
}
function concat(strs)
{
	return _elm_lang$core$Native_List.toArray(strs).join('');
}
function length(str)
{
	return str.length;
}
function map(f, str)
{
	var out = str.split('');
	for (var i = out.length; i--; )
	{
		out[i] = f(_elm_lang$core$Native_Utils.chr(out[i]));
	}
	return out.join('');
}
function filter(pred, str)
{
	return str.split('').map(_elm_lang$core$Native_Utils.chr).filter(pred).join('');
}
function reverse(str)
{
	return str.split('').reverse().join('');
}
function foldl(f, b, str)
{
	var len = str.length;
	for (var i = 0; i < len; ++i)
	{
		b = A2(f, _elm_lang$core$Native_Utils.chr(str[i]), b);
	}
	return b;
}
function foldr(f, b, str)
{
	for (var i = str.length; i--; )
	{
		b = A2(f, _elm_lang$core$Native_Utils.chr(str[i]), b);
	}
	return b;
}
function split(sep, str)
{
	return _elm_lang$core$Native_List.fromArray(str.split(sep));
}
function join(sep, strs)
{
	return _elm_lang$core$Native_List.toArray(strs).join(sep);
}
function repeat(n, str)
{
	var result = '';
	while (n > 0)
	{
		if (n & 1)
		{
			result += str;
		}
		n >>= 1, str += str;
	}
	return result;
}
function slice(start, end, str)
{
	return str.slice(start, end);
}
function left(n, str)
{
	return n < 1 ? '' : str.slice(0, n);
}
function right(n, str)
{
	return n < 1 ? '' : str.slice(-n);
}
function dropLeft(n, str)
{
	return n < 1 ? str : str.slice(n);
}
function dropRight(n, str)
{
	return n < 1 ? str : str.slice(0, -n);
}
function pad(n, chr, str)
{
	var half = (n - str.length) / 2;
	return repeat(Math.ceil(half), chr) + str + repeat(half | 0, chr);
}
function padRight(n, chr, str)
{
	return str + repeat(n - str.length, chr);
}
function padLeft(n, chr, str)
{
	return repeat(n - str.length, chr) + str;
}

function trim(str)
{
	return str.trim();
}
function trimLeft(str)
{
	return str.replace(/^\s+/, '');
}
function trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function words(str)
{
	return _elm_lang$core$Native_List.fromArray(str.trim().split(/\s+/g));
}
function lines(str)
{
	return _elm_lang$core$Native_List.fromArray(str.split(/\r\n|\r|\n/g));
}

function toUpper(str)
{
	return str.toUpperCase();
}
function toLower(str)
{
	return str.toLowerCase();
}

function any(pred, str)
{
	for (var i = str.length; i--; )
	{
		if (pred(_elm_lang$core$Native_Utils.chr(str[i])))
		{
			return true;
		}
	}
	return false;
}
function all(pred, str)
{
	for (var i = str.length; i--; )
	{
		if (!pred(_elm_lang$core$Native_Utils.chr(str[i])))
		{
			return false;
		}
	}
	return true;
}

function contains(sub, str)
{
	return str.indexOf(sub) > -1;
}
function startsWith(sub, str)
{
	return str.indexOf(sub) === 0;
}
function endsWith(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
}
function indexes(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _elm_lang$core$Native_List.Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _elm_lang$core$Native_List.fromArray(is);
}


function toInt(s)
{
	var len = s.length;

	// if empty
	if (len === 0)
	{
		return intErr(s);
	}

	// if hex
	var c = s[0];
	if (c === '0' && s[1] === 'x')
	{
		for (var i = 2; i < len; ++i)
		{
			var c = s[i];
			if (('0' <= c && c <= '9') || ('A' <= c && c <= 'F') || ('a' <= c && c <= 'f'))
			{
				continue;
			}
			return intErr(s);
		}
		return _elm_lang$core$Result$Ok(parseInt(s, 16));
	}

	// is decimal
	if (c > '9' || (c < '0' && c !== '-' && c !== '+'))
	{
		return intErr(s);
	}
	for (var i = 1; i < len; ++i)
	{
		var c = s[i];
		if (c < '0' || '9' < c)
		{
			return intErr(s);
		}
	}

	return _elm_lang$core$Result$Ok(parseInt(s, 10));
}

function intErr(s)
{
	return _elm_lang$core$Result$Err("could not convert string '" + s + "' to an Int");
}


function toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return floatErr(s);
	}
	var n = +s;
	// faster isNaN check
	return n === n ? _elm_lang$core$Result$Ok(n) : floatErr(s);
}

function floatErr(s)
{
	return _elm_lang$core$Result$Err("could not convert string '" + s + "' to a Float");
}


function toList(str)
{
	return _elm_lang$core$Native_List.fromArray(str.split('').map(_elm_lang$core$Native_Utils.chr));
}
function fromList(chars)
{
	return _elm_lang$core$Native_List.toArray(chars).join('');
}

return {
	isEmpty: isEmpty,
	cons: F2(cons),
	uncons: uncons,
	append: F2(append),
	concat: concat,
	length: length,
	map: F2(map),
	filter: F2(filter),
	reverse: reverse,
	foldl: F3(foldl),
	foldr: F3(foldr),

	split: F2(split),
	join: F2(join),
	repeat: F2(repeat),

	slice: F3(slice),
	left: F2(left),
	right: F2(right),
	dropLeft: F2(dropLeft),
	dropRight: F2(dropRight),

	pad: F3(pad),
	padLeft: F3(padLeft),
	padRight: F3(padRight),

	trim: trim,
	trimLeft: trimLeft,
	trimRight: trimRight,

	words: words,
	lines: lines,

	toUpper: toUpper,
	toLower: toLower,

	any: F2(any),
	all: F2(all),

	contains: F2(contains),
	startsWith: F2(startsWith),
	endsWith: F2(endsWith),
	indexes: F2(indexes),

	toInt: toInt,
	toFloat: toFloat,
	toList: toList,
	fromList: fromList
};

}();

var _elm_lang$core$String$fromList = _elm_lang$core$Native_String.fromList;
var _elm_lang$core$String$toList = _elm_lang$core$Native_String.toList;
var _elm_lang$core$String$toFloat = _elm_lang$core$Native_String.toFloat;
var _elm_lang$core$String$toInt = _elm_lang$core$Native_String.toInt;
var _elm_lang$core$String$indices = _elm_lang$core$Native_String.indexes;
var _elm_lang$core$String$indexes = _elm_lang$core$Native_String.indexes;
var _elm_lang$core$String$endsWith = _elm_lang$core$Native_String.endsWith;
var _elm_lang$core$String$startsWith = _elm_lang$core$Native_String.startsWith;
var _elm_lang$core$String$contains = _elm_lang$core$Native_String.contains;
var _elm_lang$core$String$all = _elm_lang$core$Native_String.all;
var _elm_lang$core$String$any = _elm_lang$core$Native_String.any;
var _elm_lang$core$String$toLower = _elm_lang$core$Native_String.toLower;
var _elm_lang$core$String$toUpper = _elm_lang$core$Native_String.toUpper;
var _elm_lang$core$String$lines = _elm_lang$core$Native_String.lines;
var _elm_lang$core$String$words = _elm_lang$core$Native_String.words;
var _elm_lang$core$String$trimRight = _elm_lang$core$Native_String.trimRight;
var _elm_lang$core$String$trimLeft = _elm_lang$core$Native_String.trimLeft;
var _elm_lang$core$String$trim = _elm_lang$core$Native_String.trim;
var _elm_lang$core$String$padRight = _elm_lang$core$Native_String.padRight;
var _elm_lang$core$String$padLeft = _elm_lang$core$Native_String.padLeft;
var _elm_lang$core$String$pad = _elm_lang$core$Native_String.pad;
var _elm_lang$core$String$dropRight = _elm_lang$core$Native_String.dropRight;
var _elm_lang$core$String$dropLeft = _elm_lang$core$Native_String.dropLeft;
var _elm_lang$core$String$right = _elm_lang$core$Native_String.right;
var _elm_lang$core$String$left = _elm_lang$core$Native_String.left;
var _elm_lang$core$String$slice = _elm_lang$core$Native_String.slice;
var _elm_lang$core$String$repeat = _elm_lang$core$Native_String.repeat;
var _elm_lang$core$String$join = _elm_lang$core$Native_String.join;
var _elm_lang$core$String$split = _elm_lang$core$Native_String.split;
var _elm_lang$core$String$foldr = _elm_lang$core$Native_String.foldr;
var _elm_lang$core$String$foldl = _elm_lang$core$Native_String.foldl;
var _elm_lang$core$String$reverse = _elm_lang$core$Native_String.reverse;
var _elm_lang$core$String$filter = _elm_lang$core$Native_String.filter;
var _elm_lang$core$String$map = _elm_lang$core$Native_String.map;
var _elm_lang$core$String$length = _elm_lang$core$Native_String.length;
var _elm_lang$core$String$concat = _elm_lang$core$Native_String.concat;
var _elm_lang$core$String$append = _elm_lang$core$Native_String.append;
var _elm_lang$core$String$uncons = _elm_lang$core$Native_String.uncons;
var _elm_lang$core$String$cons = _elm_lang$core$Native_String.cons;
var _elm_lang$core$String$fromChar = function ($char) {
	return A2(_elm_lang$core$String$cons, $char, '');
};
var _elm_lang$core$String$isEmpty = _elm_lang$core$Native_String.isEmpty;

var _elm_lang$core$Tuple$mapSecond = F2(
	function (func, _p0) {
		var _p1 = _p0;
		return {
			ctor: '_Tuple2',
			_0: _p1._0,
			_1: func(_p1._1)
		};
	});
var _elm_lang$core$Tuple$mapFirst = F2(
	function (func, _p2) {
		var _p3 = _p2;
		return {
			ctor: '_Tuple2',
			_0: func(_p3._0),
			_1: _p3._1
		};
	});
var _elm_lang$core$Tuple$second = function (_p4) {
	var _p5 = _p4;
	return _p5._1;
};
var _elm_lang$core$Tuple$first = function (_p6) {
	var _p7 = _p6;
	return _p7._0;
};

//import //

var _elm_lang$core$Native_Platform = function() {


// PROGRAMS

function program(impl)
{
	return function(flagDecoder)
	{
		return function(object, moduleName)
		{
			object['worker'] = function worker(flags)
			{
				if (typeof flags !== 'undefined')
				{
					throw new Error(
						'The `' + moduleName + '` module does not need flags.\n'
						+ 'Call ' + moduleName + '.worker() with no arguments and you should be all set!'
					);
				}

				return initialize(
					impl.init,
					impl.update,
					impl.subscriptions,
					renderer
				);
			};
		};
	};
}

function programWithFlags(impl)
{
	return function(flagDecoder)
	{
		return function(object, moduleName)
		{
			object['worker'] = function worker(flags)
			{
				if (typeof flagDecoder === 'undefined')
				{
					throw new Error(
						'Are you trying to sneak a Never value into Elm? Trickster!\n'
						+ 'It looks like ' + moduleName + '.main is defined with `programWithFlags` but has type `Program Never`.\n'
						+ 'Use `program` instead if you do not want flags.'
					);
				}

				var result = A2(_elm_lang$core$Native_Json.run, flagDecoder, flags);
				if (result.ctor === 'Err')
				{
					throw new Error(
						moduleName + '.worker(...) was called with an unexpected argument.\n'
						+ 'I tried to convert it to an Elm value, but ran into this problem:\n\n'
						+ result._0
					);
				}

				return initialize(
					impl.init(result._0),
					impl.update,
					impl.subscriptions,
					renderer
				);
			};
		};
	};
}

function renderer(enqueue, _)
{
	return function(_) {};
}


// HTML TO PROGRAM

function htmlToProgram(vnode)
{
	var emptyBag = batch(_elm_lang$core$Native_List.Nil);
	var noChange = _elm_lang$core$Native_Utils.Tuple2(
		_elm_lang$core$Native_Utils.Tuple0,
		emptyBag
	);

	return _elm_lang$virtual_dom$VirtualDom$program({
		init: noChange,
		view: function(model) { return main; },
		update: F2(function(msg, model) { return noChange; }),
		subscriptions: function (model) { return emptyBag; }
	});
}


// INITIALIZE A PROGRAM

function initialize(init, update, subscriptions, renderer)
{
	// ambient state
	var managers = {};
	var updateView;

	// init and update state in main process
	var initApp = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {
		var model = init._0;
		updateView = renderer(enqueue, model);
		var cmds = init._1;
		var subs = subscriptions(model);
		dispatchEffects(managers, cmds, subs);
		callback(_elm_lang$core$Native_Scheduler.succeed(model));
	});

	function onMessage(msg, model)
	{
		return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {
			var results = A2(update, msg, model);
			model = results._0;
			updateView(model);
			var cmds = results._1;
			var subs = subscriptions(model);
			dispatchEffects(managers, cmds, subs);
			callback(_elm_lang$core$Native_Scheduler.succeed(model));
		});
	}

	var mainProcess = spawnLoop(initApp, onMessage);

	function enqueue(msg)
	{
		_elm_lang$core$Native_Scheduler.rawSend(mainProcess, msg);
	}

	var ports = setupEffects(managers, enqueue);

	return ports ? { ports: ports } : {};
}


// EFFECT MANAGERS

var effectManagers = {};

function setupEffects(managers, callback)
{
	var ports;

	// setup all necessary effect managers
	for (var key in effectManagers)
	{
		var manager = effectManagers[key];

		if (manager.isForeign)
		{
			ports = ports || {};
			ports[key] = manager.tag === 'cmd'
				? setupOutgoingPort(key)
				: setupIncomingPort(key, callback);
		}

		managers[key] = makeManager(manager, callback);
	}

	return ports;
}

function makeManager(info, callback)
{
	var router = {
		main: callback,
		self: undefined
	};

	var tag = info.tag;
	var onEffects = info.onEffects;
	var onSelfMsg = info.onSelfMsg;

	function onMessage(msg, state)
	{
		if (msg.ctor === 'self')
		{
			return A3(onSelfMsg, router, msg._0, state);
		}

		var fx = msg._0;
		switch (tag)
		{
			case 'cmd':
				return A3(onEffects, router, fx.cmds, state);

			case 'sub':
				return A3(onEffects, router, fx.subs, state);

			case 'fx':
				return A4(onEffects, router, fx.cmds, fx.subs, state);
		}
	}

	var process = spawnLoop(info.init, onMessage);
	router.self = process;
	return process;
}

function sendToApp(router, msg)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		router.main(msg);
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function sendToSelf(router, msg)
{
	return A2(_elm_lang$core$Native_Scheduler.send, router.self, {
		ctor: 'self',
		_0: msg
	});
}


// HELPER for STATEFUL LOOPS

function spawnLoop(init, onMessage)
{
	var andThen = _elm_lang$core$Native_Scheduler.andThen;

	function loop(state)
	{
		var handleMsg = _elm_lang$core$Native_Scheduler.receive(function(msg) {
			return onMessage(msg, state);
		});
		return A2(andThen, loop, handleMsg);
	}

	var task = A2(andThen, loop, init);

	return _elm_lang$core$Native_Scheduler.rawSpawn(task);
}


// BAGS

function leaf(home)
{
	return function(value)
	{
		return {
			type: 'leaf',
			home: home,
			value: value
		};
	};
}

function batch(list)
{
	return {
		type: 'node',
		branches: list
	};
}

function map(tagger, bag)
{
	return {
		type: 'map',
		tagger: tagger,
		tree: bag
	}
}


// PIPE BAGS INTO EFFECT MANAGERS

function dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	gatherEffects(true, cmdBag, effectsDict, null);
	gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		var fx = home in effectsDict
			? effectsDict[home]
			: {
				cmds: _elm_lang$core$Native_List.Nil,
				subs: _elm_lang$core$Native_List.Nil
			};

		_elm_lang$core$Native_Scheduler.rawSend(managers[home], { ctor: 'fx', _0: fx });
	}
}

function gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.type)
	{
		case 'leaf':
			var home = bag.home;
			var effect = toEffect(isCmd, home, taggers, bag.value);
			effectsDict[home] = insert(isCmd, effect, effectsDict[home]);
			return;

		case 'node':
			var list = bag.branches;
			while (list.ctor !== '[]')
			{
				gatherEffects(isCmd, list._0, effectsDict, taggers);
				list = list._1;
			}
			return;

		case 'map':
			gatherEffects(isCmd, bag.tree, effectsDict, {
				tagger: bag.tagger,
				rest: taggers
			});
			return;
	}
}

function toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		var temp = taggers;
		while (temp)
		{
			x = temp.tagger(x);
			temp = temp.rest;
		}
		return x;
	}

	var map = isCmd
		? effectManagers[home].cmdMap
		: effectManagers[home].subMap;

	return A2(map, applyTaggers, value)
}

function insert(isCmd, newEffect, effects)
{
	effects = effects || {
		cmds: _elm_lang$core$Native_List.Nil,
		subs: _elm_lang$core$Native_List.Nil
	};
	if (isCmd)
	{
		effects.cmds = _elm_lang$core$Native_List.Cons(newEffect, effects.cmds);
		return effects;
	}
	effects.subs = _elm_lang$core$Native_List.Cons(newEffect, effects.subs);
	return effects;
}


// PORTS

function checkPortName(name)
{
	if (name in effectManagers)
	{
		throw new Error('There can only be one port named `' + name + '`, but your program has multiple.');
	}
}


// OUTGOING PORTS

function outgoingPort(name, converter)
{
	checkPortName(name);
	effectManagers[name] = {
		tag: 'cmd',
		cmdMap: outgoingPortMap,
		converter: converter,
		isForeign: true
	};
	return leaf(name);
}

var outgoingPortMap = F2(function cmdMap(tagger, value) {
	return value;
});

function setupOutgoingPort(name)
{
	var subs = [];
	var converter = effectManagers[name].converter;

	// CREATE MANAGER

	var init = _elm_lang$core$Native_Scheduler.succeed(null);

	function onEffects(router, cmdList, state)
	{
		while (cmdList.ctor !== '[]')
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = converter(cmdList._0);
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
			cmdList = cmdList._1;
		}
		return init;
	}

	effectManagers[name].init = init;
	effectManagers[name].onEffects = F3(onEffects);

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}


// INCOMING PORTS

function incomingPort(name, converter)
{
	checkPortName(name);
	effectManagers[name] = {
		tag: 'sub',
		subMap: incomingPortMap,
		converter: converter,
		isForeign: true
	};
	return leaf(name);
}

var incomingPortMap = F2(function subMap(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});

function setupIncomingPort(name, callback)
{
	var sentBeforeInit = [];
	var subs = _elm_lang$core$Native_List.Nil;
	var converter = effectManagers[name].converter;
	var currentOnEffects = preInitOnEffects;
	var currentSend = preInitSend;

	// CREATE MANAGER

	var init = _elm_lang$core$Native_Scheduler.succeed(null);

	function preInitOnEffects(router, subList, state)
	{
		var postInitResult = postInitOnEffects(router, subList, state);

		for(var i = 0; i < sentBeforeInit.length; i++)
		{
			postInitSend(sentBeforeInit[i]);
		}

		sentBeforeInit = null; // to release objects held in queue
		currentSend = postInitSend;
		currentOnEffects = postInitOnEffects;
		return postInitResult;
	}

	function postInitOnEffects(router, subList, state)
	{
		subs = subList;
		return init;
	}

	function onEffects(router, subList, state)
	{
		return currentOnEffects(router, subList, state);
	}

	effectManagers[name].init = init;
	effectManagers[name].onEffects = F3(onEffects);

	// PUBLIC API

	function preInitSend(value)
	{
		sentBeforeInit.push(value);
	}

	function postInitSend(value)
	{
		var temp = subs;
		while (temp.ctor !== '[]')
		{
			callback(temp._0(value));
			temp = temp._1;
		}
	}

	function send(incomingValue)
	{
		var result = A2(_elm_lang$core$Json_Decode$decodeValue, converter, incomingValue);
		if (result.ctor === 'Err')
		{
			throw new Error('Trying to send an unexpected type of value through port `' + name + '`:\n' + result._0);
		}

		currentSend(result._0);
	}

	return { send: send };
}

return {
	// routers
	sendToApp: F2(sendToApp),
	sendToSelf: F2(sendToSelf),

	// global setup
	effectManagers: effectManagers,
	outgoingPort: outgoingPort,
	incomingPort: incomingPort,

	htmlToProgram: htmlToProgram,
	program: program,
	programWithFlags: programWithFlags,
	initialize: initialize,

	// effect bags
	leaf: leaf,
	batch: batch,
	map: F2(map)
};

}();

//import Native.Utils //

var _elm_lang$core$Native_Scheduler = function() {

var MAX_STEPS = 10000;


// TASKS

function succeed(value)
{
	return {
		ctor: '_Task_succeed',
		value: value
	};
}

function fail(error)
{
	return {
		ctor: '_Task_fail',
		value: error
	};
}

function nativeBinding(callback)
{
	return {
		ctor: '_Task_nativeBinding',
		callback: callback,
		cancel: null
	};
}

function andThen(callback, task)
{
	return {
		ctor: '_Task_andThen',
		callback: callback,
		task: task
	};
}

function onError(callback, task)
{
	return {
		ctor: '_Task_onError',
		callback: callback,
		task: task
	};
}

function receive(callback)
{
	return {
		ctor: '_Task_receive',
		callback: callback
	};
}


// PROCESSES

function rawSpawn(task)
{
	var process = {
		ctor: '_Process',
		id: _elm_lang$core$Native_Utils.guid(),
		root: task,
		stack: null,
		mailbox: []
	};

	enqueue(process);

	return process;
}

function spawn(task)
{
	return nativeBinding(function(callback) {
		var process = rawSpawn(task);
		callback(succeed(process));
	});
}

function rawSend(process, msg)
{
	process.mailbox.push(msg);
	enqueue(process);
}

function send(process, msg)
{
	return nativeBinding(function(callback) {
		rawSend(process, msg);
		callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function kill(process)
{
	return nativeBinding(function(callback) {
		var root = process.root;
		if (root.ctor === '_Task_nativeBinding' && root.cancel)
		{
			root.cancel();
		}

		process.root = null;

		callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function sleep(time)
{
	return nativeBinding(function(callback) {
		var id = setTimeout(function() {
			callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}


// STEP PROCESSES

function step(numSteps, process)
{
	while (numSteps < MAX_STEPS)
	{
		var ctor = process.root.ctor;

		if (ctor === '_Task_succeed')
		{
			while (process.stack && process.stack.ctor === '_Task_onError')
			{
				process.stack = process.stack.rest;
			}
			if (process.stack === null)
			{
				break;
			}
			process.root = process.stack.callback(process.root.value);
			process.stack = process.stack.rest;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_fail')
		{
			while (process.stack && process.stack.ctor === '_Task_andThen')
			{
				process.stack = process.stack.rest;
			}
			if (process.stack === null)
			{
				break;
			}
			process.root = process.stack.callback(process.root.value);
			process.stack = process.stack.rest;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_andThen')
		{
			process.stack = {
				ctor: '_Task_andThen',
				callback: process.root.callback,
				rest: process.stack
			};
			process.root = process.root.task;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_onError')
		{
			process.stack = {
				ctor: '_Task_onError',
				callback: process.root.callback,
				rest: process.stack
			};
			process.root = process.root.task;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_nativeBinding')
		{
			process.root.cancel = process.root.callback(function(newRoot) {
				process.root = newRoot;
				enqueue(process);
			});

			break;
		}

		if (ctor === '_Task_receive')
		{
			var mailbox = process.mailbox;
			if (mailbox.length === 0)
			{
				break;
			}

			process.root = process.root.callback(mailbox.shift());
			++numSteps;
			continue;
		}

		throw new Error(ctor);
	}

	if (numSteps < MAX_STEPS)
	{
		return numSteps + 1;
	}
	enqueue(process);

	return numSteps;
}


// WORK QUEUE

var working = false;
var workQueue = [];

function enqueue(process)
{
	workQueue.push(process);

	if (!working)
	{
		setTimeout(work, 0);
		working = true;
	}
}

function work()
{
	var numSteps = 0;
	var process;
	while (numSteps < MAX_STEPS && (process = workQueue.shift()))
	{
		if (process.root)
		{
			numSteps = step(numSteps, process);
		}
	}
	if (!process)
	{
		working = false;
		return;
	}
	setTimeout(work, 0);
}


return {
	succeed: succeed,
	fail: fail,
	nativeBinding: nativeBinding,
	andThen: F2(andThen),
	onError: F2(onError),
	receive: receive,

	spawn: spawn,
	kill: kill,
	sleep: sleep,
	send: F2(send),

	rawSpawn: rawSpawn,
	rawSend: rawSend
};

}();
var _elm_lang$core$Platform_Cmd$batch = _elm_lang$core$Native_Platform.batch;
var _elm_lang$core$Platform_Cmd$none = _elm_lang$core$Platform_Cmd$batch(
	{ctor: '[]'});
var _elm_lang$core$Platform_Cmd_ops = _elm_lang$core$Platform_Cmd_ops || {};
_elm_lang$core$Platform_Cmd_ops['!'] = F2(
	function (model, commands) {
		return {
			ctor: '_Tuple2',
			_0: model,
			_1: _elm_lang$core$Platform_Cmd$batch(commands)
		};
	});
var _elm_lang$core$Platform_Cmd$map = _elm_lang$core$Native_Platform.map;
var _elm_lang$core$Platform_Cmd$Cmd = {ctor: 'Cmd'};

var _elm_lang$core$Platform_Sub$batch = _elm_lang$core$Native_Platform.batch;
var _elm_lang$core$Platform_Sub$none = _elm_lang$core$Platform_Sub$batch(
	{ctor: '[]'});
var _elm_lang$core$Platform_Sub$map = _elm_lang$core$Native_Platform.map;
var _elm_lang$core$Platform_Sub$Sub = {ctor: 'Sub'};

var _elm_lang$core$Platform$hack = _elm_lang$core$Native_Scheduler.succeed;
var _elm_lang$core$Platform$sendToSelf = _elm_lang$core$Native_Platform.sendToSelf;
var _elm_lang$core$Platform$sendToApp = _elm_lang$core$Native_Platform.sendToApp;
var _elm_lang$core$Platform$programWithFlags = _elm_lang$core$Native_Platform.programWithFlags;
var _elm_lang$core$Platform$program = _elm_lang$core$Native_Platform.program;
var _elm_lang$core$Platform$Program = {ctor: 'Program'};
var _elm_lang$core$Platform$Task = {ctor: 'Task'};
var _elm_lang$core$Platform$ProcessId = {ctor: 'ProcessId'};
var _elm_lang$core$Platform$Router = {ctor: 'Router'};

var _Skinney$murmur3$UTF8$accumulate = F3(
	function (add, $char, _p0) {
		var _p1 = _p0;
		var _p3 = _p1._0;
		var _p2 = _p1._1;
		if (_p2.ctor === 'Nothing') {
			return (_elm_lang$core$Native_Utils.cmp($char, 128) < 0) ? {
				ctor: '_Tuple2',
				_0: A2(add, $char, _p3),
				_1: _elm_lang$core$Maybe$Nothing
			} : ((_elm_lang$core$Native_Utils.cmp($char, 2048) < 0) ? {
				ctor: '_Tuple2',
				_0: A2(
					add,
					128 | (63 & $char),
					A2(add, 192 | ($char >>> 6), _p3)),
				_1: _elm_lang$core$Maybe$Nothing
			} : (((_elm_lang$core$Native_Utils.cmp($char, 55296) < 0) || (_elm_lang$core$Native_Utils.cmp($char, 57344) > -1)) ? {
				ctor: '_Tuple2',
				_0: A2(
					add,
					128 | (63 & $char),
					A2(
						add,
						128 | (63 & ($char >>> 6)),
						A2(add, 224 | ($char >>> 12), _p3))),
				_1: _elm_lang$core$Maybe$Nothing
			} : {
				ctor: '_Tuple2',
				_0: _p3,
				_1: _elm_lang$core$Maybe$Just($char)
			}));
		} else {
			var combined = ((1023 & $char) | ((1023 & _p2._0) << 10)) + 65536;
			return {
				ctor: '_Tuple2',
				_0: A2(
					add,
					128 | (63 & combined),
					A2(
						add,
						128 | (63 & (combined >>> 6)),
						A2(
							add,
							128 | (63 & (combined >>> 12)),
							A2(add, 240 | (combined >>> 18), _p3)))),
				_1: _elm_lang$core$Maybe$Nothing
			};
		}
	});
var _Skinney$murmur3$UTF8$foldl = F3(
	function (op, acc, input) {
		var helper = F2(
			function ($char, acc) {
				return A3(
					_Skinney$murmur3$UTF8$accumulate,
					op,
					_elm_lang$core$Char$toCode($char),
					acc);
			});
		return _elm_lang$core$Tuple$first(
			A3(
				_elm_lang$core$String$foldl,
				helper,
				{ctor: '_Tuple2', _0: acc, _1: _elm_lang$core$Maybe$Nothing},
				input));
	});

var _Skinney$murmur3$Murmur3$mur = F2(
	function (c, h) {
		return 4294967295 & (((h & 65535) * c) + ((65535 & ((h >>> 16) * c)) << 16));
	});
var _Skinney$murmur3$Murmur3$step = function (acc) {
	var h1 = A2(_Skinney$murmur3$Murmur3$mur, 5, (acc >>> 19) | (acc << 13));
	return ((h1 & 65535) + 27492) + ((65535 & ((h1 >>> 16) + 58964)) << 16);
};
var _Skinney$murmur3$Murmur3$mix = F2(
	function (h1, h2) {
		var k1 = A2(_Skinney$murmur3$Murmur3$mur, 3432918353, h2);
		return h1 ^ A2(_Skinney$murmur3$Murmur3$mur, 461845907, (k1 >>> 17) | (k1 << 15));
	});
var _Skinney$murmur3$Murmur3$finalize = function (data) {
	var acc = (!_elm_lang$core$Native_Utils.eq(data.hash, 0)) ? A2(_Skinney$murmur3$Murmur3$mix, data.seed, data.hash) : data.seed;
	var h1 = acc ^ data.charsProcessed;
	var h2 = A2(_Skinney$murmur3$Murmur3$mur, 2246822507, h1 ^ (h1 >>> 16));
	var h3 = A2(_Skinney$murmur3$Murmur3$mur, 3266489909, h2 ^ (h2 >>> 13));
	return (h3 ^ (h3 >>> 16)) >>> 0;
};
var _Skinney$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.hash | (c << data.shift);
		var _p0 = data.shift;
		if (_p0 === 24) {
			var newHash = _Skinney$murmur3$Murmur3$step(
				A2(_Skinney$murmur3$Murmur3$mix, data.seed, res));
			return {shift: 0, seed: newHash, hash: 0, charsProcessed: data.charsProcessed + 1};
		} else {
			return {shift: data.shift + 8, seed: data.seed, hash: res, charsProcessed: data.charsProcessed + 1};
		}
	});
var _Skinney$murmur3$Murmur3$HashData = F4(
	function (a, b, c, d) {
		return {shift: a, seed: b, hash: c, charsProcessed: d};
	});
var _Skinney$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return _Skinney$murmur3$Murmur3$finalize(
			A3(
				_Skinney$murmur3$UTF8$foldl,
				_Skinney$murmur3$Murmur3$hashFold,
				A4(_Skinney$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});

var _cuducos$elm_format_number$FormatNumber_Locales$Locale = F7(
	function (a, b, c, d, e, f, g) {
		return {decimals: a, thousandSeparator: b, decimalSeparator: c, negativePrefix: d, negativeSuffix: e, positivePrefix: f, positiveSuffix: g};
	});
var _cuducos$elm_format_number$FormatNumber_Locales$frenchLocale = A7(_cuducos$elm_format_number$FormatNumber_Locales$Locale, 3, ' ', ',', '−', '', '', '');
var _cuducos$elm_format_number$FormatNumber_Locales$spanishLocale = A7(_cuducos$elm_format_number$FormatNumber_Locales$Locale, 3, '.', ',', '−', '', '', '');
var _cuducos$elm_format_number$FormatNumber_Locales$usLocale = A7(_cuducos$elm_format_number$FormatNumber_Locales$Locale, 2, ',', '.', '−', '', '', '');

var _myrho$elm_round$Round$funNum = F3(
	function (fun, s, fl) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			0 / 0,
			_elm_lang$core$Result$toMaybe(
				_elm_lang$core$String$toFloat(
					A2(fun, s, fl))));
	});
var _myrho$elm_round$Round$increaseNum = function (_p0) {
	var _p1 = _p0;
	var _p4 = _p1._1;
	var _p3 = _p1._0;
	if (_elm_lang$core$Native_Utils.eq(
		_p3,
		_elm_lang$core$Native_Utils.chr('9'))) {
		var _p2 = _elm_lang$core$String$uncons(_p4);
		if (_p2.ctor === 'Nothing') {
			return '01';
		} else {
			return A2(
				_elm_lang$core$String$cons,
				_elm_lang$core$Native_Utils.chr('0'),
				_myrho$elm_round$Round$increaseNum(_p2._0));
		}
	} else {
		var c = _elm_lang$core$Char$toCode(_p3);
		return ((_elm_lang$core$Native_Utils.cmp(c, 48) > -1) && (_elm_lang$core$Native_Utils.cmp(c, 57) < 0)) ? A2(
			_elm_lang$core$String$cons,
			_elm_lang$core$Char$fromCode(c + 1),
			_p4) : '0';
	}
};
var _myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			_elm_lang$core$List$any,
			function (c) {
				return (!_elm_lang$core$Native_Utils.eq(
					c,
					_elm_lang$core$Native_Utils.chr('0'))) && (!_elm_lang$core$Native_Utils.eq(
					c,
					_elm_lang$core$Native_Utils.chr('.')));
			},
			_elm_lang$core$String$toList(str));
		return A2(
			_elm_lang$core$Basics_ops['++'],
			(signed && isNotZero) ? '-' : '',
			str);
	});
var _myrho$elm_round$Round$splitComma = function (str) {
	var _p5 = A2(_elm_lang$core$String$split, '.', str);
	if (_p5.ctor === '::') {
		if (_p5._1.ctor === '::') {
			return {ctor: '_Tuple2', _0: _p5._0, _1: _p5._1._0};
		} else {
			return {ctor: '_Tuple2', _0: _p5._0, _1: '0'};
		}
	} else {
		return {ctor: '_Tuple2', _0: '0', _1: '0'};
	}
};
var _myrho$elm_round$Round$toDecimal = function (fl) {
	var _p6 = A2(
		_elm_lang$core$String$split,
		'e',
		_elm_lang$core$Basics$toString(
			_elm_lang$core$Basics$abs(fl)));
	if (_p6.ctor === '::') {
		if (_p6._1.ctor === '::') {
			var _p10 = _p6._1._0;
			var _p7 = _myrho$elm_round$Round$splitComma(_p6._0);
			var before = _p7._0;
			var after = _p7._1;
			var total = A2(_elm_lang$core$Basics_ops['++'], before, after);
			var e = A2(
				_elm_lang$core$Maybe$withDefault,
				0,
				_elm_lang$core$Result$toMaybe(
					_elm_lang$core$String$toInt(
						A2(_elm_lang$core$String$startsWith, '+', _p10) ? A2(_elm_lang$core$String$dropLeft, 1, _p10) : _p10)));
			var zeroed = (_elm_lang$core$Native_Utils.cmp(e, 0) < 0) ? A2(
				_elm_lang$core$Maybe$withDefault,
				'0',
				A2(
					_elm_lang$core$Maybe$map,
					function (_p8) {
						var _p9 = _p8;
						return A2(
							_elm_lang$core$Basics_ops['++'],
							_p9._0,
							A2(_elm_lang$core$Basics_ops['++'], '.', _p9._1));
					},
					A2(
						_elm_lang$core$Maybe$map,
						_elm_lang$core$Tuple$mapFirst(_elm_lang$core$String$fromChar),
						_elm_lang$core$String$uncons(
							A2(
								_elm_lang$core$Basics_ops['++'],
								A2(
									_elm_lang$core$String$repeat,
									_elm_lang$core$Basics$abs(e),
									'0'),
								total))))) : A3(
				_elm_lang$core$String$padRight,
				e + 1,
				_elm_lang$core$Native_Utils.chr('0'),
				total);
			return A2(
				_elm_lang$core$Basics_ops['++'],
				(_elm_lang$core$Native_Utils.cmp(fl, 0) < 0) ? '-' : '',
				zeroed);
		} else {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				(_elm_lang$core$Native_Utils.cmp(fl, 0) < 0) ? '-' : '',
				_p6._0);
		}
	} else {
		return '';
	}
};
var _myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if (_elm_lang$core$Basics$isInfinite(fl) || _elm_lang$core$Basics$isNaN(fl)) {
			return _elm_lang$core$Basics$toString(fl);
		} else {
			var signed = _elm_lang$core$Native_Utils.cmp(fl, 0) < 0;
			var _p11 = _myrho$elm_round$Round$splitComma(
				_myrho$elm_round$Round$toDecimal(
					_elm_lang$core$Basics$abs(fl)));
			var before = _p11._0;
			var after = _p11._1;
			var r = _elm_lang$core$String$length(before) + s;
			var roundDigitIndex = A2(_elm_lang$core$Basics$max, 1, r);
			var normalized = A2(
				_elm_lang$core$Basics_ops['++'],
				A2(
					_elm_lang$core$String$repeat,
					_elm_lang$core$Basics$negate(r) + 1,
					'0'),
				A3(
					_elm_lang$core$String$padRight,
					r,
					_elm_lang$core$Native_Utils.chr('0'),
					A2(_elm_lang$core$Basics_ops['++'], before, after)));
			var totalLen = _elm_lang$core$String$length(normalized);
			var increase = A2(
				functor,
				signed,
				A3(_elm_lang$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3(_elm_lang$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? _elm_lang$core$String$reverse(
				A2(
					_elm_lang$core$Maybe$withDefault,
					'1',
					A2(
						_elm_lang$core$Maybe$map,
						_myrho$elm_round$Round$increaseNum,
						_elm_lang$core$String$uncons(
							_elm_lang$core$String$reverse(remains))))) : remains;
			var numLen = _elm_lang$core$String$length(num);
			var numZeroed = _elm_lang$core$Native_Utils.eq(num, '0') ? num : ((_elm_lang$core$Native_Utils.cmp(s, 0) < 1) ? A2(
				F2(
					function (x, y) {
						return A2(_elm_lang$core$Basics_ops['++'], x, y);
					}),
				num,
				A2(
					_elm_lang$core$String$repeat,
					_elm_lang$core$Basics$abs(s),
					'0')) : ((_elm_lang$core$Native_Utils.cmp(
				s,
				_elm_lang$core$String$length(after)) < 0) ? A2(
				_elm_lang$core$Basics_ops['++'],
				A3(_elm_lang$core$String$slice, 0, numLen - s, num),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'.',
					A3(_elm_lang$core$String$slice, numLen - s, numLen, num))) : A2(
				F2(
					function (x, y) {
						return A2(_elm_lang$core$Basics_ops['++'], x, y);
					}),
				A2(_elm_lang$core$Basics_ops['++'], before, '.'),
				A3(
					_elm_lang$core$String$padRight,
					s,
					_elm_lang$core$Native_Utils.chr('0'),
					after))));
			return A2(_myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var _myrho$elm_round$Round$round = _myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _p12 = _elm_lang$core$String$uncons(str);
			if (_p12.ctor === 'Nothing') {
				return false;
			} else {
				if (_p12._0._0.valueOf() === '5') {
					if (_p12._0._1 === '') {
						return !signed;
					} else {
						return true;
					}
				} else {
					return function ($int) {
						return ((_elm_lang$core$Native_Utils.cmp($int, 53) > 0) && signed) || ((_elm_lang$core$Native_Utils.cmp($int, 53) > -1) && (!signed));
					}(
						_elm_lang$core$Char$toCode(_p12._0._0));
				}
			}
		}));
var _myrho$elm_round$Round$roundNum = _myrho$elm_round$Round$funNum(_myrho$elm_round$Round$round);
var _myrho$elm_round$Round$ceiling = _myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _p13 = _elm_lang$core$String$uncons(str);
			if (_p13.ctor === 'Nothing') {
				return false;
			} else {
				if ((_p13._0.ctor === '_Tuple2') && (_p13._0._0.valueOf() === '0')) {
					return A2(
						F2(
							function (x, y) {
								return x && y;
							}),
						!signed,
						A2(
							_elm_lang$core$List$any,
							F2(
								function (x, y) {
									return !_elm_lang$core$Native_Utils.eq(x, y);
								})(
								_elm_lang$core$Native_Utils.chr('0')),
							_elm_lang$core$String$toList(_p13._0._1)));
				} else {
					return !signed;
				}
			}
		}));
var _myrho$elm_round$Round$ceilingNum = _myrho$elm_round$Round$funNum(_myrho$elm_round$Round$ceiling);
var _myrho$elm_round$Round$floor = _myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _p14 = _elm_lang$core$String$uncons(str);
			if (_p14.ctor === 'Nothing') {
				return false;
			} else {
				if ((_p14._0.ctor === '_Tuple2') && (_p14._0._0.valueOf() === '0')) {
					return A2(
						F2(
							function (x, y) {
								return x && y;
							}),
						signed,
						A2(
							_elm_lang$core$List$any,
							F2(
								function (x, y) {
									return !_elm_lang$core$Native_Utils.eq(x, y);
								})(
								_elm_lang$core$Native_Utils.chr('0')),
							_elm_lang$core$String$toList(_p14._0._1)));
				} else {
					return signed;
				}
			}
		}));
var _myrho$elm_round$Round$floorCom = F2(
	function (s, fl) {
		return (_elm_lang$core$Native_Utils.cmp(fl, 0) < 0) ? A2(_myrho$elm_round$Round$ceiling, s, fl) : A2(_myrho$elm_round$Round$floor, s, fl);
	});
var _myrho$elm_round$Round$floorNumCom = _myrho$elm_round$Round$funNum(_myrho$elm_round$Round$floorCom);
var _myrho$elm_round$Round$ceilingCom = F2(
	function (s, fl) {
		return (_elm_lang$core$Native_Utils.cmp(fl, 0) < 0) ? A2(_myrho$elm_round$Round$floor, s, fl) : A2(_myrho$elm_round$Round$ceiling, s, fl);
	});
var _myrho$elm_round$Round$ceilingNumCom = _myrho$elm_round$Round$funNum(_myrho$elm_round$Round$ceilingCom);
var _myrho$elm_round$Round$floorNum = _myrho$elm_round$Round$funNum(_myrho$elm_round$Round$floor);
var _myrho$elm_round$Round$roundCom = _myrho$elm_round$Round$roundFun(
	F2(
		function (_p15, $int) {
			return A2(
				F2(
					function (x, y) {
						return _elm_lang$core$Native_Utils.cmp(x, y) < 1;
					}),
				53,
				_elm_lang$core$Char$toCode(
					A2(
						_elm_lang$core$Maybe$withDefault,
						_elm_lang$core$Native_Utils.chr('0'),
						A2(
							_elm_lang$core$Maybe$map,
							_elm_lang$core$Tuple$first,
							_elm_lang$core$String$uncons($int)))));
		}));
var _myrho$elm_round$Round$roundNumCom = _myrho$elm_round$Round$funNum(_myrho$elm_round$Round$roundCom);
var _myrho$elm_round$Round$truncate = function (n) {
	return (_elm_lang$core$Native_Utils.cmp(n, 0) < 0) ? _elm_lang$core$Basics$ceiling(n) : _elm_lang$core$Basics$floor(n);
};

var _cuducos$elm_format_number$Helpers$stringfy = F2(
	function (locale, formatted) {
		var decimals = function () {
			var _p0 = formatted.decimals;
			if (_p0.ctor === 'Just') {
				return A2(_elm_lang$core$Basics_ops['++'], locale.decimalSeparator, _p0._0);
			} else {
				return '';
			}
		}();
		var integers = A2(_elm_lang$core$String$join, locale.thousandSeparator, formatted.integers);
		return _elm_lang$core$String$concat(
			{
				ctor: '::',
				_0: formatted.prefix,
				_1: {
					ctor: '::',
					_0: integers,
					_1: {
						ctor: '::',
						_0: decimals,
						_1: {
							ctor: '::',
							_0: formatted.suffix,
							_1: {ctor: '[]'}
						}
					}
				}
			});
	});
var _cuducos$elm_format_number$Helpers$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(value),
			3) > 0) ? A2(
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				}),
			A2(_elm_lang$core$String$right, 3, value),
			reversedSplitThousands(
				A2(_elm_lang$core$String$dropRight, 3, value))) : {
			ctor: '::',
			_0: value,
			_1: {ctor: '[]'}
		};
	};
	return _elm_lang$core$List$reverse(
		reversedSplitThousands(integers));
};
var _cuducos$elm_format_number$Helpers$FormattedNumber = F5(
	function (a, b, c, d, e) {
		return {original: a, integers: b, decimals: c, prefix: d, suffix: e};
	});
var _cuducos$elm_format_number$Helpers$Negative = {ctor: 'Negative'};
var _cuducos$elm_format_number$Helpers$Zero = {ctor: 'Zero'};
var _cuducos$elm_format_number$Helpers$Positive = {ctor: 'Positive'};
var _cuducos$elm_format_number$Helpers$classify = function (formatted) {
	var onlyZeros = A2(
		_elm_lang$core$String$all,
		function ($char) {
			return _elm_lang$core$Native_Utils.eq(
				$char,
				_elm_lang$core$Native_Utils.chr('0'));
		},
		_elm_lang$core$String$concat(
			A2(
				_elm_lang$core$List$append,
				formatted.integers,
				_elm_lang$core$List$singleton(
					A2(_elm_lang$core$Maybe$withDefault, '', formatted.decimals)))));
	return onlyZeros ? _cuducos$elm_format_number$Helpers$Zero : ((_elm_lang$core$Native_Utils.cmp(formatted.original, 0) < 0) ? _cuducos$elm_format_number$Helpers$Negative : _cuducos$elm_format_number$Helpers$Positive);
};
var _cuducos$elm_format_number$Helpers$parse = F2(
	function (locale, original) {
		var parts = A2(
			_elm_lang$core$String$split,
			'.',
			A2(_myrho$elm_round$Round$round, locale.decimals, original));
		var integers = _cuducos$elm_format_number$Helpers$splitThousands(
			A2(
				_elm_lang$core$String$filter,
				_elm_lang$core$Char$isDigit,
				A2(
					_elm_lang$core$Maybe$withDefault,
					'0',
					_elm_lang$core$List$head(parts))));
		var decimals = _elm_lang$core$List$head(
			A2(_elm_lang$core$List$drop, 1, parts));
		var partial = A5(_cuducos$elm_format_number$Helpers$FormattedNumber, original, integers, decimals, '', '');
		var _p1 = _cuducos$elm_format_number$Helpers$classify(partial);
		switch (_p1.ctor) {
			case 'Negative':
				return _elm_lang$core$Native_Utils.update(
					partial,
					{prefix: locale.negativePrefix, suffix: locale.negativeSuffix});
			case 'Positive':
				return _elm_lang$core$Native_Utils.update(
					partial,
					{prefix: locale.positivePrefix, suffix: locale.positiveSuffix});
			default:
				return partial;
		}
	});

var _cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			_cuducos$elm_format_number$Helpers$stringfy,
			locale,
			A2(_cuducos$elm_format_number$Helpers$parse, locale, number_));
	});

var _danyx23$elm_mimetype$MimeType$toString = function (mimeType) {
	var _p0 = mimeType;
	switch (_p0.ctor) {
		case 'Image':
			var _p1 = _p0._0;
			switch (_p1.ctor) {
				case 'Jpeg':
					return 'image/jpeg';
				case 'Png':
					return 'image/png';
				case 'Gif':
					return 'image/gif';
				default:
					return A2(_elm_lang$core$Basics_ops['++'], 'image/', _p1._0);
			}
		case 'Audio':
			var _p2 = _p0._0;
			switch (_p2.ctor) {
				case 'Mp3':
					return 'audio/mp3';
				case 'Wav':
					return 'audio/wav';
				case 'Ogg':
					return 'audio/ogg';
				default:
					return A2(_elm_lang$core$Basics_ops['++'], 'audio/', _p2._0);
			}
		case 'Video':
			var _p3 = _p0._0;
			switch (_p3.ctor) {
				case 'Mp4':
					return 'video/mp4';
				case 'Mpeg':
					return 'video/mpeg';
				case 'Quicktime':
					return 'video/quicktime';
				case 'Avi':
					return 'video/avi';
				case 'Webm':
					return 'video/webm';
				default:
					return A2(_elm_lang$core$Basics_ops['++'], 'video/', _p3._0);
			}
		case 'Text':
			var _p4 = _p0._0;
			switch (_p4.ctor) {
				case 'PlainText':
					return 'text/plain';
				case 'Html':
					return 'text/html';
				case 'Css':
					return 'text/css';
				case 'Xml':
					return 'text/xml';
				case 'Json':
					return 'application/json';
				default:
					return A2(_elm_lang$core$Basics_ops['++'], 'text/', _p4._0);
			}
		case 'App':
			var _p5 = _p0._0;
			switch (_p5.ctor) {
				case 'Word':
					return 'application/msword';
				case 'WordXml':
					return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
				case 'Excel':
					return 'application/vnd.ms-excel';
				case 'ExcelXml':
					return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				case 'PowerPoint':
					return 'application/vnd.ms-powerpoint';
				case 'PowerPointXml':
					return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
				case 'Pdf':
					return 'application/pdf';
				default:
					return A2(_elm_lang$core$Basics_ops['++'], 'application/', _p5._0);
			}
		default:
			return _p0._0;
	}
};
var _danyx23$elm_mimetype$MimeType$OtherImage = function (a) {
	return {ctor: 'OtherImage', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Gif = {ctor: 'Gif'};
var _danyx23$elm_mimetype$MimeType$Png = {ctor: 'Png'};
var _danyx23$elm_mimetype$MimeType$Jpeg = {ctor: 'Jpeg'};
var _danyx23$elm_mimetype$MimeType$OtherAudio = function (a) {
	return {ctor: 'OtherAudio', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Wav = {ctor: 'Wav'};
var _danyx23$elm_mimetype$MimeType$Ogg = {ctor: 'Ogg'};
var _danyx23$elm_mimetype$MimeType$Mp3 = {ctor: 'Mp3'};
var _danyx23$elm_mimetype$MimeType$OtherVideo = function (a) {
	return {ctor: 'OtherVideo', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Webm = {ctor: 'Webm'};
var _danyx23$elm_mimetype$MimeType$Avi = {ctor: 'Avi'};
var _danyx23$elm_mimetype$MimeType$Quicktime = {ctor: 'Quicktime'};
var _danyx23$elm_mimetype$MimeType$Mpeg = {ctor: 'Mpeg'};
var _danyx23$elm_mimetype$MimeType$Mp4 = {ctor: 'Mp4'};
var _danyx23$elm_mimetype$MimeType$OtherText = function (a) {
	return {ctor: 'OtherText', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Json = {ctor: 'Json'};
var _danyx23$elm_mimetype$MimeType$Xml = {ctor: 'Xml'};
var _danyx23$elm_mimetype$MimeType$Css = {ctor: 'Css'};
var _danyx23$elm_mimetype$MimeType$Html = {ctor: 'Html'};
var _danyx23$elm_mimetype$MimeType$PlainText = {ctor: 'PlainText'};
var _danyx23$elm_mimetype$MimeType$OtherApp = function (a) {
	return {ctor: 'OtherApp', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Pdf = {ctor: 'Pdf'};
var _danyx23$elm_mimetype$MimeType$PowerPointXml = {ctor: 'PowerPointXml'};
var _danyx23$elm_mimetype$MimeType$PowerPoint = {ctor: 'PowerPoint'};
var _danyx23$elm_mimetype$MimeType$ExcelXml = {ctor: 'ExcelXml'};
var _danyx23$elm_mimetype$MimeType$Excel = {ctor: 'Excel'};
var _danyx23$elm_mimetype$MimeType$WordXml = {ctor: 'WordXml'};
var _danyx23$elm_mimetype$MimeType$Word = {ctor: 'Word'};
var _danyx23$elm_mimetype$MimeType$OtherMimeType = function (a) {
	return {ctor: 'OtherMimeType', _0: a};
};
var _danyx23$elm_mimetype$MimeType$App = function (a) {
	return {ctor: 'App', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Text = function (a) {
	return {ctor: 'Text', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Video = function (a) {
	return {ctor: 'Video', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Audio = function (a) {
	return {ctor: 'Audio', _0: a};
};
var _danyx23$elm_mimetype$MimeType$Image = function (a) {
	return {ctor: 'Image', _0: a};
};
var _danyx23$elm_mimetype$MimeType$parseMimeType = function (mimeString) {
	var _p6 = _elm_lang$core$String$toLower(mimeString);
	switch (_p6) {
		case '':
			return _elm_lang$core$Maybe$Nothing;
		case 'image/jpeg':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Image(_danyx23$elm_mimetype$MimeType$Jpeg));
		case 'image/png':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Image(_danyx23$elm_mimetype$MimeType$Png));
		case 'image/gif':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Image(_danyx23$elm_mimetype$MimeType$Gif));
		case 'audio/mp3':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Audio(_danyx23$elm_mimetype$MimeType$Mp3));
		case 'audio/mpeg':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Audio(_danyx23$elm_mimetype$MimeType$Mp3));
		case 'audio/wav':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Audio(_danyx23$elm_mimetype$MimeType$Wav));
		case 'audio/ogg':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Audio(_danyx23$elm_mimetype$MimeType$Ogg));
		case 'video/mp4':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Video(_danyx23$elm_mimetype$MimeType$Mp4));
		case 'video/mpeg':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Video(_danyx23$elm_mimetype$MimeType$Mpeg));
		case 'video/quicktime':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Video(_danyx23$elm_mimetype$MimeType$Quicktime));
		case 'video/avi':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Video(_danyx23$elm_mimetype$MimeType$Avi));
		case 'video/webm':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Video(_danyx23$elm_mimetype$MimeType$Webm));
		case 'text/plain':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Text(_danyx23$elm_mimetype$MimeType$PlainText));
		case 'text/html':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Text(_danyx23$elm_mimetype$MimeType$Html));
		case 'text/css':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Text(_danyx23$elm_mimetype$MimeType$Css));
		case 'text/xml':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Text(_danyx23$elm_mimetype$MimeType$Xml));
		case 'application/json':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Text(_danyx23$elm_mimetype$MimeType$Json));
		case 'application/msword':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$App(_danyx23$elm_mimetype$MimeType$Word));
		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$App(_danyx23$elm_mimetype$MimeType$WordXml));
		case 'application/vnd.ms-excel':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$App(_danyx23$elm_mimetype$MimeType$Excel));
		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$App(_danyx23$elm_mimetype$MimeType$ExcelXml));
		case 'application/vnd.ms-powerpoint':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$App(_danyx23$elm_mimetype$MimeType$PowerPoint));
		case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$App(_danyx23$elm_mimetype$MimeType$PowerPointXml));
		case 'application/pdf':
			return _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$App(_danyx23$elm_mimetype$MimeType$Pdf));
		default:
			var _p7 = _p6;
			return A2(_elm_lang$core$String$startsWith, 'image/', _p7) ? _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Image(
					_danyx23$elm_mimetype$MimeType$OtherImage(
						A2(
							_elm_lang$core$String$dropLeft,
							_elm_lang$core$String$length('image/'),
							_p7)))) : (A2(_elm_lang$core$String$startsWith, 'audio/', _p7) ? _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Audio(
					_danyx23$elm_mimetype$MimeType$OtherAudio(
						A2(
							_elm_lang$core$String$dropLeft,
							_elm_lang$core$String$length('audio/'),
							_p7)))) : (A2(_elm_lang$core$String$startsWith, 'video/', _p7) ? _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Video(
					_danyx23$elm_mimetype$MimeType$OtherVideo(
						A2(
							_elm_lang$core$String$dropLeft,
							_elm_lang$core$String$length('video/'),
							_p7)))) : (A2(_elm_lang$core$String$startsWith, 'text/', _p7) ? _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$Text(
					_danyx23$elm_mimetype$MimeType$OtherText(
						A2(
							_elm_lang$core$String$dropLeft,
							_elm_lang$core$String$length('text/'),
							_p7)))) : _elm_lang$core$Maybe$Just(
				_danyx23$elm_mimetype$MimeType$OtherMimeType(_p7)))));
	}
};

//import Native.List //

var _elm_lang$core$Native_Array = function() {

// A RRB-Tree has two distinct data types.
// Leaf -> "height"  is always 0
//         "table"   is an array of elements
// Node -> "height"  is always greater than 0
//         "table"   is an array of child nodes
//         "lengths" is an array of accumulated lengths of the child nodes

// M is the maximal table size. 32 seems fast. E is the allowed increase
// of search steps when concatting to find an index. Lower values will
// decrease balancing, but will increase search steps.
var M = 32;
var E = 2;

// An empty array.
var empty = {
	ctor: '_Array',
	height: 0,
	table: []
};


function get(i, array)
{
	if (i < 0 || i >= length(array))
	{
		throw new Error(
			'Index ' + i + ' is out of range. Check the length of ' +
			'your array first or use getMaybe or getWithDefault.');
	}
	return unsafeGet(i, array);
}


function unsafeGet(i, array)
{
	for (var x = array.height; x > 0; x--)
	{
		var slot = i >> (x * 5);
		while (array.lengths[slot] <= i)
		{
			slot++;
		}
		if (slot > 0)
		{
			i -= array.lengths[slot - 1];
		}
		array = array.table[slot];
	}
	return array.table[i];
}


// Sets the value at the index i. Only the nodes leading to i will get
// copied and updated.
function set(i, item, array)
{
	if (i < 0 || length(array) <= i)
	{
		return array;
	}
	return unsafeSet(i, item, array);
}


function unsafeSet(i, item, array)
{
	array = nodeCopy(array);

	if (array.height === 0)
	{
		array.table[i] = item;
	}
	else
	{
		var slot = getSlot(i, array);
		if (slot > 0)
		{
			i -= array.lengths[slot - 1];
		}
		array.table[slot] = unsafeSet(i, item, array.table[slot]);
	}
	return array;
}


function initialize(len, f)
{
	if (len <= 0)
	{
		return empty;
	}
	var h = Math.floor( Math.log(len) / Math.log(M) );
	return initialize_(f, h, 0, len);
}

function initialize_(f, h, from, to)
{
	if (h === 0)
	{
		var table = new Array((to - from) % (M + 1));
		for (var i = 0; i < table.length; i++)
		{
		  table[i] = f(from + i);
		}
		return {
			ctor: '_Array',
			height: 0,
			table: table
		};
	}

	var step = Math.pow(M, h);
	var table = new Array(Math.ceil((to - from) / step));
	var lengths = new Array(table.length);
	for (var i = 0; i < table.length; i++)
	{
		table[i] = initialize_(f, h - 1, from + (i * step), Math.min(from + ((i + 1) * step), to));
		lengths[i] = length(table[i]) + (i > 0 ? lengths[i-1] : 0);
	}
	return {
		ctor: '_Array',
		height: h,
		table: table,
		lengths: lengths
	};
}

function fromList(list)
{
	if (list.ctor === '[]')
	{
		return empty;
	}

	// Allocate M sized blocks (table) and write list elements to it.
	var table = new Array(M);
	var nodes = [];
	var i = 0;

	while (list.ctor !== '[]')
	{
		table[i] = list._0;
		list = list._1;
		i++;

		// table is full, so we can push a leaf containing it into the
		// next node.
		if (i === M)
		{
			var leaf = {
				ctor: '_Array',
				height: 0,
				table: table
			};
			fromListPush(leaf, nodes);
			table = new Array(M);
			i = 0;
		}
	}

	// Maybe there is something left on the table.
	if (i > 0)
	{
		var leaf = {
			ctor: '_Array',
			height: 0,
			table: table.splice(0, i)
		};
		fromListPush(leaf, nodes);
	}

	// Go through all of the nodes and eventually push them into higher nodes.
	for (var h = 0; h < nodes.length - 1; h++)
	{
		if (nodes[h].table.length > 0)
		{
			fromListPush(nodes[h], nodes);
		}
	}

	var head = nodes[nodes.length - 1];
	if (head.height > 0 && head.table.length === 1)
	{
		return head.table[0];
	}
	else
	{
		return head;
	}
}

// Push a node into a higher node as a child.
function fromListPush(toPush, nodes)
{
	var h = toPush.height;

	// Maybe the node on this height does not exist.
	if (nodes.length === h)
	{
		var node = {
			ctor: '_Array',
			height: h + 1,
			table: [],
			lengths: []
		};
		nodes.push(node);
	}

	nodes[h].table.push(toPush);
	var len = length(toPush);
	if (nodes[h].lengths.length > 0)
	{
		len += nodes[h].lengths[nodes[h].lengths.length - 1];
	}
	nodes[h].lengths.push(len);

	if (nodes[h].table.length === M)
	{
		fromListPush(nodes[h], nodes);
		nodes[h] = {
			ctor: '_Array',
			height: h + 1,
			table: [],
			lengths: []
		};
	}
}

// Pushes an item via push_ to the bottom right of a tree.
function push(item, a)
{
	var pushed = push_(item, a);
	if (pushed !== null)
	{
		return pushed;
	}

	var newTree = create(item, a.height);
	return siblise(a, newTree);
}

// Recursively tries to push an item to the bottom-right most
// tree possible. If there is no space left for the item,
// null will be returned.
function push_(item, a)
{
	// Handle resursion stop at leaf level.
	if (a.height === 0)
	{
		if (a.table.length < M)
		{
			var newA = {
				ctor: '_Array',
				height: 0,
				table: a.table.slice()
			};
			newA.table.push(item);
			return newA;
		}
		else
		{
		  return null;
		}
	}

	// Recursively push
	var pushed = push_(item, botRight(a));

	// There was space in the bottom right tree, so the slot will
	// be updated.
	if (pushed !== null)
	{
		var newA = nodeCopy(a);
		newA.table[newA.table.length - 1] = pushed;
		newA.lengths[newA.lengths.length - 1]++;
		return newA;
	}

	// When there was no space left, check if there is space left
	// for a new slot with a tree which contains only the item
	// at the bottom.
	if (a.table.length < M)
	{
		var newSlot = create(item, a.height - 1);
		var newA = nodeCopy(a);
		newA.table.push(newSlot);
		newA.lengths.push(newA.lengths[newA.lengths.length - 1] + length(newSlot));
		return newA;
	}
	else
	{
		return null;
	}
}

// Converts an array into a list of elements.
function toList(a)
{
	return toList_(_elm_lang$core$Native_List.Nil, a);
}

function toList_(list, a)
{
	for (var i = a.table.length - 1; i >= 0; i--)
	{
		list =
			a.height === 0
				? _elm_lang$core$Native_List.Cons(a.table[i], list)
				: toList_(list, a.table[i]);
	}
	return list;
}

// Maps a function over the elements of an array.
function map(f, a)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: new Array(a.table.length)
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths;
	}
	for (var i = 0; i < a.table.length; i++)
	{
		newA.table[i] =
			a.height === 0
				? f(a.table[i])
				: map(f, a.table[i]);
	}
	return newA;
}

// Maps a function over the elements with their index as first argument.
function indexedMap(f, a)
{
	return indexedMap_(f, a, 0);
}

function indexedMap_(f, a, from)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: new Array(a.table.length)
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths;
	}
	for (var i = 0; i < a.table.length; i++)
	{
		newA.table[i] =
			a.height === 0
				? A2(f, from + i, a.table[i])
				: indexedMap_(f, a.table[i], i == 0 ? from : from + a.lengths[i - 1]);
	}
	return newA;
}

function foldl(f, b, a)
{
	if (a.height === 0)
	{
		for (var i = 0; i < a.table.length; i++)
		{
			b = A2(f, a.table[i], b);
		}
	}
	else
	{
		for (var i = 0; i < a.table.length; i++)
		{
			b = foldl(f, b, a.table[i]);
		}
	}
	return b;
}

function foldr(f, b, a)
{
	if (a.height === 0)
	{
		for (var i = a.table.length; i--; )
		{
			b = A2(f, a.table[i], b);
		}
	}
	else
	{
		for (var i = a.table.length; i--; )
		{
			b = foldr(f, b, a.table[i]);
		}
	}
	return b;
}

// TODO: currently, it slices the right, then the left. This can be
// optimized.
function slice(from, to, a)
{
	if (from < 0)
	{
		from += length(a);
	}
	if (to < 0)
	{
		to += length(a);
	}
	return sliceLeft(from, sliceRight(to, a));
}

function sliceRight(to, a)
{
	if (to === length(a))
	{
		return a;
	}

	// Handle leaf level.
	if (a.height === 0)
	{
		var newA = { ctor:'_Array', height:0 };
		newA.table = a.table.slice(0, to);
		return newA;
	}

	// Slice the right recursively.
	var right = getSlot(to, a);
	var sliced = sliceRight(to - (right > 0 ? a.lengths[right - 1] : 0), a.table[right]);

	// Maybe the a node is not even needed, as sliced contains the whole slice.
	if (right === 0)
	{
		return sliced;
	}

	// Create new node.
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice(0, right),
		lengths: a.lengths.slice(0, right)
	};
	if (sliced.table.length > 0)
	{
		newA.table[right] = sliced;
		newA.lengths[right] = length(sliced) + (right > 0 ? newA.lengths[right - 1] : 0);
	}
	return newA;
}

function sliceLeft(from, a)
{
	if (from === 0)
	{
		return a;
	}

	// Handle leaf level.
	if (a.height === 0)
	{
		var newA = { ctor:'_Array', height:0 };
		newA.table = a.table.slice(from, a.table.length + 1);
		return newA;
	}

	// Slice the left recursively.
	var left = getSlot(from, a);
	var sliced = sliceLeft(from - (left > 0 ? a.lengths[left - 1] : 0), a.table[left]);

	// Maybe the a node is not even needed, as sliced contains the whole slice.
	if (left === a.table.length - 1)
	{
		return sliced;
	}

	// Create new node.
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice(left, a.table.length + 1),
		lengths: new Array(a.table.length - left)
	};
	newA.table[0] = sliced;
	var len = 0;
	for (var i = 0; i < newA.table.length; i++)
	{
		len += length(newA.table[i]);
		newA.lengths[i] = len;
	}

	return newA;
}

// Appends two trees.
function append(a,b)
{
	if (a.table.length === 0)
	{
		return b;
	}
	if (b.table.length === 0)
	{
		return a;
	}

	var c = append_(a, b);

	// Check if both nodes can be crunshed together.
	if (c[0].table.length + c[1].table.length <= M)
	{
		if (c[0].table.length === 0)
		{
			return c[1];
		}
		if (c[1].table.length === 0)
		{
			return c[0];
		}

		// Adjust .table and .lengths
		c[0].table = c[0].table.concat(c[1].table);
		if (c[0].height > 0)
		{
			var len = length(c[0]);
			for (var i = 0; i < c[1].lengths.length; i++)
			{
				c[1].lengths[i] += len;
			}
			c[0].lengths = c[0].lengths.concat(c[1].lengths);
		}

		return c[0];
	}

	if (c[0].height > 0)
	{
		var toRemove = calcToRemove(a, b);
		if (toRemove > E)
		{
			c = shuffle(c[0], c[1], toRemove);
		}
	}

	return siblise(c[0], c[1]);
}

// Returns an array of two nodes; right and left. One node _may_ be empty.
function append_(a, b)
{
	if (a.height === 0 && b.height === 0)
	{
		return [a, b];
	}

	if (a.height !== 1 || b.height !== 1)
	{
		if (a.height === b.height)
		{
			a = nodeCopy(a);
			b = nodeCopy(b);
			var appended = append_(botRight(a), botLeft(b));

			insertRight(a, appended[1]);
			insertLeft(b, appended[0]);
		}
		else if (a.height > b.height)
		{
			a = nodeCopy(a);
			var appended = append_(botRight(a), b);

			insertRight(a, appended[0]);
			b = parentise(appended[1], appended[1].height + 1);
		}
		else
		{
			b = nodeCopy(b);
			var appended = append_(a, botLeft(b));

			var left = appended[0].table.length === 0 ? 0 : 1;
			var right = left === 0 ? 1 : 0;
			insertLeft(b, appended[left]);
			a = parentise(appended[right], appended[right].height + 1);
		}
	}

	// Check if balancing is needed and return based on that.
	if (a.table.length === 0 || b.table.length === 0)
	{
		return [a, b];
	}

	var toRemove = calcToRemove(a, b);
	if (toRemove <= E)
	{
		return [a, b];
	}
	return shuffle(a, b, toRemove);
}

// Helperfunctions for append_. Replaces a child node at the side of the parent.
function insertRight(parent, node)
{
	var index = parent.table.length - 1;
	parent.table[index] = node;
	parent.lengths[index] = length(node);
	parent.lengths[index] += index > 0 ? parent.lengths[index - 1] : 0;
}

function insertLeft(parent, node)
{
	if (node.table.length > 0)
	{
		parent.table[0] = node;
		parent.lengths[0] = length(node);

		var len = length(parent.table[0]);
		for (var i = 1; i < parent.lengths.length; i++)
		{
			len += length(parent.table[i]);
			parent.lengths[i] = len;
		}
	}
	else
	{
		parent.table.shift();
		for (var i = 1; i < parent.lengths.length; i++)
		{
			parent.lengths[i] = parent.lengths[i] - parent.lengths[0];
		}
		parent.lengths.shift();
	}
}

// Returns the extra search steps for E. Refer to the paper.
function calcToRemove(a, b)
{
	var subLengths = 0;
	for (var i = 0; i < a.table.length; i++)
	{
		subLengths += a.table[i].table.length;
	}
	for (var i = 0; i < b.table.length; i++)
	{
		subLengths += b.table[i].table.length;
	}

	var toRemove = a.table.length + b.table.length;
	return toRemove - (Math.floor((subLengths - 1) / M) + 1);
}

// get2, set2 and saveSlot are helpers for accessing elements over two arrays.
function get2(a, b, index)
{
	return index < a.length
		? a[index]
		: b[index - a.length];
}

function set2(a, b, index, value)
{
	if (index < a.length)
	{
		a[index] = value;
	}
	else
	{
		b[index - a.length] = value;
	}
}

function saveSlot(a, b, index, slot)
{
	set2(a.table, b.table, index, slot);

	var l = (index === 0 || index === a.lengths.length)
		? 0
		: get2(a.lengths, a.lengths, index - 1);

	set2(a.lengths, b.lengths, index, l + length(slot));
}

// Creates a node or leaf with a given length at their arrays for perfomance.
// Is only used by shuffle.
function createNode(h, length)
{
	if (length < 0)
	{
		length = 0;
	}
	var a = {
		ctor: '_Array',
		height: h,
		table: new Array(length)
	};
	if (h > 0)
	{
		a.lengths = new Array(length);
	}
	return a;
}

// Returns an array of two balanced nodes.
function shuffle(a, b, toRemove)
{
	var newA = createNode(a.height, Math.min(M, a.table.length + b.table.length - toRemove));
	var newB = createNode(a.height, newA.table.length - (a.table.length + b.table.length - toRemove));

	// Skip the slots with size M. More precise: copy the slot references
	// to the new node
	var read = 0;
	while (get2(a.table, b.table, read).table.length % M === 0)
	{
		set2(newA.table, newB.table, read, get2(a.table, b.table, read));
		set2(newA.lengths, newB.lengths, read, get2(a.lengths, b.lengths, read));
		read++;
	}

	// Pulling items from left to right, caching in a slot before writing
	// it into the new nodes.
	var write = read;
	var slot = new createNode(a.height - 1, 0);
	var from = 0;

	// If the current slot is still containing data, then there will be at
	// least one more write, so we do not break this loop yet.
	while (read - write - (slot.table.length > 0 ? 1 : 0) < toRemove)
	{
		// Find out the max possible items for copying.
		var source = get2(a.table, b.table, read);
		var to = Math.min(M - slot.table.length, source.table.length);

		// Copy and adjust size table.
		slot.table = slot.table.concat(source.table.slice(from, to));
		if (slot.height > 0)
		{
			var len = slot.lengths.length;
			for (var i = len; i < len + to - from; i++)
			{
				slot.lengths[i] = length(slot.table[i]);
				slot.lengths[i] += (i > 0 ? slot.lengths[i - 1] : 0);
			}
		}

		from += to;

		// Only proceed to next slots[i] if the current one was
		// fully copied.
		if (source.table.length <= to)
		{
			read++; from = 0;
		}

		// Only create a new slot if the current one is filled up.
		if (slot.table.length === M)
		{
			saveSlot(newA, newB, write, slot);
			slot = createNode(a.height - 1, 0);
			write++;
		}
	}

	// Cleanup after the loop. Copy the last slot into the new nodes.
	if (slot.table.length > 0)
	{
		saveSlot(newA, newB, write, slot);
		write++;
	}

	// Shift the untouched slots to the left
	while (read < a.table.length + b.table.length )
	{
		saveSlot(newA, newB, write, get2(a.table, b.table, read));
		read++;
		write++;
	}

	return [newA, newB];
}

// Navigation functions
function botRight(a)
{
	return a.table[a.table.length - 1];
}
function botLeft(a)
{
	return a.table[0];
}

// Copies a node for updating. Note that you should not use this if
// only updating only one of "table" or "lengths" for performance reasons.
function nodeCopy(a)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice()
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths.slice();
	}
	return newA;
}

// Returns how many items are in the tree.
function length(array)
{
	if (array.height === 0)
	{
		return array.table.length;
	}
	else
	{
		return array.lengths[array.lengths.length - 1];
	}
}

// Calculates in which slot of "table" the item probably is, then
// find the exact slot via forward searching in  "lengths". Returns the index.
function getSlot(i, a)
{
	var slot = i >> (5 * a.height);
	while (a.lengths[slot] <= i)
	{
		slot++;
	}
	return slot;
}

// Recursively creates a tree with a given height containing
// only the given item.
function create(item, h)
{
	if (h === 0)
	{
		return {
			ctor: '_Array',
			height: 0,
			table: [item]
		};
	}
	return {
		ctor: '_Array',
		height: h,
		table: [create(item, h - 1)],
		lengths: [1]
	};
}

// Recursively creates a tree that contains the given tree.
function parentise(tree, h)
{
	if (h === tree.height)
	{
		return tree;
	}

	return {
		ctor: '_Array',
		height: h,
		table: [parentise(tree, h - 1)],
		lengths: [length(tree)]
	};
}

// Emphasizes blood brotherhood beneath two trees.
function siblise(a, b)
{
	return {
		ctor: '_Array',
		height: a.height + 1,
		table: [a, b],
		lengths: [length(a), length(a) + length(b)]
	};
}

function toJSArray(a)
{
	var jsArray = new Array(length(a));
	toJSArray_(jsArray, 0, a);
	return jsArray;
}

function toJSArray_(jsArray, i, a)
{
	for (var t = 0; t < a.table.length; t++)
	{
		if (a.height === 0)
		{
			jsArray[i + t] = a.table[t];
		}
		else
		{
			var inc = t === 0 ? 0 : a.lengths[t - 1];
			toJSArray_(jsArray, i + inc, a.table[t]);
		}
	}
}

function fromJSArray(jsArray)
{
	if (jsArray.length === 0)
	{
		return empty;
	}
	var h = Math.floor(Math.log(jsArray.length) / Math.log(M));
	return fromJSArray_(jsArray, h, 0, jsArray.length);
}

function fromJSArray_(jsArray, h, from, to)
{
	if (h === 0)
	{
		return {
			ctor: '_Array',
			height: 0,
			table: jsArray.slice(from, to)
		};
	}

	var step = Math.pow(M, h);
	var table = new Array(Math.ceil((to - from) / step));
	var lengths = new Array(table.length);
	for (var i = 0; i < table.length; i++)
	{
		table[i] = fromJSArray_(jsArray, h - 1, from + (i * step), Math.min(from + ((i + 1) * step), to));
		lengths[i] = length(table[i]) + (i > 0 ? lengths[i - 1] : 0);
	}
	return {
		ctor: '_Array',
		height: h,
		table: table,
		lengths: lengths
	};
}

return {
	empty: empty,
	fromList: fromList,
	toList: toList,
	initialize: F2(initialize),
	append: F2(append),
	push: F2(push),
	slice: F3(slice),
	get: F2(get),
	set: F3(set),
	map: F2(map),
	indexedMap: F2(indexedMap),
	foldl: F3(foldl),
	foldr: F3(foldr),
	length: length,

	toJSArray: toJSArray,
	fromJSArray: fromJSArray
};

}();
var _elm_lang$core$Array$append = _elm_lang$core$Native_Array.append;
var _elm_lang$core$Array$length = _elm_lang$core$Native_Array.length;
var _elm_lang$core$Array$isEmpty = function (array) {
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Array$length(array),
		0);
};
var _elm_lang$core$Array$slice = _elm_lang$core$Native_Array.slice;
var _elm_lang$core$Array$set = _elm_lang$core$Native_Array.set;
var _elm_lang$core$Array$get = F2(
	function (i, array) {
		return ((_elm_lang$core$Native_Utils.cmp(0, i) < 1) && (_elm_lang$core$Native_Utils.cmp(
			i,
			_elm_lang$core$Native_Array.length(array)) < 0)) ? _elm_lang$core$Maybe$Just(
			A2(_elm_lang$core$Native_Array.get, i, array)) : _elm_lang$core$Maybe$Nothing;
	});
var _elm_lang$core$Array$push = _elm_lang$core$Native_Array.push;
var _elm_lang$core$Array$empty = _elm_lang$core$Native_Array.empty;
var _elm_lang$core$Array$filter = F2(
	function (isOkay, arr) {
		var update = F2(
			function (x, xs) {
				return isOkay(x) ? A2(_elm_lang$core$Native_Array.push, x, xs) : xs;
			});
		return A3(_elm_lang$core$Native_Array.foldl, update, _elm_lang$core$Native_Array.empty, arr);
	});
var _elm_lang$core$Array$foldr = _elm_lang$core$Native_Array.foldr;
var _elm_lang$core$Array$foldl = _elm_lang$core$Native_Array.foldl;
var _elm_lang$core$Array$indexedMap = _elm_lang$core$Native_Array.indexedMap;
var _elm_lang$core$Array$map = _elm_lang$core$Native_Array.map;
var _elm_lang$core$Array$toIndexedList = function (array) {
	return A3(
		_elm_lang$core$List$map2,
		F2(
			function (v0, v1) {
				return {ctor: '_Tuple2', _0: v0, _1: v1};
			}),
		A2(
			_elm_lang$core$List$range,
			0,
			_elm_lang$core$Native_Array.length(array) - 1),
		_elm_lang$core$Native_Array.toList(array));
};
var _elm_lang$core$Array$toList = _elm_lang$core$Native_Array.toList;
var _elm_lang$core$Array$fromList = _elm_lang$core$Native_Array.fromList;
var _elm_lang$core$Array$initialize = _elm_lang$core$Native_Array.initialize;
var _elm_lang$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			_elm_lang$core$Array$initialize,
			n,
			_elm_lang$core$Basics$always(e));
	});
var _elm_lang$core$Array$Array = {ctor: 'Array'};

//import Maybe, Native.Array, Native.List, Native.Utils, Result //

var _elm_lang$core$Native_Json = function() {


// CORE DECODERS

function succeed(msg)
{
	return {
		ctor: '<decoder>',
		tag: 'succeed',
		msg: msg
	};
}

function fail(msg)
{
	return {
		ctor: '<decoder>',
		tag: 'fail',
		msg: msg
	};
}

function decodePrimitive(tag)
{
	return {
		ctor: '<decoder>',
		tag: tag
	};
}

function decodeContainer(tag, decoder)
{
	return {
		ctor: '<decoder>',
		tag: tag,
		decoder: decoder
	};
}

function decodeNull(value)
{
	return {
		ctor: '<decoder>',
		tag: 'null',
		value: value
	};
}

function decodeField(field, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'field',
		field: field,
		decoder: decoder
	};
}

function decodeIndex(index, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'index',
		index: index,
		decoder: decoder
	};
}

function decodeKeyValuePairs(decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'key-value',
		decoder: decoder
	};
}

function mapMany(f, decoders)
{
	return {
		ctor: '<decoder>',
		tag: 'map-many',
		func: f,
		decoders: decoders
	};
}

function andThen(callback, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'andThen',
		decoder: decoder,
		callback: callback
	};
}

function oneOf(decoders)
{
	return {
		ctor: '<decoder>',
		tag: 'oneOf',
		decoders: decoders
	};
}


// DECODING OBJECTS

function map1(f, d1)
{
	return mapMany(f, [d1]);
}

function map2(f, d1, d2)
{
	return mapMany(f, [d1, d2]);
}

function map3(f, d1, d2, d3)
{
	return mapMany(f, [d1, d2, d3]);
}

function map4(f, d1, d2, d3, d4)
{
	return mapMany(f, [d1, d2, d3, d4]);
}

function map5(f, d1, d2, d3, d4, d5)
{
	return mapMany(f, [d1, d2, d3, d4, d5]);
}

function map6(f, d1, d2, d3, d4, d5, d6)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6]);
}

function map7(f, d1, d2, d3, d4, d5, d6, d7)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
}

function map8(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
}


// DECODE HELPERS

function ok(value)
{
	return { tag: 'ok', value: value };
}

function badPrimitive(type, value)
{
	return { tag: 'primitive', type: type, value: value };
}

function badIndex(index, nestedProblems)
{
	return { tag: 'index', index: index, rest: nestedProblems };
}

function badField(field, nestedProblems)
{
	return { tag: 'field', field: field, rest: nestedProblems };
}

function badIndex(index, nestedProblems)
{
	return { tag: 'index', index: index, rest: nestedProblems };
}

function badOneOf(problems)
{
	return { tag: 'oneOf', problems: problems };
}

function bad(msg)
{
	return { tag: 'fail', msg: msg };
}

function badToString(problem)
{
	var context = '_';
	while (problem)
	{
		switch (problem.tag)
		{
			case 'primitive':
				return 'Expecting ' + problem.type
					+ (context === '_' ? '' : ' at ' + context)
					+ ' but instead got: ' + jsToString(problem.value);

			case 'index':
				context += '[' + problem.index + ']';
				problem = problem.rest;
				break;

			case 'field':
				context += '.' + problem.field;
				problem = problem.rest;
				break;

			case 'oneOf':
				var problems = problem.problems;
				for (var i = 0; i < problems.length; i++)
				{
					problems[i] = badToString(problems[i]);
				}
				return 'I ran into the following problems'
					+ (context === '_' ? '' : ' at ' + context)
					+ ':\n\n' + problems.join('\n');

			case 'fail':
				return 'I ran into a `fail` decoder'
					+ (context === '_' ? '' : ' at ' + context)
					+ ': ' + problem.msg;
		}
	}
}

function jsToString(value)
{
	return value === undefined
		? 'undefined'
		: JSON.stringify(value);
}


// DECODE

function runOnString(decoder, string)
{
	var json;
	try
	{
		json = JSON.parse(string);
	}
	catch (e)
	{
		return _elm_lang$core$Result$Err('Given an invalid JSON: ' + e.message);
	}
	return run(decoder, json);
}

function run(decoder, value)
{
	var result = runHelp(decoder, value);
	return (result.tag === 'ok')
		? _elm_lang$core$Result$Ok(result.value)
		: _elm_lang$core$Result$Err(badToString(result));
}

function runHelp(decoder, value)
{
	switch (decoder.tag)
	{
		case 'bool':
			return (typeof value === 'boolean')
				? ok(value)
				: badPrimitive('a Bool', value);

		case 'int':
			if (typeof value !== 'number') {
				return badPrimitive('an Int', value);
			}

			if (-2147483647 < value && value < 2147483647 && (value | 0) === value) {
				return ok(value);
			}

			if (isFinite(value) && !(value % 1)) {
				return ok(value);
			}

			return badPrimitive('an Int', value);

		case 'float':
			return (typeof value === 'number')
				? ok(value)
				: badPrimitive('a Float', value);

		case 'string':
			return (typeof value === 'string')
				? ok(value)
				: (value instanceof String)
					? ok(value + '')
					: badPrimitive('a String', value);

		case 'null':
			return (value === null)
				? ok(decoder.value)
				: badPrimitive('null', value);

		case 'value':
			return ok(value);

		case 'list':
			if (!(value instanceof Array))
			{
				return badPrimitive('a List', value);
			}

			var list = _elm_lang$core$Native_List.Nil;
			for (var i = value.length; i--; )
			{
				var result = runHelp(decoder.decoder, value[i]);
				if (result.tag !== 'ok')
				{
					return badIndex(i, result)
				}
				list = _elm_lang$core$Native_List.Cons(result.value, list);
			}
			return ok(list);

		case 'array':
			if (!(value instanceof Array))
			{
				return badPrimitive('an Array', value);
			}

			var len = value.length;
			var array = new Array(len);
			for (var i = len; i--; )
			{
				var result = runHelp(decoder.decoder, value[i]);
				if (result.tag !== 'ok')
				{
					return badIndex(i, result);
				}
				array[i] = result.value;
			}
			return ok(_elm_lang$core$Native_Array.fromJSArray(array));

		case 'maybe':
			var result = runHelp(decoder.decoder, value);
			return (result.tag === 'ok')
				? ok(_elm_lang$core$Maybe$Just(result.value))
				: ok(_elm_lang$core$Maybe$Nothing);

		case 'field':
			var field = decoder.field;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return badPrimitive('an object with a field named `' + field + '`', value);
			}

			var result = runHelp(decoder.decoder, value[field]);
			return (result.tag === 'ok') ? result : badField(field, result);

		case 'index':
			var index = decoder.index;
			if (!(value instanceof Array))
			{
				return badPrimitive('an array', value);
			}
			if (index >= value.length)
			{
				return badPrimitive('a longer array. Need index ' + index + ' but there are only ' + value.length + ' entries', value);
			}

			var result = runHelp(decoder.decoder, value[index]);
			return (result.tag === 'ok') ? result : badIndex(index, result);

		case 'key-value':
			if (typeof value !== 'object' || value === null || value instanceof Array)
			{
				return badPrimitive('an object', value);
			}

			var keyValuePairs = _elm_lang$core$Native_List.Nil;
			for (var key in value)
			{
				var result = runHelp(decoder.decoder, value[key]);
				if (result.tag !== 'ok')
				{
					return badField(key, result);
				}
				var pair = _elm_lang$core$Native_Utils.Tuple2(key, result.value);
				keyValuePairs = _elm_lang$core$Native_List.Cons(pair, keyValuePairs);
			}
			return ok(keyValuePairs);

		case 'map-many':
			var answer = decoder.func;
			var decoders = decoder.decoders;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = runHelp(decoders[i], value);
				if (result.tag !== 'ok')
				{
					return result;
				}
				answer = answer(result.value);
			}
			return ok(answer);

		case 'andThen':
			var result = runHelp(decoder.decoder, value);
			return (result.tag !== 'ok')
				? result
				: runHelp(decoder.callback(result.value), value);

		case 'oneOf':
			var errors = [];
			var temp = decoder.decoders;
			while (temp.ctor !== '[]')
			{
				var result = runHelp(temp._0, value);

				if (result.tag === 'ok')
				{
					return result;
				}

				errors.push(result);

				temp = temp._1;
			}
			return badOneOf(errors);

		case 'fail':
			return bad(decoder.msg);

		case 'succeed':
			return ok(decoder.msg);
	}
}


// EQUALITY

function equality(a, b)
{
	if (a === b)
	{
		return true;
	}

	if (a.tag !== b.tag)
	{
		return false;
	}

	switch (a.tag)
	{
		case 'succeed':
		case 'fail':
			return a.msg === b.msg;

		case 'bool':
		case 'int':
		case 'float':
		case 'string':
		case 'value':
			return true;

		case 'null':
			return a.value === b.value;

		case 'list':
		case 'array':
		case 'maybe':
		case 'key-value':
			return equality(a.decoder, b.decoder);

		case 'field':
			return a.field === b.field && equality(a.decoder, b.decoder);

		case 'index':
			return a.index === b.index && equality(a.decoder, b.decoder);

		case 'map-many':
			if (a.func !== b.func)
			{
				return false;
			}
			return listEquality(a.decoders, b.decoders);

		case 'andThen':
			return a.callback === b.callback && equality(a.decoder, b.decoder);

		case 'oneOf':
			return listEquality(a.decoders, b.decoders);
	}
}

function listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

function encode(indentLevel, value)
{
	return JSON.stringify(value, null, indentLevel);
}

function identity(value)
{
	return value;
}

function encodeObject(keyValuePairs)
{
	var obj = {};
	while (keyValuePairs.ctor !== '[]')
	{
		var pair = keyValuePairs._0;
		obj[pair._0] = pair._1;
		keyValuePairs = keyValuePairs._1;
	}
	return obj;
}

return {
	encode: F2(encode),
	runOnString: F2(runOnString),
	run: F2(run),

	decodeNull: decodeNull,
	decodePrimitive: decodePrimitive,
	decodeContainer: F2(decodeContainer),

	decodeField: F2(decodeField),
	decodeIndex: F2(decodeIndex),

	map1: F2(map1),
	map2: F3(map2),
	map3: F4(map3),
	map4: F5(map4),
	map5: F6(map5),
	map6: F7(map6),
	map7: F8(map7),
	map8: F9(map8),
	decodeKeyValuePairs: decodeKeyValuePairs,

	andThen: F2(andThen),
	fail: fail,
	succeed: succeed,
	oneOf: oneOf,

	identity: identity,
	encodeNull: null,
	encodeArray: _elm_lang$core$Native_Array.toJSArray,
	encodeList: _elm_lang$core$Native_List.toArray,
	encodeObject: encodeObject,

	equality: equality
};

}();

var _elm_lang$core$Json_Encode$list = _elm_lang$core$Native_Json.encodeList;
var _elm_lang$core$Json_Encode$array = _elm_lang$core$Native_Json.encodeArray;
var _elm_lang$core$Json_Encode$object = _elm_lang$core$Native_Json.encodeObject;
var _elm_lang$core$Json_Encode$null = _elm_lang$core$Native_Json.encodeNull;
var _elm_lang$core$Json_Encode$bool = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$float = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$int = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$string = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$encode = _elm_lang$core$Native_Json.encode;
var _elm_lang$core$Json_Encode$Value = {ctor: 'Value'};

var _elm_lang$core$Dict$foldr = F3(
	function (f, acc, t) {
		foldr:
		while (true) {
			var _p0 = t;
			if (_p0.ctor === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var _v1 = f,
					_v2 = A3(
					f,
					_p0._1,
					_p0._2,
					A3(_elm_lang$core$Dict$foldr, f, acc, _p0._4)),
					_v3 = _p0._3;
				f = _v1;
				acc = _v2;
				t = _v3;
				continue foldr;
			}
		}
	});
var _elm_lang$core$Dict$keys = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return {ctor: '::', _0: key, _1: keyList};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$values = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return {ctor: '::', _0: value, _1: valueList};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$toList = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: key, _1: value},
					_1: list
				};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$foldl = F3(
	function (f, acc, dict) {
		foldl:
		while (true) {
			var _p1 = dict;
			if (_p1.ctor === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var _v5 = f,
					_v6 = A3(
					f,
					_p1._1,
					_p1._2,
					A3(_elm_lang$core$Dict$foldl, f, acc, _p1._3)),
					_v7 = _p1._4;
				f = _v5;
				acc = _v6;
				dict = _v7;
				continue foldl;
			}
		}
	});
var _elm_lang$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _p2) {
				stepState:
				while (true) {
					var _p3 = _p2;
					var _p9 = _p3._1;
					var _p8 = _p3._0;
					var _p4 = _p8;
					if (_p4.ctor === '[]') {
						return {
							ctor: '_Tuple2',
							_0: _p8,
							_1: A3(rightStep, rKey, rValue, _p9)
						};
					} else {
						var _p7 = _p4._1;
						var _p6 = _p4._0._1;
						var _p5 = _p4._0._0;
						if (_elm_lang$core$Native_Utils.cmp(_p5, rKey) < 0) {
							var _v10 = rKey,
								_v11 = rValue,
								_v12 = {
								ctor: '_Tuple2',
								_0: _p7,
								_1: A3(leftStep, _p5, _p6, _p9)
							};
							rKey = _v10;
							rValue = _v11;
							_p2 = _v12;
							continue stepState;
						} else {
							if (_elm_lang$core$Native_Utils.cmp(_p5, rKey) > 0) {
								return {
									ctor: '_Tuple2',
									_0: _p8,
									_1: A3(rightStep, rKey, rValue, _p9)
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: _p7,
									_1: A4(bothStep, _p5, _p6, rValue, _p9)
								};
							}
						}
					}
				}
			});
		var _p10 = A3(
			_elm_lang$core$Dict$foldl,
			stepState,
			{
				ctor: '_Tuple2',
				_0: _elm_lang$core$Dict$toList(leftDict),
				_1: initialResult
			},
			rightDict);
		var leftovers = _p10._0;
		var intermediateResult = _p10._1;
		return A3(
			_elm_lang$core$List$foldl,
			F2(
				function (_p11, result) {
					var _p12 = _p11;
					return A3(leftStep, _p12._0, _p12._1, result);
				}),
			intermediateResult,
			leftovers);
	});
var _elm_lang$core$Dict$reportRemBug = F4(
	function (msg, c, lgot, rgot) {
		return _elm_lang$core$Native_Debug.crash(
			_elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'Internal red-black tree invariant violated, expected ',
					_1: {
						ctor: '::',
						_0: msg,
						_1: {
							ctor: '::',
							_0: ' and got ',
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Basics$toString(c),
								_1: {
									ctor: '::',
									_0: '/',
									_1: {
										ctor: '::',
										_0: lgot,
										_1: {
											ctor: '::',
											_0: '/',
											_1: {
												ctor: '::',
												_0: rgot,
												_1: {
													ctor: '::',
													_0: '\nPlease report this bug to <https://github.com/elm-lang/core/issues>',
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							}
						}
					}
				}));
	});
var _elm_lang$core$Dict$isBBlack = function (dict) {
	var _p13 = dict;
	_v14_2:
	do {
		if (_p13.ctor === 'RBNode_elm_builtin') {
			if (_p13._0.ctor === 'BBlack') {
				return true;
			} else {
				break _v14_2;
			}
		} else {
			if (_p13._0.ctor === 'LBBlack') {
				return true;
			} else {
				break _v14_2;
			}
		}
	} while(false);
	return false;
};
var _elm_lang$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			var _p14 = dict;
			if (_p14.ctor === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var _v16 = A2(_elm_lang$core$Dict$sizeHelp, n + 1, _p14._4),
					_v17 = _p14._3;
				n = _v16;
				dict = _v17;
				continue sizeHelp;
			}
		}
	});
var _elm_lang$core$Dict$size = function (dict) {
	return A2(_elm_lang$core$Dict$sizeHelp, 0, dict);
};
var _elm_lang$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			var _p15 = dict;
			if (_p15.ctor === 'RBEmpty_elm_builtin') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p16 = A2(_elm_lang$core$Basics$compare, targetKey, _p15._1);
				switch (_p16.ctor) {
					case 'LT':
						var _v20 = targetKey,
							_v21 = _p15._3;
						targetKey = _v20;
						dict = _v21;
						continue get;
					case 'EQ':
						return _elm_lang$core$Maybe$Just(_p15._2);
					default:
						var _v22 = targetKey,
							_v23 = _p15._4;
						targetKey = _v22;
						dict = _v23;
						continue get;
				}
			}
		}
	});
var _elm_lang$core$Dict$member = F2(
	function (key, dict) {
		var _p17 = A2(_elm_lang$core$Dict$get, key, dict);
		if (_p17.ctor === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var _elm_lang$core$Dict$maxWithDefault = F3(
	function (k, v, r) {
		maxWithDefault:
		while (true) {
			var _p18 = r;
			if (_p18.ctor === 'RBEmpty_elm_builtin') {
				return {ctor: '_Tuple2', _0: k, _1: v};
			} else {
				var _v26 = _p18._1,
					_v27 = _p18._2,
					_v28 = _p18._4;
				k = _v26;
				v = _v27;
				r = _v28;
				continue maxWithDefault;
			}
		}
	});
var _elm_lang$core$Dict$NBlack = {ctor: 'NBlack'};
var _elm_lang$core$Dict$BBlack = {ctor: 'BBlack'};
var _elm_lang$core$Dict$Black = {ctor: 'Black'};
var _elm_lang$core$Dict$blackish = function (t) {
	var _p19 = t;
	if (_p19.ctor === 'RBNode_elm_builtin') {
		var _p20 = _p19._0;
		return _elm_lang$core$Native_Utils.eq(_p20, _elm_lang$core$Dict$Black) || _elm_lang$core$Native_Utils.eq(_p20, _elm_lang$core$Dict$BBlack);
	} else {
		return true;
	}
};
var _elm_lang$core$Dict$Red = {ctor: 'Red'};
var _elm_lang$core$Dict$moreBlack = function (color) {
	var _p21 = color;
	switch (_p21.ctor) {
		case 'Black':
			return _elm_lang$core$Dict$BBlack;
		case 'Red':
			return _elm_lang$core$Dict$Black;
		case 'NBlack':
			return _elm_lang$core$Dict$Red;
		default:
			return _elm_lang$core$Native_Debug.crash('Can\'t make a double black node more black!');
	}
};
var _elm_lang$core$Dict$lessBlack = function (color) {
	var _p22 = color;
	switch (_p22.ctor) {
		case 'BBlack':
			return _elm_lang$core$Dict$Black;
		case 'Black':
			return _elm_lang$core$Dict$Red;
		case 'Red':
			return _elm_lang$core$Dict$NBlack;
		default:
			return _elm_lang$core$Native_Debug.crash('Can\'t make a negative black node less black!');
	}
};
var _elm_lang$core$Dict$LBBlack = {ctor: 'LBBlack'};
var _elm_lang$core$Dict$LBlack = {ctor: 'LBlack'};
var _elm_lang$core$Dict$RBEmpty_elm_builtin = function (a) {
	return {ctor: 'RBEmpty_elm_builtin', _0: a};
};
var _elm_lang$core$Dict$empty = _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
var _elm_lang$core$Dict$isEmpty = function (dict) {
	return _elm_lang$core$Native_Utils.eq(dict, _elm_lang$core$Dict$empty);
};
var _elm_lang$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {ctor: 'RBNode_elm_builtin', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _elm_lang$core$Dict$ensureBlackRoot = function (dict) {
	var _p23 = dict;
	if ((_p23.ctor === 'RBNode_elm_builtin') && (_p23._0.ctor === 'Red')) {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p23._1, _p23._2, _p23._3, _p23._4);
	} else {
		return dict;
	}
};
var _elm_lang$core$Dict$lessBlackTree = function (dict) {
	var _p24 = dict;
	if (_p24.ctor === 'RBNode_elm_builtin') {
		return A5(
			_elm_lang$core$Dict$RBNode_elm_builtin,
			_elm_lang$core$Dict$lessBlack(_p24._0),
			_p24._1,
			_p24._2,
			_p24._3,
			_p24._4);
	} else {
		return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
	}
};
var _elm_lang$core$Dict$balancedTree = function (col) {
	return function (xk) {
		return function (xv) {
			return function (yk) {
				return function (yv) {
					return function (zk) {
						return function (zv) {
							return function (a) {
								return function (b) {
									return function (c) {
										return function (d) {
											return A5(
												_elm_lang$core$Dict$RBNode_elm_builtin,
												_elm_lang$core$Dict$lessBlack(col),
												yk,
												yv,
												A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, xk, xv, a, b),
												A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, zk, zv, c, d));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _elm_lang$core$Dict$blacken = function (t) {
	var _p25 = t;
	if (_p25.ctor === 'RBEmpty_elm_builtin') {
		return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
	} else {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p25._1, _p25._2, _p25._3, _p25._4);
	}
};
var _elm_lang$core$Dict$redden = function (t) {
	var _p26 = t;
	if (_p26.ctor === 'RBEmpty_elm_builtin') {
		return _elm_lang$core$Native_Debug.crash('can\'t make a Leaf red');
	} else {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Red, _p26._1, _p26._2, _p26._3, _p26._4);
	}
};
var _elm_lang$core$Dict$balanceHelp = function (tree) {
	var _p27 = tree;
	_v36_6:
	do {
		_v36_5:
		do {
			_v36_4:
			do {
				_v36_3:
				do {
					_v36_2:
					do {
						_v36_1:
						do {
							_v36_0:
							do {
								if (_p27.ctor === 'RBNode_elm_builtin') {
									if (_p27._3.ctor === 'RBNode_elm_builtin') {
										if (_p27._4.ctor === 'RBNode_elm_builtin') {
											switch (_p27._3._0.ctor) {
												case 'Red':
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																		break _v36_2;
																	} else {
																		if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																			break _v36_3;
																		} else {
																			break _v36_6;
																		}
																	}
																}
															}
														case 'NBlack':
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																		break _v36_4;
																	} else {
																		break _v36_6;
																	}
																}
															}
														default:
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	break _v36_6;
																}
															}
													}
												case 'NBlack':
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																break _v36_2;
															} else {
																if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																	break _v36_3;
																} else {
																	if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																		break _v36_5;
																	} else {
																		break _v36_6;
																	}
																}
															}
														case 'NBlack':
															if (_p27._0.ctor === 'BBlack') {
																if ((((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																	break _v36_4;
																} else {
																	if ((((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																		break _v36_5;
																	} else {
																		break _v36_6;
																	}
																}
															} else {
																break _v36_6;
															}
														default:
															if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																break _v36_5;
															} else {
																break _v36_6;
															}
													}
												default:
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																break _v36_2;
															} else {
																if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																	break _v36_3;
																} else {
																	break _v36_6;
																}
															}
														case 'NBlack':
															if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																break _v36_4;
															} else {
																break _v36_6;
															}
														default:
															break _v36_6;
													}
											}
										} else {
											switch (_p27._3._0.ctor) {
												case 'Red':
													if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
														break _v36_0;
													} else {
														if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
															break _v36_1;
														} else {
															break _v36_6;
														}
													}
												case 'NBlack':
													if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
														break _v36_5;
													} else {
														break _v36_6;
													}
												default:
													break _v36_6;
											}
										}
									} else {
										if (_p27._4.ctor === 'RBNode_elm_builtin') {
											switch (_p27._4._0.ctor) {
												case 'Red':
													if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
														break _v36_2;
													} else {
														if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
															break _v36_3;
														} else {
															break _v36_6;
														}
													}
												case 'NBlack':
													if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
														break _v36_4;
													} else {
														break _v36_6;
													}
												default:
													break _v36_6;
											}
										} else {
											break _v36_6;
										}
									}
								} else {
									break _v36_6;
								}
							} while(false);
							return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._3._3._1)(_p27._3._3._2)(_p27._3._1)(_p27._3._2)(_p27._1)(_p27._2)(_p27._3._3._3)(_p27._3._3._4)(_p27._3._4)(_p27._4);
						} while(false);
						return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._3._1)(_p27._3._2)(_p27._3._4._1)(_p27._3._4._2)(_p27._1)(_p27._2)(_p27._3._3)(_p27._3._4._3)(_p27._3._4._4)(_p27._4);
					} while(false);
					return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._1)(_p27._2)(_p27._4._3._1)(_p27._4._3._2)(_p27._4._1)(_p27._4._2)(_p27._3)(_p27._4._3._3)(_p27._4._3._4)(_p27._4._4);
				} while(false);
				return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._1)(_p27._2)(_p27._4._1)(_p27._4._2)(_p27._4._4._1)(_p27._4._4._2)(_p27._3)(_p27._4._3)(_p27._4._4._3)(_p27._4._4._4);
			} while(false);
			return A5(
				_elm_lang$core$Dict$RBNode_elm_builtin,
				_elm_lang$core$Dict$Black,
				_p27._4._3._1,
				_p27._4._3._2,
				A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p27._1, _p27._2, _p27._3, _p27._4._3._3),
				A5(
					_elm_lang$core$Dict$balance,
					_elm_lang$core$Dict$Black,
					_p27._4._1,
					_p27._4._2,
					_p27._4._3._4,
					_elm_lang$core$Dict$redden(_p27._4._4)));
		} while(false);
		return A5(
			_elm_lang$core$Dict$RBNode_elm_builtin,
			_elm_lang$core$Dict$Black,
			_p27._3._4._1,
			_p27._3._4._2,
			A5(
				_elm_lang$core$Dict$balance,
				_elm_lang$core$Dict$Black,
				_p27._3._1,
				_p27._3._2,
				_elm_lang$core$Dict$redden(_p27._3._3),
				_p27._3._4._3),
			A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p27._1, _p27._2, _p27._3._4._4, _p27._4));
	} while(false);
	return tree;
};
var _elm_lang$core$Dict$balance = F5(
	function (c, k, v, l, r) {
		var tree = A5(_elm_lang$core$Dict$RBNode_elm_builtin, c, k, v, l, r);
		return _elm_lang$core$Dict$blackish(tree) ? _elm_lang$core$Dict$balanceHelp(tree) : tree;
	});
var _elm_lang$core$Dict$bubble = F5(
	function (c, k, v, l, r) {
		return (_elm_lang$core$Dict$isBBlack(l) || _elm_lang$core$Dict$isBBlack(r)) ? A5(
			_elm_lang$core$Dict$balance,
			_elm_lang$core$Dict$moreBlack(c),
			k,
			v,
			_elm_lang$core$Dict$lessBlackTree(l),
			_elm_lang$core$Dict$lessBlackTree(r)) : A5(_elm_lang$core$Dict$RBNode_elm_builtin, c, k, v, l, r);
	});
var _elm_lang$core$Dict$removeMax = F5(
	function (c, k, v, l, r) {
		var _p28 = r;
		if (_p28.ctor === 'RBEmpty_elm_builtin') {
			return A3(_elm_lang$core$Dict$rem, c, l, r);
		} else {
			return A5(
				_elm_lang$core$Dict$bubble,
				c,
				k,
				v,
				l,
				A5(_elm_lang$core$Dict$removeMax, _p28._0, _p28._1, _p28._2, _p28._3, _p28._4));
		}
	});
var _elm_lang$core$Dict$rem = F3(
	function (color, left, right) {
		var _p29 = {ctor: '_Tuple2', _0: left, _1: right};
		if (_p29._0.ctor === 'RBEmpty_elm_builtin') {
			if (_p29._1.ctor === 'RBEmpty_elm_builtin') {
				var _p30 = color;
				switch (_p30.ctor) {
					case 'Red':
						return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
					case 'Black':
						return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBBlack);
					default:
						return _elm_lang$core$Native_Debug.crash('cannot have bblack or nblack nodes at this point');
				}
			} else {
				var _p33 = _p29._1._0;
				var _p32 = _p29._0._0;
				var _p31 = {ctor: '_Tuple3', _0: color, _1: _p32, _2: _p33};
				if ((((_p31.ctor === '_Tuple3') && (_p31._0.ctor === 'Black')) && (_p31._1.ctor === 'LBlack')) && (_p31._2.ctor === 'Red')) {
					return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p29._1._1, _p29._1._2, _p29._1._3, _p29._1._4);
				} else {
					return A4(
						_elm_lang$core$Dict$reportRemBug,
						'Black/LBlack/Red',
						color,
						_elm_lang$core$Basics$toString(_p32),
						_elm_lang$core$Basics$toString(_p33));
				}
			}
		} else {
			if (_p29._1.ctor === 'RBEmpty_elm_builtin') {
				var _p36 = _p29._1._0;
				var _p35 = _p29._0._0;
				var _p34 = {ctor: '_Tuple3', _0: color, _1: _p35, _2: _p36};
				if ((((_p34.ctor === '_Tuple3') && (_p34._0.ctor === 'Black')) && (_p34._1.ctor === 'Red')) && (_p34._2.ctor === 'LBlack')) {
					return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p29._0._1, _p29._0._2, _p29._0._3, _p29._0._4);
				} else {
					return A4(
						_elm_lang$core$Dict$reportRemBug,
						'Black/Red/LBlack',
						color,
						_elm_lang$core$Basics$toString(_p35),
						_elm_lang$core$Basics$toString(_p36));
				}
			} else {
				var _p40 = _p29._0._2;
				var _p39 = _p29._0._4;
				var _p38 = _p29._0._1;
				var newLeft = A5(_elm_lang$core$Dict$removeMax, _p29._0._0, _p38, _p40, _p29._0._3, _p39);
				var _p37 = A3(_elm_lang$core$Dict$maxWithDefault, _p38, _p40, _p39);
				var k = _p37._0;
				var v = _p37._1;
				return A5(_elm_lang$core$Dict$bubble, color, k, v, newLeft, right);
			}
		}
	});
var _elm_lang$core$Dict$map = F2(
	function (f, dict) {
		var _p41 = dict;
		if (_p41.ctor === 'RBEmpty_elm_builtin') {
			return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
		} else {
			var _p42 = _p41._1;
			return A5(
				_elm_lang$core$Dict$RBNode_elm_builtin,
				_p41._0,
				_p42,
				A2(f, _p42, _p41._2),
				A2(_elm_lang$core$Dict$map, f, _p41._3),
				A2(_elm_lang$core$Dict$map, f, _p41._4));
		}
	});
var _elm_lang$core$Dict$Same = {ctor: 'Same'};
var _elm_lang$core$Dict$Remove = {ctor: 'Remove'};
var _elm_lang$core$Dict$Insert = {ctor: 'Insert'};
var _elm_lang$core$Dict$update = F3(
	function (k, alter, dict) {
		var up = function (dict) {
			var _p43 = dict;
			if (_p43.ctor === 'RBEmpty_elm_builtin') {
				var _p44 = alter(_elm_lang$core$Maybe$Nothing);
				if (_p44.ctor === 'Nothing') {
					return {ctor: '_Tuple2', _0: _elm_lang$core$Dict$Same, _1: _elm_lang$core$Dict$empty};
				} else {
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Dict$Insert,
						_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Red, k, _p44._0, _elm_lang$core$Dict$empty, _elm_lang$core$Dict$empty)
					};
				}
			} else {
				var _p55 = _p43._2;
				var _p54 = _p43._4;
				var _p53 = _p43._3;
				var _p52 = _p43._1;
				var _p51 = _p43._0;
				var _p45 = A2(_elm_lang$core$Basics$compare, k, _p52);
				switch (_p45.ctor) {
					case 'EQ':
						var _p46 = alter(
							_elm_lang$core$Maybe$Just(_p55));
						if (_p46.ctor === 'Nothing') {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Dict$Remove,
								_1: A3(_elm_lang$core$Dict$rem, _p51, _p53, _p54)
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Dict$Same,
								_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p46._0, _p53, _p54)
							};
						}
					case 'LT':
						var _p47 = up(_p53);
						var flag = _p47._0;
						var newLeft = _p47._1;
						var _p48 = flag;
						switch (_p48.ctor) {
							case 'Same':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Same,
									_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p55, newLeft, _p54)
								};
							case 'Insert':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Insert,
									_1: A5(_elm_lang$core$Dict$balance, _p51, _p52, _p55, newLeft, _p54)
								};
							default:
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Remove,
									_1: A5(_elm_lang$core$Dict$bubble, _p51, _p52, _p55, newLeft, _p54)
								};
						}
					default:
						var _p49 = up(_p54);
						var flag = _p49._0;
						var newRight = _p49._1;
						var _p50 = flag;
						switch (_p50.ctor) {
							case 'Same':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Same,
									_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p55, _p53, newRight)
								};
							case 'Insert':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Insert,
									_1: A5(_elm_lang$core$Dict$balance, _p51, _p52, _p55, _p53, newRight)
								};
							default:
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Remove,
									_1: A5(_elm_lang$core$Dict$bubble, _p51, _p52, _p55, _p53, newRight)
								};
						}
				}
			}
		};
		var _p56 = up(dict);
		var flag = _p56._0;
		var updatedDict = _p56._1;
		var _p57 = flag;
		switch (_p57.ctor) {
			case 'Same':
				return updatedDict;
			case 'Insert':
				return _elm_lang$core$Dict$ensureBlackRoot(updatedDict);
			default:
				return _elm_lang$core$Dict$blacken(updatedDict);
		}
	});
var _elm_lang$core$Dict$insert = F3(
	function (key, value, dict) {
		return A3(
			_elm_lang$core$Dict$update,
			key,
			_elm_lang$core$Basics$always(
				_elm_lang$core$Maybe$Just(value)),
			dict);
	});
var _elm_lang$core$Dict$singleton = F2(
	function (key, value) {
		return A3(_elm_lang$core$Dict$insert, key, value, _elm_lang$core$Dict$empty);
	});
var _elm_lang$core$Dict$union = F2(
	function (t1, t2) {
		return A3(_elm_lang$core$Dict$foldl, _elm_lang$core$Dict$insert, t2, t1);
	});
var _elm_lang$core$Dict$filter = F2(
	function (predicate, dictionary) {
		var add = F3(
			function (key, value, dict) {
				return A2(predicate, key, value) ? A3(_elm_lang$core$Dict$insert, key, value, dict) : dict;
			});
		return A3(_elm_lang$core$Dict$foldl, add, _elm_lang$core$Dict$empty, dictionary);
	});
var _elm_lang$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			_elm_lang$core$Dict$filter,
			F2(
				function (k, _p58) {
					return A2(_elm_lang$core$Dict$member, k, t2);
				}),
			t1);
	});
var _elm_lang$core$Dict$partition = F2(
	function (predicate, dict) {
		var add = F3(
			function (key, value, _p59) {
				var _p60 = _p59;
				var _p62 = _p60._1;
				var _p61 = _p60._0;
				return A2(predicate, key, value) ? {
					ctor: '_Tuple2',
					_0: A3(_elm_lang$core$Dict$insert, key, value, _p61),
					_1: _p62
				} : {
					ctor: '_Tuple2',
					_0: _p61,
					_1: A3(_elm_lang$core$Dict$insert, key, value, _p62)
				};
			});
		return A3(
			_elm_lang$core$Dict$foldl,
			add,
			{ctor: '_Tuple2', _0: _elm_lang$core$Dict$empty, _1: _elm_lang$core$Dict$empty},
			dict);
	});
var _elm_lang$core$Dict$fromList = function (assocs) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (_p63, dict) {
				var _p64 = _p63;
				return A3(_elm_lang$core$Dict$insert, _p64._0, _p64._1, dict);
			}),
		_elm_lang$core$Dict$empty,
		assocs);
};
var _elm_lang$core$Dict$remove = F2(
	function (key, dict) {
		return A3(
			_elm_lang$core$Dict$update,
			key,
			_elm_lang$core$Basics$always(_elm_lang$core$Maybe$Nothing),
			dict);
	});
var _elm_lang$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			_elm_lang$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2(_elm_lang$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});

var _elm_lang$core$Set$foldr = F3(
	function (f, b, _p0) {
		var _p1 = _p0;
		return A3(
			_elm_lang$core$Dict$foldr,
			F3(
				function (k, _p2, b) {
					return A2(f, k, b);
				}),
			b,
			_p1._0);
	});
var _elm_lang$core$Set$foldl = F3(
	function (f, b, _p3) {
		var _p4 = _p3;
		return A3(
			_elm_lang$core$Dict$foldl,
			F3(
				function (k, _p5, b) {
					return A2(f, k, b);
				}),
			b,
			_p4._0);
	});
var _elm_lang$core$Set$toList = function (_p6) {
	var _p7 = _p6;
	return _elm_lang$core$Dict$keys(_p7._0);
};
var _elm_lang$core$Set$size = function (_p8) {
	var _p9 = _p8;
	return _elm_lang$core$Dict$size(_p9._0);
};
var _elm_lang$core$Set$member = F2(
	function (k, _p10) {
		var _p11 = _p10;
		return A2(_elm_lang$core$Dict$member, k, _p11._0);
	});
var _elm_lang$core$Set$isEmpty = function (_p12) {
	var _p13 = _p12;
	return _elm_lang$core$Dict$isEmpty(_p13._0);
};
var _elm_lang$core$Set$Set_elm_builtin = function (a) {
	return {ctor: 'Set_elm_builtin', _0: a};
};
var _elm_lang$core$Set$empty = _elm_lang$core$Set$Set_elm_builtin(_elm_lang$core$Dict$empty);
var _elm_lang$core$Set$singleton = function (k) {
	return _elm_lang$core$Set$Set_elm_builtin(
		A2(
			_elm_lang$core$Dict$singleton,
			k,
			{ctor: '_Tuple0'}));
};
var _elm_lang$core$Set$insert = F2(
	function (k, _p14) {
		var _p15 = _p14;
		return _elm_lang$core$Set$Set_elm_builtin(
			A3(
				_elm_lang$core$Dict$insert,
				k,
				{ctor: '_Tuple0'},
				_p15._0));
	});
var _elm_lang$core$Set$fromList = function (xs) {
	return A3(_elm_lang$core$List$foldl, _elm_lang$core$Set$insert, _elm_lang$core$Set$empty, xs);
};
var _elm_lang$core$Set$map = F2(
	function (f, s) {
		return _elm_lang$core$Set$fromList(
			A2(
				_elm_lang$core$List$map,
				f,
				_elm_lang$core$Set$toList(s)));
	});
var _elm_lang$core$Set$remove = F2(
	function (k, _p16) {
		var _p17 = _p16;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$remove, k, _p17._0));
	});
var _elm_lang$core$Set$union = F2(
	function (_p19, _p18) {
		var _p20 = _p19;
		var _p21 = _p18;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$union, _p20._0, _p21._0));
	});
var _elm_lang$core$Set$intersect = F2(
	function (_p23, _p22) {
		var _p24 = _p23;
		var _p25 = _p22;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$intersect, _p24._0, _p25._0));
	});
var _elm_lang$core$Set$diff = F2(
	function (_p27, _p26) {
		var _p28 = _p27;
		var _p29 = _p26;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$diff, _p28._0, _p29._0));
	});
var _elm_lang$core$Set$filter = F2(
	function (p, _p30) {
		var _p31 = _p30;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(
				_elm_lang$core$Dict$filter,
				F2(
					function (k, _p32) {
						return p(k);
					}),
				_p31._0));
	});
var _elm_lang$core$Set$partition = F2(
	function (p, _p33) {
		var _p34 = _p33;
		var _p35 = A2(
			_elm_lang$core$Dict$partition,
			F2(
				function (k, _p36) {
					return p(k);
				}),
			_p34._0);
		var p1 = _p35._0;
		var p2 = _p35._1;
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Set$Set_elm_builtin(p1),
			_1: _elm_lang$core$Set$Set_elm_builtin(p2)
		};
	});

var _elm_lang$core$Json_Decode$null = _elm_lang$core$Native_Json.decodeNull;
var _elm_lang$core$Json_Decode$value = _elm_lang$core$Native_Json.decodePrimitive('value');
var _elm_lang$core$Json_Decode$andThen = _elm_lang$core$Native_Json.andThen;
var _elm_lang$core$Json_Decode$fail = _elm_lang$core$Native_Json.fail;
var _elm_lang$core$Json_Decode$succeed = _elm_lang$core$Native_Json.succeed;
var _elm_lang$core$Json_Decode$lazy = function (thunk) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		thunk,
		_elm_lang$core$Json_Decode$succeed(
			{ctor: '_Tuple0'}));
};
var _elm_lang$core$Json_Decode$decodeValue = _elm_lang$core$Native_Json.run;
var _elm_lang$core$Json_Decode$decodeString = _elm_lang$core$Native_Json.runOnString;
var _elm_lang$core$Json_Decode$map8 = _elm_lang$core$Native_Json.map8;
var _elm_lang$core$Json_Decode$map7 = _elm_lang$core$Native_Json.map7;
var _elm_lang$core$Json_Decode$map6 = _elm_lang$core$Native_Json.map6;
var _elm_lang$core$Json_Decode$map5 = _elm_lang$core$Native_Json.map5;
var _elm_lang$core$Json_Decode$map4 = _elm_lang$core$Native_Json.map4;
var _elm_lang$core$Json_Decode$map3 = _elm_lang$core$Native_Json.map3;
var _elm_lang$core$Json_Decode$map2 = _elm_lang$core$Native_Json.map2;
var _elm_lang$core$Json_Decode$map = _elm_lang$core$Native_Json.map1;
var _elm_lang$core$Json_Decode$oneOf = _elm_lang$core$Native_Json.oneOf;
var _elm_lang$core$Json_Decode$maybe = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'maybe', decoder);
};
var _elm_lang$core$Json_Decode$index = _elm_lang$core$Native_Json.decodeIndex;
var _elm_lang$core$Json_Decode$field = _elm_lang$core$Native_Json.decodeField;
var _elm_lang$core$Json_Decode$at = F2(
	function (fields, decoder) {
		return A3(_elm_lang$core$List$foldr, _elm_lang$core$Json_Decode$field, decoder, fields);
	});
var _elm_lang$core$Json_Decode$keyValuePairs = _elm_lang$core$Native_Json.decodeKeyValuePairs;
var _elm_lang$core$Json_Decode$dict = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Dict$fromList,
		_elm_lang$core$Json_Decode$keyValuePairs(decoder));
};
var _elm_lang$core$Json_Decode$array = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'array', decoder);
};
var _elm_lang$core$Json_Decode$list = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'list', decoder);
};
var _elm_lang$core$Json_Decode$nullable = function (decoder) {
	return _elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, decoder),
				_1: {ctor: '[]'}
			}
		});
};
var _elm_lang$core$Json_Decode$float = _elm_lang$core$Native_Json.decodePrimitive('float');
var _elm_lang$core$Json_Decode$int = _elm_lang$core$Native_Json.decodePrimitive('int');
var _elm_lang$core$Json_Decode$bool = _elm_lang$core$Native_Json.decodePrimitive('bool');
var _elm_lang$core$Json_Decode$string = _elm_lang$core$Native_Json.decodePrimitive('string');
var _elm_lang$core$Json_Decode$Decoder = {ctor: 'Decoder'};

//import Maybe, Native.List //

var _elm_lang$core$Native_Regex = function() {

function escape(str)
{
	return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function caseInsensitive(re)
{
	return new RegExp(re.source, 'gi');
}
function regex(raw)
{
	return new RegExp(raw, 'g');
}

function contains(re, string)
{
	return string.match(re) !== null;
}

function find(n, re, str)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex === re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch === undefined
				? _elm_lang$core$Maybe$Nothing
				: _elm_lang$core$Maybe$Just(submatch);
		}
		out.push({
			match: result[0],
			submatches: _elm_lang$core$Native_List.fromArray(subs),
			index: result.index,
			number: number
		});
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _elm_lang$core$Native_List.fromArray(out);
}

function replace(n, re, replacer, string)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch === undefined
				? _elm_lang$core$Maybe$Nothing
				: _elm_lang$core$Maybe$Just(submatch);
		}
		return replacer({
			match: match,
			submatches: _elm_lang$core$Native_List.fromArray(submatches),
			index: arguments[arguments.length - 2],
			number: count
		});
	}
	return string.replace(re, jsReplacer);
}

function split(n, re, str)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	if (n === Infinity)
	{
		return _elm_lang$core$Native_List.fromArray(str.split(re));
	}
	var string = str;
	var result;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		if (!(result = re.exec(string))) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _elm_lang$core$Native_List.fromArray(out);
}

return {
	regex: regex,
	caseInsensitive: caseInsensitive,
	escape: escape,

	contains: F2(contains),
	find: F3(find),
	replace: F4(replace),
	split: F3(split)
};

}();

var _elm_lang$core$Regex$split = _elm_lang$core$Native_Regex.split;
var _elm_lang$core$Regex$replace = _elm_lang$core$Native_Regex.replace;
var _elm_lang$core$Regex$find = _elm_lang$core$Native_Regex.find;
var _elm_lang$core$Regex$contains = _elm_lang$core$Native_Regex.contains;
var _elm_lang$core$Regex$caseInsensitive = _elm_lang$core$Native_Regex.caseInsensitive;
var _elm_lang$core$Regex$regex = _elm_lang$core$Native_Regex.regex;
var _elm_lang$core$Regex$escape = _elm_lang$core$Native_Regex.escape;
var _elm_lang$core$Regex$Match = F4(
	function (a, b, c, d) {
		return {match: a, submatches: b, index: c, number: d};
	});
var _elm_lang$core$Regex$Regex = {ctor: 'Regex'};
var _elm_lang$core$Regex$AtMost = function (a) {
	return {ctor: 'AtMost', _0: a};
};
var _elm_lang$core$Regex$All = {ctor: 'All'};

var _elm_lang$http$Native_Http = function() {


// ENCODING AND DECODING

function encodeUri(string)
{
	return encodeURIComponent(string);
}

function decodeUri(string)
{
	try
	{
		return _elm_lang$core$Maybe$Just(decodeURIComponent(string));
	}
	catch(e)
	{
		return _elm_lang$core$Maybe$Nothing;
	}
}


// SEND REQUEST

function toTask(request, maybeProgress)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'NetworkError' }));
		});
		xhr.addEventListener('timeout', function() {
			callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'Timeout' }));
		});
		xhr.addEventListener('load', function() {
			callback(handleResponse(xhr, request.expect.responseToResult));
		});

		try
		{
			xhr.open(request.method, request.url, true);
		}
		catch (e)
		{
			return callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'BadUrl', _0: request.url }));
		}

		configureRequest(xhr, request);
		send(xhr, request.body);

		return function() { xhr.abort(); };
	});
}

function configureProgress(xhr, maybeProgress)
{
	if (maybeProgress.ctor === 'Nothing')
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_elm_lang$core$Native_Scheduler.rawSpawn(maybeProgress._0({
			bytes: event.loaded,
			bytesExpected: event.total
		}));
	});
}

function configureRequest(xhr, request)
{
	function setHeader(pair)
	{
		xhr.setRequestHeader(pair._0, pair._1);
	}

	A2(_elm_lang$core$List$map, setHeader, request.headers);
	xhr.responseType = request.expect.responseType;
	xhr.withCredentials = request.withCredentials;

	if (request.timeout.ctor === 'Just')
	{
		xhr.timeout = request.timeout._0;
	}
}

function send(xhr, body)
{
	switch (body.ctor)
	{
		case 'EmptyBody':
			xhr.send();
			return;

		case 'StringBody':
			xhr.setRequestHeader('Content-Type', body._0);
			xhr.send(body._1);
			return;

		case 'FormDataBody':
			xhr.send(body._0);
			return;
	}
}


// RESPONSES

function handleResponse(xhr, responseToResult)
{
	var response = toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _elm_lang$core$Native_Scheduler.fail({
			ctor: 'BadStatus',
			_0: response
		});
	}

	var result = responseToResult(response);

	if (result.ctor === 'Ok')
	{
		return _elm_lang$core$Native_Scheduler.succeed(result._0);
	}
	else
	{
		response.body = xhr.responseText;
		return _elm_lang$core$Native_Scheduler.fail({
			ctor: 'BadPayload',
			_0: result._0,
			_1: response
		});
	}
}

function toResponse(xhr)
{
	return {
		status: { code: xhr.status, message: xhr.statusText },
		headers: parseHeaders(xhr.getAllResponseHeaders()),
		url: xhr.responseURL,
		body: xhr.response
	};
}

function parseHeaders(rawHeaders)
{
	var headers = _elm_lang$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3(_elm_lang$core$Dict$update, key, function(oldValue) {
				if (oldValue.ctor === 'Just')
				{
					return _elm_lang$core$Maybe$Just(value + ', ' + oldValue._0);
				}
				return _elm_lang$core$Maybe$Just(value);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function expectStringResponse(responseToResult)
{
	return {
		responseType: 'text',
		responseToResult: responseToResult
	};
}

function mapExpect(func, expect)
{
	return {
		responseType: expect.responseType,
		responseToResult: function(response) {
			var convertedResponse = expect.responseToResult(response);
			return A2(_elm_lang$core$Result$map, func, convertedResponse);
		}
	};
}


// BODY

function multipart(parts)
{
	var formData = new FormData();

	while (parts.ctor !== '[]')
	{
		var part = parts._0;
		formData.append(part._0, part._1);
		parts = parts._1;
	}

	return { ctor: 'FormDataBody', _0: formData };
}

return {
	toTask: F2(toTask),
	expectStringResponse: expectStringResponse,
	mapExpect: F2(mapExpect),
	multipart: multipart,
	encodeUri: encodeUri,
	decodeUri: decodeUri
};

}();

//import Native.Scheduler //

var _elm_lang$core$Native_Time = function() {

var now = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
{
	callback(_elm_lang$core$Native_Scheduler.succeed(Date.now()));
});

function setInterval_(interval, task)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var id = setInterval(function() {
			_elm_lang$core$Native_Scheduler.rawSpawn(task);
		}, interval);

		return function() { clearInterval(id); };
	});
}

return {
	now: now,
	setInterval_: F2(setInterval_)
};

}();
var _elm_lang$core$Task$onError = _elm_lang$core$Native_Scheduler.onError;
var _elm_lang$core$Task$andThen = _elm_lang$core$Native_Scheduler.andThen;
var _elm_lang$core$Task$spawnCmd = F2(
	function (router, _p0) {
		var _p1 = _p0;
		return _elm_lang$core$Native_Scheduler.spawn(
			A2(
				_elm_lang$core$Task$andThen,
				_elm_lang$core$Platform$sendToApp(router),
				_p1._0));
	});
var _elm_lang$core$Task$fail = _elm_lang$core$Native_Scheduler.fail;
var _elm_lang$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			_elm_lang$core$Task$onError,
			function (_p2) {
				return _elm_lang$core$Task$fail(
					convert(_p2));
			},
			task);
	});
var _elm_lang$core$Task$succeed = _elm_lang$core$Native_Scheduler.succeed;
var _elm_lang$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return _elm_lang$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var _elm_lang$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return _elm_lang$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return _elm_lang$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map4 = F5(
	function (func, taskA, taskB, taskC, taskD) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return A2(
									_elm_lang$core$Task$andThen,
									function (d) {
										return _elm_lang$core$Task$succeed(
											A4(func, a, b, c, d));
									},
									taskD);
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map5 = F6(
	function (func, taskA, taskB, taskC, taskD, taskE) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return A2(
									_elm_lang$core$Task$andThen,
									function (d) {
										return A2(
											_elm_lang$core$Task$andThen,
											function (e) {
												return _elm_lang$core$Task$succeed(
													A5(func, a, b, c, d, e));
											},
											taskE);
									},
									taskD);
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$sequence = function (tasks) {
	var _p3 = tasks;
	if (_p3.ctor === '[]') {
		return _elm_lang$core$Task$succeed(
			{ctor: '[]'});
	} else {
		return A3(
			_elm_lang$core$Task$map2,
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				}),
			_p3._0,
			_elm_lang$core$Task$sequence(_p3._1));
	}
};
var _elm_lang$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			_elm_lang$core$Task$map,
			function (_p4) {
				return {ctor: '_Tuple0'};
			},
			_elm_lang$core$Task$sequence(
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Task$spawnCmd(router),
					commands)));
	});
var _elm_lang$core$Task$init = _elm_lang$core$Task$succeed(
	{ctor: '_Tuple0'});
var _elm_lang$core$Task$onSelfMsg = F3(
	function (_p7, _p6, _p5) {
		return _elm_lang$core$Task$succeed(
			{ctor: '_Tuple0'});
	});
var _elm_lang$core$Task$command = _elm_lang$core$Native_Platform.leaf('Task');
var _elm_lang$core$Task$Perform = function (a) {
	return {ctor: 'Perform', _0: a};
};
var _elm_lang$core$Task$perform = F2(
	function (toMessage, task) {
		return _elm_lang$core$Task$command(
			_elm_lang$core$Task$Perform(
				A2(_elm_lang$core$Task$map, toMessage, task)));
	});
var _elm_lang$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return _elm_lang$core$Task$command(
			_elm_lang$core$Task$Perform(
				A2(
					_elm_lang$core$Task$onError,
					function (_p8) {
						return _elm_lang$core$Task$succeed(
							resultToMessage(
								_elm_lang$core$Result$Err(_p8)));
					},
					A2(
						_elm_lang$core$Task$andThen,
						function (_p9) {
							return _elm_lang$core$Task$succeed(
								resultToMessage(
									_elm_lang$core$Result$Ok(_p9)));
						},
						task))));
	});
var _elm_lang$core$Task$cmdMap = F2(
	function (tagger, _p10) {
		var _p11 = _p10;
		return _elm_lang$core$Task$Perform(
			A2(_elm_lang$core$Task$map, tagger, _p11._0));
	});
_elm_lang$core$Native_Platform.effectManagers['Task'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Task$init, onEffects: _elm_lang$core$Task$onEffects, onSelfMsg: _elm_lang$core$Task$onSelfMsg, tag: 'cmd', cmdMap: _elm_lang$core$Task$cmdMap};

var _elm_lang$core$Time$setInterval = _elm_lang$core$Native_Time.setInterval_;
var _elm_lang$core$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		var _p0 = intervals;
		if (_p0.ctor === '[]') {
			return _elm_lang$core$Task$succeed(processes);
		} else {
			var _p1 = _p0._0;
			var spawnRest = function (id) {
				return A3(
					_elm_lang$core$Time$spawnHelp,
					router,
					_p0._1,
					A3(_elm_lang$core$Dict$insert, _p1, id, processes));
			};
			var spawnTimer = _elm_lang$core$Native_Scheduler.spawn(
				A2(
					_elm_lang$core$Time$setInterval,
					_p1,
					A2(_elm_lang$core$Platform$sendToSelf, router, _p1)));
			return A2(_elm_lang$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var _elm_lang$core$Time$addMySub = F2(
	function (_p2, state) {
		var _p3 = _p2;
		var _p6 = _p3._1;
		var _p5 = _p3._0;
		var _p4 = A2(_elm_lang$core$Dict$get, _p5, state);
		if (_p4.ctor === 'Nothing') {
			return A3(
				_elm_lang$core$Dict$insert,
				_p5,
				{
					ctor: '::',
					_0: _p6,
					_1: {ctor: '[]'}
				},
				state);
		} else {
			return A3(
				_elm_lang$core$Dict$insert,
				_p5,
				{ctor: '::', _0: _p6, _1: _p4._0},
				state);
		}
	});
var _elm_lang$core$Time$inMilliseconds = function (t) {
	return t;
};
var _elm_lang$core$Time$millisecond = 1;
var _elm_lang$core$Time$second = 1000 * _elm_lang$core$Time$millisecond;
var _elm_lang$core$Time$minute = 60 * _elm_lang$core$Time$second;
var _elm_lang$core$Time$hour = 60 * _elm_lang$core$Time$minute;
var _elm_lang$core$Time$inHours = function (t) {
	return t / _elm_lang$core$Time$hour;
};
var _elm_lang$core$Time$inMinutes = function (t) {
	return t / _elm_lang$core$Time$minute;
};
var _elm_lang$core$Time$inSeconds = function (t) {
	return t / _elm_lang$core$Time$second;
};
var _elm_lang$core$Time$now = _elm_lang$core$Native_Time.now;
var _elm_lang$core$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _p7 = A2(_elm_lang$core$Dict$get, interval, state.taggers);
		if (_p7.ctor === 'Nothing') {
			return _elm_lang$core$Task$succeed(state);
		} else {
			var tellTaggers = function (time) {
				return _elm_lang$core$Task$sequence(
					A2(
						_elm_lang$core$List$map,
						function (tagger) {
							return A2(
								_elm_lang$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						_p7._0));
			};
			return A2(
				_elm_lang$core$Task$andThen,
				function (_p8) {
					return _elm_lang$core$Task$succeed(state);
				},
				A2(_elm_lang$core$Task$andThen, tellTaggers, _elm_lang$core$Time$now));
		}
	});
var _elm_lang$core$Time$subscription = _elm_lang$core$Native_Platform.leaf('Time');
var _elm_lang$core$Time$State = F2(
	function (a, b) {
		return {taggers: a, processes: b};
	});
var _elm_lang$core$Time$init = _elm_lang$core$Task$succeed(
	A2(_elm_lang$core$Time$State, _elm_lang$core$Dict$empty, _elm_lang$core$Dict$empty));
var _elm_lang$core$Time$onEffects = F3(
	function (router, subs, _p9) {
		var _p10 = _p9;
		var rightStep = F3(
			function (_p12, id, _p11) {
				var _p13 = _p11;
				return {
					ctor: '_Tuple3',
					_0: _p13._0,
					_1: _p13._1,
					_2: A2(
						_elm_lang$core$Task$andThen,
						function (_p14) {
							return _p13._2;
						},
						_elm_lang$core$Native_Scheduler.kill(id))
				};
			});
		var bothStep = F4(
			function (interval, taggers, id, _p15) {
				var _p16 = _p15;
				return {
					ctor: '_Tuple3',
					_0: _p16._0,
					_1: A3(_elm_lang$core$Dict$insert, interval, id, _p16._1),
					_2: _p16._2
				};
			});
		var leftStep = F3(
			function (interval, taggers, _p17) {
				var _p18 = _p17;
				return {
					ctor: '_Tuple3',
					_0: {ctor: '::', _0: interval, _1: _p18._0},
					_1: _p18._1,
					_2: _p18._2
				};
			});
		var newTaggers = A3(_elm_lang$core$List$foldl, _elm_lang$core$Time$addMySub, _elm_lang$core$Dict$empty, subs);
		var _p19 = A6(
			_elm_lang$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			_p10.processes,
			{
				ctor: '_Tuple3',
				_0: {ctor: '[]'},
				_1: _elm_lang$core$Dict$empty,
				_2: _elm_lang$core$Task$succeed(
					{ctor: '_Tuple0'})
			});
		var spawnList = _p19._0;
		var existingDict = _p19._1;
		var killTask = _p19._2;
		return A2(
			_elm_lang$core$Task$andThen,
			function (newProcesses) {
				return _elm_lang$core$Task$succeed(
					A2(_elm_lang$core$Time$State, newTaggers, newProcesses));
			},
			A2(
				_elm_lang$core$Task$andThen,
				function (_p20) {
					return A3(_elm_lang$core$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var _elm_lang$core$Time$Every = F2(
	function (a, b) {
		return {ctor: 'Every', _0: a, _1: b};
	});
var _elm_lang$core$Time$every = F2(
	function (interval, tagger) {
		return _elm_lang$core$Time$subscription(
			A2(_elm_lang$core$Time$Every, interval, tagger));
	});
var _elm_lang$core$Time$subMap = F2(
	function (f, _p21) {
		var _p22 = _p21;
		return A2(
			_elm_lang$core$Time$Every,
			_p22._0,
			function (_p23) {
				return f(
					_p22._1(_p23));
			});
	});
_elm_lang$core$Native_Platform.effectManagers['Time'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Time$init, onEffects: _elm_lang$core$Time$onEffects, onSelfMsg: _elm_lang$core$Time$onSelfMsg, tag: 'sub', subMap: _elm_lang$core$Time$subMap};

var _elm_lang$http$Http_Internal$map = F2(
	function (func, request) {
		return _elm_lang$core$Native_Utils.update(
			request,
			{
				expect: A2(_elm_lang$http$Native_Http.mapExpect, func, request.expect)
			});
	});
var _elm_lang$http$Http_Internal$RawRequest = F7(
	function (a, b, c, d, e, f, g) {
		return {method: a, headers: b, url: c, body: d, expect: e, timeout: f, withCredentials: g};
	});
var _elm_lang$http$Http_Internal$Request = function (a) {
	return {ctor: 'Request', _0: a};
};
var _elm_lang$http$Http_Internal$Expect = {ctor: 'Expect'};
var _elm_lang$http$Http_Internal$FormDataBody = {ctor: 'FormDataBody'};
var _elm_lang$http$Http_Internal$StringBody = F2(
	function (a, b) {
		return {ctor: 'StringBody', _0: a, _1: b};
	});
var _elm_lang$http$Http_Internal$EmptyBody = {ctor: 'EmptyBody'};
var _elm_lang$http$Http_Internal$Header = F2(
	function (a, b) {
		return {ctor: 'Header', _0: a, _1: b};
	});

var _elm_lang$http$Http$decodeUri = _elm_lang$http$Native_Http.decodeUri;
var _elm_lang$http$Http$encodeUri = _elm_lang$http$Native_Http.encodeUri;
var _elm_lang$http$Http$expectStringResponse = _elm_lang$http$Native_Http.expectStringResponse;
var _elm_lang$http$Http$expectJson = function (decoder) {
	return _elm_lang$http$Http$expectStringResponse(
		function (response) {
			return A2(_elm_lang$core$Json_Decode$decodeString, decoder, response.body);
		});
};
var _elm_lang$http$Http$expectString = _elm_lang$http$Http$expectStringResponse(
	function (response) {
		return _elm_lang$core$Result$Ok(response.body);
	});
var _elm_lang$http$Http$multipartBody = _elm_lang$http$Native_Http.multipart;
var _elm_lang$http$Http$stringBody = _elm_lang$http$Http_Internal$StringBody;
var _elm_lang$http$Http$jsonBody = function (value) {
	return A2(
		_elm_lang$http$Http_Internal$StringBody,
		'application/json',
		A2(_elm_lang$core$Json_Encode$encode, 0, value));
};
var _elm_lang$http$Http$emptyBody = _elm_lang$http$Http_Internal$EmptyBody;
var _elm_lang$http$Http$header = _elm_lang$http$Http_Internal$Header;
var _elm_lang$http$Http$request = _elm_lang$http$Http_Internal$Request;
var _elm_lang$http$Http$post = F3(
	function (url, body, decoder) {
		return _elm_lang$http$Http$request(
			{
				method: 'POST',
				headers: {ctor: '[]'},
				url: url,
				body: body,
				expect: _elm_lang$http$Http$expectJson(decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _elm_lang$http$Http$get = F2(
	function (url, decoder) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: {ctor: '[]'},
				url: url,
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _elm_lang$http$Http$getString = function (url) {
	return _elm_lang$http$Http$request(
		{
			method: 'GET',
			headers: {ctor: '[]'},
			url: url,
			body: _elm_lang$http$Http$emptyBody,
			expect: _elm_lang$http$Http$expectString,
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: false
		});
};
var _elm_lang$http$Http$toTask = function (_p0) {
	var _p1 = _p0;
	return A2(_elm_lang$http$Native_Http.toTask, _p1._0, _elm_lang$core$Maybe$Nothing);
};
var _elm_lang$http$Http$send = F2(
	function (resultToMessage, request) {
		return A2(
			_elm_lang$core$Task$attempt,
			resultToMessage,
			_elm_lang$http$Http$toTask(request));
	});
var _elm_lang$http$Http$Response = F4(
	function (a, b, c, d) {
		return {url: a, status: b, headers: c, body: d};
	});
var _elm_lang$http$Http$BadPayload = F2(
	function (a, b) {
		return {ctor: 'BadPayload', _0: a, _1: b};
	});
var _elm_lang$http$Http$BadStatus = function (a) {
	return {ctor: 'BadStatus', _0: a};
};
var _elm_lang$http$Http$NetworkError = {ctor: 'NetworkError'};
var _elm_lang$http$Http$Timeout = {ctor: 'Timeout'};
var _elm_lang$http$Http$BadUrl = function (a) {
	return {ctor: 'BadUrl', _0: a};
};
var _elm_lang$http$Http$StringPart = F2(
	function (a, b) {
		return {ctor: 'StringPart', _0: a, _1: b};
	});
var _elm_lang$http$Http$stringPart = _elm_lang$http$Http$StringPart;

var _elm_lang$core$Process$kill = _elm_lang$core$Native_Scheduler.kill;
var _elm_lang$core$Process$sleep = _elm_lang$core$Native_Scheduler.sleep;
var _elm_lang$core$Process$spawn = _elm_lang$core$Native_Scheduler.spawn;

//import Result //

var _elm_lang$core$Native_Date = function() {

function fromString(str)
{
	var date = new Date(str);
	return isNaN(date.getTime())
		? _elm_lang$core$Result$Err('Unable to parse \'' + str + '\' as a date. Dates must be in the ISO 8601 format.')
		: _elm_lang$core$Result$Ok(date);
}

var dayTable = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthTable =
	['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
	 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


return {
	fromString: fromString,
	year: function(d) { return d.getFullYear(); },
	month: function(d) { return { ctor: monthTable[d.getMonth()] }; },
	day: function(d) { return d.getDate(); },
	hour: function(d) { return d.getHours(); },
	minute: function(d) { return d.getMinutes(); },
	second: function(d) { return d.getSeconds(); },
	millisecond: function(d) { return d.getMilliseconds(); },
	toTime: function(d) { return d.getTime(); },
	fromTime: function(t) { return new Date(t); },
	dayOfWeek: function(d) { return { ctor: dayTable[d.getDay()] }; }
};

}();
var _elm_lang$core$Date$millisecond = _elm_lang$core$Native_Date.millisecond;
var _elm_lang$core$Date$second = _elm_lang$core$Native_Date.second;
var _elm_lang$core$Date$minute = _elm_lang$core$Native_Date.minute;
var _elm_lang$core$Date$hour = _elm_lang$core$Native_Date.hour;
var _elm_lang$core$Date$dayOfWeek = _elm_lang$core$Native_Date.dayOfWeek;
var _elm_lang$core$Date$day = _elm_lang$core$Native_Date.day;
var _elm_lang$core$Date$month = _elm_lang$core$Native_Date.month;
var _elm_lang$core$Date$year = _elm_lang$core$Native_Date.year;
var _elm_lang$core$Date$fromTime = _elm_lang$core$Native_Date.fromTime;
var _elm_lang$core$Date$toTime = _elm_lang$core$Native_Date.toTime;
var _elm_lang$core$Date$fromString = _elm_lang$core$Native_Date.fromString;
var _elm_lang$core$Date$now = A2(_elm_lang$core$Task$map, _elm_lang$core$Date$fromTime, _elm_lang$core$Time$now);
var _elm_lang$core$Date$Date = {ctor: 'Date'};
var _elm_lang$core$Date$Sun = {ctor: 'Sun'};
var _elm_lang$core$Date$Sat = {ctor: 'Sat'};
var _elm_lang$core$Date$Fri = {ctor: 'Fri'};
var _elm_lang$core$Date$Thu = {ctor: 'Thu'};
var _elm_lang$core$Date$Wed = {ctor: 'Wed'};
var _elm_lang$core$Date$Tue = {ctor: 'Tue'};
var _elm_lang$core$Date$Mon = {ctor: 'Mon'};
var _elm_lang$core$Date$Dec = {ctor: 'Dec'};
var _elm_lang$core$Date$Nov = {ctor: 'Nov'};
var _elm_lang$core$Date$Oct = {ctor: 'Oct'};
var _elm_lang$core$Date$Sep = {ctor: 'Sep'};
var _elm_lang$core$Date$Aug = {ctor: 'Aug'};
var _elm_lang$core$Date$Jul = {ctor: 'Jul'};
var _elm_lang$core$Date$Jun = {ctor: 'Jun'};
var _elm_lang$core$Date$May = {ctor: 'May'};
var _elm_lang$core$Date$Apr = {ctor: 'Apr'};
var _elm_lang$core$Date$Mar = {ctor: 'Mar'};
var _elm_lang$core$Date$Feb = {ctor: 'Feb'};
var _elm_lang$core$Date$Jan = {ctor: 'Jan'};

var _elm_community$elm_datepicker$DatePicker_Date$yearRange = F2(
	function (_p0, range) {
		var _p1 = _p0;
		var _p5 = _p1.focused;
		var _p4 = _p1.currentMonth;
		var _p2 = range;
		switch (_p2.ctor) {
			case 'MoreOrLess':
				var _p3 = _p2._0;
				return A2(
					_elm_lang$core$List$range,
					_elm_lang$core$Date$year(_p4) - _p3,
					_elm_lang$core$Date$year(_p4) + _p3);
			case 'Between':
				return A2(_elm_lang$core$List$range, _p2._0, _p2._1);
			case 'From':
				return A2(
					_elm_lang$core$List$range,
					_p2._0,
					_elm_lang$core$Date$year(_p5));
			case 'To':
				return A2(
					_elm_lang$core$List$range,
					_elm_lang$core$Date$year(_p5),
					_p2._0);
			default:
				return {ctor: '[]'};
		}
	});
var _elm_community$elm_datepicker$DatePicker_Date$unsafeDate = function (date) {
	var _p6 = _elm_lang$core$Date$fromString(date);
	if (_p6.ctor === 'Err') {
		return _elm_lang$core$Native_Utils.crashCase(
			'DatePicker.Date',
			{
				start: {line: 552, column: 5},
				end: {line: 557, column: 17}
			},
			_p6)(
			A2(_elm_lang$core$Basics_ops['++'], 'unsafeDate: failed to parse date:', _p6._0));
	} else {
		return _p6._0;
	}
};
var _elm_community$elm_datepicker$DatePicker_Date$isLeapYear = function (y) {
	return _elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], y, 400),
		0) || ((!_elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], y, 100),
		0)) && _elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], y, 4),
		0));
};
var _elm_community$elm_datepicker$DatePicker_Date$daysInMonth = F2(
	function (year, month) {
		var _p8 = month;
		switch (_p8.ctor) {
			case 'Jan':
				return 31;
			case 'Feb':
				return _elm_community$elm_datepicker$DatePicker_Date$isLeapYear(year) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var _elm_community$elm_datepicker$DatePicker_Date$monthFromInt = function (month) {
	var _p9 = month;
	switch (_p9) {
		case 1:
			return _elm_lang$core$Date$Jan;
		case 2:
			return _elm_lang$core$Date$Feb;
		case 3:
			return _elm_lang$core$Date$Mar;
		case 4:
			return _elm_lang$core$Date$Apr;
		case 5:
			return _elm_lang$core$Date$May;
		case 6:
			return _elm_lang$core$Date$Jun;
		case 7:
			return _elm_lang$core$Date$Jul;
		case 8:
			return _elm_lang$core$Date$Aug;
		case 9:
			return _elm_lang$core$Date$Sep;
		case 10:
			return _elm_lang$core$Date$Oct;
		case 11:
			return _elm_lang$core$Date$Nov;
		case 12:
			return _elm_lang$core$Date$Dec;
		default:
			return _elm_lang$core$Native_Utils.crashCase(
				'DatePicker.Date',
				{
					start: {line: 451, column: 5},
					end: {line: 489, column: 72}
				},
				_p9)(
				A2(
					_elm_lang$core$Basics_ops['++'],
					'monthFromInt: invalid month: ',
					_elm_lang$core$Basics$toString(_p9)));
	}
};
var _elm_community$elm_datepicker$DatePicker_Date$monthToInt = function (month) {
	var _p11 = month;
	switch (_p11.ctor) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var _elm_community$elm_datepicker$DatePicker_Date$succMonth = function (month) {
	return _elm_community$elm_datepicker$DatePicker_Date$monthFromInt(
		A2(
			F2(
				function (x, y) {
					return x + y;
				}),
			1,
			A3(
				_elm_lang$core$Basics$flip,
				_elm_lang$core$Basics$rem,
				12,
				_elm_community$elm_datepicker$DatePicker_Date$monthToInt(month))));
};
var _elm_community$elm_datepicker$DatePicker_Date$predMonth = function (month) {
	var prev = A3(
		_elm_lang$core$Basics$flip,
		_elm_lang$core$Basics$rem,
		12,
		_elm_community$elm_datepicker$DatePicker_Date$monthToInt(month) - 1);
	return _elm_lang$core$Native_Utils.eq(prev, 0) ? _elm_lang$core$Date$Dec : _elm_community$elm_datepicker$DatePicker_Date$monthFromInt(prev);
};
var _elm_community$elm_datepicker$DatePicker_Date$monthToString = function (month) {
	var $int = _elm_community$elm_datepicker$DatePicker_Date$monthToInt(month);
	return (_elm_lang$core$Native_Utils.cmp($int, 10) < 0) ? A2(
		_elm_lang$core$Basics_ops['++'],
		'0',
		_elm_lang$core$Basics$toString($int)) : _elm_lang$core$Basics$toString($int);
};
var _elm_community$elm_datepicker$DatePicker_Date$dayFromInt = function (day) {
	var _p12 = day;
	switch (_p12) {
		case 1:
			return _elm_lang$core$Date$Mon;
		case 2:
			return _elm_lang$core$Date$Tue;
		case 3:
			return _elm_lang$core$Date$Wed;
		case 4:
			return _elm_lang$core$Date$Thu;
		case 5:
			return _elm_lang$core$Date$Fri;
		case 6:
			return _elm_lang$core$Date$Sat;
		case 7:
			return _elm_lang$core$Date$Sun;
		default:
			return _elm_lang$core$Native_Utils.crashCase(
				'DatePicker.Date',
				{
					start: {line: 350, column: 5},
					end: {line: 373, column: 70}
				},
				_p12)(
				A2(
					_elm_lang$core$Basics_ops['++'],
					'dayFromInt: invalid day: ',
					_elm_lang$core$Basics$toString(day)));
	}
};
var _elm_community$elm_datepicker$DatePicker_Date$dayToInt = function (day) {
	var _p14 = day;
	switch (_p14.ctor) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var _elm_community$elm_datepicker$DatePicker_Date$dayToString = function (day) {
	return (_elm_lang$core$Native_Utils.cmp(day, 10) < 0) ? A2(
		_elm_lang$core$Basics_ops['++'],
		'0',
		_elm_lang$core$Basics$toString(day)) : _elm_lang$core$Basics$toString(day);
};
var _elm_community$elm_datepicker$DatePicker_Date$mkDate = F3(
	function (year, month, day) {
		return _elm_community$elm_datepicker$DatePicker_Date$unsafeDate(
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(year),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'/',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_community$elm_datepicker$DatePicker_Date$monthToString(month),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'/',
							_elm_community$elm_datepicker$DatePicker_Date$dayToString(day))))));
	});
var _elm_community$elm_datepicker$DatePicker_Date$newYear = F2(
	function (currentMonth, newYear) {
		var _p15 = _elm_lang$core$String$toInt(newYear);
		if (_p15.ctor === 'Ok') {
			return A3(
				_elm_community$elm_datepicker$DatePicker_Date$mkDate,
				_p15._0,
				_elm_lang$core$Date$month(currentMonth),
				_elm_lang$core$Date$day(currentMonth));
		} else {
			return _elm_lang$core$Native_Utils.crashCase(
				'DatePicker.Date',
				{
					start: {line: 562, column: 5},
					end: {line: 567, column: 70}
				},
				_p15)(
				A2(
					_elm_lang$core$Basics_ops['++'],
					'Unknown Month ',
					_elm_lang$core$Basics$toString(currentMonth)));
		}
	});
var _elm_community$elm_datepicker$DatePicker_Date$predDow = function (day) {
	var prev = A3(
		_elm_lang$core$Basics$flip,
		_elm_lang$core$Basics$rem,
		7,
		_elm_community$elm_datepicker$DatePicker_Date$dayToInt(day) - 1);
	return _elm_lang$core$Native_Utils.eq(prev, 0) ? _elm_lang$core$Date$Sun : _elm_community$elm_datepicker$DatePicker_Date$dayFromInt(prev);
};
var _elm_community$elm_datepicker$DatePicker_Date$succDow = function (day) {
	return _elm_community$elm_datepicker$DatePicker_Date$dayFromInt(
		A2(
			F2(
				function (x, y) {
					return x + y;
				}),
			1,
			A3(
				_elm_lang$core$Basics$flip,
				_elm_lang$core$Basics$rem,
				7,
				_elm_community$elm_datepicker$DatePicker_Date$dayToInt(day))));
};
var _elm_community$elm_datepicker$DatePicker_Date$subDay = function (date) {
	var day = _elm_lang$core$Date$day(date) - 1;
	var year = _elm_lang$core$Date$year(date);
	var month = _elm_lang$core$Date$month(date);
	var pred = _elm_community$elm_datepicker$DatePicker_Date$predMonth(month);
	var predYear = _elm_lang$core$Native_Utils.eq(pred, _elm_lang$core$Date$Dec) ? (year - 1) : year;
	return (_elm_lang$core$Native_Utils.cmp(day, 1) < 0) ? A3(
		_elm_community$elm_datepicker$DatePicker_Date$mkDate,
		predYear,
		pred,
		A2(_elm_community$elm_datepicker$DatePicker_Date$daysInMonth, predYear, pred)) : A3(_elm_community$elm_datepicker$DatePicker_Date$mkDate, year, month, day);
};
var _elm_community$elm_datepicker$DatePicker_Date$addDay = function (date) {
	var day = _elm_lang$core$Date$day(date) + 1;
	var year = _elm_lang$core$Date$year(date);
	var month = _elm_lang$core$Date$month(date);
	var dim = A2(_elm_community$elm_datepicker$DatePicker_Date$daysInMonth, year, month);
	var succ = _elm_community$elm_datepicker$DatePicker_Date$succMonth(month);
	var succYear = _elm_lang$core$Native_Utils.eq(succ, _elm_lang$core$Date$Jan) ? (year + 1) : year;
	return (_elm_lang$core$Native_Utils.cmp(day, dim) > 0) ? A3(_elm_community$elm_datepicker$DatePicker_Date$mkDate, succYear, succ, 1) : A3(_elm_community$elm_datepicker$DatePicker_Date$mkDate, year, month, day);
};
var _elm_community$elm_datepicker$DatePicker_Date$prevMonth = function (date) {
	var prevMonth = _elm_community$elm_datepicker$DatePicker_Date$predMonth(
		_elm_lang$core$Date$month(date));
	var prevYear = _elm_lang$core$Native_Utils.eq(prevMonth, _elm_lang$core$Date$Dec) ? (_elm_lang$core$Date$year(date) - 1) : _elm_lang$core$Date$year(date);
	return A3(_elm_community$elm_datepicker$DatePicker_Date$mkDate, prevYear, prevMonth, 1);
};
var _elm_community$elm_datepicker$DatePicker_Date$nextMonth = function (date) {
	var nextMonth = _elm_community$elm_datepicker$DatePicker_Date$succMonth(
		_elm_lang$core$Date$month(date));
	var nextYear = _elm_lang$core$Native_Utils.eq(nextMonth, _elm_lang$core$Date$Jan) ? (_elm_lang$core$Date$year(date) + 1) : _elm_lang$core$Date$year(date);
	return A3(_elm_community$elm_datepicker$DatePicker_Date$mkDate, nextYear, nextMonth, 1);
};
var _elm_community$elm_datepicker$DatePicker_Date$firstOfMonth = function (date) {
	return A3(
		_elm_community$elm_datepicker$DatePicker_Date$mkDate,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date),
		1);
};
var _elm_community$elm_datepicker$DatePicker_Date$repeat = function (f) {
	var go = F2(
		function (n, x) {
			go:
			while (true) {
				if (_elm_lang$core$Native_Utils.eq(n, 0)) {
					return x;
				} else {
					var _v9 = n - 1,
						_v10 = f(x);
					n = _v9;
					x = _v10;
					continue go;
				}
			}
		});
	return go;
};
var _elm_community$elm_datepicker$DatePicker_Date$addDays = _elm_community$elm_datepicker$DatePicker_Date$repeat(_elm_community$elm_datepicker$DatePicker_Date$addDay);
var _elm_community$elm_datepicker$DatePicker_Date$subDays = _elm_community$elm_datepicker$DatePicker_Date$repeat(_elm_community$elm_datepicker$DatePicker_Date$subDay);
var _elm_community$elm_datepicker$DatePicker_Date$addDows = _elm_community$elm_datepicker$DatePicker_Date$repeat(_elm_community$elm_datepicker$DatePicker_Date$succDow);
var _elm_community$elm_datepicker$DatePicker_Date$subDows = _elm_community$elm_datepicker$DatePicker_Date$repeat(_elm_community$elm_datepicker$DatePicker_Date$succDow);
var _elm_community$elm_datepicker$DatePicker_Date$dateTuple = function (date) {
	return {
		ctor: '_Tuple3',
		_0: _elm_lang$core$Date$year(date),
		_1: _elm_community$elm_datepicker$DatePicker_Date$monthToInt(
			_elm_lang$core$Date$month(date)),
		_2: _elm_lang$core$Date$day(date)
	};
};
var _elm_community$elm_datepicker$DatePicker_Date$trimDates = F2(
	function (firstDay, dates) {
		var dl = function (dates) {
			dl:
			while (true) {
				var _p17 = dates;
				if (_p17.ctor === '[]') {
					return {ctor: '[]'};
				} else {
					if (_elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$dayOfWeek(_p17._0),
						firstDay)) {
						return dates;
					} else {
						var _v12 = _p17._1;
						dates = _v12;
						continue dl;
					}
				}
			}
		};
		var lastDay = _elm_community$elm_datepicker$DatePicker_Date$predDow(firstDay);
		var dr = function (dates) {
			dr:
			while (true) {
				var _p18 = dates;
				if (_p18.ctor === '[]') {
					return {ctor: '[]'};
				} else {
					if (_elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$dayOfWeek(_p18._0),
						lastDay)) {
						return dates;
					} else {
						var _v14 = _p18._1;
						dates = _v14;
						continue dr;
					}
				}
			}
		};
		return _elm_lang$core$List$reverse(
			dr(
				_elm_lang$core$List$reverse(
					dl(dates))));
	});
var _elm_community$elm_datepicker$DatePicker_Date$datesInRange = F3(
	function (firstDay, min, max) {
		var go = F2(
			function (x, acc) {
				go:
				while (true) {
					var y = _elm_community$elm_datepicker$DatePicker_Date$subDay(x);
					if (_elm_lang$core$Native_Utils.eq(
						_elm_community$elm_datepicker$DatePicker_Date$dateTuple(y),
						_elm_community$elm_datepicker$DatePicker_Date$dateTuple(min))) {
						return {ctor: '::', _0: y, _1: acc};
					} else {
						var _v15 = y,
							_v16 = {ctor: '::', _0: y, _1: acc};
						x = _v15;
						acc = _v16;
						continue go;
					}
				}
			});
		return A2(
			_elm_community$elm_datepicker$DatePicker_Date$trimDates,
			firstDay,
			A2(
				go,
				max,
				{ctor: '[]'}));
	});
var _elm_community$elm_datepicker$DatePicker_Date$formatMonth = function (month) {
	var _p19 = month;
	switch (_p19.ctor) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var _elm_community$elm_datepicker$DatePicker_Date$formatDay = function (day) {
	var _p20 = day;
	switch (_p20.ctor) {
		case 'Mon':
			return 'Mo';
		case 'Tue':
			return 'Tu';
		case 'Wed':
			return 'We';
		case 'Thu':
			return 'Th';
		case 'Fri':
			return 'Fr';
		case 'Sat':
			return 'Sa';
		default:
			return 'Su';
	}
};
var _elm_community$elm_datepicker$DatePicker_Date$formatDate = function (date) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_elm_lang$core$Basics$toString(
			_elm_lang$core$Date$year(date)),
		A2(
			_elm_lang$core$Basics_ops['++'],
			'/',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_community$elm_datepicker$DatePicker_Date$monthToString(
					_elm_lang$core$Date$month(date)),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'/',
					_elm_community$elm_datepicker$DatePicker_Date$dayToString(
						_elm_lang$core$Date$day(date))))));
};
var _elm_community$elm_datepicker$DatePicker_Date$initDate = A3(_elm_community$elm_datepicker$DatePicker_Date$mkDate, 1992, _elm_lang$core$Date$May, 29);
var _elm_community$elm_datepicker$DatePicker_Date$To = function (a) {
	return {ctor: 'To', _0: a};
};
var _elm_community$elm_datepicker$DatePicker_Date$From = function (a) {
	return {ctor: 'From', _0: a};
};
var _elm_community$elm_datepicker$DatePicker_Date$Between = F2(
	function (a, b) {
		return {ctor: 'Between', _0: a, _1: b};
	});
var _elm_community$elm_datepicker$DatePicker_Date$MoreOrLess = function (a) {
	return {ctor: 'MoreOrLess', _0: a};
};
var _elm_community$elm_datepicker$DatePicker_Date$Off = {ctor: 'Off'};

var _elm_lang$virtual_dom$VirtualDom_Debug$wrap;
var _elm_lang$virtual_dom$VirtualDom_Debug$wrapWithFlags;

var _elm_lang$virtual_dom$Native_VirtualDom = function() {

var STYLE_KEY = 'STYLE';
var EVENT_KEY = 'EVENT';
var ATTR_KEY = 'ATTR';
var ATTR_NS_KEY = 'ATTR_NS';

var localDoc = typeof document !== 'undefined' ? document : {};


////////////  VIRTUAL DOM NODES  ////////////


function text(string)
{
	return {
		type: 'text',
		text: string
	};
}


function node(tag)
{
	return F2(function(factList, kidList) {
		return nodeHelp(tag, factList, kidList);
	});
}


function nodeHelp(tag, factList, kidList)
{
	var organized = organizeFacts(factList);
	var namespace = organized.namespace;
	var facts = organized.facts;

	var children = [];
	var descendantsCount = 0;
	while (kidList.ctor !== '[]')
	{
		var kid = kidList._0;
		descendantsCount += (kid.descendantsCount || 0);
		children.push(kid);
		kidList = kidList._1;
	}
	descendantsCount += children.length;

	return {
		type: 'node',
		tag: tag,
		facts: facts,
		children: children,
		namespace: namespace,
		descendantsCount: descendantsCount
	};
}


function keyedNode(tag, factList, kidList)
{
	var organized = organizeFacts(factList);
	var namespace = organized.namespace;
	var facts = organized.facts;

	var children = [];
	var descendantsCount = 0;
	while (kidList.ctor !== '[]')
	{
		var kid = kidList._0;
		descendantsCount += (kid._1.descendantsCount || 0);
		children.push(kid);
		kidList = kidList._1;
	}
	descendantsCount += children.length;

	return {
		type: 'keyed-node',
		tag: tag,
		facts: facts,
		children: children,
		namespace: namespace,
		descendantsCount: descendantsCount
	};
}


function custom(factList, model, impl)
{
	var facts = organizeFacts(factList).facts;

	return {
		type: 'custom',
		facts: facts,
		model: model,
		impl: impl
	};
}


function map(tagger, node)
{
	return {
		type: 'tagger',
		tagger: tagger,
		node: node,
		descendantsCount: 1 + (node.descendantsCount || 0)
	};
}


function thunk(func, args, thunk)
{
	return {
		type: 'thunk',
		func: func,
		args: args,
		thunk: thunk,
		node: undefined
	};
}

function lazy(fn, a)
{
	return thunk(fn, [a], function() {
		return fn(a);
	});
}

function lazy2(fn, a, b)
{
	return thunk(fn, [a,b], function() {
		return A2(fn, a, b);
	});
}

function lazy3(fn, a, b, c)
{
	return thunk(fn, [a,b,c], function() {
		return A3(fn, a, b, c);
	});
}



// FACTS


function organizeFacts(factList)
{
	var namespace, facts = {};

	while (factList.ctor !== '[]')
	{
		var entry = factList._0;
		var key = entry.key;

		if (key === ATTR_KEY || key === ATTR_NS_KEY || key === EVENT_KEY)
		{
			var subFacts = facts[key] || {};
			subFacts[entry.realKey] = entry.value;
			facts[key] = subFacts;
		}
		else if (key === STYLE_KEY)
		{
			var styles = facts[key] || {};
			var styleList = entry.value;
			while (styleList.ctor !== '[]')
			{
				var style = styleList._0;
				styles[style._0] = style._1;
				styleList = styleList._1;
			}
			facts[key] = styles;
		}
		else if (key === 'namespace')
		{
			namespace = entry.value;
		}
		else if (key === 'className')
		{
			var classes = facts[key];
			facts[key] = typeof classes === 'undefined'
				? entry.value
				: classes + ' ' + entry.value;
		}
 		else
		{
			facts[key] = entry.value;
		}
		factList = factList._1;
	}

	return {
		facts: facts,
		namespace: namespace
	};
}



////////////  PROPERTIES AND ATTRIBUTES  ////////////


function style(value)
{
	return {
		key: STYLE_KEY,
		value: value
	};
}


function property(key, value)
{
	return {
		key: key,
		value: value
	};
}


function attribute(key, value)
{
	return {
		key: ATTR_KEY,
		realKey: key,
		value: value
	};
}


function attributeNS(namespace, key, value)
{
	return {
		key: ATTR_NS_KEY,
		realKey: key,
		value: {
			value: value,
			namespace: namespace
		}
	};
}


function on(name, options, decoder)
{
	return {
		key: EVENT_KEY,
		realKey: name,
		value: {
			options: options,
			decoder: decoder
		}
	};
}


function equalEvents(a, b)
{
	if (a.options !== b.options)
	{
		if (a.options.stopPropagation !== b.options.stopPropagation || a.options.preventDefault !== b.options.preventDefault)
		{
			return false;
		}
	}
	return _elm_lang$core$Native_Json.equality(a.decoder, b.decoder);
}


function mapProperty(func, property)
{
	if (property.key !== EVENT_KEY)
	{
		return property;
	}
	return on(
		property.realKey,
		property.value.options,
		A2(_elm_lang$core$Json_Decode$map, func, property.value.decoder)
	);
}


////////////  RENDER  ////////////


function render(vNode, eventNode)
{
	switch (vNode.type)
	{
		case 'thunk':
			if (!vNode.node)
			{
				vNode.node = vNode.thunk();
			}
			return render(vNode.node, eventNode);

		case 'tagger':
			var subNode = vNode.node;
			var tagger = vNode.tagger;

			while (subNode.type === 'tagger')
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.tagger]
					: tagger.push(subNode.tagger);

				subNode = subNode.node;
			}

			var subEventRoot = { tagger: tagger, parent: eventNode };
			var domNode = render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;

		case 'text':
			return localDoc.createTextNode(vNode.text);

		case 'node':
			var domNode = vNode.namespace
				? localDoc.createElementNS(vNode.namespace, vNode.tag)
				: localDoc.createElement(vNode.tag);

			applyFacts(domNode, eventNode, vNode.facts);

			var children = vNode.children;

			for (var i = 0; i < children.length; i++)
			{
				domNode.appendChild(render(children[i], eventNode));
			}

			return domNode;

		case 'keyed-node':
			var domNode = vNode.namespace
				? localDoc.createElementNS(vNode.namespace, vNode.tag)
				: localDoc.createElement(vNode.tag);

			applyFacts(domNode, eventNode, vNode.facts);

			var children = vNode.children;

			for (var i = 0; i < children.length; i++)
			{
				domNode.appendChild(render(children[i]._1, eventNode));
			}

			return domNode;

		case 'custom':
			var domNode = vNode.impl.render(vNode.model);
			applyFacts(domNode, eventNode, vNode.facts);
			return domNode;
	}
}



////////////  APPLY FACTS  ////////////


function applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		switch (key)
		{
			case STYLE_KEY:
				applyStyles(domNode, value);
				break;

			case EVENT_KEY:
				applyEvents(domNode, eventNode, value);
				break;

			case ATTR_KEY:
				applyAttrs(domNode, value);
				break;

			case ATTR_NS_KEY:
				applyAttrsNS(domNode, value);
				break;

			case 'value':
				if (domNode[key] !== value)
				{
					domNode[key] = value;
				}
				break;

			default:
				domNode[key] = value;
				break;
		}
	}
}

function applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}

function applyEvents(domNode, eventNode, events)
{
	var allHandlers = domNode.elm_handlers || {};

	for (var key in events)
	{
		var handler = allHandlers[key];
		var value = events[key];

		if (typeof value === 'undefined')
		{
			domNode.removeEventListener(key, handler);
			allHandlers[key] = undefined;
		}
		else if (typeof handler === 'undefined')
		{
			var handler = makeEventHandler(eventNode, value);
			domNode.addEventListener(key, handler);
			allHandlers[key] = handler;
		}
		else
		{
			handler.info = value;
		}
	}

	domNode.elm_handlers = allHandlers;
}

function makeEventHandler(eventNode, info)
{
	function eventHandler(event)
	{
		var info = eventHandler.info;

		var value = A2(_elm_lang$core$Native_Json.run, info.decoder, event);

		if (value.ctor === 'Ok')
		{
			var options = info.options;
			if (options.stopPropagation)
			{
				event.stopPropagation();
			}
			if (options.preventDefault)
			{
				event.preventDefault();
			}

			var message = value._0;

			var currentEventNode = eventNode;
			while (currentEventNode)
			{
				var tagger = currentEventNode.tagger;
				if (typeof tagger === 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.parent;
			}
		}
	};

	eventHandler.info = info;

	return eventHandler;
}

function applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		if (typeof value === 'undefined')
		{
			domNode.removeAttribute(key);
		}
		else
		{
			domNode.setAttribute(key, value);
		}
	}
}

function applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.namespace;
		var value = pair.value;

		if (typeof value === 'undefined')
		{
			domNode.removeAttributeNS(namespace, key);
		}
		else
		{
			domNode.setAttributeNS(namespace, key, value);
		}
	}
}



////////////  DIFF  ////////////


function diff(a, b)
{
	var patches = [];
	diffHelp(a, b, patches, 0);
	return patches;
}


function makePatch(type, index, data)
{
	return {
		index: index,
		type: type,
		data: data,
		domNode: undefined,
		eventNode: undefined
	};
}


function diffHelp(a, b, patches, index)
{
	if (a === b)
	{
		return;
	}

	var aType = a.type;
	var bType = b.type;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (aType !== bType)
	{
		patches.push(makePatch('p-redraw', index, b));
		return;
	}

	// Now we know that both nodes are the same type.
	switch (bType)
	{
		case 'thunk':
			var aArgs = a.args;
			var bArgs = b.args;
			var i = aArgs.length;
			var same = a.func === b.func && i === bArgs.length;
			while (same && i--)
			{
				same = aArgs[i] === bArgs[i];
			}
			if (same)
			{
				b.node = a.node;
				return;
			}
			b.node = b.thunk();
			var subPatches = [];
			diffHelp(a.node, b.node, subPatches, 0);
			if (subPatches.length > 0)
			{
				patches.push(makePatch('p-thunk', index, subPatches));
			}
			return;

		case 'tagger':
			// gather nested taggers
			var aTaggers = a.tagger;
			var bTaggers = b.tagger;
			var nesting = false;

			var aSubNode = a.node;
			while (aSubNode.type === 'tagger')
			{
				nesting = true;

				typeof aTaggers !== 'object'
					? aTaggers = [aTaggers, aSubNode.tagger]
					: aTaggers.push(aSubNode.tagger);

				aSubNode = aSubNode.node;
			}

			var bSubNode = b.node;
			while (bSubNode.type === 'tagger')
			{
				nesting = true;

				typeof bTaggers !== 'object'
					? bTaggers = [bTaggers, bSubNode.tagger]
					: bTaggers.push(bSubNode.tagger);

				bSubNode = bSubNode.node;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && aTaggers.length !== bTaggers.length)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !pairwiseRefEqual(aTaggers, bTaggers) : aTaggers !== bTaggers)
			{
				patches.push(makePatch('p-tagger', index, bTaggers));
			}

			// diff everything below the taggers
			diffHelp(aSubNode, bSubNode, patches, index + 1);
			return;

		case 'text':
			if (a.text !== b.text)
			{
				patches.push(makePatch('p-text', index, b.text));
				return;
			}

			return;

		case 'node':
			// Bail if obvious indicators have changed. Implies more serious
			// structural changes such that it's not worth it to diff.
			if (a.tag !== b.tag || a.namespace !== b.namespace)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);

			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			diffChildren(a, b, patches, index);
			return;

		case 'keyed-node':
			// Bail if obvious indicators have changed. Implies more serious
			// structural changes such that it's not worth it to diff.
			if (a.tag !== b.tag || a.namespace !== b.namespace)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);

			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			diffKeyedChildren(a, b, patches, index);
			return;

		case 'custom':
			if (a.impl !== b.impl)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);
			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			var patch = b.impl.diff(a,b);
			if (patch)
			{
				patches.push(makePatch('p-custom', index, patch));
				return;
			}

			return;
	}
}


// assumes the incoming arrays are the same length
function pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function diffFacts(a, b, category)
{
	var diff;

	// look for changes and removals
	for (var aKey in a)
	{
		if (aKey === STYLE_KEY || aKey === EVENT_KEY || aKey === ATTR_KEY || aKey === ATTR_NS_KEY)
		{
			var subDiff = diffFacts(a[aKey], b[aKey] || {}, aKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[aKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(aKey in b))
		{
			diff = diff || {};
			diff[aKey] =
				(typeof category === 'undefined')
					? (typeof a[aKey] === 'string' ? '' : null)
					:
				(category === STYLE_KEY)
					? ''
					:
				(category === EVENT_KEY || category === ATTR_KEY)
					? undefined
					:
				{ namespace: a[aKey].namespace, value: undefined };

			continue;
		}

		var aValue = a[aKey];
		var bValue = b[aKey];

		// reference equal, so don't worry about it
		if (aValue === bValue && aKey !== 'value'
			|| category === EVENT_KEY && equalEvents(aValue, bValue))
		{
			continue;
		}

		diff = diff || {};
		diff[aKey] = bValue;
	}

	// add new stuff
	for (var bKey in b)
	{
		if (!(bKey in a))
		{
			diff = diff || {};
			diff[bKey] = b[bKey];
		}
	}

	return diff;
}


function diffChildren(aParent, bParent, patches, rootIndex)
{
	var aChildren = aParent.children;
	var bChildren = bParent.children;

	var aLen = aChildren.length;
	var bLen = bChildren.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (aLen > bLen)
	{
		patches.push(makePatch('p-remove-last', rootIndex, aLen - bLen));
	}
	else if (aLen < bLen)
	{
		patches.push(makePatch('p-append', rootIndex, bChildren.slice(aLen)));
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	var index = rootIndex;
	var minLen = aLen < bLen ? aLen : bLen;
	for (var i = 0; i < minLen; i++)
	{
		index++;
		var aChild = aChildren[i];
		diffHelp(aChild, bChildren[i], patches, index);
		index += aChild.descendantsCount || 0;
	}
}



////////////  KEYED DIFF  ////////////


function diffKeyedChildren(aParent, bParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var aChildren = aParent.children;
	var bChildren = bParent.children;
	var aLen = aChildren.length;
	var bLen = bChildren.length;
	var aIndex = 0;
	var bIndex = 0;

	var index = rootIndex;

	while (aIndex < aLen && bIndex < bLen)
	{
		var a = aChildren[aIndex];
		var b = bChildren[bIndex];

		var aKey = a._0;
		var bKey = b._0;
		var aNode = a._1;
		var bNode = b._1;

		// check if keys match

		if (aKey === bKey)
		{
			index++;
			diffHelp(aNode, bNode, localPatches, index);
			index += aNode.descendantsCount || 0;

			aIndex++;
			bIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var aLookAhead = aIndex + 1 < aLen;
		var bLookAhead = bIndex + 1 < bLen;

		if (aLookAhead)
		{
			var aNext = aChildren[aIndex + 1];
			var aNextKey = aNext._0;
			var aNextNode = aNext._1;
			var oldMatch = bKey === aNextKey;
		}

		if (bLookAhead)
		{
			var bNext = bChildren[bIndex + 1];
			var bNextKey = bNext._0;
			var bNextNode = bNext._1;
			var newMatch = aKey === bNextKey;
		}


		// swap a and b
		if (aLookAhead && bLookAhead && newMatch && oldMatch)
		{
			index++;
			diffHelp(aNode, bNextNode, localPatches, index);
			insertNode(changes, localPatches, aKey, bNode, bIndex, inserts);
			index += aNode.descendantsCount || 0;

			index++;
			removeNode(changes, localPatches, aKey, aNextNode, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 2;
			continue;
		}

		// insert b
		if (bLookAhead && newMatch)
		{
			index++;
			insertNode(changes, localPatches, bKey, bNode, bIndex, inserts);
			diffHelp(aNode, bNextNode, localPatches, index);
			index += aNode.descendantsCount || 0;

			aIndex += 1;
			bIndex += 2;
			continue;
		}

		// remove a
		if (aLookAhead && oldMatch)
		{
			index++;
			removeNode(changes, localPatches, aKey, aNode, index);
			index += aNode.descendantsCount || 0;

			index++;
			diffHelp(aNextNode, bNode, localPatches, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 1;
			continue;
		}

		// remove a, insert b
		if (aLookAhead && bLookAhead && aNextKey === bNextKey)
		{
			index++;
			removeNode(changes, localPatches, aKey, aNode, index);
			insertNode(changes, localPatches, bKey, bNode, bIndex, inserts);
			index += aNode.descendantsCount || 0;

			index++;
			diffHelp(aNextNode, bNextNode, localPatches, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (aIndex < aLen)
	{
		index++;
		var a = aChildren[aIndex];
		var aNode = a._1;
		removeNode(changes, localPatches, a._0, aNode, index);
		index += aNode.descendantsCount || 0;
		aIndex++;
	}

	var endInserts;
	while (bIndex < bLen)
	{
		endInserts = endInserts || [];
		var b = bChildren[bIndex];
		insertNode(changes, localPatches, b._0, b._1, undefined, endInserts);
		bIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || typeof endInserts !== 'undefined')
	{
		patches.push(makePatch('p-reorder', rootIndex, {
			patches: localPatches,
			inserts: inserts,
			endInserts: endInserts
		}));
	}
}



////////////  CHANGES FROM KEYED DIFF  ////////////


var POSTFIX = '_elmW6BL';


function insertNode(changes, localPatches, key, vnode, bIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (typeof entry === 'undefined')
	{
		entry = {
			tag: 'insert',
			vnode: vnode,
			index: bIndex,
			data: undefined
		};

		inserts.push({ index: bIndex, entry: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.tag === 'remove')
	{
		inserts.push({ index: bIndex, entry: entry });

		entry.tag = 'move';
		var subPatches = [];
		diffHelp(entry.vnode, vnode, subPatches, entry.index);
		entry.index = bIndex;
		entry.data.data = {
			patches: subPatches,
			entry: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	insertNode(changes, localPatches, key + POSTFIX, vnode, bIndex, inserts);
}


function removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (typeof entry === 'undefined')
	{
		var patch = makePatch('p-remove', index, undefined);
		localPatches.push(patch);

		changes[key] = {
			tag: 'remove',
			vnode: vnode,
			index: index,
			data: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.tag === 'insert')
	{
		entry.tag = 'move';
		var subPatches = [];
		diffHelp(vnode, entry.vnode, subPatches, index);

		var patch = makePatch('p-remove', index, {
			patches: subPatches,
			entry: entry
		});
		localPatches.push(patch);

		return;
	}

	// this key has already been removed or moved, a duplicate!
	removeNode(changes, localPatches, key + POSTFIX, vnode, index);
}



////////////  ADD DOM NODES  ////////////
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function addDomNodes(domNode, vNode, patches, eventNode)
{
	addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.descendantsCount, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.index;

	while (index === low)
	{
		var patchType = patch.type;

		if (patchType === 'p-thunk')
		{
			addDomNodes(domNode, vNode.node, patch.data, eventNode);
		}
		else if (patchType === 'p-reorder')
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;

			var subPatches = patch.data.patches;
			if (subPatches.length > 0)
			{
				addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 'p-remove')
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;

			var data = patch.data;
			if (typeof data !== 'undefined')
			{
				data.entry.data = domNode;
				var subPatches = data.patches;
				if (subPatches.length > 0)
				{
					addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.index) > high)
		{
			return i;
		}
	}

	switch (vNode.type)
	{
		case 'tagger':
			var subNode = vNode.node;

			while (subNode.type === "tagger")
			{
				subNode = subNode.node;
			}

			return addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);

		case 'node':
			var vChildren = vNode.children;
			var childNodes = domNode.childNodes;
			for (var j = 0; j < vChildren.length; j++)
			{
				low++;
				var vChild = vChildren[j];
				var nextLow = low + (vChild.descendantsCount || 0);
				if (low <= index && index <= nextLow)
				{
					i = addDomNodesHelp(childNodes[j], vChild, patches, i, low, nextLow, eventNode);
					if (!(patch = patches[i]) || (index = patch.index) > high)
					{
						return i;
					}
				}
				low = nextLow;
			}
			return i;

		case 'keyed-node':
			var vChildren = vNode.children;
			var childNodes = domNode.childNodes;
			for (var j = 0; j < vChildren.length; j++)
			{
				low++;
				var vChild = vChildren[j]._1;
				var nextLow = low + (vChild.descendantsCount || 0);
				if (low <= index && index <= nextLow)
				{
					i = addDomNodesHelp(childNodes[j], vChild, patches, i, low, nextLow, eventNode);
					if (!(patch = patches[i]) || (index = patch.index) > high)
					{
						return i;
					}
				}
				low = nextLow;
			}
			return i;

		case 'text':
		case 'thunk':
			throw new Error('should never traverse `text` or `thunk` nodes like this');
	}
}



////////////  APPLY PATCHES  ////////////


function applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return applyPatchesHelp(rootDomNode, patches);
}

function applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.domNode
		var newNode = applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function applyPatch(domNode, patch)
{
	switch (patch.type)
	{
		case 'p-redraw':
			return applyPatchRedraw(domNode, patch.data, patch.eventNode);

		case 'p-facts':
			applyFacts(domNode, patch.eventNode, patch.data);
			return domNode;

		case 'p-text':
			domNode.replaceData(0, domNode.length, patch.data);
			return domNode;

		case 'p-thunk':
			return applyPatchesHelp(domNode, patch.data);

		case 'p-tagger':
			if (typeof domNode.elm_event_node_ref !== 'undefined')
			{
				domNode.elm_event_node_ref.tagger = patch.data;
			}
			else
			{
				domNode.elm_event_node_ref = { tagger: patch.data, parent: patch.eventNode };
			}
			return domNode;

		case 'p-remove-last':
			var i = patch.data;
			while (i--)
			{
				domNode.removeChild(domNode.lastChild);
			}
			return domNode;

		case 'p-append':
			var newNodes = patch.data;
			for (var i = 0; i < newNodes.length; i++)
			{
				domNode.appendChild(render(newNodes[i], patch.eventNode));
			}
			return domNode;

		case 'p-remove':
			var data = patch.data;
			if (typeof data === 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.entry;
			if (typeof entry.index !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.data = applyPatchesHelp(domNode, data.patches);
			return domNode;

		case 'p-reorder':
			return applyPatchReorder(domNode, patch);

		case 'p-custom':
			var impl = patch.data;
			return impl.applyPatch(domNode, impl.data);

		default:
			throw new Error('Ran into an unknown patch!');
	}
}


function applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = render(vNode, eventNode);

	if (typeof newNode.elm_event_node_ref === 'undefined')
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function applyPatchReorder(domNode, patch)
{
	var data = patch.data;

	// remove end inserts
	var frag = applyPatchReorderEndInsertsHelp(data.endInserts, patch);

	// removals
	domNode = applyPatchesHelp(domNode, data.patches);

	// inserts
	var inserts = data.inserts;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.entry;
		var node = entry.tag === 'move'
			? entry.data
			: render(entry.vnode, patch.eventNode);
		domNode.insertBefore(node, domNode.childNodes[insert.index]);
	}

	// add end inserts
	if (typeof frag !== 'undefined')
	{
		domNode.appendChild(frag);
	}

	return domNode;
}


function applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (typeof endInserts === 'undefined')
	{
		return;
	}

	var frag = localDoc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.entry;
		frag.appendChild(entry.tag === 'move'
			? entry.data
			: render(entry.vnode, patch.eventNode)
		);
	}
	return frag;
}


// PROGRAMS

var program = makeProgram(checkNoFlags);
var programWithFlags = makeProgram(checkYesFlags);

function makeProgram(flagChecker)
{
	return F2(function(debugWrap, impl)
	{
		return function(flagDecoder)
		{
			return function(object, moduleName, debugMetadata)
			{
				var checker = flagChecker(flagDecoder, moduleName);
				if (typeof debugMetadata === 'undefined')
				{
					normalSetup(impl, object, moduleName, checker);
				}
				else
				{
					debugSetup(A2(debugWrap, debugMetadata, impl), object, moduleName, checker);
				}
			};
		};
	});
}

function staticProgram(vNode)
{
	var nothing = _elm_lang$core$Native_Utils.Tuple2(
		_elm_lang$core$Native_Utils.Tuple0,
		_elm_lang$core$Platform_Cmd$none
	);
	return A2(program, _elm_lang$virtual_dom$VirtualDom_Debug$wrap, {
		init: nothing,
		view: function() { return vNode; },
		update: F2(function() { return nothing; }),
		subscriptions: function() { return _elm_lang$core$Platform_Sub$none; }
	})();
}


// FLAG CHECKERS

function checkNoFlags(flagDecoder, moduleName)
{
	return function(init, flags, domNode)
	{
		if (typeof flags === 'undefined')
		{
			return init;
		}

		var errorMessage =
			'The `' + moduleName + '` module does not need flags.\n'
			+ 'Initialize it with no arguments and you should be all set!';

		crash(errorMessage, domNode);
	};
}

function checkYesFlags(flagDecoder, moduleName)
{
	return function(init, flags, domNode)
	{
		if (typeof flagDecoder === 'undefined')
		{
			var errorMessage =
				'Are you trying to sneak a Never value into Elm? Trickster!\n'
				+ 'It looks like ' + moduleName + '.main is defined with `programWithFlags` but has type `Program Never`.\n'
				+ 'Use `program` instead if you do not want flags.'

			crash(errorMessage, domNode);
		}

		var result = A2(_elm_lang$core$Native_Json.run, flagDecoder, flags);
		if (result.ctor === 'Ok')
		{
			return init(result._0);
		}

		var errorMessage =
			'Trying to initialize the `' + moduleName + '` module with an unexpected flag.\n'
			+ 'I tried to convert it to an Elm value, but ran into this problem:\n\n'
			+ result._0;

		crash(errorMessage, domNode);
	};
}

function crash(errorMessage, domNode)
{
	if (domNode)
	{
		domNode.innerHTML =
			'<div style="padding-left:1em;">'
			+ '<h2 style="font-weight:normal;"><b>Oops!</b> Something went wrong when starting your Elm program.</h2>'
			+ '<pre style="padding-left:1em;">' + errorMessage + '</pre>'
			+ '</div>';
	}

	throw new Error(errorMessage);
}


//  NORMAL SETUP

function normalSetup(impl, object, moduleName, flagChecker)
{
	object['embed'] = function embed(node, flags)
	{
		while (node.lastChild)
		{
			node.removeChild(node.lastChild);
		}

		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, node),
			impl.update,
			impl.subscriptions,
			normalRenderer(node, impl.view)
		);
	};

	object['fullscreen'] = function fullscreen(flags)
	{
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, document.body),
			impl.update,
			impl.subscriptions,
			normalRenderer(document.body, impl.view)
		);
	};
}

function normalRenderer(parentNode, view)
{
	return function(tagger, initialModel)
	{
		var eventNode = { tagger: tagger, parent: undefined };
		var initialVirtualNode = view(initialModel);
		var domNode = render(initialVirtualNode, eventNode);
		parentNode.appendChild(domNode);
		return makeStepper(domNode, view, initialVirtualNode, eventNode);
	};
}


// STEPPER

var rAF =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { setTimeout(callback, 1000 / 60); };

function makeStepper(domNode, view, initialVirtualNode, eventNode)
{
	var state = 'NO_REQUEST';
	var currNode = initialVirtualNode;
	var nextModel;

	function updateIfNeeded()
	{
		switch (state)
		{
			case 'NO_REQUEST':
				throw new Error(
					'Unexpected draw callback.\n' +
					'Please report this to <https://github.com/elm-lang/virtual-dom/issues>.'
				);

			case 'PENDING_REQUEST':
				rAF(updateIfNeeded);
				state = 'EXTRA_REQUEST';

				var nextNode = view(nextModel);
				var patches = diff(currNode, nextNode);
				domNode = applyPatches(domNode, currNode, patches, eventNode);
				currNode = nextNode;

				return;

			case 'EXTRA_REQUEST':
				state = 'NO_REQUEST';
				return;
		}
	}

	return function stepper(model)
	{
		if (state === 'NO_REQUEST')
		{
			rAF(updateIfNeeded);
		}
		state = 'PENDING_REQUEST';
		nextModel = model;
	};
}


// DEBUG SETUP

function debugSetup(impl, object, moduleName, flagChecker)
{
	object['fullscreen'] = function fullscreen(flags)
	{
		var popoutRef = { doc: undefined };
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, document.body),
			impl.update(scrollTask(popoutRef)),
			impl.subscriptions,
			debugRenderer(moduleName, document.body, popoutRef, impl.view, impl.viewIn, impl.viewOut)
		);
	};

	object['embed'] = function fullscreen(node, flags)
	{
		var popoutRef = { doc: undefined };
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, node),
			impl.update(scrollTask(popoutRef)),
			impl.subscriptions,
			debugRenderer(moduleName, node, popoutRef, impl.view, impl.viewIn, impl.viewOut)
		);
	};
}

function scrollTask(popoutRef)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var doc = popoutRef.doc;
		if (doc)
		{
			var msgs = doc.getElementsByClassName('debugger-sidebar-messages')[0];
			if (msgs)
			{
				msgs.scrollTop = msgs.scrollHeight;
			}
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}


function debugRenderer(moduleName, parentNode, popoutRef, view, viewIn, viewOut)
{
	return function(tagger, initialModel)
	{
		var appEventNode = { tagger: tagger, parent: undefined };
		var eventNode = { tagger: tagger, parent: undefined };

		// make normal stepper
		var appVirtualNode = view(initialModel);
		var appNode = render(appVirtualNode, appEventNode);
		parentNode.appendChild(appNode);
		var appStepper = makeStepper(appNode, view, appVirtualNode, appEventNode);

		// make overlay stepper
		var overVirtualNode = viewIn(initialModel)._1;
		var overNode = render(overVirtualNode, eventNode);
		parentNode.appendChild(overNode);
		var wrappedViewIn = wrapViewIn(appEventNode, overNode, viewIn);
		var overStepper = makeStepper(overNode, wrappedViewIn, overVirtualNode, eventNode);

		// make debugger stepper
		var debugStepper = makeDebugStepper(initialModel, viewOut, eventNode, parentNode, moduleName, popoutRef);

		return function stepper(model)
		{
			appStepper(model);
			overStepper(model);
			debugStepper(model);
		}
	};
}

function makeDebugStepper(initialModel, view, eventNode, parentNode, moduleName, popoutRef)
{
	var curr;
	var domNode;

	return function stepper(model)
	{
		if (!model.isDebuggerOpen)
		{
			return;
		}

		if (!popoutRef.doc)
		{
			curr = view(model);
			domNode = openDebugWindow(moduleName, popoutRef, curr, eventNode);
			return;
		}

		// switch to document of popout
		localDoc = popoutRef.doc;

		var next = view(model);
		var patches = diff(curr, next);
		domNode = applyPatches(domNode, curr, patches, eventNode);
		curr = next;

		// switch back to normal document
		localDoc = document;
	};
}

function openDebugWindow(moduleName, popoutRef, virtualNode, eventNode)
{
	var w = 900;
	var h = 360;
	var x = screen.width - w;
	var y = screen.height - h;
	var debugWindow = window.open('', '', 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y);

	// switch to window document
	localDoc = debugWindow.document;

	popoutRef.doc = localDoc;
	localDoc.title = 'Debugger - ' + moduleName;
	localDoc.body.style.margin = '0';
	localDoc.body.style.padding = '0';
	var domNode = render(virtualNode, eventNode);
	localDoc.body.appendChild(domNode);

	localDoc.addEventListener('keydown', function(event) {
		if (event.metaKey && event.which === 82)
		{
			window.location.reload();
		}
		if (event.which === 38)
		{
			eventNode.tagger({ ctor: 'Up' });
			event.preventDefault();
		}
		if (event.which === 40)
		{
			eventNode.tagger({ ctor: 'Down' });
			event.preventDefault();
		}
	});

	function close()
	{
		popoutRef.doc = undefined;
		debugWindow.close();
	}
	window.addEventListener('unload', close);
	debugWindow.addEventListener('unload', function() {
		popoutRef.doc = undefined;
		window.removeEventListener('unload', close);
		eventNode.tagger({ ctor: 'Close' });
	});

	// switch back to the normal document
	localDoc = document;

	return domNode;
}


// BLOCK EVENTS

function wrapViewIn(appEventNode, overlayNode, viewIn)
{
	var ignorer = makeIgnorer(overlayNode);
	var blocking = 'Normal';
	var overflow;

	var normalTagger = appEventNode.tagger;
	var blockTagger = function() {};

	return function(model)
	{
		var tuple = viewIn(model);
		var newBlocking = tuple._0.ctor;
		appEventNode.tagger = newBlocking === 'Normal' ? normalTagger : blockTagger;
		if (blocking !== newBlocking)
		{
			traverse('removeEventListener', ignorer, blocking);
			traverse('addEventListener', ignorer, newBlocking);

			if (blocking === 'Normal')
			{
				overflow = document.body.style.overflow;
				document.body.style.overflow = 'hidden';
			}

			if (newBlocking === 'Normal')
			{
				document.body.style.overflow = overflow;
			}

			blocking = newBlocking;
		}
		return tuple._1;
	}
}

function traverse(verbEventListener, ignorer, blocking)
{
	switch(blocking)
	{
		case 'Normal':
			return;

		case 'Pause':
			return traverseHelp(verbEventListener, ignorer, mostEvents);

		case 'Message':
			return traverseHelp(verbEventListener, ignorer, allEvents);
	}
}

function traverseHelp(verbEventListener, handler, eventNames)
{
	for (var i = 0; i < eventNames.length; i++)
	{
		document.body[verbEventListener](eventNames[i], handler, true);
	}
}

function makeIgnorer(overlayNode)
{
	return function(event)
	{
		if (event.type === 'keydown' && event.metaKey && event.which === 82)
		{
			return;
		}

		var isScroll = event.type === 'scroll' || event.type === 'wheel';

		var node = event.target;
		while (node !== null)
		{
			if (node.className === 'elm-overlay-message-details' && isScroll)
			{
				return;
			}

			if (node === overlayNode && !isScroll)
			{
				return;
			}
			node = node.parentNode;
		}

		event.stopPropagation();
		event.preventDefault();
	}
}

var mostEvents = [
	'click', 'dblclick', 'mousemove',
	'mouseup', 'mousedown', 'mouseenter', 'mouseleave',
	'touchstart', 'touchend', 'touchcancel', 'touchmove',
	'pointerdown', 'pointerup', 'pointerover', 'pointerout',
	'pointerenter', 'pointerleave', 'pointermove', 'pointercancel',
	'dragstart', 'drag', 'dragend', 'dragenter', 'dragover', 'dragleave', 'drop',
	'keyup', 'keydown', 'keypress',
	'input', 'change',
	'focus', 'blur'
];

var allEvents = mostEvents.concat('wheel', 'scroll');


return {
	node: node,
	text: text,
	custom: custom,
	map: F2(map),

	on: F3(on),
	style: style,
	property: F2(property),
	attribute: F2(attribute),
	attributeNS: F3(attributeNS),
	mapProperty: F2(mapProperty),

	lazy: F2(lazy),
	lazy2: F3(lazy2),
	lazy3: F4(lazy3),
	keyedNode: F3(keyedNode),

	program: program,
	programWithFlags: programWithFlags,
	staticProgram: staticProgram
};

}();

var _elm_lang$virtual_dom$VirtualDom$programWithFlags = function (impl) {
	return A2(_elm_lang$virtual_dom$Native_VirtualDom.programWithFlags, _elm_lang$virtual_dom$VirtualDom_Debug$wrapWithFlags, impl);
};
var _elm_lang$virtual_dom$VirtualDom$program = function (impl) {
	return A2(_elm_lang$virtual_dom$Native_VirtualDom.program, _elm_lang$virtual_dom$VirtualDom_Debug$wrap, impl);
};
var _elm_lang$virtual_dom$VirtualDom$keyedNode = _elm_lang$virtual_dom$Native_VirtualDom.keyedNode;
var _elm_lang$virtual_dom$VirtualDom$lazy3 = _elm_lang$virtual_dom$Native_VirtualDom.lazy3;
var _elm_lang$virtual_dom$VirtualDom$lazy2 = _elm_lang$virtual_dom$Native_VirtualDom.lazy2;
var _elm_lang$virtual_dom$VirtualDom$lazy = _elm_lang$virtual_dom$Native_VirtualDom.lazy;
var _elm_lang$virtual_dom$VirtualDom$defaultOptions = {stopPropagation: false, preventDefault: false};
var _elm_lang$virtual_dom$VirtualDom$onWithOptions = _elm_lang$virtual_dom$Native_VirtualDom.on;
var _elm_lang$virtual_dom$VirtualDom$on = F2(
	function (eventName, decoder) {
		return A3(_elm_lang$virtual_dom$VirtualDom$onWithOptions, eventName, _elm_lang$virtual_dom$VirtualDom$defaultOptions, decoder);
	});
var _elm_lang$virtual_dom$VirtualDom$style = _elm_lang$virtual_dom$Native_VirtualDom.style;
var _elm_lang$virtual_dom$VirtualDom$mapProperty = _elm_lang$virtual_dom$Native_VirtualDom.mapProperty;
var _elm_lang$virtual_dom$VirtualDom$attributeNS = _elm_lang$virtual_dom$Native_VirtualDom.attributeNS;
var _elm_lang$virtual_dom$VirtualDom$attribute = _elm_lang$virtual_dom$Native_VirtualDom.attribute;
var _elm_lang$virtual_dom$VirtualDom$property = _elm_lang$virtual_dom$Native_VirtualDom.property;
var _elm_lang$virtual_dom$VirtualDom$map = _elm_lang$virtual_dom$Native_VirtualDom.map;
var _elm_lang$virtual_dom$VirtualDom$text = _elm_lang$virtual_dom$Native_VirtualDom.text;
var _elm_lang$virtual_dom$VirtualDom$node = _elm_lang$virtual_dom$Native_VirtualDom.node;
var _elm_lang$virtual_dom$VirtualDom$Options = F2(
	function (a, b) {
		return {stopPropagation: a, preventDefault: b};
	});
var _elm_lang$virtual_dom$VirtualDom$Node = {ctor: 'Node'};
var _elm_lang$virtual_dom$VirtualDom$Property = {ctor: 'Property'};

var _elm_lang$html$Html$programWithFlags = _elm_lang$virtual_dom$VirtualDom$programWithFlags;
var _elm_lang$html$Html$program = _elm_lang$virtual_dom$VirtualDom$program;
var _elm_lang$html$Html$beginnerProgram = function (_p0) {
	var _p1 = _p0;
	return _elm_lang$html$Html$program(
		{
			init: A2(
				_elm_lang$core$Platform_Cmd_ops['!'],
				_p1.model,
				{ctor: '[]'}),
			update: F2(
				function (msg, model) {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						A2(_p1.update, msg, model),
						{ctor: '[]'});
				}),
			view: _p1.view,
			subscriptions: function (_p2) {
				return _elm_lang$core$Platform_Sub$none;
			}
		});
};
var _elm_lang$html$Html$map = _elm_lang$virtual_dom$VirtualDom$map;
var _elm_lang$html$Html$text = _elm_lang$virtual_dom$VirtualDom$text;
var _elm_lang$html$Html$node = _elm_lang$virtual_dom$VirtualDom$node;
var _elm_lang$html$Html$body = _elm_lang$html$Html$node('body');
var _elm_lang$html$Html$section = _elm_lang$html$Html$node('section');
var _elm_lang$html$Html$nav = _elm_lang$html$Html$node('nav');
var _elm_lang$html$Html$article = _elm_lang$html$Html$node('article');
var _elm_lang$html$Html$aside = _elm_lang$html$Html$node('aside');
var _elm_lang$html$Html$h1 = _elm_lang$html$Html$node('h1');
var _elm_lang$html$Html$h2 = _elm_lang$html$Html$node('h2');
var _elm_lang$html$Html$h3 = _elm_lang$html$Html$node('h3');
var _elm_lang$html$Html$h4 = _elm_lang$html$Html$node('h4');
var _elm_lang$html$Html$h5 = _elm_lang$html$Html$node('h5');
var _elm_lang$html$Html$h6 = _elm_lang$html$Html$node('h6');
var _elm_lang$html$Html$header = _elm_lang$html$Html$node('header');
var _elm_lang$html$Html$footer = _elm_lang$html$Html$node('footer');
var _elm_lang$html$Html$address = _elm_lang$html$Html$node('address');
var _elm_lang$html$Html$main_ = _elm_lang$html$Html$node('main');
var _elm_lang$html$Html$p = _elm_lang$html$Html$node('p');
var _elm_lang$html$Html$hr = _elm_lang$html$Html$node('hr');
var _elm_lang$html$Html$pre = _elm_lang$html$Html$node('pre');
var _elm_lang$html$Html$blockquote = _elm_lang$html$Html$node('blockquote');
var _elm_lang$html$Html$ol = _elm_lang$html$Html$node('ol');
var _elm_lang$html$Html$ul = _elm_lang$html$Html$node('ul');
var _elm_lang$html$Html$li = _elm_lang$html$Html$node('li');
var _elm_lang$html$Html$dl = _elm_lang$html$Html$node('dl');
var _elm_lang$html$Html$dt = _elm_lang$html$Html$node('dt');
var _elm_lang$html$Html$dd = _elm_lang$html$Html$node('dd');
var _elm_lang$html$Html$figure = _elm_lang$html$Html$node('figure');
var _elm_lang$html$Html$figcaption = _elm_lang$html$Html$node('figcaption');
var _elm_lang$html$Html$div = _elm_lang$html$Html$node('div');
var _elm_lang$html$Html$a = _elm_lang$html$Html$node('a');
var _elm_lang$html$Html$em = _elm_lang$html$Html$node('em');
var _elm_lang$html$Html$strong = _elm_lang$html$Html$node('strong');
var _elm_lang$html$Html$small = _elm_lang$html$Html$node('small');
var _elm_lang$html$Html$s = _elm_lang$html$Html$node('s');
var _elm_lang$html$Html$cite = _elm_lang$html$Html$node('cite');
var _elm_lang$html$Html$q = _elm_lang$html$Html$node('q');
var _elm_lang$html$Html$dfn = _elm_lang$html$Html$node('dfn');
var _elm_lang$html$Html$abbr = _elm_lang$html$Html$node('abbr');
var _elm_lang$html$Html$time = _elm_lang$html$Html$node('time');
var _elm_lang$html$Html$code = _elm_lang$html$Html$node('code');
var _elm_lang$html$Html$var = _elm_lang$html$Html$node('var');
var _elm_lang$html$Html$samp = _elm_lang$html$Html$node('samp');
var _elm_lang$html$Html$kbd = _elm_lang$html$Html$node('kbd');
var _elm_lang$html$Html$sub = _elm_lang$html$Html$node('sub');
var _elm_lang$html$Html$sup = _elm_lang$html$Html$node('sup');
var _elm_lang$html$Html$i = _elm_lang$html$Html$node('i');
var _elm_lang$html$Html$b = _elm_lang$html$Html$node('b');
var _elm_lang$html$Html$u = _elm_lang$html$Html$node('u');
var _elm_lang$html$Html$mark = _elm_lang$html$Html$node('mark');
var _elm_lang$html$Html$ruby = _elm_lang$html$Html$node('ruby');
var _elm_lang$html$Html$rt = _elm_lang$html$Html$node('rt');
var _elm_lang$html$Html$rp = _elm_lang$html$Html$node('rp');
var _elm_lang$html$Html$bdi = _elm_lang$html$Html$node('bdi');
var _elm_lang$html$Html$bdo = _elm_lang$html$Html$node('bdo');
var _elm_lang$html$Html$span = _elm_lang$html$Html$node('span');
var _elm_lang$html$Html$br = _elm_lang$html$Html$node('br');
var _elm_lang$html$Html$wbr = _elm_lang$html$Html$node('wbr');
var _elm_lang$html$Html$ins = _elm_lang$html$Html$node('ins');
var _elm_lang$html$Html$del = _elm_lang$html$Html$node('del');
var _elm_lang$html$Html$img = _elm_lang$html$Html$node('img');
var _elm_lang$html$Html$iframe = _elm_lang$html$Html$node('iframe');
var _elm_lang$html$Html$embed = _elm_lang$html$Html$node('embed');
var _elm_lang$html$Html$object = _elm_lang$html$Html$node('object');
var _elm_lang$html$Html$param = _elm_lang$html$Html$node('param');
var _elm_lang$html$Html$video = _elm_lang$html$Html$node('video');
var _elm_lang$html$Html$audio = _elm_lang$html$Html$node('audio');
var _elm_lang$html$Html$source = _elm_lang$html$Html$node('source');
var _elm_lang$html$Html$track = _elm_lang$html$Html$node('track');
var _elm_lang$html$Html$canvas = _elm_lang$html$Html$node('canvas');
var _elm_lang$html$Html$math = _elm_lang$html$Html$node('math');
var _elm_lang$html$Html$table = _elm_lang$html$Html$node('table');
var _elm_lang$html$Html$caption = _elm_lang$html$Html$node('caption');
var _elm_lang$html$Html$colgroup = _elm_lang$html$Html$node('colgroup');
var _elm_lang$html$Html$col = _elm_lang$html$Html$node('col');
var _elm_lang$html$Html$tbody = _elm_lang$html$Html$node('tbody');
var _elm_lang$html$Html$thead = _elm_lang$html$Html$node('thead');
var _elm_lang$html$Html$tfoot = _elm_lang$html$Html$node('tfoot');
var _elm_lang$html$Html$tr = _elm_lang$html$Html$node('tr');
var _elm_lang$html$Html$td = _elm_lang$html$Html$node('td');
var _elm_lang$html$Html$th = _elm_lang$html$Html$node('th');
var _elm_lang$html$Html$form = _elm_lang$html$Html$node('form');
var _elm_lang$html$Html$fieldset = _elm_lang$html$Html$node('fieldset');
var _elm_lang$html$Html$legend = _elm_lang$html$Html$node('legend');
var _elm_lang$html$Html$label = _elm_lang$html$Html$node('label');
var _elm_lang$html$Html$input = _elm_lang$html$Html$node('input');
var _elm_lang$html$Html$button = _elm_lang$html$Html$node('button');
var _elm_lang$html$Html$select = _elm_lang$html$Html$node('select');
var _elm_lang$html$Html$datalist = _elm_lang$html$Html$node('datalist');
var _elm_lang$html$Html$optgroup = _elm_lang$html$Html$node('optgroup');
var _elm_lang$html$Html$option = _elm_lang$html$Html$node('option');
var _elm_lang$html$Html$textarea = _elm_lang$html$Html$node('textarea');
var _elm_lang$html$Html$keygen = _elm_lang$html$Html$node('keygen');
var _elm_lang$html$Html$output = _elm_lang$html$Html$node('output');
var _elm_lang$html$Html$progress = _elm_lang$html$Html$node('progress');
var _elm_lang$html$Html$meter = _elm_lang$html$Html$node('meter');
var _elm_lang$html$Html$details = _elm_lang$html$Html$node('details');
var _elm_lang$html$Html$summary = _elm_lang$html$Html$node('summary');
var _elm_lang$html$Html$menuitem = _elm_lang$html$Html$node('menuitem');
var _elm_lang$html$Html$menu = _elm_lang$html$Html$node('menu');

var _elm_lang$html$Html_Attributes$map = _elm_lang$virtual_dom$VirtualDom$mapProperty;
var _elm_lang$html$Html_Attributes$attribute = _elm_lang$virtual_dom$VirtualDom$attribute;
var _elm_lang$html$Html_Attributes$contextmenu = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'contextmenu', value);
};
var _elm_lang$html$Html_Attributes$draggable = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'draggable', value);
};
var _elm_lang$html$Html_Attributes$itemprop = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'itemprop', value);
};
var _elm_lang$html$Html_Attributes$tabindex = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'tabIndex',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$charset = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'charset', value);
};
var _elm_lang$html$Html_Attributes$height = function (value) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'height',
		_elm_lang$core$Basics$toString(value));
};
var _elm_lang$html$Html_Attributes$width = function (value) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'width',
		_elm_lang$core$Basics$toString(value));
};
var _elm_lang$html$Html_Attributes$formaction = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'formAction', value);
};
var _elm_lang$html$Html_Attributes$list = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'list', value);
};
var _elm_lang$html$Html_Attributes$minlength = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'minLength',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$maxlength = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'maxlength',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$size = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'size',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$form = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'form', value);
};
var _elm_lang$html$Html_Attributes$cols = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'cols',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$rows = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'rows',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$challenge = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'challenge', value);
};
var _elm_lang$html$Html_Attributes$media = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'media', value);
};
var _elm_lang$html$Html_Attributes$rel = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'rel', value);
};
var _elm_lang$html$Html_Attributes$datetime = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'datetime', value);
};
var _elm_lang$html$Html_Attributes$pubdate = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'pubdate', value);
};
var _elm_lang$html$Html_Attributes$colspan = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'colspan',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$rowspan = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'rowspan',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$manifest = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'manifest', value);
};
var _elm_lang$html$Html_Attributes$property = _elm_lang$virtual_dom$VirtualDom$property;
var _elm_lang$html$Html_Attributes$stringProperty = F2(
	function (name, string) {
		return A2(
			_elm_lang$html$Html_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$string(string));
	});
var _elm_lang$html$Html_Attributes$class = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'className', name);
};
var _elm_lang$html$Html_Attributes$id = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'id', name);
};
var _elm_lang$html$Html_Attributes$title = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'title', name);
};
var _elm_lang$html$Html_Attributes$accesskey = function ($char) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'accessKey',
		_elm_lang$core$String$fromChar($char));
};
var _elm_lang$html$Html_Attributes$dir = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'dir', value);
};
var _elm_lang$html$Html_Attributes$dropzone = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'dropzone', value);
};
var _elm_lang$html$Html_Attributes$lang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'lang', value);
};
var _elm_lang$html$Html_Attributes$content = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'content', value);
};
var _elm_lang$html$Html_Attributes$httpEquiv = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'httpEquiv', value);
};
var _elm_lang$html$Html_Attributes$language = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'language', value);
};
var _elm_lang$html$Html_Attributes$src = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'src', value);
};
var _elm_lang$html$Html_Attributes$alt = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'alt', value);
};
var _elm_lang$html$Html_Attributes$preload = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'preload', value);
};
var _elm_lang$html$Html_Attributes$poster = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'poster', value);
};
var _elm_lang$html$Html_Attributes$kind = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'kind', value);
};
var _elm_lang$html$Html_Attributes$srclang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'srclang', value);
};
var _elm_lang$html$Html_Attributes$sandbox = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'sandbox', value);
};
var _elm_lang$html$Html_Attributes$srcdoc = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'srcdoc', value);
};
var _elm_lang$html$Html_Attributes$type_ = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'type', value);
};
var _elm_lang$html$Html_Attributes$value = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'value', value);
};
var _elm_lang$html$Html_Attributes$defaultValue = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'defaultValue', value);
};
var _elm_lang$html$Html_Attributes$placeholder = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'placeholder', value);
};
var _elm_lang$html$Html_Attributes$accept = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'accept', value);
};
var _elm_lang$html$Html_Attributes$acceptCharset = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'acceptCharset', value);
};
var _elm_lang$html$Html_Attributes$action = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'action', value);
};
var _elm_lang$html$Html_Attributes$autocomplete = function (bool) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var _elm_lang$html$Html_Attributes$enctype = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'enctype', value);
};
var _elm_lang$html$Html_Attributes$method = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'method', value);
};
var _elm_lang$html$Html_Attributes$name = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'name', value);
};
var _elm_lang$html$Html_Attributes$pattern = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'pattern', value);
};
var _elm_lang$html$Html_Attributes$for = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'htmlFor', value);
};
var _elm_lang$html$Html_Attributes$max = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'max', value);
};
var _elm_lang$html$Html_Attributes$min = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'min', value);
};
var _elm_lang$html$Html_Attributes$step = function (n) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'step', n);
};
var _elm_lang$html$Html_Attributes$wrap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'wrap', value);
};
var _elm_lang$html$Html_Attributes$usemap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'useMap', value);
};
var _elm_lang$html$Html_Attributes$shape = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'shape', value);
};
var _elm_lang$html$Html_Attributes$coords = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'coords', value);
};
var _elm_lang$html$Html_Attributes$keytype = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'keytype', value);
};
var _elm_lang$html$Html_Attributes$align = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'align', value);
};
var _elm_lang$html$Html_Attributes$cite = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'cite', value);
};
var _elm_lang$html$Html_Attributes$href = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'href', value);
};
var _elm_lang$html$Html_Attributes$target = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'target', value);
};
var _elm_lang$html$Html_Attributes$downloadAs = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'download', value);
};
var _elm_lang$html$Html_Attributes$hreflang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'hreflang', value);
};
var _elm_lang$html$Html_Attributes$ping = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'ping', value);
};
var _elm_lang$html$Html_Attributes$start = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'start',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$headers = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'headers', value);
};
var _elm_lang$html$Html_Attributes$scope = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'scope', value);
};
var _elm_lang$html$Html_Attributes$boolProperty = F2(
	function (name, bool) {
		return A2(
			_elm_lang$html$Html_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$bool(bool));
	});
var _elm_lang$html$Html_Attributes$hidden = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'hidden', bool);
};
var _elm_lang$html$Html_Attributes$contenteditable = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'contentEditable', bool);
};
var _elm_lang$html$Html_Attributes$spellcheck = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'spellcheck', bool);
};
var _elm_lang$html$Html_Attributes$async = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'async', bool);
};
var _elm_lang$html$Html_Attributes$defer = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'defer', bool);
};
var _elm_lang$html$Html_Attributes$scoped = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'scoped', bool);
};
var _elm_lang$html$Html_Attributes$autoplay = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'autoplay', bool);
};
var _elm_lang$html$Html_Attributes$controls = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'controls', bool);
};
var _elm_lang$html$Html_Attributes$loop = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'loop', bool);
};
var _elm_lang$html$Html_Attributes$default = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'default', bool);
};
var _elm_lang$html$Html_Attributes$seamless = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'seamless', bool);
};
var _elm_lang$html$Html_Attributes$checked = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'checked', bool);
};
var _elm_lang$html$Html_Attributes$selected = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'selected', bool);
};
var _elm_lang$html$Html_Attributes$autofocus = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'autofocus', bool);
};
var _elm_lang$html$Html_Attributes$disabled = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'disabled', bool);
};
var _elm_lang$html$Html_Attributes$multiple = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'multiple', bool);
};
var _elm_lang$html$Html_Attributes$novalidate = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'noValidate', bool);
};
var _elm_lang$html$Html_Attributes$readonly = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'readOnly', bool);
};
var _elm_lang$html$Html_Attributes$required = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'required', bool);
};
var _elm_lang$html$Html_Attributes$ismap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'isMap', value);
};
var _elm_lang$html$Html_Attributes$download = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'download', bool);
};
var _elm_lang$html$Html_Attributes$reversed = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'reversed', bool);
};
var _elm_lang$html$Html_Attributes$classList = function (list) {
	return _elm_lang$html$Html_Attributes$class(
		A2(
			_elm_lang$core$String$join,
			' ',
			A2(
				_elm_lang$core$List$map,
				_elm_lang$core$Tuple$first,
				A2(_elm_lang$core$List$filter, _elm_lang$core$Tuple$second, list))));
};
var _elm_lang$html$Html_Attributes$style = _elm_lang$virtual_dom$VirtualDom$style;

var _elm_lang$html$Html_Events$keyCode = A2(_elm_lang$core$Json_Decode$field, 'keyCode', _elm_lang$core$Json_Decode$int);
var _elm_lang$html$Html_Events$targetChecked = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'checked',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$bool);
var _elm_lang$html$Html_Events$targetValue = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'value',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$string);
var _elm_lang$html$Html_Events$defaultOptions = _elm_lang$virtual_dom$VirtualDom$defaultOptions;
var _elm_lang$html$Html_Events$onWithOptions = _elm_lang$virtual_dom$VirtualDom$onWithOptions;
var _elm_lang$html$Html_Events$on = _elm_lang$virtual_dom$VirtualDom$on;
var _elm_lang$html$Html_Events$onFocus = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'focus',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onBlur = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'blur',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onSubmitOptions = _elm_lang$core$Native_Utils.update(
	_elm_lang$html$Html_Events$defaultOptions,
	{preventDefault: true});
var _elm_lang$html$Html_Events$onSubmit = function (msg) {
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'submit',
		_elm_lang$html$Html_Events$onSubmitOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onCheck = function (tagger) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'change',
		A2(_elm_lang$core$Json_Decode$map, tagger, _elm_lang$html$Html_Events$targetChecked));
};
var _elm_lang$html$Html_Events$onInput = function (tagger) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'input',
		A2(_elm_lang$core$Json_Decode$map, tagger, _elm_lang$html$Html_Events$targetValue));
};
var _elm_lang$html$Html_Events$onMouseOut = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseout',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseOver = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseover',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseLeave = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseleave',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseEnter = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseenter',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseUp = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseup',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseDown = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mousedown',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onDoubleClick = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'dblclick',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onClick = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'click',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$Options = F2(
	function (a, b) {
		return {stopPropagation: a, preventDefault: b};
	});

var _elm_lang$html$Html_Keyed$node = _elm_lang$virtual_dom$VirtualDom$keyedNode;
var _elm_lang$html$Html_Keyed$ol = _elm_lang$html$Html_Keyed$node('ol');
var _elm_lang$html$Html_Keyed$ul = _elm_lang$html$Html_Keyed$node('ul');

var _elm_community$elm_datepicker$DatePicker_ops = _elm_community$elm_datepicker$DatePicker_ops || {};
_elm_community$elm_datepicker$DatePicker_ops['??>'] = F2(
	function (first, $default) {
		var _p0 = first;
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Maybe$Just(_p0._0);
		} else {
			return $default;
		}
	});
var _elm_community$elm_datepicker$DatePicker_ops = _elm_community$elm_datepicker$DatePicker_ops || {};
_elm_community$elm_datepicker$DatePicker_ops['?>'] = _elm_lang$core$Basics$flip(_elm_lang$core$Maybe$withDefault);
var _elm_community$elm_datepicker$DatePicker$mkClassList = F2(
	function (_p1, cs) {
		var _p2 = _p1;
		return _elm_lang$html$Html_Attributes$classList(
			A2(
				_elm_lang$core$List$map,
				function (_p3) {
					var _p4 = _p3;
					return {
						ctor: '_Tuple2',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p2.classNamespace, _p4._0),
						_1: _p4._1
					};
				},
				cs));
	});
var _elm_community$elm_datepicker$DatePicker$mkClass = F2(
	function (_p5, c) {
		var _p6 = _p5;
		return _elm_lang$html$Html_Attributes$class(
			A2(_elm_lang$core$Basics_ops['++'], _p6.classNamespace, c));
	});
var _elm_community$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				var _p7 = xs;
				if (_p7.ctor === '[]') {
					return _elm_lang$core$List$reverse(acc);
				} else {
					var _p9 = _p7._1;
					var _p8 = _p7._0;
					if (_elm_lang$core$Native_Utils.eq(i, 6)) {
						var _v5 = 0,
							_v6 = _p9,
							_v7 = {ctor: '[]'},
							_v8 = {
							ctor: '::',
							_0: _elm_lang$core$List$reverse(
								{ctor: '::', _0: _p8, _1: racc}),
							_1: acc
						};
						i = _v5;
						xs = _v6;
						racc = _v7;
						acc = _v8;
						continue go;
					} else {
						var _v9 = i + 1,
							_v10 = _p9,
							_v11 = {ctor: '::', _0: _p8, _1: racc},
							_v12 = acc;
						i = _v9;
						xs = _v10;
						racc = _v11;
						acc = _v12;
						continue go;
					}
				}
			}
		});
	return A4(
		go,
		0,
		dates,
		{ctor: '[]'},
		{ctor: '[]'});
};
var _elm_community$elm_datepicker$DatePicker$focusedDate = function (_p10) {
	var _p11 = _p10;
	return _p11._0.focused;
};
var _elm_community$elm_datepicker$DatePicker$isOpen = function (_p12) {
	var _p13 = _p12;
	return _p13._0.open;
};
var _elm_community$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var end = A2(
			_elm_community$elm_datepicker$DatePicker_Date$addDays,
			6,
			_elm_community$elm_datepicker$DatePicker_Date$nextMonth(date));
		var start = A2(
			_elm_community$elm_datepicker$DatePicker_Date$subDays,
			6,
			_elm_community$elm_datepicker$DatePicker_Date$firstOfMonth(date));
		return {
			currentMonth: date,
			currentDates: A3(_elm_community$elm_datepicker$DatePicker_Date$datesInRange, firstDayOfWeek, start, end)
		};
	});
var _elm_community$elm_datepicker$DatePicker$formatCell = function (day) {
	return _elm_lang$html$Html$text(day);
};
var _elm_community$elm_datepicker$DatePicker$off = _elm_community$elm_datepicker$DatePicker_Date$Off;
var _elm_community$elm_datepicker$DatePicker$to = function (year) {
	return _elm_community$elm_datepicker$DatePicker_Date$To(year);
};
var _elm_community$elm_datepicker$DatePicker$from = function (year) {
	return _elm_community$elm_datepicker$DatePicker_Date$From(year);
};
var _elm_community$elm_datepicker$DatePicker$moreOrLess = function (range) {
	return _elm_community$elm_datepicker$DatePicker_Date$MoreOrLess(range);
};
var _elm_community$elm_datepicker$DatePicker$between = F2(
	function (start, end) {
		return (_elm_lang$core$Native_Utils.cmp(start, end) > 0) ? A2(_elm_community$elm_datepicker$DatePicker_Date$Between, end, start) : A2(_elm_community$elm_datepicker$DatePicker_Date$Between, start, end);
	});
var _elm_community$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_elm_lang$core$Native_Utils.eq(yearRange, _elm_community$elm_datepicker$DatePicker_Date$Off);
};
var _elm_community$elm_datepicker$DatePicker$defaultSettings = {
	placeholder: 'Please pick a date...',
	classNamespace: 'elm-datepicker--',
	inputClassList: {ctor: '[]'},
	inputName: _elm_lang$core$Maybe$Nothing,
	inputId: _elm_lang$core$Maybe$Nothing,
	inputAttributes: {
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$required(false),
		_1: {ctor: '[]'}
	},
	isDisabled: _elm_lang$core$Basics$always(false),
	parser: _elm_lang$core$Date$fromString,
	dateFormatter: _elm_community$elm_datepicker$DatePicker_Date$formatDate,
	dayFormatter: _elm_community$elm_datepicker$DatePicker_Date$formatDay,
	monthFormatter: _elm_community$elm_datepicker$DatePicker_Date$formatMonth,
	yearFormatter: _elm_lang$core$Basics$toString,
	cellFormatter: _elm_community$elm_datepicker$DatePicker$formatCell,
	firstDayOfWeek: _elm_lang$core$Date$Sun,
	changeYear: _elm_community$elm_datepicker$DatePicker$off
};
var _elm_community$elm_datepicker$DatePicker$Settings = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return {placeholder: a, classNamespace: b, inputClassList: c, inputName: d, inputId: e, inputAttributes: f, isDisabled: g, parser: h, dateFormatter: i, dayFormatter: j, monthFormatter: k, yearFormatter: l, cellFormatter: m, firstDayOfWeek: n, changeYear: o};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _elm_community$elm_datepicker$DatePicker$Model = F4(
	function (a, b, c, d) {
		return {open: a, forceOpen: b, focused: c, today: d};
	});
var _elm_community$elm_datepicker$DatePicker$MouseUp = {ctor: 'MouseUp'};
var _elm_community$elm_datepicker$DatePicker$MouseDown = {ctor: 'MouseDown'};
var _elm_community$elm_datepicker$DatePicker$Blur = {ctor: 'Blur'};
var _elm_community$elm_datepicker$DatePicker$Focus = {ctor: 'Focus'};
var _elm_community$elm_datepicker$DatePicker$SubmitText = function (a) {
	return {ctor: 'SubmitText', _0: a};
};
var _elm_community$elm_datepicker$DatePicker$Pick = function (a) {
	return {ctor: 'Pick', _0: a};
};
var _elm_community$elm_datepicker$DatePicker$pick = _elm_community$elm_datepicker$DatePicker$Pick;
var _elm_community$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {ctor: 'ChangeFocus', _0: a};
};
var _elm_community$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, _p14) {
		var _p15 = _p14;
		var onChange = function (handler) {
			return A2(
				_elm_lang$html$Html_Events$on,
				'change',
				A2(_elm_lang$core$Json_Decode$map, handler, _elm_lang$html$Html_Events$targetValue));
		};
		var onPicker = function (ev) {
			return function (_p16) {
				return A3(
					_elm_lang$html$Html_Events$onWithOptions,
					ev,
					{preventDefault: false, stopPropagation: true},
					_elm_lang$core$Json_Decode$succeed(_p16));
			};
		};
		var picked = function (d) {
			return A2(
				_elm_lang$core$Maybe$withDefault,
				false,
				A2(
					_elm_lang$core$Maybe$map,
					function (_p17) {
						return A2(
							F2(
								function (x, y) {
									return _elm_lang$core$Native_Utils.eq(x, y);
								}),
							_elm_community$elm_datepicker$DatePicker_Date$dateTuple(d),
							_elm_community$elm_datepicker$DatePicker_Date$dateTuple(_p17));
					},
					pickedDate));
		};
		var firstDay = settings.firstDayOfWeek;
		var classList = _elm_community$elm_datepicker$DatePicker$mkClassList(settings);
		var $class = _elm_community$elm_datepicker$DatePicker$mkClass(settings);
		var arrow = F2(
			function (className, message) {
				return A2(
					_elm_lang$html$Html$a,
					{
						ctor: '::',
						_0: $class(className),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$href('javascript:;'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(message),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$tabindex(-1),
									_1: {ctor: '[]'}
								}
							}
						}
					},
					{ctor: '[]'});
			});
		var dow = function (d) {
			return A2(
				_elm_lang$html$Html$td,
				{
					ctor: '::',
					_0: $class('dow'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						settings.dayFormatter(d)),
					_1: {ctor: '[]'}
				});
		};
		var currentDate = A2(
			_elm_community$elm_datepicker$DatePicker_ops['?>'],
			A2(_elm_community$elm_datepicker$DatePicker_ops['??>'], _p15.focused, pickedDate),
			_p15.today);
		var _p18 = A2(_elm_community$elm_datepicker$DatePicker$prepareDates, currentDate, settings.firstDayOfWeek);
		var currentMonth = _p18.currentMonth;
		var currentDates = _p18.currentDates;
		var isCurrentYear = function (selectedYear) {
			return _elm_lang$core$Native_Utils.eq(
				_elm_lang$core$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Basics$toString(index),
					_1: A2(
						_elm_lang$html$Html$option,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$value(
								_elm_lang$core$Basics$toString(selectedYear)),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$selected(
									isCurrentYear(selectedYear)),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								_elm_lang$core$Basics$toString(selectedYear)),
							_1: {ctor: '[]'}
						})
				};
			});
		var day = function (d) {
			var disabled = settings.isDisabled(d);
			var props = (!disabled) ? {
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onClick(
					_elm_community$elm_datepicker$DatePicker$Pick(
						_elm_lang$core$Maybe$Just(d))),
				_1: {ctor: '[]'}
			} : {ctor: '[]'};
			return A2(
				_elm_lang$html$Html$td,
				A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: classList(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'day', _1: true},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'disabled', _1: disabled},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'picked',
											_1: picked(d)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'today',
												_1: _elm_lang$core$Native_Utils.eq(
													_elm_community$elm_datepicker$DatePicker_Date$dateTuple(d),
													_elm_community$elm_datepicker$DatePicker_Date$dateTuple(currentDate))
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'other-month',
													_1: !_elm_lang$core$Native_Utils.eq(
														_elm_lang$core$Date$month(currentMonth),
														_elm_lang$core$Date$month(d))
												},
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}),
						_1: {ctor: '[]'}
					},
					props),
				{
					ctor: '::',
					_0: settings.cellFormatter(
						_elm_lang$core$Basics$toString(
							_elm_lang$core$Date$day(d))),
					_1: {ctor: '[]'}
				});
		};
		var row = function (days) {
			return A2(
				_elm_lang$html$Html$tr,
				{
					ctor: '::',
					_0: $class('row'),
					_1: {ctor: '[]'}
				},
				A2(_elm_lang$core$List$map, day, days));
		};
		var days = A2(
			_elm_lang$core$List$map,
			row,
			_elm_community$elm_datepicker$DatePicker$groupDates(currentDates));
		var dropdownYear = A3(
			_elm_lang$html$Html_Keyed$node,
			'select',
			{
				ctor: '::',
				_0: onChange(
					function (_p19) {
						return _elm_community$elm_datepicker$DatePicker$ChangeFocus(
							A2(_elm_community$elm_datepicker$DatePicker_Date$newYear, currentDate, _p19));
					}),
				_1: {
					ctor: '::',
					_0: $class('year-menu'),
					_1: {ctor: '[]'}
				}
			},
			A2(
				_elm_lang$core$List$indexedMap,
				yearOption,
				A2(
					_elm_community$elm_datepicker$DatePicker_Date$yearRange,
					{focused: currentDate, currentMonth: currentMonth},
					settings.changeYear)));
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: $class('picker'),
				_1: {
					ctor: '::',
					_0: A2(onPicker, 'mousedown', _elm_community$elm_datepicker$DatePicker$MouseDown),
					_1: {
						ctor: '::',
						_0: A2(onPicker, 'mouseup', _elm_community$elm_datepicker$DatePicker$MouseUp),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: $class('picker-header'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: $class('prev-container'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									arrow,
									'prev',
									_elm_community$elm_datepicker$DatePicker$ChangeFocus(
										_elm_community$elm_datepicker$DatePicker_Date$prevMonth(currentDate))),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: $class('month-container'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$span,
										{
											ctor: '::',
											_0: $class('month'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(
												settings.monthFormatter(
													_elm_lang$core$Date$month(currentMonth))),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: $class('year'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: (!_elm_community$elm_datepicker$DatePicker$yearRangeActive(settings.changeYear)) ? _elm_lang$html$Html$text(
													settings.yearFormatter(
														_elm_lang$core$Date$year(currentMonth))) : A3(
													_elm_lang$html$Html_Keyed$node,
													'span',
													{ctor: '[]'},
													{
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: _elm_lang$core$Basics$toString(
																_elm_lang$core$Date$year(currentMonth)),
															_1: dropdownYear
														},
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: $class('next-container'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											arrow,
											'next',
											_elm_community$elm_datepicker$DatePicker$ChangeFocus(
												_elm_community$elm_datepicker$DatePicker_Date$nextMonth(currentDate))),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$table,
						{
							ctor: '::',
							_0: $class('table'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$thead,
								{
									ctor: '::',
									_0: $class('weekdays'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$tr,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: dow(firstDay),
											_1: {
												ctor: '::',
												_0: dow(
													A2(_elm_community$elm_datepicker$DatePicker_Date$addDows, 1, firstDay)),
												_1: {
													ctor: '::',
													_0: dow(
														A2(_elm_community$elm_datepicker$DatePicker_Date$addDows, 2, firstDay)),
													_1: {
														ctor: '::',
														_0: dow(
															A2(_elm_community$elm_datepicker$DatePicker_Date$addDows, 3, firstDay)),
														_1: {
															ctor: '::',
															_0: dow(
																A2(_elm_community$elm_datepicker$DatePicker_Date$addDows, 4, firstDay)),
															_1: {
																ctor: '::',
																_0: dow(
																	A2(_elm_community$elm_datepicker$DatePicker_Date$addDows, 5, firstDay)),
																_1: {
																	ctor: '::',
																	_0: dow(
																		A2(_elm_community$elm_datepicker$DatePicker_Date$addDows, 6, firstDay)),
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										}),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$tbody,
									{
										ctor: '::',
										_0: $class('days'),
										_1: {ctor: '[]'}
									},
									days),
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _elm_community$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _p20) {
		var _p21 = _p20;
		var inputClasses = A2(
			_elm_lang$core$Basics_ops['++'],
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: A2(_elm_lang$core$Basics_ops['++'], settings.classNamespace, 'input'),
					_1: true
				},
				_1: {ctor: '[]'}
			},
			settings.inputClassList);
		var potentialInputId = function (_p22) {
			return A2(
				_elm_lang$core$List$filterMap,
				_elm_lang$core$Basics$identity,
				_elm_lang$core$List$singleton(_p22));
		}(
			A2(_elm_lang$core$Maybe$map, _elm_lang$html$Html_Attributes$id, settings.inputId));
		var inputCommon = function (xs) {
			return A2(
				_elm_lang$html$Html$input,
				A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$classList(inputClasses),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$name(
								A2(_elm_community$elm_datepicker$DatePicker_ops['?>'], settings.inputName, '')),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$type_('text'),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html_Events$on,
										'change',
										A2(_elm_lang$core$Json_Decode$map, _elm_community$elm_datepicker$DatePicker$SubmitText, _elm_lang$html$Html_Events$targetValue)),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onBlur(_elm_community$elm_datepicker$DatePicker$Blur),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Events$onClick(_elm_community$elm_datepicker$DatePicker$Focus),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Events$onFocus(_elm_community$elm_datepicker$DatePicker$Focus),
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					},
					A2(
						_elm_lang$core$Basics_ops['++'],
						settings.inputAttributes,
						A2(_elm_lang$core$Basics_ops['++'], potentialInputId, xs))),
				{ctor: '[]'});
		};
		var dateInput = inputCommon(
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$placeholder(settings.placeholder),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(
						A2(
							_elm_lang$core$Maybe$withDefault,
							'',
							A2(_elm_lang$core$Maybe$map, settings.dateFormatter, pickedDate))),
					_1: {ctor: '[]'}
				}
			});
		var $class = _elm_community$elm_datepicker$DatePicker$mkClass(settings);
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: $class('container'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: dateInput,
				_1: {
					ctor: '::',
					_0: _p21._0.open ? A3(_elm_community$elm_datepicker$DatePicker$datePicker, pickedDate, settings, _p21._0) : _elm_lang$html$Html$text(''),
					_1: {ctor: '[]'}
				}
			});
	});
var _elm_community$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {ctor: 'CurrentDate', _0: a};
};
var _elm_community$elm_datepicker$DatePicker$DatePicker = function (a) {
	return {ctor: 'DatePicker', _0: a};
};
var _elm_community$elm_datepicker$DatePicker$init = {
	ctor: '_Tuple2',
	_0: _elm_community$elm_datepicker$DatePicker$DatePicker(
		{
			open: false,
			forceOpen: false,
			focused: _elm_lang$core$Maybe$Just(_elm_community$elm_datepicker$DatePicker_Date$initDate),
			today: _elm_community$elm_datepicker$DatePicker_Date$initDate
		}),
	_1: A2(_elm_lang$core$Task$perform, _elm_community$elm_datepicker$DatePicker$CurrentDate, _elm_lang$core$Date$now)
};
var _elm_community$elm_datepicker$DatePicker$initFromDate = function (date) {
	return _elm_community$elm_datepicker$DatePicker$DatePicker(
		{
			open: false,
			forceOpen: false,
			focused: _elm_lang$core$Maybe$Just(date),
			today: date
		});
};
var _elm_community$elm_datepicker$DatePicker$initFromDates = F2(
	function (today, date) {
		return _elm_community$elm_datepicker$DatePicker$DatePicker(
			{open: false, forceOpen: false, focused: date, today: today});
	});
var _elm_community$elm_datepicker$DatePicker$Changed = function (a) {
	return {ctor: 'Changed', _0: a};
};
var _elm_community$elm_datepicker$DatePicker$NoChange = {ctor: 'NoChange'};
var _elm_community$elm_datepicker$DatePicker_ops = _elm_community$elm_datepicker$DatePicker_ops || {};
_elm_community$elm_datepicker$DatePicker_ops['!'] = F2(
	function (m, cs) {
		return {
			ctor: '_Tuple3',
			_0: _elm_community$elm_datepicker$DatePicker$DatePicker(m),
			_1: _elm_lang$core$Platform_Cmd$batch(cs),
			_2: _elm_community$elm_datepicker$DatePicker$NoChange
		};
	});
var _elm_community$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _p23) {
		var _p24 = _p23;
		var _p31 = _p24._0;
		var _p25 = msg;
		switch (_p25.ctor) {
			case 'CurrentDate':
				var _p26 = _p25._0;
				return A2(
					_elm_community$elm_datepicker$DatePicker_ops['!'],
					_elm_lang$core$Native_Utils.update(
						_p31,
						{
							focused: _elm_lang$core$Maybe$Just(_p26),
							today: _p26
						}),
					{ctor: '[]'});
			case 'ChangeFocus':
				return A2(
					_elm_community$elm_datepicker$DatePicker_ops['!'],
					_elm_lang$core$Native_Utils.update(
						_p31,
						{
							focused: _elm_lang$core$Maybe$Just(_p25._0)
						}),
					{ctor: '[]'});
			case 'Pick':
				return {
					ctor: '_Tuple3',
					_0: _elm_community$elm_datepicker$DatePicker$DatePicker(
						_elm_lang$core$Native_Utils.update(
							_p31,
							{open: false, focused: _elm_lang$core$Maybe$Nothing})),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _elm_community$elm_datepicker$DatePicker$Changed(_p25._0)
				};
			case 'SubmitText':
				var _p30 = _p25._0;
				var isWhitespace = function (_p27) {
					return _elm_lang$core$String$isEmpty(
						_elm_lang$core$String$trim(_p27));
				};
				var dateEvent = isWhitespace(_p30) ? _elm_community$elm_datepicker$DatePicker$Changed(_elm_lang$core$Maybe$Nothing) : A2(
					_elm_lang$core$Result$withDefault,
					_elm_community$elm_datepicker$DatePicker$NoChange,
					A2(
						_elm_lang$core$Result$map,
						function (_p28) {
							return _elm_community$elm_datepicker$DatePicker$Changed(
								function (date) {
									return settings.isDisabled(date) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(date);
								}(_p28));
						},
						settings.parser(_p30)));
				return {
					ctor: '_Tuple3',
					_0: _elm_community$elm_datepicker$DatePicker$DatePicker(
						_elm_lang$core$Native_Utils.update(
							_p31,
							{
								focused: function () {
									var _p29 = dateEvent;
									if (_p29.ctor === 'Changed') {
										return _elm_lang$core$Maybe$Nothing;
									} else {
										return _p31.focused;
									}
								}()
							})),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: dateEvent
				};
			case 'Focus':
				return A2(
					_elm_community$elm_datepicker$DatePicker_ops['!'],
					_elm_lang$core$Native_Utils.update(
						_p31,
						{open: true, forceOpen: false}),
					{ctor: '[]'});
			case 'Blur':
				return A2(
					_elm_community$elm_datepicker$DatePicker_ops['!'],
					_elm_lang$core$Native_Utils.update(
						_p31,
						{open: _p24._0.forceOpen}),
					{ctor: '[]'});
			case 'MouseDown':
				return A2(
					_elm_community$elm_datepicker$DatePicker_ops['!'],
					_elm_lang$core$Native_Utils.update(
						_p31,
						{forceOpen: true}),
					{ctor: '[]'});
			default:
				return A2(
					_elm_community$elm_datepicker$DatePicker_ops['!'],
					_elm_lang$core$Native_Utils.update(
						_p31,
						{forceOpen: false}),
					{ctor: '[]'});
		}
	});

var _elm_community$json_extra$Json_Decode_Extra$when = F3(
	function (checkDecoder, check, passDecoder) {
		return A2(
			_elm_lang$core$Json_Decode$andThen,
			function (checkVal) {
				return check(checkVal) ? passDecoder : _elm_lang$core$Json_Decode$fail(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'Check failed with input `',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(checkVal),
							'`')));
			},
			checkDecoder);
	});
var _elm_community$json_extra$Json_Decode_Extra$combine = A2(
	_elm_lang$core$List$foldr,
	_elm_lang$core$Json_Decode$map2(
		F2(
			function (x, y) {
				return {ctor: '::', _0: x, _1: y};
			})),
	_elm_lang$core$Json_Decode$succeed(
		{ctor: '[]'}));
var _elm_community$json_extra$Json_Decode_Extra$collection = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (length) {
			return _elm_community$json_extra$Json_Decode_Extra$combine(
				A2(
					_elm_lang$core$List$map,
					function (index) {
						return A2(
							_elm_lang$core$Json_Decode$field,
							_elm_lang$core$Basics$toString(index),
							decoder);
					},
					A2(_elm_lang$core$List$range, 0, length - 1)));
		},
		A2(_elm_lang$core$Json_Decode$field, 'length', _elm_lang$core$Json_Decode$int));
};
var _elm_community$json_extra$Json_Decode_Extra$fromResult = function (result) {
	var _p0 = result;
	if (_p0.ctor === 'Ok') {
		return _elm_lang$core$Json_Decode$succeed(_p0._0);
	} else {
		return _elm_lang$core$Json_Decode$fail(_p0._0);
	}
};
var _elm_community$json_extra$Json_Decode_Extra$parseInt = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p1) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$String$toInt(_p1));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$parseFloat = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p2) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$String$toFloat(_p2));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$doubleEncoded = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (_p3) {
			return _elm_community$json_extra$Json_Decode_Extra$fromResult(
				A2(_elm_lang$core$Json_Decode$decodeString, decoder, _p3));
		},
		_elm_lang$core$Json_Decode$string);
};
var _elm_community$json_extra$Json_Decode_Extra$keys = A2(
	_elm_lang$core$Json_Decode$map,
	A2(
		_elm_lang$core$List$foldl,
		F2(
			function (_p4, acc) {
				var _p5 = _p4;
				return {ctor: '::', _0: _p5._0, _1: acc};
			}),
		{ctor: '[]'}),
	_elm_lang$core$Json_Decode$keyValuePairs(
		_elm_lang$core$Json_Decode$succeed(
			{ctor: '_Tuple0'})));
var _elm_community$json_extra$Json_Decode_Extra$sequenceHelp = F2(
	function (decoders, jsonValues) {
		return (!_elm_lang$core$Native_Utils.eq(
			_elm_lang$core$List$length(jsonValues),
			_elm_lang$core$List$length(decoders))) ? _elm_lang$core$Json_Decode$fail('Number of decoders does not match number of values') : _elm_community$json_extra$Json_Decode_Extra$fromResult(
			A3(
				_elm_lang$core$List$foldr,
				_elm_lang$core$Result$map2(
					F2(
						function (x, y) {
							return {ctor: '::', _0: x, _1: y};
						})),
				_elm_lang$core$Result$Ok(
					{ctor: '[]'}),
				A3(_elm_lang$core$List$map2, _elm_lang$core$Json_Decode$decodeValue, decoders, jsonValues)));
	});
var _elm_community$json_extra$Json_Decode_Extra$sequence = function (decoders) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		_elm_community$json_extra$Json_Decode_Extra$sequenceHelp(decoders),
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value));
};
var _elm_community$json_extra$Json_Decode_Extra$indexedList = function (indexedDecoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (values) {
			return _elm_community$json_extra$Json_Decode_Extra$sequence(
				A2(
					_elm_lang$core$List$map,
					indexedDecoder,
					A2(
						_elm_lang$core$List$range,
						0,
						_elm_lang$core$List$length(values) - 1)));
		},
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value));
};
var _elm_community$json_extra$Json_Decode_Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _p6 = A2(
				_elm_lang$core$Json_Decode$decodeValue,
				A2(_elm_lang$core$Json_Decode$field, fieldName, _elm_lang$core$Json_Decode$value),
				json);
			if (_p6.ctor === 'Ok') {
				return A2(
					_elm_lang$core$Json_Decode$map,
					_elm_lang$core$Maybe$Just,
					A2(_elm_lang$core$Json_Decode$field, fieldName, decoder));
			} else {
				return _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Maybe$Nothing);
			}
		};
		return A2(_elm_lang$core$Json_Decode$andThen, finishDecoding, _elm_lang$core$Json_Decode$value);
	});
var _elm_community$json_extra$Json_Decode_Extra$withDefault = F2(
	function (fallback, decoder) {
		return A2(
			_elm_lang$core$Json_Decode$map,
			_elm_lang$core$Maybe$withDefault(fallback),
			_elm_lang$core$Json_Decode$maybe(decoder));
	});
var _elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples = F2(
	function (keyDecoder, tuples) {
		var _p7 = tuples;
		if (_p7.ctor === '[]') {
			return _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Dict$empty);
		} else {
			var _p8 = A2(_elm_lang$core$Json_Decode$decodeString, keyDecoder, _p7._0._0);
			if (_p8.ctor === 'Ok') {
				return A2(
					_elm_lang$core$Json_Decode$andThen,
					function (_p9) {
						return _elm_lang$core$Json_Decode$succeed(
							A3(_elm_lang$core$Dict$insert, _p8._0, _p7._0._1, _p9));
					},
					A2(_elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples, keyDecoder, _p7._1));
			} else {
				return _elm_lang$core$Json_Decode$fail(_p8._0);
			}
		}
	});
var _elm_community$json_extra$Json_Decode_Extra$dict2 = F2(
	function (keyDecoder, valueDecoder) {
		return A2(
			_elm_lang$core$Json_Decode$andThen,
			_elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples(keyDecoder),
			_elm_lang$core$Json_Decode$keyValuePairs(valueDecoder));
	});
var _elm_community$json_extra$Json_Decode_Extra$set = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Set$fromList,
		_elm_lang$core$Json_Decode$list(decoder));
};
var _elm_community$json_extra$Json_Decode_Extra$date = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p10) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$Date$fromString(_p10));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$andMap = _elm_lang$core$Json_Decode$map2(
	F2(
		function (x, y) {
			return y(x);
		}));
var _elm_community$json_extra$Json_Decode_Extra_ops = _elm_community$json_extra$Json_Decode_Extra_ops || {};
_elm_community$json_extra$Json_Decode_Extra_ops['|:'] = _elm_lang$core$Basics$flip(_elm_community$json_extra$Json_Decode_Extra$andMap);

var _elm_community$json_extra$Json_Encode_Extra$dict = F3(
	function (toKey, toValue, dict) {
		return _elm_lang$core$Json_Encode$object(
			A2(
				_elm_lang$core$List$map,
				function (_p0) {
					var _p1 = _p0;
					return {
						ctor: '_Tuple2',
						_0: toKey(_p1._0),
						_1: toValue(_p1._1)
					};
				},
				_elm_lang$core$Dict$toList(dict)));
	});
var _elm_community$json_extra$Json_Encode_Extra$maybe = function (encoder) {
	return function (_p2) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			_elm_lang$core$Json_Encode$null,
			A2(_elm_lang$core$Maybe$map, encoder, _p2));
	};
};

var _elm_lang$core$Color$fmod = F2(
	function (f, n) {
		var integer = _elm_lang$core$Basics$floor(f);
		return (_elm_lang$core$Basics$toFloat(
			A2(_elm_lang$core$Basics_ops['%'], integer, n)) + f) - _elm_lang$core$Basics$toFloat(integer);
	});
var _elm_lang$core$Color$rgbToHsl = F3(
	function (red, green, blue) {
		var b = _elm_lang$core$Basics$toFloat(blue) / 255;
		var g = _elm_lang$core$Basics$toFloat(green) / 255;
		var r = _elm_lang$core$Basics$toFloat(red) / 255;
		var cMax = A2(
			_elm_lang$core$Basics$max,
			A2(_elm_lang$core$Basics$max, r, g),
			b);
		var cMin = A2(
			_elm_lang$core$Basics$min,
			A2(_elm_lang$core$Basics$min, r, g),
			b);
		var c = cMax - cMin;
		var lightness = (cMax + cMin) / 2;
		var saturation = _elm_lang$core$Native_Utils.eq(lightness, 0) ? 0 : (c / (1 - _elm_lang$core$Basics$abs((2 * lightness) - 1)));
		var hue = _elm_lang$core$Basics$degrees(60) * (_elm_lang$core$Native_Utils.eq(cMax, r) ? A2(_elm_lang$core$Color$fmod, (g - b) / c, 6) : (_elm_lang$core$Native_Utils.eq(cMax, g) ? (((b - r) / c) + 2) : (((r - g) / c) + 4)));
		return {ctor: '_Tuple3', _0: hue, _1: saturation, _2: lightness};
	});
var _elm_lang$core$Color$hslToRgb = F3(
	function (hue, saturation, lightness) {
		var normHue = hue / _elm_lang$core$Basics$degrees(60);
		var chroma = (1 - _elm_lang$core$Basics$abs((2 * lightness) - 1)) * saturation;
		var x = chroma * (1 - _elm_lang$core$Basics$abs(
			A2(_elm_lang$core$Color$fmod, normHue, 2) - 1));
		var _p0 = (_elm_lang$core$Native_Utils.cmp(normHue, 0) < 0) ? {ctor: '_Tuple3', _0: 0, _1: 0, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 1) < 0) ? {ctor: '_Tuple3', _0: chroma, _1: x, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 2) < 0) ? {ctor: '_Tuple3', _0: x, _1: chroma, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 3) < 0) ? {ctor: '_Tuple3', _0: 0, _1: chroma, _2: x} : ((_elm_lang$core$Native_Utils.cmp(normHue, 4) < 0) ? {ctor: '_Tuple3', _0: 0, _1: x, _2: chroma} : ((_elm_lang$core$Native_Utils.cmp(normHue, 5) < 0) ? {ctor: '_Tuple3', _0: x, _1: 0, _2: chroma} : ((_elm_lang$core$Native_Utils.cmp(normHue, 6) < 0) ? {ctor: '_Tuple3', _0: chroma, _1: 0, _2: x} : {ctor: '_Tuple3', _0: 0, _1: 0, _2: 0}))))));
		var r = _p0._0;
		var g = _p0._1;
		var b = _p0._2;
		var m = lightness - (chroma / 2);
		return {ctor: '_Tuple3', _0: r + m, _1: g + m, _2: b + m};
	});
var _elm_lang$core$Color$toRgb = function (color) {
	var _p1 = color;
	if (_p1.ctor === 'RGBA') {
		return {red: _p1._0, green: _p1._1, blue: _p1._2, alpha: _p1._3};
	} else {
		var _p2 = A3(_elm_lang$core$Color$hslToRgb, _p1._0, _p1._1, _p1._2);
		var r = _p2._0;
		var g = _p2._1;
		var b = _p2._2;
		return {
			red: _elm_lang$core$Basics$round(255 * r),
			green: _elm_lang$core$Basics$round(255 * g),
			blue: _elm_lang$core$Basics$round(255 * b),
			alpha: _p1._3
		};
	}
};
var _elm_lang$core$Color$toHsl = function (color) {
	var _p3 = color;
	if (_p3.ctor === 'HSLA') {
		return {hue: _p3._0, saturation: _p3._1, lightness: _p3._2, alpha: _p3._3};
	} else {
		var _p4 = A3(_elm_lang$core$Color$rgbToHsl, _p3._0, _p3._1, _p3._2);
		var h = _p4._0;
		var s = _p4._1;
		var l = _p4._2;
		return {hue: h, saturation: s, lightness: l, alpha: _p3._3};
	}
};
var _elm_lang$core$Color$HSLA = F4(
	function (a, b, c, d) {
		return {ctor: 'HSLA', _0: a, _1: b, _2: c, _3: d};
	});
var _elm_lang$core$Color$hsla = F4(
	function (hue, saturation, lightness, alpha) {
		return A4(
			_elm_lang$core$Color$HSLA,
			hue - _elm_lang$core$Basics$turns(
				_elm_lang$core$Basics$toFloat(
					_elm_lang$core$Basics$floor(hue / (2 * _elm_lang$core$Basics$pi)))),
			saturation,
			lightness,
			alpha);
	});
var _elm_lang$core$Color$hsl = F3(
	function (hue, saturation, lightness) {
		return A4(_elm_lang$core$Color$hsla, hue, saturation, lightness, 1);
	});
var _elm_lang$core$Color$complement = function (color) {
	var _p5 = color;
	if (_p5.ctor === 'HSLA') {
		return A4(
			_elm_lang$core$Color$hsla,
			_p5._0 + _elm_lang$core$Basics$degrees(180),
			_p5._1,
			_p5._2,
			_p5._3);
	} else {
		var _p6 = A3(_elm_lang$core$Color$rgbToHsl, _p5._0, _p5._1, _p5._2);
		var h = _p6._0;
		var s = _p6._1;
		var l = _p6._2;
		return A4(
			_elm_lang$core$Color$hsla,
			h + _elm_lang$core$Basics$degrees(180),
			s,
			l,
			_p5._3);
	}
};
var _elm_lang$core$Color$grayscale = function (p) {
	return A4(_elm_lang$core$Color$HSLA, 0, 0, 1 - p, 1);
};
var _elm_lang$core$Color$greyscale = function (p) {
	return A4(_elm_lang$core$Color$HSLA, 0, 0, 1 - p, 1);
};
var _elm_lang$core$Color$RGBA = F4(
	function (a, b, c, d) {
		return {ctor: 'RGBA', _0: a, _1: b, _2: c, _3: d};
	});
var _elm_lang$core$Color$rgba = _elm_lang$core$Color$RGBA;
var _elm_lang$core$Color$rgb = F3(
	function (r, g, b) {
		return A4(_elm_lang$core$Color$RGBA, r, g, b, 1);
	});
var _elm_lang$core$Color$lightRed = A4(_elm_lang$core$Color$RGBA, 239, 41, 41, 1);
var _elm_lang$core$Color$red = A4(_elm_lang$core$Color$RGBA, 204, 0, 0, 1);
var _elm_lang$core$Color$darkRed = A4(_elm_lang$core$Color$RGBA, 164, 0, 0, 1);
var _elm_lang$core$Color$lightOrange = A4(_elm_lang$core$Color$RGBA, 252, 175, 62, 1);
var _elm_lang$core$Color$orange = A4(_elm_lang$core$Color$RGBA, 245, 121, 0, 1);
var _elm_lang$core$Color$darkOrange = A4(_elm_lang$core$Color$RGBA, 206, 92, 0, 1);
var _elm_lang$core$Color$lightYellow = A4(_elm_lang$core$Color$RGBA, 255, 233, 79, 1);
var _elm_lang$core$Color$yellow = A4(_elm_lang$core$Color$RGBA, 237, 212, 0, 1);
var _elm_lang$core$Color$darkYellow = A4(_elm_lang$core$Color$RGBA, 196, 160, 0, 1);
var _elm_lang$core$Color$lightGreen = A4(_elm_lang$core$Color$RGBA, 138, 226, 52, 1);
var _elm_lang$core$Color$green = A4(_elm_lang$core$Color$RGBA, 115, 210, 22, 1);
var _elm_lang$core$Color$darkGreen = A4(_elm_lang$core$Color$RGBA, 78, 154, 6, 1);
var _elm_lang$core$Color$lightBlue = A4(_elm_lang$core$Color$RGBA, 114, 159, 207, 1);
var _elm_lang$core$Color$blue = A4(_elm_lang$core$Color$RGBA, 52, 101, 164, 1);
var _elm_lang$core$Color$darkBlue = A4(_elm_lang$core$Color$RGBA, 32, 74, 135, 1);
var _elm_lang$core$Color$lightPurple = A4(_elm_lang$core$Color$RGBA, 173, 127, 168, 1);
var _elm_lang$core$Color$purple = A4(_elm_lang$core$Color$RGBA, 117, 80, 123, 1);
var _elm_lang$core$Color$darkPurple = A4(_elm_lang$core$Color$RGBA, 92, 53, 102, 1);
var _elm_lang$core$Color$lightBrown = A4(_elm_lang$core$Color$RGBA, 233, 185, 110, 1);
var _elm_lang$core$Color$brown = A4(_elm_lang$core$Color$RGBA, 193, 125, 17, 1);
var _elm_lang$core$Color$darkBrown = A4(_elm_lang$core$Color$RGBA, 143, 89, 2, 1);
var _elm_lang$core$Color$black = A4(_elm_lang$core$Color$RGBA, 0, 0, 0, 1);
var _elm_lang$core$Color$white = A4(_elm_lang$core$Color$RGBA, 255, 255, 255, 1);
var _elm_lang$core$Color$lightGrey = A4(_elm_lang$core$Color$RGBA, 238, 238, 236, 1);
var _elm_lang$core$Color$grey = A4(_elm_lang$core$Color$RGBA, 211, 215, 207, 1);
var _elm_lang$core$Color$darkGrey = A4(_elm_lang$core$Color$RGBA, 186, 189, 182, 1);
var _elm_lang$core$Color$lightGray = A4(_elm_lang$core$Color$RGBA, 238, 238, 236, 1);
var _elm_lang$core$Color$gray = A4(_elm_lang$core$Color$RGBA, 211, 215, 207, 1);
var _elm_lang$core$Color$darkGray = A4(_elm_lang$core$Color$RGBA, 186, 189, 182, 1);
var _elm_lang$core$Color$lightCharcoal = A4(_elm_lang$core$Color$RGBA, 136, 138, 133, 1);
var _elm_lang$core$Color$charcoal = A4(_elm_lang$core$Color$RGBA, 85, 87, 83, 1);
var _elm_lang$core$Color$darkCharcoal = A4(_elm_lang$core$Color$RGBA, 46, 52, 54, 1);
var _elm_lang$core$Color$Radial = F5(
	function (a, b, c, d, e) {
		return {ctor: 'Radial', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _elm_lang$core$Color$radial = _elm_lang$core$Color$Radial;
var _elm_lang$core$Color$Linear = F3(
	function (a, b, c) {
		return {ctor: 'Linear', _0: a, _1: b, _2: c};
	});
var _elm_lang$core$Color$linear = _elm_lang$core$Color$Linear;

var _elm_lang$core$Random$onSelfMsg = F3(
	function (_p1, _p0, seed) {
		return _elm_lang$core$Task$succeed(seed);
	});
var _elm_lang$core$Random$magicNum8 = 2147483562;
var _elm_lang$core$Random$range = function (_p2) {
	return {ctor: '_Tuple2', _0: 0, _1: _elm_lang$core$Random$magicNum8};
};
var _elm_lang$core$Random$magicNum7 = 2147483399;
var _elm_lang$core$Random$magicNum6 = 2147483563;
var _elm_lang$core$Random$magicNum5 = 3791;
var _elm_lang$core$Random$magicNum4 = 40692;
var _elm_lang$core$Random$magicNum3 = 52774;
var _elm_lang$core$Random$magicNum2 = 12211;
var _elm_lang$core$Random$magicNum1 = 53668;
var _elm_lang$core$Random$magicNum0 = 40014;
var _elm_lang$core$Random$step = F2(
	function (_p3, seed) {
		var _p4 = _p3;
		return _p4._0(seed);
	});
var _elm_lang$core$Random$onEffects = F3(
	function (router, commands, seed) {
		var _p5 = commands;
		if (_p5.ctor === '[]') {
			return _elm_lang$core$Task$succeed(seed);
		} else {
			var _p6 = A2(_elm_lang$core$Random$step, _p5._0._0, seed);
			var value = _p6._0;
			var newSeed = _p6._1;
			return A2(
				_elm_lang$core$Task$andThen,
				function (_p7) {
					return A3(_elm_lang$core$Random$onEffects, router, _p5._1, newSeed);
				},
				A2(_elm_lang$core$Platform$sendToApp, router, value));
		}
	});
var _elm_lang$core$Random$listHelp = F4(
	function (list, n, generate, seed) {
		listHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 1) < 0) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$List$reverse(list),
					_1: seed
				};
			} else {
				var _p8 = generate(seed);
				var value = _p8._0;
				var newSeed = _p8._1;
				var _v2 = {ctor: '::', _0: value, _1: list},
					_v3 = n - 1,
					_v4 = generate,
					_v5 = newSeed;
				list = _v2;
				n = _v3;
				generate = _v4;
				seed = _v5;
				continue listHelp;
			}
		}
	});
var _elm_lang$core$Random$minInt = -2147483648;
var _elm_lang$core$Random$maxInt = 2147483647;
var _elm_lang$core$Random$iLogBase = F2(
	function (b, i) {
		return (_elm_lang$core$Native_Utils.cmp(i, b) < 0) ? 1 : (1 + A2(_elm_lang$core$Random$iLogBase, b, (i / b) | 0));
	});
var _elm_lang$core$Random$command = _elm_lang$core$Native_Platform.leaf('Random');
var _elm_lang$core$Random$Generator = function (a) {
	return {ctor: 'Generator', _0: a};
};
var _elm_lang$core$Random$list = F2(
	function (n, _p9) {
		var _p10 = _p9;
		return _elm_lang$core$Random$Generator(
			function (seed) {
				return A4(
					_elm_lang$core$Random$listHelp,
					{ctor: '[]'},
					n,
					_p10._0,
					seed);
			});
	});
var _elm_lang$core$Random$map = F2(
	function (func, _p11) {
		var _p12 = _p11;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p13 = _p12._0(seed0);
				var a = _p13._0;
				var seed1 = _p13._1;
				return {
					ctor: '_Tuple2',
					_0: func(a),
					_1: seed1
				};
			});
	});
var _elm_lang$core$Random$map2 = F3(
	function (func, _p15, _p14) {
		var _p16 = _p15;
		var _p17 = _p14;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p18 = _p16._0(seed0);
				var a = _p18._0;
				var seed1 = _p18._1;
				var _p19 = _p17._0(seed1);
				var b = _p19._0;
				var seed2 = _p19._1;
				return {
					ctor: '_Tuple2',
					_0: A2(func, a, b),
					_1: seed2
				};
			});
	});
var _elm_lang$core$Random$pair = F2(
	function (genA, genB) {
		return A3(
			_elm_lang$core$Random$map2,
			F2(
				function (v0, v1) {
					return {ctor: '_Tuple2', _0: v0, _1: v1};
				}),
			genA,
			genB);
	});
var _elm_lang$core$Random$map3 = F4(
	function (func, _p22, _p21, _p20) {
		var _p23 = _p22;
		var _p24 = _p21;
		var _p25 = _p20;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p26 = _p23._0(seed0);
				var a = _p26._0;
				var seed1 = _p26._1;
				var _p27 = _p24._0(seed1);
				var b = _p27._0;
				var seed2 = _p27._1;
				var _p28 = _p25._0(seed2);
				var c = _p28._0;
				var seed3 = _p28._1;
				return {
					ctor: '_Tuple2',
					_0: A3(func, a, b, c),
					_1: seed3
				};
			});
	});
var _elm_lang$core$Random$map4 = F5(
	function (func, _p32, _p31, _p30, _p29) {
		var _p33 = _p32;
		var _p34 = _p31;
		var _p35 = _p30;
		var _p36 = _p29;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p37 = _p33._0(seed0);
				var a = _p37._0;
				var seed1 = _p37._1;
				var _p38 = _p34._0(seed1);
				var b = _p38._0;
				var seed2 = _p38._1;
				var _p39 = _p35._0(seed2);
				var c = _p39._0;
				var seed3 = _p39._1;
				var _p40 = _p36._0(seed3);
				var d = _p40._0;
				var seed4 = _p40._1;
				return {
					ctor: '_Tuple2',
					_0: A4(func, a, b, c, d),
					_1: seed4
				};
			});
	});
var _elm_lang$core$Random$map5 = F6(
	function (func, _p45, _p44, _p43, _p42, _p41) {
		var _p46 = _p45;
		var _p47 = _p44;
		var _p48 = _p43;
		var _p49 = _p42;
		var _p50 = _p41;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p51 = _p46._0(seed0);
				var a = _p51._0;
				var seed1 = _p51._1;
				var _p52 = _p47._0(seed1);
				var b = _p52._0;
				var seed2 = _p52._1;
				var _p53 = _p48._0(seed2);
				var c = _p53._0;
				var seed3 = _p53._1;
				var _p54 = _p49._0(seed3);
				var d = _p54._0;
				var seed4 = _p54._1;
				var _p55 = _p50._0(seed4);
				var e = _p55._0;
				var seed5 = _p55._1;
				return {
					ctor: '_Tuple2',
					_0: A5(func, a, b, c, d, e),
					_1: seed5
				};
			});
	});
var _elm_lang$core$Random$andThen = F2(
	function (callback, _p56) {
		var _p57 = _p56;
		return _elm_lang$core$Random$Generator(
			function (seed) {
				var _p58 = _p57._0(seed);
				var result = _p58._0;
				var newSeed = _p58._1;
				var _p59 = callback(result);
				var genB = _p59._0;
				return genB(newSeed);
			});
	});
var _elm_lang$core$Random$State = F2(
	function (a, b) {
		return {ctor: 'State', _0: a, _1: b};
	});
var _elm_lang$core$Random$initState = function (seed) {
	var s = A2(_elm_lang$core$Basics$max, seed, 0 - seed);
	var q = (s / (_elm_lang$core$Random$magicNum6 - 1)) | 0;
	var s2 = A2(_elm_lang$core$Basics_ops['%'], q, _elm_lang$core$Random$magicNum7 - 1);
	var s1 = A2(_elm_lang$core$Basics_ops['%'], s, _elm_lang$core$Random$magicNum6 - 1);
	return A2(_elm_lang$core$Random$State, s1 + 1, s2 + 1);
};
var _elm_lang$core$Random$next = function (_p60) {
	var _p61 = _p60;
	var _p63 = _p61._1;
	var _p62 = _p61._0;
	var k2 = (_p63 / _elm_lang$core$Random$magicNum3) | 0;
	var rawState2 = (_elm_lang$core$Random$magicNum4 * (_p63 - (k2 * _elm_lang$core$Random$magicNum3))) - (k2 * _elm_lang$core$Random$magicNum5);
	var newState2 = (_elm_lang$core$Native_Utils.cmp(rawState2, 0) < 0) ? (rawState2 + _elm_lang$core$Random$magicNum7) : rawState2;
	var k1 = (_p62 / _elm_lang$core$Random$magicNum1) | 0;
	var rawState1 = (_elm_lang$core$Random$magicNum0 * (_p62 - (k1 * _elm_lang$core$Random$magicNum1))) - (k1 * _elm_lang$core$Random$magicNum2);
	var newState1 = (_elm_lang$core$Native_Utils.cmp(rawState1, 0) < 0) ? (rawState1 + _elm_lang$core$Random$magicNum6) : rawState1;
	var z = newState1 - newState2;
	var newZ = (_elm_lang$core$Native_Utils.cmp(z, 1) < 0) ? (z + _elm_lang$core$Random$magicNum8) : z;
	return {
		ctor: '_Tuple2',
		_0: newZ,
		_1: A2(_elm_lang$core$Random$State, newState1, newState2)
	};
};
var _elm_lang$core$Random$split = function (_p64) {
	var _p65 = _p64;
	var _p68 = _p65._1;
	var _p67 = _p65._0;
	var _p66 = _elm_lang$core$Tuple$second(
		_elm_lang$core$Random$next(_p65));
	var t1 = _p66._0;
	var t2 = _p66._1;
	var new_s2 = _elm_lang$core$Native_Utils.eq(_p68, 1) ? (_elm_lang$core$Random$magicNum7 - 1) : (_p68 - 1);
	var new_s1 = _elm_lang$core$Native_Utils.eq(_p67, _elm_lang$core$Random$magicNum6 - 1) ? 1 : (_p67 + 1);
	return {
		ctor: '_Tuple2',
		_0: A2(_elm_lang$core$Random$State, new_s1, t2),
		_1: A2(_elm_lang$core$Random$State, t1, new_s2)
	};
};
var _elm_lang$core$Random$Seed = function (a) {
	return {ctor: 'Seed', _0: a};
};
var _elm_lang$core$Random$int = F2(
	function (a, b) {
		return _elm_lang$core$Random$Generator(
			function (_p69) {
				var _p70 = _p69;
				var _p75 = _p70._0;
				var base = 2147483561;
				var f = F3(
					function (n, acc, state) {
						f:
						while (true) {
							var _p71 = n;
							if (_p71 === 0) {
								return {ctor: '_Tuple2', _0: acc, _1: state};
							} else {
								var _p72 = _p75.next(state);
								var x = _p72._0;
								var nextState = _p72._1;
								var _v27 = n - 1,
									_v28 = x + (acc * base),
									_v29 = nextState;
								n = _v27;
								acc = _v28;
								state = _v29;
								continue f;
							}
						}
					});
				var _p73 = (_elm_lang$core$Native_Utils.cmp(a, b) < 0) ? {ctor: '_Tuple2', _0: a, _1: b} : {ctor: '_Tuple2', _0: b, _1: a};
				var lo = _p73._0;
				var hi = _p73._1;
				var k = (hi - lo) + 1;
				var n = A2(_elm_lang$core$Random$iLogBase, base, k);
				var _p74 = A3(f, n, 1, _p75.state);
				var v = _p74._0;
				var nextState = _p74._1;
				return {
					ctor: '_Tuple2',
					_0: lo + A2(_elm_lang$core$Basics_ops['%'], v, k),
					_1: _elm_lang$core$Random$Seed(
						_elm_lang$core$Native_Utils.update(
							_p75,
							{state: nextState}))
				};
			});
	});
var _elm_lang$core$Random$bool = A2(
	_elm_lang$core$Random$map,
	F2(
		function (x, y) {
			return _elm_lang$core$Native_Utils.eq(x, y);
		})(1),
	A2(_elm_lang$core$Random$int, 0, 1));
var _elm_lang$core$Random$float = F2(
	function (a, b) {
		return _elm_lang$core$Random$Generator(
			function (seed) {
				var _p76 = A2(
					_elm_lang$core$Random$step,
					A2(_elm_lang$core$Random$int, _elm_lang$core$Random$minInt, _elm_lang$core$Random$maxInt),
					seed);
				var number = _p76._0;
				var newSeed = _p76._1;
				var negativeOneToOne = _elm_lang$core$Basics$toFloat(number) / _elm_lang$core$Basics$toFloat(_elm_lang$core$Random$maxInt - _elm_lang$core$Random$minInt);
				var _p77 = (_elm_lang$core$Native_Utils.cmp(a, b) < 0) ? {ctor: '_Tuple2', _0: a, _1: b} : {ctor: '_Tuple2', _0: b, _1: a};
				var lo = _p77._0;
				var hi = _p77._1;
				var scaled = ((lo + hi) / 2) + ((hi - lo) * negativeOneToOne);
				return {ctor: '_Tuple2', _0: scaled, _1: newSeed};
			});
	});
var _elm_lang$core$Random$initialSeed = function (n) {
	return _elm_lang$core$Random$Seed(
		{
			state: _elm_lang$core$Random$initState(n),
			next: _elm_lang$core$Random$next,
			split: _elm_lang$core$Random$split,
			range: _elm_lang$core$Random$range
		});
};
var _elm_lang$core$Random$init = A2(
	_elm_lang$core$Task$andThen,
	function (t) {
		return _elm_lang$core$Task$succeed(
			_elm_lang$core$Random$initialSeed(
				_elm_lang$core$Basics$round(t)));
	},
	_elm_lang$core$Time$now);
var _elm_lang$core$Random$Generate = function (a) {
	return {ctor: 'Generate', _0: a};
};
var _elm_lang$core$Random$generate = F2(
	function (tagger, generator) {
		return _elm_lang$core$Random$command(
			_elm_lang$core$Random$Generate(
				A2(_elm_lang$core$Random$map, tagger, generator)));
	});
var _elm_lang$core$Random$cmdMap = F2(
	function (func, _p78) {
		var _p79 = _p78;
		return _elm_lang$core$Random$Generate(
			A2(_elm_lang$core$Random$map, func, _p79._0));
	});
_elm_lang$core$Native_Platform.effectManagers['Random'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Random$init, onEffects: _elm_lang$core$Random$onEffects, onSelfMsg: _elm_lang$core$Random$onSelfMsg, tag: 'cmd', cmdMap: _elm_lang$core$Random$cmdMap};

var _elm_lang$dom$Native_Dom = function() {

var fakeNode = {
	addEventListener: function() {},
	removeEventListener: function() {}
};

var onDocument = on(typeof document !== 'undefined' ? document : fakeNode);
var onWindow = on(typeof window !== 'undefined' ? window : fakeNode);

function on(node)
{
	return function(eventName, decoder, toTask)
	{
		return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {

			function performTask(event)
			{
				var result = A2(_elm_lang$core$Json_Decode$decodeValue, decoder, event);
				if (result.ctor === 'Ok')
				{
					_elm_lang$core$Native_Scheduler.rawSpawn(toTask(result._0));
				}
			}

			node.addEventListener(eventName, performTask);

			return function()
			{
				node.removeEventListener(eventName, performTask);
			};
		});
	};
}

var rAF = typeof requestAnimationFrame !== 'undefined'
	? requestAnimationFrame
	: function(callback) { callback(); };

function withNode(id, doStuff)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		rAF(function()
		{
			var node = document.getElementById(id);
			if (node === null)
			{
				callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'NotFound', _0: id }));
				return;
			}
			callback(_elm_lang$core$Native_Scheduler.succeed(doStuff(node)));
		});
	});
}


// FOCUS

function focus(id)
{
	return withNode(id, function(node) {
		node.focus();
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function blur(id)
{
	return withNode(id, function(node) {
		node.blur();
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}


// SCROLLING

function getScrollTop(id)
{
	return withNode(id, function(node) {
		return node.scrollTop;
	});
}

function setScrollTop(id, desiredScrollTop)
{
	return withNode(id, function(node) {
		node.scrollTop = desiredScrollTop;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function toBottom(id)
{
	return withNode(id, function(node) {
		node.scrollTop = node.scrollHeight;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function getScrollLeft(id)
{
	return withNode(id, function(node) {
		return node.scrollLeft;
	});
}

function setScrollLeft(id, desiredScrollLeft)
{
	return withNode(id, function(node) {
		node.scrollLeft = desiredScrollLeft;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function toRight(id)
{
	return withNode(id, function(node) {
		node.scrollLeft = node.scrollWidth;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}


// SIZE

function width(options, id)
{
	return withNode(id, function(node) {
		switch (options.ctor)
		{
			case 'Content':
				return node.scrollWidth;
			case 'VisibleContent':
				return node.clientWidth;
			case 'VisibleContentWithBorders':
				return node.offsetWidth;
			case 'VisibleContentWithBordersAndMargins':
				var rect = node.getBoundingClientRect();
				return rect.right - rect.left;
		}
	});
}

function height(options, id)
{
	return withNode(id, function(node) {
		switch (options.ctor)
		{
			case 'Content':
				return node.scrollHeight;
			case 'VisibleContent':
				return node.clientHeight;
			case 'VisibleContentWithBorders':
				return node.offsetHeight;
			case 'VisibleContentWithBordersAndMargins':
				var rect = node.getBoundingClientRect();
				return rect.bottom - rect.top;
		}
	});
}

return {
	onDocument: F3(onDocument),
	onWindow: F3(onWindow),

	focus: focus,
	blur: blur,

	getScrollTop: getScrollTop,
	setScrollTop: F2(setScrollTop),
	getScrollLeft: getScrollLeft,
	setScrollLeft: F2(setScrollLeft),
	toBottom: toBottom,
	toRight: toRight,

	height: F2(height),
	width: F2(width)
};

}();

var _elm_lang$dom$Dom_LowLevel$onWindow = _elm_lang$dom$Native_Dom.onWindow;
var _elm_lang$dom$Dom_LowLevel$onDocument = _elm_lang$dom$Native_Dom.onDocument;

var _elm_lang$html$Html_Lazy$lazy3 = _elm_lang$virtual_dom$VirtualDom$lazy3;
var _elm_lang$html$Html_Lazy$lazy2 = _elm_lang$virtual_dom$VirtualDom$lazy2;
var _elm_lang$html$Html_Lazy$lazy = _elm_lang$virtual_dom$VirtualDom$lazy;

var _elm_lang$navigation$Native_Navigation = function() {


// FAKE NAVIGATION

function go(n)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		if (n !== 0)
		{
			history.go(n);
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function pushState(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		history.pushState({}, '', url);
		callback(_elm_lang$core$Native_Scheduler.succeed(getLocation()));
	});
}

function replaceState(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		history.replaceState({}, '', url);
		callback(_elm_lang$core$Native_Scheduler.succeed(getLocation()));
	});
}


// REAL NAVIGATION

function reloadPage(skipCache)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		document.location.reload(skipCache);
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function setLocation(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		try
		{
			window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			document.location.reload(false);
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}


// GET LOCATION

function getLocation()
{
	var location = document.location;

	return {
		href: location.href,
		host: location.host,
		hostname: location.hostname,
		protocol: location.protocol,
		origin: location.origin,
		port_: location.port,
		pathname: location.pathname,
		search: location.search,
		hash: location.hash,
		username: location.username,
		password: location.password
	};
}


// DETECT IE11 PROBLEMS

function isInternetExplorer11()
{
	return window.navigator.userAgent.indexOf('Trident') !== -1;
}


return {
	go: go,
	setLocation: setLocation,
	reloadPage: reloadPage,
	pushState: pushState,
	replaceState: replaceState,
	getLocation: getLocation,
	isInternetExplorer11: isInternetExplorer11
};

}();

var _elm_lang$navigation$Navigation$replaceState = _elm_lang$navigation$Native_Navigation.replaceState;
var _elm_lang$navigation$Navigation$pushState = _elm_lang$navigation$Native_Navigation.pushState;
var _elm_lang$navigation$Navigation$go = _elm_lang$navigation$Native_Navigation.go;
var _elm_lang$navigation$Navigation$reloadPage = _elm_lang$navigation$Native_Navigation.reloadPage;
var _elm_lang$navigation$Navigation$setLocation = _elm_lang$navigation$Native_Navigation.setLocation;
var _elm_lang$navigation$Navigation_ops = _elm_lang$navigation$Navigation_ops || {};
_elm_lang$navigation$Navigation_ops['&>'] = F2(
	function (task1, task2) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (_p0) {
				return task2;
			},
			task1);
	});
var _elm_lang$navigation$Navigation$notify = F3(
	function (router, subs, location) {
		var send = function (_p1) {
			var _p2 = _p1;
			return A2(
				_elm_lang$core$Platform$sendToApp,
				router,
				_p2._0(location));
		};
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Task$sequence(
				A2(_elm_lang$core$List$map, send, subs)),
			_elm_lang$core$Task$succeed(
				{ctor: '_Tuple0'}));
	});
var _elm_lang$navigation$Navigation$cmdHelp = F3(
	function (router, subs, cmd) {
		var _p3 = cmd;
		switch (_p3.ctor) {
			case 'Jump':
				return _elm_lang$navigation$Navigation$go(_p3._0);
			case 'New':
				return A2(
					_elm_lang$core$Task$andThen,
					A2(_elm_lang$navigation$Navigation$notify, router, subs),
					_elm_lang$navigation$Navigation$pushState(_p3._0));
			case 'Modify':
				return A2(
					_elm_lang$core$Task$andThen,
					A2(_elm_lang$navigation$Navigation$notify, router, subs),
					_elm_lang$navigation$Navigation$replaceState(_p3._0));
			case 'Visit':
				return _elm_lang$navigation$Navigation$setLocation(_p3._0);
			default:
				return _elm_lang$navigation$Navigation$reloadPage(_p3._0);
		}
	});
var _elm_lang$navigation$Navigation$killPopWatcher = function (popWatcher) {
	var _p4 = popWatcher;
	if (_p4.ctor === 'Normal') {
		return _elm_lang$core$Process$kill(_p4._0);
	} else {
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Process$kill(_p4._0),
			_elm_lang$core$Process$kill(_p4._1));
	}
};
var _elm_lang$navigation$Navigation$onSelfMsg = F3(
	function (router, location, state) {
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			A3(_elm_lang$navigation$Navigation$notify, router, state.subs, location),
			_elm_lang$core$Task$succeed(state));
	});
var _elm_lang$navigation$Navigation$subscription = _elm_lang$core$Native_Platform.leaf('Navigation');
var _elm_lang$navigation$Navigation$command = _elm_lang$core$Native_Platform.leaf('Navigation');
var _elm_lang$navigation$Navigation$Location = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return {href: a, host: b, hostname: c, protocol: d, origin: e, port_: f, pathname: g, search: h, hash: i, username: j, password: k};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _elm_lang$navigation$Navigation$State = F2(
	function (a, b) {
		return {subs: a, popWatcher: b};
	});
var _elm_lang$navigation$Navigation$init = _elm_lang$core$Task$succeed(
	A2(
		_elm_lang$navigation$Navigation$State,
		{ctor: '[]'},
		_elm_lang$core$Maybe$Nothing));
var _elm_lang$navigation$Navigation$Reload = function (a) {
	return {ctor: 'Reload', _0: a};
};
var _elm_lang$navigation$Navigation$reload = _elm_lang$navigation$Navigation$command(
	_elm_lang$navigation$Navigation$Reload(false));
var _elm_lang$navigation$Navigation$reloadAndSkipCache = _elm_lang$navigation$Navigation$command(
	_elm_lang$navigation$Navigation$Reload(true));
var _elm_lang$navigation$Navigation$Visit = function (a) {
	return {ctor: 'Visit', _0: a};
};
var _elm_lang$navigation$Navigation$load = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Visit(url));
};
var _elm_lang$navigation$Navigation$Modify = function (a) {
	return {ctor: 'Modify', _0: a};
};
var _elm_lang$navigation$Navigation$modifyUrl = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Modify(url));
};
var _elm_lang$navigation$Navigation$New = function (a) {
	return {ctor: 'New', _0: a};
};
var _elm_lang$navigation$Navigation$newUrl = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$New(url));
};
var _elm_lang$navigation$Navigation$Jump = function (a) {
	return {ctor: 'Jump', _0: a};
};
var _elm_lang$navigation$Navigation$back = function (n) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Jump(0 - n));
};
var _elm_lang$navigation$Navigation$forward = function (n) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Jump(n));
};
var _elm_lang$navigation$Navigation$cmdMap = F2(
	function (_p5, myCmd) {
		var _p6 = myCmd;
		switch (_p6.ctor) {
			case 'Jump':
				return _elm_lang$navigation$Navigation$Jump(_p6._0);
			case 'New':
				return _elm_lang$navigation$Navigation$New(_p6._0);
			case 'Modify':
				return _elm_lang$navigation$Navigation$Modify(_p6._0);
			case 'Visit':
				return _elm_lang$navigation$Navigation$Visit(_p6._0);
			default:
				return _elm_lang$navigation$Navigation$Reload(_p6._0);
		}
	});
var _elm_lang$navigation$Navigation$Monitor = function (a) {
	return {ctor: 'Monitor', _0: a};
};
var _elm_lang$navigation$Navigation$program = F2(
	function (locationToMessage, stuff) {
		var init = stuff.init(
			_elm_lang$navigation$Native_Navigation.getLocation(
				{ctor: '_Tuple0'}));
		var subs = function (model) {
			return _elm_lang$core$Platform_Sub$batch(
				{
					ctor: '::',
					_0: _elm_lang$navigation$Navigation$subscription(
						_elm_lang$navigation$Navigation$Monitor(locationToMessage)),
					_1: {
						ctor: '::',
						_0: stuff.subscriptions(model),
						_1: {ctor: '[]'}
					}
				});
		};
		return _elm_lang$html$Html$program(
			{init: init, view: stuff.view, update: stuff.update, subscriptions: subs});
	});
var _elm_lang$navigation$Navigation$programWithFlags = F2(
	function (locationToMessage, stuff) {
		var init = function (flags) {
			return A2(
				stuff.init,
				flags,
				_elm_lang$navigation$Native_Navigation.getLocation(
					{ctor: '_Tuple0'}));
		};
		var subs = function (model) {
			return _elm_lang$core$Platform_Sub$batch(
				{
					ctor: '::',
					_0: _elm_lang$navigation$Navigation$subscription(
						_elm_lang$navigation$Navigation$Monitor(locationToMessage)),
					_1: {
						ctor: '::',
						_0: stuff.subscriptions(model),
						_1: {ctor: '[]'}
					}
				});
		};
		return _elm_lang$html$Html$programWithFlags(
			{init: init, view: stuff.view, update: stuff.update, subscriptions: subs});
	});
var _elm_lang$navigation$Navigation$subMap = F2(
	function (func, _p7) {
		var _p8 = _p7;
		return _elm_lang$navigation$Navigation$Monitor(
			function (_p9) {
				return func(
					_p8._0(_p9));
			});
	});
var _elm_lang$navigation$Navigation$InternetExplorer = F2(
	function (a, b) {
		return {ctor: 'InternetExplorer', _0: a, _1: b};
	});
var _elm_lang$navigation$Navigation$Normal = function (a) {
	return {ctor: 'Normal', _0: a};
};
var _elm_lang$navigation$Navigation$spawnPopWatcher = function (router) {
	var reportLocation = function (_p10) {
		return A2(
			_elm_lang$core$Platform$sendToSelf,
			router,
			_elm_lang$navigation$Native_Navigation.getLocation(
				{ctor: '_Tuple0'}));
	};
	return _elm_lang$navigation$Native_Navigation.isInternetExplorer11(
		{ctor: '_Tuple0'}) ? A3(
		_elm_lang$core$Task$map2,
		_elm_lang$navigation$Navigation$InternetExplorer,
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'popstate', _elm_lang$core$Json_Decode$value, reportLocation)),
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'hashchange', _elm_lang$core$Json_Decode$value, reportLocation))) : A2(
		_elm_lang$core$Task$map,
		_elm_lang$navigation$Navigation$Normal,
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'popstate', _elm_lang$core$Json_Decode$value, reportLocation)));
};
var _elm_lang$navigation$Navigation$onEffects = F4(
	function (router, cmds, subs, _p11) {
		var _p12 = _p11;
		var _p15 = _p12.popWatcher;
		var stepState = function () {
			var _p13 = {ctor: '_Tuple2', _0: subs, _1: _p15};
			_v6_2:
			do {
				if (_p13._0.ctor === '[]') {
					if (_p13._1.ctor === 'Just') {
						return A2(
							_elm_lang$navigation$Navigation_ops['&>'],
							_elm_lang$navigation$Navigation$killPopWatcher(_p13._1._0),
							_elm_lang$core$Task$succeed(
								A2(_elm_lang$navigation$Navigation$State, subs, _elm_lang$core$Maybe$Nothing)));
					} else {
						break _v6_2;
					}
				} else {
					if (_p13._1.ctor === 'Nothing') {
						return A2(
							_elm_lang$core$Task$map,
							function (_p14) {
								return A2(
									_elm_lang$navigation$Navigation$State,
									subs,
									_elm_lang$core$Maybe$Just(_p14));
							},
							_elm_lang$navigation$Navigation$spawnPopWatcher(router));
					} else {
						break _v6_2;
					}
				}
			} while(false);
			return _elm_lang$core$Task$succeed(
				A2(_elm_lang$navigation$Navigation$State, subs, _p15));
		}();
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Task$sequence(
				A2(
					_elm_lang$core$List$map,
					A2(_elm_lang$navigation$Navigation$cmdHelp, router, subs),
					cmds)),
			stepState);
	});
_elm_lang$core$Native_Platform.effectManagers['Navigation'] = {pkg: 'elm-lang/navigation', init: _elm_lang$navigation$Navigation$init, onEffects: _elm_lang$navigation$Navigation$onEffects, onSelfMsg: _elm_lang$navigation$Navigation$onSelfMsg, tag: 'fx', cmdMap: _elm_lang$navigation$Navigation$cmdMap, subMap: _elm_lang$navigation$Navigation$subMap};

var _elm_lang$window$Native_Window = function()
{

var size = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)	{
	callback(_elm_lang$core$Native_Scheduler.succeed({
		width: window.innerWidth,
		height: window.innerHeight
	}));
});

return {
	size: size
};

}();
var _elm_lang$window$Window_ops = _elm_lang$window$Window_ops || {};
_elm_lang$window$Window_ops['&>'] = F2(
	function (task1, task2) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (_p0) {
				return task2;
			},
			task1);
	});
var _elm_lang$window$Window$onSelfMsg = F3(
	function (router, dimensions, state) {
		var _p1 = state;
		if (_p1.ctor === 'Nothing') {
			return _elm_lang$core$Task$succeed(state);
		} else {
			var send = function (_p2) {
				var _p3 = _p2;
				return A2(
					_elm_lang$core$Platform$sendToApp,
					router,
					_p3._0(dimensions));
			};
			return A2(
				_elm_lang$window$Window_ops['&>'],
				_elm_lang$core$Task$sequence(
					A2(_elm_lang$core$List$map, send, _p1._0.subs)),
				_elm_lang$core$Task$succeed(state));
		}
	});
var _elm_lang$window$Window$init = _elm_lang$core$Task$succeed(_elm_lang$core$Maybe$Nothing);
var _elm_lang$window$Window$size = _elm_lang$window$Native_Window.size;
var _elm_lang$window$Window$width = A2(
	_elm_lang$core$Task$map,
	function (_) {
		return _.width;
	},
	_elm_lang$window$Window$size);
var _elm_lang$window$Window$height = A2(
	_elm_lang$core$Task$map,
	function (_) {
		return _.height;
	},
	_elm_lang$window$Window$size);
var _elm_lang$window$Window$onEffects = F3(
	function (router, newSubs, oldState) {
		var _p4 = {ctor: '_Tuple2', _0: oldState, _1: newSubs};
		if (_p4._0.ctor === 'Nothing') {
			if (_p4._1.ctor === '[]') {
				return _elm_lang$core$Task$succeed(_elm_lang$core$Maybe$Nothing);
			} else {
				return A2(
					_elm_lang$core$Task$andThen,
					function (pid) {
						return _elm_lang$core$Task$succeed(
							_elm_lang$core$Maybe$Just(
								{subs: newSubs, pid: pid}));
					},
					_elm_lang$core$Process$spawn(
						A3(
							_elm_lang$dom$Dom_LowLevel$onWindow,
							'resize',
							_elm_lang$core$Json_Decode$succeed(
								{ctor: '_Tuple0'}),
							function (_p5) {
								return A2(
									_elm_lang$core$Task$andThen,
									_elm_lang$core$Platform$sendToSelf(router),
									_elm_lang$window$Window$size);
							})));
			}
		} else {
			if (_p4._1.ctor === '[]') {
				return A2(
					_elm_lang$window$Window_ops['&>'],
					_elm_lang$core$Process$kill(_p4._0._0.pid),
					_elm_lang$core$Task$succeed(_elm_lang$core$Maybe$Nothing));
			} else {
				return _elm_lang$core$Task$succeed(
					_elm_lang$core$Maybe$Just(
						{subs: newSubs, pid: _p4._0._0.pid}));
			}
		}
	});
var _elm_lang$window$Window$subscription = _elm_lang$core$Native_Platform.leaf('Window');
var _elm_lang$window$Window$Size = F2(
	function (a, b) {
		return {width: a, height: b};
	});
var _elm_lang$window$Window$MySub = function (a) {
	return {ctor: 'MySub', _0: a};
};
var _elm_lang$window$Window$resizes = function (tagger) {
	return _elm_lang$window$Window$subscription(
		_elm_lang$window$Window$MySub(tagger));
};
var _elm_lang$window$Window$subMap = F2(
	function (func, _p6) {
		var _p7 = _p6;
		return _elm_lang$window$Window$MySub(
			function (_p8) {
				return func(
					_p7._0(_p8));
			});
	});
_elm_lang$core$Native_Platform.effectManagers['Window'] = {pkg: 'elm-lang/window', init: _elm_lang$window$Window$init, onEffects: _elm_lang$window$Window$onEffects, onSelfMsg: _elm_lang$window$Window$onSelfMsg, tag: 'sub', subMap: _elm_lang$window$Window$subMap};

var _evancz$elm_sortable_table$Table$findSorter = F2(
	function (selectedColumn, columnData) {
		findSorter:
		while (true) {
			var _p0 = columnData;
			if (_p0.ctor === '[]') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				if (_elm_lang$core$Native_Utils.eq(_p0._0.name, selectedColumn)) {
					return _elm_lang$core$Maybe$Just(_p0._0.sorter);
				} else {
					var _v1 = selectedColumn,
						_v2 = _p0._1;
					selectedColumn = _v1;
					columnData = _v2;
					continue findSorter;
				}
			}
		}
	});
var _evancz$elm_sortable_table$Table$applySorter = F3(
	function (isReversed, sorter, data) {
		var _p1 = sorter;
		switch (_p1.ctor) {
			case 'None':
				return data;
			case 'Increasing':
				return _p1._0(data);
			case 'Decreasing':
				return _elm_lang$core$List$reverse(
					_p1._0(data));
			case 'IncOrDec':
				var _p2 = _p1._0;
				return isReversed ? _elm_lang$core$List$reverse(
					_p2(data)) : _p2(data);
			default:
				var _p3 = _p1._0;
				return isReversed ? _p3(data) : _elm_lang$core$List$reverse(
					_p3(data));
		}
	});
var _evancz$elm_sortable_table$Table$sort = F3(
	function (_p4, columnData, data) {
		var _p5 = _p4;
		var _p6 = A2(_evancz$elm_sortable_table$Table$findSorter, _p5._0, columnData);
		if (_p6.ctor === 'Nothing') {
			return data;
		} else {
			return A3(_evancz$elm_sortable_table$Table$applySorter, _p5._1, _p6._0, data);
		}
	});
var _evancz$elm_sortable_table$Table$viewCell = F2(
	function (data, _p7) {
		var _p8 = _p7;
		var details = _p8.viewData(data);
		return A2(_elm_lang$html$Html$td, details.attributes, details.children);
	});
var _evancz$elm_sortable_table$Table$viewRowHelp = F3(
	function (columns, toRowAttrs, data) {
		return A2(
			_elm_lang$html$Html$tr,
			toRowAttrs(data),
			A2(
				_elm_lang$core$List$map,
				_evancz$elm_sortable_table$Table$viewCell(data),
				columns));
	});
var _evancz$elm_sortable_table$Table$viewRow = F4(
	function (toId, columns, toRowAttrs, data) {
		return {
			ctor: '_Tuple2',
			_0: toId(data),
			_1: A4(_elm_lang$html$Html_Lazy$lazy3, _evancz$elm_sortable_table$Table$viewRowHelp, columns, toRowAttrs, data)
		};
	});
var _evancz$elm_sortable_table$Table$simpleRowAttrs = function (_p9) {
	return {ctor: '[]'};
};
var _evancz$elm_sortable_table$Table$lightGrey = function (symbol) {
	return A2(
		_elm_lang$html$Html$span,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'color', _1: '#ccc'},
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text(
				A2(_elm_lang$core$Basics_ops['++'], ' ', symbol)),
			_1: {ctor: '[]'}
		});
};
var _evancz$elm_sortable_table$Table$darkGrey = function (symbol) {
	return A2(
		_elm_lang$html$Html$span,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'color', _1: '#555'},
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text(
				A2(_elm_lang$core$Basics_ops['++'], ' ', symbol)),
			_1: {ctor: '[]'}
		});
};
var _evancz$elm_sortable_table$Table$simpleTheadHelp = function (_p10) {
	var _p11 = _p10;
	var _p13 = _p11._0;
	var content = function () {
		var _p12 = _p11._1;
		switch (_p12.ctor) {
			case 'Unsortable':
				return {
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p13),
					_1: {ctor: '[]'}
				};
			case 'Sortable':
				return {
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p13),
					_1: {
						ctor: '::',
						_0: _p12._0 ? _evancz$elm_sortable_table$Table$darkGrey('↓') : _evancz$elm_sortable_table$Table$lightGrey('↓'),
						_1: {ctor: '[]'}
					}
				};
			default:
				if (_p12._0.ctor === 'Nothing') {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p13),
						_1: {
							ctor: '::',
							_0: _evancz$elm_sortable_table$Table$lightGrey('↕'),
							_1: {ctor: '[]'}
						}
					};
				} else {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p13),
						_1: {
							ctor: '::',
							_0: _evancz$elm_sortable_table$Table$darkGrey(
								_p12._0._0 ? '↑' : '↓'),
							_1: {ctor: '[]'}
						}
					};
				}
		}
	}();
	return A2(
		_elm_lang$html$Html$th,
		{
			ctor: '::',
			_0: _p11._2,
			_1: {ctor: '[]'}
		},
		content);
};
var _evancz$elm_sortable_table$Table$Customizations = F6(
	function (a, b, c, d, e, f) {
		return {tableAttrs: a, caption: b, thead: c, tfoot: d, tbodyAttrs: e, rowAttrs: f};
	});
var _evancz$elm_sortable_table$Table$HtmlDetails = F2(
	function (a, b) {
		return {attributes: a, children: b};
	});
var _evancz$elm_sortable_table$Table$simpleThead = function (headers) {
	return A2(
		_evancz$elm_sortable_table$Table$HtmlDetails,
		{ctor: '[]'},
		A2(_elm_lang$core$List$map, _evancz$elm_sortable_table$Table$simpleTheadHelp, headers));
};
var _evancz$elm_sortable_table$Table$defaultCustomizations = {
	tableAttrs: {ctor: '[]'},
	caption: _elm_lang$core$Maybe$Nothing,
	thead: _evancz$elm_sortable_table$Table$simpleThead,
	tfoot: _elm_lang$core$Maybe$Nothing,
	tbodyAttrs: {ctor: '[]'},
	rowAttrs: _evancz$elm_sortable_table$Table$simpleRowAttrs
};
var _evancz$elm_sortable_table$Table$textDetails = function (str) {
	return A2(
		_evancz$elm_sortable_table$Table$HtmlDetails,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text(str),
			_1: {ctor: '[]'}
		});
};
var _evancz$elm_sortable_table$Table$ColumnData = F3(
	function (a, b, c) {
		return {name: a, viewData: b, sorter: c};
	});
var _evancz$elm_sortable_table$Table$State = F2(
	function (a, b) {
		return {ctor: 'State', _0: a, _1: b};
	});
var _evancz$elm_sortable_table$Table$initialSort = function (header) {
	return A2(_evancz$elm_sortable_table$Table$State, header, false);
};
var _evancz$elm_sortable_table$Table$onClick = F3(
	function (name, isReversed, toMsg) {
		return A2(
			_elm_lang$html$Html_Events$on,
			'click',
			A2(
				_elm_lang$core$Json_Decode$map,
				toMsg,
				A3(
					_elm_lang$core$Json_Decode$map2,
					_evancz$elm_sortable_table$Table$State,
					_elm_lang$core$Json_Decode$succeed(name),
					_elm_lang$core$Json_Decode$succeed(isReversed))));
	});
var _evancz$elm_sortable_table$Table$Config = function (a) {
	return {ctor: 'Config', _0: a};
};
var _evancz$elm_sortable_table$Table$config = function (_p14) {
	var _p15 = _p14;
	return _evancz$elm_sortable_table$Table$Config(
		{
			toId: _p15.toId,
			toMsg: _p15.toMsg,
			columns: A2(
				_elm_lang$core$List$map,
				function (_p16) {
					var _p17 = _p16;
					return _p17._0;
				},
				_p15.columns),
			customizations: _evancz$elm_sortable_table$Table$defaultCustomizations
		});
};
var _evancz$elm_sortable_table$Table$customConfig = function (_p18) {
	var _p19 = _p18;
	return _evancz$elm_sortable_table$Table$Config(
		{
			toId: _p19.toId,
			toMsg: _p19.toMsg,
			columns: A2(
				_elm_lang$core$List$map,
				function (_p20) {
					var _p21 = _p20;
					return _p21._0;
				},
				_p19.columns),
			customizations: _p19.customizations
		});
};
var _evancz$elm_sortable_table$Table$Reversible = function (a) {
	return {ctor: 'Reversible', _0: a};
};
var _evancz$elm_sortable_table$Table$Sortable = function (a) {
	return {ctor: 'Sortable', _0: a};
};
var _evancz$elm_sortable_table$Table$Unsortable = {ctor: 'Unsortable'};
var _evancz$elm_sortable_table$Table$toHeaderInfo = F3(
	function (_p23, toMsg, _p22) {
		var _p24 = _p23;
		var _p29 = _p24._0;
		var _p28 = _p24._1;
		var _p25 = _p22;
		var _p27 = _p25.name;
		var _p26 = _p25.sorter;
		switch (_p26.ctor) {
			case 'None':
				return {
					ctor: '_Tuple3',
					_0: _p27,
					_1: _evancz$elm_sortable_table$Table$Unsortable,
					_2: A3(_evancz$elm_sortable_table$Table$onClick, _p29, _p28, toMsg)
				};
			case 'Increasing':
				return {
					ctor: '_Tuple3',
					_0: _p27,
					_1: _evancz$elm_sortable_table$Table$Sortable(
						_elm_lang$core$Native_Utils.eq(_p27, _p29)),
					_2: A3(_evancz$elm_sortable_table$Table$onClick, _p27, false, toMsg)
				};
			case 'Decreasing':
				return {
					ctor: '_Tuple3',
					_0: _p27,
					_1: _evancz$elm_sortable_table$Table$Sortable(
						_elm_lang$core$Native_Utils.eq(_p27, _p29)),
					_2: A3(_evancz$elm_sortable_table$Table$onClick, _p27, false, toMsg)
				};
			case 'IncOrDec':
				return _elm_lang$core$Native_Utils.eq(_p27, _p29) ? {
					ctor: '_Tuple3',
					_0: _p27,
					_1: _evancz$elm_sortable_table$Table$Reversible(
						_elm_lang$core$Maybe$Just(_p28)),
					_2: A3(_evancz$elm_sortable_table$Table$onClick, _p27, !_p28, toMsg)
				} : {
					ctor: '_Tuple3',
					_0: _p27,
					_1: _evancz$elm_sortable_table$Table$Reversible(_elm_lang$core$Maybe$Nothing),
					_2: A3(_evancz$elm_sortable_table$Table$onClick, _p27, false, toMsg)
				};
			default:
				return _elm_lang$core$Native_Utils.eq(_p27, _p29) ? {
					ctor: '_Tuple3',
					_0: _p27,
					_1: _evancz$elm_sortable_table$Table$Reversible(
						_elm_lang$core$Maybe$Just(_p28)),
					_2: A3(_evancz$elm_sortable_table$Table$onClick, _p27, !_p28, toMsg)
				} : {
					ctor: '_Tuple3',
					_0: _p27,
					_1: _evancz$elm_sortable_table$Table$Reversible(_elm_lang$core$Maybe$Nothing),
					_2: A3(_evancz$elm_sortable_table$Table$onClick, _p27, false, toMsg)
				};
		}
	});
var _evancz$elm_sortable_table$Table$view = F3(
	function (_p30, state, data) {
		var _p31 = _p30;
		var _p35 = _p31._0.customizations;
		var _p34 = _p31._0.columns;
		var theadDetails = _p35.thead(
			A2(
				_elm_lang$core$List$map,
				A2(_evancz$elm_sortable_table$Table$toHeaderInfo, state, _p31._0.toMsg),
				_p34));
		var thead = A2(_elm_lang$html$Html$thead, theadDetails.attributes, theadDetails.children);
		var sortedData = A3(_evancz$elm_sortable_table$Table$sort, state, _p34, data);
		var tbody = A3(
			_elm_lang$html$Html_Keyed$node,
			'tbody',
			_p35.tbodyAttrs,
			A2(
				_elm_lang$core$List$map,
				A3(_evancz$elm_sortable_table$Table$viewRow, _p31._0.toId, _p34, _p35.rowAttrs),
				sortedData));
		var withFoot = function () {
			var _p32 = _p35.tfoot;
			if (_p32.ctor === 'Nothing') {
				return {
					ctor: '::',
					_0: tbody,
					_1: {ctor: '[]'}
				};
			} else {
				return {
					ctor: '::',
					_0: A2(_elm_lang$html$Html$tfoot, _p32._0.attributes, _p32._0.children),
					_1: {
						ctor: '::',
						_0: tbody,
						_1: {ctor: '[]'}
					}
				};
			}
		}();
		return A2(
			_elm_lang$html$Html$table,
			_p35.tableAttrs,
			function () {
				var _p33 = _p35.caption;
				if (_p33.ctor === 'Nothing') {
					return {ctor: '::', _0: thead, _1: withFoot};
				} else {
					return {
						ctor: '::',
						_0: A2(_elm_lang$html$Html$caption, _p33._0.attributes, _p33._0.children),
						_1: {ctor: '::', _0: thead, _1: withFoot}
					};
				}
			}());
	});
var _evancz$elm_sortable_table$Table$Column = function (a) {
	return {ctor: 'Column', _0: a};
};
var _evancz$elm_sortable_table$Table$customColumn = function (_p36) {
	var _p37 = _p36;
	return _evancz$elm_sortable_table$Table$Column(
		A3(
			_evancz$elm_sortable_table$Table$ColumnData,
			_p37.name,
			function (_p38) {
				return _evancz$elm_sortable_table$Table$textDetails(
					_p37.viewData(_p38));
			},
			_p37.sorter));
};
var _evancz$elm_sortable_table$Table$veryCustomColumn = _evancz$elm_sortable_table$Table$Column;
var _evancz$elm_sortable_table$Table$DecOrInc = function (a) {
	return {ctor: 'DecOrInc', _0: a};
};
var _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy = function (toComparable) {
	return _evancz$elm_sortable_table$Table$DecOrInc(
		_elm_lang$core$List$sortBy(toComparable));
};
var _evancz$elm_sortable_table$Table$IncOrDec = function (a) {
	return {ctor: 'IncOrDec', _0: a};
};
var _evancz$elm_sortable_table$Table$increasingOrDecreasingBy = function (toComparable) {
	return _evancz$elm_sortable_table$Table$IncOrDec(
		_elm_lang$core$List$sortBy(toComparable));
};
var _evancz$elm_sortable_table$Table$stringColumn = F2(
	function (name, toStr) {
		return _evancz$elm_sortable_table$Table$Column(
			{
				name: name,
				viewData: function (_p39) {
					return _evancz$elm_sortable_table$Table$textDetails(
						toStr(_p39));
				},
				sorter: _evancz$elm_sortable_table$Table$increasingOrDecreasingBy(toStr)
			});
	});
var _evancz$elm_sortable_table$Table$intColumn = F2(
	function (name, toInt) {
		return _evancz$elm_sortable_table$Table$Column(
			{
				name: name,
				viewData: function (_p40) {
					return _evancz$elm_sortable_table$Table$textDetails(
						_elm_lang$core$Basics$toString(
							toInt(_p40)));
				},
				sorter: _evancz$elm_sortable_table$Table$increasingOrDecreasingBy(toInt)
			});
	});
var _evancz$elm_sortable_table$Table$floatColumn = F2(
	function (name, toFloat) {
		return _evancz$elm_sortable_table$Table$Column(
			{
				name: name,
				viewData: function (_p41) {
					return _evancz$elm_sortable_table$Table$textDetails(
						_elm_lang$core$Basics$toString(
							toFloat(_p41)));
				},
				sorter: _evancz$elm_sortable_table$Table$increasingOrDecreasingBy(toFloat)
			});
	});
var _evancz$elm_sortable_table$Table$Decreasing = function (a) {
	return {ctor: 'Decreasing', _0: a};
};
var _evancz$elm_sortable_table$Table$decreasingBy = function (toComparable) {
	return _evancz$elm_sortable_table$Table$Decreasing(
		_elm_lang$core$List$sortBy(toComparable));
};
var _evancz$elm_sortable_table$Table$Increasing = function (a) {
	return {ctor: 'Increasing', _0: a};
};
var _evancz$elm_sortable_table$Table$increasingBy = function (toComparable) {
	return _evancz$elm_sortable_table$Table$Increasing(
		_elm_lang$core$List$sortBy(toComparable));
};
var _evancz$elm_sortable_table$Table$None = {ctor: 'None'};
var _evancz$elm_sortable_table$Table$unsortable = _evancz$elm_sortable_table$Table$None;

var _evancz$url_parser$UrlParser$toKeyValuePair = function (segment) {
	var _p0 = A2(_elm_lang$core$String$split, '=', segment);
	if (((_p0.ctor === '::') && (_p0._1.ctor === '::')) && (_p0._1._1.ctor === '[]')) {
		return A3(
			_elm_lang$core$Maybe$map2,
			F2(
				function (v0, v1) {
					return {ctor: '_Tuple2', _0: v0, _1: v1};
				}),
			_elm_lang$http$Http$decodeUri(_p0._0),
			_elm_lang$http$Http$decodeUri(_p0._1._0));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _evancz$url_parser$UrlParser$parseParams = function (queryString) {
	return _elm_lang$core$Dict$fromList(
		A2(
			_elm_lang$core$List$filterMap,
			_evancz$url_parser$UrlParser$toKeyValuePair,
			A2(
				_elm_lang$core$String$split,
				'&',
				A2(_elm_lang$core$String$dropLeft, 1, queryString))));
};
var _evancz$url_parser$UrlParser$splitUrl = function (url) {
	var _p1 = A2(_elm_lang$core$String$split, '/', url);
	if ((_p1.ctor === '::') && (_p1._0 === '')) {
		return _p1._1;
	} else {
		return _p1;
	}
};
var _evancz$url_parser$UrlParser$parseHelp = function (states) {
	parseHelp:
	while (true) {
		var _p2 = states;
		if (_p2.ctor === '[]') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p4 = _p2._0;
			var _p3 = _p4.unvisited;
			if (_p3.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p4.value);
			} else {
				if ((_p3._0 === '') && (_p3._1.ctor === '[]')) {
					return _elm_lang$core$Maybe$Just(_p4.value);
				} else {
					var _v4 = _p2._1;
					states = _v4;
					continue parseHelp;
				}
			}
		}
	}
};
var _evancz$url_parser$UrlParser$parse = F3(
	function (_p5, url, params) {
		var _p6 = _p5;
		return _evancz$url_parser$UrlParser$parseHelp(
			_p6._0(
				{
					visited: {ctor: '[]'},
					unvisited: _evancz$url_parser$UrlParser$splitUrl(url),
					params: params,
					value: _elm_lang$core$Basics$identity
				}));
	});
var _evancz$url_parser$UrlParser$parseHash = F2(
	function (parser, location) {
		return A3(
			_evancz$url_parser$UrlParser$parse,
			parser,
			A2(_elm_lang$core$String$dropLeft, 1, location.hash),
			_evancz$url_parser$UrlParser$parseParams(location.search));
	});
var _evancz$url_parser$UrlParser$parsePath = F2(
	function (parser, location) {
		return A3(
			_evancz$url_parser$UrlParser$parse,
			parser,
			location.pathname,
			_evancz$url_parser$UrlParser$parseParams(location.search));
	});
var _evancz$url_parser$UrlParser$intParamHelp = function (maybeValue) {
	var _p7 = maybeValue;
	if (_p7.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Result$toMaybe(
			_elm_lang$core$String$toInt(_p7._0));
	}
};
var _evancz$url_parser$UrlParser$mapHelp = F2(
	function (func, _p8) {
		var _p9 = _p8;
		return {
			visited: _p9.visited,
			unvisited: _p9.unvisited,
			params: _p9.params,
			value: func(_p9.value)
		};
	});
var _evancz$url_parser$UrlParser$State = F4(
	function (a, b, c, d) {
		return {visited: a, unvisited: b, params: c, value: d};
	});
var _evancz$url_parser$UrlParser$Parser = function (a) {
	return {ctor: 'Parser', _0: a};
};
var _evancz$url_parser$UrlParser$s = function (str) {
	return _evancz$url_parser$UrlParser$Parser(
		function (_p10) {
			var _p11 = _p10;
			var _p12 = _p11.unvisited;
			if (_p12.ctor === '[]') {
				return {ctor: '[]'};
			} else {
				var _p13 = _p12._0;
				return _elm_lang$core$Native_Utils.eq(_p13, str) ? {
					ctor: '::',
					_0: A4(
						_evancz$url_parser$UrlParser$State,
						{ctor: '::', _0: _p13, _1: _p11.visited},
						_p12._1,
						_p11.params,
						_p11.value),
					_1: {ctor: '[]'}
				} : {ctor: '[]'};
			}
		});
};
var _evancz$url_parser$UrlParser$custom = F2(
	function (tipe, stringToSomething) {
		return _evancz$url_parser$UrlParser$Parser(
			function (_p14) {
				var _p15 = _p14;
				var _p16 = _p15.unvisited;
				if (_p16.ctor === '[]') {
					return {ctor: '[]'};
				} else {
					var _p18 = _p16._0;
					var _p17 = stringToSomething(_p18);
					if (_p17.ctor === 'Ok') {
						return {
							ctor: '::',
							_0: A4(
								_evancz$url_parser$UrlParser$State,
								{ctor: '::', _0: _p18, _1: _p15.visited},
								_p16._1,
								_p15.params,
								_p15.value(_p17._0)),
							_1: {ctor: '[]'}
						};
					} else {
						return {ctor: '[]'};
					}
				}
			});
	});
var _evancz$url_parser$UrlParser$string = A2(_evancz$url_parser$UrlParser$custom, 'STRING', _elm_lang$core$Result$Ok);
var _evancz$url_parser$UrlParser$int = A2(_evancz$url_parser$UrlParser$custom, 'NUMBER', _elm_lang$core$String$toInt);
var _evancz$url_parser$UrlParser_ops = _evancz$url_parser$UrlParser_ops || {};
_evancz$url_parser$UrlParser_ops['</>'] = F2(
	function (_p20, _p19) {
		var _p21 = _p20;
		var _p22 = _p19;
		return _evancz$url_parser$UrlParser$Parser(
			function (state) {
				return A2(
					_elm_lang$core$List$concatMap,
					_p22._0,
					_p21._0(state));
			});
	});
var _evancz$url_parser$UrlParser$map = F2(
	function (subValue, _p23) {
		var _p24 = _p23;
		return _evancz$url_parser$UrlParser$Parser(
			function (_p25) {
				var _p26 = _p25;
				return A2(
					_elm_lang$core$List$map,
					_evancz$url_parser$UrlParser$mapHelp(_p26.value),
					_p24._0(
						{visited: _p26.visited, unvisited: _p26.unvisited, params: _p26.params, value: subValue}));
			});
	});
var _evancz$url_parser$UrlParser$oneOf = function (parsers) {
	return _evancz$url_parser$UrlParser$Parser(
		function (state) {
			return A2(
				_elm_lang$core$List$concatMap,
				function (_p27) {
					var _p28 = _p27;
					return _p28._0(state);
				},
				parsers);
		});
};
var _evancz$url_parser$UrlParser$top = _evancz$url_parser$UrlParser$Parser(
	function (state) {
		return {
			ctor: '::',
			_0: state,
			_1: {ctor: '[]'}
		};
	});
var _evancz$url_parser$UrlParser_ops = _evancz$url_parser$UrlParser_ops || {};
_evancz$url_parser$UrlParser_ops['<?>'] = F2(
	function (_p30, _p29) {
		var _p31 = _p30;
		var _p32 = _p29;
		return _evancz$url_parser$UrlParser$Parser(
			function (state) {
				return A2(
					_elm_lang$core$List$concatMap,
					_p32._0,
					_p31._0(state));
			});
	});
var _evancz$url_parser$UrlParser$QueryParser = function (a) {
	return {ctor: 'QueryParser', _0: a};
};
var _evancz$url_parser$UrlParser$customParam = F2(
	function (key, func) {
		return _evancz$url_parser$UrlParser$QueryParser(
			function (_p33) {
				var _p34 = _p33;
				var _p35 = _p34.params;
				return {
					ctor: '::',
					_0: A4(
						_evancz$url_parser$UrlParser$State,
						_p34.visited,
						_p34.unvisited,
						_p35,
						_p34.value(
							func(
								A2(_elm_lang$core$Dict$get, key, _p35)))),
					_1: {ctor: '[]'}
				};
			});
	});
var _evancz$url_parser$UrlParser$stringParam = function (name) {
	return A2(_evancz$url_parser$UrlParser$customParam, name, _elm_lang$core$Basics$identity);
};
var _evancz$url_parser$UrlParser$intParam = function (name) {
	return A2(_evancz$url_parser$UrlParser$customParam, name, _evancz$url_parser$UrlParser$intParamHelp);
};

var _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerSecond = 1000;
var _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute = 60 * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerSecond;
var _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerHour = 60 * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute;
var _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerDay = 24 * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerHour;
var _justinmimbs$elm_date_extra$Date_Extra_Facts$dayOfWeekFromWeekdayNumber = function (n) {
	var _p0 = n;
	switch (_p0) {
		case 1:
			return _elm_lang$core$Date$Mon;
		case 2:
			return _elm_lang$core$Date$Tue;
		case 3:
			return _elm_lang$core$Date$Wed;
		case 4:
			return _elm_lang$core$Date$Thu;
		case 5:
			return _elm_lang$core$Date$Fri;
		case 6:
			return _elm_lang$core$Date$Sat;
		default:
			return _elm_lang$core$Date$Sun;
	}
};
var _justinmimbs$elm_date_extra$Date_Extra_Facts$weekdayNumberFromDayOfWeek = function (d) {
	var _p1 = d;
	switch (_p1.ctor) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var _justinmimbs$elm_date_extra$Date_Extra_Facts$monthFromMonthNumber = function (n) {
	var _p2 = n;
	switch (_p2) {
		case 1:
			return _elm_lang$core$Date$Jan;
		case 2:
			return _elm_lang$core$Date$Feb;
		case 3:
			return _elm_lang$core$Date$Mar;
		case 4:
			return _elm_lang$core$Date$Apr;
		case 5:
			return _elm_lang$core$Date$May;
		case 6:
			return _elm_lang$core$Date$Jun;
		case 7:
			return _elm_lang$core$Date$Jul;
		case 8:
			return _elm_lang$core$Date$Aug;
		case 9:
			return _elm_lang$core$Date$Sep;
		case 10:
			return _elm_lang$core$Date$Oct;
		case 11:
			return _elm_lang$core$Date$Nov;
		default:
			return _elm_lang$core$Date$Dec;
	}
};
var _justinmimbs$elm_date_extra$Date_Extra_Facts$monthNumberFromMonth = function (m) {
	var _p3 = m;
	switch (_p3.ctor) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var _justinmimbs$elm_date_extra$Date_Extra_Facts$months = {
	ctor: '::',
	_0: _elm_lang$core$Date$Jan,
	_1: {
		ctor: '::',
		_0: _elm_lang$core$Date$Feb,
		_1: {
			ctor: '::',
			_0: _elm_lang$core$Date$Mar,
			_1: {
				ctor: '::',
				_0: _elm_lang$core$Date$Apr,
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Date$May,
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Date$Jun,
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Date$Jul,
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Date$Aug,
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Date$Sep,
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Date$Oct,
										_1: {
											ctor: '::',
											_0: _elm_lang$core$Date$Nov,
											_1: {
												ctor: '::',
												_0: _elm_lang$core$Date$Dec,
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear = function (y) {
	return (_elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], y, 4),
		0) && (!_elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], y, 100),
		0))) || _elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], y, 400),
		0);
};
var _justinmimbs$elm_date_extra$Date_Extra_Facts$daysInMonth = F2(
	function (y, m) {
		var _p4 = m;
		switch (_p4.ctor) {
			case 'Jan':
				return 31;
			case 'Feb':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var _justinmimbs$elm_date_extra$Date_Extra_Facts$daysBeforeStartOfMonth = F2(
	function (y, m) {
		var _p5 = m;
		switch (_p5.ctor) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 60 : 59;
			case 'Apr':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 91 : 90;
			case 'May':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 121 : 120;
			case 'Jun':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 152 : 151;
			case 'Jul':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 182 : 181;
			case 'Aug':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 213 : 212;
			case 'Sep':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 244 : 243;
			case 'Oct':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 274 : 273;
			case 'Nov':
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 305 : 304;
			default:
				return _justinmimbs$elm_date_extra$Date_Extra_Facts$isLeapYear(y) ? 335 : 334;
		}
	});

var _justinmimbs$elm_date_extra$Date_Internal_RataDie$divideInt = F2(
	function (a, b) {
		return {
			ctor: '_Tuple2',
			_0: (a / b) | 0,
			_1: A2(_elm_lang$core$Basics$rem, a, b)
		};
	});
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$year = function (rd) {
	var _p0 = A2(_justinmimbs$elm_date_extra$Date_Internal_RataDie$divideInt, rd, 146097);
	var n400 = _p0._0;
	var r400 = _p0._1;
	var _p1 = A2(_justinmimbs$elm_date_extra$Date_Internal_RataDie$divideInt, r400, 36524);
	var n100 = _p1._0;
	var r100 = _p1._1;
	var _p2 = A2(_justinmimbs$elm_date_extra$Date_Internal_RataDie$divideInt, r100, 1461);
	var n4 = _p2._0;
	var r4 = _p2._1;
	var _p3 = A2(_justinmimbs$elm_date_extra$Date_Internal_RataDie$divideInt, r4, 365);
	var n1 = _p3._0;
	var r1 = _p3._1;
	var n = _elm_lang$core$Native_Utils.eq(r1, 0) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$weekdayNumber = function (rd) {
	var _p4 = A2(_elm_lang$core$Basics_ops['%'], rd, 7);
	if (_p4 === 0) {
		return 7;
	} else {
		return _p4;
	}
};
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$daysBeforeWeekYear = function (y) {
	var jan4 = _justinmimbs$elm_date_extra$Date_Internal_RataDie$daysBeforeYear(y) + 4;
	return jan4 - _justinmimbs$elm_date_extra$Date_Internal_RataDie$weekdayNumber(jan4);
};
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$weekYear = function (rd) {
	return _justinmimbs$elm_date_extra$Date_Internal_RataDie$year(
		rd + (4 - _justinmimbs$elm_date_extra$Date_Internal_RataDie$weekdayNumber(rd)));
};
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$weekNumber = function (rd) {
	var week1Day1 = _justinmimbs$elm_date_extra$Date_Internal_RataDie$daysBeforeWeekYear(
		_justinmimbs$elm_date_extra$Date_Internal_RataDie$weekYear(rd)) + 1;
	return (((rd - week1Day1) / 7) | 0) + 1;
};
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$fromWeekDate = F3(
	function (wy, wn, wdn) {
		return (_justinmimbs$elm_date_extra$Date_Internal_RataDie$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn;
	});
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$fromCalendarDate = F3(
	function (y, m, d) {
		return (_justinmimbs$elm_date_extra$Date_Internal_RataDie$daysBeforeYear(y) + A2(_justinmimbs$elm_date_extra$Date_Extra_Facts$daysBeforeStartOfMonth, y, m)) + d;
	});
var _justinmimbs$elm_date_extra$Date_Internal_RataDie$fromOrdinalDate = F2(
	function (y, od) {
		return _justinmimbs$elm_date_extra$Date_Internal_RataDie$daysBeforeYear(y) + od;
	});

var _justinmimbs$elm_date_extra$Date_Internal_Core$msFromTimeParts = F4(
	function (hh, mm, ss, ms) {
		return (((_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerHour * hh) + (_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute * mm)) + (_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerSecond * ss)) + ms;
	});
var _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromRataDie = function (rd) {
	return (rd - 719163) * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerDay;
};
var _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromOrdinalDate = F2(
	function (y, d) {
		return _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromRataDie(
			A2(_justinmimbs$elm_date_extra$Date_Internal_RataDie$fromOrdinalDate, y, d));
	});
var _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromCalendarDate = F3(
	function (y, m, d) {
		return _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromRataDie(
			A3(_justinmimbs$elm_date_extra$Date_Internal_RataDie$fromCalendarDate, y, m, d));
	});
var _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromParts = F7(
	function (y, m, d, hh, mm, ss, ms) {
		return A3(_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromCalendarDate, y, m, d) + A4(_justinmimbs$elm_date_extra$Date_Internal_Core$msFromTimeParts, hh, mm, ss, ms);
	});
var _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromWeekDate = F3(
	function (y, w, d) {
		return _justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromRataDie(
			A3(_justinmimbs$elm_date_extra$Date_Internal_RataDie$fromWeekDate, y, w, d));
	});
var _justinmimbs$elm_date_extra$Date_Internal_Core$weekNumberFromCalendarDate = F3(
	function (y, m, d) {
		return _justinmimbs$elm_date_extra$Date_Internal_RataDie$weekNumber(
			A3(_justinmimbs$elm_date_extra$Date_Internal_RataDie$fromCalendarDate, y, m, d));
	});
var _justinmimbs$elm_date_extra$Date_Internal_Core$weekYearFromCalendarDate = F3(
	function (y, m, d) {
		return _justinmimbs$elm_date_extra$Date_Internal_RataDie$weekYear(
			A3(_justinmimbs$elm_date_extra$Date_Internal_RataDie$fromCalendarDate, y, m, d));
	});

var _justinmimbs$elm_date_extra$Date_Internal_Extract$msOffsetFromUtc = function (date) {
	var utcTime = _elm_lang$core$Date$toTime(date);
	var localTime = _elm_lang$core$Basics$toFloat(
		A7(
			_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromParts,
			_elm_lang$core$Date$year(date),
			_elm_lang$core$Date$month(date),
			_elm_lang$core$Date$day(date),
			_elm_lang$core$Date$hour(date),
			_elm_lang$core$Date$minute(date),
			_elm_lang$core$Date$second(date),
			_elm_lang$core$Date$millisecond(date)));
	return _elm_lang$core$Basics$floor(localTime - utcTime);
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$offsetFromUtc = function (date) {
	return (_justinmimbs$elm_date_extra$Date_Internal_Extract$msOffsetFromUtc(date) / _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute) | 0;
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$weekYear = function (date) {
	return A3(
		_justinmimbs$elm_date_extra$Date_Internal_Core$weekYearFromCalendarDate,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date),
		_elm_lang$core$Date$day(date));
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$weekNumber = function (date) {
	return A3(
		_justinmimbs$elm_date_extra$Date_Internal_Core$weekNumberFromCalendarDate,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date),
		_elm_lang$core$Date$day(date));
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$weekdayNumber = function (_p0) {
	return _justinmimbs$elm_date_extra$Date_Extra_Facts$weekdayNumberFromDayOfWeek(
		_elm_lang$core$Date$dayOfWeek(_p0));
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$fractionalDay = function (date) {
	var timeOfDayMS = A4(
		_justinmimbs$elm_date_extra$Date_Internal_Core$msFromTimeParts,
		_elm_lang$core$Date$hour(date),
		_elm_lang$core$Date$minute(date),
		_elm_lang$core$Date$second(date),
		_elm_lang$core$Date$millisecond(date));
	return _elm_lang$core$Basics$toFloat(timeOfDayMS) / _elm_lang$core$Basics$toFloat(_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerDay);
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$ordinalDay = function (date) {
	return A2(
		_justinmimbs$elm_date_extra$Date_Extra_Facts$daysBeforeStartOfMonth,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date)) + _elm_lang$core$Date$day(date);
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$monthNumber = function (_p1) {
	return _justinmimbs$elm_date_extra$Date_Extra_Facts$monthNumberFromMonth(
		_elm_lang$core$Date$month(_p1));
};
var _justinmimbs$elm_date_extra$Date_Internal_Extract$quarter = function (date) {
	return _elm_lang$core$Basics$ceiling(
		function (n) {
			return n / 3;
		}(
			_elm_lang$core$Basics$toFloat(
				_justinmimbs$elm_date_extra$Date_Internal_Extract$monthNumber(date))));
};

var _justinmimbs$elm_date_extra$Date_Internal_Format$toUtc = function (date) {
	return _elm_lang$core$Date$fromTime(
		_elm_lang$core$Date$toTime(date) - _elm_lang$core$Basics$toFloat(
			_justinmimbs$elm_date_extra$Date_Internal_Extract$offsetFromUtc(date) * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute));
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$nameForm = function (length) {
	var _p0 = length;
	switch (_p0) {
		case 1:
			return 'abbreviated';
		case 2:
			return 'abbreviated';
		case 3:
			return 'abbreviated';
		case 4:
			return 'full';
		case 5:
			return 'narrow';
		case 6:
			return 'short';
		default:
			return 'invalid';
	}
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$patternMatches = _elm_lang$core$Regex$regex('([yYQMwdDEeabhHmsSXx])\\1*|\'(?:[^\']|\'\')*?\'(?!\')');
var _justinmimbs$elm_date_extra$Date_Internal_Format$formatTimeOffset = F3(
	function (separator, minutesOptional, offset) {
		var mm = A3(
			_elm_lang$core$String$padLeft,
			2,
			_elm_lang$core$Native_Utils.chr('0'),
			_elm_lang$core$Basics$toString(
				A2(
					_elm_lang$core$Basics_ops['%'],
					_elm_lang$core$Basics$abs(offset),
					60)));
		var hh = A3(
			_elm_lang$core$String$padLeft,
			2,
			_elm_lang$core$Native_Utils.chr('0'),
			_elm_lang$core$Basics$toString(
				(_elm_lang$core$Basics$abs(offset) / 60) | 0));
		var sign = (_elm_lang$core$Native_Utils.cmp(offset, 0) > -1) ? '+' : '-';
		return (minutesOptional && _elm_lang$core$Native_Utils.eq(mm, '00')) ? A2(_elm_lang$core$Basics_ops['++'], sign, hh) : A2(
			_elm_lang$core$Basics_ops['++'],
			sign,
			A2(
				_elm_lang$core$Basics_ops['++'],
				hh,
				A2(_elm_lang$core$Basics_ops['++'], separator, mm)));
	});
var _justinmimbs$elm_date_extra$Date_Internal_Format$ordinalSuffix = function (n) {
	var nn = A2(_elm_lang$core$Basics_ops['%'], n, 100);
	var _p1 = A2(
		_elm_lang$core$Basics$min,
		(_elm_lang$core$Native_Utils.cmp(nn, 20) < 0) ? nn : A2(_elm_lang$core$Basics_ops['%'], nn, 10),
		4);
	switch (_p1) {
		case 0:
			return 'th';
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		case 4:
			return 'th';
		default:
			return '';
	}
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$withOrdinalSuffix = function (n) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_elm_lang$core$Basics$toString(n),
		_justinmimbs$elm_date_extra$Date_Internal_Format$ordinalSuffix(n));
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$hour12 = function (date) {
	var _p2 = A2(
		_elm_lang$core$Basics_ops['%'],
		_elm_lang$core$Date$hour(date),
		12);
	if (_p2 === 0) {
		return 12;
	} else {
		return _p2;
	}
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$dayOfWeekName = function (d) {
	var _p3 = d;
	switch (_p3.ctor) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$monthName = function (m) {
	var _p4 = m;
	switch (_p4.ctor) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$PM = {ctor: 'PM'};
var _justinmimbs$elm_date_extra$Date_Internal_Format$Noon = {ctor: 'Noon'};
var _justinmimbs$elm_date_extra$Date_Internal_Format$AM = {ctor: 'AM'};
var _justinmimbs$elm_date_extra$Date_Internal_Format$Midnight = {ctor: 'Midnight'};
var _justinmimbs$elm_date_extra$Date_Internal_Format$dayPeriod = function (date) {
	var onTheHour = _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Date$minute(date),
		0) && (_elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Date$second(date),
		0) && _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Date$millisecond(date),
		0));
	var hh = _elm_lang$core$Date$hour(date);
	return (_elm_lang$core$Native_Utils.eq(hh, 0) && onTheHour) ? _justinmimbs$elm_date_extra$Date_Internal_Format$Midnight : ((_elm_lang$core$Native_Utils.cmp(hh, 12) < 0) ? _justinmimbs$elm_date_extra$Date_Internal_Format$AM : ((_elm_lang$core$Native_Utils.eq(hh, 12) && onTheHour) ? _justinmimbs$elm_date_extra$Date_Internal_Format$Noon : _justinmimbs$elm_date_extra$Date_Internal_Format$PM));
};
var _justinmimbs$elm_date_extra$Date_Internal_Format$format = F3(
	function (asUtc, date, match) {
		format:
		while (true) {
			var length = _elm_lang$core$String$length(match);
			var $char = A2(_elm_lang$core$String$left, 1, match);
			var _p5 = $char;
			switch (_p5) {
				case 'y':
					var _p6 = length;
					if (_p6 === 2) {
						return A2(
							_elm_lang$core$String$right,
							2,
							A3(
								_elm_lang$core$String$padLeft,
								length,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Date$year(date))));
					} else {
						return A3(
							_elm_lang$core$String$padLeft,
							length,
							_elm_lang$core$Native_Utils.chr('0'),
							_elm_lang$core$Basics$toString(
								_elm_lang$core$Date$year(date)));
					}
				case 'Y':
					var _p7 = length;
					if (_p7 === 2) {
						return A2(
							_elm_lang$core$String$right,
							2,
							A3(
								_elm_lang$core$String$padLeft,
								length,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_justinmimbs$elm_date_extra$Date_Internal_Extract$weekYear(date))));
					} else {
						return A3(
							_elm_lang$core$String$padLeft,
							length,
							_elm_lang$core$Native_Utils.chr('0'),
							_elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$weekYear(date)));
					}
				case 'Q':
					var _p8 = length;
					switch (_p8) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$quarter(date));
						case 2:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$quarter(date));
						case 3:
							return A2(
								F2(
									function (x, y) {
										return A2(_elm_lang$core$Basics_ops['++'], x, y);
									}),
								'Q',
								_elm_lang$core$Basics$toString(
									_justinmimbs$elm_date_extra$Date_Internal_Extract$quarter(date)));
						case 4:
							return _justinmimbs$elm_date_extra$Date_Internal_Format$withOrdinalSuffix(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$quarter(date));
						case 5:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$quarter(date));
						default:
							return '';
					}
				case 'M':
					var _p9 = length;
					switch (_p9) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$monthNumber(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_justinmimbs$elm_date_extra$Date_Internal_Extract$monthNumber(date)));
						case 3:
							return A2(
								_elm_lang$core$String$left,
								3,
								_justinmimbs$elm_date_extra$Date_Internal_Format$monthName(
									_elm_lang$core$Date$month(date)));
						case 4:
							return _justinmimbs$elm_date_extra$Date_Internal_Format$monthName(
								_elm_lang$core$Date$month(date));
						case 5:
							return A2(
								_elm_lang$core$String$left,
								1,
								_justinmimbs$elm_date_extra$Date_Internal_Format$monthName(
									_elm_lang$core$Date$month(date)));
						default:
							return '';
					}
				case 'w':
					var _p10 = length;
					switch (_p10) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$weekNumber(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_justinmimbs$elm_date_extra$Date_Internal_Extract$weekNumber(date)));
						default:
							return '';
					}
				case 'd':
					var _p11 = length;
					switch (_p11) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_elm_lang$core$Date$day(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Date$day(date)));
						case 3:
							return _justinmimbs$elm_date_extra$Date_Internal_Format$withOrdinalSuffix(
								_elm_lang$core$Date$day(date));
						default:
							return '';
					}
				case 'D':
					var _p12 = length;
					switch (_p12) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$ordinalDay(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_justinmimbs$elm_date_extra$Date_Internal_Extract$ordinalDay(date)));
						case 3:
							return A3(
								_elm_lang$core$String$padLeft,
								3,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_justinmimbs$elm_date_extra$Date_Internal_Extract$ordinalDay(date)));
						default:
							return '';
					}
				case 'E':
					var _p13 = _justinmimbs$elm_date_extra$Date_Internal_Format$nameForm(length);
					switch (_p13) {
						case 'abbreviated':
							return A2(
								_elm_lang$core$String$left,
								3,
								_justinmimbs$elm_date_extra$Date_Internal_Format$dayOfWeekName(
									_elm_lang$core$Date$dayOfWeek(date)));
						case 'full':
							return _justinmimbs$elm_date_extra$Date_Internal_Format$dayOfWeekName(
								_elm_lang$core$Date$dayOfWeek(date));
						case 'narrow':
							return A2(
								_elm_lang$core$String$left,
								1,
								_justinmimbs$elm_date_extra$Date_Internal_Format$dayOfWeekName(
									_elm_lang$core$Date$dayOfWeek(date)));
						case 'short':
							return A2(
								_elm_lang$core$String$left,
								2,
								_justinmimbs$elm_date_extra$Date_Internal_Format$dayOfWeekName(
									_elm_lang$core$Date$dayOfWeek(date)));
						default:
							return '';
					}
				case 'e':
					var _p14 = length;
					switch (_p14) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$weekdayNumber(date));
						case 2:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Extract$weekdayNumber(date));
						default:
							var _v15 = asUtc,
								_v16 = date,
								_v17 = _elm_lang$core$String$toUpper(match);
							asUtc = _v15;
							date = _v16;
							match = _v17;
							continue format;
					}
				case 'a':
					var p = _justinmimbs$elm_date_extra$Date_Internal_Format$dayPeriod(date);
					var m = (_elm_lang$core$Native_Utils.eq(p, _justinmimbs$elm_date_extra$Date_Internal_Format$Midnight) || _elm_lang$core$Native_Utils.eq(p, _justinmimbs$elm_date_extra$Date_Internal_Format$AM)) ? 'A' : 'P';
					var _p15 = _justinmimbs$elm_date_extra$Date_Internal_Format$nameForm(length);
					switch (_p15) {
						case 'abbreviated':
							return A2(_elm_lang$core$Basics_ops['++'], m, 'M');
						case 'full':
							return A2(_elm_lang$core$Basics_ops['++'], m, '.M.');
						case 'narrow':
							return m;
						default:
							return '';
					}
				case 'b':
					var _p16 = _justinmimbs$elm_date_extra$Date_Internal_Format$nameForm(length);
					switch (_p16) {
						case 'abbreviated':
							var _p17 = _justinmimbs$elm_date_extra$Date_Internal_Format$dayPeriod(date);
							switch (_p17.ctor) {
								case 'Midnight':
									return 'mid.';
								case 'AM':
									return 'am';
								case 'Noon':
									return 'noon';
								default:
									return 'pm';
							}
						case 'full':
							var _p18 = _justinmimbs$elm_date_extra$Date_Internal_Format$dayPeriod(date);
							switch (_p18.ctor) {
								case 'Midnight':
									return 'midnight';
								case 'AM':
									return 'a.m.';
								case 'Noon':
									return 'noon';
								default:
									return 'p.m.';
							}
						case 'narrow':
							var _p19 = _justinmimbs$elm_date_extra$Date_Internal_Format$dayPeriod(date);
							switch (_p19.ctor) {
								case 'Midnight':
									return 'md';
								case 'AM':
									return 'a';
								case 'Noon':
									return 'nn';
								default:
									return 'p';
							}
						default:
							return '';
					}
				case 'h':
					var _p20 = length;
					switch (_p20) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_justinmimbs$elm_date_extra$Date_Internal_Format$hour12(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_justinmimbs$elm_date_extra$Date_Internal_Format$hour12(date)));
						default:
							return '';
					}
				case 'H':
					var _p21 = length;
					switch (_p21) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_elm_lang$core$Date$hour(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Date$hour(date)));
						default:
							return '';
					}
				case 'm':
					var _p22 = length;
					switch (_p22) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_elm_lang$core$Date$minute(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Date$minute(date)));
						default:
							return '';
					}
				case 's':
					var _p23 = length;
					switch (_p23) {
						case 1:
							return _elm_lang$core$Basics$toString(
								_elm_lang$core$Date$second(date));
						case 2:
							return A3(
								_elm_lang$core$String$padLeft,
								2,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Date$second(date)));
						default:
							return '';
					}
				case 'S':
					return A3(
						_elm_lang$core$String$padRight,
						length,
						_elm_lang$core$Native_Utils.chr('0'),
						A2(
							_elm_lang$core$String$left,
							length,
							A3(
								_elm_lang$core$String$padLeft,
								3,
								_elm_lang$core$Native_Utils.chr('0'),
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Date$millisecond(date)))));
				case 'X':
					if ((_elm_lang$core$Native_Utils.cmp(length, 4) < 0) && (asUtc || _elm_lang$core$Native_Utils.eq(
						_justinmimbs$elm_date_extra$Date_Internal_Extract$offsetFromUtc(date),
						0))) {
						return 'Z';
					} else {
						var _v27 = asUtc,
							_v28 = date,
							_v29 = _elm_lang$core$String$toLower(match);
						asUtc = _v27;
						date = _v28;
						match = _v29;
						continue format;
					}
				case 'x':
					var offset = asUtc ? 0 : _justinmimbs$elm_date_extra$Date_Internal_Extract$offsetFromUtc(date);
					var _p24 = length;
					switch (_p24) {
						case 1:
							return A3(_justinmimbs$elm_date_extra$Date_Internal_Format$formatTimeOffset, '', true, offset);
						case 2:
							return A3(_justinmimbs$elm_date_extra$Date_Internal_Format$formatTimeOffset, '', false, offset);
						case 3:
							return A3(_justinmimbs$elm_date_extra$Date_Internal_Format$formatTimeOffset, ':', false, offset);
						default:
							return '';
					}
				case '\'':
					return _elm_lang$core$Native_Utils.eq(match, '\'\'') ? '\'' : A4(
						_elm_lang$core$Regex$replace,
						_elm_lang$core$Regex$All,
						_elm_lang$core$Regex$regex('\'\''),
						function (_p25) {
							return '\'';
						},
						A3(_elm_lang$core$String$slice, 1, -1, match));
				default:
					return '';
			}
		}
	});
var _justinmimbs$elm_date_extra$Date_Internal_Format$toFormattedString = F3(
	function (asUtc, pattern, date) {
		var date_ = asUtc ? _justinmimbs$elm_date_extra$Date_Internal_Format$toUtc(date) : date;
		return A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_justinmimbs$elm_date_extra$Date_Internal_Format$patternMatches,
			function (_p26) {
				return A3(
					_justinmimbs$elm_date_extra$Date_Internal_Format$format,
					asUtc,
					date_,
					function (_) {
						return _.match;
					}(_p26));
			},
			pattern);
	});

var _justinmimbs$elm_date_extra$Date_Internal_Parse$isoDateRegex = function () {
	var time = 'T(\\d{2})(?:(\\:)?(\\d{2})(?:\\10(\\d{2}))?)?(\\.\\d+)?(?:(Z)|(?:([+\\-])(\\d{2})(?:\\:?(\\d{2}))?))?';
	var ord = '\\-?(\\d{3})';
	var week = '(\\-)?W(\\d{2})(?:\\5(\\d))?';
	var cal = '(\\-)?(\\d{2})(?:\\2(\\d{2}))?';
	var year = '(\\d{4})';
	return _elm_lang$core$Regex$regex(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'^',
			A2(
				_elm_lang$core$Basics_ops['++'],
				year,
				A2(
					_elm_lang$core$Basics_ops['++'],
					'(?:',
					A2(
						_elm_lang$core$Basics_ops['++'],
						cal,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'|',
							A2(
								_elm_lang$core$Basics_ops['++'],
								week,
								A2(
									_elm_lang$core$Basics_ops['++'],
									'|',
									A2(
										_elm_lang$core$Basics_ops['++'],
										ord,
										A2(
											_elm_lang$core$Basics_ops['++'],
											')?',
											A2(
												_elm_lang$core$Basics_ops['++'],
												'(?:',
												A2(_elm_lang$core$Basics_ops['++'], time, ')?$'))))))))))));
}();
var _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToFloat = function (_p0) {
	return _elm_lang$core$Result$toMaybe(
		_elm_lang$core$String$toFloat(_p0));
};
var _justinmimbs$elm_date_extra$Date_Internal_Parse$msFromMatches = F4(
	function (timeHH, timeMM, timeSS, timeF) {
		var fractional = A2(
			_elm_lang$core$Maybe$withDefault,
			0.0,
			A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToFloat, timeF));
		var _p1 = function () {
			var _p2 = A2(
				_elm_lang$core$List$map,
				_elm_lang$core$Maybe$andThen(_justinmimbs$elm_date_extra$Date_Internal_Parse$stringToFloat),
				{
					ctor: '::',
					_0: timeHH,
					_1: {
						ctor: '::',
						_0: timeMM,
						_1: {
							ctor: '::',
							_0: timeSS,
							_1: {ctor: '[]'}
						}
					}
				});
			_v0_3:
			do {
				if (((_p2.ctor === '::') && (_p2._0.ctor === 'Just')) && (_p2._1.ctor === '::')) {
					if (_p2._1._0.ctor === 'Just') {
						if (_p2._1._1.ctor === '::') {
							if (_p2._1._1._0.ctor === 'Just') {
								if (_p2._1._1._1.ctor === '[]') {
									return {ctor: '_Tuple3', _0: _p2._0._0, _1: _p2._1._0._0, _2: _p2._1._1._0._0 + fractional};
								} else {
									break _v0_3;
								}
							} else {
								if (_p2._1._1._1.ctor === '[]') {
									return {ctor: '_Tuple3', _0: _p2._0._0, _1: _p2._1._0._0 + fractional, _2: 0.0};
								} else {
									break _v0_3;
								}
							}
						} else {
							break _v0_3;
						}
					} else {
						if (((_p2._1._1.ctor === '::') && (_p2._1._1._0.ctor === 'Nothing')) && (_p2._1._1._1.ctor === '[]')) {
							return {ctor: '_Tuple3', _0: _p2._0._0 + fractional, _1: 0.0, _2: 0.0};
						} else {
							break _v0_3;
						}
					}
				} else {
					break _v0_3;
				}
			} while(false);
			return {ctor: '_Tuple3', _0: 0.0, _1: 0.0, _2: 0.0};
		}();
		var hh = _p1._0;
		var mm = _p1._1;
		var ss = _p1._2;
		return _elm_lang$core$Basics$round(
			((hh * _elm_lang$core$Basics$toFloat(_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerHour)) + (mm * _elm_lang$core$Basics$toFloat(_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute))) + (ss * _elm_lang$core$Basics$toFloat(_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerSecond)));
	});
var _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt = function (_p3) {
	return _elm_lang$core$Result$toMaybe(
		_elm_lang$core$String$toInt(_p3));
};
var _justinmimbs$elm_date_extra$Date_Internal_Parse$unixTimeFromMatches = F6(
	function (yyyy, calMM, calDD, weekWW, weekD, ordDDD) {
		var y = A2(
			_elm_lang$core$Maybe$withDefault,
			1,
			_justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt(yyyy));
		var _p4 = {ctor: '_Tuple2', _0: calMM, _1: weekWW};
		_v1_2:
		do {
			if (_p4.ctor === '_Tuple2') {
				if (_p4._0.ctor === 'Just') {
					if (_p4._1.ctor === 'Nothing') {
						return A3(
							_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromCalendarDate,
							y,
							_justinmimbs$elm_date_extra$Date_Extra_Facts$monthFromMonthNumber(
								A2(
									_elm_lang$core$Maybe$withDefault,
									1,
									A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt, calMM))),
							A2(
								_elm_lang$core$Maybe$withDefault,
								1,
								A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt, calDD)));
					} else {
						break _v1_2;
					}
				} else {
					if (_p4._1.ctor === 'Just') {
						return A3(
							_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromWeekDate,
							y,
							A2(
								_elm_lang$core$Maybe$withDefault,
								1,
								A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt, weekWW)),
							A2(
								_elm_lang$core$Maybe$withDefault,
								1,
								A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt, weekD)));
					} else {
						break _v1_2;
					}
				}
			} else {
				break _v1_2;
			}
		} while(false);
		return A2(
			_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromOrdinalDate,
			y,
			A2(
				_elm_lang$core$Maybe$withDefault,
				1,
				A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt, ordDDD)));
	});
var _justinmimbs$elm_date_extra$Date_Internal_Parse$offsetFromMatches = F4(
	function (tzZ, tzSign, tzHH, tzMM) {
		var _p5 = {ctor: '_Tuple2', _0: tzZ, _1: tzSign};
		_v2_2:
		do {
			if (_p5.ctor === '_Tuple2') {
				if (_p5._0.ctor === 'Just') {
					if ((_p5._0._0 === 'Z') && (_p5._1.ctor === 'Nothing')) {
						return _elm_lang$core$Maybe$Just(0);
					} else {
						break _v2_2;
					}
				} else {
					if (_p5._1.ctor === 'Just') {
						var mm = A2(
							_elm_lang$core$Maybe$withDefault,
							0,
							A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt, tzMM));
						var hh = A2(
							_elm_lang$core$Maybe$withDefault,
							0,
							A2(_elm_lang$core$Maybe$andThen, _justinmimbs$elm_date_extra$Date_Internal_Parse$stringToInt, tzHH));
						return _elm_lang$core$Maybe$Just(
							(_elm_lang$core$Native_Utils.eq(_p5._1._0, '+') ? 1 : -1) * ((hh * 60) + mm));
					} else {
						break _v2_2;
					}
				}
			} else {
				break _v2_2;
			}
		} while(false);
		return _elm_lang$core$Maybe$Nothing;
	});
var _justinmimbs$elm_date_extra$Date_Internal_Parse$offsetTimeFromMatches = function (matches) {
	var _p6 = matches;
	if (((((((((((((((((((_p6.ctor === '::') && (_p6._0.ctor === 'Just')) && (_p6._1.ctor === '::')) && (_p6._1._1.ctor === '::')) && (_p6._1._1._1.ctor === '::')) && (_p6._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.ctor === '::')) && (_p6._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.ctor === '[]')) {
		var offset = A4(_justinmimbs$elm_date_extra$Date_Internal_Parse$offsetFromMatches, _p6._1._1._1._1._1._1._1._1._1._1._1._1._1._0, _p6._1._1._1._1._1._1._1._1._1._1._1._1._1._1._0, _p6._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._0, _p6._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._0);
		var timeMS = A4(_justinmimbs$elm_date_extra$Date_Internal_Parse$msFromMatches, _p6._1._1._1._1._1._1._1._1._0, _p6._1._1._1._1._1._1._1._1._1._1._0, _p6._1._1._1._1._1._1._1._1._1._1._1._0, _p6._1._1._1._1._1._1._1._1._1._1._1._1._0);
		var dateMS = A6(_justinmimbs$elm_date_extra$Date_Internal_Parse$unixTimeFromMatches, _p6._0._0, _p6._1._1._0, _p6._1._1._1._0, _p6._1._1._1._1._1._0, _p6._1._1._1._1._1._1._0, _p6._1._1._1._1._1._1._1._0);
		return _elm_lang$core$Maybe$Just(
			{ctor: '_Tuple2', _0: offset, _1: dateMS + timeMS});
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _justinmimbs$elm_date_extra$Date_Internal_Parse$offsetTimeFromIsoString = function (s) {
	return A2(
		_elm_lang$core$Maybe$andThen,
		_justinmimbs$elm_date_extra$Date_Internal_Parse$offsetTimeFromMatches,
		A2(
			_elm_lang$core$Maybe$map,
			function (_) {
				return _.submatches;
			},
			_elm_lang$core$List$head(
				A3(
					_elm_lang$core$Regex$find,
					_elm_lang$core$Regex$AtMost(1),
					_justinmimbs$elm_date_extra$Date_Internal_Parse$isoDateRegex,
					s))));
};

var _justinmimbs$elm_date_extra$Date_Extra$toRataDie = function (date) {
	return A3(
		_justinmimbs$elm_date_extra$Date_Internal_RataDie$fromCalendarDate,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date),
		_elm_lang$core$Date$day(date));
};
var _justinmimbs$elm_date_extra$Date_Extra$toParts = function (date) {
	return {
		ctor: '_Tuple7',
		_0: _elm_lang$core$Date$year(date),
		_1: _elm_lang$core$Date$month(date),
		_2: _elm_lang$core$Date$day(date),
		_3: _elm_lang$core$Date$hour(date),
		_4: _elm_lang$core$Date$minute(date),
		_5: _elm_lang$core$Date$second(date),
		_6: _elm_lang$core$Date$millisecond(date)
	};
};
var _justinmimbs$elm_date_extra$Date_Extra$monthFromQuarter = function (q) {
	var _p0 = q;
	switch (_p0) {
		case 1:
			return _elm_lang$core$Date$Jan;
		case 2:
			return _elm_lang$core$Date$Apr;
		case 3:
			return _elm_lang$core$Date$Jul;
		default:
			return _elm_lang$core$Date$Oct;
	}
};
var _justinmimbs$elm_date_extra$Date_Extra$clamp = F3(
	function (min, max, date) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$Date$toTime(date),
			_elm_lang$core$Date$toTime(min)) < 0) ? min : ((_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$Date$toTime(date),
			_elm_lang$core$Date$toTime(max)) > 0) ? max : date);
	});
var _justinmimbs$elm_date_extra$Date_Extra$comparableIsBetween = F3(
	function (a, b, x) {
		return ((_elm_lang$core$Native_Utils.cmp(a, x) < 1) && (_elm_lang$core$Native_Utils.cmp(x, b) < 1)) || ((_elm_lang$core$Native_Utils.cmp(b, x) < 1) && (_elm_lang$core$Native_Utils.cmp(x, a) < 1));
	});
var _justinmimbs$elm_date_extra$Date_Extra$isBetween = F3(
	function (date1, date2, date) {
		return A3(
			_justinmimbs$elm_date_extra$Date_Extra$comparableIsBetween,
			_elm_lang$core$Date$toTime(date1),
			_elm_lang$core$Date$toTime(date2),
			_elm_lang$core$Date$toTime(date));
	});
var _justinmimbs$elm_date_extra$Date_Extra$compare = F2(
	function (a, b) {
		return A2(
			_elm_lang$core$Basics$compare,
			_elm_lang$core$Date$toTime(a),
			_elm_lang$core$Date$toTime(b));
	});
var _justinmimbs$elm_date_extra$Date_Extra$equal = F2(
	function (a, b) {
		return _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$Date$toTime(a),
			_elm_lang$core$Date$toTime(b));
	});
var _justinmimbs$elm_date_extra$Date_Extra$offsetFromUtc = _justinmimbs$elm_date_extra$Date_Internal_Extract$offsetFromUtc;
var _justinmimbs$elm_date_extra$Date_Extra$weekYear = _justinmimbs$elm_date_extra$Date_Internal_Extract$weekYear;
var _justinmimbs$elm_date_extra$Date_Extra$weekNumber = _justinmimbs$elm_date_extra$Date_Internal_Extract$weekNumber;
var _justinmimbs$elm_date_extra$Date_Extra$weekdayNumber = _justinmimbs$elm_date_extra$Date_Internal_Extract$weekdayNumber;
var _justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek = F2(
	function (d, date) {
		return _elm_lang$core$Basics$negate(
			A2(
				_elm_lang$core$Basics_ops['%'],
				(_justinmimbs$elm_date_extra$Date_Extra$weekdayNumber(date) - _justinmimbs$elm_date_extra$Date_Extra_Facts$weekdayNumberFromDayOfWeek(d)) + 7,
				7));
	});
var _justinmimbs$elm_date_extra$Date_Extra$fractionalDay = _justinmimbs$elm_date_extra$Date_Internal_Extract$fractionalDay;
var _justinmimbs$elm_date_extra$Date_Extra$ordinalDay = _justinmimbs$elm_date_extra$Date_Internal_Extract$ordinalDay;
var _justinmimbs$elm_date_extra$Date_Extra$quarter = _justinmimbs$elm_date_extra$Date_Internal_Extract$quarter;
var _justinmimbs$elm_date_extra$Date_Extra$monthNumber = _justinmimbs$elm_date_extra$Date_Internal_Extract$monthNumber;
var _justinmimbs$elm_date_extra$Date_Extra$ordinalMonth = function (date) {
	return (_elm_lang$core$Date$year(date) * 12) + _justinmimbs$elm_date_extra$Date_Extra$monthNumber(date);
};
var _justinmimbs$elm_date_extra$Date_Extra$diffMonth = F2(
	function (date1, date2) {
		var fractionalMonth = function (date) {
			return (_elm_lang$core$Basics$toFloat(
				_elm_lang$core$Date$day(date) - 1) + _justinmimbs$elm_date_extra$Date_Extra$fractionalDay(date)) / 31;
		};
		var ordinalMonthFloat = function (date) {
			return _elm_lang$core$Basics$toFloat(
				_justinmimbs$elm_date_extra$Date_Extra$ordinalMonth(date)) + fractionalMonth(date);
		};
		return _elm_lang$core$Basics$truncate(
			ordinalMonthFloat(date2) - ordinalMonthFloat(date1));
	});
var _justinmimbs$elm_date_extra$Date_Extra$toUtcFormattedString = _justinmimbs$elm_date_extra$Date_Internal_Format$toFormattedString(true);
var _justinmimbs$elm_date_extra$Date_Extra$toUtcIsoString = _justinmimbs$elm_date_extra$Date_Extra$toUtcFormattedString('yyyy-MM-dd\'T\'HH:mm:ss.SSSXXX');
var _justinmimbs$elm_date_extra$Date_Extra$toFormattedString = _justinmimbs$elm_date_extra$Date_Internal_Format$toFormattedString(false);
var _justinmimbs$elm_date_extra$Date_Extra$toIsoString = _justinmimbs$elm_date_extra$Date_Extra$toFormattedString('yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx');
var _justinmimbs$elm_date_extra$Date_Extra$fromTime = function (_p1) {
	return _elm_lang$core$Date$fromTime(
		_elm_lang$core$Basics$toFloat(_p1));
};
var _justinmimbs$elm_date_extra$Date_Extra$fromOffsetTime = function (_p2) {
	var _p3 = _p2;
	var _p5 = _p3._1;
	var _p4 = _p3._0;
	if (_p4.ctor === 'Just') {
		return _justinmimbs$elm_date_extra$Date_Extra$fromTime(_p5 - (_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute * _p4._0));
	} else {
		var offset0 = _justinmimbs$elm_date_extra$Date_Extra$offsetFromUtc(
			_justinmimbs$elm_date_extra$Date_Extra$fromTime(_p5));
		var date1 = _justinmimbs$elm_date_extra$Date_Extra$fromTime(_p5 - (_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute * offset0));
		var offset1 = _justinmimbs$elm_date_extra$Date_Extra$offsetFromUtc(date1);
		if (_elm_lang$core$Native_Utils.eq(offset0, offset1)) {
			return date1;
		} else {
			var date2 = _justinmimbs$elm_date_extra$Date_Extra$fromTime(_p5 - (_justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute * offset1));
			var offset2 = _justinmimbs$elm_date_extra$Date_Extra$offsetFromUtc(date2);
			return _elm_lang$core$Native_Utils.eq(offset1, offset2) ? date2 : date1;
		}
	}
};
var _justinmimbs$elm_date_extra$Date_Extra$fromParts = F7(
	function (y, m, d, hh, mm, ss, ms) {
		return _justinmimbs$elm_date_extra$Date_Extra$fromOffsetTime(
			{
				ctor: '_Tuple2',
				_0: _elm_lang$core$Maybe$Nothing,
				_1: A7(_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromParts, y, m, d, hh, mm, ss, ms)
			});
	});
var _justinmimbs$elm_date_extra$Date_Extra$addMonths = F2(
	function (n, date) {
		var om = (_justinmimbs$elm_date_extra$Date_Extra$ordinalMonth(date) + n) + -1;
		var y_ = (om / 12) | 0;
		var m_ = _justinmimbs$elm_date_extra$Date_Extra_Facts$monthFromMonthNumber(
			A2(_elm_lang$core$Basics_ops['%'], om, 12) + 1);
		var _p6 = _justinmimbs$elm_date_extra$Date_Extra$toParts(date);
		var y = _p6._0;
		var m = _p6._1;
		var d = _p6._2;
		var hh = _p6._3;
		var mm = _p6._4;
		var ss = _p6._5;
		var ms = _p6._6;
		var d_ = A2(
			_elm_lang$core$Basics$min,
			d,
			A2(_justinmimbs$elm_date_extra$Date_Extra_Facts$daysInMonth, y_, m_));
		return A7(_justinmimbs$elm_date_extra$Date_Extra$fromParts, y_, m_, d_, hh, mm, ss, ms);
	});
var _justinmimbs$elm_date_extra$Date_Extra$add = F3(
	function (interval, n, date) {
		var _p7 = _justinmimbs$elm_date_extra$Date_Extra$toParts(date);
		var y = _p7._0;
		var m = _p7._1;
		var d = _p7._2;
		var hh = _p7._3;
		var mm = _p7._4;
		var ss = _p7._5;
		var ms = _p7._6;
		var _p8 = interval;
		switch (_p8.ctor) {
			case 'Millisecond':
				return _elm_lang$core$Date$fromTime(
					_elm_lang$core$Date$toTime(date) + _elm_lang$core$Basics$toFloat(n));
			case 'Second':
				return _elm_lang$core$Date$fromTime(
					_elm_lang$core$Date$toTime(date) + _elm_lang$core$Basics$toFloat(n * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerSecond));
			case 'Minute':
				return _elm_lang$core$Date$fromTime(
					_elm_lang$core$Date$toTime(date) + _elm_lang$core$Basics$toFloat(n * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute));
			case 'Hour':
				return _elm_lang$core$Date$fromTime(
					_elm_lang$core$Date$toTime(date) + _elm_lang$core$Basics$toFloat(n * _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerHour));
			case 'Day':
				return A7(_justinmimbs$elm_date_extra$Date_Extra$fromParts, y, m, d + n, hh, mm, ss, ms);
			case 'Month':
				return A2(_justinmimbs$elm_date_extra$Date_Extra$addMonths, n, date);
			case 'Year':
				return A2(_justinmimbs$elm_date_extra$Date_Extra$addMonths, n * 12, date);
			case 'Quarter':
				return A2(_justinmimbs$elm_date_extra$Date_Extra$addMonths, n * 3, date);
			case 'Week':
				return A7(_justinmimbs$elm_date_extra$Date_Extra$fromParts, y, m, d + (n * 7), hh, mm, ss, ms);
			default:
				return A7(_justinmimbs$elm_date_extra$Date_Extra$fromParts, y, m, d + (n * 7), hh, mm, ss, ms);
		}
	});
var _justinmimbs$elm_date_extra$Date_Extra$rangeHelp = F5(
	function (interval, step, end, revList, date) {
		rangeHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(
				_elm_lang$core$Date$toTime(date),
				_elm_lang$core$Date$toTime(end)) < 0) {
				var _v4 = interval,
					_v5 = step,
					_v6 = end,
					_v7 = {ctor: '::', _0: date, _1: revList},
					_v8 = A3(_justinmimbs$elm_date_extra$Date_Extra$add, interval, step, date);
				interval = _v4;
				step = _v5;
				end = _v6;
				revList = _v7;
				date = _v8;
				continue rangeHelp;
			} else {
				return _elm_lang$core$List$reverse(revList);
			}
		}
	});
var _justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate = F3(
	function (y, m, d) {
		return _justinmimbs$elm_date_extra$Date_Extra$fromOffsetTime(
			{
				ctor: '_Tuple2',
				_0: _elm_lang$core$Maybe$Nothing,
				_1: A3(_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromCalendarDate, y, m, d)
			});
	});
var _justinmimbs$elm_date_extra$Date_Extra$floor = F2(
	function (interval, date) {
		var _p9 = _justinmimbs$elm_date_extra$Date_Extra$toParts(date);
		var y = _p9._0;
		var m = _p9._1;
		var d = _p9._2;
		var hh = _p9._3;
		var mm = _p9._4;
		var ss = _p9._5;
		var _p10 = interval;
		switch (_p10.ctor) {
			case 'Millisecond':
				return date;
			case 'Second':
				return A7(_justinmimbs$elm_date_extra$Date_Extra$fromParts, y, m, d, hh, mm, ss, 0);
			case 'Minute':
				return A7(_justinmimbs$elm_date_extra$Date_Extra$fromParts, y, m, d, hh, mm, 0, 0);
			case 'Hour':
				return A7(_justinmimbs$elm_date_extra$Date_Extra$fromParts, y, m, d, hh, 0, 0, 0);
			case 'Day':
				return A3(_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate, y, m, d);
			case 'Month':
				return A3(_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate, y, m, 1);
			case 'Year':
				return A3(_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate, y, _elm_lang$core$Date$Jan, 1);
			case 'Quarter':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					_justinmimbs$elm_date_extra$Date_Extra$monthFromQuarter(
						_justinmimbs$elm_date_extra$Date_Extra$quarter(date)),
					1);
			case 'Week':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Mon, date));
			case 'Monday':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Mon, date));
			case 'Tuesday':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Tue, date));
			case 'Wednesday':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Wed, date));
			case 'Thursday':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Thu, date));
			case 'Friday':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Fri, date));
			case 'Saturday':
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Sat, date));
			default:
				return A3(
					_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate,
					y,
					m,
					d + A2(_justinmimbs$elm_date_extra$Date_Extra$daysToPreviousDayOfWeek, _elm_lang$core$Date$Sun, date));
		}
	});
var _justinmimbs$elm_date_extra$Date_Extra$ceiling = F2(
	function (interval, date) {
		var floored = A2(_justinmimbs$elm_date_extra$Date_Extra$floor, interval, date);
		return _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$Date$toTime(date),
			_elm_lang$core$Date$toTime(floored)) ? date : A3(_justinmimbs$elm_date_extra$Date_Extra$add, interval, 1, floored);
	});
var _justinmimbs$elm_date_extra$Date_Extra$range = F4(
	function (interval, step, start, end) {
		var first = A2(_justinmimbs$elm_date_extra$Date_Extra$ceiling, interval, start);
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$Date$toTime(first),
			_elm_lang$core$Date$toTime(end)) < 0) ? A5(
			_justinmimbs$elm_date_extra$Date_Extra$rangeHelp,
			interval,
			A2(_elm_lang$core$Basics$max, 1, step),
			end,
			{ctor: '[]'},
			first) : {ctor: '[]'};
	});
var _justinmimbs$elm_date_extra$Date_Extra$fromIsoString = function (_p11) {
	return A2(
		_elm_lang$core$Maybe$map,
		_justinmimbs$elm_date_extra$Date_Extra$fromOffsetTime,
		_justinmimbs$elm_date_extra$Date_Internal_Parse$offsetTimeFromIsoString(_p11));
};
var _justinmimbs$elm_date_extra$Date_Extra$fromSpec = F3(
	function (_p14, _p13, _p12) {
		var _p15 = _p14;
		var _p16 = _p13;
		var _p17 = _p12;
		return _justinmimbs$elm_date_extra$Date_Extra$fromOffsetTime(
			{ctor: '_Tuple2', _0: _p15._0, _1: _p17._0 + _p16._0});
	});
var _justinmimbs$elm_date_extra$Date_Extra$Offset = function (a) {
	return {ctor: 'Offset', _0: a};
};
var _justinmimbs$elm_date_extra$Date_Extra$utc = _justinmimbs$elm_date_extra$Date_Extra$Offset(
	_elm_lang$core$Maybe$Just(0));
var _justinmimbs$elm_date_extra$Date_Extra$offset = function (minutes) {
	return _justinmimbs$elm_date_extra$Date_Extra$Offset(
		_elm_lang$core$Maybe$Just(minutes));
};
var _justinmimbs$elm_date_extra$Date_Extra$local = _justinmimbs$elm_date_extra$Date_Extra$Offset(_elm_lang$core$Maybe$Nothing);
var _justinmimbs$elm_date_extra$Date_Extra$TimeMS = function (a) {
	return {ctor: 'TimeMS', _0: a};
};
var _justinmimbs$elm_date_extra$Date_Extra$noTime = _justinmimbs$elm_date_extra$Date_Extra$TimeMS(0);
var _justinmimbs$elm_date_extra$Date_Extra$atTime = F4(
	function (hh, mm, ss, ms) {
		return _justinmimbs$elm_date_extra$Date_Extra$TimeMS(
			A4(_justinmimbs$elm_date_extra$Date_Internal_Core$msFromTimeParts, hh, mm, ss, ms));
	});
var _justinmimbs$elm_date_extra$Date_Extra$DateMS = function (a) {
	return {ctor: 'DateMS', _0: a};
};
var _justinmimbs$elm_date_extra$Date_Extra$calendarDate = F3(
	function (y, m, d) {
		return _justinmimbs$elm_date_extra$Date_Extra$DateMS(
			A3(_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromCalendarDate, y, m, d));
	});
var _justinmimbs$elm_date_extra$Date_Extra$ordinalDate = F2(
	function (y, d) {
		return _justinmimbs$elm_date_extra$Date_Extra$DateMS(
			A2(_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromOrdinalDate, y, d));
	});
var _justinmimbs$elm_date_extra$Date_Extra$weekDate = F3(
	function (y, w, d) {
		return _justinmimbs$elm_date_extra$Date_Extra$DateMS(
			A3(_justinmimbs$elm_date_extra$Date_Internal_Core$unixTimeFromWeekDate, y, w, d));
	});
var _justinmimbs$elm_date_extra$Date_Extra$Sunday = {ctor: 'Sunday'};
var _justinmimbs$elm_date_extra$Date_Extra$Saturday = {ctor: 'Saturday'};
var _justinmimbs$elm_date_extra$Date_Extra$Friday = {ctor: 'Friday'};
var _justinmimbs$elm_date_extra$Date_Extra$Thursday = {ctor: 'Thursday'};
var _justinmimbs$elm_date_extra$Date_Extra$Wednesday = {ctor: 'Wednesday'};
var _justinmimbs$elm_date_extra$Date_Extra$Tuesday = {ctor: 'Tuesday'};
var _justinmimbs$elm_date_extra$Date_Extra$Monday = {ctor: 'Monday'};
var _justinmimbs$elm_date_extra$Date_Extra$Week = {ctor: 'Week'};
var _justinmimbs$elm_date_extra$Date_Extra$Quarter = {ctor: 'Quarter'};
var _justinmimbs$elm_date_extra$Date_Extra$Year = {ctor: 'Year'};
var _justinmimbs$elm_date_extra$Date_Extra$Month = {ctor: 'Month'};
var _justinmimbs$elm_date_extra$Date_Extra$Day = {ctor: 'Day'};
var _justinmimbs$elm_date_extra$Date_Extra$diff = F3(
	function (interval, date1, date2) {
		var diffMS = _elm_lang$core$Basics$floor(
			_elm_lang$core$Date$toTime(date2) - _elm_lang$core$Date$toTime(date1));
		var _p18 = interval;
		switch (_p18.ctor) {
			case 'Millisecond':
				return diffMS;
			case 'Second':
				return (diffMS / _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerSecond) | 0;
			case 'Minute':
				return (diffMS / _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerMinute) | 0;
			case 'Hour':
				return (diffMS / _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerHour) | 0;
			case 'Day':
				return (diffMS / _justinmimbs$elm_date_extra$Date_Extra_Facts$msPerDay) | 0;
			case 'Month':
				return A2(_justinmimbs$elm_date_extra$Date_Extra$diffMonth, date1, date2);
			case 'Year':
				return (A2(_justinmimbs$elm_date_extra$Date_Extra$diffMonth, date1, date2) / 12) | 0;
			case 'Quarter':
				return (A2(_justinmimbs$elm_date_extra$Date_Extra$diffMonth, date1, date2) / 3) | 0;
			case 'Week':
				return (A3(_justinmimbs$elm_date_extra$Date_Extra$diff, _justinmimbs$elm_date_extra$Date_Extra$Day, date1, date2) / 7) | 0;
			default:
				var _p19 = _p18;
				return (A3(
					_justinmimbs$elm_date_extra$Date_Extra$diff,
					_justinmimbs$elm_date_extra$Date_Extra$Day,
					A2(_justinmimbs$elm_date_extra$Date_Extra$floor, _p19, date1),
					A2(_justinmimbs$elm_date_extra$Date_Extra$floor, _p19, date2)) / 7) | 0;
		}
	});
var _justinmimbs$elm_date_extra$Date_Extra$fromRataDie = function (rd) {
	return A3(
		_justinmimbs$elm_date_extra$Date_Extra$add,
		_justinmimbs$elm_date_extra$Date_Extra$Day,
		rd - 719163,
		A3(_justinmimbs$elm_date_extra$Date_Extra$fromCalendarDate, 1970, _elm_lang$core$Date$Jan, 1));
};
var _justinmimbs$elm_date_extra$Date_Extra$Hour = {ctor: 'Hour'};
var _justinmimbs$elm_date_extra$Date_Extra$Minute = {ctor: 'Minute'};
var _justinmimbs$elm_date_extra$Date_Extra$equalBy = F3(
	function (interval, date1, date2) {
		equalBy:
		while (true) {
			var _p20 = interval;
			switch (_p20.ctor) {
				case 'Millisecond':
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$toTime(date1),
						_elm_lang$core$Date$toTime(date2));
				case 'Second':
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$second(date1),
						_elm_lang$core$Date$second(date2)) && A3(_justinmimbs$elm_date_extra$Date_Extra$equalBy, _justinmimbs$elm_date_extra$Date_Extra$Minute, date1, date2);
				case 'Minute':
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$minute(date1),
						_elm_lang$core$Date$minute(date2)) && A3(_justinmimbs$elm_date_extra$Date_Extra$equalBy, _justinmimbs$elm_date_extra$Date_Extra$Hour, date1, date2);
				case 'Hour':
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$hour(date1),
						_elm_lang$core$Date$hour(date2)) && A3(_justinmimbs$elm_date_extra$Date_Extra$equalBy, _justinmimbs$elm_date_extra$Date_Extra$Day, date1, date2);
				case 'Day':
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$day(date1),
						_elm_lang$core$Date$day(date2)) && A3(_justinmimbs$elm_date_extra$Date_Extra$equalBy, _justinmimbs$elm_date_extra$Date_Extra$Month, date1, date2);
				case 'Month':
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$month(date1),
						_elm_lang$core$Date$month(date2)) && A3(_justinmimbs$elm_date_extra$Date_Extra$equalBy, _justinmimbs$elm_date_extra$Date_Extra$Year, date1, date2);
				case 'Year':
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$Date$year(date1),
						_elm_lang$core$Date$year(date2));
				case 'Quarter':
					return _elm_lang$core$Native_Utils.eq(
						_justinmimbs$elm_date_extra$Date_Extra$quarter(date1),
						_justinmimbs$elm_date_extra$Date_Extra$quarter(date2)) && A3(_justinmimbs$elm_date_extra$Date_Extra$equalBy, _justinmimbs$elm_date_extra$Date_Extra$Year, date1, date2);
				case 'Week':
					return _elm_lang$core$Native_Utils.eq(
						_justinmimbs$elm_date_extra$Date_Extra$weekNumber(date1),
						_justinmimbs$elm_date_extra$Date_Extra$weekNumber(date2)) && _elm_lang$core$Native_Utils.eq(
						_justinmimbs$elm_date_extra$Date_Extra$weekYear(date1),
						_justinmimbs$elm_date_extra$Date_Extra$weekYear(date2));
				default:
					var _p21 = _p20;
					var _v15 = _justinmimbs$elm_date_extra$Date_Extra$Day,
						_v16 = A2(_justinmimbs$elm_date_extra$Date_Extra$floor, _p21, date1),
						_v17 = A2(_justinmimbs$elm_date_extra$Date_Extra$floor, _p21, date2);
					interval = _v15;
					date1 = _v16;
					date2 = _v17;
					continue equalBy;
			}
		}
	});
var _justinmimbs$elm_date_extra$Date_Extra$Second = {ctor: 'Second'};
var _justinmimbs$elm_date_extra$Date_Extra$Millisecond = {ctor: 'Millisecond'};

var _mdgriffith$style_elements$Style_Internal_Model$StyleSheet = F3(
	function (a, b, c) {
		return {style: a, variations: b, css: c};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Reset = function (a) {
	return {ctor: 'Reset', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Import = function (a) {
	return {ctor: 'Import', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$RawStyle = F2(
	function (a, b) {
		return {ctor: 'RawStyle', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Style = F2(
	function (a, b) {
		return {ctor: 'Style', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Transitions = function (a) {
	return {ctor: 'Transitions', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$TextColor = function (a) {
	return {ctor: 'TextColor', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$SelectionColor = function (a) {
	return {ctor: 'SelectionColor', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Visibility = function (a) {
	return {ctor: 'Visibility', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Filters = function (a) {
	return {ctor: 'Filters', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Transform = function (a) {
	return {ctor: 'Transform', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Shadows = function (a) {
	return {ctor: 'Shadows', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Background = function (a) {
	return {ctor: 'Background', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Layout = function (a) {
	return {ctor: 'Layout', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$FontFamily = function (a) {
	return {ctor: 'FontFamily', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Font = F2(
	function (a, b) {
		return {ctor: 'Font', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Position = function (a) {
	return {ctor: 'Position', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$PseudoElement = F2(
	function (a, b) {
		return {ctor: 'PseudoElement', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$MediaQuery = F2(
	function (a, b) {
		return {ctor: 'MediaQuery', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Child = F2(
	function (a, b) {
		return {ctor: 'Child', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Variation = F2(
	function (a, b) {
		return {ctor: 'Variation', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Exact = F2(
	function (a, b) {
		return {ctor: 'Exact', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$mapPropClass = F2(
	function (fn, prop) {
		var _p0 = prop;
		switch (_p0.ctor) {
			case 'Child':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$Child,
					fn(_p0._0),
					A2(
						_elm_lang$core$List$map,
						_mdgriffith$style_elements$Style_Internal_Model$mapPropClass(fn),
						_p0._1));
			case 'Variation':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$Variation,
					_p0._0,
					A2(
						_elm_lang$core$List$map,
						_mdgriffith$style_elements$Style_Internal_Model$mapPropClass(fn),
						_p0._1));
			case 'Exact':
				return A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, _p0._0, _p0._1);
			case 'Position':
				return _mdgriffith$style_elements$Style_Internal_Model$Position(_p0._0);
			case 'Font':
				return A2(_mdgriffith$style_elements$Style_Internal_Model$Font, _p0._0, _p0._1);
			case 'Layout':
				return _mdgriffith$style_elements$Style_Internal_Model$Layout(_p0._0);
			case 'Background':
				return _mdgriffith$style_elements$Style_Internal_Model$Background(_p0._0);
			case 'MediaQuery':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$MediaQuery,
					_p0._0,
					A2(
						_elm_lang$core$List$map,
						_mdgriffith$style_elements$Style_Internal_Model$mapPropClass(fn),
						_p0._1));
			case 'PseudoElement':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$PseudoElement,
					_p0._0,
					A2(
						_elm_lang$core$List$map,
						_mdgriffith$style_elements$Style_Internal_Model$mapPropClass(fn),
						_p0._1));
			case 'Shadows':
				return _mdgriffith$style_elements$Style_Internal_Model$Shadows(_p0._0);
			case 'Transform':
				return _mdgriffith$style_elements$Style_Internal_Model$Transform(_p0._0);
			case 'Filters':
				return _mdgriffith$style_elements$Style_Internal_Model$Filters(_p0._0);
			case 'Visibility':
				return _mdgriffith$style_elements$Style_Internal_Model$Visibility(_p0._0);
			case 'TextColor':
				return _mdgriffith$style_elements$Style_Internal_Model$TextColor(_p0._0);
			case 'Transitions':
				return _mdgriffith$style_elements$Style_Internal_Model$Transitions(_p0._0);
			case 'SelectionColor':
				return _mdgriffith$style_elements$Style_Internal_Model$SelectionColor(_p0._0);
			default:
				return _mdgriffith$style_elements$Style_Internal_Model$FontFamily(_p0._0);
		}
	});
var _mdgriffith$style_elements$Style_Internal_Model$mapPropClassAndVar = F3(
	function (fn, fnVar, prop) {
		var _p1 = prop;
		switch (_p1.ctor) {
			case 'Child':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$Child,
					fn(_p1._0),
					A2(
						_elm_lang$core$List$map,
						A2(_mdgriffith$style_elements$Style_Internal_Model$mapPropClassAndVar, fn, fnVar),
						_p1._1));
			case 'Variation':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$Variation,
					fnVar(_p1._0),
					A2(
						_elm_lang$core$List$map,
						_mdgriffith$style_elements$Style_Internal_Model$mapPropClass(fn),
						_p1._1));
			case 'Exact':
				return A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, _p1._0, _p1._1);
			case 'Position':
				return _mdgriffith$style_elements$Style_Internal_Model$Position(_p1._0);
			case 'Font':
				return A2(_mdgriffith$style_elements$Style_Internal_Model$Font, _p1._0, _p1._1);
			case 'Layout':
				return _mdgriffith$style_elements$Style_Internal_Model$Layout(_p1._0);
			case 'Background':
				return _mdgriffith$style_elements$Style_Internal_Model$Background(_p1._0);
			case 'MediaQuery':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$MediaQuery,
					_p1._0,
					A2(
						_elm_lang$core$List$map,
						A2(_mdgriffith$style_elements$Style_Internal_Model$mapPropClassAndVar, fn, fnVar),
						_p1._1));
			case 'PseudoElement':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$PseudoElement,
					_p1._0,
					A2(
						_elm_lang$core$List$map,
						A2(_mdgriffith$style_elements$Style_Internal_Model$mapPropClassAndVar, fn, fnVar),
						_p1._1));
			case 'Shadows':
				return _mdgriffith$style_elements$Style_Internal_Model$Shadows(_p1._0);
			case 'Transform':
				return _mdgriffith$style_elements$Style_Internal_Model$Transform(_p1._0);
			case 'Filters':
				return _mdgriffith$style_elements$Style_Internal_Model$Filters(_p1._0);
			case 'Visibility':
				return _mdgriffith$style_elements$Style_Internal_Model$Visibility(_p1._0);
			case 'TextColor':
				return _mdgriffith$style_elements$Style_Internal_Model$TextColor(_p1._0);
			case 'Transitions':
				return _mdgriffith$style_elements$Style_Internal_Model$Transitions(_p1._0);
			case 'SelectionColor':
				return _mdgriffith$style_elements$Style_Internal_Model$SelectionColor(_p1._0);
			default:
				return _mdgriffith$style_elements$Style_Internal_Model$FontFamily(_p1._0);
		}
	});
var _mdgriffith$style_elements$Style_Internal_Model$mapClassAndVar = F3(
	function (fn, fnVariation, style) {
		var _p2 = style;
		switch (_p2.ctor) {
			case 'Style':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Model$Style,
					fn(_p2._0),
					A2(
						_elm_lang$core$List$map,
						A2(_mdgriffith$style_elements$Style_Internal_Model$mapPropClassAndVar, fn, fnVariation),
						_p2._1));
			case 'Import':
				return _mdgriffith$style_elements$Style_Internal_Model$Import(_p2._0);
			case 'RawStyle':
				return A2(_mdgriffith$style_elements$Style_Internal_Model$RawStyle, _p2._0, _p2._1);
			default:
				return _mdgriffith$style_elements$Style_Internal_Model$Reset(_p2._0);
		}
	});
var _mdgriffith$style_elements$Style_Internal_Model$ImportFont = F2(
	function (a, b) {
		return {ctor: 'ImportFont', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$FontName = function (a) {
	return {ctor: 'FontName', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Monospace = {ctor: 'Monospace'};
var _mdgriffith$style_elements$Style_Internal_Model$Fantasy = {ctor: 'Fantasy'};
var _mdgriffith$style_elements$Style_Internal_Model$Cursive = {ctor: 'Cursive'};
var _mdgriffith$style_elements$Style_Internal_Model$SansSerif = {ctor: 'SansSerif'};
var _mdgriffith$style_elements$Style_Internal_Model$Serif = {ctor: 'Serif'};
var _mdgriffith$style_elements$Style_Internal_Model$BackgroundSize = function (a) {
	return {ctor: 'BackgroundSize', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$BackgroundHeight = function (a) {
	return {ctor: 'BackgroundHeight', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$BackgroundWidth = function (a) {
	return {ctor: 'BackgroundWidth', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Cover = {ctor: 'Cover'};
var _mdgriffith$style_elements$Style_Internal_Model$Contain = {ctor: 'Contain'};
var _mdgriffith$style_elements$Style_Internal_Model$Transition = function (a) {
	return {ctor: 'Transition', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Opacity = function (a) {
	return {ctor: 'Opacity', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Invisible = {ctor: 'Invisible'};
var _mdgriffith$style_elements$Style_Internal_Model$Hidden = {ctor: 'Hidden'};
var _mdgriffith$style_elements$Style_Internal_Model$Float = function (a) {
	return {ctor: 'Float', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Inline = {ctor: 'Inline'};
var _mdgriffith$style_elements$Style_Internal_Model$ZIndex = function (a) {
	return {ctor: 'ZIndex', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$PosBottom = function (a) {
	return {ctor: 'PosBottom', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$PosTop = function (a) {
	return {ctor: 'PosTop', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$PosRight = function (a) {
	return {ctor: 'PosRight', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$PosLeft = function (a) {
	return {ctor: 'PosLeft', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$RelativeTo = function (a) {
	return {ctor: 'RelativeTo', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Parent = {ctor: 'Parent'};
var _mdgriffith$style_elements$Style_Internal_Model$Current = {ctor: 'Current'};
var _mdgriffith$style_elements$Style_Internal_Model$Screen = {ctor: 'Screen'};
var _mdgriffith$style_elements$Style_Internal_Model$FloatTopRight = {ctor: 'FloatTopRight'};
var _mdgriffith$style_elements$Style_Internal_Model$FloatTopLeft = {ctor: 'FloatTopLeft'};
var _mdgriffith$style_elements$Style_Internal_Model$FloatRight = {ctor: 'FloatRight'};
var _mdgriffith$style_elements$Style_Internal_Model$FloatLeft = {ctor: 'FloatLeft'};
var _mdgriffith$style_elements$Style_Internal_Model$BoxProp = F2(
	function (a, b) {
		return {ctor: 'BoxProp', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Grid = F2(
	function (a, b) {
		return {ctor: 'Grid', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$FlexLayout = F2(
	function (a, b) {
		return {ctor: 'FlexLayout', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$TextLayout = function (a) {
	return {ctor: 'TextLayout', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Vert = function (a) {
	return {ctor: 'Vert', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Horz = function (a) {
	return {ctor: 'Horz', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Wrap = function (a) {
	return {ctor: 'Wrap', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$GridGap = F2(
	function (a, b) {
		return {ctor: 'GridGap', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$GridV = function (a) {
	return {ctor: 'GridV', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$GridH = function (a) {
	return {ctor: 'GridH', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$NamedGridTemplate = function (a) {
	return {ctor: 'NamedGridTemplate', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$GridTemplate = function (a) {
	return {ctor: 'GridTemplate', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$GridPosition = function (a) {
	return {ctor: 'GridPosition', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Named = F2(
	function (a, b) {
		return {ctor: 'Named', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$SpanJust = function (a) {
	return {ctor: 'SpanJust', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$SpanAll = {ctor: 'SpanAll'};
var _mdgriffith$style_elements$Style_Internal_Model$BackgroundLinearGradient = F2(
	function (a, b) {
		return {ctor: 'BackgroundLinearGradient', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$BackgroundElement = F2(
	function (a, b) {
		return {ctor: 'BackgroundElement', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$BackgroundImage = function (a) {
	return {ctor: 'BackgroundImage', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$ToAngle = function (a) {
	return {ctor: 'ToAngle', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$ToBottomLeft = {ctor: 'ToBottomLeft'};
var _mdgriffith$style_elements$Style_Internal_Model$ToTopLeft = {ctor: 'ToTopLeft'};
var _mdgriffith$style_elements$Style_Internal_Model$ToLeft = {ctor: 'ToLeft'};
var _mdgriffith$style_elements$Style_Internal_Model$ToBottomRight = {ctor: 'ToBottomRight'};
var _mdgriffith$style_elements$Style_Internal_Model$ToTopRight = {ctor: 'ToTopRight'};
var _mdgriffith$style_elements$Style_Internal_Model$ToRight = {ctor: 'ToRight'};
var _mdgriffith$style_elements$Style_Internal_Model$ToDown = {ctor: 'ToDown'};
var _mdgriffith$style_elements$Style_Internal_Model$ToUp = {ctor: 'ToUp'};
var _mdgriffith$style_elements$Style_Internal_Model$PxStep = F2(
	function (a, b) {
		return {ctor: 'PxStep', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$PercentStep = F2(
	function (a, b) {
		return {ctor: 'PercentStep', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$ColorStep = function (a) {
	return {ctor: 'ColorStep', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$ShadowModel = function (a) {
	return {ctor: 'ShadowModel', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$DropShadow = function (a) {
	return {ctor: 'DropShadow', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Sepia = function (a) {
	return {ctor: 'Sepia', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Saturate = function (a) {
	return {ctor: 'Saturate', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$OpacityFilter = function (a) {
	return {ctor: 'OpacityFilter', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Invert = function (a) {
	return {ctor: 'Invert', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$HueRotate = function (a) {
	return {ctor: 'HueRotate', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Grayscale = function (a) {
	return {ctor: 'Grayscale', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Contrast = function (a) {
	return {ctor: 'Contrast', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Brightness = function (a) {
	return {ctor: 'Brightness', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Blur = function (a) {
	return {ctor: 'Blur', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$FilterUrl = function (a) {
	return {ctor: 'FilterUrl', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Scale = F3(
	function (a, b, c) {
		return {ctor: 'Scale', _0: a, _1: b, _2: c};
	});
var _mdgriffith$style_elements$Style_Internal_Model$RotateAround = F4(
	function (a, b, c, d) {
		return {ctor: 'RotateAround', _0: a, _1: b, _2: c, _3: d};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Rotate = function (a) {
	return {ctor: 'Rotate', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Translate = F3(
	function (a, b, c) {
		return {ctor: 'Translate', _0: a, _1: b, _2: c};
	});
var _mdgriffith$style_elements$Style_Internal_Model$NoRepeat = {ctor: 'NoRepeat'};
var _mdgriffith$style_elements$Style_Internal_Model$Round = {ctor: 'Round'};
var _mdgriffith$style_elements$Style_Internal_Model$Space = {ctor: 'Space'};
var _mdgriffith$style_elements$Style_Internal_Model$Repeat = {ctor: 'Repeat'};
var _mdgriffith$style_elements$Style_Internal_Model$RepeatY = {ctor: 'RepeatY'};
var _mdgriffith$style_elements$Style_Internal_Model$RepeatX = {ctor: 'RepeatX'};
var _mdgriffith$style_elements$Style_Internal_Model$GoLeft = {ctor: 'GoLeft'};
var _mdgriffith$style_elements$Style_Internal_Model$Down = {ctor: 'Down'};
var _mdgriffith$style_elements$Style_Internal_Model$GoRight = {ctor: 'GoRight'};
var _mdgriffith$style_elements$Style_Internal_Model$Up = {ctor: 'Up'};
var _mdgriffith$style_elements$Style_Internal_Model$Other = function (a) {
	return {ctor: 'Other', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$JustifyAll = {ctor: 'JustifyAll'};
var _mdgriffith$style_elements$Style_Internal_Model$Justify = {ctor: 'Justify'};
var _mdgriffith$style_elements$Style_Internal_Model$Center = {ctor: 'Center'};
var _mdgriffith$style_elements$Style_Internal_Model$Bottom = {ctor: 'Bottom'};
var _mdgriffith$style_elements$Style_Internal_Model$Top = {ctor: 'Top'};
var _mdgriffith$style_elements$Style_Internal_Model$Right = {ctor: 'Right'};
var _mdgriffith$style_elements$Style_Internal_Model$Left = {ctor: 'Left'};
var _mdgriffith$style_elements$Style_Internal_Model$Calc = F2(
	function (a, b) {
		return {ctor: 'Calc', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Model$Fill = function (a) {
	return {ctor: 'Fill', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Auto = {ctor: 'Auto'};
var _mdgriffith$style_elements$Style_Internal_Model$Percent = function (a) {
	return {ctor: 'Percent', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Model$Px = function (a) {
	return {ctor: 'Px', _0: a};
};

var _mdgriffith$style_elements$Element_Internal_Model$name = function (el) {
	var _p0 = el;
	switch (_p0.ctor) {
		case 'Empty':
			return 'empty';
		case 'Spacer':
			return 'spacer';
		case 'Text':
			return 'text';
		case 'Element':
			return 'element';
		case 'Layout':
			return 'layout';
		default:
			return 'html';
	}
};
var _mdgriffith$style_elements$Element_Internal_Model$Raw = function (a) {
	return {ctor: 'Raw', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Layout = function (a) {
	return {ctor: 'Layout', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Element = function (a) {
	return {ctor: 'Element', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Text = F2(
	function (a, b) {
		return {ctor: 'Text', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Element_Internal_Model$Spacer = function (a) {
	return {ctor: 'Spacer', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Empty = {ctor: 'Empty'};
var _mdgriffith$style_elements$Element_Internal_Model$Keyed = function (a) {
	return {ctor: 'Keyed', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Normal = function (a) {
	return {ctor: 'Normal', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$adjust = F3(
	function (fn, parent, el) {
		var maybeOnEmptyList = function (list) {
			return _elm_lang$core$List$isEmpty(list) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(list);
		};
		var merge = F2(
			function (el, current) {
				var _p1 = el;
				if (_p1.ctor === 'Nothing') {
					return current;
				} else {
					var _p2 = current;
					if (_p2.ctor === 'Nothing') {
						return el;
					} else {
						return _elm_lang$core$Maybe$Just(
							A2(_elm_lang$core$Basics_ops['++'], _p1._0, _p2._0));
					}
				}
			});
		var _p3 = el;
		switch (_p3.ctor) {
			case 'Element':
				var adjustAndMerge = F2(
					function (el, _p4) {
						var _p5 = _p4;
						var _p9 = _p5._1;
						var _p8 = _p5._0;
						var _p6 = A3(_mdgriffith$style_elements$Element_Internal_Model$adjust, fn, _elm_lang$core$Maybe$Nothing, el);
						var adjusted = _p6._0;
						var data = _p6._1;
						var _p7 = data;
						if (_p7.ctor === 'Nothing') {
							return {
								ctor: '_Tuple2',
								_0: {ctor: '::', _0: adjusted, _1: _p8},
								_1: _p9
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: {ctor: '::', _0: adjusted, _1: _p8},
								_1: A2(_elm_lang$core$Basics_ops['++'], _p7._0, _p9)
							};
						}
					});
				var _p10 = function () {
					var _p11 = _p3._0.absolutelyPositioned;
					if (_p11.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Maybe$Nothing};
					} else {
						return function (_p12) {
							var _p13 = _p12;
							return {
								ctor: '_Tuple2',
								_0: maybeOnEmptyList(_p13._0),
								_1: maybeOnEmptyList(_p13._1)
							};
						}(
							A3(
								_elm_lang$core$List$foldr,
								adjustAndMerge,
								{
									ctor: '_Tuple2',
									_0: {ctor: '[]'},
									_1: {ctor: '[]'}
								},
								_p11._0));
					}
				}();
				var adjustedOthers = _p10._0;
				var otherChildrenData = _p10._1;
				var _p14 = A3(_mdgriffith$style_elements$Element_Internal_Model$adjust, fn, _elm_lang$core$Maybe$Nothing, _p3._0.child);
				var adjustedChild = _p14._0;
				var childData = _p14._1;
				var _p15 = A2(
					fn,
					parent,
					_mdgriffith$style_elements$Element_Internal_Model$Element(
						_elm_lang$core$Native_Utils.update(
							_p3._0,
							{child: adjustedChild, absolutelyPositioned: adjustedOthers})));
				var adjustedEl = _p15._0;
				var elData = _p15._1;
				return {
					ctor: '_Tuple2',
					_0: adjustedEl,
					_1: A3(
						_elm_lang$core$List$foldr,
						merge,
						_elm_lang$core$Maybe$Nothing,
						{
							ctor: '::',
							_0: childData,
							_1: {
								ctor: '::',
								_0: otherChildrenData,
								_1: {
									ctor: '::',
									_0: elData,
									_1: {ctor: '[]'}
								}
							}
						})
				};
			case 'Layout':
				var _p40 = _p3._0.layout;
				var adjustAndMergeKeyed = F3(
					function (usingParent, _p17, _p16) {
						var _p18 = _p17;
						var _p24 = _p18._0;
						var _p19 = _p16;
						var _p23 = _p19._1;
						var _p22 = _p19._0;
						var _p20 = A3(_mdgriffith$style_elements$Element_Internal_Model$adjust, fn, usingParent, _p18._1);
						var adjusted = _p20._0;
						var data = _p20._1;
						var _p21 = data;
						if (_p21.ctor === 'Nothing') {
							return {
								ctor: '_Tuple2',
								_0: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: _p24, _1: adjusted},
									_1: _p22
								},
								_1: _p23
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: _p24, _1: adjusted},
									_1: _p22
								},
								_1: A2(_elm_lang$core$Basics_ops['++'], _p21._0, _p23)
							};
						}
					});
				var adjustAndMerge = F3(
					function (usingParent, el, _p25) {
						var _p26 = _p25;
						var _p30 = _p26._1;
						var _p29 = _p26._0;
						var _p27 = A3(_mdgriffith$style_elements$Element_Internal_Model$adjust, fn, usingParent, el);
						var adjusted = _p27._0;
						var data = _p27._1;
						var _p28 = data;
						if (_p28.ctor === 'Nothing') {
							return {
								ctor: '_Tuple2',
								_0: {ctor: '::', _0: adjusted, _1: _p29},
								_1: _p30
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: {ctor: '::', _0: adjusted, _1: _p29},
								_1: A2(_elm_lang$core$Basics_ops['++'], _p28._0, _p30)
							};
						}
					});
				var _p31 = function () {
					var _p32 = _p3._0.children;
					if (_p32.ctor === 'Normal') {
						var _p33 = A3(
							_elm_lang$core$List$foldr,
							adjustAndMerge(
								_elm_lang$core$Maybe$Just(_p40)),
							{
								ctor: '_Tuple2',
								_0: {ctor: '[]'},
								_1: {ctor: '[]'}
							},
							_p32._0);
						var adjusted = _p33._0;
						var data = _p33._1;
						return {
							ctor: '_Tuple2',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Normal(adjusted),
							_1: maybeOnEmptyList(data)
						};
					} else {
						var _p34 = A3(
							_elm_lang$core$List$foldr,
							adjustAndMergeKeyed(
								_elm_lang$core$Maybe$Just(_p40)),
							{
								ctor: '_Tuple2',
								_0: {ctor: '[]'},
								_1: {ctor: '[]'}
							},
							_p32._0);
						var adjusted = _p34._0;
						var data = _p34._1;
						return {
							ctor: '_Tuple2',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Keyed(adjusted),
							_1: maybeOnEmptyList(data)
						};
					}
				}();
				var adjustedChildren = _p31._0;
				var childrenData = _p31._1;
				var _p35 = function () {
					var _p36 = _p3._0.absolutelyPositioned;
					if (_p36.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Maybe$Nothing};
					} else {
						return function (_p37) {
							var _p38 = _p37;
							return {
								ctor: '_Tuple2',
								_0: maybeOnEmptyList(_p38._0),
								_1: maybeOnEmptyList(_p38._1)
							};
						}(
							A3(
								_elm_lang$core$List$foldr,
								adjustAndMerge(_elm_lang$core$Maybe$Nothing),
								{
									ctor: '_Tuple2',
									_0: {ctor: '[]'},
									_1: {ctor: '[]'}
								},
								_p36._0));
					}
				}();
				var adjustedOthers = _p35._0;
				var otherChildrenData = _p35._1;
				var _p39 = A2(
					fn,
					parent,
					_mdgriffith$style_elements$Element_Internal_Model$Layout(
						_elm_lang$core$Native_Utils.update(
							_p3._0,
							{children: adjustedChildren, absolutelyPositioned: adjustedOthers})));
				var adjustedLayout = _p39._0;
				var layoutData = _p39._1;
				return {
					ctor: '_Tuple2',
					_0: adjustedLayout,
					_1: A3(
						_elm_lang$core$List$foldr,
						merge,
						_elm_lang$core$Maybe$Nothing,
						{
							ctor: '::',
							_0: layoutData,
							_1: {
								ctor: '::',
								_0: childrenData,
								_1: {
									ctor: '::',
									_0: otherChildrenData,
									_1: {ctor: '[]'}
								}
							}
						})
				};
			default:
				return A2(fn, _elm_lang$core$Maybe$Nothing, el);
		}
	});
var _mdgriffith$style_elements$Element_Internal_Model$mapChildren = F2(
	function (fn, children) {
		var _p41 = children;
		if (_p41.ctor === 'Normal') {
			return _mdgriffith$style_elements$Element_Internal_Model$Normal(
				A2(_elm_lang$core$List$map, fn, _p41._0));
		} else {
			return _mdgriffith$style_elements$Element_Internal_Model$Keyed(
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Tuple$mapSecond(fn),
					_p41._0));
		}
	});
var _mdgriffith$style_elements$Element_Internal_Model$OnGrid = function (a) {
	return {ctor: 'OnGrid', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$NamedOnGrid = function (a) {
	return {ctor: 'NamedOnGrid', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Overflow = function (a) {
	return {ctor: 'Overflow', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Shrink = function (a) {
	return {ctor: 'Shrink', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$PointerEvents = function (a) {
	return {ctor: 'PointerEvents', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$GridCoords = function (a) {
	return {ctor: 'GridCoords', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$GridArea = function (a) {
	return {ctor: 'GridArea', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Attr = function (a) {
	return {ctor: 'Attr', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$InputEvent = function (a) {
	return {ctor: 'InputEvent', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Event = function (a) {
	return {ctor: 'Event', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$PhantomPadding = function (a) {
	return {ctor: 'PhantomPadding', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Padding = F4(
	function (a, b, c, d) {
		return {ctor: 'Padding', _0: a, _1: b, _2: c, _3: d};
	});
var _mdgriffith$style_elements$Element_Internal_Model$Expand = {ctor: 'Expand'};
var _mdgriffith$style_elements$Element_Internal_Model$Margin = function (a) {
	return {ctor: 'Margin', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Spacing = F2(
	function (a, b) {
		return {ctor: 'Spacing', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Element_Internal_Model$Opacity = function (a) {
	return {ctor: 'Opacity', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Hidden = {ctor: 'Hidden'};
var _mdgriffith$style_elements$Element_Internal_Model$PositionFrame = function (a) {
	return {ctor: 'PositionFrame', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Position = F3(
	function (a, b, c) {
		return {ctor: 'Position', _0: a, _1: b, _2: c};
	});
var _mdgriffith$style_elements$Element_Internal_Model$VAlign = function (a) {
	return {ctor: 'VAlign', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$HAlign = function (a) {
	return {ctor: 'HAlign', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Inline = {ctor: 'Inline'};
var _mdgriffith$style_elements$Element_Internal_Model$Width = function (a) {
	return {ctor: 'Width', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Height = function (a) {
	return {ctor: 'Height', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Vary = F2(
	function (a, b) {
		return {ctor: 'Vary', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Element_Internal_Model$mapAllAttr = F3(
	function (fnMsg, fnVar, attr) {
		var _p42 = attr;
		switch (_p42.ctor) {
			case 'Event':
				return _mdgriffith$style_elements$Element_Internal_Model$Event(
					A2(_elm_lang$html$Html_Attributes$map, fnMsg, _p42._0));
			case 'InputEvent':
				return _mdgriffith$style_elements$Element_Internal_Model$InputEvent(
					A2(_elm_lang$html$Html_Attributes$map, fnMsg, _p42._0));
			case 'Attr':
				return _mdgriffith$style_elements$Element_Internal_Model$Attr(
					A2(_elm_lang$html$Html_Attributes$map, fnMsg, _p42._0));
			case 'Vary':
				return A2(
					_mdgriffith$style_elements$Element_Internal_Model$Vary,
					fnVar(_p42._0),
					_p42._1);
			case 'Height':
				return _mdgriffith$style_elements$Element_Internal_Model$Height(_p42._0);
			case 'Width':
				return _mdgriffith$style_elements$Element_Internal_Model$Width(_p42._0);
			case 'Inline':
				return _mdgriffith$style_elements$Element_Internal_Model$Inline;
			case 'HAlign':
				return _mdgriffith$style_elements$Element_Internal_Model$HAlign(_p42._0);
			case 'VAlign':
				return _mdgriffith$style_elements$Element_Internal_Model$VAlign(_p42._0);
			case 'Position':
				return A3(_mdgriffith$style_elements$Element_Internal_Model$Position, _p42._0, _p42._1, _p42._2);
			case 'PositionFrame':
				return _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_p42._0);
			case 'Hidden':
				return _mdgriffith$style_elements$Element_Internal_Model$Hidden;
			case 'Opacity':
				return _mdgriffith$style_elements$Element_Internal_Model$Opacity(_p42._0);
			case 'Spacing':
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, _p42._0, _p42._1);
			case 'Margin':
				return _mdgriffith$style_elements$Element_Internal_Model$Margin(_p42._0);
			case 'Expand':
				return _mdgriffith$style_elements$Element_Internal_Model$Expand;
			case 'Padding':
				return A4(_mdgriffith$style_elements$Element_Internal_Model$Padding, _p42._0, _p42._1, _p42._2, _p42._3);
			case 'PhantomPadding':
				return _mdgriffith$style_elements$Element_Internal_Model$PhantomPadding(_p42._0);
			case 'GridArea':
				return _mdgriffith$style_elements$Element_Internal_Model$GridArea(_p42._0);
			case 'GridCoords':
				return _mdgriffith$style_elements$Element_Internal_Model$GridCoords(_p42._0);
			case 'PointerEvents':
				return _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(_p42._0);
			case 'Shrink':
				return _mdgriffith$style_elements$Element_Internal_Model$Shrink(_p42._0);
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Overflow(_p42._0);
		}
	});
var _mdgriffith$style_elements$Element_Internal_Model$mapAll = F4(
	function (onMsg, onStyle, onVariation, el) {
		var _p43 = el;
		switch (_p43.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p43._0);
			case 'Text':
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p43._0, _p43._1);
			case 'Element':
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p43._0,
						{
							attrs: A2(
								_elm_lang$core$List$map,
								A2(_mdgriffith$style_elements$Element_Internal_Model$mapAllAttr, onMsg, onVariation),
								_p43._0.attrs),
							style: A2(_elm_lang$core$Maybe$map, onStyle, _p43._0.style),
							child: A4(_mdgriffith$style_elements$Element_Internal_Model$mapAll, onMsg, onStyle, onVariation, _p43._0.child),
							absolutelyPositioned: A2(
								_elm_lang$core$Maybe$map,
								_elm_lang$core$List$map(
									function (child) {
										return A4(_mdgriffith$style_elements$Element_Internal_Model$mapAll, onMsg, onStyle, onVariation, child);
									}),
								_p43._0.absolutelyPositioned)
						}));
			case 'Layout':
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p43._0,
						{
							attrs: A2(
								_elm_lang$core$List$map,
								A2(_mdgriffith$style_elements$Element_Internal_Model$mapAllAttr, onMsg, onVariation),
								_p43._0.attrs),
							style: A2(_elm_lang$core$Maybe$map, onStyle, _p43._0.style),
							children: A2(
								_mdgriffith$style_elements$Element_Internal_Model$mapChildren,
								function (child) {
									return A4(_mdgriffith$style_elements$Element_Internal_Model$mapAll, onMsg, onStyle, onVariation, child);
								},
								_p43._0.children),
							absolutelyPositioned: A2(
								_elm_lang$core$Maybe$map,
								_elm_lang$core$List$map(
									function (child) {
										return A4(_mdgriffith$style_elements$Element_Internal_Model$mapAll, onMsg, onStyle, onVariation, child);
									}),
								_p43._0.absolutelyPositioned)
						}));
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(
					A2(_elm_lang$html$Html$map, onMsg, _p43._0));
		}
	});
var _mdgriffith$style_elements$Element_Internal_Model$mapAttr = F2(
	function (fn, attr) {
		var _p44 = attr;
		switch (_p44.ctor) {
			case 'Event':
				return _mdgriffith$style_elements$Element_Internal_Model$Event(
					A2(_elm_lang$html$Html_Attributes$map, fn, _p44._0));
			case 'InputEvent':
				return _mdgriffith$style_elements$Element_Internal_Model$InputEvent(
					A2(_elm_lang$html$Html_Attributes$map, fn, _p44._0));
			case 'Attr':
				return _mdgriffith$style_elements$Element_Internal_Model$Attr(
					A2(_elm_lang$html$Html_Attributes$map, fn, _p44._0));
			case 'Vary':
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Vary, _p44._0, _p44._1);
			case 'Height':
				return _mdgriffith$style_elements$Element_Internal_Model$Height(_p44._0);
			case 'Width':
				return _mdgriffith$style_elements$Element_Internal_Model$Width(_p44._0);
			case 'Inline':
				return _mdgriffith$style_elements$Element_Internal_Model$Inline;
			case 'HAlign':
				return _mdgriffith$style_elements$Element_Internal_Model$HAlign(_p44._0);
			case 'VAlign':
				return _mdgriffith$style_elements$Element_Internal_Model$VAlign(_p44._0);
			case 'Position':
				return A3(_mdgriffith$style_elements$Element_Internal_Model$Position, _p44._0, _p44._1, _p44._2);
			case 'PositionFrame':
				return _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_p44._0);
			case 'Hidden':
				return _mdgriffith$style_elements$Element_Internal_Model$Hidden;
			case 'Opacity':
				return _mdgriffith$style_elements$Element_Internal_Model$Opacity(_p44._0);
			case 'Spacing':
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, _p44._0, _p44._1);
			case 'Margin':
				return _mdgriffith$style_elements$Element_Internal_Model$Margin(_p44._0);
			case 'Expand':
				return _mdgriffith$style_elements$Element_Internal_Model$Expand;
			case 'Padding':
				return A4(_mdgriffith$style_elements$Element_Internal_Model$Padding, _p44._0, _p44._1, _p44._2, _p44._3);
			case 'PhantomPadding':
				return _mdgriffith$style_elements$Element_Internal_Model$PhantomPadding(_p44._0);
			case 'GridArea':
				return _mdgriffith$style_elements$Element_Internal_Model$GridArea(_p44._0);
			case 'GridCoords':
				return _mdgriffith$style_elements$Element_Internal_Model$GridCoords(_p44._0);
			case 'PointerEvents':
				return _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(_p44._0);
			case 'Shrink':
				return _mdgriffith$style_elements$Element_Internal_Model$Shrink(_p44._0);
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Overflow(_p44._0);
		}
	});
var _mdgriffith$style_elements$Element_Internal_Model$mapMsg = F2(
	function (fn, el) {
		var _p45 = el;
		switch (_p45.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p45._0);
			case 'Text':
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p45._0, _p45._1);
			case 'Element':
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p45._0,
						{
							attrs: A2(
								_elm_lang$core$List$map,
								_mdgriffith$style_elements$Element_Internal_Model$mapAttr(fn),
								_p45._0.attrs),
							child: A2(_mdgriffith$style_elements$Element_Internal_Model$mapMsg, fn, _p45._0.child),
							absolutelyPositioned: A2(
								_elm_lang$core$Maybe$map,
								_elm_lang$core$List$map(
									function (child) {
										return A2(_mdgriffith$style_elements$Element_Internal_Model$mapMsg, fn, child);
									}),
								_p45._0.absolutelyPositioned)
						}));
			case 'Layout':
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p45._0,
						{
							attrs: A2(
								_elm_lang$core$List$map,
								_mdgriffith$style_elements$Element_Internal_Model$mapAttr(fn),
								_p45._0.attrs),
							children: A2(
								_mdgriffith$style_elements$Element_Internal_Model$mapChildren,
								_mdgriffith$style_elements$Element_Internal_Model$mapMsg(fn),
								_p45._0.children),
							absolutelyPositioned: A2(
								_elm_lang$core$Maybe$map,
								_elm_lang$core$List$map(
									function (child) {
										return A2(_mdgriffith$style_elements$Element_Internal_Model$mapMsg, fn, child);
									}),
								_p45._0.absolutelyPositioned)
						}));
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(
					A2(_elm_lang$html$Html$map, fn, _p45._0));
		}
	});
var _mdgriffith$style_elements$Element_Internal_Model$AllAxis = {ctor: 'AllAxis'};
var _mdgriffith$style_elements$Element_Internal_Model$YAxis = {ctor: 'YAxis'};
var _mdgriffith$style_elements$Element_Internal_Model$XAxis = {ctor: 'XAxis'};
var _mdgriffith$style_elements$Element_Internal_Model$Sub = {ctor: 'Sub'};
var _mdgriffith$style_elements$Element_Internal_Model$Super = {ctor: 'Super'};
var _mdgriffith$style_elements$Element_Internal_Model$Strike = {ctor: 'Strike'};
var _mdgriffith$style_elements$Element_Internal_Model$Underline = {ctor: 'Underline'};
var _mdgriffith$style_elements$Element_Internal_Model$Italic = {ctor: 'Italic'};
var _mdgriffith$style_elements$Element_Internal_Model$Bold = {ctor: 'Bold'};
var _mdgriffith$style_elements$Element_Internal_Model$RawText = {ctor: 'RawText'};
var _mdgriffith$style_elements$Element_Internal_Model$NoDecoration = {ctor: 'NoDecoration'};
var _mdgriffith$style_elements$Element_Internal_Model$Nearby = function (a) {
	return {ctor: 'Nearby', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Absolute = function (a) {
	return {ctor: 'Absolute', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Model$Relative = {ctor: 'Relative'};
var _mdgriffith$style_elements$Element_Internal_Model$Screen = {ctor: 'Screen'};
var _mdgriffith$style_elements$Element_Internal_Model$BottomLeft = {ctor: 'BottomLeft'};
var _mdgriffith$style_elements$Element_Internal_Model$TopLeft = {ctor: 'TopLeft'};
var _mdgriffith$style_elements$Element_Internal_Model$Within = {ctor: 'Within'};
var _mdgriffith$style_elements$Element_Internal_Model$OnRight = {ctor: 'OnRight'};
var _mdgriffith$style_elements$Element_Internal_Model$OnLeft = {ctor: 'OnLeft'};
var _mdgriffith$style_elements$Element_Internal_Model$Above = {ctor: 'Above'};
var _mdgriffith$style_elements$Element_Internal_Model$Below = {ctor: 'Below'};
var _mdgriffith$style_elements$Element_Internal_Model$Justify = {ctor: 'Justify'};
var _mdgriffith$style_elements$Element_Internal_Model$Center = {ctor: 'Center'};
var _mdgriffith$style_elements$Element_Internal_Model$Right = {ctor: 'Right'};
var _mdgriffith$style_elements$Element_Internal_Model$Left = {ctor: 'Left'};
var _mdgriffith$style_elements$Element_Internal_Model$VerticalJustify = {ctor: 'VerticalJustify'};
var _mdgriffith$style_elements$Element_Internal_Model$VerticalCenter = {ctor: 'VerticalCenter'};
var _mdgriffith$style_elements$Element_Internal_Model$Bottom = {ctor: 'Bottom'};
var _mdgriffith$style_elements$Element_Internal_Model$Top = {ctor: 'Top'};

var _mdgriffith$style_elements$Style_Internal_Render_Value$typeface = function (families) {
	var renderFont = function (font) {
		var _p0 = font;
		switch (_p0.ctor) {
			case 'Serif':
				return 'serif';
			case 'SansSerif':
				return 'sans-serif';
			case 'Cursive':
				return 'cursive';
			case 'Fantasy':
				return 'fantasy';
			case 'Monospace':
				return 'monospace';
			case 'FontName':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'\"',
					A2(_elm_lang$core$Basics_ops['++'], _p0._0, '\"'));
			default:
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'\"',
					A2(_elm_lang$core$Basics_ops['++'], _p0._0, '\"'));
		}
	};
	return A2(
		_elm_lang$core$String$join,
		', ',
		A2(_elm_lang$core$List$map, renderFont, families));
};
var _mdgriffith$style_elements$Style_Internal_Render_Value$gridPosition = function (_p1) {
	var _p2 = _p1;
	var _p7 = _p2._0.width;
	var _p6 = _p2._0.height;
	var _p3 = _p2._0.start;
	var x = _p3._0;
	var y = _p3._1;
	var _p4 = {ctor: '_Tuple2', _0: y + 1, _1: (y + 1) + _p6};
	var rowStart = _p4._0;
	var rowEnd = _p4._1;
	var _p5 = {ctor: '_Tuple2', _0: x + 1, _1: (x + 1) + _p7};
	var colStart = _p5._0;
	var colEnd = _p5._1;
	return (_elm_lang$core$Native_Utils.eq(_p7, 0) || _elm_lang$core$Native_Utils.eq(_p6, 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
		A2(
			_elm_lang$core$String$join,
			' / ',
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(rowStart),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(colStart),
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(rowEnd),
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Basics$toString(colEnd),
							_1: {ctor: '[]'}
						}
					}
				}
			}));
};
var _mdgriffith$style_elements$Style_Internal_Render_Value$color = function (color) {
	var _p8 = _elm_lang$core$Color$toRgb(color);
	var red = _p8.red;
	var green = _p8.green;
	var blue = _p8.blue;
	var alpha = _p8.alpha;
	return A2(
		_elm_lang$core$Basics_ops['++'],
		A2(
			_elm_lang$core$Basics_ops['++'],
			'rgba(',
			_elm_lang$core$Basics$toString(red)),
		A2(
			_elm_lang$core$Basics_ops['++'],
			A2(
				_elm_lang$core$Basics_ops['++'],
				',',
				_elm_lang$core$Basics$toString(green)),
			A2(
				_elm_lang$core$Basics_ops['++'],
				A2(
					_elm_lang$core$Basics_ops['++'],
					',',
					_elm_lang$core$Basics$toString(blue)),
				A2(
					_elm_lang$core$Basics_ops['++'],
					',',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(alpha),
						')')))));
};
var _mdgriffith$style_elements$Style_Internal_Render_Value$shadow = function (_p9) {
	var _p10 = _p9;
	var _p11 = _p10._0;
	return A2(
		_elm_lang$core$String$join,
		' ',
		A2(
			_elm_lang$core$List$filterMap,
			_elm_lang$core$Basics$identity,
			{
				ctor: '::',
				_0: _elm_lang$core$Native_Utils.eq(_p11.kind, 'inset') ? _elm_lang$core$Maybe$Just('inset') : _elm_lang$core$Maybe$Nothing,
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Maybe$Just(
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(
								_elm_lang$core$Tuple$first(_p11.offset)),
							'px')),
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Maybe$Just(
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Tuple$second(_p11.offset)),
								'px')),
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Maybe$Just(
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p11.blur),
									'px')),
							_1: {
								ctor: '::',
								_0: (_elm_lang$core$Native_Utils.eq(_p11.kind, 'text') || _elm_lang$core$Native_Utils.eq(_p11.kind, 'drop')) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p11.size),
										'px')),
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Maybe$Just(
										_mdgriffith$style_elements$Style_Internal_Render_Value$color(_p11.color)),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}));
};
var _mdgriffith$style_elements$Style_Internal_Render_Value$parentAdjustedLength = F2(
	function (len, adjustment) {
		var _p12 = len;
		switch (_p12.ctor) {
			case 'Px':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p12._0),
					'px');
			case 'Percent':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'calc(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p12._0),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'% - ',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(adjustment),
								'px)'))));
			case 'Auto':
				return 'auto';
			case 'Fill':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'calc(100% - ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(adjustment),
						'px)'));
			default:
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'calc(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p12._0),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'% + ',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p12._1),
								'px)'))));
		}
	});
var _mdgriffith$style_elements$Style_Internal_Render_Value$length = function (l) {
	var _p13 = l;
	switch (_p13.ctor) {
		case 'Px':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(_p13._0),
				'px');
		case 'Percent':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(_p13._0),
				'%');
		case 'Auto':
			return 'auto';
		case 'Fill':
			return '100%';
		default:
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'calc(',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p13._0),
					A2(
						_elm_lang$core$Basics_ops['++'],
						'% + ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p13._1),
							'px)'))));
	}
};
var _mdgriffith$style_elements$Style_Internal_Render_Value$box = function (_p14) {
	var _p15 = _p14;
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_elm_lang$core$Basics$toString(_p15._0),
		A2(
			_elm_lang$core$Basics_ops['++'],
			'px ',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(_p15._1),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'px ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p15._2),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'px ',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p15._3),
								'px')))))));
};

var _mdgriffith$style_elements$Element_Attributes$toAttr = _mdgriffith$style_elements$Element_Internal_Model$Attr;
var _mdgriffith$style_elements$Element_Attributes$language = function (str) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$lang(str));
};
var _mdgriffith$style_elements$Element_Attributes$id = function (str) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$id(str));
};
var _mdgriffith$style_elements$Element_Attributes$class = function (cls) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$class(cls));
};
var _mdgriffith$style_elements$Element_Attributes$map = F2(
	function (fn, attr) {
		var _p0 = attr;
		switch (_p0.ctor) {
			case 'Attr':
				return _mdgriffith$style_elements$Element_Internal_Model$Attr(
					A2(_elm_lang$html$Html_Attributes$map, fn, _p0._0));
			case 'Vary':
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Vary, _p0._0, _p0._1);
			case 'Height':
				return _mdgriffith$style_elements$Element_Internal_Model$Height(_p0._0);
			case 'Width':
				return _mdgriffith$style_elements$Element_Internal_Model$Width(_p0._0);
			case 'Inline':
				return _mdgriffith$style_elements$Element_Internal_Model$Inline;
			case 'Hidden':
				return _mdgriffith$style_elements$Element_Internal_Model$Hidden;
			case 'PositionFrame':
				return _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_p0._0);
			case 'Opacity':
				return _mdgriffith$style_elements$Element_Internal_Model$Opacity(_p0._0);
			case 'Expand':
				return _mdgriffith$style_elements$Element_Internal_Model$Expand;
			case 'Padding':
				return A4(_mdgriffith$style_elements$Element_Internal_Model$Padding, _p0._0, _p0._1, _p0._2, _p0._3);
			case 'PhantomPadding':
				return _mdgriffith$style_elements$Element_Internal_Model$PhantomPadding(_p0._0);
			case 'Margin':
				return _mdgriffith$style_elements$Element_Internal_Model$Margin(_p0._0);
			case 'GridArea':
				return _mdgriffith$style_elements$Element_Internal_Model$GridArea(_p0._0);
			case 'GridCoords':
				return _mdgriffith$style_elements$Element_Internal_Model$GridCoords(_p0._0);
			case 'PointerEvents':
				return _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(_p0._0);
			case 'Event':
				return _mdgriffith$style_elements$Element_Internal_Model$Event(
					A2(_elm_lang$html$Html_Attributes$map, fn, _p0._0));
			case 'InputEvent':
				return _mdgriffith$style_elements$Element_Internal_Model$InputEvent(
					A2(_elm_lang$html$Html_Attributes$map, fn, _p0._0));
			case 'Position':
				return A3(_mdgriffith$style_elements$Element_Internal_Model$Position, _p0._0, _p0._1, _p0._2);
			case 'Spacing':
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, _p0._0, _p0._1);
			case 'VAlign':
				return _mdgriffith$style_elements$Element_Internal_Model$VAlign(_p0._0);
			case 'HAlign':
				return _mdgriffith$style_elements$Element_Internal_Model$HAlign(_p0._0);
			case 'Shrink':
				return _mdgriffith$style_elements$Element_Internal_Model$Shrink(_p0._0);
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Overflow(_p0._0);
		}
	});
var _mdgriffith$style_elements$Element_Attributes$attribute = F2(
	function (name, val) {
		return _mdgriffith$style_elements$Element_Internal_Model$Attr(
			A2(_elm_lang$html$Html_Attributes$attribute, name, val));
	});
var _mdgriffith$style_elements$Element_Attributes$property = F2(
	function (str, val) {
		return _mdgriffith$style_elements$Element_Internal_Model$Attr(
			A2(_elm_lang$html$Html_Attributes$property, str, val));
	});
var _mdgriffith$style_elements$Element_Attributes$inlineStyle = function (_p1) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$virtual_dom$VirtualDom$style(_p1));
};
var _mdgriffith$style_elements$Element_Attributes$classList = function (_p2) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$classList(_p2));
};
var _mdgriffith$style_elements$Element_Attributes$clipY = _mdgriffith$style_elements$Element_Internal_Model$Attr(
	_elm_lang$virtual_dom$VirtualDom$style(
		{
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'overflow-y', _1: 'hidden'},
			_1: {ctor: '[]'}
		}));
var _mdgriffith$style_elements$Element_Attributes$clipX = _mdgriffith$style_elements$Element_Internal_Model$Attr(
	_elm_lang$virtual_dom$VirtualDom$style(
		{
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'overflow-x', _1: 'hidden'},
			_1: {ctor: '[]'}
		}));
var _mdgriffith$style_elements$Element_Attributes$clip = _mdgriffith$style_elements$Element_Internal_Model$Attr(
	_elm_lang$virtual_dom$VirtualDom$style(
		{
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'overflow', _1: 'hidden'},
			_1: {ctor: '[]'}
		}));
var _mdgriffith$style_elements$Element_Attributes$xScrollbar = _mdgriffith$style_elements$Element_Internal_Model$Overflow(_mdgriffith$style_elements$Element_Internal_Model$XAxis);
var _mdgriffith$style_elements$Element_Attributes$yScrollbar = _mdgriffith$style_elements$Element_Internal_Model$Overflow(_mdgriffith$style_elements$Element_Internal_Model$YAxis);
var _mdgriffith$style_elements$Element_Attributes$scrollbars = _mdgriffith$style_elements$Element_Internal_Model$Overflow(_mdgriffith$style_elements$Element_Internal_Model$AllAxis);
var _mdgriffith$style_elements$Element_Attributes$hidden = _mdgriffith$style_elements$Element_Internal_Model$Hidden;
var _mdgriffith$style_elements$Element_Attributes$paddingBottom = function (x) {
	return A4(
		_mdgriffith$style_elements$Element_Internal_Model$Padding,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Just(x),
		_elm_lang$core$Maybe$Nothing);
};
var _mdgriffith$style_elements$Element_Attributes$paddingTop = function (x) {
	return A4(
		_mdgriffith$style_elements$Element_Internal_Model$Padding,
		_elm_lang$core$Maybe$Just(x),
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing);
};
var _mdgriffith$style_elements$Element_Attributes$paddingRight = function (x) {
	return A4(
		_mdgriffith$style_elements$Element_Internal_Model$Padding,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Just(x),
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing);
};
var _mdgriffith$style_elements$Element_Attributes$paddingLeft = function (x) {
	return A4(
		_mdgriffith$style_elements$Element_Internal_Model$Padding,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Just(x));
};
var _mdgriffith$style_elements$Element_Attributes$paddingXY = F2(
	function (x, y) {
		return A4(
			_mdgriffith$style_elements$Element_Internal_Model$Padding,
			_elm_lang$core$Maybe$Just(y),
			_elm_lang$core$Maybe$Just(x),
			_elm_lang$core$Maybe$Just(y),
			_elm_lang$core$Maybe$Just(x));
	});
var _mdgriffith$style_elements$Element_Attributes$padding = function (x) {
	return A4(
		_mdgriffith$style_elements$Element_Internal_Model$Padding,
		_elm_lang$core$Maybe$Just(x),
		_elm_lang$core$Maybe$Just(x),
		_elm_lang$core$Maybe$Just(x),
		_elm_lang$core$Maybe$Just(x));
};
var _mdgriffith$style_elements$Element_Attributes$spacingXY = _mdgriffith$style_elements$Element_Internal_Model$Spacing;
var _mdgriffith$style_elements$Element_Attributes$spacing = function (x) {
	return A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, x, x);
};
var _mdgriffith$style_elements$Element_Attributes$vary = _mdgriffith$style_elements$Element_Internal_Model$Vary;
var _mdgriffith$style_elements$Element_Attributes$percent = _mdgriffith$style_elements$Style_Internal_Model$Percent;
var _mdgriffith$style_elements$Element_Attributes$fillPortion = function (_p3) {
	return _mdgriffith$style_elements$Style_Internal_Model$Fill(
		_elm_lang$core$Basics$toFloat(_p3));
};
var _mdgriffith$style_elements$Element_Attributes$fill = _mdgriffith$style_elements$Style_Internal_Model$Fill(1);
var _mdgriffith$style_elements$Element_Attributes$content = _mdgriffith$style_elements$Style_Internal_Model$Auto;
var _mdgriffith$style_elements$Element_Attributes$px = _mdgriffith$style_elements$Style_Internal_Model$Px;
var _mdgriffith$style_elements$Element_Attributes$height = _mdgriffith$style_elements$Element_Internal_Model$Height;
var _mdgriffith$style_elements$Element_Attributes$maxHeight = function (len) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$style(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'max-height',
					_1: _mdgriffith$style_elements$Style_Internal_Render_Value$length(len)
				},
				_1: {ctor: '[]'}
			}));
};
var _mdgriffith$style_elements$Element_Attributes$minHeight = function (len) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$style(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'min-height',
					_1: _mdgriffith$style_elements$Style_Internal_Render_Value$length(len)
				},
				_1: {ctor: '[]'}
			}));
};
var _mdgriffith$style_elements$Element_Attributes$maxWidth = function (len) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$style(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'max-width',
					_1: _mdgriffith$style_elements$Style_Internal_Render_Value$length(len)
				},
				_1: {ctor: '[]'}
			}));
};
var _mdgriffith$style_elements$Element_Attributes$minWidth = function (len) {
	return _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$style(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'min-width',
					_1: _mdgriffith$style_elements$Style_Internal_Render_Value$length(len)
				},
				_1: {ctor: '[]'}
			}));
};
var _mdgriffith$style_elements$Element_Attributes$width = _mdgriffith$style_elements$Element_Internal_Model$Width;
var _mdgriffith$style_elements$Element_Attributes$moveLeft = function (x) {
	return A3(
		_mdgriffith$style_elements$Element_Internal_Model$Position,
		_elm_lang$core$Maybe$Just(
			_elm_lang$core$Basics$negate(x)),
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing);
};
var _mdgriffith$style_elements$Element_Attributes$moveRight = function (x) {
	return A3(
		_mdgriffith$style_elements$Element_Internal_Model$Position,
		_elm_lang$core$Maybe$Just(x),
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Nothing);
};
var _mdgriffith$style_elements$Element_Attributes$moveDown = function (y) {
	return A3(
		_mdgriffith$style_elements$Element_Internal_Model$Position,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Just(y),
		_elm_lang$core$Maybe$Nothing);
};
var _mdgriffith$style_elements$Element_Attributes$moveUp = function (y) {
	return A3(
		_mdgriffith$style_elements$Element_Internal_Model$Position,
		_elm_lang$core$Maybe$Nothing,
		_elm_lang$core$Maybe$Just(
			_elm_lang$core$Basics$negate(y)),
		_elm_lang$core$Maybe$Nothing);
};
var _mdgriffith$style_elements$Element_Attributes$alignRight = _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Right);
var _mdgriffith$style_elements$Element_Attributes$alignLeft = _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Left);
var _mdgriffith$style_elements$Element_Attributes$alignBottom = _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Bottom);
var _mdgriffith$style_elements$Element_Attributes$alignTop = _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Top);
var _mdgriffith$style_elements$Element_Attributes$spread = _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Justify);
var _mdgriffith$style_elements$Element_Attributes$verticalSpread = _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$VerticalJustify);
var _mdgriffith$style_elements$Element_Attributes$verticalCenter = _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$VerticalCenter);
var _mdgriffith$style_elements$Element_Attributes$center = _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Center);

var _mdgriffith$style_elements$Element_Internal_Modify$getTextList = function (el) {
	getTextList:
	while (true) {
		var _p0 = el;
		switch (_p0.ctor) {
			case 'Empty':
				return {ctor: '[]'};
			case 'Spacer':
				return {ctor: '[]'};
			case 'Raw':
				return {ctor: '[]'};
			case 'Layout':
				var _p1 = _p0._0.children;
				if (_p1.ctor === 'Normal') {
					return A2(_elm_lang$core$List$concatMap, _mdgriffith$style_elements$Element_Internal_Modify$getTextList, _p1._0);
				} else {
					return A2(
						_elm_lang$core$List$concatMap,
						function (_p2) {
							return _mdgriffith$style_elements$Element_Internal_Modify$getTextList(
								_elm_lang$core$Tuple$second(_p2));
						},
						_p1._0);
				}
			case 'Element':
				var _v2 = _p0._0.child;
				el = _v2;
				continue getTextList;
			default:
				return {
					ctor: '::',
					_0: _p0._1,
					_1: {ctor: '[]'}
				};
		}
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$getText = function (el) {
	getText:
	while (true) {
		var _p3 = el;
		switch (_p3.ctor) {
			case 'Empty':
				return '';
			case 'Spacer':
				return '';
			case 'Raw':
				return '';
			case 'Layout':
				var _p4 = _p3._0.children;
				if (_p4.ctor === 'Normal') {
					return A2(
						_elm_lang$core$String$join,
						'-',
						A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Element_Internal_Modify$getText, _p4._0));
				} else {
					return A2(
						_elm_lang$core$String$join,
						'-',
						A2(
							_elm_lang$core$List$map,
							function (_p5) {
								return _mdgriffith$style_elements$Element_Internal_Modify$getText(
									_elm_lang$core$Tuple$second(_p5));
							},
							_p4._0));
				}
			case 'Element':
				var _v5 = _p3._0.child;
				el = _v5;
				continue getText;
			default:
				return _p3._1;
		}
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$getChild = function (el) {
	var _p6 = el;
	switch (_p6.ctor) {
		case 'Empty':
			return _mdgriffith$style_elements$Element_Internal_Model$Empty;
		case 'Spacer':
			return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p6._0);
		case 'Raw':
			return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p6._0);
		case 'Layout':
			return el;
		case 'Element':
			return _p6._0.child;
		default:
			return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p6._0, _p6._1);
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$removeContent = function (el) {
	var _p7 = el;
	switch (_p7.ctor) {
		case 'Empty':
			return _mdgriffith$style_elements$Element_Internal_Model$Empty;
		case 'Spacer':
			return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p7._0);
		case 'Raw':
			return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p7._0);
		case 'Layout':
			return _mdgriffith$style_elements$Element_Internal_Model$Layout(
				_elm_lang$core$Native_Utils.update(
					_p7._0,
					{
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							{ctor: '[]'}),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					}));
		case 'Element':
			return _mdgriffith$style_elements$Element_Internal_Model$Element(
				_elm_lang$core$Native_Utils.update(
					_p7._0,
					{child: _mdgriffith$style_elements$Element_Internal_Model$Empty, absolutelyPositioned: _elm_lang$core$Maybe$Nothing}));
		default:
			return _mdgriffith$style_elements$Element_Internal_Model$Empty;
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$removeStyle = function (el) {
	var _p8 = el;
	switch (_p8.ctor) {
		case 'Empty':
			return _mdgriffith$style_elements$Element_Internal_Model$Empty;
		case 'Spacer':
			return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p8._0);
		case 'Raw':
			return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p8._0);
		case 'Layout':
			return _mdgriffith$style_elements$Element_Internal_Model$Layout(
				_elm_lang$core$Native_Utils.update(
					_p8._0,
					{style: _elm_lang$core$Maybe$Nothing}));
		case 'Element':
			return _mdgriffith$style_elements$Element_Internal_Model$Element(
				_elm_lang$core$Native_Utils.update(
					_p8._0,
					{style: _elm_lang$core$Maybe$Nothing}));
		default:
			return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p8._0, _p8._1);
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$getStyle = function (el) {
	var _p9 = el;
	switch (_p9.ctor) {
		case 'Empty':
			return _elm_lang$core$Maybe$Nothing;
		case 'Raw':
			return _elm_lang$core$Maybe$Nothing;
		case 'Spacer':
			return _elm_lang$core$Maybe$Nothing;
		case 'Layout':
			return _p9._0.style;
		case 'Element':
			return _p9._0.style;
		default:
			return _elm_lang$core$Maybe$Nothing;
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$getAttrs = function (el) {
	var _p10 = el;
	switch (_p10.ctor) {
		case 'Empty':
			return {ctor: '[]'};
		case 'Spacer':
			return {ctor: '[]'};
		case 'Raw':
			return {ctor: '[]'};
		case 'Layout':
			return _p10._0.attrs;
		case 'Element':
			return _p10._0.attrs;
		default:
			return {ctor: '[]'};
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$addChild = F2(
	function (parent, el) {
		var _p11 = parent;
		switch (_p11.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						attrs: {ctor: '[]'},
						child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
						absolutelyPositioned: _elm_lang$core$Maybe$Just(
							{
								ctor: '::',
								_0: el,
								_1: {ctor: '[]'}
							})
					});
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p11._0);
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p11._0);
			case 'Layout':
				var _p13 = _p11._0;
				var _p12 = _p11._0.absolutelyPositioned;
				if (_p12.ctor === 'Nothing') {
					return _mdgriffith$style_elements$Element_Internal_Model$Layout(
						_elm_lang$core$Native_Utils.update(
							_p13,
							{
								absolutelyPositioned: _elm_lang$core$Maybe$Just(
									{
										ctor: '::',
										_0: el,
										_1: {ctor: '[]'}
									})
							}));
				} else {
					return _mdgriffith$style_elements$Element_Internal_Model$Layout(
						_elm_lang$core$Native_Utils.update(
							_p13,
							{
								absolutelyPositioned: _elm_lang$core$Maybe$Just(
									{ctor: '::', _0: el, _1: _p12._0})
							}));
				}
			case 'Element':
				var _p15 = _p11._0;
				var _p14 = _p11._0.absolutelyPositioned;
				if (_p14.ctor === 'Nothing') {
					return _mdgriffith$style_elements$Element_Internal_Model$Element(
						_elm_lang$core$Native_Utils.update(
							_p15,
							{
								absolutelyPositioned: _elm_lang$core$Maybe$Just(
									{
										ctor: '::',
										_0: el,
										_1: {ctor: '[]'}
									})
							}));
				} else {
					return _mdgriffith$style_elements$Element_Internal_Model$Element(
						_elm_lang$core$Native_Utils.update(
							_p15,
							{
								absolutelyPositioned: _elm_lang$core$Maybe$Just(
									{ctor: '::', _0: el, _1: _p14._0})
							}));
				}
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						attrs: {ctor: '[]'},
						child: A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p11._0, _p11._1),
						absolutelyPositioned: _elm_lang$core$Maybe$Just(
							{
								ctor: '::',
								_0: el,
								_1: {ctor: '[]'}
							})
					});
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$removeAllAttrs = function (el) {
	var _p16 = el;
	switch (_p16.ctor) {
		case 'Empty':
			return _mdgriffith$style_elements$Element_Internal_Model$Empty;
		case 'Spacer':
			return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p16._0);
		case 'Raw':
			return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p16._0);
		case 'Layout':
			return _mdgriffith$style_elements$Element_Internal_Model$Layout(
				_elm_lang$core$Native_Utils.update(
					_p16._0,
					{
						attrs: {ctor: '[]'}
					}));
		case 'Element':
			return _mdgriffith$style_elements$Element_Internal_Model$Element(
				_elm_lang$core$Native_Utils.update(
					_p16._0,
					{
						attrs: {ctor: '[]'}
					}));
		default:
			return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p16._0, _p16._1);
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$removeAttrs = F2(
	function (props, el) {
		var match = function (p) {
			return !A2(_elm_lang$core$List$member, p, props);
		};
		var _p17 = el;
		switch (_p17.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p17._0);
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p17._0);
			case 'Layout':
				var _p18 = _p17._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p18,
						{
							attrs: A2(_elm_lang$core$List$filter, match, _p18.attrs)
						}));
			case 'Element':
				var _p19 = _p17._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p19,
						{
							attrs: A2(_elm_lang$core$List$filter, match, _p19.attrs)
						}));
			default:
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p17._0, _p17._1);
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$setAttrs = F2(
	function (props, el) {
		var _p20 = el;
		switch (_p20.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p20._0);
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p20._0);
			case 'Layout':
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p20._0,
						{attrs: props}));
			case 'Element':
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p20._0,
						{attrs: props}));
			default:
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p20._0, _p20._1);
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$addAttrList = F2(
	function (props, el) {
		var _p21 = el;
		switch (_p21.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p21._0);
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p21._0);
			case 'Layout':
				var _p22 = _p21._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p22,
						{
							attrs: A2(_elm_lang$core$Basics_ops['++'], props, _p22.attrs)
						}));
			case 'Element':
				var _p23 = _p21._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p23,
						{
							attrs: A2(_elm_lang$core$Basics_ops['++'], props, _p23.attrs)
						}));
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						attrs: props,
						child: A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p21._0, _p21._1),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$addAttrPriority = F2(
	function (prop, el) {
		var _p24 = el;
		switch (_p24.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p24._0);
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p24._0);
			case 'Layout':
				var _p25 = _p24._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p25,
						{
							attrs: A2(
								_elm_lang$core$Basics_ops['++'],
								_p25.attrs,
								{
									ctor: '::',
									_0: prop,
									_1: {ctor: '[]'}
								})
						}));
			case 'Element':
				var _p26 = _p24._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p26,
						{
							attrs: A2(
								_elm_lang$core$Basics_ops['++'],
								_p26.attrs,
								{
									ctor: '::',
									_0: prop,
									_1: {ctor: '[]'}
								})
						}));
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						attrs: {
							ctor: '::',
							_0: prop,
							_1: {ctor: '[]'}
						},
						child: A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p24._0, _p24._1),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$addAttr = F2(
	function (prop, el) {
		var _p27 = el;
		switch (_p27.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p27._0);
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p27._0);
			case 'Layout':
				var _p28 = _p27._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p28,
						{
							attrs: {ctor: '::', _0: prop, _1: _p28.attrs}
						}));
			case 'Element':
				var _p29 = _p27._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p29,
						{
							attrs: {ctor: '::', _0: prop, _1: _p29.attrs}
						}));
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						attrs: {
							ctor: '::',
							_0: prop,
							_1: {ctor: '[]'}
						},
						child: A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p27._0, _p27._1),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$addAttrToNonText = F2(
	function (prop, el) {
		var _p30 = el;
		switch (_p30.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p30._0);
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p30._0);
			case 'Layout':
				var _p31 = _p30._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p31,
						{
							attrs: {ctor: '::', _0: prop, _1: _p31.attrs}
						}));
			case 'Element':
				var _p32 = _p30._0;
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p32,
						{
							attrs: {ctor: '::', _0: prop, _1: _p32.attrs}
						}));
			default:
				return A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p30._0, _p30._1);
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$makeInline = function (el) {
	var _p33 = el;
	switch (_p33.ctor) {
		case 'Empty':
			return _mdgriffith$style_elements$Element_Internal_Model$Empty;
		case 'Raw':
			return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p33._0);
		case 'Spacer':
			return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p33._0);
		case 'Layout':
			var _p34 = _p33._0;
			return _mdgriffith$style_elements$Element_Internal_Model$Layout(
				_elm_lang$core$Native_Utils.update(
					_p34,
					{
						attrs: {ctor: '::', _0: _mdgriffith$style_elements$Element_Internal_Model$Inline, _1: _p34.attrs}
					}));
		case 'Element':
			var _p35 = _p33._0;
			return _mdgriffith$style_elements$Element_Internal_Model$Element(
				_elm_lang$core$Native_Utils.update(
					_p35,
					{
						attrs: {ctor: '::', _0: _mdgriffith$style_elements$Element_Internal_Model$Inline, _1: _p35.attrs},
						child: _mdgriffith$style_elements$Element_Internal_Modify$makeInline(_p35.child)
					}));
		default:
			return A2(
				_mdgriffith$style_elements$Element_Internal_Model$Text,
				_elm_lang$core$Native_Utils.update(
					_p33._0,
					{inline: true}),
				_p33._1);
	}
};
var _mdgriffith$style_elements$Element_Internal_Modify$setNode = F2(
	function (node, el) {
		var _p36 = el;
		switch (_p36.ctor) {
			case 'Empty':
				return _mdgriffith$style_elements$Element_Internal_Model$Empty;
			case 'Raw':
				return _mdgriffith$style_elements$Element_Internal_Model$Raw(_p36._0);
			case 'Spacer':
				return _mdgriffith$style_elements$Element_Internal_Model$Spacer(_p36._0);
			case 'Layout':
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p36._0,
						{node: node}));
			case 'Element':
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					_elm_lang$core$Native_Utils.update(
						_p36._0,
						{node: node}));
			default:
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: node,
						style: _elm_lang$core$Maybe$Nothing,
						attrs: {ctor: '[]'},
						child: A2(_mdgriffith$style_elements$Element_Internal_Model$Text, _p36._0, _p36._1),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
		}
	});
var _mdgriffith$style_elements$Element_Internal_Modify$wrapHtml = function (el) {
	var _p37 = el;
	if (_p37.ctor === 'Raw') {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {ctor: '[]'},
				child: _mdgriffith$style_elements$Element_Internal_Model$Raw(_p37._0),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	} else {
		return _p37;
	}
};

var _mdgriffith$style_elements$Element_Internal_Adjustments$spacingToMargin = function (attrs) {
	var spaceToMarg = function (a) {
		var _p0 = a;
		if (_p0.ctor === 'Spacing') {
			var _p2 = _p0._1;
			var _p1 = _p0._0;
			return _mdgriffith$style_elements$Element_Internal_Model$Margin(
				{ctor: '_Tuple4', _0: _p2, _1: _p1, _2: _p2, _3: _p1});
		} else {
			return _p0;
		}
	};
	return A2(_elm_lang$core$List$map, spaceToMarg, attrs);
};
var _mdgriffith$style_elements$Element_Internal_Adjustments$defaultPadding = F2(
	function (_p4, _p3) {
		var _p5 = _p4;
		var _p6 = _p3;
		return {
			ctor: '_Tuple4',
			_0: A2(_elm_lang$core$Maybe$withDefault, _p6._0, _p5._0),
			_1: A2(_elm_lang$core$Maybe$withDefault, _p6._1, _p5._1),
			_2: A2(_elm_lang$core$Maybe$withDefault, _p6._2, _p5._2),
			_3: A2(_elm_lang$core$Maybe$withDefault, _p6._3, _p5._3)
		};
	});
var _mdgriffith$style_elements$Element_Internal_Adjustments$hoistFixedScreenElements = function (el) {
	var elementIsOnScreen = function (attrs) {
		return A2(
			_elm_lang$core$List$any,
			function (attr) {
				return _elm_lang$core$Native_Utils.eq(
					attr,
					_mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_mdgriffith$style_elements$Element_Internal_Model$Screen));
			},
			attrs);
	};
	var _p7 = el;
	switch (_p7.ctor) {
		case 'Element':
			return elementIsOnScreen(_p7._0.attrs) ? {
				ctor: '_Tuple2',
				_0: _mdgriffith$style_elements$Element_Internal_Model$Empty,
				_1: _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: el,
						_1: {ctor: '[]'}
					})
			} : {ctor: '_Tuple2', _0: el, _1: _elm_lang$core$Maybe$Nothing};
		case 'Layout':
			return elementIsOnScreen(_p7._0.attrs) ? {
				ctor: '_Tuple2',
				_0: _mdgriffith$style_elements$Element_Internal_Model$Empty,
				_1: _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: el,
						_1: {ctor: '[]'}
					})
			} : {ctor: '_Tuple2', _0: el, _1: _elm_lang$core$Maybe$Nothing};
		default:
			return {ctor: '_Tuple2', _0: el, _1: _elm_lang$core$Maybe$Nothing};
	}
};
var _mdgriffith$style_elements$Element_Internal_Adjustments$tagIntermediates = false;
var _mdgriffith$style_elements$Element_Internal_Adjustments$tag = function (str) {
	return _mdgriffith$style_elements$Element_Internal_Adjustments$tagIntermediates ? _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$class(str)) : _mdgriffith$style_elements$Element_Internal_Model$Attr(
		_elm_lang$html$Html_Attributes$class(''));
};
var _mdgriffith$style_elements$Element_Internal_Adjustments$counterSpacing = function (elm) {
	var _p8 = elm;
	if (_p8.ctor === 'Layout') {
		var _p25 = _p8._0.layout;
		var _p24 = _p8._0.attrs;
		var forPadding = function (posAttr) {
			var _p9 = posAttr;
			if (_p9.ctor === 'Padding') {
				return _elm_lang$core$Maybe$Just(
					A2(
						_mdgriffith$style_elements$Element_Internal_Adjustments$defaultPadding,
						{ctor: '_Tuple4', _0: _p9._0, _1: _p9._1, _2: _p9._2, _3: _p9._3},
						{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0}));
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var forSpacing = function (posAttr) {
			var _p10 = posAttr;
			if (_p10.ctor === 'Spacing') {
				var _p12 = _p10._1;
				var _p11 = _p10._0;
				return _elm_lang$core$Maybe$Just(
					{ctor: '_Tuple4', _0: _p12, _1: _p11, _2: _p12, _3: _p11});
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var padding = _elm_lang$core$List$head(
			_elm_lang$core$List$reverse(
				A2(_elm_lang$core$List$filterMap, forPadding, _p24)));
		var spacing = _elm_lang$core$List$head(
			_elm_lang$core$List$reverse(
				A2(_elm_lang$core$List$filterMap, forSpacing, _p24)));
		var hasSpacing = function () {
			var _p13 = spacing;
			if (_p13.ctor === 'Nothing') {
				return false;
			} else {
				return true;
			}
		}();
		var _p14 = A2(
			_elm_lang$core$List$partition,
			function (attr) {
				return _elm_lang$core$Native_Utils.eq(
					attr,
					_mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Center)) || _elm_lang$core$Native_Utils.eq(
					attr,
					_mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$VerticalCenter));
			},
			_p24);
		var centeredProps = _p14._0;
		var others = _p14._1;
		var _p15 = _p25;
		if (_p15.ctor === 'FlexLayout') {
			if (hasSpacing) {
				var phantomPadding = _mdgriffith$style_elements$Element_Internal_Model$PhantomPadding(
					A2(
						_elm_lang$core$Maybe$withDefault,
						{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0},
						padding));
				var _p16 = function () {
					var _p17 = spacing;
					if (_p17.ctor === 'Nothing') {
						return {
							ctor: '_Tuple3',
							_0: {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0},
							_1: A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, 0, 0),
							_2: 0
						};
					} else {
						var _p20 = _p17._0._1;
						var _p19 = _p17._0._3;
						var _p18 = _p17._0._2;
						return {
							ctor: '_Tuple3',
							_0: {ctor: '_Tuple4', _0: -1 * _p17._0._0, _1: -1 * _p20, _2: -1 * _p18, _3: -1 * _p19},
							_1: A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, _p20, _p18),
							_2: (_p20 + _p19) / 2
						};
					}
				}();
				var negativeMargin = _p16._0;
				var spacingAttr = _p16._1;
				var totalHSpacing = _p16._2;
				var forAlignment = function (attr) {
					var _p21 = attr;
					switch (_p21.ctor) {
						case 'HAlign':
							return true;
						case 'VAlign':
							return true;
						default:
							return false;
					}
				};
				var _p22 = A2(_elm_lang$core$List$partition, forAlignment, _p24);
				var aligned = _p22._0;
				var unaligned = _p22._1;
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: _p8._0.node,
						style: _p8._0.style,
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '[]'}),
						attrs: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('counter-spacing-container'),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true),
								_1: unaligned
							}
						},
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Layout(
									{
										node: 'div',
										style: _elm_lang$core$Maybe$Nothing,
										layout: _p25,
										attrs: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('counter-spacing'),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
												_1: {
													ctor: '::',
													_0: phantomPadding,
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Internal_Model$Margin(negativeMargin),
														_1: {
															ctor: '::',
															_0: spacingAttr,
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
																	A2(_mdgriffith$style_elements$Style_Internal_Model$Calc, 100, totalHSpacing)),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Internal_Model$Shrink(1),
																	_1: aligned
																}
															}
														}
													}
												}
											}
										},
										children: function () {
											var _p23 = _p8._0.children;
											if (_p23.ctor === 'Normal') {
												return _mdgriffith$style_elements$Element_Internal_Model$Normal(
													A2(
														_elm_lang$core$List$map,
														_mdgriffith$style_elements$Element_Internal_Modify$addAttr(
															_mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true)),
														_p23._0));
											} else {
												return _mdgriffith$style_elements$Element_Internal_Model$Keyed(
													A2(
														_elm_lang$core$List$map,
														_elm_lang$core$Tuple$mapSecond(
															_mdgriffith$style_elements$Element_Internal_Modify$addAttr(
																_mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true))),
														_p23._0));
											}
										}(),
										absolutelyPositioned: _elm_lang$core$Maybe$Nothing
									}),
								_1: {ctor: '[]'}
							}),
						absolutelyPositioned: _p8._0.absolutelyPositioned
					});
			} else {
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					_elm_lang$core$Native_Utils.update(
						_p8._0,
						{
							attrs: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true),
								_1: _p24
							}
						}));
			}
		} else {
			return elm;
		}
	} else {
		return elm;
	}
};
var _mdgriffith$style_elements$Element_Internal_Adjustments$positionNearby = F2(
	function (parent, elm) {
		var setPosition = F3(
			function (nearbyPosition, _p26, el) {
				var _p27 = _p26;
				var _p37 = _p27._1;
				var _p36 = _p27._0;
				var nearbyAlignment = function () {
					var _p28 = nearbyPosition;
					_v13_4:
					do {
						if ((_p28.ctor === 'Just') && (_p28._0.ctor === 'Nearby')) {
							switch (_p28._0._0.ctor) {
								case 'Above':
									return {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Top),
										_1: {ctor: '[]'}
									};
								case 'Below':
									return {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Bottom),
										_1: {ctor: '[]'}
									};
								case 'OnRight':
									return {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Right),
										_1: {ctor: '[]'}
									};
								case 'OnLeft':
									return {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Left),
										_1: {ctor: '[]'}
									};
								default:
									break _v13_4;
							}
						} else {
							break _v13_4;
						}
					} while(false);
					return {ctor: '[]'};
				}();
				var isLayout = function () {
					var _p29 = elm;
					if (_p29.ctor === 'Layout') {
						return true;
					} else {
						return false;
					}
				}();
				var framed = function () {
					var _p30 = nearbyPosition;
					if (_p30.ctor === 'Nothing') {
						return false;
					} else {
						return true;
					}
				}();
				var forHeight = function (prop) {
					var _p31 = prop;
					if (_p31.ctor === 'Height') {
						return true;
					} else {
						return false;
					}
				};
				var height = _elm_lang$core$List$head(
					_elm_lang$core$List$reverse(
						A2(_elm_lang$core$List$filter, forHeight, _p37)));
				var forWidth = function (prop) {
					var _p32 = prop;
					if (_p32.ctor === 'Width') {
						return true;
					} else {
						return false;
					}
				};
				var width = _elm_lang$core$List$head(
					_elm_lang$core$List$reverse(
						A2(_elm_lang$core$List$filter, forWidth, _p37)));
				var addWidthHeight = function (attrs) {
					var _p33 = {ctor: '_Tuple2', _0: width, _1: height};
					if (_p33._0.ctor === 'Nothing') {
						if (_p33._1.ctor === 'Nothing') {
							return attrs;
						} else {
							return {ctor: '::', _0: _p33._1._0, _1: attrs};
						}
					} else {
						if (_p33._1.ctor === 'Just') {
							return {
								ctor: '::',
								_0: _p33._0._0,
								_1: {ctor: '::', _0: _p33._1._0, _1: attrs}
							};
						} else {
							return {ctor: '::', _0: _p33._0._0, _1: attrs};
						}
					}
				};
				var adjustWidthHeight = function (elem) {
					var adjustHeight = function (element) {
						var _p34 = height;
						if (_p34.ctor === 'Nothing') {
							return element;
						} else {
							if ((_p34._0.ctor === 'Height') && (_p34._0._0.ctor === 'Percent')) {
								return A2(
									_mdgriffith$style_elements$Element_Internal_Modify$addAttrPriority,
									_mdgriffith$style_elements$Element_Internal_Model$Width(
										_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
									element);
							} else {
								return element;
							}
						}
					};
					var adjustWidth = function (element) {
						var _p35 = width;
						if (_p35.ctor === 'Nothing') {
							return element;
						} else {
							if ((_p35._0.ctor === 'Width') && (_p35._0._0.ctor === 'Percent')) {
								return A2(
									_mdgriffith$style_elements$Element_Internal_Modify$addAttrPriority,
									_mdgriffith$style_elements$Element_Internal_Model$Width(
										_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
									element);
							} else {
								return element;
							}
						}
					};
					return adjustHeight(
						adjustWidth(elem));
				};
				return (_elm_lang$core$Native_Utils.eq(
					nearbyPosition,
					_elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$Above))) || _elm_lang$core$Native_Utils.eq(
					nearbyPosition,
					_elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$Below)))) ? _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '[]'}),
						attrs: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('above-below-intermediate-parent'),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Model$Height(
										_mdgriffith$style_elements$Style_Internal_Model$Px(0)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
											_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
												_mdgriffith$style_elements$Element_Internal_Model$Absolute(
													_elm_lang$core$Native_Utils.eq(
														nearbyPosition,
														_elm_lang$core$Maybe$Just(
															_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$Above))) ? _mdgriffith$style_elements$Element_Internal_Model$TopLeft : _mdgriffith$style_elements$Element_Internal_Model$BottomLeft)),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element_Internal_Model$Position,
													_elm_lang$core$Maybe$Just(0),
													_elm_lang$core$Maybe$Just(0),
													_elm_lang$core$Maybe$Nothing),
												_1: isLayout ? nearbyAlignment : A2(_elm_lang$core$Basics_ops['++'], nearbyAlignment, _p36)
											}
										}
									}
								}
							}
						},
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Element(
									{
										node: 'div',
										style: _elm_lang$core$Maybe$Nothing,
										attrs: function () {
											var addWidth = function (attrs) {
												return isLayout ? {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
														_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
													_1: attrs
												} : attrs;
											};
											return addWidth(
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('above-below-intermediate'),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
																_mdgriffith$style_elements$Element_Internal_Model$Absolute(
																	_elm_lang$core$Native_Utils.eq(
																		nearbyPosition,
																		_elm_lang$core$Maybe$Just(
																			_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$Above))) ? _mdgriffith$style_elements$Element_Internal_Model$BottomLeft : _mdgriffith$style_elements$Element_Internal_Model$TopLeft)),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element_Internal_Model$Position,
																	_elm_lang$core$Maybe$Nothing,
																	_elm_lang$core$Maybe$Just(0),
																	_elm_lang$core$Maybe$Nothing),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Bottom),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
																			_elm_lang$html$Html_Attributes$style(
																				{
																					ctor: '::',
																					_0: {ctor: '_Tuple2', _0: 'z-index', _1: '10'},
																					_1: {ctor: '[]'}
																				})),
																		_1: {ctor: '[]'}
																	}
																}
															}
														}
													}
												});
										}(),
										child: _mdgriffith$style_elements$Element_Internal_Adjustments$counterSpacing(
											A2(
												_mdgriffith$style_elements$Element_Internal_Modify$setAttrs,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
															_mdgriffith$style_elements$Element_Internal_Model$Absolute(_mdgriffith$style_elements$Element_Internal_Model$TopLeft)),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element_Internal_Model$Position,
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Nothing),
															_1: _p37
														}
													}
												},
												el)),
										absolutelyPositioned: _elm_lang$core$Maybe$Nothing
									}),
								_1: {ctor: '[]'}
							}),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					}) : (framed ? _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '[]'}),
						attrs: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('nearby-intermediate-parent'),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Model$Height(
										_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
											_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
												_mdgriffith$style_elements$Element_Internal_Model$Absolute(_mdgriffith$style_elements$Element_Internal_Model$TopLeft)),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element_Internal_Model$Position,
													_elm_lang$core$Maybe$Just(0),
													_elm_lang$core$Maybe$Just(0),
													_elm_lang$core$Maybe$Nothing),
												_1: isLayout ? nearbyAlignment : A2(_elm_lang$core$Basics_ops['++'], nearbyAlignment, _p36)
											}
										}
									}
								}
							}
						},
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Element(
									{
										node: 'div',
										style: _elm_lang$core$Maybe$Nothing,
										attrs: addWidthHeight(
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_mdgriffith$style_elements$Element_Internal_Model$Relative),
													_1: {
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element_Internal_Model$Position,
															_elm_lang$core$Maybe$Just(0),
															_elm_lang$core$Maybe$Just(0),
															_elm_lang$core$Maybe$Nothing),
														_1: {
															ctor: '::',
															_0: A4(
																_mdgriffith$style_elements$Element_Internal_Model$Padding,
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Just(0)),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
																	_elm_lang$html$Html_Attributes$style(
																		{
																			ctor: '::',
																			_0: {ctor: '_Tuple2', _0: 'z-index', _1: '10'},
																			_1: {ctor: '[]'}
																		})),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('nearby-intermediate'),
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}),
										child: _mdgriffith$style_elements$Element_Internal_Adjustments$counterSpacing(
											adjustWidthHeight(
												A2(
													_mdgriffith$style_elements$Element_Internal_Modify$addAttrList,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
																_mdgriffith$style_elements$Element_Internal_Model$Absolute(_mdgriffith$style_elements$Element_Internal_Model$TopLeft)),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element_Internal_Model$Position,
																	_elm_lang$core$Maybe$Just(0),
																	_elm_lang$core$Maybe$Just(0),
																	_elm_lang$core$Maybe$Nothing),
																_1: {ctor: '[]'}
															}
														}
													},
													el))),
										absolutelyPositioned: _elm_lang$core$Maybe$Nothing
									}),
								_1: {ctor: '[]'}
							}),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					}) : ((!_elm_lang$core$List$isEmpty(_p36)) ? _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: 'div',
						style: _elm_lang$core$Maybe$Nothing,
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '[]'}),
						attrs: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('nearby-aligned-intermediate-parent'),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Model$Height(
										_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
											_mdgriffith$style_elements$Style_Internal_Model$Percent(100)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_mdgriffith$style_elements$Element_Internal_Model$Relative),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element_Internal_Model$Position,
													_elm_lang$core$Maybe$Just(0),
													_elm_lang$core$Maybe$Just(0),
													_elm_lang$core$Maybe$Nothing),
												_1: isLayout ? nearbyAlignment : A2(_elm_lang$core$Basics_ops['++'], nearbyAlignment, _p36)
											}
										}
									}
								}
							}
						},
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Element(
									{
										node: 'div',
										style: _elm_lang$core$Maybe$Nothing,
										attrs: addWidthHeight(
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_mdgriffith$style_elements$Element_Internal_Model$Relative),
													_1: {
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element_Internal_Model$Position,
															_elm_lang$core$Maybe$Just(0),
															_elm_lang$core$Maybe$Just(0),
															_elm_lang$core$Maybe$Nothing),
														_1: {
															ctor: '::',
															_0: A4(
																_mdgriffith$style_elements$Element_Internal_Model$Padding,
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Just(0),
																_elm_lang$core$Maybe$Just(0)),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('nearby-aligned-intermediate'),
																_1: {ctor: '[]'}
															}
														}
													}
												}
											}),
										child: _mdgriffith$style_elements$Element_Internal_Adjustments$counterSpacing(
											adjustWidthHeight(
												A2(
													_mdgriffith$style_elements$Element_Internal_Modify$addAttrList,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_mdgriffith$style_elements$Element_Internal_Model$Relative),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element_Internal_Model$Position,
																	_elm_lang$core$Maybe$Just(0),
																	_elm_lang$core$Maybe$Just(0),
																	_elm_lang$core$Maybe$Nothing),
																_1: {ctor: '[]'}
															}
														}
													},
													el))),
										absolutelyPositioned: _elm_lang$core$Maybe$Nothing
									}),
								_1: {ctor: '[]'}
							}),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					}) : _mdgriffith$style_elements$Element_Internal_Adjustments$counterSpacing(elm)));
			});
		var forAlignment = function (attr) {
			var _p38 = attr;
			switch (_p38.ctor) {
				case 'HAlign':
					return true;
				case 'VAlign':
					return true;
				default:
					return false;
			}
		};
		var separateAlignment = function (attrs) {
			return A2(_elm_lang$core$List$partition, forAlignment, attrs);
		};
		var _p39 = elm;
		switch (_p39.ctor) {
			case 'Element':
				var _p43 = _p39._0.attrs;
				var isFrame = function (attr) {
					var _p40 = attr;
					if (_p40.ctor === 'PositionFrame') {
						return _elm_lang$core$Maybe$Just(_p40._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				};
				var frame = _elm_lang$core$List$head(
					A2(_elm_lang$core$List$filterMap, isFrame, _p43));
				var _p41 = separateAlignment(_p43);
				var aligned = _p41._0;
				var unaligned = _p41._1;
				var _p42 = parent;
				if (_p42.ctor === 'Nothing') {
					return A3(
						setPosition,
						frame,
						{ctor: '_Tuple2', _0: aligned, _1: unaligned},
						elm);
				} else {
					return elm;
				}
			case 'Layout':
				var _p47 = _p39._0.attrs;
				var isFrame = function (attr) {
					var _p44 = attr;
					if (_p44.ctor === 'PositionFrame') {
						return _elm_lang$core$Maybe$Just(_p44._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				};
				var frame = _elm_lang$core$List$head(
					A2(_elm_lang$core$List$filterMap, isFrame, _p47));
				var _p45 = separateAlignment(_p47);
				var aligned = _p45._0;
				var unaligned = _p45._1;
				var _p46 = parent;
				if (_p46.ctor === 'Nothing') {
					return A3(
						setPosition,
						frame,
						{ctor: '_Tuple2', _0: aligned, _1: unaligned},
						elm);
				} else {
					return _mdgriffith$style_elements$Element_Internal_Adjustments$counterSpacing(elm);
				}
			default:
				return _mdgriffith$style_elements$Element_Internal_Adjustments$counterSpacing(elm);
		}
	});
var _mdgriffith$style_elements$Element_Internal_Adjustments$centerTextLayout = function (elm) {
	var _p48 = elm;
	if (_p48.ctor === 'Layout') {
		var _p49 = A2(
			_elm_lang$core$List$partition,
			function (attr) {
				return _elm_lang$core$Native_Utils.eq(
					attr,
					_mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Center)) || _elm_lang$core$Native_Utils.eq(
					attr,
					_mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$VerticalCenter));
			},
			_p48._0.attrs);
		var centeredProps = _p49._0;
		var others = _p49._1;
		var _p50 = _p48._0.layout;
		if (_p50.ctor === 'TextLayout') {
			return (!_elm_lang$core$List$isEmpty(centeredProps)) ? _mdgriffith$style_elements$Element_Internal_Model$Layout(
				{
					node: 'div',
					style: _elm_lang$core$Maybe$Nothing,
					layout: A2(
						_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
						_mdgriffith$style_elements$Style_Internal_Model$GoRight,
						{ctor: '[]'}),
					attrs: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Adjustments$tag('center-text'),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
							_1: centeredProps
						}
					},
					children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Layout(
								_elm_lang$core$Native_Utils.update(
									_p48._0,
									{
										attrs: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(true),
											_1: others
										}
									})),
							_1: {ctor: '[]'}
						}),
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				}) : elm;
		} else {
			return elm;
		}
	} else {
		return elm;
	}
};
var _mdgriffith$style_elements$Element_Internal_Adjustments$apply = function (root) {
	var stack = F2(
		function (parent, el) {
			return function (_p51) {
				return _mdgriffith$style_elements$Element_Internal_Adjustments$hoistFixedScreenElements(
					A2(
						_mdgriffith$style_elements$Element_Internal_Adjustments$positionNearby,
						parent,
						_mdgriffith$style_elements$Element_Internal_Adjustments$centerTextLayout(_p51)));
			}(el);
		});
	return A3(_mdgriffith$style_elements$Element_Internal_Model$adjust, stack, _elm_lang$core$Maybe$Nothing, root);
};

var _mdgriffith$style_elements$Style_Internal_Render_Property$flexbox = F2(
	function (dir, el) {
		var _p0 = el;
		switch (_p0.ctor) {
			case 'Wrap':
				return _p0._0 ? {ctor: '_Tuple2', _0: 'flex-wrap', _1: 'wrap'} : {ctor: '_Tuple2', _0: 'flex-wrap', _1: 'nowrap'};
			case 'Horz':
				var _p6 = _p0._0;
				var _p1 = dir;
				switch (_p1.ctor) {
					case 'GoRight':
						var _p2 = _p6;
						switch (_p2.ctor) {
							case 'Other':
								if (_p2._0.ctor === 'Left') {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-start'};
								} else {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-end'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
							default:
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
						}
					case 'GoLeft':
						var _p3 = _p6;
						switch (_p3.ctor) {
							case 'Other':
								if (_p3._0.ctor === 'Left') {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-end'};
								} else {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-start'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
							default:
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
						}
					case 'Down':
						var _p4 = _p6;
						switch (_p4.ctor) {
							case 'Other':
								if (_p4._0.ctor === 'Left') {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-start'};
								} else {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-end'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
							default:
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
						}
					default:
						var _p5 = _p6;
						switch (_p5.ctor) {
							case 'Other':
								if (_p5._0.ctor === 'Left') {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-start'};
								} else {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-end'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
							default:
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
						}
				}
			default:
				var _p12 = _p0._0;
				var _p7 = dir;
				switch (_p7.ctor) {
					case 'GoRight':
						var _p8 = _p12;
						switch (_p8.ctor) {
							case 'Other':
								if (_p8._0.ctor === 'Top') {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-start'};
								} else {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-end'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
							default:
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
						}
					case 'GoLeft':
						var _p9 = _p12;
						switch (_p9.ctor) {
							case 'Other':
								if (_p9._0.ctor === 'Top') {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-start'};
								} else {
									return {ctor: '_Tuple2', _0: 'align-items', _1: 'flex-end'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
							default:
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
						}
					case 'Down':
						var _p10 = _p12;
						switch (_p10.ctor) {
							case 'Other':
								if (_p10._0.ctor === 'Top') {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-start'};
								} else {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-end'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
							default:
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
						}
					default:
						var _p11 = _p12;
						switch (_p11.ctor) {
							case 'Other':
								if (_p11._0.ctor === 'Top') {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-end'};
								} else {
									return {ctor: '_Tuple2', _0: 'justify-content', _1: 'flex-start'};
								}
							case 'Center':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'center'};
							case 'Justify':
								return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
							default:
								return {ctor: '_Tuple2', _0: 'align-items', _1: 'Justify'};
						}
				}
		}
	});
var _mdgriffith$style_elements$Style_Internal_Render_Property$transition = function (_p13) {
	var _p14 = _p13;
	var formatTrans = function (prop) {
		return A2(
			_elm_lang$core$String$join,
			' ',
			{
				ctor: '::',
				_0: prop,
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p14._0.duration * _elm_lang$core$Time$millisecond),
						'ms'),
					_1: {
						ctor: '::',
						_0: _p14._0.easing,
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p14._0.delay * _elm_lang$core$Time$millisecond),
								'ms'),
							_1: {ctor: '[]'}
						}
					}
				}
			});
	};
	return A2(
		_elm_lang$core$String$join,
		', ',
		A2(_elm_lang$core$List$map, formatTrans, _p14._0.props));
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$direction = function (dir) {
	var _p15 = dir;
	switch (_p15.ctor) {
		case 'GoRight':
			return {ctor: '_Tuple2', _0: 'flex-direction', _1: 'row'};
		case 'GoLeft':
			return {ctor: '_Tuple2', _0: 'flex-direction', _1: 'row-reverse'};
		case 'Down':
			return {ctor: '_Tuple2', _0: 'flex-direction', _1: 'column'};
		default:
			return {ctor: '_Tuple2', _0: 'flex-direction', _1: 'column-reverse'};
	}
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$gridAlignment = function (align) {
	var _p16 = align;
	switch (_p16.ctor) {
		case 'GridGap':
			return {
				ctor: '_Tuple2',
				_0: 'grid-gap',
				_1: A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p16._0),
					A2(
						_elm_lang$core$Basics_ops['++'],
						'px ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p16._1),
							'px')))
			};
		case 'GridH':
			var _p17 = _p16._0;
			switch (_p17.ctor) {
				case 'Other':
					if (_p17._0.ctor === 'Left') {
						return {ctor: '_Tuple2', _0: 'justify-content', _1: 'start'};
					} else {
						return {ctor: '_Tuple2', _0: 'justify-content', _1: 'end'};
					}
				case 'Center':
					return {ctor: '_Tuple2', _0: 'justify-content', _1: 'center'};
				case 'Justify':
					return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
				default:
					return {ctor: '_Tuple2', _0: 'justify-content', _1: 'space-between'};
			}
		default:
			var _p18 = _p16._0;
			switch (_p18.ctor) {
				case 'Other':
					if (_p18._0.ctor === 'Top') {
						return {ctor: '_Tuple2', _0: 'align-content', _1: 'start'};
					} else {
						return {ctor: '_Tuple2', _0: 'align-content', _1: 'end'};
					}
				case 'Center':
					return {ctor: '_Tuple2', _0: 'align-content', _1: 'center'};
				case 'Justify':
					return {ctor: '_Tuple2', _0: 'align-content', _1: 'space-between'};
				default:
					return {ctor: '_Tuple2', _0: 'align-content', _1: 'space-between'};
			}
	}
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$layout = F2(
	function (inline, lay) {
		var _p19 = lay;
		switch (_p19.ctor) {
			case 'TextLayout':
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'display',
						_1: inline ? 'inline-block' : 'block'
					},
					_1: {ctor: '[]'}
				};
			case 'FlexLayout':
				var _p20 = _p19._0;
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'display',
						_1: inline ? 'inline-flex' : 'flex'
					},
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Internal_Render_Property$direction(_p20),
						_1: A2(
							_elm_lang$core$List$map,
							_mdgriffith$style_elements$Style_Internal_Render_Property$flexbox(_p20),
							_p19._1)
					}
				};
			default:
				if (_p19._0.ctor === 'NamedGridTemplate') {
					var _p31 = _p19._0._0.rows;
					var _p30 = _p19._0._0.columns;
					var areaSpan = function (_p21) {
						var _p22 = _p21;
						var name = function () {
							var _p23 = _p22._1;
							if (_p23.ctor === 'Nothing') {
								return '.';
							} else {
								return _p23._0;
							}
						}();
						var _p24 = _p22._0;
						if (_p24.ctor === 'SpanAll') {
							return A2(
								_elm_lang$core$List$repeat,
								_elm_lang$core$List$length(_p30),
								name);
						} else {
							return A2(_elm_lang$core$List$repeat, _p24._0, name);
						}
					};
					var areasInRow = function (areas) {
						var areaStrs = A2(_elm_lang$core$List$concatMap, areaSpan, areas);
						var quote = function (str) {
							return A2(
								_elm_lang$core$Basics_ops['++'],
								'\"',
								A2(_elm_lang$core$Basics_ops['++'], str, '\"'));
						};
						if (_elm_lang$core$Native_Utils.cmp(
							_elm_lang$core$List$length(areaStrs),
							_elm_lang$core$List$length(_p30)) > 0) {
							var _p25 = A2(
								_elm_lang$core$Basics_ops['++'],
								A2(_elm_lang$core$Debug$log, 'style-elements', 'Named grid row ('),
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(areas),
									') is too big for this grid!'));
							return quote(
								A2(_elm_lang$core$String$join, ' ', areaStrs));
						} else {
							if (_elm_lang$core$Native_Utils.cmp(
								_elm_lang$core$List$length(areaStrs),
								_elm_lang$core$List$length(_p30)) < 0) {
								var _p26 = A2(
									_elm_lang$core$Basics_ops['++'],
									A2(_elm_lang$core$Debug$log, 'style-elements', 'Named grid row ('),
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(areas),
										') doesn\'t have enough names to fit this grid!'));
								return quote(
									A2(_elm_lang$core$String$join, ' ', areaStrs));
							} else {
								return quote(
									A2(_elm_lang$core$String$join, ' ', areaStrs));
							}
						}
					};
					var alignment = A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Style_Internal_Render_Property$gridAlignment, _p19._1);
					var renderLen = function (len) {
						var _p27 = len;
						switch (_p27.ctor) {
							case 'Px':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p27._0),
									'px');
							case 'Percent':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p27._0),
									'%');
							case 'Auto':
								return 'auto';
							case 'Fill':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p27._0),
									'fr');
							default:
								return A2(
									_elm_lang$core$Basics_ops['++'],
									'calc(',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p27._0),
										A2(
											_elm_lang$core$Basics_ops['++'],
											'% + ',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p27._1),
												'px)'))));
						}
					};
					var grid = inline ? {ctor: '_Tuple2', _0: 'display', _1: 'inline-grid'} : {ctor: '_Tuple2', _0: 'display', _1: 'grid'};
					return {
						ctor: '::',
						_0: grid,
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'grid-template-rows',
								_1: A2(
									_elm_lang$core$String$join,
									' ',
									A2(
										_elm_lang$core$List$map,
										function (_p28) {
											return renderLen(
												_elm_lang$core$Tuple$first(_p28));
										},
										_p31))
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'grid-template-columns',
									_1: A2(
										_elm_lang$core$String$join,
										' ',
										A2(_elm_lang$core$List$map, renderLen, _p30))
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'grid-template-areas',
										_1: A2(
											_elm_lang$core$String$join,
											'\n',
											A2(
												_elm_lang$core$List$map,
												function (_p29) {
													return areasInRow(
														_elm_lang$core$Tuple$second(_p29));
												},
												_p31))
									},
									_1: alignment
								}
							}
						}
					};
				} else {
					var alignment = A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Style_Internal_Render_Property$gridAlignment, _p19._1);
					var renderLen = function (len) {
						var _p32 = len;
						switch (_p32.ctor) {
							case 'Px':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p32._0),
									'px');
							case 'Percent':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p32._0),
									'%');
							case 'Auto':
								return 'auto';
							case 'Fill':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p32._0),
									'fr');
							default:
								return A2(
									_elm_lang$core$Basics_ops['++'],
									'calc(',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p32._0),
										A2(
											_elm_lang$core$Basics_ops['++'],
											'% + ',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p32._1),
												'px)'))));
						}
					};
					var grid = inline ? {ctor: '_Tuple2', _0: 'display', _1: 'inline-grid'} : {ctor: '_Tuple2', _0: 'display', _1: 'grid'};
					return {
						ctor: '::',
						_0: grid,
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'grid-template-rows',
								_1: A2(
									_elm_lang$core$String$join,
									' ',
									A2(_elm_lang$core$List$map, renderLen, _p19._0._0.rows))
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'grid-template-columns',
									_1: A2(
										_elm_lang$core$String$join,
										' ',
										A2(_elm_lang$core$List$map, renderLen, _p19._0._0.columns))
								},
								_1: alignment
							}
						}
					};
				}
		}
	});
var _mdgriffith$style_elements$Style_Internal_Render_Property$background = function (prop) {
	var renderStep = function (step) {
		var _p33 = step;
		switch (_p33.ctor) {
			case 'ColorStep':
				return _mdgriffith$style_elements$Style_Internal_Render_Value$color(_p33._0);
			case 'PercentStep':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_mdgriffith$style_elements$Style_Internal_Render_Value$color(_p33._0),
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p33._1),
							'%')));
			default:
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_mdgriffith$style_elements$Style_Internal_Render_Value$color(_p33._0),
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p33._1),
							'px')));
		}
	};
	var directionName = function (dir) {
		var _p34 = dir;
		switch (_p34.ctor) {
			case 'ToUp':
				return 'to top';
			case 'ToDown':
				return 'to bottom';
			case 'ToRight':
				return 'to right';
			case 'ToTopRight':
				return 'to top right';
			case 'ToBottomRight':
				return 'to bottom right';
			case 'ToLeft':
				return 'to left';
			case 'ToTopLeft':
				return 'to top left';
			case 'ToBottomLeft':
				return 'to bottom left';
			default:
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p34._0),
					'rad');
		}
	};
	var _p35 = prop;
	switch (_p35.ctor) {
		case 'BackgroundElement':
			return {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: _p35._0, _1: _p35._1},
				_1: {ctor: '[]'}
			};
		case 'BackgroundImage':
			var _p38 = _p35._0.position;
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'background-image',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						'url(',
						A2(_elm_lang$core$Basics_ops['++'], _p35._0.src, ')'))
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'background-position',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(
								_elm_lang$core$Tuple$first(_p38)),
							A2(
								_elm_lang$core$Basics_ops['++'],
								'px ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(
										_elm_lang$core$Tuple$second(_p38)),
									'px')))
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'background-repeat',
							_1: function () {
								var _p36 = _p35._0.repeat;
								switch (_p36.ctor) {
									case 'RepeatX':
										return 'repeat-x';
									case 'RepeatY':
										return 'repeat-y';
									case 'Repeat':
										return 'repeat';
									case 'Space':
										return 'space';
									case 'Round':
										return 'round';
									default:
										return 'no-repeat';
								}
							}()
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'background-size',
								_1: function () {
									var _p37 = _p35._0.size;
									switch (_p37.ctor) {
										case 'Contain':
											return 'contain';
										case 'Cover':
											return 'cover';
										case 'BackgroundWidth':
											return A2(
												_elm_lang$core$Basics_ops['++'],
												_mdgriffith$style_elements$Style_Internal_Render_Value$length(_p37._0),
												' auto');
										case 'BackgroundHeight':
											return A2(
												_elm_lang$core$Basics_ops['++'],
												'auto ',
												_mdgriffith$style_elements$Style_Internal_Render_Value$length(_p37._0));
										default:
											return A2(
												_elm_lang$core$Basics_ops['++'],
												_mdgriffith$style_elements$Style_Internal_Render_Value$length(_p37._0.width),
												A2(
													_elm_lang$core$Basics_ops['++'],
													' ',
													_mdgriffith$style_elements$Style_Internal_Render_Value$length(_p37._0.height)));
									}
								}()
							},
							_1: {ctor: '[]'}
						}
					}
				}
			};
		default:
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'background-image',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						'linear-gradient(',
						A2(
							_elm_lang$core$Basics_ops['++'],
							A2(
								_elm_lang$core$String$join,
								', ',
								{
									ctor: '::',
									_0: directionName(_p35._0),
									_1: A2(_elm_lang$core$List$map, renderStep, _p35._1)
								}),
							')'))
				},
				_1: {ctor: '[]'}
			};
	}
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$position = function (posEls) {
	var renderPos = function (pos) {
		var _p39 = pos;
		switch (_p39.ctor) {
			case 'RelativeTo':
				switch (_p39._0.ctor) {
					case 'Screen':
						return {ctor: '_Tuple2', _0: 'position', _1: 'fixed'};
					case 'Parent':
						return {ctor: '_Tuple2', _0: 'position', _1: 'absolute'};
					default:
						return {ctor: '_Tuple2', _0: 'position', _1: 'relative'};
				}
			case 'PosLeft':
				return {
					ctor: '_Tuple2',
					_0: 'left',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p39._0),
						'px')
				};
			case 'PosRight':
				return {
					ctor: '_Tuple2',
					_0: 'right',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p39._0),
						'px')
				};
			case 'PosTop':
				return {
					ctor: '_Tuple2',
					_0: 'top',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p39._0),
						'px')
				};
			case 'PosBottom':
				return {
					ctor: '_Tuple2',
					_0: 'bottom',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p39._0),
						'px')
				};
			case 'ZIndex':
				return {
					ctor: '_Tuple2',
					_0: 'z-index',
					_1: _elm_lang$core$Basics$toString(_p39._0)
				};
			case 'Inline':
				return {ctor: '_Tuple2', _0: 'display', _1: 'inline-block'};
			default:
				switch (_p39._0.ctor) {
					case 'FloatLeft':
						return {ctor: '_Tuple2', _0: 'float', _1: 'left'};
					case 'FloatRight':
						return {ctor: '_Tuple2', _0: 'float', _1: 'right'};
					case 'FloatTopLeft':
						return {ctor: '_Tuple2', _0: 'float', _1: 'left'};
					default:
						return {ctor: '_Tuple2', _0: 'float', _1: 'right'};
				}
		}
	};
	return A2(_elm_lang$core$List$map, renderPos, posEls);
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$transformations = function (transforms) {
	var transformToString = function (transform) {
		var _p40 = transform;
		switch (_p40.ctor) {
			case 'Translate':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'translate3d(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p40._0),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'px, ',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p40._1),
								A2(
									_elm_lang$core$Basics_ops['++'],
									'px, ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p40._2),
										'px)'))))));
			case 'RotateAround':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'rotate3d(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p40._0),
						A2(
							_elm_lang$core$Basics_ops['++'],
							',',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p40._1),
								A2(
									_elm_lang$core$Basics_ops['++'],
									',',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p40._2),
										A2(
											_elm_lang$core$Basics_ops['++'],
											',',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p40._3),
												'rad)'))))))));
			case 'Rotate':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'rotate(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p40._0),
						'rad)'));
			default:
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'scale3d(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p40._0),
						A2(
							_elm_lang$core$Basics_ops['++'],
							', ',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p40._1),
								A2(
									_elm_lang$core$Basics_ops['++'],
									', ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p40._2),
										')'))))));
		}
	};
	var transformString = A2(
		_elm_lang$core$String$join,
		' ',
		A2(_elm_lang$core$List$map, transformToString, transforms));
	var renderedTransforms = (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$String$length(transformString),
		0) > 0) ? {
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'transform', _1: transformString},
		_1: {ctor: '[]'}
	} : {ctor: '[]'};
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$List$length(transforms),
		0) ? {ctor: '[]'} : renderedTransforms;
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$box = function (_p41) {
	var _p42 = _p41;
	return {ctor: '_Tuple2', _0: _p42._0, _1: _p42._1};
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$shadow = function (shadows) {
	var _p43 = A2(
		_elm_lang$core$List$partition,
		function (_p44) {
			var _p45 = _p44;
			return _elm_lang$core$Native_Utils.eq(_p45._0.kind, 'text');
		},
		shadows);
	var text = _p43._0;
	var box = _p43._1;
	var renderedBox = A2(
		_elm_lang$core$String$join,
		', ',
		A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Style_Internal_Render_Value$shadow, box));
	var renderedText = A2(
		_elm_lang$core$String$join,
		', ',
		A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Style_Internal_Render_Value$shadow, text));
	return A2(
		_elm_lang$core$List$filterMap,
		_elm_lang$core$Basics$identity,
		{
			ctor: '::',
			_0: _elm_lang$core$Native_Utils.eq(renderedBox, '') ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
				{ctor: '_Tuple2', _0: 'box-shadow', _1: renderedBox}),
			_1: {
				ctor: '::',
				_0: _elm_lang$core$Native_Utils.eq(renderedText, '') ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					{ctor: '_Tuple2', _0: 'text-shadow', _1: renderedText}),
				_1: {ctor: '[]'}
			}
		});
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$filters = function (filters) {
	var filterName = function (filtr) {
		var _p46 = filtr;
		switch (_p46.ctor) {
			case 'FilterUrl':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'url(',
					A2(_elm_lang$core$Basics_ops['++'], _p46._0, ')'));
			case 'Blur':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'blur(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'px)'));
			case 'Brightness':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'brightness(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'%)'));
			case 'Contrast':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'contrast(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'%)'));
			case 'Grayscale':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'grayscale(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'%)'));
			case 'HueRotate':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'hueRotate(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'deg)'));
			case 'Invert':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'invert(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'%)'));
			case 'OpacityFilter':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'opacity(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'%)'));
			case 'Saturate':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'saturate(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'%)'));
			case 'Sepia':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'sepia(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p46._0),
						'%)'));
			default:
				var _p47 = _p46._0;
				var shadowModel = _mdgriffith$style_elements$Style_Internal_Model$ShadowModel(
					{kind: 'drop', offset: _p47.offset, size: _p47.size, blur: _p47.blur, color: _p47.color});
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'drop-shadow(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_mdgriffith$style_elements$Style_Internal_Render_Value$shadow(shadowModel),
						')'));
		}
	};
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$List$length(filters),
		0) ? {ctor: '[]'} : {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'filter',
			_1: A2(
				_elm_lang$core$String$join,
				' ',
				A2(_elm_lang$core$List$map, filterName, filters))
		},
		_1: {ctor: '[]'}
	};
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$flexHeight = function (l) {
	var _p48 = l;
	switch (_p48.ctor) {
		case 'Px':
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'height',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p48._0),
						'px')
				},
				_1: {ctor: '[]'}
			};
		case 'Percent':
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'height',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p48._0),
						'%')
				},
				_1: {ctor: '[]'}
			};
		case 'Auto':
			return {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'height', _1: 'auto'},
				_1: {ctor: '[]'}
			};
		case 'Fill':
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'flex-grow',
					_1: _elm_lang$core$Basics$toString(_p48._0)
				},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'flex-basis', _1: '0'},
					_1: {ctor: '[]'}
				}
			};
		default:
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'height',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						'calc(',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p48._0),
							A2(
								_elm_lang$core$Basics_ops['++'],
								'% + ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p48._1),
									'px)'))))
				},
				_1: {ctor: '[]'}
			};
	}
};
var _mdgriffith$style_elements$Style_Internal_Render_Property$flexWidth = F2(
	function (len, adjustment) {
		var _p49 = len;
		switch (_p49.ctor) {
			case 'Px':
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'width',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p49._0),
							'px')
					},
					_1: {ctor: '[]'}
				};
			case 'Percent':
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'width',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							'calc(',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p49._0),
								A2(
									_elm_lang$core$Basics_ops['++'],
									'% - ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(adjustment),
										'px)'))))
					},
					_1: {ctor: '[]'}
				};
			case 'Auto':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: 'auto'},
					_1: {ctor: '[]'}
				};
			case 'Fill':
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'flex-grow',
						_1: _elm_lang$core$Basics$toString(_p49._0)
					},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'flex-basis', _1: '0'},
						_1: {ctor: '[]'}
					}
				};
			default:
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'width',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							'calc(',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p49._0),
								A2(
									_elm_lang$core$Basics_ops['++'],
									'% + ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p49._1),
										'px)'))))
					},
					_1: {ctor: '[]'}
				};
		}
	});
var _mdgriffith$style_elements$Style_Internal_Render_Property$visibility = function (vis) {
	var _p50 = vis;
	switch (_p50.ctor) {
		case 'Hidden':
			return {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'display', _1: 'none'},
				_1: {ctor: '[]'}
			};
		case 'Invisible':
			return {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'hidden'},
				_1: {ctor: '[]'}
			};
		default:
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'opacity',
					_1: _elm_lang$core$Basics$toString(_p50._0)
				},
				_1: {ctor: '[]'}
			};
	}
};

var _mdgriffith$style_elements$Element_Internal_Render$renderPadding = function (_p0) {
	var _p1 = _p0;
	var format = F2(
		function (name, x) {
			return {
				ctor: '_Tuple2',
				_0: name,
				_1: A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(x),
					'px')
			};
		});
	return A2(
		_elm_lang$core$List$filterMap,
		_elm_lang$core$Basics$identity,
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Maybe$map,
				format('padding-top'),
				_p1._0),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Maybe$map,
					format('padding-bottom'),
					_p1._2),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$core$Maybe$map,
						format('padding-left'),
						_p1._3),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$Maybe$map,
							format('padding-right'),
							_p1._1),
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _mdgriffith$style_elements$Element_Internal_Render$flexboxVerticalIndividualAlignment = F2(
	function (direction, alignment) {
		var _p2 = direction;
		switch (_p2.ctor) {
			case 'GoRight':
				var _p3 = alignment;
				switch (_p3.ctor) {
					case 'Top':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-start'});
					case 'Bottom':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-end'});
					case 'VerticalCenter':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'center'});
					default:
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'center'});
				}
			case 'GoLeft':
				var _p4 = alignment;
				switch (_p4.ctor) {
					case 'Top':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-start'});
					case 'Bottom':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-end'});
					case 'VerticalCenter':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'center'});
					default:
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'center'});
				}
			case 'Down':
				var _p5 = alignment;
				switch (_p5.ctor) {
					case 'Top':
						return _elm_lang$core$Maybe$Nothing;
					case 'Bottom':
						return _elm_lang$core$Maybe$Nothing;
					case 'VerticalCenter':
						return _elm_lang$core$Maybe$Nothing;
					default:
						return _elm_lang$core$Maybe$Nothing;
				}
			default:
				var _p6 = alignment;
				switch (_p6.ctor) {
					case 'Top':
						return _elm_lang$core$Maybe$Nothing;
					case 'Bottom':
						return _elm_lang$core$Maybe$Nothing;
					case 'VerticalCenter':
						return _elm_lang$core$Maybe$Nothing;
					default:
						return _elm_lang$core$Maybe$Nothing;
				}
		}
	});
var _mdgriffith$style_elements$Element_Internal_Render$flexboxHorizontalIndividualAlignment = F2(
	function (direction, alignment) {
		var _p7 = direction;
		switch (_p7.ctor) {
			case 'GoRight':
				var _p8 = alignment;
				switch (_p8.ctor) {
					case 'Left':
						return _elm_lang$core$Maybe$Nothing;
					case 'Right':
						return _elm_lang$core$Maybe$Nothing;
					case 'Center':
						return _elm_lang$core$Maybe$Nothing;
					default:
						return _elm_lang$core$Maybe$Nothing;
				}
			case 'GoLeft':
				var _p9 = alignment;
				switch (_p9.ctor) {
					case 'Left':
						return _elm_lang$core$Maybe$Nothing;
					case 'Right':
						return _elm_lang$core$Maybe$Nothing;
					case 'Center':
						return _elm_lang$core$Maybe$Nothing;
					default:
						return _elm_lang$core$Maybe$Nothing;
				}
			case 'Down':
				var _p10 = alignment;
				switch (_p10.ctor) {
					case 'Left':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-start'});
					case 'Right':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-end'});
					case 'Center':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'center'});
					default:
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'stretch'});
				}
			default:
				var _p11 = alignment;
				switch (_p11.ctor) {
					case 'Left':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-start'});
					case 'Right':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'flex-end'});
					case 'Center':
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'center'});
					default:
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: 'align-self', _1: 'stretch'});
				}
		}
	});
var _mdgriffith$style_elements$Element_Internal_Render$alignLayout = F3(
	function (maybeHorizontal, maybeVertical, layout) {
		var alignGridVertical = function (align) {
			var _p12 = align;
			switch (_p12.ctor) {
				case 'Top':
					return _mdgriffith$style_elements$Style_Internal_Model$GridV(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Top));
				case 'Bottom':
					return _mdgriffith$style_elements$Style_Internal_Model$GridV(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Bottom));
				case 'VerticalCenter':
					return _mdgriffith$style_elements$Style_Internal_Model$GridV(_mdgriffith$style_elements$Style_Internal_Model$Center);
				default:
					return _mdgriffith$style_elements$Style_Internal_Model$GridV(_mdgriffith$style_elements$Style_Internal_Model$Justify);
			}
		};
		var alignGridHorizontal = function (align) {
			var _p13 = align;
			switch (_p13.ctor) {
				case 'Left':
					return _mdgriffith$style_elements$Style_Internal_Model$GridH(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Left));
				case 'Right':
					return _mdgriffith$style_elements$Style_Internal_Model$GridH(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Right));
				case 'Center':
					return _mdgriffith$style_elements$Style_Internal_Model$GridH(_mdgriffith$style_elements$Style_Internal_Model$Center);
				default:
					return _mdgriffith$style_elements$Style_Internal_Model$GridH(_mdgriffith$style_elements$Style_Internal_Model$Justify);
			}
		};
		var alignFlexboxVertical = function (align) {
			var _p14 = align;
			switch (_p14.ctor) {
				case 'Top':
					return _mdgriffith$style_elements$Style_Internal_Model$Vert(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Top));
				case 'Bottom':
					return _mdgriffith$style_elements$Style_Internal_Model$Vert(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Bottom));
				case 'VerticalCenter':
					return _mdgriffith$style_elements$Style_Internal_Model$Vert(_mdgriffith$style_elements$Style_Internal_Model$Center);
				default:
					return _mdgriffith$style_elements$Style_Internal_Model$Vert(_mdgriffith$style_elements$Style_Internal_Model$Justify);
			}
		};
		var alignFlexboxHorizontal = function (align) {
			var _p15 = align;
			switch (_p15.ctor) {
				case 'Left':
					return _mdgriffith$style_elements$Style_Internal_Model$Horz(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Left));
				case 'Right':
					return _mdgriffith$style_elements$Style_Internal_Model$Horz(
						_mdgriffith$style_elements$Style_Internal_Model$Other(_mdgriffith$style_elements$Style_Internal_Model$Right));
				case 'Center':
					return _mdgriffith$style_elements$Style_Internal_Model$Horz(_mdgriffith$style_elements$Style_Internal_Model$Center);
				default:
					return _mdgriffith$style_elements$Style_Internal_Model$Horz(_mdgriffith$style_elements$Style_Internal_Model$Justify);
			}
		};
		var _p16 = layout;
		switch (_p16.ctor) {
			case 'TextLayout':
				return _mdgriffith$style_elements$Style_Internal_Model$TextLayout(_p16._0);
			case 'FlexLayout':
				var _p19 = _p16._1;
				var _p18 = _p16._0;
				var _p17 = {ctor: '_Tuple2', _0: maybeHorizontal, _1: maybeVertical};
				if (_p17._0.ctor === 'Nothing') {
					if (_p17._1.ctor === 'Nothing') {
						return A2(_mdgriffith$style_elements$Style_Internal_Model$FlexLayout, _p18, _p19);
					} else {
						return A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_p18,
							{
								ctor: '::',
								_0: alignFlexboxVertical(_p17._1._0),
								_1: _p19
							});
					}
				} else {
					if (_p17._1.ctor === 'Nothing') {
						return A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_p18,
							{
								ctor: '::',
								_0: alignFlexboxHorizontal(_p17._0._0),
								_1: _p19
							});
					} else {
						return A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_p18,
							{
								ctor: '::',
								_0: alignFlexboxHorizontal(_p17._0._0),
								_1: {
									ctor: '::',
									_0: alignFlexboxVertical(_p17._1._0),
									_1: _p19
								}
							});
					}
				}
			default:
				var _p22 = _p16._0;
				var _p21 = _p16._1;
				var _p20 = {ctor: '_Tuple2', _0: maybeHorizontal, _1: maybeVertical};
				if (_p20._0.ctor === 'Nothing') {
					if (_p20._1.ctor === 'Nothing') {
						return A2(_mdgriffith$style_elements$Style_Internal_Model$Grid, _p22, _p21);
					} else {
						return A2(
							_mdgriffith$style_elements$Style_Internal_Model$Grid,
							_p22,
							{
								ctor: '::',
								_0: alignGridVertical(_p20._1._0),
								_1: _p21
							});
					}
				} else {
					if (_p20._1.ctor === 'Nothing') {
						return A2(
							_mdgriffith$style_elements$Style_Internal_Model$Grid,
							_p22,
							{
								ctor: '::',
								_0: alignGridHorizontal(_p20._0._0),
								_1: _p21
							});
					} else {
						return A2(
							_mdgriffith$style_elements$Style_Internal_Model$Grid,
							_p22,
							{
								ctor: '::',
								_0: alignGridHorizontal(_p20._0._0),
								_1: {
									ctor: '::',
									_0: alignGridVertical(_p20._1._0),
									_1: _p21
								}
							});
					}
				}
		}
	});
var _mdgriffith$style_elements$Element_Internal_Render$makePositionable = F2(
	function (attr, pos) {
		var _p23 = attr;
		switch (_p23.ctor) {
			case 'Overflow':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						overflow: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'Shrink':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						shrink: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'Inline':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{inline: true});
			case 'Expand':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{expand: true});
			case 'Vary':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						variations: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: _p23._0, _1: _p23._1},
							_1: pos.variations
						}
					});
			case 'Height':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						height: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'Width':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						width: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'Position':
				var _p24 = pos.positioned;
				var currentX = _p24._0;
				var currentY = _p24._1;
				var currentZ = _p24._2;
				var newX = function () {
					var _p25 = _p23._0;
					if (_p25.ctor === 'Nothing') {
						return currentX;
					} else {
						return _elm_lang$core$Maybe$Just(_p25._0);
					}
				}();
				var newY = function () {
					var _p26 = _p23._1;
					if (_p26.ctor === 'Nothing') {
						return currentY;
					} else {
						return _elm_lang$core$Maybe$Just(_p26._0);
					}
				}();
				var newZ = function () {
					var _p27 = _p23._2;
					if (_p27.ctor === 'Nothing') {
						return currentZ;
					} else {
						return _elm_lang$core$Maybe$Just(_p27._0);
					}
				}();
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						positioned: {ctor: '_Tuple3', _0: newX, _1: newY, _2: newZ}
					});
			case 'PositionFrame':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						frame: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'HAlign':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						horizontal: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'VAlign':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						vertical: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'Spacing':
				return pos;
			case 'Margin':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						margin: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'PhantomPadding':
				return pos;
			case 'Padding':
				var _p28 = pos.padding;
				var currentTop = _p28._0;
				var currentRight = _p28._1;
				var currentBottom = _p28._2;
				var currentLeft = _p28._3;
				var newTop = function () {
					var _p29 = _p23._0;
					if (_p29.ctor === 'Nothing') {
						return currentTop;
					} else {
						return _elm_lang$core$Maybe$Just(_p29._0);
					}
				}();
				var newRight = function () {
					var _p30 = _p23._1;
					if (_p30.ctor === 'Nothing') {
						return currentRight;
					} else {
						return _elm_lang$core$Maybe$Just(_p30._0);
					}
				}();
				var newBottom = function () {
					var _p31 = _p23._2;
					if (_p31.ctor === 'Nothing') {
						return currentBottom;
					} else {
						return _elm_lang$core$Maybe$Just(_p31._0);
					}
				}();
				var newLeft = function () {
					var _p32 = _p23._3;
					if (_p32.ctor === 'Nothing') {
						return currentLeft;
					} else {
						return _elm_lang$core$Maybe$Just(_p32._0);
					}
				}();
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						padding: {ctor: '_Tuple4', _0: newTop, _1: newRight, _2: newBottom, _3: newLeft}
					});
			case 'Hidden':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{hidden: true});
			case 'Opacity':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						opacity: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'Event':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						attrs: {ctor: '::', _0: _p23._0, _1: pos.attrs}
					});
			case 'InputEvent':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						attrs: {ctor: '::', _0: _p23._0, _1: pos.attrs}
					});
			case 'Attr':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						attrs: {ctor: '::', _0: _p23._0, _1: pos.attrs}
					});
			case 'PointerEvents':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						pointerevents: _elm_lang$core$Maybe$Just(_p23._0)
					});
			case 'GridArea':
				return _elm_lang$core$Native_Utils.update(
					pos,
					{
						gridPosition: _elm_lang$core$Maybe$Just(_p23._0)
					});
			default:
				var _p33 = _mdgriffith$style_elements$Style_Internal_Render_Value$gridPosition(_p23._0);
				if (_p33.ctor === 'Nothing') {
					return _elm_lang$core$Native_Utils.update(
						pos,
						{hidden: true});
				} else {
					return _elm_lang$core$Native_Utils.update(
						pos,
						{
							gridPosition: _elm_lang$core$Maybe$Just(_p33._0)
						});
				}
		}
	});
var _mdgriffith$style_elements$Element_Internal_Render$emptyPositionable = {
	inline: false,
	horizontal: _elm_lang$core$Maybe$Nothing,
	vertical: _elm_lang$core$Maybe$Nothing,
	frame: _elm_lang$core$Maybe$Nothing,
	expand: false,
	hidden: false,
	width: _elm_lang$core$Maybe$Nothing,
	height: _elm_lang$core$Maybe$Nothing,
	positioned: {ctor: '_Tuple3', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Maybe$Nothing, _2: _elm_lang$core$Maybe$Nothing},
	margin: _elm_lang$core$Maybe$Nothing,
	padding: {ctor: '_Tuple4', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Maybe$Nothing, _2: _elm_lang$core$Maybe$Nothing, _3: _elm_lang$core$Maybe$Nothing},
	variations: {ctor: '[]'},
	opacity: _elm_lang$core$Maybe$Nothing,
	gridPosition: _elm_lang$core$Maybe$Nothing,
	pointerevents: _elm_lang$core$Maybe$Nothing,
	attrs: {ctor: '[]'},
	shrink: _elm_lang$core$Maybe$Nothing,
	overflow: _elm_lang$core$Maybe$Nothing
};
var _mdgriffith$style_elements$Element_Internal_Render$gather = function (attrs) {
	return A3(_elm_lang$core$List$foldl, _mdgriffith$style_elements$Element_Internal_Render$makePositionable, _mdgriffith$style_elements$Element_Internal_Render$emptyPositionable, attrs);
};
var _mdgriffith$style_elements$Element_Internal_Render$defaultPadding = F2(
	function (_p35, _p34) {
		var _p36 = _p35;
		var _p37 = _p34;
		return {
			ctor: '_Tuple4',
			_0: A2(_elm_lang$core$Maybe$withDefault, _p37._0, _p36._0),
			_1: A2(_elm_lang$core$Maybe$withDefault, _p37._1, _p36._1),
			_2: A2(_elm_lang$core$Maybe$withDefault, _p37._2, _p36._2),
			_3: A2(_elm_lang$core$Maybe$withDefault, _p37._3, _p36._3)
		};
	});
var _mdgriffith$style_elements$Element_Internal_Render$calcPosition = F2(
	function (frame, _p38) {
		var _p39 = _p38;
		var _p46 = _p39._1;
		var _p45 = _p39._0;
		var z = A2(_elm_lang$core$Maybe$withDefault, 0, _p39._2);
		var y = A2(_elm_lang$core$Maybe$withDefault, 0, _p46);
		var x = A2(_elm_lang$core$Maybe$withDefault, 0, _p45);
		var _p40 = frame;
		switch (_p40.ctor) {
			case 'Relative':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'left',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(x),
								'px')
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'top',
								_1: A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(y),
									'px')
							},
							_1: {ctor: '[]'}
						}
					}
				};
			case 'Screen':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'position', _1: 'fixed'},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'left',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(x),
								'px')
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'top',
								_1: A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(y),
									'px')
							},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'z-index', _1: '1000'},
								_1: {ctor: '[]'}
							}
						}
					}
				};
			case 'Absolute':
				if (_p40._0.ctor === 'TopLeft') {
					return A2(
						_elm_lang$core$List$filterMap,
						_elm_lang$core$Basics$identity,
						{
							ctor: '::',
							_0: _elm_lang$core$Maybe$Just(
								{ctor: '_Tuple2', _0: 'position', _1: 'absolute'}),
							_1: {
								ctor: '::',
								_0: function () {
									var _p41 = _p45;
									if (_p41.ctor === 'Just') {
										return _elm_lang$core$Maybe$Just(
											{
												ctor: '_Tuple2',
												_0: 'left',
												_1: A2(
													_elm_lang$core$Basics_ops['++'],
													_elm_lang$core$Basics$toString(_p41._0),
													'px')
											});
									} else {
										return _elm_lang$core$Maybe$Nothing;
									}
								}(),
								_1: {
									ctor: '::',
									_0: function () {
										var _p42 = _p46;
										if (_p42.ctor === 'Just') {
											return _elm_lang$core$Maybe$Just(
												{
													ctor: '_Tuple2',
													_0: 'top',
													_1: A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(_p42._0),
														'px')
												});
										} else {
											return _elm_lang$core$Maybe$Nothing;
										}
									}(),
									_1: {ctor: '[]'}
								}
							}
						});
				} else {
					return A2(
						_elm_lang$core$List$filterMap,
						_elm_lang$core$Basics$identity,
						{
							ctor: '::',
							_0: _elm_lang$core$Maybe$Just(
								{ctor: '_Tuple2', _0: 'position', _1: 'absolute'}),
							_1: {
								ctor: '::',
								_0: function () {
									var _p43 = _p45;
									if (_p43.ctor === 'Just') {
										return _elm_lang$core$Maybe$Just(
											{
												ctor: '_Tuple2',
												_0: 'left',
												_1: A2(
													_elm_lang$core$Basics_ops['++'],
													_elm_lang$core$Basics$toString(_p43._0),
													'px')
											});
									} else {
										return _elm_lang$core$Maybe$Nothing;
									}
								}(),
								_1: {
									ctor: '::',
									_0: function () {
										var _p44 = _p46;
										if (_p44.ctor === 'Just') {
											return _elm_lang$core$Maybe$Just(
												{
													ctor: '_Tuple2',
													_0: 'bottom',
													_1: A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(_p44._0),
														'px')
												});
										} else {
											return _elm_lang$core$Maybe$Nothing;
										}
									}(),
									_1: {ctor: '[]'}
								}
							}
						});
				}
			default:
				switch (_p40._0.ctor) {
					case 'Within':
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'top',
									_1: A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(y),
										'px')
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'left',
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(x),
											'px')
									},
									_1: {ctor: '[]'}
								}
							}
						};
					case 'Above':
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'top',
									_1: A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(y),
										'px')
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'left',
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(x),
											'px')
									},
									_1: {ctor: '[]'}
								}
							}
						};
					case 'Below':
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'top',
									_1: A2(
										_elm_lang$core$Basics_ops['++'],
										'calc(100% + ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(y),
											'px)'))
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'left',
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(x),
											'px')
									},
									_1: {ctor: '[]'}
								}
							}
						};
					case 'OnLeft':
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'right',
									_1: A2(
										_elm_lang$core$Basics_ops['++'],
										'calc(100% - ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(x),
											'px)'))
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'top',
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(y),
											'px')
									},
									_1: {ctor: '[]'}
								}
							}
						};
					default:
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'left',
									_1: A2(
										_elm_lang$core$Basics_ops['++'],
										'calc(100% + ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(x),
											'px)'))
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'top',
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(y),
											'px')
									},
									_1: {ctor: '[]'}
								}
							}
						};
				}
		}
	});
var _mdgriffith$style_elements$Element_Internal_Render$spacingToMargin = function (attrs) {
	var spaceToMarg = function (a) {
		var _p47 = a;
		if (_p47.ctor === 'Spacing') {
			var _p49 = _p47._1;
			var _p48 = _p47._0;
			return _mdgriffith$style_elements$Element_Internal_Model$Margin(
				{ctor: '_Tuple4', _0: _p49, _1: _p48, _2: _p49, _3: _p48});
		} else {
			return _p47;
		}
	};
	return A2(_elm_lang$core$List$map, spaceToMarg, attrs);
};
var _mdgriffith$style_elements$Element_Internal_Render$withFocus = '\n\n.style-elements em.el {\n    padding: 0;\n    padding-left: 0.2em;\n}\n\n.style-elements button.button-focus:focus {\n   outline: none;\n   box-shadow: 0 0 3px 3px rgba(155,203,255,1.0);\n   border-color: rgba(155,203,255,1.0);\n}\n\n.style-elements textarea:focus, .style-elements input:focus {\n   outline: none;\n   box-shadow: 0 0 2px 2px rgba(155,203,255,1.0);\n   border-color: rgba(155,203,255,1.0);\n}\n.style-elements input[type=\'checkbox\'] {\n    border-radius: 3px;\n}\n.style-elements input[type=\'radio\'] {\n    border-radius: 7px;\n}\n.style-elements input[type=\'radio\']:focus {\n    border-radius: 7px;\n    box-shadow: 0 0 4px 4px rgba(155,203,255,1.0);\n}\n\n.style-elements select.focus-override:focus, .style-elements input.focus-override:focus {\n    outline: none;\n    box-shadow: none;\n    border-color:transparent;\n}\n.style-elements input.focus-override:focus ~ .alt-icon {\n    box-shadow: 0 0 3px 3px rgba(155,203,255,1.0);\n    border-color: rgba(155,203,255,1.0);\n}\n.style-elements select.focus-override:focus ~ .alt-icon {\n    box-shadow: 0 0 3px 3px rgba(155,203,255,1.0);\n    border-color: rgba(155,203,255,1.0);\n}\n.style-elements .arrows {\n    display:block;\n    position: relative;\n    height: 10px;\n    width: 10px;\n}\n/*\n.style-elements .arrows::after {\n    content: \" \";\n    position:absolute;\n    top:-2px;\n    left:0;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid black;\n}\n*/\n\n.style-elements .arrows::before {\n    content: \" \";\n    position:absolute;\n    top:2px;\n    left:0;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 5px solid black;\n}\n\n\n';
var _mdgriffith$style_elements$Element_Internal_Render$miniNormalize = A2(_elm_lang$core$Basics_ops['++'], 'html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;margin:0;padding:0;border:0}body{margin:0}.style-elements{display:block;position:relative;margin:0;padding:0;border:0;font-size:100%;font:inherit;box-sizing:border-box;line-height:1.2}.el{display:block;position:relative;margin:0;padding:0;border:0;border-style:solid;font-size:100%;font:inherit;box-sizing:border-box}em.el{font-style:italic}b.el,strong.el{font-weight:bolder}strike.el{text-decoration:line-through}u.el{text-decoration:underline}a.el{text-decoration:none;color:inherit}img.el{border-style:none}sub.el,sup.el{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub.el{bottom:-0.25em}sup.el{top:-0.5em}', _mdgriffith$style_elements$Element_Internal_Render$withFocus);
var _mdgriffith$style_elements$Element_Internal_Render$embed = F2(
	function (full, stylesheet) {
		return {
			ctor: '::',
			_0: A3(
				_elm_lang$html$Html$node,
				'style',
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						full ? A2(_elm_lang$core$Basics_ops['++'], 'html,body{width:100%;height:100%;}', _mdgriffith$style_elements$Element_Internal_Render$miniNormalize) : _mdgriffith$style_elements$Element_Internal_Render$miniNormalize),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A3(
					_elm_lang$html$Html$node,
					'style',
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(stylesheet.css),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		};
	});
var _mdgriffith$style_elements$Element_Internal_Render$qualifiedNormalize = A2(_elm_lang$core$Basics_ops['++'], 'html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;margin:0;padding:0;border:0}body{margin:0}.style-elements article,.style-elements aside,.style-elements footer,.style-elements header,.style-elements nav,.style-elements section{display:block}.style-elements h1{font-size:1em;margin:0}.style-elements figcaption,.style-elements figure,.style-elements main{display:block}.style-elements figure{margin:1em 40px}.style-elements hr{box-sizing:content-box;height:0;overflow:visible}.style-elements pre{font-family:monospace, monospace;font-size:1em}.style-elements a{background-color:transparent;-webkit-text-decoration-skip:objects}.style-elements abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}.style-elements b,.style-elements strong{font-weight:inherit}.style-elements b,.style-elements strong{font-weight:bolder}.style-elements code,.style-elements kbd,.style-elements samp{font-family:monospace, monospace;font-size:1em}.style-elements dfn{font-style:italic}.style-elements mark{background-color:#ff0;color:#000}.style-elements small{font-size:80%}.style-elements audio,.style-elements video{display:inline-block}.style-elements audio:not([controls]){display:none;height:0}.style-elements img{border-style:none}.style-elements svg:not(:root){overflow:hidden}.style-elements button,.style-elements input,.style-elements optgroup,.style-elements select,.style-elements textarea{font-family:sans-serif;font-size:100%;margin:0}.style-elements button,.style-elements input{overflow:visible}.style-elements button,.style-elements select{text-transform:none}.style-elements button,.style-elements html [type=\"button\"],.style-elements [type=\"reset\"],.style-elements [type=\"submit\"]{-webkit-appearance:button}.style-elements [type=\"button\"]::-moz-focus-inner,.style-elements [type=\"reset\"]::-moz-focus-inner,.style-elements [type=\"submit\"]::-moz-focus-inner,.style-elements button::-moz-focus-inner{border-style:none;padding:0}.style-elements [type=\"button\"]:-moz-focusring,.style-elements [type=\"reset\"]:-moz-focusring,.style-elements [type=\"submit\"]:-moz-focusring,.style-elements button:-moz-focusring{outline:1px dotted ButtonText}.style-elements fieldset{padding:0.35em 0.75em 0.625em}.style-elements legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}.style-elements progress{display:inline-block;vertical-align:baseline}.style-elements textarea{overflow:auto}.style-elements [type=\"checkbox\"],.style-elements [type=\"radio\"]{box-sizing:border-box;padding:0}.style-elements [type=\"number\"]::-webkit-inner-spin-button,.style-elements [type=\"number\"]::-webkit-outer-spin-button{height:auto}.style-elements [type=\"search\"]{-webkit-appearance:textfield;outline-offset:-2px}.style-elements [type=\"search\"]::-webkit-search-cancel-button,.style-elements [type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none}.style-elements::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}.style-elements details,.style-elements menu{display:block}.style-elements summary{display:list-item}.style-elements canvas{display:inline-block}.style-elements template{display:none}.style-elements [hidden]{display:none}.style-elements a{text-decoration:none}.style-elements input,.style-elements textarea{border:0}.style-elements .clearfix:after{content:\"\";display:table;clear:both}.style-elements a,.style-elements abbr,.style-elements acronym,.style-elements address,.style-elements applet,.style-elements article,.style-elements aside,.style-elements audio,.style-elements b,.style-elements big,.style-elements blockquote,.style-elements canvas,.style-elements caption,.style-elements center,.style-elements cite,.style-elements code,.style-elements dd,.style-elements del,.style-elements details,.style-elements dfn,.style-elements div,.style-elements dl,.style-elements dt,.style-elements em,.style-elements embed,.style-elements fieldset,.style-elements figcaption,.style-elements figure,.style-elements footer,.style-elements form,.style-elements h1,.style-elements h2,.style-elements h3,.style-elements h4,.style-elements h5,.style-elements h6,.style-elements header,.style-elements hgroup,.style-elements hr,.style-elements i,.style-elements iframe,.style-elements img,.style-elements ins,.style-elements kbd,.style-elements label,.style-elements legend,.style-elements li,.style-elements mark,.style-elements menu,.style-elements nav,.style-elements object,.style-elements ol,.style-elements output,.style-elements p,.style-elements pre,.style-elements q,.style-elements ruby,.style-elements s,.style-elements samp,.style-elements section,.style-elements small,.style-elements span,.style-elements strike,.style-elements strong,.style-elements sub,.style-elements summary,.style-elements sup,.style-elements table,.style-elements tbody,.style-elements td,.style-elements tfoot,.style-elements th,.style-elements thead,.style-elements time,.style-elements tr,.style-elements tt,.style-elements u,.style-elements ul,.style-elements var,.style-elements video{margin:0;padding:0;border:0;font-size:100%;font:inherit;box-sizing:border-box}.style-elements{margin:0;padding:0;border:0;font-size:100%;font:inherit;line-height:1}.style-elements em.el{font-style:italic}.style-elements strong.el{font-weight:bold}.style-elements strike.el{text-decoration:line-through}.style-elements u.el{text-decoration:underline}.style-elements sub.el,.style-elements sup.el{font-size:75%;line-height:0;position:relative;vertical-align:baseline}.style-elements sub.el{bottom:-0.25em}.style-elements sup.el{top:-0.5em}', _mdgriffith$style_elements$Element_Internal_Render$withFocus);
var _mdgriffith$style_elements$Element_Internal_Render$Parent = F3(
	function (a, b, c) {
		return {parentSpecifiedSpacing: a, layout: b, parentPadding: c};
	});
var _mdgriffith$style_elements$Element_Internal_Render$Positionable = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return {inline: a, horizontal: b, vertical: c, frame: d, expand: e, hidden: f, width: g, height: h, positioned: i, margin: j, padding: k, variations: l, opacity: m, gridPosition: n, pointerevents: o, attrs: p, shrink: q, overflow: r};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast = {ctor: 'FirstAndLast'};
var _mdgriffith$style_elements$Element_Internal_Render$Last = {ctor: 'Last'};
var _mdgriffith$style_elements$Element_Internal_Render$Middle = function (a) {
	return {ctor: 'Middle', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Render$First = {ctor: 'First'};
var _mdgriffith$style_elements$Element_Internal_Render$detectOrder = F2(
	function (list, i) {
		var len = _elm_lang$core$List$length(list);
		return (_elm_lang$core$Native_Utils.eq(i, 0) && _elm_lang$core$Native_Utils.eq(len, 1)) ? _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast : (_elm_lang$core$Native_Utils.eq(i, 0) ? _mdgriffith$style_elements$Element_Internal_Render$First : (_elm_lang$core$Native_Utils.eq(i, len - 1) ? _mdgriffith$style_elements$Element_Internal_Render$Last : _mdgriffith$style_elements$Element_Internal_Render$Middle(i)));
	});
var _mdgriffith$style_elements$Element_Internal_Render$LayoutElement = function (a) {
	return {ctor: 'LayoutElement', _0: a};
};
var _mdgriffith$style_elements$Element_Internal_Render$Single = {ctor: 'Single'};
var _mdgriffith$style_elements$Element_Internal_Render$renderAttributes = F6(
	function (elType, order, maybeElemID, parent, stylesheet, elem) {
		var attributes = function () {
			var _p50 = maybeElemID;
			if (_p50.ctor === 'Nothing') {
				return elem.attrs;
			} else {
				var _p51 = _p50._0;
				return (_elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$List$length(elem.variations),
					0) > 0) ? {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$classList(
						A2(stylesheet.variations, _p51, elem.variations)),
					_1: elem.attrs
				} : {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(
						stylesheet.style(_p51)),
					_1: elem.attrs
				};
			}
		}();
		var defaults = {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'box-sizing', _1: 'border-box'},
			_1: {ctor: '[]'}
		};
		var adjustspacing = function (_p52) {
			var _p53 = _p52;
			var _p62 = _p53._0;
			var _p61 = _p53._1;
			var _p60 = _p53._3;
			var _p59 = _p53._2;
			var onScreen = function () {
				var _p54 = elem.frame;
				if ((_p54.ctor === 'Just') && (_p54._0.ctor === 'Screen')) {
					return true;
				} else {
					return false;
				}
			}();
			var halved = {ctor: '_Tuple4', _0: _p62 / 2, _1: _p61 / 2, _2: _p59 / 2, _3: _p60 / 2};
			if (onScreen) {
				return {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0};
			} else {
				var _p55 = parent;
				if (_p55.ctor === 'Nothing') {
					return {ctor: '_Tuple4', _0: _p62, _1: _p61, _2: _p59, _3: _p60};
				} else {
					var _p56 = _p55._0.layout;
					if (_p56.ctor === 'TextLayout') {
						var _p57 = elem.horizontal;
						if (_p57.ctor === 'Nothing') {
							return (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0} : (elem.inline ? {ctor: '_Tuple4', _0: 0, _1: _p61, _2: 0, _3: 0} : {ctor: '_Tuple4', _0: 0, _1: 0, _2: _p59, _3: 0});
						} else {
							if ((!elem.inline) && _elm_lang$core$Native_Utils.eq(elem.frame, _elm_lang$core$Maybe$Nothing)) {
								var _p58 = _p57._0;
								switch (_p58.ctor) {
									case 'Left':
										return _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) ? {ctor: '_Tuple4', _0: 0, _1: _p61, _2: _p59, _3: 0} : (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast) ? {ctor: '_Tuple4', _0: 0, _1: _p61, _2: 0, _3: 0} : (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) ? {ctor: '_Tuple4', _0: 0, _1: _p61, _2: 0, _3: 0} : {ctor: '_Tuple4', _0: 0, _1: _p61, _2: _p59, _3: 0}));
									case 'Right':
										return _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) ? {ctor: '_Tuple4', _0: 0, _1: 0, _2: _p59, _3: _p60} : (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast) ? {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: _p60} : (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) ? {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: _p60} : {ctor: '_Tuple4', _0: 0, _1: 0, _2: _p59, _3: _p60}));
									default:
										return (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0} : {ctor: '_Tuple4', _0: 0, _1: 0, _2: _p59, _3: 0};
								}
							} else {
								return {ctor: '_Tuple4', _0: _p62, _1: _p61, _2: _p59, _3: _p60};
							}
						}
					} else {
						return halved;
					}
				}
			}
		};
		var spacing = function (attrs) {
			var _p63 = elem.margin;
			if (_p63.ctor === 'Nothing') {
				return attrs;
			} else {
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'margin',
						_1: _mdgriffith$style_elements$Style_Internal_Render_Value$box(
							adjustspacing(_p63._0))
					},
					_1: attrs
				};
			}
		};
		var gridPos = function (attrs) {
			var _p64 = elem.gridPosition;
			if (_p64.ctor === 'Nothing') {
				return attrs;
			} else {
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'grid-area', _1: _p64._0},
					_1: attrs
				};
			}
		};
		var padding = function (attrs) {
			var paddings = _mdgriffith$style_elements$Element_Internal_Render$renderPadding(elem.padding);
			return (_elm_lang$core$Native_Utils.cmp(
				_elm_lang$core$List$length(paddings),
				0) > 0) ? A2(_elm_lang$core$Basics_ops['++'], paddings, attrs) : attrs;
		};
		var opacity = function (attrs) {
			var _p65 = elem.opacity;
			if (_p65.ctor === 'Nothing') {
				return attrs;
			} else {
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'opacity',
						_1: _elm_lang$core$Basics$toString(_p65._0)
					},
					_1: attrs
				};
			}
		};
		var height = function (attrs) {
			var _p66 = elem.height;
			if (_p66.ctor === 'Nothing') {
				return attrs;
			} else {
				var _p71 = _p66._0;
				var _p67 = parent;
				if (_p67.ctor === 'Just') {
					var hundredPercentOrFill = function (x) {
						var _p68 = x;
						switch (_p68.ctor) {
							case 'Percent':
								return _elm_lang$core$Native_Utils.eq(_p68._0, 100);
							case 'Fill':
								return true;
							case 'Calc':
								return _elm_lang$core$Native_Utils.eq(_p68._0, 100);
							default:
								return false;
						}
					};
					var _p69 = A2(
						_elm_lang$core$Maybe$withDefault,
						{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0},
						_p67._0.parentSpecifiedSpacing);
					var topPad = _p69._0;
					var bottomPad = _p69._2;
					var paddingAdjustment = (topPad + bottomPad) / 2;
					var _p70 = _p67._0.layout;
					if (_p70.ctor === 'FlexLayout') {
						switch (_p70._0.ctor) {
							case 'Down':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_mdgriffith$style_elements$Style_Internal_Render_Property$flexHeight(_p71),
									attrs);
							case 'Up':
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_mdgriffith$style_elements$Style_Internal_Render_Property$flexHeight(_p71),
									attrs);
							case 'GoRight':
								return hundredPercentOrFill(_p71) ? {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'height', _1: 'auto'},
									_1: attrs
								} : {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'height',
										_1: A2(_mdgriffith$style_elements$Style_Internal_Render_Value$parentAdjustedLength, _p71, paddingAdjustment)
									},
									_1: attrs
								};
							default:
								return hundredPercentOrFill(_p71) ? {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'height', _1: 'auto'},
									_1: attrs
								} : {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'height',
										_1: A2(_mdgriffith$style_elements$Style_Internal_Render_Value$parentAdjustedLength, _p71, paddingAdjustment)
									},
									_1: attrs
								};
						}
					} else {
						return {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'height',
								_1: A2(_mdgriffith$style_elements$Style_Internal_Render_Value$parentAdjustedLength, _p71, paddingAdjustment)
							},
							_1: attrs
						};
					}
				} else {
					return {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'height',
							_1: _mdgriffith$style_elements$Style_Internal_Render_Value$length(_p71)
						},
						_1: attrs
					};
				}
			}
		};
		var width = function (attrs) {
			var _p72 = elem.width;
			if (_p72.ctor === 'Nothing') {
				return attrs;
			} else {
				var _p76 = _p72._0;
				var _p73 = parent;
				if (_p73.ctor === 'Just') {
					var _p74 = A2(
						_elm_lang$core$Maybe$withDefault,
						{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0},
						_p73._0.parentSpecifiedSpacing);
					var rightPad = _p74._1;
					var leftPad = _p74._3;
					var paddingAdjustment = (rightPad + leftPad) / 2;
					var _p75 = _p73._0.layout;
					_v52_2:
					do {
						if (_p75.ctor === 'FlexLayout') {
							switch (_p75._0.ctor) {
								case 'GoRight':
									return A2(
										_elm_lang$core$Basics_ops['++'],
										A2(_mdgriffith$style_elements$Style_Internal_Render_Property$flexWidth, _p76, paddingAdjustment),
										attrs);
								case 'GoLeft':
									return A2(
										_elm_lang$core$Basics_ops['++'],
										A2(_mdgriffith$style_elements$Style_Internal_Render_Property$flexWidth, _p76, paddingAdjustment),
										attrs);
								default:
									break _v52_2;
							}
						} else {
							break _v52_2;
						}
					} while(false);
					return {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'width',
							_1: A2(_mdgriffith$style_elements$Style_Internal_Render_Value$parentAdjustedLength, _p76, paddingAdjustment)
						},
						_1: attrs
					};
				} else {
					return {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'width',
							_1: _mdgriffith$style_elements$Style_Internal_Render_Value$length(_p76)
						},
						_1: attrs
					};
				}
			}
		};
		var shrink = function (attrs) {
			var _p77 = elem.shrink;
			if (_p77.ctor === 'Just') {
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'flex-shrink',
						_1: _elm_lang$core$Basics$toString(_p77._0)
					},
					_1: attrs
				};
			} else {
				var _p78 = parent;
				if (_p78.ctor === 'Nothing') {
					return attrs;
				} else {
					var horizontalOverflow = function () {
						var _p79 = elem.overflow;
						if (_p79.ctor === 'Just') {
							switch (_p79._0.ctor) {
								case 'XAxis':
									return true;
								case 'YAxis':
									return false;
								default:
									return true;
							}
						} else {
							return false;
						}
					}();
					var verticalOverflow = function () {
						var _p80 = elem.overflow;
						if (_p80.ctor === 'Just') {
							switch (_p80._0.ctor) {
								case 'XAxis':
									return false;
								case 'YAxis':
									return true;
								default:
									return true;
							}
						} else {
							return false;
						}
					}();
					var isVertical = function (dir) {
						var _p81 = dir;
						switch (_p81.ctor) {
							case 'Up':
								return true;
							case 'Down':
								return true;
							default:
								return false;
						}
					};
					var isHorizontal = function (dir) {
						var _p82 = dir;
						switch (_p82.ctor) {
							case 'GoRight':
								return true;
							case 'GoLeft':
								return true;
							default:
								return false;
						}
					};
					var isPx = function (x) {
						var _p83 = x;
						if ((_p83.ctor === 'Just') && (_p83._0.ctor === 'Px')) {
							return true;
						} else {
							return false;
						}
					};
					var isPercent = function (x) {
						var _p84 = x;
						if ((_p84.ctor === 'Just') && (_p84._0.ctor === 'Percent')) {
							return true;
						} else {
							return false;
						}
					};
					var _p85 = _p78._0.layout;
					if (_p85.ctor === 'FlexLayout') {
						var _p87 = _p85._0;
						if (isHorizontal(_p87) && isPx(elem.width)) {
							return {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '0'},
								_1: attrs
							};
						} else {
							if (isHorizontal(_p87) && isPercent(elem.width)) {
								return {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '0'},
									_1: attrs
								};
							} else {
								if (isHorizontal(_p87) && (!_elm_lang$core$Native_Utils.eq(elem.width, _elm_lang$core$Maybe$Nothing))) {
									return {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '1'},
										_1: attrs
									};
								} else {
									if (isHorizontal(_p87) && horizontalOverflow) {
										return {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '1'},
											_1: attrs
										};
									} else {
										if (isVertical(_p87) && isPx(elem.height)) {
											return {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '0'},
												_1: attrs
											};
										} else {
											if (isVertical(_p87) && isPercent(elem.height)) {
												return {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '0'},
													_1: attrs
												};
											} else {
												if (isVertical(_p87) && (!_elm_lang$core$Native_Utils.eq(elem.height, _elm_lang$core$Maybe$Nothing))) {
													return {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '1'},
														_1: attrs
													};
												} else {
													if (isVertical(_p87) && verticalOverflow) {
														return {
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '1'},
															_1: attrs
														};
													} else {
														if (isHorizontal(_p87) && _elm_lang$core$Native_Utils.eq(elem.width, _elm_lang$core$Maybe$Nothing)) {
															return {
																ctor: '::',
																_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '1'},
																_1: attrs
															};
														} else {
															if (isVertical(_p87) && _elm_lang$core$Native_Utils.eq(elem.height, _elm_lang$core$Maybe$Nothing)) {
																var _p86 = elType;
																if (_p86.ctor === 'Single') {
																	return {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '1'},
																		_1: attrs
																	};
																} else {
																	return {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '0'},
																		_1: attrs
																	};
																}
															} else {
																return {
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'flex-shrink', _1: '0'},
																	_1: attrs
																};
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					} else {
						return attrs;
					}
				}
			}
		};
		var overflow = function (attrs) {
			var _p88 = elem.overflow;
			if (_p88.ctor === 'Nothing') {
				return attrs;
			} else {
				var _p89 = _p88._0;
				switch (_p89.ctor) {
					case 'XAxis':
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'overflow-x', _1: 'auto'},
							_1: attrs
						};
					case 'YAxis':
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'overflow-y', _1: 'auto'},
							_1: attrs
						};
					default:
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'overflow', _1: 'auto'},
							_1: attrs
						};
				}
			}
		};
		var horizontal = function (attrs) {
			var _p90 = elem.horizontal;
			if (_p90.ctor === 'Nothing') {
				return attrs;
			} else {
				var _p98 = _p90._0;
				if (elem.inline && _elm_lang$core$Native_Utils.eq(elType, _mdgriffith$style_elements$Element_Internal_Render$Single)) {
					var _p91 = _p98;
					switch (_p91.ctor) {
						case 'Left':
							return {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'z-index', _1: '1'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'float', _1: 'left'},
									_1: attrs
								}
							};
						case 'Right':
							return {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'z-index', _1: '1'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'float', _1: 'right'},
									_1: attrs
								}
							};
						case 'Center':
							return attrs;
						default:
							return attrs;
					}
				} else {
					if (elem.inline) {
						return attrs;
					} else {
						if (!_elm_lang$core$Native_Utils.eq(elem.frame, _elm_lang$core$Maybe$Nothing)) {
							var _p92 = _p98;
							switch (_p92.ctor) {
								case 'Left':
									return {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'left', _1: '0'},
										_1: attrs
									};
								case 'Right':
									return {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'right', _1: '0'},
										_1: attrs
									};
								case 'Center':
									return attrs;
								default:
									return attrs;
							}
						} else {
							var _p93 = elType;
							if (_p93.ctor === 'LayoutElement') {
								return attrs;
							} else {
								var _p94 = parent;
								if (_p94.ctor === 'Nothing') {
									return attrs;
								} else {
									var _p95 = _p94._0.layout;
									switch (_p95.ctor) {
										case 'TextLayout':
											var _p96 = _p98;
											switch (_p96.ctor) {
												case 'Left':
													return {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'z-index', _1: '1'},
														_1: {
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'float', _1: 'left'},
															_1: attrs
														}
													};
												case 'Right':
													return {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'z-index', _1: '1'},
														_1: {
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'float', _1: 'right'},
															_1: attrs
														}
													};
												case 'Center':
													return attrs;
												default:
													return attrs;
											}
										case 'FlexLayout':
											var _p97 = A2(_mdgriffith$style_elements$Element_Internal_Render$flexboxHorizontalIndividualAlignment, _p95._0, _p98);
											if (_p97.ctor === 'Nothing') {
												return attrs;
											} else {
												return {ctor: '::', _0: _p97._0, _1: attrs};
											}
										default:
											return attrs;
									}
								}
							}
						}
					}
				}
			}
		};
		var vertical = function (attrs) {
			var _p99 = elem.vertical;
			if (_p99.ctor === 'Nothing') {
				return attrs;
			} else {
				var _p104 = _p99._0;
				if (elem.inline && _elm_lang$core$Native_Utils.eq(elType, _mdgriffith$style_elements$Element_Internal_Render$Single)) {
					return attrs;
				} else {
					if (elem.inline) {
						return attrs;
					} else {
						if (!_elm_lang$core$Native_Utils.eq(elem.frame, _elm_lang$core$Maybe$Nothing)) {
							var _p100 = _p104;
							switch (_p100.ctor) {
								case 'Top':
									return {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'top', _1: '0'},
										_1: attrs
									};
								case 'Bottom':
									return {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'bottom', _1: '0'},
										_1: attrs
									};
								case 'VerticalCenter':
									return attrs;
								default:
									return attrs;
							}
						} else {
							var _p101 = parent;
							if (_p101.ctor === 'Nothing') {
								return attrs;
							} else {
								var _p102 = _p101._0.layout;
								if (_p102.ctor === 'FlexLayout') {
									var _p103 = A2(_mdgriffith$style_elements$Element_Internal_Render$flexboxVerticalIndividualAlignment, _p102._0, _p104);
									if (_p103.ctor === 'Nothing') {
										return attrs;
									} else {
										return {ctor: '::', _0: _p103._0, _1: attrs};
									}
								} else {
									return attrs;
								}
							}
						}
					}
				}
			}
		};
		var passthrough = function (attrs) {
			var _p105 = elem.pointerevents;
			if (_p105.ctor === 'Nothing') {
				return attrs;
			} else {
				if (_p105._0 === false) {
					return {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'pointer-events', _1: 'none'},
						_1: attrs
					};
				} else {
					return {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'pointer-events', _1: 'auto'},
						_1: attrs
					};
				}
			}
		};
		var position = function (attrs) {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				A2(
					_mdgriffith$style_elements$Element_Internal_Render$calcPosition,
					A2(_elm_lang$core$Maybe$withDefault, _mdgriffith$style_elements$Element_Internal_Model$Relative, elem.frame),
					elem.positioned),
				attrs);
		};
		var layout = function (attrs) {
			var _p106 = elType;
			if (_p106.ctor === 'Single') {
				return elem.inline ? {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'display', _1: 'inline'},
					_1: attrs
				} : {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'display', _1: 'block'},
					_1: attrs
				};
			} else {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					A2(
						_mdgriffith$style_elements$Style_Internal_Render_Property$layout,
						elem.inline,
						A3(_mdgriffith$style_elements$Element_Internal_Render$alignLayout, elem.horizontal, elem.vertical, _p106._0)),
					attrs);
			}
		};
		if (elem.hidden) {
			return {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'display', _1: 'none'},
						_1: {ctor: '[]'}
					}),
				_1: attributes
			};
		} else {
			if (elem.expand) {
				var expandedProps = function () {
					var _p107 = parent;
					if (_p107.ctor === 'Nothing') {
						return {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'height', _1: '100%'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'margin', _1: '0'},
									_1: {ctor: '[]'}
								}
							}
						};
					} else {
						var _p114 = _p107._0.parentPadding;
						var _p108 = _p107._0.layout;
						switch (_p108.ctor) {
							case 'TextLayout':
								var borders = _elm_lang$core$List$concat(
									{
										ctor: '::',
										_0: _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) ? {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'border-top-right-radius', _1: '0'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'border-top-left-radius', _1: '0'},
												_1: {ctor: '[]'}
											}
										} : (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) ? {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'border-bottom-right-radius', _1: '0'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'border-bottom-left-radius', _1: '0'},
												_1: {ctor: '[]'}
											}
										} : (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast) ? {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'border-top-right-radius', _1: '0'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'border-top-left-radius', _1: '0'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'border-bottom-right-radius', _1: '0'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'border-bottom-left-radius', _1: '0'},
														_1: {ctor: '[]'}
													}
												}
											}
										} : {ctor: '[]'})),
										_1: {ctor: '[]'}
									});
								var _p109 = _p114;
								var top = _p109._0;
								var right = _p109._1;
								var bottom = _p109._2;
								var left = _p109._3;
								return A2(
									_elm_lang$core$Basics_ops['++'],
									{
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'width',
											_1: A2(
												_elm_lang$core$Basics_ops['++'],
												'calc(100% + ',
												A2(
													_elm_lang$core$Basics_ops['++'],
													_elm_lang$core$Basics$toString(right + left),
													'px'))
										},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'margin', _1: '0'},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'margin-left',
													_1: A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(-1 * left),
														'px')
												},
												_1: {
													ctor: '::',
													_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
														ctor: '_Tuple2',
														_0: 'margin-top',
														_1: A2(
															_elm_lang$core$Basics_ops['++'],
															_elm_lang$core$Basics$toString(-1 * top),
															'px')
													} : {ctor: '_Tuple2', _0: 'margin-top', _1: '0'},
													_1: {
														ctor: '::',
														_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
															ctor: '_Tuple2',
															_0: 'margin-bottom',
															_1: A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString(-1 * bottom),
																'px')
														} : {ctor: '_Tuple2', _0: 'margin-bottom', _1: '0'},
														_1: {
															ctor: '::',
															_0: {
																ctor: '_Tuple2',
																_0: 'padding',
																_1: _mdgriffith$style_elements$Style_Internal_Render_Value$box(
																	A2(_mdgriffith$style_elements$Element_Internal_Render$defaultPadding, elem.padding, _p114))
															},
															_1: {ctor: '[]'}
														}
													}
												}
											}
										}
									},
									borders);
							case 'FlexLayout':
								var _p110 = function () {
									var _p111 = _p107._0.parentSpecifiedSpacing;
									if (_p111.ctor === 'Nothing') {
										return {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0};
									} else {
										return _p111._0;
									}
								}();
								var parentSpaceTop = _p110._0;
								var parentSpaceRight = _p110._1;
								var parentSpaceBottom = _p110._2;
								var parentSpaceLeft = _p110._3;
								var _p112 = _p114;
								var top = _p112._0;
								var right = _p112._1;
								var bottom = _p112._2;
								var left = _p112._3;
								var _p113 = _p108._0;
								switch (_p113.ctor) {
									case 'GoRight':
										return width(
											{
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'height',
													_1: A2(
														_elm_lang$core$Basics_ops['++'],
														'calc(100% + ',
														A2(
															_elm_lang$core$Basics_ops['++'],
															_elm_lang$core$Basics$toString((top + bottom) - ((parentSpaceTop + parentSpaceBottom) / 2)),
															'px'))
												},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin', _1: '0'},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'margin-top',
															_1: A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString((-1 * top) + (parentSpaceTop / 2)),
																'px')
														},
														_1: {
															ctor: '::',
															_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																ctor: '_Tuple2',
																_0: 'margin-left',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(-1 * left),
																	'px')
															} : {
																ctor: '_Tuple2',
																_0: 'margin-left',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(parentSpaceLeft / 2),
																	'px')
															},
															_1: {
																ctor: '::',
																_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																	ctor: '_Tuple2',
																	_0: 'margin-right',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(-1 * right),
																		'px')
																} : {
																	ctor: '_Tuple2',
																	_0: 'margin-right',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(parentSpaceRight / 2),
																		'px')
																},
																_1: {ctor: '[]'}
															}
														}
													}
												}
											});
									case 'GoLeft':
										return width(
											{
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'height',
													_1: A2(
														_elm_lang$core$Basics_ops['++'],
														'calc(100% + ',
														A2(
															_elm_lang$core$Basics_ops['++'],
															_elm_lang$core$Basics$toString((top + bottom) - ((parentSpaceTop + parentSpaceBottom) / 2)),
															'px'))
												},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin', _1: '0'},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'margin-top',
															_1: A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString((-1 * top) + (parentSpaceTop / 2)),
																'px')
														},
														_1: {
															ctor: '::',
															_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																ctor: '_Tuple2',
																_0: 'margin-right',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(-1 * right),
																	'px')
															} : {
																ctor: '_Tuple2',
																_0: 'margin-right',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(parentSpaceRight / 2),
																	'px')
															},
															_1: {
																ctor: '::',
																_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																	ctor: '_Tuple2',
																	_0: 'margin-left',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(-1 * left),
																		'px')
																} : {
																	ctor: '_Tuple2',
																	_0: 'margin-left',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(parentSpaceLeft / 2),
																		'px')
																},
																_1: {ctor: '[]'}
															}
														}
													}
												}
											});
									case 'Up':
										return height(
											{
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'width',
													_1: A2(
														_elm_lang$core$Basics_ops['++'],
														'calc(100% + ',
														A2(
															_elm_lang$core$Basics_ops['++'],
															_elm_lang$core$Basics$toString((left + right) - ((parentSpaceLeft + parentSpaceRight) / 2)),
															'px'))
												},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin', _1: '0'},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'margin-left',
															_1: A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString((-1 * left) + (parentSpaceLeft / 2)),
																'px')
														},
														_1: {
															ctor: '::',
															_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																ctor: '_Tuple2',
																_0: 'margin-bottom',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(-1 * top),
																	'px')
															} : {
																ctor: '_Tuple2',
																_0: 'margin-bottom',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(parentSpaceBottom / 2),
																	'px')
															},
															_1: {
																ctor: '::',
																_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																	ctor: '_Tuple2',
																	_0: 'margin-top',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(-1 * bottom),
																		'px')
																} : {
																	ctor: '_Tuple2',
																	_0: 'margin-top',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(parentSpaceTop / 2),
																		'px')
																},
																_1: {ctor: '[]'}
															}
														}
													}
												}
											});
									default:
										return height(
											{
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'width',
													_1: A2(
														_elm_lang$core$Basics_ops['++'],
														'calc(100% + ',
														A2(
															_elm_lang$core$Basics_ops['++'],
															_elm_lang$core$Basics$toString((left + right) - ((parentSpaceLeft + parentSpaceRight) / 2)),
															'px'))
												},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin', _1: '0'},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'margin-left',
															_1: A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString((-1 * left) + (parentSpaceLeft / 2)),
																'px')
														},
														_1: {
															ctor: '::',
															_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$First) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																ctor: '_Tuple2',
																_0: 'margin-top',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(-1 * top),
																	'px')
															} : {
																ctor: '_Tuple2',
																_0: 'margin-top',
																_1: A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(parentSpaceTop / 2),
																	'px')
															},
															_1: {
																ctor: '::',
																_0: (_elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$Last) || _elm_lang$core$Native_Utils.eq(order, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast)) ? {
																	ctor: '_Tuple2',
																	_0: 'margin-bottom',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(-1 * bottom),
																		'px')
																} : {
																	ctor: '_Tuple2',
																	_0: 'margin-bottom',
																	_1: A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(parentSpaceBottom / 2),
																		'px')
																},
																_1: {ctor: '[]'}
															}
														}
													}
												}
											});
								}
							default:
								return {ctor: '[]'};
						}
					}
				}();
				return {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(
						A2(
							_elm_lang$core$Basics_ops['++'],
							defaults,
							function (_p115) {
								return passthrough(
									gridPos(
										layout(
											spacing(
												opacity(
													shrink(
														padding(
															position(
																overflow(_p115)))))))));
							}(expandedProps))),
					_1: attributes
				};
			} else {
				return {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(
						function (_p116) {
							return passthrough(
								gridPos(
									layout(
										spacing(
											opacity(
												shrink(
													width(
														height(
															padding(
																horizontal(
																	vertical(
																		position(
																			overflow(_p116)))))))))))));
						}(defaults)),
					_1: attributes
				};
			}
		}
	});
var _mdgriffith$style_elements$Element_Internal_Render$renderElement = F4(
	function (parent, stylesheet, order, elm) {
		var _p117 = elm;
		switch (_p117.ctor) {
			case 'Empty':
				return _elm_lang$html$Html$text('');
			case 'Raw':
				return _p117._0;
			case 'Spacer':
				var _p121 = _p117._0;
				var forSpacing = function (posAttr) {
					var _p118 = posAttr;
					if (_p118.ctor === 'Spacing') {
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: _p118._0, _1: _p118._1});
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				};
				var _p119 = function () {
					var _p120 = parent;
					if (_p120.ctor === 'Just') {
						return A2(
							_elm_lang$core$Maybe$withDefault,
							{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0},
							_p120._0.parentSpecifiedSpacing);
					} else {
						return {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0};
					}
				}();
				var spacingX = _p119._0;
				var spacingY = _p119._1;
				var inline = {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'width',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p121 * spacingX),
							'px')
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'height',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p121 * spacingY),
								'px')
						},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'hidden'},
							_1: {ctor: '[]'}
						}
					}
				};
				return A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$style(inline),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'});
			case 'Text':
				var _p123 = _p117._1;
				var attrs = _p117._0.inline ? _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'display', _1: 'inline'},
						_1: {ctor: '[]'}
					}) : _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'white-space', _1: 'pre'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'text-overflow', _1: 'ellipsis'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'overflow', _1: 'hidden'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'display', _1: 'block'},
									_1: {ctor: '[]'}
								}
							}
						}
					});
				var _p122 = _p117._0.decoration;
				switch (_p122.ctor) {
					case 'NoDecoration':
						return A2(
							_elm_lang$html$Html$span,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: {
									ctor: '::',
									_0: attrs,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p123),
								_1: {ctor: '[]'}
							});
					case 'RawText':
						return _elm_lang$html$Html$text(_p123);
					case 'Bold':
						return A2(
							_elm_lang$html$Html$strong,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: {
									ctor: '::',
									_0: attrs,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p123),
								_1: {ctor: '[]'}
							});
					case 'Italic':
						return A2(
							_elm_lang$html$Html$em,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: {
									ctor: '::',
									_0: attrs,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p123),
								_1: {ctor: '[]'}
							});
					case 'Underline':
						return A2(
							_elm_lang$html$Html$u,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: {
									ctor: '::',
									_0: attrs,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p123),
								_1: {ctor: '[]'}
							});
					case 'Strike':
						return A2(
							_elm_lang$html$Html$s,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: {
									ctor: '::',
									_0: attrs,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p123),
								_1: {ctor: '[]'}
							});
					case 'Super':
						return A2(
							_elm_lang$html$Html$sup,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: {
									ctor: '::',
									_0: attrs,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p123),
								_1: {ctor: '[]'}
							});
					default:
						return A2(
							_elm_lang$html$Html$sub,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: {
									ctor: '::',
									_0: attrs,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p123),
								_1: {ctor: '[]'}
							});
				}
			case 'Element':
				var _p134 = _p117._0.child;
				var _p133 = _p117._0.attrs;
				var parentTextLayout = function (layout) {
					var _p124 = layout;
					if (_p124.ctor === 'TextLayout') {
						return true;
					} else {
						return false;
					}
				};
				var attributes = function () {
					var _p125 = parent;
					if (_p125.ctor === 'Nothing') {
						return _mdgriffith$style_elements$Element_Internal_Render$spacingToMargin(_p133);
					} else {
						var _p131 = _p125._0;
						var _p126 = _p131.parentSpecifiedSpacing;
						if (_p126.ctor === 'Nothing') {
							return (parentTextLayout(_p131.layout) || A2(
								_elm_lang$core$List$any,
								F2(
									function (x, y) {
										return _elm_lang$core$Native_Utils.eq(x, y);
									})(_mdgriffith$style_elements$Element_Internal_Model$Inline),
								_p133)) ? _mdgriffith$style_elements$Element_Internal_Render$spacingToMargin(_p133) : _p133;
						} else {
							var _p130 = _p126._0._0;
							var _p129 = _p126._0._1;
							var _p128 = _p126._0._3;
							var _p127 = _p126._0._2;
							return (parentTextLayout(_p131.layout) || A2(
								_elm_lang$core$List$any,
								F2(
									function (x, y) {
										return _elm_lang$core$Native_Utils.eq(x, y);
									})(_mdgriffith$style_elements$Element_Internal_Model$Inline),
								_p133)) ? {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Margin(
									{ctor: '_Tuple4', _0: _p130, _1: _p129, _2: _p127, _3: _p128}),
								_1: _mdgriffith$style_elements$Element_Internal_Render$spacingToMargin(_p133)
							} : {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Margin(
									{ctor: '_Tuple4', _0: _p130, _1: _p129, _2: _p127, _3: _p128}),
								_1: _p133
							};
						}
					}
				}();
				var htmlAttrs = A6(
					_mdgriffith$style_elements$Element_Internal_Render$renderAttributes,
					_mdgriffith$style_elements$Element_Internal_Render$Single,
					order,
					_p117._0.style,
					parent,
					stylesheet,
					_mdgriffith$style_elements$Element_Internal_Render$gather(attributes));
				var childHtml = function () {
					var _p132 = _p117._0.absolutelyPositioned;
					if (_p132.ctor === 'Nothing') {
						return {
							ctor: '::',
							_0: A4(_mdgriffith$style_elements$Element_Internal_Render$renderElement, _elm_lang$core$Maybe$Nothing, stylesheet, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast, _p134),
							_1: {ctor: '[]'}
						};
					} else {
						return A2(
							_elm_lang$core$List$map,
							A3(_mdgriffith$style_elements$Element_Internal_Render$renderElement, _elm_lang$core$Maybe$Nothing, stylesheet, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast),
							{ctor: '::', _0: _p134, _1: _p132._0});
					}
				}();
				return A3(
					_elm_lang$html$Html$node,
					_p117._0.node,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('el'),
						_1: htmlAttrs
					},
					childHtml);
			default:
				var _p156 = _p117._0.node;
				var _p155 = _p117._0.layout;
				var _p154 = _p117._0.attrs;
				var isFlexbox = function (layout) {
					var _p135 = layout;
					if (_p135.ctor === 'FlexLayout') {
						return true;
					} else {
						return false;
					}
				};
				var adjacentFlexboxCorrection = function (htmlNode) {
					var _p136 = parent;
					if (_p136.ctor === 'Nothing') {
						return htmlNode;
					} else {
						return (isFlexbox(_p136._0.layout) && isFlexbox(_p155)) ? htmlNode : htmlNode;
					}
				};
				var findSpacing = function (posAttr) {
					var _p137 = posAttr;
					if (_p137.ctor === 'Spacing') {
						var _p139 = _p137._1;
						var _p138 = _p137._0;
						return _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple4', _0: _p139, _1: _p138, _2: _p139, _3: _p138});
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				};
				var forSpacing = function (_p140) {
					return function (x) {
						return !_elm_lang$core$Native_Utils.eq(x, _elm_lang$core$Maybe$Nothing);
					}(
						findSpacing(_p140));
				};
				var _p141 = A2(_elm_lang$core$List$partition, forSpacing, _p154);
				var spacing = _p141._0;
				var forPadding = function (posAttr) {
					var _p142 = posAttr;
					switch (_p142.ctor) {
						case 'Padding':
							return _elm_lang$core$Maybe$Just(
								A2(
									_mdgriffith$style_elements$Element_Internal_Render$defaultPadding,
									{ctor: '_Tuple4', _0: _p142._0, _1: _p142._1, _2: _p142._2, _3: _p142._3},
									{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0}));
						case 'PhantomPadding':
							return _elm_lang$core$Maybe$Just(_p142._0);
						default:
							return _elm_lang$core$Maybe$Nothing;
					}
				};
				var clearfix = function (attrs) {
					var _p143 = _p155;
					if (_p143.ctor === 'TextLayout') {
						return _p143._0 ? {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('clearfix'),
							_1: attrs
						} : attrs;
					} else {
						return attrs;
					}
				};
				var attributes = function () {
					var _p144 = parent;
					if (_p144.ctor === 'Nothing') {
						return _p154;
					} else {
						var _p145 = _p144._0.parentSpecifiedSpacing;
						if (_p145.ctor === 'Nothing') {
							return _p154;
						} else {
							return {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Margin(_p145._0),
								_1: _p154
							};
						}
					}
				}();
				var padding = function () {
					var _p146 = _elm_lang$core$List$head(
						A2(_elm_lang$core$List$filterMap, forPadding, attributes));
					if (_p146.ctor === 'Nothing') {
						return {ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0};
					} else {
						return _p146._0;
					}
				}();
				var inherit = {
					parentSpecifiedSpacing: _elm_lang$core$List$head(
						A2(_elm_lang$core$List$filterMap, findSpacing, _p154)),
					layout: _p155,
					parentPadding: padding
				};
				var htmlAttrs = clearfix(
					A6(
						_mdgriffith$style_elements$Element_Internal_Render$renderAttributes,
						_mdgriffith$style_elements$Element_Internal_Render$LayoutElement(_p155),
						order,
						_p117._0.style,
						parent,
						stylesheet,
						_mdgriffith$style_elements$Element_Internal_Render$gather(attributes)));
				var _p147 = A2(
					_elm_lang$core$List$partition,
					function (attr) {
						return _elm_lang$core$Native_Utils.eq(
							attr,
							_mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Center)) || _elm_lang$core$Native_Utils.eq(
							attr,
							_mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$VerticalCenter));
					},
					_p154);
				var centeredProps = _p147._0;
				var others = _p147._1;
				var _p148 = _p117._0.children;
				if (_p148.ctor === 'Normal') {
					var _p150 = _p148._0;
					var childHtml = A2(
						_elm_lang$core$List$indexedMap,
						F2(
							function (i, child) {
								return A4(
									_mdgriffith$style_elements$Element_Internal_Render$renderElement,
									_elm_lang$core$Maybe$Just(inherit),
									stylesheet,
									A2(_mdgriffith$style_elements$Element_Internal_Render$detectOrder, _p150, i),
									child);
							}),
						_p150);
					var allChildren = function () {
						var _p149 = _p117._0.absolutelyPositioned;
						if (_p149.ctor === 'Nothing') {
							return childHtml;
						} else {
							return A2(
								_elm_lang$core$Basics_ops['++'],
								childHtml,
								A2(
									_elm_lang$core$List$map,
									A3(_mdgriffith$style_elements$Element_Internal_Render$renderElement, _elm_lang$core$Maybe$Nothing, stylesheet, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast),
									_p149._0));
						}
					}();
					return adjacentFlexboxCorrection(
						A3(
							_elm_lang$html$Html$node,
							_p156,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: htmlAttrs
							},
							allChildren));
				} else {
					var _p153 = _p148._0;
					var childHtml = A2(
						_elm_lang$core$List$indexedMap,
						F2(
							function (i, _p151) {
								var _p152 = _p151;
								return {
									ctor: '_Tuple2',
									_0: _p152._0,
									_1: A4(
										_mdgriffith$style_elements$Element_Internal_Render$renderElement,
										_elm_lang$core$Maybe$Just(inherit),
										stylesheet,
										A2(_mdgriffith$style_elements$Element_Internal_Render$detectOrder, _p153, i),
										_p152._1)
								};
							}),
						_p153);
					return adjacentFlexboxCorrection(
						A3(
							_elm_lang$html$Html_Keyed$node,
							_p156,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('el'),
								_1: htmlAttrs
							},
							childHtml));
				}
		}
	});
var _mdgriffith$style_elements$Element_Internal_Render$render = F2(
	function (stylesheet, elm) {
		var _p157 = _mdgriffith$style_elements$Element_Internal_Adjustments$apply(elm);
		var adjusted = _p157._0;
		var onScreen = _p157._1;
		var fixedScreenElements = function () {
			var _p158 = onScreen;
			if (_p158.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				return A2(
					_elm_lang$core$List$map,
					A3(_mdgriffith$style_elements$Element_Internal_Render$renderElement, _elm_lang$core$Maybe$Nothing, stylesheet, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast),
					_p158._0);
			}
		}();
		return {
			ctor: '::',
			_0: A4(_mdgriffith$style_elements$Element_Internal_Render$renderElement, _elm_lang$core$Maybe$Nothing, stylesheet, _mdgriffith$style_elements$Element_Internal_Render$FirstAndLast, adjusted),
			_1: fixedScreenElements
		};
	});
var _mdgriffith$style_elements$Element_Internal_Render$viewport = F2(
	function (stylesheet, elm) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('style-elements'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(
						{
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'height', _1: '100%'},
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			},
			A2(
				_elm_lang$core$Basics_ops['++'],
				A2(_mdgriffith$style_elements$Element_Internal_Render$embed, true, stylesheet),
				A2(_mdgriffith$style_elements$Element_Internal_Render$render, stylesheet, elm)));
	});
var _mdgriffith$style_elements$Element_Internal_Render$root = F2(
	function (stylesheet, elm) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('style-elements'),
				_1: {ctor: '[]'}
			},
			A2(
				_elm_lang$core$Basics_ops['++'],
				A2(_mdgriffith$style_elements$Element_Internal_Render$embed, false, stylesheet),
				A2(_mdgriffith$style_elements$Element_Internal_Render$render, stylesheet, elm)));
	});

var _mdgriffith$style_elements$Style_Internal_Batchable$toList = function (batchables) {
	var flatten = function (batch) {
		var _p0 = batch;
		switch (_p0.ctor) {
			case 'One':
				return {
					ctor: '::',
					_0: _p0._0,
					_1: {ctor: '[]'}
				};
			case 'Many':
				return _p0._0;
			default:
				return _mdgriffith$style_elements$Style_Internal_Batchable$toList(_p0._0);
		}
	};
	return A2(_elm_lang$core$List$concatMap, flatten, batchables);
};
var _mdgriffith$style_elements$Style_Internal_Batchable$Batch = function (a) {
	return {ctor: 'Batch', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Batchable$batch = _mdgriffith$style_elements$Style_Internal_Batchable$Batch;
var _mdgriffith$style_elements$Style_Internal_Batchable$Many = function (a) {
	return {ctor: 'Many', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Batchable$many = _mdgriffith$style_elements$Style_Internal_Batchable$Many;
var _mdgriffith$style_elements$Style_Internal_Batchable$One = function (a) {
	return {ctor: 'One', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Batchable$one = _mdgriffith$style_elements$Style_Internal_Batchable$One;
var _mdgriffith$style_elements$Style_Internal_Batchable$map = F2(
	function (fn, batchable) {
		var _p1 = batchable;
		switch (_p1.ctor) {
			case 'One':
				return _mdgriffith$style_elements$Style_Internal_Batchable$One(
					fn(_p1._0));
			case 'Many':
				return _mdgriffith$style_elements$Style_Internal_Batchable$Many(
					A2(_elm_lang$core$List$map, fn, _p1._0));
			default:
				return _mdgriffith$style_elements$Style_Internal_Batchable$Batch(
					A2(
						_elm_lang$core$List$map,
						_mdgriffith$style_elements$Style_Internal_Batchable$map(fn),
						_p1._0));
		}
	});

var _mdgriffith$style_elements$Style_Internal_Find$variation = F3(
	function ($class, variation, elements) {
		var find = function (el) {
			var _p0 = el;
			if (_p0.ctor === 'Variation') {
				return (_elm_lang$core$Native_Utils.eq($class, _p0._0) && _elm_lang$core$Native_Utils.eq(_p0._1, variation)) ? _elm_lang$core$Maybe$Just(_p0._2) : _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var found = _elm_lang$core$List$head(
			A2(_elm_lang$core$List$filterMap, find, elements));
		var _p1 = found;
		if (_p1.ctor === 'Nothing') {
			return A2(
				_elm_lang$core$Debug$log,
				A2(
					_elm_lang$core$Basics_ops['++'],
					'No ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(variation),
						A2(
							_elm_lang$core$Basics_ops['++'],
							' variation  present for ',
							_elm_lang$core$Basics$toString($class)))),
				'');
		} else {
			return _p1._0;
		}
	});
var _mdgriffith$style_elements$Style_Internal_Find$style = F2(
	function ($class, elements) {
		var find = function (el) {
			var _p2 = el;
			if (_p2.ctor === 'Style') {
				return _elm_lang$core$Native_Utils.eq(_p2._0, $class) ? _elm_lang$core$Maybe$Just(_p2._1) : _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var found = _elm_lang$core$List$head(
			A2(_elm_lang$core$List$filterMap, find, elements));
		var _p3 = found;
		if (_p3.ctor === 'Nothing') {
			return A2(
				_elm_lang$core$Debug$log,
				A2(
					_elm_lang$core$Basics_ops['++'],
					'No style present for ',
					_elm_lang$core$Basics$toString($class)),
				'');
		} else {
			return _p3._0;
		}
	});
var _mdgriffith$style_elements$Style_Internal_Find$Variation = F3(
	function (a, b, c) {
		return {ctor: 'Variation', _0: a, _1: b, _2: c};
	});
var _mdgriffith$style_elements$Style_Internal_Find$toVariation = F3(
	function ($var, newName, element) {
		var _p4 = element;
		if (_p4.ctor === 'Style') {
			return A3(_mdgriffith$style_elements$Style_Internal_Find$Variation, _p4._0, $var, newName);
		} else {
			return A3(_mdgriffith$style_elements$Style_Internal_Find$Variation, _p4._0, $var, newName);
		}
	});
var _mdgriffith$style_elements$Style_Internal_Find$Style = F2(
	function (a, b) {
		return {ctor: 'Style', _0: a, _1: b};
	});

var _mdgriffith$style_elements$Style_Internal_Render_Css$prop = F2(
	function (i, _p0) {
		var _p1 = _p0;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			A2(_elm_lang$core$String$repeat, i, ' '),
			A2(
				_elm_lang$core$Basics_ops['++'],
				_p1._0,
				A2(
					_elm_lang$core$Basics_ops['++'],
					': ',
					A2(_elm_lang$core$Basics_ops['++'], _p1._1, ';'))));
	});
var _mdgriffith$style_elements$Style_Internal_Render_Css$brace = F2(
	function (i, str) {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			' {\n',
			A2(
				_elm_lang$core$Basics_ops['++'],
				str,
				A2(
					_elm_lang$core$Basics_ops['++'],
					'\n',
					A2(
						_elm_lang$core$Basics_ops['++'],
						A2(_elm_lang$core$String$repeat, i, ' '),
						'}'))));
	});

var _mdgriffith$style_elements$Style_Internal_Selector$getFindable = function (find) {
	getFindable:
	while (true) {
		var _p0 = find;
		switch (_p0.ctor) {
			case 'Select':
				return {
					ctor: '::',
					_0: _p0._1,
					_1: {ctor: '[]'}
				};
			case 'SelectChild':
				var _v1 = _p0._0;
				find = _v1;
				continue getFindable;
			case 'Stack':
				return A2(
					_elm_lang$core$Maybe$withDefault,
					{ctor: '[]'},
					A2(
						_elm_lang$core$Maybe$map,
						function (x) {
							return {
								ctor: '::',
								_0: x,
								_1: {ctor: '[]'}
							};
						},
						_elm_lang$core$List$head(
							_elm_lang$core$List$reverse(
								A2(_elm_lang$core$List$concatMap, _mdgriffith$style_elements$Style_Internal_Selector$getFindable, _p0._0)))));
			default:
				return {ctor: '[]'};
		}
	}
};
var _mdgriffith$style_elements$Style_Internal_Selector$render = F2(
	function (maybeGuard, selector) {
		var spacer = function (sel) {
			var _p1 = sel;
			if (_p1.ctor === 'Pseudo') {
				return '';
			} else {
				return ' ';
			}
		};
		var renderAndSpace = F2(
			function (i, sel) {
				return _elm_lang$core$Native_Utils.eq(i, 0) ? A2(_mdgriffith$style_elements$Style_Internal_Selector$render, maybeGuard, sel) : A2(
					_elm_lang$core$Basics_ops['++'],
					spacer(sel),
					A2(_mdgriffith$style_elements$Style_Internal_Selector$render, maybeGuard, sel));
			});
		var guard = function (str) {
			var _p2 = maybeGuard;
			if (_p2.ctor === 'Nothing') {
				return str;
			} else {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					str,
					A2(_elm_lang$core$Basics_ops['++'], '--', _p2._0));
			}
		};
		var _p3 = selector;
		switch (_p3.ctor) {
			case 'Select':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'.style-elements .',
					guard(_p3._0));
			case 'SelectChild':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'> ',
					A2(_mdgriffith$style_elements$Style_Internal_Selector$render, maybeGuard, _p3._0));
			case 'Free':
				return _p3._0;
			case 'Pseudo':
				return _p3._0;
			default:
				return _elm_lang$core$String$concat(
					A2(_elm_lang$core$List$indexedMap, renderAndSpace, _p3._0));
		}
	});
var _mdgriffith$style_elements$Style_Internal_Selector$topName = function (selector) {
	topName:
	while (true) {
		var _p4 = selector;
		switch (_p4.ctor) {
			case 'Select':
				return _p4._0;
			case 'SelectChild':
				var _v6 = _p4._0;
				selector = _v6;
				continue topName;
			case 'Stack':
				return A2(
					_elm_lang$core$Maybe$withDefault,
					'',
					_elm_lang$core$List$head(
						_elm_lang$core$List$reverse(
							A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Style_Internal_Selector$topName, _p4._0))));
			default:
				return '';
		}
	}
};
var _mdgriffith$style_elements$Style_Internal_Selector$uncapitalize = function (str) {
	var tail = A2(_elm_lang$core$String$dropLeft, 1, str);
	var head = _elm_lang$core$String$toLower(
		A2(_elm_lang$core$String$left, 1, str));
	return A2(_elm_lang$core$Basics_ops['++'], head, tail);
};
var _mdgriffith$style_elements$Style_Internal_Selector$formatName = function (x) {
	return A4(
		_elm_lang$core$Regex$replace,
		_elm_lang$core$Regex$All,
		_elm_lang$core$Regex$regex('[\\s+]'),
		function (_p5) {
			return '-';
		},
		A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_elm_lang$core$Regex$regex('[A-Z0-9]+'),
			function (_p6) {
				var _p7 = _p6;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					' ',
					_elm_lang$core$String$toLower(_p7.match));
			},
			A4(
				_elm_lang$core$Regex$replace,
				_elm_lang$core$Regex$All,
				_elm_lang$core$Regex$regex('[^a-zA-Z0-9_-]'),
				function (_p8) {
					return '';
				},
				_mdgriffith$style_elements$Style_Internal_Selector$uncapitalize(
					_elm_lang$core$Basics$toString(x)))));
};
var _mdgriffith$style_elements$Style_Internal_Selector$Stack = function (a) {
	return {ctor: 'Stack', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Selector$Free = function (a) {
	return {ctor: 'Free', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Selector$free = function (str) {
	return _mdgriffith$style_elements$Style_Internal_Selector$Free(str);
};
var _mdgriffith$style_elements$Style_Internal_Selector$SelectChild = function (a) {
	return {ctor: 'SelectChild', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Selector$child = F2(
	function (parent, selector) {
		return _mdgriffith$style_elements$Style_Internal_Selector$Stack(
			{
				ctor: '::',
				_0: parent,
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Style_Internal_Selector$SelectChild(selector),
					_1: {ctor: '[]'}
				}
			});
	});
var _mdgriffith$style_elements$Style_Internal_Selector$Pseudo = function (a) {
	return {ctor: 'Pseudo', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Selector$Select = F2(
	function (a, b) {
		return {ctor: 'Select', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Selector$guard = F2(
	function (guard, selector) {
		var addGuard = function (str) {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				str,
				A2(_elm_lang$core$Basics_ops['++'], '__', guard));
		};
		var onFindable = function (findable) {
			var _p9 = findable;
			if (_p9.ctor === 'Style') {
				return A2(
					_mdgriffith$style_elements$Style_Internal_Find$Style,
					_p9._0,
					addGuard(_p9._1));
			} else {
				return A3(
					_mdgriffith$style_elements$Style_Internal_Find$Variation,
					_p9._0,
					_p9._1,
					addGuard(_p9._2));
			}
		};
		var onSelector = function (sel) {
			var _p10 = sel;
			switch (_p10.ctor) {
				case 'Select':
					return A2(
						_mdgriffith$style_elements$Style_Internal_Selector$Select,
						addGuard(_p10._0),
						onFindable(_p10._1));
				case 'SelectChild':
					return _mdgriffith$style_elements$Style_Internal_Selector$SelectChild(
						onSelector(_p10._0));
				case 'Stack':
					return _mdgriffith$style_elements$Style_Internal_Selector$Stack(
						A2(_elm_lang$core$List$map, onSelector, _p10._0));
				default:
					return _p10;
			}
		};
		return onSelector(selector);
	});
var _mdgriffith$style_elements$Style_Internal_Selector$select = function ($class) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Selector$Select,
		_mdgriffith$style_elements$Style_Internal_Selector$formatName($class),
		A2(
			_mdgriffith$style_elements$Style_Internal_Find$Style,
			$class,
			_mdgriffith$style_elements$Style_Internal_Selector$formatName($class)));
};
var _mdgriffith$style_elements$Style_Internal_Selector$variant = F2(
	function (sel, $var) {
		var _p11 = sel;
		switch (_p11.ctor) {
			case 'Pseudo':
				return _mdgriffith$style_elements$Style_Internal_Selector$Pseudo(_p11._0);
			case 'Select':
				var _p12 = _p11._0;
				return A2(
					_mdgriffith$style_elements$Style_Internal_Selector$Select,
					A2(
						_elm_lang$core$Basics_ops['++'],
						_p12,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'-',
							_mdgriffith$style_elements$Style_Internal_Selector$formatName($var))),
					A3(
						_mdgriffith$style_elements$Style_Internal_Find$toVariation,
						$var,
						A2(
							_elm_lang$core$Basics_ops['++'],
							_p12,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'-',
								_mdgriffith$style_elements$Style_Internal_Selector$formatName($var))),
						_p11._1));
			case 'SelectChild':
				return _mdgriffith$style_elements$Style_Internal_Selector$SelectChild(
					A2(_mdgriffith$style_elements$Style_Internal_Selector$variant, _p11._0, $var));
			case 'Free':
				return _mdgriffith$style_elements$Style_Internal_Selector$Free(_p11._0);
			default:
				var _p14 = _p11._0;
				var init = _elm_lang$core$List$reverse(
					A2(
						_elm_lang$core$List$drop,
						1,
						_elm_lang$core$List$reverse(_p14)));
				var lastElem = _elm_lang$core$List$head(
					_elm_lang$core$List$reverse(_p14));
				var _p13 = lastElem;
				if (_p13.ctor === 'Nothing') {
					return _mdgriffith$style_elements$Style_Internal_Selector$Stack(_p14);
				} else {
					return _mdgriffith$style_elements$Style_Internal_Selector$Stack(
						A2(
							_elm_lang$core$Basics_ops['++'],
							init,
							{
								ctor: '::',
								_0: A2(_mdgriffith$style_elements$Style_Internal_Selector$variant, _p13._0, $var),
								_1: {ctor: '[]'}
							}));
				}
		}
	});
var _mdgriffith$style_elements$Style_Internal_Selector$pseudo = F2(
	function (psu, sel) {
		var _p15 = sel;
		switch (_p15.ctor) {
			case 'Pseudo':
				return _mdgriffith$style_elements$Style_Internal_Selector$Pseudo(
					A2(_elm_lang$core$Basics_ops['++'], _p15._0, psu));
			case 'Select':
				return _mdgriffith$style_elements$Style_Internal_Selector$Stack(
					{
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Style_Internal_Selector$Select, _p15._0, _p15._1),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Style_Internal_Selector$Pseudo(psu),
							_1: {ctor: '[]'}
						}
					});
			case 'SelectChild':
				return _mdgriffith$style_elements$Style_Internal_Selector$SelectChild(
					A2(_mdgriffith$style_elements$Style_Internal_Selector$pseudo, psu, _p15._0));
			case 'Free':
				return _mdgriffith$style_elements$Style_Internal_Selector$Free(_p15._0);
			default:
				var _p17 = _p15._0;
				var init = _elm_lang$core$List$reverse(
					A2(
						_elm_lang$core$List$drop,
						1,
						_elm_lang$core$List$reverse(_p17)));
				var lastElem = _elm_lang$core$List$head(
					_elm_lang$core$List$reverse(_p17));
				var _p16 = lastElem;
				if (_p16.ctor === 'Nothing') {
					return _mdgriffith$style_elements$Style_Internal_Selector$Stack(_p17);
				} else {
					return _mdgriffith$style_elements$Style_Internal_Selector$Stack(
						A2(
							_elm_lang$core$Basics_ops['++'],
							init,
							{
								ctor: '::',
								_0: A2(_mdgriffith$style_elements$Style_Internal_Selector$pseudo, psu, _p16._0),
								_1: {ctor: '[]'}
							}));
				}
		}
	});

var _mdgriffith$style_elements$Style_Internal_Intermediate$asFindable = function (intermediate) {
	var findableProp = function (prop) {
		var _p0 = prop;
		switch (_p0.ctor) {
			case 'SubClass':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$asFindable(_p0._0);
			case 'PropsAndSub':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$asFindable(_p0._1);
			default:
				return {ctor: '[]'};
		}
	};
	var _p1 = intermediate;
	if (_p1.ctor === 'Class') {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			_mdgriffith$style_elements$Style_Internal_Selector$getFindable(_p1._0.selector),
			A2(_elm_lang$core$List$concatMap, findableProp, _p1._0.props));
	} else {
		return {ctor: '[]'};
	}
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$render = function (renderable) {
	var _p2 = renderable;
	switch (_p2.ctor) {
		case 'RenderableClass':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_p2._0,
				A2(
					_elm_lang$core$Basics_ops['++'],
					A2(
						_mdgriffith$style_elements$Style_Internal_Render_Css$brace,
						0,
						A2(
							_elm_lang$core$String$join,
							'\n',
							A2(
								_elm_lang$core$List$map,
								_mdgriffith$style_elements$Style_Internal_Render_Css$prop(2),
								_p2._1))),
					'\n'));
		case 'RenderableMedia':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_p2._0,
				A2(
					_mdgriffith$style_elements$Style_Internal_Render_Css$brace,
					0,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'  ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_p2._1,
							A2(
								_mdgriffith$style_elements$Style_Internal_Render_Css$brace,
								2,
								A2(
									_elm_lang$core$String$join,
									'\n',
									A2(
										_elm_lang$core$List$map,
										_mdgriffith$style_elements$Style_Internal_Render_Css$prop(4),
										_p2._2)))))));
		default:
			return _p2._0;
	}
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$hash = function (value) {
	return _elm_lang$core$Basics$toString(
		A2(_Skinney$murmur3$Murmur3$hashString, 8675309, value));
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$calculateGuard = function ($class) {
	var propToString = function (_p3) {
		var _p4 = _p3;
		return A2(_elm_lang$core$Basics_ops['++'], _p4._0, _p4._1);
	};
	var asString = function (prop) {
		var _p5 = prop;
		switch (_p5.ctor) {
			case 'Props':
				return _elm_lang$core$String$concat(
					A2(_elm_lang$core$List$map, propToString, _p5._0));
			case 'SubClass':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$calculateGuard(_p5._0);
			case 'PropsAndSub':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$String$concat(
						A2(_elm_lang$core$List$map, propToString, _p5._0)),
					_mdgriffith$style_elements$Style_Internal_Intermediate$calculateGuard(_p5._1));
			default:
				return '';
		}
	};
	var _p6 = $class;
	switch (_p6.ctor) {
		case 'Class':
			return _elm_lang$core$String$concat(
				A2(_elm_lang$core$List$map, asString, _p6._0.props));
		case 'Media':
			return _elm_lang$core$String$concat(
				A2(_elm_lang$core$List$map, asString, _p6._0.props));
		default:
			return '';
	}
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$Free = function (a) {
	return {ctor: 'Free', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$Media = function (a) {
	return {ctor: 'Media', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$Class = function (a) {
	return {ctor: 'Class', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$Animation = {ctor: 'Animation'};
var _mdgriffith$style_elements$Style_Internal_Intermediate$PropsAndSub = F2(
	function (a, b) {
		return {ctor: 'PropsAndSub', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass = function (a) {
	return {ctor: 'SubClass', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$applyGuard = F2(
	function (guard, $class) {
		var guardProp = function (prop) {
			var _p7 = prop;
			if (_p7.ctor === 'SubClass') {
				return _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
					A2(_mdgriffith$style_elements$Style_Internal_Intermediate$applyGuard, guard, _p7._0));
			} else {
				return _p7;
			}
		};
		var _p8 = $class;
		switch (_p8.ctor) {
			case 'Class':
				var _p9 = _p8._0;
				return _mdgriffith$style_elements$Style_Internal_Intermediate$Class(
					{
						selector: A2(_mdgriffith$style_elements$Style_Internal_Selector$guard, guard, _p9.selector),
						props: A2(_elm_lang$core$List$map, guardProp, _p9.props)
					});
			case 'Media':
				var _p10 = _p8._0;
				return _mdgriffith$style_elements$Style_Internal_Intermediate$Media(
					{
						query: _p10.query,
						selector: A2(_mdgriffith$style_elements$Style_Internal_Selector$guard, guard, _p10.selector),
						props: A2(_elm_lang$core$List$map, guardProp, _p10.props)
					});
			default:
				return _p8;
		}
	});
var _mdgriffith$style_elements$Style_Internal_Intermediate$guard = function ($class) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Intermediate$applyGuard,
		_mdgriffith$style_elements$Style_Internal_Intermediate$hash(
			_mdgriffith$style_elements$Style_Internal_Intermediate$calculateGuard($class)),
		$class);
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$asMediaQuery = F2(
	function (query, prop) {
		var classAsMediaQuery = function (cls) {
			var _p11 = cls;
			if (_p11.ctor === 'Class') {
				return _mdgriffith$style_elements$Style_Internal_Intermediate$Media(
					{query: query, selector: _p11._0.selector, props: _p11._0.props});
			} else {
				return _p11;
			}
		};
		var _p12 = prop;
		switch (_p12.ctor) {
			case 'SubClass':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
					classAsMediaQuery(_p12._0));
			case 'PropsAndSub':
				return A2(
					_mdgriffith$style_elements$Style_Internal_Intermediate$PropsAndSub,
					_p12._0,
					classAsMediaQuery(_p12._1));
			default:
				return _p12;
		}
	});
var _mdgriffith$style_elements$Style_Internal_Intermediate$Props = function (a) {
	return {ctor: 'Props', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$props = _mdgriffith$style_elements$Style_Internal_Intermediate$Props;
var _mdgriffith$style_elements$Style_Internal_Intermediate$RenderableFree = function (a) {
	return {ctor: 'RenderableFree', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$RenderableMedia = F3(
	function (a, b, c) {
		return {ctor: 'RenderableMedia', _0: a, _1: b, _2: c};
	});
var _mdgriffith$style_elements$Style_Internal_Intermediate$RenderableClass = F2(
	function (a, b) {
		return {ctor: 'RenderableClass', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Style_Internal_Intermediate$makeRenderable = function (cls) {
	var renderableProps = F2(
		function (prop, _p13) {
			var _p14 = _p13;
			var _p17 = _p14._1;
			var _p16 = _p14._0;
			var _p15 = prop;
			switch (_p15.ctor) {
				case 'Props':
					return {
						ctor: '_Tuple2',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p16, _p15._0),
						_1: _p17
					};
				case 'SubClass':
					return {
						ctor: '_Tuple2',
						_0: _p16,
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_p17,
							_mdgriffith$style_elements$Style_Internal_Intermediate$makeRenderable(_p15._0))
					};
				case 'PropsAndSub':
					return {
						ctor: '_Tuple2',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p16, _p15._0),
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_p17,
							_mdgriffith$style_elements$Style_Internal_Intermediate$makeRenderable(_p15._1))
					};
				default:
					return {ctor: '_Tuple2', _0: _p16, _1: _p17};
			}
		});
	var _p18 = cls;
	switch (_p18.ctor) {
		case 'Class':
			var _p19 = A3(
				_elm_lang$core$List$foldl,
				renderableProps,
				{
					ctor: '_Tuple2',
					_0: {ctor: '[]'},
					_1: {ctor: '[]'}
				},
				_p18._0.props);
			var rendered = _p19._0;
			var subelements = _p19._1;
			return {
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Style_Internal_Intermediate$RenderableClass,
					A2(_mdgriffith$style_elements$Style_Internal_Selector$render, _elm_lang$core$Maybe$Nothing, _p18._0.selector),
					rendered),
				_1: subelements
			};
		case 'Media':
			var _p20 = A3(
				_elm_lang$core$List$foldl,
				renderableProps,
				{
					ctor: '_Tuple2',
					_0: {ctor: '[]'},
					_1: {ctor: '[]'}
				},
				_p18._0.props);
			var rendered = _p20._0;
			var subelements = _p20._1;
			return {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Style_Internal_Intermediate$RenderableMedia,
					_p18._0.query,
					A2(_mdgriffith$style_elements$Style_Internal_Selector$render, _elm_lang$core$Maybe$Nothing, _p18._0.selector),
					rendered),
				_1: subelements
			};
		default:
			return {
				ctor: '::',
				_0: _mdgriffith$style_elements$Style_Internal_Intermediate$RenderableFree(_p18._0),
				_1: {ctor: '[]'}
			};
	}
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$raw = function (cls) {
	var topName = function () {
		var _p21 = cls;
		switch (_p21.ctor) {
			case 'Class':
				return _mdgriffith$style_elements$Style_Internal_Selector$topName(_p21._0.selector);
			case 'Media':
				return _mdgriffith$style_elements$Style_Internal_Selector$topName(_p21._0.selector);
			default:
				return '';
		}
	}();
	return {
		ctor: '_Tuple2',
		_0: topName,
		_1: A2(
			_elm_lang$core$String$join,
			'\n',
			A2(
				_elm_lang$core$List$map,
				_mdgriffith$style_elements$Style_Internal_Intermediate$render,
				_mdgriffith$style_elements$Style_Internal_Intermediate$makeRenderable(cls)))
	};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$Rendered = function (a) {
	return {ctor: 'Rendered', _0: a};
};
var _mdgriffith$style_elements$Style_Internal_Intermediate$finalize = function (intermediates) {
	var finalizeCss = function (cls) {
		return A2(
			_elm_lang$core$String$join,
			'\n',
			A2(
				_elm_lang$core$List$map,
				_mdgriffith$style_elements$Style_Internal_Intermediate$render,
				_mdgriffith$style_elements$Style_Internal_Intermediate$makeRenderable(cls)));
	};
	return _mdgriffith$style_elements$Style_Internal_Intermediate$Rendered(
		{
			css: A2(
				_elm_lang$core$String$join,
				'\n',
				A2(_elm_lang$core$List$map, finalizeCss, intermediates)),
			findable: A2(_elm_lang$core$List$concatMap, _mdgriffith$style_elements$Style_Internal_Intermediate$asFindable, intermediates)
		});
};

var _mdgriffith$style_elements$Style_Internal_Render$renderVariationProp = F2(
	function (parentClass, prop) {
		var _p0 = prop;
		switch (_p0.ctor) {
			case 'Child':
				return _elm_lang$core$Maybe$Nothing;
			case 'Variation':
				return _elm_lang$core$Maybe$Nothing;
			case 'PseudoElement':
				return function (_p1) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
							_mdgriffith$style_elements$Style_Internal_Intermediate$Class(_p1)));
				}(
					{
						selector: A2(_mdgriffith$style_elements$Style_Internal_Selector$pseudo, _p0._0, parentClass),
						props: A2(
							_elm_lang$core$List$filterMap,
							_mdgriffith$style_elements$Style_Internal_Render$renderVariationProp(parentClass),
							_p0._1)
					});
			case 'MediaQuery':
				var _p3 = _p0._0;
				return function (_p2) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
							_mdgriffith$style_elements$Style_Internal_Intermediate$Media(_p2)));
				}(
					{
						query: A2(_elm_lang$core$Basics_ops['++'], '@media ', _p3),
						selector: parentClass,
						props: A2(
							_elm_lang$core$List$map,
							_mdgriffith$style_elements$Style_Internal_Intermediate$asMediaQuery(_p3),
							A2(
								_elm_lang$core$List$filterMap,
								_mdgriffith$style_elements$Style_Internal_Render$renderVariationProp(parentClass),
								_p0._1))
					});
			case 'Exact':
				return function (_p4) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p4));
				}(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _p0._0, _1: _p0._1},
						_1: {ctor: '[]'}
					});
			case 'Visibility':
				return function (_p5) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p5));
				}(
					_mdgriffith$style_elements$Style_Internal_Render_Property$visibility(_p0._0));
			case 'Position':
				return function (_p6) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p6));
				}(
					_mdgriffith$style_elements$Style_Internal_Render_Property$position(_p0._0));
			case 'Font':
				return function (_p7) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p7));
				}(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _p0._0, _1: _p0._1},
						_1: {ctor: '[]'}
					});
			case 'FontFamily':
				return function (_p8) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p8));
				}(
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'font-family',
							_1: _mdgriffith$style_elements$Style_Internal_Render_Value$typeface(_p0._0)
						},
						_1: {ctor: '[]'}
					});
			case 'Layout':
				return function (_p9) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p9));
				}(
					A2(_mdgriffith$style_elements$Style_Internal_Render_Property$layout, false, _p0._0));
			case 'Background':
				return function (_p10) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p10));
				}(
					_mdgriffith$style_elements$Style_Internal_Render_Property$background(_p0._0));
			case 'Shadows':
				return function (_p11) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p11));
				}(
					_mdgriffith$style_elements$Style_Internal_Render_Property$shadow(_p0._0));
			case 'Transform':
				return function (_p12) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p12));
				}(
					_mdgriffith$style_elements$Style_Internal_Render_Property$transformations(_p0._0));
			case 'Filters':
				return function (_p13) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p13));
				}(
					_mdgriffith$style_elements$Style_Internal_Render_Property$filters(_p0._0));
			case 'TextColor':
				return function (_p14) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$props(_p14));
				}(
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'color',
							_1: _mdgriffith$style_elements$Style_Internal_Render_Value$color(_p0._0)
						},
						_1: {ctor: '[]'}
					});
			case 'SelectionColor':
				return function (_p15) {
					return _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
							_mdgriffith$style_elements$Style_Internal_Intermediate$Class(_p15)));
				}(
					{
						selector: A2(_mdgriffith$style_elements$Style_Internal_Selector$pseudo, '::selection', parentClass),
						props: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Style_Internal_Intermediate$props(
								{
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'background-color',
										_1: _mdgriffith$style_elements$Style_Internal_Render_Value$color(_p0._0)
									},
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					});
			default:
				return _elm_lang$core$Maybe$Just(
					_mdgriffith$style_elements$Style_Internal_Intermediate$props(
						{
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'transition',
								_1: A2(
									_elm_lang$core$String$join,
									', ',
									A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Style_Internal_Render_Property$transition, _p0._0))
							},
							_1: {ctor: '[]'}
						}));
		}
	});
var _mdgriffith$style_elements$Style_Internal_Render$renderProp = F2(
	function (parentClass, prop) {
		var _p16 = prop;
		switch (_p16.ctor) {
			case 'Child':
				return function (_p17) {
					return _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
						_mdgriffith$style_elements$Style_Internal_Intermediate$Class(_p17));
				}(
					{
						selector: A2(
							_mdgriffith$style_elements$Style_Internal_Selector$child,
							parentClass,
							_mdgriffith$style_elements$Style_Internal_Selector$select(_p16._0)),
						props: A2(
							_elm_lang$core$List$map,
							_mdgriffith$style_elements$Style_Internal_Render$renderProp(parentClass),
							_p16._1)
					});
			case 'Variation':
				var selectVariation = A2(_mdgriffith$style_elements$Style_Internal_Selector$variant, parentClass, _p16._0);
				return function (_p18) {
					return _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
						_mdgriffith$style_elements$Style_Internal_Intermediate$Class(_p18));
				}(
					{
						selector: selectVariation,
						props: A2(
							_elm_lang$core$List$filterMap,
							_mdgriffith$style_elements$Style_Internal_Render$renderVariationProp(selectVariation),
							_p16._1)
					});
			case 'PseudoElement':
				return function (_p19) {
					return _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
						_mdgriffith$style_elements$Style_Internal_Intermediate$Class(_p19));
				}(
					{
						selector: A2(_mdgriffith$style_elements$Style_Internal_Selector$pseudo, _p16._0, parentClass),
						props: A2(
							_elm_lang$core$List$map,
							_mdgriffith$style_elements$Style_Internal_Render$renderProp(parentClass),
							_p16._1)
					});
			case 'MediaQuery':
				var _p21 = _p16._0;
				return function (_p20) {
					return _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
						_mdgriffith$style_elements$Style_Internal_Intermediate$Media(_p20));
				}(
					{
						query: A2(_elm_lang$core$Basics_ops['++'], '@media ', _p21),
						selector: parentClass,
						props: A2(
							_elm_lang$core$List$map,
							_mdgriffith$style_elements$Style_Internal_Intermediate$asMediaQuery(_p21),
							A2(
								_elm_lang$core$List$map,
								_mdgriffith$style_elements$Style_Internal_Render$renderProp(parentClass),
								_p16._1))
					});
			case 'Exact':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _p16._0, _1: _p16._1},
						_1: {ctor: '[]'}
					});
			case 'Visibility':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					_mdgriffith$style_elements$Style_Internal_Render_Property$visibility(_p16._0));
			case 'Position':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					_mdgriffith$style_elements$Style_Internal_Render_Property$position(_p16._0));
			case 'Font':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _p16._0, _1: _p16._1},
						_1: {ctor: '[]'}
					});
			case 'Layout':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					A2(_mdgriffith$style_elements$Style_Internal_Render_Property$layout, false, _p16._0));
			case 'Background':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					_mdgriffith$style_elements$Style_Internal_Render_Property$background(_p16._0));
			case 'Shadows':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					_mdgriffith$style_elements$Style_Internal_Render_Property$shadow(_p16._0));
			case 'Transform':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					_mdgriffith$style_elements$Style_Internal_Render_Property$transformations(_p16._0));
			case 'Filters':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					_mdgriffith$style_elements$Style_Internal_Render_Property$filters(_p16._0));
			case 'SelectionColor':
				return function (_p22) {
					return _mdgriffith$style_elements$Style_Internal_Intermediate$SubClass(
						_mdgriffith$style_elements$Style_Internal_Intermediate$Class(_p22));
				}(
					{
						selector: A2(_mdgriffith$style_elements$Style_Internal_Selector$pseudo, '::selection', parentClass),
						props: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Style_Internal_Intermediate$props(
								{
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'background-color',
										_1: _mdgriffith$style_elements$Style_Internal_Render_Value$color(_p16._0)
									},
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					});
			case 'TextColor':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'color',
							_1: _mdgriffith$style_elements$Style_Internal_Render_Value$color(_p16._0)
						},
						_1: {ctor: '[]'}
					});
			case 'Transitions':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'transition',
							_1: A2(
								_elm_lang$core$String$join,
								', ',
								A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Style_Internal_Render_Property$transition, _p16._0))
						},
						_1: {ctor: '[]'}
					});
			default:
				return _mdgriffith$style_elements$Style_Internal_Intermediate$props(
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'font-family',
							_1: _mdgriffith$style_elements$Style_Internal_Render_Value$typeface(_p16._0)
						},
						_1: {ctor: '[]'}
					});
		}
	});
var _mdgriffith$style_elements$Style_Internal_Render$preprocess = function (style) {
	var _p23 = style;
	if (_p23.ctor === 'Style') {
		var mergeShadowsAndFilters = function (props) {
			var combine = function (_p24) {
				var _p25 = _p24;
				return {
					ctor: '::',
					_0: _mdgriffith$style_elements$Style_Internal_Model$Filters(_p25.filters),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Internal_Model$Shadows(_p25.shadows),
						_1: _p25.others
					}
				};
			};
			var gather = F2(
				function (prop, existing) {
					var _p26 = prop;
					switch (_p26.ctor) {
						case 'Filters':
							return _elm_lang$core$Native_Utils.update(
								existing,
								{
									filters: A2(_elm_lang$core$Basics_ops['++'], _p26._0, existing.filters)
								});
						case 'Shadows':
							return _elm_lang$core$Native_Utils.update(
								existing,
								{
									shadows: A2(_elm_lang$core$Basics_ops['++'], _p26._0, existing.shadows)
								});
						default:
							return _elm_lang$core$Native_Utils.update(
								existing,
								{
									others: {ctor: '::', _0: prop, _1: existing.others}
								});
					}
				});
			return combine(
				A3(
					_elm_lang$core$List$foldr,
					gather,
					{
						filters: {ctor: '[]'},
						shadows: {ctor: '[]'},
						others: {ctor: '[]'}
					},
					props));
		};
		var mergeTransforms = function (props) {
			var applyTransforms = function (_p27) {
				var _p28 = _p27;
				var _p29 = _p28._1;
				var transformations = A2(
					_elm_lang$core$List$filterMap,
					_elm_lang$core$Basics$identity,
					{
						ctor: '::',
						_0: _p28._0.translate,
						_1: {
							ctor: '::',
							_0: _p28._0.rotate,
							_1: {
								ctor: '::',
								_0: _p28._0.scale,
								_1: {ctor: '[]'}
							}
						}
					});
				return _elm_lang$core$List$isEmpty(transformations) ? _p29 : {
					ctor: '::',
					_0: _mdgriffith$style_elements$Style_Internal_Model$Transform(transformations),
					_1: _p29
				};
			};
			var setIfNothing = F2(
				function (x, maybeX) {
					var _p30 = maybeX;
					if (_p30.ctor === 'Nothing') {
						return _elm_lang$core$Maybe$Just(x);
					} else {
						return _p30;
					}
				});
			var gatherTransformStack = F2(
				function (transformation, gathered) {
					var _p31 = transformation;
					switch (_p31.ctor) {
						case 'Translate':
							return _elm_lang$core$Native_Utils.update(
								gathered,
								{
									translate: A2(
										setIfNothing,
										A3(_mdgriffith$style_elements$Style_Internal_Model$Translate, _p31._0, _p31._1, _p31._2),
										gathered.translate)
								});
						case 'Rotate':
							return _elm_lang$core$Native_Utils.update(
								gathered,
								{
									rotate: A2(
										setIfNothing,
										_mdgriffith$style_elements$Style_Internal_Model$Rotate(_p31._0),
										gathered.rotate)
								});
						case 'RotateAround':
							return _elm_lang$core$Native_Utils.update(
								gathered,
								{
									rotate: A2(
										setIfNothing,
										A4(_mdgriffith$style_elements$Style_Internal_Model$RotateAround, _p31._0, _p31._1, _p31._2, _p31._3),
										gathered.rotate)
								});
						default:
							return _elm_lang$core$Native_Utils.update(
								gathered,
								{
									scale: A2(
										setIfNothing,
										A3(_mdgriffith$style_elements$Style_Internal_Model$Scale, _p31._0, _p31._1, _p31._2),
										gathered.scale)
								});
					}
				});
			var gatherTransforms = F2(
				function (prop, _p32) {
					var _p33 = _p32;
					var _p36 = _p33._0;
					var _p35 = _p33._1;
					var _p34 = prop;
					if (_p34.ctor === 'Transform') {
						return {
							ctor: '_Tuple2',
							_0: A3(_elm_lang$core$List$foldr, gatherTransformStack, _p36, _p34._0),
							_1: _p35
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: _p36,
							_1: {ctor: '::', _0: prop, _1: _p35}
						};
					}
				});
			return applyTransforms(
				A3(
					_elm_lang$core$List$foldr,
					gatherTransforms,
					{
						ctor: '_Tuple2',
						_0: {rotate: _elm_lang$core$Maybe$Nothing, scale: _elm_lang$core$Maybe$Nothing, translate: _elm_lang$core$Maybe$Nothing},
						_1: {ctor: '[]'}
					},
					props));
		};
		var dropShadow = function (_p37) {
			var _p38 = _p37;
			return _elm_lang$core$Native_Utils.eq(_p38._0.kind, 'drop');
		};
		var overridePrevious = F2(
			function (overridable, props) {
				var eliminatePrevious = F2(
					function (prop, _p39) {
						var _p40 = _p39;
						var _p42 = _p40._1;
						var _p41 = _p40._0;
						return (overridable(prop) && _p42) ? {ctor: '_Tuple2', _0: _p41, _1: _p42} : ((overridable(prop) && (!_p42)) ? {
							ctor: '_Tuple2',
							_0: {ctor: '::', _0: prop, _1: _p41},
							_1: true
						} : {
							ctor: '_Tuple2',
							_0: {ctor: '::', _0: prop, _1: _p41},
							_1: _p42
						});
					});
				return _elm_lang$core$Tuple$first(
					A3(
						_elm_lang$core$List$foldr,
						eliminatePrevious,
						{
							ctor: '_Tuple2',
							_0: {ctor: '[]'},
							_1: false
						},
						props));
			});
		var prioritize = F2(
			function (isPriority, props) {
				var _p43 = A2(_elm_lang$core$List$partition, isPriority, props);
				var high = _p43._0;
				var low = _p43._1;
				return A2(_elm_lang$core$Basics_ops['++'], low, high);
			});
		var shadows = function (prop) {
			var _p44 = prop;
			if (_p44.ctor === 'Shadows') {
				return true;
			} else {
				return false;
			}
		};
		var visible = function (prop) {
			var _p45 = prop;
			if (_p45.ctor === 'Visibility') {
				return true;
			} else {
				return false;
			}
		};
		var processed = mergeTransforms(
			mergeShadowsAndFilters(
				A2(
					overridePrevious,
					shadows,
					A2(
						prioritize,
						shadows,
						A2(
							overridePrevious,
							visible,
							A2(prioritize, visible, _p23._1))))));
		return A2(_mdgriffith$style_elements$Style_Internal_Model$Style, _p23._0, processed);
	} else {
		return style;
	}
};
var _mdgriffith$style_elements$Style_Internal_Render$reorderImportAddReset = F2(
	function (reset, styles) {
		var reorder = F2(
			function (style, _p46) {
				var _p47 = _p46;
				var _p50 = _p47._1;
				var _p49 = _p47._0;
				var _p48 = style;
				if (_p48.ctor === 'Import') {
					return {
						ctor: '_Tuple2',
						_0: {ctor: '::', _0: style, _1: _p49},
						_1: _p50
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: _p49,
						_1: {ctor: '::', _0: style, _1: _p50}
					};
				}
			});
		var _p51 = A3(
			_elm_lang$core$List$foldr,
			reorder,
			{
				ctor: '_Tuple2',
				_0: {ctor: '[]'},
				_1: {ctor: '[]'}
			},
			styles);
		var imports = _p51._0;
		var allStyles = _p51._1;
		var getFontStyle = function (style) {
			var _p52 = style;
			if (_p52.ctor === 'Style') {
				var forFont = function (prop) {
					var _p53 = prop;
					if (_p53.ctor === 'FontFamily') {
						var forImport = function (font) {
							var _p54 = font;
							if (_p54.ctor === 'ImportFont') {
								return _elm_lang$core$Maybe$Just(_p54._1);
							} else {
								return _elm_lang$core$Maybe$Nothing;
							}
						};
						return A2(_elm_lang$core$List$filterMap, forImport, _p53._0);
					} else {
						return {ctor: '[]'};
					}
				};
				return A2(_elm_lang$core$List$concatMap, forFont, _p52._1);
			} else {
				return {ctor: '[]'};
			}
		};
		var importedFonts = A2(
			_elm_lang$core$List$map,
			function (uri) {
				return _mdgriffith$style_elements$Style_Internal_Model$Import(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'url(\'',
						A2(_elm_lang$core$Basics_ops['++'], uri, '\')')));
			},
			function (_p55) {
				return _elm_lang$core$Set$toList(
					_elm_lang$core$Set$fromList(_p55));
			}(
				A2(_elm_lang$core$List$concatMap, getFontStyle, styles)));
		return A2(
			_elm_lang$core$Basics_ops['++'],
			imports,
			A2(
				_elm_lang$core$Basics_ops['++'],
				importedFonts,
				A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Internal_Model$Reset(reset),
						_1: {ctor: '[]'}
					},
					allStyles)));
	});
var _mdgriffith$style_elements$Style_Internal_Render$spacing = function (box) {
	var name = function () {
		var _p56 = box;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			'spacing-',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(_p56._0),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'-',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p56._1),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'-',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p56._2),
								A2(
									_elm_lang$core$Basics_ops['++'],
									'-',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p56._3),
										' > *:not(.nospacing)'))))))));
	}();
	return function (cls) {
		return {
			ctor: '_Tuple2',
			_0: name,
			_1: A2(
				_elm_lang$core$Basics_ops['++'],
				'.',
				A2(_elm_lang$core$Basics_ops['++'], name, cls))
		};
	}(
		A2(
			_mdgriffith$style_elements$Style_Internal_Render_Css$brace,
			0,
			A2(
				_mdgriffith$style_elements$Style_Internal_Render_Css$prop,
				2,
				{
					ctor: '_Tuple2',
					_0: 'margin',
					_1: _mdgriffith$style_elements$Style_Internal_Render_Value$box(box)
				})));
};
var _mdgriffith$style_elements$Style_Internal_Render$class = F2(
	function (name, props) {
		var renderedProps = A2(
			_elm_lang$core$String$join,
			'\n',
			A2(
				_elm_lang$core$List$map,
				_mdgriffith$style_elements$Style_Internal_Render_Css$prop(2),
				props));
		return A2(
			_elm_lang$core$Basics_ops['++'],
			'.',
			A2(
				_elm_lang$core$Basics_ops['++'],
				name,
				A2(_mdgriffith$style_elements$Style_Internal_Render_Css$brace, 0, renderedProps)));
	});
var _mdgriffith$style_elements$Style_Internal_Render$renderStyle = F2(
	function (guarded, style) {
		var _p57 = style;
		switch (_p57.ctor) {
			case 'Reset':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$Free(_p57._0);
			case 'Import':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$Free(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'@import ',
						A2(_elm_lang$core$Basics_ops['++'], _p57._0, ';')));
			case 'RawStyle':
				return _mdgriffith$style_elements$Style_Internal_Intermediate$Free(
					A2(_mdgriffith$style_elements$Style_Internal_Render$class, _p57._0, _p57._1));
			default:
				var guard = function (i) {
					return guarded ? _mdgriffith$style_elements$Style_Internal_Intermediate$guard(i) : i;
				};
				var selector = _mdgriffith$style_elements$Style_Internal_Selector$select(_p57._0);
				var inter = _mdgriffith$style_elements$Style_Internal_Intermediate$Class(
					{
						selector: selector,
						props: A2(
							_elm_lang$core$List$map,
							_mdgriffith$style_elements$Style_Internal_Render$renderProp(selector),
							_p57._1)
					});
				return guard(inter);
		}
	});
var _mdgriffith$style_elements$Style_Internal_Render$stylesheet = F3(
	function (reset, guard, batched) {
		return _mdgriffith$style_elements$Style_Internal_Intermediate$finalize(
			A2(
				_elm_lang$core$List$map,
				function (_p58) {
					return A2(
						_mdgriffith$style_elements$Style_Internal_Render$renderStyle,
						guard,
						_mdgriffith$style_elements$Style_Internal_Render$preprocess(_p58));
				},
				A2(
					_mdgriffith$style_elements$Style_Internal_Render$reorderImportAddReset,
					reset,
					_mdgriffith$style_elements$Style_Internal_Batchable$toList(batched))));
	});
var _mdgriffith$style_elements$Style_Internal_Render$unbatchedStylesheet = F2(
	function (guard, styles) {
		return _mdgriffith$style_elements$Style_Internal_Intermediate$finalize(
			A2(
				_elm_lang$core$List$map,
				function (_p59) {
					return A2(
						_mdgriffith$style_elements$Style_Internal_Render$renderStyle,
						guard,
						_mdgriffith$style_elements$Style_Internal_Render$preprocess(_p59));
				},
				styles));
	});
var _mdgriffith$style_elements$Style_Internal_Render$single = F2(
	function (guard, style) {
		return function (_p60) {
			return _mdgriffith$style_elements$Style_Internal_Intermediate$raw(
				A2(
					_mdgriffith$style_elements$Style_Internal_Render$renderStyle,
					guard,
					_mdgriffith$style_elements$Style_Internal_Render$preprocess(_p60)));
		}(style);
	});

var _mdgriffith$style_elements$Style$prepareSheet = function (_p0) {
	var _p1 = _p0;
	var _p3 = _p1._0.findable;
	var variations = F2(
		function ($class, vs) {
			var varys = A2(
				_elm_lang$core$List$map,
				function (cls) {
					return {ctor: '_Tuple2', _0: cls, _1: true};
				},
				A2(
					_elm_lang$core$List$map,
					function (_p2) {
						return function (vary) {
							return A3(_mdgriffith$style_elements$Style_Internal_Find$variation, $class, vary, _p3);
						}(
							_elm_lang$core$Tuple$first(_p2));
					},
					A2(_elm_lang$core$List$filter, _elm_lang$core$Tuple$second, vs)));
			var parent = A2(_mdgriffith$style_elements$Style_Internal_Find$style, $class, _p3);
			return {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: parent, _1: true},
				_1: varys
			};
		});
	return {
		style: function ($class) {
			return A2(_mdgriffith$style_elements$Style_Internal_Find$style, $class, _p3);
		},
		variations: F2(
			function ($class, varys) {
				return A2(variations, $class, varys);
			}),
		css: _p1._0.css
	};
};
var _mdgriffith$style_elements$Style$pseudo = F2(
	function (psu, props) {
		return A2(
			_mdgriffith$style_elements$Style_Internal_Model$PseudoElement,
			A2(_elm_lang$core$Basics_ops['++'], ':', psu),
			props);
	});
var _mdgriffith$style_elements$Style$checked = function (props) {
	return A2(_mdgriffith$style_elements$Style_Internal_Model$PseudoElement, ':checked', props);
};
var _mdgriffith$style_elements$Style$focus = function (props) {
	return A2(_mdgriffith$style_elements$Style_Internal_Model$PseudoElement, ':focus', props);
};
var _mdgriffith$style_elements$Style$hover = function (props) {
	return A2(_mdgriffith$style_elements$Style_Internal_Model$PseudoElement, ':hover', props);
};
var _mdgriffith$style_elements$Style$scale = F3(
	function (x, y, z) {
		return _mdgriffith$style_elements$Style_Internal_Model$Transform(
			{
				ctor: '::',
				_0: A3(_mdgriffith$style_elements$Style_Internal_Model$Scale, x, y, z),
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Style$translate = F3(
	function (x, y, z) {
		return _mdgriffith$style_elements$Style_Internal_Model$Transform(
			{
				ctor: '::',
				_0: A3(_mdgriffith$style_elements$Style_Internal_Model$Translate, x, y, z),
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Style$rotateAround = F2(
	function (_p4, angle) {
		var _p5 = _p4;
		return _mdgriffith$style_elements$Style_Internal_Model$Transform(
			{
				ctor: '::',
				_0: A4(_mdgriffith$style_elements$Style_Internal_Model$RotateAround, _p5._0, _p5._1, _p5._2, angle),
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Style$rotate = function (a) {
	return _mdgriffith$style_elements$Style_Internal_Model$Transform(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Rotate(a),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style$origin = F3(
	function (x, y, z) {
		return A2(
			_mdgriffith$style_elements$Style_Internal_Model$Exact,
			'transform-origin',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(x),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'px  ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(y),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'px ',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(z),
								'px'))))));
	});
var _mdgriffith$style_elements$Style$cursor = function (name) {
	return A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, 'cursor', name);
};
var _mdgriffith$style_elements$Style$opacity = function (o) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'opacity',
		_elm_lang$core$Basics$toString(o));
};
var _mdgriffith$style_elements$Style$prop = F2(
	function (name, val) {
		return A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, name, val);
	});
var _mdgriffith$style_elements$Style$variation = F2(
	function (variation, props) {
		return A2(_mdgriffith$style_elements$Style_Internal_Model$Variation, variation, props);
	});
var _mdgriffith$style_elements$Style$style = F2(
	function (cls, props) {
		return _mdgriffith$style_elements$Style_Internal_Batchable$one(
			A2(
				_mdgriffith$style_elements$Style_Internal_Model$Style,
				cls,
				{
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Style$prop, 'border-style', 'solid'),
					_1: props
				}));
	});
var _mdgriffith$style_elements$Style$importCss = function (str) {
	return _mdgriffith$style_elements$Style_Internal_Batchable$one(
		_mdgriffith$style_elements$Style_Internal_Model$Import(
			A2(
				_elm_lang$core$Basics_ops['++'],
				'\"',
				A2(_elm_lang$core$Basics_ops['++'], str, '\"'))));
};
var _mdgriffith$style_elements$Style$importUrl = function (url) {
	return _mdgriffith$style_elements$Style_Internal_Batchable$one(
		_mdgriffith$style_elements$Style_Internal_Model$Import(
			A2(
				_elm_lang$core$Basics_ops['++'],
				'url(\"',
				A2(_elm_lang$core$Basics_ops['++'], url, '\")'))));
};
var _mdgriffith$style_elements$Style$Unguarded = {ctor: 'Unguarded'};
var _mdgriffith$style_elements$Style$unguarded = _mdgriffith$style_elements$Style$Unguarded;
var _mdgriffith$style_elements$Style$styleSheetWith = F2(
	function (options, styles) {
		var unguarded = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Style$Unguarded),
			options);
		return _mdgriffith$style_elements$Style$prepareSheet(
			A3(_mdgriffith$style_elements$Style_Internal_Render$stylesheet, '', !unguarded, styles));
	});
var _mdgriffith$style_elements$Style$styleSheet = function (styles) {
	return A2(
		_mdgriffith$style_elements$Style$styleSheetWith,
		{ctor: '[]'},
		styles);
};

var _mdgriffith$style_elements$Element$mainContent = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'main',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'main'),
							_1: attrs
						}
					}
				},
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$sidebar = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'aside',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$Down,
					{ctor: '[]'}),
				attrs: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'complementary'),
					_1: attrs
				},
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$footer = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'footer',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'contentinfo'),
						_1: attrs
					}
				},
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$header = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'header',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'banner'),
						_1: attrs
					}
				},
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$navigationColumn = F3(
	function (style, attrs, _p0) {
		var _p1 = _p0;
		var wrap = function (el) {
			return _mdgriffith$style_elements$Element_Internal_Model$Element(
				{
					node: 'li',
					style: _elm_lang$core$Maybe$Nothing,
					attrs: {ctor: '[]'},
					child: el,
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				});
		};
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'nav',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'navigation'),
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-label', _p1.name),
						_1: {ctor: '[]'}
					}
				},
				child: _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: 'ul',
						style: _elm_lang$core$Maybe$Just(style),
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$Down,
							{ctor: '[]'}),
						attrs: attrs,
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							A2(_elm_lang$core$List$map, wrap, _p1.options)),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					}),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$navigation = F3(
	function (style, attrs, _p2) {
		var _p3 = _p2;
		var wrap = function (el) {
			return _mdgriffith$style_elements$Element_Internal_Model$Element(
				{
					node: 'li',
					style: _elm_lang$core$Maybe$Nothing,
					attrs: {ctor: '[]'},
					child: el,
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				});
		};
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'nav',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'navigation'),
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-label', _p3.name),
						_1: {ctor: '[]'}
					}
				},
				child: _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: 'ul',
						style: _elm_lang$core$Maybe$Just(style),
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '[]'}),
						attrs: attrs,
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							A2(_elm_lang$core$List$map, wrap, _p3.options)),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					}),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$search = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'search'),
						_1: attrs
					}
				},
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$mapAll = _mdgriffith$style_elements$Element_Internal_Model$mapAll;
var _mdgriffith$style_elements$Element$map = _mdgriffith$style_elements$Element_Internal_Model$mapMsg;
var _mdgriffith$style_elements$Element$responsive = F3(
	function (a, _p5, _p4) {
		var _p6 = _p5;
		var _p11 = _p6._0;
		var _p10 = _p6._1;
		var _p7 = _p4;
		var _p9 = _p7._0;
		var _p8 = _p7._1;
		if (_elm_lang$core$Native_Utils.cmp(a, _p11) < 1) {
			return _p9;
		} else {
			if (_elm_lang$core$Native_Utils.cmp(a, _p10) > -1) {
				return _p8;
			} else {
				var deltaA = (a - _p11) / (_p10 - _p11);
				return (deltaA * (_p8 - _p9)) + _p9;
			}
		}
	});
var _mdgriffith$style_elements$Element$classifyDevice = function (_p12) {
	var _p13 = _p12;
	var _p15 = _p13.width;
	var _p14 = _p13.height;
	return {
		width: _p15,
		height: _p14,
		phone: _elm_lang$core$Native_Utils.cmp(_p15, 600) < 1,
		tablet: (_elm_lang$core$Native_Utils.cmp(_p15, 600) > 0) && (_elm_lang$core$Native_Utils.cmp(_p15, 1200) < 1),
		desktop: (_elm_lang$core$Native_Utils.cmp(_p15, 1200) > 0) && (_elm_lang$core$Native_Utils.cmp(_p15, 1800) < 1),
		bigDesktop: _elm_lang$core$Native_Utils.cmp(_p15, 1800) > 0,
		portrait: _elm_lang$core$Native_Utils.cmp(_p15, _p14) < 0
	};
};
var _mdgriffith$style_elements$Element$embedStylesheet = function (sheet) {
	return A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		A2(_mdgriffith$style_elements$Element_Internal_Render$embed, false, sheet));
};
var _mdgriffith$style_elements$Element$toHtml = F2(
	function (stylesheet, el) {
		return A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			A2(_mdgriffith$style_elements$Element_Internal_Render$render, stylesheet, el));
	});
var _mdgriffith$style_elements$Element$viewport = _mdgriffith$style_elements$Element_Internal_Render$viewport;
var _mdgriffith$style_elements$Element$layout = _mdgriffith$style_elements$Element_Internal_Render$root;
var _mdgriffith$style_elements$Element$onLeft = F2(
	function (nearbys, parent) {
		var position = F2(
			function (el, p) {
				return A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addChild,
					p,
					A2(
						_mdgriffith$style_elements$Element_Internal_Modify$removeAttrs,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Right),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Left),
								_1: {ctor: '[]'}
							}
						},
						A2(
							_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
							_mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
								_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$OnLeft)),
							_mdgriffith$style_elements$Element_Internal_Modify$wrapHtml(el))));
			});
		return A3(_elm_lang$core$List$foldr, position, parent, nearbys);
	});
var _mdgriffith$style_elements$Element$onRight = F2(
	function (nearbys, parent) {
		var position = F2(
			function (el, p) {
				return A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addChild,
					p,
					A2(
						_mdgriffith$style_elements$Element_Internal_Modify$removeAttrs,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Right),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$HAlign(_mdgriffith$style_elements$Element_Internal_Model$Left),
								_1: {ctor: '[]'}
							}
						},
						A2(
							_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
							_mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
								_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$OnRight)),
							_mdgriffith$style_elements$Element_Internal_Modify$wrapHtml(el))));
			});
		return A3(_elm_lang$core$List$foldr, position, parent, nearbys);
	});
var _mdgriffith$style_elements$Element$below = F2(
	function (nearbys, parent) {
		var position = F2(
			function (el, p) {
				return A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addChild,
					p,
					A2(
						_mdgriffith$style_elements$Element_Internal_Modify$removeAttrs,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Top),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Bottom),
								_1: {ctor: '[]'}
							}
						},
						A2(
							_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
							_mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
								_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$Below)),
							_mdgriffith$style_elements$Element_Internal_Modify$wrapHtml(el))));
			});
		return A3(_elm_lang$core$List$foldr, position, parent, nearbys);
	});
var _mdgriffith$style_elements$Element$above = F2(
	function (nearbys, parent) {
		var position = F2(
			function (el, p) {
				return A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addChild,
					p,
					A2(
						_mdgriffith$style_elements$Element_Internal_Modify$removeAttrs,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Top),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$VAlign(_mdgriffith$style_elements$Element_Internal_Model$Bottom),
								_1: {ctor: '[]'}
							}
						},
						A2(
							_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
							_mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
								_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$Above)),
							_mdgriffith$style_elements$Element_Internal_Modify$wrapHtml(el))));
			});
		return A3(_elm_lang$core$List$foldr, position, parent, nearbys);
	});
var _mdgriffith$style_elements$Element$within = F2(
	function (nearbys, parent) {
		var position = F2(
			function (el, p) {
				return A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addChild,
					p,
					A2(
						_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
						_mdgriffith$style_elements$Element_Internal_Model$PositionFrame(
							_mdgriffith$style_elements$Element_Internal_Model$Nearby(_mdgriffith$style_elements$Element_Internal_Model$Within)),
						_mdgriffith$style_elements$Element_Internal_Modify$wrapHtml(el)));
			});
		return A3(_elm_lang$core$List$foldr, position, parent, nearbys);
	});
var _mdgriffith$style_elements$Element$downloadAs = F2(
	function (_p16, el) {
		var _p17 = _p16;
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'a',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
						_elm_lang$html$Html_Attributes$href(_p17.src)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
							_elm_lang$html$Html_Attributes$downloadAs(_p17.filename)),
						_1: {ctor: '[]'}
					}
				},
				child: el,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$download = F2(
	function (src, el) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'a',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
						_elm_lang$html$Html_Attributes$href(src)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
							_elm_lang$html$Html_Attributes$download(true)),
						_1: {ctor: '[]'}
					}
				},
				child: el,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$newTab = F2(
	function (src, el) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'a',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
						_elm_lang$html$Html_Attributes$href(src)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
							_elm_lang$html$Html_Attributes$rel('noopener noreferrer')),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
								_elm_lang$html$Html_Attributes$target('_blank')),
							_1: {ctor: '[]'}
						}
					}
				},
				child: el,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$link = F2(
	function (src, el) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'a',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
						_elm_lang$html$Html_Attributes$href(src)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
							_elm_lang$html$Html_Attributes$rel('noopener noreferrer')),
						_1: {ctor: '[]'}
					}
				},
				child: el,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$spanAll = function (name) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Named,
		_mdgriffith$style_elements$Style_Internal_Model$SpanAll,
		_elm_lang$core$Maybe$Just(name));
};
var _mdgriffith$style_elements$Element$span = F2(
	function (i, name) {
		return A2(
			_mdgriffith$style_elements$Style_Internal_Model$Named,
			_mdgriffith$style_elements$Style_Internal_Model$SpanJust(i),
			_elm_lang$core$Maybe$Just(name));
	});
var _mdgriffith$style_elements$Element$named = F2(
	function (name, el) {
		return _mdgriffith$style_elements$Element_Internal_Model$NamedOnGrid(
			A2(
				_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
				_mdgriffith$style_elements$Element_Internal_Model$GridArea(name),
				el));
	});
var _mdgriffith$style_elements$Element$cell = function (box) {
	var coords = {start: box.start, width: box.width, height: box.height};
	return _mdgriffith$style_elements$Element_Internal_Model$OnGrid(
		A2(
			_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
			_mdgriffith$style_elements$Element_Internal_Model$GridCoords(
				_mdgriffith$style_elements$Style_Internal_Model$GridPosition(coords)),
			box.content));
};
var _mdgriffith$style_elements$Element$namedGrid = F3(
	function (style, attrs, config) {
		var forSpacing = function (attr) {
			var _p18 = attr;
			if (_p18.ctor === 'Spacing') {
				return true;
			} else {
				return false;
			}
		};
		var _p19 = A2(_elm_lang$core$List$partition, forSpacing, attrs);
		var spacing = _p19._0;
		var notSpacingAttrs = _p19._1;
		var gridAttributes = function () {
			var _p20 = _elm_lang$core$List$head(
				_elm_lang$core$List$reverse(spacing));
			if (_p20.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				if (_p20._0.ctor === 'Spacing') {
					return {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Style_Internal_Model$GridGap, _p20._0._0, _p20._0._1),
						_1: {ctor: '[]'}
					};
				} else {
					return {ctor: '[]'};
				}
			}
		}();
		var prepare = function (el) {
			return _mdgriffith$style_elements$Element_Internal_Model$Normal(
				A2(
					_elm_lang$core$List$map,
					function (_p21) {
						var _p22 = _p21;
						return _p22._0;
					},
					el));
		};
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$Grid,
					_mdgriffith$style_elements$Style_Internal_Model$NamedGridTemplate(
						{rows: config.rows, columns: config.columns}),
					gridAttributes),
				attrs: notSpacingAttrs,
				children: prepare(config.cells),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$grid = F3(
	function (style, attrs, config) {
		var forSpacing = function (attr) {
			var _p23 = attr;
			if (_p23.ctor === 'Spacing') {
				return true;
			} else {
				return false;
			}
		};
		var _p24 = A2(_elm_lang$core$List$partition, forSpacing, attrs);
		var spacing = _p24._0;
		var notSpacingAttrs = _p24._1;
		var gridAttributes = function () {
			var _p25 = _elm_lang$core$List$head(
				_elm_lang$core$List$reverse(spacing));
			if (_p25.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				if (_p25._0.ctor === 'Spacing') {
					return {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Style_Internal_Model$GridGap, _p25._0._0, _p25._0._1),
						_1: {ctor: '[]'}
					};
				} else {
					return {ctor: '[]'};
				}
			}
		}();
		var prepare = function (el) {
			return _mdgriffith$style_elements$Element_Internal_Model$Normal(
				A2(
					_elm_lang$core$List$map,
					function (_p26) {
						var _p27 = _p26;
						return _p27._0;
					},
					el));
		};
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$Grid,
					_mdgriffith$style_elements$Style_Internal_Model$GridTemplate(
						{rows: config.rows, columns: config.columns}),
					gridAttributes),
				attrs: notSpacingAttrs,
				children: prepare(config.cells),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$table = F3(
	function (style, attrs, rows) {
		var children = _elm_lang$core$List$concat(
			A2(
				_elm_lang$core$List$indexedMap,
				F2(
					function (row, columns) {
						return A2(
							_elm_lang$core$List$indexedMap,
							F2(
								function (col, content) {
									return _mdgriffith$style_elements$Element$cell(
										{
											start: {ctor: '_Tuple2', _0: row, _1: col},
											width: 1,
											height: 1,
											content: content
										});
								}),
							columns);
					}),
				rows));
		return A3(
			_mdgriffith$style_elements$Element$grid,
			style,
			attrs,
			{
				columns: {ctor: '[]'},
				rows: {ctor: '[]'},
				cells: children
			});
	});
var _mdgriffith$style_elements$Element$wrappedColumn = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$Down,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Internal_Model$Wrap(true),
						_1: {ctor: '[]'}
					}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$wrappedRow = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$GoRight,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Internal_Model$Wrap(true),
						_1: {ctor: '[]'}
					}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$column = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$Down,
					{ctor: '[]'}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$row = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$GoRight,
					{ctor: '[]'}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$paragraph = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'p',
				style: _elm_lang$core$Maybe$Just(style),
				layout: _mdgriffith$style_elements$Style_Internal_Model$TextLayout(false),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
					A2(_elm_lang$core$List$map, _mdgriffith$style_elements$Element_Internal_Modify$makeInline, children)),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$textLayout = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: _mdgriffith$style_elements$Style_Internal_Model$TextLayout(true),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$full = F3(
	function (elem, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(elem),
				attrs: {ctor: '::', _0: _mdgriffith$style_elements$Element_Internal_Model$Expand, _1: attrs},
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$h6 = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'h6',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$h5 = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'h5',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$h4 = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'h4',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$h3 = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'h3',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$h2 = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'h2',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$h1 = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'h1',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$button = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'button',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$class('button-focus'),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'cursor', _1: 'pointer'},
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$toAttr(
								_elm_lang$html$Html_Attributes$tabindex(0)),
							_1: attrs
						}
					}
				},
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$node = function (str) {
	return _mdgriffith$style_elements$Element_Internal_Modify$setNode(str);
};
var _mdgriffith$style_elements$Element$html = _mdgriffith$style_elements$Element_Internal_Model$Raw;
var _mdgriffith$style_elements$Element$spacer = _mdgriffith$style_elements$Element_Internal_Model$Spacer;
var _mdgriffith$style_elements$Element$circle = F4(
	function (radius, style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
						_elm_lang$html$Html_Attributes$style(
							{
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'border-radius',
									_1: A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(radius),
										'px')
								},
								_1: {ctor: '[]'}
							})),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
							_mdgriffith$style_elements$Style_Internal_Model$Px(2 * radius)),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Height(
								_mdgriffith$style_elements$Style_Internal_Model$Px(2 * radius)),
							_1: attrs
						}
					}
				},
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$aside = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'aside',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$article = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'article',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$section = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'section',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$el = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: child,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$bulleted = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'ul',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$Down,
					{ctor: '[]'}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
					A2(
						_elm_lang$core$List$map,
						function (_p28) {
							return A2(
								_mdgriffith$style_elements$Element_Internal_Modify$setNode,
								'li',
								A2(
									_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
									_mdgriffith$style_elements$Element_Attributes$inlineStyle(
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'display', _1: 'list-item'},
											_1: {ctor: '[]'}
										}),
									_p28));
						},
						children)),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$numbered = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'ol',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$Down,
					{ctor: '[]'}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
					A2(
						_elm_lang$core$List$map,
						function (_p29) {
							return A2(
								_mdgriffith$style_elements$Element_Internal_Modify$setNode,
								'li',
								A2(
									_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
									_mdgriffith$style_elements$Element_Attributes$inlineStyle(
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'display', _1: 'list-item'},
											_1: {ctor: '[]'}
										}),
									_p29));
						},
						children)),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$super = _mdgriffith$style_elements$Element_Internal_Model$Text(
	{decoration: _mdgriffith$style_elements$Element_Internal_Model$Super, inline: false});
var _mdgriffith$style_elements$Element$sub = _mdgriffith$style_elements$Element_Internal_Model$Text(
	{decoration: _mdgriffith$style_elements$Element_Internal_Model$Sub, inline: false});
var _mdgriffith$style_elements$Element$underline = _mdgriffith$style_elements$Element_Internal_Model$Text(
	{decoration: _mdgriffith$style_elements$Element_Internal_Model$Underline, inline: false});
var _mdgriffith$style_elements$Element$strike = _mdgriffith$style_elements$Element_Internal_Model$Text(
	{decoration: _mdgriffith$style_elements$Element_Internal_Model$Strike, inline: false});
var _mdgriffith$style_elements$Element$italic = _mdgriffith$style_elements$Element_Internal_Model$Text(
	{decoration: _mdgriffith$style_elements$Element_Internal_Model$Italic, inline: false});
var _mdgriffith$style_elements$Element$bold = _mdgriffith$style_elements$Element_Internal_Model$Text(
	{decoration: _mdgriffith$style_elements$Element_Internal_Model$Bold, inline: false});
var _mdgriffith$style_elements$Element$text = _mdgriffith$style_elements$Element_Internal_Model$Text(
	{decoration: _mdgriffith$style_elements$Element_Internal_Model$NoDecoration, inline: false});
var _mdgriffith$style_elements$Element$subheading = F3(
	function (style, attrs, str) {
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'p',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: attrs,
				child: _mdgriffith$style_elements$Element$text(str),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$empty = _mdgriffith$style_elements$Element_Internal_Model$Empty;
var _mdgriffith$style_elements$Element$image = F3(
	function (style, attrs, _p30) {
		var _p31 = _p30;
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'img',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
						_elm_lang$html$Html_Attributes$src(_p31.src)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
							_elm_lang$html$Html_Attributes$alt(_p31.caption)),
						_1: attrs
					}
				},
				child: _mdgriffith$style_elements$Element$empty,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$decorativeImage = F3(
	function (style, attrs, _p32) {
		var _p33 = _p32;
		return _mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'img',
				style: _elm_lang$core$Maybe$Just(style),
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Attr(
						_elm_lang$html$Html_Attributes$src(_p33.src)),
					_1: attrs
				},
				child: _mdgriffith$style_elements$Element$empty,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element$hairline = function (style) {
	return _mdgriffith$style_elements$Element_Internal_Model$Element(
		{
			node: 'hr',
			style: _elm_lang$core$Maybe$Just(style),
			attrs: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Internal_Model$Height(
					_mdgriffith$style_elements$Style_Internal_Model$Px(1)),
				_1: {ctor: '[]'}
			},
			child: _mdgriffith$style_elements$Element$empty,
			absolutelyPositioned: _elm_lang$core$Maybe$Nothing
		});
};
var _mdgriffith$style_elements$Element$when = F2(
	function (bool, elm) {
		return bool ? elm : _mdgriffith$style_elements$Element$empty;
	});
var _mdgriffith$style_elements$Element$whenJust = F2(
	function (maybe, view) {
		var _p34 = maybe;
		if (_p34.ctor === 'Nothing') {
			return _mdgriffith$style_elements$Element$empty;
		} else {
			return view(_p34._0);
		}
	});
var _mdgriffith$style_elements$Element$screen = function (el) {
	return A2(
		_mdgriffith$style_elements$Element$within,
		{
			ctor: '::',
			_0: el,
			_1: {ctor: '[]'}
		},
		_mdgriffith$style_elements$Element_Internal_Model$Element(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Nothing,
				attrs: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$PositionFrame(_mdgriffith$style_elements$Element_Internal_Model$Screen),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
							A2(_mdgriffith$style_elements$Style_Internal_Model$Calc, 100, 0)),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Height(
								A2(_mdgriffith$style_elements$Style_Internal_Model$Calc, 100, 0)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$PointerEvents(false),
								_1: {ctor: '[]'}
							}
						}
					}
				},
				child: _mdgriffith$style_elements$Element$empty,
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			}));
};
var _mdgriffith$style_elements$Element$modal = F3(
	function (style, attrs, child) {
		return _mdgriffith$style_elements$Element$screen(
			_mdgriffith$style_elements$Element_Internal_Model$Element(
				{
					node: 'div',
					style: _elm_lang$core$Maybe$Just(style),
					attrs: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'alertdialog'),
						_1: {
							ctor: '::',
							_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-modal', 'true'),
							_1: attrs
						}
					},
					child: child,
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				}));
	});
var _mdgriffith$style_elements$Element$Grid = F3(
	function (a, b, c) {
		return {rows: a, columns: b, cells: c};
	});
var _mdgriffith$style_elements$Element$NamedGrid = F3(
	function (a, b, c) {
		return {rows: a, columns: b, cells: c};
	});
var _mdgriffith$style_elements$Element$GridPosition = F4(
	function (a, b, c, d) {
		return {start: a, width: b, height: c, content: d};
	});
var _mdgriffith$style_elements$Element$Device = F7(
	function (a, b, c, d, e, f, g) {
		return {width: a, height: b, phone: c, tablet: d, desktop: e, bigDesktop: f, portrait: g};
	});

var _mdgriffith$style_elements$Element_Events$keyCode = A2(_elm_lang$core$Json_Decode$field, 'keyCode', _elm_lang$core$Json_Decode$int);
var _mdgriffith$style_elements$Element_Events$targetChecked = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'checked',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$bool);
var _mdgriffith$style_elements$Element_Events$targetValue = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'value',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$string);
var _mdgriffith$style_elements$Element_Events$defaultOptions = _elm_lang$virtual_dom$VirtualDom$defaultOptions;
var _mdgriffith$style_elements$Element_Events$onWithOptions = F3(
	function (event, options, decode) {
		return _mdgriffith$style_elements$Element_Internal_Model$Event(
			A3(_elm_lang$html$Html_Events$onWithOptions, event, options, decode));
	});
var _mdgriffith$style_elements$Element_Events$on = F2(
	function (event, decode) {
		return _mdgriffith$style_elements$Element_Internal_Model$Event(
			A2(_elm_lang$html$Html_Events$on, event, decode));
	});
var _mdgriffith$style_elements$Element_Events$onFocus = function (_p0) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onFocus(_p0));
};
var _mdgriffith$style_elements$Element_Events$onBlur = function (_p1) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onBlur(_p1));
};
var _mdgriffith$style_elements$Element_Events$onSubmit = function (_p2) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onSubmit(_p2));
};
var _mdgriffith$style_elements$Element_Events$onCheck = function (_p3) {
	return _mdgriffith$style_elements$Element_Internal_Model$InputEvent(
		_elm_lang$html$Html_Events$onCheck(_p3));
};
var _mdgriffith$style_elements$Element_Events$onInput = function (_p4) {
	return _mdgriffith$style_elements$Element_Internal_Model$InputEvent(
		_elm_lang$html$Html_Events$onInput(_p4));
};
var _mdgriffith$style_elements$Element_Events$onMouseOut = function (_p5) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onMouseOut(_p5));
};
var _mdgriffith$style_elements$Element_Events$onMouseOver = function (_p6) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onMouseOver(_p6));
};
var _mdgriffith$style_elements$Element_Events$onMouseLeave = function (_p7) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onMouseLeave(_p7));
};
var _mdgriffith$style_elements$Element_Events$onMouseEnter = function (_p8) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onMouseEnter(_p8));
};
var _mdgriffith$style_elements$Element_Events$onMouseUp = function (_p9) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onMouseUp(_p9));
};
var _mdgriffith$style_elements$Element_Events$onMouseDown = function (_p10) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onMouseDown(_p10));
};
var _mdgriffith$style_elements$Element_Events$onDoubleClick = function (_p11) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onDoubleClick(_p11));
};
var _mdgriffith$style_elements$Element_Events$onClick = function (_p12) {
	return _mdgriffith$style_elements$Element_Internal_Model$Event(
		_elm_lang$html$Html_Events$onClick(_p12));
};
var _mdgriffith$style_elements$Element_Events$event = _mdgriffith$style_elements$Element_Internal_Model$Event;
var _mdgriffith$style_elements$Element_Events$Options = F2(
	function (a, b) {
		return {stopPropagation: a, preventDefault: b};
	});

var _mdgriffith$style_elements$Element_Input$onFocusIn = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'focusin',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _mdgriffith$style_elements$Element_Input$onFocusOut = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'focusout',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _mdgriffith$style_elements$Element_Input$onKeyLookup = function (lookup) {
	var decode = function (code) {
		var _p0 = lookup(code);
		if (_p0.ctor === 'Nothing') {
			return _elm_lang$core$Json_Decode$fail('No key matched');
		} else {
			return _elm_lang$core$Json_Decode$succeed(_p0._0);
		}
	};
	var isKey = A2(
		_elm_lang$core$Json_Decode$andThen,
		decode,
		A2(_elm_lang$core$Json_Decode$field, 'which', _elm_lang$core$Json_Decode$int));
	return A2(_mdgriffith$style_elements$Element_Events$on, 'keydown', isKey);
};
var _mdgriffith$style_elements$Element_Input$onKey = F2(
	function (desiredCode, msg) {
		var decode = function (code) {
			return _elm_lang$core$Native_Utils.eq(code, desiredCode) ? _elm_lang$core$Json_Decode$succeed(msg) : _elm_lang$core$Json_Decode$fail('Not the enter key');
		};
		var isKey = A2(
			_elm_lang$core$Json_Decode$andThen,
			decode,
			A2(_elm_lang$core$Json_Decode$field, 'which', _elm_lang$core$Json_Decode$int));
		return A2(_mdgriffith$style_elements$Element_Events$on, 'keydown', isKey);
	});
var _mdgriffith$style_elements$Element_Input$space = 32;
var _mdgriffith$style_elements$Element_Input$downArrow = 40;
var _mdgriffith$style_elements$Element_Input$upArrow = 38;
var _mdgriffith$style_elements$Element_Input$backspace = 46;
var _mdgriffith$style_elements$Element_Input$delete = 8;
var _mdgriffith$style_elements$Element_Input$tab = 9;
var _mdgriffith$style_elements$Element_Input$enter = 13;
var _mdgriffith$style_elements$Element_Input$onDown = function (msg) {
	return A2(_mdgriffith$style_elements$Element_Input$onKey, 40, msg);
};
var _mdgriffith$style_elements$Element_Input$onUp = function (msg) {
	return A2(_mdgriffith$style_elements$Element_Input$onKey, 38, msg);
};
var _mdgriffith$style_elements$Element_Input$onSpace = function (msg) {
	return A2(_mdgriffith$style_elements$Element_Input$onKey, 32, msg);
};
var _mdgriffith$style_elements$Element_Input$onEnter = function (msg) {
	return A2(_mdgriffith$style_elements$Element_Input$onKey, 13, msg);
};
var _mdgriffith$style_elements$Element_Input$defaultPadding = F2(
	function (_p2, _p1) {
		var _p3 = _p2;
		var _p4 = _p1;
		return {
			ctor: '_Tuple4',
			_0: A2(_elm_lang$core$Maybe$withDefault, _p4._0, _p3._0),
			_1: A2(_elm_lang$core$Maybe$withDefault, _p4._1, _p3._1),
			_2: A2(_elm_lang$core$Maybe$withDefault, _p4._2, _p3._2),
			_3: A2(_elm_lang$core$Maybe$withDefault, _p4._3, _p3._3)
		};
	});
var _mdgriffith$style_elements$Element_Input$selected = function (select) {
	var _p5 = select;
	if (_p5.ctor === 'Autocomplete') {
		return _p5._0.selected;
	} else {
		return _p5._0.selected;
	}
};
var _mdgriffith$style_elements$Element_Input$arrows = _mdgriffith$style_elements$Element_Internal_Model$Element(
	{
		node: 'div',
		style: _elm_lang$core$Maybe$Nothing,
		attrs: {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$class('arrows'),
			_1: {ctor: '[]'}
		},
		child: _mdgriffith$style_elements$Element$empty,
		absolutelyPositioned: _elm_lang$core$Maybe$Nothing
	});
var _mdgriffith$style_elements$Element_Input$getOptionValue = function (opt) {
	var _p6 = opt;
	if (_p6.ctor === 'Choice') {
		return _p6._0;
	} else {
		return _p6._0;
	}
};
var _mdgriffith$style_elements$Element_Input$getLabelText = function (label) {
	getLabelText:
	while (true) {
		var _p7 = label;
		switch (_p7.ctor) {
			case 'LabelBelow':
				return _mdgriffith$style_elements$Element_Internal_Modify$getText(_p7._0);
			case 'LabelAbove':
				return _mdgriffith$style_elements$Element_Internal_Modify$getText(_p7._0);
			case 'LabelOnRight':
				return _mdgriffith$style_elements$Element_Internal_Modify$getText(_p7._0);
			case 'LabelOnLeft':
				return _mdgriffith$style_elements$Element_Internal_Modify$getText(_p7._0);
			case 'HiddenLabel':
				return _p7._0;
			default:
				var _v6 = _p7._1;
				label = _v6;
				continue getLabelText;
		}
	}
};
var _mdgriffith$style_elements$Element_Input$hidden = _mdgriffith$style_elements$Element_Attributes$inlineStyle(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'position', _1: 'absolute'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'opacity', _1: '0'},
			_1: {ctor: '[]'}
		}
	});
var _mdgriffith$style_elements$Element_Input$autofocusAttr = function (_p8) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$autofocus(_p8));
};
var _mdgriffith$style_elements$Element_Input$autofillAttr = _mdgriffith$style_elements$Element_Attributes$attribute('autocomplete');
var _mdgriffith$style_elements$Element_Input$readonlyAttr = function (_p9) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$readonly(_p9));
};
var _mdgriffith$style_elements$Element_Input$spellcheckAttr = function (_p10) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$spellcheck(_p10));
};
var _mdgriffith$style_elements$Element_Input$addOptionsAsAttrs = F2(
	function (options, attrs) {
		var renderOption = F2(
			function (option, attrs) {
				var _p11 = option;
				switch (_p11.ctor) {
					case 'Key':
						return attrs;
					case 'FocusOnLoad':
						return {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$autofocusAttr(true),
							_1: attrs
						};
					case 'SpellCheck':
						return {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$spellcheckAttr(true),
							_1: attrs
						};
					case 'AutoFill':
						return {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$autofillAttr(_p11._0),
							_1: attrs
						};
					case 'Disabled':
						return attrs;
					default:
						return attrs;
				}
			});
		return A3(_elm_lang$core$List$foldr, renderOption, attrs, options);
	});
var _mdgriffith$style_elements$Element_Input$disabledAttr = function (_p12) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$disabled(_p12));
};
var _mdgriffith$style_elements$Element_Input$tabindex = function (_p13) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$tabindex(_p13));
};
var _mdgriffith$style_elements$Element_Input$textValueAttr = function (_p14) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$defaultValue(_p14));
};
var _mdgriffith$style_elements$Element_Input$valueAttr = function (_p15) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$value(_p15));
};
var _mdgriffith$style_elements$Element_Input$name = function (_p16) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$name(_p16));
};
var _mdgriffith$style_elements$Element_Input$selectedAttr = function (_p17) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$selected(_p17));
};
var _mdgriffith$style_elements$Element_Input$checked = function (_p18) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$checked(_p18));
};
var _mdgriffith$style_elements$Element_Input$type_ = function (_p19) {
	return _mdgriffith$style_elements$Element_Attributes$toAttr(
		_elm_lang$html$Html_Attributes$type_(_p19));
};
var _mdgriffith$style_elements$Element_Input$pointer = _mdgriffith$style_elements$Element_Attributes$inlineStyle(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'cursor', _1: 'pointer'},
		_1: {ctor: '[]'}
	});
var _mdgriffith$style_elements$Element_Input$Checkbox = F4(
	function (a, b, c, d) {
		return {onChange: a, label: b, checked: c, options: d};
	});
var _mdgriffith$style_elements$Element_Input$StyledCheckbox = F5(
	function (a, b, c, d, e) {
		return {onChange: a, label: b, checked: c, options: d, icon: e};
	});
var _mdgriffith$style_elements$Element_Input$Text = F4(
	function (a, b, c, d) {
		return {onChange: a, value: b, label: c, options: d};
	});
var _mdgriffith$style_elements$Element_Input$LabelIntermediate = F6(
	function (a, b, c, d, e, f) {
		return {style: a, attrs: b, label: c, error: d, isDisabled: e, input: f};
	});
var _mdgriffith$style_elements$Element_Input$Radio = F5(
	function (a, b, c, d, e) {
		return {onChange: a, choices: b, selected: c, label: d, options: e};
	});
var _mdgriffith$style_elements$Element_Input$MasterRadio = F6(
	function (a, b, c, d, e, f) {
		return {selection: a, choices: b, label: c, disabled: d, errors: e, key: f};
	});
var _mdgriffith$style_elements$Element_Input$SelectMenuValues = F7(
	function (a, b, c, d, e, f, g) {
		return {max: a, menu: b, label: c, options: d, onUpdate: e, isOpen: f, selected: g};
	});
var _mdgriffith$style_elements$Element_Input$SearchMenu = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {max: a, menu: b, label: c, options: d, query: e, selected: f, focus: g, onUpdate: h, isOpen: i};
	});
var _mdgriffith$style_elements$Element_Input$Select = F5(
	function (a, b, c, d, e) {
		return {$with: a, max: b, menu: c, label: d, options: e};
	});
var _mdgriffith$style_elements$Element_Input$TextArea = {ctor: 'TextArea'};
var _mdgriffith$style_elements$Element_Input$Email = {ctor: 'Email'};
var _mdgriffith$style_elements$Element_Input$Password = {ctor: 'Password'};
var _mdgriffith$style_elements$Element_Input$Search = {ctor: 'Search'};
var _mdgriffith$style_elements$Element_Input$Plain = {ctor: 'Plain'};
var _mdgriffith$style_elements$Element_Input$Key = function (a) {
	return {ctor: 'Key', _0: a};
};
var _mdgriffith$style_elements$Element_Input$textKey = _mdgriffith$style_elements$Element_Input$Key;
var _mdgriffith$style_elements$Element_Input$radioKey = _mdgriffith$style_elements$Element_Input$Key;
var _mdgriffith$style_elements$Element_Input$SpellCheck = {ctor: 'SpellCheck'};
var _mdgriffith$style_elements$Element_Input$allowSpellcheck = _mdgriffith$style_elements$Element_Input$SpellCheck;
var _mdgriffith$style_elements$Element_Input$AutoFill = function (a) {
	return {ctor: 'AutoFill', _0: a};
};
var _mdgriffith$style_elements$Element_Input$autofill = _mdgriffith$style_elements$Element_Input$AutoFill;
var _mdgriffith$style_elements$Element_Input$autofillSection = function (section) {
	return _mdgriffith$style_elements$Element_Input$AutoFill(
		A2(_elm_lang$core$Basics_ops['++'], 'section-', section));
};
var _mdgriffith$style_elements$Element_Input$FocusOnLoad = {ctor: 'FocusOnLoad'};
var _mdgriffith$style_elements$Element_Input$focusOnLoad = _mdgriffith$style_elements$Element_Input$FocusOnLoad;
var _mdgriffith$style_elements$Element_Input$Disabled = {ctor: 'Disabled'};
var _mdgriffith$style_elements$Element_Input$disabled = _mdgriffith$style_elements$Element_Input$Disabled;
var _mdgriffith$style_elements$Element_Input$ErrorOpt = function (a) {
	return {ctor: 'ErrorOpt', _0: a};
};
var _mdgriffith$style_elements$Element_Input$ErrorAbove = function (a) {
	return {ctor: 'ErrorAbove', _0: a};
};
var _mdgriffith$style_elements$Element_Input$errorAbove = function (el) {
	return _mdgriffith$style_elements$Element_Input$ErrorOpt(
		_mdgriffith$style_elements$Element_Input$ErrorAbove(
			A2(
				_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
				A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-live', 'assertive'),
				el)));
};
var _mdgriffith$style_elements$Element_Input$ErrorBelow = function (a) {
	return {ctor: 'ErrorBelow', _0: a};
};
var _mdgriffith$style_elements$Element_Input$errorBelow = function (el) {
	return _mdgriffith$style_elements$Element_Input$ErrorOpt(
		_mdgriffith$style_elements$Element_Input$ErrorBelow(
			A2(
				_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
				A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-live', 'assertive'),
				el)));
};
var _mdgriffith$style_elements$Element_Input$PlaceHolder = F2(
	function (a, b) {
		return {ctor: 'PlaceHolder', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Element_Input$placeholder = function (_p20) {
	var _p21 = _p20;
	var _p23 = _p21.text;
	var _p22 = _p21.label;
	if (_p22.ctor === 'PlaceHolder') {
		return A2(_mdgriffith$style_elements$Element_Input$PlaceHolder, _p23, _p22._1);
	} else {
		return A2(_mdgriffith$style_elements$Element_Input$PlaceHolder, _p23, _p22);
	}
};
var _mdgriffith$style_elements$Element_Input$HiddenLabel = function (a) {
	return {ctor: 'HiddenLabel', _0: a};
};
var _mdgriffith$style_elements$Element_Input$hiddenLabel = _mdgriffith$style_elements$Element_Input$HiddenLabel;
var _mdgriffith$style_elements$Element_Input$LabelOnLeft = function (a) {
	return {ctor: 'LabelOnLeft', _0: a};
};
var _mdgriffith$style_elements$Element_Input$labelLeft = _mdgriffith$style_elements$Element_Input$LabelOnLeft;
var _mdgriffith$style_elements$Element_Input$LabelOnRight = function (a) {
	return {ctor: 'LabelOnRight', _0: a};
};
var _mdgriffith$style_elements$Element_Input$labelRight = _mdgriffith$style_elements$Element_Input$LabelOnRight;
var _mdgriffith$style_elements$Element_Input$LabelAbove = function (a) {
	return {ctor: 'LabelAbove', _0: a};
};
var _mdgriffith$style_elements$Element_Input$labelAbove = _mdgriffith$style_elements$Element_Input$LabelAbove;
var _mdgriffith$style_elements$Element_Input$LabelBelow = function (a) {
	return {ctor: 'LabelBelow', _0: a};
};
var _mdgriffith$style_elements$Element_Input$labelBelow = _mdgriffith$style_elements$Element_Input$LabelBelow;
var _mdgriffith$style_elements$Element_Input$ErrorAboveBelow = F2(
	function (a, b) {
		return {ctor: 'ErrorAboveBelow', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Element_Input$ErrorAllAbove = function (a) {
	return {ctor: 'ErrorAllAbove', _0: a};
};
var _mdgriffith$style_elements$Element_Input$ErrorAllBelow = function (a) {
	return {ctor: 'ErrorAllBelow', _0: a};
};
var _mdgriffith$style_elements$Element_Input$applyLabel = F8(
	function (maybeKey, style, attrs, label, errors, isDisabled, hasPointer, input) {
		applyLabel:
		while (true) {
			var orientedErrors = A3(
				_elm_lang$core$List$foldl,
				F2(
					function (currentError, oriented) {
						var _p24 = oriented;
						if (_p24.ctor === 'Nothing') {
							return _elm_lang$core$Maybe$Just(
								function () {
									var _p25 = currentError;
									if (_p25.ctor === 'ErrorAbove') {
										return _mdgriffith$style_elements$Element_Input$ErrorAllAbove(
											{
												ctor: '::',
												_0: _p25._0,
												_1: {ctor: '[]'}
											});
									} else {
										return _mdgriffith$style_elements$Element_Input$ErrorAllBelow(
											{
												ctor: '::',
												_0: _p25._0,
												_1: {ctor: '[]'}
											});
									}
								}());
						} else {
							return _elm_lang$core$Maybe$Just(
								function () {
									var _p26 = _p24._0;
									switch (_p26.ctor) {
										case 'ErrorAllAbove':
											var _p28 = _p26._0;
											var _p27 = currentError;
											if (_p27.ctor === 'ErrorAbove') {
												return _mdgriffith$style_elements$Element_Input$ErrorAllAbove(
													{ctor: '::', _0: _p27._0, _1: _p28});
											} else {
												return A2(
													_mdgriffith$style_elements$Element_Input$ErrorAboveBelow,
													{
														ctor: '::',
														_0: _p27._0,
														_1: {ctor: '[]'}
													},
													_p28);
											}
										case 'ErrorAllBelow':
											var _p30 = _p26._0;
											var _p29 = currentError;
											if (_p29.ctor === 'ErrorAbove') {
												return A2(
													_mdgriffith$style_elements$Element_Input$ErrorAboveBelow,
													{
														ctor: '::',
														_0: _p29._0,
														_1: {ctor: '[]'}
													},
													_p30);
											} else {
												return _mdgriffith$style_elements$Element_Input$ErrorAllBelow(
													{ctor: '::', _0: _p29._0, _1: _p30});
											}
										default:
											var _p33 = _p26._1;
											var _p32 = _p26._0;
											var _p31 = currentError;
											if (_p31.ctor === 'ErrorAbove') {
												return A2(
													_mdgriffith$style_elements$Element_Input$ErrorAboveBelow,
													{ctor: '::', _0: _p31._0, _1: _p32},
													_p33);
											} else {
												return A2(
													_mdgriffith$style_elements$Element_Input$ErrorAboveBelow,
													_p32,
													{ctor: '::', _0: _p31._0, _1: _p33});
											}
									}
								}());
						}
					}),
				_elm_lang$core$Maybe$Nothing,
				errors);
			var labelContainer = F2(
				function (direction, children) {
					var _p34 = maybeKey;
					if (_p34.ctor === 'Nothing') {
						return _mdgriffith$style_elements$Element_Internal_Model$Layout(
							{
								node: 'label',
								style: style,
								layout: A2(
									_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
									direction,
									{ctor: '[]'}),
								attrs: hasPointer ? {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
										_mdgriffith$style_elements$Style_Internal_Model$Fill(1)),
									_1: {ctor: '::', _0: _mdgriffith$style_elements$Element_Input$pointer, _1: attrs}
								} : {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
										_mdgriffith$style_elements$Style_Internal_Model$Fill(1)),
									_1: attrs
								},
								children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
								absolutelyPositioned: _elm_lang$core$Maybe$Nothing
							});
					} else {
						return _mdgriffith$style_elements$Element_Internal_Model$Layout(
							{
								node: 'label',
								style: style,
								layout: A2(
									_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
									direction,
									{ctor: '[]'}),
								attrs: hasPointer ? {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
										_mdgriffith$style_elements$Style_Internal_Model$Fill(1)),
									_1: {ctor: '::', _0: _mdgriffith$style_elements$Element_Input$pointer, _1: attrs}
								} : {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
										_mdgriffith$style_elements$Style_Internal_Model$Fill(1)),
									_1: attrs
								},
								children: _mdgriffith$style_elements$Element_Internal_Model$Keyed(
									A2(
										_elm_lang$core$List$indexedMap,
										F2(
											function (i, child) {
												return {
													ctor: '_Tuple2',
													_0: A2(
														_elm_lang$core$Basics_ops['++'],
														_p34._0,
														A2(
															_elm_lang$core$Basics_ops['++'],
															'-',
															_elm_lang$core$Basics$toString(i))),
													_1: child
												};
											}),
										children)),
								absolutelyPositioned: _elm_lang$core$Maybe$Nothing
							});
					}
				});
			var forSpacing = function (attr) {
				var _p35 = attr;
				if (_p35.ctor === 'Spacing') {
					return _elm_lang$core$Maybe$Just(attr);
				} else {
					return _elm_lang$core$Maybe$Nothing;
				}
			};
			var spacing = A2(
				_elm_lang$core$Maybe$withDefault,
				A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, 0, 0),
				_elm_lang$core$List$head(
					_elm_lang$core$List$reverse(
						A2(_elm_lang$core$List$filterMap, forSpacing, attrs))));
			var orient = F2(
				function (direction, children) {
					return _mdgriffith$style_elements$Element_Internal_Model$Layout(
						{
							node: 'div',
							style: _elm_lang$core$Maybe$Nothing,
							layout: A2(
								_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
								direction,
								{ctor: '[]'}),
							attrs: hasPointer ? {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$pointer,
								_1: {
									ctor: '::',
									_0: spacing,
									_1: {ctor: '[]'}
								}
							} : {
								ctor: '::',
								_0: spacing,
								_1: {ctor: '[]'}
							},
							children: _mdgriffith$style_elements$Element_Internal_Model$Normal(children),
							absolutelyPositioned: _elm_lang$core$Maybe$Nothing
						});
				});
			var _p36 = label;
			switch (_p36.ctor) {
				case 'PlaceHolder':
					var _v19 = maybeKey,
						_v20 = style,
						_v21 = attrs,
						_v22 = _p36._1,
						_v23 = errors,
						_v24 = isDisabled,
						_v25 = hasPointer,
						_v26 = input;
					maybeKey = _v19;
					style = _v20;
					attrs = _v21;
					label = _v22;
					errors = _v23;
					isDisabled = _v24;
					hasPointer = _v25;
					input = _v26;
					continue applyLabel;
				case 'HiddenLabel':
					var labeledInput = A2(
						_elm_lang$core$List$map,
						_mdgriffith$style_elements$Element_Internal_Modify$addAttr(
							A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'title', _p36._0)),
						input);
					var _p37 = orientedErrors;
					if (_p37.ctor === 'Nothing') {
						return A2(labelContainer, _mdgriffith$style_elements$Style_Internal_Model$Down, labeledInput);
					} else {
						switch (_p37._0.ctor) {
							case 'ErrorAllAbove':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p37._0._0),
										_1: labeledInput
									});
							case 'ErrorAllBelow':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									A2(
										_elm_lang$core$Basics_ops['++'],
										labeledInput,
										{
											ctor: '::',
											_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p37._0._0),
											_1: {ctor: '[]'}
										}));
							default:
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p37._0._0),
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											labeledInput,
											{
												ctor: '::',
												_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p37._0._1),
												_1: {ctor: '[]'}
											})
									});
						}
					}
				case 'LabelAbove':
					var _p39 = _p36._0;
					var _p38 = orientedErrors;
					if (_p38.ctor === 'Nothing') {
						return A2(
							labelContainer,
							_mdgriffith$style_elements$Style_Internal_Model$Down,
							{ctor: '::', _0: _p39, _1: input});
					} else {
						switch (_p38._0.ctor) {
							case 'ErrorAllAbove':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(
											orient,
											_mdgriffith$style_elements$Style_Internal_Model$GoRight,
											{ctor: '::', _0: _p39, _1: _p38._0._0}),
										_1: input
									});
							case 'ErrorAllBelow':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: _p39,
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											input,
											{
												ctor: '::',
												_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p38._0._0),
												_1: {ctor: '[]'}
											})
									});
							default:
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(
											orient,
											_mdgriffith$style_elements$Style_Internal_Model$GoRight,
											{ctor: '::', _0: _p39, _1: _p38._0._0}),
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											input,
											{
												ctor: '::',
												_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p38._0._1),
												_1: {ctor: '[]'}
											})
									});
						}
					}
				case 'LabelBelow':
					var _p41 = _p36._0;
					var _p40 = orientedErrors;
					if (_p40.ctor === 'Nothing') {
						return A2(
							labelContainer,
							_mdgriffith$style_elements$Style_Internal_Model$Down,
							A2(
								_elm_lang$core$Basics_ops['++'],
								input,
								{
									ctor: '::',
									_0: _p41,
									_1: {ctor: '[]'}
								}));
					} else {
						switch (_p40._0.ctor) {
							case 'ErrorAllAbove':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p40._0._0),
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											input,
											{
												ctor: '::',
												_0: _p41,
												_1: {ctor: '[]'}
											})
									});
							case 'ErrorAllBelow':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									A2(
										_elm_lang$core$Basics_ops['++'],
										input,
										{
											ctor: '::',
											_0: A2(
												orient,
												_mdgriffith$style_elements$Style_Internal_Model$GoRight,
												{ctor: '::', _0: _p41, _1: _p40._0._0}),
											_1: {ctor: '[]'}
										}));
							default:
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(orient, _mdgriffith$style_elements$Style_Internal_Model$GoRight, _p40._0._0),
										_1: A2(
											_elm_lang$core$Basics_ops['++'],
											input,
											{
												ctor: '::',
												_0: A2(
													orient,
													_mdgriffith$style_elements$Style_Internal_Model$GoRight,
													{ctor: '::', _0: _p41, _1: _p40._0._1}),
												_1: {ctor: '[]'}
											})
									});
						}
					}
				case 'LabelOnRight':
					var _p43 = _p36._0;
					var _p42 = orientedErrors;
					if (_p42.ctor === 'Nothing') {
						return A2(
							labelContainer,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							A2(
								_elm_lang$core$Basics_ops['++'],
								input,
								{
									ctor: '::',
									_0: _p43,
									_1: {ctor: '[]'}
								}));
					} else {
						switch (_p42._0.ctor) {
							case 'ErrorAllAbove':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									A2(
										_elm_lang$core$Basics_ops['++'],
										_p42._0._0,
										{
											ctor: '::',
											_0: A2(
												orient,
												_mdgriffith$style_elements$Style_Internal_Model$GoRight,
												A2(
													_elm_lang$core$Basics_ops['++'],
													input,
													{
														ctor: '::',
														_0: _p43,
														_1: {ctor: '[]'}
													})),
											_1: {ctor: '[]'}
										}));
							case 'ErrorAllBelow':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(
											orient,
											_mdgriffith$style_elements$Style_Internal_Model$GoRight,
											A2(
												_elm_lang$core$Basics_ops['++'],
												input,
												{
													ctor: '::',
													_0: _p43,
													_1: {ctor: '[]'}
												})),
										_1: _p42._0._0
									});
							default:
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									A2(
										_elm_lang$core$Basics_ops['++'],
										_p42._0._0,
										A2(
											_elm_lang$core$Basics_ops['++'],
											{
												ctor: '::',
												_0: A2(
													orient,
													_mdgriffith$style_elements$Style_Internal_Model$GoRight,
													A2(
														_elm_lang$core$Basics_ops['++'],
														input,
														{
															ctor: '::',
															_0: _p43,
															_1: {ctor: '[]'}
														})),
												_1: {ctor: '[]'}
											},
											_p42._0._1)));
						}
					}
				default:
					var _p45 = _p36._0;
					var _p44 = orientedErrors;
					if (_p44.ctor === 'Nothing') {
						return A2(
							labelContainer,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '::', _0: _p45, _1: input});
					} else {
						switch (_p44._0.ctor) {
							case 'ErrorAllAbove':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									A2(
										_elm_lang$core$Basics_ops['++'],
										_p44._0._0,
										{
											ctor: '::',
											_0: A2(
												orient,
												_mdgriffith$style_elements$Style_Internal_Model$GoRight,
												{ctor: '::', _0: _p45, _1: input}),
											_1: {ctor: '[]'}
										}));
							case 'ErrorAllBelow':
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									{
										ctor: '::',
										_0: A2(
											orient,
											_mdgriffith$style_elements$Style_Internal_Model$GoRight,
											{ctor: '::', _0: _p45, _1: input}),
										_1: _p44._0._0
									});
							default:
								return A2(
									labelContainer,
									_mdgriffith$style_elements$Style_Internal_Model$Down,
									A2(
										_elm_lang$core$Basics_ops['++'],
										_p44._0._0,
										A2(
											_elm_lang$core$Basics_ops['++'],
											{
												ctor: '::',
												_0: A2(
													orient,
													_mdgriffith$style_elements$Style_Internal_Model$GoRight,
													{ctor: '::', _0: _p45, _1: input}),
												_1: {ctor: '[]'}
											},
											_p44._0._1)));
						}
					}
			}
		}
	});
var _mdgriffith$style_elements$Element_Input$checkbox = F3(
	function (style, attrs, input) {
		var isDisabled = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Element_Input$Disabled),
			input.options);
		var forErrors = function (opt) {
			var _p46 = opt;
			if (_p46.ctor === 'ErrorOpt') {
				return _elm_lang$core$Maybe$Just(_p46._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var errs = A2(_elm_lang$core$List$filterMap, forErrors, input.options);
		var withError = function (attrs) {
			return (!_elm_lang$core$List$isEmpty(errs)) ? {
				ctor: '::',
				_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-invalid', 'true'),
				_1: attrs
			} : attrs;
		};
		var withDisabled = function (attrs) {
			return isDisabled ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$class('disabled-input'),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$disabledAttr(true),
					_1: attrs
				}
			} : {ctor: '::', _0: _mdgriffith$style_elements$Element_Input$pointer, _1: attrs};
		};
		var inputElem = {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Internal_Model$Element(
				{
					node: 'input',
					style: _elm_lang$core$Maybe$Nothing,
					attrs: function (_p47) {
						return A2(
							_mdgriffith$style_elements$Element_Input$addOptionsAsAttrs,
							input.options,
							withError(
								withDisabled(_p47)));
					}(
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$type_('checkbox'),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$checked(input.checked),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onCheck(input.onChange),
									_1: {ctor: '[]'}
								}
							}
						}),
					child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				}),
			_1: {ctor: '[]'}
		};
		return A8(
			_mdgriffith$style_elements$Element_Input$applyLabel,
			_elm_lang$core$Maybe$Nothing,
			_elm_lang$core$Maybe$Nothing,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
				_1: {ctor: '::', _0: _mdgriffith$style_elements$Element_Attributes$verticalCenter, _1: attrs}
			},
			_mdgriffith$style_elements$Element_Input$LabelOnRight(input.label),
			errs,
			isDisabled,
			true,
			inputElem);
	});
var _mdgriffith$style_elements$Element_Input$styledCheckbox = F3(
	function (style, attrs, input) {
		var isDisabled = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Element_Input$Disabled),
			input.options);
		var forErrors = function (opt) {
			var _p48 = opt;
			if (_p48.ctor === 'ErrorOpt') {
				return _elm_lang$core$Maybe$Just(_p48._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var errs = A2(_elm_lang$core$List$filterMap, forErrors, input.options);
		var withError = function (attrs) {
			return (!_elm_lang$core$List$isEmpty(errs)) ? {
				ctor: '::',
				_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-invalid', 'true'),
				_1: attrs
			} : attrs;
		};
		var withDisabled = function (attrs) {
			return isDisabled ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$class('disabled-input'),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$disabledAttr(true),
					_1: attrs
				}
			} : {ctor: '::', _0: _mdgriffith$style_elements$Element_Input$pointer, _1: attrs};
		};
		var inputElem = {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Internal_Model$Element(
				{
					node: 'input',
					style: _elm_lang$core$Maybe$Nothing,
					attrs: function (_p49) {
						return A2(
							_mdgriffith$style_elements$Element_Input$addOptionsAsAttrs,
							input.options,
							withError(
								withDisabled(_p49)));
					}(
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$type_('checkbox'),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$checked(input.checked),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onCheck(input.onChange),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Input$hidden,
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$toAttr(
												_elm_lang$html$Html_Attributes$class('focus-override')),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}),
					child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
					_mdgriffith$style_elements$Element_Attributes$toAttr(
						_elm_lang$html$Html_Attributes$class('alt-icon')),
					input.icon(input.checked)),
				_1: {ctor: '[]'}
			}
		};
		return A8(
			_mdgriffith$style_elements$Element_Input$applyLabel,
			_elm_lang$core$Maybe$Nothing,
			_elm_lang$core$Maybe$Nothing,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
				_1: {ctor: '::', _0: _mdgriffith$style_elements$Element_Attributes$verticalCenter, _1: attrs}
			},
			_mdgriffith$style_elements$Element_Input$LabelOnRight(input.label),
			errs,
			isDisabled,
			true,
			inputElem);
	});
var _mdgriffith$style_elements$Element_Input$textHelper = F5(
	function (kind, addedOptions, style, attrs, input) {
		var kindAsText = function () {
			var _p50 = kind;
			switch (_p50.ctor) {
				case 'Plain':
					return 'text';
				case 'Search':
					return 'search';
				case 'Password':
					return 'password';
				case 'Email':
					return 'email';
				default:
					return 'text';
			}
		}();
		var forErrors = function (opt) {
			var _p51 = opt;
			if (_p51.ctor === 'ErrorOpt') {
				return _elm_lang$core$Maybe$Just(_p51._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var forKey = function (opt) {
			var _p52 = opt;
			if (_p52.ctor === 'Key') {
				return _elm_lang$core$Maybe$Just(_p52._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var withPlaceholder = function (attrs) {
			var _p53 = input.label;
			if (_p53.ctor === 'PlaceHolder') {
				return {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$toAttr(
						_elm_lang$html$Html_Attributes$placeholder(_p53._0)),
					_1: attrs
				};
			} else {
				return attrs;
			}
		};
		var forSpacing = function (attr) {
			var _p54 = attr;
			if (_p54.ctor === 'Spacing') {
				return _elm_lang$core$Maybe$Just(attr);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var spacing = A2(
			_elm_lang$core$Maybe$withDefault,
			A2(_mdgriffith$style_elements$Element_Internal_Model$Spacing, 7, 7),
			_elm_lang$core$List$head(
				_elm_lang$core$List$reverse(
					A2(_elm_lang$core$List$filterMap, forSpacing, attrs))));
		var combineFill = F2(
			function (opt, _p55) {
				var _p56 = _p55;
				var _p61 = _p56._0;
				var _p60 = _p56._1;
				var _p57 = opt;
				if (_p57.ctor === 'AutoFill') {
					var _p59 = _p57._0;
					var _p58 = _p60;
					if (_p58.ctor === 'Nothing') {
						return {
							ctor: '_Tuple2',
							_0: _p61,
							_1: _elm_lang$core$Maybe$Just(
								{
									ctor: '::',
									_0: _p59,
									_1: {ctor: '[]'}
								})
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: _p61,
							_1: _elm_lang$core$Maybe$Just(
								{ctor: '::', _0: _p59, _1: _p58._0})
						};
					}
				} else {
					return {
						ctor: '_Tuple2',
						_0: {ctor: '::', _0: opt, _1: _p61},
						_1: _p60
					};
				}
			});
		var options = function (_p62) {
			var _p63 = _p62;
			var _p65 = _p63._0;
			var _p64 = _p63._1;
			if (_p64.ctor === 'Nothing') {
				return _p65;
			} else {
				return {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$AutoFill(
						A2(_elm_lang$core$String$join, ' ', _p64._0)),
					_1: _p65
				};
			}
		}(
			A3(
				_elm_lang$core$List$foldr,
				combineFill,
				{
					ctor: '_Tuple2',
					_0: {ctor: '[]'},
					_1: _elm_lang$core$Maybe$Nothing
				},
				A2(_elm_lang$core$Basics_ops['++'], addedOptions, input.options)));
		var withDisabled = function (attrs) {
			return A2(
				_elm_lang$core$List$any,
				F2(
					function (x, y) {
						return _elm_lang$core$Native_Utils.eq(x, y);
					})(_mdgriffith$style_elements$Element_Input$Disabled),
				options) ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$class('disabled-input'),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$disabledAttr(true),
					_1: attrs
				}
			} : attrs;
		};
		var withReadonly = function (attrs) {
			return A2(
				_elm_lang$core$List$any,
				F2(
					function (x, y) {
						return _elm_lang$core$Native_Utils.eq(x, y);
					})(_mdgriffith$style_elements$Element_Input$Disabled),
				options) ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$class('disabled-input'),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$readonlyAttr(true),
					_1: attrs
				}
			} : attrs;
		};
		var withSpellCheck = function (attrs) {
			return A2(
				_elm_lang$core$List$any,
				F2(
					function (x, y) {
						return _elm_lang$core$Native_Utils.eq(x, y);
					})(_mdgriffith$style_elements$Element_Input$SpellCheck),
				options) ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Input$spellcheckAttr(true),
				_1: attrs
			} : {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Input$spellcheckAttr(false),
				_1: attrs
			};
		};
		var key = _elm_lang$core$List$head(
			A2(_elm_lang$core$List$filterMap, forKey, options));
		var errors = A2(_elm_lang$core$List$filterMap, forErrors, options);
		var withError = function (attrs) {
			return (!_elm_lang$core$List$isEmpty(errors)) ? {
				ctor: '::',
				_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-invalid', 'true'),
				_1: attrs
			} : attrs;
		};
		var isDisabled = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Element_Input$Disabled),
			options);
		var withAutofocus = function (attrs) {
			return A2(
				_elm_lang$core$List$any,
				F2(
					function (x, y) {
						return _elm_lang$core$Native_Utils.eq(x, y);
					})(_mdgriffith$style_elements$Element_Input$FocusOnLoad),
				options) ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Input$autofocusAttr(true),
				_1: attrs
			} : attrs;
		};
		var inputElem = function () {
			var _p66 = kind;
			if (_p66.ctor === 'TextArea') {
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'textarea',
						style: _elm_lang$core$Maybe$Just(style),
						attrs: function (_p67) {
							return A2(
								_mdgriffith$style_elements$Element_Input$addOptionsAsAttrs,
								options,
								withSpellCheck(
									withError(
										withReadonly(
											withPlaceholder(_p67)))));
						}(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
									_mdgriffith$style_elements$Style_Internal_Model$Fill(1)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'resize', _1: 'none'},
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Events$onInput(input.onChange),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Input$textValueAttr(input.value),
											_1: attrs
										}
									}
								}
							}),
						child: A2(
							_mdgriffith$style_elements$Element_Internal_Model$Text,
							{decoration: _mdgriffith$style_elements$Element_Internal_Model$RawText, inline: false},
							''),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
			} else {
				return _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'input',
						style: _elm_lang$core$Maybe$Just(style),
						attrs: function (_p68) {
							return A2(
								_mdgriffith$style_elements$Element_Input$addOptionsAsAttrs,
								options,
								withError(
									withDisabled(
										withPlaceholder(_p68))));
						}(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Internal_Model$Width(
									_mdgriffith$style_elements$Style_Internal_Model$Fill(1)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Input$type_(kindAsText),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Events$onInput(input.onChange),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Input$textValueAttr(input.value),
											_1: attrs
										}
									}
								}
							}),
						child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
			}
		}();
		return A8(
			_mdgriffith$style_elements$Element_Input$applyLabel,
			key,
			_elm_lang$core$Maybe$Nothing,
			{
				ctor: '::',
				_0: spacing,
				_1: {ctor: '[]'}
			},
			input.label,
			errors,
			isDisabled,
			false,
			{
				ctor: '::',
				_0: inputElem,
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Element_Input$text = A2(
	_mdgriffith$style_elements$Element_Input$textHelper,
	_mdgriffith$style_elements$Element_Input$Plain,
	{ctor: '[]'});
var _mdgriffith$style_elements$Element_Input$search = A2(
	_mdgriffith$style_elements$Element_Input$textHelper,
	_mdgriffith$style_elements$Element_Input$Search,
	{ctor: '[]'});
var _mdgriffith$style_elements$Element_Input$newPassword = A2(
	_mdgriffith$style_elements$Element_Input$textHelper,
	_mdgriffith$style_elements$Element_Input$Password,
	{
		ctor: '::',
		_0: _mdgriffith$style_elements$Element_Input$AutoFill('new-password'),
		_1: {ctor: '[]'}
	});
var _mdgriffith$style_elements$Element_Input$currentPassword = A2(
	_mdgriffith$style_elements$Element_Input$textHelper,
	_mdgriffith$style_elements$Element_Input$Password,
	{
		ctor: '::',
		_0: _mdgriffith$style_elements$Element_Input$AutoFill('current-password'),
		_1: {ctor: '[]'}
	});
var _mdgriffith$style_elements$Element_Input$username = A2(
	_mdgriffith$style_elements$Element_Input$textHelper,
	_mdgriffith$style_elements$Element_Input$Plain,
	{
		ctor: '::',
		_0: _mdgriffith$style_elements$Element_Input$AutoFill('username'),
		_1: {ctor: '[]'}
	});
var _mdgriffith$style_elements$Element_Input$email = A2(
	_mdgriffith$style_elements$Element_Input$textHelper,
	_mdgriffith$style_elements$Element_Input$Email,
	{
		ctor: '::',
		_0: _mdgriffith$style_elements$Element_Input$AutoFill('email'),
		_1: {ctor: '[]'}
	});
var _mdgriffith$style_elements$Element_Input$multiline = A2(
	_mdgriffith$style_elements$Element_Input$textHelper,
	_mdgriffith$style_elements$Element_Input$TextArea,
	{ctor: '[]'});
var _mdgriffith$style_elements$Element_Input$ChoiceWith = F2(
	function (a, b) {
		return {ctor: 'ChoiceWith', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Element_Input$styledChoice = F2(
	function (value, selected) {
		var choose = function (state) {
			var _p69 = state;
			switch (_p69.ctor) {
				case 'Focused':
					return selected(false);
				case 'Selected':
					return selected(true);
				case 'SelectedInBox':
					return selected(true);
				default:
					return selected(false);
			}
		};
		return A2(_mdgriffith$style_elements$Element_Input$ChoiceWith, value, choose);
	});
var _mdgriffith$style_elements$Element_Input$styledSelectChoice = _mdgriffith$style_elements$Element_Input$ChoiceWith;
var _mdgriffith$style_elements$Element_Input$Choice = F2(
	function (a, b) {
		return {ctor: 'Choice', _0: a, _1: b};
	});
var _mdgriffith$style_elements$Element_Input$choice = _mdgriffith$style_elements$Element_Input$Choice;
var _mdgriffith$style_elements$Element_Input$SelectedInBox = {ctor: 'SelectedInBox'};
var _mdgriffith$style_elements$Element_Input$Selected = {ctor: 'Selected'};
var _mdgriffith$style_elements$Element_Input$Focused = {ctor: 'Focused'};
var _mdgriffith$style_elements$Element_Input$Idle = {ctor: 'Idle'};
var _mdgriffith$style_elements$Element_Input$radioHelper = F4(
	function (orientation, style, attrs, config) {
		var isSelected = function (val) {
			var _p70 = config.selection;
			if (_p70.ctor === 'Single') {
				var _p72 = _p70._0;
				var isSelected = _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(val),
					_p72.selected);
				return isSelected ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$checked(true),
					_1: {ctor: '[]'}
				} : {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$checked(false),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onCheck(
							function (_p71) {
								return _p72.onChange(val);
							}),
						_1: {ctor: '[]'}
					}
				};
			} else {
				var _p75 = _p70._0;
				var isSelected = A2(_elm_lang$core$List$member, val, _p75.selected);
				return {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$checked(isSelected),
					_1: {
						ctor: '::',
						_0: isSelected ? _mdgriffith$style_elements$Element_Events$onCheck(
							function (_p73) {
								return _p75.onChange(
									A2(
										_elm_lang$core$List$filter,
										function (item) {
											return !_elm_lang$core$Native_Utils.eq(item, val);
										},
										_p75.selected));
							}) : _mdgriffith$style_elements$Element_Events$onCheck(
							function (_p74) {
								return _p75.onChange(
									{ctor: '::', _0: val, _1: _p75.selected});
							}),
						_1: {ctor: '[]'}
					}
				};
			}
		};
		var withDisabled = function (attrs) {
			return config.disabled ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Input$disabledAttr(true),
				_1: attrs
			} : {ctor: '::', _0: _mdgriffith$style_elements$Element_Input$pointer, _1: attrs};
		};
		var addSelection = F2(
			function (val, attrs) {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					attrs,
					isSelected(val));
			});
		var valueIsSelected = function (val) {
			var _p76 = config.selection;
			if (_p76.ctor === 'Single') {
				return _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(val),
					_p76._0.selected);
			} else {
				return A2(_elm_lang$core$List$member, val, _p76._0.selected);
			}
		};
		var group = function () {
			var _p77 = config.key;
			if (_p77.ctor === 'Nothing') {
				return _mdgriffith$style_elements$Element_Input$getLabelText(config.label);
			} else {
				return _p77._0;
			}
		}();
		var renderOption = function (option) {
			var _p78 = option;
			if (_p78.ctor === 'Choice') {
				var _p81 = _p78._1;
				var literalLabel = _mdgriffith$style_elements$Element_Internal_Modify$removeStyle(
					_mdgriffith$style_elements$Element_Internal_Modify$removeAllAttrs(
						_mdgriffith$style_elements$Element_Internal_Modify$getChild(_p81)));
				var textValue = function () {
					var _p79 = config.key;
					if (_p79.ctor === 'Nothing') {
						return _mdgriffith$style_elements$Element_Internal_Modify$getText(_p81);
					} else {
						return A2(
							_elm_lang$core$Basics_ops['++'],
							_p79._0,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'-',
								_mdgriffith$style_elements$Element_Internal_Modify$getText(_p81)));
					}
				}();
				var input = _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'input',
						style: _elm_lang$core$Maybe$Nothing,
						attrs: function (_p80) {
							return withDisabled(
								A2(addSelection, _p78._0, _p80));
						}(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$type_('radio'),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Input$name(group),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Input$valueAttr(textValue),
										_1: {ctor: '[]'}
									}
								}
							}),
						child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: 'label',
						style: _mdgriffith$style_elements$Element_Internal_Modify$getStyle(_p81),
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '[]'}),
						attrs: config.disabled ? {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
							_1: _mdgriffith$style_elements$Element_Internal_Modify$getAttrs(_p81)
						} : {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$pointer,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
								_1: _mdgriffith$style_elements$Element_Internal_Modify$getAttrs(_p81)
							}
						},
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							{
								ctor: '::',
								_0: input,
								_1: {
									ctor: '::',
									_0: literalLabel,
									_1: {ctor: '[]'}
								}
							}),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
			} else {
				var _p85 = _p78._1;
				var _p84 = _p78._0;
				var textValue = function () {
					var _p82 = config.key;
					if (_p82.ctor === 'Nothing') {
						return _mdgriffith$style_elements$Element_Internal_Modify$getText(
							_p85(_mdgriffith$style_elements$Element_Input$Selected));
					} else {
						return A2(
							_elm_lang$core$Basics_ops['++'],
							_p82._0,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'-',
								_mdgriffith$style_elements$Element_Internal_Modify$getText(
									_p85(_mdgriffith$style_elements$Element_Input$Selected))));
					}
				}();
				var hiddenInput = _mdgriffith$style_elements$Element_Internal_Model$Element(
					{
						node: 'input',
						style: _elm_lang$core$Maybe$Nothing,
						attrs: function (_p83) {
							return withDisabled(
								A2(addSelection, _p84, _p83));
						}(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$type_('radio'),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Input$hidden,
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Input$name(group),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Input$valueAttr(textValue),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$toAttr(
													_elm_lang$html$Html_Attributes$class('focus-override')),
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}),
						child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
				var viewed = _p85(
					valueIsSelected(_p84) ? _mdgriffith$style_elements$Element_Input$Selected : _mdgriffith$style_elements$Element_Input$Idle);
				return _mdgriffith$style_elements$Element_Internal_Model$Layout(
					{
						node: 'label',
						style: _mdgriffith$style_elements$Element_Internal_Modify$getStyle(viewed),
						layout: A2(
							_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
							_mdgriffith$style_elements$Style_Internal_Model$GoRight,
							{ctor: '[]'}),
						attrs: config.disabled ? {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
							_1: _mdgriffith$style_elements$Element_Internal_Modify$getAttrs(viewed)
						} : {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$pointer,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
								_1: _mdgriffith$style_elements$Element_Internal_Modify$getAttrs(viewed)
							}
						},
						children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
							{
								ctor: '::',
								_0: hiddenInput,
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Internal_Modify$removeStyle(
										A2(
											_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
											_mdgriffith$style_elements$Element_Attributes$toAttr(
												_elm_lang$html$Html_Attributes$class('alt-icon')),
											_mdgriffith$style_elements$Element_Internal_Modify$removeAllAttrs(viewed))),
									_1: {ctor: '[]'}
								}
							}),
						absolutelyPositioned: _elm_lang$core$Maybe$Nothing
					});
			}
		};
		var _p86 = orientation;
		if (_p86.ctor === 'Horizontal') {
			return A3(
				_mdgriffith$style_elements$Element$row,
				style,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
					_1: attrs
				},
				A2(_elm_lang$core$List$map, renderOption, config.choices));
		} else {
			return A3(
				_mdgriffith$style_elements$Element$column,
				style,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
					_1: attrs
				},
				A2(_elm_lang$core$List$map, renderOption, config.choices));
		}
	});
var _mdgriffith$style_elements$Element_Input$Multi = function (a) {
	return {ctor: 'Multi', _0: a};
};
var _mdgriffith$style_elements$Element_Input$Single = function (a) {
	return {ctor: 'Single', _0: a};
};
var _mdgriffith$style_elements$Element_Input$Vertical = {ctor: 'Vertical'};
var _mdgriffith$style_elements$Element_Input$radio = F3(
	function (style, attrs, input) {
		var forKeys = function (opt) {
			var _p87 = opt;
			if (_p87.ctor === 'Key') {
				return _elm_lang$core$Maybe$Just(_p87._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var key = A2(
			_elm_lang$core$String$join,
			'-',
			A2(_elm_lang$core$List$filterMap, forKeys, input.options));
		var isDisabled = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Element_Input$Disabled),
			input.options);
		var forErrors = function (opt) {
			var _p88 = opt;
			if (_p88.ctor === 'ErrorOpt') {
				return _elm_lang$core$Maybe$Just(_p88._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var errs = A2(_elm_lang$core$List$filterMap, forErrors, input.options);
		var inputElem = A4(
			_mdgriffith$style_elements$Element_Input$radioHelper,
			_mdgriffith$style_elements$Element_Input$Vertical,
			style,
			attrs,
			{
				selection: _mdgriffith$style_elements$Element_Input$Single(
					{selected: input.selected, onChange: input.onChange}),
				choices: input.choices,
				label: input.label,
				disabled: isDisabled,
				errors: errs,
				key: _elm_lang$core$Native_Utils.eq(key, '') ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(key)
			});
		return A8(
			_mdgriffith$style_elements$Element_Input$applyLabel,
			_elm_lang$core$Maybe$Nothing,
			_elm_lang$core$Maybe$Nothing,
			{ctor: '[]'},
			input.label,
			errs,
			isDisabled,
			!isDisabled,
			{
				ctor: '::',
				_0: inputElem,
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Element_Input$Horizontal = {ctor: 'Horizontal'};
var _mdgriffith$style_elements$Element_Input$radioRow = F3(
	function (style, attrs, config) {
		var forKeys = function (opt) {
			var _p89 = opt;
			if (_p89.ctor === 'Key') {
				return _elm_lang$core$Maybe$Just(_p89._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var key = A2(
			_elm_lang$core$String$join,
			'-',
			A2(_elm_lang$core$List$filterMap, forKeys, config.options));
		var isDisabled = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Element_Input$Disabled),
			config.options);
		var forErrors = function (opt) {
			var _p90 = opt;
			if (_p90.ctor === 'ErrorOpt') {
				return _elm_lang$core$Maybe$Just(_p90._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var errs = A2(_elm_lang$core$List$filterMap, forErrors, config.options);
		var input = A4(
			_mdgriffith$style_elements$Element_Input$radioHelper,
			_mdgriffith$style_elements$Element_Input$Horizontal,
			style,
			attrs,
			{
				selection: _mdgriffith$style_elements$Element_Input$Single(
					{selected: config.selected, onChange: config.onChange}),
				choices: config.choices,
				label: config.label,
				disabled: isDisabled,
				errors: errs,
				key: _elm_lang$core$Native_Utils.eq(key, '') ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(key)
			});
		return A8(
			_mdgriffith$style_elements$Element_Input$applyLabel,
			_elm_lang$core$Maybe$Nothing,
			_elm_lang$core$Maybe$Nothing,
			{ctor: '[]'},
			config.label,
			errs,
			isDisabled,
			!isDisabled,
			{
				ctor: '::',
				_0: input,
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Element_Input$MenuDown = F3(
	function (a, b, c) {
		return {ctor: 'MenuDown', _0: a, _1: b, _2: c};
	});
var _mdgriffith$style_elements$Element_Input$menu = _mdgriffith$style_elements$Element_Input$MenuDown;
var _mdgriffith$style_elements$Element_Input$MenuUp = F3(
	function (a, b, c) {
		return {ctor: 'MenuUp', _0: a, _1: b, _2: c};
	});
var _mdgriffith$style_elements$Element_Input$menuAbove = _mdgriffith$style_elements$Element_Input$MenuUp;
var _mdgriffith$style_elements$Element_Input$SelectMenu = function (a) {
	return {ctor: 'SelectMenu', _0: a};
};
var _mdgriffith$style_elements$Element_Input$dropMenu = F2(
	function (selected, onUpdate) {
		return _mdgriffith$style_elements$Element_Input$SelectMenu(
			{selected: selected, onUpdate: onUpdate, isOpen: false});
	});
var _mdgriffith$style_elements$Element_Input$Autocomplete = function (a) {
	return {ctor: 'Autocomplete', _0: a};
};
var _mdgriffith$style_elements$Element_Input$autocomplete = F2(
	function (selected, onUpdate) {
		return _mdgriffith$style_elements$Element_Input$Autocomplete(
			{query: '', selected: selected, focus: selected, onUpdate: onUpdate, isOpen: false});
	});
var _mdgriffith$style_elements$Element_Input$clear = function (select) {
	var _p91 = select;
	if (_p91.ctor === 'Autocomplete') {
		return _mdgriffith$style_elements$Element_Input$Autocomplete(
			{query: '', selected: _elm_lang$core$Maybe$Nothing, focus: _elm_lang$core$Maybe$Nothing, onUpdate: _p91._0.onUpdate, isOpen: false});
	} else {
		return _mdgriffith$style_elements$Element_Input$SelectMenu(
			{selected: _elm_lang$core$Maybe$Nothing, onUpdate: _p91._0.onUpdate, isOpen: false});
	}
};
var _mdgriffith$style_elements$Element_Input$updateSelection = F2(
	function (msg, select) {
		var _p92 = msg;
		switch (_p92.ctor) {
			case 'OpenMenu':
				var _p93 = select;
				if (_p93.ctor === 'Autocomplete') {
					return _mdgriffith$style_elements$Element_Input$Autocomplete(
						_elm_lang$core$Native_Utils.update(
							_p93._0,
							{isOpen: true}));
				} else {
					return _mdgriffith$style_elements$Element_Input$SelectMenu(
						_elm_lang$core$Native_Utils.update(
							_p93._0,
							{isOpen: true}));
				}
			case 'CloseMenu':
				var _p94 = select;
				if (_p94.ctor === 'Autocomplete') {
					return _mdgriffith$style_elements$Element_Input$Autocomplete(
						_elm_lang$core$Native_Utils.update(
							_p94._0,
							{isOpen: false}));
				} else {
					return _mdgriffith$style_elements$Element_Input$SelectMenu(
						_elm_lang$core$Native_Utils.update(
							_p94._0,
							{isOpen: false}));
				}
			case 'SetQuery':
				var _p97 = _p92._0;
				var _p95 = select;
				if (_p95.ctor === 'Autocomplete') {
					var _p96 = _p95._0;
					return _mdgriffith$style_elements$Element_Input$Autocomplete(
						_elm_lang$core$Native_Utils.update(
							_p96,
							{
								query: _p97,
								isOpen: true,
								selected: _elm_lang$core$Native_Utils.eq(_p97, '') ? _p96.selected : _elm_lang$core$Maybe$Nothing
							}));
				} else {
					return _mdgriffith$style_elements$Element_Input$SelectMenu(_p95._0);
				}
			case 'SetFocus':
				var _p98 = select;
				if (_p98.ctor === 'Autocomplete') {
					return _mdgriffith$style_elements$Element_Input$Autocomplete(
						_elm_lang$core$Native_Utils.update(
							_p98._0,
							{focus: _p92._0}));
				} else {
					return _mdgriffith$style_elements$Element_Input$SelectMenu(_p98._0);
				}
			case 'SelectValue':
				var _p100 = _p92._0;
				var _p99 = select;
				if (_p99.ctor === 'Autocomplete') {
					return _mdgriffith$style_elements$Element_Input$Autocomplete(
						_elm_lang$core$Native_Utils.update(
							_p99._0,
							{selected: _p100, query: ''}));
				} else {
					return _mdgriffith$style_elements$Element_Input$SelectMenu(
						_elm_lang$core$Native_Utils.update(
							_p99._0,
							{selected: _p100}));
				}
			case 'SelectFocused':
				var _p101 = select;
				if (_p101.ctor === 'Autocomplete') {
					var _p102 = _p101._0;
					return _mdgriffith$style_elements$Element_Input$Autocomplete(
						_elm_lang$core$Native_Utils.update(
							_p102,
							{selected: _p102.focus, query: ''}));
				} else {
					return _mdgriffith$style_elements$Element_Input$SelectMenu(_p101._0);
				}
			case 'Clear':
				var _p103 = select;
				if (_p103.ctor === 'Autocomplete') {
					return _mdgriffith$style_elements$Element_Input$Autocomplete(
						_elm_lang$core$Native_Utils.update(
							_p103._0,
							{query: '', isOpen: true, selected: _elm_lang$core$Maybe$Nothing, focus: _elm_lang$core$Maybe$Nothing}));
				} else {
					return _mdgriffith$style_elements$Element_Input$SelectMenu(
						_elm_lang$core$Native_Utils.update(
							_p103._0,
							{selected: _elm_lang$core$Maybe$Nothing}));
				}
			default:
				return A3(_elm_lang$core$List$foldl, _mdgriffith$style_elements$Element_Input$updateSelection, select, _p92._0);
		}
	});
var _mdgriffith$style_elements$Element_Input$Batch = function (a) {
	return {ctor: 'Batch', _0: a};
};
var _mdgriffith$style_elements$Element_Input$Clear = {ctor: 'Clear'};
var _mdgriffith$style_elements$Element_Input$SelectFocused = {ctor: 'SelectFocused'};
var _mdgriffith$style_elements$Element_Input$SelectValue = function (a) {
	return {ctor: 'SelectValue', _0: a};
};
var _mdgriffith$style_elements$Element_Input$SetFocus = function (a) {
	return {ctor: 'SetFocus', _0: a};
};
var _mdgriffith$style_elements$Element_Input$SetQuery = function (a) {
	return {ctor: 'SetQuery', _0: a};
};
var _mdgriffith$style_elements$Element_Input$CloseMenu = {ctor: 'CloseMenu'};
var _mdgriffith$style_elements$Element_Input$OpenMenu = {ctor: 'OpenMenu'};
var _mdgriffith$style_elements$Element_Input$selectMenu = F3(
	function (style, attrs, input) {
		var isDisabled = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Element_Input$Disabled),
			input.options);
		var forErrors = function (opt) {
			var _p104 = opt;
			if (_p104.ctor === 'ErrorOpt') {
				return _elm_lang$core$Maybe$Just(_p104._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var errors = A2(_elm_lang$core$List$filterMap, forErrors, input.options);
		var forSpacing = function (attr) {
			var _p105 = attr;
			if (_p105.ctor === 'Spacing') {
				return true;
			} else {
				return false;
			}
		};
		var _p106 = A2(_elm_lang$core$List$partition, forSpacing, attrs);
		var attrsWithSpacing = _p106._0;
		var attrsWithoutSpacing = _p106._1;
		var forPadding = function (attr) {
			var _p107 = attr;
			if (_p107.ctor === 'Padding') {
				return true;
			} else {
				return false;
			}
		};
		var parentPadding = A2(_elm_lang$core$List$filter, forPadding, attrs);
		var renderOption = function (option) {
			var _p108 = option;
			if (_p108.ctor === 'Choice') {
				var _p109 = _p108._0;
				var isSelected = _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p109),
					input.selected) ? A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'true'),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
								{
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgba(0,0,0,0.03)'},
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					},
					parentPadding) : A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'false'),
						_1: {ctor: '[]'}
					},
					parentPadding);
				var additional = isDisabled ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
						_1: isSelected
					}
				} : {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onClick(
						input.onUpdate(
							_mdgriffith$style_elements$Element_Input$Batch(
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Input$CloseMenu,
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Input$SelectValue(
											_elm_lang$core$Maybe$Just(_p109)),
										_1: {ctor: '[]'}
									}
								}))),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
						_1: {
							ctor: '::',
							_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
							_1: isSelected
						}
					}
				};
				return A2(_mdgriffith$style_elements$Element_Internal_Modify$addAttrList, additional, _p108._1);
			} else {
				var _p110 = _p108._0;
				var viewState = _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p110),
					input.selected) ? _mdgriffith$style_elements$Element_Input$Selected : _mdgriffith$style_elements$Element_Input$Idle;
				var isSelected = _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p110),
					input.selected) ? {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'true'),
					_1: parentPadding
				} : {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'false'),
					_1: parentPadding
				};
				var additional = isDisabled ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
						_1: isSelected
					}
				} : {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onClick(
						input.onUpdate(
							_mdgriffith$style_elements$Element_Input$Batch(
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Input$CloseMenu,
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Input$SelectValue(
											_elm_lang$core$Maybe$Just(_p110)),
										_1: {ctor: '[]'}
									}
								}))),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
						_1: {
							ctor: '::',
							_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
							_1: isSelected
						}
					}
				};
				return A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addAttrList,
					additional,
					_p108._1(viewState));
			}
		};
		var getSelectedLabel = F2(
			function (selected, option) {
				if (_elm_lang$core$Native_Utils.eq(
					_mdgriffith$style_elements$Element_Input$getOptionValue(option),
					selected)) {
					var _p111 = option;
					if (_p111.ctor === 'Choice') {
						return _elm_lang$core$Maybe$Just(_p111._1);
					} else {
						return _elm_lang$core$Maybe$Just(
							_p111._1(_mdgriffith$style_elements$Element_Input$SelectedInBox));
					}
				} else {
					return _elm_lang$core$Maybe$Nothing;
				}
			});
		var placeholderText = function () {
			var _p112 = input.label;
			if (_p112.ctor === 'PlaceHolder') {
				return _mdgriffith$style_elements$Element$text(_p112._0);
			} else {
				return _mdgriffith$style_elements$Element$text(' - ');
			}
		}();
		var _p113 = function () {
			var _p114 = input.menu;
			if (_p114.ctor === 'MenuUp') {
				return {ctor: '_Tuple4', _0: true, _1: _p114._0, _2: _p114._1, _3: _p114._2};
			} else {
				return {ctor: '_Tuple4', _0: false, _1: _p114._0, _2: _p114._1, _3: _p114._2};
			}
		}();
		var menuAbove = _p113._0;
		var menuStyle = _p113._1;
		var menuAttrs = _p113._2;
		var choices = _p113._3;
		var selectedText = function () {
			var _p115 = input.selected;
			if (_p115.ctor === 'Nothing') {
				return placeholderText;
			} else {
				return A2(
					_elm_lang$core$Maybe$withDefault,
					placeholderText,
					_elm_lang$core$List$head(
						A2(
							_elm_lang$core$List$filterMap,
							getSelectedLabel(_p115._0),
							choices)));
			}
		}();
		var bar = _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$GoRight,
					{ctor: '[]'}),
				attrs: isDisabled ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$spread,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: attrsWithoutSpacing
						}
					}
				} : ((input.isOpen && (!_elm_lang$core$Native_Utils.eq(input.selected, _elm_lang$core$Maybe$Nothing))) ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onMouseDown(
						input.onUpdate(_mdgriffith$style_elements$Element_Input$CloseMenu)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Input$pointer,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spread,
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: attrsWithoutSpacing
								}
							}
						}
					}
				} : (((!input.isOpen) && (!_elm_lang$core$Native_Utils.eq(input.selected, _elm_lang$core$Maybe$Nothing))) ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onMouseDown(
						input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Input$pointer,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spread,
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: attrsWithoutSpacing
								}
							}
						}
					}
				} : {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$pointer,
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spread,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: attrsWithoutSpacing
							}
						}
					}
				})),
				children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
					{
						ctor: '::',
						_0: selectedText,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$arrows,
							_1: {ctor: '[]'}
						}
					}),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
		var cursor = A3(
			_elm_lang$core$List$foldl,
			F2(
				function (option, cache) {
					var last = _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Element_Input$getOptionValue(option));
					var first = function () {
						var _p116 = cache.first;
						if (_p116.ctor === 'Nothing') {
							return _elm_lang$core$Maybe$Just(
								_mdgriffith$style_elements$Element_Input$getOptionValue(option));
						} else {
							return cache.first;
						}
					}();
					var currentIsSelected = function () {
						var _p117 = cache.selected;
						if (_p117.ctor === 'Nothing') {
							return false;
						} else {
							return _elm_lang$core$Native_Utils.eq(
								_mdgriffith$style_elements$Element_Input$getOptionValue(option),
								_p117._0);
						}
					}();
					var found = (!cache.found) ? currentIsSelected : cache.found;
					var prev = (currentIsSelected && _elm_lang$core$Native_Utils.eq(cache.prev, _elm_lang$core$Maybe$Nothing)) ? cache.last : cache.prev;
					var next = (cache.found && _elm_lang$core$Native_Utils.eq(cache.next, _elm_lang$core$Maybe$Nothing)) ? _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Element_Input$getOptionValue(option)) : cache.next;
					return _elm_lang$core$Native_Utils.update(
						cache,
						{next: next, found: found, prev: prev, first: first, last: last});
				}),
			{selected: input.selected, found: false, prev: _elm_lang$core$Maybe$Nothing, next: _elm_lang$core$Maybe$Nothing, first: _elm_lang$core$Maybe$Nothing, last: _elm_lang$core$Maybe$Nothing},
			choices);
		var _p118 = _elm_lang$core$Native_Utils.eq(cursor.found, false) ? {next: cursor.first, prev: cursor.first} : ((_elm_lang$core$Native_Utils.eq(cursor.next, _elm_lang$core$Maybe$Nothing) && (!_elm_lang$core$Native_Utils.eq(cursor.prev, _elm_lang$core$Maybe$Nothing))) ? {next: cursor.first, prev: cursor.prev} : ((_elm_lang$core$Native_Utils.eq(cursor.prev, _elm_lang$core$Maybe$Nothing) && (!_elm_lang$core$Native_Utils.eq(cursor.next, _elm_lang$core$Maybe$Nothing))) ? {next: cursor.next, prev: cursor.last} : {next: cursor.next, prev: cursor.prev}));
		var next = _p118.next;
		var prev = _p118.prev;
		var fullElement = A2(
			menuAbove ? _mdgriffith$style_elements$Element$above : _mdgriffith$style_elements$Element$below,
			(input.isOpen && (!isDisabled)) ? {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$column,
					menuStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'z-index', _1: '20'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
									_1: {ctor: '[]'}
								}
							}),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$pointer,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: menuAttrs
							}
						}
					},
					A2(_elm_lang$core$List$map, renderOption, choices)),
				_1: {ctor: '[]'}
			} : {ctor: '[]'},
			_mdgriffith$style_elements$Element_Internal_Model$Element(
				{
					node: 'div',
					style: _elm_lang$core$Maybe$Nothing,
					attrs: A2(
						_elm_lang$core$List$filterMap,
						_elm_lang$core$Basics$identity,
						{
							ctor: '::',
							_0: _elm_lang$core$Maybe$Just(
								_mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill)),
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Maybe$Just(
									A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menu')),
								_1: {
									ctor: '::',
									_0: (!isDisabled) ? _elm_lang$core$Maybe$Just(
										_mdgriffith$style_elements$Element_Input$tabindex(0)) : _elm_lang$core$Maybe$Nothing,
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Maybe$Just(
											_mdgriffith$style_elements$Element_Attributes$inlineStyle(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'z-index', _1: '20'},
													_1: {ctor: '[]'}
												})),
										_1: {
											ctor: '::',
											_0: isDisabled ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
												_mdgriffith$style_elements$Element_Attributes$toAttr(
													_mdgriffith$style_elements$Element_Input$onFocusOut(
														input.onUpdate(_mdgriffith$style_elements$Element_Input$CloseMenu)))),
											_1: {
												ctor: '::',
												_0: isDisabled ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
													_mdgriffith$style_elements$Element_Attributes$toAttr(
														_mdgriffith$style_elements$Element_Input$onFocusIn(
															input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu)))),
												_1: {
													ctor: '::',
													_0: isDisabled ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
														_mdgriffith$style_elements$Element_Input$onKeyLookup(
															function (key) {
																return _elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$enter) ? _elm_lang$core$Maybe$Just(
																	input.onUpdate(
																		input.isOpen ? _mdgriffith$style_elements$Element_Input$CloseMenu : _mdgriffith$style_elements$Element_Input$OpenMenu)) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$downArrow) && (!input.isOpen)) ? _elm_lang$core$Maybe$Just(
																	input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu)) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$downArrow) && input.isOpen) ? A2(
																	_elm_lang$core$Maybe$map,
																	function (x) {
																		return input.onUpdate(
																			_mdgriffith$style_elements$Element_Input$SelectValue(
																				_elm_lang$core$Maybe$Just(x)));
																	},
																	next) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$upArrow) && (!input.isOpen)) ? _elm_lang$core$Maybe$Just(
																	input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu)) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$upArrow) && input.isOpen) ? A2(
																	_elm_lang$core$Maybe$map,
																	function (x) {
																		return input.onUpdate(
																			_mdgriffith$style_elements$Element_Input$SelectValue(
																				_elm_lang$core$Maybe$Just(x)));
																	},
																	prev) : _elm_lang$core$Maybe$Nothing))));
															})),
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							}
						}),
					child: bar,
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				}));
		return A8(
			_mdgriffith$style_elements$Element_Input$applyLabel,
			_elm_lang$core$Maybe$Nothing,
			_elm_lang$core$Maybe$Nothing,
			attrsWithSpacing,
			input.label,
			errors,
			isDisabled,
			!isDisabled,
			{
				ctor: '::',
				_0: fullElement,
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Element_Input$searchSelect = F3(
	function (style, attrs, input) {
		var choiceText = function (choice) {
			var _p119 = choice;
			if (_p119.ctor === 'Choice') {
				return _mdgriffith$style_elements$Element_Internal_Modify$getTextList(_p119._1);
			} else {
				return _mdgriffith$style_elements$Element_Internal_Modify$getTextList(
					_p119._1(_mdgriffith$style_elements$Element_Input$Idle));
			}
		};
		var matchesQuery = F2(
			function (query, opt) {
				return _elm_lang$core$Native_Utils.eq(query, '') ? true : A2(
					_elm_lang$core$List$any,
					function (str) {
						return A2(
							_elm_lang$core$String$startsWith,
							function (_p120) {
								return _elm_lang$core$String$toLower(
									_elm_lang$core$String$trimLeft(_p120));
							}(query),
							_elm_lang$core$String$toLower(
								_elm_lang$core$String$trimLeft(str)));
					},
					choiceText(opt));
			});
		var forSpacing = function (attr) {
			var _p121 = attr;
			if (_p121.ctor === 'Spacing') {
				return _elm_lang$core$Maybe$Just(
					{ctor: '_Tuple2', _0: _p121._0, _1: _p121._1});
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var _p122 = A2(
			_elm_lang$core$Maybe$withDefault,
			{ctor: '_Tuple2', _0: 0, _1: 0},
			_elm_lang$core$List$head(
				A2(_elm_lang$core$List$filterMap, forSpacing, attrs)));
		var xSpacing = _p122._0;
		var ySpacing = _p122._1;
		var forPadding = function (attr) {
			var _p123 = attr;
			if (_p123.ctor === 'Padding') {
				return _elm_lang$core$Maybe$Just(
					{ctor: '_Tuple4', _0: _p123._0, _1: _p123._1, _2: _p123._2, _3: _p123._3});
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var _p124 = A2(
			_elm_lang$core$Maybe$withDefault,
			{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0},
			A2(
				_elm_lang$core$Maybe$map,
				A2(
					_elm_lang$core$Basics$flip,
					_mdgriffith$style_elements$Element_Input$defaultPadding,
					{ctor: '_Tuple4', _0: 0, _1: 0, _2: 0, _3: 0}),
				_elm_lang$core$List$head(
					A2(_elm_lang$core$List$filterMap, forPadding, attrs))));
		var ppTop = _p124._0;
		var ppRight = _p124._1;
		var ppBottom = _p124._2;
		var ppLeft = _p124._3;
		var parentPadding = A4(
			_mdgriffith$style_elements$Element_Internal_Model$Padding,
			_elm_lang$core$Maybe$Just(ppTop),
			_elm_lang$core$Maybe$Just(ppRight),
			_elm_lang$core$Maybe$Just(ppBottom),
			_elm_lang$core$Maybe$Just(ppLeft));
		var onlySpacing = function (attr) {
			var _p125 = attr;
			if (_p125.ctor === 'Spacing') {
				return true;
			} else {
				return false;
			}
		};
		var _p126 = A2(_elm_lang$core$List$partition, onlySpacing, attrs);
		var attrsWithSpacing = _p126._0;
		var attrsWithoutSpacing = _p126._1;
		var placeholderText = function () {
			var _p127 = input.selected;
			if (_p127.ctor === 'Nothing') {
				var _p128 = input.label;
				if (_p128.ctor === 'PlaceHolder') {
					return _p128._0;
				} else {
					return 'Search...';
				}
			} else {
				return '';
			}
		}();
		var _p129 = function () {
			var _p130 = input.menu;
			if (_p130.ctor === 'MenuUp') {
				return {ctor: '_Tuple4', _0: true, _1: _p130._0, _2: _p130._1, _3: _p130._2};
			} else {
				return {ctor: '_Tuple4', _0: false, _1: _p130._0, _2: _p130._1, _3: _p130._2};
			}
		}();
		var menuAbove = _p129._0;
		var menuStyle = _p129._1;
		var menuAttrs = _p129._2;
		var choices = _p129._3;
		var cursor = A3(
			_elm_lang$core$List$foldl,
			F2(
				function (option, cache) {
					var last = _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Element_Input$getOptionValue(option));
					var first = function () {
						var _p131 = cache.first;
						if (_p131.ctor === 'Nothing') {
							return _elm_lang$core$Maybe$Just(
								_mdgriffith$style_elements$Element_Input$getOptionValue(option));
						} else {
							return cache.first;
						}
					}();
					var currentIsSelected = function () {
						var _p132 = cache.selected;
						if (_p132.ctor === 'Nothing') {
							return false;
						} else {
							return _elm_lang$core$Native_Utils.eq(
								_mdgriffith$style_elements$Element_Input$getOptionValue(option),
								_p132._0);
						}
					}();
					var found = (!cache.found) ? currentIsSelected : cache.found;
					var prev = (currentIsSelected && _elm_lang$core$Native_Utils.eq(cache.prev, _elm_lang$core$Maybe$Nothing)) ? cache.last : cache.prev;
					var next = (cache.found && _elm_lang$core$Native_Utils.eq(cache.next, _elm_lang$core$Maybe$Nothing)) ? _elm_lang$core$Maybe$Just(
						_mdgriffith$style_elements$Element_Input$getOptionValue(option)) : cache.next;
					return _elm_lang$core$Native_Utils.update(
						cache,
						{next: next, found: found, prev: prev, first: first, last: last});
				}),
			{selected: input.focus, found: false, prev: _elm_lang$core$Maybe$Nothing, next: _elm_lang$core$Maybe$Nothing, first: _elm_lang$core$Maybe$Nothing, last: _elm_lang$core$Maybe$Nothing},
			A2(
				_elm_lang$core$List$filter,
				matchesQuery(input.query),
				choices));
		var _p133 = _elm_lang$core$Native_Utils.eq(cursor.found, false) ? {next: cursor.first, prev: cursor.first} : ((_elm_lang$core$Native_Utils.eq(cursor.next, _elm_lang$core$Maybe$Nothing) && (!_elm_lang$core$Native_Utils.eq(cursor.prev, _elm_lang$core$Maybe$Nothing))) ? {next: cursor.first, prev: cursor.prev} : ((_elm_lang$core$Native_Utils.eq(cursor.prev, _elm_lang$core$Maybe$Nothing) && (!_elm_lang$core$Native_Utils.eq(cursor.next, _elm_lang$core$Maybe$Nothing))) ? {next: cursor.next, prev: cursor.last} : {next: cursor.next, prev: cursor.prev}));
		var next = _p133.next;
		var prev = _p133.prev;
		var getFocus = function (query) {
			return A2(
				_elm_lang$core$Maybe$map,
				_mdgriffith$style_elements$Element_Input$getOptionValue,
				_elm_lang$core$List$head(
					A2(
						_elm_lang$core$List$filter,
						matchesQuery(query),
						choices)));
		};
		var isDisabled = A2(
			_elm_lang$core$List$any,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				})(_mdgriffith$style_elements$Element_Input$Disabled),
			input.options);
		var renderOption = function (option) {
			var _p134 = option;
			if (_p134.ctor === 'Choice') {
				var _p135 = _p134._0;
				var isSelected = _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p135),
					input.selected) ? {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'true'),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgba(0,0,0,0.05)'},
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: parentPadding,
							_1: {ctor: '[]'}
						}
					}
				} : (_elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p135),
					input.focus) ? {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'false'),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgba(0,0,0,0.03)'},
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: parentPadding,
							_1: {ctor: '[]'}
						}
					}
				} : {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'false'),
					_1: {
						ctor: '::',
						_0: parentPadding,
						_1: {ctor: '[]'}
					}
				});
				var additional = isDisabled ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
						_1: isSelected
					}
				} : {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onMouseEnter(
						input.onUpdate(
							_mdgriffith$style_elements$Element_Input$SetFocus(
								_elm_lang$core$Maybe$Just(_p135)))),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							input.onUpdate(
								_mdgriffith$style_elements$Element_Input$Batch(
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Input$SetFocus(
											_elm_lang$core$Maybe$Just(_p135)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Input$SelectFocused,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Input$CloseMenu,
												_1: {ctor: '[]'}
											}
										}
									}))),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
							_1: {
								ctor: '::',
								_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
								_1: isSelected
							}
						}
					}
				};
				return A2(_mdgriffith$style_elements$Element_Internal_Modify$addAttrList, additional, _p134._1);
			} else {
				var _p136 = _p134._0;
				var selectedState = _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p136),
					input.selected) ? _mdgriffith$style_elements$Element_Input$Selected : (_elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p136),
					input.focus) ? _mdgriffith$style_elements$Element_Input$Focused : _mdgriffith$style_elements$Element_Input$Idle);
				var isSelected = _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p136),
					input.selected) ? {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'true'),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgba(0,0,0,0.05)'},
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: parentPadding,
							_1: {ctor: '[]'}
						}
					}
				} : (_elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Maybe$Just(_p136),
					input.focus) ? {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'false'),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgba(0,0,0,0.03)'},
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: parentPadding,
							_1: {ctor: '[]'}
						}
					}
				} : {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'aria-selected', 'false'),
					_1: {
						ctor: '::',
						_0: parentPadding,
						_1: {ctor: '[]'}
					}
				});
				var additional = isDisabled ? {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
						_1: isSelected
					}
				} : {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onMouseEnter(
						input.onUpdate(
							_mdgriffith$style_elements$Element_Input$SetFocus(
								_elm_lang$core$Maybe$Just(_p136)))),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							input.onUpdate(
								_mdgriffith$style_elements$Element_Input$Batch(
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Input$SetFocus(
											_elm_lang$core$Maybe$Just(_p136)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Input$SelectFocused,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Input$CloseMenu,
												_1: {ctor: '[]'}
											}
										}
									}))),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Internal_Model$Expand,
							_1: {
								ctor: '::',
								_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menuitemradio'),
								_1: isSelected
							}
						}
					}
				};
				return A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addAttrList,
					additional,
					_p134._1(selectedState));
			}
		};
		var matches = A2(
			_elm_lang$core$List$map,
			renderOption,
			A2(
				_elm_lang$core$List$take,
				input.max,
				A2(
					_elm_lang$core$List$filter,
					matchesQuery(input.query),
					choices)));
		var fullElement = A2(
			menuAbove ? _mdgriffith$style_elements$Element$above : _mdgriffith$style_elements$Element$below,
			(input.isOpen && ((!_elm_lang$core$List$isEmpty(matches)) && ((!isDisabled) && _elm_lang$core$Native_Utils.eq(input.selected, _elm_lang$core$Maybe$Nothing)))) ? {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$column,
					menuStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'z-index', _1: '20'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
									_1: {ctor: '[]'}
								}
							}),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$pointer,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: menuAttrs
							}
						}
					},
					matches),
				_1: {ctor: '[]'}
			} : {ctor: '[]'},
			_mdgriffith$style_elements$Element_Internal_Model$Element(
				{
					node: 'div',
					style: _elm_lang$core$Maybe$Nothing,
					attrs: A2(
						_elm_lang$core$List$filterMap,
						_elm_lang$core$Basics$identity,
						{
							ctor: '::',
							_0: _elm_lang$core$Maybe$Just(
								_mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill)),
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Maybe$Just(
									_mdgriffith$style_elements$Element_Attributes$inlineStyle(
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'z-index', _1: '20'},
											_1: {ctor: '[]'}
										})),
								_1: {
									ctor: '::',
									_0: isDisabled ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
										_mdgriffith$style_elements$Element_Input$onKeyLookup(
											function (key) {
												return ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$delete) || _elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$backspace)) && (!_elm_lang$core$Native_Utils.eq(input.selected, _elm_lang$core$Maybe$Nothing))) ? _elm_lang$core$Maybe$Just(
													input.onUpdate(_mdgriffith$style_elements$Element_Input$Clear)) : (_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$tab) ? _elm_lang$core$Maybe$Just(
													input.onUpdate(_mdgriffith$style_elements$Element_Input$SelectFocused)) : (_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$enter) ? (input.isOpen ? _elm_lang$core$Maybe$Just(
													input.onUpdate(
														_mdgriffith$style_elements$Element_Input$Batch(
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Input$CloseMenu,
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Input$SelectFocused,
																	_1: {ctor: '[]'}
																}
															}))) : _elm_lang$core$Maybe$Just(
													input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu))) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$downArrow) && (!input.isOpen)) ? _elm_lang$core$Maybe$Just(
													input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu)) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$downArrow) && input.isOpen) ? A2(
													_elm_lang$core$Maybe$map,
													function (_p137) {
														return input.onUpdate(
															_mdgriffith$style_elements$Element_Input$SetFocus(
																_elm_lang$core$Maybe$Just(_p137)));
													},
													next) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$upArrow) && (!input.isOpen)) ? _elm_lang$core$Maybe$Just(
													input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu)) : ((_elm_lang$core$Native_Utils.eq(key, _mdgriffith$style_elements$Element_Input$upArrow) && input.isOpen) ? A2(
													_elm_lang$core$Maybe$map,
													function (_p138) {
														return input.onUpdate(
															_mdgriffith$style_elements$Element_Input$SetFocus(
																_elm_lang$core$Maybe$Just(_p138)));
													},
													prev) : _elm_lang$core$Maybe$Nothing))))));
											})),
									_1: {ctor: '[]'}
								}
							}
						}),
					child: _mdgriffith$style_elements$Element_Internal_Model$Layout(
						{
							node: 'div',
							style: _elm_lang$core$Maybe$Nothing,
							layout: A2(
								_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
								_mdgriffith$style_elements$Style_Internal_Model$GoRight,
								{ctor: '[]'}),
							attrs: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
									{
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'cursor', _1: 'text'},
										_1: {ctor: '[]'}
									}),
								_1: attrsWithoutSpacing
							},
							children: _mdgriffith$style_elements$Element_Internal_Model$Normal(
								{
									ctor: '::',
									_0: function () {
										var _p139 = input.selected;
										if (_p139.ctor === 'Nothing') {
											return _mdgriffith$style_elements$Element$text('');
										} else {
											return A2(
												_elm_lang$core$Maybe$withDefault,
												_mdgriffith$style_elements$Element$text(''),
												_elm_lang$core$List$head(
													A2(
														_elm_lang$core$List$map,
														function (opt) {
															var _p140 = opt;
															if (_p140.ctor === 'Choice') {
																return _p140._1;
															} else {
																return _p140._1(_mdgriffith$style_elements$Element_Input$SelectedInBox);
															}
														},
														A2(
															_elm_lang$core$List$filter,
															function (opt) {
																return _elm_lang$core$Native_Utils.eq(
																	_p139._0,
																	_mdgriffith$style_elements$Element_Input$getOptionValue(opt));
															},
															choices))));
										}
									}(),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Internal_Model$Element(
											{
												node: 'input',
												style: _elm_lang$core$Maybe$Nothing,
												attrs: A2(
													_elm_lang$core$List$filterMap,
													_elm_lang$core$Basics$identity,
													{
														ctor: '::',
														_0: _elm_lang$core$Maybe$Just(
															_mdgriffith$style_elements$Element_Attributes$toAttr(
																_elm_lang$html$Html_Attributes$placeholder(placeholderText))),
														_1: {
															ctor: '::',
															_0: _elm_lang$core$Maybe$Just(
																_mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill)),
															_1: {
																ctor: '::',
																_0: isDisabled ? _elm_lang$core$Maybe$Just(
																	_mdgriffith$style_elements$Element_Input$disabledAttr(true)) : _elm_lang$core$Maybe$Nothing,
																_1: {
																	ctor: '::',
																	_0: isDisabled ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
																		_mdgriffith$style_elements$Element_Attributes$toAttr(
																			_mdgriffith$style_elements$Element_Input$onFocusOut(
																				input.onUpdate(
																					_mdgriffith$style_elements$Element_Input$Batch(
																						{
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Input$SelectFocused,
																							_1: {
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Input$CloseMenu,
																								_1: {ctor: '[]'}
																							}
																						}))))),
																	_1: {
																		ctor: '::',
																		_0: isDisabled ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
																			_mdgriffith$style_elements$Element_Attributes$toAttr(
																				_mdgriffith$style_elements$Element_Input$onFocusIn(
																					input.onUpdate(_mdgriffith$style_elements$Element_Input$OpenMenu)))),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$core$Maybe$Just(
																				A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'role', 'menu')),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$core$Maybe$Just(
																					_mdgriffith$style_elements$Element_Input$type_('text')),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$core$Maybe$Just(
																						_mdgriffith$style_elements$Element_Attributes$toAttr(
																							_elm_lang$html$Html_Attributes$class('focus-override'))),
																					_1: {
																						ctor: '::',
																						_0: isDisabled ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
																							_mdgriffith$style_elements$Element_Events$onInput(
																								function (q) {
																									return input.onUpdate(
																										_mdgriffith$style_elements$Element_Input$Batch(
																											{
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Input$SetQuery(q),
																												_1: {
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Element_Input$SetFocus(
																														getFocus(q)),
																													_1: {ctor: '[]'}
																												}
																											}));
																								})),
																						_1: {
																							ctor: '::',
																							_0: _elm_lang$core$Maybe$Just(
																								_mdgriffith$style_elements$Element_Input$valueAttr(input.query)),
																							_1: {ctor: '[]'}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}),
												child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
												absolutelyPositioned: _elm_lang$core$Maybe$Nothing
											}),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Internal_Model$Element(
												{
													node: 'div',
													style: _elm_lang$core$Maybe$Just(style),
													attrs: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(
															A2(_mdgriffith$style_elements$Style_Internal_Model$Calc, 100, 0)),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$toAttr(
																_elm_lang$html$Html_Attributes$class('alt-icon')),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
																	{
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'height', _1: '100%'},
																		_1: {
																			ctor: '::',
																			_0: {ctor: '_Tuple2', _0: 'position', _1: 'absolute'},
																			_1: {
																				ctor: '::',
																				_0: {ctor: '_Tuple2', _0: 'top', _1: '0'},
																				_1: {
																					ctor: '::',
																					_0: {ctor: '_Tuple2', _0: 'left', _1: '0'},
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	}),
																_1: {ctor: '[]'}
															}
														}
													},
													child: _mdgriffith$style_elements$Element_Internal_Model$Empty,
													absolutelyPositioned: _elm_lang$core$Maybe$Nothing
												}),
											_1: {ctor: '[]'}
										}
									}
								}),
							absolutelyPositioned: _elm_lang$core$Maybe$Nothing
						}),
					absolutelyPositioned: _elm_lang$core$Maybe$Nothing
				}));
		var forErrors = function (opt) {
			var _p141 = opt;
			if (_p141.ctor === 'ErrorOpt') {
				return _elm_lang$core$Maybe$Just(_p141._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var errors = A2(_elm_lang$core$List$filterMap, forErrors, input.options);
		return A8(
			_mdgriffith$style_elements$Element_Input$applyLabel,
			_elm_lang$core$Maybe$Nothing,
			_elm_lang$core$Maybe$Nothing,
			A2(
				_elm_lang$core$Basics_ops['++'],
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
						{
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'cursor', _1: 'auto'},
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				},
				attrsWithSpacing),
			input.label,
			errors,
			isDisabled,
			false,
			{
				ctor: '::',
				_0: fullElement,
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Element_Input$select = F3(
	function (style, attrs, input) {
		var _p142 = input.$with;
		if (_p142.ctor === 'Autocomplete') {
			var _p143 = _p142._0;
			return A3(
				_mdgriffith$style_elements$Element_Input$searchSelect,
				style,
				attrs,
				{max: input.max, menu: input.menu, label: input.label, options: input.options, onUpdate: _p143.onUpdate, isOpen: _p143.isOpen, selected: _p143.selected, query: _p143.query, focus: _p143.focus});
		} else {
			var _p144 = _p142._0;
			return A3(
				_mdgriffith$style_elements$Element_Input$selectMenu,
				style,
				attrs,
				{max: input.max, menu: input.menu, label: input.label, options: input.options, onUpdate: _p144.onUpdate, isOpen: _p144.isOpen, selected: _p144.selected});
		}
	});

var _mdgriffith$style_elements$Element_Keyed$namedGrid = F3(
	function (style, attrs, config) {
		var forSpacing = function (attr) {
			var _p0 = attr;
			if (_p0.ctor === 'Spacing') {
				return true;
			} else {
				return false;
			}
		};
		var _p1 = A2(_elm_lang$core$List$partition, forSpacing, attrs);
		var spacing = _p1._0;
		var notSpacingAttrs = _p1._1;
		var gridAttributes = function () {
			var _p2 = _elm_lang$core$List$head(
				_elm_lang$core$List$reverse(spacing));
			if (_p2.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				if (_p2._0.ctor === 'Spacing') {
					return {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Style_Internal_Model$GridGap, _p2._0._0, _p2._0._1),
						_1: {ctor: '[]'}
					};
				} else {
					return {ctor: '[]'};
				}
			}
		}();
		var prepare = function (el) {
			return _mdgriffith$style_elements$Element_Internal_Model$Keyed(
				A2(
					_elm_lang$core$List$map,
					function (_p3) {
						var _p4 = _p3;
						return _p4._0;
					},
					el));
		};
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$Grid,
					_mdgriffith$style_elements$Style_Internal_Model$NamedGridTemplate(
						{rows: config.rows, columns: config.columns}),
					gridAttributes),
				attrs: notSpacingAttrs,
				children: prepare(config.cells),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element_Keyed$grid = F3(
	function (style, attrs, config) {
		var forSpacing = function (attr) {
			var _p5 = attr;
			if (_p5.ctor === 'Spacing') {
				return true;
			} else {
				return false;
			}
		};
		var _p6 = A2(_elm_lang$core$List$partition, forSpacing, attrs);
		var spacing = _p6._0;
		var notSpacingAttrs = _p6._1;
		var gridAttributes = function () {
			var _p7 = _elm_lang$core$List$head(
				_elm_lang$core$List$reverse(spacing));
			if (_p7.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				if (_p7._0.ctor === 'Spacing') {
					return {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Style_Internal_Model$GridGap, _p7._0._0, _p7._0._1),
						_1: {ctor: '[]'}
					};
				} else {
					return {ctor: '[]'};
				}
			}
		}();
		var prepare = function (el) {
			return _mdgriffith$style_elements$Element_Internal_Model$Keyed(
				A2(
					_elm_lang$core$List$map,
					function (_p8) {
						var _p9 = _p8;
						return _p9._0;
					},
					el));
		};
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$Grid,
					_mdgriffith$style_elements$Style_Internal_Model$GridTemplate(
						{rows: config.rows, columns: config.columns}),
					gridAttributes),
				attrs: notSpacingAttrs,
				children: prepare(config.cells),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element_Keyed$named = F2(
	function (name, el) {
		return _mdgriffith$style_elements$Element_Internal_Model$NamedOnGrid(
			{
				ctor: '_Tuple2',
				_0: name,
				_1: A2(
					_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
					_mdgriffith$style_elements$Element_Internal_Model$GridArea(name),
					el)
			});
	});
var _mdgriffith$style_elements$Element_Keyed$cell = function (box) {
	var pos = {start: box.start, width: box.width, height: box.height};
	return _mdgriffith$style_elements$Element_Internal_Model$OnGrid(
		{
			ctor: '_Tuple2',
			_0: box.key,
			_1: A2(
				_mdgriffith$style_elements$Element_Internal_Modify$addAttr,
				_mdgriffith$style_elements$Element_Internal_Model$GridCoords(
					_mdgriffith$style_elements$Style_Internal_Model$GridPosition(pos)),
				box.content)
		});
};
var _mdgriffith$style_elements$Element_Keyed$wrappedColumn = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$Down,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Internal_Model$Wrap(true),
						_1: {ctor: '[]'}
					}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Keyed(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element_Keyed$wrappedRow = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$GoRight,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Internal_Model$Wrap(true),
						_1: {ctor: '[]'}
					}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Keyed(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element_Keyed$column = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$Down,
					{ctor: '[]'}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Keyed(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element_Keyed$row = F3(
	function (style, attrs, children) {
		return _mdgriffith$style_elements$Element_Internal_Model$Layout(
			{
				node: 'div',
				style: _elm_lang$core$Maybe$Just(style),
				layout: A2(
					_mdgriffith$style_elements$Style_Internal_Model$FlexLayout,
					_mdgriffith$style_elements$Style_Internal_Model$GoRight,
					{ctor: '[]'}),
				attrs: attrs,
				children: _mdgriffith$style_elements$Element_Internal_Model$Keyed(children),
				absolutelyPositioned: _elm_lang$core$Maybe$Nothing
			});
	});
var _mdgriffith$style_elements$Element_Keyed$GridPosition = F5(
	function (a, b, c, d, e) {
		return {start: a, width: b, height: c, key: d, content: e};
	});
var _mdgriffith$style_elements$Element_Keyed$Grid = F3(
	function (a, b, c) {
		return {rows: a, columns: b, cells: c};
	});
var _mdgriffith$style_elements$Element_Keyed$NamedGrid = F3(
	function (a, b, c) {
		return {rows: a, columns: b, cells: c};
	});

var _mdgriffith$style_elements$Style_Border$roundBottomLeft = function (x) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-bottom-left-radius',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(x),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$roundBottomRight = function (x) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-bottom-right-radius',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(x),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$roundTopRight = function (x) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-top-right-radius',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(x),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$roundTopLeft = function (x) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-top-left-radius',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(x),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$rounded = function (box) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-radius',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(box),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$dotted = A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, 'border-style', 'dotted');
var _mdgriffith$style_elements$Style_Border$dashed = A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, 'border-style', 'dashed');
var _mdgriffith$style_elements$Style_Border$solid = A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, 'border-style', 'solid');
var _mdgriffith$style_elements$Style_Border$none = A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, 'border-width', '0');
var _mdgriffith$style_elements$Style_Border$bottom = function (l) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-bottom-width',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(l),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$top = function (l) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-top-width',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(l),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$right = function (l) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-right-width',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(l),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$left = function (l) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-left-width',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(l),
			'px'));
};
var _mdgriffith$style_elements$Style_Border$all = function (v) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-width',
		_mdgriffith$style_elements$Style_Internal_Render_Value$box(
			{ctor: '_Tuple4', _0: v, _1: v, _2: v, _3: v}));
};

var _mdgriffith$style_elements$Style_Color$placeholder = function (clr) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$PseudoElement,
		'::placeholder',
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$TextColor(clr),
			_1: {
				ctor: '::',
				_0: A2(_mdgriffith$style_elements$Style_Internal_Model$Exact, 'opacity', '1'),
				_1: {ctor: '[]'}
			}
		});
};
var _mdgriffith$style_elements$Style_Color$selection = function (clr) {
	return _mdgriffith$style_elements$Style_Internal_Model$SelectionColor(clr);
};
var _mdgriffith$style_elements$Style_Color$decoration = function (clr) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'text-decoration-color',
		_mdgriffith$style_elements$Style_Internal_Render_Value$color(clr));
};
var _mdgriffith$style_elements$Style_Color$cursor = function (clr) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'cursor-color',
		_mdgriffith$style_elements$Style_Internal_Render_Value$color(clr));
};
var _mdgriffith$style_elements$Style_Color$border = function (clr) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'border-color',
		_mdgriffith$style_elements$Style_Internal_Render_Value$color(clr));
};
var _mdgriffith$style_elements$Style_Color$background = function (clr) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Exact,
		'background-color',
		_mdgriffith$style_elements$Style_Internal_Render_Value$color(clr));
};
var _mdgriffith$style_elements$Style_Color$text = _mdgriffith$style_elements$Style_Internal_Model$TextColor;

var _mdgriffith$style_elements$Style_Filter$sepia = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Sepia(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$saturate = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Saturate(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$opacity = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$OpacityFilter(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$invert = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Invert(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$hueRotate = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$HueRotate(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$grayscale = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Grayscale(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$contrast = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Contrast(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$brightness = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Brightness(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$blur = function (x) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$Blur(x),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Filter$url = function (s) {
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$FilterUrl(s),
			_1: {ctor: '[]'}
		});
};

var _mdgriffith$style_elements$Style_Font$lowercase = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-transform', 'lowercase');
var _mdgriffith$style_elements$Style_Font$capitalize = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-transform', 'capitalize');
var _mdgriffith$style_elements$Style_Font$uppercase = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-transform', 'uppercase');
var _mdgriffith$style_elements$Style_Font$weight = function (fontWeight) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Font,
		'font-weight',
		_elm_lang$core$Basics$toString(fontWeight));
};
var _mdgriffith$style_elements$Style_Font$light = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'font-weight', '300');
var _mdgriffith$style_elements$Style_Font$bold = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'font-weight', '700');
var _mdgriffith$style_elements$Style_Font$italic = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'font-style', 'italic');
var _mdgriffith$style_elements$Style_Font$strike = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-decoration', 'line-through');
var _mdgriffith$style_elements$Style_Font$underline = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-decoration', 'underline');
var _mdgriffith$style_elements$Style_Font$justifyAll = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-align', 'justify-all');
var _mdgriffith$style_elements$Style_Font$justify = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-align', 'justify');
var _mdgriffith$style_elements$Style_Font$center = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-align', 'center');
var _mdgriffith$style_elements$Style_Font$alignRight = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-align', 'right');
var _mdgriffith$style_elements$Style_Font$alignLeft = A2(_mdgriffith$style_elements$Style_Internal_Model$Font, 'text-align', 'left');
var _mdgriffith$style_elements$Style_Font$wordSpacing = function (offset) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Font,
		'word-spacing',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(offset),
			'px'));
};
var _mdgriffith$style_elements$Style_Font$letterSpacing = function (offset) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Font,
		'letter-spacing',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(offset),
			'px'));
};
var _mdgriffith$style_elements$Style_Font$lineHeight = function (height) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Font,
		'line-height',
		_elm_lang$core$Basics$toString(height));
};
var _mdgriffith$style_elements$Style_Font$size = function (size) {
	return A2(
		_mdgriffith$style_elements$Style_Internal_Model$Font,
		'font-size',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(size),
			'px'));
};
var _mdgriffith$style_elements$Style_Font$importUrl = function (_p0) {
	var _p1 = _p0;
	return A2(_mdgriffith$style_elements$Style_Internal_Model$ImportFont, _p1.name, _p1.url);
};
var _mdgriffith$style_elements$Style_Font$font = _mdgriffith$style_elements$Style_Internal_Model$FontName;
var _mdgriffith$style_elements$Style_Font$monospace = _mdgriffith$style_elements$Style_Internal_Model$Monospace;
var _mdgriffith$style_elements$Style_Font$fantasy = _mdgriffith$style_elements$Style_Internal_Model$Fantasy;
var _mdgriffith$style_elements$Style_Font$cursive = _mdgriffith$style_elements$Style_Internal_Model$Cursive;
var _mdgriffith$style_elements$Style_Font$sansSerif = _mdgriffith$style_elements$Style_Internal_Model$SansSerif;
var _mdgriffith$style_elements$Style_Font$serif = _mdgriffith$style_elements$Style_Internal_Model$Serif;
var _mdgriffith$style_elements$Style_Font$typeface = function (families) {
	return _mdgriffith$style_elements$Style_Internal_Model$FontFamily(families);
};

var _mdgriffith$style_elements$Style_Shadow$drop = function (_p0) {
	var _p1 = _p0;
	return _mdgriffith$style_elements$Style_Internal_Model$Filters(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$DropShadow(
				{offset: _p1.offset, size: 0, blur: _p1.blur, color: _p1.color}),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Shadow$text = function (_p2) {
	var _p3 = _p2;
	return _mdgriffith$style_elements$Style_Internal_Model$Shadows(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$ShadowModel(
				{kind: 'text', offset: _p3.offset, size: 0, blur: _p3.blur, color: _p3.color}),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Shadow$inset = function (_p4) {
	var _p5 = _p4;
	return _mdgriffith$style_elements$Style_Internal_Model$Shadows(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Internal_Model$ShadowModel(
				{kind: 'inset', offset: _p5.offset, size: _p5.size, blur: _p5.blur, color: _p5.color}),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Shadow$boxHelper = function (_p6) {
	var _p7 = _p6;
	return _mdgriffith$style_elements$Style_Internal_Model$ShadowModel(
		{kind: 'box', offset: _p7.offset, size: _p7.size, blur: _p7.blur, color: _p7.color});
};
var _mdgriffith$style_elements$Style_Shadow$box = function (shadow) {
	return _mdgriffith$style_elements$Style_Internal_Model$Shadows(
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Shadow$boxHelper(shadow),
			_1: {ctor: '[]'}
		});
};
var _mdgriffith$style_elements$Style_Shadow$deep = _mdgriffith$style_elements$Style_Shadow$box(
	{
		color: A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0.2),
		offset: {ctor: '_Tuple2', _0: 0, _1: 14},
		blur: 20,
		size: -12
	});
var _mdgriffith$style_elements$Style_Shadow$simple = _mdgriffith$style_elements$Style_Internal_Model$Shadows(
	{
		ctor: '::',
		_0: _mdgriffith$style_elements$Style_Shadow$boxHelper(
			{
				color: A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0.5),
				offset: {ctor: '_Tuple2', _0: 0, _1: 29},
				blur: 32,
				size: -20
			}),
		_1: {
			ctor: '::',
			_0: _mdgriffith$style_elements$Style_Shadow$boxHelper(
				{
					color: A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0.25),
					offset: {ctor: '_Tuple2', _0: 0, _1: 4},
					blur: 11,
					size: -3
				}),
			_1: {ctor: '[]'}
		}
	});
var _mdgriffith$style_elements$Style_Shadow$textGlow = F2(
	function (color, size) {
		return _mdgriffith$style_elements$Style_Internal_Model$Shadows(
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Style_Internal_Model$ShadowModel(
					{
						kind: 'text',
						offset: {ctor: '_Tuple2', _0: 0, _1: 0},
						size: size,
						blur: size * 2,
						color: color
					}),
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Style_Shadow$innerGlow = F2(
	function (color, size) {
		return _mdgriffith$style_elements$Style_Internal_Model$Shadows(
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Style_Internal_Model$ShadowModel(
					{
						kind: 'inset',
						offset: {ctor: '_Tuple2', _0: 0, _1: 0},
						size: size,
						blur: size * 2,
						color: color
					}),
				_1: {ctor: '[]'}
			});
	});
var _mdgriffith$style_elements$Style_Shadow$glow = F2(
	function (color, size) {
		return _mdgriffith$style_elements$Style_Internal_Model$Shadows(
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Style_Internal_Model$ShadowModel(
					{
						kind: 'box',
						offset: {ctor: '_Tuple2', _0: 0, _1: 0},
						size: size,
						blur: size * 2,
						color: color
					}),
				_1: {ctor: '[]'}
			});
	});

var _mdgriffith$style_elements$Style_Sheet$mix = _mdgriffith$style_elements$Style_Internal_Batchable$batch;
var _mdgriffith$style_elements$Style_Sheet$merge = function (_p0) {
	var _p1 = _p0;
	return _mdgriffith$style_elements$Style_Internal_Batchable$many(
		_mdgriffith$style_elements$Style_Internal_Batchable$toList(_p1._0));
};
var _mdgriffith$style_elements$Style_Sheet$ChildSheet = function (a) {
	return {ctor: 'ChildSheet', _0: a};
};
var _mdgriffith$style_elements$Style_Sheet$map = F3(
	function (toParent, toParentVariation, styles) {
		return _mdgriffith$style_elements$Style_Sheet$ChildSheet(
			A2(
				_elm_lang$core$List$map,
				_mdgriffith$style_elements$Style_Internal_Batchable$map(
					A2(_mdgriffith$style_elements$Style_Internal_Model$mapClassAndVar, toParent, toParentVariation)),
				styles));
	});

var _rtfeldman$elm_css$Css_Structure$compactHelp = F2(
	function (declaration, _p0) {
		var _p1 = _p0;
		var _p9 = _p1._0;
		var _p8 = _p1._1;
		var _p2 = declaration;
		switch (_p2.ctor) {
			case 'StyleBlockDeclaration':
				return _elm_lang$core$List$isEmpty(_p2._0._2) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			case 'MediaRule':
				return A2(
					_elm_lang$core$List$all,
					function (_p3) {
						var _p4 = _p3;
						return _elm_lang$core$List$isEmpty(_p4._2);
					},
					_p2._1) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			case 'SupportsRule':
				return _elm_lang$core$List$isEmpty(_p2._1) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			case 'DocumentRule':
				return {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			case 'PageRule':
				return _elm_lang$core$List$isEmpty(_p2._1) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			case 'FontFace':
				return _elm_lang$core$List$isEmpty(_p2._0) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			case 'Keyframes':
				var _p5 = _p2._0;
				return _elm_lang$core$String$isEmpty(_p5.declaration) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: A3(_elm_lang$core$Dict$insert, _p5.name, _p5.declaration, _p9),
					_1: _p8
				};
			case 'Viewport':
				return _elm_lang$core$List$isEmpty(_p2._0) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			case 'CounterStyle':
				return _elm_lang$core$List$isEmpty(_p2._0) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
			default:
				return A2(
					_elm_lang$core$List$all,
					function (_p6) {
						var _p7 = _p6;
						return _elm_lang$core$List$isEmpty(_p7._1);
					},
					_p2._0) ? {ctor: '_Tuple2', _0: _p9, _1: _p8} : {
					ctor: '_Tuple2',
					_0: _p9,
					_1: {ctor: '::', _0: declaration, _1: _p8}
				};
		}
	});
var _rtfeldman$elm_css$Css_Structure$concatMapLast = F2(
	function (update, list) {
		var _p10 = list;
		if (_p10.ctor === '[]') {
			return list;
		} else {
			if (_p10._1.ctor === '[]') {
				return update(_p10._0);
			} else {
				return {
					ctor: '::',
					_0: _p10._0,
					_1: A2(_rtfeldman$elm_css$Css_Structure$concatMapLast, update, _p10._1)
				};
			}
		}
	});
var _rtfeldman$elm_css$Css_Structure$mapLast = F2(
	function (update, list) {
		var _p11 = list;
		if (_p11.ctor === '[]') {
			return list;
		} else {
			if (_p11._1.ctor === '[]') {
				return {
					ctor: '::',
					_0: update(_p11._0),
					_1: {ctor: '[]'}
				};
			} else {
				return {
					ctor: '::',
					_0: _p11._0,
					_1: A2(_rtfeldman$elm_css$Css_Structure$mapLast, update, _p11._1)
				};
			}
		}
	});
var _rtfeldman$elm_css$Css_Structure$Stylesheet = F4(
	function (a, b, c, d) {
		return {charset: a, imports: b, namespaces: c, declarations: d};
	});
var _rtfeldman$elm_css$Css_Structure$MediaExpression = F2(
	function (a, b) {
		return {feature: a, value: b};
	});
var _rtfeldman$elm_css$Css_Structure$Compatible = {ctor: 'Compatible'};
var _rtfeldman$elm_css$Css_Structure$FontFeatureValues = function (a) {
	return {ctor: 'FontFeatureValues', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$CounterStyle = function (a) {
	return {ctor: 'CounterStyle', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$Viewport = function (a) {
	return {ctor: 'Viewport', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$Keyframes = function (a) {
	return {ctor: 'Keyframes', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			_elm_lang$core$List$append,
			A2(
				_elm_lang$core$List$map,
				function (_p12) {
					var _p13 = _p12;
					return _rtfeldman$elm_css$Css_Structure$Keyframes(
						{name: _p13._0, declaration: _p13._1});
				},
				_elm_lang$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var _rtfeldman$elm_css$Css_Structure$compactStylesheet = function (_p14) {
	var _p15 = _p14;
	var _p16 = A3(
		_elm_lang$core$List$foldr,
		_rtfeldman$elm_css$Css_Structure$compactHelp,
		{
			ctor: '_Tuple2',
			_0: _elm_lang$core$Dict$empty,
			_1: {ctor: '[]'}
		},
		_p15.declarations);
	var keyframesByName = _p16._0;
	var compactedDeclarations = _p16._1;
	var finalDeclarations = A2(_rtfeldman$elm_css$Css_Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {charset: _p15.charset, imports: _p15.imports, namespaces: _p15.namespaces, declarations: finalDeclarations};
};
var _rtfeldman$elm_css$Css_Structure$FontFace = function (a) {
	return {ctor: 'FontFace', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$PageRule = F2(
	function (a, b) {
		return {ctor: 'PageRule', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {ctor: 'DocumentRule', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _rtfeldman$elm_css$Css_Structure$SupportsRule = F2(
	function (a, b) {
		return {ctor: 'SupportsRule', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Structure$MediaRule = F2(
	function (a, b) {
		return {ctor: 'MediaRule', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		var _p17 = declaration;
		if (_p17.ctor === 'StyleBlockDeclaration') {
			return A2(
				_rtfeldman$elm_css$Css_Structure$MediaRule,
				mediaQueries,
				{
					ctor: '::',
					_0: _p17._0,
					_1: {ctor: '[]'}
				});
		} else {
			return declaration;
		}
	});
var _rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration = function (a) {
	return {ctor: 'StyleBlockDeclaration', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		var _p18 = declarations;
		_v9_12:
		do {
			if (_p18.ctor === '[]') {
				return declarations;
			} else {
				if (_p18._1.ctor === '[]') {
					switch (_p18._0.ctor) {
						case 'StyleBlockDeclaration':
							return A2(
								_elm_lang$core$List$map,
								_rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration,
								update(_p18._0._0));
						case 'MediaRule':
							if (_p18._0._1.ctor === '::') {
								if (_p18._0._1._1.ctor === '[]') {
									return {
										ctor: '::',
										_0: A2(
											_rtfeldman$elm_css$Css_Structure$MediaRule,
											_p18._0._0,
											update(_p18._0._1._0)),
										_1: {ctor: '[]'}
									};
								} else {
									var _p19 = A2(
										_rtfeldman$elm_css$Css_Structure$concatMapLastStyleBlock,
										update,
										{
											ctor: '::',
											_0: A2(_rtfeldman$elm_css$Css_Structure$MediaRule, _p18._0._0, _p18._0._1._1),
											_1: {ctor: '[]'}
										});
									if (((_p19.ctor === '::') && (_p19._0.ctor === 'MediaRule')) && (_p19._1.ctor === '[]')) {
										return {
											ctor: '::',
											_0: A2(
												_rtfeldman$elm_css$Css_Structure$MediaRule,
												_p19._0._0,
												{ctor: '::', _0: _p18._0._1._0, _1: _p19._0._1}),
											_1: {ctor: '[]'}
										};
									} else {
										return _p19;
									}
								}
							} else {
								break _v9_12;
							}
						case 'SupportsRule':
							return {
								ctor: '::',
								_0: A2(
									_rtfeldman$elm_css$Css_Structure$SupportsRule,
									_p18._0._0,
									A2(_rtfeldman$elm_css$Css_Structure$concatMapLastStyleBlock, update, _p18._0._1)),
								_1: {ctor: '[]'}
							};
						case 'DocumentRule':
							return A2(
								_elm_lang$core$List$map,
								A4(_rtfeldman$elm_css$Css_Structure$DocumentRule, _p18._0._0, _p18._0._1, _p18._0._2, _p18._0._3),
								update(_p18._0._4));
						case 'PageRule':
							return declarations;
						case 'FontFace':
							return declarations;
						case 'Keyframes':
							return declarations;
						case 'Viewport':
							return declarations;
						case 'CounterStyle':
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v9_12;
				}
			}
		} while(false);
		return {
			ctor: '::',
			_0: _p18._0,
			_1: A2(_rtfeldman$elm_css$Css_Structure$concatMapLastStyleBlock, update, _p18._1)
		};
	});
var _rtfeldman$elm_css$Css_Structure$StyleBlock = F3(
	function (a, b, c) {
		return {ctor: 'StyleBlock', _0: a, _1: b, _2: c};
	});
var _rtfeldman$elm_css$Css_Structure$withPropertyAppended = F2(
	function (property, _p20) {
		var _p21 = _p20;
		return A3(
			_rtfeldman$elm_css$Css_Structure$StyleBlock,
			_p21._0,
			_p21._1,
			A2(
				_elm_lang$core$Basics_ops['++'],
				_p21._2,
				{
					ctor: '::',
					_0: property,
					_1: {ctor: '[]'}
				}));
	});
var _rtfeldman$elm_css$Css_Structure$appendProperty = F2(
	function (property, declarations) {
		var _p22 = declarations;
		if (_p22.ctor === '[]') {
			return declarations;
		} else {
			if (_p22._1.ctor === '[]') {
				switch (_p22._0.ctor) {
					case 'StyleBlockDeclaration':
						return {
							ctor: '::',
							_0: _rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration(
								A2(_rtfeldman$elm_css$Css_Structure$withPropertyAppended, property, _p22._0._0)),
							_1: {ctor: '[]'}
						};
					case 'MediaRule':
						return {
							ctor: '::',
							_0: A2(
								_rtfeldman$elm_css$Css_Structure$MediaRule,
								_p22._0._0,
								A2(
									_rtfeldman$elm_css$Css_Structure$mapLast,
									_rtfeldman$elm_css$Css_Structure$withPropertyAppended(property),
									_p22._0._1)),
							_1: {ctor: '[]'}
						};
					default:
						return declarations;
				}
			} else {
				return {
					ctor: '::',
					_0: _p22._0,
					_1: A2(_rtfeldman$elm_css$Css_Structure$appendProperty, property, _p22._1)
				};
			}
		}
	});
var _rtfeldman$elm_css$Css_Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		var _p23 = styleBlock;
		if (_p23._1.ctor === '[]') {
			var _p24 = _p23._0;
			return {
				ctor: '::',
				_0: A3(
					_rtfeldman$elm_css$Css_Structure$StyleBlock,
					_p24,
					{ctor: '[]'},
					_p23._2),
				_1: {
					ctor: '::',
					_0: A3(
						_rtfeldman$elm_css$Css_Structure$StyleBlock,
						f(_p24),
						{ctor: '[]'},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}
			};
		} else {
			var _p26 = _p23._1;
			var _p25 = _p23._0;
			var newFirst = f(_p25);
			var newRest = A2(_elm_lang$core$List$map, f, _p26);
			return {
				ctor: '::',
				_0: A3(_rtfeldman$elm_css$Css_Structure$StyleBlock, _p25, _p26, _p23._2),
				_1: {
					ctor: '::',
					_0: A3(
						_rtfeldman$elm_css$Css_Structure$StyleBlock,
						newFirst,
						newRest,
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}
			};
		}
	});
var _rtfeldman$elm_css$Css_Structure$Speech = {ctor: 'Speech'};
var _rtfeldman$elm_css$Css_Structure$Screen = {ctor: 'Screen'};
var _rtfeldman$elm_css$Css_Structure$Print = {ctor: 'Print'};
var _rtfeldman$elm_css$Css_Structure$CustomQuery = function (a) {
	return {ctor: 'CustomQuery', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$NotQuery = F2(
	function (a, b) {
		return {ctor: 'NotQuery', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Structure$OnlyQuery = F2(
	function (a, b) {
		return {ctor: 'OnlyQuery', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Structure$AllQuery = function (a) {
	return {ctor: 'AllQuery', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$Selector = F3(
	function (a, b, c) {
		return {ctor: 'Selector', _0: a, _1: b, _2: c};
	});
var _rtfeldman$elm_css$Css_Structure$applyPseudoElement = F2(
	function (pseudo, _p27) {
		var _p28 = _p27;
		return A3(
			_rtfeldman$elm_css$Css_Structure$Selector,
			_p28._0,
			_p28._1,
			_elm_lang$core$Maybe$Just(pseudo));
	});
var _rtfeldman$elm_css$Css_Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			_rtfeldman$elm_css$Css_Structure$appendToLastSelector,
			_rtfeldman$elm_css$Css_Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var _rtfeldman$elm_css$Css_Structure$CustomSelector = F2(
	function (a, b) {
		return {ctor: 'CustomSelector', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Structure$UniversalSelectorSequence = function (a) {
	return {ctor: 'UniversalSelectorSequence', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {ctor: 'TypeSelectorSequence', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Structure$appendRepeatable = F2(
	function (selector, sequence) {
		var _p29 = sequence;
		switch (_p29.ctor) {
			case 'TypeSelectorSequence':
				return A2(
					_rtfeldman$elm_css$Css_Structure$TypeSelectorSequence,
					_p29._0,
					A2(
						_elm_lang$core$Basics_ops['++'],
						_p29._1,
						{
							ctor: '::',
							_0: selector,
							_1: {ctor: '[]'}
						}));
			case 'UniversalSelectorSequence':
				return _rtfeldman$elm_css$Css_Structure$UniversalSelectorSequence(
					A2(
						_elm_lang$core$Basics_ops['++'],
						_p29._0,
						{
							ctor: '::',
							_0: selector,
							_1: {ctor: '[]'}
						}));
			default:
				return A2(
					_rtfeldman$elm_css$Css_Structure$CustomSelector,
					_p29._0,
					A2(
						_elm_lang$core$Basics_ops['++'],
						_p29._1,
						{
							ctor: '::',
							_0: selector,
							_1: {ctor: '[]'}
						}));
		}
	});
var _rtfeldman$elm_css$Css_Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		var _p30 = list;
		if (_p30.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			if ((_p30._0.ctor === '_Tuple2') && (_p30._1.ctor === '[]')) {
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: _p30._0._0,
						_1: A2(_rtfeldman$elm_css$Css_Structure$appendRepeatable, selector, _p30._0._1)
					},
					_1: {ctor: '[]'}
				};
			} else {
				return {
					ctor: '::',
					_0: _p30._0,
					_1: A2(_rtfeldman$elm_css$Css_Structure$appendRepeatableWithCombinator, selector, _p30._1)
				};
			}
		}
	});
var _rtfeldman$elm_css$Css_Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		var _p31 = selector;
		if (_p31._1.ctor === '[]') {
			return A3(
				_rtfeldman$elm_css$Css_Structure$Selector,
				A2(_rtfeldman$elm_css$Css_Structure$appendRepeatable, repeatableSimpleSelector, _p31._0),
				{ctor: '[]'},
				_p31._2);
		} else {
			return A3(
				_rtfeldman$elm_css$Css_Structure$Selector,
				_p31._0,
				A2(_rtfeldman$elm_css$Css_Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, _p31._1),
				_p31._2);
		}
	});
var _rtfeldman$elm_css$Css_Structure$extendLastSelector = F2(
	function (selector, declarations) {
		var _p32 = declarations;
		_v18_15:
		do {
			if (_p32.ctor === '[]') {
				return declarations;
			} else {
				if (_p32._1.ctor === '[]') {
					switch (_p32._0.ctor) {
						case 'StyleBlockDeclaration':
							if (_p32._0._0._1.ctor === '[]') {
								return {
									ctor: '::',
									_0: _rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration(
										A3(
											_rtfeldman$elm_css$Css_Structure$StyleBlock,
											A2(_rtfeldman$elm_css$Css_Structure$appendRepeatableSelector, selector, _p32._0._0._0),
											{ctor: '[]'},
											_p32._0._0._2)),
									_1: {ctor: '[]'}
								};
							} else {
								var newRest = A2(
									_rtfeldman$elm_css$Css_Structure$mapLast,
									_rtfeldman$elm_css$Css_Structure$appendRepeatableSelector(selector),
									_p32._0._0._1);
								return {
									ctor: '::',
									_0: _rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration(
										A3(_rtfeldman$elm_css$Css_Structure$StyleBlock, _p32._0._0._0, newRest, _p32._0._0._2)),
									_1: {ctor: '[]'}
								};
							}
						case 'MediaRule':
							if (_p32._0._1.ctor === '::') {
								if (_p32._0._1._1.ctor === '[]') {
									if (_p32._0._1._0._1.ctor === '[]') {
										var newStyleBlock = A3(
											_rtfeldman$elm_css$Css_Structure$StyleBlock,
											A2(_rtfeldman$elm_css$Css_Structure$appendRepeatableSelector, selector, _p32._0._1._0._0),
											{ctor: '[]'},
											_p32._0._1._0._2);
										return {
											ctor: '::',
											_0: A2(
												_rtfeldman$elm_css$Css_Structure$MediaRule,
												_p32._0._0,
												{
													ctor: '::',
													_0: newStyleBlock,
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										};
									} else {
										var newRest = A2(
											_rtfeldman$elm_css$Css_Structure$mapLast,
											_rtfeldman$elm_css$Css_Structure$appendRepeatableSelector(selector),
											_p32._0._1._0._1);
										var newStyleBlock = A3(_rtfeldman$elm_css$Css_Structure$StyleBlock, _p32._0._1._0._0, newRest, _p32._0._1._0._2);
										return {
											ctor: '::',
											_0: A2(
												_rtfeldman$elm_css$Css_Structure$MediaRule,
												_p32._0._0,
												{
													ctor: '::',
													_0: newStyleBlock,
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										};
									}
								} else {
									var _p33 = A2(
										_rtfeldman$elm_css$Css_Structure$extendLastSelector,
										selector,
										{
											ctor: '::',
											_0: A2(_rtfeldman$elm_css$Css_Structure$MediaRule, _p32._0._0, _p32._0._1._1),
											_1: {ctor: '[]'}
										});
									if (((_p33.ctor === '::') && (_p33._0.ctor === 'MediaRule')) && (_p33._1.ctor === '[]')) {
										return {
											ctor: '::',
											_0: A2(
												_rtfeldman$elm_css$Css_Structure$MediaRule,
												_p33._0._0,
												{ctor: '::', _0: _p32._0._1._0, _1: _p33._0._1}),
											_1: {ctor: '[]'}
										};
									} else {
										return _p33;
									}
								}
							} else {
								break _v18_15;
							}
						case 'SupportsRule':
							return {
								ctor: '::',
								_0: A2(
									_rtfeldman$elm_css$Css_Structure$SupportsRule,
									_p32._0._0,
									A2(_rtfeldman$elm_css$Css_Structure$extendLastSelector, selector, _p32._0._1)),
								_1: {ctor: '[]'}
							};
						case 'DocumentRule':
							if (_p32._0._4._1.ctor === '[]') {
								var newStyleBlock = A3(
									_rtfeldman$elm_css$Css_Structure$StyleBlock,
									A2(_rtfeldman$elm_css$Css_Structure$appendRepeatableSelector, selector, _p32._0._4._0),
									{ctor: '[]'},
									_p32._0._4._2);
								return {
									ctor: '::',
									_0: A5(_rtfeldman$elm_css$Css_Structure$DocumentRule, _p32._0._0, _p32._0._1, _p32._0._2, _p32._0._3, newStyleBlock),
									_1: {ctor: '[]'}
								};
							} else {
								var newRest = A2(
									_rtfeldman$elm_css$Css_Structure$mapLast,
									_rtfeldman$elm_css$Css_Structure$appendRepeatableSelector(selector),
									_p32._0._4._1);
								var newStyleBlock = A3(_rtfeldman$elm_css$Css_Structure$StyleBlock, _p32._0._4._0, newRest, _p32._0._4._2);
								return {
									ctor: '::',
									_0: A5(_rtfeldman$elm_css$Css_Structure$DocumentRule, _p32._0._0, _p32._0._1, _p32._0._2, _p32._0._3, newStyleBlock),
									_1: {ctor: '[]'}
								};
							}
						case 'PageRule':
							return declarations;
						case 'FontFace':
							return declarations;
						case 'Keyframes':
							return declarations;
						case 'Viewport':
							return declarations;
						case 'CounterStyle':
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v18_15;
				}
			}
		} while(false);
		return {
			ctor: '::',
			_0: _p32._0,
			_1: A2(_rtfeldman$elm_css$Css_Structure$extendLastSelector, selector, _p32._1)
		};
	});
var _rtfeldman$elm_css$Css_Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			_rtfeldman$elm_css$Css_Structure$appendToLastSelector,
			_rtfeldman$elm_css$Css_Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var _rtfeldman$elm_css$Css_Structure$AttributeSelector = function (a) {
	return {ctor: 'AttributeSelector', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$PseudoClassSelector = function (a) {
	return {ctor: 'PseudoClassSelector', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$IdSelector = function (a) {
	return {ctor: 'IdSelector', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$ClassSelector = function (a) {
	return {ctor: 'ClassSelector', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$TypeSelector = function (a) {
	return {ctor: 'TypeSelector', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$PseudoElement = function (a) {
	return {ctor: 'PseudoElement', _0: a};
};
var _rtfeldman$elm_css$Css_Structure$Descendant = {ctor: 'Descendant'};
var _rtfeldman$elm_css$Css_Structure$Child = {ctor: 'Child'};
var _rtfeldman$elm_css$Css_Structure$GeneralSibling = {ctor: 'GeneralSibling'};
var _rtfeldman$elm_css$Css_Structure$AdjacentSibling = {ctor: 'AdjacentSibling'};

var _rtfeldman$elm_css$Css_Preprocess$toPropertyStrings = function (styles) {
	toPropertyStrings:
	while (true) {
		var _p0 = styles;
		if (_p0.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			switch (_p0._0.ctor) {
				case 'AppendProperty':
					return {
						ctor: '::',
						_0: _p0._0._0,
						_1: _rtfeldman$elm_css$Css_Preprocess$toPropertyStrings(_p0._1)
					};
				case 'ApplyStyles':
					return A2(
						_elm_lang$core$Basics_ops['++'],
						_rtfeldman$elm_css$Css_Preprocess$toPropertyStrings(_p0._0._0),
						_rtfeldman$elm_css$Css_Preprocess$toPropertyStrings(_p0._1));
				default:
					var _v1 = _p0._1;
					styles = _v1;
					continue toPropertyStrings;
			}
		}
	}
};
var _rtfeldman$elm_css$Css_Preprocess$unwrapSnippet = function (_p1) {
	var _p2 = _p1;
	return _p2._0;
};
var _rtfeldman$elm_css$Css_Preprocess$toMediaRule = F2(
	function (mediaQueries, declaration) {
		var _p3 = declaration;
		switch (_p3.ctor) {
			case 'StyleBlockDeclaration':
				return A2(
					_rtfeldman$elm_css$Css_Structure$MediaRule,
					mediaQueries,
					{
						ctor: '::',
						_0: _p3._0,
						_1: {ctor: '[]'}
					});
			case 'MediaRule':
				return A2(
					_rtfeldman$elm_css$Css_Structure$MediaRule,
					A2(_elm_lang$core$Basics_ops['++'], mediaQueries, _p3._0),
					_p3._1);
			case 'SupportsRule':
				return A2(
					_rtfeldman$elm_css$Css_Structure$SupportsRule,
					_p3._0,
					A2(
						_elm_lang$core$List$map,
						_rtfeldman$elm_css$Css_Preprocess$toMediaRule(mediaQueries),
						_p3._1));
			case 'DocumentRule':
				return A5(_rtfeldman$elm_css$Css_Structure$DocumentRule, _p3._0, _p3._1, _p3._2, _p3._3, _p3._4);
			case 'PageRule':
				return declaration;
			case 'FontFace':
				return declaration;
			case 'Keyframes':
				return declaration;
			case 'Viewport':
				return declaration;
			case 'CounterStyle':
				return declaration;
			default:
				return declaration;
		}
	});
var _rtfeldman$elm_css$Css_Preprocess$stylesheet = function (snippets) {
	return {
		charset: _elm_lang$core$Maybe$Nothing,
		imports: {ctor: '[]'},
		namespaces: {ctor: '[]'},
		snippets: snippets
	};
};
var _rtfeldman$elm_css$Css_Preprocess$Stylesheet = F4(
	function (a, b, c, d) {
		return {charset: a, imports: b, namespaces: c, snippets: d};
	});
var _rtfeldman$elm_css$Css_Preprocess$ApplyStyles = function (a) {
	return {ctor: 'ApplyStyles', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$WithKeyframes = function (a) {
	return {ctor: 'WithKeyframes', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$WithMedia = F2(
	function (a, b) {
		return {ctor: 'WithMedia', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {ctor: 'WithPseudoElement', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Preprocess$NestSnippet = F2(
	function (a, b) {
		return {ctor: 'NestSnippet', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {ctor: 'ExtendSelector', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Preprocess$AppendProperty = function (a) {
	return {ctor: 'AppendProperty', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$mapLastProperty = F2(
	function (update, style) {
		var _p4 = style;
		switch (_p4.ctor) {
			case 'AppendProperty':
				return _rtfeldman$elm_css$Css_Preprocess$AppendProperty(
					update(_p4._0));
			case 'ExtendSelector':
				return A2(
					_rtfeldman$elm_css$Css_Preprocess$ExtendSelector,
					_p4._0,
					A2(_rtfeldman$elm_css$Css_Preprocess$mapAllLastProperty, update, _p4._1));
			case 'NestSnippet':
				return style;
			case 'WithPseudoElement':
				return style;
			case 'WithMedia':
				return style;
			case 'WithKeyframes':
				return style;
			default:
				return _rtfeldman$elm_css$Css_Preprocess$ApplyStyles(
					A2(
						_rtfeldman$elm_css$Css_Structure$mapLast,
						_rtfeldman$elm_css$Css_Preprocess$mapLastProperty(update),
						_p4._0));
		}
	});
var _rtfeldman$elm_css$Css_Preprocess$mapAllLastProperty = F2(
	function (update, styles) {
		var _p5 = styles;
		if (_p5.ctor === '[]') {
			return styles;
		} else {
			if (_p5._1.ctor === '[]') {
				return {
					ctor: '::',
					_0: A2(_rtfeldman$elm_css$Css_Preprocess$mapLastProperty, update, _p5._0),
					_1: {ctor: '[]'}
				};
			} else {
				return {
					ctor: '::',
					_0: _p5._0,
					_1: A2(_rtfeldman$elm_css$Css_Preprocess$mapAllLastProperty, update, _p5._1)
				};
			}
		}
	});
var _rtfeldman$elm_css$Css_Preprocess$Snippet = function (a) {
	return {ctor: 'Snippet', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$FontFeatureValues = function (a) {
	return {ctor: 'FontFeatureValues', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$CounterStyle = function (a) {
	return {ctor: 'CounterStyle', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$Viewport = function (a) {
	return {ctor: 'Viewport', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$FontFace = function (a) {
	return {ctor: 'FontFace', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$PageRule = F2(
	function (a, b) {
		return {ctor: 'PageRule', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Preprocess$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {ctor: 'DocumentRule', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _rtfeldman$elm_css$Css_Preprocess$SupportsRule = F2(
	function (a, b) {
		return {ctor: 'SupportsRule', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Preprocess$MediaRule = F2(
	function (a, b) {
		return {ctor: 'MediaRule', _0: a, _1: b};
	});
var _rtfeldman$elm_css$Css_Preprocess$StyleBlockDeclaration = function (a) {
	return {ctor: 'StyleBlockDeclaration', _0: a};
};
var _rtfeldman$elm_css$Css_Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {ctor: 'StyleBlock', _0: a, _1: b, _2: c};
	});

var _rtfeldman$elm_css$Css_Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			value: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(numericValue),
				unitLabel),
			numericValue: numericValue,
			units: units,
			unitLabel: unitLabel,
			length: _rtfeldman$elm_css$Css_Structure$Compatible,
			lengthOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible,
			lengthOrNumber: _rtfeldman$elm_css$Css_Structure$Compatible,
			lengthOrNone: _rtfeldman$elm_css$Css_Structure$Compatible,
			lengthOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible,
			lengthOrNoneOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible,
			textIndent: _rtfeldman$elm_css$Css_Structure$Compatible,
			flexBasis: _rtfeldman$elm_css$Css_Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible,
			fontSize: _rtfeldman$elm_css$Css_Structure$Compatible,
			absoluteLength: _rtfeldman$elm_css$Css_Structure$Compatible,
			lengthOrAutoOrCoverOrContain: _rtfeldman$elm_css$Css_Structure$Compatible,
			calc: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css_Internal$property = F2(
	function (key, value) {
		return _rtfeldman$elm_css$Css_Preprocess$AppendProperty(
			A2(
				_elm_lang$core$Basics_ops['++'],
				key,
				A2(_elm_lang$core$Basics_ops['++'], ':', value)));
	});
var _rtfeldman$elm_css$Css_Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			var _p0 = style;
			switch (_p0.ctor) {
				case 'AppendProperty':
					var key = A2(
						_elm_lang$core$Maybe$withDefault,
						'',
						_elm_lang$core$List$head(
							A2(_elm_lang$core$String$split, ':', _p0._0)));
					return A2(_rtfeldman$elm_css$Css_Internal$property, desiredKey, key);
				case 'ExtendSelector':
					return A2(
						_rtfeldman$elm_css$Css_Internal$property,
						desiredKey,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'elm-css-error-cannot-apply-',
							A2(_elm_lang$core$Basics_ops['++'], functionName, '-with-inapplicable-Style-for-selector')));
				case 'NestSnippet':
					return A2(
						_rtfeldman$elm_css$Css_Internal$property,
						desiredKey,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'elm-css-error-cannot-apply-',
							A2(_elm_lang$core$Basics_ops['++'], functionName, '-with-inapplicable-Style-for-combinator')));
				case 'WithPseudoElement':
					return A2(
						_rtfeldman$elm_css$Css_Internal$property,
						desiredKey,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'elm-css-error-cannot-apply-',
							A2(_elm_lang$core$Basics_ops['++'], functionName, '-with-inapplicable-Style-for-pseudo-element setter')));
				case 'WithMedia':
					return A2(
						_rtfeldman$elm_css$Css_Internal$property,
						desiredKey,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'elm-css-error-cannot-apply-',
							A2(_elm_lang$core$Basics_ops['++'], functionName, '-with-inapplicable-Style-for-media-query')));
				case 'WithKeyframes':
					return A2(
						_rtfeldman$elm_css$Css_Internal$property,
						desiredKey,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'elm-css-error-cannot-apply-',
							A2(_elm_lang$core$Basics_ops['++'], functionName, '-with-inapplicable-Style-for-keyframes')));
				default:
					if (_p0._0.ctor === '[]') {
						return A2(
							_rtfeldman$elm_css$Css_Internal$property,
							desiredKey,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'elm-css-error-cannot-apply-',
								A2(_elm_lang$core$Basics_ops['++'], functionName, '-with-empty-Style')));
					} else {
						if (_p0._0._1.ctor === '[]') {
							var _v1 = functionName,
								_v2 = desiredKey,
								_v3 = _p0._0._0;
							functionName = _v1;
							desiredKey = _v2;
							style = _v3;
							continue getOverloadedProperty;
						} else {
							var _v4 = functionName,
								_v5 = desiredKey,
								_v6 = _rtfeldman$elm_css$Css_Preprocess$ApplyStyles(_p0._0._1);
							functionName = _v4;
							desiredKey = _v5;
							style = _v6;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var _rtfeldman$elm_css$Css_Internal$printKeyframeSelector = function (_p1) {
	var _p2 = _p1;
	var propertiesStr = A2(
		_elm_lang$core$String$join,
		'',
		A2(
			_elm_lang$core$List$map,
			function (_p3) {
				var _p4 = _p3;
				return A2(_elm_lang$core$Basics_ops['++'], _p4._0, ';');
			},
			_p2._1));
	var percentageStr = A2(
		_elm_lang$core$Basics_ops['++'],
		_elm_lang$core$Basics$toString(_p2._0),
		'%');
	return A2(
		_elm_lang$core$Basics_ops['++'],
		percentageStr,
		A2(
			_elm_lang$core$Basics_ops['++'],
			' {',
			A2(_elm_lang$core$Basics_ops['++'], propertiesStr, '}')));
};
var _rtfeldman$elm_css$Css_Internal$compileKeyframes = function (tuples) {
	return A2(
		_elm_lang$core$String$join,
		'\n\n',
		A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Internal$printKeyframeSelector, tuples));
};
var _rtfeldman$elm_css$Css_Internal$ExplicitLength = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return {value: a, numericValue: b, units: c, unitLabel: d, length: e, lengthOrAuto: f, lengthOrNumber: g, lengthOrNone: h, lengthOrMinMaxDimension: i, lengthOrNoneOrMinMaxDimension: j, textIndent: k, flexBasis: l, absoluteLength: m, lengthOrNumberOrAutoOrNoneOrContent: n, fontSize: o, lengthOrAutoOrCoverOrContain: p, calc: q};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _rtfeldman$elm_css$Css_Internal$IncompatibleUnits = {ctor: 'IncompatibleUnits'};
var _rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty = A3(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css_Internal$IncompatibleUnits, '', 0);
var _rtfeldman$elm_css$Css_Internal$Property = function (a) {
	return {ctor: 'Property', _0: a};
};

var _rtfeldman$elm_css$Css_Animations$property = F2(
	function (key, value) {
		return _rtfeldman$elm_css$Css_Internal$Property(
			A2(
				_elm_lang$core$Basics_ops['++'],
				key,
				A2(_elm_lang$core$Basics_ops['++'], ':', value)));
	});
var _rtfeldman$elm_css$Css_Animations$transform = function (values) {
	return _rtfeldman$elm_css$Css_Internal$Property(
		_elm_lang$core$List$isEmpty(values) ? 'transform:none' : A2(
			_elm_lang$core$Basics_ops['++'],
			'transform:',
			A2(
				_elm_lang$core$String$join,
				' ',
				A2(
					_elm_lang$core$List$map,
					function (_) {
						return _.value;
					},
					values))));
};
var _rtfeldman$elm_css$Css_Animations$opacity = function (_p0) {
	var _p1 = _p0;
	return _rtfeldman$elm_css$Css_Internal$Property(
		A2(_elm_lang$core$Basics_ops['++'], 'opacity:', _p1.value));
};
var _rtfeldman$elm_css$Css_Animations$borderBottom3 = F3(
	function (arg1, arg2, arg3) {
		return _rtfeldman$elm_css$Css_Internal$Property(
			A2(
				_elm_lang$core$Basics_ops['++'],
				'border-bottom:',
				A2(
					_elm_lang$core$Basics_ops['++'],
					arg1.value,
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							arg2.value,
							A2(_elm_lang$core$Basics_ops['++'], ' ', arg3.value))))));
	});
var _rtfeldman$elm_css$Css_Animations$borderBottom2 = F2(
	function (arg1, arg2) {
		return _rtfeldman$elm_css$Css_Internal$Property(
			A2(
				_elm_lang$core$Basics_ops['++'],
				'border-bottom:',
				A2(
					_elm_lang$core$Basics_ops['++'],
					arg1.value,
					A2(_elm_lang$core$Basics_ops['++'], ' ', arg2.value))));
	});
var _rtfeldman$elm_css$Css_Animations$borderBottom = function (_p2) {
	var _p3 = _p2;
	return _rtfeldman$elm_css$Css_Internal$Property(
		A2(_elm_lang$core$Basics_ops['++'], 'border-bottom:', _p3.value));
};
var _rtfeldman$elm_css$Css_Animations$border3 = F3(
	function (arg1, arg2, arg3) {
		return _rtfeldman$elm_css$Css_Internal$Property(
			A2(
				_elm_lang$core$Basics_ops['++'],
				'border:',
				A2(
					_elm_lang$core$Basics_ops['++'],
					arg1.value,
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							arg2.value,
							A2(_elm_lang$core$Basics_ops['++'], ' ', arg3.value))))));
	});
var _rtfeldman$elm_css$Css_Animations$border2 = F2(
	function (arg1, arg2) {
		return _rtfeldman$elm_css$Css_Internal$Property(
			A2(
				_elm_lang$core$Basics_ops['++'],
				'border:',
				A2(
					_elm_lang$core$Basics_ops['++'],
					arg1.value,
					A2(_elm_lang$core$Basics_ops['++'], ' ', arg2.value))));
	});
var _rtfeldman$elm_css$Css_Animations$border = function (_p4) {
	var _p5 = _p4;
	return _rtfeldman$elm_css$Css_Internal$Property(
		A2(_elm_lang$core$Basics_ops['++'], 'border:', _p5.value));
};
var _rtfeldman$elm_css$Css_Animations$backgroundSize2 = F2(
	function (arg1, arg2) {
		return _rtfeldman$elm_css$Css_Internal$Property(
			A2(
				_elm_lang$core$Basics_ops['++'],
				'background-size:',
				A2(
					_elm_lang$core$Basics_ops['++'],
					arg1.value,
					A2(_elm_lang$core$Basics_ops['++'], ' ', arg2.value))));
	});
var _rtfeldman$elm_css$Css_Animations$backgroundSize = function (_p6) {
	var _p7 = _p6;
	return _rtfeldman$elm_css$Css_Internal$Property(
		A2(_elm_lang$core$Basics_ops['++'], 'background-size:', _p7.value));
};
var _rtfeldman$elm_css$Css_Animations$backgroundColor = function (_p8) {
	var _p9 = _p8;
	return _rtfeldman$elm_css$Css_Internal$Property(
		A2(_elm_lang$core$Basics_ops['++'], 'background-color:', _p9.value));
};
var _rtfeldman$elm_css$Css_Animations$all = function (_p10) {
	var _p11 = _p10;
	return _rtfeldman$elm_css$Css_Internal$Property(
		A2(_elm_lang$core$Basics_ops['++'], 'all:', _p11.value));
};
var _rtfeldman$elm_css$Css_Animations$custom = F2(
	function (name, value) {
		return _rtfeldman$elm_css$Css_Internal$Property(
			A2(
				_elm_lang$core$Basics_ops['++'],
				name,
				A2(_elm_lang$core$Basics_ops['++'], ':', value)));
	});
var _rtfeldman$elm_css$Css_Animations$keyframes = function (tuples) {
	return _elm_lang$core$List$isEmpty(tuples) ? {value: 'none', none: _rtfeldman$elm_css$Css_Structure$Compatible, keyframes: _rtfeldman$elm_css$Css_Structure$Compatible} : {
		value: _rtfeldman$elm_css$Css_Internal$compileKeyframes(tuples),
		none: _rtfeldman$elm_css$Css_Structure$Compatible,
		keyframes: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};

var _rtfeldman$hex$Hex$toString = function (num) {
	return _elm_lang$core$String$fromList(
		(_elm_lang$core$Native_Utils.cmp(num, 0) < 0) ? {
			ctor: '::',
			_0: _elm_lang$core$Native_Utils.chr('-'),
			_1: A2(
				_rtfeldman$hex$Hex$unsafePositiveToDigits,
				{ctor: '[]'},
				_elm_lang$core$Basics$negate(num))
		} : A2(
			_rtfeldman$hex$Hex$unsafePositiveToDigits,
			{ctor: '[]'},
			num));
};
var _rtfeldman$hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(num, 16) < 0) {
				return {
					ctor: '::',
					_0: _rtfeldman$hex$Hex$unsafeToDigit(num),
					_1: digits
				};
			} else {
				var _v0 = {
					ctor: '::',
					_0: _rtfeldman$hex$Hex$unsafeToDigit(
						A2(_elm_lang$core$Basics_ops['%'], num, 16)),
					_1: digits
				},
					_v1 = (num / 16) | 0;
				digits = _v0;
				num = _v1;
				continue unsafePositiveToDigits;
			}
		}
	});
var _rtfeldman$hex$Hex$unsafeToDigit = function (num) {
	var _p0 = num;
	switch (_p0) {
		case 0:
			return _elm_lang$core$Native_Utils.chr('0');
		case 1:
			return _elm_lang$core$Native_Utils.chr('1');
		case 2:
			return _elm_lang$core$Native_Utils.chr('2');
		case 3:
			return _elm_lang$core$Native_Utils.chr('3');
		case 4:
			return _elm_lang$core$Native_Utils.chr('4');
		case 5:
			return _elm_lang$core$Native_Utils.chr('5');
		case 6:
			return _elm_lang$core$Native_Utils.chr('6');
		case 7:
			return _elm_lang$core$Native_Utils.chr('7');
		case 8:
			return _elm_lang$core$Native_Utils.chr('8');
		case 9:
			return _elm_lang$core$Native_Utils.chr('9');
		case 10:
			return _elm_lang$core$Native_Utils.chr('a');
		case 11:
			return _elm_lang$core$Native_Utils.chr('b');
		case 12:
			return _elm_lang$core$Native_Utils.chr('c');
		case 13:
			return _elm_lang$core$Native_Utils.chr('d');
		case 14:
			return _elm_lang$core$Native_Utils.chr('e');
		case 15:
			return _elm_lang$core$Native_Utils.chr('f');
		default:
			return _elm_lang$core$Native_Utils.crashCase(
				'Hex',
				{
					start: {line: 138, column: 5},
					end: {line: 188, column: 84}
				},
				_p0)(
				A2(
					_elm_lang$core$Basics_ops['++'],
					'Tried to convert ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_rtfeldman$hex$Hex$toString(num),
						' to hexadecimal.')));
	}
};
var _rtfeldman$hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		var _p2 = chars;
		if (_p2.ctor === '[]') {
			return _elm_lang$core$Result$Ok(accumulated);
		} else {
			var recurse = function (additional) {
				return A3(
					_rtfeldman$hex$Hex$fromStringHelp,
					position - 1,
					_p2._1,
					accumulated + (additional * Math.pow(16, position)));
			};
			var _p3 = _p2._0;
			switch (_p3.valueOf()) {
				case '0':
					return recurse(0);
				case '1':
					return recurse(1);
				case '2':
					return recurse(2);
				case '3':
					return recurse(3);
				case '4':
					return recurse(4);
				case '5':
					return recurse(5);
				case '6':
					return recurse(6);
				case '7':
					return recurse(7);
				case '8':
					return recurse(8);
				case '9':
					return recurse(9);
				case 'a':
					return recurse(10);
				case 'b':
					return recurse(11);
				case 'c':
					return recurse(12);
				case 'd':
					return recurse(13);
				case 'e':
					return recurse(14);
				case 'f':
					return recurse(15);
				default:
					return _elm_lang$core$Result$Err(
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p3),
							' is not a valid hexadecimal character.'));
			}
		}
	});
var _rtfeldman$hex$Hex$fromString = function (str) {
	if (_elm_lang$core$String$isEmpty(str)) {
		return _elm_lang$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var formatError = function (err) {
			return A2(
				_elm_lang$core$String$join,
				' ',
				{
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(str),
					_1: {
						ctor: '::',
						_0: 'is not a valid hexadecimal string because',
						_1: {
							ctor: '::',
							_0: err,
							_1: {ctor: '[]'}
						}
					}
				});
		};
		var result = function () {
			if (A2(_elm_lang$core$String$startsWith, '-', str)) {
				var list = A2(
					_elm_lang$core$Maybe$withDefault,
					{ctor: '[]'},
					_elm_lang$core$List$tail(
						_elm_lang$core$String$toList(str)));
				return A2(
					_elm_lang$core$Result$map,
					_elm_lang$core$Basics$negate,
					A3(
						_rtfeldman$hex$Hex$fromStringHelp,
						_elm_lang$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					_rtfeldman$hex$Hex$fromStringHelp,
					_elm_lang$core$String$length(str) - 1,
					_elm_lang$core$String$toList(str),
					0);
			}
		}();
		return A2(_elm_lang$core$Result$mapError, formatError, result);
	}
};

var _rtfeldman$elm_css$Css$stroke = {value: 'stroke', pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$painted = {value: 'painted', pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$visibleStroke = {value: 'visibleStroke', pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$visibleFill = {value: 'visibleFill', pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$visiblePainted = {value: 'visiblePainted', pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$manipulation = {value: 'manipulation', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$pinchZoom = {value: 'pinch-zoom', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$panDown = {value: 'pan-down', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$panUp = {value: 'pan-up', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$panY = {value: 'pan-y', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$panRight = {value: 'pan-right', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$panLeft = {value: 'pan-left', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$panX = {value: 'pan-x', touchAction: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$stringsToValue = function (list) {
	return _elm_lang$core$List$isEmpty(list) ? {value: 'none'} : {
		value: A2(
			_elm_lang$core$String$join,
			', ',
			A2(
				_elm_lang$core$List$map,
				function (s) {
					return s;
				},
				list))
	};
};
var _rtfeldman$elm_css$Css$valuesOrNone = function (list) {
	return _elm_lang$core$List$isEmpty(list) ? {value: 'none'} : {
		value: A2(
			_elm_lang$core$String$join,
			' ',
			A2(
				_elm_lang$core$List$map,
				function (_) {
					return _.value;
				},
				list))
	};
};
var _rtfeldman$elm_css$Css$numericalPercentageToString = function (value) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_elm_lang$core$Basics$toString(value * 100),
		'%');
};
var _rtfeldman$elm_css$Css$stringToInt = function (str) {
	return A2(
		_elm_lang$core$Result$withDefault,
		0,
		_elm_lang$core$String$toInt(str));
};
var _rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return _rtfeldman$elm_css$Css_Preprocess$WithPseudoElement(
		_rtfeldman$elm_css$Css_Structure$PseudoElement(element));
};
var _rtfeldman$elm_css$Css$after = _rtfeldman$elm_css$Css$pseudoElement('after');
var _rtfeldman$elm_css$Css$before = _rtfeldman$elm_css$Css$pseudoElement('before');
var _rtfeldman$elm_css$Css$firstLetter = _rtfeldman$elm_css$Css$pseudoElement('first-letter');
var _rtfeldman$elm_css$Css$firstLine = _rtfeldman$elm_css$Css$pseudoElement('first-line');
var _rtfeldman$elm_css$Css$selection = _rtfeldman$elm_css$Css$pseudoElement('selection');
var _rtfeldman$elm_css$Css$pseudoClass = function ($class) {
	return _rtfeldman$elm_css$Css_Preprocess$ExtendSelector(
		_rtfeldman$elm_css$Css_Structure$PseudoClassSelector($class));
};
var _rtfeldman$elm_css$Css$active = _rtfeldman$elm_css$Css$pseudoClass('active');
var _rtfeldman$elm_css$Css$any = function (str) {
	return _rtfeldman$elm_css$Css$pseudoClass(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'any(',
			A2(_elm_lang$core$Basics_ops['++'], str, ')')));
};
var _rtfeldman$elm_css$Css$checked = _rtfeldman$elm_css$Css$pseudoClass('checked');
var _rtfeldman$elm_css$Css$disabled = _rtfeldman$elm_css$Css$pseudoClass('disabled');
var _rtfeldman$elm_css$Css$empty = _rtfeldman$elm_css$Css$pseudoClass('empty');
var _rtfeldman$elm_css$Css$enabled = _rtfeldman$elm_css$Css$pseudoClass('enabled');
var _rtfeldman$elm_css$Css$first = _rtfeldman$elm_css$Css$pseudoClass('first');
var _rtfeldman$elm_css$Css$firstChild = _rtfeldman$elm_css$Css$pseudoClass('first-child');
var _rtfeldman$elm_css$Css$firstOfType = _rtfeldman$elm_css$Css$pseudoClass('first-of-type');
var _rtfeldman$elm_css$Css$fullscreen = _rtfeldman$elm_css$Css$pseudoClass('fullscreen');
var _rtfeldman$elm_css$Css$focus = _rtfeldman$elm_css$Css$pseudoClass('focus');
var _rtfeldman$elm_css$Css$hover = _rtfeldman$elm_css$Css$pseudoClass('hover');
var _rtfeldman$elm_css$Css$visited = _rtfeldman$elm_css$Css$pseudoClass('visited');
var _rtfeldman$elm_css$Css$indeterminate = _rtfeldman$elm_css$Css$pseudoClass('indeterminate');
var _rtfeldman$elm_css$Css$invalid = _rtfeldman$elm_css$Css$pseudoClass('invalid');
var _rtfeldman$elm_css$Css$lang = function (str) {
	return _rtfeldman$elm_css$Css$pseudoClass(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'lang(',
			A2(_elm_lang$core$Basics_ops['++'], str, ')')));
};
var _rtfeldman$elm_css$Css$lastChild = _rtfeldman$elm_css$Css$pseudoClass('last-child');
var _rtfeldman$elm_css$Css$lastOfType = _rtfeldman$elm_css$Css$pseudoClass('last-of-type');
var _rtfeldman$elm_css$Css$link = _rtfeldman$elm_css$Css$pseudoClass('link');
var _rtfeldman$elm_css$Css$nthChild = function (str) {
	return _rtfeldman$elm_css$Css$pseudoClass(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'nth-child(',
			A2(_elm_lang$core$Basics_ops['++'], str, ')')));
};
var _rtfeldman$elm_css$Css$nthLastChild = function (str) {
	return _rtfeldman$elm_css$Css$pseudoClass(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'nth-last-child(',
			A2(_elm_lang$core$Basics_ops['++'], str, ')')));
};
var _rtfeldman$elm_css$Css$nthLastOfType = function (str) {
	return _rtfeldman$elm_css$Css$pseudoClass(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'nth-last-of-type(',
			A2(_elm_lang$core$Basics_ops['++'], str, ')')));
};
var _rtfeldman$elm_css$Css$nthOfType = function (str) {
	return _rtfeldman$elm_css$Css$pseudoClass(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'nth-of-type(',
			A2(_elm_lang$core$Basics_ops['++'], str, ')')));
};
var _rtfeldman$elm_css$Css$onlyChild = _rtfeldman$elm_css$Css$pseudoClass('only-child');
var _rtfeldman$elm_css$Css$onlyOfType = _rtfeldman$elm_css$Css$pseudoClass('only-of-type');
var _rtfeldman$elm_css$Css$optional = _rtfeldman$elm_css$Css$pseudoClass('optional');
var _rtfeldman$elm_css$Css$outOfRange = _rtfeldman$elm_css$Css$pseudoClass('out-of-range');
var _rtfeldman$elm_css$Css$readWrite = _rtfeldman$elm_css$Css$pseudoClass('read-write');
var _rtfeldman$elm_css$Css$required = _rtfeldman$elm_css$Css$pseudoClass('required');
var _rtfeldman$elm_css$Css$root = _rtfeldman$elm_css$Css$pseudoClass('root');
var _rtfeldman$elm_css$Css$scope = _rtfeldman$elm_css$Css$pseudoClass('scope');
var _rtfeldman$elm_css$Css$target = _rtfeldman$elm_css$Css$pseudoClass('target');
var _rtfeldman$elm_css$Css$valid = _rtfeldman$elm_css$Css$pseudoClass('valid');
var _rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return _rtfeldman$elm_css$Css_Preprocess$AppendProperty(
			A2(
				_elm_lang$core$Basics_ops['++'],
				key,
				A2(_elm_lang$core$Basics_ops['++'], ':', value)));
	});
var _rtfeldman$elm_css$Css$pointerEventsFill = A2(_rtfeldman$elm_css$Css$property, 'pointer-events', 'fill');
var _rtfeldman$elm_css$Css$pointerEventsAll = A2(_rtfeldman$elm_css$Css$property, 'pointer-events', 'all');
var _rtfeldman$elm_css$Css$batch = _rtfeldman$elm_css$Css_Preprocess$ApplyStyles;
var _rtfeldman$elm_css$Css$preLine = {value: 'pre-line', whiteSpace: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$preWrap = {value: 'pre-wrap', whiteSpace: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$pre = {value: 'pre', whiteSpace: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$grabbing = {value: 'grabbing', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$grab = {value: 'grab', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$zoomOut = {value: 'zoom-out', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$zoomIn = {value: 'zoom-in', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$allScroll = {value: 'all-scroll', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$rowResize = {value: 'row-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$colResize = {value: 'col-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$nwseResize = {value: 'nwse-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$neswResize = {value: 'nesw-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$nsResize = {value: 'ns-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$ewResize = {value: 'ew-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$wResize = {value: 'w-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$swResize = {value: 'sw-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$seResize = {value: 'se-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$sResize = {value: 's-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$nwResize = {value: 'nw-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$neResize = {value: 'ne-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$nResize = {value: 'n-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$eResize = {value: 'e-resize', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$notAllowed = {value: 'not-allowed', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$noDrop = {value: 'no-drop', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$move = {value: 'move', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$copy = {value: 'copy', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$cursorAlias = {value: 'alias', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$verticalText = {value: 'vertical-text', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$text_ = {value: 'text', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$cell = {value: 'cell', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$wait = {value: 'wait', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$progress = {value: 'progress', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$pointer = {value: 'pointer', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$help = {value: 'help', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$contextMenu = {value: 'context-menu', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$crosshair = {value: 'crosshair', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$default = {value: 'default', cursor: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$fontWeight = function (_p0) {
	var _p1 = _p0;
	return A2(_rtfeldman$elm_css$Css$property, 'font-weight', _p1.value);
};
var _rtfeldman$elm_css$Css$fontFeatureSettingsList = function (featureTagValues) {
	return A2(
		_rtfeldman$elm_css$Css$property,
		'font-feature-settings',
		A2(
			_elm_lang$core$String$join,
			', ',
			A2(
				_elm_lang$core$List$map,
				function (_) {
					return _.value;
				},
				featureTagValues)));
};
var _rtfeldman$elm_css$Css$fontFeatureSettings = function (_p2) {
	var _p3 = _p2;
	return A2(_rtfeldman$elm_css$Css$property, 'font-feature-settings', _p3.value);
};
var _rtfeldman$elm_css$Css$qt = function (str) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		'\"',
		A2(_elm_lang$core$Basics_ops['++'], str, '\"'));
};
var _rtfeldman$elm_css$Css$fontFace = function (value) {
	return A2(_elm_lang$core$Basics_ops['++'], 'font-face ', value);
};
var _rtfeldman$elm_css$Css$src_ = function (value) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		'\"',
		A2(_elm_lang$core$Basics_ops['++'], value.value, '\"'));
};
var _rtfeldman$elm_css$Css$color = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'color', c.value);
};
var _rtfeldman$elm_css$Css$backgroundPosition = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'backgroundPosition',
		'background-position',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'background-color', c.value);
};
var _rtfeldman$elm_css$Css$outlineColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'outline-color', c.value);
};
var _rtfeldman$elm_css$Css$borderColor4 = F4(
	function (c1, c2, c3, c4) {
		var value = A2(
			_elm_lang$core$String$join,
			' ',
			{
				ctor: '::',
				_0: c1.value,
				_1: {
					ctor: '::',
					_0: c2.value,
					_1: {
						ctor: '::',
						_0: c3.value,
						_1: {
							ctor: '::',
							_0: c4.value,
							_1: {ctor: '[]'}
						}
					}
				}
			});
		return A2(_rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var _rtfeldman$elm_css$Css$borderColor3 = F3(
	function (c1, c2, c3) {
		var value = A2(
			_elm_lang$core$String$join,
			' ',
			{
				ctor: '::',
				_0: c1.value,
				_1: {
					ctor: '::',
					_0: c2.value,
					_1: {
						ctor: '::',
						_0: c3.value,
						_1: {ctor: '[]'}
					}
				}
			});
		return A2(_rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var _rtfeldman$elm_css$Css$borderColor2 = F2(
	function (c1, c2) {
		var value = A2(
			_elm_lang$core$String$join,
			' ',
			{
				ctor: '::',
				_0: c1.value,
				_1: {
					ctor: '::',
					_0: c2.value,
					_1: {ctor: '[]'}
				}
			});
		return A2(_rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var _rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'border-color', c.value);
};
var _rtfeldman$elm_css$Css$borderTopColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'border-top-color', c.value);
};
var _rtfeldman$elm_css$Css$borderRightColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'border-right-color', c.value);
};
var _rtfeldman$elm_css$Css$borderLeftColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'border-left-color', c.value);
};
var _rtfeldman$elm_css$Css$borderInlineEndColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'border-inline-end-color', c.value);
};
var _rtfeldman$elm_css$Css$borderInlineStartColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'border-inline-start-color', c.value);
};
var _rtfeldman$elm_css$Css$borderBottomColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'border-bottom-color', c.value);
};
var _rtfeldman$elm_css$Css$featureTag2 = F2(
	function (tag, value) {
		return {
			value: A2(
				_elm_lang$core$Basics_ops['++'],
				'\"',
				A2(
					_elm_lang$core$Basics_ops['++'],
					tag,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'\" ',
						_elm_lang$core$Basics$toString(value)))),
			featureTagValue: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$featureTag = function (tag) {
	return A2(_rtfeldman$elm_css$Css$featureTag2, tag, 1);
};
var _rtfeldman$elm_css$Css$featureOff = 0;
var _rtfeldman$elm_css$Css$featureOn = 1;
var _rtfeldman$elm_css$Css$slashedZero = {value: 'slashed-zero', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$ordinal = {value: 'ordinal', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$stackedFractions = {value: 'stacked-fractions', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$diagonalFractions = {value: 'diagonal-fractions', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tabularNums = {value: 'tabular-nums', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$proportionalNums = {value: 'proportional-nums', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$oldstyleNums = {value: 'oldstyle-nums', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$liningNums = {value: 'lining-nums', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantNumeric: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$noContextual = {value: 'no-contextual', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$contextual = {value: 'context', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$noHistoricalLigatures = {value: 'no-historical-ligatures', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$historicalLigatures = {value: 'historical-ligatures', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$noDiscretionaryLigatures = {value: 'no-discretionary-ligatures', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$discretionaryLigatures = {value: 'discretionary-ligatures', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$noCommonLigatures = {value: 'no-common-ligatures', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$commonLigatures = {value: 'common-ligatures', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantLigatures: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$titlingCaps = {value: 'titling-caps', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantCaps: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$unicase = {value: 'unicase', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantCaps: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$allPetiteCaps = {value: 'all-petite-caps', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantCaps: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$petiteCaps = {value: 'petite-caps', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantCaps: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$allSmallCaps = {value: 'all-small-caps', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantCaps: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$smallCaps = {value: 'small-caps', fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariantCaps: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$bolder = {value: 'bolder', fontWeight: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lighter = {value: 'lighter', fontWeight: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$bold = {value: 'bold', fontWeight: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$oblique = {value: 'oblique', fontStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$italic = {value: 'italic', fontStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$normal = {value: 'normal', fontStyle: _rtfeldman$elm_css$Css_Structure$Compatible, fontWeight: _rtfeldman$elm_css$Css_Structure$Compatible, featureTagValue: _rtfeldman$elm_css$Css_Structure$Compatible, overflowWrap: _rtfeldman$elm_css$Css_Structure$Compatible, whiteSpace: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$larger = {value: 'larger', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$smaller = {value: 'smaller', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$xxLarge = {value: 'xx-large', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$xLarge = {value: 'x-large', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$large = {value: 'large', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$medium = {value: 'medium', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$small = {value: 'small', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$xSmall = {value: 'x-small', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$xxSmall = {value: 'xx-small', fontSize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$fantasy = {value: 'fantasy', fontFamily: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$cursive = {value: 'cursive', fontFamily: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$monospace = {value: 'monospace', fontFamily: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$sansSerif = {value: 'sans-serif', fontFamily: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$serif = {value: 'serif', fontFamily: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$absolute = {value: 'absolute', position: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$relative = {value: 'relative', position: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$sticky = {value: 'sticky', position: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$fixed = {value: 'fixed', position: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundAttachment: _rtfeldman$elm_css$Css_Structure$Compatible, tableLayout: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$static = {value: 'static', position: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$fillAvailable = {value: 'fill-available', minMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNoneOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$fitContent = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$fillAvailable,
	{value: 'fit-content'});
var _rtfeldman$elm_css$Css$minContent = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$fillAvailable,
	{value: 'min-content'});
var _rtfeldman$elm_css$Css$maxContent = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$fillAvailable,
	{value: 'max-content'});
var _rtfeldman$elm_css$Css$displayFlex = A2(_rtfeldman$elm_css$Css$property, 'display', 'flex');
var _rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$textAlignLast = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'textAlignLast',
		'text-align-last',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$textEmphasisColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'text-emphasis-color', c.value);
};
var _rtfeldman$elm_css$Css$textDecorationColor = function (c) {
	return A2(_rtfeldman$elm_css$Css$property, 'text-decoration-color', c.value);
};
var _rtfeldman$elm_css$Css$float = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'float',
		'float',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$prop6 = F7(
	function (key, argA, argB, argC, argD, argE, argF) {
		return A2(
			_rtfeldman$elm_css$Css$property,
			key,
			A2(
				_elm_lang$core$String$join,
				' ',
				{
					ctor: '::',
					_0: argA.value,
					_1: {
						ctor: '::',
						_0: argB.value,
						_1: {
							ctor: '::',
							_0: argC.value,
							_1: {
								ctor: '::',
								_0: argD.value,
								_1: {
									ctor: '::',
									_0: argE.value,
									_1: {
										ctor: '::',
										_0: argF.value,
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}));
	});
var _rtfeldman$elm_css$Css$boxShadow6 = _rtfeldman$elm_css$Css$prop6('box-shadow');
var _rtfeldman$elm_css$Css$prop5 = F6(
	function (key, argA, argB, argC, argD, argE) {
		return A2(
			_rtfeldman$elm_css$Css$property,
			key,
			A2(
				_elm_lang$core$String$join,
				' ',
				{
					ctor: '::',
					_0: argA.value,
					_1: {
						ctor: '::',
						_0: argB.value,
						_1: {
							ctor: '::',
							_0: argC.value,
							_1: {
								ctor: '::',
								_0: argD.value,
								_1: {
									ctor: '::',
									_0: argE.value,
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}));
	});
var _rtfeldman$elm_css$Css$boxShadow5 = _rtfeldman$elm_css$Css$prop5('box-shadow');
var _rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2(
			_rtfeldman$elm_css$Css$property,
			key,
			A2(
				_elm_lang$core$String$join,
				' ',
				{
					ctor: '::',
					_0: argA.value,
					_1: {
						ctor: '::',
						_0: argB.value,
						_1: {
							ctor: '::',
							_0: argC.value,
							_1: {
								ctor: '::',
								_0: argD.value,
								_1: {ctor: '[]'}
							}
						}
					}
				}));
	});
var _rtfeldman$elm_css$Css$textShadow4 = _rtfeldman$elm_css$Css$prop4('text-shadow');
var _rtfeldman$elm_css$Css$boxShadow4 = _rtfeldman$elm_css$Css$prop4('box-shadow');
var _rtfeldman$elm_css$Css$padding4 = _rtfeldman$elm_css$Css$prop4('padding');
var _rtfeldman$elm_css$Css$margin4 = _rtfeldman$elm_css$Css$prop4('margin');
var _rtfeldman$elm_css$Css$borderImageOutset4 = _rtfeldman$elm_css$Css$prop4('border-image-outset');
var _rtfeldman$elm_css$Css$borderImageWidth4 = _rtfeldman$elm_css$Css$prop4('border-image-width');
var _rtfeldman$elm_css$Css$borderWidth4 = _rtfeldman$elm_css$Css$prop4('border-width');
var _rtfeldman$elm_css$Css$borderRadius4 = _rtfeldman$elm_css$Css$prop4('border-radius');
var _rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			_rtfeldman$elm_css$Css$property,
			key,
			A2(
				_elm_lang$core$String$join,
				' ',
				{
					ctor: '::',
					_0: argA.value,
					_1: {
						ctor: '::',
						_0: argB.value,
						_1: {
							ctor: '::',
							_0: argC.value,
							_1: {ctor: '[]'}
						}
					}
				}));
	});
var _rtfeldman$elm_css$Css$textShadow3 = _rtfeldman$elm_css$Css$prop3('text-shadow');
var _rtfeldman$elm_css$Css$boxShadow3 = _rtfeldman$elm_css$Css$prop3('box-shadow');
var _rtfeldman$elm_css$Css$textIndent3 = _rtfeldman$elm_css$Css$prop3('text-indent');
var _rtfeldman$elm_css$Css$padding3 = _rtfeldman$elm_css$Css$prop3('padding');
var _rtfeldman$elm_css$Css$margin3 = _rtfeldman$elm_css$Css$prop3('margin');
var _rtfeldman$elm_css$Css$border3 = _rtfeldman$elm_css$Css$prop3('border');
var _rtfeldman$elm_css$Css$borderTop3 = _rtfeldman$elm_css$Css$prop3('border-top');
var _rtfeldman$elm_css$Css$borderBottom3 = _rtfeldman$elm_css$Css$prop3('border-bottom');
var _rtfeldman$elm_css$Css$borderLeft3 = _rtfeldman$elm_css$Css$prop3('border-left');
var _rtfeldman$elm_css$Css$borderRight3 = _rtfeldman$elm_css$Css$prop3('border-right');
var _rtfeldman$elm_css$Css$borderImageOutset3 = _rtfeldman$elm_css$Css$prop3('border-image-outset');
var _rtfeldman$elm_css$Css$borderImageWidth3 = _rtfeldman$elm_css$Css$prop3('border-image-width');
var _rtfeldman$elm_css$Css$borderWidth3 = _rtfeldman$elm_css$Css$prop3('border-width');
var _rtfeldman$elm_css$Css$borderRadius3 = _rtfeldman$elm_css$Css$prop3('border-radius');
var _rtfeldman$elm_css$Css$outline3 = _rtfeldman$elm_css$Css$prop3('outline');
var _rtfeldman$elm_css$Css$fontVariant3 = _rtfeldman$elm_css$Css$prop3('font-variant');
var _rtfeldman$elm_css$Css$fontVariantNumeric3 = _rtfeldman$elm_css$Css$prop3('font-variant-numeric');
var _rtfeldman$elm_css$Css$textDecoration3 = _rtfeldman$elm_css$Css$prop3('text-decoration');
var _rtfeldman$elm_css$Css$textDecorations3 = function (_p4) {
	return A2(
		_rtfeldman$elm_css$Css$prop3,
		'text-decoration',
		_rtfeldman$elm_css$Css$valuesOrNone(_p4));
};
var _rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			_rtfeldman$elm_css$Css$property,
			key,
			A2(
				_elm_lang$core$String$join,
				' ',
				{
					ctor: '::',
					_0: argA.value,
					_1: {
						ctor: '::',
						_0: argB.value,
						_1: {ctor: '[]'}
					}
				}));
	});
var _rtfeldman$elm_css$Css$textShadow2 = _rtfeldman$elm_css$Css$prop2('text-shadow');
var _rtfeldman$elm_css$Css$boxShadow2 = _rtfeldman$elm_css$Css$prop2('box-shadow');
var _rtfeldman$elm_css$Css$textIndent2 = _rtfeldman$elm_css$Css$prop2('text-indent');
var _rtfeldman$elm_css$Css$padding2 = _rtfeldman$elm_css$Css$prop2('padding');
var _rtfeldman$elm_css$Css$margin2 = _rtfeldman$elm_css$Css$prop2('margin');
var _rtfeldman$elm_css$Css$border2 = _rtfeldman$elm_css$Css$prop2('border');
var _rtfeldman$elm_css$Css$borderTop2 = _rtfeldman$elm_css$Css$prop2('border-top');
var _rtfeldman$elm_css$Css$borderBottom2 = _rtfeldman$elm_css$Css$prop2('border-bottom');
var _rtfeldman$elm_css$Css$borderLeft2 = _rtfeldman$elm_css$Css$prop2('border-left');
var _rtfeldman$elm_css$Css$borderRight2 = _rtfeldman$elm_css$Css$prop2('border-right');
var _rtfeldman$elm_css$Css$borderImageOutset2 = _rtfeldman$elm_css$Css$prop2('border-image-outset');
var _rtfeldman$elm_css$Css$borderImageWidth2 = _rtfeldman$elm_css$Css$prop2('border-image-width');
var _rtfeldman$elm_css$Css$borderWidth2 = _rtfeldman$elm_css$Css$prop2('border-width');
var _rtfeldman$elm_css$Css$borderTopWidth2 = _rtfeldman$elm_css$Css$prop2('border-top-width');
var _rtfeldman$elm_css$Css$borderBottomLeftRadius2 = _rtfeldman$elm_css$Css$prop2('border-bottom-left-radius');
var _rtfeldman$elm_css$Css$borderBottomRightRadius2 = _rtfeldman$elm_css$Css$prop2('border-bottom-right-radius');
var _rtfeldman$elm_css$Css$borderTopLeftRadius2 = _rtfeldman$elm_css$Css$prop2('border-top-left-radius');
var _rtfeldman$elm_css$Css$borderTopRightRadius2 = _rtfeldman$elm_css$Css$prop2('border-top-right-radius');
var _rtfeldman$elm_css$Css$borderRadius2 = _rtfeldman$elm_css$Css$prop2('border-radius');
var _rtfeldman$elm_css$Css$borderSpacing2 = _rtfeldman$elm_css$Css$prop2('border-spacing');
var _rtfeldman$elm_css$Css$backgroundRepeat2 = _rtfeldman$elm_css$Css$prop2('background-repeat');
var _rtfeldman$elm_css$Css$backgroundPosition2 = _rtfeldman$elm_css$Css$prop2('background-position');
var _rtfeldman$elm_css$Css$backgroundSize2 = _rtfeldman$elm_css$Css$prop2('background-size');
var _rtfeldman$elm_css$Css$fontVariant2 = _rtfeldman$elm_css$Css$prop2('font-variant');
var _rtfeldman$elm_css$Css$fontVariantNumeric2 = _rtfeldman$elm_css$Css$prop2('font-variant-numeric');
var _rtfeldman$elm_css$Css$textDecoration2 = _rtfeldman$elm_css$Css$prop2('text-decoration');
var _rtfeldman$elm_css$Css$textDecorations2 = function (_p5) {
	return A2(
		_rtfeldman$elm_css$Css$prop2,
		'text-decoration',
		_rtfeldman$elm_css$Css$valuesOrNone(_p5));
};
var _rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2(_rtfeldman$elm_css$Css$property, key, arg.value);
	});
var _rtfeldman$elm_css$Css$textRendering = _rtfeldman$elm_css$Css$prop1('text-rendering');
var _rtfeldman$elm_css$Css$textOrientation = _rtfeldman$elm_css$Css$prop1('text-orientation');
var _rtfeldman$elm_css$Css$textOverflow = _rtfeldman$elm_css$Css$prop1('text-overflow');
var _rtfeldman$elm_css$Css$textShadow = _rtfeldman$elm_css$Css$prop1('text-shadow');
var _rtfeldman$elm_css$Css$boxShadow = _rtfeldman$elm_css$Css$prop1('box-shadow');
var _rtfeldman$elm_css$Css$textIndent = _rtfeldman$elm_css$Css$prop1('text-indent');
var _rtfeldman$elm_css$Css$textTransform = _rtfeldman$elm_css$Css$prop1('text-transform');
var _rtfeldman$elm_css$Css$display = _rtfeldman$elm_css$Css$prop1('display');
var _rtfeldman$elm_css$Css$opacity = _rtfeldman$elm_css$Css$prop1('opacity');
var _rtfeldman$elm_css$Css$width = _rtfeldman$elm_css$Css$prop1('width');
var _rtfeldman$elm_css$Css$maxWidth = _rtfeldman$elm_css$Css$prop1('max-width');
var _rtfeldman$elm_css$Css$minWidth = _rtfeldman$elm_css$Css$prop1('min-width');
var _rtfeldman$elm_css$Css$height = _rtfeldman$elm_css$Css$prop1('height');
var _rtfeldman$elm_css$Css$minHeight = _rtfeldman$elm_css$Css$prop1('min-height');
var _rtfeldman$elm_css$Css$maxHeight = _rtfeldman$elm_css$Css$prop1('max-height');
var _rtfeldman$elm_css$Css$padding = _rtfeldman$elm_css$Css$prop1('padding');
var _rtfeldman$elm_css$Css$paddingTop = _rtfeldman$elm_css$Css$prop1('padding-top');
var _rtfeldman$elm_css$Css$paddingBottom = _rtfeldman$elm_css$Css$prop1('padding-bottom');
var _rtfeldman$elm_css$Css$paddingRight = _rtfeldman$elm_css$Css$prop1('padding-right');
var _rtfeldman$elm_css$Css$paddingLeft = _rtfeldman$elm_css$Css$prop1('padding-left');
var _rtfeldman$elm_css$Css$margin = _rtfeldman$elm_css$Css$prop1('margin');
var _rtfeldman$elm_css$Css$marginTop = _rtfeldman$elm_css$Css$prop1('margin-top');
var _rtfeldman$elm_css$Css$marginBottom = _rtfeldman$elm_css$Css$prop1('margin-bottom');
var _rtfeldman$elm_css$Css$marginRight = _rtfeldman$elm_css$Css$prop1('margin-right');
var _rtfeldman$elm_css$Css$marginLeft = _rtfeldman$elm_css$Css$prop1('margin-left');
var _rtfeldman$elm_css$Css$marginBlockStart = _rtfeldman$elm_css$Css$prop1('margin-block-start');
var _rtfeldman$elm_css$Css$marginBlockEnd = _rtfeldman$elm_css$Css$prop1('margin-block-end');
var _rtfeldman$elm_css$Css$marginInlineStart = _rtfeldman$elm_css$Css$prop1('margin-inline-start');
var _rtfeldman$elm_css$Css$marginInlineEnd = _rtfeldman$elm_css$Css$prop1('margin-inline-end');
var _rtfeldman$elm_css$Css$top = _rtfeldman$elm_css$Css$prop1('top');
var _rtfeldman$elm_css$Css$bottom = _rtfeldman$elm_css$Css$prop1('bottom');
var _rtfeldman$elm_css$Css$left = _rtfeldman$elm_css$Css$prop1('left');
var _rtfeldman$elm_css$Css$right = _rtfeldman$elm_css$Css$prop1('right');
var _rtfeldman$elm_css$Css$border = _rtfeldman$elm_css$Css$prop1('border');
var _rtfeldman$elm_css$Css$borderTop = _rtfeldman$elm_css$Css$prop1('border-top');
var _rtfeldman$elm_css$Css$borderBottom = _rtfeldman$elm_css$Css$prop1('border-bottom');
var _rtfeldman$elm_css$Css$borderLeft = _rtfeldman$elm_css$Css$prop1('border-left');
var _rtfeldman$elm_css$Css$borderRight = _rtfeldman$elm_css$Css$prop1('border-right');
var _rtfeldman$elm_css$Css$borderImageOutset = _rtfeldman$elm_css$Css$prop1('border-image-outset');
var _rtfeldman$elm_css$Css$borderImageWidth = _rtfeldman$elm_css$Css$prop1('border-image-width');
var _rtfeldman$elm_css$Css$borderBottomStyle = _rtfeldman$elm_css$Css$prop1('border-bottom-style');
var _rtfeldman$elm_css$Css$borderLeftStyle = _rtfeldman$elm_css$Css$prop1('border-left-style');
var _rtfeldman$elm_css$Css$borderRightStyle = _rtfeldman$elm_css$Css$prop1('border-right-style');
var _rtfeldman$elm_css$Css$borderTopStyle = _rtfeldman$elm_css$Css$prop1('border-top-style');
var _rtfeldman$elm_css$Css$borderStyle = _rtfeldman$elm_css$Css$prop1('border-style');
var _rtfeldman$elm_css$Css$borderCollapse = _rtfeldman$elm_css$Css$prop1('border-collapse');
var _rtfeldman$elm_css$Css$borderWidth = _rtfeldman$elm_css$Css$prop1('border-width');
var _rtfeldman$elm_css$Css$borderBottomWidth = _rtfeldman$elm_css$Css$prop1('border-bottom-width');
var _rtfeldman$elm_css$Css$borderLeftWidth = _rtfeldman$elm_css$Css$prop1('border-left-width');
var _rtfeldman$elm_css$Css$borderRightWidth = _rtfeldman$elm_css$Css$prop1('border-right-width');
var _rtfeldman$elm_css$Css$borderTopWidth = _rtfeldman$elm_css$Css$prop1('border-top-width');
var _rtfeldman$elm_css$Css$borderBottomLeftRadius = _rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
var _rtfeldman$elm_css$Css$borderBottomRightRadius = _rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
var _rtfeldman$elm_css$Css$borderTopLeftRadius = _rtfeldman$elm_css$Css$prop1('border-top-left-radius');
var _rtfeldman$elm_css$Css$borderTopRightRadius = _rtfeldman$elm_css$Css$prop1('border-top-right-radius');
var _rtfeldman$elm_css$Css$borderRadius = _rtfeldman$elm_css$Css$prop1('border-radius');
var _rtfeldman$elm_css$Css$borderSpacing = _rtfeldman$elm_css$Css$prop1('border-spacing');
var _rtfeldman$elm_css$Css$outline = _rtfeldman$elm_css$Css$prop1('outline');
var _rtfeldman$elm_css$Css$outlineWidth = _rtfeldman$elm_css$Css$prop1('outline-width');
var _rtfeldman$elm_css$Css$outlineStyle = _rtfeldman$elm_css$Css$prop1('outline-style');
var _rtfeldman$elm_css$Css$outlineOffset = _rtfeldman$elm_css$Css$prop1('outline-offset');
var _rtfeldman$elm_css$Css$resize = _rtfeldman$elm_css$Css$prop1('resize');
var _rtfeldman$elm_css$Css$fill = _rtfeldman$elm_css$Css$prop1('fill');
var _rtfeldman$elm_css$Css$visibility = _rtfeldman$elm_css$Css$prop1('visibility');
var _rtfeldman$elm_css$Css$overflow = _rtfeldman$elm_css$Css$prop1('overflow');
var _rtfeldman$elm_css$Css$overflowX = _rtfeldman$elm_css$Css$prop1('overflow-x');
var _rtfeldman$elm_css$Css$overflowY = _rtfeldman$elm_css$Css$prop1('overflow-y');
var _rtfeldman$elm_css$Css$overflowWrap = _rtfeldman$elm_css$Css$prop1('overflow-wrap');
var _rtfeldman$elm_css$Css$whiteSpace = _rtfeldman$elm_css$Css$prop1('white-space');
var _rtfeldman$elm_css$Css$backgroundRepeat = _rtfeldman$elm_css$Css$prop1('background-repeat');
var _rtfeldman$elm_css$Css$backgroundAttachment = _rtfeldman$elm_css$Css$prop1('background-attachment');
var _rtfeldman$elm_css$Css$backgroundClip = _rtfeldman$elm_css$Css$prop1('background-clip');
var _rtfeldman$elm_css$Css$backgroundOrigin = _rtfeldman$elm_css$Css$prop1('background-origin');
var _rtfeldman$elm_css$Css$backgroundImage = _rtfeldman$elm_css$Css$prop1('background-image');
var _rtfeldman$elm_css$Css$backgroundSize = _rtfeldman$elm_css$Css$prop1('background-size');
var _rtfeldman$elm_css$Css$lineHeight = _rtfeldman$elm_css$Css$prop1('line-height');
var _rtfeldman$elm_css$Css$letterSpacing = _rtfeldman$elm_css$Css$prop1('letter-spacing');
var _rtfeldman$elm_css$Css$fontFamily = _rtfeldman$elm_css$Css$prop1('font-family');
var _rtfeldman$elm_css$Css$fontFamilies = function (_p6) {
	return A2(
		_rtfeldman$elm_css$Css$prop1,
		'font-family',
		_rtfeldman$elm_css$Css$stringsToValue(_p6));
};
var _rtfeldman$elm_css$Css$fontSize = _rtfeldman$elm_css$Css$prop1('font-size');
var _rtfeldman$elm_css$Css$fontStyle = _rtfeldman$elm_css$Css$prop1('font-style');
var _rtfeldman$elm_css$Css$fontVariant = _rtfeldman$elm_css$Css$prop1('font-variant');
var _rtfeldman$elm_css$Css$fontVariantLigatures = _rtfeldman$elm_css$Css$prop1('font-variant-ligatures');
var _rtfeldman$elm_css$Css$fontVariantCaps = _rtfeldman$elm_css$Css$prop1('font-variant-caps');
var _rtfeldman$elm_css$Css$fontVariantNumeric = _rtfeldman$elm_css$Css$prop1('font-variant-numeric');
var _rtfeldman$elm_css$Css$fontVariantNumerics = function (_p7) {
	return A2(
		_rtfeldman$elm_css$Css$prop1,
		'font-variant-numeric',
		_rtfeldman$elm_css$Css$valuesOrNone(_p7));
};
var _rtfeldman$elm_css$Css$cursor = _rtfeldman$elm_css$Css$prop1('cursor');
var _rtfeldman$elm_css$Css$textDecoration = _rtfeldman$elm_css$Css$prop1('text-decoration');
var _rtfeldman$elm_css$Css$textDecorations = function (_p8) {
	return A2(
		_rtfeldman$elm_css$Css$prop1,
		'text-decoration',
		_rtfeldman$elm_css$Css$valuesOrNone(_p8));
};
var _rtfeldman$elm_css$Css$textDecorationLine = _rtfeldman$elm_css$Css$prop1('text-decoration-line');
var _rtfeldman$elm_css$Css$textDecorationLines = function (_p9) {
	return A2(
		_rtfeldman$elm_css$Css$prop1,
		'text-decoration-line',
		_rtfeldman$elm_css$Css$valuesOrNone(_p9));
};
var _rtfeldman$elm_css$Css$textDecorationStyle = _rtfeldman$elm_css$Css$prop1('text-decoration-style');
var _rtfeldman$elm_css$Css$zIndex = _rtfeldman$elm_css$Css$prop1('z-index');
var _rtfeldman$elm_css$Css$touchAction = _rtfeldman$elm_css$Css$prop1('touch-action');
var _rtfeldman$elm_css$Css$tableLayout = _rtfeldman$elm_css$Css$prop1('table-layout');
var _rtfeldman$elm_css$Css$pointerEvents = _rtfeldman$elm_css$Css$prop1('pointer-events');
var _rtfeldman$elm_css$Css$position = _rtfeldman$elm_css$Css$prop1('position');
var _rtfeldman$elm_css$Css$textBottom = _rtfeldman$elm_css$Css$prop1('text-bottom');
var _rtfeldman$elm_css$Css$textTop = _rtfeldman$elm_css$Css$prop1('text-top');
var _rtfeldman$elm_css$Css$super = _rtfeldman$elm_css$Css$prop1('super');
var _rtfeldman$elm_css$Css$sub = _rtfeldman$elm_css$Css$prop1('sub');
var _rtfeldman$elm_css$Css$baseline = _rtfeldman$elm_css$Css$prop1('baseline');
var _rtfeldman$elm_css$Css$middle = _rtfeldman$elm_css$Css$prop1('middle');
var _rtfeldman$elm_css$Css$noWrap = {value: 'nowrap', whiteSpace: _rtfeldman$elm_css$Css_Structure$Compatible, flexWrap: _rtfeldman$elm_css$Css_Structure$Compatible, flexDirectionOrWrap: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$auto = {value: 'auto', cursor: _rtfeldman$elm_css$Css_Structure$Compatible, flexBasis: _rtfeldman$elm_css$Css_Structure$Compatible, overflow: _rtfeldman$elm_css$Css_Structure$Compatible, textRendering: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible, alignItemsOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrAutoOrCoverOrContain: _rtfeldman$elm_css$Css_Structure$Compatible, justifyContentOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, intOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible, touchAction: _rtfeldman$elm_css$Css_Structure$Compatible, tableLayout: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$none = {value: 'none', cursor: _rtfeldman$elm_css$Css_Structure$Compatible, none: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNone: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNoneOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible, textDecorationLine: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible, display: _rtfeldman$elm_css$Css_Structure$Compatible, keyframes: _rtfeldman$elm_css$Css_Structure$Compatible, outline: _rtfeldman$elm_css$Css_Structure$Compatible, pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible, resize: _rtfeldman$elm_css$Css_Structure$Compatible, transform: _rtfeldman$elm_css$Css_Structure$Compatible, borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundImage: _rtfeldman$elm_css$Css_Structure$Compatible, textTransform: _rtfeldman$elm_css$Css_Structure$Compatible, touchAction: _rtfeldman$elm_css$Css_Structure$Compatible, updateFrequency: _rtfeldman$elm_css$Css_Structure$Compatible, blockAxisOverflow: _rtfeldman$elm_css$Css_Structure$Compatible, inlineAxisOverflow: _rtfeldman$elm_css$Css_Structure$Compatible, pointerDevice: _rtfeldman$elm_css$Css_Structure$Compatible, hoverCapability: _rtfeldman$elm_css$Css_Structure$Compatible, scriptingSupport: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inlineListItem = {value: 'inline-list-item', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$listItem = {value: 'list-item', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableFooterGroup = {value: 'table-footer-group', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableHeaderGroup = {value: 'table-header-group', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableColumnGroup = {value: 'table-column-group', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableRowGroup = {value: 'table-row-group', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableCaption = {value: 'table-caption', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableColumn = {value: 'table-column', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableCell = {value: 'table-cell', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$tableRow = {value: 'table-row', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inlineTable = {value: 'inline-table', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$table = {value: 'table', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inline = {value: 'inline', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inlineFlex = {value: 'inline-flex', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inlineBlock = {value: 'inline-block', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$block = {value: 'block', display: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toTopLeft = {value: 'to top left', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toLeft = {value: 'to left', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toBottomLeft = {value: 'to bottom left', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toBottom = {value: 'to bottom', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toBottomRight = {value: 'to bottom right', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toRight = {value: 'to right', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toTopRight = {value: 'to top right', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$toTop = {value: 'to top', angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$stop2 = F2(
	function (c, len) {
		return {
			ctor: '_Tuple2',
			_0: c,
			_1: _elm_lang$core$Maybe$Just(len)
		};
	});
var _rtfeldman$elm_css$Css$stop = function (c) {
	return {ctor: '_Tuple2', _0: c, _1: _elm_lang$core$Maybe$Nothing};
};
var _rtfeldman$elm_css$Css$collectStops = _elm_lang$core$List$map(
	function (_p10) {
		var _p11 = _p10;
		return A2(
			_elm_lang$core$String$append,
			_p11._0.value,
			A2(
				_elm_lang$core$Maybe$withDefault,
				'',
				A2(
					_elm_lang$core$Maybe$map,
					function (_p12) {
						return A2(
							_elm_lang$core$String$cons,
							_elm_lang$core$Native_Utils.chr(' '),
							function (_) {
								return _.value;
							}(_p12));
					},
					_p11._1)));
	});
var _rtfeldman$elm_css$Css$local = {value: 'local', backgroundAttachment: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$noRepeat = {value: 'no-repeat', backgroundRepeat: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundRepeatShorthand: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$round = {value: 'round', backgroundRepeat: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundRepeatShorthand: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$space = {value: 'space', backgroundRepeat: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundRepeatShorthand: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$repeat = {value: 'repeat', backgroundRepeat: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundRepeatShorthand: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$repeatY = {value: 'repeat-y', backgroundRepeatShorthand: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$repeatX = {value: 'repeat-x', backgroundRepeatShorthand: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lineThrough = {value: 'line-through', textDecorationLine: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$overline = {value: 'overline', textDecorationLine: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$underline = {value: 'underline', textDecorationLine: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$row = {value: 'row', flexDirection: _rtfeldman$elm_css$Css_Structure$Compatible, flexDirectionOrWrap: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$rowReverse = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$row,
	{value: 'row-reverse'});
var _rtfeldman$elm_css$Css$column = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$row,
	{value: 'column'});
var _rtfeldman$elm_css$Css$columnReverse = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$row,
	{value: 'column-reverse'});
var _rtfeldman$elm_css$Css$stretch = _rtfeldman$elm_css$Css$prop1('stretch');
var _rtfeldman$elm_css$Css$spaceBetween = _rtfeldman$elm_css$Css$prop1('space-between');
var _rtfeldman$elm_css$Css$spaceAround = _rtfeldman$elm_css$Css$prop1('space-around');
var _rtfeldman$elm_css$Css$flexEnd = _rtfeldman$elm_css$Css$prop1('flex-end');
var _rtfeldman$elm_css$Css$flexStart = _rtfeldman$elm_css$Css$prop1('flex-start');
var _rtfeldman$elm_css$Css$wrap = {value: 'wrap', flexWrap: _rtfeldman$elm_css$Css_Structure$Compatible, flexDirectionOrWrap: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$wrapReverse = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$wrap,
	{value: 'wrap-reverse'});
var _rtfeldman$elm_css$Css$content = {value: 'content', flexBasis: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$order = _rtfeldman$elm_css$Css$prop1('order');
var _rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn(_rtfeldman$elm_css$Css_Internal$lengthForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$flexFlow2 = _rtfeldman$elm_css$Css$prop2('flex-flow');
var _rtfeldman$elm_css$Css$flexFlow1 = _rtfeldman$elm_css$Css$prop1('flex-flow');
var _rtfeldman$elm_css$Css$flexDirection = _rtfeldman$elm_css$Css$prop1('flex-direction');
var _rtfeldman$elm_css$Css$flexWrap = _rtfeldman$elm_css$Css$prop1('flex-wrap');
var _rtfeldman$elm_css$Css$flexShrink = _rtfeldman$elm_css$Css$prop1('flex-shrink');
var _rtfeldman$elm_css$Css$flexGrow = _rtfeldman$elm_css$Css$prop1('flex-grow');
var _rtfeldman$elm_css$Css$flexBasis = _rtfeldman$elm_css$Css$prop1('flex-basis');
var _rtfeldman$elm_css$Css$flex3 = _rtfeldman$elm_css$Css$prop3('flex');
var _rtfeldman$elm_css$Css$flex2 = _rtfeldman$elm_css$Css$prop2('flex');
var _rtfeldman$elm_css$Css$flex = _rtfeldman$elm_css$Css$prop1('flex');
var _rtfeldman$elm_css$Css$listStyle3 = _rtfeldman$elm_css$Css$prop3('list-style');
var _rtfeldman$elm_css$Css$listStyle2 = _rtfeldman$elm_css$Css$prop2('list-style');
var _rtfeldman$elm_css$Css$listStyle = _rtfeldman$elm_css$Css$prop1('list-style');
var _rtfeldman$elm_css$Css$thai = {value: 'thai', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$telugu = {value: 'telugu', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$oriya = {value: 'oriya', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$myanmar = {value: 'myanmar', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$malayalam = {value: 'malayalam', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lao = {value: 'lao', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$khmer = {value: 'khmer', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$kannada = {value: 'kannada', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$gurmukhi = {value: 'gurmukhi', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$gujarati = {value: 'gujarati', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$georgian = {value: 'georgian', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$devanagari = {value: 'devanagari', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$cjkHeavenlyStem = {value: 'cjk-heavenly-stem', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$cjkEarthlyBranch = {value: 'cjk-earthly-branch', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$bengali = {value: 'bengali', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$armenian = {value: 'armenian', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$arabicIndic = {value: 'arabic-indic', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$upperLatin = {value: 'upper-latin', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lowerLatin = {value: 'lower-latin', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$upperAlpha = {value: 'upper-alpha', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lowerAlpha = {value: 'lower-alpha', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$upperGreek = {value: 'upper-greek', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lowerGreek = {value: 'lower-greek', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$upperRoman = {value: 'upper-roman', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lowerRoman = {value: 'lower-roman', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$decimalLeadingZero = {value: 'decimal-leading-zero', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$decimal = {value: 'decimal', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$square = {value: 'square', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$circle = {value: 'circle', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$disc = {value: 'disc', listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$listStyleType = _rtfeldman$elm_css$Css$prop1('list-style-type');
var _rtfeldman$elm_css$Css$outside = {value: 'outside', listStylePosition: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inside = {value: 'inside', listStylePosition: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$listStylePosition = _rtfeldman$elm_css$Css$prop1('list-style-position');
var _rtfeldman$elm_css$Css$transformStyle = _rtfeldman$elm_css$Css$prop1('transform-style');
var _rtfeldman$elm_css$Css$flat = {value: 'flat', transformStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$preserve3d = {value: 'preserve-3d', transformStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$boxSizing = _rtfeldman$elm_css$Css$prop1('box-sizing');
var _rtfeldman$elm_css$Css$transformBox = _rtfeldman$elm_css$Css$prop1('transform-box');
var _rtfeldman$elm_css$Css$viewBox = {value: 'view-box', transformBox: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$borderBox = {value: 'border-box', boxSizing: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundClip: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$contentBox = {value: 'content-box', boxSizing: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundClip: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$fillBox = {value: 'fill-box', transformBox: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$transforms = function (_p13) {
	return A2(
		_rtfeldman$elm_css$Css$prop1,
		'transform',
		_rtfeldman$elm_css$Css$valuesOrNone(_p13));
};
var _rtfeldman$elm_css$Css$transform = function (only) {
	return _rtfeldman$elm_css$Css$transforms(
		{
			ctor: '::',
			_0: only,
			_1: {ctor: '[]'}
		});
};
var _rtfeldman$elm_css$Css$animationIterationCount = function (arg) {
	return A2(_rtfeldman$elm_css$Css$prop1, 'animation-iteration-count', arg);
};
var _rtfeldman$elm_css$Css$animationDuration = function (arg) {
	return A2(_rtfeldman$elm_css$Css$prop1, 'animation-duration', arg);
};
var _rtfeldman$elm_css$Css$animationDelay = function (arg) {
	return A2(_rtfeldman$elm_css$Css$prop1, 'animation-delay', arg);
};
var _rtfeldman$elm_css$Css$animationName = function (arg) {
	return (_elm_lang$core$Native_Utils.eq(arg.value, 'none') || (_elm_lang$core$Native_Utils.eq(arg.value, 'inherit') || (_elm_lang$core$Native_Utils.eq(arg.value, 'unset') || _elm_lang$core$Native_Utils.eq(arg.value, 'initial')))) ? A2(_rtfeldman$elm_css$Css$prop1, 'animation-name', arg) : _rtfeldman$elm_css$Css_Preprocess$WithKeyframes(arg.value);
};
var _rtfeldman$elm_css$Css$angleConverter = F2(
	function (suffix, angleVal) {
		return {
			value: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(angleVal),
				suffix),
			angle: _rtfeldman$elm_css$Css_Structure$Compatible,
			angleOrDirection: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$deg = _rtfeldman$elm_css$Css$angleConverter('deg');
var _rtfeldman$elm_css$Css$grad = _rtfeldman$elm_css$Css$angleConverter('grad');
var _rtfeldman$elm_css$Css$rad = _rtfeldman$elm_css$Css$angleConverter('rad');
var _rtfeldman$elm_css$Css$turn = _rtfeldman$elm_css$Css$angleConverter('turn');
var _rtfeldman$elm_css$Css$infinite = {value: 'infinite', infinite: _rtfeldman$elm_css$Css_Structure$Compatible, numberOrInfinite: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$ms = function (amount) {
	return {
		value: A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(amount),
			'ms'),
		duration: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$sec = function (amount) {
	return {
		value: A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(amount),
			's'),
		duration: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$true = _rtfeldman$elm_css$Css$prop1('true');
var _rtfeldman$elm_css$Css$matchParent = _rtfeldman$elm_css$Css$prop1('match-parent');
var _rtfeldman$elm_css$Css$end = _rtfeldman$elm_css$Css$prop1('end');
var _rtfeldman$elm_css$Css$start = _rtfeldman$elm_css$Css$prop1('start');
var _rtfeldman$elm_css$Css$justifyAll = _rtfeldman$elm_css$Css$prop1('justify-all');
var _rtfeldman$elm_css$Css$justify = _rtfeldman$elm_css$Css$prop1('justify');
var _rtfeldman$elm_css$Css$center = _rtfeldman$elm_css$Css$prop1('center');
var _rtfeldman$elm_css$Css$collapse = {value: 'collapse', borderCollapse: _rtfeldman$elm_css$Css_Structure$Compatible, visibility: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$separate = {value: 'separate', borderCollapse: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$outset = {value: 'outset', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inset = {value: 'inset', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$ridge = {value: 'ridge', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$groove = {value: 'groove', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$double = {value: 'double', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible, textDecorationStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$solid = {value: 'solid', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible, textDecorationStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$dashed = {value: 'dashed', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible, textDecorationStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$dotted = {value: 'dotted', borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible, textDecorationStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$wavy = {value: 'wavy', textDecorationStyle: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$clip = {value: 'clip', textOverflow: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$ellipsis = {value: 'ellipsis', textOverflow: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$fullWidth = {value: 'full-width', textTransform: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$lowercase = {value: 'lowercase', textTransform: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$uppercase = {value: 'uppercase', textTransform: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$capitalize = {value: 'capitalize', textTransform: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$sideways = {value: 'sideways', textOrientation: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$upright = {value: 'upright', textOrientation: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$mixed = {value: 'mixed', textOrientation: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$eachLine = {value: 'each-line', textIndent: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$hanging = {value: 'hanging', textIndent: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$geometricPrecision = {value: 'geometricPrecision', textRendering: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$optimizeLegibility = {value: 'optimizeLegibility', textRendering: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$optimizeSpeed = {value: 'optimizeSpeed', textRendering: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$degreesToRadians = function (degrees) {
	return (degrees * 180) / _elm_lang$core$Basics$pi;
};
var _rtfeldman$elm_css$Css$fmod = F2(
	function (f, n) {
		var integer = _elm_lang$core$Basics$floor(f);
		return (_elm_lang$core$Basics$toFloat(
			A2(_elm_lang$core$Basics_ops['%'], integer, n)) + f) - _elm_lang$core$Basics$toFloat(integer);
	});
var _rtfeldman$elm_css$Css$hslToRgb = F3(
	function (hueVal, saturationVal, lightness) {
		var normHue = hueVal / _elm_lang$core$Basics$degrees(60);
		var chroma = (1 - _elm_lang$core$Basics$abs((2 * lightness) - 1)) * saturationVal;
		var x = chroma * (1 - _elm_lang$core$Basics$abs(
			A2(_rtfeldman$elm_css$Css$fmod, normHue, 2) - 1));
		var _p14 = (_elm_lang$core$Native_Utils.cmp(normHue, 0) < 0) ? {ctor: '_Tuple3', _0: 0, _1: 0, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 1) < 0) ? {ctor: '_Tuple3', _0: chroma, _1: x, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 2) < 0) ? {ctor: '_Tuple3', _0: x, _1: chroma, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 3) < 0) ? {ctor: '_Tuple3', _0: 0, _1: chroma, _2: x} : ((_elm_lang$core$Native_Utils.cmp(normHue, 4) < 0) ? {ctor: '_Tuple3', _0: 0, _1: x, _2: chroma} : ((_elm_lang$core$Native_Utils.cmp(normHue, 5) < 0) ? {ctor: '_Tuple3', _0: x, _1: 0, _2: chroma} : ((_elm_lang$core$Native_Utils.cmp(normHue, 6) < 0) ? {ctor: '_Tuple3', _0: chroma, _1: 0, _2: x} : {ctor: '_Tuple3', _0: 0, _1: 0, _2: 0}))))));
		var r = _p14._0;
		var g = _p14._1;
		var b = _p14._2;
		var m = lightness - (chroma / 2);
		return {ctor: '_Tuple3', _0: r + m, _1: g + m, _2: b + m};
	});
var _rtfeldman$elm_css$Css$hslaToRgba = F5(
	function (value, hueVal, saturationVal, lightness, hslAlpha) {
		var _p15 = A3(
			_rtfeldman$elm_css$Css$hslToRgb,
			_rtfeldman$elm_css$Css$degreesToRadians(hueVal),
			saturationVal,
			lightness);
		var red = _p15._0;
		var green = _p15._1;
		var blue = _p15._2;
		return {
			value: value,
			color: _rtfeldman$elm_css$Css_Structure$Compatible,
			red: _elm_lang$core$Basics$floor(red),
			green: _elm_lang$core$Basics$floor(green),
			blue: _elm_lang$core$Basics$floor(blue),
			alpha: hslAlpha
		};
	});
var _rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2(_elm_lang$core$String$startsWith, '#', str) ? str : A2(
		_elm_lang$core$String$cons,
		_elm_lang$core$Native_Utils.chr('#'),
		str);
};
var _rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		value: _rtfeldman$elm_css$Css$withPrecedingHash(str),
		color: _rtfeldman$elm_css$Css_Structure$Compatible,
		red: 0,
		green: 0,
		blue: 0,
		alpha: 1
	};
};
var _rtfeldman$elm_css$Css$validHex = F5(
	function (str, _p19, _p18, _p17, _p16) {
		var _p20 = _p19;
		var _p21 = _p18;
		var _p22 = _p17;
		var _p23 = _p16;
		var toResult = function (_p24) {
			return _rtfeldman$hex$Hex$fromString(
				_elm_lang$core$String$toLower(
					_elm_lang$core$String$fromList(_p24)));
		};
		var results = {
			ctor: '_Tuple2',
			_0: {
				ctor: '_Tuple2',
				_0: toResult(
					{
						ctor: '::',
						_0: _p20._0,
						_1: {
							ctor: '::',
							_0: _p20._1,
							_1: {ctor: '[]'}
						}
					}),
				_1: toResult(
					{
						ctor: '::',
						_0: _p21._0,
						_1: {
							ctor: '::',
							_0: _p21._1,
							_1: {ctor: '[]'}
						}
					})
			},
			_1: {
				ctor: '_Tuple2',
				_0: toResult(
					{
						ctor: '::',
						_0: _p22._0,
						_1: {
							ctor: '::',
							_0: _p22._1,
							_1: {ctor: '[]'}
						}
					}),
				_1: toResult(
					{
						ctor: '::',
						_0: _p23._0,
						_1: {
							ctor: '::',
							_0: _p23._1,
							_1: {ctor: '[]'}
						}
					})
			}
		};
		var _p25 = results;
		if (((((((_p25.ctor === '_Tuple2') && (_p25._0.ctor === '_Tuple2')) && (_p25._0._0.ctor === 'Ok')) && (_p25._0._1.ctor === 'Ok')) && (_p25._1.ctor === '_Tuple2')) && (_p25._1._0.ctor === 'Ok')) && (_p25._1._1.ctor === 'Ok')) {
			return {
				value: _rtfeldman$elm_css$Css$withPrecedingHash(str),
				color: _rtfeldman$elm_css$Css_Structure$Compatible,
				red: _p25._0._0._0,
				green: _p25._0._1._0,
				blue: _p25._1._0._0,
				alpha: _elm_lang$core$Basics$toFloat(_p25._1._1._0) / 255
			};
		} else {
			return _rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var _rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2(_elm_lang$core$String$startsWith, '#', str) ? A2(_elm_lang$core$String$dropLeft, 1, str) : str;
	var _p26 = _elm_lang$core$String$toList(withoutHash);
	_v8_4:
	do {
		if (((_p26.ctor === '::') && (_p26._1.ctor === '::')) && (_p26._1._1.ctor === '::')) {
			if (_p26._1._1._1.ctor === '[]') {
				var _p29 = _p26._0;
				var _p28 = _p26._1._0;
				var _p27 = _p26._1._1._0;
				return A5(
					_rtfeldman$elm_css$Css$validHex,
					str,
					{ctor: '_Tuple2', _0: _p29, _1: _p29},
					{ctor: '_Tuple2', _0: _p28, _1: _p28},
					{ctor: '_Tuple2', _0: _p27, _1: _p27},
					{
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.chr('f'),
						_1: _elm_lang$core$Native_Utils.chr('f')
					});
			} else {
				if (_p26._1._1._1._1.ctor === '[]') {
					var _p33 = _p26._0;
					var _p32 = _p26._1._0;
					var _p31 = _p26._1._1._0;
					var _p30 = _p26._1._1._1._0;
					return A5(
						_rtfeldman$elm_css$Css$validHex,
						str,
						{ctor: '_Tuple2', _0: _p33, _1: _p33},
						{ctor: '_Tuple2', _0: _p32, _1: _p32},
						{ctor: '_Tuple2', _0: _p31, _1: _p31},
						{ctor: '_Tuple2', _0: _p30, _1: _p30});
				} else {
					if (_p26._1._1._1._1._1.ctor === '::') {
						if (_p26._1._1._1._1._1._1.ctor === '[]') {
							return A5(
								_rtfeldman$elm_css$Css$validHex,
								str,
								{ctor: '_Tuple2', _0: _p26._0, _1: _p26._1._0},
								{ctor: '_Tuple2', _0: _p26._1._1._0, _1: _p26._1._1._1._0},
								{ctor: '_Tuple2', _0: _p26._1._1._1._1._0, _1: _p26._1._1._1._1._1._0},
								{
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.chr('f'),
									_1: _elm_lang$core$Native_Utils.chr('f')
								});
						} else {
							if ((_p26._1._1._1._1._1._1._1.ctor === '::') && (_p26._1._1._1._1._1._1._1._1.ctor === '[]')) {
								return A5(
									_rtfeldman$elm_css$Css$validHex,
									str,
									{ctor: '_Tuple2', _0: _p26._0, _1: _p26._1._0},
									{ctor: '_Tuple2', _0: _p26._1._1._0, _1: _p26._1._1._1._0},
									{ctor: '_Tuple2', _0: _p26._1._1._1._1._0, _1: _p26._1._1._1._1._1._0},
									{ctor: '_Tuple2', _0: _p26._1._1._1._1._1._1._0, _1: _p26._1._1._1._1._1._1._1._0});
							} else {
								break _v8_4;
							}
						}
					} else {
						break _v8_4;
					}
				}
			}
		} else {
			break _v8_4;
		}
	} while(false);
	return _rtfeldman$elm_css$Css$erroneousHex(str);
};
var _rtfeldman$elm_css$Css$initial = {value: 'initial', overflow: _rtfeldman$elm_css$Css_Structure$Compatible, visibility: _rtfeldman$elm_css$Css_Structure$Compatible, none: _rtfeldman$elm_css$Css_Structure$Compatible, number: _rtfeldman$elm_css$Css_Structure$Compatible, textDecorationLine: _rtfeldman$elm_css$Css_Structure$Compatible, textRendering: _rtfeldman$elm_css$Css_Structure$Compatible, textIndent: _rtfeldman$elm_css$Css_Structure$Compatible, textDecorationStyle: _rtfeldman$elm_css$Css_Structure$Compatible, textTransform: _rtfeldman$elm_css$Css_Structure$Compatible, borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible, boxSizing: _rtfeldman$elm_css$Css_Structure$Compatible, color: _rtfeldman$elm_css$Css_Structure$Compatible, cursor: _rtfeldman$elm_css$Css_Structure$Compatible, display: _rtfeldman$elm_css$Css_Structure$Compatible, keyframes: _rtfeldman$elm_css$Css_Structure$Compatible, all: _rtfeldman$elm_css$Css_Structure$Compatible, alignItems: _rtfeldman$elm_css$Css_Structure$Compatible, justifyContent: _rtfeldman$elm_css$Css_Structure$Compatible, length: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNone: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumber: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNoneOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleType: _rtfeldman$elm_css$Css_Structure$Compatible, listStylePosition: _rtfeldman$elm_css$Css_Structure$Compatible, listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible, flexBasis: _rtfeldman$elm_css$Css_Structure$Compatible, flexWrap: _rtfeldman$elm_css$Css_Structure$Compatible, flexDirection: _rtfeldman$elm_css$Css_Structure$Compatible, flexDirectionOrWrap: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible, fontFamily: _rtfeldman$elm_css$Css_Structure$Compatible, fontSize: _rtfeldman$elm_css$Css_Structure$Compatible, fontStyle: _rtfeldman$elm_css$Css_Structure$Compatible, fontWeight: _rtfeldman$elm_css$Css_Structure$Compatible, fontVariant: _rtfeldman$elm_css$Css_Structure$Compatible, outline: _rtfeldman$elm_css$Css_Structure$Compatible, pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible, units: _rtfeldman$elm_css$Css_Internal$IncompatibleUnits, numericValue: 0, unitLabel: '', backgroundRepeat: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundRepeatShorthand: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundAttachment: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundBlendMode: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundOrigin: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundImage: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrAutoOrCoverOrContain: _rtfeldman$elm_css$Css_Structure$Compatible, intOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, touchAction: _rtfeldman$elm_css$Css_Structure$Compatible, whiteSpace: _rtfeldman$elm_css$Css_Structure$Compatible, tableLayout: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$inherit = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$initial,
	{value: 'inherit'});
var _rtfeldman$elm_css$Css$unset = _elm_lang$core$Native_Utils.update(
	_rtfeldman$elm_css$Css$initial,
	{value: 'unset'});
var _rtfeldman$elm_css$Css$hidden = {value: 'hidden', overflow: _rtfeldman$elm_css$Css_Structure$Compatible, borderStyle: _rtfeldman$elm_css$Css_Structure$Compatible, visibility: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$contain = {value: 'contain', lengthOrAutoOrCoverOrContain: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$cover = {value: 'cover', lengthOrAutoOrCoverOrContain: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$url = function (urlValue) {
	return {
		value: A2(
			_elm_lang$core$Basics_ops['++'],
			'url(',
			A2(_elm_lang$core$Basics_ops['++'], urlValue, ')')),
		backgroundImage: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$paddingBox = {value: 'padding-box', backgroundClip: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$luminosity = _rtfeldman$elm_css$Css$prop1('luminosity');
var _rtfeldman$elm_css$Css$saturation = _rtfeldman$elm_css$Css$prop1('saturation');
var _rtfeldman$elm_css$Css$hue = _rtfeldman$elm_css$Css$prop1('hue');
var _rtfeldman$elm_css$Css$exclusion = _rtfeldman$elm_css$Css$prop1('exclusion');
var _rtfeldman$elm_css$Css$difference = _rtfeldman$elm_css$Css$prop1('difference');
var _rtfeldman$elm_css$Css$softLight = _rtfeldman$elm_css$Css$prop1('soft-light');
var _rtfeldman$elm_css$Css$hardLight = _rtfeldman$elm_css$Css$prop1('hard-light');
var _rtfeldman$elm_css$Css$colorBurn = _rtfeldman$elm_css$Css$prop1('color-burn');
var _rtfeldman$elm_css$Css$colorDodge = _rtfeldman$elm_css$Css$prop1('color-dodge');
var _rtfeldman$elm_css$Css$lighten = _rtfeldman$elm_css$Css$prop1('lighten');
var _rtfeldman$elm_css$Css$darken = _rtfeldman$elm_css$Css$prop1('darken');
var _rtfeldman$elm_css$Css$overlay = _rtfeldman$elm_css$Css$prop1('overlay');
var _rtfeldman$elm_css$Css$screenBlendMode = _rtfeldman$elm_css$Css$prop1('screen');
var _rtfeldman$elm_css$Css$multiply = _rtfeldman$elm_css$Css$prop1('multiply');
var _rtfeldman$elm_css$Css$vertical = {value: 'vertical', resize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$horizontal = {value: 'horizontal', resize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$both = {value: 'both', resize: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$breakWord = {value: 'break-word', overflowWrap: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$scroll = {value: 'scroll', scroll: _rtfeldman$elm_css$Css_Structure$Compatible, overflow: _rtfeldman$elm_css$Css_Structure$Compatible, backgroundAttachment: _rtfeldman$elm_css$Css_Structure$Compatible, blockAxisOverflow: _rtfeldman$elm_css$Css_Structure$Compatible, inlineAxisOverflow: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$visible = {value: 'visible', overflow: _rtfeldman$elm_css$Css_Structure$Compatible, visibility: _rtfeldman$elm_css$Css_Structure$Compatible, pointerEvents: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$currentColor = {value: 'currentColor', color: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$transparent = {value: 'transparent', color: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$makeImportant = function (str) {
	return A2(
		_elm_lang$core$String$endsWith,
		' !important',
		_elm_lang$core$String$toLower(str)) ? str : A2(_elm_lang$core$Basics_ops['++'], str, ' !important');
};
var _rtfeldman$elm_css$Css$important = _rtfeldman$elm_css$Css_Preprocess$mapLastProperty(_rtfeldman$elm_css$Css$makeImportant);
var _rtfeldman$elm_css$Css$all = _rtfeldman$elm_css$Css$prop1('all');
var _rtfeldman$elm_css$Css$combineLengths = F3(
	function (operation, firstLength, secondLength) {
		var numericValue = A2(operation, firstLength.numericValue, secondLength.numericValue);
		var value = A2(
			_elm_lang$core$String$join,
			'',
			A2(
				_elm_lang$core$List$filter,
				function (_p34) {
					return !_elm_lang$core$String$isEmpty(_p34);
				},
				{
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(numericValue),
					_1: {
						ctor: '::',
						_0: firstLength.unitLabel,
						_1: {ctor: '[]'}
					}
				}));
		return _elm_lang$core$Native_Utils.update(
			firstLength,
			{value: value, numericValue: numericValue});
	});
var _rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
	var _p35 = expression;
	if (_p35.ctor === 'Addition') {
		return '+';
	} else {
		return '-';
	}
};
var _rtfeldman$elm_css$Css$colorValueForOverloadedProperty = _rtfeldman$elm_css$Css$transparent;
var _rtfeldman$elm_css$Css$backgroundBlendMode = function (fn) {
	return A3(
		_rtfeldman$elm_css$Css_Internal$getOverloadedProperty,
		'backgroundBlendMode',
		'background-blend-mode',
		fn(_rtfeldman$elm_css$Css$colorValueForOverloadedProperty));
};
var _rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			funcName,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'(',
				A2(
					_elm_lang$core$Basics_ops['++'],
					A2(_elm_lang$core$String$join, ', ', args),
					')')));
	});
var _rtfeldman$elm_css$Css$calc = F3(
	function (firstExpr, expression, secondExpr) {
		var withoutCalcStr = function (l) {
			return A2(_elm_lang$core$String$startsWith, 'calc(', l.value) ? A2(_elm_lang$core$String$dropLeft, 4, l.value) : l.value;
		};
		var calcs = A2(
			_elm_lang$core$String$join,
			' ',
			{
				ctor: '::',
				_0: withoutCalcStr(firstExpr),
				_1: {
					ctor: '::',
					_0: _rtfeldman$elm_css$Css$calcExpressionToString(expression),
					_1: {
						ctor: '::',
						_0: withoutCalcStr(secondExpr),
						_1: {ctor: '[]'}
					}
				}
			});
		var value = A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'calc',
			{
				ctor: '::',
				_0: calcs,
				_1: {ctor: '[]'}
			});
		return {value: value, length: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumber: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNone: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNoneOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, textIndent: _rtfeldman$elm_css$Css_Structure$Compatible, flexBasis: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible, fontSize: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrAutoOrCoverOrContain: _rtfeldman$elm_css$Css_Structure$Compatible, calc: _rtfeldman$elm_css$Css_Structure$Compatible};
	});
var _rtfeldman$elm_css$Css$rgb = F3(
	function (r, g, b) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'rgb',
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Basics$toString,
					{
						ctor: '::',
						_0: r,
						_1: {
							ctor: '::',
							_0: g,
							_1: {
								ctor: '::',
								_0: b,
								_1: {ctor: '[]'}
							}
						}
					})),
			color: _rtfeldman$elm_css$Css_Structure$Compatible,
			red: r,
			green: g,
			blue: b,
			alpha: 1
		};
	});
var _rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				A2(
					_elm_lang$core$Basics_ops['++'],
					A2(
						_elm_lang$core$List$map,
						_elm_lang$core$Basics$toString,
						{
							ctor: '::',
							_0: r,
							_1: {
								ctor: '::',
								_0: g,
								_1: {
									ctor: '::',
									_0: b,
									_1: {ctor: '[]'}
								}
							}
						}),
					{
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(alpha),
						_1: {ctor: '[]'}
					})),
			color: _rtfeldman$elm_css$Css_Structure$Compatible,
			red: r,
			green: g,
			blue: b,
			alpha: alpha
		};
	});
var _rtfeldman$elm_css$Css$hsl = F3(
	function (hueVal, saturationVal, lightnessVal) {
		var valuesList = {
			ctor: '::',
			_0: _elm_lang$core$Basics$toString(hueVal),
			_1: {
				ctor: '::',
				_0: _rtfeldman$elm_css$Css$numericalPercentageToString(saturationVal),
				_1: {
					ctor: '::',
					_0: _rtfeldman$elm_css$Css$numericalPercentageToString(lightnessVal),
					_1: {ctor: '[]'}
				}
			}
		};
		var value = A2(_rtfeldman$elm_css$Css$cssFunction, 'hsl', valuesList);
		return A5(_rtfeldman$elm_css$Css$hslaToRgba, value, hueVal, saturationVal, lightnessVal, 1);
	});
var _rtfeldman$elm_css$Css$hsla = F4(
	function (hueVal, saturationVal, lightnessVal, alpha) {
		var valuesList = {
			ctor: '::',
			_0: _elm_lang$core$Basics$toString(hueVal),
			_1: {
				ctor: '::',
				_0: _rtfeldman$elm_css$Css$numericalPercentageToString(saturationVal),
				_1: {
					ctor: '::',
					_0: _rtfeldman$elm_css$Css$numericalPercentageToString(lightnessVal),
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(alpha),
						_1: {ctor: '[]'}
					}
				}
			}
		};
		var value = A2(_rtfeldman$elm_css$Css$cssFunction, 'hsla', valuesList);
		return A5(_rtfeldman$elm_css$Css$hslaToRgba, value, hueVal, saturationVal, lightnessVal, alpha);
	});
var _rtfeldman$elm_css$Css$matrix = F6(
	function (a, b, c, d, tx, ty) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'matrix',
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Basics$toString,
					{
						ctor: '::',
						_0: a,
						_1: {
							ctor: '::',
							_0: b,
							_1: {
								ctor: '::',
								_0: c,
								_1: {
									ctor: '::',
									_0: d,
									_1: {
										ctor: '::',
										_0: tx,
										_1: {
											ctor: '::',
											_0: ty,
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					})),
			transform: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$matrix3d = function (a1) {
	return function (a2) {
		return function (a3) {
			return function (a4) {
				return function (b1) {
					return function (b2) {
						return function (b3) {
							return function (b4) {
								return function (c1) {
									return function (c2) {
										return function (c3) {
											return function (c4) {
												return function (d1) {
													return function (d2) {
														return function (d3) {
															return function (d4) {
																return {
																	value: A2(
																		_rtfeldman$elm_css$Css$cssFunction,
																		'matrix3d',
																		A2(
																			_elm_lang$core$List$map,
																			_elm_lang$core$Basics$toString,
																			{
																				ctor: '::',
																				_0: a1,
																				_1: {
																					ctor: '::',
																					_0: a2,
																					_1: {
																						ctor: '::',
																						_0: a3,
																						_1: {
																							ctor: '::',
																							_0: a4,
																							_1: {
																								ctor: '::',
																								_0: b1,
																								_1: {
																									ctor: '::',
																									_0: b2,
																									_1: {
																										ctor: '::',
																										_0: b3,
																										_1: {
																											ctor: '::',
																											_0: b4,
																											_1: {
																												ctor: '::',
																												_0: c1,
																												_1: {
																													ctor: '::',
																													_0: c2,
																													_1: {
																														ctor: '::',
																														_0: c3,
																														_1: {
																															ctor: '::',
																															_0: c4,
																															_1: {
																																ctor: '::',
																																_0: d1,
																																_1: {
																																	ctor: '::',
																																	_0: d2,
																																	_1: {
																																		ctor: '::',
																																		_0: d3,
																																		_1: {
																																			ctor: '::',
																																			_0: d4,
																																			_1: {ctor: '[]'}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			})),
																	transform: _rtfeldman$elm_css$Css_Structure$Compatible
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _rtfeldman$elm_css$Css$perspective = function (l) {
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'perspective',
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(l),
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$rotate = function (_p36) {
	var _p37 = _p36;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'rotate',
			{
				ctor: '::',
				_0: _p37.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$rotateX = function (_p38) {
	var _p39 = _p38;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'rotateX',
			{
				ctor: '::',
				_0: _p39.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$rotateY = function (_p40) {
	var _p41 = _p40;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'rotateY',
			{
				ctor: '::',
				_0: _p41.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$rotateZ = function (_p42) {
	var _p43 = _p42;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'rotateZ',
			{
				ctor: '::',
				_0: _p43.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$rotate3d = F4(
	function (x, y, z, _p44) {
		var _p45 = _p44;
		var coordsAsStrings = A2(
			_elm_lang$core$List$map,
			_elm_lang$core$Basics$toString,
			{
				ctor: '::',
				_0: x,
				_1: {
					ctor: '::',
					_0: y,
					_1: {
						ctor: '::',
						_0: z,
						_1: {ctor: '[]'}
					}
				}
			});
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'rotate3d',
				A2(
					_elm_lang$core$Basics_ops['++'],
					coordsAsStrings,
					{
						ctor: '::',
						_0: _p45.value,
						_1: {ctor: '[]'}
					})),
			transform: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$scale = function (x) {
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'scale',
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(x),
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$scale2 = F2(
	function (x, y) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'scale',
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Basics$toString,
					{
						ctor: '::',
						_0: x,
						_1: {
							ctor: '::',
							_0: y,
							_1: {ctor: '[]'}
						}
					})),
			transform: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$scaleX = function (x) {
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'scaleX',
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(x),
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$scaleY = function (y) {
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'scaleY',
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(y),
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$scale3d = F3(
	function (x, y, z) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'scale3d',
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Basics$toString,
					{
						ctor: '::',
						_0: x,
						_1: {
							ctor: '::',
							_0: y,
							_1: {
								ctor: '::',
								_0: z,
								_1: {ctor: '[]'}
							}
						}
					})),
			transform: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$skew = function (_p46) {
	var _p47 = _p46;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'skew',
			{
				ctor: '::',
				_0: _p47.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$skew2 = F2(
	function (ax, ay) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'skew',
				{
					ctor: '::',
					_0: ax.value,
					_1: {
						ctor: '::',
						_0: ay.value,
						_1: {ctor: '[]'}
					}
				}),
			transform: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$skewX = function (_p48) {
	var _p49 = _p48;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'skewX',
			{
				ctor: '::',
				_0: _p49.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$skewY = function (_p50) {
	var _p51 = _p50;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'skewY',
			{
				ctor: '::',
				_0: _p51.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$translate = function (_p52) {
	var _p53 = _p52;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'translate',
			{
				ctor: '::',
				_0: _p53.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$translate2 = F2(
	function (tx, ty) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'translate',
				{
					ctor: '::',
					_0: tx.value,
					_1: {
						ctor: '::',
						_0: ty.value,
						_1: {ctor: '[]'}
					}
				}),
			transform: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$translateX = function (_p54) {
	var _p55 = _p54;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'translateX',
			{
				ctor: '::',
				_0: _p55.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$translateY = function (_p56) {
	var _p57 = _p56;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'translateY',
			{
				ctor: '::',
				_0: _p57.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$translateZ = function (_p58) {
	var _p59 = _p58;
	return {
		value: A2(
			_rtfeldman$elm_css$Css$cssFunction,
			'translateZ',
			{
				ctor: '::',
				_0: _p59.value,
				_1: {ctor: '[]'}
			}),
		transform: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css$translate3d = F3(
	function (tx, ty, tz) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'translate3d',
				{
					ctor: '::',
					_0: tx.value,
					_1: {
						ctor: '::',
						_0: ty.value,
						_1: {
							ctor: '::',
							_0: tz.value,
							_1: {ctor: '[]'}
						}
					}
				}),
			transform: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$linearGradient = F3(
	function (firstStop, secondStop, otherStops) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'linear-gradient',
				_rtfeldman$elm_css$Css$collectStops(
					A2(
						_elm_lang$core$Basics_ops['++'],
						{
							ctor: '::',
							_0: firstStop,
							_1: {
								ctor: '::',
								_0: secondStop,
								_1: {ctor: '[]'}
							}
						},
						otherStops))),
			backgroundImage: _rtfeldman$elm_css$Css_Structure$Compatible,
			listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$linearGradient2 = F4(
	function (direction, firstStop, secondStop, otherStops) {
		return {
			value: A2(
				_rtfeldman$elm_css$Css$cssFunction,
				'linear-gradient',
				A2(
					F2(
						function (x, y) {
							return {ctor: '::', _0: x, _1: y};
						}),
					direction.value,
					_rtfeldman$elm_css$Css$collectStops(
						A2(
							_elm_lang$core$Basics_ops['++'],
							{
								ctor: '::',
								_0: firstStop,
								_1: {
									ctor: '::',
									_0: secondStop,
									_1: {ctor: '[]'}
								}
							},
							otherStops)))),
			backgroundImage: _rtfeldman$elm_css$Css_Structure$Compatible,
			listStyleTypeOrPositionOrImage: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css$Infinite = F3(
	function (a, b, c) {
		return {value: a, numberOrInfinite: b, infinite: c};
	});
var _rtfeldman$elm_css$Css$CalculatedLength = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return {value: a, length: b, lengthOrAuto: c, lengthOrNumber: d, lengthOrNone: e, lengthOrMinMaxDimension: f, lengthOrNoneOrMinMaxDimension: g, textIndent: h, flexBasis: i, lengthOrNumberOrAutoOrNoneOrContent: j, fontSize: k, lengthOrAutoOrCoverOrContain: l, calc: m};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _rtfeldman$elm_css$Css$NonMixable = {};
var _rtfeldman$elm_css$Css$BasicProperty = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return function (_4) {
																														return function (_5) {
																															return function (_6) {
																																return function (_7) {
																																	return function (_8) {
																																		return function (_9) {
																																			return function (_10) {
																																				return function (_11) {
																																					return function (_12) {
																																						return function (_13) {
																																							return function (_14) {
																																								return function (_15) {
																																									return function (_16) {
																																										return function (_17) {
																																											return function (_18) {
																																												return function (_19) {
																																													return function (_20) {
																																														return function (_21) {
																																															return function (_22) {
																																																return function (_23) {
																																																	return function (_24) {
																																																		return function (_25) {
																																																			return function (_26) {
																																																				return function (_27) {
																																																					return function (_28) {
																																																						return {value: a, all: b, alignItems: c, borderStyle: d, boxSizing: e, color: f, cursor: g, display: h, flexBasis: i, flexWrap: j, flexDirection: k, flexDirectionOrWrap: l, justifyContent: m, none: n, number: o, keyframes: p, outline: q, overflow: r, pointerEvents: s, visibility: t, textDecorationLine: u, textRendering: v, textIndent: w, textDecorationStyle: x, textTransform: y, length: z, lengthOrAuto: _1, lengthOrNone: _2, lengthOrNumber: _3, lengthOrMinMaxDimension: _4, lengthOrNoneOrMinMaxDimension: _5, lengthOrNumberOrAutoOrNoneOrContent: _6, listStyleType: _7, listStylePosition: _8, listStyleTypeOrPositionOrImage: _9, fontFamily: _10, fontSize: _11, fontStyle: _12, fontWeight: _13, fontVariant: _14, units: _15, numericValue: _16, unitLabel: _17, backgroundRepeat: _18, backgroundRepeatShorthand: _19, backgroundAttachment: _20, backgroundBlendMode: _21, backgroundOrigin: _22, backgroundImage: _23, lengthOrAutoOrCoverOrContain: _24, intOrAuto: _25, touchAction: _26, whiteSpace: _27, tableLayout: _28};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _rtfeldman$elm_css$Css$Normal = F6(
	function (a, b, c, d, e, f) {
		return {value: a, fontStyle: b, fontWeight: c, featureTagValue: d, overflowWrap: e, whiteSpace: f};
	});
var _rtfeldman$elm_css$Css$Subtraction = {ctor: 'Subtraction'};
var _rtfeldman$elm_css$Css$minus = _rtfeldman$elm_css$Css$Subtraction;
var _rtfeldman$elm_css$Css$Addition = {ctor: 'Addition'};
var _rtfeldman$elm_css$Css$plus = _rtfeldman$elm_css$Css$Addition;
var _rtfeldman$elm_css$Css$PercentageUnits = {ctor: 'PercentageUnits'};
var _rtfeldman$elm_css$Css$pct = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$PercentageUnits, '%');
var _rtfeldman$elm_css$Css$EmUnits = {ctor: 'EmUnits'};
var _rtfeldman$elm_css$Css$em = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$EmUnits, 'em');
var _rtfeldman$elm_css$Css$ExUnits = {ctor: 'ExUnits'};
var _rtfeldman$elm_css$Css$ex = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$ExUnits, 'ex');
var _rtfeldman$elm_css$Css$ChUnits = {ctor: 'ChUnits'};
var _rtfeldman$elm_css$Css$ch = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$ChUnits, 'ch');
var _rtfeldman$elm_css$Css$RemUnits = {ctor: 'RemUnits'};
var _rtfeldman$elm_css$Css$rem = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$RemUnits, 'rem');
var _rtfeldman$elm_css$Css$VhUnits = {ctor: 'VhUnits'};
var _rtfeldman$elm_css$Css$vh = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$VhUnits, 'vh');
var _rtfeldman$elm_css$Css$VwUnits = {ctor: 'VwUnits'};
var _rtfeldman$elm_css$Css$vw = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$VwUnits, 'vw');
var _rtfeldman$elm_css$Css$VMinUnits = {ctor: 'VMinUnits'};
var _rtfeldman$elm_css$Css$vmin = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$VMinUnits, 'vmin');
var _rtfeldman$elm_css$Css$VMaxUnits = {ctor: 'VMaxUnits'};
var _rtfeldman$elm_css$Css$vmax = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$VMaxUnits, 'vmax');
var _rtfeldman$elm_css$Css$PxUnits = {ctor: 'PxUnits'};
var _rtfeldman$elm_css$Css$px = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$PxUnits, 'px');
var _rtfeldman$elm_css$Css$MMUnits = {ctor: 'MMUnits'};
var _rtfeldman$elm_css$Css$mm = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$MMUnits, 'mm');
var _rtfeldman$elm_css$Css$CMUnits = {ctor: 'CMUnits'};
var _rtfeldman$elm_css$Css$cm = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$CMUnits, 'cm');
var _rtfeldman$elm_css$Css$InchUnits = {ctor: 'InchUnits'};
var _rtfeldman$elm_css$Css$inches = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$InchUnits, 'in');
var _rtfeldman$elm_css$Css$PtUnits = {ctor: 'PtUnits'};
var _rtfeldman$elm_css$Css$pt = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$PtUnits, 'pt');
var _rtfeldman$elm_css$Css$PcUnits = {ctor: 'PcUnits'};
var _rtfeldman$elm_css$Css$pc = A2(_rtfeldman$elm_css$Css_Internal$lengthConverter, _rtfeldman$elm_css$Css$PcUnits, 'pc');
var _rtfeldman$elm_css$Css$UnitlessInteger = {ctor: 'UnitlessInteger'};
var _rtfeldman$elm_css$Css$zero = {value: '0', length: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNumber: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNone: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, lengthOrNoneOrMinMaxDimension: _rtfeldman$elm_css$Css_Structure$Compatible, number: _rtfeldman$elm_css$Css_Structure$Compatible, outline: _rtfeldman$elm_css$Css_Structure$Compatible, units: _rtfeldman$elm_css$Css$UnitlessInteger, unitLabel: '', numericValue: 0, lengthOrAutoOrCoverOrContain: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css$int = function (val) {
	return {
		value: _elm_lang$core$Basics$toString(val),
		lengthOrNumber: _rtfeldman$elm_css$Css_Structure$Compatible,
		number: _rtfeldman$elm_css$Css_Structure$Compatible,
		numberOrInfinite: _rtfeldman$elm_css$Css_Structure$Compatible,
		fontWeight: _rtfeldman$elm_css$Css_Structure$Compatible,
		lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible,
		intOrAuto: _rtfeldman$elm_css$Css_Structure$Compatible,
		numericValue: _elm_lang$core$Basics$toFloat(val),
		unitLabel: '',
		units: _rtfeldman$elm_css$Css$UnitlessInteger
	};
};
var _rtfeldman$elm_css$Css$UnitlessFloat = {ctor: 'UnitlessFloat'};
var _rtfeldman$elm_css$Css$num = function (val) {
	return {
		value: _elm_lang$core$Basics$toString(val),
		lengthOrNumber: _rtfeldman$elm_css$Css_Structure$Compatible,
		number: _rtfeldman$elm_css$Css_Structure$Compatible,
		numberOrInfinite: _rtfeldman$elm_css$Css_Structure$Compatible,
		lengthOrNumberOrAutoOrNoneOrContent: _rtfeldman$elm_css$Css_Structure$Compatible,
		numericValue: val,
		unitLabel: '',
		units: _rtfeldman$elm_css$Css$UnitlessFloat
	};
};
var _rtfeldman$elm_css$Css$IntentionallyUnsupportedPleaseSeeDocs = {ctor: 'IntentionallyUnsupportedPleaseSeeDocs'};
var _rtfeldman$elm_css$Css$thin = _rtfeldman$elm_css$Css$IntentionallyUnsupportedPleaseSeeDocs;
var _rtfeldman$elm_css$Css$thick = _rtfeldman$elm_css$Css$IntentionallyUnsupportedPleaseSeeDocs;
var _rtfeldman$elm_css$Css$blink = _rtfeldman$elm_css$Css$IntentionallyUnsupportedPleaseSeeDocs;

var _rtfeldman$elm_css$Css_Media$unparameterizedFeature = function (key) {
	return {feature: key, value: _elm_lang$core$Maybe$Nothing};
};
var _rtfeldman$elm_css$Css_Media$feature = F2(
	function (key, _p0) {
		var _p1 = _p0;
		return {
			feature: key,
			value: _elm_lang$core$Maybe$Just(_p1.value)
		};
	});
var _rtfeldman$elm_css$Css_Media$scripting = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'scripting', value);
};
var _rtfeldman$elm_css$Css_Media$enabled = {value: 'enabled', scriptingSupport: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$initialOnly = {value: 'initial-only', scriptingSupport: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$anyHover = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'any-hover', value);
};
var _rtfeldman$elm_css$Css_Media$hover = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'hover', value);
};
var _rtfeldman$elm_css$Css_Media$canHover = {value: 'hover', hoverCapability: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$anyPointer = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'any-pointer', value);
};
var _rtfeldman$elm_css$Css_Media$pointer = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'pointer', value);
};
var _rtfeldman$elm_css$Css_Media$coarse = {value: 'coarse', pointerDevice: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$fine = {value: 'fine', pointerDevice: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$colorGamut = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'color-gamut', value);
};
var _rtfeldman$elm_css$Css_Media$rec2020 = {value: 'rec2020', colorGamut: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$p3 = {value: 'p3', colorGamut: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$srgb = {value: 'srgb', colorGamut: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$maxColorIndex = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'max-color-index', value);
};
var _rtfeldman$elm_css$Css_Media$minColorIndex = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'min-color-index', value);
};
var _rtfeldman$elm_css$Css_Media$colorIndex = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'color-index', value);
};
var _rtfeldman$elm_css$Css_Media$maxMonochrome = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'max-monochrome', value);
};
var _rtfeldman$elm_css$Css_Media$minMonochrome = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'min-monochrome', value);
};
var _rtfeldman$elm_css$Css_Media$monochrome = _rtfeldman$elm_css$Css_Media$unparameterizedFeature('monochrome');
var _rtfeldman$elm_css$Css_Media$maxColor = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'max-color', value);
};
var _rtfeldman$elm_css$Css_Media$color = _rtfeldman$elm_css$Css_Media$unparameterizedFeature('color');
var _rtfeldman$elm_css$Css_Media$minColor = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'min-color', value);
};
var _rtfeldman$elm_css$Css_Media$bits = function (value) {
	return {
		value: _elm_lang$core$Basics$toString(value),
		bits: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css_Media$overflowInline = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'overflow-inline', value);
};
var _rtfeldman$elm_css$Css_Media$overflowBlock = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'overflow-block', value);
};
var _rtfeldman$elm_css$Css_Media$optionalPaged = {value: 'optional-paged', blockAxisOverflow: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$paged = {value: 'paged', blockAxisOverflow: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$update = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'update', value);
};
var _rtfeldman$elm_css$Css_Media$fast = {value: 'fast', updateFrequency: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$slow = {value: 'slow', updateFrequency: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$grid = _rtfeldman$elm_css$Css_Media$unparameterizedFeature('grid');
var _rtfeldman$elm_css$Css_Media$scan = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'scan', value);
};
var _rtfeldman$elm_css$Css_Media$interlace = {value: 'interlace', scanningProcess: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$progressive = {value: 'progressive', scanningProcess: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$maxResolution = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'max-resolution', value);
};
var _rtfeldman$elm_css$Css_Media$resolution = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'resolution', value);
};
var _rtfeldman$elm_css$Css_Media$minResolution = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'min-resolution', value);
};
var _rtfeldman$elm_css$Css_Media$dppx = function (value) {
	return {
		value: A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(value),
			'dppx'),
		resolution: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css_Media$dpcm = function (value) {
	return {
		value: A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(value),
			'dpcm'),
		resolution: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css_Media$dpi = function (value) {
	return {
		value: A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(value),
			'dpi'),
		resolution: _rtfeldman$elm_css$Css_Structure$Compatible
	};
};
var _rtfeldman$elm_css$Css_Media$orientation = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'orientation', value);
};
var _rtfeldman$elm_css$Css_Media$portrait = {value: 'portrait', orientation: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$landscape = {value: 'landscape', orientation: _rtfeldman$elm_css$Css_Structure$Compatible};
var _rtfeldman$elm_css$Css_Media$maxAspectRatio = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'max-aspect-ratio', value);
};
var _rtfeldman$elm_css$Css_Media$aspectRatio = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'aspect-ratio', value);
};
var _rtfeldman$elm_css$Css_Media$minAspectRatio = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'min-aspect-ratio', value);
};
var _rtfeldman$elm_css$Css_Media$ratio = F2(
	function (numerator, denominator) {
		return {
			value: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(numerator),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'/',
					_elm_lang$core$Basics$toString(denominator))),
			ratio: _rtfeldman$elm_css$Css_Structure$Compatible
		};
	});
var _rtfeldman$elm_css$Css_Media$maxHeight = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'max-height', value);
};
var _rtfeldman$elm_css$Css_Media$height = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'height', value);
};
var _rtfeldman$elm_css$Css_Media$minHeight = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'min-height', value);
};
var _rtfeldman$elm_css$Css_Media$maxWidth = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'max-width', value);
};
var _rtfeldman$elm_css$Css_Media$width = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'width', value);
};
var _rtfeldman$elm_css$Css_Media$minWidth = function (value) {
	return A2(_rtfeldman$elm_css$Css_Media$feature, 'min-width', value);
};
var _rtfeldman$elm_css$Css_Media$speech = _rtfeldman$elm_css$Css_Structure$Speech;
var _rtfeldman$elm_css$Css_Media$screen = _rtfeldman$elm_css$Css_Structure$Screen;
var _rtfeldman$elm_css$Css_Media$print = _rtfeldman$elm_css$Css_Structure$Print;
var _rtfeldman$elm_css$Css_Media$not = _rtfeldman$elm_css$Css_Structure$NotQuery;
var _rtfeldman$elm_css$Css_Media$only = _rtfeldman$elm_css$Css_Structure$OnlyQuery;
var _rtfeldman$elm_css$Css_Media$all = _rtfeldman$elm_css$Css_Structure$AllQuery;
var _rtfeldman$elm_css$Css_Media$withMediaQuery = function (queries) {
	return _rtfeldman$elm_css$Css_Preprocess$WithMedia(
		A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure$CustomQuery, queries));
};
var _rtfeldman$elm_css$Css_Media$withMedia = _rtfeldman$elm_css$Css_Preprocess$WithMedia;
var _rtfeldman$elm_css$Css_Media$Ratio = F2(
	function (a, b) {
		return {value: a, ratio: b};
	});
var _rtfeldman$elm_css$Css_Media$Landscape = F2(
	function (a, b) {
		return {value: a, orientation: b};
	});
var _rtfeldman$elm_css$Css_Media$Portrait = F2(
	function (a, b) {
		return {value: a, orientation: b};
	});
var _rtfeldman$elm_css$Css_Media$Resolution = F2(
	function (a, b) {
		return {value: a, resolution: b};
	});
var _rtfeldman$elm_css$Css_Media$Progressive = F2(
	function (a, b) {
		return {value: a, scanningProcess: b};
	});
var _rtfeldman$elm_css$Css_Media$Interlace = F2(
	function (a, b) {
		return {value: a, scanningProcess: b};
	});
var _rtfeldman$elm_css$Css_Media$Slow = F2(
	function (a, b) {
		return {value: a, updateFrequency: b};
	});
var _rtfeldman$elm_css$Css_Media$Fast = F2(
	function (a, b) {
		return {value: a, updateFrequency: b};
	});
var _rtfeldman$elm_css$Css_Media$Paged = F2(
	function (a, b) {
		return {value: a, blockAxisOverflow: b};
	});
var _rtfeldman$elm_css$Css_Media$OptionalPaged = F2(
	function (a, b) {
		return {value: a, blockAxisOverflow: b};
	});
var _rtfeldman$elm_css$Css_Media$Bits = F2(
	function (a, b) {
		return {value: a, bits: b};
	});
var _rtfeldman$elm_css$Css_Media$SRGB = F2(
	function (a, b) {
		return {value: a, colorGamut: b};
	});
var _rtfeldman$elm_css$Css_Media$P3 = F2(
	function (a, b) {
		return {value: a, colorGamut: b};
	});
var _rtfeldman$elm_css$Css_Media$Rec2020 = F2(
	function (a, b) {
		return {value: a, colorGamut: b};
	});
var _rtfeldman$elm_css$Css_Media$Fine = F2(
	function (a, b) {
		return {value: a, pointerDevice: b};
	});
var _rtfeldman$elm_css$Css_Media$Coarse = F2(
	function (a, b) {
		return {value: a, pointerDevice: b};
	});
var _rtfeldman$elm_css$Css_Media$CanHover = F2(
	function (a, b) {
		return {value: a, hoverCapability: b};
	});
var _rtfeldman$elm_css$Css_Media$InitialOnly = F2(
	function (a, b) {
		return {value: a, scriptingSupport: b};
	});
var _rtfeldman$elm_css$Css_Media$Enabled = F2(
	function (a, b) {
		return {value: a, scriptingSupport: b};
	});

var _rtfeldman$elm_css$Css_Structure_Output$noIndent = '';
var _rtfeldman$elm_css$Css_Structure_Output$spaceIndent = '    ';
var _rtfeldman$elm_css$Css_Structure_Output$indent = function (str) {
	return A2(_elm_lang$core$Basics_ops['++'], _rtfeldman$elm_css$Css_Structure_Output$spaceIndent, str);
};
var _rtfeldman$elm_css$Css_Structure_Output$emitProperty = function (str) {
	return A2(_elm_lang$core$Basics_ops['++'], str, ';');
};
var _rtfeldman$elm_css$Css_Structure_Output$emitProperties = function (properties) {
	return A2(
		_elm_lang$core$String$join,
		'\n',
		A2(
			_elm_lang$core$List$map,
			function (_p0) {
				return _rtfeldman$elm_css$Css_Structure_Output$indent(
					_rtfeldman$elm_css$Css_Structure_Output$emitProperty(_p0));
			},
			properties));
};
var _rtfeldman$elm_css$Css_Structure_Output$combinatorToString = function (combinator) {
	var _p1 = combinator;
	switch (_p1.ctor) {
		case 'AdjacentSibling':
			return '+';
		case 'GeneralSibling':
			return '~';
		case 'Child':
			return '>';
		default:
			return '';
	}
};
var _rtfeldman$elm_css$Css_Structure_Output$pseudoElementToString = function (_p2) {
	var _p3 = _p2;
	return A2(_elm_lang$core$Basics_ops['++'], '::', _p3._0);
};
var _rtfeldman$elm_css$Css_Structure_Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	var _p4 = repeatableSimpleSelector;
	switch (_p4.ctor) {
		case 'ClassSelector':
			return A2(_elm_lang$core$Basics_ops['++'], '.', _p4._0);
		case 'IdSelector':
			return A2(_elm_lang$core$Basics_ops['++'], '#', _p4._0);
		case 'PseudoClassSelector':
			return A2(_elm_lang$core$Basics_ops['++'], ':', _p4._0);
		default:
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'[',
				A2(_elm_lang$core$Basics_ops['++'], _p4._0, ']'));
	}
};
var _rtfeldman$elm_css$Css_Structure_Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	var _p5 = simpleSelectorSequence;
	switch (_p5.ctor) {
		case 'TypeSelectorSequence':
			return A2(
				_elm_lang$core$String$join,
				'',
				{
					ctor: '::',
					_0: _p5._0._0,
					_1: A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$repeatableSimpleSelectorToString, _p5._1)
				});
		case 'UniversalSelectorSequence':
			var _p6 = _p5._0;
			return _elm_lang$core$List$isEmpty(_p6) ? '*' : A2(
				_elm_lang$core$String$join,
				'',
				A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$repeatableSimpleSelectorToString, _p6));
		default:
			return A2(
				_elm_lang$core$String$join,
				'',
				{
					ctor: '::',
					_0: _p5._0,
					_1: A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$repeatableSimpleSelectorToString, _p5._1)
				});
	}
};
var _rtfeldman$elm_css$Css_Structure_Output$selectorChainToString = function (_p7) {
	var _p8 = _p7;
	return A2(
		_elm_lang$core$String$join,
		' ',
		{
			ctor: '::',
			_0: _rtfeldman$elm_css$Css_Structure_Output$combinatorToString(_p8._0),
			_1: {
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Structure_Output$simpleSelectorSequenceToString(_p8._1),
				_1: {ctor: '[]'}
			}
		});
};
var _rtfeldman$elm_css$Css_Structure_Output$selectorToString = function (_p9) {
	var _p10 = _p9;
	var pseudoElementsString = A2(
		_elm_lang$core$String$join,
		'',
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Maybe$withDefault,
				'',
				A2(_elm_lang$core$Maybe$map, _rtfeldman$elm_css$Css_Structure_Output$pseudoElementToString, _p10._2)),
			_1: {ctor: '[]'}
		});
	var segments = {
		ctor: '::',
		_0: _rtfeldman$elm_css$Css_Structure_Output$simpleSelectorSequenceToString(_p10._0),
		_1: A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$selectorChainToString, _p10._1)
	};
	return A2(
		_elm_lang$core$String$append,
		A2(
			_elm_lang$core$String$join,
			' ',
			A2(
				_elm_lang$core$List$filter,
				function (_p11) {
					return !_elm_lang$core$String$isEmpty(_p11);
				},
				segments)),
		pseudoElementsString);
};
var _rtfeldman$elm_css$Css_Structure_Output$mediaExpressionToString = function (expression) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		'(',
		A2(
			_elm_lang$core$Basics_ops['++'],
			expression.feature,
			A2(
				_elm_lang$core$Basics_ops['++'],
				A2(
					_elm_lang$core$Maybe$withDefault,
					'',
					A2(
						_elm_lang$core$Maybe$map,
						F2(
							function (x, y) {
								return A2(_elm_lang$core$Basics_ops['++'], x, y);
							})(': '),
						expression.value)),
				')')));
};
var _rtfeldman$elm_css$Css_Structure_Output$mediaTypeToString = function (mediaType) {
	var _p12 = mediaType;
	switch (_p12.ctor) {
		case 'Print':
			return 'print';
		case 'Screen':
			return 'screen';
		default:
			return 'speech';
	}
};
var _rtfeldman$elm_css$Css_Structure_Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				str,
				A2(
					_elm_lang$core$Basics_ops['++'],
					' ',
					A2(
						_elm_lang$core$String$join,
						' and ',
						{
							ctor: '::',
							_0: _rtfeldman$elm_css$Css_Structure_Output$mediaTypeToString(mediaType),
							_1: A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$mediaExpressionToString, expressions)
						})));
		});
	var _p13 = mediaQuery;
	switch (_p13.ctor) {
		case 'AllQuery':
			return A2(
				_elm_lang$core$String$join,
				' and ',
				A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$mediaExpressionToString, _p13._0));
		case 'OnlyQuery':
			return A3(prefixWith, 'only', _p13._0, _p13._1);
		case 'NotQuery':
			return A3(prefixWith, 'not', _p13._0, _p13._1);
		default:
			return _p13._0;
	}
};
var _rtfeldman$elm_css$Css_Structure_Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _p14) {
		var _p15 = _p14;
		var selectorStr = A2(
			_elm_lang$core$String$join,
			', ',
			A2(
				_elm_lang$core$List$map,
				_rtfeldman$elm_css$Css_Structure_Output$selectorToString,
				{ctor: '::', _0: _p15._0, _1: _p15._1}));
		return A2(
			_elm_lang$core$String$join,
			'',
			{
				ctor: '::',
				_0: selectorStr,
				_1: {
					ctor: '::',
					_0: ' {\n',
					_1: {
						ctor: '::',
						_0: indentLevel,
						_1: {
							ctor: '::',
							_0: _rtfeldman$elm_css$Css_Structure_Output$emitProperties(_p15._2),
							_1: {
								ctor: '::',
								_0: '\n',
								_1: {
									ctor: '::',
									_0: indentLevel,
									_1: {
										ctor: '::',
										_0: '}',
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			});
	});
var _rtfeldman$elm_css$Css_Structure_Output$prettyPrintDeclaration = function (decl) {
	var _p16 = decl;
	switch (_p16.ctor) {
		case 'StyleBlockDeclaration':
			return A2(_rtfeldman$elm_css$Css_Structure_Output$prettyPrintStyleBlock, _rtfeldman$elm_css$Css_Structure_Output$noIndent, _p16._0);
		case 'MediaRule':
			var query = A2(
				_elm_lang$core$String$join,
				',\n',
				A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$mediaQueryToString, _p16._0));
			var blocks = A2(
				_elm_lang$core$String$join,
				'\n\n',
				A2(
					_elm_lang$core$List$map,
					function (_p17) {
						return _rtfeldman$elm_css$Css_Structure_Output$indent(
							A2(_rtfeldman$elm_css$Css_Structure_Output$prettyPrintStyleBlock, _rtfeldman$elm_css$Css_Structure_Output$spaceIndent, _p17));
					},
					_p16._1));
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'@media ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					query,
					A2(
						_elm_lang$core$Basics_ops['++'],
						' {\n',
						A2(_elm_lang$core$Basics_ops['++'], blocks, '\n}'))));
		case 'SupportsRule':
			return 'TODO';
		case 'DocumentRule':
			return 'TODO';
		case 'PageRule':
			return 'TODO';
		case 'FontFace':
			return 'TODO';
		case 'Keyframes':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'@keyframes ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_p16._0.name,
					A2(
						_elm_lang$core$Basics_ops['++'],
						' {\n',
						A2(_elm_lang$core$Basics_ops['++'], _p16._0.declaration, '\n}'))));
		case 'Viewport':
			return 'TODO';
		case 'CounterStyle':
			return 'TODO';
		default:
			return 'TODO';
	}
};
var _rtfeldman$elm_css$Css_Structure_Output$namespaceToString = function (_p18) {
	var _p19 = _p18;
	return A2(
		_elm_lang$core$Basics_ops['++'],
		'@namespace ',
		A2(
			_elm_lang$core$Basics_ops['++'],
			_p19._0,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'\"',
				A2(_elm_lang$core$Basics_ops['++'], _p19._1, '\"'))));
};
var _rtfeldman$elm_css$Css_Structure_Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			'@import \"',
			A2(
				_elm_lang$core$Basics_ops['++'],
				name,
				A2(
					_elm_lang$core$Basics_ops['++'],
					_rtfeldman$elm_css$Css_Structure_Output$mediaQueryToString(mediaQuery),
					'\"')));
	});
var _rtfeldman$elm_css$Css_Structure_Output$importToString = function (_p20) {
	var _p21 = _p20;
	return A2(
		_elm_lang$core$String$join,
		'\n',
		A2(
			_elm_lang$core$List$map,
			_rtfeldman$elm_css$Css_Structure_Output$importMediaQueryToString(_p21._0),
			_p21._1));
};
var _rtfeldman$elm_css$Css_Structure_Output$charsetToString = function (charset) {
	return A2(
		_elm_lang$core$Maybe$withDefault,
		'',
		A2(
			_elm_lang$core$Maybe$map,
			function (str) {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'@charset \"',
					A2(_elm_lang$core$Basics_ops['++'], str, '\"'));
			},
			charset));
};
var _rtfeldman$elm_css$Css_Structure_Output$prettyPrint = function (_p22) {
	var _p23 = _p22;
	return A2(
		_elm_lang$core$String$join,
		'\n\n',
		A2(
			_elm_lang$core$List$filter,
			function (_p24) {
				return !_elm_lang$core$String$isEmpty(_p24);
			},
			{
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Structure_Output$charsetToString(_p23.charset),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$core$String$join,
						'\n',
						A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$importToString, _p23.imports)),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$String$join,
							'\n',
							A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$namespaceToString, _p23.namespaces)),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$String$join,
								'\n\n',
								A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure_Output$prettyPrintDeclaration, _p23.declarations)),
							_1: {ctor: '[]'}
						}
					}
				}
			}));
};

var _rtfeldman$elm_css$Hash$murmurSeed = 15739;
var _rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		_elm_lang$core$String$cons,
		_elm_lang$core$Native_Utils.chr('_'),
		_rtfeldman$hex$Hex$toString(
			A2(_Skinney$murmur3$Murmur3$hashString, _rtfeldman$elm_css$Hash$murmurSeed, str)));
};

var _rtfeldman$elm_css$Css_Preprocess_Resolve$last = function (list) {
	last:
	while (true) {
		var _p0 = list;
		if (_p0.ctor === '[]') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			if (_p0._1.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p0._0);
			} else {
				var _v1 = _p0._1;
				list = _v1;
				continue last;
			}
		}
	}
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		var _p1 = maybes;
		if (_p1.ctor === '[]') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p3 = _p1._0;
			var _p2 = _p3;
			if (_p2.ctor === 'Nothing') {
				var _v4 = _p1._1;
				maybes = _v4;
				continue oneOf;
			} else {
				return _p3;
			}
		}
	}
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		var _p4 = declarations;
		if (_p4.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			if (_p4._0.ctor === 'StyleBlockDeclaration') {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					{ctor: '::', _0: _p4._0._0._0, _1: _p4._0._0._1},
					_rtfeldman$elm_css$Css_Preprocess_Resolve$collectSelectors(_p4._1));
			} else {
				var _v6 = _p4._1;
				declarations = _v6;
				continue collectSelectors;
			}
		}
	}
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		var _p5 = declaration;
		if (_p5.ctor === 'StyleBlockDeclaration') {
			return A5(_rtfeldman$elm_css$Css_Structure$DocumentRule, str1, str2, str3, str4, _p5._0);
		} else {
			return declaration;
		}
	});
var _rtfeldman$elm_css$Css_Preprocess_Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		var _p6 = declarations;
		if (_p6.ctor === '[]') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			if (_p6._1.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: _p6._0,
						_1: {ctor: '[]'}
					});
			} else {
				var _v9 = _p6._1;
				declarations = _v9;
				continue lastDeclaration;
			}
		}
	}
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		var _p7 = tuplesToExpand;
		if (_p7.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			return {
				ctor: '::',
				_0: _p7._0,
				_1: expandTuples(_p7._1)
			};
		}
	};
	var newTuples = expandTuples(tuples);
	return {
		ctor: '::',
		_0: _rtfeldman$elm_css$Css_Structure$FontFeatureValues(newTuples),
		_1: {ctor: '[]'}
	};
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		var _p8 = declaration;
		switch (_p8.ctor) {
			case 'StyleBlockDeclaration':
				return A2(
					_rtfeldman$elm_css$Css_Structure$MediaRule,
					mediaQueries,
					{
						ctor: '::',
						_0: _p8._0,
						_1: {ctor: '[]'}
					});
			case 'MediaRule':
				return A2(
					_rtfeldman$elm_css$Css_Structure$MediaRule,
					A2(_elm_lang$core$Basics_ops['++'], mediaQueries, _p8._0),
					_p8._1);
			case 'SupportsRule':
				return A2(
					_rtfeldman$elm_css$Css_Structure$SupportsRule,
					_p8._0,
					A2(
						_elm_lang$core$List$map,
						_rtfeldman$elm_css$Css_Preprocess_Resolve$toMediaRule(mediaQueries),
						_p8._1));
			case 'DocumentRule':
				return A5(_rtfeldman$elm_css$Css_Structure$DocumentRule, _p8._0, _p8._1, _p8._2, _p8._3, _p8._4);
			case 'PageRule':
				return declaration;
			case 'FontFace':
				return declaration;
			case 'Keyframes':
				return declaration;
			case 'Viewport':
				return declaration;
			case 'CounterStyle':
				return declaration;
			default:
				return declaration;
		}
	});
var _rtfeldman$elm_css$Css_Preprocess_Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				_elm_lang$core$List$map,
				_rtfeldman$elm_css$Css_Preprocess_Resolve$toMediaRule(mediaQueries),
				_rtfeldman$elm_css$Css_Preprocess_Resolve$expandStyleBlock(styleBlock));
		};
		return A2(_elm_lang$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var _rtfeldman$elm_css$Css_Preprocess_Resolve$expandStyleBlock = function (_p9) {
	var _p10 = _p9;
	return A2(
		_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles,
		_p10._2,
		{
			ctor: '::',
			_0: _rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration(
				A3(
					_rtfeldman$elm_css$Css_Structure$StyleBlock,
					_p10._0,
					_p10._1,
					{ctor: '[]'})),
			_1: {ctor: '[]'}
		});
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles = F2(
	function (styles, declarations) {
		applyStyles:
		while (true) {
			var _p11 = styles;
			if (_p11.ctor === '[]') {
				return declarations;
			} else {
				switch (_p11._0.ctor) {
					case 'AppendProperty':
						var _v14 = _p11._1,
							_v15 = A2(_rtfeldman$elm_css$Css_Structure$appendProperty, _p11._0._0, declarations);
						styles = _v14;
						declarations = _v15;
						continue applyStyles;
					case 'ExtendSelector':
						return A4(
							_rtfeldman$elm_css$Css_Preprocess_Resolve$applyNestedStylesToLast,
							_p11._0._1,
							_p11._1,
							_rtfeldman$elm_css$Css_Structure$appendRepeatableToLastSelector(_p11._0._0),
							declarations);
					case 'NestSnippet':
						var chain = F2(
							function (_p13, _p12) {
								var _p14 = _p13;
								var _p15 = _p12;
								return A3(
									_rtfeldman$elm_css$Css_Structure$Selector,
									_p14._0,
									A2(
										_elm_lang$core$Basics_ops['++'],
										_p14._1,
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: _p11._0._0, _1: _p15._0},
											_1: _p15._1
										}),
									_rtfeldman$elm_css$Css_Preprocess_Resolve$oneOf(
										{
											ctor: '::',
											_0: _p15._2,
											_1: {
												ctor: '::',
												_0: _p14._2,
												_1: {ctor: '[]'}
											}
										}));
							});
						var expandDeclaration = function (declaration) {
							var _p16 = declaration;
							switch (_p16.ctor) {
								case 'StyleBlockDeclaration':
									var newSelectors = A2(
										_elm_lang$core$List$concatMap,
										function (originalSelector) {
											return A2(
												_elm_lang$core$List$map,
												chain(originalSelector),
												{ctor: '::', _0: _p16._0._0, _1: _p16._0._1});
										},
										_rtfeldman$elm_css$Css_Preprocess_Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										var _p17 = newSelectors;
										if (_p17.ctor === '[]') {
											return {ctor: '[]'};
										} else {
											return {
												ctor: '::',
												_0: _rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration(
													A3(
														_rtfeldman$elm_css$Css_Structure$StyleBlock,
														_p17._0,
														_p17._1,
														{ctor: '[]'})),
												_1: {ctor: '[]'}
											};
										}
									}();
									return A2(_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles, _p16._0._2, newDeclarations);
								case 'MediaRule':
									return A2(_rtfeldman$elm_css$Css_Preprocess_Resolve$resolveMediaRule, _p16._0, _p16._1);
								case 'SupportsRule':
									return A2(_rtfeldman$elm_css$Css_Preprocess_Resolve$resolveSupportsRule, _p16._0, _p16._1);
								case 'DocumentRule':
									return A2(
										_elm_lang$core$List$map,
										A4(_rtfeldman$elm_css$Css_Preprocess_Resolve$toDocumentRule, _p16._0, _p16._1, _p16._2, _p16._3),
										_rtfeldman$elm_css$Css_Preprocess_Resolve$expandStyleBlock(_p16._4));
								case 'PageRule':
									return {
										ctor: '::',
										_0: A2(_rtfeldman$elm_css$Css_Structure$PageRule, _p16._0, _p16._1),
										_1: {ctor: '[]'}
									};
								case 'FontFace':
									return {
										ctor: '::',
										_0: _rtfeldman$elm_css$Css_Structure$FontFace(_p16._0),
										_1: {ctor: '[]'}
									};
								case 'Viewport':
									return {
										ctor: '::',
										_0: _rtfeldman$elm_css$Css_Structure$Viewport(_p16._0),
										_1: {ctor: '[]'}
									};
								case 'CounterStyle':
									return {
										ctor: '::',
										_0: _rtfeldman$elm_css$Css_Structure$CounterStyle(_p16._0),
										_1: {ctor: '[]'}
									};
								default:
									return _rtfeldman$elm_css$Css_Preprocess_Resolve$resolveFontFeatureValues(_p16._0);
							}
						};
						return _elm_lang$core$List$concat(
							A2(
								F2(
									function (x, y) {
										return A2(_elm_lang$core$Basics_ops['++'], x, y);
									}),
								{
									ctor: '::',
									_0: A2(_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles, _p11._1, declarations),
									_1: {ctor: '[]'}
								},
								A2(
									_elm_lang$core$List$map,
									expandDeclaration,
									A2(_elm_lang$core$List$concatMap, _rtfeldman$elm_css$Css_Preprocess$unwrapSnippet, _p11._0._1))));
					case 'WithPseudoElement':
						return A4(
							_rtfeldman$elm_css$Css_Preprocess_Resolve$applyNestedStylesToLast,
							_p11._0._1,
							_p11._1,
							_rtfeldman$elm_css$Css_Structure$appendPseudoElementToLastSelector(_p11._0._0),
							declarations);
					case 'WithKeyframes':
						var _p18 = _p11._0._0;
						var name = _rtfeldman$elm_css$Hash$fromString(_p18);
						var newProperty = A2(_elm_lang$core$Basics_ops['++'], 'animation-name:', name);
						var newDeclarations = A2(
							_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles,
							_p11._1,
							A2(_rtfeldman$elm_css$Css_Structure$appendProperty, newProperty, declarations));
						return A2(
							_elm_lang$core$List$append,
							newDeclarations,
							{
								ctor: '::',
								_0: _rtfeldman$elm_css$Css_Structure$Keyframes(
									{name: name, declaration: _p18}),
								_1: {ctor: '[]'}
							});
					case 'WithMedia':
						var extraDeclarations = function () {
							var _p19 = _rtfeldman$elm_css$Css_Preprocess_Resolve$collectSelectors(declarations);
							if (_p19.ctor === '[]') {
								return {ctor: '[]'};
							} else {
								return A2(
									_elm_lang$core$List$map,
									_rtfeldman$elm_css$Css_Structure$styleBlockToMediaRule(_p11._0._0),
									A2(
										_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles,
										_p11._0._1,
										_elm_lang$core$List$singleton(
											_rtfeldman$elm_css$Css_Structure$StyleBlockDeclaration(
												A3(
													_rtfeldman$elm_css$Css_Structure$StyleBlock,
													_p19._0,
													_p19._1,
													{ctor: '[]'})))));
							}
						}();
						return A2(
							_elm_lang$core$Basics_ops['++'],
							A2(_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles, _p11._1, declarations),
							extraDeclarations);
					default:
						var _v21 = A2(_elm_lang$core$Basics_ops['++'], _p11._0._0, _p11._1),
							_v22 = declarations;
						styles = _v21;
						declarations = _v22;
						continue applyStyles;
				}
			}
		}
	});
var _rtfeldman$elm_css$Css_Preprocess_Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				_elm_lang$core$Maybe$withDefault,
				{ctor: '[]'},
				_elm_lang$core$List$tail(decls));
		};
		var nextResult = A2(
			_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles,
			rest,
			A2(
				_elm_lang$core$Maybe$withDefault,
				{ctor: '[]'},
				_rtfeldman$elm_css$Css_Preprocess_Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _p20 = {
				ctor: '_Tuple2',
				_0: _elm_lang$core$List$head(nextResult),
				_1: _rtfeldman$elm_css$Css_Preprocess_Resolve$last(declarations)
			};
			if (((_p20.ctor === '_Tuple2') && (_p20._0.ctor === 'Just')) && (_p20._1.ctor === 'Just')) {
				var _p22 = _p20._1._0;
				var _p21 = _p20._0._0;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					A2(
						_elm_lang$core$List$take,
						_elm_lang$core$List$length(declarations) - 1,
						declarations),
					{
						ctor: '::',
						_0: (!_elm_lang$core$Native_Utils.eq(_p22, _p21)) ? _p21 : _p22,
						_1: {ctor: '[]'}
					});
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return _elm_lang$core$List$concat(
				A2(
					_rtfeldman$elm_css$Css_Structure$mapLast,
					_rtfeldman$elm_css$Css_Preprocess_Resolve$applyStyles(nestedStyles),
					A2(
						_elm_lang$core$List$map,
						_elm_lang$core$List$singleton,
						A2(_rtfeldman$elm_css$Css_Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			_elm_lang$core$Maybe$withDefault,
			{ctor: '[]'},
			A2(
				_elm_lang$core$Maybe$map,
				insertStylesToNestedDecl,
				_rtfeldman$elm_css$Css_Preprocess_Resolve$lastDeclaration(declarations)));
		return A2(
			_elm_lang$core$Basics_ops['++'],
			newDeclarations,
			A2(
				_elm_lang$core$Basics_ops['++'],
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var _rtfeldman$elm_css$Css_Preprocess_Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = _rtfeldman$elm_css$Css_Preprocess_Resolve$extract(
			A2(_elm_lang$core$List$concatMap, _rtfeldman$elm_css$Css_Preprocess$unwrapSnippet, snippets));
		return {
			ctor: '::',
			_0: A2(_rtfeldman$elm_css$Css_Structure$SupportsRule, str, declarations),
			_1: {ctor: '[]'}
		};
	});
var _rtfeldman$elm_css$Css_Preprocess_Resolve$extract = function (snippetDeclarations) {
	var _p23 = snippetDeclarations;
	if (_p23.ctor === '[]') {
		return {ctor: '[]'};
	} else {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			_rtfeldman$elm_css$Css_Preprocess_Resolve$toDeclarations(_p23._0),
			_rtfeldman$elm_css$Css_Preprocess_Resolve$extract(_p23._1));
	}
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$toDeclarations = function (snippetDeclaration) {
	var _p24 = snippetDeclaration;
	switch (_p24.ctor) {
		case 'StyleBlockDeclaration':
			return _rtfeldman$elm_css$Css_Preprocess_Resolve$expandStyleBlock(_p24._0);
		case 'MediaRule':
			return A2(_rtfeldman$elm_css$Css_Preprocess_Resolve$resolveMediaRule, _p24._0, _p24._1);
		case 'SupportsRule':
			return A2(_rtfeldman$elm_css$Css_Preprocess_Resolve$resolveSupportsRule, _p24._0, _p24._1);
		case 'DocumentRule':
			return A2(
				_elm_lang$core$List$map,
				A4(_rtfeldman$elm_css$Css_Preprocess_Resolve$toDocumentRule, _p24._0, _p24._1, _p24._2, _p24._3),
				_rtfeldman$elm_css$Css_Preprocess_Resolve$expandStyleBlock(_p24._4));
		case 'PageRule':
			return {
				ctor: '::',
				_0: A2(_rtfeldman$elm_css$Css_Structure$PageRule, _p24._0, _p24._1),
				_1: {ctor: '[]'}
			};
		case 'FontFace':
			return {
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Structure$FontFace(_p24._0),
				_1: {ctor: '[]'}
			};
		case 'Viewport':
			return {
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Structure$Viewport(_p24._0),
				_1: {ctor: '[]'}
			};
		case 'CounterStyle':
			return {
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Structure$CounterStyle(_p24._0),
				_1: {ctor: '[]'}
			};
		default:
			return _rtfeldman$elm_css$Css_Preprocess_Resolve$resolveFontFeatureValues(_p24._0);
	}
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$toStructure = function (_p25) {
	var _p26 = _p25;
	var declarations = _rtfeldman$elm_css$Css_Preprocess_Resolve$extract(
		A2(_elm_lang$core$List$concatMap, _rtfeldman$elm_css$Css_Preprocess$unwrapSnippet, _p26.snippets));
	return {charset: _p26.charset, imports: _p26.imports, namespaces: _p26.namespaces, declarations: declarations};
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$compileHelp = function (sheet) {
	return _rtfeldman$elm_css$Css_Structure_Output$prettyPrint(
		_rtfeldman$elm_css$Css_Structure$compactStylesheet(
			_rtfeldman$elm_css$Css_Preprocess_Resolve$toStructure(sheet)));
};
var _rtfeldman$elm_css$Css_Preprocess_Resolve$compile = function (styles) {
	return A2(
		_elm_lang$core$String$join,
		'\n\n',
		A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Preprocess_Resolve$compileHelp, styles));
};

var _rtfeldman$elm_css$VirtualDom_Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			var _p0 = pairs;
			if (_p0.ctor === '[]') {
				return false;
			} else {
				if (_elm_lang$core$Native_Utils.eq(key, _p0._0._0)) {
					return true;
				} else {
					var _v1 = key,
						_v2 = _p0._1;
					key = _v1;
					pairs = _v2;
					continue containsKey;
				}
			}
		}
	});
var _rtfeldman$elm_css$VirtualDom_Styled$getUnusedKey = F2(
	function ($default, pairs) {
		getUnusedKey:
		while (true) {
			var _p1 = pairs;
			if (_p1.ctor === '[]') {
				return $default;
			} else {
				var _p2 = _p1._1;
				var newKey = A2(_elm_lang$core$Basics_ops['++'], '_', _p1._0._0);
				if (A2(_rtfeldman$elm_css$VirtualDom_Styled$containsKey, newKey, _p2)) {
					var _v4 = newKey,
						_v5 = _p2;
					$default = _v4;
					pairs = _v5;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var _rtfeldman$elm_css$VirtualDom_Styled$extractUnstyledProperty = function (_p3) {
	var _p4 = _p3;
	return _p4._0;
};
var _rtfeldman$elm_css$VirtualDom_Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			var _p5 = properties;
			if (_p5.ctor === '[]') {
				return candidate;
			} else {
				var _p7 = _p5._1;
				var _p6 = _p5._0._2;
				if (_elm_lang$core$String$isEmpty(_p6)) {
					var _v8 = candidate,
						_v9 = _p7;
					candidate = _v8;
					properties = _v9;
					continue stylesFromPropertiesHelp;
				} else {
					var _v10 = _elm_lang$core$Maybe$Just(
						{ctor: '_Tuple2', _0: _p6, _1: _p5._0._1}),
						_v11 = _p7;
					candidate = _v10;
					properties = _v11;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var _rtfeldman$elm_css$VirtualDom_Styled$stylesFromProperties = function (properties) {
	var _p8 = A2(_rtfeldman$elm_css$VirtualDom_Styled$stylesFromPropertiesHelp, _elm_lang$core$Maybe$Nothing, properties);
	if (_p8.ctor === 'Nothing') {
		return _elm_lang$core$Dict$empty;
	} else {
		return A2(_elm_lang$core$Dict$singleton, _p8._0._0, _p8._0._1);
	}
};
var _rtfeldman$elm_css$VirtualDom_Styled$accumulateStyles = F2(
	function (_p9, styles) {
		var _p10 = _p9;
		var _p11 = _p10._1;
		return _elm_lang$core$List$isEmpty(_p11) ? styles : A3(_elm_lang$core$Dict$insert, _p10._2, _p11, styles);
	});
var _rtfeldman$elm_css$VirtualDom_Styled$accumulateKeyedStyledHtml = F2(
	function (_p13, _p12) {
		var _p14 = _p13;
		var _p23 = _p14._0;
		var _p15 = _p12;
		var _p22 = _p15._1;
		var _p21 = _p15._0;
		var _p16 = _p14._1;
		switch (_p16.ctor) {
			case 'Unstyled':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _p23, _1: _p16._0},
						_1: _p21
					},
					_1: _p22
				};
			case 'Element':
				var _p18 = _p16._1;
				var combinedStyles = A3(_elm_lang$core$List$foldl, _rtfeldman$elm_css$VirtualDom_Styled$accumulateStyles, _p22, _p18);
				var _p17 = A3(
					_elm_lang$core$List$foldl,
					_rtfeldman$elm_css$VirtualDom_Styled$accumulateStyledHtml,
					{
						ctor: '_Tuple2',
						_0: {ctor: '[]'},
						_1: combinedStyles
					},
					_p16._2);
				var childNodes = _p17._0;
				var finalStyles = _p17._1;
				var vdom = A3(
					_elm_lang$virtual_dom$VirtualDom$node,
					_p16._0,
					A2(_elm_lang$core$List$map, _rtfeldman$elm_css$VirtualDom_Styled$extractUnstyledProperty, _p18),
					_elm_lang$core$List$reverse(childNodes));
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _p23, _1: vdom},
						_1: _p21
					},
					_1: finalStyles
				};
			default:
				var _p20 = _p16._1;
				var combinedStyles = A3(_elm_lang$core$List$foldl, _rtfeldman$elm_css$VirtualDom_Styled$accumulateStyles, _p22, _p20);
				var _p19 = A3(
					_elm_lang$core$List$foldl,
					_rtfeldman$elm_css$VirtualDom_Styled$accumulateKeyedStyledHtml,
					{
						ctor: '_Tuple2',
						_0: {ctor: '[]'},
						_1: combinedStyles
					},
					_p16._2);
				var childNodes = _p19._0;
				var finalStyles = _p19._1;
				var vdom = A3(
					_elm_lang$virtual_dom$VirtualDom$keyedNode,
					_p16._0,
					A2(_elm_lang$core$List$map, _rtfeldman$elm_css$VirtualDom_Styled$extractUnstyledProperty, _p20),
					_elm_lang$core$List$reverse(childNodes));
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _p23, _1: vdom},
						_1: _p21
					},
					_1: finalStyles
				};
		}
	});
var _rtfeldman$elm_css$VirtualDom_Styled$accumulateStyledHtml = F2(
	function (html, _p24) {
		var _p25 = _p24;
		var _p32 = _p25._1;
		var _p31 = _p25._0;
		var _p26 = html;
		switch (_p26.ctor) {
			case 'Unstyled':
				return {
					ctor: '_Tuple2',
					_0: {ctor: '::', _0: _p26._0, _1: _p31},
					_1: _p32
				};
			case 'Element':
				var _p28 = _p26._1;
				var combinedStyles = A3(_elm_lang$core$List$foldl, _rtfeldman$elm_css$VirtualDom_Styled$accumulateStyles, _p32, _p28);
				var _p27 = A3(
					_elm_lang$core$List$foldl,
					_rtfeldman$elm_css$VirtualDom_Styled$accumulateStyledHtml,
					{
						ctor: '_Tuple2',
						_0: {ctor: '[]'},
						_1: combinedStyles
					},
					_p26._2);
				var childNodes = _p27._0;
				var finalStyles = _p27._1;
				var node = A3(
					_elm_lang$virtual_dom$VirtualDom$node,
					_p26._0,
					A2(_elm_lang$core$List$map, _rtfeldman$elm_css$VirtualDom_Styled$extractUnstyledProperty, _p28),
					_elm_lang$core$List$reverse(childNodes));
				return {
					ctor: '_Tuple2',
					_0: {ctor: '::', _0: node, _1: _p31},
					_1: finalStyles
				};
			default:
				var _p30 = _p26._1;
				var combinedStyles = A3(_elm_lang$core$List$foldl, _rtfeldman$elm_css$VirtualDom_Styled$accumulateStyles, _p32, _p30);
				var _p29 = A3(
					_elm_lang$core$List$foldl,
					_rtfeldman$elm_css$VirtualDom_Styled$accumulateKeyedStyledHtml,
					{
						ctor: '_Tuple2',
						_0: {ctor: '[]'},
						_1: combinedStyles
					},
					_p26._2);
				var childNodes = _p29._0;
				var finalStyles = _p29._1;
				var node = A3(
					_elm_lang$virtual_dom$VirtualDom$keyedNode,
					_p26._0,
					A2(_elm_lang$core$List$map, _rtfeldman$elm_css$VirtualDom_Styled$extractUnstyledProperty, _p30),
					_elm_lang$core$List$reverse(childNodes));
				return {
					ctor: '_Tuple2',
					_0: {ctor: '::', _0: node, _1: _p31},
					_1: finalStyles
				};
		}
	});
var _rtfeldman$elm_css$VirtualDom_Styled$murmurSeed = 15739;
var _rtfeldman$elm_css$VirtualDom_Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3(
			_rtfeldman$elm_css$Css_Structure$Selector,
			sequence,
			{ctor: '[]'},
			_elm_lang$core$Maybe$Nothing);
		return _rtfeldman$elm_css$Css_Preprocess$Snippet(
			{
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Preprocess$StyleBlockDeclaration(
					A3(
						_rtfeldman$elm_css$Css_Preprocess$StyleBlock,
						selector,
						{ctor: '[]'},
						styles)),
				_1: {ctor: '[]'}
			});
	});
var _rtfeldman$elm_css$VirtualDom_Styled$snippetFromPair = function (_p33) {
	var _p34 = _p33;
	return A2(
		_rtfeldman$elm_css$VirtualDom_Styled$makeSnippet,
		_p34._1,
		_rtfeldman$elm_css$Css_Structure$UniversalSelectorSequence(
			{
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Structure$ClassSelector(_p34._0),
				_1: {ctor: '[]'}
			}));
};
var _rtfeldman$elm_css$VirtualDom_Styled$toDeclaration = function (dict) {
	return _rtfeldman$elm_css$Css_Preprocess_Resolve$compile(
		_elm_lang$core$List$singleton(
			_rtfeldman$elm_css$Css_Preprocess$stylesheet(
				A2(
					_elm_lang$core$List$map,
					_rtfeldman$elm_css$VirtualDom_Styled$snippetFromPair,
					_elm_lang$core$Dict$toList(dict)))));
};
var _rtfeldman$elm_css$VirtualDom_Styled$toStyleNode = function (styles) {
	return A3(
		_elm_lang$virtual_dom$VirtualDom$node,
		'style',
		{ctor: '[]'},
		_elm_lang$core$List$singleton(
			_elm_lang$virtual_dom$VirtualDom$text(
				_rtfeldman$elm_css$VirtualDom_Styled$toDeclaration(styles))));
};
var _rtfeldman$elm_css$VirtualDom_Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2(_elm_lang$core$List$map, _rtfeldman$elm_css$VirtualDom_Styled$extractUnstyledProperty, properties);
		var initialStyles = _rtfeldman$elm_css$VirtualDom_Styled$stylesFromProperties(properties);
		var _p35 = A3(
			_elm_lang$core$List$foldl,
			_rtfeldman$elm_css$VirtualDom_Styled$accumulateStyledHtml,
			{
				ctor: '_Tuple2',
				_0: {ctor: '[]'},
				_1: initialStyles
			},
			children);
		var childNodes = _p35._0;
		var styles = _p35._1;
		var styleNode = _rtfeldman$elm_css$VirtualDom_Styled$toStyleNode(styles);
		return A3(
			_elm_lang$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			{
				ctor: '::',
				_0: styleNode,
				_1: _elm_lang$core$List$reverse(childNodes)
			});
	});
var _rtfeldman$elm_css$VirtualDom_Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var finalNode = _rtfeldman$elm_css$VirtualDom_Styled$toStyleNode(allStyles);
		var styleNodeKey = A2(_rtfeldman$elm_css$VirtualDom_Styled$getUnusedKey, '_', keyedChildNodes);
		return {ctor: '_Tuple2', _0: styleNodeKey, _1: finalNode};
	});
var _rtfeldman$elm_css$VirtualDom_Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2(_elm_lang$core$List$map, _rtfeldman$elm_css$VirtualDom_Styled$extractUnstyledProperty, properties);
		var initialStyles = _rtfeldman$elm_css$VirtualDom_Styled$stylesFromProperties(properties);
		var _p36 = A3(
			_elm_lang$core$List$foldl,
			_rtfeldman$elm_css$VirtualDom_Styled$accumulateKeyedStyledHtml,
			{
				ctor: '_Tuple2',
				_0: {ctor: '[]'},
				_1: initialStyles
			},
			keyedChildren);
		var keyedChildNodes = _p36._0;
		var styles = _p36._1;
		var keyedStyleNode = A2(_rtfeldman$elm_css$VirtualDom_Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			_elm_lang$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			{
				ctor: '::',
				_0: keyedStyleNode,
				_1: _elm_lang$core$List$reverse(keyedChildNodes)
			});
	});
var _rtfeldman$elm_css$VirtualDom_Styled$getClassname = function (styles) {
	return _elm_lang$core$List$isEmpty(styles) ? 'unstyled' : A2(
		_elm_lang$core$String$cons,
		_elm_lang$core$Native_Utils.chr('_'),
		_rtfeldman$hex$Hex$toString(
			A2(
				_Skinney$murmur3$Murmur3$hashString,
				_rtfeldman$elm_css$VirtualDom_Styled$murmurSeed,
				_rtfeldman$elm_css$Css_Preprocess_Resolve$compile(
					_elm_lang$core$List$singleton(
						_rtfeldman$elm_css$Css_Preprocess$stylesheet(
							_elm_lang$core$List$singleton(
								A2(
									_rtfeldman$elm_css$VirtualDom_Styled$makeSnippet,
									styles,
									_rtfeldman$elm_css$Css_Structure$UniversalSelectorSequence(
										{ctor: '[]'})))))))));
};
var _rtfeldman$elm_css$VirtualDom_Styled$toUnstyled = function (node) {
	var _p37 = node;
	switch (_p37.ctor) {
		case 'Unstyled':
			return _p37._0;
		case 'Element':
			return A3(_rtfeldman$elm_css$VirtualDom_Styled$unstyle, _p37._0, _p37._1, _p37._2);
		default:
			return A3(_rtfeldman$elm_css$VirtualDom_Styled$unstyleKeyed, _p37._0, _p37._1, _p37._2);
	}
};
var _rtfeldman$elm_css$VirtualDom_Styled$Unstyled = function (a) {
	return {ctor: 'Unstyled', _0: a};
};
var _rtfeldman$elm_css$VirtualDom_Styled$unstyledNode = _rtfeldman$elm_css$VirtualDom_Styled$Unstyled;
var _rtfeldman$elm_css$VirtualDom_Styled$text = function (_p38) {
	return _rtfeldman$elm_css$VirtualDom_Styled$Unstyled(
		_elm_lang$virtual_dom$VirtualDom$text(_p38));
};
var _rtfeldman$elm_css$VirtualDom_Styled$lazy = F2(
	function (fn, arg) {
		return _rtfeldman$elm_css$VirtualDom_Styled$Unstyled(
			A2(_elm_lang$virtual_dom$VirtualDom$lazy, fn, arg));
	});
var _rtfeldman$elm_css$VirtualDom_Styled$lazy2 = F3(
	function (fn, arg1, arg2) {
		return _rtfeldman$elm_css$VirtualDom_Styled$Unstyled(
			A3(_elm_lang$virtual_dom$VirtualDom$lazy2, fn, arg1, arg2));
	});
var _rtfeldman$elm_css$VirtualDom_Styled$lazy3 = F4(
	function (fn, arg1, arg2, arg3) {
		return _rtfeldman$elm_css$VirtualDom_Styled$Unstyled(
			A4(_elm_lang$virtual_dom$VirtualDom$lazy3, fn, arg1, arg2, arg3));
	});
var _rtfeldman$elm_css$VirtualDom_Styled$KeyedElement = F3(
	function (a, b, c) {
		return {ctor: 'KeyedElement', _0: a, _1: b, _2: c};
	});
var _rtfeldman$elm_css$VirtualDom_Styled$keyedNode = _rtfeldman$elm_css$VirtualDom_Styled$KeyedElement;
var _rtfeldman$elm_css$VirtualDom_Styled$Element = F3(
	function (a, b, c) {
		return {ctor: 'Element', _0: a, _1: b, _2: c};
	});
var _rtfeldman$elm_css$VirtualDom_Styled$node = _rtfeldman$elm_css$VirtualDom_Styled$Element;
var _rtfeldman$elm_css$VirtualDom_Styled$Property = F3(
	function (a, b, c) {
		return {ctor: 'Property', _0: a, _1: b, _2: c};
	});
var _rtfeldman$elm_css$VirtualDom_Styled$property = F2(
	function (key, value) {
		return A3(
			_rtfeldman$elm_css$VirtualDom_Styled$Property,
			A2(_elm_lang$virtual_dom$VirtualDom$property, key, value),
			{ctor: '[]'},
			'');
	});
var _rtfeldman$elm_css$VirtualDom_Styled$attribute = F2(
	function (key, value) {
		return A3(
			_rtfeldman$elm_css$VirtualDom_Styled$Property,
			A2(_elm_lang$virtual_dom$VirtualDom$attribute, key, value),
			{ctor: '[]'},
			'');
	});
var _rtfeldman$elm_css$VirtualDom_Styled$attributeNS = F3(
	function (namespace, key, value) {
		return A3(
			_rtfeldman$elm_css$VirtualDom_Styled$Property,
			A3(_elm_lang$virtual_dom$VirtualDom$attributeNS, namespace, key, value),
			{ctor: '[]'},
			'');
	});
var _rtfeldman$elm_css$VirtualDom_Styled$unstyledProperty = function (prop) {
	return A3(
		_rtfeldman$elm_css$VirtualDom_Styled$Property,
		prop,
		{ctor: '[]'},
		'');
};
var _rtfeldman$elm_css$VirtualDom_Styled$on = F2(
	function (eventName, decoder) {
		return A3(
			_rtfeldman$elm_css$VirtualDom_Styled$Property,
			A2(_elm_lang$virtual_dom$VirtualDom$on, eventName, decoder),
			{ctor: '[]'},
			'');
	});
var _rtfeldman$elm_css$VirtualDom_Styled$onWithOptions = F3(
	function (eventName, options, decoder) {
		return A3(
			_rtfeldman$elm_css$VirtualDom_Styled$Property,
			A3(_elm_lang$virtual_dom$VirtualDom$onWithOptions, eventName, options, decoder),
			{ctor: '[]'},
			'');
	});
var _rtfeldman$elm_css$VirtualDom_Styled$mapProperty = F2(
	function (transform, _p39) {
		var _p40 = _p39;
		return A3(
			_rtfeldman$elm_css$VirtualDom_Styled$Property,
			A2(_elm_lang$virtual_dom$VirtualDom$mapProperty, transform, _p40._0),
			_p40._1,
			_p40._2);
	});
var _rtfeldman$elm_css$VirtualDom_Styled$map = F2(
	function (transform, node) {
		var _p41 = node;
		switch (_p41.ctor) {
			case 'Element':
				return A3(
					_rtfeldman$elm_css$VirtualDom_Styled$Element,
					_p41._0,
					A2(
						_elm_lang$core$List$map,
						_rtfeldman$elm_css$VirtualDom_Styled$mapProperty(transform),
						_p41._1),
					A2(
						_elm_lang$core$List$map,
						_rtfeldman$elm_css$VirtualDom_Styled$map(transform),
						_p41._2));
			case 'KeyedElement':
				return A3(
					_rtfeldman$elm_css$VirtualDom_Styled$KeyedElement,
					_p41._0,
					A2(
						_elm_lang$core$List$map,
						_rtfeldman$elm_css$VirtualDom_Styled$mapProperty(transform),
						_p41._1),
					A2(
						_elm_lang$core$List$map,
						function (_p42) {
							var _p43 = _p42;
							return {
								ctor: '_Tuple2',
								_0: _p43._0,
								_1: A2(_rtfeldman$elm_css$VirtualDom_Styled$map, transform, _p43._1)
							};
						},
						_p41._2));
			default:
				return _rtfeldman$elm_css$VirtualDom_Styled$Unstyled(
					A2(_elm_lang$virtual_dom$VirtualDom$map, transform, _p41._0));
		}
	});

var _rtfeldman$elm_css$Html_Styled_Internal$css = function (styles) {
	var classname = _rtfeldman$elm_css$VirtualDom_Styled$getClassname(styles);
	var classProperty = A2(
		_elm_lang$virtual_dom$VirtualDom$property,
		'className',
		_elm_lang$core$Json_Encode$string(classname));
	return A3(_rtfeldman$elm_css$VirtualDom_Styled$Property, classProperty, styles, classname);
};

var _rtfeldman$elm_css$Html_Styled$fromUnstyled = _rtfeldman$elm_css$VirtualDom_Styled$unstyledNode;
var _rtfeldman$elm_css$Html_Styled$toUnstyled = _rtfeldman$elm_css$VirtualDom_Styled$toUnstyled;
var _rtfeldman$elm_css$Html_Styled$program = function (config) {
	return _elm_lang$virtual_dom$VirtualDom$program(
		_elm_lang$core$Native_Utils.update(
			config,
			{
				view: function (_p0) {
					return _rtfeldman$elm_css$Html_Styled$toUnstyled(
						config.view(_p0));
				}
			}));
};
var _rtfeldman$elm_css$Html_Styled$beginnerProgram = function (_p1) {
	var _p2 = _p1;
	return _rtfeldman$elm_css$Html_Styled$program(
		{
			init: A2(
				_elm_lang$core$Platform_Cmd_ops['!'],
				_p2.model,
				{ctor: '[]'}),
			update: F2(
				function (msg, model) {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						A2(_p2.update, msg, model),
						{ctor: '[]'});
				}),
			view: _p2.view,
			subscriptions: function (_p3) {
				return _elm_lang$core$Platform_Sub$none;
			}
		});
};
var _rtfeldman$elm_css$Html_Styled$programWithFlags = function (config) {
	return _elm_lang$virtual_dom$VirtualDom$programWithFlags(
		_elm_lang$core$Native_Utils.update(
			config,
			{
				view: function (_p4) {
					return _rtfeldman$elm_css$Html_Styled$toUnstyled(
						config.view(_p4));
				}
			}));
};
var _rtfeldman$elm_css$Html_Styled$styled = F4(
	function (fn, styles, attrs, children) {
		return A2(
			fn,
			{
				ctor: '::',
				_0: _rtfeldman$elm_css$Html_Styled_Internal$css(styles),
				_1: attrs
			},
			children);
	});
var _rtfeldman$elm_css$Html_Styled$map = _rtfeldman$elm_css$VirtualDom_Styled$map;
var _rtfeldman$elm_css$Html_Styled$text = _rtfeldman$elm_css$VirtualDom_Styled$text;
var _rtfeldman$elm_css$Html_Styled$node = _rtfeldman$elm_css$VirtualDom_Styled$node;
var _rtfeldman$elm_css$Html_Styled$body = _rtfeldman$elm_css$Html_Styled$node('body');
var _rtfeldman$elm_css$Html_Styled$section = _rtfeldman$elm_css$Html_Styled$node('section');
var _rtfeldman$elm_css$Html_Styled$nav = _rtfeldman$elm_css$Html_Styled$node('nav');
var _rtfeldman$elm_css$Html_Styled$article = _rtfeldman$elm_css$Html_Styled$node('article');
var _rtfeldman$elm_css$Html_Styled$aside = _rtfeldman$elm_css$Html_Styled$node('aside');
var _rtfeldman$elm_css$Html_Styled$h1 = _rtfeldman$elm_css$Html_Styled$node('h1');
var _rtfeldman$elm_css$Html_Styled$h2 = _rtfeldman$elm_css$Html_Styled$node('h2');
var _rtfeldman$elm_css$Html_Styled$h3 = _rtfeldman$elm_css$Html_Styled$node('h3');
var _rtfeldman$elm_css$Html_Styled$h4 = _rtfeldman$elm_css$Html_Styled$node('h4');
var _rtfeldman$elm_css$Html_Styled$h5 = _rtfeldman$elm_css$Html_Styled$node('h5');
var _rtfeldman$elm_css$Html_Styled$h6 = _rtfeldman$elm_css$Html_Styled$node('h6');
var _rtfeldman$elm_css$Html_Styled$header = _rtfeldman$elm_css$Html_Styled$node('header');
var _rtfeldman$elm_css$Html_Styled$footer = _rtfeldman$elm_css$Html_Styled$node('footer');
var _rtfeldman$elm_css$Html_Styled$address = _rtfeldman$elm_css$Html_Styled$node('address');
var _rtfeldman$elm_css$Html_Styled$main_ = _rtfeldman$elm_css$Html_Styled$node('main');
var _rtfeldman$elm_css$Html_Styled$p = _rtfeldman$elm_css$Html_Styled$node('p');
var _rtfeldman$elm_css$Html_Styled$hr = _rtfeldman$elm_css$Html_Styled$node('hr');
var _rtfeldman$elm_css$Html_Styled$pre = _rtfeldman$elm_css$Html_Styled$node('pre');
var _rtfeldman$elm_css$Html_Styled$blockquote = _rtfeldman$elm_css$Html_Styled$node('blockquote');
var _rtfeldman$elm_css$Html_Styled$ol = _rtfeldman$elm_css$Html_Styled$node('ol');
var _rtfeldman$elm_css$Html_Styled$ul = _rtfeldman$elm_css$Html_Styled$node('ul');
var _rtfeldman$elm_css$Html_Styled$li = _rtfeldman$elm_css$Html_Styled$node('li');
var _rtfeldman$elm_css$Html_Styled$dl = _rtfeldman$elm_css$Html_Styled$node('dl');
var _rtfeldman$elm_css$Html_Styled$dt = _rtfeldman$elm_css$Html_Styled$node('dt');
var _rtfeldman$elm_css$Html_Styled$dd = _rtfeldman$elm_css$Html_Styled$node('dd');
var _rtfeldman$elm_css$Html_Styled$figure = _rtfeldman$elm_css$Html_Styled$node('figure');
var _rtfeldman$elm_css$Html_Styled$figcaption = _rtfeldman$elm_css$Html_Styled$node('figcaption');
var _rtfeldman$elm_css$Html_Styled$div = _rtfeldman$elm_css$Html_Styled$node('div');
var _rtfeldman$elm_css$Html_Styled$a = _rtfeldman$elm_css$Html_Styled$node('a');
var _rtfeldman$elm_css$Html_Styled$em = _rtfeldman$elm_css$Html_Styled$node('em');
var _rtfeldman$elm_css$Html_Styled$strong = _rtfeldman$elm_css$Html_Styled$node('strong');
var _rtfeldman$elm_css$Html_Styled$small = _rtfeldman$elm_css$Html_Styled$node('small');
var _rtfeldman$elm_css$Html_Styled$s = _rtfeldman$elm_css$Html_Styled$node('s');
var _rtfeldman$elm_css$Html_Styled$cite = _rtfeldman$elm_css$Html_Styled$node('cite');
var _rtfeldman$elm_css$Html_Styled$q = _rtfeldman$elm_css$Html_Styled$node('q');
var _rtfeldman$elm_css$Html_Styled$dfn = _rtfeldman$elm_css$Html_Styled$node('dfn');
var _rtfeldman$elm_css$Html_Styled$abbr = _rtfeldman$elm_css$Html_Styled$node('abbr');
var _rtfeldman$elm_css$Html_Styled$time = _rtfeldman$elm_css$Html_Styled$node('time');
var _rtfeldman$elm_css$Html_Styled$code = _rtfeldman$elm_css$Html_Styled$node('code');
var _rtfeldman$elm_css$Html_Styled$var = _rtfeldman$elm_css$Html_Styled$node('var');
var _rtfeldman$elm_css$Html_Styled$samp = _rtfeldman$elm_css$Html_Styled$node('samp');
var _rtfeldman$elm_css$Html_Styled$kbd = _rtfeldman$elm_css$Html_Styled$node('kbd');
var _rtfeldman$elm_css$Html_Styled$sub = _rtfeldman$elm_css$Html_Styled$node('sub');
var _rtfeldman$elm_css$Html_Styled$sup = _rtfeldman$elm_css$Html_Styled$node('sup');
var _rtfeldman$elm_css$Html_Styled$i = _rtfeldman$elm_css$Html_Styled$node('i');
var _rtfeldman$elm_css$Html_Styled$b = _rtfeldman$elm_css$Html_Styled$node('b');
var _rtfeldman$elm_css$Html_Styled$u = _rtfeldman$elm_css$Html_Styled$node('u');
var _rtfeldman$elm_css$Html_Styled$mark = _rtfeldman$elm_css$Html_Styled$node('mark');
var _rtfeldman$elm_css$Html_Styled$ruby = _rtfeldman$elm_css$Html_Styled$node('ruby');
var _rtfeldman$elm_css$Html_Styled$rt = _rtfeldman$elm_css$Html_Styled$node('rt');
var _rtfeldman$elm_css$Html_Styled$rp = _rtfeldman$elm_css$Html_Styled$node('rp');
var _rtfeldman$elm_css$Html_Styled$bdi = _rtfeldman$elm_css$Html_Styled$node('bdi');
var _rtfeldman$elm_css$Html_Styled$bdo = _rtfeldman$elm_css$Html_Styled$node('bdo');
var _rtfeldman$elm_css$Html_Styled$span = _rtfeldman$elm_css$Html_Styled$node('span');
var _rtfeldman$elm_css$Html_Styled$br = _rtfeldman$elm_css$Html_Styled$node('br');
var _rtfeldman$elm_css$Html_Styled$wbr = _rtfeldman$elm_css$Html_Styled$node('wbr');
var _rtfeldman$elm_css$Html_Styled$ins = _rtfeldman$elm_css$Html_Styled$node('ins');
var _rtfeldman$elm_css$Html_Styled$del = _rtfeldman$elm_css$Html_Styled$node('del');
var _rtfeldman$elm_css$Html_Styled$img = _rtfeldman$elm_css$Html_Styled$node('img');
var _rtfeldman$elm_css$Html_Styled$iframe = _rtfeldman$elm_css$Html_Styled$node('iframe');
var _rtfeldman$elm_css$Html_Styled$embed = _rtfeldman$elm_css$Html_Styled$node('embed');
var _rtfeldman$elm_css$Html_Styled$object = _rtfeldman$elm_css$Html_Styled$node('object');
var _rtfeldman$elm_css$Html_Styled$param = _rtfeldman$elm_css$Html_Styled$node('param');
var _rtfeldman$elm_css$Html_Styled$video = _rtfeldman$elm_css$Html_Styled$node('video');
var _rtfeldman$elm_css$Html_Styled$audio = _rtfeldman$elm_css$Html_Styled$node('audio');
var _rtfeldman$elm_css$Html_Styled$source = _rtfeldman$elm_css$Html_Styled$node('source');
var _rtfeldman$elm_css$Html_Styled$track = _rtfeldman$elm_css$Html_Styled$node('track');
var _rtfeldman$elm_css$Html_Styled$canvas = _rtfeldman$elm_css$Html_Styled$node('canvas');
var _rtfeldman$elm_css$Html_Styled$math = _rtfeldman$elm_css$Html_Styled$node('math');
var _rtfeldman$elm_css$Html_Styled$table = _rtfeldman$elm_css$Html_Styled$node('table');
var _rtfeldman$elm_css$Html_Styled$caption = _rtfeldman$elm_css$Html_Styled$node('caption');
var _rtfeldman$elm_css$Html_Styled$colgroup = _rtfeldman$elm_css$Html_Styled$node('colgroup');
var _rtfeldman$elm_css$Html_Styled$col = _rtfeldman$elm_css$Html_Styled$node('col');
var _rtfeldman$elm_css$Html_Styled$tbody = _rtfeldman$elm_css$Html_Styled$node('tbody');
var _rtfeldman$elm_css$Html_Styled$thead = _rtfeldman$elm_css$Html_Styled$node('thead');
var _rtfeldman$elm_css$Html_Styled$tfoot = _rtfeldman$elm_css$Html_Styled$node('tfoot');
var _rtfeldman$elm_css$Html_Styled$tr = _rtfeldman$elm_css$Html_Styled$node('tr');
var _rtfeldman$elm_css$Html_Styled$td = _rtfeldman$elm_css$Html_Styled$node('td');
var _rtfeldman$elm_css$Html_Styled$th = _rtfeldman$elm_css$Html_Styled$node('th');
var _rtfeldman$elm_css$Html_Styled$form = _rtfeldman$elm_css$Html_Styled$node('form');
var _rtfeldman$elm_css$Html_Styled$fieldset = _rtfeldman$elm_css$Html_Styled$node('fieldset');
var _rtfeldman$elm_css$Html_Styled$legend = _rtfeldman$elm_css$Html_Styled$node('legend');
var _rtfeldman$elm_css$Html_Styled$label = _rtfeldman$elm_css$Html_Styled$node('label');
var _rtfeldman$elm_css$Html_Styled$input = _rtfeldman$elm_css$Html_Styled$node('input');
var _rtfeldman$elm_css$Html_Styled$button = _rtfeldman$elm_css$Html_Styled$node('button');
var _rtfeldman$elm_css$Html_Styled$select = _rtfeldman$elm_css$Html_Styled$node('select');
var _rtfeldman$elm_css$Html_Styled$datalist = _rtfeldman$elm_css$Html_Styled$node('datalist');
var _rtfeldman$elm_css$Html_Styled$optgroup = _rtfeldman$elm_css$Html_Styled$node('optgroup');
var _rtfeldman$elm_css$Html_Styled$option = _rtfeldman$elm_css$Html_Styled$node('option');
var _rtfeldman$elm_css$Html_Styled$textarea = _rtfeldman$elm_css$Html_Styled$node('textarea');
var _rtfeldman$elm_css$Html_Styled$keygen = _rtfeldman$elm_css$Html_Styled$node('keygen');
var _rtfeldman$elm_css$Html_Styled$output = _rtfeldman$elm_css$Html_Styled$node('output');
var _rtfeldman$elm_css$Html_Styled$progress = _rtfeldman$elm_css$Html_Styled$node('progress');
var _rtfeldman$elm_css$Html_Styled$meter = _rtfeldman$elm_css$Html_Styled$node('meter');
var _rtfeldman$elm_css$Html_Styled$details = _rtfeldman$elm_css$Html_Styled$node('details');
var _rtfeldman$elm_css$Html_Styled$summary = _rtfeldman$elm_css$Html_Styled$node('summary');
var _rtfeldman$elm_css$Html_Styled$menuitem = _rtfeldman$elm_css$Html_Styled$node('menuitem');
var _rtfeldman$elm_css$Html_Styled$menu = _rtfeldman$elm_css$Html_Styled$node('menu');

var _rtfeldman$elm_css$Css_Global$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		var _p0 = declarations;
		if (_p0.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			if (_p0._0.ctor === 'StyleBlockDeclaration') {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: A2(_rtfeldman$elm_css$Css_Global$unwrapSelector, _p0._0._0._0, _p0._0._0._2),
						_1: _p0._0._0._1
					},
					_rtfeldman$elm_css$Css_Global$collectSelectors(_p0._1));
			} else {
				var _v1 = _p0._1;
				declarations = _v1;
				continue collectSelectors;
			}
		}
	}
};
var _rtfeldman$elm_css$Css_Global$unwrapSelector = F2(
	function (_p1, styles) {
		var _p2 = _p1;
		var unwrapCombinatorSelector = F2(
			function (style, cs) {
				var _p3 = style;
				if (_p3.ctor === 'NestSnippet') {
					return A2(
						_elm_lang$core$List$append,
						cs,
						A2(
							_elm_lang$core$List$map,
							function (_p4) {
								var _p5 = _p4;
								return {ctor: '_Tuple2', _0: _p3._0, _1: _p5._0};
							},
							A2(
								_elm_lang$core$List$concatMap,
								function (_p6) {
									return _rtfeldman$elm_css$Css_Global$collectSelectors(
										_rtfeldman$elm_css$Css_Preprocess$unwrapSnippet(_p6));
								},
								_p3._1)));
				} else {
					return cs;
				}
			});
		var unwrapSequenceSelector = F2(
			function (style, s) {
				var _p7 = style;
				if (_p7.ctor === 'ExtendSelector') {
					return A3(
						_elm_lang$core$List$foldr,
						unwrapSequenceSelector,
						A2(_rtfeldman$elm_css$Css_Structure$appendRepeatable, _p7._0, s),
						_p7._1);
				} else {
					return s;
				}
			});
		return A3(
			_rtfeldman$elm_css$Css_Structure$Selector,
			A3(_elm_lang$core$List$foldr, unwrapSequenceSelector, _p2._0, styles),
			A3(_elm_lang$core$List$foldr, unwrapCombinatorSelector, _p2._1, styles),
			_p2._2);
	});
var _rtfeldman$elm_css$Css_Global$typeSelector = F2(
	function (selectorStr, styles) {
		var sequence = A2(
			_rtfeldman$elm_css$Css_Structure$TypeSelectorSequence,
			_rtfeldman$elm_css$Css_Structure$TypeSelector(selectorStr),
			{ctor: '[]'});
		var sel = A3(
			_rtfeldman$elm_css$Css_Structure$Selector,
			sequence,
			{ctor: '[]'},
			_elm_lang$core$Maybe$Nothing);
		return _rtfeldman$elm_css$Css_Preprocess$Snippet(
			{
				ctor: '::',
				_0: _rtfeldman$elm_css$Css_Preprocess$StyleBlockDeclaration(
					A3(
						_rtfeldman$elm_css$Css_Preprocess$StyleBlock,
						sel,
						{ctor: '[]'},
						styles)),
				_1: {ctor: '[]'}
			});
	});
var _rtfeldman$elm_css$Css_Global$html = _rtfeldman$elm_css$Css_Global$typeSelector('html');
var _rtfeldman$elm_css$Css_Global$body = _rtfeldman$elm_css$Css_Global$typeSelector('body');
var _rtfeldman$elm_css$Css_Global$article = _rtfeldman$elm_css$Css_Global$typeSelector('article');
var _rtfeldman$elm_css$Css_Global$header = _rtfeldman$elm_css$Css_Global$typeSelector('header');
var _rtfeldman$elm_css$Css_Global$footer = _rtfeldman$elm_css$Css_Global$typeSelector('footer');
var _rtfeldman$elm_css$Css_Global$h1 = _rtfeldman$elm_css$Css_Global$typeSelector('h1');
var _rtfeldman$elm_css$Css_Global$h2 = _rtfeldman$elm_css$Css_Global$typeSelector('h2');
var _rtfeldman$elm_css$Css_Global$h3 = _rtfeldman$elm_css$Css_Global$typeSelector('h3');
var _rtfeldman$elm_css$Css_Global$h4 = _rtfeldman$elm_css$Css_Global$typeSelector('h4');
var _rtfeldman$elm_css$Css_Global$h5 = _rtfeldman$elm_css$Css_Global$typeSelector('h5');
var _rtfeldman$elm_css$Css_Global$h6 = _rtfeldman$elm_css$Css_Global$typeSelector('h6');
var _rtfeldman$elm_css$Css_Global$nav = _rtfeldman$elm_css$Css_Global$typeSelector('nav');
var _rtfeldman$elm_css$Css_Global$menu = _rtfeldman$elm_css$Css_Global$typeSelector('menu');
var _rtfeldman$elm_css$Css_Global$section = _rtfeldman$elm_css$Css_Global$typeSelector('section');
var _rtfeldman$elm_css$Css_Global$aside = _rtfeldman$elm_css$Css_Global$typeSelector('aside');
var _rtfeldman$elm_css$Css_Global$time = _rtfeldman$elm_css$Css_Global$typeSelector('time');
var _rtfeldman$elm_css$Css_Global$div = _rtfeldman$elm_css$Css_Global$typeSelector('div');
var _rtfeldman$elm_css$Css_Global$hr = _rtfeldman$elm_css$Css_Global$typeSelector('hr');
var _rtfeldman$elm_css$Css_Global$li = _rtfeldman$elm_css$Css_Global$typeSelector('li');
var _rtfeldman$elm_css$Css_Global$main_ = _rtfeldman$elm_css$Css_Global$typeSelector('main');
var _rtfeldman$elm_css$Css_Global$ol = _rtfeldman$elm_css$Css_Global$typeSelector('ol');
var _rtfeldman$elm_css$Css_Global$p = _rtfeldman$elm_css$Css_Global$typeSelector('p');
var _rtfeldman$elm_css$Css_Global$ul = _rtfeldman$elm_css$Css_Global$typeSelector('ul');
var _rtfeldman$elm_css$Css_Global$pre = _rtfeldman$elm_css$Css_Global$typeSelector('pre');
var _rtfeldman$elm_css$Css_Global$dl = _rtfeldman$elm_css$Css_Global$typeSelector('dl');
var _rtfeldman$elm_css$Css_Global$dt = _rtfeldman$elm_css$Css_Global$typeSelector('dt');
var _rtfeldman$elm_css$Css_Global$dd = _rtfeldman$elm_css$Css_Global$typeSelector('dd');
var _rtfeldman$elm_css$Css_Global$a = _rtfeldman$elm_css$Css_Global$typeSelector('a');
var _rtfeldman$elm_css$Css_Global$code = _rtfeldman$elm_css$Css_Global$typeSelector('code');
var _rtfeldman$elm_css$Css_Global$small = _rtfeldman$elm_css$Css_Global$typeSelector('small');
var _rtfeldman$elm_css$Css_Global$span = _rtfeldman$elm_css$Css_Global$typeSelector('span');
var _rtfeldman$elm_css$Css_Global$strong = _rtfeldman$elm_css$Css_Global$typeSelector('strong');
var _rtfeldman$elm_css$Css_Global$i = _rtfeldman$elm_css$Css_Global$typeSelector('i');
var _rtfeldman$elm_css$Css_Global$em = _rtfeldman$elm_css$Css_Global$typeSelector('em');
var _rtfeldman$elm_css$Css_Global$q = _rtfeldman$elm_css$Css_Global$typeSelector('q');
var _rtfeldman$elm_css$Css_Global$img = _rtfeldman$elm_css$Css_Global$typeSelector('img');
var _rtfeldman$elm_css$Css_Global$audio = _rtfeldman$elm_css$Css_Global$typeSelector('audio');
var _rtfeldman$elm_css$Css_Global$video = _rtfeldman$elm_css$Css_Global$typeSelector('video');
var _rtfeldman$elm_css$Css_Global$canvas = _rtfeldman$elm_css$Css_Global$typeSelector('canvas');
var _rtfeldman$elm_css$Css_Global$caption = _rtfeldman$elm_css$Css_Global$typeSelector('caption');
var _rtfeldman$elm_css$Css_Global$col = _rtfeldman$elm_css$Css_Global$typeSelector('col');
var _rtfeldman$elm_css$Css_Global$colgroup = _rtfeldman$elm_css$Css_Global$typeSelector('colgroup');
var _rtfeldman$elm_css$Css_Global$table = _rtfeldman$elm_css$Css_Global$typeSelector('table');
var _rtfeldman$elm_css$Css_Global$tbody = _rtfeldman$elm_css$Css_Global$typeSelector('tbody');
var _rtfeldman$elm_css$Css_Global$td = _rtfeldman$elm_css$Css_Global$typeSelector('td');
var _rtfeldman$elm_css$Css_Global$tfoot = _rtfeldman$elm_css$Css_Global$typeSelector('tfoot');
var _rtfeldman$elm_css$Css_Global$th = _rtfeldman$elm_css$Css_Global$typeSelector('th');
var _rtfeldman$elm_css$Css_Global$thead = _rtfeldman$elm_css$Css_Global$typeSelector('thead');
var _rtfeldman$elm_css$Css_Global$tr = _rtfeldman$elm_css$Css_Global$typeSelector('tr');
var _rtfeldman$elm_css$Css_Global$button = _rtfeldman$elm_css$Css_Global$typeSelector('button');
var _rtfeldman$elm_css$Css_Global$fieldset = _rtfeldman$elm_css$Css_Global$typeSelector('fieldset');
var _rtfeldman$elm_css$Css_Global$form = _rtfeldman$elm_css$Css_Global$typeSelector('form');
var _rtfeldman$elm_css$Css_Global$input = _rtfeldman$elm_css$Css_Global$typeSelector('input');
var _rtfeldman$elm_css$Css_Global$label = _rtfeldman$elm_css$Css_Global$typeSelector('label');
var _rtfeldman$elm_css$Css_Global$legend = _rtfeldman$elm_css$Css_Global$typeSelector('legend');
var _rtfeldman$elm_css$Css_Global$optgroup = _rtfeldman$elm_css$Css_Global$typeSelector('optgroup');
var _rtfeldman$elm_css$Css_Global$option = _rtfeldman$elm_css$Css_Global$typeSelector('option');
var _rtfeldman$elm_css$Css_Global$progress = _rtfeldman$elm_css$Css_Global$typeSelector('progress');
var _rtfeldman$elm_css$Css_Global$select = _rtfeldman$elm_css$Css_Global$typeSelector('select');
var _rtfeldman$elm_css$Css_Global$textarea = _rtfeldman$elm_css$Css_Global$typeSelector('textarea');
var _rtfeldman$elm_css$Css_Global$blockquote = _rtfeldman$elm_css$Css_Global$typeSelector('blockquote');
var _rtfeldman$elm_css$Css_Global$svg = _rtfeldman$elm_css$Css_Global$typeSelector('svg');
var _rtfeldman$elm_css$Css_Global$path = _rtfeldman$elm_css$Css_Global$typeSelector('path');
var _rtfeldman$elm_css$Css_Global$rect = _rtfeldman$elm_css$Css_Global$typeSelector('rect');
var _rtfeldman$elm_css$Css_Global$circle = _rtfeldman$elm_css$Css_Global$typeSelector('circle');
var _rtfeldman$elm_css$Css_Global$ellipse = _rtfeldman$elm_css$Css_Global$typeSelector('ellipse');
var _rtfeldman$elm_css$Css_Global$line = _rtfeldman$elm_css$Css_Global$typeSelector('line');
var _rtfeldman$elm_css$Css_Global$polyline = _rtfeldman$elm_css$Css_Global$typeSelector('polyline');
var _rtfeldman$elm_css$Css_Global$polygon = _rtfeldman$elm_css$Css_Global$typeSelector('polygon');
var _rtfeldman$elm_css$Css_Global$details = _rtfeldman$elm_css$Css_Global$typeSelector('details');
var _rtfeldman$elm_css$Css_Global$summary = _rtfeldman$elm_css$Css_Global$typeSelector('summary');
var _rtfeldman$elm_css$Css_Global$each = F2(
	function (snippetCreators, styles) {
		var selectorsToSnippet = function (selectors) {
			var _p8 = selectors;
			if (_p8.ctor === '[]') {
				return _rtfeldman$elm_css$Css_Preprocess$Snippet(
					{ctor: '[]'});
			} else {
				return _rtfeldman$elm_css$Css_Preprocess$Snippet(
					{
						ctor: '::',
						_0: _rtfeldman$elm_css$Css_Preprocess$StyleBlockDeclaration(
							A3(_rtfeldman$elm_css$Css_Preprocess$StyleBlock, _p8._0, _p8._1, styles)),
						_1: {ctor: '[]'}
					});
			}
		};
		return selectorsToSnippet(
			_rtfeldman$elm_css$Css_Global$collectSelectors(
				A2(
					_elm_lang$core$List$concatMap,
					_rtfeldman$elm_css$Css_Preprocess$unwrapSnippet,
					A2(
						_elm_lang$core$List$map,
						F2(
							function (x, y) {
								return y(x);
							})(
							{ctor: '[]'}),
						snippetCreators))));
	});
var _rtfeldman$elm_css$Css_Global$generalSiblings = _rtfeldman$elm_css$Css_Preprocess$NestSnippet(_rtfeldman$elm_css$Css_Structure$GeneralSibling);
var _rtfeldman$elm_css$Css_Global$adjacentSiblings = _rtfeldman$elm_css$Css_Preprocess$NestSnippet(_rtfeldman$elm_css$Css_Structure$AdjacentSibling);
var _rtfeldman$elm_css$Css_Global$descendants = _rtfeldman$elm_css$Css_Preprocess$NestSnippet(_rtfeldman$elm_css$Css_Structure$Descendant);
var _rtfeldman$elm_css$Css_Global$withAttribute = function (attribute) {
	return _rtfeldman$elm_css$Css_Preprocess$ExtendSelector(
		_rtfeldman$elm_css$Css_Structure$AttributeSelector(attribute));
};
var _rtfeldman$elm_css$Css_Global$withClass = function (str) {
	return _rtfeldman$elm_css$Css_Preprocess$ExtendSelector(
		_rtfeldman$elm_css$Css_Structure$ClassSelector(str));
};
var _rtfeldman$elm_css$Css_Global$children = _rtfeldman$elm_css$Css_Preprocess$NestSnippet(_rtfeldman$elm_css$Css_Structure$Child);
var _rtfeldman$elm_css$Css_Global$media = F2(
	function (queries, snippets) {
		var nestedMediaRules = function (declarations) {
			nestedMediaRules:
			while (true) {
				var _p9 = declarations;
				if (_p9.ctor === '[]') {
					return {ctor: '[]'};
				} else {
					switch (_p9._0.ctor) {
						case 'StyleBlockDeclaration':
							var _v8 = _p9._1;
							declarations = _v8;
							continue nestedMediaRules;
						case 'MediaRule':
							return {
								ctor: '::',
								_0: A2(
									_rtfeldman$elm_css$Css_Preprocess$MediaRule,
									A2(_elm_lang$core$List$append, queries, _p9._0._0),
									_p9._0._1),
								_1: nestedMediaRules(_p9._1)
							};
						default:
							return {
								ctor: '::',
								_0: _p9._0,
								_1: nestedMediaRules(_p9._1)
							};
					}
				}
			}
		};
		var extractStyleBlocks = function (declarations) {
			extractStyleBlocks:
			while (true) {
				var _p10 = declarations;
				if (_p10.ctor === '[]') {
					return {ctor: '[]'};
				} else {
					if (_p10._0.ctor === 'StyleBlockDeclaration') {
						return {
							ctor: '::',
							_0: _p10._0._0,
							_1: extractStyleBlocks(_p10._1)
						};
					} else {
						var _v10 = _p10._1;
						declarations = _v10;
						continue extractStyleBlocks;
					}
				}
			}
		};
		var snippetDeclarations = A2(_elm_lang$core$List$concatMap, _rtfeldman$elm_css$Css_Preprocess$unwrapSnippet, snippets);
		var mediaRuleFromStyleBlocks = A2(
			_rtfeldman$elm_css$Css_Preprocess$MediaRule,
			queries,
			extractStyleBlocks(snippetDeclarations));
		return _rtfeldman$elm_css$Css_Preprocess$Snippet(
			{
				ctor: '::',
				_0: mediaRuleFromStyleBlocks,
				_1: nestedMediaRules(snippetDeclarations)
			});
	});
var _rtfeldman$elm_css$Css_Global$mediaQuery = F2(
	function (stringQueries, snippets) {
		return A2(
			_rtfeldman$elm_css$Css_Global$media,
			A2(_elm_lang$core$List$map, _rtfeldman$elm_css$Css_Structure$CustomQuery, stringQueries),
			snippets);
	});
var _rtfeldman$elm_css$Css_Global$everything = function (styles) {
	return A2(
		_rtfeldman$elm_css$VirtualDom_Styled$makeSnippet,
		styles,
		_rtfeldman$elm_css$Css_Structure$UniversalSelectorSequence(
			{ctor: '[]'}));
};
var _rtfeldman$elm_css$Css_Global$selector = F2(
	function (selectorStr, styles) {
		return A2(
			_rtfeldman$elm_css$VirtualDom_Styled$makeSnippet,
			styles,
			A2(
				_rtfeldman$elm_css$Css_Structure$CustomSelector,
				selectorStr,
				{ctor: '[]'}));
	});
var _rtfeldman$elm_css$Css_Global$class = F2(
	function (str, styles) {
		return A2(
			_rtfeldman$elm_css$VirtualDom_Styled$makeSnippet,
			styles,
			_rtfeldman$elm_css$Css_Structure$UniversalSelectorSequence(
				{
					ctor: '::',
					_0: _rtfeldman$elm_css$Css_Structure$ClassSelector(str),
					_1: {ctor: '[]'}
				}));
	});
var _rtfeldman$elm_css$Css_Global$id = F2(
	function (str, styles) {
		return A2(
			_rtfeldman$elm_css$VirtualDom_Styled$makeSnippet,
			styles,
			_rtfeldman$elm_css$Css_Structure$UniversalSelectorSequence(
				{
					ctor: '::',
					_0: _rtfeldman$elm_css$Css_Structure$IdSelector(str),
					_1: {ctor: '[]'}
				}));
	});
var _rtfeldman$elm_css$Css_Global$global = function (snippets) {
	return _rtfeldman$elm_css$VirtualDom_Styled$unstyledNode(
		A3(
			_elm_lang$virtual_dom$VirtualDom$node,
			'style',
			{ctor: '[]'},
			_elm_lang$core$List$singleton(
				_elm_lang$virtual_dom$VirtualDom$text(
					_rtfeldman$elm_css$Css_Preprocess_Resolve$compile(
						_elm_lang$core$List$singleton(
							_rtfeldman$elm_css$Css_Preprocess$stylesheet(snippets)))))));
};

var _rtfeldman$elm_css$Html_Styled_Attributes$css = _rtfeldman$elm_css$Html_Styled_Internal$css;
var _rtfeldman$elm_css$Html_Styled_Attributes$map = _rtfeldman$elm_css$VirtualDom_Styled$mapProperty;
var _rtfeldman$elm_css$Html_Styled_Attributes$attribute = _rtfeldman$elm_css$VirtualDom_Styled$attribute;
var _rtfeldman$elm_css$Html_Styled_Attributes$contextmenu = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'contextmenu', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$draggable = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'draggable', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$itemprop = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'itemprop', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$tabindex = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'tabIndex',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$charset = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'charset', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$height = function (value) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'height',
		_elm_lang$core$Basics$toString(value));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$width = function (value) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'width',
		_elm_lang$core$Basics$toString(value));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$formaction = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'formAction', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$list = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'list', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$minlength = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'minLength',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$maxlength = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'maxlength',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$size = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'size',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$form = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'form', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$cols = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'cols',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$rows = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'rows',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$challenge = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'challenge', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$media = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'media', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$rel = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'rel', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$datetime = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'datetime', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$pubdate = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'pubdate', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$colspan = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'colspan',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$rowspan = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$attribute,
		'rowspan',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$manifest = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$attribute, 'manifest', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$property = _rtfeldman$elm_css$VirtualDom_Styled$property;
var _rtfeldman$elm_css$Html_Styled_Attributes$stringProperty = F2(
	function (name, string) {
		return A2(
			_rtfeldman$elm_css$Html_Styled_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$string(string));
	});
var _rtfeldman$elm_css$Html_Styled_Attributes$class = function (name) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'className', name);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$id = function (name) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'id', name);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$title = function (name) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'title', name);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$accesskey = function ($char) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty,
		'accessKey',
		_elm_lang$core$String$fromChar($char));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$dir = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'dir', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$dropzone = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'dropzone', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$lang = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'lang', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$content = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'content', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$httpEquiv = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'httpEquiv', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$language = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'language', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$src = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'src', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$alt = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'alt', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$preload = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'preload', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$poster = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'poster', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$kind = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'kind', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$srclang = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'srclang', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$sandbox = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'sandbox', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$srcdoc = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'srcdoc', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$type_ = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'type', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$value = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'value', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$defaultValue = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'defaultValue', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$placeholder = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'placeholder', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$accept = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'accept', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$acceptCharset = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'acceptCharset', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$action = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'action', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$autocomplete = function (bool) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var _rtfeldman$elm_css$Html_Styled_Attributes$enctype = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'enctype', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$method = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'method', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$name = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'name', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$pattern = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'pattern', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$for = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'htmlFor', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$max = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'max', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$min = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'min', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$step = function (n) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'step', n);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$wrap = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'wrap', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$usemap = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'useMap', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$shape = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'shape', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$coords = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'coords', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$keytype = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'keytype', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$align = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'align', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$cite = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'cite', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$href = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'href', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$target = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'target', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$downloadAs = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'download', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$hreflang = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'hreflang', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$ping = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'ping', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$start = function (n) {
	return A2(
		_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty,
		'start',
		_elm_lang$core$Basics$toString(n));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$headers = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'headers', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$scope = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$stringProperty, 'scope', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$boolProperty = F2(
	function (name, bool) {
		return A2(
			_rtfeldman$elm_css$Html_Styled_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$bool(bool));
	});
var _rtfeldman$elm_css$Html_Styled_Attributes$hidden = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'hidden', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$contenteditable = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'contentEditable', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$spellcheck = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'spellcheck', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$async = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'async', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$defer = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'defer', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$scoped = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'scoped', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$autoplay = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'autoplay', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$controls = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'controls', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$loop = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'loop', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$default = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'default', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$seamless = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'seamless', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$checked = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'checked', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$selected = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'selected', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$autofocus = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'autofocus', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$disabled = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'disabled', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$multiple = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'multiple', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$novalidate = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'noValidate', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$readonly = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'readOnly', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$required = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'required', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$ismap = function (value) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'isMap', value);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$download = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'download', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$reversed = function (bool) {
	return A2(_rtfeldman$elm_css$Html_Styled_Attributes$boolProperty, 'reversed', bool);
};
var _rtfeldman$elm_css$Html_Styled_Attributes$classList = function (list) {
	return _rtfeldman$elm_css$Html_Styled_Attributes$class(
		A2(
			_elm_lang$core$String$join,
			' ',
			A2(
				_elm_lang$core$List$map,
				_elm_lang$core$Tuple$first,
				A2(_elm_lang$core$List$filter, _elm_lang$core$Tuple$second, list))));
};
var _rtfeldman$elm_css$Html_Styled_Attributes$fromUnstyled = _rtfeldman$elm_css$VirtualDom_Styled$unstyledProperty;
var _rtfeldman$elm_css$Html_Styled_Attributes$style = function (_p0) {
	return _rtfeldman$elm_css$Html_Styled_Attributes$fromUnstyled(
		_elm_lang$virtual_dom$VirtualDom$style(_p0));
};

var _truqu$elm_base64$Base64_Decode$charToInt = function ($char) {
	var _p0 = $char;
	switch (_p0.valueOf()) {
		case 'A':
			return 0;
		case 'B':
			return 1;
		case 'C':
			return 2;
		case 'D':
			return 3;
		case 'E':
			return 4;
		case 'F':
			return 5;
		case 'G':
			return 6;
		case 'H':
			return 7;
		case 'I':
			return 8;
		case 'J':
			return 9;
		case 'K':
			return 10;
		case 'L':
			return 11;
		case 'M':
			return 12;
		case 'N':
			return 13;
		case 'O':
			return 14;
		case 'P':
			return 15;
		case 'Q':
			return 16;
		case 'R':
			return 17;
		case 'S':
			return 18;
		case 'T':
			return 19;
		case 'U':
			return 20;
		case 'V':
			return 21;
		case 'W':
			return 22;
		case 'X':
			return 23;
		case 'Y':
			return 24;
		case 'Z':
			return 25;
		case 'a':
			return 26;
		case 'b':
			return 27;
		case 'c':
			return 28;
		case 'd':
			return 29;
		case 'e':
			return 30;
		case 'f':
			return 31;
		case 'g':
			return 32;
		case 'h':
			return 33;
		case 'i':
			return 34;
		case 'j':
			return 35;
		case 'k':
			return 36;
		case 'l':
			return 37;
		case 'm':
			return 38;
		case 'n':
			return 39;
		case 'o':
			return 40;
		case 'p':
			return 41;
		case 'q':
			return 42;
		case 'r':
			return 43;
		case 's':
			return 44;
		case 't':
			return 45;
		case 'u':
			return 46;
		case 'v':
			return 47;
		case 'w':
			return 48;
		case 'x':
			return 49;
		case 'y':
			return 50;
		case 'z':
			return 51;
		case '0':
			return 52;
		case '1':
			return 53;
		case '2':
			return 54;
		case '3':
			return 55;
		case '4':
			return 56;
		case '5':
			return 57;
		case '6':
			return 58;
		case '7':
			return 59;
		case '8':
			return 60;
		case '9':
			return 61;
		case '+':
			return 62;
		case '/':
			return 63;
		default:
			return 0;
	}
};
var _truqu$elm_base64$Base64_Decode$intToString = function ($int) {
	if (_elm_lang$core$Native_Utils.cmp($int, 65536) < 1) {
		return _elm_lang$core$String$fromChar(
			_elm_lang$core$Char$fromCode($int));
	} else {
		var c = $int - 65536;
		return _elm_lang$core$String$fromList(
			{
				ctor: '::',
				_0: _elm_lang$core$Char$fromCode(55296 | (c >>> 10)),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Char$fromCode(56320 | (1023 & c)),
					_1: {ctor: '[]'}
				}
			});
	}
};
var _truqu$elm_base64$Base64_Decode$add = F2(
	function ($char, _p1) {
		var _p2 = _p1;
		var _p4 = _p2._2;
		var _p3 = _p2._1;
		var shiftAndAdd = function ($int) {
			return (63 & $int) | (_p2._0 << 6);
		};
		return _elm_lang$core$Native_Utils.eq(_p3, 0) ? (_elm_lang$core$Native_Utils.eq(128 & $char, 0) ? {
			ctor: '_Tuple3',
			_0: 0,
			_1: 0,
			_2: A2(
				_elm_lang$core$Basics_ops['++'],
				_p4,
				_truqu$elm_base64$Base64_Decode$intToString($char))
		} : (_elm_lang$core$Native_Utils.eq(224 & $char, 192) ? {ctor: '_Tuple3', _0: 31 & $char, _1: 1, _2: _p4} : (_elm_lang$core$Native_Utils.eq(240 & $char, 224) ? {ctor: '_Tuple3', _0: 15 & $char, _1: 2, _2: _p4} : {ctor: '_Tuple3', _0: 7 & $char, _1: 3, _2: _p4}))) : (_elm_lang$core$Native_Utils.eq(_p3, 1) ? {
			ctor: '_Tuple3',
			_0: 0,
			_1: 0,
			_2: A2(
				_elm_lang$core$Basics_ops['++'],
				_p4,
				_truqu$elm_base64$Base64_Decode$intToString(
					shiftAndAdd($char)))
		} : {
			ctor: '_Tuple3',
			_0: shiftAndAdd($char),
			_1: _p3 - 1,
			_2: _p4
		});
	});
var _truqu$elm_base64$Base64_Decode$toUTF16 = F2(
	function ($char, acc) {
		return {
			ctor: '_Tuple3',
			_0: 0,
			_1: 0,
			_2: A2(
				_truqu$elm_base64$Base64_Decode$add,
				255 & ($char >>> 0),
				A2(
					_truqu$elm_base64$Base64_Decode$add,
					255 & ($char >>> 8),
					A2(_truqu$elm_base64$Base64_Decode$add, 255 & ($char >>> 16), acc)))
		};
	});
var _truqu$elm_base64$Base64_Decode$chomp = F2(
	function (char_, _p5) {
		var _p6 = _p5;
		var _p10 = _p6._2;
		var _p9 = _p6._0;
		var _p8 = _p6._1;
		var $char = _truqu$elm_base64$Base64_Decode$charToInt(char_);
		var _p7 = _p8;
		if (_p7 === 3) {
			return A2(_truqu$elm_base64$Base64_Decode$toUTF16, _p9 | $char, _p10);
		} else {
			return {ctor: '_Tuple3', _0: ($char << ((3 - _p8) * 6)) | _p9, _1: _p8 + 1, _2: _p10};
		}
	});
var _truqu$elm_base64$Base64_Decode$initial = {
	ctor: '_Tuple3',
	_0: 0,
	_1: 0,
	_2: {ctor: '_Tuple3', _0: 0, _1: 0, _2: ''}
};
var _truqu$elm_base64$Base64_Decode$wrapUp = function (_p11) {
	var _p12 = _p11;
	return (_elm_lang$core$Native_Utils.cmp(_p12._2._1, 0) > 0) ? _elm_lang$core$Result$Err('Invalid UTF-16') : _elm_lang$core$Result$Ok(_p12._2._2);
};
var _truqu$elm_base64$Base64_Decode$stripNulls = F2(
	function (input, output) {
		return A2(_elm_lang$core$String$endsWith, '==', input) ? A2(_elm_lang$core$String$dropRight, 2, output) : (A2(_elm_lang$core$String$endsWith, '=', input) ? A2(_elm_lang$core$String$dropRight, 1, output) : output);
	});
var _truqu$elm_base64$Base64_Decode$validBase64Regex = _elm_lang$core$Regex$regex('^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$');
var _truqu$elm_base64$Base64_Decode$validate = function (input) {
	return A2(_elm_lang$core$Regex$contains, _truqu$elm_base64$Base64_Decode$validBase64Regex, input) ? _elm_lang$core$Result$Ok(input) : _elm_lang$core$Result$Err('Invalid base64');
};
var _truqu$elm_base64$Base64_Decode$pad = function (input) {
	var _p13 = A2(
		_elm_lang$core$Basics$rem,
		_elm_lang$core$String$length(input),
		4);
	switch (_p13) {
		case 3:
			return A2(_elm_lang$core$Basics_ops['++'], input, '=');
		case 2:
			return A2(_elm_lang$core$Basics_ops['++'], input, '==');
		default:
			return input;
	}
};
var _truqu$elm_base64$Base64_Decode$validateAndDecode = function (input) {
	return A2(
		_elm_lang$core$Result$map,
		_truqu$elm_base64$Base64_Decode$stripNulls(input),
		A2(
			_elm_lang$core$Result$andThen,
			function (_p14) {
				return _truqu$elm_base64$Base64_Decode$wrapUp(
					A3(_elm_lang$core$String$foldl, _truqu$elm_base64$Base64_Decode$chomp, _truqu$elm_base64$Base64_Decode$initial, _p14));
			},
			_truqu$elm_base64$Base64_Decode$validate(input)));
};
var _truqu$elm_base64$Base64_Decode$decode = function (_p15) {
	return _truqu$elm_base64$Base64_Decode$validateAndDecode(
		_truqu$elm_base64$Base64_Decode$pad(_p15));
};

var _truqu$elm_base64$Base64_Encode$intToBase64 = function (i) {
	var _p0 = i;
	switch (_p0) {
		case 0:
			return 'A';
		case 1:
			return 'B';
		case 2:
			return 'C';
		case 3:
			return 'D';
		case 4:
			return 'E';
		case 5:
			return 'F';
		case 6:
			return 'G';
		case 7:
			return 'H';
		case 8:
			return 'I';
		case 9:
			return 'J';
		case 10:
			return 'K';
		case 11:
			return 'L';
		case 12:
			return 'M';
		case 13:
			return 'N';
		case 14:
			return 'O';
		case 15:
			return 'P';
		case 16:
			return 'Q';
		case 17:
			return 'R';
		case 18:
			return 'S';
		case 19:
			return 'T';
		case 20:
			return 'U';
		case 21:
			return 'V';
		case 22:
			return 'W';
		case 23:
			return 'X';
		case 24:
			return 'Y';
		case 25:
			return 'Z';
		case 26:
			return 'a';
		case 27:
			return 'b';
		case 28:
			return 'c';
		case 29:
			return 'd';
		case 30:
			return 'e';
		case 31:
			return 'f';
		case 32:
			return 'g';
		case 33:
			return 'h';
		case 34:
			return 'i';
		case 35:
			return 'j';
		case 36:
			return 'k';
		case 37:
			return 'l';
		case 38:
			return 'm';
		case 39:
			return 'n';
		case 40:
			return 'o';
		case 41:
			return 'p';
		case 42:
			return 'q';
		case 43:
			return 'r';
		case 44:
			return 's';
		case 45:
			return 't';
		case 46:
			return 'u';
		case 47:
			return 'v';
		case 48:
			return 'w';
		case 49:
			return 'x';
		case 50:
			return 'y';
		case 51:
			return 'z';
		case 52:
			return '0';
		case 53:
			return '1';
		case 54:
			return '2';
		case 55:
			return '3';
		case 56:
			return '4';
		case 57:
			return '5';
		case 58:
			return '6';
		case 59:
			return '7';
		case 60:
			return '8';
		case 61:
			return '9';
		case 62:
			return '+';
		default:
			return '/';
	}
};
var _truqu$elm_base64$Base64_Encode$toBase64 = function ($int) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_truqu$elm_base64$Base64_Encode$intToBase64(63 & ($int >>> 18)),
		A2(
			_elm_lang$core$Basics_ops['++'],
			_truqu$elm_base64$Base64_Encode$intToBase64(63 & ($int >>> 12)),
			A2(
				_elm_lang$core$Basics_ops['++'],
				_truqu$elm_base64$Base64_Encode$intToBase64(63 & ($int >>> 6)),
				_truqu$elm_base64$Base64_Encode$intToBase64(63 & ($int >>> 0)))));
};
var _truqu$elm_base64$Base64_Encode$add = F2(
	function ($char, _p1) {
		var _p2 = _p1;
		var _p5 = _p2._0;
		var _p4 = _p2._1;
		var current = (_p2._2 << 8) | $char;
		var _p3 = _p4;
		if (_p3 === 2) {
			return {
				ctor: '_Tuple3',
				_0: A2(
					_elm_lang$core$Basics_ops['++'],
					_p5,
					_truqu$elm_base64$Base64_Encode$toBase64(current)),
				_1: 0,
				_2: 0
			};
		} else {
			return {ctor: '_Tuple3', _0: _p5, _1: _p4 + 1, _2: current};
		}
	});
var _truqu$elm_base64$Base64_Encode$chomp = F2(
	function (char_, _p6) {
		var _p7 = _p6;
		var _p9 = _p7._1;
		var $char = _elm_lang$core$Char$toCode(char_);
		var _p8 = _p7._0;
		if (_p8.ctor === 'Nothing') {
			return (_elm_lang$core$Native_Utils.cmp($char, 128) < 0) ? {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Maybe$Nothing,
				_1: A2(_truqu$elm_base64$Base64_Encode$add, $char, _p9)
			} : ((_elm_lang$core$Native_Utils.cmp($char, 2048) < 0) ? {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Maybe$Nothing,
				_1: A2(
					_truqu$elm_base64$Base64_Encode$add,
					128 | (63 & $char),
					A2(_truqu$elm_base64$Base64_Encode$add, 192 | ($char >>> 6), _p9))
			} : (((_elm_lang$core$Native_Utils.cmp($char, 55296) < 0) || (_elm_lang$core$Native_Utils.cmp($char, 57344) > -1)) ? {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Maybe$Nothing,
				_1: A2(
					_truqu$elm_base64$Base64_Encode$add,
					128 | (63 & $char),
					A2(
						_truqu$elm_base64$Base64_Encode$add,
						128 | (63 & ($char >>> 6)),
						A2(_truqu$elm_base64$Base64_Encode$add, 224 | ($char >>> 12), _p9)))
			} : {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Maybe$Just($char),
				_1: _p9
			}));
		} else {
			var combined = A2(
				F2(
					function (x, y) {
						return x + y;
					}),
				65536,
				(1023 & $char) | ((1023 & _p8._0) << 10));
			return {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Maybe$Nothing,
				_1: A2(
					_truqu$elm_base64$Base64_Encode$add,
					128 | (63 & combined),
					A2(
						_truqu$elm_base64$Base64_Encode$add,
						128 | (63 & (combined >>> 6)),
						A2(
							_truqu$elm_base64$Base64_Encode$add,
							128 | (63 & (combined >>> 12)),
							A2(_truqu$elm_base64$Base64_Encode$add, 240 | (combined >>> 18), _p9))))
			};
		}
	});
var _truqu$elm_base64$Base64_Encode$wrapUp = function (_p10) {
	var _p11 = _p10;
	var _p14 = _p11._1._0;
	var _p13 = _p11._1._2;
	var _p12 = _p11._1._1;
	switch (_p12) {
		case 1:
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_p14,
				A2(
					_elm_lang$core$Basics_ops['++'],
					_truqu$elm_base64$Base64_Encode$intToBase64(63 & (_p13 >>> 2)),
					A2(
						_elm_lang$core$Basics_ops['++'],
						_truqu$elm_base64$Base64_Encode$intToBase64(63 & (_p13 << 4)),
						'==')));
		case 2:
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_p14,
				A2(
					_elm_lang$core$Basics_ops['++'],
					_truqu$elm_base64$Base64_Encode$intToBase64(63 & (_p13 >>> 10)),
					A2(
						_elm_lang$core$Basics_ops['++'],
						_truqu$elm_base64$Base64_Encode$intToBase64(63 & (_p13 >>> 4)),
						A2(
							_elm_lang$core$Basics_ops['++'],
							_truqu$elm_base64$Base64_Encode$intToBase64(63 & (_p13 << 2)),
							'='))));
		default:
			return _p14;
	}
};
var _truqu$elm_base64$Base64_Encode$initial = {
	ctor: '_Tuple2',
	_0: _elm_lang$core$Maybe$Nothing,
	_1: {ctor: '_Tuple3', _0: '', _1: 0, _2: 0}
};
var _truqu$elm_base64$Base64_Encode$encode = function (input) {
	return _truqu$elm_base64$Base64_Encode$wrapUp(
		A3(_elm_lang$core$String$foldl, _truqu$elm_base64$Base64_Encode$chomp, _truqu$elm_base64$Base64_Encode$initial, input));
};

var _truqu$elm_base64$Base64$decode = _truqu$elm_base64$Base64_Decode$decode;
var _truqu$elm_base64$Base64$encode = _truqu$elm_base64$Base64_Encode$encode;

var _simonh1000$elm_jwt$Jwt$authenticate = F3(
	function (url, dec, credentials) {
		return A3(
			_elm_lang$http$Http$post,
			url,
			_elm_lang$http$Http$jsonBody(credentials),
			dec);
	});
var _simonh1000$elm_jwt$Jwt$createRequestObject = F5(
	function (method, token, url, body, dec) {
		return {
			method: method,
			headers: {
				ctor: '::',
				_0: A2(
					_elm_lang$http$Http$header,
					'Authorization',
					A2(_elm_lang$core$Basics_ops['++'], 'Bearer ', token)),
				_1: {ctor: '[]'}
			},
			url: url,
			body: body,
			expect: _elm_lang$http$Http$expectJson(dec),
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: false
		};
	});
var _simonh1000$elm_jwt$Jwt$createRequest = F4(
	function (method, token, url, body) {
		return function (_p0) {
			return _elm_lang$http$Http$request(
				A5(_simonh1000$elm_jwt$Jwt$createRequestObject, method, token, url, body, _p0));
		};
	});
var _simonh1000$elm_jwt$Jwt$get = F3(
	function (token, url, dec) {
		return A5(_simonh1000$elm_jwt$Jwt$createRequest, 'GET', token, url, _elm_lang$http$Http$emptyBody, dec);
	});
var _simonh1000$elm_jwt$Jwt$post = _simonh1000$elm_jwt$Jwt$createRequest('POST');
var _simonh1000$elm_jwt$Jwt$put = _simonh1000$elm_jwt$Jwt$createRequest('PUT');
var _simonh1000$elm_jwt$Jwt$delete = F3(
	function (token, url, dec) {
		return A5(_simonh1000$elm_jwt$Jwt$createRequest, 'DELETE', token, url, _elm_lang$http$Http$emptyBody, dec);
	});
var _simonh1000$elm_jwt$Jwt$unurl = function () {
	var fix = function (c) {
		var _p1 = c;
		switch (_p1.valueOf()) {
			case '-':
				return _elm_lang$core$Native_Utils.chr('+');
			case '_':
				return _elm_lang$core$Native_Utils.chr('/');
			default:
				return c;
		}
	};
	return _elm_lang$core$String$map(fix);
}();
var _simonh1000$elm_jwt$Jwt$TokenDecodeError = function (a) {
	return {ctor: 'TokenDecodeError', _0: a};
};
var _simonh1000$elm_jwt$Jwt$TokenProcessingError = function (a) {
	return {ctor: 'TokenProcessingError', _0: a};
};
var _simonh1000$elm_jwt$Jwt$fixlength = function (s) {
	var _p2 = A2(
		_elm_lang$core$Basics_ops['%'],
		_elm_lang$core$String$length(s),
		4);
	switch (_p2) {
		case 0:
			return _elm_lang$core$Result$Ok(s);
		case 2:
			return _elm_lang$core$Result$Ok(
				_elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: s,
						_1: {
							ctor: '::',
							_0: '==',
							_1: {ctor: '[]'}
						}
					}));
		case 3:
			return _elm_lang$core$Result$Ok(
				_elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: s,
						_1: {
							ctor: '::',
							_0: '=',
							_1: {ctor: '[]'}
						}
					}));
		default:
			return _elm_lang$core$Result$Err(
				_simonh1000$elm_jwt$Jwt$TokenProcessingError('Wrong length'));
	}
};
var _simonh1000$elm_jwt$Jwt$getTokenBody = function (token) {
	var processor = function (_p3) {
		return A2(
			_elm_lang$core$List$map,
			_simonh1000$elm_jwt$Jwt$fixlength,
			A2(
				_elm_lang$core$String$split,
				'.',
				_simonh1000$elm_jwt$Jwt$unurl(_p3)));
	};
	var _p4 = processor(token);
	_v2_2:
	do {
		if ((_p4.ctor === '::') && (_p4._1.ctor === '::')) {
			if (_p4._1._0.ctor === 'Err') {
				if ((_p4._1._1.ctor === '::') && (_p4._1._1._1.ctor === '[]')) {
					return _elm_lang$core$Result$Err(_p4._1._0._0);
				} else {
					break _v2_2;
				}
			} else {
				if ((_p4._1._1.ctor === '::') && (_p4._1._1._1.ctor === '[]')) {
					return _elm_lang$core$Result$Ok(_p4._1._0._0);
				} else {
					break _v2_2;
				}
			}
		} else {
			break _v2_2;
		}
	} while(false);
	return _elm_lang$core$Result$Err(
		_simonh1000$elm_jwt$Jwt$TokenProcessingError('Token has invalid shape'));
};
var _simonh1000$elm_jwt$Jwt$decodeToken = function (dec) {
	return function (_p5) {
		return A2(
			_elm_lang$core$Result$andThen,
			function (_p6) {
				return A2(
					_elm_lang$core$Result$mapError,
					_simonh1000$elm_jwt$Jwt$TokenDecodeError,
					A2(_elm_lang$core$Json_Decode$decodeString, dec, _p6));
			},
			A2(
				_elm_lang$core$Result$andThen,
				function (_p7) {
					return A2(
						_elm_lang$core$Result$mapError,
						_simonh1000$elm_jwt$Jwt$TokenDecodeError,
						_truqu$elm_base64$Base64$decode(_p7));
				},
				_simonh1000$elm_jwt$Jwt$getTokenBody(_p5)));
	};
};
var _simonh1000$elm_jwt$Jwt$isExpired = F2(
	function (now, token) {
		return A2(
			_elm_lang$core$Result$map,
			function (exp) {
				return _elm_lang$core$Native_Utils.cmp(now, exp * 1000) > 0;
			},
			A2(
				_simonh1000$elm_jwt$Jwt$decodeToken,
				A2(_elm_lang$core$Json_Decode$field, 'exp', _elm_lang$core$Json_Decode$float),
				token));
	});
var _simonh1000$elm_jwt$Jwt$tokenDecoder = function (inner) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (tokenStr) {
			var transformedToken = A2(
				_elm_lang$core$Result$andThen,
				_elm_lang$core$Json_Decode$decodeString(inner),
				A2(
					_elm_lang$core$Result$mapError,
					F2(
						function (x, y) {
							return A2(_elm_lang$core$Basics_ops['++'], x, y);
						})('base64 error: '),
					A2(
						_elm_lang$core$Result$andThen,
						_truqu$elm_base64$Base64$decode,
						A2(
							_elm_lang$core$Result$mapError,
							_elm_lang$core$Basics$toString,
							_simonh1000$elm_jwt$Jwt$getTokenBody(tokenStr)))));
			var _p8 = transformedToken;
			if (_p8.ctor === 'Ok') {
				return _elm_lang$core$Json_Decode$succeed(_p8._0);
			} else {
				return _elm_lang$core$Json_Decode$fail(_p8._0);
			}
		},
		_elm_lang$core$Json_Decode$string);
};
var _simonh1000$elm_jwt$Jwt$TokenNotExpired = {ctor: 'TokenNotExpired'};
var _simonh1000$elm_jwt$Jwt$TokenExpired = {ctor: 'TokenExpired'};
var _simonh1000$elm_jwt$Jwt$checkUnacceptedToken = F2(
	function (token, now) {
		var _p9 = A2(_simonh1000$elm_jwt$Jwt$isExpired, now, token);
		if (_p9.ctor === 'Ok') {
			if (_p9._0 === true) {
				return _simonh1000$elm_jwt$Jwt$TokenExpired;
			} else {
				return _simonh1000$elm_jwt$Jwt$TokenNotExpired;
			}
		} else {
			return _p9._0;
		}
	});
var _simonh1000$elm_jwt$Jwt$checkTokenExpiry = function (token) {
	return A2(
		_elm_lang$core$Task$andThen,
		function (_p10) {
			return _elm_lang$core$Task$succeed(
				A2(_simonh1000$elm_jwt$Jwt$checkUnacceptedToken, token, _p10));
		},
		_elm_lang$core$Time$now);
};
var _simonh1000$elm_jwt$Jwt$Unauthorized = {ctor: 'Unauthorized'};
var _simonh1000$elm_jwt$Jwt$HttpError = function (a) {
	return {ctor: 'HttpError', _0: a};
};
var _simonh1000$elm_jwt$Jwt$promote401 = function (err) {
	var _p11 = err;
	if (_p11.ctor === 'BadStatus') {
		return _elm_lang$core$Native_Utils.eq(_p11._0.status.code, 401) ? _simonh1000$elm_jwt$Jwt$Unauthorized : _simonh1000$elm_jwt$Jwt$HttpError(err);
	} else {
		return _simonh1000$elm_jwt$Jwt$HttpError(err);
	}
};
var _simonh1000$elm_jwt$Jwt$send = F2(
	function (msgCreator, req) {
		var conv = function (fn) {
			return function (_p12) {
				return fn(
					A2(_elm_lang$core$Result$mapError, _simonh1000$elm_jwt$Jwt$promote401, _p12));
			};
		};
		return A2(
			_elm_lang$http$Http$send,
			conv(msgCreator),
			req);
	});
var _simonh1000$elm_jwt$Jwt$handleError = F2(
	function (token, err) {
		var _p13 = _simonh1000$elm_jwt$Jwt$promote401(err);
		if (_p13.ctor === 'Unauthorized') {
			return _simonh1000$elm_jwt$Jwt$checkTokenExpiry(token);
		} else {
			return _elm_lang$core$Task$succeed(
				_simonh1000$elm_jwt$Jwt$HttpError(err));
		}
	});
var _simonh1000$elm_jwt$Jwt$sendCheckExpired = F3(
	function (token, msgCreator, req) {
		return A2(
			_elm_lang$core$Task$perform,
			msgCreator,
			A2(
				_elm_lang$core$Task$onError,
				function (_p14) {
					return A2(
						_elm_lang$core$Task$map,
						_elm_lang$core$Result$Err,
						A2(_simonh1000$elm_jwt$Jwt$handleError, token, _p14));
				},
				A2(
					_elm_lang$core$Task$map,
					_elm_lang$core$Result$Ok,
					_elm_lang$http$Http$toTask(req))));
	});

// To use the examples, swap the commenting on the next two lines

// var _user$project$Native_FileReader = function() {
var _simonh1000$file_reader$Native_FileReader = function() {

    var scheduler = _elm_lang$core$Native_Scheduler;

    function useReader(method, fileObjectToRead) {
        return scheduler.nativeBinding(function(callback){

            /*
             * Test for existence of FileReader using
             * if(window.FileReader) { ...
             * http://caniuse.com/#search=filereader
             * main gap is IE10 and 11 which do not support readAsBinaryFile
             * but we do not use this API either as it is deprecated
             */
            var reader = new FileReader();

            reader.onload = function(evt) {
                return callback(scheduler.succeed(evt.target.result));
            };

            reader.onerror = function() {
                return callback(scheduler.fail({ctor : 'ReadFail'}));
            };

            // Error if not passed an objectToRead or if it is not a Blob
            if (!fileObjectToRead || !(fileObjectToRead instanceof Blob)) {
                return callback(scheduler.fail({ctor : 'NoValidBlob'}));
            }

            if (reader[method]) {
                var result = reader[method](fileObjectToRead);
                // prevent memory leak by nullifying fileObjectToRead
                fileObjectToRead = null;
                return result;
            } else {
                return callback(scheduler.fail({ctor : 'ReadFail'}));
            }
        });
    }

    // readAsTextFile : Value -> Task error String
    var readAsTextFile = function(fileObjectToRead){
        return useReader("readAsText", fileObjectToRead);
    };

    // readAsArrayBuffer : Value -> Task error String
    var readAsArrayBuffer = function(fileObjectToRead){
        return useReader("readAsArrayBuffer", fileObjectToRead);
    };

    // readAsDataUrl : Value -> Task error String
    var readAsDataUrl = function(fileObjectToRead){
        return useReader("readAsDataURL", fileObjectToRead);
    };

    var filePart = function(name, blob) {
        return {
            _0: name,
            _1: blob
        }
    };

    var rawBody = function (mimeType, blob) {
        return {
            ctor: "StringBody",
            _0: mimeType,
            _1: blob
        };
    };

    return {
        readAsTextFile : readAsTextFile,
        readAsArrayBuffer : readAsArrayBuffer,
        readAsDataUrl: readAsDataUrl,
        filePart: F2(filePart),
        rawBody: F2(rawBody)
    };
}();

var _simonh1000$file_reader$FileReader$mtypeDecoder = A2(
	_elm_lang$core$Json_Decode$map,
	_danyx23$elm_mimetype$MimeType$parseMimeType,
	A2(_elm_lang$core$Json_Decode$field, 'type', _elm_lang$core$Json_Decode$string));
var _simonh1000$file_reader$FileReader$fileListDecoder = function (decoder) {
	var decodeFileValues = function (indexes) {
		return A3(
			_elm_lang$core$List$foldr,
			_elm_lang$core$Json_Decode$map2(
				F2(
					function (x, y) {
						return {ctor: '::', _0: x, _1: y};
					})),
			_elm_lang$core$Json_Decode$succeed(
				{ctor: '[]'}),
			A2(
				_elm_lang$core$List$map,
				function (index) {
					return A2(
						_elm_lang$core$Json_Decode$field,
						_elm_lang$core$Basics$toString(index),
						decoder);
				},
				indexes));
	};
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		decodeFileValues,
		A2(
			_elm_lang$core$Json_Decode$map,
			function (i) {
				return A2(_elm_lang$core$List$range, 0, i - 1);
			},
			A2(_elm_lang$core$Json_Decode$field, 'length', _elm_lang$core$Json_Decode$int)));
};
var _simonh1000$file_reader$FileReader$isTextFile = function (fileRef) {
	var _p0 = A2(_elm_lang$core$Json_Decode$decodeValue, _simonh1000$file_reader$FileReader$mtypeDecoder, fileRef);
	_v0_2:
	do {
		if (_p0.ctor === 'Ok') {
			if (_p0._0.ctor === 'Just') {
				if (_p0._0._0.ctor === 'Text') {
					return true;
				} else {
					break _v0_2;
				}
			} else {
				return true;
			}
		} else {
			break _v0_2;
		}
	} while(false);
	return false;
};
var _simonh1000$file_reader$FileReader$prettyPrint = function (err) {
	var _p1 = err;
	switch (_p1.ctor) {
		case 'ReadFail':
			return 'File reading error';
		case 'NoValidBlob':
			return 'Blob was not valid';
		default:
			return 'Not a text file';
	}
};
var _simonh1000$file_reader$FileReader$rawBody = F2(
	function (mimeType, nf) {
		return A2(_simonh1000$file_reader$Native_FileReader.rawBody, mimeType, nf.blob);
	});
var _simonh1000$file_reader$FileReader$filePart = F2(
	function (name, nf) {
		return A2(_simonh1000$file_reader$Native_FileReader.filePart, name, nf.blob);
	});
var _simonh1000$file_reader$FileReader$readAsDataUrl = function (fileRef) {
	return _simonh1000$file_reader$Native_FileReader.readAsDataUrl(fileRef);
};
var _simonh1000$file_reader$FileReader$readAsArrayBuffer = function (fileRef) {
	return _simonh1000$file_reader$Native_FileReader.readAsArrayBuffer(fileRef);
};
var _simonh1000$file_reader$FileReader$NativeFile = F4(
	function (a, b, c, d) {
		return {name: a, size: b, mimeType: c, blob: d};
	});
var _simonh1000$file_reader$FileReader$nativeFileDecoder = A5(
	_elm_lang$core$Json_Decode$map4,
	_simonh1000$file_reader$FileReader$NativeFile,
	A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string),
	A2(_elm_lang$core$Json_Decode$field, 'size', _elm_lang$core$Json_Decode$int),
	_simonh1000$file_reader$FileReader$mtypeDecoder,
	_elm_lang$core$Json_Decode$value);
var _simonh1000$file_reader$FileReader$fileParser = function (fieldName) {
	return A2(
		_elm_lang$core$Json_Decode$field,
		fieldName,
		A2(
			_elm_lang$core$Json_Decode$field,
			'files',
			_simonh1000$file_reader$FileReader$fileListDecoder(_simonh1000$file_reader$FileReader$nativeFileDecoder)));
};
var _simonh1000$file_reader$FileReader$parseSelectedFiles = _simonh1000$file_reader$FileReader$fileParser('target');
var _simonh1000$file_reader$FileReader$onFileChange = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'change',
		A2(_elm_lang$core$Json_Decode$map, msg, _simonh1000$file_reader$FileReader$parseSelectedFiles));
};
var _simonh1000$file_reader$FileReader$parseDroppedFiles = _simonh1000$file_reader$FileReader$fileParser('dataTransfer');
var _simonh1000$file_reader$FileReader$NotTextFile = {ctor: 'NotTextFile'};
var _simonh1000$file_reader$FileReader$readAsTextFile = function (fileRef) {
	return _simonh1000$file_reader$FileReader$isTextFile(fileRef) ? _simonh1000$file_reader$Native_FileReader.readAsTextFile(fileRef) : _elm_lang$core$Task$fail(_simonh1000$file_reader$FileReader$NotTextFile);
};
var _simonh1000$file_reader$FileReader$ReadFail = {ctor: 'ReadFail'};
var _simonh1000$file_reader$FileReader$NoValidBlob = {ctor: 'NoValidBlob'};

var _user$project$Action$execute = F4(
	function (execCfg, action, model, cmd) {
		var _p0 = action;
		switch (_p0.ctor) {
			case 'None':
				return {ctor: '_Tuple2', _0: model, _1: cmd};
			case 'Batch':
				return A4(_user$project$Action$executeActions, execCfg, _p0._0, model, cmd);
			case 'SendMsg':
				var _p1 = A2(execCfg.sendMsg, _p0._0, model);
				var newModel = _p1._0;
				var newCmd = _p1._1;
				return {
					ctor: '_Tuple2',
					_0: newModel,
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: cmd,
							_1: {
								ctor: '::',
								_0: newCmd,
								_1: {ctor: '[]'}
							}
						})
				};
			default:
				var _p2 = A2(execCfg.execCustAction, action, model);
				var newModel = _p2._0;
				var newCmd = _p2._1;
				return {
					ctor: '_Tuple2',
					_0: newModel,
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: cmd,
							_1: {
								ctor: '::',
								_0: newCmd,
								_1: {ctor: '[]'}
							}
						})
				};
		}
	});
var _user$project$Action$executeActions = F4(
	function (execCfg, actions, startModel, startCmd) {
		var fold = F2(
			function (action, _p3) {
				var _p4 = _p3;
				var _p5 = A4(_user$project$Action$execute, execCfg, action, _p4._0, _elm_lang$core$Platform_Cmd$none);
				var m = _p5._0;
				var c = _p5._1;
				return {
					ctor: '_Tuple2',
					_0: m,
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: _p4._1,
							_1: {
								ctor: '::',
								_0: c,
								_1: {ctor: '[]'}
							}
						})
				};
			});
		return A3(
			_elm_lang$core$List$foldl,
			fold,
			{ctor: '_Tuple2', _0: startModel, _1: startCmd},
			actions);
	});
var _user$project$Action$ExecCfg = F2(
	function (a, b) {
		return {execCustAction: a, sendMsg: b};
	});
var _user$project$Action$Custom = function (a) {
	return {ctor: 'Custom', _0: a};
};
var _user$project$Action$custom = function (custAction) {
	return _user$project$Action$Custom(custAction);
};
var _user$project$Action$SendMsg = function (a) {
	return {ctor: 'SendMsg', _0: a};
};
var _user$project$Action$sendMsg = function (msg) {
	return _user$project$Action$SendMsg(msg);
};
var _user$project$Action$Batch = function (a) {
	return {ctor: 'Batch', _0: a};
};
var _user$project$Action$batch = function (actions) {
	return _user$project$Action$Batch(actions);
};
var _user$project$Action$None = {ctor: 'None'};
var _user$project$Action$none = _user$project$Action$None;

var _user$project$Auth$httpErrorString = function (error) {
	var _p0 = error;
	switch (_p0.ctor) {
		case 'BadUrl':
			return A2(_elm_lang$core$Basics_ops['++'], 'Bad Url: ', _p0._0);
		case 'Timeout':
			return 'auth_no_connexion';
		case 'NetworkError':
			return 'Network Error';
		case 'BadStatus':
			var _p1 = _p0._0;
			return _elm_lang$core$Native_Utils.eq(_p1.status.code, 401) ? 'auth_bad_credentials' : A2(
				_elm_lang$core$Basics_ops['++'],
				'Bad Http Status: ',
				_elm_lang$core$Basics$toString(_p1.status.code));
		default:
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'Bad Http Payload: ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p0._0),
					A2(
						_elm_lang$core$Basics_ops['++'],
						' (',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p0._1.status.code),
							')'))));
	}
};
var _user$project$Auth$tokenDecoder = A2(_elm_lang$core$Json_Decode$field, 'token', _elm_lang$core$Json_Decode$string);
var _user$project$Auth$State = F4(
	function (a, b, c, d) {
		return {loginUrl: a, username: b, password: c, infoMsg: d};
	});
var _user$project$Auth$initState = function (loginUrl) {
	return {
		ctor: '_Tuple2',
		_0: A4(_user$project$Auth$State, loginUrl, '', '', ''),
		_1: _elm_lang$core$Platform_Cmd$none
	};
};
var _user$project$Auth$AuthReqReceived = function (a) {
	return {ctor: 'AuthReqReceived', _0: a};
};
var _user$project$Auth$sendAuth = F2(
	function (msgFromAuth, state) {
		var body = A2(
			_elm_lang$http$Http$stringBody,
			'application/x-www-form-urlencoded',
			A2(
				_elm_lang$core$Basics_ops['++'],
				'username=',
				A2(
					_elm_lang$core$Basics_ops['++'],
					state.username,
					A2(_elm_lang$core$Basics_ops['++'], '&password=', state.password))));
		return A2(
			_elm_lang$http$Http$send,
			function (_p2) {
				return msgFromAuth(
					_user$project$Auth$AuthReqReceived(_p2));
			},
			A3(_elm_lang$http$Http$post, state.loginUrl, body, _user$project$Auth$tokenDecoder));
	});
var _user$project$Auth$LoginClicked = {ctor: 'LoginClicked'};
var _user$project$Auth$PwdChanged = function (a) {
	return {ctor: 'PwdChanged', _0: a};
};
var _user$project$Auth$NameChanged = function (a) {
	return {ctor: 'NameChanged', _0: a};
};
var _user$project$Auth$view = F3(
	function (msgFromAuth, state, toUiTxt) {
		var infomsgcol = _elm_lang$core$Native_Utils.eq(state.infoMsg, 'auth_login_ok') ? 'green' : 'red';
		return {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$form,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('form-group row'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('col-lg-8 ml-auto'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'color', _1: infomsgcol},
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(
												toUiTxt(state.infoMsg)),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form-group row'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$label,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$for('auth-usrfield'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('col-lg-4 col-form-label'),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(
											toUiTxt('auth_form_usr')),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('col-lg-8'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$input,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_('text'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id('auth-usrfield'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('form-control'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onInput(
																	function (_p3) {
																		return msgFromAuth(
																			_user$project$Auth$NameChanged(_p3));
																	}),
																_1: {ctor: '[]'}
															}
														}
													}
												},
												{ctor: '[]'}),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('form-group row'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$label,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$for('pwdfield'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('col-lg-4 col-form-label'),
												_1: {ctor: '[]'}
											}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(
												toUiTxt('auth_form_pwd')),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('col-lg-8'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$input,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$type_('password'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$id('pwdfield'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('form-control'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Events$onInput(
																		function (_p4) {
																			return msgFromAuth(
																				_user$project$Auth$PwdChanged(_p4));
																		}),
																	_1: {ctor: '[]'}
																}
															}
														}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('form-group row'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('col-lg-8 ml-auto'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$button,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$type_('submit'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('btn btn-primary'),
															_1: {
																ctor: '::',
																_0: A3(
																	_elm_lang$html$Html_Events$onWithOptions,
																	'click',
																	{preventDefault: true, stopPropagation: true},
																	_elm_lang$core$Json_Decode$succeed(
																		msgFromAuth(_user$project$Auth$LoginClicked))),
																_1: {ctor: '[]'}
															}
														}
													},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text(
															toUiTxt('auth_log_bttn')),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}
					}
				}),
			_1: {ctor: '[]'}
		};
	});
var _user$project$Auth$AuthSucceeded = F2(
	function (a, b) {
		return {ctor: 'AuthSucceeded', _0: a, _1: b};
	});
var _user$project$Auth$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Auth$update = F3(
	function (msg, msgFromAuth, state) {
		var _p5 = msg;
		switch (_p5.ctor) {
			case 'NameChanged':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{username: _p5._0}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Auth$NoOutMsg
				};
			case 'PwdChanged':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{password: _p5._0}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Auth$NoOutMsg
				};
			case 'LoginClicked':
				return (_elm_lang$core$Native_Utils.eq(state.username, '') || _elm_lang$core$Native_Utils.eq(state.password, '')) ? {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{infoMsg: 'auth_missing_usrpwd'}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Auth$NoOutMsg
				} : {
					ctor: '_Tuple3',
					_0: state,
					_1: A2(_user$project$Auth$sendAuth, msgFromAuth, state),
					_2: _user$project$Auth$NoOutMsg
				};
			default:
				if (_p5._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							state,
							{infoMsg: 'auth_login_ok'}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: A2(_user$project$Auth$AuthSucceeded, state.username, _p5._0._0)
					};
				} else {
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							state,
							{
								infoMsg: _user$project$Auth$httpErrorString(_p5._0._0)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Auth$NoOutMsg
					};
				}
		}
	});

var _user$project$Data_Contact$encoder = function (contact) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'firstname',
				_1: _elm_lang$core$Json_Encode$string(contact.firstname)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'lastname',
					_1: _elm_lang$core$Json_Encode$string(contact.lastname)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'unit',
						_1: _elm_lang$core$Json_Encode$string(contact.unit)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'mail',
							_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, contact.mail)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'phone',
								_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, contact.phone)
							},
							_1: {ctor: '[]'}
						}
					}
				}
			}
		});
};
var _user$project$Data_Contact$Contact = F6(
	function (a, b, c, d, e, f) {
		return {id: a, firstname: b, lastname: c, unit: d, mail: e, phone: f};
	});
var _user$project$Data_Contact$decoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					A2(
						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
						_elm_lang$core$Json_Decode$succeed(_user$project$Data_Contact$Contact),
						_elm_lang$core$Json_Decode$maybe(
							A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int))),
					A2(_elm_lang$core$Json_Decode$field, 'firstname', _elm_lang$core$Json_Decode$string)),
				A2(_elm_lang$core$Json_Decode$field, 'lastname', _elm_lang$core$Json_Decode$string)),
			A2(_elm_lang$core$Json_Decode$field, 'unit', _elm_lang$core$Json_Decode$string)),
		_elm_lang$core$Json_Decode$maybe(
			A2(_elm_lang$core$Json_Decode$field, 'mail', _elm_lang$core$Json_Decode$string))),
	_elm_lang$core$Json_Decode$maybe(
		A2(_elm_lang$core$Json_Decode$field, 'phone', _elm_lang$core$Json_Decode$string)));

var _user$project$Data_Document$docEncode = function (document) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'content_type',
				_1: _elm_lang$core$Json_Encode$string(document.contentType)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'name',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, document.name)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'description',
						_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, document.description)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'date',
							_1: A2(
								_elm_community$json_extra$Json_Encode_Extra$maybe,
								_elm_lang$core$Json_Encode$string,
								A2(_elm_lang$core$Maybe$map, _justinmimbs$elm_date_extra$Date_Extra$toIsoString, document.date))
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'author',
								_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, document.author)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'filename',
									_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, document.filename)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'file',
										_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, document.file)
									},
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}
		});
};
var _user$project$Data_Document$contentTypeOther = 'data_document_dcontent_other';
var _user$project$Data_Document$contentTypeVideo = 'data_document_dcontent_video';
var _user$project$Data_Document$contentTypeImage = 'data_document_dcontent_image';
var _user$project$Data_Document$contentTypePlan = 'data_document_dcontent_plan';
var _user$project$Data_Document$contentTypeLog = 'data_document_dcontent_log';
var _user$project$Data_Document$contentTypeData = 'data_document_dcontent_data';
var _user$project$Data_Document$contentTypeText = 'data_document_dcontent_text';
var _user$project$Data_Document$contentTypeOptions = {
	ctor: '::',
	_0: _user$project$Data_Document$contentTypeText,
	_1: {
		ctor: '::',
		_0: _user$project$Data_Document$contentTypeData,
		_1: {
			ctor: '::',
			_0: _user$project$Data_Document$contentTypeLog,
			_1: {
				ctor: '::',
				_0: _user$project$Data_Document$contentTypePlan,
				_1: {
					ctor: '::',
					_0: _user$project$Data_Document$contentTypeImage,
					_1: {
						ctor: '::',
						_0: _user$project$Data_Document$contentTypeVideo,
						_1: {
							ctor: '::',
							_0: _user$project$Data_Document$contentTypeOther,
							_1: {ctor: '[]'}
						}
					}
				}
			}
		}
	}
};
var _user$project$Data_Document$docNew = {id: _elm_lang$core$Maybe$Nothing, contentType: 'gen_undefined', name: _elm_lang$core$Maybe$Nothing, description: _elm_lang$core$Maybe$Nothing, date: _elm_lang$core$Maybe$Nothing, author: _elm_lang$core$Maybe$Nothing, filename: _elm_lang$core$Maybe$Nothing, file: _elm_lang$core$Maybe$Nothing};
var _user$project$Data_Document$Document = F8(
	function (a, b, c, d, e, f, g, h) {
		return {id: a, contentType: b, name: c, description: d, date: e, author: f, filename: g, file: h};
	});
var _user$project$Data_Document$docDecoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					A2(
						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
						A2(
							_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
							A2(
								_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
								_elm_lang$core$Json_Decode$succeed(_user$project$Data_Document$Document),
								_elm_lang$core$Json_Decode$maybe(
									A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int))),
							A2(_elm_lang$core$Json_Decode$field, 'content_type', _elm_lang$core$Json_Decode$string)),
						_elm_lang$core$Json_Decode$maybe(
							A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string))),
					_elm_lang$core$Json_Decode$maybe(
						A2(_elm_lang$core$Json_Decode$field, 'description', _elm_lang$core$Json_Decode$string))),
				A2(
					_elm_lang$core$Json_Decode$andThen,
					function (_p0) {
						return _elm_lang$core$Json_Decode$maybe(
							_elm_community$json_extra$Json_Decode_Extra$fromResult(
								_elm_lang$core$Date$fromString(
									A2(_elm_lang$core$Maybe$withDefault, '', _p0))));
					},
					_elm_lang$core$Json_Decode$maybe(
						A2(_elm_lang$core$Json_Decode$field, 'date', _elm_lang$core$Json_Decode$string)))),
			_elm_lang$core$Json_Decode$maybe(
				A2(_elm_lang$core$Json_Decode$field, 'author', _elm_lang$core$Json_Decode$string))),
		_elm_lang$core$Json_Decode$maybe(
			A2(_elm_lang$core$Json_Decode$field, 'filename', _elm_lang$core$Json_Decode$string))),
	_elm_lang$core$Json_Decode$maybe(
		A2(_elm_lang$core$Json_Decode$field, 'file', _elm_lang$core$Json_Decode$string)));

var _user$project$Map_Data_GeoJSON$coordinatesPointEncoder = function (point) {
	return _elm_lang$core$Json_Encode$list(
		A2(
			_elm_lang$core$List$map,
			function (coord) {
				return _elm_lang$core$Json_Encode$float(coord);
			},
			point));
};
var _user$project$Map_Data_GeoJSON$coordinatesPolylineEncoder = function (polyline) {
	return _elm_lang$core$Json_Encode$list(
		A2(
			_elm_lang$core$List$map,
			function (point) {
				return _user$project$Map_Data_GeoJSON$coordinatesPointEncoder(point);
			},
			polyline));
};
var _user$project$Map_Data_GeoJSON$coordinatesMultiPolylineEncoder = function (multiPolyline) {
	return _elm_lang$core$Json_Encode$list(
		A2(
			_elm_lang$core$List$map,
			function (polyline) {
				return _user$project$Map_Data_GeoJSON$coordinatesPolylineEncoder(polyline);
			},
			multiPolyline));
};
var _user$project$Map_Data_GeoJSON$propertiesEncoder = function (properties) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'name',
				_1: _elm_lang$core$Json_Encode$string(properties.name)
			},
			_1: {ctor: '[]'}
		});
};
var _user$project$Map_Data_GeoJSON$crsEncoder = function (crs) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: _elm_lang$core$Json_Encode$string(crs.cType)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'properties',
					_1: _user$project$Map_Data_GeoJSON$propertiesEncoder(crs.properties)
				},
				_1: {ctor: '[]'}
			}
		});
};
var _user$project$Map_Data_GeoJSON$polylineEncoder = function (polyline) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, polyline.gType)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'crs',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$Map_Data_GeoJSON$crsEncoder, polyline.crs)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'coordinates',
						_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$Map_Data_GeoJSON$coordinatesPolylineEncoder, polyline.coordinates)
					},
					_1: {ctor: '[]'}
				}
			}
		});
};
var _user$project$Map_Data_GeoJSON$multiPolylineEncoder = function (multiPolyline) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, multiPolyline.gType)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'crs',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$Map_Data_GeoJSON$crsEncoder, multiPolyline.crs)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'coordinates',
						_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$Map_Data_GeoJSON$coordinatesMultiPolylineEncoder, multiPolyline.coordinates)
					},
					_1: {ctor: '[]'}
				}
			}
		});
};
var _user$project$Map_Data_GeoJSON$pointEncoder = function (point) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, point.gType)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'crs',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$Map_Data_GeoJSON$crsEncoder, point.crs)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'coordinates',
						_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$Map_Data_GeoJSON$coordinatesPointEncoder, point.coordinates)
					},
					_1: {ctor: '[]'}
				}
			}
		});
};
var _user$project$Map_Data_GeoJSON$getCrs = function (epsg) {
	return {
		cType: 'name',
		properties: {
			name: _elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'EPSG:',
					_1: {
						ctor: '::',
						_0: epsg,
						_1: {ctor: '[]'}
					}
				})
		}
	};
};
var _user$project$Map_Data_GeoJSON$getPolylineType = 'LineString';
var _user$project$Map_Data_GeoJSON$getPointType = 'Point';
var _user$project$Map_Data_GeoJSON$Properties = function (a) {
	return {name: a};
};
var _user$project$Map_Data_GeoJSON$propertiesDecoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_GeoJSON$Properties),
	A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string));
var _user$project$Map_Data_GeoJSON$Crs = F2(
	function (a, b) {
		return {cType: a, properties: b};
	});
var _user$project$Map_Data_GeoJSON$crsDecoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_GeoJSON$Crs),
		A2(_elm_lang$core$Json_Decode$field, 'type', _elm_lang$core$Json_Decode$string)),
	A2(_elm_lang$core$Json_Decode$field, 'properties', _user$project$Map_Data_GeoJSON$propertiesDecoder));
var _user$project$Map_Data_GeoJSON$PolygonData = F3(
	function (a, b, c) {
		return {gType: a, crs: b, coordinates: c};
	});
var _user$project$Map_Data_GeoJSON$polygonDecoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_GeoJSON$PolygonData),
			_elm_lang$core$Json_Decode$maybe(
				A2(_elm_lang$core$Json_Decode$field, 'type', _elm_lang$core$Json_Decode$string))),
		_elm_lang$core$Json_Decode$maybe(
			A2(_elm_lang$core$Json_Decode$field, 'crs', _user$project$Map_Data_GeoJSON$crsDecoder))),
	_elm_lang$core$Json_Decode$maybe(
		A2(
			_elm_lang$core$Json_Decode$field,
			'coordinates',
			_elm_lang$core$Json_Decode$list(
				_elm_lang$core$Json_Decode$list(
					_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$float))))));
var _user$project$Map_Data_GeoJSON$MultiPolylineData = F3(
	function (a, b, c) {
		return {gType: a, crs: b, coordinates: c};
	});
var _user$project$Map_Data_GeoJSON$multiPolylineDecoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_GeoJSON$MultiPolylineData),
			_elm_lang$core$Json_Decode$maybe(
				A2(_elm_lang$core$Json_Decode$field, 'type', _elm_lang$core$Json_Decode$string))),
		_elm_lang$core$Json_Decode$maybe(
			A2(_elm_lang$core$Json_Decode$field, 'crs', _user$project$Map_Data_GeoJSON$crsDecoder))),
	_elm_lang$core$Json_Decode$maybe(
		A2(
			_elm_lang$core$Json_Decode$field,
			'coordinates',
			_elm_lang$core$Json_Decode$list(
				_elm_lang$core$Json_Decode$list(
					_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$float))))));
var _user$project$Map_Data_GeoJSON$PolylineData = F3(
	function (a, b, c) {
		return {gType: a, crs: b, coordinates: c};
	});
var _user$project$Map_Data_GeoJSON$polylineDecoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_GeoJSON$PolylineData),
			_elm_lang$core$Json_Decode$maybe(
				A2(_elm_lang$core$Json_Decode$field, 'type', _elm_lang$core$Json_Decode$string))),
		_elm_lang$core$Json_Decode$maybe(
			A2(_elm_lang$core$Json_Decode$field, 'crs', _user$project$Map_Data_GeoJSON$crsDecoder))),
	_elm_lang$core$Json_Decode$maybe(
		A2(
			_elm_lang$core$Json_Decode$field,
			'coordinates',
			_elm_lang$core$Json_Decode$list(
				_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$float)))));
var _user$project$Map_Data_GeoJSON$PointData = F3(
	function (a, b, c) {
		return {gType: a, crs: b, coordinates: c};
	});
var _user$project$Map_Data_GeoJSON$pointDecoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_GeoJSON$PointData),
			_elm_lang$core$Json_Decode$maybe(
				A2(_elm_lang$core$Json_Decode$field, 'type', _elm_lang$core$Json_Decode$string))),
		_elm_lang$core$Json_Decode$maybe(
			A2(_elm_lang$core$Json_Decode$field, 'crs', _user$project$Map_Data_GeoJSON$crsDecoder))),
	_elm_lang$core$Json_Decode$maybe(
		A2(
			_elm_lang$core$Json_Decode$field,
			'coordinates',
			_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$float))));
var _user$project$Map_Data_GeoJSON$MultiPolyline = {ctor: 'MultiPolyline'};
var _user$project$Map_Data_GeoJSON$Polygon = {ctor: 'Polygon'};
var _user$project$Map_Data_GeoJSON$Polyline = {ctor: 'Polyline'};
var _user$project$Map_Data_GeoJSON$Point = {ctor: 'Point'};

var _user$project$Data_GenVector$SvsTree = F8(
	function (a, b, c, d, e, f, g, h) {
		return {id: a, latinName: b, commonName: c, name: d, place: e, circumference: f, height: g, age: h};
	});
var _user$project$Data_GenVector$svsTreeDecoder = A9(
	_elm_lang$core$Json_Decode$map8,
	_user$project$Data_GenVector$SvsTree,
	A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'properties',
			_1: {
				ctor: '::',
				_0: 'Numéro',
				_1: {ctor: '[]'}
			}
		},
		_elm_lang$core$Json_Decode$float),
	A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'properties',
			_1: {
				ctor: '::',
				_0: 'Genre',
				_1: {ctor: '[]'}
			}
		},
		_elm_lang$core$Json_Decode$string),
	A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'properties',
			_1: {
				ctor: '::',
				_0: 'Nom commun',
				_1: {ctor: '[]'}
			}
		},
		_elm_lang$core$Json_Decode$string),
	A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'properties',
			_1: {
				ctor: '::',
				_0: 'Appelation',
				_1: {ctor: '[]'}
			}
		},
		_elm_lang$core$Json_Decode$string),
	A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'properties',
			_1: {
				ctor: '::',
				_0: 'Lieu-dit',
				_1: {ctor: '[]'}
			}
		},
		_elm_lang$core$Json_Decode$string),
	A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'properties',
			_1: {
				ctor: '::',
				_0: 'Circonférence (cm)',
				_1: {ctor: '[]'}
			}
		},
		_elm_lang$core$Json_Decode$string),
	_elm_lang$core$Json_Decode$maybe(
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'properties',
				_1: {
					ctor: '::',
					_0: 'Hauteur (m)',
					_1: {ctor: '[]'}
				}
			},
			_elm_lang$core$Json_Decode$int)),
	_elm_lang$core$Json_Decode$maybe(
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'properties',
				_1: {
					ctor: '::',
					_0: 'Âge (années)',
					_1: {ctor: '[]'}
				}
			},
			_elm_lang$core$Json_Decode$int)));

var _user$project$Data_Place$Place = F5(
	function (a, b, c, d, e) {
		return {id: a, bfs_nummer: b, bezirksnummer: c, kantonsnummer: d, name: e};
	});
var _user$project$Data_Place$decoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					_elm_lang$core$Json_Decode$succeed(_user$project$Data_Place$Place),
					A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int)),
				A2(_elm_lang$core$Json_Decode$field, 'bfs_nummer', _elm_lang$core$Json_Decode$int)),
			A2(_elm_lang$core$Json_Decode$field, 'bezirksnummer', _elm_lang$core$Json_Decode$int)),
		A2(_elm_lang$core$Json_Decode$field, 'kantonsnummer', _elm_lang$core$Json_Decode$int)),
	A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string));

var _user$project$Helpers_Data_JwtToken$addAuthHeader = F2(
	function (headers, mayToken) {
		var _p0 = mayToken;
		if (_p0.ctor === 'Nothing') {
			return headers;
		} else {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$http$Http$header,
					'Authorization',
					A2(_elm_lang$core$Basics_ops['++'], 'Bearer ', _p0._0._0)),
				_1: headers
			};
		}
	});
var _user$project$Helpers_Data_JwtToken$getClaim = function (mayToken) {
	var _p1 = mayToken;
	if (_p1.ctor === 'Nothing') {
		return _elm_lang$core$Json_Encode$null;
	} else {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			_elm_lang$core$Json_Encode$null,
			_elm_lang$core$Result$toMaybe(
				A2(_simonh1000$elm_jwt$Jwt$decodeToken, _elm_lang$core$Json_Decode$value, _p1._0._0)));
	}
};
var _user$project$Helpers_Data_JwtToken$checkToken = F3(
	function (_p2, checkUrl, callback) {
		var _p3 = _p2;
		return A2(
			_simonh1000$elm_jwt$Jwt$send,
			function (_p4) {
				return callback(
					function (mayval) {
						var _p5 = mayval;
						if (_p5.ctor === 'Nothing') {
							return false;
						} else {
							return true;
						}
					}(
						_elm_lang$core$Result$toMaybe(_p4)));
			},
			A3(_simonh1000$elm_jwt$Jwt$get, _p3._0, checkUrl, _elm_lang$core$Json_Decode$value));
	});
var _user$project$Helpers_Data_JwtToken$toString = function (mayToken) {
	return A2(
		_elm_lang$core$Maybe$map,
		function (_p6) {
			var _p7 = _p6;
			return _p7._0;
		},
		mayToken);
};
var _user$project$Helpers_Data_JwtToken$JwtToken = function (a) {
	return {ctor: 'JwtToken', _0: a};
};
var _user$project$Helpers_Data_JwtToken$fromString = function (tokenStr) {
	return _elm_lang$core$Maybe$Just(
		_user$project$Helpers_Data_JwtToken$JwtToken(tokenStr));
};

var _user$project$Helpers_Data_User$encodeRoleData = function (roleData) {
	var _p0 = roleData;
	if (_p0.ctor === 'JustYes') {
		return _elm_lang$core$Json_Encode$bool(true);
	} else {
		var _p1 = _p0._0;
		if (_p1.ctor === 'Nothing') {
			return _elm_lang$core$Json_Encode$null;
		} else {
			return _elm_lang$core$Json_Encode$object(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'geometry', _1: _p1._0},
					_1: {ctor: '[]'}
				});
		}
	}
};
var _user$project$Helpers_Data_User$encode = F2(
	function (roleToString, user) {
		var toMayEncodedRole = function (_p2) {
			var _p3 = _p2;
			var _p4 = roleToString(_p3._0);
			if (_p4.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					{
						ctor: '_Tuple2',
						_0: _p4._0,
						_1: _user$project$Helpers_Data_User$encodeRoleData(_p3._1)
					});
			}
		};
		var baseEncodedList = {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'username',
				_1: _elm_lang$core$Json_Encode$string(user.username)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'roles',
					_1: _elm_lang$core$Json_Encode$object(
						A2(_elm_lang$core$List$filterMap, toMayEncodedRole, user.roleObjs))
				},
				_1: {ctor: '[]'}
			}
		};
		var encodedList = function () {
			var _p5 = user.newPassword;
			if (_p5.ctor === 'Nothing') {
				return baseEncodedList;
			} else {
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'password',
						_1: _elm_lang$core$Json_Encode$string(_p5._0)
					},
					_1: baseEncodedList
				};
			}
		}();
		return _elm_lang$core$Json_Encode$object(encodedList);
	});
var _user$project$Helpers_Data_User$User = F4(
	function (a, b, c, d) {
		return {id: a, username: b, newPassword: c, roleObjs: d};
	});
var _user$project$Helpers_Data_User$Geometry = function (a) {
	return {ctor: 'Geometry', _0: a};
};
var _user$project$Helpers_Data_User$JustYes = {ctor: 'JustYes'};
var _user$project$Helpers_Data_User$roleDataDecoder = _elm_lang$core$Json_Decode$oneOf(
	{
		ctor: '::',
		_0: A2(
			_elm_lang$core$Json_Decode$andThen,
			function (yes) {
				return yes ? _elm_lang$core$Json_Decode$succeed(_user$project$Helpers_Data_User$JustYes) : _elm_lang$core$Json_Decode$fail('Not a bool or No');
			},
			_elm_lang$core$Json_Decode$bool),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$core$Json_Decode$map,
				_user$project$Helpers_Data_User$Geometry,
				_elm_lang$core$Json_Decode$maybe(
					A2(_elm_lang$core$Json_Decode$field, 'geometry', _elm_lang$core$Json_Decode$value))),
			_1: {ctor: '[]'}
		}
	});
var _user$project$Helpers_Data_User$rolesDataDecoder = function (toRole) {
	var toMayRoleRoleData = function (_p6) {
		var _p7 = _p6;
		var _p8 = toRole(_p7._0);
		if (_p8.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			return _elm_lang$core$Maybe$Just(
				{ctor: '_Tuple2', _0: _p8._0, _1: _p7._1});
		}
	};
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (_p9) {
			return _elm_lang$core$Json_Decode$succeed(
				A2(
					_elm_lang$core$Maybe$withDefault,
					{ctor: '[]'},
					_p9));
		},
		_elm_lang$core$Json_Decode$maybe(
			A2(
				_elm_lang$core$Json_Decode$field,
				'roles',
				A2(
					_elm_lang$core$Json_Decode$map,
					_elm_lang$core$List$filterMap(toMayRoleRoleData),
					_elm_lang$core$Json_Decode$keyValuePairs(_user$project$Helpers_Data_User$roleDataDecoder)))));
};
var _user$project$Helpers_Data_User$decoder = function (toRole) {
	return A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					_elm_lang$core$Json_Decode$succeed(_user$project$Helpers_Data_User$User),
					_elm_lang$core$Json_Decode$maybe(
						A2(_elm_lang$core$Json_Decode$field, '_id', _elm_lang$core$Json_Decode$string))),
				A2(_elm_lang$core$Json_Decode$field, 'username', _elm_lang$core$Json_Decode$string)),
			_elm_lang$core$Json_Decode$succeed(_elm_lang$core$Maybe$Nothing)),
		_user$project$Helpers_Data_User$rolesDataDecoder(toRole));
};

var _user$project$Helpers_Data_Language$langToString = function (lang) {
	var _p0 = lang;
	switch (_p0.ctor) {
		case 'EN':
			return 'EN';
		case 'FR':
			return 'FR';
		case 'DE':
			return 'DE';
		default:
			return 'IT';
	}
};
var _user$project$Helpers_Data_Language$getTxt = F3(
	function (_p1, lang, key) {
		var _p2 = _p1;
		if (_elm_lang$core$Native_Utils.eq(key, '')) {
			return '';
		} else {
			var langtxtDict = A2(_elm_lang$core$Dict$get, key, _p2._0);
			var _p3 = langtxtDict;
			if (_p3.ctor === 'Nothing') {
				return A2(_elm_lang$core$Basics_ops['++'], 'Error: missing key ', key);
			} else {
				var langStr = _user$project$Helpers_Data_Language$langToString(lang);
				var maytxt = A2(_elm_lang$core$Dict$get, langStr, _p3._0);
				var _p4 = maytxt;
				if (_p4.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Basics_ops['++'],
						'Error: missing language ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							langStr,
							A2(_elm_lang$core$Basics_ops['++'], ' for key ', key)));
				} else {
					return _p4._0;
				}
			}
		}
	});
var _user$project$Helpers_Data_Language$IT = {ctor: 'IT'};
var _user$project$Helpers_Data_Language$DE = {ctor: 'DE'};
var _user$project$Helpers_Data_Language$FR = {ctor: 'FR'};
var _user$project$Helpers_Data_Language$EN = {ctor: 'EN'};
var _user$project$Helpers_Data_Language$fromStringWithDefault = F2(
	function (defLang, langStr) {
		var _p5 = langStr;
		switch (_p5) {
			case 'EN':
				return _user$project$Helpers_Data_Language$EN;
			case 'FR':
				return _user$project$Helpers_Data_Language$FR;
			case 'DE':
				return _user$project$Helpers_Data_Language$DE;
			case 'IT':
				return _user$project$Helpers_Data_Language$IT;
			default:
				return defLang;
		}
	});
var _user$project$Helpers_Data_Language$LanguageDict = function (a) {
	return {ctor: 'LanguageDict', _0: a};
};
var _user$project$Helpers_Data_Language$dictFromKeyVals = function (keyVals) {
	return _user$project$Helpers_Data_Language$LanguageDict(
		_elm_lang$core$Dict$fromList(
			A2(
				_elm_lang$core$List$map,
				function (_p6) {
					var _p7 = _p6;
					return {
						ctor: '_Tuple2',
						_0: _p7._0,
						_1: _elm_lang$core$Dict$fromList(_p7._1)
					};
				},
				keyVals)));
};

var _user$project$Map_Data_Utils$getNormalizedValue = function (value) {
	return (_elm_lang$core$Native_Utils.cmp(value, 1.0) > 0) ? (1.0 / value) : value;
};
var _user$project$Map_Data_Utils$getResolutionFromScale = function (scale) {
	var dotsPerInch = 72;
	var inchesPerMeters = 39.3701;
	var normalizedScale = _user$project$Map_Data_Utils$getNormalizedValue(scale);
	return 1 / ((normalizedScale * inchesPerMeters) * dotsPerInch);
};
var _user$project$Map_Data_Utils$isValueBetweenMinMax = F3(
	function (value, min, max) {
		return (_elm_lang$core$Native_Utils.cmp(value, min) > -1) && (_elm_lang$core$Native_Utils.cmp(value, max) < 1);
	});
var _user$project$Map_Data_Utils$isPointInExtent = F2(
	function (point, extent) {
		return ((_elm_lang$core$Native_Utils.cmp(point.x, extent.minx) > -1) && (_elm_lang$core$Native_Utils.cmp(point.x, extent.maxx) < 1)) && ((_elm_lang$core$Native_Utils.cmp(point.y, extent.miny) > -1) && (_elm_lang$core$Native_Utils.cmp(point.y, extent.maxy) < 1));
	});
var _user$project$Map_Data_Utils$Point = F2(
	function (a, b) {
		return {x: a, y: b};
	});
var _user$project$Map_Data_Utils$Extent = F4(
	function (a, b, c, d) {
		return {minx: a, miny: b, maxx: c, maxy: d};
	});

var _user$project$Map_Data_Geolocation$Errored = F2(
	function (a, b) {
		return {ctor: 'Errored', _0: a, _1: b};
	});
var _user$project$Map_Data_Geolocation$Disabled = function (a) {
	return {ctor: 'Disabled', _0: a};
};
var _user$project$Map_Data_Geolocation$Enabled = F2(
	function (a, b) {
		return {ctor: 'Enabled', _0: a, _1: b};
	});

var _user$project$Map_Data_Ports$MapData = F4(
	function (a, b, c, d) {
		return {map: a, extent: b, resolution: c, clickPixelPos: d};
	});
var _user$project$Map_Data_Ports$MapClickData = F4(
	function (a, b, c, d) {
		return {isUpdate: a, coordinate: b, pixelPos: c, featuresData: d};
	});
var _user$project$Map_Data_Ports$CoordInZonesData = F2(
	function (a, b) {
		return {mapClickData: a, namedGeoZones: b};
	});
var _user$project$Map_Data_Ports$LegendData = F2(
	function (a, b) {
		return {layerKey: a, legend: b};
	});
var _user$project$Map_Data_Ports$FeatureData = F5(
	function (a, b, c, d, e) {
		return {layerKey: a, id: b, data: c, rootId: d, rootData: e};
	});
var _user$project$Map_Data_Ports$LayerFeaturesData = F2(
	function (a, b) {
		return {layerKey: a, features: b};
	});
var _user$project$Map_Data_Ports$GeomData = F2(
	function (a, b) {
		return {layerKey: a, geom: b};
	});
var _user$project$Map_Data_Ports$GeoObjData = F3(
	function (a, b, c) {
		return {id: a, obj: b, layerKey: c};
	});
var _user$project$Map_Data_Ports$LayerNewFeatures = F2(
	function (a, b) {
		return {layerKey: a, features: b};
	});
var _user$project$Map_Data_Ports$CurPosData = F5(
	function (a, b, c, d, e) {
		return {x: a, y: b, z: c, xyAccuracy: d, zAccuracy: e};
	});
var _user$project$Map_Data_Ports$PtAtCurPosData = F2(
	function (a, b) {
		return {geomData: a, curPosData: b};
	});
var _user$project$Map_Data_Ports$CaptureCanvasData = F2(
	function (a, b) {
		return {image: a, canvasDimensions: b};
	});

var _user$project$Map_Data_Mode_Op_Select$getUniqueLayerKey = function (select) {
	return _elm_lang$core$List$head(select.layerKeys);
};
var _user$project$Map_Data_Mode_Op_Select$noEndFromGeoObjs = function (layerKeys) {
	return {
		layerKeys: layerKeys,
		min: _elm_lang$core$Random$maxInt,
		max: _elm_lang$core$Random$maxInt,
		selected: {ctor: '[]'},
		geoZone: _elm_lang$core$Maybe$Nothing,
		onlyMulti: false,
		error: _elm_lang$core$Maybe$Nothing
	};
};
var _user$project$Map_Data_Mode_Op_Select$fromAllParams = F5(
	function (layerKeys, min, max, geoZone, onlyMulti) {
		return {
			layerKeys: layerKeys,
			min: min,
			max: max,
			selected: {ctor: '[]'},
			geoZone: geoZone,
			onlyMulti: onlyMulti,
			error: _elm_lang$core$Maybe$Nothing
		};
	});
var _user$project$Map_Data_Mode_Op_Select$fromLayerKeysZone = F2(
	function (layerKeys, geoZone) {
		return {
			layerKeys: layerKeys,
			min: 1,
			max: _elm_lang$core$Random$maxInt,
			selected: {ctor: '[]'},
			geoZone: geoZone,
			onlyMulti: false,
			error: _elm_lang$core$Maybe$Nothing
		};
	});
var _user$project$Map_Data_Mode_Op_Select$Select = F7(
	function (a, b, c, d, e, f, g) {
		return {layerKeys: a, min: b, max: c, selected: d, geoZone: e, onlyMulti: f, error: g};
	});

var _user$project$Map_Data_Mode_Op_Modify$fromLayerKeyZone = F2(
	function (layerKey, geoZone) {
		return {layerKey: layerKey, modified: _elm_lang$core$Dict$empty, geoZone: geoZone, error: _elm_lang$core$Maybe$Nothing};
	});
var _user$project$Map_Data_Mode_Op_Modify$Modify = F4(
	function (a, b, c, d) {
		return {layerKey: a, modified: b, geoZone: c, error: d};
	});

var _user$project$Map_Data_Mode_Op_Save$Done = function (a) {
	return {ctor: 'Done', _0: a};
};
var _user$project$Map_Data_Mode_Op_Save$Working = function (a) {
	return {ctor: 'Working', _0: a};
};
var _user$project$Map_Data_Mode_Op_Save$NotStarted = {ctor: 'NotStarted'};

var _user$project$Map_Data_Mode_Op_Draw$fromKeyTypeIdZone = F4(
	function (layerKey, shapeType, mayId, geoZone) {
		return {layerKey: layerKey, shapeType: shapeType, drawn: _elm_lang$core$Maybe$Nothing, id: mayId, geoZone: geoZone, error: _elm_lang$core$Maybe$Nothing};
	});
var _user$project$Map_Data_Mode_Op_Draw$Draw = F6(
	function (a, b, c, d, e, f) {
		return {layerKey: a, shapeType: b, drawn: c, id: d, geoZone: e, error: f};
	});

var _user$project$Map_Data_Mode_Op_Merge$fromKeyAndSel = F2(
	function (layerKey, selected) {
		return {layerKey: layerKey, selected: selected, merged: _elm_lang$core$Maybe$Nothing};
	});
var _user$project$Map_Data_Mode_Op_Merge$Merge = F3(
	function (a, b, c) {
		return {layerKey: a, selected: b, merged: c};
	});

var _user$project$Map_Data_Mode_Op_Split$fromKeySelAndLine = F3(
	function (layerKey, selected, lineGeom) {
		return {layerKey: layerKey, selected: selected, lineGeom: lineGeom, split: _elm_lang$core$Maybe$Nothing};
	});
var _user$project$Map_Data_Mode_Op_Split$Split = F4(
	function (a, b, c, d) {
		return {layerKey: a, selected: b, lineGeom: c, split: d};
	});

var _user$project$Map_Data_Mode_Op_Breakup$fromKeySel = F2(
	function (layerKey, selected) {
		return {layerKey: layerKey, selected: selected, breakup: _elm_lang$core$Maybe$Nothing};
	});
var _user$project$Map_Data_Mode_Op_Breakup$Breakup = F3(
	function (a, b, c) {
		return {layerKey: a, selected: b, breakup: c};
	});

var _user$project$Map_Data_Mode_Op_GetInSel$fromKeysAndGeoms = F2(
	function (layerKeys, sourceGeoms) {
		return {layerKeys: layerKeys, sourceGeoms: sourceGeoms, selected: _elm_lang$core$Maybe$Nothing};
	});
var _user$project$Map_Data_Mode_Op_GetInSel$GetInSel = F3(
	function (a, b, c) {
		return {layerKeys: a, sourceGeoms: b, selected: c};
	});

var _user$project$Map_Data_Mode_Op$SaveOp = function (a) {
	return {ctor: 'SaveOp', _0: a};
};
var _user$project$Map_Data_Mode_Op$GetInSelOp = function (a) {
	return {ctor: 'GetInSelOp', _0: a};
};
var _user$project$Map_Data_Mode_Op$BreakupOp = function (a) {
	return {ctor: 'BreakupOp', _0: a};
};
var _user$project$Map_Data_Mode_Op$SplitOp = function (a) {
	return {ctor: 'SplitOp', _0: a};
};
var _user$project$Map_Data_Mode_Op$MergeOp = function (a) {
	return {ctor: 'MergeOp', _0: a};
};
var _user$project$Map_Data_Mode_Op$ModifyOp = function (a) {
	return {ctor: 'ModifyOp', _0: a};
};
var _user$project$Map_Data_Mode_Op$DrawOp = function (a) {
	return {ctor: 'DrawOp', _0: a};
};
var _user$project$Map_Data_Mode_Op$SelectOp = function (a) {
	return {ctor: 'SelectOp', _0: a};
};

var _user$project$Map_Data_Mode_Op_DrawPtAtCurPos$fromKeyIdZone = F3(
	function (layerKey, mayId, geoZone) {
		return {layerKey: layerKey, ptAtCurPosData: _elm_lang$core$Maybe$Nothing, id: mayId, geoZone: geoZone, error: _elm_lang$core$Maybe$Nothing};
	});
var _user$project$Map_Data_Mode_Op_DrawPtAtCurPos$DrawPtAtCurPos = F5(
	function (a, b, c, d, e) {
		return {layerKey: a, ptAtCurPosData: b, id: c, geoZone: d, error: e};
	});

var _user$project$Map_Data_Mode_Op_Capture$Capture = F3(
	function (a, b, c) {
		return {image: a, canvasDimensions: b, error: c};
	});

var _user$project$Map_Data_Mode$CaptureCanvas = function (a) {
	return {ctor: 'CaptureCanvas', _0: a};
};
var _user$project$Map_Data_Mode$BreakupPolys = function (a) {
	return {ctor: 'BreakupPolys', _0: a};
};
var _user$project$Map_Data_Mode$MergePolys = function (a) {
	return {ctor: 'MergePolys', _0: a};
};
var _user$project$Map_Data_Mode$SplitPolys = F2(
	function (a, b) {
		return {ctor: 'SplitPolys', _0: a, _1: b};
	});
var _user$project$Map_Data_Mode$DeleteObjs = function (a) {
	return {ctor: 'DeleteObjs', _0: a};
};
var _user$project$Map_Data_Mode$ModifyGeoms = function (a) {
	return {ctor: 'ModifyGeoms', _0: a};
};
var _user$project$Map_Data_Mode$AddPointFromCurPos = F2(
	function (a, b) {
		return {ctor: 'AddPointFromCurPos', _0: a, _1: b};
	});
var _user$project$Map_Data_Mode$AddGeom = F2(
	function (a, b) {
		return {ctor: 'AddGeom', _0: a, _1: b};
	});
var _user$project$Map_Data_Mode$DrawSelect = F2(
	function (a, b) {
		return {ctor: 'DrawSelect', _0: a, _1: b};
	});
var _user$project$Map_Data_Mode$SelectObjs = F2(
	function (a, b) {
		return {ctor: 'SelectObjs', _0: a, _1: b};
	});
var _user$project$Map_Data_Mode$Wait = {ctor: 'Wait'};
var _user$project$Map_Data_Mode$NormalMode = {ctor: 'NormalMode'};
var _user$project$Map_Data_Mode$OpDone = {ctor: 'OpDone'};
var _user$project$Map_Data_Mode$Cancel = {ctor: 'Cancel'};
var _user$project$Map_Data_Mode$SaveOpReceived = function (a) {
	return {ctor: 'SaveOpReceived', _0: a};
};
var _user$project$Map_Data_Mode$CapturedCanvasReceived = function (a) {
	return {ctor: 'CapturedCanvasReceived', _0: a};
};
var _user$project$Map_Data_Mode$ModeErrorReceived = function (a) {
	return {ctor: 'ModeErrorReceived', _0: a};
};
var _user$project$Map_Data_Mode$GetInSelReceived = function (a) {
	return {ctor: 'GetInSelReceived', _0: a};
};
var _user$project$Map_Data_Mode$BreakupReceived = function (a) {
	return {ctor: 'BreakupReceived', _0: a};
};
var _user$project$Map_Data_Mode$SplitReceived = function (a) {
	return {ctor: 'SplitReceived', _0: a};
};
var _user$project$Map_Data_Mode$MergeReceived = function (a) {
	return {ctor: 'MergeReceived', _0: a};
};
var _user$project$Map_Data_Mode$ModifsUpdated = function (a) {
	return {ctor: 'ModifsUpdated', _0: a};
};
var _user$project$Map_Data_Mode$PtDrawnFromCurPos = function (a) {
	return {ctor: 'PtDrawnFromCurPos', _0: a};
};
var _user$project$Map_Data_Mode$GeomDrawn = function (a) {
	return {ctor: 'GeomDrawn', _0: a};
};
var _user$project$Map_Data_Mode$SelectionUpdated = function (a) {
	return {ctor: 'SelectionUpdated', _0: a};
};

var _user$project$Map_Data_Msg$RegisterCallbackOnCaptureCanvasEnded = function (a) {
	return {ctor: 'RegisterCallbackOnCaptureCanvasEnded', _0: a};
};
var _user$project$Map_Data_Msg$StartCaptureCanvasMode = {ctor: 'StartCaptureCanvasMode'};
var _user$project$Map_Data_Msg$RegisterCallbackOnSelectionEnded = F2(
	function (a, b) {
		return {ctor: 'RegisterCallbackOnSelectionEnded', _0: a, _1: b};
	});
var _user$project$Map_Data_Msg$StartSelectObjsModeMinMax = F5(
	function (a, b, c, d, e) {
		return {ctor: 'StartSelectObjsModeMinMax', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _user$project$Map_Data_Msg$ApiResponse = F3(
	function (a, b, c) {
		return {ctor: 'ApiResponse', _0: a, _1: b, _2: c};
	});
var _user$project$Map_Data_Msg$UpdateOpacity = F3(
	function (a, b, c) {
		return {ctor: 'UpdateOpacity', _0: a, _1: b, _2: c};
	});
var _user$project$Map_Data_Msg$GetVectorCompleted = F2(
	function (a, b) {
		return {ctor: 'GetVectorCompleted', _0: a, _1: b};
	});
var _user$project$Map_Data_Msg$UpdateVectorStyle = F2(
	function (a, b) {
		return {ctor: 'UpdateVectorStyle', _0: a, _1: b};
	});
var _user$project$Map_Data_Msg$UpdateVisibility = F2(
	function (a, b) {
		return {ctor: 'UpdateVisibility', _0: a, _1: b};
	});
var _user$project$Map_Data_Msg$ToggleSettings = function (a) {
	return {ctor: 'ToggleSettings', _0: a};
};
var _user$project$Map_Data_Msg$ToggleInfo = function (a) {
	return {ctor: 'ToggleInfo', _0: a};
};
var _user$project$Map_Data_Msg$ToggleGroup = function (a) {
	return {ctor: 'ToggleGroup', _0: a};
};
var _user$project$Map_Data_Msg$InitOpenLayerBtn = function (a) {
	return {ctor: 'InitOpenLayerBtn', _0: a};
};
var _user$project$Map_Data_Msg$ToggleLayerPanelContent = {ctor: 'ToggleLayerPanelContent'};
var _user$project$Map_Data_Msg$ToggleLayerPanel = {ctor: 'ToggleLayerPanel'};
var _user$project$Map_Data_Msg$ClosePopup = {ctor: 'ClosePopup'};
var _user$project$Map_Data_Msg$ModeEvent = function (a) {
	return {ctor: 'ModeEvent', _0: a};
};
var _user$project$Map_Data_Msg$LegendCreated = function (a) {
	return {ctor: 'LegendCreated', _0: a};
};
var _user$project$Map_Data_Msg$MapPointerMoved = function (a) {
	return {ctor: 'MapPointerMoved', _0: a};
};
var _user$project$Map_Data_Msg$CoordInZonesChecked = function (a) {
	return {ctor: 'CoordInZonesChecked', _0: a};
};
var _user$project$Map_Data_Msg$MapClickDataReceived = function (a) {
	return {ctor: 'MapClickDataReceived', _0: a};
};
var _user$project$Map_Data_Msg$MapMoved = function (a) {
	return {ctor: 'MapMoved', _0: a};
};
var _user$project$Map_Data_Msg$CurPosDataErrored = function (a) {
	return {ctor: 'CurPosDataErrored', _0: a};
};
var _user$project$Map_Data_Msg$CurPosDataReceived = function (a) {
	return {ctor: 'CurPosDataReceived', _0: a};
};
var _user$project$Map_Data_Msg$GeolocErrored = function (a) {
	return {ctor: 'GeolocErrored', _0: a};
};
var _user$project$Map_Data_Msg$UpdateGeolocation = function (a) {
	return {ctor: 'UpdateGeolocation', _0: a};
};
var _user$project$Map_Data_Msg$ToggleGoogleMap = {ctor: 'ToggleGoogleMap'};
var _user$project$Map_Data_Msg$MapCreated = function (a) {
	return {ctor: 'MapCreated', _0: a};
};
var _user$project$Map_Data_Msg$WindowResized = function (a) {
	return {ctor: 'WindowResized', _0: a};
};
var _user$project$Map_Data_Msg$Decrease = {ctor: 'Decrease'};
var _user$project$Map_Data_Msg$Increase = {ctor: 'Increase'};

var _user$project$Map_Data_UiBits$UiBits = F3(
	function (a, b, c) {
		return {bitToElem: a, strToElem: b, bits: c};
	});
var _user$project$Map_Data_UiBits$UiBitsContent = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return function (_4) {
																														return function (_5) {
																															return function (_6) {
																																return function (_7) {
																																	return function (_8) {
																																		return function (_9) {
																																			return function (_10) {
																																				return function (_11) {
																																					return function (_12) {
																																						return function (_13) {
																																							return function (_14) {
																																								return function (_15) {
																																									return function (_16) {
																																										return function (_17) {
																																											return function (_18) {
																																												return function (_19) {
																																													return function (_20) {
																																														return function (_21) {
																																															return function (_22) {
																																																return function (_23) {
																																																	return function (_24) {
																																																		return function (_25) {
																																																			return function (_26) {
																																																				return {normalModeBar: a, mode: b, modeError: c, selectionOutOfRange: d, selectionOk: e, modifNothing: f, modifOk: g, drawNothing: h, drawOk: i, drawPtAtCurPosWaiting: j, drawPtAtCurPosReceived: k, saveWorking: l, saveFailed: m, saveOk: n, mergeOk: o, mergeNotOk: p, splitOk: q, splitNotOk: r, breakupOk: s, breakupNotOk: t, labelOpacity: u, getInSelOk: v, getInSelNotOk: w, cancelButtonContent: x, nextButtonContent: y, saveButtonContent: z, doneButtonContent: _1, layersControlTitle: _2, openLayerPanelBtnContent: _3, closeLayerPanelBtnContent: _4, openLayerFileBtnContent: _5, closeBtnContent: _6, layerSettingsBtnContent: _7, plusBtnContent: _8, greyedPlusBtnContent: _9, minusBtnContent: _10, greyedMinusBtnContent: _11, moreBtnContent: _12, lessBtnContent: _13, moreInfoBtnContent: _14, lessInfoBtnContent: _15, layerGroupIcon: _16, vectorIcon: _17, rasterIcon: _18, legend: _19, geolocOngoing: _20, geolocStopped: _21, startGeolocBtnContent: _22, startGeolocWithBlinkBtnContent: _23, stopGeolocBtnContent: _24, toggleGoogleMapBtnContent: _25, toggleLayerPanelBtnContent: _26};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};

var _user$project$Map_Data_Styles$StylingData = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return function (_4) {
																														return function (_5) {
																															return function (_6) {
																																return function (_7) {
																																	return function (_8) {
																																		return function (_9) {
																																			return function (_10) {
																																				return function (_11) {
																																					return function (_12) {
																																						return function (_13) {
																																							return function (_14) {
																																								return function (_15) {
																																									return function (_16) {
																																										return {none: a, h1: b, label: c, checkbox: d, btn: e, plusBtn: f, greyedPlusBtn: g, minusBtn: h, greyedMinusBtn: i, groupBtn: j, infoBtn: k, layerSettingsBtn: l, geolocBtn: m, toggleGoogleMapBtn: n, layersToggleBtn: o, openFileBtn: p, cancelBtn: q, warningBtn: r, successBtn: s, btnImg: t, icon: u, popup: v, popupPointerBorder: w, popupPointer: x, mapCol: y, map: z, mapFooter: _1, success: _2, warning: _3, error: _4, layersCol: _5, layer: _6, layerData: _7, layerGroup: _8, rootLayerGroup: _9, layerGroupData: _10, layerGroupLayers: _11, legendCol: _12, legendDropDown: _13, legendElement: _14, submenu: _15, focused: _16};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Map_Data_Styles$Error = {ctor: 'Error'};
var _user$project$Map_Data_Styles$Warning = {ctor: 'Warning'};
var _user$project$Map_Data_Styles$Success = {ctor: 'Success'};
var _user$project$Map_Data_Styles$MapFooter = {ctor: 'MapFooter'};
var _user$project$Map_Data_Styles$Focused = {ctor: 'Focused'};
var _user$project$Map_Data_Styles$SubMenu = {ctor: 'SubMenu'};
var _user$project$Map_Data_Styles$LayerGroup = {ctor: 'LayerGroup'};
var _user$project$Map_Data_Styles$Layer = {ctor: 'Layer'};
var _user$project$Map_Data_Styles$PopupPointer = {ctor: 'PopupPointer'};
var _user$project$Map_Data_Styles$PopupPointerBorder = {ctor: 'PopupPointerBorder'};
var _user$project$Map_Data_Styles$Popup = {ctor: 'Popup'};
var _user$project$Map_Data_Styles$BtnImg = {ctor: 'BtnImg'};
var _user$project$Map_Data_Styles$SuccessBtn = {ctor: 'SuccessBtn'};
var _user$project$Map_Data_Styles$WarningBtn = {ctor: 'WarningBtn'};
var _user$project$Map_Data_Styles$CancelBtn = {ctor: 'CancelBtn'};
var _user$project$Map_Data_Styles$GreyBtn = {ctor: 'GreyBtn'};
var _user$project$Map_Data_Styles$TrspDisabledBtn = {ctor: 'TrspDisabledBtn'};
var _user$project$Map_Data_Styles$TrspNoHoverBtn = {ctor: 'TrspNoHoverBtn'};
var _user$project$Map_Data_Styles$TrspBtn = {ctor: 'TrspBtn'};
var _user$project$Map_Data_Styles$Btn = {ctor: 'Btn'};
var _user$project$Map_Data_Styles$Icon = {ctor: 'Icon'};
var _user$project$Map_Data_Styles$Checkbox = {ctor: 'Checkbox'};
var _user$project$Map_Data_Styles$Label = {ctor: 'Label'};
var _user$project$Map_Data_Styles$H1 = {ctor: 'H1'};
var _user$project$Map_Data_Styles$None = {ctor: 'None'};
var _user$project$Map_Data_Styles$list = {
	ctor: '::',
	_0: A2(
		_mdgriffith$style_elements$Style$style,
		_user$project$Map_Data_Styles$None,
		{ctor: '[]'}),
	_1: {
		ctor: '::',
		_0: A2(
			_mdgriffith$style_elements$Style$style,
			_user$project$Map_Data_Styles$Label,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Style_Font$bold,
				_1: {ctor: '[]'}
			}),
		_1: {
			ctor: '::',
			_0: A2(
				_mdgriffith$style_elements$Style$style,
				_user$project$Map_Data_Styles$H1,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkGrey),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Font$size(32),
						_1: {ctor: '[]'}
					}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Style$style,
					_user$project$Map_Data_Styles$Checkbox,
					{ctor: '[]'}),
				_1: {
					ctor: '::',
					_0: A2(
						_mdgriffith$style_elements$Style$style,
						_user$project$Map_Data_Styles$Icon,
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: A2(
							_mdgriffith$style_elements$Style$style,
							_user$project$Map_Data_Styles$Btn,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Style_Border$all(1),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Border$rounded(4),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$grey),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Style$hover(
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}
								}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Style$style,
								_user$project$Map_Data_Styles$TrspBtn,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Color$background(
										A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Style$hover(
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$grey),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_mdgriffith$style_elements$Style$style,
									_user$project$Map_Data_Styles$TrspNoHoverBtn,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Style_Color$background(
											A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0)),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_mdgriffith$style_elements$Style$style,
										_user$project$Map_Data_Styles$TrspDisabledBtn,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Style_Color$background(
												A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0)),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Style$hover(
													{ctor: '[]'}),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Style$cursor('not-allowed'),
													_1: {ctor: '[]'}
												}
											}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_mdgriffith$style_elements$Style$style,
											_user$project$Map_Data_Styles$GreyBtn,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Style$hover(
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$grey),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_mdgriffith$style_elements$Style$style,
												_user$project$Map_Data_Styles$CancelBtn,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$yellow),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Style_Border$rounded(12),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Style$hover(
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$darkYellow),
																	_1: {ctor: '[]'}
																}),
															_1: {ctor: '[]'}
														}
													}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_mdgriffith$style_elements$Style$style,
													_user$project$Map_Data_Styles$WarningBtn,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$orange),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Style_Border$rounded(12),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Style$hover(
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$darkOrange),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}
														}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_mdgriffith$style_elements$Style$style,
														_user$project$Map_Data_Styles$SuccessBtn,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGreen),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Style_Border$rounded(12),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Style$hover(
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$green),
																			_1: {ctor: '[]'}
																		}),
																	_1: {ctor: '[]'}
																}
															}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_mdgriffith$style_elements$Style$style,
															_user$project$Map_Data_Styles$BtnImg,
															{ctor: '[]'}),
														_1: {
															ctor: '::',
															_0: A2(
																_mdgriffith$style_elements$Style$style,
																_user$project$Map_Data_Styles$Popup,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$white),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$black),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Style_Border$all(1),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Style_Border$rounded(5),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A2(
																	_mdgriffith$style_elements$Style$style,
																	_user$project$Map_Data_Styles$PopupPointerBorder,
																	{
																		ctor: '::',
																		_0: A2(_mdgriffith$style_elements$Style$prop, 'border-bottom', '20px solid black'),
																		_1: {
																			ctor: '::',
																			_0: A2(_mdgriffith$style_elements$Style$prop, 'border-left', '10px solid transparent'),
																			_1: {
																				ctor: '::',
																				_0: A2(_mdgriffith$style_elements$Style$prop, 'border-right', '10px solid transparent'),
																				_1: {ctor: '[]'}
																			}
																		}
																	}),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_mdgriffith$style_elements$Style$style,
																		_user$project$Map_Data_Styles$PopupPointer,
																		{
																			ctor: '::',
																			_0: A2(_mdgriffith$style_elements$Style$prop, 'border-bottom', '18px solid white'),
																			_1: {
																				ctor: '::',
																				_0: A2(_mdgriffith$style_elements$Style$prop, 'border-left', '8px solid transparent'),
																				_1: {
																					ctor: '::',
																					_0: A2(_mdgriffith$style_elements$Style$prop, 'border-right', '8px solid transparent'),
																					_1: {ctor: '[]'}
																				}
																			}
																		}),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_mdgriffith$style_elements$Style$style,
																			_user$project$Map_Data_Styles$LayerGroup,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Style_Border$all(1),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Style_Border$rounded(4),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
																						_1: {ctor: '[]'}
																					}
																				}
																			}),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_mdgriffith$style_elements$Style$style,
																				_user$project$Map_Data_Styles$Layer,
																				{
																					ctor: '::',
																					_0: A2(_mdgriffith$style_elements$Style_Shadow$glow, _elm_lang$core$Color$grey, 2),
																					_1: {ctor: '[]'}
																				}),
																			_1: {
																				ctor: '::',
																				_0: A2(
																					_mdgriffith$style_elements$Style$style,
																					_user$project$Map_Data_Styles$SubMenu,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Style_Border$rounded(5),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Style_Border$all(2),
																							_1: {
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Style_Border$solid,
																								_1: {
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
																									_1: {ctor: '[]'}
																								}
																							}
																						}
																					}),
																				_1: {
																					ctor: '::',
																					_0: A2(
																						_mdgriffith$style_elements$Style$style,
																						_user$project$Map_Data_Styles$Focused,
																						{
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Style$hover(
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGray),
																									_1: {ctor: '[]'}
																								}),
																							_1: {ctor: '[]'}
																						}),
																					_1: {
																						ctor: '::',
																						_0: A2(
																							_mdgriffith$style_elements$Style$style,
																							_user$project$Map_Data_Styles$MapFooter,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																								_1: {ctor: '[]'}
																							}),
																						_1: {
																							ctor: '::',
																							_0: A2(
																								_mdgriffith$style_elements$Style$style,
																								_user$project$Map_Data_Styles$Success,
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$green),
																									_1: {ctor: '[]'}
																								}),
																							_1: {
																								ctor: '::',
																								_0: A2(
																									_mdgriffith$style_elements$Style$style,
																									_user$project$Map_Data_Styles$Warning,
																									{
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$orange),
																										_1: {ctor: '[]'}
																									}),
																								_1: {
																									ctor: '::',
																									_0: A2(
																										_mdgriffith$style_elements$Style$style,
																										_user$project$Map_Data_Styles$Error,
																										{
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$red),
																											_1: {ctor: '[]'}
																										}),
																									_1: {ctor: '[]'}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _user$project$Map_Data_Styles$Styling = function (a) {
	return {ctor: 'Styling', _0: a};
};

var _user$project$Map_Data_ClickPosInfo$ClickPosInfo = F6(
	function (a, b, c, d, e, f) {
		return {coordinate: a, pixelPos: b, featuresData: c, visibleTileLayerKeys: d, checkedNamedGeoZones: e, apiResponse: f};
	});
var _user$project$Map_Data_ClickPosInfo$ApiResponseData = F2(
	function (a, b) {
		return {layerKey: a, response: b};
	});

var _user$project$Map_Data_Config$ConfigData = F6(
	function (a, b, c, d, e, f) {
		return {msgFromMap: a, toPopup: b, uiBits: c, styling: d, showAddNewLayerBtn: e, popUpWidth: f};
	});
var _user$project$Map_Data_Config$Config = function (a) {
	return {ctor: 'Config', _0: a};
};
var _user$project$Map_Data_Config$config = function (_p0) {
	var _p1 = _p0;
	var _p2 = _p1.styling;
	return _user$project$Map_Data_Config$Config(
		{msgFromMap: _p1.msgFromMap, toPopup: _p1.toPopup, uiBits: _p1.uiBits, styling: _p2._0, showAddNewLayerBtn: false, popUpWidth: _elm_lang$core$Maybe$Nothing});
};
var _user$project$Map_Data_Config$detailedConfig = function (_p3) {
	var _p4 = _p3;
	var _p5 = _p4.styling;
	return _user$project$Map_Data_Config$Config(
		{msgFromMap: _p4.msgFromMap, toPopup: _p4.toPopup, uiBits: _p4.uiBits, styling: _p5._0, showAddNewLayerBtn: _p4.showAddNewLayerBtn, popUpWidth: _p4.popUpWidth});
};

var _user$project$Map_Data_Layer_Legend$RectData = F4(
	function (a, b, c, d) {
		return {label: a, fill: b, stroke: c, strokeWidth: d};
	});
var _user$project$Map_Data_Layer_Legend$CircleData = F5(
	function (a, b, c, d, e) {
		return {label: a, radius: b, fill: c, stroke: d, strokeWidth: e};
	});
var _user$project$Map_Data_Layer_Legend$LineData = F3(
	function (a, b, c) {
		return {label: a, stroke: b, strokeWidth: c};
	});
var _user$project$Map_Data_Layer_Legend$IconData = F3(
	function (a, b, c) {
		return {label: a, url: b, size: c};
	});
var _user$project$Map_Data_Layer_Legend$Icons = function (a) {
	return {ctor: 'Icons', _0: a};
};
var _user$project$Map_Data_Layer_Legend$iconDecoder = A2(
	_elm_lang$core$Json_Decode$map,
	_user$project$Map_Data_Layer_Legend$Icons,
	A2(
		_elm_lang$core$Json_Decode$field,
		'elements',
		_elm_lang$core$Json_Decode$list(
			A4(
				_elm_lang$core$Json_Decode$map3,
				_user$project$Map_Data_Layer_Legend$IconData,
				A2(_elm_lang$core$Json_Decode$field, 'label', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'url', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'size', _elm_lang$core$Json_Decode$float)))));
var _user$project$Map_Data_Layer_Legend$Lines = function (a) {
	return {ctor: 'Lines', _0: a};
};
var _user$project$Map_Data_Layer_Legend$lineDecoder = A2(
	_elm_lang$core$Json_Decode$map,
	_user$project$Map_Data_Layer_Legend$Lines,
	A2(
		_elm_lang$core$Json_Decode$field,
		'elements',
		_elm_lang$core$Json_Decode$list(
			A4(
				_elm_lang$core$Json_Decode$map3,
				_user$project$Map_Data_Layer_Legend$LineData,
				A2(_elm_lang$core$Json_Decode$field, 'label', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'stroke', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'strokeWidth', _elm_lang$core$Json_Decode$float)))));
var _user$project$Map_Data_Layer_Legend$Circles = function (a) {
	return {ctor: 'Circles', _0: a};
};
var _user$project$Map_Data_Layer_Legend$circleDecoder = A2(
	_elm_lang$core$Json_Decode$map,
	_user$project$Map_Data_Layer_Legend$Circles,
	A2(
		_elm_lang$core$Json_Decode$field,
		'elements',
		_elm_lang$core$Json_Decode$list(
			A6(
				_elm_lang$core$Json_Decode$map5,
				_user$project$Map_Data_Layer_Legend$CircleData,
				A2(_elm_lang$core$Json_Decode$field, 'label', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'radius', _elm_lang$core$Json_Decode$float),
				A2(_elm_lang$core$Json_Decode$field, 'fill', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'stroke', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'strokeWidth', _elm_lang$core$Json_Decode$float)))));
var _user$project$Map_Data_Layer_Legend$Rectangles = function (a) {
	return {ctor: 'Rectangles', _0: a};
};
var _user$project$Map_Data_Layer_Legend$rectDecoder = A2(
	_elm_lang$core$Json_Decode$map,
	_user$project$Map_Data_Layer_Legend$Rectangles,
	A2(
		_elm_lang$core$Json_Decode$field,
		'elements',
		_elm_lang$core$Json_Decode$list(
			A5(
				_elm_lang$core$Json_Decode$map4,
				_user$project$Map_Data_Layer_Legend$RectData,
				A2(_elm_lang$core$Json_Decode$field, 'label', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'fill', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'stroke', _elm_lang$core$Json_Decode$string),
				A2(_elm_lang$core$Json_Decode$field, 'strokeWidth', _elm_lang$core$Json_Decode$float)))));
var _user$project$Map_Data_Layer_Legend$decoderSelect = function (lType) {
	var _p0 = lType;
	switch (_p0) {
		case 'Rect':
			return _user$project$Map_Data_Layer_Legend$rectDecoder;
		case 'Circle':
			return _user$project$Map_Data_Layer_Legend$circleDecoder;
		case 'Line':
			return _user$project$Map_Data_Layer_Legend$lineDecoder;
		case 'Icon':
			return _user$project$Map_Data_Layer_Legend$iconDecoder;
		default:
			return _elm_lang$core$Json_Decode$fail(
				A2(
					_elm_lang$core$Basics_ops['++'],
					'Trying to decode legend, but its type ',
					A2(_elm_lang$core$Basics_ops['++'], lType, ' is not supported.')));
	}
};
var _user$project$Map_Data_Layer_Legend$decoder = A2(
	_elm_lang$core$Json_Decode$andThen,
	_user$project$Map_Data_Layer_Legend$decoderSelect,
	A2(_elm_lang$core$Json_Decode$field, 'type', _elm_lang$core$Json_Decode$string));


var _user$project$Map_Data_Layer_URLRequest$imageDisplayToString = function (imageDisplay) {
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(imageDisplay.width),
				','),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(imageDisplay.height),
					','),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(imageDisplay.dpi),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _user$project$Map_Data_Layer_URLRequest$geometryTypeToString = function (geometryType) {
	var _p0 = geometryType;
	switch (_p0.ctor) {
		case 'EsriGeometryPoint':
			return 'esriGeometryPoint';
		case 'EsriGeometryPolyline':
			return 'esriGeometryPolyline';
		case 'EsriGeometryPolygon':
			return 'esriGeometryPolygon';
		default:
			return 'esriGeometryEnvelope';
	}
};
var _user$project$Map_Data_Layer_URLRequest$pointToString = function (point) {
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(point.x),
				','),
			_1: {
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(point.y),
				_1: {ctor: '[]'}
			}
		});
};
var _user$project$Map_Data_Layer_URLRequest$extentToString = function (extent) {
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(extent.minx),
				','),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(extent.miny),
					','),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(extent.maxx),
						','),
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(extent.maxy),
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _user$project$Map_Data_Layer_URLRequest$getTransformedCoords = F2(
	function (coordinate, wmsData) {
		return {
			x: ((coordinate.x - wmsData.bbox.minx) / (wmsData.bbox.maxx - wmsData.bbox.minx)) * _elm_lang$core$Basics$toFloat(wmsData.width),
			y: ((wmsData.bbox.maxy - coordinate.y) / (wmsData.bbox.maxy - wmsData.bbox.miny)) * _elm_lang$core$Basics$toFloat(wmsData.height)
		};
	});
var _user$project$Map_Data_Layer_URLRequest$sortByDirectionToString = function (sortByDireciton) {
	var _p1 = sortByDireciton;
	if (_p1.ctor === 'Ascending') {
		return '+A';
	} else {
		return '+D';
	}
};
var _user$project$Map_Data_Layer_URLRequest$withDefaultExtentToString = function (extent) {
	var _p2 = extent;
	if (_p2.ctor === 'Just') {
		return _user$project$Map_Data_Layer_URLRequest$extentToString(_p2._0);
	} else {
		return '';
	}
};
var _user$project$Map_Data_Layer_URLRequest$withDefaultSortByToString = function (sortby) {
	var _p3 = sortby;
	if (_p3.ctor === 'Just') {
		var _p4 = _p3._0;
		return _elm_lang$core$String$concat(
			{
				ctor: '::',
				_0: _p4.attribute,
				_1: {
					ctor: '::',
					_0: _user$project$Map_Data_Layer_URLRequest$sortByDirectionToString(_p4.direction),
					_1: {ctor: '[]'}
				}
			});
	} else {
		return '';
	}
};
var _user$project$Map_Data_Layer_URLRequest$withDefaultString = function (string) {
	return A2(_elm_lang$core$Maybe$withDefault, '', string);
};
var _user$project$Map_Data_Layer_URLRequest$getFormattedURL = F2(
	function (urlRequest, coordinates) {
		var _p5 = urlRequest;
		switch (_p5.ctor) {
			case 'RegexRequest':
				var _p10 = _p5._0;
				var yRegex = function () {
					var _p6 = _p10.yRegex;
					if (_p6.ctor === 'Nothing') {
						return '$a';
					} else {
						return _p6._0;
					}
				}();
				var xRegex = function () {
					var _p7 = _p10.xRegex;
					if (_p7.ctor === 'Nothing') {
						return '$a';
					} else {
						return _p7._0;
					}
				}();
				return A4(
					_elm_lang$core$Regex$replace,
					_elm_lang$core$Regex$All,
					_elm_lang$core$Regex$regex(xRegex),
					function (_p8) {
						return _elm_lang$core$Basics$toString(coordinates.x);
					},
					A4(
						_elm_lang$core$Regex$replace,
						_elm_lang$core$Regex$All,
						_elm_lang$core$Regex$regex(yRegex),
						function (_p9) {
							return _elm_lang$core$Basics$toString(coordinates.y);
						},
						_p10.baseURL));
			case 'WMSRequest':
				var _p11 = _p5._0;
				var transformedCoords = A2(_user$project$Map_Data_Layer_URLRequest$getTransformedCoords, coordinates, _p11);
				return _elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p11.baseURL, '?'),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$core$Basics_ops['++'], 'service=', _p11.service),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$core$Basics_ops['++'], '&version=', _p11.version),
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$core$Basics_ops['++'], '&request=', _p11.request),
									_1: {
										ctor: '::',
										_0: A2(_elm_lang$core$Basics_ops['++'], '&layers=', _p11.layerKeys),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$core$Basics_ops['++'],
												'&width=',
												_elm_lang$core$Basics$toString(_p11.width)),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$core$Basics_ops['++'],
													'&height=',
													_elm_lang$core$Basics$toString(_p11.height)),
												_1: {
													ctor: '::',
													_0: A2(_elm_lang$core$Basics_ops['++'], '&crs=', _p11.crs),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$core$Basics_ops['++'], '&styles=', _p11.styles),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$core$Basics_ops['++'],
																'&bbox=',
																_user$project$Map_Data_Layer_URLRequest$extentToString(_p11.bbox)),
															_1: {
																ctor: '::',
																_0: A2(_elm_lang$core$Basics_ops['++'], '&query_layers=', _p11.queryLayers),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$core$Basics_ops['++'],
																		'&x=',
																		_elm_lang$core$Basics$toString(transformedCoords.x)),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_elm_lang$core$Basics_ops['++'],
																			'&y=',
																			_elm_lang$core$Basics$toString(transformedCoords.y)),
																		_1: {
																			ctor: '::',
																			_0: A2(_elm_lang$core$Basics_ops['++'], '&info_format=', _p11.infoFormat),
																			_1: {ctor: '[]'}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					});
			case 'GeoAdminRequest':
				var _p12 = _p5._0;
				return _elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p12.baseURL, '?'),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								'geometry=',
								_user$project$Map_Data_Layer_URLRequest$pointToString(coordinates)),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$core$Basics_ops['++'],
									'&geometryType=',
									_user$project$Map_Data_Layer_URLRequest$geometryTypeToString(_p12.geometryType)),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$core$Basics_ops['++'],
										'&layerKeys=',
										_elm_lang$core$Basics$toString(_p12.layerKeys)),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$core$Basics_ops['++'],
											'&mapExtent=',
											_user$project$Map_Data_Layer_URLRequest$extentToString(_p12.mapExtent)),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$core$Basics_ops['++'],
												'&imageDisplay=',
												_user$project$Map_Data_Layer_URLRequest$imageDisplayToString(_p12.imageDisplay)),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$core$Basics_ops['++'],
													'&tolerance=',
													_elm_lang$core$Basics$toString(_p12.tolerance)),
												_1: {
													ctor: '::',
													_0: A2(_elm_lang$core$Basics_ops['++'], '&lang=', _p12.lang),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$core$Basics_ops['++'],
															'&sr=',
															_elm_lang$core$Basics$toString(_p12.sr)),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								}
							}
						}
					});
			default:
				var _p13 = _p5._0;
				return _elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p13.baseURL, '?'),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$core$Basics_ops['++'], 'service=', _p13.service),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$core$Basics_ops['++'], '&version=', _p13.version),
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$core$Basics_ops['++'], '&request=', _p13.request),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$core$Basics_ops['++'],
											'&typeNames=',
											_user$project$Map_Data_Layer_URLRequest$withDefaultString(_p13.typeNames)),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$core$Basics_ops['++'],
												'&srsName=',
												_user$project$Map_Data_Layer_URLRequest$withDefaultString(_p13.srsName)),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$core$Basics_ops['++'],
													'&propertyName=',
													_user$project$Map_Data_Layer_URLRequest$withDefaultString(_p13.propertyName)),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$core$Basics_ops['++'],
														'&bbox=',
														_user$project$Map_Data_Layer_URLRequest$withDefaultExtentToString(_p13.bbox)),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$core$Basics_ops['++'],
															'sortby=',
															_user$project$Map_Data_Layer_URLRequest$withDefaultSortByToString(_p13.sortBy)),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								}
							}
						}
					});
		}
	});
var _user$project$Map_Data_Layer_URLRequest$getBoundingBox = function (urlRequest) {
	var _p14 = urlRequest;
	switch (_p14.ctor) {
		case 'RegexRequest':
			return _p14._0.bbox;
		case 'WMSRequest':
			return _elm_lang$core$Maybe$Just(_p14._0.bbox);
		case 'GeoAdminRequest':
			return _elm_lang$core$Maybe$Just(_p14._0.mapExtent);
		default:
			return _p14._0.bbox;
	}
};
var _user$project$Map_Data_Layer_URLRequest$RegexRequestData = F4(
	function (a, b, c, d) {
		return {baseURL: a, xRegex: b, yRegex: c, bbox: d};
	});
var _user$project$Map_Data_Layer_URLRequest$WMSRequestData = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return {baseURL: a, service: b, version: c, request: d, layerKeys: e, width: f, height: g, crs: h, styles: i, bbox: j, queryLayers: k, infoFormat: l};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Map_Data_Layer_URLRequest$GeoAdminRequestData = F8(
	function (a, b, c, d, e, f, g, h) {
		return {baseURL: a, geometryType: b, layerKeys: c, mapExtent: d, imageDisplay: e, tolerance: f, lang: g, sr: h};
	});
var _user$project$Map_Data_Layer_URLRequest$SortBy = F2(
	function (a, b) {
		return {attribute: a, direction: b};
	});
var _user$project$Map_Data_Layer_URLRequest$WFSRequestData = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {baseURL: a, service: b, version: c, request: d, typeNames: e, srsName: f, propertyName: g, bbox: h, sortBy: i};
	});
var _user$project$Map_Data_Layer_URLRequest$ImageDisplay = F3(
	function (a, b, c) {
		return {width: a, height: b, dpi: c};
	});
var _user$project$Map_Data_Layer_URLRequest$WFSRequest = function (a) {
	return {ctor: 'WFSRequest', _0: a};
};
var _user$project$Map_Data_Layer_URLRequest$GeoAdminRequest = function (a) {
	return {ctor: 'GeoAdminRequest', _0: a};
};
var _user$project$Map_Data_Layer_URLRequest$createGeoAdminUrlRequest = function (data) {
	return _user$project$Map_Data_Layer_URLRequest$GeoAdminRequest(
		{
			baseURL: data.baseURL,
			geometryType: data.geometryType,
			layerKeys: A2(_elm_lang$core$String$join, ':', data.layerKeys),
			mapExtent: data.mapExtent,
			imageDisplay: data.imageDisplay,
			tolerance: data.tolerance,
			lang: data.lang,
			sr: data.sr
		});
};
var _user$project$Map_Data_Layer_URLRequest$WMSRequest = function (a) {
	return {ctor: 'WMSRequest', _0: a};
};
var _user$project$Map_Data_Layer_URLRequest$createWMSUrlRequest = function (data) {
	return _user$project$Map_Data_Layer_URLRequest$WMSRequest(
		{
			baseURL: data.baseURL,
			service: 'WMS',
			version: data.version,
			request: 'GetFeatureInfo',
			layerKeys: A2(_elm_lang$core$String$join, ',', data.layerKeys),
			width: data.width,
			height: data.height,
			crs: data.crs,
			styles: data.styles,
			bbox: data.bbox,
			queryLayers: data.queryLayers,
			infoFormat: data.infoFormat
		});
};
var _user$project$Map_Data_Layer_URLRequest$createWFSUrlRequest = function (data) {
	return _user$project$Map_Data_Layer_URLRequest$WMSRequest(
		{
			baseURL: data.baseURL,
			service: 'WFS',
			version: data.version,
			request: 'GetFeature',
			layerKeys: A2(_elm_lang$core$String$join, ',', data.layerKeys),
			width: data.width,
			height: data.height,
			crs: data.crs,
			styles: data.styles,
			bbox: data.bbox,
			queryLayers: data.queryLayers,
			infoFormat: data.infoFormat
		});
};
var _user$project$Map_Data_Layer_URLRequest$RegexRequest = function (a) {
	return {ctor: 'RegexRequest', _0: a};
};
var _user$project$Map_Data_Layer_URLRequest$createRegexUrlRequest = function (data) {
	return _user$project$Map_Data_Layer_URLRequest$RegexRequest(data);
};
var _user$project$Map_Data_Layer_URLRequest$Descending = {ctor: 'Descending'};
var _user$project$Map_Data_Layer_URLRequest$Ascending = {ctor: 'Ascending'};
var _user$project$Map_Data_Layer_URLRequest$EsriGeometryEnvelope = {ctor: 'EsriGeometryEnvelope'};
var _user$project$Map_Data_Layer_URLRequest$EsriGeometryPolygon = {ctor: 'EsriGeometryPolygon'};
var _user$project$Map_Data_Layer_URLRequest$EsriGeometryPolyline = {ctor: 'EsriGeometryPolyline'};
var _user$project$Map_Data_Layer_URLRequest$EsriGeometryPoint = {ctor: 'EsriGeometryPoint'};

var _user$project$Map_Data_Layer_Wmts$encode = function (wmts) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: _elm_lang$core$Json_Encode$string('WMTS')
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'key',
					_1: _elm_lang$core$Json_Encode$string(wmts.key)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'isVisible',
						_1: _elm_lang$core$Json_Encode$bool(wmts.isVisible)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'opacity',
							_1: _elm_lang$core$Json_Encode$float(wmts.opacity)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'url',
								_1: _elm_lang$core$Json_Encode$string(wmts.url)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'layerName',
									_1: _elm_lang$core$Json_Encode$string(wmts.layerName)
								},
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
};
var _user$project$Map_Data_Layer_Wmts$addLegend = F2(
	function (legend, uibitWmts) {
		return _elm_lang$core$Native_Utils.update(
			uibitWmts,
			{
				legend: _elm_lang$core$Maybe$Just(legend)
			});
	});
var _user$project$Map_Data_Layer_Wmts$fromParamsWithScale = function (wdata) {
	return {
		key: wdata.key,
		name: wdata.name,
		info: wdata.info,
		isVisible: wdata.isVisible,
		opacity: wdata.opacity,
		url: wdata.url,
		layerName: wdata.layerName,
		urlRequest: wdata.urlRequest,
		isInfoExpanded: false,
		isSettingsExpanded: false,
		legend: _elm_lang$core$Maybe$Nothing,
		minResolution: function () {
			var _p0 = wdata.maxScale;
			if (_p0.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					_user$project$Map_Data_Utils$getResolutionFromScale(_p0._0));
			}
		}(),
		maxResolution: function () {
			var _p1 = wdata.minScale;
			if (_p1.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					_user$project$Map_Data_Utils$getResolutionFromScale(_p1._0));
			}
		}()
	};
};
var _user$project$Map_Data_Layer_Wmts$fromParamsWithResoltion = function (wdata) {
	return {key: wdata.key, name: wdata.name, info: wdata.info, isVisible: wdata.isVisible, opacity: wdata.opacity, url: wdata.url, layerName: wdata.layerName, urlRequest: wdata.urlRequest, isInfoExpanded: false, isSettingsExpanded: false, minResolution: wdata.minResolution, maxResolution: wdata.maxResolution, legend: _elm_lang$core$Maybe$Nothing};
};
var _user$project$Map_Data_Layer_Wmts$fromParams = function (wdata) {
	return {key: wdata.key, name: wdata.name, info: wdata.info, isVisible: wdata.isVisible, opacity: wdata.opacity, url: wdata.url, layerName: wdata.layerName, urlRequest: wdata.urlRequest, isInfoExpanded: false, isSettingsExpanded: false, minResolution: _elm_lang$core$Maybe$Nothing, maxResolution: _elm_lang$core$Maybe$Nothing, legend: _elm_lang$core$Maybe$Nothing};
};

var _user$project$Map_Data_Layer_LegendRequest$getLegendOptions = function (legendRequest) {
	var _p0 = legendRequest;
	if (_p0.ctor === 'Nothing') {
		return '';
	} else {
		return _p0._0;
	}
};
var _user$project$Map_Data_Layer_LegendRequest$getFormattedURL = function (legendRequest) {
	var _p1 = legendRequest;
	var _p2 = _p1._0;
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: A2(_elm_lang$core$Basics_ops['++'], _p2.url, '?'),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Basics_ops['++'], 'request=', _p2.request),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$core$Basics_ops['++'], '&version=', _p2.version),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$core$Basics_ops['++'], '&format=', _p2.format),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$core$Basics_ops['++'], '&layer=', _p2.layerKeys),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$core$Basics_ops['++'],
									'&legend_options=',
									_user$project$Map_Data_Layer_LegendRequest$getLegendOptions(_p2.legendOptions)),
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
};
var _user$project$Map_Data_Layer_LegendRequest$LegendRequestData = F6(
	function (a, b, c, d, e, f) {
		return {request: a, url: b, version: c, layerKeys: d, format: e, legendOptions: f};
	});
var _user$project$Map_Data_Layer_LegendRequest$LegendRequest = function (a) {
	return {ctor: 'LegendRequest', _0: a};
};
var _user$project$Map_Data_Layer_LegendRequest$createLegendRequest = function (data) {
	return _user$project$Map_Data_Layer_LegendRequest$LegendRequest(
		{request: 'GetLegendGraphic', url: data.url, version: data.version, layerKeys: data.layerKeys, format: data.format, legendOptions: data.legendOptions});
};

var _user$project$Map_Data_Layer_WmsTile$getLegendRequest = F2(
	function (providedData, userData) {
		var _p0 = userData;
		if (_p0.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p1 = _p0._0;
			return _elm_lang$core$Maybe$Just(
				_user$project$Map_Data_Layer_LegendRequest$createLegendRequest(
					{url: providedData.url, version: _p1.version, layerKeys: providedData.layerKeys, format: _p1.format, legendOptions: _p1.legendOptions}));
		}
	});
var _user$project$Map_Data_Layer_WmsTile$encode = function (wmsTile) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: _elm_lang$core$Json_Encode$string('WMSTILE')
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'key',
					_1: _elm_lang$core$Json_Encode$string(wmsTile.key)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'isVisible',
						_1: _elm_lang$core$Json_Encode$bool(wmsTile.isVisible)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'opacity',
							_1: _elm_lang$core$Json_Encode$float(wmsTile.opacity)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'url',
								_1: _elm_lang$core$Json_Encode$string(wmsTile.url)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'layerName',
									_1: _elm_lang$core$Json_Encode$string(wmsTile.layerName)
								},
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
};
var _user$project$Map_Data_Layer_WmsTile$addLegend = F2(
	function (legend, uibitWmts) {
		return _elm_lang$core$Native_Utils.update(
			uibitWmts,
			{
				legend: _elm_lang$core$Maybe$Just(legend)
			});
	});
var _user$project$Map_Data_Layer_WmsTile$fromParamsWithScale = function (wdata) {
	return {
		key: wdata.key,
		name: wdata.name,
		info: wdata.info,
		isVisible: wdata.isVisible,
		opacity: wdata.opacity,
		url: wdata.url,
		legendRequest: A2(
			_user$project$Map_Data_Layer_WmsTile$getLegendRequest,
			{url: wdata.url, layerKeys: wdata.layerName},
			wdata.legendRequest),
		layerName: wdata.layerName,
		urlRequest: wdata.urlRequest,
		isInfoExpanded: false,
		isSettingsExpanded: false,
		legend: _elm_lang$core$Maybe$Nothing,
		minResolution: function () {
			var _p2 = wdata.maxScale;
			if (_p2.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					_user$project$Map_Data_Utils$getResolutionFromScale(_p2._0));
			}
		}(),
		maxResolution: function () {
			var _p3 = wdata.minScale;
			if (_p3.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					_user$project$Map_Data_Utils$getResolutionFromScale(_p3._0));
			}
		}()
	};
};
var _user$project$Map_Data_Layer_WmsTile$fromParamsWithResoltion = function (wdata) {
	return {
		key: wdata.key,
		name: wdata.name,
		info: wdata.info,
		isVisible: wdata.isVisible,
		opacity: wdata.opacity,
		url: wdata.url,
		layerName: wdata.layerName,
		legend: _elm_lang$core$Maybe$Nothing,
		legendRequest: A2(
			_user$project$Map_Data_Layer_WmsTile$getLegendRequest,
			{url: wdata.url, layerKeys: wdata.layerName},
			wdata.legendRequest),
		urlRequest: wdata.urlRequest,
		isInfoExpanded: false,
		isSettingsExpanded: false,
		minResolution: wdata.minResolution,
		maxResolution: wdata.maxResolution
	};
};
var _user$project$Map_Data_Layer_WmsTile$fromParams = function (wdata) {
	return {
		key: wdata.key,
		name: wdata.name,
		info: wdata.info,
		isVisible: wdata.isVisible,
		opacity: wdata.opacity,
		url: wdata.url,
		layerName: wdata.layerName,
		legend: _elm_lang$core$Maybe$Nothing,
		legendRequest: A2(
			_user$project$Map_Data_Layer_WmsTile$getLegendRequest,
			{url: wdata.url, layerKeys: wdata.layerName},
			wdata.legendRequest),
		urlRequest: wdata.urlRequest,
		isInfoExpanded: false,
		isSettingsExpanded: false,
		minResolution: _elm_lang$core$Maybe$Nothing,
		maxResolution: _elm_lang$core$Maybe$Nothing
	};
};
var _user$project$Map_Data_Layer_WmsTile$LegendRequestData = F3(
	function (a, b, c) {
		return {version: a, format: b, legendOptions: c};
	});

var _user$project$Map_Data_Layer_VectorStyle$getStyleObjName = function (styleData) {
	return styleData.current;
};
var _user$project$Map_Data_Layer_VectorStyle$choiceBasedStyles = F4(
	function (msgFromMap, layerKey, initStyleName, styleChoices) {
		return {
			current: _elm_lang$core$Maybe$Just(initStyleName),
			more: _elm_lang$core$Maybe$Just(
				{
					selectMenu: A2(
						_mdgriffith$style_elements$Element_Input$dropMenu,
						_elm_lang$core$Maybe$Just(initStyleName),
						function (_p0) {
							return msgFromMap(
								A2(_user$project$Map_Data_Msg$UpdateVectorStyle, layerKey, _p0));
						}),
					choices: styleChoices
				})
		};
	});
var _user$project$Map_Data_Layer_VectorStyle$uniqueStyle = function (name) {
	return {
		current: _elm_lang$core$Maybe$Just(name),
		more: _elm_lang$core$Maybe$Nothing
	};
};
var _user$project$Map_Data_Layer_VectorStyle$noStyle = {current: _elm_lang$core$Maybe$Nothing, more: _elm_lang$core$Maybe$Nothing};
var _user$project$Map_Data_Layer_VectorStyle$StyleData = F2(
	function (a, b) {
		return {current: a, more: b};
	});

var _user$project$Map_Data_Layer_Tiles$getStyleObjName = function (tiles) {
	var _p0 = tiles.tileType;
	if (_p0.ctor === 'XyzImg') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _user$project$Map_Data_Layer_VectorStyle$getStyleObjName(_p0._0);
	}
};
var _user$project$Map_Data_Layer_Tiles$encode = function (tiles) {
	var headerEncoder = function (_p1) {
		var _p2 = _p1;
		return _elm_lang$core$Json_Encode$list(
			{
				ctor: '::',
				_0: _elm_lang$core$Json_Encode$string(_p2._0),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Json_Encode$string(_p2._1),
					_1: {ctor: '[]'}
				}
			});
	};
	var coreEnc = {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'type',
			_1: function () {
				var _p3 = tiles.tileType;
				if (_p3.ctor === 'XyzImg') {
					return _elm_lang$core$Json_Encode$string('XyzImgTiles');
				} else {
					return _elm_lang$core$Json_Encode$string('MapBoxVectorTiles');
				}
			}()
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'key',
				_1: _elm_lang$core$Json_Encode$string(tiles.key)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'isVisible',
					_1: _elm_lang$core$Json_Encode$bool(tiles.isVisible)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'opacity',
						_1: _elm_lang$core$Json_Encode$float(tiles.opacity)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'url',
							_1: _elm_lang$core$Json_Encode$string(tiles.url)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'headers',
								_1: _elm_lang$core$Json_Encode$list(
									A2(_elm_lang$core$List$map, headerEncoder, tiles.headers))
							},
							_1: {ctor: '[]'}
						}
					}
				}
			}
		}
	};
	var finalEnc = function () {
		var _p4 = tiles.tileType;
		if (_p4.ctor === 'XyzImg') {
			return coreEnc;
		} else {
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'currentStyle',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, _p4._0.current)
				},
				_1: coreEnc
			};
		}
	}();
	return _elm_lang$core$Json_Encode$object(finalEnc);
};
var _user$project$Map_Data_Layer_Tiles$tilesFromParamAndType = F2(
	function (params, tileType) {
		return {key: params.key, name: params.name, info: params.info, isVisible: params.isVisible, opacity: params.opacity, url: params.url, headers: params.headers, tileType: tileType, urlRequest: params.urlRequest, isInfoExpanded: false, isSettingsExpanded: false};
	});
var _user$project$Map_Data_Layer_Tiles$MapBoxVector = F2(
	function (a, b) {
		return {ctor: 'MapBoxVector', _0: a, _1: b};
	});
var _user$project$Map_Data_Layer_Tiles$mapBoxVector = function (params) {
	return A2(
		_user$project$Map_Data_Layer_Tiles$tilesFromParamAndType,
		params,
		A2(_user$project$Map_Data_Layer_Tiles$MapBoxVector, params.style, _elm_lang$core$Maybe$Nothing));
};
var _user$project$Map_Data_Layer_Tiles$XyzImg = function (a) {
	return {ctor: 'XyzImg', _0: a};
};
var _user$project$Map_Data_Layer_Tiles$xyzImg = function (params) {
	return A2(
		_user$project$Map_Data_Layer_Tiles$tilesFromParamAndType,
		params,
		_user$project$Map_Data_Layer_Tiles$XyzImg(_elm_lang$core$Maybe$Nothing));
};
var _user$project$Map_Data_Layer_Tiles$addLegendToXyzTiles = F2(
	function (legend, tiles) {
		var _p5 = tiles.tileType;
		if (_p5.ctor === 'MapBoxVector') {
			return tiles;
		} else {
			var newXyzImg = _user$project$Map_Data_Layer_Tiles$XyzImg(
				_elm_lang$core$Maybe$Just(legend));
			return _elm_lang$core$Native_Utils.update(
				tiles,
				{tileType: newXyzImg});
		}
	});

var _user$project$Map_Data_Layer_Vector$encode = function (vdata) {
	var encodedUrl = function () {
		var _p0 = vdata.loadMethod;
		if (_p0.ctor === 'Delegate') {
			return _elm_lang$core$Json_Encode$string(_p0._0);
		} else {
			return _elm_lang$core$Json_Encode$null;
		}
	}();
	var mayInitVal = function () {
		var _p1 = vdata.loadMethod;
		if (_p1.ctor === 'Local') {
			return _p1._0;
		} else {
			return _elm_lang$core$Json_Encode$null;
		}
	}();
	var formatData = function () {
		var _p2 = vdata.format;
		switch (_p2.ctor) {
			case 'StandardGeoJson':
				return _p2._0;
			case 'GeoJson':
				return _p2._0;
			default:
				return _p2._0;
		}
	}();
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: _elm_lang$core$Json_Encode$string('Vector')
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'key',
					_1: _elm_lang$core$Json_Encode$string(vdata.key)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'isVisible',
						_1: _elm_lang$core$Json_Encode$bool(vdata.isVisible)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'opacity',
							_1: _elm_lang$core$Json_Encode$float(vdata.opacity)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'format',
								_1: _elm_lang$core$Json_Encode$string(
									function () {
										var _p3 = vdata.format;
										switch (_p3.ctor) {
											case 'StandardGeoJson':
												return 'StandardGeoJson';
											case 'GeoJson':
												return 'GeoJson';
											default:
												return 'EsriJson';
										}
									}())
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'clusterOptions',
									_1: function () {
										var _p4 = vdata.clusterOptions;
										if (_p4.ctor === 'NoClusters') {
											return _elm_lang$core$Json_Encode$null;
										} else {
											return _elm_lang$core$Json_Encode$object(
												{
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'distance',
														_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$int, _p4._0.distance)
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'objsReturnedOnClick',
															_1: _elm_lang$core$Json_Encode$int(_p4._0.objsReturnedOnClick)
														},
														_1: {ctor: '[]'}
													}
												});
										}
									}()
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'idPath',
										_1: A2(
											_elm_community$json_extra$Json_Encode_Extra$maybe,
											function (_p5) {
												return _elm_lang$core$Json_Encode$list(
													A2(
														_elm_lang$core$List$map,
														function (v) {
															return _elm_lang$core$Json_Encode$string(v);
														},
														_p5));
											},
											formatData.idPath)
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'subObjPath',
											_1: A2(
												_elm_community$json_extra$Json_Encode_Extra$maybe,
												function (_p6) {
													return _elm_lang$core$Json_Encode$list(
														A2(
															_elm_lang$core$List$map,
															function (v) {
																return _elm_lang$core$Json_Encode$string(v);
															},
															_p6));
												},
												formatData.subObjPath)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'subObjIdPath',
												_1: A2(
													_elm_community$json_extra$Json_Encode_Extra$maybe,
													function (_p7) {
														return _elm_lang$core$Json_Encode$list(
															A2(
																_elm_lang$core$List$map,
																function (v) {
																	return _elm_lang$core$Json_Encode$string(v);
																},
																_p7));
													},
													formatData.subObjIdPath)
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'minResolution',
													_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$float, vdata.minResolution)
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'maxResolution',
														_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$float, vdata.maxResolution)
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'currentStyle',
															_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, vdata.style.current)
														},
														_1: {
															ctor: '::',
															_0: {
																ctor: '_Tuple2',
																_0: 'select',
																_1: _elm_lang$core$Json_Encode$bool(vdata.select)
															},
															_1: {
																ctor: '::',
																_0: {ctor: '_Tuple2', _0: 'initData', _1: mayInitVal},
																_1: {
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'url', _1: encodedUrl},
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		});
};
var _user$project$Map_Data_Layer_Vector$getServiceFullUrl = function (data) {
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: A2(_elm_lang$core$Basics_ops['++'], data.baseUrl, '?'),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Basics_ops['++'],
					'service=',
					A2(_elm_lang$core$Basics_ops['++'], data.service, '&')),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$core$Basics_ops['++'],
						'version=',
						A2(_elm_lang$core$Basics_ops['++'], data.version, '&')),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'request=',
							A2(_elm_lang$core$Basics_ops['++'], data.request, '&')),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								'srsname=',
								A2(_elm_lang$core$Basics_ops['++'], data.srsName, '&')),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$core$Basics_ops['++'],
									'outputFormat=',
									A2(_elm_lang$core$Basics_ops['++'], data.outputFormat, '&')),
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$core$Basics_ops['++'], 'typeNames=', data.typeNames),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}
		});
};
var _user$project$Map_Data_Layer_Vector$getStyleObjName = function (vector) {
	return _user$project$Map_Data_Layer_VectorStyle$getStyleObjName(vector.style);
};
var _user$project$Map_Data_Layer_Vector$fromAllParams = function (vdata) {
	return {key: vdata.key, name: vdata.name, info: vdata.info, isVisible: vdata.isVisible, opacity: vdata.opacity, isInfoExpanded: vdata.isInfoExpanded, isSettingsExpanded: false, loadMethod: vdata.loadMethod, format: vdata.format, clusterOptions: vdata.clusterOptions, minResolution: vdata.minResolution, maxResolution: vdata.maxResolution, select: vdata.select, style: vdata.style, urlRequest: vdata.urlRequest, legend: _elm_lang$core$Maybe$Nothing};
};
var _user$project$Map_Data_Layer_Vector$FormatData = F3(
	function (a, b, c) {
		return {idPath: a, subObjPath: b, subObjIdPath: c};
	});
var _user$project$Map_Data_Layer_Vector$Delegate = function (a) {
	return {ctor: 'Delegate', _0: a};
};
var _user$project$Map_Data_Layer_Vector$Local = function (a) {
	return {ctor: 'Local', _0: a};
};
var _user$project$Map_Data_Layer_Vector$localLoadMethod = function (value) {
	return _user$project$Map_Data_Layer_Vector$Local(value);
};
var _user$project$Map_Data_Layer_Vector$RestServer = F2(
	function (a, b) {
		return {ctor: 'RestServer', _0: a, _1: b};
	});
var _user$project$Map_Data_Layer_Vector$InExtent = function (a) {
	return {ctor: 'InExtent', _0: a};
};
var _user$project$Map_Data_Layer_Vector$inExtentLoadMethod = F2(
	function (url, urlSuffix) {
		return A2(
			_user$project$Map_Data_Layer_Vector$RestServer,
			url,
			_user$project$Map_Data_Layer_Vector$InExtent(urlSuffix));
	});
var _user$project$Map_Data_Layer_Vector$Batch = {ctor: 'Batch'};
var _user$project$Map_Data_Layer_Vector$batchLoadMethod = function (url) {
	return A2(_user$project$Map_Data_Layer_Vector$RestServer, url, _user$project$Map_Data_Layer_Vector$Batch);
};
var _user$project$Map_Data_Layer_Vector$EsriJson = function (a) {
	return {ctor: 'EsriJson', _0: a};
};
var _user$project$Map_Data_Layer_Vector$esriJsonFormat = _user$project$Map_Data_Layer_Vector$EsriJson(
	{idPath: _elm_lang$core$Maybe$Nothing, subObjPath: _elm_lang$core$Maybe$Nothing, subObjIdPath: _elm_lang$core$Maybe$Nothing});
var _user$project$Map_Data_Layer_Vector$esriJsonFormatWithParams = function (params) {
	return _user$project$Map_Data_Layer_Vector$EsriJson(
		{idPath: params.idPath, subObjPath: params.subObjPath, subObjIdPath: params.subObjIdPath});
};
var _user$project$Map_Data_Layer_Vector$GeoJson = function (a) {
	return {ctor: 'GeoJson', _0: a};
};
var _user$project$Map_Data_Layer_Vector$geoJsonFormat = _user$project$Map_Data_Layer_Vector$GeoJson(
	{idPath: _elm_lang$core$Maybe$Nothing, subObjPath: _elm_lang$core$Maybe$Nothing, subObjIdPath: _elm_lang$core$Maybe$Nothing});
var _user$project$Map_Data_Layer_Vector$geoJsonFormatWithParams = function (params) {
	return _user$project$Map_Data_Layer_Vector$GeoJson(
		{idPath: params.idPath, subObjPath: params.subObjPath, subObjIdPath: params.subObjIdPath});
};
var _user$project$Map_Data_Layer_Vector$StandardGeoJson = function (a) {
	return {ctor: 'StandardGeoJson', _0: a};
};
var _user$project$Map_Data_Layer_Vector$standardGeoJsonFormat = _user$project$Map_Data_Layer_Vector$StandardGeoJson(
	{idPath: _elm_lang$core$Maybe$Nothing, subObjPath: _elm_lang$core$Maybe$Nothing, subObjIdPath: _elm_lang$core$Maybe$Nothing});
var _user$project$Map_Data_Layer_Vector$standardGeoJsonFormatWithParams = function (params) {
	return _user$project$Map_Data_Layer_Vector$StandardGeoJson(
		{idPath: params.idPath, subObjPath: params.subObjPath, subObjIdPath: params.subObjIdPath});
};
var _user$project$Map_Data_Layer_Vector$DefaultClusterFn = function (a) {
	return {ctor: 'DefaultClusterFn', _0: a};
};
var _user$project$Map_Data_Layer_Vector$defaultClusterFn = _user$project$Map_Data_Layer_Vector$DefaultClusterFn(
	{distance: _elm_lang$core$Maybe$Nothing, objsReturnedOnClick: 0});
var _user$project$Map_Data_Layer_Vector$clusterFnWithDistance = function (dist) {
	return _user$project$Map_Data_Layer_Vector$DefaultClusterFn(
		{
			distance: _elm_lang$core$Maybe$Just(dist),
			objsReturnedOnClick: 0
		});
};
var _user$project$Map_Data_Layer_Vector$NoClusters = {ctor: 'NoClusters'};
var _user$project$Map_Data_Layer_Vector$fromEssentialParams = function (vdata) {
	return {
		key: vdata.key,
		name: vdata.name,
		info: vdata.info,
		isVisible: true,
		opacity: 1,
		isInfoExpanded: false,
		isSettingsExpanded: false,
		loadMethod: vdata.loadMethod,
		format: _user$project$Map_Data_Layer_Vector$GeoJson(
			A3(_user$project$Map_Data_Layer_Vector$FormatData, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing)),
		clusterOptions: _user$project$Map_Data_Layer_Vector$NoClusters,
		minResolution: _elm_lang$core$Maybe$Nothing,
		maxResolution: vdata.maxResolution,
		select: false,
		style: function () {
			var _p8 = vdata.styleObjName;
			if (_p8.ctor === 'Nothing') {
				return _user$project$Map_Data_Layer_VectorStyle$noStyle;
			} else {
				return _user$project$Map_Data_Layer_VectorStyle$uniqueStyle(_p8._0);
			}
		}(),
		urlRequest: vdata.urlRequest,
		legend: _elm_lang$core$Maybe$Nothing
	};
};
var _user$project$Map_Data_Layer_Vector$noCluster = _user$project$Map_Data_Layer_Vector$NoClusters;
var _user$project$Map_Data_Layer_Vector$returnNbOfClusterObjsWhenClicked = F2(
	function (objsNb, clusterOptions) {
		var _p9 = clusterOptions;
		if (_p9.ctor === 'NoClusters') {
			return _user$project$Map_Data_Layer_Vector$NoClusters;
		} else {
			var newOpts = _elm_lang$core$Native_Utils.update(
				_p9._0,
				{objsReturnedOnClick: objsNb});
			return _user$project$Map_Data_Layer_Vector$DefaultClusterFn(newOpts);
		}
	});

var _user$project$Map_Data_Layer$encodeSingleLayer = function (sldata) {
	var _p0 = sldata;
	switch (_p0.ctor) {
		case 'WmtsLayer':
			return _user$project$Map_Data_Layer_Wmts$encode(_p0._0);
		case 'WmsTileLayer':
			return _user$project$Map_Data_Layer_WmsTile$encode(_p0._0);
		case 'TilesLayer':
			return _user$project$Map_Data_Layer_Tiles$encode(_p0._0);
		default:
			return _user$project$Map_Data_Layer_Vector$encode(_p0._0);
	}
};
var _user$project$Map_Data_Layer$encode = function (layer) {
	var _p1 = layer;
	if (_p1.ctor === 'SingleLayer') {
		return _user$project$Map_Data_Layer$encodeSingleLayer(_p1._0);
	} else {
		return _user$project$Map_Data_Layer$encodeGroup(_p1._0);
	}
};
var _user$project$Map_Data_Layer$encodeGroup = function (gdata) {
	var encLayers = A2(_elm_lang$core$List$map, _user$project$Map_Data_Layer$encode, gdata.layers);
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'type',
				_1: _elm_lang$core$Json_Encode$string('Group')
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'key',
					_1: _elm_lang$core$Json_Encode$string(gdata.key)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'isVisible',
						_1: _elm_lang$core$Json_Encode$bool(gdata.isVisible)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'opacity',
							_1: _elm_lang$core$Json_Encode$float(gdata.opacity)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'layers',
								_1: _elm_lang$core$Json_Encode$list(encLayers)
							},
							_1: {ctor: '[]'}
						}
					}
				}
			}
		});
};
var _user$project$Map_Data_Layer$encodeList = function (layers) {
	return _elm_lang$core$Json_Encode$list(
		A2(_elm_lang$core$List$map, _user$project$Map_Data_Layer$encode, layers));
};
var _user$project$Map_Data_Layer$getUrlRequest = function (ldata) {
	var _p2 = ldata;
	switch (_p2.ctor) {
		case 'WmtsLayer':
			return _p2._0.urlRequest;
		case 'WmsTileLayer':
			return _p2._0.urlRequest;
		case 'TilesLayer':
			return _p2._0.urlRequest;
		default:
			return _p2._0.urlRequest;
	}
};
var _user$project$Map_Data_Layer$getMinResolution = function (ldata) {
	var _p3 = ldata;
	switch (_p3.ctor) {
		case 'WmtsLayer':
			return _p3._0.minResolution;
		case 'WmsTileLayer':
			return _p3._0.minResolution;
		case 'VectorLayer':
			return _p3._0.minResolution;
		default:
			return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Map_Data_Layer$getMaxResolution = function (ldata) {
	var _p4 = ldata;
	switch (_p4.ctor) {
		case 'WmtsLayer':
			return _p4._0.maxResolution;
		case 'WmsTileLayer':
			return _p4._0.maxResolution;
		case 'VectorLayer':
			return _p4._0.maxResolution;
		default:
			return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Map_Data_Layer$getOpacity = function (ldata) {
	var _p5 = ldata;
	switch (_p5.ctor) {
		case 'WmtsLayer':
			return _p5._0.opacity;
		case 'WmsTileLayer':
			return _p5._0.opacity;
		case 'TilesLayer':
			return _p5._0.opacity;
		default:
			return _p5._0.opacity;
	}
};
var _user$project$Map_Data_Layer$getVisibility = function (ldata) {
	var _p6 = ldata;
	switch (_p6.ctor) {
		case 'WmtsLayer':
			return _p6._0.isVisible;
		case 'WmsTileLayer':
			return _p6._0.isVisible;
		case 'TilesLayer':
			return _p6._0.isVisible;
		default:
			return _p6._0.isVisible;
	}
};
var _user$project$Map_Data_Layer$getInfo = function (ldata) {
	var _p7 = ldata;
	switch (_p7.ctor) {
		case 'WmtsLayer':
			return _p7._0.info;
		case 'WmsTileLayer':
			return _p7._0.info;
		case 'TilesLayer':
			return _p7._0.info;
		default:
			return _p7._0.info;
	}
};
var _user$project$Map_Data_Layer$getIsSettingsExp = function (ldata) {
	var _p8 = ldata;
	switch (_p8.ctor) {
		case 'WmtsLayer':
			return _p8._0.isSettingsExpanded;
		case 'WmsTileLayer':
			return _p8._0.isSettingsExpanded;
		case 'TilesLayer':
			return _p8._0.isSettingsExpanded;
		default:
			return _p8._0.isSettingsExpanded;
	}
};
var _user$project$Map_Data_Layer$getIsInfoExp = function (ldata) {
	var _p9 = ldata;
	switch (_p9.ctor) {
		case 'WmtsLayer':
			return _p9._0.isInfoExpanded;
		case 'WmsTileLayer':
			return _p9._0.isInfoExpanded;
		case 'TilesLayer':
			return _p9._0.isInfoExpanded;
		default:
			return _p9._0.isInfoExpanded;
	}
};
var _user$project$Map_Data_Layer$getName = function (ldata) {
	var _p10 = ldata;
	switch (_p10.ctor) {
		case 'WmtsLayer':
			return _p10._0.name;
		case 'WmsTileLayer':
			return _p10._0.name;
		case 'TilesLayer':
			return _p10._0.name;
		default:
			return _p10._0.name;
	}
};
var _user$project$Map_Data_Layer$getKey = function (ldata) {
	var _p11 = ldata;
	switch (_p11.ctor) {
		case 'WmtsLayer':
			return _p11._0.key;
		case 'WmsTileLayer':
			return _p11._0.key;
		case 'TilesLayer':
			return _p11._0.key;
		default:
			return _p11._0.key;
	}
};
var _user$project$Map_Data_Layer$getLayerData = function (layer) {
	var _p12 = layer;
	if (_p12.ctor === 'SingleLayer') {
		return _elm_lang$core$Maybe$Just(_p12._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Map_Data_Layer$opacityConfig = {max: 1.0, min: 0.0, step: 0.1};
var _user$project$Map_Data_Layer$LayerGroup = function (a) {
	return {ctor: 'LayerGroup', _0: a};
};
var _user$project$Map_Data_Layer$groupFromParams = function (gdata) {
	return _user$project$Map_Data_Layer$LayerGroup(
		{key: gdata.key, name: gdata.name, info: gdata.info, isVisible: gdata.isVisible, opacity: gdata.opacity, isExpanded: gdata.isExpanded, layers: gdata.layers, isInfoExpanded: false, isSettingsExpanded: false, reverseLayerListDisp: gdata.reverseLayerListDisp});
};
var _user$project$Map_Data_Layer$SingleLayer = function (a) {
	return {ctor: 'SingleLayer', _0: a};
};
var _user$project$Map_Data_Layer$VectorLayer = function (a) {
	return {ctor: 'VectorLayer', _0: a};
};
var _user$project$Map_Data_Layer$vectorFromEssentialParams = function (_p13) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$VectorLayer(
			_user$project$Map_Data_Layer_Vector$fromEssentialParams(_p13)));
};
var _user$project$Map_Data_Layer$vectorFromAllParams = function (_p14) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$VectorLayer(
			_user$project$Map_Data_Layer_Vector$fromAllParams(_p14)));
};
var _user$project$Map_Data_Layer$TilesLayer = function (a) {
	return {ctor: 'TilesLayer', _0: a};
};
var _user$project$Map_Data_Layer$xyzTilesFromParams = function (_p15) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$TilesLayer(
			_user$project$Map_Data_Layer_Tiles$xyzImg(_p15)));
};
var _user$project$Map_Data_Layer$mapBoxVectorTilesFromParams = function (_p16) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$TilesLayer(
			_user$project$Map_Data_Layer_Tiles$mapBoxVector(_p16)));
};
var _user$project$Map_Data_Layer$WmsTileLayer = function (a) {
	return {ctor: 'WmsTileLayer', _0: a};
};
var _user$project$Map_Data_Layer$wmsTileFromParams = function (_p17) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$WmsTileLayer(
			_user$project$Map_Data_Layer_WmsTile$fromParams(_p17)));
};
var _user$project$Map_Data_Layer$wmsTileFromParamsWithResolution = function (_p18) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$WmsTileLayer(
			_user$project$Map_Data_Layer_WmsTile$fromParamsWithResoltion(_p18)));
};
var _user$project$Map_Data_Layer$wmsTileFromParamsWithScale = function (_p19) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$WmsTileLayer(
			_user$project$Map_Data_Layer_WmsTile$fromParamsWithScale(_p19)));
};
var _user$project$Map_Data_Layer$WmtsLayer = function (a) {
	return {ctor: 'WmtsLayer', _0: a};
};
var _user$project$Map_Data_Layer$wmtsFromParams = function (_p20) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$WmtsLayer(
			_user$project$Map_Data_Layer_Wmts$fromParams(_p20)));
};
var _user$project$Map_Data_Layer$wmtsFromParamsWithResolution = function (_p21) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$WmtsLayer(
			_user$project$Map_Data_Layer_Wmts$fromParamsWithResoltion(_p21)));
};
var _user$project$Map_Data_Layer$wmtsFromParamsWithScale = function (_p22) {
	return _user$project$Map_Data_Layer$SingleLayer(
		_user$project$Map_Data_Layer$WmtsLayer(
			_user$project$Map_Data_Layer_Wmts$fromParamsWithScale(_p22)));
};
var _user$project$Map_Data_Layer$addLegendToRasterLayer = F2(
	function (legend, layer) {
		var _p23 = layer;
		if (_p23.ctor === 'LayerGroup') {
			return layer;
		} else {
			var _p24 = _p23._0;
			switch (_p24.ctor) {
				case 'VectorLayer':
					return layer;
				case 'WmsTileLayer':
					return _user$project$Map_Data_Layer$SingleLayer(
						_user$project$Map_Data_Layer$WmsTileLayer(
							A2(_user$project$Map_Data_Layer_WmsTile$addLegend, legend, _p24._0)));
				case 'WmtsLayer':
					return _user$project$Map_Data_Layer$SingleLayer(
						_user$project$Map_Data_Layer$WmtsLayer(
							A2(_user$project$Map_Data_Layer_Wmts$addLegend, legend, _p24._0)));
				default:
					return _user$project$Map_Data_Layer$SingleLayer(
						_user$project$Map_Data_Layer$TilesLayer(
							A2(_user$project$Map_Data_Layer_Tiles$addLegendToXyzTiles, legend, _p24._0)));
			}
		}
	});

var _user$project$Map_Data_MapSettings$MapSettingsData = F6(
	function (a, b, c, d, e, f) {
		return {projection: a, extent: b, center: c, zoom: d, geolocAndBlink: e, showCustomPanel: f};
	});
var _user$project$Map_Data_MapSettings$Projection = F2(
	function (a, b) {
		return {code: a, proj4String: b};
	});
var _user$project$Map_Data_MapSettings$MapSettings = function (a) {
	return {ctor: 'MapSettings', _0: a};
};
var _user$project$Map_Data_MapSettings$fromCoreParams = function (_p0) {
	var _p1 = _p0;
	var _p4 = _p1.projection;
	var _p3 = _p1.extent;
	var _p2 = _p1.center;
	return _user$project$Map_Data_MapSettings$MapSettings(
		{
			projection: {code: _p4.code, proj4String: _p4.proj4String},
			extent: {minx: _p3.minx, miny: _p3.miny, maxx: _p3.maxx, maxy: _p3.maxy},
			center: {x: _p2.x, y: _p2.y},
			zoom: _p1.zoom,
			geolocAndBlink: _p1.geolocAndBlink,
			showCustomPanel: false
		});
};
var _user$project$Map_Data_MapSettings$fromAllParams = function (_p5) {
	var _p6 = _p5;
	var _p9 = _p6.projection;
	var _p8 = _p6.extent;
	var _p7 = _p6.center;
	return _user$project$Map_Data_MapSettings$MapSettings(
		{
			projection: {code: _p9.code, proj4String: _p9.proj4String},
			extent: {minx: _p8.minx, miny: _p8.miny, maxx: _p8.maxx, maxy: _p8.maxy},
			center: {x: _p7.x, y: _p7.y},
			zoom: _p6.zoom,
			geolocAndBlink: _p6.geolocAndBlink,
			showCustomPanel: _p6.showCustomPanel
		});
};

var _user$project$Map_Data_Mode_OutMsg$FeatureData = F5(
	function (a, b, c, d, e) {
		return {layerKey: a, id: b, data: c, rootId: d, rootData: e};
	});
var _user$project$Map_Data_Mode_OutMsg$GeomData = F2(
	function (a, b) {
		return {layerKey: a, geom: b};
	});
var _user$project$Map_Data_Mode_OutMsg$CaptureCanvasEnded = function (a) {
	return {ctor: 'CaptureCanvasEnded', _0: a};
};
var _user$project$Map_Data_Mode_OutMsg$AddGeomEnded = F2(
	function (a, b) {
		return {ctor: 'AddGeomEnded', _0: a, _1: b};
	});
var _user$project$Map_Data_Mode_OutMsg$SelectUpdated = F3(
	function (a, b, c) {
		return {ctor: 'SelectUpdated', _0: a, _1: b, _2: c};
	});
var _user$project$Map_Data_Mode_OutMsg$NoOutMsg = {ctor: 'NoOutMsg'};

var _user$project$Map_Data_Defaults$germanModeErrorToElement = F2(
	function (_p0, modeError) {
		var _p1 = _p0;
		var _p3 = _p1._0;
		var _p2 = modeError;
		if (_p2.ctor === 'Just') {
			if (_p2._0 === 'mapmodule_geozone_not_allowed') {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p3.error,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text('Ausser vom erlaubten Gebiet'));
			} else {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p3.error,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(_p2._0));
			}
		} else {
			return _mdgriffith$style_elements$Element$empty;
		}
	});
var _user$project$Map_Data_Defaults$germanModeToElement = function (mode) {
	var _p4 = mode;
	_v2_19:
	do {
		switch (_p4.ctor) {
			case 'NormalMode':
				return _mdgriffith$style_elements$Element$empty;
			case 'Wait':
				return _mdgriffith$style_elements$Element$text('Aktualisierung in Arbeit...');
			case 'SelectObjs':
				return _mdgriffith$style_elements$Element$text('Auf Klick auswählen');
			case 'AddGeom':
				return _mdgriffith$style_elements$Element$text('Geometrie Hinzufügung');
			case 'AddPointFromCurPos':
				return _mdgriffith$style_elements$Element$text('Neuer Punkt an der aktuellen Position');
			case 'ModifyGeoms':
				switch (_p4._0.ctor) {
					case 'ModifyOp':
						return _mdgriffith$style_elements$Element$text('Geometrie Edition');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Speicherung der Veränderungen');
					default:
						break _v2_19;
				}
			case 'DeleteObjs':
				switch (_p4._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Auswahl der Elementen zu löschen');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Elemente löschen');
					default:
						break _v2_19;
				}
			case 'MergePolys':
				switch (_p4._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Fusion (1/3): Auswahl');
					case 'MergeOp':
						return _mdgriffith$style_elements$Element$text('Fusion (2/3): Berechnung');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Fusion (3/3): Speicherung');
					default:
						break _v2_19;
				}
			case 'SplitPolys':
				switch (_p4._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Teilung (1/4): Auswahl');
					case 'DrawOp':
						return _mdgriffith$style_elements$Element$text('Teilung (2/4): Teilungs Linie');
					case 'SplitOp':
						return _mdgriffith$style_elements$Element$text('Teilung (3/4): Berechnung');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Teilungs (4/4): Speicherung');
					default:
						break _v2_19;
				}
			case 'BreakupPolys':
				switch (_p4._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Zerlegung (1/3): Auswahl');
					case 'MergeOp':
						return _mdgriffith$style_elements$Element$text('Zerlegung (2/3): Berechnung');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Zerlegung (3/3): Speicherung');
					default:
						break _v2_19;
				}
			default:
				break _v2_19;
		}
	} while(false);
	return _mdgriffith$style_elements$Element$text('no message for this mode');
};
var _user$project$Map_Data_Defaults$frenchModeErrorToElement = F2(
	function (_p5, modeError) {
		var _p6 = _p5;
		var _p8 = _p6._0;
		var _p7 = modeError;
		if (_p7.ctor === 'Just') {
			if (_p7._0 === 'mapmodule_geozone_not_allowed') {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p8.error,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text('Hors zone de droits!'));
			} else {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p8.error,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(_p7._0));
			}
		} else {
			return _mdgriffith$style_elements$Element$empty;
		}
	});
var _user$project$Map_Data_Defaults$frenchModeToElement = function (mode) {
	var _p9 = mode;
	_v5_19:
	do {
		switch (_p9.ctor) {
			case 'NormalMode':
				return _mdgriffith$style_elements$Element$empty;
			case 'Wait':
				return _mdgriffith$style_elements$Element$text('En attente de mise à jour...');
			case 'SelectObjs':
				return _mdgriffith$style_elements$Element$text('Sélection par clic');
			case 'AddGeom':
				return _mdgriffith$style_elements$Element$text('Ajout de géométrie');
			case 'AddPointFromCurPos':
				return _mdgriffith$style_elements$Element$text('Création de point à la position actuelle');
			case 'ModifyGeoms':
				switch (_p9._0.ctor) {
					case 'ModifyOp':
						return _mdgriffith$style_elements$Element$text('Edition des géométries');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Sauvegarde des modifications');
					default:
						break _v5_19;
				}
			case 'DeleteObjs':
				switch (_p9._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Sélection des éléments à supprimer');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Suppression des éléments');
					default:
						break _v5_19;
				}
			case 'MergePolys':
				switch (_p9._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Fusion (1/3): sélection');
					case 'MergeOp':
						return _mdgriffith$style_elements$Element$text('Fusion (2/3): calcul');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Fusion (3/3): sauvegarde');
					default:
						break _v5_19;
				}
			case 'SplitPolys':
				switch (_p9._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Division (1/4): sélection');
					case 'DrawOp':
						return _mdgriffith$style_elements$Element$text('Division (2/4): ligne de division');
					case 'SplitOp':
						return _mdgriffith$style_elements$Element$text('Division (3/4): calcul');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Division (4/4): sauvegarde');
					default:
						break _v5_19;
				}
			case 'BreakupPolys':
				switch (_p9._0.ctor) {
					case 'SelectOp':
						return _mdgriffith$style_elements$Element$text('Décomposition (1/3): sélection');
					case 'BreakupOp':
						return _mdgriffith$style_elements$Element$text('Décomposition (2/3): calcul');
					case 'SaveOp':
						return _mdgriffith$style_elements$Element$text('Décomposition (3/3): sauvegarde');
					default:
						break _v5_19;
				}
			default:
				break _v5_19;
		}
	} while(false);
	return _mdgriffith$style_elements$Element$text('no message for this mode');
};
var _user$project$Map_Data_Defaults$mayFloatPosToStr = function (mayPosFloat) {
	return A2(
		_elm_lang$core$Maybe$withDefault,
		'?',
		A2(_elm_lang$core$Maybe$map, _elm_lang$core$Basics$toString, mayPosFloat));
};
var _user$project$Map_Data_Defaults$uiBitsContentCustomModeToEl = F4(
	function (lang, _p10, normalModeBar, mayCustomModeToElement) {
		var _p11 = _p10;
		var _p63 = _p11._0;
		var buttonSz = 24;
		var iconSz = 20;
		var infoSz = 14;
		return {
			normalModeBar: normalModeBar,
			mode: function () {
				var _p12 = mayCustomModeToElement;
				if (_p12.ctor === 'Just') {
					var _p14 = _p12._0;
					var _p13 = lang;
					if (_p13.ctor === 'French') {
						return _p14.french;
					} else {
						return _p14.german;
					}
				} else {
					var _p15 = lang;
					if (_p15.ctor === 'French') {
						return _user$project$Map_Data_Defaults$frenchModeToElement;
					} else {
						return _user$project$Map_Data_Defaults$germanModeToElement;
					}
				}
			}(),
			modeError: function () {
				var _p16 = lang;
				if (_p16.ctor === 'French') {
					return _user$project$Map_Data_Defaults$frenchModeErrorToElement(
						_user$project$Map_Data_Styles$Styling(_p63));
				} else {
					return _user$project$Map_Data_Defaults$germanModeErrorToElement(
						_user$project$Map_Data_Styles$Styling(_p63));
				}
			}(),
			selectionOutOfRange: F2(
				function (min, max) {
					return A3(
						_mdgriffith$style_elements$Element$el,
						_p63.warning,
						{ctor: '[]'},
						_mdgriffith$style_elements$Element$text(
							function () {
								var _p17 = lang;
								if (_p17.ctor === 'French') {
									return _elm_lang$core$Native_Utils.eq(max, _elm_lang$core$Random$maxInt) ? A2(
										_elm_lang$core$Basics_ops['++'],
										'Sélectionner au moins ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(min),
											' élément')) : A2(
										_elm_lang$core$Basics_ops['++'],
										'Sélectionner entre ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(min),
											A2(
												_elm_lang$core$Basics_ops['++'],
												' et ',
												A2(
													_elm_lang$core$Basics_ops['++'],
													_elm_lang$core$Basics$toString(max),
													' éléments'))));
								} else {
									return _elm_lang$core$Native_Utils.eq(max, _elm_lang$core$Random$maxInt) ? A2(
										_elm_lang$core$Basics_ops['++'],
										'Mindestens ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(min),
											' Element auswählen')) : A2(
										_elm_lang$core$Basics_ops['++'],
										'Zwischen ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(min),
											A2(
												_elm_lang$core$Basics_ops['++'],
												' und ',
												A2(
													_elm_lang$core$Basics_ops['++'],
													_elm_lang$core$Basics$toString(max),
													' Elementen auswählen'))));
								}
							}()));
				}),
			selectionOk: function (nb) {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p63.success,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(
						function () {
							var _p18 = lang;
							if (_p18.ctor === 'French') {
								return _elm_lang$core$Native_Utils.eq(nb, 1) ? '1 élément sélectionné' : A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(nb),
									' éléments sélectionnés');
							} else {
								return _elm_lang$core$Native_Utils.eq(nb, 1) ? '1 ausgewähltes Element' : A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(nb),
									' ausgewählte Elemente');
							}
						}()));
			},
			modifNothing: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.warning,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p19 = lang;
						if (_p19.ctor === 'French') {
							return 'Pas de modifications';
						} else {
							return 'Keine veränderungen';
						}
					}())),
			modifOk: function (nb) {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p63.success,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(
						function () {
							var _p20 = lang;
							if (_p20.ctor === 'French') {
								return _elm_lang$core$Native_Utils.eq(nb, 1) ? '1 élément modifié' : A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(nb),
									' éléments modifiés');
							} else {
								return _elm_lang$core$Native_Utils.eq(nb, 1) ? '1 verändertes Element' : A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(nb),
									' veränderte Elemente');
							}
						}()));
			},
			drawNothing: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.warning,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p21 = lang;
						if (_p21.ctor === 'French') {
							return 'Dessin pas terminé';
						} else {
							return 'Skizze nicht abgeschlossen';
						}
					}())),
			drawOk: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.success,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text('Ok')),
			drawPtAtCurPosWaiting: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.warning,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p22 = lang;
						if (_p22.ctor === 'French') {
							return 'En attente de la position...';
						} else {
							return 'Warten auf Position. . .';
						}
					}())),
			drawPtAtCurPosReceived: function (curPosData) {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p63.success,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(
						_elm_lang$core$String$concat(
							{
								ctor: '::',
								_0: 'x: ',
								_1: {
									ctor: '::',
									_0: _user$project$Map_Data_Defaults$mayFloatPosToStr(curPosData.x),
									_1: {
										ctor: '::',
										_0: ', y: ',
										_1: {
											ctor: '::',
											_0: _user$project$Map_Data_Defaults$mayFloatPosToStr(curPosData.y),
											_1: {
												ctor: '::',
												_0: ', z: ',
												_1: {
													ctor: '::',
													_0: _user$project$Map_Data_Defaults$mayFloatPosToStr(curPosData.z),
													_1: {
														ctor: '::',
														_0: ', x,y +/- ',
														_1: {
															ctor: '::',
															_0: _user$project$Map_Data_Defaults$mayFloatPosToStr(curPosData.xyAccuracy),
															_1: {
																ctor: '::',
																_0: ', z +/- ',
																_1: {
																	ctor: '::',
																	_0: _user$project$Map_Data_Defaults$mayFloatPosToStr(curPosData.zAccuracy),
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							})));
			},
			saveWorking: A3(
				_mdgriffith$style_elements$Element$row,
				_p63.none,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_p63.warningBtn,
						{ctor: '[]'},
						A3(
							_mdgriffith$style_elements$Element$image,
							_p63.btnImg,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$height(
									_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
									_1: {ctor: '[]'}
								}
							},
							{
								src: './images/saving.svg',
								caption: function () {
									var _p23 = lang;
									if (_p23.ctor === 'French') {
										return 'Sauvegarde en cours';
									} else {
										return 'Laufende Speicherung';
									}
								}()
							})),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_p63.warning,
							{ctor: '[]'},
							_mdgriffith$style_elements$Element$text(
								function () {
									var _p24 = lang;
									if (_p24.ctor === 'French') {
										return 'En cours...';
									} else {
										return 'Im Gang...';
									}
								}())),
						_1: {ctor: '[]'}
					}
				}),
			saveFailed: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.error,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p25 = lang;
						if (_p25.ctor === 'French') {
							return 'Echec (voir console)';
						} else {
							return 'Misserfolg (siehe Konsole)';
						}
					}())),
			saveOk: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.success,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text('Ok')),
			mergeOk: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.success,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p26 = lang;
						if (_p26.ctor === 'French') {
							return 'Fusion réussie';
						} else {
							return 'Fusion gelungen';
						}
					}())),
			mergeNotOk: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.error,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p27 = lang;
						if (_p27.ctor === 'French') {
							return 'Echec de la fusion';
						} else {
							return 'Misserfolg der Fusion';
						}
					}())),
			splitOk: function (nb) {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p63.success,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(
						function () {
							var _p28 = lang;
							if (_p28.ctor === 'French') {
								return A2(
									_elm_lang$core$Basics_ops['++'],
									'Division réussie: ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(nb),
										' éléments créés'));
							} else {
								return A2(
									_elm_lang$core$Basics_ops['++'],
									'Teilung gelungen: ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(nb),
										' Elementen geschaft'));
							}
						}()));
			},
			splitNotOk: function (mayNb) {
				return _elm_lang$core$Native_Utils.eq(mayNb, _elm_lang$core$Maybe$Nothing) ? A3(
					_mdgriffith$style_elements$Element$el,
					_p63.error,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(
						function () {
							var _p29 = lang;
							if (_p29.ctor === 'French') {
								return 'Echec de la division';
							} else {
								return 'Misserfolg der Teilung';
							}
						}())) : A3(
					_mdgriffith$style_elements$Element$el,
					_p63.warning,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(
						function () {
							var _p30 = lang;
							if (_p30.ctor === 'French') {
								return 'Pas de nouveaux éléments';
							} else {
								return 'Keine neue Elemente';
							}
						}()));
			},
			breakupOk: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.success,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p31 = lang;
						if (_p31.ctor === 'French') {
							return 'Décomposition réussie';
						} else {
							return 'Zerlegung gelungen';
						}
					}())),
			breakupNotOk: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.error,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p32 = lang;
						if (_p32.ctor === 'French') {
							return 'Echec de la décomposition';
						} else {
							return 'Misserfolg der Zerlegung';
						}
					}())),
			labelOpacity: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.label,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p33 = lang;
						if (_p33.ctor === 'French') {
							return 'Opacité';
						} else {
							return 'Undurchsichtigkeit';
						}
					}())),
			getInSelOk: function (nb) {
				return A3(
					_mdgriffith$style_elements$Element$el,
					_p63.success,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text(
						function () {
							var _p34 = lang;
							if (_p34.ctor === 'French') {
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(nb),
									' éléments sélectionnés');
							} else {
								return A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(nb),
									' ausgewählte Elemente');
							}
						}()));
			},
			getInSelNotOk: A3(
				_mdgriffith$style_elements$Element$el,
				_p63.error,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(
					function () {
						var _p35 = lang;
						if (_p35.ctor === 'French') {
							return 'Echec de la sélection';
						} else {
							return 'Misserfolg der Auswahl';
						}
					}())),
			cancelButtonContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/cancel.svg',
					caption: function () {
						var _p36 = lang;
						if (_p36.ctor === 'French') {
							return 'Annuler';
						} else {
							return 'Stornieren';
						}
					}()
				}),
			nextButtonContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/next.svg',
					caption: function () {
						var _p37 = lang;
						if (_p37.ctor === 'French') {
							return 'Suivant';
						} else {
							return 'Folgender';
						}
					}()
				}),
			saveButtonContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/save.svg',
					caption: function () {
						var _p38 = lang;
						if (_p38.ctor === 'French') {
							return 'Sauvegarder';
						} else {
							return 'Speichern';
						}
					}()
				}),
			doneButtonContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/done.svg',
					caption: function () {
						var _p39 = lang;
						if (_p39.ctor === 'French') {
							return 'Valider';
						} else {
							return 'Bestätigen';
						}
					}()
				}),
			layersControlTitle: function () {
				var _p40 = lang;
				if (_p40.ctor === 'French') {
					return _mdgriffith$style_elements$Element$text('Couches et légendes');
				} else {
					return _mdgriffith$style_elements$Element$text('Layern und Legenden');
				}
			}(),
			openLayerPanelBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/open_layers.svg',
					caption: function () {
						var _p41 = lang;
						if (_p41.ctor === 'French') {
							return 'Ouvrir';
						} else {
							return 'Aufklappen';
						}
					}()
				}),
			closeLayerPanelBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/close_layers.svg',
					caption: function () {
						var _p42 = lang;
						if (_p42.ctor === 'French') {
							return 'Fermer';
						} else {
							return 'Zuklappen';
						}
					}()
				}),
			openLayerFileBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/open_layer.svg',
					caption: function () {
						var _p43 = lang;
						if (_p43.ctor === 'French') {
							return 'Ouvrir';
						} else {
							return 'Öffnen';
						}
					}()
				}),
			closeBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(12)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(12)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/close.svg',
					caption: function () {
						var _p44 = lang;
						if (_p44.ctor === 'French') {
							return 'Fermer';
						} else {
							return 'Schliessen';
						}
					}()
				}),
			layerSettingsBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(18)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(18)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/layer_settings.svg',
					caption: function () {
						var _p45 = lang;
						if (_p45.ctor === 'French') {
							return 'Configuration';
						} else {
							return 'Konfiguration';
						}
					}()
				}),
			plusBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(17)),
					_1: {ctor: '[]'}
				},
				{
					src: './images/plus.svg',
					caption: function () {
						var _p46 = lang;
						if (_p46.ctor === 'French') {
							return 'Augmenter l\'opacité';
						} else {
							return 'Undurchsichtigkeit erhöhen';
						}
					}()
				}),
			greyedPlusBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(17)),
					_1: {ctor: '[]'}
				},
				{
					src: './images/greyed_plus.svg',
					caption: function () {
						var _p47 = lang;
						if (_p47.ctor === 'French') {
							return 'Augmenter l\'opacité';
						} else {
							return 'Undurchsichtigkeit erhöhen';
						}
					}()
				}),
			minusBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(17)),
					_1: {ctor: '[]'}
				},
				{
					src: './images/minus.svg',
					caption: function () {
						var _p48 = lang;
						if (_p48.ctor === 'French') {
							return 'Diminuer l\'opacité';
						} else {
							return 'Undurchsichtigkeit reduzieren';
						}
					}()
				}),
			greyedMinusBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(17)),
					_1: {ctor: '[]'}
				},
				{
					src: './images/greyed_minus.svg',
					caption: function () {
						var _p49 = lang;
						if (_p49.ctor === 'French') {
							return 'Diminuer l\'opacité';
						} else {
							return 'Undurchsichtigkeit reduzieren';
						}
					}()
				}),
			moreBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{ctor: '[]'},
				{
					src: './images/arrowBtnR.svg',
					caption: function () {
						var _p50 = lang;
						if (_p50.ctor === 'French') {
							return 'Ouvrir';
						} else {
							return 'Aufklappen';
						}
					}()
				}),
			lessBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{ctor: '[]'},
				{
					src: './images/arrowBtnD.svg',
					caption: function () {
						var _p51 = lang;
						if (_p51.ctor === 'French') {
							return 'Fermer';
						} else {
							return 'Zuklappen';
						}
					}()
				}),
			moreInfoBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(infoSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(infoSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/arrowR.svg',
					caption: function () {
						var _p52 = lang;
						if (_p52.ctor === 'French') {
							return 'Plus';
						} else {
							return 'Zunehmen';
						}
					}()
				}),
			lessInfoBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(infoSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(infoSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/arrowD.svg',
					caption: function () {
						var _p53 = lang;
						if (_p53.ctor === 'French') {
							return 'Moins';
						} else {
							return 'Abnehmen';
						}
					}()
				}),
			layerGroupIcon: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.icon,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(iconSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(iconSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/layer_group.svg',
					caption: function () {
						var _p54 = lang;
						if (_p54.ctor === 'French') {
							return 'Groupe';
						} else {
							return 'Gruppe';
						}
					}()
				}),
			vectorIcon: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.icon,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(iconSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(iconSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/vector.svg',
					caption: function () {
						var _p55 = lang;
						if (_p55.ctor === 'French') {
							return 'Vecteur';
						} else {
							return 'Vektor';
						}
					}()
				}),
			rasterIcon: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.icon,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(iconSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(iconSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/raster.svg',
					caption: function () {
						var _p56 = lang;
						if (_p56.ctor === 'French') {
							return 'Image';
						} else {
							return 'Bild';
						}
					}()
				}),
			legend: function () {
				var _p57 = lang;
				if (_p57.ctor === 'French') {
					return 'Légende';
				} else {
					return 'Legende';
				}
			}(),
			geolocOngoing: _mdgriffith$style_elements$Element$text(
				function () {
					var _p58 = lang;
					if (_p58.ctor === 'French') {
						return 'Localisation activée';
					} else {
						return 'Tracking an';
					}
				}()),
			geolocStopped: _mdgriffith$style_elements$Element$text(
				function () {
					var _p59 = lang;
					if (_p59.ctor === 'French') {
						return 'Localisation désactivée';
					} else {
						return 'Tracking aus';
					}
				}()),
			startGeolocBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/geolocStep2.svg',
					caption: function () {
						var _p60 = lang;
						if (_p60.ctor === 'French') {
							return 'Lancer';
						} else {
							return 'Starten';
						}
					}()
				}),
			startGeolocWithBlinkBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/geolocStep1.svg',
					caption: function () {
						var _p61 = lang;
						if (_p61.ctor === 'French') {
							return 'Lancer';
						} else {
							return 'Starten';
						}
					}()
				}),
			stopGeolocBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{
					src: './images/geolocStop.svg',
					caption: function () {
						var _p62 = lang;
						if (_p62.ctor === 'French') {
							return 'Lancer';
						} else {
							return 'Starten';
						}
					}()
				}),
			toggleGoogleMapBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{src: './images/map.svg', caption: 'Google Map On/Off'}),
			toggleLayerPanelBtnContent: A3(
				_mdgriffith$style_elements$Element$image,
				_p63.btnImg,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{src: './images/toggle.svg', caption: 'Custom layer panel On/Off'})
		};
	});
var _user$project$Map_Data_Defaults$uiBitsContent = F3(
	function (lang, _p64, normalModeBar) {
		var _p65 = _p64;
		return A4(
			_user$project$Map_Data_Defaults$uiBitsContentCustomModeToEl,
			lang,
			_user$project$Map_Data_Styles$Styling(_p65._0),
			normalModeBar,
			_elm_lang$core$Maybe$Nothing);
	});
var _user$project$Map_Data_Defaults$styles = function (toParentStyle) {
	return _user$project$Map_Data_Styles$Styling(
		{
			none: toParentStyle(_user$project$Map_Data_Styles$None),
			h1: toParentStyle(_user$project$Map_Data_Styles$H1),
			label: toParentStyle(_user$project$Map_Data_Styles$Label),
			checkbox: toParentStyle(_user$project$Map_Data_Styles$Checkbox),
			btn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			plusBtn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			minusBtn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			greyedPlusBtn: toParentStyle(_user$project$Map_Data_Styles$TrspDisabledBtn),
			greyedMinusBtn: toParentStyle(_user$project$Map_Data_Styles$TrspDisabledBtn),
			groupBtn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			infoBtn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			layerSettingsBtn: toParentStyle(_user$project$Map_Data_Styles$TrspNoHoverBtn),
			geolocBtn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			toggleGoogleMapBtn: toParentStyle(_user$project$Map_Data_Styles$GreyBtn),
			layersToggleBtn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			openFileBtn: toParentStyle(_user$project$Map_Data_Styles$TrspBtn),
			cancelBtn: toParentStyle(_user$project$Map_Data_Styles$CancelBtn),
			warningBtn: toParentStyle(_user$project$Map_Data_Styles$WarningBtn),
			successBtn: toParentStyle(_user$project$Map_Data_Styles$SuccessBtn),
			btnImg: toParentStyle(_user$project$Map_Data_Styles$BtnImg),
			icon: toParentStyle(_user$project$Map_Data_Styles$Icon),
			popup: toParentStyle(_user$project$Map_Data_Styles$Popup),
			popupPointerBorder: toParentStyle(_user$project$Map_Data_Styles$PopupPointerBorder),
			popupPointer: toParentStyle(_user$project$Map_Data_Styles$PopupPointer),
			mapCol: toParentStyle(_user$project$Map_Data_Styles$None),
			map: toParentStyle(_user$project$Map_Data_Styles$None),
			mapFooter: toParentStyle(_user$project$Map_Data_Styles$MapFooter),
			success: toParentStyle(_user$project$Map_Data_Styles$Success),
			warning: toParentStyle(_user$project$Map_Data_Styles$Warning),
			error: toParentStyle(_user$project$Map_Data_Styles$Error),
			layersCol: toParentStyle(_user$project$Map_Data_Styles$None),
			layer: toParentStyle(_user$project$Map_Data_Styles$Layer),
			layerData: toParentStyle(_user$project$Map_Data_Styles$None),
			layerGroup: toParentStyle(_user$project$Map_Data_Styles$LayerGroup),
			rootLayerGroup: toParentStyle(_user$project$Map_Data_Styles$None),
			layerGroupData: toParentStyle(_user$project$Map_Data_Styles$None),
			layerGroupLayers: toParentStyle(_user$project$Map_Data_Styles$None),
			legendCol: toParentStyle(_user$project$Map_Data_Styles$None),
			legendDropDown: toParentStyle(_user$project$Map_Data_Styles$Btn),
			legendElement: toParentStyle(_user$project$Map_Data_Styles$None),
			submenu: toParentStyle(_user$project$Map_Data_Styles$SubMenu),
			focused: toParentStyle(_user$project$Map_Data_Styles$Focused)
		});
};
var _user$project$Map_Data_Defaults$CustomModeToElement = F2(
	function (a, b) {
		return {french: a, german: b};
	});
var _user$project$Map_Data_Defaults$German = {ctor: 'German'};
var _user$project$Map_Data_Defaults$French = {ctor: 'French'};

var _user$project$Map_Effects_Ports$initMap = _elm_lang$core$Native_Platform.outgoingPort(
	'initMap',
	function (v) {
		return {
			divName: v.divName,
			mapSettings: {
				projection: {code: v.mapSettings.projection.code, proj4String: v.mapSettings.projection.proj4String},
				extent: {minx: v.mapSettings.extent.minx, miny: v.mapSettings.extent.miny, maxx: v.mapSettings.extent.maxx, maxy: v.mapSettings.extent.maxy},
				center: {x: v.mapSettings.center.x, y: v.mapSettings.center.y},
				zoom: v.mapSettings.zoom,
				geolocAndBlink: [v.mapSettings.geolocAndBlink._0, v.mapSettings.geolocAndBlink._1, v.mapSettings.geolocAndBlink._2],
				showCustomPanel: v.mapSettings.showCustomPanel
			},
			layers: v.layers
		};
	});
var _user$project$Map_Effects_Ports$resizeMap = _elm_lang$core$Native_Platform.outgoingPort(
	'resizeMap',
	function (v) {
		return v;
	});
var _user$project$Map_Effects_Ports$attachMapToDiv = _elm_lang$core$Native_Platform.outgoingPort(
	'attachMapToDiv',
	function (v) {
		return {map: v.map, divName: v.divName};
	});
var _user$project$Map_Effects_Ports$initGoogleMap = _elm_lang$core$Native_Platform.outgoingPort(
	'initGoogleMap',
	function (v) {
		return {map: v.map, divName: v.divName};
	});
var _user$project$Map_Effects_Ports$getCurrentPosition = _elm_lang$core$Native_Platform.outgoingPort(
	'getCurrentPosition',
	function (v) {
		return v;
	});
var _user$project$Map_Effects_Ports$drawPtAtCurPos = _elm_lang$core$Native_Platform.outgoingPort(
	'drawPtAtCurPos',
	function (v) {
		return {
			map: v.map,
			layerKey: v.layerKey,
			geoZone: (v.geoZone.ctor === 'Nothing') ? null : v.geoZone._0
		};
	});
var _user$project$Map_Effects_Ports$updateGeolocation = _elm_lang$core$Native_Platform.outgoingPort(
	'updateGeolocation',
	function (v) {
		return {map: v.map, enabled: v.enabled, panAndZoomToRes: v.panAndZoomToRes, blinking: v.blinking};
	});
var _user$project$Map_Effects_Ports$updateLayerVisibility = _elm_lang$core$Native_Platform.outgoingPort(
	'updateLayerVisibility',
	function (v) {
		return {map: v.map, layerKey: v.layerKey, isVisible: v.isVisible};
	});
var _user$project$Map_Effects_Ports$updateLayerOpacity = _elm_lang$core$Native_Platform.outgoingPort(
	'updateLayerOpacity',
	function (v) {
		return {map: v.map, layerKey: v.layerKey, opacity: v.opacity};
	});
var _user$project$Map_Effects_Ports$updateLayerStyle = _elm_lang$core$Native_Platform.outgoingPort(
	'updateLayerStyle',
	function (v) {
		return {
			map: v.map,
			layerKey: v.layerKey,
			style: v.style,
			styleParams: _elm_lang$core$Native_List.toArray(v.styleParams).map(
				function (v) {
					return v;
				})
		};
	});
var _user$project$Map_Effects_Ports$addGeoJSONToVectorLayer = _elm_lang$core$Native_Platform.outgoingPort(
	'addGeoJSONToVectorLayer',
	function (v) {
		return {map: v.map, layerKey: v.layerKey, vectorData: v.vectorData};
	});
var _user$project$Map_Effects_Ports$updateLayerVectorData = _elm_lang$core$Native_Platform.outgoingPort(
	'updateLayerVectorData',
	function (v) {
		return {map: v.map, layerKey: v.layerKey, vectorData: v.vectorData};
	});
var _user$project$Map_Effects_Ports$removeFeature = _elm_lang$core$Native_Platform.outgoingPort(
	'removeFeature',
	function (v) {
		return {map: v.map, layerKey: v.layerKey, id: v.id};
	});
var _user$project$Map_Effects_Ports$clearVectorLayer = _elm_lang$core$Native_Platform.outgoingPort(
	'clearVectorLayer',
	function (v) {
		return {map: v.map, layerKey: v.layerKey};
	});
var _user$project$Map_Effects_Ports$updateInteractions = _elm_lang$core$Native_Platform.outgoingPort(
	'updateInteractions',
	function (v) {
		return {map: v.map, iaType: v.iaType, options: v.options};
	});
var _user$project$Map_Effects_Ports$startMerge = _elm_lang$core$Native_Platform.outgoingPort(
	'startMerge',
	function (v) {
		return {
			map: v.map,
			selected: {
				layerKey: v.selected.layerKey,
				features: _elm_lang$core$Native_List.toArray(v.selected.features).map(
					function (v) {
						return {id: v.id, data: v.data};
					})
			}
		};
	});
var _user$project$Map_Effects_Ports$startSplit = _elm_lang$core$Native_Platform.outgoingPort(
	'startSplit',
	function (v) {
		return {
			map: v.map,
			selected: {
				layerKey: v.selected.layerKey,
				features: _elm_lang$core$Native_List.toArray(v.selected.features).map(
					function (v) {
						return {id: v.id, data: v.data};
					})
			},
			lineGeom: v.lineGeom
		};
	});
var _user$project$Map_Effects_Ports$startBreakup = _elm_lang$core$Native_Platform.outgoingPort(
	'startBreakup',
	function (v) {
		return {
			map: v.map,
			selected: {
				layerKey: v.selected.layerKey,
				features: _elm_lang$core$Native_List.toArray(v.selected.features).map(
					function (v) {
						return {id: v.id, data: v.data};
					})
			}
		};
	});
var _user$project$Map_Effects_Ports$startGetInSel = _elm_lang$core$Native_Platform.outgoingPort(
	'startGetInSel',
	function (v) {
		return {
			map: v.map,
			sourceGeoms: _elm_lang$core$Native_List.toArray(v.sourceGeoms).map(
				function (v) {
					return v;
				})
		};
	});
var _user$project$Map_Effects_Ports$panAndZoom = _elm_lang$core$Native_Platform.outgoingPort(
	'panAndZoom',
	function (v) {
		return {
			map: v.map,
			geoObjs: _elm_lang$core$Native_List.toArray(v.geoObjs).map(
				function (v) {
					return {
						id: v.id,
						obj: (v.obj.ctor === 'Nothing') ? null : v.obj._0,
						layerKey: v.layerKey
					};
				}),
			zoom: v.zoom
		};
	});
var _user$project$Map_Effects_Ports$panZoomSelectGeoObjs = _elm_lang$core$Native_Platform.outgoingPort(
	'panZoomSelectGeoObjs',
	function (v) {
		return {
			map: v.map,
			geoObjs: _elm_lang$core$Native_List.toArray(v.geoObjs).map(
				function (v) {
					return {
						id: v.id,
						obj: (v.obj.ctor === 'Nothing') ? null : v.obj._0,
						layerKey: v.layerKey
					};
				}),
			panAndZoom: v.panAndZoom,
			select: v.select
		};
	});
var _user$project$Map_Effects_Ports$checkIfCoordInZones = _elm_lang$core$Native_Platform.outgoingPort(
	'checkIfCoordInZones',
	function (v) {
		return {
			mapClickData: {
				isUpdate: v.mapClickData.isUpdate,
				coordinate: {x: v.mapClickData.coordinate.x, y: v.mapClickData.coordinate.y},
				pixelPos: {x: v.mapClickData.pixelPos.x, y: v.mapClickData.pixelPos.y},
				featuresData: _elm_lang$core$Native_List.toArray(v.mapClickData.featuresData).map(
					function (v) {
						return {layerKey: v.layerKey, id: v.id, data: v.data, rootId: v.rootId, rootData: v.rootData};
					})
			},
			namedGeoZones: _elm_lang$core$Native_List.toArray(v.namedGeoZones).map(
				function (v) {
					return {name: v.name, geoZone: v.geoZone};
				})
		};
	});
var _user$project$Map_Effects_Ports$initOpenLayerBtn = _elm_lang$core$Native_Platform.outgoingPort(
	'initOpenLayerBtn',
	function (v) {
		return {divName: v.divName, map: v.map};
	});
var _user$project$Map_Effects_Ports$disableDrawIA = _elm_lang$core$Native_Platform.outgoingPort(
	'disableDrawIA',
	function (v) {
		return {map: v.map};
	});
var _user$project$Map_Effects_Ports$captureCanvas = _elm_lang$core$Native_Platform.outgoingPort(
	'captureCanvas',
	function (v) {
		return {};
	});
var _user$project$Map_Effects_Ports$mapCreated = _elm_lang$core$Native_Platform.incomingPort(
	'mapCreated',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (map) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (extent) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (resolution) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (clickPixelPos) {
									return _elm_lang$core$Json_Decode$succeed(
										{map: map, extent: extent, resolution: resolution, clickPixelPos: clickPixelPos});
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'clickPixelPos',
									_elm_lang$core$Json_Decode$oneOf(
										{
											ctor: '::',
											_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$core$Json_Decode$map,
													_elm_lang$core$Maybe$Just,
													A2(
														_elm_lang$core$Json_Decode$andThen,
														function (x) {
															return A2(
																_elm_lang$core$Json_Decode$andThen,
																function (y) {
																	return _elm_lang$core$Json_Decode$succeed(
																		{x: x, y: y});
																},
																A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
														},
														A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float))),
												_1: {ctor: '[]'}
											}
										})));
						},
						A2(_elm_lang$core$Json_Decode$field, 'resolution', _elm_lang$core$Json_Decode$float));
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'extent',
					A2(
						_elm_lang$core$Json_Decode$andThen,
						function (minx) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (miny) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (maxx) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (maxy) {
													return _elm_lang$core$Json_Decode$succeed(
														{minx: minx, miny: miny, maxx: maxx, maxy: maxy});
												},
												A2(_elm_lang$core$Json_Decode$field, 'maxy', _elm_lang$core$Json_Decode$float));
										},
										A2(_elm_lang$core$Json_Decode$field, 'maxx', _elm_lang$core$Json_Decode$float));
								},
								A2(_elm_lang$core$Json_Decode$field, 'miny', _elm_lang$core$Json_Decode$float));
						},
						A2(_elm_lang$core$Json_Decode$field, 'minx', _elm_lang$core$Json_Decode$float))));
		},
		A2(_elm_lang$core$Json_Decode$field, 'map', _elm_lang$core$Json_Decode$value)));
var _user$project$Map_Effects_Ports$geolocErrored = _elm_lang$core$Native_Platform.incomingPort('geolocErrored', _elm_lang$core$Json_Decode$string);
var _user$project$Map_Effects_Ports$curPosDataReceived = _elm_lang$core$Native_Platform.incomingPort(
	'curPosDataReceived',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (x) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (y) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (z) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (xyAccuracy) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (zAccuracy) {
											return _elm_lang$core$Json_Decode$succeed(
												{x: x, y: y, z: z, xyAccuracy: xyAccuracy, zAccuracy: zAccuracy});
										},
										A2(
											_elm_lang$core$Json_Decode$field,
											'zAccuracy',
											_elm_lang$core$Json_Decode$oneOf(
												{
													ctor: '::',
													_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
														_1: {ctor: '[]'}
													}
												})));
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'xyAccuracy',
									_elm_lang$core$Json_Decode$oneOf(
										{
											ctor: '::',
											_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
											_1: {
												ctor: '::',
												_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
												_1: {ctor: '[]'}
											}
										})));
						},
						A2(
							_elm_lang$core$Json_Decode$field,
							'z',
							_elm_lang$core$Json_Decode$oneOf(
								{
									ctor: '::',
									_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
									_1: {
										ctor: '::',
										_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
										_1: {ctor: '[]'}
									}
								})));
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'y',
					_elm_lang$core$Json_Decode$oneOf(
						{
							ctor: '::',
							_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
								_1: {ctor: '[]'}
							}
						})));
		},
		A2(
			_elm_lang$core$Json_Decode$field,
			'x',
			_elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
						_1: {ctor: '[]'}
					}
				}))));
var _user$project$Map_Effects_Ports$curPosDataErrored = _elm_lang$core$Native_Platform.incomingPort('curPosDataErrored', _elm_lang$core$Json_Decode$string);
var _user$project$Map_Effects_Ports$mapMoved = _elm_lang$core$Native_Platform.incomingPort(
	'mapMoved',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (map) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (extent) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (resolution) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (clickPixelPos) {
									return _elm_lang$core$Json_Decode$succeed(
										{map: map, extent: extent, resolution: resolution, clickPixelPos: clickPixelPos});
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'clickPixelPos',
									_elm_lang$core$Json_Decode$oneOf(
										{
											ctor: '::',
											_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$core$Json_Decode$map,
													_elm_lang$core$Maybe$Just,
													A2(
														_elm_lang$core$Json_Decode$andThen,
														function (x) {
															return A2(
																_elm_lang$core$Json_Decode$andThen,
																function (y) {
																	return _elm_lang$core$Json_Decode$succeed(
																		{x: x, y: y});
																},
																A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
														},
														A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float))),
												_1: {ctor: '[]'}
											}
										})));
						},
						A2(_elm_lang$core$Json_Decode$field, 'resolution', _elm_lang$core$Json_Decode$float));
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'extent',
					A2(
						_elm_lang$core$Json_Decode$andThen,
						function (minx) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (miny) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (maxx) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (maxy) {
													return _elm_lang$core$Json_Decode$succeed(
														{minx: minx, miny: miny, maxx: maxx, maxy: maxy});
												},
												A2(_elm_lang$core$Json_Decode$field, 'maxy', _elm_lang$core$Json_Decode$float));
										},
										A2(_elm_lang$core$Json_Decode$field, 'maxx', _elm_lang$core$Json_Decode$float));
								},
								A2(_elm_lang$core$Json_Decode$field, 'miny', _elm_lang$core$Json_Decode$float));
						},
						A2(_elm_lang$core$Json_Decode$field, 'minx', _elm_lang$core$Json_Decode$float))));
		},
		A2(_elm_lang$core$Json_Decode$field, 'map', _elm_lang$core$Json_Decode$value)));
var _user$project$Map_Effects_Ports$mapClickDataReceived = _elm_lang$core$Native_Platform.incomingPort(
	'mapClickDataReceived',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (isUpdate) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (coordinate) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (pixelPos) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (featuresData) {
									return _elm_lang$core$Json_Decode$succeed(
										{isUpdate: isUpdate, coordinate: coordinate, pixelPos: pixelPos, featuresData: featuresData});
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'featuresData',
									_elm_lang$core$Json_Decode$list(
										A2(
											_elm_lang$core$Json_Decode$andThen,
											function (layerKey) {
												return A2(
													_elm_lang$core$Json_Decode$andThen,
													function (id) {
														return A2(
															_elm_lang$core$Json_Decode$andThen,
															function (data) {
																return A2(
																	_elm_lang$core$Json_Decode$andThen,
																	function (rootId) {
																		return A2(
																			_elm_lang$core$Json_Decode$andThen,
																			function (rootData) {
																				return _elm_lang$core$Json_Decode$succeed(
																					{layerKey: layerKey, id: id, data: data, rootId: rootId, rootData: rootData});
																			},
																			A2(_elm_lang$core$Json_Decode$field, 'rootData', _elm_lang$core$Json_Decode$value));
																	},
																	A2(_elm_lang$core$Json_Decode$field, 'rootId', _elm_lang$core$Json_Decode$string));
															},
															A2(_elm_lang$core$Json_Decode$field, 'data', _elm_lang$core$Json_Decode$value));
													},
													A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$string));
											},
											A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string)))));
						},
						A2(
							_elm_lang$core$Json_Decode$field,
							'pixelPos',
							A2(
								_elm_lang$core$Json_Decode$andThen,
								function (x) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (y) {
											return _elm_lang$core$Json_Decode$succeed(
												{x: x, y: y});
										},
										A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
								},
								A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float))));
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'coordinate',
					A2(
						_elm_lang$core$Json_Decode$andThen,
						function (x) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (y) {
									return _elm_lang$core$Json_Decode$succeed(
										{x: x, y: y});
								},
								A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
						},
						A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float))));
		},
		A2(_elm_lang$core$Json_Decode$field, 'isUpdate', _elm_lang$core$Json_Decode$bool)));
var _user$project$Map_Effects_Ports$coordInZonesChecked = _elm_lang$core$Native_Platform.incomingPort(
	'coordInZonesChecked',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (mapClickData) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (namedGeoZones) {
					return _elm_lang$core$Json_Decode$succeed(
						{mapClickData: mapClickData, namedGeoZones: namedGeoZones});
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'namedGeoZones',
					_elm_lang$core$Json_Decode$list(
						A2(
							_elm_lang$core$Json_Decode$andThen,
							function (name) {
								return A2(
									_elm_lang$core$Json_Decode$andThen,
									function (geoZone) {
										return A2(
											_elm_lang$core$Json_Decode$andThen,
											function (isWithin) {
												return _elm_lang$core$Json_Decode$succeed(
													{name: name, geoZone: geoZone, isWithin: isWithin});
											},
											A2(_elm_lang$core$Json_Decode$field, 'isWithin', _elm_lang$core$Json_Decode$bool));
									},
									A2(_elm_lang$core$Json_Decode$field, 'geoZone', _elm_lang$core$Json_Decode$value));
							},
							A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string)))));
		},
		A2(
			_elm_lang$core$Json_Decode$field,
			'mapClickData',
			A2(
				_elm_lang$core$Json_Decode$andThen,
				function (isUpdate) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (coordinate) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (pixelPos) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (featuresData) {
											return _elm_lang$core$Json_Decode$succeed(
												{isUpdate: isUpdate, coordinate: coordinate, pixelPos: pixelPos, featuresData: featuresData});
										},
										A2(
											_elm_lang$core$Json_Decode$field,
											'featuresData',
											_elm_lang$core$Json_Decode$list(
												A2(
													_elm_lang$core$Json_Decode$andThen,
													function (layerKey) {
														return A2(
															_elm_lang$core$Json_Decode$andThen,
															function (id) {
																return A2(
																	_elm_lang$core$Json_Decode$andThen,
																	function (data) {
																		return A2(
																			_elm_lang$core$Json_Decode$andThen,
																			function (rootId) {
																				return A2(
																					_elm_lang$core$Json_Decode$andThen,
																					function (rootData) {
																						return _elm_lang$core$Json_Decode$succeed(
																							{layerKey: layerKey, id: id, data: data, rootId: rootId, rootData: rootData});
																					},
																					A2(_elm_lang$core$Json_Decode$field, 'rootData', _elm_lang$core$Json_Decode$value));
																			},
																			A2(_elm_lang$core$Json_Decode$field, 'rootId', _elm_lang$core$Json_Decode$string));
																	},
																	A2(_elm_lang$core$Json_Decode$field, 'data', _elm_lang$core$Json_Decode$value));
															},
															A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$string));
													},
													A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string)))));
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'pixelPos',
									A2(
										_elm_lang$core$Json_Decode$andThen,
										function (x) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (y) {
													return _elm_lang$core$Json_Decode$succeed(
														{x: x, y: y});
												},
												A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
										},
										A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float))));
						},
						A2(
							_elm_lang$core$Json_Decode$field,
							'coordinate',
							A2(
								_elm_lang$core$Json_Decode$andThen,
								function (x) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (y) {
											return _elm_lang$core$Json_Decode$succeed(
												{x: x, y: y});
										},
										A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
								},
								A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float))));
				},
				A2(_elm_lang$core$Json_Decode$field, 'isUpdate', _elm_lang$core$Json_Decode$bool)))));
var _user$project$Map_Effects_Ports$mapPointerMoved = _elm_lang$core$Native_Platform.incomingPort(
	'mapPointerMoved',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (x) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (y) {
					return _elm_lang$core$Json_Decode$succeed(
						{x: x, y: y});
				},
				A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
		},
		A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float)));
var _user$project$Map_Effects_Ports$legendCreated = _elm_lang$core$Native_Platform.incomingPort(
	'legendCreated',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (layerKey) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (legend) {
					return _elm_lang$core$Json_Decode$succeed(
						{layerKey: layerKey, legend: legend});
				},
				A2(_elm_lang$core$Json_Decode$field, 'legend', _elm_lang$core$Json_Decode$value));
		},
		A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string)));
var _user$project$Map_Effects_Ports$selectionUpdated = _elm_lang$core$Native_Platform.incomingPort(
	'selectionUpdated',
	_elm_lang$core$Json_Decode$list(
		A2(
			_elm_lang$core$Json_Decode$andThen,
			function (layerKey) {
				return A2(
					_elm_lang$core$Json_Decode$andThen,
					function (id) {
						return A2(
							_elm_lang$core$Json_Decode$andThen,
							function (data) {
								return A2(
									_elm_lang$core$Json_Decode$andThen,
									function (rootId) {
										return A2(
											_elm_lang$core$Json_Decode$andThen,
											function (rootData) {
												return _elm_lang$core$Json_Decode$succeed(
													{layerKey: layerKey, id: id, data: data, rootId: rootId, rootData: rootData});
											},
											A2(_elm_lang$core$Json_Decode$field, 'rootData', _elm_lang$core$Json_Decode$value));
									},
									A2(_elm_lang$core$Json_Decode$field, 'rootId', _elm_lang$core$Json_Decode$string));
							},
							A2(_elm_lang$core$Json_Decode$field, 'data', _elm_lang$core$Json_Decode$value));
					},
					A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$string));
			},
			A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string))));
var _user$project$Map_Effects_Ports$geomDrawn = _elm_lang$core$Native_Platform.incomingPort(
	'geomDrawn',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (layerKey) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (geom) {
					return _elm_lang$core$Json_Decode$succeed(
						{layerKey: layerKey, geom: geom});
				},
				A2(_elm_lang$core$Json_Decode$field, 'geom', _elm_lang$core$Json_Decode$value));
		},
		A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string)));
var _user$project$Map_Effects_Ports$ptDrawnFromCurPos = _elm_lang$core$Native_Platform.incomingPort(
	'ptDrawnFromCurPos',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (geomData) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (curPosData) {
					return _elm_lang$core$Json_Decode$succeed(
						{geomData: geomData, curPosData: curPosData});
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'curPosData',
					A2(
						_elm_lang$core$Json_Decode$andThen,
						function (x) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (y) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (z) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (xyAccuracy) {
													return A2(
														_elm_lang$core$Json_Decode$andThen,
														function (zAccuracy) {
															return _elm_lang$core$Json_Decode$succeed(
																{x: x, y: y, z: z, xyAccuracy: xyAccuracy, zAccuracy: zAccuracy});
														},
														A2(
															_elm_lang$core$Json_Decode$field,
															'zAccuracy',
															_elm_lang$core$Json_Decode$oneOf(
																{
																	ctor: '::',
																	_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																	_1: {
																		ctor: '::',
																		_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
																		_1: {ctor: '[]'}
																	}
																})));
												},
												A2(
													_elm_lang$core$Json_Decode$field,
													'xyAccuracy',
													_elm_lang$core$Json_Decode$oneOf(
														{
															ctor: '::',
															_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
															_1: {
																ctor: '::',
																_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
																_1: {ctor: '[]'}
															}
														})));
										},
										A2(
											_elm_lang$core$Json_Decode$field,
											'z',
											_elm_lang$core$Json_Decode$oneOf(
												{
													ctor: '::',
													_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
														_1: {ctor: '[]'}
													}
												})));
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'y',
									_elm_lang$core$Json_Decode$oneOf(
										{
											ctor: '::',
											_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
											_1: {
												ctor: '::',
												_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
												_1: {ctor: '[]'}
											}
										})));
						},
						A2(
							_elm_lang$core$Json_Decode$field,
							'x',
							_elm_lang$core$Json_Decode$oneOf(
								{
									ctor: '::',
									_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
									_1: {
										ctor: '::',
										_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$float),
										_1: {ctor: '[]'}
									}
								})))));
		},
		A2(
			_elm_lang$core$Json_Decode$field,
			'geomData',
			A2(
				_elm_lang$core$Json_Decode$andThen,
				function (layerKey) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (geom) {
							return _elm_lang$core$Json_Decode$succeed(
								{layerKey: layerKey, geom: geom});
						},
						A2(_elm_lang$core$Json_Decode$field, 'geom', _elm_lang$core$Json_Decode$value));
				},
				A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string)))));
var _user$project$Map_Effects_Ports$modifsUpdated = _elm_lang$core$Native_Platform.incomingPort(
	'modifsUpdated',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (layerKey) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (features) {
					return _elm_lang$core$Json_Decode$succeed(
						{layerKey: layerKey, features: features});
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'features',
					_elm_lang$core$Json_Decode$list(
						A2(
							_elm_lang$core$Json_Decode$andThen,
							function (id) {
								return A2(
									_elm_lang$core$Json_Decode$andThen,
									function (data) {
										return _elm_lang$core$Json_Decode$succeed(
											{id: id, data: data});
									},
									A2(_elm_lang$core$Json_Decode$field, 'data', _elm_lang$core$Json_Decode$value));
							},
							A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$string)))));
		},
		A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string)));
var _user$project$Map_Effects_Ports$mergeReceived = _elm_lang$core$Native_Platform.incomingPort(
	'mergeReceived',
	_elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$value),
				_1: {ctor: '[]'}
			}
		}));
var _user$project$Map_Effects_Ports$splitReceived = _elm_lang$core$Native_Platform.incomingPort(
	'splitReceived',
	_elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Json_Decode$map,
					_elm_lang$core$Maybe$Just,
					_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value)),
				_1: {ctor: '[]'}
			}
		}));
var _user$project$Map_Effects_Ports$breakupReceived = _elm_lang$core$Native_Platform.incomingPort(
	'breakupReceived',
	_elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Json_Decode$map,
					_elm_lang$core$Maybe$Just,
					_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value)),
				_1: {ctor: '[]'}
			}
		}));
var _user$project$Map_Effects_Ports$getInSelReceived = _elm_lang$core$Native_Platform.incomingPort(
	'getInSelReceived',
	_elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Json_Decode$map,
					_elm_lang$core$Maybe$Just,
					_elm_lang$core$Json_Decode$list(
						A2(
							_elm_lang$core$Json_Decode$andThen,
							function (layerKey) {
								return A2(
									_elm_lang$core$Json_Decode$andThen,
									function (id) {
										return A2(
											_elm_lang$core$Json_Decode$andThen,
											function (data) {
												return A2(
													_elm_lang$core$Json_Decode$andThen,
													function (rootId) {
														return A2(
															_elm_lang$core$Json_Decode$andThen,
															function (rootData) {
																return _elm_lang$core$Json_Decode$succeed(
																	{layerKey: layerKey, id: id, data: data, rootId: rootId, rootData: rootData});
															},
															A2(_elm_lang$core$Json_Decode$field, 'rootData', _elm_lang$core$Json_Decode$value));
													},
													A2(_elm_lang$core$Json_Decode$field, 'rootId', _elm_lang$core$Json_Decode$string));
											},
											A2(_elm_lang$core$Json_Decode$field, 'data', _elm_lang$core$Json_Decode$value));
									},
									A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$string));
							},
							A2(_elm_lang$core$Json_Decode$field, 'layerKey', _elm_lang$core$Json_Decode$string)))),
				_1: {ctor: '[]'}
			}
		}));
var _user$project$Map_Effects_Ports$modeErrorReceived = _elm_lang$core$Native_Platform.incomingPort(
	'modeErrorReceived',
	_elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
				_1: {ctor: '[]'}
			}
		}));
var _user$project$Map_Effects_Ports$capturedCanvasReceived = _elm_lang$core$Native_Platform.incomingPort(
	'capturedCanvasReceived',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (image) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (canvasDimensions) {
					return _elm_lang$core$Json_Decode$succeed(
						{image: image, canvasDimensions: canvasDimensions});
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'canvasDimensions',
					A2(
						_elm_lang$core$Json_Decode$andThen,
						function (height) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (width) {
									return _elm_lang$core$Json_Decode$succeed(
										{height: height, width: width});
								},
								A2(_elm_lang$core$Json_Decode$field, 'width', _elm_lang$core$Json_Decode$int));
						},
						A2(_elm_lang$core$Json_Decode$field, 'height', _elm_lang$core$Json_Decode$int))));
		},
		A2(_elm_lang$core$Json_Decode$field, 'image', _elm_lang$core$Json_Decode$string)));
var _user$project$Map_Effects_Ports$subscriptions = _elm_lang$core$Platform_Sub$batch(
	{
		ctor: '::',
		_0: _elm_lang$window$Window$resizes(_user$project$Map_Data_Msg$WindowResized),
		_1: {
			ctor: '::',
			_0: _user$project$Map_Effects_Ports$mapCreated(_user$project$Map_Data_Msg$MapCreated),
			_1: {
				ctor: '::',
				_0: _user$project$Map_Effects_Ports$geolocErrored(_user$project$Map_Data_Msg$GeolocErrored),
				_1: {
					ctor: '::',
					_0: _user$project$Map_Effects_Ports$curPosDataReceived(_user$project$Map_Data_Msg$CurPosDataReceived),
					_1: {
						ctor: '::',
						_0: _user$project$Map_Effects_Ports$curPosDataErrored(_user$project$Map_Data_Msg$CurPosDataErrored),
						_1: {
							ctor: '::',
							_0: _user$project$Map_Effects_Ports$mapMoved(_user$project$Map_Data_Msg$MapMoved),
							_1: {
								ctor: '::',
								_0: _user$project$Map_Effects_Ports$mapClickDataReceived(_user$project$Map_Data_Msg$MapClickDataReceived),
								_1: {
									ctor: '::',
									_0: _user$project$Map_Effects_Ports$coordInZonesChecked(_user$project$Map_Data_Msg$CoordInZonesChecked),
									_1: {
										ctor: '::',
										_0: _user$project$Map_Effects_Ports$mapPointerMoved(_user$project$Map_Data_Msg$MapPointerMoved),
										_1: {
											ctor: '::',
											_0: _user$project$Map_Effects_Ports$legendCreated(_user$project$Map_Data_Msg$LegendCreated),
											_1: {
												ctor: '::',
												_0: _user$project$Map_Effects_Ports$selectionUpdated(
													function (_p0) {
														return _user$project$Map_Data_Msg$ModeEvent(
															_user$project$Map_Data_Mode$SelectionUpdated(_p0));
													}),
												_1: {
													ctor: '::',
													_0: _user$project$Map_Effects_Ports$modifsUpdated(
														function (_p1) {
															return _user$project$Map_Data_Msg$ModeEvent(
																_user$project$Map_Data_Mode$ModifsUpdated(_p1));
														}),
													_1: {
														ctor: '::',
														_0: _user$project$Map_Effects_Ports$geomDrawn(
															function (_p2) {
																return _user$project$Map_Data_Msg$ModeEvent(
																	_user$project$Map_Data_Mode$GeomDrawn(_p2));
															}),
														_1: {
															ctor: '::',
															_0: _user$project$Map_Effects_Ports$ptDrawnFromCurPos(
																function (_p3) {
																	return _user$project$Map_Data_Msg$ModeEvent(
																		_user$project$Map_Data_Mode$PtDrawnFromCurPos(_p3));
																}),
															_1: {
																ctor: '::',
																_0: _user$project$Map_Effects_Ports$mergeReceived(
																	function (_p4) {
																		return _user$project$Map_Data_Msg$ModeEvent(
																			_user$project$Map_Data_Mode$MergeReceived(_p4));
																	}),
																_1: {
																	ctor: '::',
																	_0: _user$project$Map_Effects_Ports$splitReceived(
																		function (_p5) {
																			return _user$project$Map_Data_Msg$ModeEvent(
																				_user$project$Map_Data_Mode$SplitReceived(_p5));
																		}),
																	_1: {
																		ctor: '::',
																		_0: _user$project$Map_Effects_Ports$breakupReceived(
																			function (_p6) {
																				return _user$project$Map_Data_Msg$ModeEvent(
																					_user$project$Map_Data_Mode$BreakupReceived(_p6));
																			}),
																		_1: {
																			ctor: '::',
																			_0: _user$project$Map_Effects_Ports$getInSelReceived(
																				function (_p7) {
																					return _user$project$Map_Data_Msg$ModeEvent(
																						_user$project$Map_Data_Mode$GetInSelReceived(_p7));
																				}),
																			_1: {
																				ctor: '::',
																				_0: _user$project$Map_Effects_Ports$modeErrorReceived(
																					function (_p8) {
																						return _user$project$Map_Data_Msg$ModeEvent(
																							_user$project$Map_Data_Mode$ModeErrorReceived(_p8));
																					}),
																				_1: {
																					ctor: '::',
																					_0: _user$project$Map_Effects_Ports$capturedCanvasReceived(
																						function (_p9) {
																							return _user$project$Map_Data_Msg$ModeEvent(
																								_user$project$Map_Data_Mode$CapturedCanvasReceived(_p9));
																						}),
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});

var _user$project$Map_Effects_Vector$addIdToUrl = F2(
	function (id, url) {
		var splitUrl = A2(_elm_lang$core$String$split, '?', url);
		var _p0 = _elm_lang$core$List$length(splitUrl);
		switch (_p0) {
			case 1:
				return A2(
					_elm_lang$core$Basics_ops['++'],
					url,
					A2(_elm_lang$core$Basics_ops['++'], '/', id));
			case 2:
				return A2(
					_elm_lang$core$String$join,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'/',
						A2(_elm_lang$core$Basics_ops['++'], id, '?')),
					splitUrl);
			default:
				return A2(_elm_lang$core$Debug$log, 'Malformatted url, containing multiple \'?\'', url);
		}
	});
var _user$project$Map_Effects_Vector$deleteRequest = F4(
	function (msgFromMap, headers, vdata, id) {
		var request = function (url) {
			return _elm_lang$http$Http$request(
				{
					method: 'DELETE',
					headers: headers,
					url: A2(_user$project$Map_Effects_Vector$addIdToUrl, id, url),
					body: _elm_lang$http$Http$emptyBody,
					expect: _elm_lang$http$Http$expectJson(_elm_lang$core$Json_Decode$value),
					timeout: _elm_lang$core$Maybe$Nothing,
					withCredentials: true
				});
		};
		var _p1 = vdata.loadMethod;
		switch (_p1.ctor) {
			case 'RestServer':
				return _elm_lang$core$Maybe$Just(
					request(_p1._0));
			case 'Local':
				return A2(_elm_lang$core$Debug$log, 'Trying to create a save request for local Vector', _elm_lang$core$Maybe$Nothing);
			default:
				return _elm_lang$core$Maybe$Nothing;
		}
	});
var _user$project$Map_Effects_Vector$saveRequest = F5(
	function (msgFromMap, headers, vdata, mayId, data) {
		var method = function () {
			var _p2 = mayId;
			if (_p2.ctor === 'Nothing') {
				return 'POST';
			} else {
				return 'PATCH';
			}
		}();
		var finalUrl = function (url) {
			var _p3 = mayId;
			if (_p3.ctor === 'Nothing') {
				return url;
			} else {
				return A2(_user$project$Map_Effects_Vector$addIdToUrl, _p3._0, url);
			}
		};
		var request = function (url) {
			return _elm_lang$http$Http$request(
				{
					method: method,
					headers: headers,
					url: finalUrl(url),
					body: _elm_lang$http$Http$jsonBody(data),
					expect: _elm_lang$http$Http$expectJson(_elm_lang$core$Json_Decode$value),
					timeout: _elm_lang$core$Maybe$Nothing,
					withCredentials: true
				});
		};
		var _p4 = vdata.loadMethod;
		switch (_p4.ctor) {
			case 'RestServer':
				return _elm_lang$core$Maybe$Just(
					request(_p4._0));
			case 'Local':
				return A2(_elm_lang$core$Debug$log, 'Trying to create a save request for local Vector', _elm_lang$core$Maybe$Nothing);
			default:
				return _elm_lang$core$Maybe$Nothing;
		}
	});
var _user$project$Map_Effects_Vector$get = F4(
	function (msgFromMap, headers, mayExtent, vdata) {
		var finalUrl = F2(
			function (url, loadingDetails) {
				var _p5 = {ctor: '_Tuple2', _0: loadingDetails, _1: mayExtent};
				if ((_p5._0.ctor === 'InExtent') && (_p5._1.ctor === 'Just')) {
					var _p6 = _p5._1._0;
					return A2(
						_elm_lang$core$Basics_ops['++'],
						url,
						A2(
							_elm_lang$core$Basics_ops['++'],
							_p5._0._0,
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p6.minx),
								A2(
									_elm_lang$core$Basics_ops['++'],
									',',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p6.miny),
										A2(
											_elm_lang$core$Basics_ops['++'],
											',',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p6.maxx),
												A2(
													_elm_lang$core$Basics_ops['++'],
													',',
													_elm_lang$core$Basics$toString(_p6.maxy)))))))));
				} else {
					return url;
				}
			});
		var request = F2(
			function (url, loadingDetails) {
				return _elm_lang$http$Http$request(
					{
						method: 'GET',
						headers: headers,
						url: A2(finalUrl, url, loadingDetails),
						body: _elm_lang$http$Http$emptyBody,
						expect: _elm_lang$http$Http$expectJson(_elm_lang$core$Json_Decode$value),
						timeout: _elm_lang$core$Maybe$Nothing,
						withCredentials: true
					});
			});
		var _p7 = vdata.loadMethod;
		switch (_p7.ctor) {
			case 'RestServer':
				return A2(
					_elm_lang$http$Http$send,
					function (_p8) {
						return msgFromMap(
							A2(_user$project$Map_Data_Msg$GetVectorCompleted, vdata.key, _p8));
					},
					A2(request, _p7._0, _p7._1));
			case 'Local':
				return A2(_elm_lang$core$Debug$log, 'Trying to create a GET request for local Vector', _elm_lang$core$Platform_Cmd$none);
			default:
				return _elm_lang$core$Platform_Cmd$none;
		}
	});
var _user$project$Map_Effects_Vector$getMany = F4(
	function (msgFromMap, headers, mayExtent, vdatas) {
		return _elm_lang$core$Platform_Cmd$batch(
			A2(
				_elm_lang$core$List$map,
				A3(_user$project$Map_Effects_Vector$get, msgFromMap, headers, mayExtent),
				vdatas));
	});

var _user$project$Map_Update_Layer_Utils$updateIfKey = F3(
	function (key, updateField, layers) {
		var upCoreData = F2(
			function (lay, data) {
				return (!_elm_lang$core$Native_Utils.eq(data.key, key)) ? lay : updateField(lay);
			});
		var updSingLay = F2(
			function (lay, ldata) {
				var _p0 = ldata;
				switch (_p0.ctor) {
					case 'WmtsLayer':
						return A2(upCoreData, lay, _p0._0);
					case 'WmsTileLayer':
						return A2(upCoreData, lay, _p0._0);
					case 'TilesLayer':
						return A2(upCoreData, lay, _p0._0);
					default:
						return A2(upCoreData, lay, _p0._0);
				}
			});
		var updateLayer = function (lay) {
			var _p1 = lay;
			if (_p1.ctor === 'SingleLayer') {
				return A2(updSingLay, lay, _p1._0);
			} else {
				var _p2 = _p1._0;
				var updGData = _elm_lang$core$Native_Utils.update(
					_p2,
					{
						layers: A2(_elm_lang$core$List$map, updateLayer, _p2.layers)
					});
				return A2(
					upCoreData,
					_user$project$Map_Data_Layer$LayerGroup(updGData),
					updGData);
			}
		};
		return A2(_elm_lang$core$List$map, updateLayer, layers);
	});
var _user$project$Map_Update_Layer_Utils$flattenToSingleLayers = function (layers) {
	var flattenLayer = function (layer) {
		var _p3 = layer;
		if (_p3.ctor === 'SingleLayer') {
			return {
				ctor: '::',
				_0: _p3._0,
				_1: {ctor: '[]'}
			};
		} else {
			return A2(_elm_lang$core$List$concatMap, flattenLayer, _p3._0.layers);
		}
	};
	return A2(_elm_lang$core$List$concatMap, flattenLayer, layers);
};
var _user$project$Map_Update_Layer_Utils$flatten = function (layers) {
	var flattenLayer = function (layer) {
		var _p4 = layer;
		if (_p4.ctor === 'SingleLayer') {
			return {
				ctor: '::',
				_0: _user$project$Map_Data_Layer$SingleLayer(_p4._0),
				_1: {ctor: '[]'}
			};
		} else {
			var _p5 = _p4._0;
			return {
				ctor: '::',
				_0: _user$project$Map_Data_Layer$LayerGroup(_p5),
				_1: A2(_elm_lang$core$List$concatMap, flattenLayer, _p5.layers)
			};
		}
	};
	return A2(_elm_lang$core$List$concatMap, flattenLayer, layers);
};
var _user$project$Map_Update_Layer_Utils$findByKey = F2(
	function (layers, key) {
		var filter = function (layer) {
			var _p6 = layer;
			if (_p6.ctor === 'LayerGroup') {
				var _p7 = _p6._0;
				return _elm_lang$core$Native_Utils.eq(_p7.key, key) ? _elm_lang$core$Maybe$Just(
					_user$project$Map_Data_Layer$LayerGroup(_p7)) : _elm_lang$core$Maybe$Nothing;
			} else {
				var _p8 = _p6._0;
				return _elm_lang$core$Native_Utils.eq(
					_user$project$Map_Data_Layer$getKey(_p8),
					key) ? _elm_lang$core$Maybe$Just(
					_user$project$Map_Data_Layer$SingleLayer(_p8)) : _elm_lang$core$Maybe$Nothing;
			}
		};
		return _elm_lang$core$List$head(
			A2(
				_elm_lang$core$List$filterMap,
				filter,
				_user$project$Map_Update_Layer_Utils$flatten(layers)));
	});

var _user$project$Map_Update_Layer$clear = F2(
	function (map, layer) {
		var mayLayerData = _user$project$Map_Data_Layer$getLayerData(layer);
		var mayLayerKey = function () {
			var _p0 = mayLayerData;
			if (_p0.ctor === 'Just') {
				return _elm_lang$core$Maybe$Just(
					_user$project$Map_Data_Layer$getKey(_p0._0));
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		}();
		var _p1 = mayLayerKey;
		if (_p1.ctor === 'Just') {
			return _user$project$Map_Effects_Ports$clearVectorLayer(
				{map: map, layerKey: _p1._0});
		} else {
			return _elm_lang$core$Platform_Cmd$none;
		}
	});
var _user$project$Map_Update_Layer$clearLayers = F2(
	function (map, layers) {
		return _elm_lang$core$Platform_Cmd$batch(
			A2(
				_elm_lang$core$List$map,
				function (layer) {
					return A2(_user$project$Map_Update_Layer$clear, map, layer);
				},
				layers));
	});
var _user$project$Map_Update_Layer$findByKey = _user$project$Map_Update_Layer_Utils$findByKey;
var _user$project$Map_Update_Layer$clearByKeys = F3(
	function (map, layers, keys) {
		var filtredLayers = A2(
			_elm_lang$core$List$filterMap,
			_user$project$Map_Update_Layer$findByKey(layers),
			keys);
		return A2(_user$project$Map_Update_Layer$clearLayers, map, filtredLayers);
	});
var _user$project$Map_Update_Layer$getStyleObjName = F2(
	function (layers, layerKey) {
		var _p2 = A2(_user$project$Map_Update_Layer$findByKey, layers, layerKey);
		_v2_2:
		do {
			if ((_p2.ctor === 'Just') && (_p2._0.ctor === 'SingleLayer')) {
				switch (_p2._0._0.ctor) {
					case 'VectorLayer':
						return _user$project$Map_Data_Layer_Vector$getStyleObjName(_p2._0._0._0);
					case 'TilesLayer':
						return _user$project$Map_Data_Layer_Tiles$getStyleObjName(_p2._0._0._0);
					default:
						break _v2_2;
				}
			} else {
				break _v2_2;
			}
		} while(false);
		return _elm_lang$core$Maybe$Nothing;
	});
var _user$project$Map_Update_Layer$updateOpacity = F3(
	function (key, opacity, layers) {
		var updOpc = function (layer) {
			var _p3 = layer;
			if (_p3.ctor === 'SingleLayer') {
				var _p4 = _p3._0;
				switch (_p4.ctor) {
					case 'WmtsLayer':
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmtsLayer(
								_elm_lang$core$Native_Utils.update(
									_p4._0,
									{opacity: opacity})));
					case 'WmsTileLayer':
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmsTileLayer(
								_elm_lang$core$Native_Utils.update(
									_p4._0,
									{opacity: opacity})));
					case 'TilesLayer':
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$TilesLayer(
								_elm_lang$core$Native_Utils.update(
									_p4._0,
									{opacity: opacity})));
					default:
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$VectorLayer(
								_elm_lang$core$Native_Utils.update(
									_p4._0,
									{opacity: opacity})));
				}
			} else {
				return _user$project$Map_Data_Layer$LayerGroup(_p3._0);
			}
		};
		return A3(_user$project$Map_Update_Layer_Utils$updateIfKey, key, updOpc, layers);
	});
var _user$project$Map_Update_Layer$updateVisibility = F3(
	function (key, isVisible, layers) {
		var updVis = function (layer) {
			var _p5 = layer;
			if (_p5.ctor === 'SingleLayer') {
				var _p6 = _p5._0;
				switch (_p6.ctor) {
					case 'WmsTileLayer':
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmsTileLayer(
								_elm_lang$core$Native_Utils.update(
									_p6._0,
									{isVisible: isVisible})));
					case 'WmtsLayer':
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmtsLayer(
								_elm_lang$core$Native_Utils.update(
									_p6._0,
									{isVisible: isVisible})));
					case 'TilesLayer':
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$TilesLayer(
								_elm_lang$core$Native_Utils.update(
									_p6._0,
									{isVisible: isVisible})));
					default:
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$VectorLayer(
								_elm_lang$core$Native_Utils.update(
									_p6._0,
									{isVisible: isVisible})));
				}
			} else {
				return _user$project$Map_Data_Layer$LayerGroup(
					_elm_lang$core$Native_Utils.update(
						_p5._0,
						{isVisible: isVisible}));
			}
		};
		return A3(_user$project$Map_Update_Layer_Utils$updateIfKey, key, updVis, layers);
	});
var _user$project$Map_Update_Layer$toggleSettingsExpanded = F2(
	function (key, layers) {
		var toggleExp = function (layer) {
			var _p7 = layer;
			if (_p7.ctor === 'SingleLayer') {
				var _p8 = _p7._0;
				switch (_p8.ctor) {
					case 'WmtsLayer':
						var _p9 = _p8._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmtsLayer(
								_elm_lang$core$Native_Utils.update(
									_p9,
									{isSettingsExpanded: !_p9.isSettingsExpanded})));
					case 'WmsTileLayer':
						var _p10 = _p8._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmsTileLayer(
								_elm_lang$core$Native_Utils.update(
									_p10,
									{isSettingsExpanded: !_p10.isSettingsExpanded})));
					case 'TilesLayer':
						var _p11 = _p8._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$TilesLayer(
								_elm_lang$core$Native_Utils.update(
									_p11,
									{isSettingsExpanded: !_p11.isSettingsExpanded})));
					default:
						var _p12 = _p8._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$VectorLayer(
								_elm_lang$core$Native_Utils.update(
									_p12,
									{isSettingsExpanded: !_p12.isSettingsExpanded})));
				}
			} else {
				return layer;
			}
		};
		return A3(_user$project$Map_Update_Layer_Utils$updateIfKey, key, toggleExp, layers);
	});
var _user$project$Map_Update_Layer$toggleInfoExpanded = F2(
	function (key, layers) {
		var toggleExp = function (layer) {
			var _p13 = layer;
			if (_p13.ctor === 'SingleLayer') {
				var _p14 = _p13._0;
				switch (_p14.ctor) {
					case 'WmtsLayer':
						var _p15 = _p14._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmtsLayer(
								_elm_lang$core$Native_Utils.update(
									_p15,
									{isInfoExpanded: !_p15.isInfoExpanded})));
					case 'WmsTileLayer':
						var _p16 = _p14._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$WmsTileLayer(
								_elm_lang$core$Native_Utils.update(
									_p16,
									{isInfoExpanded: !_p16.isInfoExpanded})));
					case 'TilesLayer':
						var _p17 = _p14._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$TilesLayer(
								_elm_lang$core$Native_Utils.update(
									_p17,
									{isInfoExpanded: !_p17.isInfoExpanded})));
					default:
						var _p18 = _p14._0;
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$VectorLayer(
								_elm_lang$core$Native_Utils.update(
									_p18,
									{isInfoExpanded: !_p18.isInfoExpanded})));
				}
			} else {
				return layer;
			}
		};
		return A3(_user$project$Map_Update_Layer_Utils$updateIfKey, key, toggleExp, layers);
	});
var _user$project$Map_Update_Layer$toggleGroupExpanded = F2(
	function (key, layers) {
		var toggleExp = function (layer) {
			var _p19 = layer;
			if (_p19.ctor === 'LayerGroup') {
				var _p20 = _p19._0;
				return _user$project$Map_Data_Layer$LayerGroup(
					_elm_lang$core$Native_Utils.update(
						_p20,
						{isExpanded: !_p20.isExpanded}));
			} else {
				return layer;
			}
		};
		return A3(_user$project$Map_Update_Layer_Utils$updateIfKey, key, toggleExp, layers);
	});

var _user$project$Map_Update_Layer_Vector$getReallyVisibleExtentBased = F2(
	function (resolution, layers) {
		var getVisiExtVectors = function (layer) {
			var _p0 = layer;
			if (_p0.ctor === 'LayerGroup') {
				var _p1 = _p0._0;
				return _p1.isVisible ? A2(_elm_lang$core$List$concatMap, getVisiExtVectors, _p1.layers) : {ctor: '[]'};
			} else {
				var _p2 = _p0._0;
				if (_p2.ctor === 'VectorLayer') {
					var _p7 = _p2._0;
					var _p3 = _p7.loadMethod;
					if (_p3.ctor === 'RestServer') {
						var maxResOk = function () {
							var _p4 = _p7.maxResolution;
							if (_p4.ctor === 'Just') {
								return _elm_lang$core$Native_Utils.cmp(resolution, _p4._0) < 0;
							} else {
								return true;
							}
						}();
						var minResOk = function () {
							var _p5 = _p7.minResolution;
							if (_p5.ctor === 'Just') {
								return _elm_lang$core$Native_Utils.cmp(resolution, _p5._0) > 0;
							} else {
								return true;
							}
						}();
						var _p6 = _p3._1;
						if (_p6.ctor === 'Batch') {
							return {ctor: '[]'};
						} else {
							return (_p7.isVisible && (minResOk && maxResOk)) ? {
								ctor: '::',
								_0: _p7,
								_1: {ctor: '[]'}
							} : {ctor: '[]'};
						}
					} else {
						return {ctor: '[]'};
					}
				} else {
					return {ctor: '[]'};
				}
			}
		};
		return A2(_elm_lang$core$List$concatMap, getVisiExtVectors, layers);
	});
var _user$project$Map_Update_Layer_Vector$getVectors = function (layers) {
	var filter = function (sldata) {
		var _p8 = sldata;
		if (_p8.ctor === 'VectorLayer') {
			return _elm_lang$core$Maybe$Just(_p8._0);
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	};
	return A2(
		_elm_lang$core$List$filterMap,
		filter,
		_user$project$Map_Update_Layer_Utils$flattenToSingleLayers(layers));
};
var _user$project$Map_Update_Layer_Vector$getServerBatchLoad = function (layers) {
	var filter = function (vdata) {
		var _p9 = vdata.loadMethod;
		if ((_p9.ctor === 'RestServer') && (_p9._1.ctor === 'Batch')) {
			return _elm_lang$core$Maybe$Just(vdata);
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	};
	return A2(
		_elm_lang$core$List$filterMap,
		filter,
		_user$project$Map_Update_Layer_Vector$getVectors(layers));
};
var _user$project$Map_Update_Layer_Vector$findByKey = F2(
	function (layers, key) {
		var _p10 = A2(_user$project$Map_Update_Layer_Utils$findByKey, layers, key);
		if (_p10.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p11 = _p10._0;
			if (_p11.ctor === 'LayerGroup') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p12 = _p11._0;
				if (_p12.ctor === 'VectorLayer') {
					return _elm_lang$core$Maybe$Just(_p12._0);
				} else {
					return _elm_lang$core$Maybe$Nothing;
				}
			}
		}
	});
var _user$project$Map_Update_Layer_Vector$updateStyle = F3(
	function (key, selectMsg, layers) {
		var updStyle = function (layer) {
			var _p13 = layer;
			if (_p13.ctor === 'LayerGroup') {
				return layer;
			} else {
				var _p14 = _p13._0;
				switch (_p14.ctor) {
					case 'WmtsLayer':
						return layer;
					case 'WmsTileLayer':
						return layer;
					case 'TilesLayer':
						return layer;
					default:
						var _p17 = _p14._0;
						var _p15 = _p17.style.more;
						if (_p15.ctor === 'Nothing') {
							return layer;
						} else {
							var _p16 = _p15._0;
							var updSelMenu = A2(_mdgriffith$style_elements$Element_Input$updateSelection, selectMsg, _p16.selectMenu);
							var newStyle = _mdgriffith$style_elements$Element_Input$selected(updSelMenu);
							return _user$project$Map_Data_Layer$SingleLayer(
								_user$project$Map_Data_Layer$VectorLayer(
									_elm_lang$core$Native_Utils.update(
										_p17,
										{
											style: {
												current: newStyle,
												more: _elm_lang$core$Maybe$Just(
													{selectMenu: updSelMenu, choices: _p16.choices})
											}
										})));
						}
				}
			}
		};
		return A3(_user$project$Map_Update_Layer_Utils$updateIfKey, key, updStyle, layers);
	});
var _user$project$Map_Update_Layer_Vector$clearCmd = F2(
	function (map, vectors) {
		return _elm_lang$core$Platform_Cmd$batch(
			A2(
				_elm_lang$core$List$map,
				function (vdata) {
					return _user$project$Map_Effects_Ports$clearVectorLayer(
						{map: map, layerKey: vdata.key});
				},
				vectors));
	});
var _user$project$Map_Update_Layer_Vector$clearByKeysCmd = F3(
	function (map, layers, keys) {
		return A2(
			_user$project$Map_Update_Layer_Vector$clearCmd,
			map,
			A2(
				_elm_lang$core$List$filterMap,
				_user$project$Map_Update_Layer_Vector$findByKey(layers),
				keys));
	});
var _user$project$Map_Update_Layer_Vector$reloadCmd = F4(
	function (msgFromMap, headers, extent, vectors) {
		return A4(
			_user$project$Map_Effects_Vector$getMany,
			msgFromMap,
			headers,
			_elm_lang$core$Maybe$Just(extent),
			vectors);
	});
var _user$project$Map_Update_Layer_Vector$reloadByKeysCmd = F5(
	function (msgFromMap, headers, extent, layers, keys) {
		return A4(
			_user$project$Map_Update_Layer_Vector$reloadCmd,
			msgFromMap,
			headers,
			extent,
			A2(
				_elm_lang$core$List$filterMap,
				_user$project$Map_Update_Layer_Vector$findByKey(layers),
				keys));
	});
var _user$project$Map_Update_Layer_Vector$clearReloadByKeys = F6(
	function (msgFromMap, headers, map, extent, layers, keys) {
		return _elm_lang$core$Platform_Cmd$batch(
			{
				ctor: '::',
				_0: A3(_user$project$Map_Update_Layer_Vector$clearByKeysCmd, map, layers, keys),
				_1: {
					ctor: '::',
					_0: A5(_user$project$Map_Update_Layer_Vector$reloadByKeysCmd, msgFromMap, headers, extent, layers, keys),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map_Update_Layer_Vector$clearReload = F5(
	function (msgFromMap, headers, map, extent, vectors) {
		return _elm_lang$core$Platform_Cmd$batch(
			{
				ctor: '::',
				_0: A2(_user$project$Map_Update_Layer_Vector$clearCmd, map, vectors),
				_1: {
					ctor: '::',
					_0: A4(_user$project$Map_Update_Layer_Vector$reloadCmd, msgFromMap, headers, extent, vectors),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map_Update_Layer_Vector$updMapStyle = F5(
	function (msgFromMap, headers, map, key, layers) {
		var _p18 = A2(_user$project$Map_Update_Layer_Utils$findByKey, layers, key);
		if (_p18.ctor === 'Nothing') {
			return _elm_lang$core$Platform_Cmd$none;
		} else {
			var _p19 = _p18._0;
			if (_p19.ctor === 'LayerGroup') {
				return _elm_lang$core$Platform_Cmd$none;
			} else {
				var _p20 = _p19._0;
				switch (_p20.ctor) {
					case 'WmtsLayer':
						return _elm_lang$core$Platform_Cmd$none;
					case 'WmsTileLayer':
						return _elm_lang$core$Platform_Cmd$none;
					case 'TilesLayer':
						return _elm_lang$core$Platform_Cmd$none;
					default:
						var _p21 = _p20._0.style.current;
						if (_p21.ctor === 'Nothing') {
							return _elm_lang$core$Platform_Cmd$none;
						} else {
							return _user$project$Map_Effects_Ports$updateLayerStyle(
								{
									map: map,
									layerKey: key,
									style: _p21._0,
									styleParams: {ctor: '[]'}
								});
						}
				}
			}
		}
	});
var _user$project$Map_Update_Layer_Vector$onVisChangedLoad = F6(
	function (msgFromMap, headers, resolution, extent, key, layers) {
		var _p22 = A2(_user$project$Map_Update_Layer_Utils$findByKey, layers, key);
		if (_p22.ctor === 'Nothing') {
			return _elm_lang$core$Platform_Cmd$none;
		} else {
			return A4(
				_user$project$Map_Effects_Vector$getMany,
				msgFromMap,
				headers,
				_elm_lang$core$Maybe$Just(extent),
				A2(
					_user$project$Map_Update_Layer_Vector$getReallyVisibleExtentBased,
					resolution,
					{
						ctor: '::',
						_0: _p22._0,
						_1: {ctor: '[]'}
					}));
		}
	});
var _user$project$Map_Update_Layer_Vector$onMoveLoad = F5(
	function (msgFromMap, headers, resolution, mayExtent, layers) {
		return A4(
			_user$project$Map_Effects_Vector$getMany,
			msgFromMap,
			headers,
			mayExtent,
			A2(_user$project$Map_Update_Layer_Vector$getReallyVisibleExtentBased, resolution, layers));
	});
var _user$project$Map_Update_Layer_Vector$onRestoreClearBatchLoad = F5(
	function (msgFromMap, headers, map, layers, mayExtent) {
		return A5(
			_user$project$Map_Update_Layer_Vector$clearReload,
			msgFromMap,
			headers,
			map,
			mayExtent,
			_user$project$Map_Update_Layer_Vector$getServerBatchLoad(layers));
	});
var _user$project$Map_Update_Layer_Vector$onInitbatchLoad = F3(
	function (msgFromMap, headers, layers) {
		return A4(
			_user$project$Map_Effects_Vector$getMany,
			msgFromMap,
			headers,
			_elm_lang$core$Maybe$Nothing,
			_user$project$Map_Update_Layer_Vector$getServerBatchLoad(layers));
	});

var _user$project$Map_Update_Layer_Tiles$getVisible = function (layers) {
	var filter = function (sldata) {
		var _p0 = sldata;
		switch (_p0.ctor) {
			case 'WmtsLayer':
				return _p0._0.isVisible ? _elm_lang$core$Maybe$Just(sldata) : _elm_lang$core$Maybe$Nothing;
			case 'TilesLayer':
				return _p0._0.isVisible ? _elm_lang$core$Maybe$Just(sldata) : _elm_lang$core$Maybe$Nothing;
			default:
				return _elm_lang$core$Maybe$Nothing;
		}
	};
	return A2(
		_elm_lang$core$List$filterMap,
		filter,
		_user$project$Map_Update_Layer_Utils$flattenToSingleLayers(layers));
};

var _user$project$Map_Update_Layer_Legend$updateOneLegend = function (legendJson) {
	return _elm_lang$core$Result$toMaybe(
		A2(
			_elm_lang$core$Result$mapError,
			function (err) {
				return A2(
					_elm_lang$core$Debug$log,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'Could not decode legend',
						_elm_lang$core$Basics$toString(legendJson)),
					err);
			},
			A2(_elm_lang$core$Json_Decode$decodeValue, _user$project$Map_Data_Layer_Legend$decoder, legendJson)));
};
var _user$project$Map_Update_Layer_Legend$update = F2(
	function (legendData, layers) {
		var updateLayerLegend = function (layer) {
			var _p0 = layer;
			if (_p0.ctor === 'SingleLayer') {
				var _p1 = _p0._0;
				switch (_p1.ctor) {
					case 'VectorLayer':
						return _user$project$Map_Data_Layer$SingleLayer(
							_user$project$Map_Data_Layer$VectorLayer(
								_elm_lang$core$Native_Utils.update(
									_p1._0,
									{
										legend: _user$project$Map_Update_Layer_Legend$updateOneLegend(legendData.legend)
									})));
					case 'TilesLayer':
						var _p3 = _p1._0;
						var _p2 = _p3.tileType;
						if (_p2.ctor === 'MapBoxVector') {
							return _user$project$Map_Data_Layer$SingleLayer(
								_user$project$Map_Data_Layer$TilesLayer(
									_elm_lang$core$Native_Utils.update(
										_p3,
										{
											tileType: A2(
												_user$project$Map_Data_Layer_Tiles$MapBoxVector,
												_p2._0,
												_user$project$Map_Update_Layer_Legend$updateOneLegend(legendData.legend))
										})));
						} else {
							return layer;
						}
					default:
						return layer;
				}
			} else {
				return layer;
			}
		};
		return A3(_user$project$Map_Update_Layer_Utils$updateIfKey, legendData.layerKey, updateLayerLegend, layers);
	});

var _user$project$Map_Update_ClickPosInfo$updateWithCoordInZonesData = F3(
	function (coordInZonesData, visTileLayerKeys, clickPosInfo) {
		if (coordInZonesData.mapClickData.isUpdate && _elm_lang$core$Native_Utils.eq(clickPosInfo, _elm_lang$core$Maybe$Nothing)) {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p0 = clickPosInfo;
			if (_p0.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Just(
					{
						coordinate: coordInZonesData.mapClickData.coordinate,
						pixelPos: coordInZonesData.mapClickData.pixelPos,
						featuresData: coordInZonesData.mapClickData.featuresData,
						visibleTileLayerKeys: visTileLayerKeys,
						checkedNamedGeoZones: coordInZonesData.namedGeoZones,
						apiResponse: {ctor: '[]'}
					});
			} else {
				return _elm_lang$core$Maybe$Just(
					{coordinate: coordInZonesData.mapClickData.coordinate, pixelPos: coordInZonesData.mapClickData.pixelPos, featuresData: coordInZonesData.mapClickData.featuresData, visibleTileLayerKeys: visTileLayerKeys, checkedNamedGeoZones: coordInZonesData.namedGeoZones, apiResponse: _p0._0.apiResponse});
			}
		}
	});
var _user$project$Map_Update_ClickPosInfo$updateResponse = F4(
	function (layerKey, relatedClickCoords, response, clickPosInfo) {
		var _p1 = clickPosInfo;
		if (_p1.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p2 = _p1._0;
			return _elm_lang$core$Native_Utils.eq(relatedClickCoords, _p2.coordinate) ? _elm_lang$core$Maybe$Just(
				_elm_lang$core$Native_Utils.update(
					_p2,
					{
						apiResponse: _elm_lang$core$List$concat(
							{
								ctor: '::',
								_0: _p2.apiResponse,
								_1: {
									ctor: '::',
									_0: {
										ctor: '::',
										_0: {layerKey: layerKey, response: response},
										_1: {ctor: '[]'}
									},
									_1: {ctor: '[]'}
								}
							})
					})) : _elm_lang$core$Maybe$Just(_p2);
		}
	});
var _user$project$Map_Update_ClickPosInfo$clearResponses = function (clickPosInfo) {
	var _p3 = clickPosInfo;
	if (_p3.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			_elm_lang$core$Native_Utils.update(
				_p3._0,
				{
					apiResponse: {ctor: '[]'}
				}));
	}
};
var _user$project$Map_Update_ClickPosInfo$updatePixelPos = F2(
	function (pixelPos, clickPosInfo) {
		var _p4 = clickPosInfo;
		if (_p4.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p5 = pixelPos;
			if (_p5.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					_elm_lang$core$Native_Utils.update(
						_p4._0,
						{pixelPos: _p5._0}));
			}
		}
	});

var _user$project$Map_Update_Mode_Utils$printDebugMismatch = F2(
	function (situation, mode) {
		var print = A2(
			_elm_lang$core$Basics_ops['++'],
			'Mismatch in ',
			A2(_elm_lang$core$Basics_ops['++'], situation, ' while mode is '));
		return A2(_elm_lang$core$Debug$log, print, mode);
	});
var _user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg = F2(
	function (situation, mode) {
		var newMode = A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, situation, mode);
		return {ctor: '_Tuple3', _0: newMode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
	});
var _user$project$Map_Update_Mode_Utils$updateError = F2(
	function (errorOp, error) {
		return _elm_lang$core$Native_Utils.update(
			errorOp,
			{error: error});
	});
var _user$project$Map_Update_Mode_Utils$resetInteractions = function (map) {
	return _user$project$Map_Effects_Ports$updateInteractions(
		{map: map, iaType: 'normal', options: _elm_lang$core$Json_Encode$null});
};
var _user$project$Map_Update_Mode_Utils$resetMode = function (state) {
	return {
		ctor: '_Tuple2',
		_0: _elm_lang$core$Native_Utils.update(
			state,
			{mode: _user$project$Map_Data_Mode$NormalMode}),
		_1: _user$project$Map_Update_Mode_Utils$resetInteractions(state.map)
	};
};
var _user$project$Map_Update_Mode_Utils$resetIasClearReload = F6(
	function (msgFromMap, headers, map, extent, layers, keys) {
		var reloadVectorCmd = A5(_user$project$Map_Update_Layer_Vector$reloadByKeysCmd, msgFromMap, headers, extent, layers, keys);
		var clearLayersCmd = A3(_user$project$Map_Update_Layer$clearByKeys, map, layers, keys);
		return _elm_lang$core$Platform_Cmd$batch(
			{
				ctor: '::',
				_0: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
				_1: {
					ctor: '::',
					_0: clearLayersCmd,
					_1: {
						ctor: '::',
						_0: reloadVectorCmd,
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _user$project$Map_Update_Mode_Op_Select$initWithSelect = F3(
	function (map, geoObjs, select) {
		var layerKeyVals = _elm_lang$core$Json_Encode$list(
			A2(_elm_lang$core$List$map, _elm_lang$core$Json_Encode$string, select.layerKeys));
		var portData = {
			map: map,
			iaType: 'select',
			options: _elm_lang$core$Json_Encode$object(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'layerKeys', _1: layerKeyVals},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'initGeoObjs',
							_1: _elm_lang$core$Json_Encode$list(
								A2(
									_elm_lang$core$List$map,
									function (geoObj) {
										return _elm_lang$core$Json_Encode$object(
											{
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'id',
													_1: _elm_lang$core$Json_Encode$string(geoObj.id)
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'obj',
														_1: function () {
															var _p0 = geoObj.obj;
															if (_p0.ctor === 'Nothing') {
																return _elm_lang$core$Json_Encode$null;
															} else {
																return _p0._0;
															}
														}()
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'layerKey',
															_1: _elm_lang$core$Json_Encode$string(geoObj.layerKey)
														},
														_1: {ctor: '[]'}
													}
												}
											});
									},
									geoObjs))
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'geoZone',
								_1: function () {
									var _p1 = select.geoZone;
									if (_p1.ctor === 'Nothing') {
										return _elm_lang$core$Json_Encode$null;
									} else {
										return _p1._0;
									}
								}()
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'onlyMulti',
									_1: _elm_lang$core$Json_Encode$bool(select.onlyMulti)
								},
								_1: {ctor: '[]'}
							}
						}
					}
				})
		};
		return {
			ctor: '_Tuple2',
			_0: select,
			_1: _user$project$Map_Effects_Ports$updateInteractions(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_Select$getFilteredByKeySelected = F2(
	function (layerKey, select) {
		var toFeatureData = function (feature) {
			return (!_elm_lang$core$Native_Utils.eq(feature.layerKey, layerKey)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
				{id: feature.id, data: feature.data});
		};
		return {
			layerKey: layerKey,
			features: A2(_elm_lang$core$List$filterMap, toFeatureData, select.selected)
		};
	});
var _user$project$Map_Update_Mode_Op_Select$updateSelection = F2(
	function (featuresData, select) {
		return _elm_lang$core$Native_Utils.update(
			select,
			{selected: featuresData});
	});
var _user$project$Map_Update_Mode_Op_Select$initNoEndWithGeoObjs = F4(
	function (map, layerKeys, geoObjs, panAndZoom) {
		var panZoomPortData = {map: map, geoObjs: geoObjs, panAndZoom: panAndZoom, select: false};
		var select = _user$project$Map_Data_Mode_Op_Select$noEndFromGeoObjs(layerKeys);
		var _p2 = A3(_user$project$Map_Update_Mode_Op_Select$initWithSelect, map, geoObjs, select);
		var updSelect = _p2._0;
		var selCmd = _p2._1;
		var cmds = panAndZoom ? _elm_lang$core$Platform_Cmd$batch(
			{
				ctor: '::',
				_0: selCmd,
				_1: {
					ctor: '::',
					_0: _user$project$Map_Effects_Ports$panZoomSelectGeoObjs(panZoomPortData),
					_1: {ctor: '[]'}
				}
			}) : selCmd;
		return {ctor: '_Tuple2', _0: updSelect, _1: cmds};
	});
var _user$project$Map_Update_Mode_Op_Select$initWithMinMaxZone = F5(
	function (map, layerKeys, min, max, geoZone) {
		var select = A5(_user$project$Map_Data_Mode_Op_Select$fromAllParams, layerKeys, min, max, geoZone, false);
		return A3(
			_user$project$Map_Update_Mode_Op_Select$initWithSelect,
			map,
			{ctor: '[]'},
			select);
	});
var _user$project$Map_Update_Mode_Op_Select$initWithOnlyMultiGeoms = F3(
	function (map, layerKeys, geoZone) {
		var select = A5(_user$project$Map_Data_Mode_Op_Select$fromAllParams, layerKeys, 1, _elm_lang$core$Random$maxInt, geoZone, true);
		return A3(
			_user$project$Map_Update_Mode_Op_Select$initWithSelect,
			map,
			{ctor: '[]'},
			select);
	});
var _user$project$Map_Update_Mode_Op_Select$init = F3(
	function (map, layerKeys, geoZone) {
		var select = A2(_user$project$Map_Data_Mode_Op_Select$fromLayerKeysZone, layerKeys, geoZone);
		return A3(
			_user$project$Map_Update_Mode_Op_Select$initWithSelect,
			map,
			{ctor: '[]'},
			select);
	});

var _user$project$Map_Update_Mode_SelectObjs$onCancelled = F2(
	function (map, name) {
		return {
			ctor: '_Tuple3',
			_0: _user$project$Map_Data_Mode$NormalMode,
			_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
			_2: A3(_user$project$Map_Data_Mode_OutMsg$SelectUpdated, name, _elm_lang$core$Maybe$Nothing, true)
		};
	});
var _user$project$Map_Update_Mode_SelectObjs$onOpDone = F3(
	function (map, name, select) {
		return {
			ctor: '_Tuple3',
			_0: _user$project$Map_Data_Mode$NormalMode,
			_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
			_2: A3(
				_user$project$Map_Data_Mode_OutMsg$SelectUpdated,
				name,
				_elm_lang$core$Maybe$Just(select.selected),
				true)
		};
	});
var _user$project$Map_Update_Mode_SelectObjs$sendOnUpdated = F2(
	function (name, select) {
		return A3(
			_user$project$Map_Data_Mode_OutMsg$SelectUpdated,
			name,
			_elm_lang$core$Maybe$Just(select.selected),
			false);
	});
var _user$project$Map_Update_Mode_SelectObjs$startNoEndWithGeoObjs = F5(
	function (state, name, layerKeys, geoObjs, panAndZoom) {
		var _p0 = A4(_user$project$Map_Update_Mode_Op_Select$initNoEndWithGeoObjs, state.map, layerKeys, geoObjs, panAndZoom);
		var newSelect = _p0._0;
		var selCmd = _p0._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$SelectObjs, name, newSelect)
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});
var _user$project$Map_Update_Mode_SelectObjs$startNoEnd = F3(
	function (state, name, layerKeys) {
		var _p1 = A5(_user$project$Map_Update_Mode_Op_Select$initWithMinMaxZone, state.map, layerKeys, _elm_lang$core$Random$maxInt, _elm_lang$core$Random$maxInt, _elm_lang$core$Maybe$Nothing);
		var newSelect = _p1._0;
		var selCmd = _p1._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$SelectObjs, name, newSelect)
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});
var _user$project$Map_Update_Mode_SelectObjs$startWithMinMaxZone = F6(
	function (state, name, layerKeys, min, max, geoZone) {
		var _p2 = A5(_user$project$Map_Update_Mode_Op_Select$initWithMinMaxZone, state.map, layerKeys, min, max, geoZone);
		var newSelect = _p2._0;
		var selCmd = _p2._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$SelectObjs, name, newSelect)
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});
var _user$project$Map_Update_Mode_SelectObjs$startOnlyMultiGeoms = F4(
	function (state, name, layerKeys, geoZone) {
		var _p3 = A3(_user$project$Map_Update_Mode_Op_Select$initWithOnlyMultiGeoms, state.map, layerKeys, geoZone);
		var newSelect = _p3._0;
		var selCmd = _p3._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$SelectObjs, name, newSelect)
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});
var _user$project$Map_Update_Mode_SelectObjs$start = F4(
	function (state, name, layerKeys, geoZone) {
		var _p4 = A3(_user$project$Map_Update_Mode_Op_Select$init, state.map, layerKeys, geoZone);
		var newSelect = _p4._0;
		var selCmd = _p4._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$SelectObjs, name, newSelect)
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});

var _user$project$Map_Update_Mode_Op_Draw$initWithDrawAndSnapLayerKeys = F5(
	function (map, draw, snap, snapLayerKeys, freezeSel) {
		var portData = {
			map: map,
			iaType: 'draw',
			options: _elm_lang$core$Json_Encode$object(
				{
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'layerKey',
						_1: _elm_lang$core$Json_Encode$string(draw.layerKey)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'shapeType',
							_1: _elm_lang$core$Json_Encode$string(draw.shapeType)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'snap',
								_1: _elm_lang$core$Json_Encode$bool(snap)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'snapLayerKeys',
									_1: _elm_lang$core$Json_Encode$list(
										A2(
											_elm_lang$core$List$map,
											function (snapLayerKey) {
												return _elm_lang$core$Json_Encode$string(snapLayerKey);
											},
											snapLayerKeys))
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'freezeSelection',
										_1: _elm_lang$core$Json_Encode$bool(freezeSel)
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'id',
											_1: function () {
												var _p0 = draw.id;
												if (_p0.ctor === 'Nothing') {
													return _elm_lang$core$Json_Encode$null;
												} else {
													return _elm_lang$core$Json_Encode$string(_p0._0);
												}
											}()
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'geoZone',
												_1: function () {
													var _p1 = draw.geoZone;
													if (_p1.ctor === 'Nothing') {
														return _elm_lang$core$Json_Encode$null;
													} else {
														return _p1._0;
													}
												}()
											},
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}
				})
		};
		return {
			ctor: '_Tuple2',
			_0: draw,
			_1: _user$project$Map_Effects_Ports$updateInteractions(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_Draw$initWithDraw = F4(
	function (map, draw, snap, freezeSel) {
		var portData = {
			map: map,
			iaType: 'draw',
			options: _elm_lang$core$Json_Encode$object(
				{
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'layerKey',
						_1: _elm_lang$core$Json_Encode$string(draw.layerKey)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'shapeType',
							_1: _elm_lang$core$Json_Encode$string(draw.shapeType)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'snap',
								_1: _elm_lang$core$Json_Encode$bool(snap)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'freezeSelection',
									_1: _elm_lang$core$Json_Encode$bool(freezeSel)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'id',
										_1: function () {
											var _p2 = draw.id;
											if (_p2.ctor === 'Nothing') {
												return _elm_lang$core$Json_Encode$null;
											} else {
												return _elm_lang$core$Json_Encode$string(_p2._0);
											}
										}()
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'geoZone',
											_1: function () {
												var _p3 = draw.geoZone;
												if (_p3.ctor === 'Nothing') {
													return _elm_lang$core$Json_Encode$null;
												} else {
													return _p3._0;
												}
											}()
										},
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				})
		};
		return {
			ctor: '_Tuple2',
			_0: draw,
			_1: _user$project$Map_Effects_Ports$updateInteractions(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_Draw$updateDrawn = F2(
	function (geomData, draw) {
		return _elm_lang$core$Native_Utils.update(
			draw,
			{
				drawn: _elm_lang$core$Maybe$Just(geomData)
			});
	});
var _user$project$Map_Update_Mode_Op_Draw$addPolylineToMultiPolyline = F2(
	function (geomData, draw) {
		var decodeMultiPolyline = F2(
			function (decoder, geom) {
				var _p4 = A2(_elm_lang$core$Json_Decode$decodeValue, decoder, geom);
				if (_p4.ctor === 'Ok') {
					return _elm_lang$core$Maybe$Just(_p4._0);
				} else {
					return A2(_elm_lang$core$Debug$log, 'Error: Coudn\'t decode MultiLineString', _elm_lang$core$Maybe$Nothing);
				}
			});
		var mayCurrentMultiPolylineData = function () {
			var _p5 = draw.drawn;
			if (_p5.ctor === 'Just') {
				return A2(decodeMultiPolyline, _user$project$Map_Data_GeoJSON$multiPolylineDecoder, _p5._0.geom);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		}();
		var mayNewMultiPolylineData = A2(decodeMultiPolyline, _user$project$Map_Data_GeoJSON$multiPolylineDecoder, geomData.geom);
		var mayNewGeomData = function () {
			var _p6 = {ctor: '_Tuple2', _0: mayCurrentMultiPolylineData, _1: mayNewMultiPolylineData};
			_v6_2:
			do {
				if (_p6._0.ctor === 'Just') {
					if (_p6._1.ctor === 'Just') {
						var _p8 = _p6._0._0;
						var mayUpdCoordinates = function () {
							var _p7 = {ctor: '_Tuple2', _0: _p8.coordinates, _1: _p6._1._0.coordinates};
							if ((_p7._0.ctor === 'Just') && (_p7._1.ctor === 'Just')) {
								return _elm_lang$core$Maybe$Just(
									_elm_lang$core$List$concat(
										{
											ctor: '::',
											_0: _p7._0._0,
											_1: {
												ctor: '::',
												_0: _p7._1._0,
												_1: {ctor: '[]'}
											}
										}));
							} else {
								return _elm_lang$core$Maybe$Nothing;
							}
						}();
						var updMultiPolylineData = _elm_lang$core$Native_Utils.update(
							_p8,
							{coordinates: mayUpdCoordinates});
						var newGeom = _user$project$Map_Data_GeoJSON$multiPolylineEncoder(updMultiPolylineData);
						return A2(
							_elm_lang$core$Maybe$map,
							function (drawn) {
								return _elm_lang$core$Native_Utils.update(
									drawn,
									{layerKey: geomData.layerKey, geom: newGeom});
							},
							draw.drawn);
					} else {
						break _v6_2;
					}
				} else {
					if (_p6._1.ctor === 'Just') {
						return _elm_lang$core$Maybe$Just(geomData);
					} else {
						break _v6_2;
					}
				}
			} while(false);
			return _elm_lang$core$Maybe$Nothing;
		}();
		return _elm_lang$core$Native_Utils.update(
			draw,
			{drawn: mayNewGeomData});
	});
var _user$project$Map_Update_Mode_Op_Draw$initWithSnapLayerKeys = F8(
	function (map, layerKey, shapeType, snap, snapLayerKeys, freezeSel, mayId, geoZone) {
		var draw = A4(_user$project$Map_Data_Mode_Op_Draw$fromKeyTypeIdZone, layerKey, shapeType, mayId, geoZone);
		return A5(_user$project$Map_Update_Mode_Op_Draw$initWithDrawAndSnapLayerKeys, map, draw, snap, snapLayerKeys, freezeSel);
	});
var _user$project$Map_Update_Mode_Op_Draw$init = F7(
	function (map, layerKey, shapeType, snap, freezeSel, mayId, geoZone) {
		var draw = A4(_user$project$Map_Data_Mode_Op_Draw$fromKeyTypeIdZone, layerKey, shapeType, mayId, geoZone);
		return A4(_user$project$Map_Update_Mode_Op_Draw$initWithDraw, map, draw, snap, freezeSel);
	});

var _user$project$Map_Update_Mode_AddGeom$onCancelled = F7(
	function (msgFromMap, headers, map, extent, layers, name, draw) {
		return {
			ctor: '_Tuple3',
			_0: _user$project$Map_Data_Mode$NormalMode,
			_1: A6(
				_user$project$Map_Update_Mode_Utils$resetIasClearReload,
				msgFromMap,
				headers,
				map,
				extent,
				layers,
				{
					ctor: '::',
					_0: draw.layerKey,
					_1: {ctor: '[]'}
				}),
			_2: A2(_user$project$Map_Data_Mode_OutMsg$AddGeomEnded, name, _elm_lang$core$Maybe$Nothing)
		};
	});
var _user$project$Map_Update_Mode_AddGeom$onOpDone = F2(
	function (name, draw) {
		return {
			ctor: '_Tuple3',
			_0: _user$project$Map_Data_Mode$Wait,
			_1: _elm_lang$core$Platform_Cmd$none,
			_2: A2(_user$project$Map_Data_Mode_OutMsg$AddGeomEnded, name, draw.drawn)
		};
	});
var _user$project$Map_Update_Mode_AddGeom$startWithSnapLayerKeys = F7(
	function (shapeType, state, name, layerKey, snap, snapLayerKeys, geoZone) {
		var _p0 = A8(_user$project$Map_Update_Mode_Op_Draw$initWithSnapLayerKeys, state.map, layerKey, shapeType, snap, snapLayerKeys, false, _elm_lang$core$Maybe$Nothing, geoZone);
		var newDraw = _p0._0;
		var drawCmd = _p0._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$AddGeom, name, newDraw)
			});
		return {ctor: '_Tuple2', _0: newState, _1: drawCmd};
	});
var _user$project$Map_Update_Mode_AddGeom$start = F6(
	function (shapeType, state, name, layerKey, snap, geoZone) {
		var _p1 = A7(_user$project$Map_Update_Mode_Op_Draw$init, state.map, layerKey, shapeType, snap, false, _elm_lang$core$Maybe$Nothing, geoZone);
		var newDraw = _p1._0;
		var drawCmd = _p1._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$AddGeom, name, newDraw)
			});
		return {ctor: '_Tuple2', _0: newState, _1: drawCmd};
	});

var _user$project$Map_Update_Mode_Op_DrawPtAtCurPos$initWithDrawPtAtCurPos = F2(
	function (map, drawPtAtCurPos) {
		var portData = {map: map, layerKey: drawPtAtCurPos.layerKey, geoZone: drawPtAtCurPos.geoZone};
		return {
			ctor: '_Tuple2',
			_0: drawPtAtCurPos,
			_1: _user$project$Map_Effects_Ports$drawPtAtCurPos(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_DrawPtAtCurPos$updateDrawPtAtCurPos = F2(
	function (ptAtCurPosData, drawPtAtCurPos) {
		return _elm_lang$core$Native_Utils.update(
			drawPtAtCurPos,
			{
				ptAtCurPosData: _elm_lang$core$Maybe$Just(ptAtCurPosData)
			});
	});
var _user$project$Map_Update_Mode_Op_DrawPtAtCurPos$init = F4(
	function (map, layerKey, mayId, geoZone) {
		var drawPtAtCurPos = A3(_user$project$Map_Data_Mode_Op_DrawPtAtCurPos$fromKeyIdZone, layerKey, mayId, geoZone);
		return A2(_user$project$Map_Update_Mode_Op_DrawPtAtCurPos$initWithDrawPtAtCurPos, map, drawPtAtCurPos);
	});

var _user$project$Map_Update_Mode_AddPointFromCurPos$onCancelled = F7(
	function (msgFromMap, headers, map, extent, layers, name, drawPtAtCurPos) {
		return {
			ctor: '_Tuple3',
			_0: _user$project$Map_Data_Mode$NormalMode,
			_1: A6(
				_user$project$Map_Update_Mode_Utils$resetIasClearReload,
				msgFromMap,
				headers,
				map,
				extent,
				layers,
				{
					ctor: '::',
					_0: drawPtAtCurPos.layerKey,
					_1: {ctor: '[]'}
				}),
			_2: A2(_user$project$Map_Data_Mode_OutMsg$AddGeomEnded, name, _elm_lang$core$Maybe$Nothing)
		};
	});
var _user$project$Map_Update_Mode_AddPointFromCurPos$onOpDone = F2(
	function (name, drawPtAtCurPos) {
		return {
			ctor: '_Tuple3',
			_0: _user$project$Map_Data_Mode$Wait,
			_1: _elm_lang$core$Platform_Cmd$none,
			_2: A2(
				_user$project$Map_Data_Mode_OutMsg$AddGeomEnded,
				name,
				A2(
					_elm_lang$core$Maybe$map,
					function (_) {
						return _.geomData;
					},
					drawPtAtCurPos.ptAtCurPosData))
		};
	});
var _user$project$Map_Update_Mode_AddPointFromCurPos$start = F4(
	function (state, name, layerKey, geoZone) {
		var _p0 = A4(_user$project$Map_Update_Mode_Op_DrawPtAtCurPos$init, state.map, layerKey, _elm_lang$core$Maybe$Nothing, geoZone);
		var newDrawPtAtCurPos = _p0._0;
		var drawPtAtCurPosCmd = _p0._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(_user$project$Map_Data_Mode$AddPointFromCurPos, name, newDrawPtAtCurPos)
			});
		return {ctor: '_Tuple2', _0: newState, _1: drawPtAtCurPosCmd};
	});

var _user$project$Map_Update_Mode_Op_Save$batchSave = F6(
	function (msgFromMap, headers, layers, toCreate, toModify, toDelete) {
		var allKeys = function () {
			var keysWithToCreate = function () {
				var _p0 = toCreate;
				if (_p0.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					return {
						ctor: '::',
						_0: _p0._0.layerKey,
						_1: {ctor: '[]'}
					};
				}
			}();
			var keysWithToModifyAndToCreate = function () {
				var _p1 = toModify;
				if (_p1.ctor === 'Nothing') {
					return keysWithToCreate;
				} else {
					var _p2 = _p1._0;
					return A2(_elm_lang$core$List$member, _p2.layerKey, keysWithToCreate) ? keysWithToCreate : {ctor: '::', _0: _p2.layerKey, _1: keysWithToCreate};
				}
			}();
			var _p3 = toDelete;
			if (_p3.ctor === 'Nothing') {
				return keysWithToModifyAndToCreate;
			} else {
				var _p4 = _p3._0;
				return A2(_elm_lang$core$List$member, _p4.layerKey, keysWithToModifyAndToCreate) ? keysWithToModifyAndToCreate : {ctor: '::', _0: _p4.layerKey, _1: keysWithToModifyAndToCreate};
			}
		}();
		var toDeleteReqs = function () {
			var _p5 = toDelete;
			if (_p5.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				var _p7 = _p5._0;
				var _p6 = A2(_user$project$Map_Update_Layer_Vector$findByKey, layers, _p7.layerKey);
				if (_p6.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					return A2(
						_elm_lang$core$List$filterMap,
						function (feat) {
							return A4(_user$project$Map_Effects_Vector$deleteRequest, msgFromMap, headers, _p6._0, feat.id);
						},
						_p7.features);
				}
			}
		}();
		var toModifyReqs = function () {
			var _p8 = toModify;
			if (_p8.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				var _p10 = _p8._0;
				var _p9 = A2(_user$project$Map_Update_Layer_Vector$findByKey, layers, _p10.layerKey);
				if (_p9.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					return A2(
						_elm_lang$core$List$filterMap,
						function (feat) {
							return A5(
								_user$project$Map_Effects_Vector$saveRequest,
								msgFromMap,
								headers,
								_p9._0,
								_elm_lang$core$Maybe$Just(feat.id),
								feat.data);
						},
						_p10.features);
				}
			}
		}();
		var toCreateReqs = function () {
			var _p11 = toCreate;
			if (_p11.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				var _p13 = _p11._0;
				var _p12 = A2(_user$project$Map_Update_Layer_Vector$findByKey, layers, _p13.layerKey);
				if (_p12.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					return A2(
						_elm_lang$core$List$filterMap,
						function (feat) {
							return A5(_user$project$Map_Effects_Vector$saveRequest, msgFromMap, headers, _p12._0, _elm_lang$core$Maybe$Nothing, feat);
						},
						_p13.features);
				}
			}
		}();
		var allRequests = _elm_lang$core$List$concat(
			{
				ctor: '::',
				_0: toCreateReqs,
				_1: {
					ctor: '::',
					_0: toModifyReqs,
					_1: {
						ctor: '::',
						_0: toDeleteReqs,
						_1: {ctor: '[]'}
					}
				}
			});
		return _elm_lang$core$List$isEmpty(allRequests) ? {ctor: '_Tuple2', _0: _user$project$Map_Data_Mode_Op_Save$NotStarted, _1: _elm_lang$core$Platform_Cmd$none} : {
			ctor: '_Tuple2',
			_0: _user$project$Map_Data_Mode_Op_Save$Working(allKeys),
			_1: A2(
				_elm_lang$core$Task$attempt,
				function (_p14) {
					return msgFromMap(
						_user$project$Map_Data_Msg$ModeEvent(
							_user$project$Map_Data_Mode$SaveOpReceived(_p14)));
				},
				_elm_lang$core$Task$sequence(
					A2(_elm_lang$core$List$map, _elm_lang$http$Http$toTask, allRequests)))
		};
	});
var _user$project$Map_Update_Mode_Op_Save$updateResult = function (res) {
	return _user$project$Map_Data_Mode_Op_Save$Done(res);
};

var _user$project$Map_Update_Mode_ModifyGeoms$startWithModify = F4(
	function (state, layerKey, snap, modify) {
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: _user$project$Map_Data_Mode$ModifyGeoms(
					_user$project$Map_Data_Mode_Op$ModifyOp(modify))
			});
		var portData = {
			map: state.map,
			iaType: 'modify',
			options: _elm_lang$core$Json_Encode$object(
				{
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'layerKey',
						_1: _elm_lang$core$Json_Encode$string(layerKey)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'snap',
							_1: _elm_lang$core$Json_Encode$bool(snap)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'geoZone',
								_1: function () {
									var _p0 = modify.geoZone;
									if (_p0.ctor === 'Nothing') {
										return _elm_lang$core$Json_Encode$null;
									} else {
										return _p0._0;
									}
								}()
							},
							_1: {ctor: '[]'}
						}
					}
				})
		};
		return {
			ctor: '_Tuple2',
			_0: newState,
			_1: _user$project$Map_Effects_Ports$updateInteractions(portData)
		};
	});
var _user$project$Map_Update_Mode_ModifyGeoms$onCancelled = F7(
	function (msgFromMap, headers, map, extent, layers, mode, op) {
		var _p1 = op;
		if (_p1.ctor === 'ModifyOp') {
			return {
				ctor: '_Tuple3',
				_0: _user$project$Map_Data_Mode$NormalMode,
				_1: A6(
					_user$project$Map_Update_Mode_Utils$resetIasClearReload,
					msgFromMap,
					headers,
					map,
					extent,
					layers,
					{
						ctor: '::',
						_0: _p1._0.layerKey,
						_1: {ctor: '[]'}
					}),
				_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
			};
		} else {
			return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'on cancelled modifGeoms', mode);
		}
	});
var _user$project$Map_Update_Mode_ModifyGeoms$onOpDone = F6(
	function (msgFromMap, headers, map, layers, mode, op) {
		var _p2 = op;
		switch (_p2.ctor) {
			case 'ModifyOp':
				var _p6 = _p2._0;
				var features = A2(
					_elm_lang$core$List$map,
					function (_p3) {
						var _p4 = _p3;
						return {id: _p4._0, data: _p4._1};
					},
					_elm_lang$core$Dict$toList(_p6.modified));
				var layerFeatures = {layerKey: _p6.layerKey, features: features};
				var _p5 = A6(
					_user$project$Map_Update_Mode_Op_Save$batchSave,
					msgFromMap,
					headers,
					layers,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Just(layerFeatures),
					_elm_lang$core$Maybe$Nothing);
				var newSave = _p5._0;
				var saveCmd = _p5._1;
				var newMode = _user$project$Map_Data_Mode$ModifyGeoms(
					_user$project$Map_Data_Mode_Op$SaveOp(newSave));
				return {
					ctor: '_Tuple3',
					_0: newMode,
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: saveCmd,
							_1: {
								ctor: '::',
								_0: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
								_1: {ctor: '[]'}
							}
						}),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'SaveOp':
				return {ctor: '_Tuple3', _0: _user$project$Map_Data_Mode$NormalMode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'update selection', mode);
		}
	});
var _user$project$Map_Update_Mode_ModifyGeoms$start = F4(
	function (state, layerKey, snap, geoZone) {
		return A4(
			_user$project$Map_Update_Mode_ModifyGeoms$startWithModify,
			state,
			layerKey,
			snap,
			A2(_user$project$Map_Data_Mode_Op_Modify$fromLayerKeyZone, layerKey, geoZone));
	});

var _user$project$Map_Update_Mode_DeleteObjs$onCancelled = function (map) {
	return {
		ctor: '_Tuple3',
		_0: _user$project$Map_Data_Mode$NormalMode,
		_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
		_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
	};
};
var _user$project$Map_Update_Mode_DeleteObjs$onOpDone = F5(
	function (msgFromMap, headers, layers, mode, op) {
		var _p0 = op;
		switch (_p0.ctor) {
			case 'SelectOp':
				var _p3 = _p0._0;
				var _p1 = _user$project$Map_Data_Mode_Op_Select$getUniqueLayerKey(_p3);
				if (_p1.ctor === 'Nothing') {
					return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'from selection to save', mode);
				} else {
					var toDelete = A2(_user$project$Map_Update_Mode_Op_Select$getFilteredByKeySelected, _p1._0, _p3);
					var _p2 = A6(
						_user$project$Map_Update_Mode_Op_Save$batchSave,
						msgFromMap,
						headers,
						layers,
						_elm_lang$core$Maybe$Nothing,
						_elm_lang$core$Maybe$Nothing,
						_elm_lang$core$Maybe$Just(toDelete));
					var newSave = _p2._0;
					var saveCmd = _p2._1;
					var newMode = _user$project$Map_Data_Mode$DeleteObjs(
						_user$project$Map_Data_Mode_Op$SaveOp(newSave));
					return {ctor: '_Tuple3', _0: newMode, _1: saveCmd, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
				}
			case 'SaveOp':
				return {ctor: '_Tuple3', _0: _user$project$Map_Data_Mode$NormalMode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'no such op ', mode);
		}
	});
var _user$project$Map_Update_Mode_DeleteObjs$start = F3(
	function (state, layerKey, geoZone) {
		var _p4 = A3(
			_user$project$Map_Update_Mode_Op_Select$init,
			state.map,
			{
				ctor: '::',
				_0: layerKey,
				_1: {ctor: '[]'}
			},
			geoZone);
		var newSelect = _p4._0;
		var selCmd = _p4._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: _user$project$Map_Data_Mode$DeleteObjs(
					_user$project$Map_Data_Mode_Op$SelectOp(newSelect))
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});

var _user$project$Map_Update_Mode_Op_Merge$initWithMerge = F2(
	function (map, merge) {
		var portData = {map: map, selected: merge.selected};
		return {
			ctor: '_Tuple2',
			_0: merge,
			_1: _user$project$Map_Effects_Ports$startMerge(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_Merge$updateMerged = F2(
	function (mergeData, merge) {
		return _elm_lang$core$Native_Utils.update(
			merge,
			{merged: mergeData});
	});
var _user$project$Map_Update_Mode_Op_Merge$init = F3(
	function (map, layerKey, selected) {
		var merge = A2(_user$project$Map_Data_Mode_Op_Merge$fromKeyAndSel, layerKey, selected);
		return A2(_user$project$Map_Update_Mode_Op_Merge$initWithMerge, map, merge);
	});

var _user$project$Map_Update_Mode_MergePolys$onCancelled = F7(
	function (msgFromMap, headers, map, extent, layers, mode, op) {
		var _p0 = op;
		switch (_p0.ctor) {
			case 'SelectOp':
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$NormalMode,
					_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'MergeOp':
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$NormalMode,
					_1: A6(
						_user$project$Map_Update_Mode_Utils$resetIasClearReload,
						msgFromMap,
						headers,
						map,
						extent,
						layers,
						{
							ctor: '::',
							_0: _p0._0.layerKey,
							_1: {ctor: '[]'}
						}),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'on cancelled mergepolys', mode);
		}
	});
var _user$project$Map_Update_Mode_MergePolys$onOpDone = F6(
	function (msgFromMap, headers, map, layers, mode, op) {
		var _p1 = op;
		switch (_p1.ctor) {
			case 'SelectOp':
				var _p5 = _p1._0;
				var _p2 = _user$project$Map_Data_Mode_Op_Select$getUniqueLayerKey(_p5);
				if (_p2.ctor === 'Nothing') {
					return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'from selection to merge', mode);
				} else {
					var _p4 = _p2._0;
					var selected = A2(_user$project$Map_Update_Mode_Op_Select$getFilteredByKeySelected, _p4, _p5);
					var _p3 = A3(_user$project$Map_Update_Mode_Op_Merge$init, map, _p4, selected);
					var newMerge = _p3._0;
					var mergeCmd = _p3._1;
					var cmds = _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
							_1: {
								ctor: '::',
								_0: mergeCmd,
								_1: {ctor: '[]'}
							}
						});
					return {
						ctor: '_Tuple3',
						_0: _user$project$Map_Data_Mode$MergePolys(
							_user$project$Map_Data_Mode_Op$MergeOp(newMerge)),
						_1: cmds,
						_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
					};
				}
			case 'MergeOp':
				var _p8 = _p1._0;
				var toAdd = function () {
					var _p6 = _p8.merged;
					if (_p6.ctor === 'Nothing') {
						return A2(_elm_lang$core$Debug$log, 'saving merge, but no merged', _elm_lang$core$Maybe$Nothing);
					} else {
						return _elm_lang$core$Maybe$Just(
							{
								layerKey: _p8.layerKey,
								features: {
									ctor: '::',
									_0: _p6._0,
									_1: {ctor: '[]'}
								}
							});
					}
				}();
				var _p7 = A6(
					_user$project$Map_Update_Mode_Op_Save$batchSave,
					msgFromMap,
					headers,
					layers,
					toAdd,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Just(_p8.selected));
				var newSave = _p7._0;
				var saveCmd = _p7._1;
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$MergePolys(
						_user$project$Map_Data_Mode_Op$SaveOp(newSave)),
					_1: saveCmd,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'SaveOp':
				return {ctor: '_Tuple3', _0: _user$project$Map_Data_Mode$NormalMode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'no such op ', mode);
		}
	});
var _user$project$Map_Update_Mode_MergePolys$start = F3(
	function (state, layerKey, geoZone) {
		var _p9 = A5(
			_user$project$Map_Update_Mode_Op_Select$initWithMinMaxZone,
			state.map,
			{
				ctor: '::',
				_0: layerKey,
				_1: {ctor: '[]'}
			},
			2,
			_elm_lang$core$Random$maxInt,
			geoZone);
		var newSelect = _p9._0;
		var selCmd = _p9._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: _user$project$Map_Data_Mode$MergePolys(
					_user$project$Map_Data_Mode_Op$SelectOp(newSelect))
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});

var _user$project$Map_Update_Mode_Op_Split$initWithSplit = F2(
	function (map, split) {
		var portData = {map: map, selected: split.selected, lineGeom: split.lineGeom};
		return {
			ctor: '_Tuple2',
			_0: split,
			_1: _user$project$Map_Effects_Ports$startSplit(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_Split$updateSplit = F2(
	function (splitData, split) {
		return _elm_lang$core$Native_Utils.update(
			split,
			{split: splitData});
	});
var _user$project$Map_Update_Mode_Op_Split$init = F4(
	function (map, layerKey, selected, lineGeom) {
		var split = A3(_user$project$Map_Data_Mode_Op_Split$fromKeySelAndLine, layerKey, selected, lineGeom);
		return A2(_user$project$Map_Update_Mode_Op_Split$initWithSplit, map, split);
	});

var _user$project$Map_Update_Mode_SplitPolys$onCancelled = F7(
	function (msgFromMap, headers, map, extent, layers, mode, op) {
		var _p0 = op;
		switch (_p0.ctor) {
			case 'SelectOp':
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$NormalMode,
					_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'DrawOp':
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$NormalMode,
					_1: A6(
						_user$project$Map_Update_Mode_Utils$resetIasClearReload,
						msgFromMap,
						headers,
						map,
						extent,
						layers,
						{
							ctor: '::',
							_0: _p0._0.layerKey,
							_1: {ctor: '[]'}
						}),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'SplitOp':
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$NormalMode,
					_1: A6(
						_user$project$Map_Update_Mode_Utils$resetIasClearReload,
						msgFromMap,
						headers,
						map,
						extent,
						layers,
						{
							ctor: '::',
							_0: _p0._0.layerKey,
							_1: {ctor: '[]'}
						}),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'on cancelled splitpolys', mode);
		}
	});
var _user$project$Map_Update_Mode_SplitPolys$onOpDone = F7(
	function (msgFromMap, headers, map, layers, mode, op, selected) {
		var _p1 = op;
		switch (_p1.ctor) {
			case 'SelectOp':
				var _p5 = _p1._0;
				var _p2 = _user$project$Map_Data_Mode_Op_Select$getUniqueLayerKey(_p5);
				if (_p2.ctor === 'Nothing') {
					return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'from selection to split', mode);
				} else {
					var _p4 = _p2._0;
					var _p3 = A7(
						_user$project$Map_Update_Mode_Op_Draw$init,
						map,
						_p4,
						'LineString',
						true,
						true,
						_elm_lang$core$Maybe$Just('temp_split_line'),
						_elm_lang$core$Maybe$Nothing);
					var newDraw = _p3._0;
					var drawCmd = _p3._1;
					var newSel = A2(_user$project$Map_Update_Mode_Op_Select$getFilteredByKeySelected, _p4, _p5);
					return {
						ctor: '_Tuple3',
						_0: A2(
							_user$project$Map_Data_Mode$SplitPolys,
							_user$project$Map_Data_Mode_Op$DrawOp(newDraw),
							_elm_lang$core$Maybe$Just(newSel)),
						_1: drawCmd,
						_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
					};
				}
			case 'DrawOp':
				var _p10 = _p1._0;
				var _p6 = selected;
				if (_p6.ctor === 'Nothing') {
					return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'from draw to split', mode);
				} else {
					var _p9 = _p6._0;
					var _p7 = _p10.drawn;
					if (_p7.ctor === 'Nothing') {
						return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'from draw to split', mode);
					} else {
						var _p8 = A4(_user$project$Map_Update_Mode_Op_Split$init, map, _p10.layerKey, _p9, _p7._0.geom);
						var newSplit = _p8._0;
						var splitCmd = _p8._1;
						var cmds = _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
								_1: {
									ctor: '::',
									_0: splitCmd,
									_1: {ctor: '[]'}
								}
							});
						return {
							ctor: '_Tuple3',
							_0: A2(
								_user$project$Map_Data_Mode$SplitPolys,
								_user$project$Map_Data_Mode_Op$SplitOp(newSplit),
								_elm_lang$core$Maybe$Just(_p9)),
							_1: cmds,
							_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
						};
					}
				}
			case 'SplitOp':
				var _p13 = _p1._0;
				var toAdd = function () {
					var _p11 = _p13.split;
					if (_p11.ctor === 'Nothing') {
						return A2(_elm_lang$core$Debug$log, 'saving split, but no split to save', _elm_lang$core$Maybe$Nothing);
					} else {
						return _elm_lang$core$Maybe$Just(
							{layerKey: _p13.layerKey, features: _p11._0});
					}
				}();
				var _p12 = A6(
					_user$project$Map_Update_Mode_Op_Save$batchSave,
					msgFromMap,
					headers,
					layers,
					toAdd,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Just(_p13.selected));
				var newSave = _p12._0;
				var saveCmd = _p12._1;
				return {
					ctor: '_Tuple3',
					_0: A2(
						_user$project$Map_Data_Mode$SplitPolys,
						_user$project$Map_Data_Mode_Op$SaveOp(newSave),
						selected),
					_1: saveCmd,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'SaveOp':
				return {ctor: '_Tuple3', _0: _user$project$Map_Data_Mode$NormalMode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'no such op in split ', mode);
		}
	});
var _user$project$Map_Update_Mode_SplitPolys$start = F3(
	function (state, layerKey, geoZone) {
		var _p14 = A3(
			_user$project$Map_Update_Mode_Op_Select$init,
			state.map,
			{
				ctor: '::',
				_0: layerKey,
				_1: {ctor: '[]'}
			},
			geoZone);
		var newSelect = _p14._0;
		var selCmd = _p14._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: A2(
					_user$project$Map_Data_Mode$SplitPolys,
					_user$project$Map_Data_Mode_Op$SelectOp(newSelect),
					_elm_lang$core$Maybe$Nothing)
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});

var _user$project$Map_Update_Mode_Op_Breakup$initWithBreakup = F2(
	function (map, breakup) {
		var portData = {map: map, selected: breakup.selected};
		return {
			ctor: '_Tuple2',
			_0: breakup,
			_1: _user$project$Map_Effects_Ports$startBreakup(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_Breakup$updateBreakup = F2(
	function (breakupData, breakup) {
		return _elm_lang$core$Native_Utils.update(
			breakup,
			{breakup: breakupData});
	});
var _user$project$Map_Update_Mode_Op_Breakup$init = F3(
	function (map, layerKey, selected) {
		var breakup = A2(_user$project$Map_Data_Mode_Op_Breakup$fromKeySel, layerKey, selected);
		return A2(_user$project$Map_Update_Mode_Op_Breakup$initWithBreakup, map, breakup);
	});

var _user$project$Map_Update_Mode_BreakupPolys$onCancelled = F7(
	function (msgFromMap, headers, map, extent, layers, mode, op) {
		var _p0 = op;
		switch (_p0.ctor) {
			case 'SelectOp':
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$NormalMode,
					_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'BreakupOp':
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$NormalMode,
					_1: A6(
						_user$project$Map_Update_Mode_Utils$resetIasClearReload,
						msgFromMap,
						headers,
						map,
						extent,
						layers,
						{
							ctor: '::',
							_0: _p0._0.layerKey,
							_1: {ctor: '[]'}
						}),
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'on cancelled breakuppolys', mode);
		}
	});
var _user$project$Map_Update_Mode_BreakupPolys$onOpDone = F6(
	function (msgFromMap, headers, map, layers, mode, op) {
		var _p1 = op;
		switch (_p1.ctor) {
			case 'SelectOp':
				var _p5 = _p1._0;
				var _p2 = _user$project$Map_Data_Mode_Op_Select$getUniqueLayerKey(_p5);
				if (_p2.ctor === 'Nothing') {
					return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'from selection to breakup', mode);
				} else {
					var _p4 = _p2._0;
					var selected = A2(_user$project$Map_Update_Mode_Op_Select$getFilteredByKeySelected, _p4, _p5);
					var _p3 = A3(_user$project$Map_Update_Mode_Op_Breakup$init, map, _p4, selected);
					var newBreakup = _p3._0;
					var breakupCmd = _p3._1;
					return {
						ctor: '_Tuple3',
						_0: _user$project$Map_Data_Mode$BreakupPolys(
							_user$project$Map_Data_Mode_Op$BreakupOp(newBreakup)),
						_1: breakupCmd,
						_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
					};
				}
			case 'BreakupOp':
				var _p8 = _p1._0;
				var toAdd = function () {
					var _p6 = _p8.breakup;
					if (_p6.ctor === 'Nothing') {
						return A2(_elm_lang$core$Debug$log, 'saving breakup, but no breakup to save', _elm_lang$core$Maybe$Nothing);
					} else {
						return _elm_lang$core$Maybe$Just(
							{layerKey: _p8.layerKey, features: _p6._0});
					}
				}();
				var _p7 = A6(
					_user$project$Map_Update_Mode_Op_Save$batchSave,
					msgFromMap,
					headers,
					layers,
					toAdd,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Just(_p8.selected));
				var newSave = _p7._0;
				var saveCmd = _p7._1;
				return {
					ctor: '_Tuple3',
					_0: _user$project$Map_Data_Mode$BreakupPolys(
						_user$project$Map_Data_Mode_Op$SaveOp(newSave)),
					_1: saveCmd,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'SaveOp':
				return {ctor: '_Tuple3', _0: _user$project$Map_Data_Mode$NormalMode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
			default:
				return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatchOutMsg, 'no such op in breakup ', mode);
		}
	});
var _user$project$Map_Update_Mode_BreakupPolys$start = F3(
	function (state, layerKey, geoZone) {
		var _p9 = A3(
			_user$project$Map_Update_Mode_Op_Select$initWithOnlyMultiGeoms,
			state.map,
			{
				ctor: '::',
				_0: layerKey,
				_1: {ctor: '[]'}
			},
			geoZone);
		var newSelect = _p9._0;
		var selCmd = _p9._1;
		var newState = _elm_lang$core$Native_Utils.update(
			state,
			{
				mode: _user$project$Map_Data_Mode$BreakupPolys(
					_user$project$Map_Data_Mode_Op$SelectOp(newSelect))
			});
		return {ctor: '_Tuple2', _0: newState, _1: selCmd};
	});

var _user$project$Map_Update_Mode_Op_Capture$updateCapture = F2(
	function (captureData, capture) {
		return _elm_lang$core$Native_Utils.update(
			capture,
			{
				image: _elm_lang$core$Maybe$Just(captureData.image),
				canvasDimensions: _elm_lang$core$Maybe$Just(captureData.canvasDimensions)
			});
	});
var _user$project$Map_Update_Mode_Op_Capture$init = {
	ctor: '_Tuple2',
	_0: {image: _elm_lang$core$Maybe$Nothing, canvasDimensions: _elm_lang$core$Maybe$Nothing, error: _elm_lang$core$Maybe$Nothing},
	_1: _user$project$Map_Effects_Ports$captureCanvas(
		{})
};

var _user$project$Map_Update_Mode_CaptureCanvas$onCancelled = function (map) {
	return {
		ctor: '_Tuple3',
		_0: _user$project$Map_Data_Mode$NormalMode,
		_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
		_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
	};
};
var _user$project$Map_Update_Mode_CaptureCanvas$onOpDone = F2(
	function (map, capturedData) {
		return {
			ctor: '_Tuple3',
			_0: _user$project$Map_Data_Mode$NormalMode,
			_1: _user$project$Map_Update_Mode_Utils$resetInteractions(map),
			_2: _user$project$Map_Data_Mode_OutMsg$CaptureCanvasEnded(capturedData)
		};
	});
var _user$project$Map_Update_Mode_CaptureCanvas$start = function (state) {
	var _p0 = _user$project$Map_Update_Mode_Op_Capture$init;
	var newCapture = _p0._0;
	var captureCmd = _p0._1;
	var newState = _elm_lang$core$Native_Utils.update(
		state,
		{
			mode: _user$project$Map_Data_Mode$CaptureCanvas(newCapture)
		});
	return {ctor: '_Tuple2', _0: newState, _1: captureCmd};
};

var _user$project$Map_Update_Mode_Op_Modify$updateModifs = F2(
	function (featuresData, modify) {
		if (!_elm_lang$core$Native_Utils.eq(featuresData.layerKey, modify.layerKey)) {
			return A2(
				_elm_lang$core$Debug$log,
				A2(
					_elm_lang$core$Basics_ops['++'],
					'Layer mismatch in modify operation; expected ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						modify.layerKey,
						A2(_elm_lang$core$Basics_ops['++'], ' but received ', featuresData.layerKey))),
				modify);
		} else {
			var updates = _elm_lang$core$Dict$fromList(
				A2(
					_elm_lang$core$List$map,
					function (f) {
						return {ctor: '_Tuple2', _0: f.id, _1: f.data};
					},
					featuresData.features));
			var updModifs = A2(_elm_lang$core$Dict$union, updates, modify.modified);
			return _elm_lang$core$Native_Utils.update(
				modify,
				{modified: updModifs});
		}
	});

var _user$project$Map_Update_Mode_Op_GetInSel$initWithGetInSel = F2(
	function (map, getInSel) {
		var portData = {map: map, sourceGeoms: getInSel.sourceGeoms};
		return {
			ctor: '_Tuple2',
			_0: getInSel,
			_1: _user$project$Map_Effects_Ports$startGetInSel(portData)
		};
	});
var _user$project$Map_Update_Mode_Op_GetInSel$updateSelection = F2(
	function (getInSelData, getInSel) {
		return _elm_lang$core$Native_Utils.update(
			getInSel,
			{selected: getInSelData});
	});
var _user$project$Map_Update_Mode_Op_GetInSel$init = F3(
	function (map, layerKeys, sourceGeoms) {
		var getInSel = A2(_user$project$Map_Data_Mode_Op_GetInSel$fromKeysAndGeoms, layerKeys, sourceGeoms);
		return A2(_user$project$Map_Update_Mode_Op_GetInSel$initWithGetInSel, map, getInSel);
	});

var _user$project$Map_Update_Mode$onCancelled = F6(
	function (msgFromMap, headers, map, extent, layers, mode) {
		var _p0 = mode;
		switch (_p0.ctor) {
			case 'SelectObjs':
				return A2(_user$project$Map_Update_Mode_SelectObjs$onCancelled, map, _p0._0);
			case 'AddGeom':
				return A7(_user$project$Map_Update_Mode_AddGeom$onCancelled, msgFromMap, headers, map, extent, layers, _p0._0, _p0._1);
			case 'AddPointFromCurPos':
				return A7(_user$project$Map_Update_Mode_AddPointFromCurPos$onCancelled, msgFromMap, headers, map, extent, layers, _p0._0, _p0._1);
			case 'ModifyGeoms':
				return A7(_user$project$Map_Update_Mode_ModifyGeoms$onCancelled, msgFromMap, headers, map, extent, layers, mode, _p0._0);
			case 'DeleteObjs':
				return _user$project$Map_Update_Mode_DeleteObjs$onCancelled(map);
			case 'CaptureCanvas':
				return _user$project$Map_Update_Mode_CaptureCanvas$onCancelled(map);
			case 'MergePolys':
				return A7(_user$project$Map_Update_Mode_MergePolys$onCancelled, msgFromMap, headers, map, extent, layers, mode, _p0._0);
			case 'SplitPolys':
				return A7(_user$project$Map_Update_Mode_SplitPolys$onCancelled, msgFromMap, headers, map, extent, layers, mode, _p0._0);
			default:
				return {ctor: '_Tuple3', _0: _user$project$Map_Data_Mode$NormalMode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
		}
	});
var _user$project$Map_Update_Mode$onOpDone = F6(
	function (msgFromMap, headers, map, extent, layers, mode) {
		var _p1 = mode;
		switch (_p1.ctor) {
			case 'SelectObjs':
				return A3(_user$project$Map_Update_Mode_SelectObjs$onOpDone, map, _p1._0, _p1._1);
			case 'AddGeom':
				return A2(_user$project$Map_Update_Mode_AddGeom$onOpDone, _p1._0, _p1._1);
			case 'AddPointFromCurPos':
				return A2(_user$project$Map_Update_Mode_AddPointFromCurPos$onOpDone, _p1._0, _p1._1);
			case 'ModifyGeoms':
				return A6(_user$project$Map_Update_Mode_ModifyGeoms$onOpDone, msgFromMap, headers, map, layers, mode, _p1._0);
			case 'DeleteObjs':
				return A5(_user$project$Map_Update_Mode_DeleteObjs$onOpDone, msgFromMap, headers, layers, mode, _p1._0);
			case 'MergePolys':
				return A6(_user$project$Map_Update_Mode_MergePolys$onOpDone, msgFromMap, headers, map, layers, mode, _p1._0);
			case 'SplitPolys':
				return A7(_user$project$Map_Update_Mode_SplitPolys$onOpDone, msgFromMap, headers, map, layers, mode, _p1._0, _p1._1);
			case 'BreakupPolys':
				return A6(_user$project$Map_Update_Mode_BreakupPolys$onOpDone, msgFromMap, headers, map, layers, mode, _p1._0);
			case 'CaptureCanvas':
				return A2(_user$project$Map_Update_Mode_CaptureCanvas$onOpDone, map, _p1._0);
			default:
				return {ctor: '_Tuple3', _0: mode, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
		}
	});
var _user$project$Map_Update_Mode$onSaveResReceived = F4(
	function (map, clearReload, result, mode) {
		var _p2 = mode;
		_v2_5:
		do {
			switch (_p2.ctor) {
				case 'ModifyGeoms':
					if (_p2._0.ctor === 'SaveOp') {
						return {
							ctor: '_Tuple2',
							_0: _user$project$Map_Data_Mode$ModifyGeoms(
								_user$project$Map_Data_Mode_Op$SaveOp(
									_user$project$Map_Update_Mode_Op_Save$updateResult(result))),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						break _v2_5;
					}
				case 'DeleteObjs':
					if ((_p2._0.ctor === 'SaveOp') && (_p2._0._0.ctor === 'Working')) {
						return {
							ctor: '_Tuple2',
							_0: _user$project$Map_Data_Mode$DeleteObjs(
								_user$project$Map_Data_Mode_Op$SaveOp(
									_user$project$Map_Update_Mode_Op_Save$updateResult(result))),
							_1: clearReload(_p2._0._0._0)
						};
					} else {
						break _v2_5;
					}
				case 'MergePolys':
					if ((_p2._0.ctor === 'SaveOp') && (_p2._0._0.ctor === 'Working')) {
						return {
							ctor: '_Tuple2',
							_0: _user$project$Map_Data_Mode$MergePolys(
								_user$project$Map_Data_Mode_Op$SaveOp(
									_user$project$Map_Update_Mode_Op_Save$updateResult(result))),
							_1: clearReload(_p2._0._0._0)
						};
					} else {
						break _v2_5;
					}
				case 'SplitPolys':
					if ((_p2._0.ctor === 'SaveOp') && (_p2._0._0.ctor === 'Working')) {
						return {
							ctor: '_Tuple2',
							_0: A2(
								_user$project$Map_Data_Mode$SplitPolys,
								_user$project$Map_Data_Mode_Op$SaveOp(
									_user$project$Map_Update_Mode_Op_Save$updateResult(result)),
								_p2._1),
							_1: clearReload(_p2._0._0._0)
						};
					} else {
						break _v2_5;
					}
				case 'BreakupPolys':
					if ((_p2._0.ctor === 'SaveOp') && (_p2._0._0.ctor === 'Working')) {
						return {
							ctor: '_Tuple2',
							_0: _user$project$Map_Data_Mode$BreakupPolys(
								_user$project$Map_Data_Mode_Op$SaveOp(
									_user$project$Map_Update_Mode_Op_Save$updateResult(result))),
							_1: clearReload(_p2._0._0._0)
						};
					} else {
						break _v2_5;
					}
				default:
					break _v2_5;
			}
		} while(false);
		return {
			ctor: '_Tuple2',
			_0: A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'on save received', mode),
			_1: _elm_lang$core$Platform_Cmd$none
		};
	});
var _user$project$Map_Update_Mode$updateModeError = F2(
	function (mode, error) {
		var _p3 = mode;
		_v3_9:
		do {
			switch (_p3.ctor) {
				case 'AddGeom':
					return A2(
						_user$project$Map_Data_Mode$AddGeom,
						_p3._0,
						A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._1, error));
				case 'AddPointFromCurPos':
					return A2(
						_user$project$Map_Data_Mode$AddPointFromCurPos,
						_p3._0,
						A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._1, error));
				case 'ModifyGeoms':
					if (_p3._0.ctor === 'ModifyOp') {
						return _user$project$Map_Data_Mode$ModifyGeoms(
							_user$project$Map_Data_Mode_Op$ModifyOp(
								A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._0._0, error)));
					} else {
						break _v3_9;
					}
				case 'DeleteObjs':
					if (_p3._0.ctor === 'SelectOp') {
						return _user$project$Map_Data_Mode$DeleteObjs(
							_user$project$Map_Data_Mode_Op$SelectOp(
								A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._0._0, error)));
					} else {
						break _v3_9;
					}
				case 'SelectObjs':
					return A2(
						_user$project$Map_Data_Mode$SelectObjs,
						_p3._0,
						A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._1, error));
				case 'MergePolys':
					if (_p3._0.ctor === 'SelectOp') {
						return _user$project$Map_Data_Mode$MergePolys(
							_user$project$Map_Data_Mode_Op$SelectOp(
								A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._0._0, error)));
					} else {
						break _v3_9;
					}
				case 'SplitPolys':
					if (_p3._0.ctor === 'SelectOp') {
						return A2(
							_user$project$Map_Data_Mode$SplitPolys,
							_user$project$Map_Data_Mode_Op$SelectOp(
								A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._0._0, error)),
							_p3._1);
					} else {
						break _v3_9;
					}
				case 'BreakupPolys':
					if (_p3._0.ctor === 'SelectOp') {
						return _user$project$Map_Data_Mode$BreakupPolys(
							_user$project$Map_Data_Mode_Op$SelectOp(
								A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._0._0, error)));
					} else {
						break _v3_9;
					}
				case 'CaptureCanvas':
					return _user$project$Map_Data_Mode$CaptureCanvas(
						A2(_user$project$Map_Update_Mode_Utils$updateError, _p3._0, error));
				default:
					break _v3_9;
			}
		} while(false);
		return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'update mode error', mode);
	});
var _user$project$Map_Update_Mode$onCapturedCanvasReceived = F3(
	function (map, captureCanvasData, mode) {
		var _p4 = mode;
		if (_p4.ctor === 'CaptureCanvas') {
			return _user$project$Map_Data_Mode$CaptureCanvas(
				A2(_user$project$Map_Update_Mode_Op_Capture$updateCapture, captureCanvasData, _p4._0));
		} else {
			return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'on captured canvas received', mode);
		}
	});
var _user$project$Map_Update_Mode$onGetInSelReceived = F3(
	function (map, getInSelData, mode) {
		var _p5 = mode;
		return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'on getInSel received', mode);
	});
var _user$project$Map_Update_Mode$onBreakupReceived = F3(
	function (map, breakupData, mode) {
		var _p6 = mode;
		if ((_p6.ctor === 'BreakupPolys') && (_p6._0.ctor === 'BreakupOp')) {
			return _user$project$Map_Data_Mode$BreakupPolys(
				_user$project$Map_Data_Mode_Op$BreakupOp(
					A2(_user$project$Map_Update_Mode_Op_Breakup$updateBreakup, breakupData, _p6._0._0)));
		} else {
			return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'on breakup received', mode);
		}
	});
var _user$project$Map_Update_Mode$onSplitReceived = F3(
	function (map, splitData, mode) {
		var _p7 = mode;
		if ((_p7.ctor === 'SplitPolys') && (_p7._0.ctor === 'SplitOp')) {
			var _p8 = _p7._0._0;
			return {
				ctor: '_Tuple2',
				_0: A2(
					_user$project$Map_Data_Mode$SplitPolys,
					_user$project$Map_Data_Mode_Op$SplitOp(
						A2(_user$project$Map_Update_Mode_Op_Split$updateSplit, splitData, _p8)),
					_p7._1),
				_1: _user$project$Map_Effects_Ports$removeFeature(
					{map: map, layerKey: _p8.layerKey, id: 'temp_split_line'})
			};
		} else {
			return {
				ctor: '_Tuple2',
				_0: A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'on split received', mode),
				_1: _elm_lang$core$Platform_Cmd$none
			};
		}
	});
var _user$project$Map_Update_Mode$onMergeReceived = F3(
	function (map, mergeData, mode) {
		var _p9 = mode;
		if ((_p9.ctor === 'MergePolys') && (_p9._0.ctor === 'MergeOp')) {
			return _user$project$Map_Data_Mode$MergePolys(
				_user$project$Map_Data_Mode_Op$MergeOp(
					A2(_user$project$Map_Update_Mode_Op_Merge$updateMerged, mergeData, _p9._0._0)));
		} else {
			return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'on merge received', mode);
		}
	});
var _user$project$Map_Update_Mode$updateModifs = F3(
	function (map, featuresData, mode) {
		var _p10 = mode;
		if ((_p10.ctor === 'ModifyGeoms') && (_p10._0.ctor === 'ModifyOp')) {
			var newModify = A2(_user$project$Map_Update_Mode_Op_Modify$updateModifs, featuresData, _p10._0._0);
			return _user$project$Map_Data_Mode$ModifyGeoms(
				_user$project$Map_Data_Mode_Op$ModifyOp(newModify));
		} else {
			return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'update modifs', mode);
		}
	});
var _user$project$Map_Update_Mode$onPtDrawnFromCurPos = F3(
	function (map, ptAtCurPosData, mode) {
		var _p11 = mode;
		if (_p11.ctor === 'AddPointFromCurPos') {
			return A2(
				_user$project$Map_Data_Mode$AddPointFromCurPos,
				_p11._0,
				A2(_user$project$Map_Update_Mode_Op_DrawPtAtCurPos$updateDrawPtAtCurPos, ptAtCurPosData, _p11._1));
		} else {
			return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'update geom', mode);
		}
	});
var _user$project$Map_Update_Mode$onGeomDrawn = F3(
	function (map, geomData, mode) {
		var _p12 = mode;
		_v11_2:
		do {
			switch (_p12.ctor) {
				case 'AddGeom':
					var _p15 = _p12._0;
					var _p14 = _p12._1;
					var _p13 = _p14.shapeType;
					if (_p13 === 'MultiLineString') {
						return A2(
							_user$project$Map_Data_Mode$AddGeom,
							_p15,
							A2(_user$project$Map_Update_Mode_Op_Draw$addPolylineToMultiPolyline, geomData, _p14));
					} else {
						return A2(
							_user$project$Map_Data_Mode$AddGeom,
							_p15,
							A2(_user$project$Map_Update_Mode_Op_Draw$updateDrawn, geomData, _p14));
					}
				case 'SplitPolys':
					if (_p12._0.ctor === 'DrawOp') {
						return A2(
							_user$project$Map_Data_Mode$SplitPolys,
							_user$project$Map_Data_Mode_Op$DrawOp(
								A2(_user$project$Map_Update_Mode_Op_Draw$updateDrawn, geomData, _p12._0._0)),
							_p12._1);
					} else {
						break _v11_2;
					}
				default:
					break _v11_2;
			}
		} while(false);
		return A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'update geom', mode);
	});
var _user$project$Map_Update_Mode$updateSelection = F3(
	function (map, featuresData, mode) {
		var _p16 = mode;
		_v13_5:
		do {
			switch (_p16.ctor) {
				case 'SelectObjs':
					var _p17 = _p16._0;
					var updSelect = A2(_user$project$Map_Update_Mode_Op_Select$updateSelection, featuresData, _p16._1);
					return {
						ctor: '_Tuple3',
						_0: A2(_user$project$Map_Data_Mode$SelectObjs, _p17, updSelect),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: A2(_user$project$Map_Update_Mode_SelectObjs$sendOnUpdated, _p17, updSelect)
					};
				case 'DeleteObjs':
					if (_p16._0.ctor === 'SelectOp') {
						return {
							ctor: '_Tuple3',
							_0: _user$project$Map_Data_Mode$DeleteObjs(
								_user$project$Map_Data_Mode_Op$SelectOp(
									A2(_user$project$Map_Update_Mode_Op_Select$updateSelection, featuresData, _p16._0._0))),
							_1: _elm_lang$core$Platform_Cmd$none,
							_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
						};
					} else {
						break _v13_5;
					}
				case 'MergePolys':
					if (_p16._0.ctor === 'SelectOp') {
						return {
							ctor: '_Tuple3',
							_0: _user$project$Map_Data_Mode$MergePolys(
								_user$project$Map_Data_Mode_Op$SelectOp(
									A2(_user$project$Map_Update_Mode_Op_Select$updateSelection, featuresData, _p16._0._0))),
							_1: _elm_lang$core$Platform_Cmd$none,
							_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
						};
					} else {
						break _v13_5;
					}
				case 'SplitPolys':
					if (_p16._0.ctor === 'SelectOp') {
						return {
							ctor: '_Tuple3',
							_0: A2(
								_user$project$Map_Data_Mode$SplitPolys,
								_user$project$Map_Data_Mode_Op$SelectOp(
									A2(_user$project$Map_Update_Mode_Op_Select$updateSelection, featuresData, _p16._0._0)),
								_p16._1),
							_1: _elm_lang$core$Platform_Cmd$none,
							_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
						};
					} else {
						break _v13_5;
					}
				case 'BreakupPolys':
					if (_p16._0.ctor === 'SelectOp') {
						return {
							ctor: '_Tuple3',
							_0: _user$project$Map_Data_Mode$BreakupPolys(
								_user$project$Map_Data_Mode_Op$SelectOp(
									A2(_user$project$Map_Update_Mode_Op_Select$updateSelection, featuresData, _p16._0._0))),
							_1: _elm_lang$core$Platform_Cmd$none,
							_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
						};
					} else {
						break _v13_5;
					}
				default:
					break _v13_5;
			}
		} while(false);
		return {
			ctor: '_Tuple3',
			_0: A2(_user$project$Map_Update_Mode_Utils$printDebugMismatch, 'update selection', mode),
			_1: _elm_lang$core$Platform_Cmd$none,
			_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
		};
	});
var _user$project$Map_Update_Mode$update = F7(
	function (msgFromMap, headers, event, map, extent, layers, mode) {
		var clearReload = A5(_user$project$Map_Update_Mode_Utils$resetIasClearReload, msgFromMap, headers, map, extent, layers);
		var _p18 = event;
		switch (_p18.ctor) {
			case 'SelectionUpdated':
				return A3(_user$project$Map_Update_Mode$updateSelection, map, _p18._0, mode);
			case 'GeomDrawn':
				return {
					ctor: '_Tuple3',
					_0: A3(_user$project$Map_Update_Mode$onGeomDrawn, map, _p18._0, mode),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'PtDrawnFromCurPos':
				return {
					ctor: '_Tuple3',
					_0: A3(_user$project$Map_Update_Mode$onPtDrawnFromCurPos, map, _p18._0, mode),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'ModifsUpdated':
				return {
					ctor: '_Tuple3',
					_0: A3(_user$project$Map_Update_Mode$updateModifs, map, _p18._0, mode),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'MergeReceived':
				return {
					ctor: '_Tuple3',
					_0: A3(_user$project$Map_Update_Mode$onMergeReceived, map, _p18._0, mode),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'SplitReceived':
				var _p19 = A3(_user$project$Map_Update_Mode$onSplitReceived, map, _p18._0, mode);
				var newMode = _p19._0;
				var modeCmd = _p19._1;
				return {ctor: '_Tuple3', _0: newMode, _1: modeCmd, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
			case 'BreakupReceived':
				return {
					ctor: '_Tuple3',
					_0: A3(_user$project$Map_Update_Mode$onBreakupReceived, map, _p18._0, mode),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'GetInSelReceived':
				return {
					ctor: '_Tuple3',
					_0: A3(_user$project$Map_Update_Mode$onGetInSelReceived, map, _p18._0, mode),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'CapturedCanvasReceived':
				return A6(
					_user$project$Map_Update_Mode$onOpDone,
					msgFromMap,
					headers,
					map,
					extent,
					layers,
					A3(_user$project$Map_Update_Mode$onCapturedCanvasReceived, map, _p18._0, mode));
			case 'ModeErrorReceived':
				return {
					ctor: '_Tuple3',
					_0: A2(_user$project$Map_Update_Mode$updateModeError, mode, _p18._0),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg
				};
			case 'SaveOpReceived':
				var _p20 = A4(_user$project$Map_Update_Mode$onSaveResReceived, map, clearReload, _p18._0, mode);
				var newMode = _p20._0;
				var modeCmd = _p20._1;
				return {ctor: '_Tuple3', _0: newMode, _1: modeCmd, _2: _user$project$Map_Data_Mode_OutMsg$NoOutMsg};
			case 'OpDone':
				return A6(_user$project$Map_Update_Mode$onOpDone, msgFromMap, headers, map, extent, layers, mode);
			default:
				return A6(_user$project$Map_Update_Mode$onCancelled, msgFromMap, headers, map, extent, layers, mode);
		}
	});

var _user$project$Map_View_Popup$view = F2(
	function (config, clickPosInfo) {
		var _p0 = clickPosInfo;
		if (_p0.ctor === 'Nothing') {
			return {ctor: '[]'};
		} else {
			var _p2 = _p0._0;
			var fixedPopUpWidth = function () {
				var _p1 = config.popUpWidth;
				if (_p1.ctor === 'Nothing') {
					return 240;
				} else {
					return _p1._0;
				}
			}();
			var content = config.toPopup(_p2);
			return _elm_lang$core$Native_Utils.eq(
				content,
				{ctor: '[]'}) ? {ctor: '[]'} : {
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Element$above,
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							config.styling.popupPointerBorder,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$moveRight(20),
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$empty),
						_1: {ctor: '[]'}
					},
					A2(
						_mdgriffith$style_elements$Element$above,
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$el,
								config.styling.popupPointer,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$moveRight(22),
									_1: {ctor: '[]'}
								},
								_mdgriffith$style_elements$Element$empty),
							_1: {ctor: '[]'}
						},
						A2(
							_mdgriffith$style_elements$Element$within,
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$button,
									config.styling.btn,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(2),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(3),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$moveDown(3),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onClick(
															config.msgFromMap(_user$project$Map_Data_Msg$ClosePopup)),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									},
									config.uiBits.bits.closeBtnContent),
								_1: {ctor: '[]'}
							},
							A3(
								_mdgriffith$style_elements$Element$el,
								config.styling.popup,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$moveRight(_p2.pixelPos.x - 32),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$moveDown(_p2.pixelPos.y + 18),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(14),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(14),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(22),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(14),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								},
								A3(
									_mdgriffith$style_elements$Element$paragraph,
									config.styling.none,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$width(
											_mdgriffith$style_elements$Element_Attributes$px(fixedPopUpWidth)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$maxHeight(
												_mdgriffith$style_elements$Element_Attributes$px(200)),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$scrollbars,
												_1: {ctor: '[]'}
											}
										}
									},
									content))))),
				_1: {ctor: '[]'}
			};
		}
	});

var _user$project$Map_View_Layer_Legend$getBackgroundStyle = function (fill) {
	return A2(_elm_lang$core$String$startsWith, 'url(\'', fill) ? {ctor: '_Tuple2', _0: 'backgroundImage', _1: fill} : {ctor: '_Tuple2', _0: 'backgroundColor', _1: fill};
};
var _user$project$Map_View_Layer_Legend$viewIcon = F2(
	function (config, icon) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.legendElement,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$image,
					config.styling.legendElement,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(
							_mdgriffith$style_elements$Element_Attributes$px(icon.size)),
						_1: {ctor: '[]'}
					},
					{src: icon.url, caption: icon.label}),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$paragraph,
						config.styling.none,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: config.uiBits.strToElem(icon.label),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map_View_Layer_Legend$viewLine = F2(
	function (config, line) {
		var style = _mdgriffith$style_elements$Element_Attributes$inlineStyle(
			{
				ctor: '::',
				_0: _user$project$Map_View_Layer_Legend$getBackgroundStyle(line.stroke),
				_1: {ctor: '[]'}
			});
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.legendElement,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					config.styling.none,
					{
						ctor: '::',
						_0: style,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(
								_mdgriffith$style_elements$Element_Attributes$px(line.strokeWidth)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(34)),
								_1: {ctor: '[]'}
							}
						}
					},
					_mdgriffith$style_elements$Element$empty),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$paragraph,
						config.styling.none,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: config.uiBits.strToElem(line.label),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map_View_Layer_Legend$viewCircle = F2(
	function (config, circle) {
		var style = _mdgriffith$style_elements$Element_Attributes$inlineStyle(
			{
				ctor: '::',
				_0: _user$project$Map_View_Layer_Legend$getBackgroundStyle(circle.fill),
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'borderColor', _1: circle.stroke},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'borderWidth',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(circle.strokeWidth),
								'px')
						},
						_1: {ctor: '[]'}
					}
				}
			});
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.legendElement,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					config.styling.none,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(50)),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$center,
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A4(
							_mdgriffith$style_elements$Element$circle,
							circle.radius,
							config.styling.none,
							{
								ctor: '::',
								_0: style,
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$empty),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$paragraph,
						config.styling.none,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: config.uiBits.strToElem(circle.label),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map_View_Layer_Legend$viewRect = F2(
	function (config, rect) {
		var style = _mdgriffith$style_elements$Element_Attributes$inlineStyle(
			{
				ctor: '::',
				_0: _user$project$Map_View_Layer_Legend$getBackgroundStyle(rect.fill),
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'borderColor', _1: rect.stroke},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'borderWidth',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(rect.strokeWidth),
								'px')
						},
						_1: {ctor: '[]'}
					}
				}
			});
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.legendElement,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					config.styling.none,
					{
						ctor: '::',
						_0: style,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(
								_mdgriffith$style_elements$Element_Attributes$px(16)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(34)),
								_1: {ctor: '[]'}
							}
						}
					},
					_mdgriffith$style_elements$Element$empty),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$paragraph,
						config.styling.none,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: config.uiBits.strToElem(rect.label),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map_View_Layer_Legend$viewStyleSelect = F3(
	function (config, dropMenu, choices) {
		var uiBits = config.uiBits;
		var toChoice = function (_p0) {
			var _p1 = _p0;
			return A2(
				_mdgriffith$style_elements$Element_Input$styledChoice,
				_p1._1,
				function (focused) {
					return A3(
						_mdgriffith$style_elements$Element$el,
						config.styling.focused,
						{ctor: '[]'},
						uiBits.strToElem(_p1._0));
				});
		};
		return A3(
			_mdgriffith$style_elements$Element_Input$select,
			config.styling.legendDropDown,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
					_1: {ctor: '[]'}
				}
			},
			{
				label: _mdgriffith$style_elements$Element_Input$labelLeft(_mdgriffith$style_elements$Element$empty),
				$with: dropMenu,
				max: 6,
				options: {ctor: '[]'},
				menu: A3(
					_mdgriffith$style_elements$Element_Input$menu,
					config.styling.submenu,
					{ctor: '[]'},
					A2(_elm_lang$core$List$map, toChoice, choices))
			});
	});
var _user$project$Map_View_Layer_Legend$view = F2(
	function (config, mayLegend) {
		var _p2 = mayLegend;
		if (_p2.ctor === 'Nothing') {
			return _mdgriffith$style_elements$Element$empty;
		} else {
			return A3(
				_mdgriffith$style_elements$Element$column,
				config.styling.legendCol,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(2),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(2),
							_1: {ctor: '[]'}
						}
					}
				},
				function () {
					var _p3 = _p2._0;
					switch (_p3.ctor) {
						case 'Rectangles':
							return A2(
								_elm_lang$core$List$map,
								_user$project$Map_View_Layer_Legend$viewRect(config),
								_p3._0);
						case 'Circles':
							return A2(
								_elm_lang$core$List$map,
								_user$project$Map_View_Layer_Legend$viewCircle(config),
								_p3._0);
						case 'Lines':
							return A2(
								_elm_lang$core$List$map,
								_user$project$Map_View_Layer_Legend$viewLine(config),
								_p3._0);
						default:
							return A2(
								_elm_lang$core$List$map,
								_user$project$Map_View_Layer_Legend$viewIcon(config),
								_p3._0);
					}
				}());
		}
	});

var _user$project$Map_View_Layer$viewLayerOpacityMinusButton = F3(
	function (_p0, ldata, disabled) {
		var _p1 = _p0;
		var _p2 = _p1._0;
		var styling = _p2.styling;
		var uiBits = _p2.uiBits;
		var minusBtnContent = uiBits.bits.minusBtnContent;
		var greyedMinusBtnContent = uiBits.bits.greyedMinusBtnContent;
		return (!disabled) ? A3(
			_mdgriffith$style_elements$Element$button,
			styling.minusBtn,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Events$onClick(
					_p2.msgFromMap(
						A3(
							_user$project$Map_Data_Msg$UpdateOpacity,
							_user$project$Map_Data_Layer$getKey(ldata),
							_user$project$Map_Data_Layer$getOpacity(ldata),
							_user$project$Map_Data_Msg$Decrease))),
				_1: {ctor: '[]'}
			},
			minusBtnContent) : A3(
			_mdgriffith$style_elements$Element$button,
			styling.greyedMinusBtn,
			{ctor: '[]'},
			A3(
				_mdgriffith$style_elements$Element$el,
				styling.greyedMinusBtn,
				{ctor: '[]'},
				greyedMinusBtnContent));
	});
var _user$project$Map_View_Layer$viewLayerOpacityPlusButton = F3(
	function (_p3, ldata, disabled) {
		var _p4 = _p3;
		var _p5 = _p4._0;
		var styling = _p5.styling;
		var uiBits = _p5.uiBits;
		var plusBtnContent = uiBits.bits.plusBtnContent;
		var greyedPlusBtnContent = uiBits.bits.greyedPlusBtnContent;
		return (!disabled) ? A3(
			_mdgriffith$style_elements$Element$button,
			styling.plusBtn,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Events$onClick(
					_p5.msgFromMap(
						A3(
							_user$project$Map_Data_Msg$UpdateOpacity,
							_user$project$Map_Data_Layer$getKey(ldata),
							_user$project$Map_Data_Layer$getOpacity(ldata),
							_user$project$Map_Data_Msg$Increase))),
				_1: {ctor: '[]'}
			},
			plusBtnContent) : A3(
			_mdgriffith$style_elements$Element$button,
			styling.greyedPlusBtn,
			{ctor: '[]'},
			A3(
				_mdgriffith$style_elements$Element$el,
				styling.greyedPlusBtn,
				{ctor: '[]'},
				greyedPlusBtnContent));
	});
var _user$project$Map_View_Layer$viewSingleLayer = F2(
	function (_p6, ldata) {
		var _p7 = _p6;
		var _p15 = _p7._0;
		var opacityConfig = _user$project$Map_Data_Layer$opacityConfig;
		var styling = _p15.styling;
		var displayMayLegend = F2(
			function (config, legend) {
				return A3(
					_mdgriffith$style_elements$Element$el,
					styling.none,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
						_1: {ctor: '[]'}
					},
					A2(_user$project$Map_View_Layer_Legend$view, config, legend));
			});
		var uiBits = _p15.uiBits;
		var infoBtnContent = _user$project$Map_Data_Layer$getIsInfoExp(ldata) ? uiBits.bits.lessInfoBtnContent : uiBits.bits.moreInfoBtnContent;
		var legendCaption = uiBits.bits.legend;
		var layerRowData = A3(
			_mdgriffith$style_elements$Element$row,
			styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: uiBits.bitToElem(
					_user$project$Map_Data_Layer$getName(ldata)),
				_1: {ctor: '[]'}
			});
		return A3(
			_mdgriffith$style_elements$Element$column,
			styling.layer,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					styling.layerData,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$padding(2),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(2),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$column,
							styling.none,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$row,
									styling.none,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$el,
											styling.none,
											{ctor: '[]'},
											A3(
												_mdgriffith$style_elements$Element$button,
												styling.infoBtn,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$padding(2),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onClick(
															_p15.msgFromMap(
																_user$project$Map_Data_Msg$ToggleInfo(
																	_user$project$Map_Data_Layer$getKey(ldata)))),
														_1: {ctor: '[]'}
													}
												},
												infoBtnContent)),
										_1: {
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$el,
												styling.none,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(15),
													_1: {ctor: '[]'}
												},
												A3(
													_mdgriffith$style_elements$Element_Input$checkbox,
													styling.checkbox,
													{ctor: '[]'},
													{
														onChange: function (_p8) {
															return _p15.msgFromMap(
																_user$project$Map_Data_Msg$UpdateVisibility(
																	_user$project$Map_Data_Layer$getKey(ldata))(_p8));
														},
														checked: _user$project$Map_Data_Layer$getVisibility(ldata),
														label: layerRowData,
														options: {ctor: '[]'}
													})),
											_1: {ctor: '[]'}
										}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$column,
								styling.none,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
											_1: {ctor: '[]'}
										}
									}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$button,
										styling.layerSettingsBtn,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Events$onClick(
												_p15.msgFromMap(
													_user$project$Map_Data_Msg$ToggleSettings(
														_user$project$Map_Data_Layer$getKey(ldata)))),
											_1: {ctor: '[]'}
										},
										uiBits.bits.layerSettingsBtnContent),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_mdgriffith$style_elements$Element$when,
						_user$project$Map_Data_Layer$getIsSettingsExp(ldata),
						A3(
							_mdgriffith$style_elements$Element$column,
							styling.none,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$row,
									styling.none,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: uiBits.bits.labelOpacity,
										_1: {
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$el,
												styling.none,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
													_1: {ctor: '[]'}
												},
												A3(
													_user$project$Map_View_Layer$viewLayerOpacityMinusButton,
													_user$project$Map_Data_Config$Config(_p15),
													ldata,
													_elm_lang$core$Native_Utils.cmp(
														_user$project$Map_Data_Layer$getOpacity(ldata),
														opacityConfig.step) < 0)),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$el,
													styling.none,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
														_1: {ctor: '[]'}
													},
													A3(
														_user$project$Map_View_Layer$viewLayerOpacityPlusButton,
														_user$project$Map_Data_Config$Config(_p15),
														ldata,
														_elm_lang$core$Native_Utils.cmp(
															_user$project$Map_Data_Layer$getOpacity(ldata),
															opacityConfig.max) > -1)),
												_1: {ctor: '[]'}
											}
										}
									}),
								_1: {
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$el,
										styling.none,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
											_1: {ctor: '[]'}
										},
										uiBits.bitToElem(
											_user$project$Map_Data_Layer$getInfo(ldata))),
									_1: {ctor: '[]'}
								}
							})),
					_1: {
						ctor: '::',
						_0: A2(
							_mdgriffith$style_elements$Element$when,
							_user$project$Map_Data_Layer$getIsInfoExp(ldata),
							A3(
								_mdgriffith$style_elements$Element$column,
								styling.none,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: function () {
										var _p9 = ldata;
										switch (_p9.ctor) {
											case 'WmtsLayer':
												return _mdgriffith$style_elements$Element$empty;
											case 'WmsTileLayer':
												var _p10 = _p9._0.legendRequest;
												if (_p10.ctor === 'Nothing') {
													return _mdgriffith$style_elements$Element$empty;
												} else {
													return A3(
														_mdgriffith$style_elements$Element$row,
														styling.none,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$el,
																styling.none,
																{ctor: '[]'},
																A3(
																	_mdgriffith$style_elements$Element$image,
																	styling.none,
																	{ctor: '[]'},
																	{
																		src: _user$project$Map_Data_Layer_LegendRequest$getFormattedURL(_p10._0),
																		caption: legendCaption
																	})),
															_1: {ctor: '[]'}
														});
												}
											case 'TilesLayer':
												return _mdgriffith$style_elements$Element$empty;
											default:
												var _p11 = _p9._0.style.more;
												if (_p11.ctor === 'Nothing') {
													return _mdgriffith$style_elements$Element$empty;
												} else {
													var _p12 = _p11._0;
													return A3(
														_mdgriffith$style_elements$Element$el,
														styling.none,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
															_1: {ctor: '[]'}
														},
														A3(_user$project$Map_View_Layer_Legend$viewStyleSelect, _p15, _p12.selectMenu, _p12.choices));
												}
										}
									}(),
									_1: {
										ctor: '::',
										_0: function () {
											var _p13 = ldata;
											switch (_p13.ctor) {
												case 'WmtsLayer':
													return A2(displayMayLegend, _p15, _p13._0.legend);
												case 'WmsTileLayer':
													return A2(displayMayLegend, _p15, _p13._0.legend);
												case 'TilesLayer':
													var _p14 = _p13._0.tileType;
													if (_p14.ctor === 'MapBoxVector') {
														return A2(displayMayLegend, _p15, _p14._1);
													} else {
														return A2(displayMayLegend, _p15, _p14._0);
													}
												default:
													return A2(displayMayLegend, _p15, _p13._0.legend);
											}
										}(),
										_1: {ctor: '[]'}
									}
								})),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Map_View_Layer$viewLayers = F4(
	function (_p16, isRootGroup, reverseLayerListDisp, layers) {
		var _p17 = _p16;
		var _p19 = _p17._0;
		var layerList = reverseLayerListDisp ? _elm_lang$core$List$reverse(layers) : layers;
		var _p18 = isRootGroup ? {ctor: '_Tuple3', _0: _p19.styling.rootLayerGroup, _1: 0, _2: 0} : {ctor: '_Tuple3', _0: _p19.styling.layerGroupLayers, _1: 6, _2: 24};
		var lGrpStyle = _p18._0;
		var genPadding = _p18._1;
		var leftPadding = _p18._2;
		return A3(
			_mdgriffith$style_elements$Element_Keyed$column,
			lGrpStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$padding(genPadding),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(leftPadding),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
						_1: {ctor: '[]'}
					}
				}
			},
			A2(
				_elm_lang$core$List$map,
				_user$project$Map_View_Layer$viewKeyedLayer(
					_user$project$Map_Data_Config$Config(_p19)),
				layerList));
	});
var _user$project$Map_View_Layer$viewKeyedLayer = F2(
	function (_p20, layer) {
		var _p21 = _p20;
		var _p25 = _p21._0;
		var _p22 = layer;
		if (_p22.ctor === 'SingleLayer') {
			var _p23 = _p22._0;
			return {
				ctor: '_Tuple2',
				_0: _user$project$Map_Data_Layer$getKey(_p23),
				_1: A2(
					_user$project$Map_View_Layer$viewSingleLayer,
					_user$project$Map_Data_Config$Config(_p25),
					_p23)
			};
		} else {
			var _p24 = _p22._0;
			return {
				ctor: '_Tuple2',
				_0: _p24.key,
				_1: A2(
					_user$project$Map_View_Layer$viewLayerGroupData,
					_user$project$Map_Data_Config$Config(_p25),
					_p24)
			};
		}
	});
var _user$project$Map_View_Layer$viewLayerGroupData = F2(
	function (_p26, gdata) {
		var _p27 = _p26;
		var _p29 = _p27._0;
		var groupRowData = A3(
			_mdgriffith$style_elements$Element$row,
			_p29.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _p29.uiBits.bitToElem(gdata.name),
				_1: {ctor: '[]'}
			});
		var btnContent = gdata.isExpanded ? _p29.uiBits.bits.lessBtnContent : _p29.uiBits.bits.moreBtnContent;
		return A3(
			_mdgriffith$style_elements$Element$column,
			_p29.styling.layerGroup,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_p29.styling.layerGroupData,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
									_1: {ctor: '[]'}
								}
							}
						}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$button,
							_p29.styling.groupBtn,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(2),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										_p29.msgFromMap(
											_user$project$Map_Data_Msg$ToggleGroup(gdata.key))),
									_1: {ctor: '[]'}
								}
							},
							btnContent),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$el,
								_p29.styling.none,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
									_1: {ctor: '[]'}
								},
								A3(
									_mdgriffith$style_elements$Element_Input$checkbox,
									_p29.styling.checkbox,
									{ctor: '[]'},
									{
										onChange: function (_p28) {
											return _p29.msgFromMap(
												_user$project$Map_Data_Msg$UpdateVisibility(gdata.key)(_p28));
										},
										checked: gdata.isVisible,
										label: groupRowData,
										options: {ctor: '[]'}
									})),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_mdgriffith$style_elements$Element$when,
						gdata.isExpanded,
						A4(
							_user$project$Map_View_Layer$viewLayers,
							_user$project$Map_Data_Config$Config(_p29),
							false,
							gdata.reverseLayerListDisp,
							gdata.layers)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map_View_Layer$viewGeolocationInfo = F2(
	function (config, geolocState) {
		var _p30 = geolocState;
		switch (_p30.ctor) {
			case 'Enabled':
				var _p31 = _p30._0;
				return A3(
					_mdgriffith$style_elements$Element$row,
					config.styling.none,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$padding(6),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: _p30._1 ? A3(
							_mdgriffith$style_elements$Element$button,
							config.styling.geolocBtn,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										config.msgFromMap(
											_user$project$Map_Data_Msg$UpdateGeolocation(
												A2(_user$project$Map_Data_Geolocation$Enabled, _p31, false)))),
									_1: {ctor: '[]'}
								}
							},
							config.uiBits.bits.startGeolocBtnContent) : A3(
							_mdgriffith$style_elements$Element$button,
							config.styling.geolocBtn,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										config.msgFromMap(
											_user$project$Map_Data_Msg$UpdateGeolocation(
												_user$project$Map_Data_Geolocation$Disabled(_p31)))),
									_1: {ctor: '[]'}
								}
							},
							config.uiBits.bits.stopGeolocBtnContent),
						_1: {ctor: '[]'}
					});
			case 'Disabled':
				return A3(
					_mdgriffith$style_elements$Element$row,
					config.styling.none,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$padding(6),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$button,
							config.styling.geolocBtn,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										config.msgFromMap(
											_user$project$Map_Data_Msg$UpdateGeolocation(
												A2(_user$project$Map_Data_Geolocation$Enabled, _p30._0, true)))),
									_1: {ctor: '[]'}
								}
							},
							config.uiBits.bits.startGeolocWithBlinkBtnContent),
						_1: {ctor: '[]'}
					});
			default:
				return _mdgriffith$style_elements$Element$text(_p30._1);
		}
	});
var _user$project$Map_View_Layer$viewLayerPanelToggle = F3(
	function (config, showLayerToggle, showLayerPanel) {
		var btnContent = showLayerPanel ? config.uiBits.bits.closeLayerPanelBtnContent : config.uiBits.bits.openLayerPanelBtnContent;
		return A2(
			_mdgriffith$style_elements$Element$when,
			showLayerToggle,
			A3(
				_mdgriffith$style_elements$Element$button,
				config.styling.layersToggleBtn,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							config.msgFromMap(_user$project$Map_Data_Msg$ToggleLayerPanel)),
						_1: {ctor: '[]'}
					}
				},
				btnContent));
	});
var _user$project$Map_View_Layer$viewDefaultLayerPanel = F3(
	function (_p32, uName, layers) {
		var _p33 = _p32;
		var _p34 = _p33._0;
		var openBtnId = A2(_elm_lang$core$Basics_ops['++'], uName, '_openLayerFileBtn');
		return A3(
			_mdgriffith$style_elements$Element$column,
			_p34.styling.layersCol,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$h1,
					_p34.styling.h1,
					{ctor: '[]'},
					_p34.uiBits.bits.layersControlTitle),
				_1: {
					ctor: '::',
					_0: A4(
						_user$project$Map_View_Layer$viewLayers,
						_user$project$Map_Data_Config$Config(_p34),
						true,
						true,
						layers),
					_1: {
						ctor: '::',
						_0: A2(
							_mdgriffith$style_elements$Element$when,
							_p34.showAddNewLayerBtn,
							A3(
								_mdgriffith$style_elements$Element$row,
								_p34.styling.none,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$button,
										_p34.styling.openFileBtn,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$id(openBtnId),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$alignBottom,
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onMouseEnter(
															_p34.msgFromMap(
																_user$project$Map_Data_Msg$InitOpenLayerBtn(openBtnId))),
														_1: {ctor: '[]'}
													}
												}
											}
										},
										_p34.uiBits.bits.openLayerFileBtnContent),
									_1: {ctor: '[]'}
								})),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Map_View_Layer$view = F5(
	function (_p35, mayPanelToggle, uName, showCustomPanel, layers) {
		var _p36 = _p35;
		var _p38 = _p36._0;
		return A3(
			_mdgriffith$style_elements$Element$column,
			_p38.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$scrollbars,
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$padding(6),
							_1: {ctor: '[]'}
						}
					}
				}
			},
			function () {
				var _p37 = mayPanelToggle;
				if ((_p37.ctor === 'Just') && (_p37._0.ctor === '_Tuple2')) {
					return {
						ctor: '::',
						_0: A2(
							_mdgriffith$style_elements$Element$when,
							_p37._0._1,
							A3(
								_mdgriffith$style_elements$Element$row,
								_p38.styling.none,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$button,
										_p38.styling.infoBtn,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Events$onClick(
													_p38.msgFromMap(_user$project$Map_Data_Msg$ToggleLayerPanelContent)),
												_1: {ctor: '[]'}
											}
										},
										_p38.uiBits.bits.toggleLayerPanelBtnContent),
									_1: {ctor: '[]'}
								})),
						_1: {
							ctor: '::',
							_0: showCustomPanel ? _p37._0._0 : A3(
								_user$project$Map_View_Layer$viewDefaultLayerPanel,
								_user$project$Map_Data_Config$Config(_p38),
								uName,
								layers),
							_1: {ctor: '[]'}
						}
					};
				} else {
					return {
						ctor: '::',
						_0: A3(
							_user$project$Map_View_Layer$viewDefaultLayerPanel,
							_user$project$Map_Data_Config$Config(_p38),
							uName,
							layers),
						_1: {ctor: '[]'}
					};
				}
			}());
	});

var _user$project$Map_View_Mode_Op_Select$fulfillsEndCdts = F2(
	function (count, select) {
		return ((_elm_lang$core$Native_Utils.cmp(count, select.min) < 0) || (_elm_lang$core$Native_Utils.cmp(count, select.max) > 0)) ? false : true;
	});
var _user$project$Map_View_Mode_Op_Select$viewOpBar = F3(
	function (config, showNextNotEnd, select) {
		var nextOrEnd = showNextNotEnd ? config.uiBits.bits.nextButtonContent : config.uiBits.bits.doneButtonContent;
		var count = _elm_lang$core$List$length(select.selected);
		var isNoEnd = _elm_lang$core$Native_Utils.eq(select.min, _elm_lang$core$Random$maxInt);
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					config.styling.cancelBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								config.msgFromMap(
									_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
							_1: {ctor: '[]'}
						}
					},
					config.uiBits.bits.cancelButtonContent),
				_1: {
					ctor: '::',
					_0: ((!isNoEnd) && A2(_user$project$Map_View_Mode_Op_Select$fulfillsEndCdts, count, select)) ? A3(
						_mdgriffith$style_elements$Element$button,
						config.styling.successBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Events$onClick(
									config.msgFromMap(
										_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
								_1: {ctor: '[]'}
							}
						},
						nextOrEnd) : _mdgriffith$style_elements$Element$empty,
					_1: {
						ctor: '::',
						_0: isNoEnd ? _mdgriffith$style_elements$Element$empty : (A2(_user$project$Map_View_Mode_Op_Select$fulfillsEndCdts, count, select) ? config.uiBits.bits.selectionOk(count) : A2(config.uiBits.bits.selectionOutOfRange, select.min, select.max)),
						_1: {
							ctor: '::',
							_0: config.uiBits.bits.modeError(select.error),
							_1: {ctor: '[]'}
						}
					}
				}
			});
	});

var _user$project$Map_View_Mode_Op_Modify$canEndModify = F2(
	function (count, modify) {
		return _elm_lang$core$Native_Utils.eq(count, 0) ? false : true;
	});
var _user$project$Map_View_Mode_Op_Modify$viewOpBar = F2(
	function (config, modify) {
		var count = _elm_lang$core$Dict$size(modify.modified);
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					config.styling.cancelBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							config.msgFromMap(
								_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
						_1: {ctor: '[]'}
					},
					config.uiBits.bits.cancelButtonContent),
				_1: {
					ctor: '::',
					_0: A2(_user$project$Map_View_Mode_Op_Modify$canEndModify, count, modify) ? A3(
						_mdgriffith$style_elements$Element$button,
						config.styling.warningBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								config.msgFromMap(
									_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
							_1: {ctor: '[]'}
						},
						config.uiBits.bits.saveButtonContent) : _mdgriffith$style_elements$Element$empty,
					_1: {
						ctor: '::',
						_0: A2(_user$project$Map_View_Mode_Op_Modify$canEndModify, count, modify) ? config.uiBits.bits.modifOk(count) : config.uiBits.bits.modifNothing,
						_1: {
							ctor: '::',
							_0: config.uiBits.bits.modeError(modify.error),
							_1: {ctor: '[]'}
						}
					}
				}
			});
	});

var _user$project$Map_View_Mode_Op_Save$viewOpBar = F2(
	function (config, save) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			function () {
				var _p0 = save;
				switch (_p0.ctor) {
					case 'NotStarted':
						return {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$el,
								config.styling.error,
								{ctor: '[]'},
								_mdgriffith$style_elements$Element$text('Saving not started')),
							_1: {ctor: '[]'}
						};
					case 'Working':
						return {
							ctor: '::',
							_0: config.uiBits.bits.saveWorking,
							_1: {ctor: '[]'}
						};
					default:
						if (_p0._0.ctor === 'Err') {
							return {
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$button,
									config.styling.cancelBtn,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Events$onClick(
												config.msgFromMap(
													_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
											_1: {ctor: '[]'}
										}
									},
									config.uiBits.bits.cancelButtonContent),
								_1: {
									ctor: '::',
									_0: config.uiBits.bits.saveFailed,
									_1: {ctor: '[]'}
								}
							};
						} else {
							return {
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$button,
									config.styling.successBtn,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Events$onClick(
												config.msgFromMap(
													_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
											_1: {ctor: '[]'}
										}
									},
									config.uiBits.bits.doneButtonContent),
								_1: {
									ctor: '::',
									_0: config.uiBits.bits.saveOk,
									_1: {ctor: '[]'}
								}
							};
						}
				}
			}());
	});

var _user$project$Map_View_Mode_Op_Draw$viewOpBar = F3(
	function (config, showNextNotEnd, draw) {
		var nextOrEnd = showNextNotEnd ? config.uiBits.bits.nextButtonContent : config.uiBits.bits.doneButtonContent;
		var isDrawn = _elm_lang$core$Native_Utils.eq(draw.drawn, _elm_lang$core$Maybe$Nothing) ? false : true;
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					config.styling.cancelBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							config.msgFromMap(
								_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
						_1: {ctor: '[]'}
					},
					config.uiBits.bits.cancelButtonContent),
				_1: {
					ctor: '::',
					_0: isDrawn ? A3(
						_mdgriffith$style_elements$Element$button,
						config.styling.successBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								config.msgFromMap(
									_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
							_1: {ctor: '[]'}
						},
						nextOrEnd) : _mdgriffith$style_elements$Element$empty,
					_1: {
						ctor: '::',
						_0: isDrawn ? config.uiBits.bits.drawOk : config.uiBits.bits.drawNothing,
						_1: {
							ctor: '::',
							_0: config.uiBits.bits.modeError(draw.error),
							_1: {ctor: '[]'}
						}
					}
				}
			});
	});

var _user$project$Map_View_Mode_Op_DrawPtAtCurPos$viewOpBar = F2(
	function (config, drawPtAtCurPos) {
		var isErrored = _elm_lang$core$Native_Utils.eq(drawPtAtCurPos.error, _elm_lang$core$Maybe$Nothing) ? false : true;
		var isDrawn = _elm_lang$core$Native_Utils.eq(drawPtAtCurPos.ptAtCurPosData, _elm_lang$core$Maybe$Nothing) ? false : true;
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					config.styling.cancelBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							config.msgFromMap(
								_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
						_1: {ctor: '[]'}
					},
					config.uiBits.bits.cancelButtonContent),
				_1: {
					ctor: '::',
					_0: isDrawn ? A3(
						_mdgriffith$style_elements$Element$button,
						config.styling.successBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								config.msgFromMap(
									_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
							_1: {ctor: '[]'}
						},
						config.uiBits.bits.doneButtonContent) : _mdgriffith$style_elements$Element$empty,
					_1: {
						ctor: '::',
						_0: function () {
							var _p0 = drawPtAtCurPos.ptAtCurPosData;
							if (_p0.ctor === 'Just') {
								return config.uiBits.bits.drawPtAtCurPosReceived(_p0._0.curPosData);
							} else {
								return (!isErrored) ? config.uiBits.bits.drawPtAtCurPosWaiting : config.uiBits.bits.modeError(drawPtAtCurPos.error);
							}
						}(),
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _user$project$Map_View_Mode_Op_Merge$viewOpBar = F2(
	function (config, merge) {
		var isOk = _elm_lang$core$Native_Utils.eq(merge.merged, _elm_lang$core$Maybe$Nothing) ? false : true;
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					config.styling.cancelBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							config.msgFromMap(
								_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
						_1: {ctor: '[]'}
					},
					config.uiBits.bits.cancelButtonContent),
				_1: {
					ctor: '::',
					_0: isOk ? A3(
						_mdgriffith$style_elements$Element$button,
						config.styling.warningBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								config.msgFromMap(
									_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
							_1: {ctor: '[]'}
						},
						config.uiBits.bits.saveButtonContent) : _mdgriffith$style_elements$Element$empty,
					_1: {
						ctor: '::',
						_0: isOk ? config.uiBits.bits.mergeOk : config.uiBits.bits.mergeNotOk,
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _user$project$Map_View_Mode_Op_Split$viewOpBar = F2(
	function (config, split) {
		var mayCount = A2(_elm_lang$core$Maybe$map, _elm_lang$core$List$length, split.split);
		var okCount = function () {
			var _p0 = mayCount;
			if (_p0.ctor === 'Nothing') {
				return 0;
			} else {
				return _p0._0;
			}
		}();
		var isOk = _elm_lang$core$Native_Utils.cmp(okCount, 2) > -1;
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					config.styling.cancelBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							config.msgFromMap(
								_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
						_1: {ctor: '[]'}
					},
					config.uiBits.bits.cancelButtonContent),
				_1: {
					ctor: '::',
					_0: isOk ? A3(
						_mdgriffith$style_elements$Element$button,
						config.styling.warningBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								config.msgFromMap(
									_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
							_1: {ctor: '[]'}
						},
						config.uiBits.bits.saveButtonContent) : _mdgriffith$style_elements$Element$empty,
					_1: {
						ctor: '::',
						_0: isOk ? config.uiBits.bits.splitOk(okCount) : config.uiBits.bits.splitNotOk(mayCount),
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _user$project$Map_View_Mode_Op_Breakup$viewOpBar = F2(
	function (config, breakup) {
		var isOk = _elm_lang$core$Native_Utils.eq(breakup.breakup, _elm_lang$core$Maybe$Nothing) ? false : true;
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					config.styling.cancelBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							config.msgFromMap(
								_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$Cancel))),
						_1: {ctor: '[]'}
					},
					config.uiBits.bits.cancelButtonContent),
				_1: {
					ctor: '::',
					_0: isOk ? A3(
						_mdgriffith$style_elements$Element$button,
						config.styling.warningBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								config.msgFromMap(
									_user$project$Map_Data_Msg$ModeEvent(_user$project$Map_Data_Mode$OpDone))),
							_1: {ctor: '[]'}
						},
						config.uiBits.bits.saveButtonContent) : _mdgriffith$style_elements$Element$empty,
					_1: {
						ctor: '::',
						_0: isOk ? config.uiBits.bits.breakupOk : config.uiBits.bits.breakupNotOk,
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _user$project$Map_View_Mode$printDebugMismatch = F2(
	function (situation, mode) {
		var print = A2(
			_elm_lang$core$Basics_ops['++'],
			'Mismatch in ',
			A2(_elm_lang$core$Basics_ops['++'], situation, ' while mode is '));
		return A2(_elm_lang$core$Debug$log, print, _mdgriffith$style_elements$Element$empty);
	});
var _user$project$Map_View_Mode$viewBar = F2(
	function (config, mode) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$center,
							_1: {ctor: '[]'}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: config.uiBits.bits.mode(mode),
				_1: {
					ctor: '::',
					_0: function () {
						var _p0 = mode;
						_v0_20:
						do {
							switch (_p0.ctor) {
								case 'NormalMode':
									return config.uiBits.bits.normalModeBar;
								case 'Wait':
									return _mdgriffith$style_elements$Element$empty;
								case 'SelectObjs':
									return A3(_user$project$Map_View_Mode_Op_Select$viewOpBar, config, false, _p0._1);
								case 'AddGeom':
									return A3(_user$project$Map_View_Mode_Op_Draw$viewOpBar, config, false, _p0._1);
								case 'AddPointFromCurPos':
									return A2(_user$project$Map_View_Mode_Op_DrawPtAtCurPos$viewOpBar, config, _p0._1);
								case 'ModifyGeoms':
									switch (_p0._0.ctor) {
										case 'ModifyOp':
											return A2(_user$project$Map_View_Mode_Op_Modify$viewOpBar, config, _p0._0._0);
										case 'SaveOp':
											return A2(_user$project$Map_View_Mode_Op_Save$viewOpBar, config, _p0._0._0);
										default:
											break _v0_20;
									}
								case 'DeleteObjs':
									switch (_p0._0.ctor) {
										case 'SelectOp':
											return A3(_user$project$Map_View_Mode_Op_Select$viewOpBar, config, false, _p0._0._0);
										case 'SaveOp':
											return A2(_user$project$Map_View_Mode_Op_Save$viewOpBar, config, _p0._0._0);
										default:
											break _v0_20;
									}
								case 'MergePolys':
									switch (_p0._0.ctor) {
										case 'SelectOp':
											return A3(_user$project$Map_View_Mode_Op_Select$viewOpBar, config, true, _p0._0._0);
										case 'MergeOp':
											return A2(_user$project$Map_View_Mode_Op_Merge$viewOpBar, config, _p0._0._0);
										case 'SaveOp':
											return A2(_user$project$Map_View_Mode_Op_Save$viewOpBar, config, _p0._0._0);
										default:
											break _v0_20;
									}
								case 'SplitPolys':
									switch (_p0._0.ctor) {
										case 'SelectOp':
											return A3(_user$project$Map_View_Mode_Op_Select$viewOpBar, config, true, _p0._0._0);
										case 'DrawOp':
											return A3(_user$project$Map_View_Mode_Op_Draw$viewOpBar, config, true, _p0._0._0);
										case 'SplitOp':
											return A2(_user$project$Map_View_Mode_Op_Split$viewOpBar, config, _p0._0._0);
										case 'SaveOp':
											return A2(_user$project$Map_View_Mode_Op_Save$viewOpBar, config, _p0._0._0);
										default:
											break _v0_20;
									}
								case 'BreakupPolys':
									switch (_p0._0.ctor) {
										case 'SelectOp':
											return A3(_user$project$Map_View_Mode_Op_Select$viewOpBar, config, true, _p0._0._0);
										case 'BreakupOp':
											return A2(_user$project$Map_View_Mode_Op_Breakup$viewOpBar, config, _p0._0._0);
										case 'SaveOp':
											return A2(_user$project$Map_View_Mode_Op_Save$viewOpBar, config, _p0._0._0);
										default:
											break _v0_20;
									}
								case 'CaptureCanvas':
									return _mdgriffith$style_elements$Element$empty;
								default:
									break _v0_20;
							}
						} while(false);
						return A2(_elm_lang$core$Debug$log, 'no view defined for this mode', _mdgriffith$style_elements$Element$empty);
					}(),
					_1: {ctor: '[]'}
				}
			});
	});

var _user$project$Map$stylesDefault = _user$project$Map_Data_Defaults$styles;
var _user$project$Map$uiBitsContentGermanDefault = _user$project$Map_Data_Defaults$uiBitsContent(_user$project$Map_Data_Defaults$German);
var _user$project$Map$uiBitsContentFrenchDefault = _user$project$Map_Data_Defaults$uiBitsContent(_user$project$Map_Data_Defaults$French);
var _user$project$Map$uiBitsContentCustomModeToElGermanDefault = _user$project$Map_Data_Defaults$uiBitsContentCustomModeToEl(_user$project$Map_Data_Defaults$German);
var _user$project$Map$uiBitsContentCustomModeToElFrenchDefault = _user$project$Map_Data_Defaults$uiBitsContentCustomModeToEl(_user$project$Map_Data_Defaults$French);
var _user$project$Map$vectorChoiceBasedStyles = _user$project$Map_Data_Layer_VectorStyle$choiceBasedStyles;
var _user$project$Map$vectorUniqueStyle = _user$project$Map_Data_Layer_VectorStyle$uniqueStyle;
var _user$project$Map$vectorNoStyle = _user$project$Map_Data_Layer_VectorStyle$noStyle;
var _user$project$Map$vectorReturnNbOfClusterObjsWhenClicked = _user$project$Map_Data_Layer_Vector$returnNbOfClusterObjsWhenClicked;
var _user$project$Map$vectorClusterFnWithDistance = _user$project$Map_Data_Layer_Vector$clusterFnWithDistance;
var _user$project$Map$vectorDefaultClusterFn = _user$project$Map_Data_Layer_Vector$defaultClusterFn;
var _user$project$Map$vectorNoCluster = _user$project$Map_Data_Layer_Vector$noCluster;
var _user$project$Map$esriJsonFormat = _user$project$Map_Data_Layer_Vector$esriJsonFormat;
var _user$project$Map$esriJsonFormatWithParams = _user$project$Map_Data_Layer_Vector$esriJsonFormatWithParams;
var _user$project$Map$standardGeoJsonFormat = _user$project$Map_Data_Layer_Vector$standardGeoJsonFormat;
var _user$project$Map$standardGeoJsonFormatWithParams = _user$project$Map_Data_Layer_Vector$standardGeoJsonFormatWithParams;
var _user$project$Map$geoJsonFormat = _user$project$Map_Data_Layer_Vector$geoJsonFormat;
var _user$project$Map$geoJsonFormatWithParams = _user$project$Map_Data_Layer_Vector$geoJsonFormatWithParams;
var _user$project$Map$vectorInExtentLoadMethod = _user$project$Map_Data_Layer_Vector$inExtentLoadMethod;
var _user$project$Map$vectorBatchLoadMethod = _user$project$Map_Data_Layer_Vector$batchLoadMethod;
var _user$project$Map$vectorLocalLoadMethod = _user$project$Map_Data_Layer_Vector$localLoadMethod;
var _user$project$Map$vectorLayerFromAllParams = _user$project$Map_Data_Layer$vectorFromAllParams;
var _user$project$Map$vectorLayerFromEssentialParams = _user$project$Map_Data_Layer$vectorFromEssentialParams;
var _user$project$Map$mapBoxVectorTilesLayerFromParams = _user$project$Map_Data_Layer$mapBoxVectorTilesFromParams;
var _user$project$Map$xyzTilesLayerFromParams = _user$project$Map_Data_Layer$xyzTilesFromParams;
var _user$project$Map$addLegendToRasterLayer = _user$project$Map_Data_Layer$addLegendToRasterLayer;
var _user$project$Map$wmtsLayerFromParamsWithScale = _user$project$Map_Data_Layer$wmtsFromParamsWithScale;
var _user$project$Map$wmtsLayerFromParamsWithResolution = _user$project$Map_Data_Layer$wmtsFromParamsWithResolution;
var _user$project$Map$wmtsLayerFromParams = _user$project$Map_Data_Layer$wmtsFromParams;
var _user$project$Map$wmsTileLayerFromParamsWithScale = _user$project$Map_Data_Layer$wmsTileFromParamsWithScale;
var _user$project$Map$wmsTileLayerFromParamsWithResolution = _user$project$Map_Data_Layer$wmsTileFromParamsWithResolution;
var _user$project$Map$wmsTileLayerFromParams = _user$project$Map_Data_Layer$wmsTileFromParams;
var _user$project$Map$layerGroupFromParams = _user$project$Map_Data_Layer$groupFromParams;
var _user$project$Map$getLayerStyleObjName = F2(
	function (mapState, layerKey) {
		return A2(_user$project$Map_Update_Layer$getStyleObjName, mapState.layers, layerKey);
	});
var _user$project$Map$findLayerByKey = _user$project$Map_Update_Layer$findByKey;
var _user$project$Map$startCaptureCanvasMode = _user$project$Map_Update_Mode_CaptureCanvas$start;
var _user$project$Map$startBreakupPolysMode = _user$project$Map_Update_Mode_BreakupPolys$start;
var _user$project$Map$startSplitPolysMode = _user$project$Map_Update_Mode_SplitPolys$start;
var _user$project$Map$startMergePolysMode = _user$project$Map_Update_Mode_MergePolys$start;
var _user$project$Map$startDeleteObjsMode = _user$project$Map_Update_Mode_DeleteObjs$start;
var _user$project$Map$startModifyGeomsMode = _user$project$Map_Update_Mode_ModifyGeoms$start;
var _user$project$Map$startAddPointFromCurPos = _user$project$Map_Update_Mode_AddPointFromCurPos$start;
var _user$project$Map$startAddPointMode = _user$project$Map_Update_Mode_AddGeom$start('Point');
var _user$project$Map$startAddLineMode = _user$project$Map_Update_Mode_AddGeom$start('LineString');
var _user$project$Map$startAddMultiLineModeWithSnapLayerKeys = _user$project$Map_Update_Mode_AddGeom$startWithSnapLayerKeys('MultiLineString');
var _user$project$Map$startAddMultiLineMode = _user$project$Map_Update_Mode_AddGeom$start('MultiLineString');
var _user$project$Map$startAddPolygonMode = _user$project$Map_Update_Mode_AddGeom$start('Polygon');
var _user$project$Map$startAddMultiPolygonMode = _user$project$Map_Update_Mode_AddGeom$start('MultiPolygon');
var _user$project$Map$startSelectObjsModeNoEndWithGeoObjs = function (_p0) {
	var _p1 = _p0;
	return A5(_user$project$Map_Update_Mode_SelectObjs$startNoEndWithGeoObjs, _p1.mapState, _p1.name, _p1.layerKeys, _p1.geoObjs, _p1.panAndZoom);
};
var _user$project$Map$startSelectObjsModeNoEnd = _user$project$Map_Update_Mode_SelectObjs$startNoEnd;
var _user$project$Map$startSelectObjsModeMinMax = _user$project$Map_Update_Mode_SelectObjs$startWithMinMaxZone;
var _user$project$Map$startSelectObjsMode = _user$project$Map_Update_Mode_SelectObjs$start;
var _user$project$Map$startNormalMode = _user$project$Map_Update_Mode_Utils$resetMode;
var _user$project$Map$resetMode = _user$project$Map_Update_Mode_Utils$resetMode;
var _user$project$Map$settingsFromAllParams = _user$project$Map_Data_MapSettings$fromAllParams;
var _user$project$Map$settingsFromCoreParams = _user$project$Map_Data_MapSettings$fromCoreParams;
var _user$project$Map$stylesList = _user$project$Map_Data_Styles$list;
var _user$project$Map$detailedConfig = _user$project$Map_Data_Config$detailedConfig;
var _user$project$Map$config = _user$project$Map_Data_Config$config;
var _user$project$Map$subscriptions = _user$project$Map_Effects_Ports$subscriptions;
var _user$project$Map$getCurrentPosition = function (map) {
	return _user$project$Map_Effects_Ports$getCurrentPosition(map);
};
var _user$project$Map$disableDrawIA = function (_p2) {
	var _p3 = _p2;
	return _user$project$Map_Effects_Ports$disableDrawIA(
		{map: _p3.map});
};
var _user$project$Map$addGeoJSONToVectorLayer = function (_p4) {
	var _p5 = _p4;
	return _user$project$Map_Effects_Ports$addGeoJSONToVectorLayer(
		{map: _p5.map, layerKey: _p5.layerKey, vectorData: _p5.vectorData});
};
var _user$project$Map$panAndZoom = function (_p6) {
	var _p7 = _p6;
	return _user$project$Map_Effects_Ports$panAndZoom(
		{map: _p7.mapState.map, geoObjs: _p7.geoObjs, zoom: _p7.zoom});
};
var _user$project$Map$panZoomSelectGeoObjs = function (_p8) {
	var _p9 = _p8;
	return _user$project$Map_Effects_Ports$panZoomSelectGeoObjs(
		{map: _p9.mapState.map, geoObjs: _p9.geoObjs, panAndZoom: _p9.panAndZoom, select: _p9.select});
};
var _user$project$Map$resetInteractions = function (state) {
	return _user$project$Map_Update_Mode_Utils$resetInteractions(state.map);
};
var _user$project$Map$updateVector = F4(
	function (msgFromMap, headers, state, keys) {
		return A6(_user$project$Map_Update_Layer_Vector$clearReloadByKeys, msgFromMap, headers, state.map, state.extent, state.layers, keys);
	});
var _user$project$Map$resize = function (state) {
	return _user$project$Map_Effects_Ports$resizeMap(state.map);
};
var _user$project$Map$viewLayers = _user$project$Map_View_Layer$viewLayers;
var _user$project$Map$viewPointerCoord = F2(
	function (styling, pointerCoord) {
		var defaultFormat = {decimals: 0, thousandSeparator: '\'', decimalSeparator: '.', negativePrefix: '−', negativeSuffix: '', positivePrefix: '', positiveSuffix: ''};
		return A3(
			_mdgriffith$style_elements$Element$row,
			styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$padding(6),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element$text(
					A2(
						_elm_lang$core$Basics_ops['++'],
						A2(_cuducos$elm_format_number$FormatNumber$format, defaultFormat, pointerCoord.x),
						A2(
							_elm_lang$core$Basics_ops['++'],
							' | ',
							A2(_cuducos$elm_format_number$FormatNumber$format, defaultFormat, pointerCoord.y)))),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Map$viewToggleGoogleMapBtn = function (config) {
	return A3(
		_mdgriffith$style_elements$Element$button,
		config.styling.toggleGoogleMapBtn,
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
			_1: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Events$onClick(
					config.msgFromMap(_user$project$Map_Data_Msg$ToggleGoogleMap)),
				_1: {ctor: '[]'}
			}
		},
		config.uiBits.bits.toggleGoogleMapBtnContent);
};
var _user$project$Map$viewMapFooter = F3(
	function (config, showLayerToggle, state) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			config.styling.mapFooter,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(32)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
							_1: {ctor: '[]'}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(_user$project$Map_View_Layer$viewLayerPanelToggle, config, showLayerToggle, state.layerPanelVis),
				_1: {
					ctor: '::',
					_0: _user$project$Map$viewToggleGoogleMapBtn(config),
					_1: {
						ctor: '::',
						_0: A2(_user$project$Map_View_Layer$viewGeolocationInfo, config, state.geolocation),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$row,
								config.styling.none,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$center,
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(_user$project$Map_View_Mode$viewBar, config, state.mode),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(_user$project$Map$viewPointerCoord, config.styling, state.pointerCoord),
								_1: {ctor: '[]'}
							}
						}
					}
				}
			});
	});
var _user$project$Map$viewMap = F4(
	function (_p10, showLayerToggle, hide, state) {
		var _p11 = _p10;
		var _p12 = _p11._0;
		return A3(
			_mdgriffith$style_elements$Element_Keyed$column,
			_p12.styling.mapCol,
			hide ? {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$hidden,
							_1: {ctor: '[]'}
						}
					}
				}
			} : {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: state.uName,
					_1: A2(
						_mdgriffith$style_elements$Element$within,
						_elm_lang$core$Native_Utils.eq(state.mode, _user$project$Map_Data_Mode$NormalMode) ? A2(_user$project$Map_View_Popup$view, _p12, state.clickPosInfo) : {ctor: '[]'},
						A3(
							_mdgriffith$style_elements$Element$el,
							_p12.styling.map,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$clip,
										_1: {ctor: '[]'}
									}
								}
							},
							A3(
								_mdgriffith$style_elements$Element$el,
								_p12.styling.map,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$id(state.uName),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
											_1: {ctor: '[]'}
										}
									}
								},
								_mdgriffith$style_elements$Element$empty)))
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: A2(_elm_lang$core$Basics_ops['++'], state.uName, 'footer'),
						_1: A3(_user$project$Map$viewMapFooter, _p12, showLayerToggle, state)
					},
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Map$smallView = F3(
	function (_p13, mayPanelToggle, state) {
		var _p14 = _p13;
		var _p15 = _p14._0;
		return {
			ctor: '::',
			_0: state.layerPanelVis ? A2(
				_mdgriffith$style_elements$Element$within,
				{
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_p15.styling.none,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$alignBottom,
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(3),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$moveUp(3),
										_1: {ctor: '[]'}
									}
								}
							}
						},
						A3(_user$project$Map_View_Layer$viewLayerPanelToggle, _p15, true, true)),
					_1: {ctor: '[]'}
				},
				A3(
					_mdgriffith$style_elements$Element$el,
					_p15.styling.none,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$clipX,
								_1: {ctor: '[]'}
							}
						}
					},
					A5(
						_user$project$Map_View_Layer$view,
						_user$project$Map_Data_Config$Config(_p15),
						mayPanelToggle,
						state.uName,
						state.showCustomPanel,
						state.layers))) : _mdgriffith$style_elements$Element$empty,
			_1: {
				ctor: '::',
				_0: A4(
					_user$project$Map$viewMap,
					_user$project$Map_Data_Config$Config(_p15),
					true,
					state.layerPanelVis,
					state),
				_1: {ctor: '[]'}
			}
		};
	});
var _user$project$Map$largeView = F4(
	function (_p16, mayPanelToggle, layersWidth, state) {
		var _p17 = _p16;
		var _p18 = _p17._0;
		return {
			ctor: '::',
			_0: A2(
				_mdgriffith$style_elements$Element$when,
				state.layerPanelVis,
				A3(
					_mdgriffith$style_elements$Element$el,
					_p18.styling.none,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$px(layersWidth)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$clipX,
								_1: {ctor: '[]'}
							}
						}
					},
					A5(
						_user$project$Map_View_Layer$view,
						_user$project$Map_Data_Config$Config(_p18),
						mayPanelToggle,
						state.uName,
						state.showCustomPanel,
						state.layers))),
			_1: {
				ctor: '::',
				_0: A4(
					_user$project$Map$viewMap,
					_user$project$Map_Data_Config$Config(_p18),
					true,
					false,
					state),
				_1: {ctor: '[]'}
			}
		};
	});
var _user$project$Map$viewGoogleMap = F2(
	function (_p19, state) {
		var _p20 = _p19;
		var _p21 = _p20._0;
		return {
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$column,
				_p21.styling.none,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_p21.styling.none,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$id(
								A2(_elm_lang$core$Basics_ops['++'], 'googlemap-', state.uName)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
										_1: {ctor: '[]'}
									}
								}
							}
						},
						_mdgriffith$style_elements$Element$empty),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_p21.styling.none,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$moveRight(86),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$moveUp(34),
									_1: {ctor: '[]'}
								}
							},
							_user$project$Map$viewToggleGoogleMapBtn(_p21)),
						_1: {ctor: '[]'}
					}
				}),
			_1: {
				ctor: '::',
				_0: A4(
					_user$project$Map$viewMap,
					_user$project$Map_Data_Config$Config(_p21),
					false,
					true,
					state),
				_1: {ctor: '[]'}
			}
		};
	});
var _user$project$Map$viewWithCustomPanel = F4(
	function (_p22, mayPanelToggle, layersWidth, state) {
		var _p23 = _p22;
		var _p24 = _p23._0;
		return A3(
			_mdgriffith$style_elements$Element$row,
			_p24.styling.none,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$clip,
						_1: {ctor: '[]'}
					}
				}
			},
			state.showGoogleMap ? A2(
				_user$project$Map$viewGoogleMap,
				_user$project$Map_Data_Config$Config(_p24),
				state) : ((state.device.phone || state.device.tablet) ? A3(
				_user$project$Map$smallView,
				_user$project$Map_Data_Config$Config(_p24),
				mayPanelToggle,
				state) : A4(
				_user$project$Map$largeView,
				_user$project$Map_Data_Config$Config(_p24),
				mayPanelToggle,
				layersWidth,
				state)));
	});
var _user$project$Map$view = F3(
	function (cfg, layersWidth, state) {
		return A4(_user$project$Map$viewWithCustomPanel, cfg, _elm_lang$core$Maybe$Nothing, layersWidth, state);
	});
var _user$project$Map$hasURLRequest = function (layer) {
	return !_elm_lang$core$Native_Utils.eq(
		_user$project$Map_Data_Layer$getUrlRequest(layer),
		_elm_lang$core$Maybe$Nothing);
};
var _user$project$Map$getRequestCmd = F3(
	function (layer, resolution, coordinates) {
		var urlRequest = _user$project$Map_Data_Layer$getUrlRequest(layer);
		var isResolutionBetweenBoundaries = function () {
			var maxResolution = function () {
				var _p25 = _user$project$Map_Data_Layer$getMaxResolution(layer);
				if (_p25.ctor === 'Nothing') {
					return 1 / 0;
				} else {
					return _p25._0;
				}
			}();
			var minResolution = function () {
				var _p26 = _user$project$Map_Data_Layer$getMinResolution(layer);
				if (_p26.ctor === 'Nothing') {
					return 0 - (1 / 0);
				} else {
					return _p26._0;
				}
			}();
			return A3(_user$project$Map_Data_Utils$isValueBetweenMinMax, resolution, minResolution, maxResolution);
		}();
		var isVisible = _user$project$Map_Data_Layer$getVisibility(layer);
		var layerKey = _user$project$Map_Data_Layer$getKey(layer);
		var _p27 = urlRequest;
		if (_p27.ctor === 'Nothing') {
			return _elm_lang$core$Platform_Cmd$none;
		} else {
			var _p29 = _p27._0;
			var isCoordsInBbox = function () {
				var _p28 = _user$project$Map_Data_Layer_URLRequest$getBoundingBox(_p29);
				if (_p28.ctor === 'Nothing') {
					return false;
				} else {
					return A2(_user$project$Map_Data_Utils$isPointInExtent, coordinates, _p28._0);
				}
			}();
			return (isCoordsInBbox && (isVisible && isResolutionBetweenBoundaries)) ? A2(
				_elm_lang$http$Http$send,
				A2(_user$project$Map_Data_Msg$ApiResponse, layerKey, coordinates),
				_elm_lang$http$Http$getString(
					A2(_user$project$Map_Data_Layer_URLRequest$getFormattedURL, _p29, coordinates))) : _elm_lang$core$Platform_Cmd$none;
		}
	});
var _user$project$Map$resetMapAndLayers = F4(
	function (msgFromMap, headers, state, layerKeys) {
		var cmds = _elm_lang$core$Platform_Cmd$batch(
			{
				ctor: '::',
				_0: A4(_user$project$Map$updateVector, msgFromMap, headers, state, layerKeys),
				_1: {
					ctor: '::',
					_0: _user$project$Map$resetInteractions(state),
					_1: {
						ctor: '::',
						_0: _user$project$Map$resize(state),
						_1: {ctor: '[]'}
					}
				}
			});
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				state,
				{mode: _user$project$Map_Data_Mode$NormalMode}),
			_1: cmds
		};
	});
var _user$project$Map$restore = F3(
	function (msgFromMap, headers, state) {
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				state,
				{mode: _user$project$Map_Data_Mode$NormalMode}),
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: _user$project$Map_Update_Mode_Utils$resetInteractions(state.map),
					_1: {
						ctor: '::',
						_0: _user$project$Map_Effects_Ports$attachMapToDiv(
							{map: state.map, divName: state.uName}),
						_1: {
							ctor: '::',
							_0: A5(_user$project$Map_Update_Layer_Vector$onRestoreClearBatchLoad, msgFromMap, headers, state.map, state.layers, state.extent),
							_1: {ctor: '[]'}
						}
					}
				})
		};
	});
var _user$project$Map$State = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return {uName: a, map: b, layers: c, layerPanelVis: d, extent: e, resolution: f, pointerCoord: g, clickPosInfo: h, mode: i, device: j, geolocation: k, showGoogleMap: l, showCustomPanel: m, callbackOnSelectionMsg: n, callbackOnCaptureCanvasMsg: o};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Map$init = F5(
	function (msgFromMap, name, _p30, layers, layerPanelVis) {
		var _p31 = _p30;
		var _p34 = _p31._0;
		var initWinSize = A2(
			_elm_lang$core$Task$perform,
			function (_p32) {
				return msgFromMap(
					_user$project$Map_Data_Msg$WindowResized(_p32));
			},
			_elm_lang$window$Window$size);
		var geolocationState = function () {
			var _p33 = _p34.geolocAndBlink;
			if (_p33._0 === true) {
				return A2(_user$project$Map_Data_Geolocation$Enabled, _p33._1, _p33._2);
			} else {
				return _user$project$Map_Data_Geolocation$Disabled(_p33._1);
			}
		}();
		var uName = A2(_elm_lang$core$Basics_ops['++'], 'map-', name);
		var state = _user$project$Map$State(uName)(_elm_lang$core$Json_Encode$null)(layers)(layerPanelVis)(_p34.extent)(100)(
			{x: 2528054, y: 1181334})(_elm_lang$core$Maybe$Nothing)(_user$project$Map_Data_Mode$NormalMode)(
			_mdgriffith$style_elements$Element$classifyDevice(
				{width: 500, height: 800}))(geolocationState)(false)(_p34.showCustomPanel)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing);
		var initLayers = _user$project$Map_Effects_Ports$initMap(
			{
				divName: uName,
				mapSettings: _p34,
				layers: _user$project$Map_Data_Layer$encodeList(layers)
			});
		return {
			ctor: '_Tuple2',
			_0: state,
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: initLayers,
					_1: {
						ctor: '::',
						_0: initWinSize,
						_1: {ctor: '[]'}
					}
				})
		};
	});
var _user$project$Map$CurPosDataEnded = function (a) {
	return {ctor: 'CurPosDataEnded', _0: a};
};
var _user$project$Map$StyleChanged = function (a) {
	return {ctor: 'StyleChanged', _0: a};
};
var _user$project$Map$Mode = function (a) {
	return {ctor: 'Mode', _0: a};
};
var _user$project$Map$Click = function (a) {
	return {ctor: 'Click', _0: a};
};
var _user$project$Map$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Map$update = F5(
	function (msgFromMap, headers, namedGeoZones, msg, state) {
		var _p35 = msg;
		switch (_p35.ctor) {
			case 'WindowResized':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{
							device: _mdgriffith$style_elements$Element$classifyDevice(_p35._0)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'MapCreated':
				var _p36 = _p35._0;
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{map: _p36.map, extent: _p36.extent, resolution: _p36.resolution});
				var onInitbatchLoadVector = A3(_user$project$Map_Update_Layer_Vector$onInitbatchLoad, msgFromMap, headers, state.layers);
				return {ctor: '_Tuple4', _0: newState, _1: onInitbatchLoadVector, _2: _user$project$Map$NoOutMsg, _3: _user$project$Action$none};
			case 'ToggleGoogleMap':
				var cmd = state.showGoogleMap ? _elm_lang$core$Platform_Cmd$none : _user$project$Map_Effects_Ports$initGoogleMap(
					{
						map: state.map,
						divName: A2(_elm_lang$core$Basics_ops['++'], 'googlemap-', state.uName)
					});
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{showGoogleMap: !state.showGoogleMap}),
					_1: cmd,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'UpdateGeolocation':
				var _p39 = _p35._0;
				var _p37 = function () {
					var _p38 = _p39;
					switch (_p38.ctor) {
						case 'Enabled':
							return {ctor: '_Tuple3', _0: true, _1: _p38._0, _2: _p38._1};
						case 'Disabled':
							return {ctor: '_Tuple3', _0: false, _1: _p38._0, _2: false};
						default:
							return {ctor: '_Tuple3', _0: false, _1: _p38._0, _2: false};
					}
				}();
				var enabled = _p37._0;
				var panAndZoomToRes = _p37._1;
				var blinking = _p37._2;
				var portData = {map: state.map, enabled: enabled, blinking: blinking, panAndZoomToRes: panAndZoomToRes};
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{geolocation: _p39}),
					_1: _user$project$Map_Effects_Ports$updateGeolocation(portData),
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'GeolocErrored':
				var panAndZoomToRes = function () {
					var _p40 = state.geolocation;
					switch (_p40.ctor) {
						case 'Enabled':
							return _p40._0;
						case 'Disabled':
							return _p40._0;
						default:
							return _p40._0;
					}
				}();
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{
							geolocation: A2(_user$project$Map_Data_Geolocation$Errored, panAndZoomToRes, _p35._0)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'CurPosDataReceived':
				return {
					ctor: '_Tuple4',
					_0: state,
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$CurPosDataEnded(
						_elm_lang$core$Result$Ok(_p35._0)),
					_3: _user$project$Action$none
				};
			case 'CurPosDataErrored':
				return {
					ctor: '_Tuple4',
					_0: state,
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$CurPosDataEnded(
						_elm_lang$core$Result$Err(_p35._0)),
					_3: _user$project$Action$none
				};
			case 'MapMoved':
				var _p41 = _p35._0;
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{
						clickPosInfo: A2(_user$project$Map_Update_ClickPosInfo$updatePixelPos, _p41.clickPixelPos, state.clickPosInfo),
						extent: _p41.extent,
						resolution: _p41.resolution
					});
				var onMoveLoadVector = A5(
					_user$project$Map_Update_Layer_Vector$onMoveLoad,
					msgFromMap,
					headers,
					_p41.resolution,
					_elm_lang$core$Maybe$Just(_p41.extent),
					state.layers);
				return {ctor: '_Tuple4', _0: newState, _1: onMoveLoadVector, _2: _user$project$Map$NoOutMsg, _3: _user$project$Action$none};
			case 'MapClickDataReceived':
				var _p42 = _p35._0;
				var cmdRequestsToRun = (!_p42.isUpdate) ? A2(
					_elm_lang$core$List$map,
					function (layer) {
						return A3(_user$project$Map$getRequestCmd, layer, state.resolution, _p42.coordinate);
					},
					A2(
						_elm_lang$core$List$filter,
						_user$project$Map$hasURLRequest,
						_user$project$Map_Update_Layer_Utils$flattenToSingleLayers(state.layers))) : {ctor: '[]'};
				var newClickPosInfo = (!_p42.isUpdate) ? _user$project$Map_Update_ClickPosInfo$clearResponses(state.clickPosInfo) : state.clickPosInfo;
				var portData = {mapClickData: _p42, namedGeoZones: namedGeoZones};
				var cmdCheckIfCoordInZones = _user$project$Map_Effects_Ports$checkIfCoordInZones(portData);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{clickPosInfo: newClickPosInfo}),
					_1: A2(
						_elm_lang$core$Platform_Cmd$map,
						msgFromMap,
						_elm_lang$core$Platform_Cmd$batch(
							_elm_lang$core$List$concat(
								{
									ctor: '::',
									_0: cmdRequestsToRun,
									_1: {
										ctor: '::',
										_0: {
											ctor: '::',
											_0: cmdCheckIfCoordInZones,
											_1: {ctor: '[]'}
										},
										_1: {ctor: '[]'}
									}
								}))),
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'ApiResponse':
				if (_p35._2.ctor === 'Ok') {
					var newClickPosInfo = A4(_user$project$Map_Update_ClickPosInfo$updateResponse, _p35._0, _p35._1, _p35._2._0, state.clickPosInfo);
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							state,
							{clickPosInfo: newClickPosInfo}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Map$NoOutMsg,
						_3: _user$project$Action$none
					};
				} else {
					return {ctor: '_Tuple4', _0: state, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map$NoOutMsg, _3: _user$project$Action$none};
				}
			case 'CoordInZonesChecked':
				var _p45 = _p35._0;
				var visTileLayKeys = A2(
					_elm_lang$core$List$map,
					_user$project$Map_Data_Layer$getKey,
					_user$project$Map_Update_Layer_Tiles$getVisible(state.layers));
				var newClickPosInfo = function () {
					var _p43 = state.mode;
					if (_p43.ctor === 'NormalMode') {
						return A3(_user$project$Map_Update_ClickPosInfo$updateWithCoordInZonesData, _p45, visTileLayKeys, state.clickPosInfo);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{clickPosInfo: newClickPosInfo});
				var outMsg = function () {
					if (_p45.mapClickData.isUpdate) {
						return _user$project$Map$NoOutMsg;
					} else {
						var _p44 = newClickPosInfo;
						if (_p44.ctor === 'Nothing') {
							return _user$project$Map$NoOutMsg;
						} else {
							return _user$project$Map$Click(_p44._0);
						}
					}
				}();
				return {ctor: '_Tuple4', _0: newState, _1: _elm_lang$core$Platform_Cmd$none, _2: outMsg, _3: _user$project$Action$none};
			case 'MapPointerMoved':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{pointerCoord: _p35._0}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'LegendCreated':
				var updLayers = A2(_user$project$Map_Update_Layer_Legend$update, _p35._0, state.layers);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{layers: updLayers}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'ModeEvent':
				var _p46 = A7(_user$project$Map_Update_Mode$update, msgFromMap, headers, _p35._0, state.map, state.extent, state.layers, state.mode);
				var mode = _p46._0;
				var modeCmd = _p46._1;
				var modeOutMsg = _p46._2;
				var defaultReturn = {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{mode: mode}),
					_1: modeCmd,
					_2: _user$project$Map$Mode(modeOutMsg),
					_3: _user$project$Action$none
				};
				var _p47 = modeOutMsg;
				_v21_2:
				do {
					switch (_p47.ctor) {
						case 'SelectUpdated':
							if ((_p47._0.ctor === 'Just') && (_p47._1.ctor === 'Just')) {
								var _p48 = state.callbackOnSelectionMsg;
								if ((_p48.ctor === 'Just') && (_p48._0.ctor === '_Tuple2')) {
									var action = (_elm_lang$core$Native_Utils.eq(_p47._0._0, _p48._0._0) && _p47._2) ? _user$project$Action$sendMsg(
										_p48._0._1(_p47._1._0)) : _user$project$Action$none;
									return {
										ctor: '_Tuple4',
										_0: _elm_lang$core$Native_Utils.update(
											state,
											{mode: mode}),
										_1: modeCmd,
										_2: _user$project$Map$Mode(modeOutMsg),
										_3: action
									};
								} else {
									return defaultReturn;
								}
							} else {
								break _v21_2;
							}
						case 'CaptureCanvasEnded':
							var _p49 = state.callbackOnCaptureCanvasMsg;
							if (_p49.ctor === 'Just') {
								var action = _user$project$Action$sendMsg(
									_p49._0(_p47._0));
								return {
									ctor: '_Tuple4',
									_0: _elm_lang$core$Native_Utils.update(
										state,
										{mode: mode}),
									_1: modeCmd,
									_2: _user$project$Map$Mode(modeOutMsg),
									_3: action
								};
							} else {
								return defaultReturn;
							}
						default:
							break _v21_2;
					}
				} while(false);
				return defaultReturn;
			case 'ClosePopup':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{clickPosInfo: _elm_lang$core$Maybe$Nothing}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'ToggleLayerPanel':
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{layerPanelVis: !state.layerPanelVis});
				return {
					ctor: '_Tuple4',
					_0: newState,
					_1: _user$project$Map_Effects_Ports$resizeMap(state.map),
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'ToggleLayerPanelContent':
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{showCustomPanel: !state.showCustomPanel});
				return {
					ctor: '_Tuple4',
					_0: newState,
					_1: _user$project$Map_Effects_Ports$resizeMap(state.map),
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'InitOpenLayerBtn':
				return {
					ctor: '_Tuple4',
					_0: state,
					_1: _user$project$Map_Effects_Ports$initOpenLayerBtn(
						{map: state.map, divName: _p35._0}),
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'ToggleGroup':
				var updLayers = A2(_user$project$Map_Update_Layer$toggleGroupExpanded, _p35._0, state.layers);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{layers: updLayers}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'ToggleInfo':
				var updLayers = A2(_user$project$Map_Update_Layer$toggleInfoExpanded, _p35._0, state.layers);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{layers: updLayers}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'ToggleSettings':
				var updLayers = A2(_user$project$Map_Update_Layer$toggleSettingsExpanded, _p35._0, state.layers);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{layers: updLayers}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'UpdateVisibility':
				var _p51 = _p35._0;
				var _p50 = _p35._1;
				var updMapLayerVis = _user$project$Map_Effects_Ports$updateLayerVisibility(
					{map: state.map, layerKey: _p51, isVisible: _p50});
				var updLayers = A3(_user$project$Map_Update_Layer$updateVisibility, _p51, _p50, state.layers);
				var onVisChangedLoad = A6(_user$project$Map_Update_Layer_Vector$onVisChangedLoad, msgFromMap, headers, state.resolution, state.extent, _p51, updLayers);
				var batchCmd = _elm_lang$core$Platform_Cmd$batch(
					{
						ctor: '::',
						_0: updMapLayerVis,
						_1: {
							ctor: '::',
							_0: onVisChangedLoad,
							_1: {ctor: '[]'}
						}
					});
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{layers: updLayers}),
					_1: batchCmd,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'UpdateVectorStyle':
				var _p53 = _p35._0;
				var updLayers = A3(_user$project$Map_Update_Layer_Vector$updateStyle, _p53, _p35._1, state.layers);
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{layers: updLayers});
				var mayNewStyle = A2(_user$project$Map$getLayerStyleObjName, newState, _p53);
				var outMsg = function () {
					var _p52 = mayNewStyle;
					if (_p52.ctor === 'Nothing') {
						return _user$project$Map$NoOutMsg;
					} else {
						return _user$project$Map$StyleChanged(_p52._0);
					}
				}();
				var updMapVectorStyle = A5(_user$project$Map_Update_Layer_Vector$updMapStyle, msgFromMap, headers, state.map, _p53, updLayers);
				return {ctor: '_Tuple4', _0: newState, _1: updMapVectorStyle, _2: outMsg, _3: _user$project$Action$none};
			case 'GetVectorCompleted':
				if (_p35._1.ctor === 'Err') {
					return {ctor: '_Tuple4', _0: state, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Map$NoOutMsg, _3: _user$project$Action$none};
				} else {
					var updVectorData = _user$project$Map_Effects_Ports$updateLayerVectorData(
						{map: state.map, layerKey: _p35._0, vectorData: _p35._1._0});
					return {ctor: '_Tuple4', _0: state, _1: updVectorData, _2: _user$project$Map$NoOutMsg, _3: _user$project$Action$none};
				}
			case 'UpdateOpacity':
				var _p56 = _p35._1;
				var _p55 = _p35._0;
				var updOpacity = function () {
					var opacityConfig = _user$project$Map_Data_Layer$opacityConfig;
					var _p54 = _p35._2;
					if (_p54.ctor === 'Increase') {
						return (_elm_lang$core$Native_Utils.cmp(_p56, opacityConfig.max) < 0) ? (_p56 + opacityConfig.step) : _p56;
					} else {
						return (_elm_lang$core$Native_Utils.cmp(_p56, opacityConfig.step + opacityConfig.min) > -1) ? (_p56 - opacityConfig.step) : _p56;
					}
				}();
				var updLayers = A3(_user$project$Map_Update_Layer$updateOpacity, _p55, updOpacity, state.layers);
				var updMapLayerOpacity = _user$project$Map_Effects_Ports$updateLayerOpacity(
					{map: state.map, layerKey: _p55, opacity: updOpacity});
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{layers: updLayers}),
					_1: updMapLayerOpacity,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'StartSelectObjsModeMinMax':
				var _p57 = A6(
					_user$project$Map$startSelectObjsModeMinMax,
					state,
					_elm_lang$core$Maybe$Just(_p35._0),
					_p35._1,
					_p35._2,
					_p35._3,
					_p35._4);
				var newState = _p57._0;
				var cmd = _p57._1;
				return {ctor: '_Tuple4', _0: newState, _1: cmd, _2: _user$project$Map$NoOutMsg, _3: _user$project$Action$none};
			case 'RegisterCallbackOnSelectionEnded':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{
							callbackOnSelectionMsg: _elm_lang$core$Maybe$Just(
								{ctor: '_Tuple2', _0: _p35._0, _1: _p35._1})
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
			case 'StartCaptureCanvasMode':
				var _p58 = _user$project$Map$startCaptureCanvasMode(state);
				var newState = _p58._0;
				var cmd = _p58._1;
				return {ctor: '_Tuple4', _0: newState, _1: cmd, _2: _user$project$Map$NoOutMsg, _3: _user$project$Action$none};
			default:
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{
							callbackOnCaptureCanvasMsg: _elm_lang$core$Maybe$Just(_p35._0)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Map$NoOutMsg,
					_3: _user$project$Action$none
				};
		}
	});

var _user$project$OpsHandler_Styles$Instructions = {ctor: 'Instructions'};
var _user$project$OpsHandler_Styles$ImageNotSelected = {ctor: 'ImageNotSelected'};
var _user$project$OpsHandler_Styles$ImageSelected = {ctor: 'ImageSelected'};
var _user$project$OpsHandler_Styles$Image = {ctor: 'Image'};
var _user$project$OpsHandler_Styles$Background = {ctor: 'Background'};
var _user$project$OpsHandler_Styles$OpsHandler = {ctor: 'OpsHandler'};
var _user$project$OpsHandler_Styles$Btn = {ctor: 'Btn'};
var _user$project$OpsHandler_Styles$SubTitle = {ctor: 'SubTitle'};
var _user$project$OpsHandler_Styles$MainTitle = {ctor: 'MainTitle'};
var _user$project$OpsHandler_Styles$NoStyle = {ctor: 'NoStyle'};
var _user$project$OpsHandler_Styles$NoVariation = {ctor: 'NoVariation'};
var _user$project$OpsHandler_Styles$Disabled = {ctor: 'Disabled'};
var _user$project$OpsHandler_Styles$styleList = {
	ctor: '::',
	_0: A2(
		_mdgriffith$style_elements$Style$style,
		_user$project$OpsHandler_Styles$NoStyle,
		{ctor: '[]'}),
	_1: {
		ctor: '::',
		_0: A2(
			_mdgriffith$style_elements$Style$style,
			_user$project$OpsHandler_Styles$MainTitle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Style_Font$size(18),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Style_Font$bold,
					_1: {ctor: '[]'}
				}
			}),
		_1: {
			ctor: '::',
			_0: A2(
				_mdgriffith$style_elements$Style$style,
				_user$project$OpsHandler_Styles$SubTitle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Style_Font$bold,
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Style$style,
					_user$project$OpsHandler_Styles$Btn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Style_Border$all(2),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Border$rounded(2),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Style$hover(
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$grey),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_mdgriffith$style_elements$Style$variation,
												_user$project$OpsHandler_Styles$Disabled,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkGrey),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Style$hover(
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																	_1: {ctor: '[]'}
																}),
															_1: {ctor: '[]'}
														}
													}
												}),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_mdgriffith$style_elements$Style$style,
						_user$project$OpsHandler_Styles$OpsHandler,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Style_Border$all(2),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Style_Border$rounded(2),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGray),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Style_Color$background(
											A3(_elm_lang$core$Color$rgb, 255, 255, 255)),
										_1: {ctor: '[]'}
									}
								}
							}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_mdgriffith$style_elements$Style$style,
							_user$project$OpsHandler_Styles$Background,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Style_Color$background(
									A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0.5)),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Style$style,
								_user$project$OpsHandler_Styles$ImageSelected,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Border$all(4),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$lightBlue),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_mdgriffith$style_elements$Style$style,
									_user$project$OpsHandler_Styles$ImageNotSelected,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Style_Border$all(1),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$black),
											_1: {ctor: '[]'}
										}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_mdgriffith$style_elements$Style$style,
										_user$project$OpsHandler_Styles$Image,
										{
											ctor: '::',
											_0: A2(_mdgriffith$style_elements$Style$prop, 'object-fit', 'cover'),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_mdgriffith$style_elements$Style$style,
											_user$project$OpsHandler_Styles$Instructions,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Style_Font$italic,
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};

var _user$project$Styles$StylesFromOpsHandler = function (a) {
	return {ctor: 'StylesFromOpsHandler', _0: a};
};
var _user$project$Styles$Exemple = {ctor: 'Exemple'};
var _user$project$Styles$StyleFromMap = function (a) {
	return {ctor: 'StyleFromMap', _0: a};
};
var _user$project$Styles$ListItem = {ctor: 'ListItem'};
var _user$project$Styles$BorderTop = {ctor: 'BorderTop'};
var _user$project$Styles$BioStyle = {ctor: 'BioStyle'};
var _user$project$Styles$CarStyle = {ctor: 'CarStyle'};
var _user$project$Styles$FolStyle = {ctor: 'FolStyle'};
var _user$project$Styles$SecStyle = {ctor: 'SecStyle'};
var _user$project$Styles$Modal = {ctor: 'Modal'};
var _user$project$Styles$SubMenu = {ctor: 'SubMenu'};
var _user$project$Styles$DropDownMenu = {ctor: 'DropDownMenu'};
var _user$project$Styles$DocDisabledBtn = {ctor: 'DocDisabledBtn'};
var _user$project$Styles$DocDeleteBtn = {ctor: 'DocDeleteBtn'};
var _user$project$Styles$DocEditBtn = {ctor: 'DocEditBtn'};
var _user$project$Styles$DocAddBtn = {ctor: 'DocAddBtn'};
var _user$project$Styles$SuccessBtn = {ctor: 'SuccessBtn'};
var _user$project$Styles$WarningBtn = {ctor: 'WarningBtn'};
var _user$project$Styles$SaveBtn = {ctor: 'SaveBtn'};
var _user$project$Styles$EditBtn = {ctor: 'EditBtn'};
var _user$project$Styles$ExportBtn = {ctor: 'ExportBtn'};
var _user$project$Styles$CancelBtn = {ctor: 'CancelBtn'};
var _user$project$Styles$TrspBtn = {ctor: 'TrspBtn'};
var _user$project$Styles$Btn = {ctor: 'Btn'};
var _user$project$Styles$OldStatusStyle = {ctor: 'OldStatusStyle'};
var _user$project$Styles$DarkTableRow = {ctor: 'DarkTableRow'};
var _user$project$Styles$TableRow = {ctor: 'TableRow'};
var _user$project$Styles$NotValidSelect = {ctor: 'NotValidSelect'};
var _user$project$Styles$ValidSelect = {ctor: 'ValidSelect'};
var _user$project$Styles$NotValid = {ctor: 'NotValid'};
var _user$project$Styles$InputRow = {ctor: 'InputRow'};
var _user$project$Styles$InputNotValid = {ctor: 'InputNotValid'};
var _user$project$Styles$Input = {ctor: 'Input'};
var _user$project$Styles$VerySmallFont = {ctor: 'VerySmallFont'};
var _user$project$Styles$SmallFont = {ctor: 'SmallFont'};
var _user$project$Styles$ErrorText = {ctor: 'ErrorText'};
var _user$project$Styles$DisabledText = {ctor: 'DisabledText'};
var _user$project$Styles$ExtraInfo = {ctor: 'ExtraInfo'};
var _user$project$Styles$LabelPoints = {ctor: 'LabelPoints'};
var _user$project$Styles$Label = {ctor: 'Label'};
var _user$project$Styles$Separator = {ctor: 'Separator'};
var _user$project$Styles$FormConstraint = {ctor: 'FormConstraint'};
var _user$project$Styles$FormValidationError = {ctor: 'FormValidationError'};
var _user$project$Styles$Warning = {ctor: 'Warning'};
var _user$project$Styles$RedSubTitle = {ctor: 'RedSubTitle'};
var _user$project$Styles$SubTitle = {ctor: 'SubTitle'};
var _user$project$Styles$MainTitle = {ctor: 'MainTitle'};
var _user$project$Styles$Footer = {ctor: 'Footer'};
var _user$project$Styles$Header = {ctor: 'Header'};
var _user$project$Styles$InnerContainer = {ctor: 'InnerContainer'};
var _user$project$Styles$LightBlueBorder = {ctor: 'LightBlueBorder'};
var _user$project$Styles$LightGreenBorder = {ctor: 'LightGreenBorder'};
var _user$project$Styles$Level3 = {ctor: 'Level3'};
var _user$project$Styles$Level2 = {ctor: 'Level2'};
var _user$project$Styles$Level1 = {ctor: 'Level1'};
var _user$project$Styles$SectionDotted = {ctor: 'SectionDotted'};
var _user$project$Styles$SectionLight = {ctor: 'SectionLight'};
var _user$project$Styles$Section = {ctor: 'Section'};
var _user$project$Styles$FormNotice = {ctor: 'FormNotice'};
var _user$project$Styles$FormFooterPointsOK = {ctor: 'FormFooterPointsOK'};
var _user$project$Styles$FormFooterPointsKO = {ctor: 'FormFooterPointsKO'};
var _user$project$Styles$FormFooterText = {ctor: 'FormFooterText'};
var _user$project$Styles$FormFooter = {ctor: 'FormFooter'};
var _user$project$Styles$Form = {ctor: 'Form'};
var _user$project$Styles$PopupHeader = {ctor: 'PopupHeader'};
var _user$project$Styles$Link = {ctor: 'Link'};
var _user$project$Styles$HyperLink = {ctor: 'HyperLink'};
var _user$project$Styles$NoStyle = {ctor: 'NoStyle'};
var _user$project$Styles$VariationsFromOpsHandler = function (a) {
	return {ctor: 'VariationsFromOpsHandler', _0: a};
};
var _user$project$Styles$NoVariation = {ctor: 'NoVariation'};
var _user$project$Styles$Disabled = {ctor: 'Disabled'};
var _user$project$Styles$stylesheet = _mdgriffith$style_elements$Style$styleSheet(
	{
		ctor: '::',
		_0: A2(
			_mdgriffith$style_elements$Style$style,
			_user$project$Styles$NoStyle,
			{ctor: '[]'}),
		_1: {
			ctor: '::',
			_0: A2(
				_mdgriffith$style_elements$Style$style,
				_user$project$Styles$HyperLink,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Style_Color$text(
						A4(_elm_lang$core$Color$rgba, 13, 128, 201, 1)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Style$hover(
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Style_Color$text(
									A4(_elm_lang$core$Color$rgba, 0, 89, 188, 1)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Font$underline,
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Style$style,
					_user$project$Styles$Link,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$orange),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Style$hover(
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$lightOrange),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_mdgriffith$style_elements$Style$style,
						_user$project$Styles$PopupHeader,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkBlue),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Style_Font$underline,
								_1: {ctor: '[]'}
							}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_mdgriffith$style_elements$Style$style,
							_user$project$Styles$Form,
							{
								ctor: '::',
								_0: A2(_mdgriffith$style_elements$Style_Shadow$glow, _elm_lang$core$Color$grey, 3),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Style$style,
								_user$project$Styles$FormFooter,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Style_Color$background(
										A4(_elm_lang$core$Color$rgba, 147, 196, 125, 1)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Style_Color$text(
											A4(_elm_lang$core$Color$rgba, 12, 83, 147, 1)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Style_Font$bold,
											_1: {ctor: '[]'}
										}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_mdgriffith$style_elements$Style$style,
									_user$project$Styles$FormFooterText,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Style_Font$alignLeft,
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_mdgriffith$style_elements$Style$style,
										_user$project$Styles$FormFooterPointsKO,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Style_Font$alignRight,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Style_Color$text(
													A4(_elm_lang$core$Color$rgba, 254, 0, 0, 1)),
												_1: {ctor: '[]'}
											}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_mdgriffith$style_elements$Style$style,
											_user$project$Styles$FormFooterPointsOK,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Style_Font$alignRight,
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Style_Color$text(
														A4(_elm_lang$core$Color$rgba, 152, 0, 254, 1)),
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_mdgriffith$style_elements$Style$style,
												_user$project$Styles$FormNotice,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Style_Color$text(
														A4(_elm_lang$core$Color$rgba, 103, 0, 13, 1)),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_mdgriffith$style_elements$Style$style,
													_user$project$Styles$Section,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Style_Border$rounded(4),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Style_Border$all(1),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
																_1: {ctor: '[]'}
															}
														}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_mdgriffith$style_elements$Style$style,
														_user$project$Styles$SectionLight,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Style_Border$rounded(4),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Style_Border$all(1),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$lightGrey),
																	_1: {ctor: '[]'}
																}
															}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_mdgriffith$style_elements$Style$style,
															_user$project$Styles$SectionDotted,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Style_Border$rounded(4),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Style_Border$all(1),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Style_Filter$sepia(40),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
																			_1: {ctor: '[]'}
																		}
																	}
																}
															}),
														_1: {
															ctor: '::',
															_0: A2(
																_mdgriffith$style_elements$Style$style,
																_user$project$Styles$Level1,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Style_Color$background(
																		A4(_elm_lang$core$Color$rgba, 250, 250, 210, 1)),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: A2(
																	_mdgriffith$style_elements$Style$style,
																	_user$project$Styles$Level2,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Style_Color$background(
																			A4(_elm_lang$core$Color$rgba, 238, 232, 170, 1)),
																		_1: {ctor: '[]'}
																	}),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_mdgriffith$style_elements$Style$style,
																		_user$project$Styles$Level3,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Style_Color$background(
																				A4(_elm_lang$core$Color$rgba, 218, 165, 32, 1)),
																			_1: {ctor: '[]'}
																		}),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_mdgriffith$style_elements$Style$style,
																			_user$project$Styles$LightGreenBorder,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Style_Border$rounded(4),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Style_Border$all(4),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$lightGreen),
																						_1: {ctor: '[]'}
																					}
																				}
																			}),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_mdgriffith$style_elements$Style$style,
																				_user$project$Styles$LightBlueBorder,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Style_Border$rounded(4),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Style_Border$all(4),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$lightBlue),
																							_1: {ctor: '[]'}
																						}
																					}
																				}),
																			_1: {
																				ctor: '::',
																				_0: A2(
																					_mdgriffith$style_elements$Style$style,
																					_user$project$Styles$InnerContainer,
																					{
																						ctor: '::',
																						_0: A2(_mdgriffith$style_elements$Style_Shadow$glow, _elm_lang$core$Color$grey, 2),
																						_1: {ctor: '[]'}
																					}),
																				_1: {
																					ctor: '::',
																					_0: A2(
																						_mdgriffith$style_elements$Style$style,
																						_user$project$Styles$Header,
																						{
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Style_Border$bottom(3),
																							_1: {
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$charcoal),
																								_1: {ctor: '[]'}
																							}
																						}),
																					_1: {
																						ctor: '::',
																						_0: A2(
																							_mdgriffith$style_elements$Style$style,
																							_user$project$Styles$Footer,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Style_Border$top(3),
																								_1: {
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$charcoal),
																									_1: {
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Style_Font$size(14),
																										_1: {ctor: '[]'}
																									}
																								}
																							}),
																						_1: {
																							ctor: '::',
																							_0: A2(
																								_mdgriffith$style_elements$Style$style,
																								_user$project$Styles$MainTitle,
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Style_Font$size(18),
																									_1: {
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Style_Font$bold,
																										_1: {ctor: '[]'}
																									}
																								}),
																							_1: {
																								ctor: '::',
																								_0: A2(
																									_mdgriffith$style_elements$Style$style,
																									_user$project$Styles$SubTitle,
																									{
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Style_Font$bold,
																										_1: {ctor: '[]'}
																									}),
																								_1: {
																									ctor: '::',
																									_0: A2(
																										_mdgriffith$style_elements$Style$style,
																										_user$project$Styles$RedSubTitle,
																										{
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Style_Font$bold,
																											_1: {
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$red),
																												_1: {ctor: '[]'}
																											}
																										}),
																									_1: {
																										ctor: '::',
																										_0: A2(
																											_mdgriffith$style_elements$Style$style,
																											_user$project$Styles$Warning,
																											{
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$orange),
																												_1: {ctor: '[]'}
																											}),
																										_1: {
																											ctor: '::',
																											_0: A2(
																												_mdgriffith$style_elements$Style$style,
																												_user$project$Styles$FormValidationError,
																												{
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$red),
																													_1: {
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Style_Font$size(12),
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Style_Font$bold,
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Style_Font$italic,
																																_1: {ctor: '[]'}
																															}
																														}
																													}
																												}),
																											_1: {
																												ctor: '::',
																												_0: A2(
																													_mdgriffith$style_elements$Style$style,
																													_user$project$Styles$FormConstraint,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$orange),
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Style_Font$size(14),
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Style_Font$italic,
																																_1: {ctor: '[]'}
																															}
																														}
																													}),
																												_1: {
																													ctor: '::',
																													_0: A2(
																														_mdgriffith$style_elements$Style$style,
																														_user$project$Styles$Separator,
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Style_Border$top(1),
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
																																_1: {ctor: '[]'}
																															}
																														}),
																													_1: {
																														ctor: '::',
																														_0: A2(
																															_mdgriffith$style_elements$Style$style,
																															_user$project$Styles$Label,
																															{
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkBlue),
																																_1: {ctor: '[]'}
																															}),
																														_1: {
																															ctor: '::',
																															_0: A2(
																																_mdgriffith$style_elements$Style$style,
																																_user$project$Styles$LabelPoints,
																																{
																																	ctor: '::',
																																	_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$orange),
																																	_1: {
																																		ctor: '::',
																																		_0: _mdgriffith$style_elements$Style_Font$alignRight,
																																		_1: {
																																			ctor: '::',
																																			_0: _mdgriffith$style_elements$Style_Font$bold,
																																			_1: {ctor: '[]'}
																																		}
																																	}
																																}),
																															_1: {
																																ctor: '::',
																																_0: A2(
																																	_mdgriffith$style_elements$Style$style,
																																	_user$project$Styles$ExtraInfo,
																																	{
																																		ctor: '::',
																																		_0: _mdgriffith$style_elements$Style_Color$background(
																																			A3(_elm_lang$core$Color$rgb, 221, 221, 221)),
																																		_1: {ctor: '[]'}
																																	}),
																																_1: {
																																	ctor: '::',
																																	_0: A2(
																																		_mdgriffith$style_elements$Style$style,
																																		_user$project$Styles$DisabledText,
																																		{
																																			ctor: '::',
																																			_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$grey),
																																			_1: {ctor: '[]'}
																																		}),
																																	_1: {
																																		ctor: '::',
																																		_0: A2(
																																			_mdgriffith$style_elements$Style$style,
																																			_user$project$Styles$ErrorText,
																																			{
																																				ctor: '::',
																																				_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$red),
																																				_1: {ctor: '[]'}
																																			}),
																																		_1: {
																																			ctor: '::',
																																			_0: A2(
																																				_mdgriffith$style_elements$Style$style,
																																				_user$project$Styles$SmallFont,
																																				{
																																					ctor: '::',
																																					_0: _mdgriffith$style_elements$Style_Font$size(14),
																																					_1: {ctor: '[]'}
																																				}),
																																			_1: {
																																				ctor: '::',
																																				_0: A2(
																																					_mdgriffith$style_elements$Style$style,
																																					_user$project$Styles$VerySmallFont,
																																					{
																																						ctor: '::',
																																						_0: _mdgriffith$style_elements$Style_Font$size(12),
																																						_1: {ctor: '[]'}
																																					}),
																																				_1: {
																																					ctor: '::',
																																					_0: A2(
																																						_mdgriffith$style_elements$Style$style,
																																						_user$project$Styles$Input,
																																						{
																																							ctor: '::',
																																							_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$grey),
																																							_1: {
																																								ctor: '::',
																																								_0: _mdgriffith$style_elements$Style_Border$all(1),
																																								_1: {
																																									ctor: '::',
																																									_0: _mdgriffith$style_elements$Style_Color$background(
																																										A4(_elm_lang$core$Color$rgba, 246, 245, 244, 1)),
																																									_1: {ctor: '[]'}
																																								}
																																							}
																																						}),
																																					_1: {
																																						ctor: '::',
																																						_0: A2(
																																							_mdgriffith$style_elements$Style$style,
																																							_user$project$Styles$InputNotValid,
																																							{
																																								ctor: '::',
																																								_0: _mdgriffith$style_elements$Style_Color$background(
																																									A4(_elm_lang$core$Color$rgba, 255, 220, 220, 1)),
																																								_1: {
																																									ctor: '::',
																																									_0: _mdgriffith$style_elements$Style_Border$all(1),
																																									_1: {
																																										ctor: '::',
																																										_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$lightGray),
																																										_1: {ctor: '[]'}
																																									}
																																								}
																																							}),
																																						_1: {
																																							ctor: '::',
																																							_0: A2(
																																								_mdgriffith$style_elements$Style$style,
																																								_user$project$Styles$InputRow,
																																								{
																																									ctor: '::',
																																									_0: _mdgriffith$style_elements$Style_Color$background(
																																										A4(_elm_lang$core$Color$rgba, 238, 236, 234, 1)),
																																									_1: {
																																										ctor: '::',
																																										_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																										_1: {ctor: '[]'}
																																									}
																																								}),
																																							_1: {
																																								ctor: '::',
																																								_0: A2(
																																									_mdgriffith$style_elements$Style$style,
																																									_user$project$Styles$NotValid,
																																									{
																																										ctor: '::',
																																										_0: _mdgriffith$style_elements$Style_Color$background(
																																											A4(_elm_lang$core$Color$rgba, 255, 220, 220, 1)),
																																										_1: {
																																											ctor: '::',
																																											_0: _mdgriffith$style_elements$Style_Border$all(2),
																																											_1: {
																																												ctor: '::',
																																												_0: _mdgriffith$style_elements$Style_Border$rounded(6),
																																												_1: {ctor: '[]'}
																																											}
																																										}
																																									}),
																																								_1: {
																																									ctor: '::',
																																									_0: A2(
																																										_mdgriffith$style_elements$Style$style,
																																										_user$project$Styles$TableRow,
																																										{
																																											ctor: '::',
																																											_0: _mdgriffith$style_elements$Style_Color$background(
																																												_elm_lang$core$Color$greyscale(0.2)),
																																											_1: {
																																												ctor: '::',
																																												_0: _mdgriffith$style_elements$Style_Border$bottom(1),
																																												_1: {
																																													ctor: '::',
																																													_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$white),
																																													_1: {ctor: '[]'}
																																												}
																																											}
																																										}),
																																									_1: {
																																										ctor: '::',
																																										_0: A2(
																																											_mdgriffith$style_elements$Style$style,
																																											_user$project$Styles$DarkTableRow,
																																											{
																																												ctor: '::',
																																												_0: _mdgriffith$style_elements$Style_Color$background(
																																													_elm_lang$core$Color$greyscale(0.5)),
																																												_1: {
																																													ctor: '::',
																																													_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$white),
																																													_1: {
																																														ctor: '::',
																																														_0: _mdgriffith$style_elements$Style_Font$bold,
																																														_1: {
																																															ctor: '::',
																																															_0: _mdgriffith$style_elements$Style_Border$bottom(1),
																																															_1: {
																																																ctor: '::',
																																																_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$white),
																																																_1: {ctor: '[]'}
																																															}
																																														}
																																													}
																																												}
																																											}),
																																										_1: {
																																											ctor: '::',
																																											_0: A2(
																																												_mdgriffith$style_elements$Style$style,
																																												_user$project$Styles$OldStatusStyle,
																																												{
																																													ctor: '::',
																																													_0: _mdgriffith$style_elements$Style_Color$background(
																																														_elm_lang$core$Color$greyscale(0.1)),
																																													_1: {
																																														ctor: '::',
																																														_0: _mdgriffith$style_elements$Style_Border$all(1),
																																														_1: {
																																															ctor: '::',
																																															_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
																																															_1: {
																																																ctor: '::',
																																																_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkGrey),
																																																_1: {ctor: '[]'}
																																															}
																																														}
																																													}
																																												}),
																																											_1: {
																																												ctor: '::',
																																												_0: A2(
																																													_mdgriffith$style_elements$Style$style,
																																													_user$project$Styles$Btn,
																																													{
																																														ctor: '::',
																																														_0: _mdgriffith$style_elements$Style_Border$rounded(1),
																																														_1: {
																																															ctor: '::',
																																															_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$grey),
																																															_1: {
																																																ctor: '::',
																																																_0: _mdgriffith$style_elements$Style$hover(
																																																	{
																																																		ctor: '::',
																																																		_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																		_1: {ctor: '[]'}
																																																	}),
																																																_1: {ctor: '[]'}
																																															}
																																														}
																																													}),
																																												_1: {
																																													ctor: '::',
																																													_0: A2(
																																														_mdgriffith$style_elements$Style$style,
																																														_user$project$Styles$TrspBtn,
																																														{
																																															ctor: '::',
																																															_0: _mdgriffith$style_elements$Style_Color$background(
																																																A4(_elm_lang$core$Color$rgba, 0, 0, 0, 0)),
																																															_1: {
																																																ctor: '::',
																																																_0: _mdgriffith$style_elements$Style$hover(
																																																	{
																																																		ctor: '::',
																																																		_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$grey),
																																																		_1: {ctor: '[]'}
																																																	}),
																																																_1: {ctor: '[]'}
																																															}
																																														}),
																																													_1: {
																																														ctor: '::',
																																														_0: A2(
																																															_mdgriffith$style_elements$Style$style,
																																															_user$project$Styles$CancelBtn,
																																															{
																																																ctor: '::',
																																																_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																_1: {
																																																	ctor: '::',
																																																	_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGrey),
																																																	_1: {
																																																		ctor: '::',
																																																		_0: _mdgriffith$style_elements$Style_Border$all(2),
																																																		_1: {
																																																			ctor: '::',
																																																			_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																																			_1: {
																																																				ctor: '::',
																																																				_0: _mdgriffith$style_elements$Style$hover(
																																																					{
																																																						ctor: '::',
																																																						_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$grey),
																																																						_1: {ctor: '[]'}
																																																					}),
																																																				_1: {
																																																					ctor: '::',
																																																					_0: A2(
																																																						_mdgriffith$style_elements$Style$variation,
																																																						_user$project$Styles$Disabled,
																																																						{
																																																							ctor: '::',
																																																							_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkGrey),
																																																							_1: {
																																																								ctor: '::',
																																																								_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																								_1: {
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style$hover(
																																																										{
																																																											ctor: '::',
																																																											_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																											_1: {ctor: '[]'}
																																																										}),
																																																									_1: {ctor: '[]'}
																																																								}
																																																							}
																																																						}),
																																																					_1: {ctor: '[]'}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}),
																																														_1: {
																																															ctor: '::',
																																															_0: A2(
																																																_mdgriffith$style_elements$Style$style,
																																																_user$project$Styles$ExportBtn,
																																																{
																																																	ctor: '::',
																																																	_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGreen),
																																																	_1: {
																																																		ctor: '::',
																																																		_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkGreen),
																																																		_1: {
																																																			ctor: '::',
																																																			_0: _mdgriffith$style_elements$Style_Border$all(2),
																																																			_1: {
																																																				ctor: '::',
																																																				_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																																				_1: {
																																																					ctor: '::',
																																																					_0: _mdgriffith$style_elements$Style$hover(
																																																						{
																																																							ctor: '::',
																																																							_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$darkGreen),
																																																							_1: {ctor: '[]'}
																																																						}),
																																																					_1: {
																																																						ctor: '::',
																																																						_0: A2(
																																																							_mdgriffith$style_elements$Style$variation,
																																																							_user$project$Styles$Disabled,
																																																							{
																																																								ctor: '::',
																																																								_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkGrey),
																																																								_1: {
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																									_1: {
																																																										ctor: '::',
																																																										_0: _mdgriffith$style_elements$Style$hover(
																																																											{
																																																												ctor: '::',
																																																												_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																												_1: {ctor: '[]'}
																																																											}),
																																																										_1: {ctor: '[]'}
																																																									}
																																																								}
																																																							}),
																																																						_1: {ctor: '[]'}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}),
																																															_1: {
																																																ctor: '::',
																																																_0: A2(
																																																	_mdgriffith$style_elements$Style$style,
																																																	_user$project$Styles$EditBtn,
																																																	{
																																																		ctor: '::',
																																																		_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightYellow),
																																																		_1: {
																																																			ctor: '::',
																																																			_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkYellow),
																																																			_1: {
																																																				ctor: '::',
																																																				_0: _mdgriffith$style_elements$Style_Border$all(2),
																																																				_1: {
																																																					ctor: '::',
																																																					_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																																					_1: {
																																																						ctor: '::',
																																																						_0: _mdgriffith$style_elements$Style$hover(
																																																							{
																																																								ctor: '::',
																																																								_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$yellow),
																																																								_1: {ctor: '[]'}
																																																							}),
																																																						_1: {
																																																							ctor: '::',
																																																							_0: A2(
																																																								_mdgriffith$style_elements$Style$variation,
																																																								_user$project$Styles$Disabled,
																																																								{
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkGrey),
																																																									_1: {
																																																										ctor: '::',
																																																										_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																										_1: {
																																																											ctor: '::',
																																																											_0: _mdgriffith$style_elements$Style$hover(
																																																												{
																																																													ctor: '::',
																																																													_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																													_1: {ctor: '[]'}
																																																												}),
																																																											_1: {ctor: '[]'}
																																																										}
																																																									}
																																																								}),
																																																							_1: {ctor: '[]'}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}),
																																																_1: {
																																																	ctor: '::',
																																																	_0: A2(
																																																		_mdgriffith$style_elements$Style$style,
																																																		_user$project$Styles$SaveBtn,
																																																		{
																																																			ctor: '::',
																																																			_0: _mdgriffith$style_elements$Style_Color$background(
																																																				A4(_elm_lang$core$Color$rgba, 255, 120, 120, 1)),
																																																			_1: {
																																																				ctor: '::',
																																																				_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkRed),
																																																				_1: {
																																																					ctor: '::',
																																																					_0: _mdgriffith$style_elements$Style_Border$all(2),
																																																					_1: {
																																																						ctor: '::',
																																																						_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																																						_1: {
																																																							ctor: '::',
																																																							_0: _mdgriffith$style_elements$Style$hover(
																																																								{
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$red),
																																																									_1: {ctor: '[]'}
																																																								}),
																																																							_1: {
																																																								ctor: '::',
																																																								_0: A2(
																																																									_mdgriffith$style_elements$Style$variation,
																																																									_user$project$Styles$Disabled,
																																																									{
																																																										ctor: '::',
																																																										_0: _mdgriffith$style_elements$Style_Color$text(_elm_lang$core$Color$darkGrey),
																																																										_1: {
																																																											ctor: '::',
																																																											_0: _mdgriffith$style_elements$Style_Color$background(
																																																												A4(_elm_lang$core$Color$rgba, 255, 220, 220, 1)),
																																																											_1: {
																																																												ctor: '::',
																																																												_0: _mdgriffith$style_elements$Style$hover(
																																																													{
																																																														ctor: '::',
																																																														_0: _mdgriffith$style_elements$Style_Color$background(
																																																															A4(_elm_lang$core$Color$rgba, 255, 220, 220, 1)),
																																																														_1: {ctor: '[]'}
																																																													}),
																																																												_1: {ctor: '[]'}
																																																											}
																																																										}
																																																									}),
																																																								_1: {ctor: '[]'}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}),
																																																	_1: {
																																																		ctor: '::',
																																																		_0: A2(
																																																			_mdgriffith$style_elements$Style$style,
																																																			_user$project$Styles$WarningBtn,
																																																			{
																																																				ctor: '::',
																																																				_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$orange),
																																																				_1: {
																																																					ctor: '::',
																																																					_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																																					_1: {
																																																						ctor: '::',
																																																						_0: _mdgriffith$style_elements$Style$hover(
																																																							{
																																																								ctor: '::',
																																																								_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$darkOrange),
																																																								_1: {ctor: '[]'}
																																																							}),
																																																						_1: {ctor: '[]'}
																																																					}
																																																				}
																																																			}),
																																																		_1: {
																																																			ctor: '::',
																																																			_0: A2(
																																																				_mdgriffith$style_elements$Style$style,
																																																				_user$project$Styles$SuccessBtn,
																																																				{
																																																					ctor: '::',
																																																					_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGreen),
																																																					_1: {
																																																						ctor: '::',
																																																						_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																																						_1: {
																																																							ctor: '::',
																																																							_0: _mdgriffith$style_elements$Style$hover(
																																																								{
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$green),
																																																									_1: {ctor: '[]'}
																																																								}),
																																																							_1: {ctor: '[]'}
																																																						}
																																																					}
																																																				}),
																																																			_1: {
																																																				ctor: '::',
																																																				_0: A2(
																																																					_mdgriffith$style_elements$Style$style,
																																																					_user$project$Styles$DocAddBtn,
																																																					{
																																																						ctor: '::',
																																																						_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGreen),
																																																						_1: {
																																																							ctor: '::',
																																																							_0: _mdgriffith$style_elements$Style_Border$rounded(12),
																																																							_1: {
																																																								ctor: '::',
																																																								_0: _mdgriffith$style_elements$Style$hover(
																																																									{
																																																										ctor: '::',
																																																										_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$green),
																																																										_1: {ctor: '[]'}
																																																									}),
																																																								_1: {ctor: '[]'}
																																																							}
																																																						}
																																																					}),
																																																				_1: {
																																																					ctor: '::',
																																																					_0: A2(
																																																						_mdgriffith$style_elements$Style$style,
																																																						_user$project$Styles$DocEditBtn,
																																																						{
																																																							ctor: '::',
																																																							_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightYellow),
																																																							_1: {
																																																								ctor: '::',
																																																								_0: _mdgriffith$style_elements$Style_Border$rounded(12),
																																																								_1: {
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style$hover(
																																																										{
																																																											ctor: '::',
																																																											_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$yellow),
																																																											_1: {ctor: '[]'}
																																																										}),
																																																									_1: {ctor: '[]'}
																																																								}
																																																							}
																																																						}),
																																																					_1: {
																																																						ctor: '::',
																																																						_0: A2(
																																																							_mdgriffith$style_elements$Style$style,
																																																							_user$project$Styles$DocDeleteBtn,
																																																							{
																																																								ctor: '::',
																																																								_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightRed),
																																																								_1: {
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style_Border$rounded(12),
																																																									_1: {
																																																										ctor: '::',
																																																										_0: _mdgriffith$style_elements$Style$hover(
																																																											{
																																																												ctor: '::',
																																																												_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$red),
																																																												_1: {ctor: '[]'}
																																																											}),
																																																										_1: {ctor: '[]'}
																																																									}
																																																								}
																																																							}),
																																																						_1: {
																																																							ctor: '::',
																																																							_0: A2(
																																																								_mdgriffith$style_elements$Style$style,
																																																								_user$project$Styles$DocDisabledBtn,
																																																								{
																																																									ctor: '::',
																																																									_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																									_1: {
																																																										ctor: '::',
																																																										_0: _mdgriffith$style_elements$Style_Border$rounded(12),
																																																										_1: {
																																																											ctor: '::',
																																																											_0: _mdgriffith$style_elements$Style$hover(
																																																												{
																																																													ctor: '::',
																																																													_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																													_1: {ctor: '[]'}
																																																												}),
																																																											_1: {ctor: '[]'}
																																																										}
																																																									}
																																																								}),
																																																							_1: {
																																																								ctor: '::',
																																																								_0: A2(
																																																									_mdgriffith$style_elements$Style$style,
																																																									_user$project$Styles$DropDownMenu,
																																																									{
																																																										ctor: '::',
																																																										_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																										_1: {ctor: '[]'}
																																																									}),
																																																								_1: {
																																																									ctor: '::',
																																																									_0: A2(
																																																										_mdgriffith$style_elements$Style$style,
																																																										_user$project$Styles$SubMenu,
																																																										{
																																																											ctor: '::',
																																																											_0: _mdgriffith$style_elements$Style_Border$rounded(5),
																																																											_1: {
																																																												ctor: '::',
																																																												_0: _mdgriffith$style_elements$Style_Border$all(2),
																																																												_1: {
																																																													ctor: '::',
																																																													_0: _mdgriffith$style_elements$Style_Border$solid,
																																																													_1: {
																																																														ctor: '::',
																																																														_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$blue),
																																																														_1: {
																																																															ctor: '::',
																																																															_0: _mdgriffith$style_elements$Style$focus(
																																																																{
																																																																	ctor: '::',
																																																																	_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$blue),
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: A2(_mdgriffith$style_elements$Style$prop, 'outline', 'none'),
																																																																		_1: {ctor: '[]'}
																																																																	}
																																																																}),
																																																															_1: {ctor: '[]'}
																																																														}
																																																													}
																																																												}
																																																											}
																																																										}),
																																																									_1: {
																																																										ctor: '::',
																																																										_0: A2(
																																																											_mdgriffith$style_elements$Style$style,
																																																											_user$project$Styles$ListItem,
																																																											{
																																																												ctor: '::',
																																																												_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$white),
																																																												_1: {
																																																													ctor: '::',
																																																													_0: _mdgriffith$style_elements$Style$hover(
																																																														{
																																																															ctor: '::',
																																																															_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																															_1: {ctor: '[]'}
																																																														}),
																																																													_1: {ctor: '[]'}
																																																												}
																																																											}),
																																																										_1: {
																																																											ctor: '::',
																																																											_0: A2(
																																																												_mdgriffith$style_elements$Style$style,
																																																												_user$project$Styles$Modal,
																																																												{
																																																													ctor: '::',
																																																													_0: _mdgriffith$style_elements$Style_Color$background(_elm_lang$core$Color$lightGrey),
																																																													_1: {
																																																														ctor: '::',
																																																														_0: _mdgriffith$style_elements$Style_Border$all(2),
																																																														_1: {
																																																															ctor: '::',
																																																															_0: _mdgriffith$style_elements$Style_Border$rounded(2),
																																																															_1: {ctor: '[]'}
																																																														}
																																																													}
																																																												}),
																																																											_1: {
																																																												ctor: '::',
																																																												_0: A2(
																																																													_mdgriffith$style_elements$Style$style,
																																																													_user$project$Styles$SecStyle,
																																																													{
																																																														ctor: '::',
																																																														_0: _mdgriffith$style_elements$Style_Border$rounded(4),
																																																														_1: {
																																																															ctor: '::',
																																																															_0: _mdgriffith$style_elements$Style_Border$all(2),
																																																															_1: {
																																																																ctor: '::',
																																																																_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$lightBlue),
																																																																_1: {ctor: '[]'}
																																																															}
																																																														}
																																																													}),
																																																												_1: {
																																																													ctor: '::',
																																																													_0: A2(
																																																														_mdgriffith$style_elements$Style$style,
																																																														_user$project$Styles$FolStyle,
																																																														{
																																																															ctor: '::',
																																																															_0: _mdgriffith$style_elements$Style_Color$background(
																																																																A4(_elm_lang$core$Color$rgba, 84, 144, 187, 1)),
																																																															_1: {
																																																																ctor: '::',
																																																																_0: _mdgriffith$style_elements$Style_Border$all(1),
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$white),
																																																																	_1: {ctor: '[]'}
																																																																}
																																																															}
																																																														}),
																																																													_1: {
																																																														ctor: '::',
																																																														_0: A2(
																																																															_mdgriffith$style_elements$Style$style,
																																																															_user$project$Styles$CarStyle,
																																																															{
																																																																ctor: '::',
																																																																_0: _mdgriffith$style_elements$Style_Color$background(
																																																																	A4(_elm_lang$core$Color$rgba, 164, 193, 224, 1)),
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: _mdgriffith$style_elements$Style_Border$all(1),
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$white),
																																																																		_1: {ctor: '[]'}
																																																																	}
																																																																}
																																																															}),
																																																														_1: {
																																																															ctor: '::',
																																																															_0: A2(
																																																																_mdgriffith$style_elements$Style$style,
																																																																_user$project$Styles$BioStyle,
																																																																{
																																																																	ctor: '::',
																																																																	_0: _mdgriffith$style_elements$Style_Color$background(
																																																																		A4(_elm_lang$core$Color$rgba, 193, 226, 162, 1)),
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: _mdgriffith$style_elements$Style_Border$all(1),
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$white),
																																																																			_1: {ctor: '[]'}
																																																																		}
																																																																	}
																																																																}),
																																																															_1: {
																																																																ctor: '::',
																																																																_0: A2(
																																																																	_mdgriffith$style_elements$Style$style,
																																																																	_user$project$Styles$BorderTop,
																																																																	{
																																																																		ctor: '::',
																																																																		_0: _mdgriffith$style_elements$Style_Border$top(1),
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: _mdgriffith$style_elements$Style_Color$border(_elm_lang$core$Color$darkBlue),
																																																																			_1: {ctor: '[]'}
																																																																		}
																																																																	}),
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: A2(
																																																																		_mdgriffith$style_elements$Style$style,
																																																																		_user$project$Styles$Exemple,
																																																																		{
																																																																			ctor: '::',
																																																																			_0: _mdgriffith$style_elements$Style_Font$italic,
																																																																			_1: {ctor: '[]'}
																																																																		}),
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: _mdgriffith$style_elements$Style_Sheet$merge(
																																																																			A3(
																																																																				_mdgriffith$style_elements$Style_Sheet$map,
																																																																				_user$project$Styles$StyleFromMap,
																																																																				function (_p0) {
																																																																					return _user$project$Styles$NoVariation;
																																																																				},
																																																																				_user$project$Map$stylesList)),
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: _mdgriffith$style_elements$Style_Sheet$merge(
																																																																				A3(_mdgriffith$style_elements$Style_Sheet$map, _user$project$Styles$StylesFromOpsHandler, _user$project$Styles$VariationsFromOpsHandler, _user$project$OpsHandler_Styles$styleList)),
																																																																			_1: {ctor: '[]'}
																																																																		}
																																																																	}
																																																																}
																																																															}
																																																														}
																																																													}
																																																												}
																																																											}
																																																										}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});

var _user$project$Data_Role$toUibit = F2(
	function (lang, role) {
		var _p0 = lang;
		if (_p0.ctor === 'DE') {
			var _p1 = role;
			switch (_p1.ctor) {
				case 'UsersManager':
					return _mdgriffith$style_elements$Element$text('Benutzerverwaltung');
				case 'ContactReader':
					return _mdgriffith$style_elements$Element$text('Baustelle - lesen');
				case 'ContactEditor':
					return _mdgriffith$style_elements$Element$text('Baustelle - lesen');
				case 'Guest':
					return _mdgriffith$style_elements$Element$text('Besucher');
				case 'TreeReader':
					return _mdgriffith$style_elements$Element$text('Baustelle - lesen');
				case 'TreeEditor':
					return _mdgriffith$style_elements$Element$text('Baustelle - bearbeiten');
				default:
					return _mdgriffith$style_elements$Element$text('Baustelle - bearbeiten');
			}
		} else {
			var _p2 = role;
			switch (_p2.ctor) {
				case 'UsersManager':
					return _mdgriffith$style_elements$Element$text('Gestion des utilisateurs');
				case 'ContactReader':
					return _mdgriffith$style_elements$Element$text('Contact - lecture');
				case 'ContactEditor':
					return _mdgriffith$style_elements$Element$text('Contact - édition');
				case 'Guest':
					return _mdgriffith$style_elements$Element$text('Arbre - lecture');
				case 'TreeReader':
					return _mdgriffith$style_elements$Element$text('Arbre - lecture');
				case 'TreeEditor':
					return _mdgriffith$style_elements$Element$text('Arbre - édition');
				default:
					return _mdgriffith$style_elements$Element$text('Arbre - édition locale');
			}
		}
	});
var _user$project$Data_Role$toString = function (role) {
	var _p3 = role;
	switch (_p3.ctor) {
		case 'UsersManager':
			return _elm_lang$core$Maybe$Just('users_manager');
		case 'ContactReader':
			return _elm_lang$core$Maybe$Just('contact_reader');
		case 'ContactEditor':
			return _elm_lang$core$Maybe$Just('contact_editor');
		case 'Guest':
			return _elm_lang$core$Maybe$Just('guest');
		case 'TreeReader':
			return _elm_lang$core$Maybe$Just('tree_reader');
		case 'TreeEditor':
			return _elm_lang$core$Maybe$Just('tree_editor');
		default:
			return _elm_lang$core$Maybe$Just('tree_localeditor');
	}
};
var _user$project$Data_Role$TreeLocalEditor = {ctor: 'TreeLocalEditor'};
var _user$project$Data_Role$TreeEditor = {ctor: 'TreeEditor'};
var _user$project$Data_Role$TreeReader = {ctor: 'TreeReader'};
var _user$project$Data_Role$Guest = {ctor: 'Guest'};
var _user$project$Data_Role$ContactEditor = {ctor: 'ContactEditor'};
var _user$project$Data_Role$ContactReader = {ctor: 'ContactReader'};
var _user$project$Data_Role$UsersManager = {ctor: 'UsersManager'};
var _user$project$Data_Role$allRoleObjs = {
	ctor: '::',
	_0: {ctor: '_Tuple2', _0: _user$project$Data_Role$UsersManager, _1: _user$project$Helpers_Data_User$JustYes},
	_1: {
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: _user$project$Data_Role$ContactReader, _1: _user$project$Helpers_Data_User$JustYes},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: _user$project$Data_Role$ContactEditor, _1: _user$project$Helpers_Data_User$JustYes},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: _user$project$Data_Role$Guest, _1: _user$project$Helpers_Data_User$JustYes},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: _user$project$Data_Role$TreeReader, _1: _user$project$Helpers_Data_User$JustYes},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: _user$project$Data_Role$TreeEditor, _1: _user$project$Helpers_Data_User$JustYes},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: _user$project$Data_Role$TreeLocalEditor, _1: _user$project$Helpers_Data_User$JustYes},
							_1: {ctor: '[]'}
						}
					}
				}
			}
		}
	}
};
var _user$project$Data_Role$stringToRole = function (roleStr) {
	var _p4 = roleStr;
	switch (_p4) {
		case 'users_manager':
			return _elm_lang$core$Maybe$Just(_user$project$Data_Role$UsersManager);
		case 'contact_reader':
			return _elm_lang$core$Maybe$Just(_user$project$Data_Role$ContactReader);
		case 'contact_editor':
			return _elm_lang$core$Maybe$Just(_user$project$Data_Role$ContactEditor);
		case 'guest':
			return _elm_lang$core$Maybe$Just(_user$project$Data_Role$Guest);
		case 'tree_reader':
			return _elm_lang$core$Maybe$Just(_user$project$Data_Role$TreeReader);
		case 'tree_editor':
			return _elm_lang$core$Maybe$Just(_user$project$Data_Role$TreeEditor);
		case 'tree_localeditor':
			return _elm_lang$core$Maybe$Just(_user$project$Data_Role$TreeLocalEditor);
		default:
			return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Data_Role$hasRole = F2(
	function (mayToken, targRole) {
		var isTargRole = function (curRoleObj) {
			return _elm_lang$core$Native_Utils.eq(
				_elm_lang$core$Tuple$first(curRoleObj),
				targRole);
		};
		return A2(
			_elm_lang$core$List$any,
			isTargRole,
			A2(
				_elm_lang$core$Maybe$withDefault,
				{ctor: '[]'},
				_elm_lang$core$Result$toMaybe(
					A2(
						_elm_lang$core$Json_Decode$decodeValue,
						_user$project$Helpers_Data_User$rolesDataDecoder(_user$project$Data_Role$stringToRole),
						_user$project$Helpers_Data_JwtToken$getClaim(mayToken)))));
	});
var _user$project$Data_Role$getRoleGeom = F2(
	function (mayToken, targRole) {
		var getTargRoleValue = function (curRoleObj) {
			if (_elm_lang$core$Native_Utils.eq(
				_elm_lang$core$Tuple$first(curRoleObj),
				targRole)) {
				var _p5 = _elm_lang$core$Tuple$second(curRoleObj);
				if (_p5.ctor === 'Geometry') {
					return _elm_lang$core$Maybe$Just(_p5._0);
				} else {
					return _elm_lang$core$Maybe$Nothing;
				}
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		return A2(
			_elm_lang$core$Maybe$withDefault,
			_elm_lang$core$Maybe$Nothing,
			_elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filterMap,
					getTargRoleValue,
					A2(
						_elm_lang$core$Maybe$withDefault,
						{ctor: '[]'},
						_elm_lang$core$Result$toMaybe(
							A2(
								_elm_lang$core$Json_Decode$decodeValue,
								_user$project$Helpers_Data_User$rolesDataDecoder(_user$project$Data_Role$stringToRole),
								_user$project$Helpers_Data_JwtToken$getClaim(mayToken)))))));
	});

var _user$project$Data_Variety$encoder = function (variety) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'latin_name',
				_1: _elm_lang$core$Json_Encode$string(variety.latinName)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'common_name',
					_1: _elm_lang$core$Json_Encode$string(variety.commonName)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'initial_threshold',
						_1: _elm_lang$core$Json_Encode$int(variety.initialThreshold)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'cantonal_threshold',
							_1: _elm_lang$core$Json_Encode$int(variety.cantonalThreshold)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'federal_threshold',
								_1: _elm_lang$core$Json_Encode$int(variety.federalThreshold)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'final_biodiv_grade',
									_1: _elm_lang$core$Json_Encode$int(variety.finalBiodivGrade)
								},
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
};
var _user$project$Data_Variety$Variety = F7(
	function (a, b, c, d, e, f, g) {
		return {id: a, latinName: b, commonName: c, initialThreshold: d, cantonalThreshold: e, federalThreshold: f, finalBiodivGrade: g};
	});
var _user$project$Data_Variety$decoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					A2(
						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
						A2(
							_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
							_elm_lang$core$Json_Decode$succeed(_user$project$Data_Variety$Variety),
							A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int)),
						A2(_elm_lang$core$Json_Decode$field, 'latin_name', _elm_lang$core$Json_Decode$string)),
					A2(_elm_lang$core$Json_Decode$field, 'common_name', _elm_lang$core$Json_Decode$string)),
				A2(_elm_lang$core$Json_Decode$field, 'initial_threshold', _elm_lang$core$Json_Decode$int)),
			A2(_elm_lang$core$Json_Decode$field, 'cantonal_threshold', _elm_lang$core$Json_Decode$int)),
		A2(_elm_lang$core$Json_Decode$field, 'federal_threshold', _elm_lang$core$Json_Decode$int)),
	A2(_elm_lang$core$Json_Decode$field, 'final_biodiv_grade', _elm_lang$core$Json_Decode$int));

var _user$project$OpsHandler_OpOutMsg$DoneManual = {ctor: 'DoneManual'};
var _user$project$OpsHandler_OpOutMsg$DoneAuto = {ctor: 'DoneAuto'};
var _user$project$OpsHandler_OpOutMsg$InProgress = {ctor: 'InProgress'};
var _user$project$OpsHandler_OpOutMsg$OpStateChanged = function (a) {
	return {ctor: 'OpStateChanged', _0: a};
};
var _user$project$OpsHandler_OpOutMsg$NoOpOutMsg = {ctor: 'NoOpOutMsg'};

var _user$project$OpsHandler_Ops_Map_CaptureOp$dimensionEncoder = function (dimension) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'height',
				_1: _elm_lang$core$Json_Encode$int(dimension.height)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'width',
					_1: _elm_lang$core$Json_Encode$int(dimension.width)
				},
				_1: {ctor: '[]'}
			}
		});
};
var _user$project$OpsHandler_Ops_Map_CaptureOp$encoder = function (model) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'image',
				_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, model.image)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'canvasDimensions',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$OpsHandler_Ops_Map_CaptureOp$dimensionEncoder, model.canvasDimensions)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'error',
						_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, model.error)
					},
					_1: {ctor: '[]'}
				}
			}
		});
};
var _user$project$OpsHandler_Ops_Map_CaptureOp$update = F2(
	function (msg, model) {
		var _p0 = msg;
		var _p1 = _p0._0;
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				model,
				{image: _p1.image, canvasDimensions: _p1.canvasDimensions, error: _p1.error}),
			_1: _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneAuto)
		};
	});
var _user$project$OpsHandler_Ops_Map_CaptureOp$Model = F3(
	function (a, b, c) {
		return {image: a, canvasDimensions: b, error: c};
	});
var _user$project$OpsHandler_Ops_Map_CaptureOp$Dimension = F2(
	function (a, b) {
		return {height: a, width: b};
	});
var _user$project$OpsHandler_Ops_Map_CaptureOp$OnCaptureCanvasEnded = function (a) {
	return {ctor: 'OnCaptureCanvasEnded', _0: a};
};
var _user$project$OpsHandler_Ops_Map_CaptureOp$init = F2(
	function (toMapMsg, toMsg) {
		var registerCallbackAction = _user$project$Action$sendMsg(
			toMapMsg(
				_user$project$Map_Data_Msg$RegisterCallbackOnCaptureCanvasEnded(
					function (_p2) {
						return toMsg(
							_user$project$OpsHandler_Ops_Map_CaptureOp$OnCaptureCanvasEnded(_p2));
					})));
		var startSelectAction = _user$project$Action$sendMsg(
			toMapMsg(_user$project$Map_Data_Msg$StartCaptureCanvasMode));
		return {
			ctor: '_Tuple2',
			_0: {image: _elm_lang$core$Maybe$Nothing, canvasDimensions: _elm_lang$core$Maybe$Nothing, error: _elm_lang$core$Maybe$Nothing},
			_1: _user$project$Action$batch(
				{
					ctor: '::',
					_0: startSelectAction,
					_1: {
						ctor: '::',
						_0: registerCallbackAction,
						_1: {ctor: '[]'}
					}
				})
		};
	});

var _user$project$Data_Tree$exportDataEncoder = function (exportData) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'isolatedTree', _1: exportData.isolatedTree},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'mapCaptureModel',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _user$project$OpsHandler_Ops_Map_CaptureOp$encoder, exportData.mapCaptureModel)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'image',
						_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, exportData.image)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'points',
							_1: _elm_lang$core$Json_Encode$int(exportData.points)
						},
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _user$project$Data_Tree$encoder = F2(
	function (isForExport, isolatedTree) {
		var baseEncodeList = {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'name',
				_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.name)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'collection_date',
					_1: _elm_lang$core$Json_Encode$string(
						_justinmimbs$elm_date_extra$Date_Extra$toIsoString(isolatedTree.collectionDate))
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'commune',
						_1: _elm_lang$core$Json_Encode$string(isolatedTree.commune)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'plot_nb',
							_1: _elm_lang$core$Json_Encode$string(isolatedTree.plotNb)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'variety_id',
								_1: _elm_lang$core$Json_Encode$int(isolatedTree.variety.id)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'circumference',
									_1: _elm_lang$core$Json_Encode$float(isolatedTree.circumference)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'crown_development',
										_1: _elm_lang$core$Json_Encode$string(isolatedTree.crownDevelopment)
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'year_of_planting',
											_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$int, isolatedTree.yearOfPlanting)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'has_socio_historical_interest',
												_1: _elm_lang$core$Json_Encode$bool(isolatedTree.hasSocioHistoricalInterest)
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'socio_historical_interest',
													_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.socioHistoricalInterest)
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'has_landscape_interest',
														_1: _elm_lang$core$Json_Encode$bool(isolatedTree.hasLandscapeInterest)
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'is_mentioned',
															_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isMentioned)
														},
														_1: {
															ctor: '::',
															_0: {
																ctor: '_Tuple2',
																_0: 'ecosystem_situation',
																_1: _elm_lang$core$Json_Encode$string(isolatedTree.ecosystemSituation)
															},
															_1: {
																ctor: '::',
																_0: {
																	ctor: '_Tuple2',
																	_0: 'is_of_regional_importance',
																	_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isOfRegionalImportance)
																},
																_1: {
																	ctor: '::',
																	_0: {
																		ctor: '_Tuple2',
																		_0: 'comments',
																		_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.comments)
																	},
																	_1: {
																		ctor: '::',
																		_0: {
																			ctor: '_Tuple2',
																			_0: 'is_ranked',
																			_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$bool, isolatedTree.isRanked)
																		},
																		_1: {
																			ctor: '::',
																			_0: {
																				ctor: '_Tuple2',
																				_0: 'justification_of_ranking',
																				_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.justificationOfRanking)
																			},
																			_1: {
																				ctor: '::',
																				_0: {
																					ctor: '_Tuple2',
																					_0: 'documents',
																					_1: _elm_lang$core$Json_Encode$list(
																						A2(_elm_lang$core$List$map, _user$project$Data_Document$docEncode, isolatedTree.documents))
																				},
																				_1: {
																					ctor: '::',
																					_0: {
																						ctor: '_Tuple2',
																						_0: 'moderator_id',
																						_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$int, isolatedTree.moderatorId)
																					},
																					_1: {
																						ctor: '::',
																						_0: {
																							ctor: '_Tuple2',
																							_0: 'is_multi_trunk',
																							_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isMultiTrunk)
																						},
																						_1: {
																							ctor: '::',
																							_0: {
																								ctor: '_Tuple2',
																								_0: 'is_variety_certain',
																								_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isVarietyCertain)
																							},
																							_1: {
																								ctor: '::',
																								_0: {
																									ctor: '_Tuple2',
																									_0: 'is_more_than_100_years',
																									_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$bool, isolatedTree.isMoreThan100Years)
																								},
																								_1: {
																									ctor: '::',
																									_0: {
																										ctor: '_Tuple2',
																										_0: 'is_part_of_a_group',
																										_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isPartOfAGroup)
																									},
																									_1: {
																										ctor: '::',
																										_0: {
																											ctor: '_Tuple2',
																											_0: 'is_candidate',
																											_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isCandidate)
																										},
																										_1: {
																											ctor: '::',
																											_0: {
																												ctor: '_Tuple2',
																												_0: 'candidacy_comment',
																												_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.candidacyComment)
																											},
																											_1: {
																												ctor: '::',
																												_0: {
																													ctor: '_Tuple2',
																													_0: 'is_of_local_interest',
																													_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isOfLocalInterest)
																												},
																												_1: {
																													ctor: '::',
																													_0: {ctor: '_Tuple2', _0: 'geometry', _1: isolatedTree.geometry},
																													_1: {
																														ctor: '::',
																														_0: {
																															ctor: '_Tuple2',
																															_0: 'created_by',
																															_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.createdBy)
																														},
																														_1: {
																															ctor: '::',
																															_0: {
																																ctor: '_Tuple2',
																																_0: 'updated_by',
																																_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.updatedBy)
																															},
																															_1: {ctor: '[]'}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		};
		var finalEncodeList = isForExport ? A2(
			_elm_lang$core$List$append,
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'variety',
					_1: _user$project$Data_Variety$encoder(isolatedTree.variety)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'total_score',
						_1: _elm_lang$core$Json_Encode$int(isolatedTree.totalScore)
					},
					_1: {ctor: '[]'}
				}
			},
			baseEncodeList) : baseEncodeList;
		return _elm_lang$core$Json_Encode$object(finalEncodeList);
	});
var _user$project$Data_Tree$decodeDocuments = A2(
	_elm_lang$core$Json_Decode$field,
	'documents',
	_elm_lang$core$Json_Decode$list(_user$project$Data_Document$docDecoder));
var _user$project$Data_Tree$idDecoder = _elm_lang$core$Json_Decode$maybe(
	A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int));
var _user$project$Data_Tree$decodeAtProperties = F2(
	function (field, decoder) {
		return A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'properties',
				_1: {
					ctor: '::',
					_0: field,
					_1: {ctor: '[]'}
				}
			},
			decoder);
	});
var _user$project$Data_Tree$getEcologicalInterest = function (variety) {
	var _p0 = variety.finalBiodivGrade;
	switch (_p0) {
		case 5:
			return {ctor: '_Tuple2', _0: 5, _1: 'Très élevé'};
		case 4:
			return {ctor: '_Tuple2', _0: 4, _1: 'Elevé'};
		case 3:
			return {ctor: '_Tuple2', _0: 3, _1: 'Plutôt élevé'};
		case 2:
			return {ctor: '_Tuple2', _0: 2, _1: 'Moyen'};
		case 1:
			return {ctor: '_Tuple2', _0: 1, _1: 'Faible'};
		case 0:
			return {ctor: '_Tuple2', _0: 0, _1: 'Très faible'};
		default:
			return {ctor: '_Tuple2', _0: 0, _1: ''};
	}
};
var _user$project$Data_Tree$eventOptions = {
	ctor: '::',
	_0: 'data_event_eventype_worksite',
	_1: {
		ctor: '::',
		_0: 'data_event_eventtype_woodwound',
		_1: {
			ctor: '::',
			_0: 'data_event_eventtype_reductionofrootvolume',
			_1: {
				ctor: '::',
				_0: 'data_event_eventtype_fire',
				_1: {
					ctor: '::',
					_0: 'data_event_eventtype_mutilatingpruning',
					_1: {
						ctor: '::',
						_0: 'data_event_eventtype_pathogenagent',
						_1: {
							ctor: '::',
							_0: 'data_event_eventtype_meteorologicalevent',
							_1: {
								ctor: '::',
								_0: 'data_event_eventtype_trafficaccident',
								_1: {
									ctor: '::',
									_0: 'data_event_eventtype_materialdeposit',
									_1: {
										ctor: '::',
										_0: 'data_event_eventtype_soilcompaction',
										_1: {
											ctor: '::',
											_0: 'data_event_eventtype_soilwaterproofing',
											_1: {
												ctor: '::',
												_0: 'data_event_eventtype_poisoning',
												_1: {
													ctor: '::',
													_0: 'data_event_eventtype_illegalfelling',
													_1: {
														ctor: '::',
														_0: 'data_event_eventtype_naturaldeath',
														_1: {
															ctor: '::',
															_0: 'data_event_eventtype_pastlegalfelling',
															_1: {
																ctor: '::',
																_0: 'data_event_eventtype_disappearance',
																_1: {
																	ctor: '::',
																	_0: 'data_event_eventtype_other',
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _user$project$Data_Tree$socioHistoricalInterestOptions = {
	ctor: '::',
	_0: 'data_isolatedTree_sociohisto_anniversary',
	_1: {
		ctor: '::',
		_0: 'data_isolatedTree_sociohisto_commemoration',
		_1: {
			ctor: '::',
			_0: 'data_isolatedTree_sociohisto_inauguration',
			_1: {
				ctor: '::',
				_0: 'data_isolatedTree_sociohisto_historicalevent',
				_1: {
					ctor: '::',
					_0: 'data_isolatedTree_sociohisto_ceremonial',
					_1: {
						ctor: '::',
						_0: 'data_isolatedTree_sociohisto_historicalbuilding',
						_1: {
							ctor: '::',
							_0: 'data_isolatedTree_sociohisto_cemetery',
							_1: {
								ctor: '::',
								_0: 'data_isolatedTree_sociohisto_landmark',
								_1: {
									ctor: '::',
									_0: 'data_isolatedTree_sociohisto_heritage',
									_1: {
										ctor: '::',
										_0: 'data_isolatedTree_sociohisto_meetingplace',
										_1: {
											ctor: '::',
											_0: 'data_isolatedTree_sociohisto_other',
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _user$project$Data_Tree$ecosystemSituationOptions = {
	ctor: '::',
	_0: 'data_isolatedTree_ecosystemSituation_built_up_area',
	_1: {
		ctor: '::',
		_0: 'data_isolatedTree_ecosystemSituation_green_area',
		_1: {
			ctor: '::',
			_0: 'data_isolatedTree_ecosystemSituation_agricultural_area',
			_1: {ctor: '[]'}
		}
	}
};
var _user$project$Data_Tree$crownDevelopmentOptions = {
	ctor: '::',
	_0: 'data_isolatedTree_crownDevelopment_exceptional',
	_1: {
		ctor: '::',
		_0: 'data_isolatedTree_crownDevelopment_typical',
		_1: {
			ctor: '::',
			_0: 'data_isolatedTree_crownDevelopment_no_aesthetic_interest',
			_1: {
				ctor: '::',
				_0: 'data_isolatedTree_crownDevelopment_distorted',
				_1: {ctor: '[]'}
			}
		}
	}
};
var _user$project$Data_Tree$epsg = '2056';
var _user$project$Data_Tree$fileServiceUrl = './tree-filesservice/';
var _user$project$Data_Tree$IsolatedTree = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return function (_4) {
																														return function (_5) {
																															return function (_6) {
																																return function (_7) {
																																	return {id: a, name: b, collectionDate: c, commune: d, plotNb: e, variety: f, circumference: g, crownDevelopment: h, yearOfPlanting: i, hasSocioHistoricalInterest: j, socioHistoricalInterest: k, hasLandscapeInterest: l, isMentioned: m, ecosystemSituation: n, isOfRegionalImportance: o, comments: p, isRanked: q, justificationOfRanking: r, documents: s, moderatorId: t, isMultiTrunk: u, isVarietyCertain: v, isMoreThan100Years: w, isPartOfAGroup: x, isCandidate: y, candidacyComment: z, isOfLocalInterest: _1, totalScore: _2, geometry: _3, createdBy: _4, updatedBy: _5, createdAt: _6, updatedAt: _7};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Data_Tree$decoder = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					A2(
						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
						A2(
							_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
							A2(
								_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
								A2(
									_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
									A2(
										_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
										A2(
											_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
											A2(
												_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
												A2(
													_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
													A2(
														_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
														A2(
															_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
															A2(
																_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																A2(
																	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																	A2(
																		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																		A2(
																			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																			A2(
																				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																				A2(
																					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																					A2(
																						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																						A2(
																							_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																							A2(
																								_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																								A2(
																									_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																									A2(
																										_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																										A2(
																											_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																											A2(
																												_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																												A2(
																													_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																													A2(
																														_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																														A2(
																															_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																															A2(
																																_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																																A2(
																																	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
																																	_elm_lang$core$Json_Decode$succeed(_user$project$Data_Tree$IsolatedTree),
																																	_elm_lang$core$Json_Decode$maybe(
																																		A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int))),
																																_elm_lang$core$Json_Decode$maybe(
																																	A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string))),
																															A2(
																																_elm_lang$core$Json_Decode$andThen,
																																function (_p1) {
																																	return _elm_community$json_extra$Json_Decode_Extra$fromResult(
																																		_elm_lang$core$Date$fromString(_p1));
																																},
																																A2(_elm_lang$core$Json_Decode$field, 'collection_date', _elm_lang$core$Json_Decode$string))),
																														A2(_elm_lang$core$Json_Decode$field, 'commune', _elm_lang$core$Json_Decode$string)),
																													A2(_elm_lang$core$Json_Decode$field, 'plot_nb', _elm_lang$core$Json_Decode$string)),
																												A2(_elm_lang$core$Json_Decode$field, 'variety', _user$project$Data_Variety$decoder)),
																											A2(_elm_lang$core$Json_Decode$field, 'circumference', _elm_lang$core$Json_Decode$float)),
																										A2(_elm_lang$core$Json_Decode$field, 'crown_development', _elm_lang$core$Json_Decode$string)),
																									_elm_lang$core$Json_Decode$maybe(
																										A2(_elm_lang$core$Json_Decode$field, 'year_of_planting', _elm_lang$core$Json_Decode$int))),
																								A2(_elm_lang$core$Json_Decode$field, 'has_socio_historical_interest', _elm_lang$core$Json_Decode$bool)),
																							_elm_lang$core$Json_Decode$maybe(
																								A2(_elm_lang$core$Json_Decode$field, 'socio_historical_interest', _elm_lang$core$Json_Decode$string))),
																						A2(_elm_lang$core$Json_Decode$field, 'has_landscape_interest', _elm_lang$core$Json_Decode$bool)),
																					A2(_elm_lang$core$Json_Decode$field, 'is_mentioned', _elm_lang$core$Json_Decode$bool)),
																				A2(_elm_lang$core$Json_Decode$field, 'ecosystem_situation', _elm_lang$core$Json_Decode$string)),
																			A2(_elm_lang$core$Json_Decode$field, 'is_of_regional_importance', _elm_lang$core$Json_Decode$bool)),
																		_elm_lang$core$Json_Decode$maybe(
																			A2(_elm_lang$core$Json_Decode$field, 'comments', _elm_lang$core$Json_Decode$string))),
																	_elm_lang$core$Json_Decode$maybe(
																		A2(_elm_lang$core$Json_Decode$field, 'is_ranked', _elm_lang$core$Json_Decode$bool))),
																_elm_lang$core$Json_Decode$maybe(
																	A2(_elm_lang$core$Json_Decode$field, 'justification_of_ranking', _elm_lang$core$Json_Decode$string))),
															A2(
																_elm_lang$core$Json_Decode$field,
																'documents',
																_elm_lang$core$Json_Decode$list(_user$project$Data_Document$docDecoder))),
														_elm_lang$core$Json_Decode$maybe(
															A2(_elm_lang$core$Json_Decode$field, 'moderator_id', _elm_lang$core$Json_Decode$int))),
													A2(_elm_lang$core$Json_Decode$field, 'is_multi_trunk', _elm_lang$core$Json_Decode$bool)),
												A2(_elm_lang$core$Json_Decode$field, 'is_variety_certain', _elm_lang$core$Json_Decode$bool)),
											_elm_lang$core$Json_Decode$maybe(
												A2(_elm_lang$core$Json_Decode$field, 'is_more_than_100_years', _elm_lang$core$Json_Decode$bool))),
										A2(_elm_lang$core$Json_Decode$field, 'is_part_of_a_group', _elm_lang$core$Json_Decode$bool)),
									A2(_elm_lang$core$Json_Decode$field, 'is_candidate', _elm_lang$core$Json_Decode$bool)),
								_elm_lang$core$Json_Decode$maybe(
									A2(_elm_lang$core$Json_Decode$field, 'candidacy_comment', _elm_lang$core$Json_Decode$string))),
							A2(_elm_lang$core$Json_Decode$field, 'is_of_local_interest', _elm_lang$core$Json_Decode$bool)),
						A2(_elm_lang$core$Json_Decode$field, 'total_score', _elm_lang$core$Json_Decode$int)),
					A2(_elm_lang$core$Json_Decode$field, 'geometry', _elm_lang$core$Json_Decode$value)),
				_elm_lang$core$Json_Decode$maybe(
					A2(_elm_lang$core$Json_Decode$field, 'created_by', _elm_lang$core$Json_Decode$string))),
			_elm_lang$core$Json_Decode$maybe(
				A2(_elm_lang$core$Json_Decode$field, 'updated_by', _elm_lang$core$Json_Decode$string))),
		_elm_lang$core$Json_Decode$maybe(
			A2(
				_elm_lang$core$Json_Decode$andThen,
				function (_p2) {
					return _elm_community$json_extra$Json_Decode_Extra$fromResult(
						_elm_lang$core$Date$fromString(_p2));
				},
				A2(_elm_lang$core$Json_Decode$field, 'created_at', _elm_lang$core$Json_Decode$string)))),
	_elm_lang$core$Json_Decode$maybe(
		A2(
			_elm_lang$core$Json_Decode$andThen,
			function (_p3) {
				return _elm_community$json_extra$Json_Decode_Extra$fromResult(
					_elm_lang$core$Date$fromString(_p3));
			},
			A2(_elm_lang$core$Json_Decode$field, 'updated_at', _elm_lang$core$Json_Decode$string))));
var _user$project$Data_Tree$IsolatedTreeForm = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return function (_4) {
																														return function (_5) {
																															return function (_6) {
																																return function (_7) {
																																	return function (_8) {
																																		return function (_9) {
																																			return {id: a, name: b, collectionDate: c, commune: d, plotNb: e, variety: f, isVarietyCertain: g, circumference: h, isMultiTrunk: i, crownDevelopment: j, isyearOfPlantingKnown: k, yearOfPlanting: l, isMoreThan100Years: m, age: n, hasSocioHistoricalInterest: o, socioHistoricalInterest: p, hasLandscapeInterest: q, ecosystemSituation: r, isMentioned: s, isOfRegionalImportance: t, comments: u, documents: v, isRanked: w, justificationOfRanking: x, isPartOfAGroup: y, isCandidate: z, candidacyComment: _1, isOfLocalInterest: _2, totalScore: _3, moderator: _4, geometry: _5, createdBy: _6, updatedBy: _7, createdAt: _8, updatedAt: _9};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Data_Tree$AttributesScore = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {circumferenceScore: a, multitrunkScore: b, crownDevelopmentScore: c, ageScore: d, ecologicalInterestScore: e, socioHistoricalInterestScore: f, landscapeInterestScore: g, ecosystemSituationScore: h, totalScore: i};
	});
var _user$project$Data_Tree$decoderAttributesScore = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					A2(
						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
						A2(
							_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
							A2(
								_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
								A2(
									_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
									_elm_lang$core$Json_Decode$succeed(_user$project$Data_Tree$AttributesScore),
									A2(_elm_lang$core$Json_Decode$field, 'circumference_score', _elm_lang$core$Json_Decode$int)),
								A2(_elm_lang$core$Json_Decode$field, 'multitrunk_score', _elm_lang$core$Json_Decode$int)),
							A2(_elm_lang$core$Json_Decode$field, 'crown_development_score', _elm_lang$core$Json_Decode$int)),
						A2(_elm_lang$core$Json_Decode$field, 'age_score', _elm_lang$core$Json_Decode$int)),
					A2(_elm_lang$core$Json_Decode$field, 'ecological_interest_score', _elm_lang$core$Json_Decode$int)),
				A2(_elm_lang$core$Json_Decode$field, 'socio_historical_interest_score', _elm_lang$core$Json_Decode$int)),
			A2(_elm_lang$core$Json_Decode$field, 'landscape_interest_score', _elm_lang$core$Json_Decode$int)),
		A2(_elm_lang$core$Json_Decode$field, 'ecosystem_situation_score', _elm_lang$core$Json_Decode$int)),
	A2(_elm_lang$core$Json_Decode$field, 'total_score', _elm_lang$core$Json_Decode$int));
var _user$project$Data_Tree$ExportData = F4(
	function (a, b, c, d) {
		return {isolatedTree: a, mapCaptureModel: b, image: c, points: d};
	});
var _user$project$Data_Tree$CandidateNo = {ctor: 'CandidateNo'};
var _user$project$Data_Tree$CandidateYes = {ctor: 'CandidateYes'};
var _user$project$Data_Tree$CandidateAll = {ctor: 'CandidateAll'};
var _user$project$Data_Tree$EventNone = {ctor: 'EventNone'};
var _user$project$Data_Tree$EventOther = {ctor: 'EventOther'};
var _user$project$Data_Tree$Disappearance = {ctor: 'Disappearance'};
var _user$project$Data_Tree$Pastlegalfelling = {ctor: 'Pastlegalfelling'};
var _user$project$Data_Tree$Naturaldeath = {ctor: 'Naturaldeath'};
var _user$project$Data_Tree$Illegalfelling = {ctor: 'Illegalfelling'};
var _user$project$Data_Tree$Poisoning = {ctor: 'Poisoning'};
var _user$project$Data_Tree$Soilwaterproofing = {ctor: 'Soilwaterproofing'};
var _user$project$Data_Tree$Soilcompaction = {ctor: 'Soilcompaction'};
var _user$project$Data_Tree$Waterialdeposit = {ctor: 'Waterialdeposit'};
var _user$project$Data_Tree$Trafficaccident = {ctor: 'Trafficaccident'};
var _user$project$Data_Tree$Meteorologicalevent = {ctor: 'Meteorologicalevent'};
var _user$project$Data_Tree$Pathogenagent = {ctor: 'Pathogenagent'};
var _user$project$Data_Tree$Mutilatingpruning = {ctor: 'Mutilatingpruning'};
var _user$project$Data_Tree$Fire = {ctor: 'Fire'};
var _user$project$Data_Tree$Reductionofrootvolume = {ctor: 'Reductionofrootvolume'};
var _user$project$Data_Tree$Woodwound = {ctor: 'Woodwound'};
var _user$project$Data_Tree$Worksite = {ctor: 'Worksite'};
var _user$project$Data_Tree$eventTypeFilterList = {
	ctor: '::',
	_0: _user$project$Data_Tree$Worksite,
	_1: {
		ctor: '::',
		_0: _user$project$Data_Tree$Woodwound,
		_1: {
			ctor: '::',
			_0: _user$project$Data_Tree$Reductionofrootvolume,
			_1: {
				ctor: '::',
				_0: _user$project$Data_Tree$Fire,
				_1: {
					ctor: '::',
					_0: _user$project$Data_Tree$Mutilatingpruning,
					_1: {
						ctor: '::',
						_0: _user$project$Data_Tree$Pathogenagent,
						_1: {
							ctor: '::',
							_0: _user$project$Data_Tree$Meteorologicalevent,
							_1: {
								ctor: '::',
								_0: _user$project$Data_Tree$Trafficaccident,
								_1: {
									ctor: '::',
									_0: _user$project$Data_Tree$Waterialdeposit,
									_1: {
										ctor: '::',
										_0: _user$project$Data_Tree$Soilcompaction,
										_1: {
											ctor: '::',
											_0: _user$project$Data_Tree$Soilwaterproofing,
											_1: {
												ctor: '::',
												_0: _user$project$Data_Tree$Poisoning,
												_1: {
													ctor: '::',
													_0: _user$project$Data_Tree$Illegalfelling,
													_1: {
														ctor: '::',
														_0: _user$project$Data_Tree$Naturaldeath,
														_1: {
															ctor: '::',
															_0: _user$project$Data_Tree$Pastlegalfelling,
															_1: {
																ctor: '::',
																_0: _user$project$Data_Tree$Disappearance,
																_1: {
																	ctor: '::',
																	_0: _user$project$Data_Tree$EventOther,
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _user$project$Data_Tree$EventAll = {ctor: 'EventAll'};

var _user$project$OpsHandler_Ports$exportPDFfromHtml = _elm_lang$core$Native_Platform.outgoingPort(
	'exportPDFfromHtml',
	function (v) {
		return v;
	});
var _user$project$OpsHandler_Ports$invokeJS = _elm_lang$core$Native_Platform.outgoingPort(
	'invokeJS',
	function (v) {
		return {funcName: v.funcName, initData: v.initData};
	});
var _user$project$OpsHandler_Ports$inboundInvokeJSDone = _elm_lang$core$Native_Platform.incomingPort(
	'inboundInvokeJSDone',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (err) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (value) {
					return _elm_lang$core$Json_Decode$succeed(
						{err: err, value: value});
				},
				A2(_elm_lang$core$Json_Decode$field, 'value', _elm_lang$core$Json_Decode$value));
		},
		A2(
			_elm_lang$core$Json_Decode$field,
			'err',
			_elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
						_1: {ctor: '[]'}
					}
				}))));

var _user$project$OpsHandler$viewCenteredModal = F2(
	function (toStyles, content) {
		return A3(
			_mdgriffith$style_elements$Element$modal,
			toStyles(_user$project$OpsHandler_Styles$NoStyle),
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				}
			},
			A3(
				_mdgriffith$style_elements$Element$row,
				toStyles(_user$project$OpsHandler_Styles$Background),
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$center,
								_1: {ctor: '[]'}
							}
						}
					}
				},
				{
					ctor: '::',
					_0: content,
					_1: {ctor: '[]'}
				}));
	});
var _user$project$OpsHandler$intEndedOpsToEndedOps = function (intEndedOps) {
	return A2(
		_elm_lang$core$List$map,
		function (_p0) {
			var _p1 = _p0;
			return {ctor: '_Tuple2', _0: _p1._0._1, _1: _p1._0._0};
		},
		intEndedOps);
};
var _user$project$OpsHandler$restartOpsAsTheyWere = F5(
	function (manageOpInits, opInitData, endedOps, expOpKey, _p2) {
		return A3(manageOpInits, opInitData, endedOps, expOpKey);
	});
var _user$project$OpsHandler$getEndedOpsByOpKey = F2(
	function (opKey, endedOps) {
		return A2(
			_elm_lang$core$List$map,
			function (_p3) {
				var _p4 = _p3;
				return _p4._1;
			},
			A2(
				_elm_lang$core$List$filter,
				function (_p5) {
					var _p6 = _p5;
					return _elm_lang$core$Native_Utils.eq(_p6._0, opKey);
				},
				endedOps));
	});
var _user$project$OpsHandler$getWrapperElementId = 'exported';
var _user$project$OpsHandler$Model = F2(
	function (a, b) {
		return {progress: a, isNextDisabled: b};
	});
var _user$project$OpsHandler$IdentifyNextOpData = F2(
	function (a, b) {
		return {endedOps: a, currentOpKey: b};
	});
var _user$project$OpsHandler$UpdateConfig = F4(
	function (a, b, c, d) {
		return {identifyNextOp: a, manageOpInits: b, manageOpRestarts: c, manageOpUpdates: d};
	});
var _user$project$OpsHandler$PreDefined = {ctor: 'PreDefined'};
var _user$project$OpsHandler$Auto = {ctor: 'Auto'};
var _user$project$OpsHandler$Manual = {ctor: 'Manual'};
var _user$project$OpsHandler$ProcessEnded = {ctor: 'ProcessEnded'};
var _user$project$OpsHandler$AdvancingOps = F2(
	function (a, b) {
		return {ctor: 'AdvancingOps', _0: a, _1: b};
	});
var _user$project$OpsHandler$Operation = F2(
	function (a, b) {
		return {ctor: 'Operation', _0: a, _1: b};
	});
var _user$project$OpsHandler$endedOpsToIntEndedOps = function (endedOps) {
	return A2(
		_elm_lang$core$List$map,
		function (_p7) {
			var _p8 = _p7;
			return {
				ctor: '_Tuple2',
				_0: A2(_user$project$OpsHandler$Operation, _p8._1, _p8._0),
				_1: _user$project$OpsHandler$PreDefined
			};
		},
		endedOps);
};
var _user$project$OpsHandler$InstructionView = F2(
	function (a, b) {
		return {ctor: 'InstructionView', _0: a, _1: b};
	});
var _user$project$OpsHandler$WizardView = function (a) {
	return {ctor: 'WizardView', _0: a};
};
var _user$project$OpsHandler$ExportingViewState = function (a) {
	return {ctor: 'ExportingViewState', _0: a};
};
var _user$project$OpsHandler$NextAndPreviousState = F2(
	function (a, b) {
		return {ctor: 'NextAndPreviousState', _0: a, _1: b};
	});
var _user$project$OpsHandler$CustomFormat = function (a) {
	return {ctor: 'CustomFormat', _0: a};
};
var _user$project$OpsHandler$HtmlFormat = function (a) {
	return {ctor: 'HtmlFormat', _0: a};
};
var _user$project$OpsHandler$DoneClicked = {ctor: 'DoneClicked'};
var _user$project$OpsHandler$CancelClicked = {ctor: 'CancelClicked'};
var _user$project$OpsHandler$PreviousClicked = {ctor: 'PreviousClicked'};
var _user$project$OpsHandler$NextClicked = function (a) {
	return {ctor: 'NextClicked', _0: a};
};
var _user$project$OpsHandler$viewButtons = F5(
	function (toMsg, toStyles, toVariations, isPreviousDisabled, isNextDisabled) {
		var nextClickAttribute = function () {
			var _p9 = isNextDisabled;
			if (_p9 === false) {
				return {ctor: '[]'};
			} else {
				return {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'disabled', ''),
					_1: {ctor: '[]'}
				};
			}
		}();
		var previousClickAttribute = function () {
			var _p10 = isPreviousDisabled;
			if (_p10 === false) {
				return {ctor: '[]'};
			} else {
				return {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$attribute, 'disabled', ''),
					_1: {ctor: '[]'}
				};
			}
		}();
		return {
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$button,
				toStyles(_user$project$OpsHandler_Styles$Btn),
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(
						_mdgriffith$style_elements$Element_Attributes$px(100)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								toMsg(_user$project$OpsHandler$CancelClicked)),
							_1: {ctor: '[]'}
						}
					}
				},
				_mdgriffith$style_elements$Element$text('Annuler')),
			_1: {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					toStyles(_user$project$OpsHandler_Styles$Btn),
					A2(
						_elm_lang$core$List$append,
						previousClickAttribute,
						{
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element_Attributes$vary,
								toVariations(_user$project$OpsHandler_Styles$Disabled),
								isPreviousDisabled),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(100)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Events$onClick(
											toMsg(_user$project$OpsHandler$PreviousClicked)),
										_1: {ctor: '[]'}
									}
								}
							}
						}),
					_mdgriffith$style_elements$Element$text('Précédent')),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$button,
						toStyles(_user$project$OpsHandler_Styles$Btn),
						A2(
							_elm_lang$core$List$append,
							nextClickAttribute,
							{
								ctor: '::',
								_0: A2(
									_mdgriffith$style_elements$Element_Attributes$vary,
									toVariations(_user$project$OpsHandler_Styles$Disabled),
									isNextDisabled),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$px(100)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Events$onClick(
												toMsg(
													_user$project$OpsHandler$NextClicked(_user$project$OpsHandler$Manual))),
											_1: {ctor: '[]'}
										}
									}
								}
							}),
						_mdgriffith$style_elements$Element$text('Suivant')),
					_1: {ctor: '[]'}
				}
			}
		};
	});
var _user$project$OpsHandler$viewMaximized = F6(
	function (toMsg, toStyles, toVariations, content, mayExporationView, viewState) {
		var buttons = function () {
			var _p11 = viewState;
			if (_p11.ctor === 'NextAndPreviousState') {
				return A5(_user$project$OpsHandler$viewButtons, toMsg, toStyles, toVariations, _p11._0, _p11._1);
			} else {
				var _p12 = mayExporationView;
				if (_p12.ctor === 'Nothing') {
					return {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element$empty,
						_1: {ctor: '[]'}
					};
				} else {
					return {
						ctor: '::',
						_0: _p12._0,
						_1: {ctor: '[]'}
					};
				}
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$column,
			toStyles(_user$project$OpsHandler_Styles$OpsHandler),
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(
					_mdgriffith$style_elements$Element_Attributes$px(500)),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$padding(20),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					toStyles(_user$project$OpsHandler_Styles$MainTitle),
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text('Export PDF')),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						toStyles(_user$project$OpsHandler_Styles$NoStyle),
						{ctor: '[]'},
						{
							ctor: '::',
							_0: A2(_mdgriffith$style_elements$Element$map, toMsg, content),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$row,
							toStyles(_user$project$OpsHandler_Styles$NoStyle),
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
									_1: {ctor: '[]'}
								}
							},
							buttons),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$OpsHandler$viewMinimized = F7(
	function (toMsg, toStyles, toVariations, title, instruction, isPreviousDisabled, isNextDisabled) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			toStyles(_user$project$OpsHandler_Styles$OpsHandler),
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(
					_mdgriffith$style_elements$Element_Attributes$px(420)),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$center,
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(20),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					toStyles(_user$project$OpsHandler_Styles$MainTitle),
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$text('Export PDF')),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						toStyles(_user$project$OpsHandler_Styles$NoStyle),
						{ctor: '[]'},
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$wrappedColumn,
								toStyles(_user$project$OpsHandler_Styles$NoStyle),
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(20),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
											_1: {ctor: '[]'}
										}
									}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$el,
										toStyles(_user$project$OpsHandler_Styles$SubTitle),
										{ctor: '[]'},
										_mdgriffith$style_elements$Element$text(title)),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$el,
											toStyles(_user$project$OpsHandler_Styles$Instructions),
											{ctor: '[]'},
											_mdgriffith$style_elements$Element$text(instruction)),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$row,
							toStyles(_user$project$OpsHandler_Styles$NoStyle),
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(5),
									_1: {ctor: '[]'}
								}
							},
							A5(_user$project$OpsHandler$viewButtons, toMsg, toStyles, toVariations, isPreviousDisabled, isNextDisabled)),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$OpsHandler$OpMsg = function (a) {
	return {ctor: 'OpMsg', _0: a};
};
var _user$project$OpsHandler$manageInits = F5(
	function (toMsg, manageOpInits, opInitData, endedOps, opKey) {
		var _p13 = A3(manageOpInits, opInitData, endedOps, opKey);
		var op = _p13._0;
		var opCmds = _p13._1;
		var opOutMsg = _p13._2;
		var actions = _p13._3;
		return {
			ctor: '_Tuple4',
			_0: A2(_user$project$OpsHandler$Operation, op, opKey),
			_1: A2(
				_elm_lang$core$Platform_Cmd$map,
				toMsg,
				A2(_elm_lang$core$Platform_Cmd$map, _user$project$OpsHandler$OpMsg, opCmds)),
			_2: opOutMsg,
			_3: actions
		};
	});
var _user$project$OpsHandler$initWithOpData = F5(
	function (toMsg, manageOpInits, opInitData, endedOps, opKey) {
		var _p14 = A5(_user$project$OpsHandler$manageInits, toMsg, manageOpInits, opInitData, endedOps, opKey);
		var nextOp = _p14._0;
		var nextOpCmds = _p14._1;
		var opOutMsg = _p14._2;
		var actions = _p14._3;
		return {
			ctor: '_Tuple3',
			_0: {
				progress: A2(
					_user$project$OpsHandler$AdvancingOps,
					_user$project$OpsHandler$endedOpsToIntEndedOps(endedOps),
					nextOp),
				isNextDisabled: function () {
					var _p15 = opOutMsg;
					if (_p15.ctor === 'OpStateChanged') {
						var _p16 = _p15._0;
						if (_p16.ctor === 'InProgress') {
							return true;
						} else {
							return false;
						}
					} else {
						return true;
					}
				}()
			},
			_1: nextOpCmds,
			_2: actions
		};
	});
var _user$project$OpsHandler$init = F4(
	function (toMsg, manageOpInits, opInitData, opKey) {
		return A5(
			_user$project$OpsHandler$initWithOpData,
			toMsg,
			manageOpInits,
			opInitData,
			{ctor: '[]'},
			opKey);
	});
var _user$project$OpsHandler$moveToNextOp = F6(
	function (toMsg, updateConfig, opInitData, endedOps, _p17, completionMode) {
		var _p18 = _p17;
		var _p22 = _p18._1;
		var newIntEndedOps = {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: A2(_user$project$OpsHandler$Operation, _p18._0, _p22),
				_1: completionMode
			},
			_1: endedOps
		};
		var newEndedOps = _user$project$OpsHandler$intEndedOpsToEndedOps(newIntEndedOps);
		var identifyNextOpData = {
			endedOps: newEndedOps,
			currentOpKey: _elm_lang$core$Maybe$Just(_p22)
		};
		var mayNextOpKey = updateConfig.identifyNextOp(identifyNextOpData);
		var _p19 = function () {
			var _p20 = mayNextOpKey;
			if (_p20.ctor === 'Nothing') {
				return {ctor: '_Tuple4', _0: _user$project$OpsHandler$ProcessEnded, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$OpsHandler_OpOutMsg$NoOpOutMsg, _3: _user$project$Action$none};
			} else {
				var _p21 = A5(_user$project$OpsHandler$manageInits, toMsg, updateConfig.manageOpInits, opInitData, newEndedOps, _p20._0);
				var newCurrentOp = _p21._0;
				var newCurOpCmds = _p21._1;
				var opOutMsg = _p21._2;
				var action = _p21._3;
				return {
					ctor: '_Tuple4',
					_0: A2(_user$project$OpsHandler$AdvancingOps, newIntEndedOps, newCurrentOp),
					_1: newCurOpCmds,
					_2: opOutMsg,
					_3: action
				};
			}
		}();
		var newProgress = _p19._0;
		var newCurOpCmds = _p19._1;
		var opOutMsg = _p19._2;
		var actions = _p19._3;
		return {ctor: '_Tuple4', _0: newProgress, _1: newCurOpCmds, _2: opOutMsg, _3: actions};
	});
var _user$project$OpsHandler$returnToPreviousOp = F4(
	function (toMsg, updateConfig, opInitData, endedOps) {
		returnToPreviousOp:
		while (true) {
			var mayNewIntEndedOps = _elm_lang$core$List$tail(endedOps);
			var isFirstOp = function () {
				var _p23 = mayNewIntEndedOps;
				if (_p23.ctor === 'Nothing') {
					return true;
				} else {
					return A2(
						_elm_lang$core$Maybe$withDefault,
						true,
						A2(
							_elm_lang$core$Maybe$map,
							function (_p24) {
								var _p25 = _p24;
								return _elm_lang$core$Native_Utils.eq(_p25._1, _user$project$OpsHandler$PreDefined);
							},
							_elm_lang$core$List$head(_p23._0)));
				}
			}();
			var mayPrevOp = _elm_lang$core$List$head(endedOps);
			var _p26 = {ctor: '_Tuple2', _0: mayNewIntEndedOps, _1: mayPrevOp};
			if (((_p26._0.ctor === 'Just') && (_p26._1.ctor === 'Just')) && (_p26._1._0.ctor === '_Tuple2')) {
				var _p29 = _p26._1._0._0._1;
				var _p28 = _p26._0._0;
				if (_elm_lang$core$Native_Utils.eq(_p26._1._0._1, _user$project$OpsHandler$Auto) && (!isFirstOp)) {
					var _v15 = toMsg,
						_v16 = updateConfig,
						_v17 = opInitData,
						_v18 = _p28;
					toMsg = _v15;
					updateConfig = _v16;
					opInitData = _v17;
					endedOps = _v18;
					continue returnToPreviousOp;
				} else {
					var _p27 = A4(
						updateConfig.manageOpRestarts,
						opInitData,
						_user$project$OpsHandler$intEndedOpsToEndedOps(_p28),
						_p29,
						_p26._1._0._0._0);
					var newOp = _p27._0;
					var newOpCmds = _p27._1;
					var newOpOutMsg = _p27._2;
					var newOpActions = _p27._3;
					return {
						ctor: '_Tuple4',
						_0: A2(
							_user$project$OpsHandler$AdvancingOps,
							_p28,
							A2(_user$project$OpsHandler$Operation, newOp, _p29)),
						_1: A2(
							_elm_lang$core$Platform_Cmd$map,
							toMsg,
							A2(_elm_lang$core$Platform_Cmd$map, _user$project$OpsHandler$OpMsg, newOpCmds)),
						_2: newOpOutMsg,
						_3: newOpActions
					};
				}
			} else {
				return _elm_lang$core$Native_Utils.crashCase(
					'OpsHandler',
					{
						start: {line: 240, column: 3},
						end: {line: 256, column: 71}
					},
					_p26)('Error: Impossible to go to the previous operation.');
			}
		}
	});
var _user$project$OpsHandler$view = F5(
	function (toMsg, toStyles, toVariations, manageOpViews, model) {
		var _p31 = model.progress;
		if (_p31.ctor === 'AdvancingOps') {
			var isPreviousDisabled = A2(
				_elm_lang$core$Maybe$withDefault,
				true,
				A2(
					_elm_lang$core$Maybe$map,
					function (_p32) {
						var _p33 = _p32;
						return _elm_lang$core$Native_Utils.eq(_p33._1, _user$project$OpsHandler$PreDefined);
					},
					_elm_lang$core$List$head(_p31._0)));
			var _p34 = manageOpViews(_p31._1._0);
			if (_p34.ctor === 'WizardView') {
				return A2(
					_user$project$OpsHandler$viewCenteredModal,
					toStyles,
					A6(
						_user$project$OpsHandler$viewMaximized,
						toMsg,
						toStyles,
						toVariations,
						A2(_mdgriffith$style_elements$Element$map, _user$project$OpsHandler$OpMsg, _p34._0),
						_elm_lang$core$Maybe$Nothing,
						A2(_user$project$OpsHandler$NextAndPreviousState, isPreviousDisabled, model.isNextDisabled)));
			} else {
				return A3(
					_mdgriffith$style_elements$Element$modal,
					toStyles(_user$project$OpsHandler_Styles$NoStyle),
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$alignBottom,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$moveUp(20),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$moveRight(20),
								_1: {ctor: '[]'}
							}
						}
					},
					A3(
						_mdgriffith$style_elements$Element$row,
						toStyles(_user$project$OpsHandler_Styles$NoStyle),
						{ctor: '[]'},
						{
							ctor: '::',
							_0: A7(_user$project$OpsHandler$viewMinimized, toMsg, toStyles, toVariations, _p34._0, _p34._1, isPreviousDisabled, model.isNextDisabled),
							_1: {ctor: '[]'}
						}));
			}
		} else {
			return _mdgriffith$style_elements$Element$empty;
		}
	});
var _user$project$OpsHandler$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$OpsHandler$Done = {ctor: 'Done'};
var _user$project$OpsHandler$Canceled = {ctor: 'Canceled'};
var _user$project$OpsHandler$update = F6(
	function (toMsg, updateConfig, opInitData, opData, msg, model) {
		var updIsNextDisabled = function (opOutMsg) {
			var _p35 = opOutMsg;
			if (_p35.ctor === 'OpStateChanged') {
				var _p36 = _p35._0;
				if (_p36.ctor === 'InProgress') {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		};
		var _p37 = {ctor: '_Tuple2', _0: model.progress, _1: msg};
		if (_p37._0.ctor === 'AdvancingOps') {
			switch (_p37._1.ctor) {
				case 'NextClicked':
					var _p38 = A6(
						_user$project$OpsHandler$moveToNextOp,
						toMsg,
						updateConfig,
						opInitData,
						_p37._0._0,
						A2(_user$project$OpsHandler$Operation, _p37._0._1._0, _p37._0._1._1),
						_p37._1._0);
					var newProgress = _p38._0;
					var opCmd = _p38._1;
					var opOutMsg = _p38._2;
					var opAction = _p38._3;
					var newModel = _elm_lang$core$Native_Utils.update(
						model,
						{
							progress: newProgress,
							isNextDisabled: updIsNextDisabled(opOutMsg)
						});
					var _p39 = newProgress;
					if (_p39.ctor === 'ProcessEnded') {
						return {ctor: '_Tuple4', _0: newModel, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$OpsHandler$NoOutMsg, _3: _user$project$Action$none};
					} else {
						var _p40 = opOutMsg;
						if (_p40.ctor === 'OpStateChanged') {
							return A9(
								_user$project$OpsHandler$handleOpState,
								_p40._0,
								toMsg,
								updateConfig,
								opInitData,
								opData,
								_user$project$OpsHandler$NextClicked(_user$project$OpsHandler$Auto),
								newModel,
								opCmd,
								opAction);
						} else {
							return {ctor: '_Tuple4', _0: newModel, _1: opCmd, _2: _user$project$OpsHandler$NoOutMsg, _3: opAction};
						}
					}
				case 'PreviousClicked':
					var _p41 = A4(_user$project$OpsHandler$returnToPreviousOp, toMsg, updateConfig, opInitData, _p37._0._0);
					var newProgress = _p41._0;
					var opCmds = _p41._1;
					var opOutMsg = _p41._2;
					var opAction = _p41._3;
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								progress: newProgress,
								isNextDisabled: updIsNextDisabled(opOutMsg)
							}),
						_1: opCmds,
						_2: _user$project$OpsHandler$NoOutMsg,
						_3: opAction
					};
				case 'CancelClicked':
					return {ctor: '_Tuple4', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$OpsHandler$Canceled, _3: _user$project$Action$none};
				case 'OpMsg':
					var _p47 = _p37._0._1._1;
					var _p46 = _p37._0._0;
					var _p42 = A3(updateConfig.manageOpUpdates, opData, _p37._1._0, _p37._0._1._0);
					var newOp = _p42._0;
					var opCmd = _p42._1;
					var opOutMsg = _p42._2;
					var curOpAction = _p42._3;
					var curOpsCmd = A2(
						_elm_lang$core$Platform_Cmd$map,
						toMsg,
						A2(_elm_lang$core$Platform_Cmd$map, _user$project$OpsHandler$OpMsg, opCmd));
					var _p43 = opOutMsg;
					if (_p43.ctor === 'NoOpOutMsg') {
						return {
							ctor: '_Tuple4',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									progress: A2(
										_user$project$OpsHandler$AdvancingOps,
										_p46,
										A2(_user$project$OpsHandler$Operation, newOp, _p47))
								}),
							_1: curOpsCmd,
							_2: _user$project$OpsHandler$NoOutMsg,
							_3: curOpAction
						};
					} else {
						var _p45 = _p43._0;
						var updModel = _elm_lang$core$Native_Utils.update(
							model,
							{
								progress: A2(
									_user$project$OpsHandler$AdvancingOps,
									_p46,
									A2(_user$project$OpsHandler$Operation, newOp, _p47)),
								isNextDisabled: function () {
									var _p44 = _p45;
									if (_p44.ctor === 'InProgress') {
										return true;
									} else {
										return false;
									}
								}()
							});
						return A9(
							_user$project$OpsHandler$handleOpState,
							_p45,
							toMsg,
							updateConfig,
							opInitData,
							opData,
							_user$project$OpsHandler$NextClicked(_user$project$OpsHandler$Auto),
							updModel,
							curOpsCmd,
							curOpAction);
					}
				default:
					return {ctor: '_Tuple4', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$OpsHandler$NoOutMsg, _3: _user$project$Action$none};
			}
		} else {
			return {ctor: '_Tuple4', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$OpsHandler$Done, _3: _user$project$Action$none};
		}
	});
var _user$project$OpsHandler$handleOpState = F9(
	function (opState, toMsg, updateConfig, opInitData, opData, msg, model, opCmd, opAction) {
		var _p48 = opState;
		switch (_p48.ctor) {
			case 'DoneAuto':
				var _p49 = A6(_user$project$OpsHandler$update, toMsg, updateConfig, opInitData, opData, msg, model);
				var newModel = _p49._0;
				var cmd = _p49._1;
				var outMsg = _p49._2;
				var action = _p49._3;
				return {
					ctor: '_Tuple4',
					_0: newModel,
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: opCmd,
							_1: {
								ctor: '::',
								_0: cmd,
								_1: {ctor: '[]'}
							}
						}),
					_2: outMsg,
					_3: _user$project$Action$batch(
						{
							ctor: '::',
							_0: opAction,
							_1: {
								ctor: '::',
								_0: action,
								_1: {ctor: '[]'}
							}
						})
				};
			case 'DoneManual':
				return {ctor: '_Tuple4', _0: model, _1: opCmd, _2: _user$project$OpsHandler$NoOutMsg, _3: opAction};
			default:
				return {ctor: '_Tuple4', _0: model, _1: opCmd, _2: _user$project$OpsHandler$NoOutMsg, _3: opAction};
		}
	});

var _user$project$OpsHandler_Ops_Map_SelectOp$update = F3(
	function (msg, model, decoder) {
		var _p0 = msg;
		var listOfA = A2(
			_elm_lang$core$List$filterMap,
			function (sel) {
				return _elm_lang$core$Result$toMaybe(
					A2(_elm_lang$core$Json_Decode$decodeValue, decoder, sel.data));
			},
			_p0._0);
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				model,
				{
					maySelectedItems: _elm_lang$core$Maybe$Just(listOfA)
				}),
			_1: _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneAuto)
		};
	});
var _user$project$OpsHandler_Ops_Map_SelectOp$Model = function (a) {
	return {maySelectedItems: a};
};
var _user$project$OpsHandler_Ops_Map_SelectOp$MapParams = F4(
	function (a, b, c, d) {
		return {layers: a, min: b, max: c, geoZone: d};
	});
var _user$project$OpsHandler_Ops_Map_SelectOp$OnSelectionEnded = function (a) {
	return {ctor: 'OnSelectionEnded', _0: a};
};
var _user$project$OpsHandler_Ops_Map_SelectOp$init = F3(
	function (toMapMsg, toMsg, mapParams) {
		var name = 'mapSelectOp';
		var startSelectAction = _user$project$Action$sendMsg(
			toMapMsg(
				A5(_user$project$Map_Data_Msg$StartSelectObjsModeMinMax, name, mapParams.layers, mapParams.min, mapParams.max, mapParams.geoZone)));
		var registerCallbackAction = _user$project$Action$sendMsg(
			toMapMsg(
				A2(
					_user$project$Map_Data_Msg$RegisterCallbackOnSelectionEnded,
					name,
					function (_p1) {
						return toMsg(
							_user$project$OpsHandler_Ops_Map_SelectOp$OnSelectionEnded(_p1));
					})));
		return {
			ctor: '_Tuple2',
			_0: {maySelectedItems: _elm_lang$core$Maybe$Nothing},
			_1: _user$project$Action$batch(
				{
					ctor: '::',
					_0: startSelectAction,
					_1: {
						ctor: '::',
						_0: registerCallbackAction,
						_1: {ctor: '[]'}
					}
				})
		};
	});

var _user$project$OpsHandler_Ops_Map_PanAndZoomOp$init = F3(
	function (mapState, geoObjs, zoom) {
		return _user$project$Map$panAndZoom(
			{mapState: mapState, geoObjs: geoObjs, zoom: zoom});
	});
var _user$project$OpsHandler_Ops_Map_PanAndZoomOp$Msg = {ctor: 'Msg'};

var _user$project$OpsHandler_Ops_SelectImageOp$update = F2(
	function (msg, model) {
		var _p0 = msg;
		return {
			ctor: '_Tuple3',
			_0: _elm_lang$core$Native_Utils.update(
				model,
				{
					maySelectedImage: _elm_lang$core$Maybe$Just(_p0._0)
				}),
			_1: _elm_lang$core$Platform_Cmd$none,
			_2: _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneManual)
		};
	});
var _user$project$OpsHandler_Ops_SelectImageOp$init = function (imageUrls) {
	return {
		ctor: '_Tuple2',
		_0: {imageUrls: imageUrls, maySelectedImage: _elm_lang$core$Maybe$Nothing},
		_1: _elm_lang$core$Platform_Cmd$none
	};
};
var _user$project$OpsHandler_Ops_SelectImageOp$Model = F2(
	function (a, b) {
		return {imageUrls: a, maySelectedImage: b};
	});
var _user$project$OpsHandler_Ops_SelectImageOp$ImageClicked = function (a) {
	return {ctor: 'ImageClicked', _0: a};
};
var _user$project$OpsHandler_Ops_SelectImageOp$viewImage = F2(
	function (imageUrl, isSelected) {
		var selectedStyle = function () {
			var _p1 = isSelected;
			if (_p1 === true) {
				return _user$project$OpsHandler_Styles$ImageSelected;
			} else {
				return _user$project$OpsHandler_Styles$ImageNotSelected;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$el,
			selectedStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(
					_mdgriffith$style_elements$Element_Attributes$px(120)),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(120)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(
							_user$project$OpsHandler_Ops_SelectImageOp$ImageClicked(imageUrl)),
						_1: {ctor: '[]'}
					}
				}
			},
			A3(
				_mdgriffith$style_elements$Element$image,
				_user$project$OpsHandler_Styles$Image,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(
						_mdgriffith$style_elements$Element_Attributes$percent(100)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(
							_mdgriffith$style_elements$Element_Attributes$percent(100)),
						_1: {ctor: '[]'}
					}
				},
				{src: imageUrl, caption: ''}));
	});
var _user$project$OpsHandler_Ops_SelectImageOp$viewImages = F2(
	function (imageUrls, maySelectedImage) {
		var isSelected = function (imgUrl) {
			var _p2 = maySelectedImage;
			if (_p2.ctor === 'Nothing') {
				return false;
			} else {
				return _elm_lang$core$Native_Utils.eq(imgUrl, _p2._0);
			}
		};
		return A2(
			_elm_lang$core$List$map,
			function (imgUrl) {
				return A2(
					_user$project$OpsHandler_Ops_SelectImageOp$viewImage,
					imgUrl,
					isSelected(imgUrl));
			},
			imageUrls);
	});
var _user$project$OpsHandler_Ops_SelectImageOp$view = function (model) {
	return A3(
		_mdgriffith$style_elements$Element$column,
		_user$project$OpsHandler_Styles$NoStyle,
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
			_1: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$el,
				_user$project$OpsHandler_Styles$NoStyle,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text('Sélectionnez l\'image à associer au document')),
			_1: {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$wrappedRow,
					_user$project$OpsHandler_Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$center,
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
								_1: {ctor: '[]'}
							}
						}
					},
					A2(_user$project$OpsHandler_Ops_SelectImageOp$viewImages, model.imageUrls, model.maySelectedImage)),
				_1: {ctor: '[]'}
			}
		});
};

var _user$project$OpsHandler_Ops_TransformOp$init = F2(
	function (transform, endedOps) {
		return {
			ctor: '_Tuple2',
			_0: {
				transformedData: transform(endedOps)
			},
			_1: _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneAuto)
		};
	});
var _user$project$OpsHandler_Ops_TransformOp$Model = function (a) {
	return {transformedData: a};
};

var _user$project$OpsHandler_Ops_InvokeJSOp$updateExpectResult = F3(
	function (msg, model, decoder) {
		var _p0 = msg;
		var _p2 = _p0._0;
		var _p1 = _p2.err;
		if (_p1.ctor === 'Just') {
			return {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Native_Utils.update(
					model,
					{
						result: _elm_lang$core$Result$Err(_p1._0)
					}),
				_1: _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneAuto)
			};
		} else {
			return {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Native_Utils.update(
					model,
					{
						result: A2(_elm_lang$core$Json_Decode$decodeValue, decoder, _p2.value)
					}),
				_1: _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneAuto)
			};
		}
	});
var _user$project$OpsHandler_Ops_InvokeJSOp$updateExpectNoRes = function (msg) {
	var _p3 = msg;
	return _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneAuto);
};
var _user$project$OpsHandler_Ops_InvokeJSOp$initExpectNoRes = F3(
	function (initData, funcName, encoder) {
		return _user$project$OpsHandler_Ports$invokeJS(
			{
				funcName: funcName,
				initData: encoder(initData)
			});
	});
var _user$project$OpsHandler_Ops_InvokeJSOp$initExpectResult = F3(
	function (initData, funcName, encoder) {
		return {
			ctor: '_Tuple2',
			_0: {
				result: _elm_lang$core$Result$Err('Not called back')
			},
			_1: A3(_user$project$OpsHandler_Ops_InvokeJSOp$initExpectNoRes, initData, funcName, encoder)
		};
	});
var _user$project$OpsHandler_Ops_InvokeJSOp$Model = function (a) {
	return {result: a};
};
var _user$project$OpsHandler_Ops_InvokeJSOp$InboundResult = F2(
	function (a, b) {
		return {value: a, err: b};
	});
var _user$project$OpsHandler_Ops_InvokeJSOp$InvokeJSDone = function (a) {
	return {ctor: 'InvokeJSDone', _0: a};
};
var _user$project$OpsHandler_Ops_InvokeJSOp$subscription = _user$project$OpsHandler_Ports$inboundInvokeJSDone(_user$project$OpsHandler_Ops_InvokeJSOp$InvokeJSDone);

var _user$project$Helpers_Data_Session$headerStrings = function (session) {
	var _p0 = _user$project$Helpers_Data_JwtToken$toString(session.token);
	if (_p0.ctor === 'Nothing') {
		return {ctor: '[]'};
	} else {
		return {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'Authorization',
				_1: A2(_elm_lang$core$Basics_ops['++'], 'Bearer ', _p0._0)
			},
			_1: {ctor: '[]'}
		};
	}
};
var _user$project$Helpers_Data_Session$headers = function (session) {
	var _p1 = _user$project$Helpers_Data_JwtToken$toString(session.token);
	if (_p1.ctor === 'Nothing') {
		return {ctor: '[]'};
	} else {
		return {
			ctor: '::',
			_0: A2(
				_elm_lang$http$Http$header,
				'Authorization',
				A2(_elm_lang$core$Basics_ops['++'], 'Bearer ', _p1._0)),
			_1: {ctor: '[]'}
		};
	}
};
var _user$project$Helpers_Data_Session$Session = F2(
	function (a, b) {
		return {token: a, user: b};
	});

var _user$project$Routing$routeToString = function (route) {
	var urlsegs = function () {
		var _p0 = route;
		switch (_p0.ctor) {
			case 'Login':
				return {
					ctor: '::',
					_0: 'login',
					_1: {ctor: '[]'}
				};
			case 'Logout':
				return {
					ctor: '::',
					_0: 'logout',
					_1: {ctor: '[]'}
				};
			case 'TreeMap':
				return {
					ctor: '::',
					_0: 'treemap',
					_1: {ctor: '[]'}
				};
			case 'ViewFile':
				var _p2 = _p0._0;
				var _p1 = _p0._1;
				if (_p1.ctor === 'Nothing') {
					return {
						ctor: '::',
						_0: 'viewfile',
						_1: {
							ctor: '::',
							_0: _p2,
							_1: {ctor: '[]'}
						}
					};
				} else {
					return {
						ctor: '::',
						_0: 'viewfile',
						_1: {
							ctor: '::',
							_0: _p2,
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$core$Basics_ops['++'], '?filename=', _p1._0),
								_1: {ctor: '[]'}
							}
						}
					};
				}
			default:
				return {
					ctor: '::',
					_0: 'gettempfile',
					_1: {
						ctor: '::',
						_0: _p0._0,
						_1: {ctor: '[]'}
					}
				};
		}
	}();
	return A2(
		_elm_lang$core$Basics_ops['++'],
		'#/',
		A2(_elm_lang$core$String$join, '/', urlsegs));
};
var _user$project$Routing$fixLocationQuery = function (location) {
	var search = A2(
		_elm_lang$core$String$append,
		'?',
		A2(
			_elm_lang$core$String$join,
			'?',
			A2(
				_elm_lang$core$List$drop,
				1,
				A2(_elm_lang$core$String$split, '?', location.hash))));
	var hash = A2(
		_elm_lang$core$Maybe$withDefault,
		'',
		_elm_lang$core$List$head(
			A2(_elm_lang$core$String$split, '?', location.hash)));
	return _elm_lang$core$Native_Utils.update(
		location,
		{hash: hash, search: search});
};
var _user$project$Routing$newUrl = function (_p3) {
	return _elm_lang$navigation$Navigation$newUrl(
		_user$project$Routing$routeToString(_p3));
};
var _user$project$Routing$modifyUrl = function (_p4) {
	return _elm_lang$navigation$Navigation$modifyUrl(
		_user$project$Routing$routeToString(_p4));
};
var _user$project$Routing$href = function (route) {
	return _elm_lang$html$Html_Attributes$href(
		_user$project$Routing$routeToString(route));
};
var _user$project$Routing$GetTempFile = function (a) {
	return {ctor: 'GetTempFile', _0: a};
};
var _user$project$Routing$ViewFile = F2(
	function (a, b) {
		return {ctor: 'ViewFile', _0: a, _1: b};
	});
var _user$project$Routing$TreeMap = {ctor: 'TreeMap'};
var _user$project$Routing$Logout = {ctor: 'Logout'};
var _user$project$Routing$Login = {ctor: 'Login'};
var _user$project$Routing$route = _evancz$url_parser$UrlParser$oneOf(
	{
		ctor: '::',
		_0: A2(
			_evancz$url_parser$UrlParser$map,
			_user$project$Routing$Login,
			_evancz$url_parser$UrlParser$s('')),
		_1: {
			ctor: '::',
			_0: A2(
				_evancz$url_parser$UrlParser$map,
				_user$project$Routing$Login,
				_evancz$url_parser$UrlParser$s('login')),
			_1: {
				ctor: '::',
				_0: A2(
					_evancz$url_parser$UrlParser$map,
					_user$project$Routing$Logout,
					_evancz$url_parser$UrlParser$s('logout')),
				_1: {
					ctor: '::',
					_0: A2(
						_evancz$url_parser$UrlParser$map,
						_user$project$Routing$TreeMap,
						_evancz$url_parser$UrlParser$s('treemap')),
					_1: {
						ctor: '::',
						_0: A2(
							_evancz$url_parser$UrlParser$map,
							_user$project$Routing$ViewFile,
							A2(
								_evancz$url_parser$UrlParser_ops['</>'],
								_evancz$url_parser$UrlParser$s('viewfile'),
								A2(
									_evancz$url_parser$UrlParser_ops['<?>'],
									_evancz$url_parser$UrlParser$string,
									_evancz$url_parser$UrlParser$stringParam('filename')))),
						_1: {
							ctor: '::',
							_0: A2(
								_evancz$url_parser$UrlParser$map,
								_user$project$Routing$GetTempFile,
								A2(
									_evancz$url_parser$UrlParser_ops['</>'],
									_evancz$url_parser$UrlParser$s('gettempfile'),
									_evancz$url_parser$UrlParser$string)),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		}
	});
var _user$project$Routing$fromLocation = function (location) {
	var fixedLoc = _user$project$Routing$fixLocationQuery(location);
	return _elm_lang$core$String$isEmpty(fixedLoc.hash) ? _elm_lang$core$Maybe$Just(_user$project$Routing$Login) : A2(_evancz$url_parser$UrlParser$parseHash, _user$project$Routing$route, fixedLoc);
};

var _user$project$Helpers_Data_EventMsg$Error = function (a) {
	return {ctor: 'Error', _0: a};
};
var _user$project$Helpers_Data_EventMsg$Warning = function (a) {
	return {ctor: 'Warning', _0: a};
};
var _user$project$Helpers_Data_EventMsg$Success = function (a) {
	return {ctor: 'Success', _0: a};
};
var _user$project$Helpers_Data_EventMsg$Info = function (a) {
	return {ctor: 'Info', _0: a};
};

var _user$project$Helpers_Views_EventMsg$viewOne = F2(
	function (toUiTxt, evtMsg) {
		var print = F2(
			function (alertClass, txt) {
				return A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(_elm_lang$core$Basics_ops['++'], 'alert ', alertClass)),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'alert'),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							toUiTxt(txt)),
						_1: {ctor: '[]'}
					});
			});
		var _p0 = evtMsg;
		switch (_p0.ctor) {
			case 'Info':
				return A2(print, 'alert-info', _p0._0);
			case 'Success':
				return A2(print, 'alert-success', _p0._0);
			case 'Warning':
				return A2(print, 'alert-warning', _p0._0);
			default:
				return A2(print, 'alert-danger', _p0._0);
		}
	});
var _user$project$Helpers_Views_EventMsg$viewList = F2(
	function (toUiTxt, evtMsgs) {
		return A2(
			_elm_lang$html$Html$ul,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('list-unstyled'),
				_1: {ctor: '[]'}
			},
			A2(
				_elm_lang$core$List$map,
				_user$project$Helpers_Views_EventMsg$viewOne(toUiTxt),
				evtMsgs));
	});

var _user$project$Helpers_Views_Text$fromMaybeNumberToMaybeString = function (maybe) {
	var _p0 = maybe;
	if (_p0.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			_elm_lang$core$Basics$toString(_p0._0));
	}
};
var _user$project$Helpers_Views_Text$fromMaybeNumberToString = F2(
	function ($default, maybe) {
		var _p1 = maybe;
		if (_p1.ctor === 'Nothing') {
			return $default;
		} else {
			return _elm_lang$core$Basics$toString(_p1._0);
		}
	});
var _user$project$Helpers_Views_Text$fromMaybeBoolToBool = F2(
	function ($default, maybe) {
		var _p2 = maybe;
		if (_p2.ctor === 'Nothing') {
			return $default;
		} else {
			return _p2._0;
		}
	});
var _user$project$Helpers_Views_Text$fromMaybeToUndefOrString = F2(
	function ($default, maybe) {
		var _p3 = maybe;
		if (_p3.ctor === 'Nothing') {
			return $default;
		} else {
			return _elm_lang$core$Basics$toString(_p3._0);
		}
	});
var _user$project$Helpers_Views_Text$fromDayToString = function (day) {
	return (_elm_lang$core$Native_Utils.cmp(day, 10) < 0) ? A2(
		_elm_lang$core$Basics_ops['++'],
		'0',
		_elm_lang$core$Basics$toString(day)) : _elm_lang$core$Basics$toString(day);
};
var _user$project$Helpers_Views_Text$fromMonthToInt = function (month) {
	var _p4 = month;
	switch (_p4.ctor) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var _user$project$Helpers_Views_Text$fromMonthToString = function (month) {
	var _p5 = month;
	switch (_p5.ctor) {
		case 'Jan':
			return '01';
		case 'Feb':
			return '02';
		case 'Mar':
			return '03';
		case 'Apr':
			return '04';
		case 'May':
			return '05';
		case 'Jun':
			return '06';
		case 'Jul':
			return '07';
		case 'Aug':
			return '08';
		case 'Sep':
			return '09';
		case 'Oct':
			return '10';
		case 'Nov':
			return '11';
		default:
			return '12';
	}
};
var _user$project$Helpers_Views_Text$maybeDateToTime = function (date) {
	var _p6 = date;
	if (_p6.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			_elm_lang$core$Date$toTime(_p6._0));
	}
};
var _user$project$Helpers_Views_Text$maybeDateToShortString = function (date) {
	var _p7 = date;
	if (_p7.ctor === 'Nothing') {
		return '';
	} else {
		var _p8 = _p7._0;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(
				_elm_lang$core$Date$year(_p8)),
			A2(
				_elm_lang$core$Basics_ops['++'],
				_user$project$Helpers_Views_Text$fromMonthToString(
					_elm_lang$core$Date$month(_p8)),
				_user$project$Helpers_Views_Text$fromDayToString(
					_elm_lang$core$Date$day(_p8))));
	}
};
var _user$project$Helpers_Views_Text$dateToString = function (date) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_user$project$Helpers_Views_Text$fromDayToString(
			_elm_lang$core$Date$day(date)),
		A2(
			_elm_lang$core$Basics_ops['++'],
			'.',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_user$project$Helpers_Views_Text$fromMonthToString(
					_elm_lang$core$Date$month(date)),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'.',
					_elm_lang$core$Basics$toString(
						_elm_lang$core$Date$year(date))))));
};
var _user$project$Helpers_Views_Text$toDateFromString = function (dateString) {
	return _elm_lang$core$Date$fromString(
		A2(
			_elm_lang$core$String$join,
			'/',
			_elm_lang$core$List$reverse(
				A2(_elm_lang$core$String$split, '.', dateString))));
};
var _user$project$Helpers_Views_Text$toDateString = F2(
	function (mayDate, defTxt) {
		var _p9 = mayDate;
		if (_p9.ctor === 'Nothing') {
			return defTxt;
		} else {
			var _p10 = _p9._0;
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_user$project$Helpers_Views_Text$fromDayToString(
					_elm_lang$core$Date$day(_p10)),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'.',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_user$project$Helpers_Views_Text$fromMonthToString(
							_elm_lang$core$Date$month(_p10)),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'.',
							_elm_lang$core$Basics$toString(
								_elm_lang$core$Date$year(_p10))))));
		}
	});
var _user$project$Helpers_Views_Text$toUiTextOrDefault = F3(
	function (toUiTxt, $default, maybe) {
		var _p11 = maybe;
		if (_p11.ctor === 'Nothing') {
			return $default;
		} else {
			return toUiTxt(_p11._0);
		}
	});
var _user$project$Helpers_Views_Text$toUiTextOrSelf = F2(
	function (mayToUiTxt, txt) {
		var _p12 = mayToUiTxt;
		if (_p12.ctor === 'Nothing') {
			return txt;
		} else {
			return _p12._0(txt);
		}
	});
var _user$project$Helpers_Views_Text$toTextOrDefault = F2(
	function (defTxt, mayStr) {
		var _p13 = mayStr;
		if (_p13.ctor === 'Nothing') {
			return defTxt;
		} else {
			return _p13._0;
		}
	});
var _user$project$Helpers_Views_Text$nonStringtoTextOrDefault = F2(
	function (defTxt, mayValue) {
		var _p14 = mayValue;
		if (_p14.ctor === 'Nothing') {
			return defTxt;
		} else {
			return _elm_lang$core$Basics$toString(_p14._0);
		}
	});
var _user$project$Helpers_Views_Text$boolToTextOrDefault = F2(
	function (defTxt, mayBool) {
		var _p15 = mayBool;
		if (_p15.ctor === 'Nothing') {
			return defTxt;
		} else {
			var _p16 = _p15._0;
			if (_p16 === true) {
				return 'data_bool_true';
			} else {
				return 'data_bool_false';
			}
		}
	});
var _user$project$Helpers_Views_Text$dateToTextOrDefault = F2(
	function (defTxt, maydate) {
		var _p17 = maydate;
		if (_p17.ctor === 'Nothing') {
			return defTxt;
		} else {
			return _elm_lang$core$Basics$toString(_p17._0);
		}
	});
var _user$project$Helpers_Views_Text$defaultFormat = {decimals: 0, thousandSeparator: '\'', decimalSeparator: '.', negativePrefix: '−', negativeSuffix: '', positivePrefix: '', positiveSuffix: ''};
var _user$project$Helpers_Views_Text$maybeFloat2UndefOrString = F2(
	function ($default, maybe) {
		var _p18 = maybe;
		if (_p18.ctor === 'Nothing') {
			return $default;
		} else {
			return A2(_cuducos$elm_format_number$FormatNumber$format, _user$project$Helpers_Views_Text$defaultFormat, _p18._0);
		}
	});

var _user$project$Helpers_Data_InputValidation$smallerOrEqualValidator = F2(
	function (number, mayInput) {
		var _p0 = mayInput;
		if (_p0.ctor === 'Nothing') {
			return false;
		} else {
			return _elm_lang$core$Native_Utils.cmp(_p0._0, number) < 1;
		}
	});
var _user$project$Helpers_Data_InputValidation$matchFound = F2(
	function (regex, string) {
		return _elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$List$length(
				A3(_elm_lang$core$Regex$find, _elm_lang$core$Regex$All, regex, string)),
			0) > 0;
	});
var _user$project$Helpers_Data_InputValidation$emailValidator = function (mayInput) {
	var validEmail = _elm_lang$core$Regex$regex('^\\S+@\\S+\\.\\S+$');
	var _p1 = mayInput;
	if (_p1.ctor === 'Nothing') {
		return false;
	} else {
		return A2(_user$project$Helpers_Data_InputValidation$matchFound, validEmail, _p1._0);
	}
};
var _user$project$Helpers_Data_InputValidation$phoneValidator = function (mayInput) {
	var validPhone = _elm_lang$core$Regex$regex('^(\\b(0041|0)|\\B\\+41)(\\s?\\(0\\))?(\\s)?[1-9]{2}(\\s)?[0-9]{3}(\\s)?[0-9]{2}(\\s)?[0-9]{2}\\b$');
	var _p2 = mayInput;
	if (_p2.ctor === 'Nothing') {
		return false;
	} else {
		return A2(_user$project$Helpers_Data_InputValidation$matchFound, validPhone, _p2._0);
	}
};
var _user$project$Helpers_Data_InputValidation$validateForm = function (listValidationData) {
	var notValids = A2(
		_elm_lang$core$List$filter,
		function (vData) {
			return !vData.isValid;
		},
		listValidationData);
	return _elm_lang$core$Native_Utils.eq(
		notValids,
		{ctor: '[]'});
};
var _user$project$Helpers_Data_InputValidation$validate = F4(
	function (isMandatory, mayValidator, mayMessage, mayValue) {
		var isNotEmpty = function (mayVal) {
			return !_elm_lang$core$Native_Utils.eq(mayVal, _elm_lang$core$Maybe$Nothing);
		};
		var isEmpty = function (mayVal) {
			return _elm_lang$core$Native_Utils.eq(mayVal, _elm_lang$core$Maybe$Nothing);
		};
		var isValid = function () {
			var didPassValidation = function () {
				var _p3 = mayValidator;
				if (_p3.ctor === 'Just') {
					return _p3._0(mayValue);
				} else {
					return true;
				}
			}();
			var _p4 = isMandatory;
			if (_p4 === true) {
				return isNotEmpty(mayValue) && didPassValidation;
			} else {
				return isEmpty(mayValue) || didPassValidation;
			}
		}();
		var displayMessage = (!isValid) && isNotEmpty(mayValue);
		return {isValid: isValid, mayMessage: mayMessage, displayMessage: displayMessage};
	});
var _user$project$Helpers_Data_InputValidation$mayValueToMayString = _elm_lang$core$Maybe$map(
	function (f) {
		return _elm_lang$core$Basics$toString(f);
	});
var _user$project$Helpers_Data_InputValidation$defaultValidation = {isValid: true, mayMessage: _elm_lang$core$Maybe$Nothing, displayMessage: false};
var _user$project$Helpers_Data_InputValidation$ValidationData = F3(
	function (a, b, c) {
		return {isValid: a, mayMessage: b, displayMessage: c};
	});

var _user$project$Helpers_Views_Sorting$maybeLastUpdateSorter = F2(
	function (a, b) {
		var _p0 = a.lastUpdate;
		if (_p0.ctor === 'Nothing') {
			return _elm_lang$core$Native_Utils.eq(b.lastUpdate, _elm_lang$core$Maybe$Nothing) ? _elm_lang$core$Basics$EQ : _elm_lang$core$Basics$GT;
		} else {
			var _p1 = b.lastUpdate;
			if (_p1.ctor === 'Nothing') {
				return _elm_lang$core$Basics$LT;
			} else {
				return A2(_justinmimbs$elm_date_extra$Date_Extra$compare, _p0._0, _p1._0);
			}
		}
	});
var _user$project$Helpers_Views_Sorting$maybeStartDateSorter = F2(
	function (a, b) {
		var _p2 = a.startDate;
		if (_p2.ctor === 'Nothing') {
			return _elm_lang$core$Native_Utils.eq(b.startDate, _elm_lang$core$Maybe$Nothing) ? _elm_lang$core$Basics$EQ : _elm_lang$core$Basics$GT;
		} else {
			var _p3 = b.startDate;
			if (_p3.ctor === 'Nothing') {
				return _elm_lang$core$Basics$LT;
			} else {
				return A2(_justinmimbs$elm_date_extra$Date_Extra$compare, _p2._0, _p3._0);
			}
		}
	});
var _user$project$Helpers_Views_Sorting$maybeDateSorter = F2(
	function (a, b) {
		var _p4 = a.date;
		if (_p4.ctor === 'Nothing') {
			return _elm_lang$core$Native_Utils.eq(b.date, _elm_lang$core$Maybe$Nothing) ? _elm_lang$core$Basics$EQ : _elm_lang$core$Basics$GT;
		} else {
			var _p5 = b.date;
			if (_p5.ctor === 'Nothing') {
				return _elm_lang$core$Basics$LT;
			} else {
				return A2(_justinmimbs$elm_date_extra$Date_Extra$compare, _p4._0, _p5._0);
			}
		}
	});

var _user$project$Helpers_Views_Form$elFilter2 = function (toUiTxt) {
	return function (label) {
		return function (labelwidth) {
			return function (hidden) {
				return function (onclickMsg) {
					return function (labelall) {
						return function (labelnone) {
							return function (onchangeall) {
								return function (onchangenone) {
									return function (filters) {
										return function (checkboxes) {
											return A3(
												_mdgriffith$style_elements$Element$column,
												_user$project$Styles$SmallFont,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$spacing(2),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(
																		_mdgriffith$style_elements$Element_Attributes$percent(labelwidth)),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$image,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$height(
																				_mdgriffith$style_elements$Element_Attributes$px(20)),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$px(20)),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(6),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Events$onClick(onclickMsg),
																						_1: {ctor: '[]'}
																					}
																				}
																			}
																		},
																		{
																			src: hidden ? './images/arrowSmallR.svg' : './images/arrowSmallD.svg',
																			caption: 'exp'
																		}),
																	_1: {
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$Label,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(6),
																					_1: {ctor: '[]'}
																				}
																			},
																			_mdgriffith$style_elements$Element$text(label)),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element_Input$checkbox,
																			_user$project$Styles$NoStyle,
																			{ctor: '[]'},
																			{
																				onChange: onchangeall,
																				checked: A2(_elm_lang$core$List$member, labelall, filters),
																				label: A3(
																					_mdgriffith$style_elements$Element$el,
																					_user$project$Styles$NoStyle,
																					{ctor: '[]'},
																					_mdgriffith$style_elements$Element$text(labelall)),
																				options: {ctor: '[]'}
																			}),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element_Input$checkbox,
																				_user$project$Styles$NoStyle,
																				{ctor: '[]'},
																				{
																					onChange: onchangenone,
																					checked: A2(_elm_lang$core$List$member, labelnone, filters),
																					label: A3(
																						_mdgriffith$style_elements$Element$el,
																						_user$project$Styles$NoStyle,
																						{ctor: '[]'},
																						_mdgriffith$style_elements$Element$text(labelnone)),
																					options: {ctor: '[]'}
																				}),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {ctor: '[]'}
															}
														}),
													_1: {
														ctor: '::',
														_0: hidden ? _mdgriffith$style_elements$Element$empty : A3(
															_mdgriffith$style_elements$Element$column,
															_user$project$Styles$NoStyle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(labelwidth)),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$height(
																						_mdgriffith$style_elements$Element_Attributes$px(2)),
																					_1: {ctor: '[]'}
																				}
																			},
																			_mdgriffith$style_elements$Element$text('')),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$height(
																							_mdgriffith$style_elements$Element_Attributes$px(2)),
																						_1: {ctor: '[]'}
																					}
																				},
																				_mdgriffith$style_elements$Element$hairline(_user$project$Styles$BorderTop)),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$column,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																			_1: {ctor: '[]'}
																		},
																		checkboxes),
																	_1: {
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$row,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																				_1: {ctor: '[]'}
																			},
																			{
																				ctor: '::',
																				_0: A3(
																					_mdgriffith$style_elements$Element$el,
																					_user$project$Styles$NoStyle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$width(
																							_mdgriffith$style_elements$Element_Attributes$percent(labelwidth)),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$height(
																								_mdgriffith$style_elements$Element_Attributes$px(2)),
																							_1: {ctor: '[]'}
																						}
																					},
																					_mdgriffith$style_elements$Element$text('')),
																				_1: {
																					ctor: '::',
																					_0: A3(
																						_mdgriffith$style_elements$Element$el,
																						_user$project$Styles$NoStyle,
																						{
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																							_1: {
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$height(
																									_mdgriffith$style_elements$Element_Attributes$px(2)),
																								_1: {ctor: '[]'}
																							}
																						},
																						_mdgriffith$style_elements$Element$hairline(_user$project$Styles$BorderTop)),
																					_1: {ctor: '[]'}
																				}
																			}),
																		_1: {ctor: '[]'}
																	}
																}
															}),
														_1: {ctor: '[]'}
													}
												});
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$elTableViewLoading = F9(
	function (isLoading, label, isviewmode, editstatuschanged, switchsection, itemList, sectionhidden, hidestyle, tableview) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$Section,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: isviewmode ? A3(
							_mdgriffith$style_elements$Element$button,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(editstatuschanged),
									_1: {ctor: '[]'}
								}
							},
							A3(
								_mdgriffith$style_elements$Element$image,
								_user$project$Styles$NoStyle,
								{ctor: '[]'},
								{src: './images/gobackup.svg', caption: 'arrowBtn'})) : A3(
							_mdgriffith$style_elements$Element$button,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(switchsection),
									_1: {ctor: '[]'}
								}
							},
							(_elm_lang$core$List$isEmpty(itemList) && (!isLoading)) ? A3(
								_mdgriffith$style_elements$Element$image,
								_user$project$Styles$NoStyle,
								{ctor: '[]'},
								{src: './images/arrowBtnRD.svg', caption: 'arrowBtn'}) : A3(
								_mdgriffith$style_elements$Element$image,
								_user$project$Styles$NoStyle,
								{ctor: '[]'},
								{
									src: sectionhidden ? './images/arrowBtnR.svg' : './images/arrowBtnD.svg',
									caption: 'arrowBtn'
								})),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$el,
								_user$project$Styles$SubTitle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
										_1: {ctor: '[]'}
									}
								},
								_mdgriffith$style_elements$Element$text(label)),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						_user$project$Styles$NoStyle,
						A2(
							_elm_lang$core$Basics_ops['++'],
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {ctor: '[]'}
							},
							hidestyle),
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$column,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: (_elm_lang$core$List$isEmpty(itemList) && (!isLoading)) ? _mdgriffith$style_elements$Element$empty : (isLoading ? A3(
										_mdgriffith$style_elements$Element$el,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
											_1: {ctor: '[]'}
										},
										_mdgriffith$style_elements$Element$text('... chargement en cours')) : A3(
										_mdgriffith$style_elements$Element$column,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
											_1: {
												ctor: '::',
												_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 4),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
													_1: {ctor: '[]'}
												}
											}
										},
										{
											ctor: '::',
											_0: tableview,
											_1: {ctor: '[]'}
										})),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elTableView = F8(
	function (label, isviewmode, editstatuschanged, switchsection, itemList, sectionhidden, hidestyle, tableview) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$Section,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: isviewmode ? A3(
							_mdgriffith$style_elements$Element$button,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(editstatuschanged),
									_1: {ctor: '[]'}
								}
							},
							A3(
								_mdgriffith$style_elements$Element$image,
								_user$project$Styles$NoStyle,
								{ctor: '[]'},
								{src: './images/gobackup.svg', caption: 'arrowBtn'})) : A3(
							_mdgriffith$style_elements$Element$button,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(switchsection),
									_1: {ctor: '[]'}
								}
							},
							_elm_lang$core$List$isEmpty(itemList) ? A3(
								_mdgriffith$style_elements$Element$image,
								_user$project$Styles$NoStyle,
								{ctor: '[]'},
								{src: './images/arrowBtnRD.svg', caption: 'arrowBtn'}) : A3(
								_mdgriffith$style_elements$Element$image,
								_user$project$Styles$NoStyle,
								{ctor: '[]'},
								{
									src: sectionhidden ? './images/arrowBtnR.svg' : './images/arrowBtnD.svg',
									caption: 'arrowBtn'
								})),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$el,
								_user$project$Styles$SubTitle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
										_1: {ctor: '[]'}
									}
								},
								_mdgriffith$style_elements$Element$text(label)),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						_user$project$Styles$NoStyle,
						A2(
							_elm_lang$core$Basics_ops['++'],
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {ctor: '[]'}
							},
							hidestyle),
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$column,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$core$List$isEmpty(itemList) ? _mdgriffith$style_elements$Element$empty : A3(
										_mdgriffith$style_elements$Element$column,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
											_1: {
												ctor: '::',
												_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 4),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
													_1: {ctor: '[]'}
												}
											}
										},
										{
											ctor: '::',
											_0: tableview,
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$htmlItemList = F8(
	function (toUiTxt, elLabel, items, targetview, onclick, divclass, labelclass, inputclass) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(divclass),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(labelclass),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('d-inline-block'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									toUiTxt(elLabel)),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: function () {
								var _p0 = onclick;
								if (_p0.ctor === 'Nothing') {
									return A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('btn-group d-inline-block float-right'),
											_1: {ctor: '[]'}
										},
										{ctor: '[]'});
								} else {
									return A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('btn-group d-inline-block float-right'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$button,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_('button'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('btn btn-success btn-sm'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Events$onClick(_p0._0),
															_1: {ctor: '[]'}
														}
													}
												},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$img,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$src('images/add.svg'),
															_1: {ctor: '[]'}
														},
														{ctor: '[]'}),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										});
								}
							}(),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$List$isEmpty(items) ? _elm_lang$html$Html$text('') : A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(inputclass),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('col'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{ctor: '[]'},
										A2(
											_elm_lang$core$List$map,
											targetview(toUiTxt),
											items)),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elSimpleList = F9(
	function (toUiTxt, key, invalue, updatemsg, isvalid, items, targetview, onclick, placeholder) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element_Keyed$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: key,
							_1: A3(
								_mdgriffith$style_elements$Element_Input$text,
								_user$project$Styles$Input,
								{ctor: '[]'},
								{
									onChange: updatemsg,
									value: invalue,
									label: _mdgriffith$style_elements$Element_Input$placeholder(
										{
											label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
											text: placeholder
										}),
									options: {ctor: '[]'}
								})
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'button',
								_1: A3(
									_mdgriffith$style_elements$Element$row,
									_user$project$Styles$NoStyle,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: isvalid ? A3(
											_mdgriffith$style_elements$Element$image,
											_user$project$Styles$DocAddBtn,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$height(
													_mdgriffith$style_elements$Element_Attributes$px(20)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(
														_mdgriffith$style_elements$Element_Attributes$px(20)),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onClick(onclick),
														_1: {ctor: '[]'}
													}
												}
											},
											{src: './images/add.svg', caption: 'add'}) : A3(
											_mdgriffith$style_elements$Element$image,
											_user$project$Styles$DocDisabledBtn,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$height(
													_mdgriffith$style_elements$Element_Attributes$px(20)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(
														_mdgriffith$style_elements$Element_Attributes$px(20)),
													_1: {ctor: '[]'}
												}
											},
											{src: './images/add.svg', caption: 'add'}),
										_1: {ctor: '[]'}
									})
							},
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$List$isEmpty(items) ? _mdgriffith$style_elements$Element$empty : A3(
						_mdgriffith$style_elements$Element$column,
						_user$project$Styles$NoStyle,
						{ctor: '[]'},
						A2(_elm_lang$core$List$map, targetview, items)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elItemList = F6(
	function (toUiTxt, sValue, elLabel, items, targetview, onclick) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: function () {
							var _p1 = onclick;
							if (_p1.ctor === 'Nothing') {
								return _mdgriffith$style_elements$Element$empty;
							} else {
								return A3(
									_mdgriffith$style_elements$Element$row,
									_user$project$Styles$NoStyle,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$image,
											_user$project$Styles$DocAddBtn,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$height(
													_mdgriffith$style_elements$Element_Attributes$px(20)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(
														_mdgriffith$style_elements$Element_Attributes$px(20)),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onClick(_p1._0),
														_1: {ctor: '[]'}
													}
												}
											},
											{src: './images/add.svg', caption: 'add'}),
										_1: {ctor: '[]'}
									});
							}
						}(),
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Native_Utils.eq(elLabel, 'NoLabel') ? _mdgriffith$style_elements$Element$empty : A3(
								_mdgriffith$style_elements$Element$el,
								_user$project$Styles$Label,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
									_1: {ctor: '[]'}
								},
								_mdgriffith$style_elements$Element$text(
									toUiTxt(elLabel))),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$List$isEmpty(items) ? _mdgriffith$style_elements$Element$empty : A3(
						_mdgriffith$style_elements$Element$column,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(sValue),
							_1: {ctor: '[]'}
						},
						A2(_elm_lang$core$List$map, targetview, items)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$htmlOkCancel = F8(
	function (toUiTxt, isValid, applyText, applyClass, applyClick, cancelText, cancelClass, cancelClick) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('form-group row'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('col-auto ml-auto'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('btn-group'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$button,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$type_('button'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$min('0'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$step('1'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class(applyClass),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$disabled(!isValid),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Events$onClick(applyClick),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(
											toUiTxt(applyText)),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$button,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$type_('button'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class(cancelClass),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Events$onClick(cancelClick),
													_1: {ctor: '[]'}
												}
											}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(
												toUiTxt(cancelText)),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$elCancel = F3(
	function (cancelText, cancelStyle, cancelClick) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$percent(50)),
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$empty),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$row,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$percent(50)),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$el,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(
												_mdgriffith$style_elements$Element_Attributes$percent(50)),
											_1: {ctor: '[]'}
										},
										_mdgriffith$style_elements$Element$empty),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$button,
											cancelStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(
													_mdgriffith$style_elements$Element_Attributes$percent(50)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Events$onClick(cancelClick),
													_1: {ctor: '[]'}
												}
											},
											_mdgriffith$style_elements$Element$text(cancelText)),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$elOkCancel = F7(
	function (isValid, applyText, applyStyle, applyClick, cancelText, cancelStyle, cancelClick) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$Label,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$percent(50)),
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$empty),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$row,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$percent(50)),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: isValid ? A3(
										_mdgriffith$style_elements$Element$button,
										applyStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(
												_mdgriffith$style_elements$Element_Attributes$percent(50)),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Events$onClick(applyClick),
													_1: {ctor: '[]'}
												}
											}
										},
										_mdgriffith$style_elements$Element$text(applyText)) : A3(
										_mdgriffith$style_elements$Element$button,
										applyStyle,
										{
											ctor: '::',
											_0: A2(_mdgriffith$style_elements$Element_Attributes$vary, _user$project$Styles$Disabled, true),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(
													_mdgriffith$style_elements$Element_Attributes$percent(50)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
													_1: {ctor: '[]'}
												}
											}
										},
										_mdgriffith$style_elements$Element$text(applyText)),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$button,
											cancelStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(
													_mdgriffith$style_elements$Element_Attributes$percent(50)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Events$onClick(cancelClick),
													_1: {ctor: '[]'}
												}
											},
											_mdgriffith$style_elements$Element$text(cancelText)),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$htmlFile = F6(
	function (toUiTxt, elId, elLabel, filesSelect, divclass, labelclass) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(divclass),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$label,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$for(elId),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(labelclass),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							toUiTxt(elLabel)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$input,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id('document-file'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('col-sm-7 form-control'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$type_('file'),
									_1: {
										ctor: '::',
										_0: _simonh1000$file_reader$FileReader$onFileChange(filesSelect),
										_1: {ctor: '[]'}
									}
								}
							}
						},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elFile = F3(
	function (toUiTxt, elLabel1, filesSelect) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$Label,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$percent(70)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
									_1: {ctor: '[]'}
								}
							},
							_mdgriffith$style_elements$Element$text(
								toUiTxt(elLabel1))),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$row,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$percent(30)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
												_1: {ctor: '[]'}
											}
										}
									}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$row,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(
												_mdgriffith$style_elements$Element_Attributes$px(24)),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
												_1: {ctor: '[]'}
											}
										},
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element$html(
												A2(
													_elm_lang$html$Html$label,
													{ctor: '[]'},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$img,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$src('images/fileselect.svg'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$width(24),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$height(24),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$style(
																				{
																					ctor: '::',
																					_0: {ctor: '_Tuple2', _0: 'verticalAlign', _1: 'bottom'},
																					_1: {
																						ctor: '::',
																						_0: {ctor: '_Tuple2', _0: 'margin-top', _1: '4px'},
																						_1: {
																							ctor: '::',
																							_0: {ctor: '_Tuple2', _0: 'margin-right', _1: '2px'},
																							_1: {ctor: '[]'}
																						}
																					}
																				}),
																			_1: {ctor: '[]'}
																		}
																	}
																}
															},
															{ctor: '[]'}),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$input,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$style(
																		{
																			ctor: '::',
																			_0: {ctor: '_Tuple2', _0: 'display', _1: 'none'},
																			_1: {ctor: '[]'}
																		}),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$type_('file'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$defaultValue(''),
																			_1: {
																				ctor: '::',
																				_0: _simonh1000$file_reader$FileReader$onFileChange(filesSelect),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																},
																{ctor: '[]'}),
															_1: {ctor: '[]'}
														}
													})),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$row,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(
													_mdgriffith$style_elements$Element_Attributes$px(24)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
													_1: {ctor: '[]'}
												}
											},
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element$html(
													A2(
														_elm_lang$html$Html$label,
														{ctor: '[]'},
														{
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$img,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$src('images/camera.svg'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$width(24),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$height(24),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$style(
																					{
																						ctor: '::',
																						_0: {ctor: '_Tuple2', _0: 'verticalAlign', _1: 'bottom'},
																						_1: {
																							ctor: '::',
																							_0: {ctor: '_Tuple2', _0: 'margin-top', _1: '4px'},
																							_1: {
																								ctor: '::',
																								_0: {ctor: '_Tuple2', _0: 'margin-right', _1: '2px'},
																								_1: {ctor: '[]'}
																							}
																						}
																					}),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																},
																{ctor: '[]'}),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$input,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$style(
																			{
																				ctor: '::',
																				_0: {ctor: '_Tuple2', _0: 'display', _1: 'none'},
																				_1: {ctor: '[]'}
																			}),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$type_('file'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$accept('image/*'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$defaultValue(''),
																					_1: {
																						ctor: '::',
																						_0: _simonh1000$file_reader$FileReader$onFileChange(filesSelect),
																						_1: {ctor: '[]'}
																					}
																				}
																			}
																		}
																	},
																	{ctor: '[]'}),
																_1: {ctor: '[]'}
															}
														})),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$elCheckBox = F6(
	function (elLabel, checklabel, size, updatemsg, ischecked, isvalid) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(size)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element_Input$checkbox,
						_user$project$Styles$NoStyle,
						{ctor: '[]'},
						{
							onChange: updatemsg,
							checked: ischecked,
							label: A3(
								_mdgriffith$style_elements$Element$el,
								_user$project$Styles$NoStyle,
								{ctor: '[]'},
								_mdgriffith$style_elements$Element$text(checklabel)),
							options: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$htmlTextarea = function (toUiTxt) {
	return function (elId) {
		return function (elLabel) {
			return function (updatemsg) {
				return function (inValue) {
					return function (isvalid) {
						return function (isreadonly) {
							return function (nrows) {
								return function (divclass) {
									return function (labelclass) {
										return function (inputclass) {
											var base = {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$id(elId),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class(
														isvalid ? inputclass : A2(_elm_lang$core$Basics_ops['++'], inputclass, ' is-invalid')),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$readonly(isreadonly),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$value(inValue),
															_1: {ctor: '[]'}
														}
													}
												}
											};
											var attributes = function () {
												var _p2 = updatemsg;
												if (_p2.ctor === 'Nothing') {
													return base;
												} else {
													return A2(
														_elm_lang$core$List$append,
														base,
														{
															ctor: '::',
															_0: A2(_elm_lang$html$Html_Events$on, 'input', _p2._0),
															_1: {ctor: '[]'}
														});
												}
											}();
											return A2(
												_elm_lang$html$Html$div,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class(divclass),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$label,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$for(elId),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class(labelclass),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(
																toUiTxt(elLabel)),
															_1: {ctor: '[]'}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$textarea,
															attributes,
															{ctor: '[]'}),
														_1: {ctor: '[]'}
													}
												});
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$elMultilineLabelTextarea = F4(
	function (elLabel, updatemsg, inValue, isvalid) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(50)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$html(
						A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$style(
									{
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'padding-right', _1: '10px'},
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(elLabel),
								_1: {ctor: '[]'}
							}))),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element_Input$multiline,
						_user$project$Styles$Input,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$inlineStyle(
								{
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'resize', _1: 'vertical'},
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						},
						{
							onChange: updatemsg,
							value: function () {
								var _p3 = inValue;
								if (_p3.ctor === 'Nothing') {
									return '';
								} else {
									return _p3._0;
								}
							}(),
							label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
							options: isvalid ? {ctor: '[]'} : {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$disabled,
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elTextarea = F4(
	function (elLabel, updatemsg, inValue, isvalid) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(50)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element_Input$multiline,
						_user$project$Styles$Input,
						{ctor: '[]'},
						{
							onChange: updatemsg,
							value: inValue,
							label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
							options: isvalid ? {ctor: '[]'} : {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$disabled,
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elSelect2Option = F3(
	function (toUiTxt, targVal, optVal) {
		var selectedAttr = _elm_lang$core$Native_Utils.eq(targVal, optVal) ? _elm_lang$html$Html_Attributes$selected(true) : _elm_lang$html$Html_Attributes$selected(false);
		return A2(
			_elm_lang$html$Html$option,
			{
				ctor: '::',
				_0: selectedAttr,
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(optVal),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					toUiTxt(optVal)),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$htmlInput = function (toUiTxt) {
	return function (elId) {
		return function (elLabel) {
			return function (inputType) {
				return function (updatemsg) {
					return function (inValue) {
						return function (isvalid) {
							return function (isreadonly) {
								return function (divclass) {
									return function (labelclass) {
										return function (inputclass) {
											var base = {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$id(elId),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_(inputType),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class(
															isvalid ? inputclass : A2(_elm_lang$core$Basics_ops['++'], inputclass, ' is-invalid')),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$readonly(isreadonly),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$value(inValue),
																_1: {ctor: '[]'}
															}
														}
													}
												}
											};
											var attributes = function () {
												var _p4 = updatemsg;
												if (_p4.ctor === 'Nothing') {
													return base;
												} else {
													return A2(
														_elm_lang$core$List$append,
														base,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Events$onInput(_p4._0),
															_1: {ctor: '[]'}
														});
												}
											}();
											return A2(
												_elm_lang$html$Html$div,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class(divclass),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$label,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$for(elId),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class(labelclass),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(
																toUiTxt(elLabel)),
															_1: {ctor: '[]'}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$input,
															attributes,
															{ctor: '[]'}),
														_1: {ctor: '[]'}
													}
												});
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$elInputSized = F5(
	function (size, elLabel, updatemsg, inValue, isvalid) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(size)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element_Input$text,
						_user$project$Styles$Input,
						{ctor: '[]'},
						{
							onChange: updatemsg,
							value: inValue,
							label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
							options: isvalid ? {ctor: '[]'} : {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$disabled,
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elSearch2 = F6(
	function (updatemsg, onFocusMsg, onBlurMsg, isValid, isDisabled, placeholder) {
		var isValidStyle = function () {
			var _p5 = isValid;
			if (_p5 === true) {
				return _user$project$Styles$Input;
			} else {
				return _user$project$Styles$InputNotValid;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element_Input$text,
			isValidStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onFocus(onFocusMsg),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onBlur(onBlurMsg),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				onChange: updatemsg,
				value: '',
				label: _mdgriffith$style_elements$Element_Input$placeholder(
					{
						label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
						text: placeholder
					}),
				options: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$elSearch = F3(
	function (updatemsg, isDisabled, placeholder) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element_Input$search,
					_user$project$Styles$Input,
					{ctor: '[]'},
					{
						onChange: updatemsg,
						value: '',
						label: _mdgriffith$style_elements$Element_Input$placeholder(
							{
								label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
								text: placeholder
							}),
						options: isDisabled ? {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Input$disabled,
							_1: {ctor: '[]'}
						} : {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$elSeparator = A3(
	_mdgriffith$style_elements$Element$row,
	_user$project$Styles$NoStyle,
	{
		ctor: '::',
		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: A3(
			_mdgriffith$style_elements$Element$el,
			_user$project$Styles$Separator,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(0)),
					_1: {ctor: '[]'}
				}
			},
			_mdgriffith$style_elements$Element$text('')),
		_1: {ctor: '[]'}
	});
var _user$project$Helpers_Views_Form$wrapInSummary = F3(
	function (elements, maybeInfo, isSelect) {
		var innerEls = function (info) {
			return A3(
				_mdgriffith$style_elements$Element$row,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: info.content,
					_1: {
						ctor: '::',
						_0: function () {
							var _p6 = info.mayLink;
							if (_p6.ctor === 'Nothing') {
								return _mdgriffith$style_elements$Element$empty;
							} else {
								return A2(
									_mdgriffith$style_elements$Element$newTab,
									_p6._0,
									A3(
										_mdgriffith$style_elements$Element$el,
										_user$project$Styles$Link,
										{
											ctor: '::',
											_0: A2(_mdgriffith$style_elements$Element_Attributes$spacingXY, 0, 5),
											_1: {ctor: '[]'}
										},
										_mdgriffith$style_elements$Element$text('En savoir plus...')));
							}
						}(),
						_1: {ctor: '[]'}
					}
				});
		};
		var wrapper = function (info) {
			return {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element$html(
					_rtfeldman$elm_css$Html_Styled$toUnstyled(
						A2(
							_rtfeldman$elm_css$Html_Styled$details,
							{
								ctor: '::',
								_0: _rtfeldman$elm_css$Html_Styled_Attributes$style(
									{
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_rtfeldman$elm_css$Html_Styled$summary,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _rtfeldman$elm_css$Css_Global$global(
											{
												ctor: '::',
												_0: A2(
													_rtfeldman$elm_css$Css_Global$typeSelector,
													'summary',
													{
														ctor: '::',
														_0: _rtfeldman$elm_css$Css_Global$children(
															{
																ctor: '::',
																_0: A2(
																	_rtfeldman$elm_css$Css_Global$typeSelector,
																	'div',
																	{
																		ctor: '::',
																		_0: _rtfeldman$elm_css$Css$width(
																			A3(
																				_rtfeldman$elm_css$Css$calc,
																				_rtfeldman$elm_css$Css$pct(100),
																				_rtfeldman$elm_css$Css$minus,
																				_rtfeldman$elm_css$Css$px(13))),
																		_1: {
																			ctor: '::',
																			_0: _rtfeldman$elm_css$Css$display(_rtfeldman$elm_css$Css$inlineBlock),
																			_1: {
																				ctor: '::',
																				_0: _rtfeldman$elm_css$Css$verticalAlign(_rtfeldman$elm_css$Css$textTop),
																				_1: {ctor: '[]'}
																			}
																		}
																	}),
																_1: {ctor: '[]'}
															}),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: _rtfeldman$elm_css$Html_Styled$fromUnstyled(
												A2(
													_mdgriffith$style_elements$Element$toHtml,
													_user$project$Styles$stylesheet,
													A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {
																ctor: '::',
																_0: function () {
																	var _p7 = isSelect;
																	if (_p7 === true) {
																		return _mdgriffith$style_elements$Element_Attributes$inlineStyle(
																			{
																				ctor: '::',
																				_0: {ctor: '_Tuple2', _0: 'display', _1: 'inline-flex'},
																				_1: {ctor: '[]'}
																			});
																	} else {
																		return _mdgriffith$style_elements$Element_Attributes$inlineStyle(
																			{
																				ctor: '::',
																				_0: {ctor: '_Tuple2', _0: 'display', _1: 'block'},
																				_1: {ctor: '[]'}
																			});
																	}
																}(),
																_1: {ctor: '[]'}
															}
														},
														elements))),
											_1: {ctor: '[]'}
										}
									}),
								_1: {
									ctor: '::',
									_0: _rtfeldman$elm_css$Html_Styled$fromUnstyled(
										A2(
											_mdgriffith$style_elements$Element$toHtml,
											_user$project$Styles$stylesheet,
											A3(
												_mdgriffith$style_elements$Element$el,
												_user$project$Styles$ExtraInfo,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$padding(5),
													_1: {
														ctor: '::',
														_0: A2(_mdgriffith$style_elements$Element_Attributes$spacingXY, 0, 5),
														_1: {ctor: '[]'}
													}
												},
												innerEls(info)))),
									_1: {ctor: '[]'}
								}
							}))),
				_1: {ctor: '[]'}
			};
		};
		var _p8 = maybeInfo;
		if (_p8.ctor === 'Just') {
			return wrapper(_p8._0);
		} else {
			return elements;
		}
	});
var _user$project$Helpers_Views_Form$elLinkLabel = F2(
	function (label, urlLink) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$Label,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(
					_mdgriffith$style_elements$Element_Attributes$percent(50)),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$NoStyle,
							{ctor: '[]'},
							_mdgriffith$style_elements$Element$text(label)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_mdgriffith$style_elements$Element$newTab,
						urlLink,
						A3(
							_mdgriffith$style_elements$Element$image,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(12)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(10),
									_1: {
										ctor: '::',
										_0: A2(_mdgriffith$style_elements$Element_Attributes$spacingXY, 5, 0),
										_1: {ctor: '[]'}
									}
								}
							},
							{src: './images/infoblue.svg', caption: 'plus d\'information'})),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elDefaultLabel = F2(
	function (label, labelwidth) {
		return A3(
			_mdgriffith$style_elements$Element$el,
			_user$project$Styles$Label,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(
					_mdgriffith$style_elements$Element_Attributes$percent(labelwidth)),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			_mdgriffith$style_elements$Element$text(label));
	});
var _user$project$Helpers_Views_Form$elLabelInfo = F2(
	function (label, labelwidth) {
		return _mdgriffith$style_elements$Element$html(
			_rtfeldman$elm_css$Html_Styled$toUnstyled(
				A2(
					_rtfeldman$elm_css$Html_Styled$div,
					{
						ctor: '::',
						_0: _rtfeldman$elm_css$Html_Styled_Attributes$css(
							{
								ctor: '::',
								_0: _rtfeldman$elm_css$Css$display(_rtfeldman$elm_css$Css$block),
								_1: {
									ctor: '::',
									_0: _rtfeldman$elm_css$Css$width(
										A3(
											_rtfeldman$elm_css$Css$calc,
											_rtfeldman$elm_css$Css$pct(50),
											_rtfeldman$elm_css$Css$minus,
											_rtfeldman$elm_css$Css$px(6))),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _rtfeldman$elm_css$Html_Styled$fromUnstyled(
							A2(
								_mdgriffith$style_elements$Element$toHtml,
								_user$project$Styles$stylesheet,
								A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, 100))),
						_1: {ctor: '[]'}
					})));
	});
var _user$project$Helpers_Views_Form$elPoints = function (mayPoints) {
	var _p9 = mayPoints;
	if (_p9.ctor === 'Nothing') {
		return _mdgriffith$style_elements$Element$empty;
	} else {
		return A3(
			_mdgriffith$style_elements$Element$el,
			_user$project$Styles$LabelPoints,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(
					_mdgriffith$style_elements$Element_Attributes$percent(12)),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			_mdgriffith$style_elements$Element$text(
				_elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(_p9._0),
						_1: {
							ctor: '::',
							_0: ' Pts',
							_1: {ctor: '[]'}
						}
					})));
	}
};
var _user$project$Helpers_Views_Form$elInput2 = F9(
	function (label, labelwidth, updatemsg, validationData, isDisabled, placeholder, maybevalue, maybeUrlLink, maybePoints) {
		var isValidStyle = function () {
			var _p10 = validationData.isValid;
			if (_p10 === true) {
				return _user$project$Styles$Input;
			} else {
				return _user$project$Styles$InputNotValid;
			}
		}();
		var value = A2(_elm_lang$core$Maybe$withDefault, '', maybevalue);
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: function () {
							var _p11 = maybeUrlLink;
							if (_p11.ctor === 'Nothing') {
								return A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, labelwidth);
							} else {
								return A2(_user$project$Helpers_Views_Form$elLinkLabel, label, _p11._0);
							}
						}(),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$row,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element_Input$text,
										isValidStyle,
										{
											ctor: '::',
											_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 4),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
												_1: {ctor: '[]'}
											}
										},
										{
											onChange: updatemsg,
											value: value,
											label: _mdgriffith$style_elements$Element_Input$placeholder(
												{
													label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
													text: placeholder
												}),
											options: isDisabled ? {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Input$disabled,
												_1: {ctor: '[]'}
											} : {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: _user$project$Helpers_Views_Form$elPoints(maybePoints),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: function () {
								if (validationData.displayMessage) {
									var _p12 = validationData.mayMessage;
									if (_p12.ctor === 'Just') {
										return A3(
											_mdgriffith$style_elements$Element$el,
											_user$project$Styles$FormValidationError,
											{ctor: '[]'},
											_mdgriffith$style_elements$Element$text(_p12._0));
									} else {
										return _mdgriffith$style_elements$Element$empty;
									}
								} else {
									return _mdgriffith$style_elements$Element$empty;
								}
							}(),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elInputWithExpanders = F9(
	function (label, labelwidth, updatemsg, validationData, isDisabled, placeholder, maybevalue, maybeInfo, maybePoints) {
		var isValidStyle = function () {
			var _p13 = validationData.isValid;
			if (_p13 === true) {
				return _user$project$Styles$Input;
			} else {
				return _user$project$Styles$InputNotValid;
			}
		}();
		var value = A2(_elm_lang$core$Maybe$withDefault, '', maybevalue);
		var element = {
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$row,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: function () {
						var _p14 = maybeInfo;
						if (_p14.ctor === 'Just') {
							return A2(_user$project$Helpers_Views_Form$elLabelInfo, label, labelwidth);
						} else {
							return A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, labelwidth);
						}
					}(),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$row,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element_Input$text,
									isValidStyle,
									{
										ctor: '::',
										_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 4),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
											_1: {ctor: '[]'}
										}
									},
									{
										onChange: updatemsg,
										value: value,
										label: _mdgriffith$style_elements$Element_Input$placeholder(
											{
												label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
												text: placeholder
											}),
										options: isDisabled ? {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Input$disabled,
											_1: {ctor: '[]'}
										} : {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: _user$project$Helpers_Views_Form$elPoints(maybePoints),
							_1: {ctor: '[]'}
						}
					}
				}),
			_1: {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: function () {
							if (validationData.displayMessage) {
								var _p15 = validationData.mayMessage;
								if (_p15.ctor === 'Just') {
									return A3(
										_mdgriffith$style_elements$Element$el,
										_user$project$Styles$FormValidationError,
										{ctor: '[]'},
										_mdgriffith$style_elements$Element$text(_p15._0));
								} else {
									return _mdgriffith$style_elements$Element$empty;
								}
							} else {
								return _mdgriffith$style_elements$Element$empty;
							}
						}(),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		};
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			A3(_user$project$Helpers_Views_Form$wrapInSummary, element, maybeInfo, false));
	});
var _user$project$Helpers_Views_Form$elRadioBool = function (updateMsg) {
	return function (labelwidth) {
		return function (label) {
			return function (labelTrue) {
				return function (labelFalse) {
					return function (isMandatory) {
						return function (isDisabled) {
							return function (maySelected) {
								return function (maybeUrlLink) {
									return function (maybePoints) {
										var options = function () {
											var _p16 = isDisabled;
											if (_p16 === true) {
												return {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Input$disabled,
													_1: {ctor: '[]'}
												};
											} else {
												return {ctor: '[]'};
											}
										}();
										return A3(
											_mdgriffith$style_elements$Element$column,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: function () {
															var _p17 = maybeUrlLink;
															if (_p17.ctor === 'Nothing') {
																return A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, labelwidth);
															} else {
																return A2(_user$project$Helpers_Views_Form$elLinkLabel, label, _p17._0);
															}
														}(),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$spacing(15),
																		_1: {ctor: '[]'}
																	}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element_Input$radioRow,
																		_user$project$Styles$NoStyle,
																		{ctor: '[]'},
																		{
																			onChange: updateMsg,
																			selected: maySelected,
																			label: _mdgriffith$style_elements$Element_Input$labelLeft(
																				_mdgriffith$style_elements$Element$text('')),
																			options: options,
																			choices: function () {
																				if (!isMandatory) {
																					return {
																						ctor: '::',
																						_0: A2(
																							_mdgriffith$style_elements$Element_Input$choice,
																							true,
																							A3(
																								_mdgriffith$style_elements$Element$el,
																								_user$project$Styles$NoStyle,
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$width(
																										_mdgriffith$style_elements$Element_Attributes$percent(50)),
																									_1: {
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Element_Attributes$center,
																										_1: {ctor: '[]'}
																									}
																								},
																								_mdgriffith$style_elements$Element$text(labelTrue))),
																						_1: {
																							ctor: '::',
																							_0: A2(
																								_mdgriffith$style_elements$Element_Input$choice,
																								false,
																								A3(
																									_mdgriffith$style_elements$Element$el,
																									_user$project$Styles$NoStyle,
																									{
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Element_Attributes$width(
																											_mdgriffith$style_elements$Element_Attributes$percent(50)),
																										_1: {
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Attributes$center,
																											_1: {ctor: '[]'}
																										}
																									},
																									_mdgriffith$style_elements$Element$text(labelFalse))),
																							_1: {ctor: '[]'}
																						}
																					};
																				} else {
																					var _p18 = maySelected;
																					if (_p18.ctor === 'Just') {
																						return {
																							ctor: '::',
																							_0: A2(
																								_mdgriffith$style_elements$Element_Input$styledChoice,
																								true,
																								function (selected) {
																									return A3(
																										_mdgriffith$style_elements$Element$row,
																										_user$project$Styles$NoStyle,
																										{
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Attributes$width(
																												_mdgriffith$style_elements$Element_Attributes$percent(50)),
																											_1: {
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																												_1: {
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
																													_1: {ctor: '[]'}
																												}
																											}
																										},
																										{
																											ctor: '::',
																											_0: A3(
																												_mdgriffith$style_elements$Element$el,
																												_user$project$Styles$NoStyle,
																												{
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																													_1: {ctor: '[]'}
																												},
																												selected ? A3(
																													_mdgriffith$style_elements$Element$image,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$height(
																															_mdgriffith$style_elements$Element_Attributes$px(12)),
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$width(
																																_mdgriffith$style_elements$Element_Attributes$px(12)),
																															_1: {ctor: '[]'}
																														}
																													},
																													{src: './images/radioBtnSel.svg', caption: 'selected'}) : A3(
																													_mdgriffith$style_elements$Element$image,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$height(
																															_mdgriffith$style_elements$Element_Attributes$px(12)),
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$width(
																																_mdgriffith$style_elements$Element_Attributes$px(12)),
																															_1: {ctor: '[]'}
																														}
																													},
																													{src: './images/radioBtnNotSel.svg', caption: 'unselected'})),
																											_1: {
																												ctor: '::',
																												_0: A3(
																													_mdgriffith$style_elements$Element$el,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(5),
																															_1: {ctor: '[]'}
																														}
																													},
																													_mdgriffith$style_elements$Element$text(labelTrue)),
																												_1: {ctor: '[]'}
																											}
																										});
																								}),
																							_1: {
																								ctor: '::',
																								_0: A2(
																									_mdgriffith$style_elements$Element_Input$styledChoice,
																									false,
																									function (selected) {
																										return A3(
																											_mdgriffith$style_elements$Element$row,
																											_user$project$Styles$NoStyle,
																											{
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$width(
																													_mdgriffith$style_elements$Element_Attributes$percent(50)),
																												_1: {
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																													_1: {
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
																														_1: {ctor: '[]'}
																													}
																												}
																											},
																											{
																												ctor: '::',
																												_0: A3(
																													_mdgriffith$style_elements$Element$el,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																														_1: {ctor: '[]'}
																													},
																													selected ? A3(
																														_mdgriffith$style_elements$Element$image,
																														_user$project$Styles$NoStyle,
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$height(
																																_mdgriffith$style_elements$Element_Attributes$px(12)),
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element_Attributes$width(
																																	_mdgriffith$style_elements$Element_Attributes$px(12)),
																																_1: {ctor: '[]'}
																															}
																														},
																														{src: './images/radioBtnSel.svg', caption: 'selected'}) : A3(
																														_mdgriffith$style_elements$Element$image,
																														_user$project$Styles$NoStyle,
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$height(
																																_mdgriffith$style_elements$Element_Attributes$px(12)),
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element_Attributes$width(
																																	_mdgriffith$style_elements$Element_Attributes$px(12)),
																																_1: {ctor: '[]'}
																															}
																														},
																														{src: './images/radioBtnNotSel.svg', caption: 'unselected'})),
																												_1: {
																													ctor: '::',
																													_0: A3(
																														_mdgriffith$style_elements$Element$el,
																														_user$project$Styles$NoStyle,
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(5),
																																_1: {ctor: '[]'}
																															}
																														},
																														_mdgriffith$style_elements$Element$text(labelFalse)),
																													_1: {ctor: '[]'}
																												}
																											});
																									}),
																								_1: {ctor: '[]'}
																							}
																						};
																					} else {
																						return {
																							ctor: '::',
																							_0: A2(
																								_mdgriffith$style_elements$Element_Input$styledChoice,
																								true,
																								function (selected) {
																									return A3(
																										_mdgriffith$style_elements$Element$row,
																										_user$project$Styles$NoStyle,
																										{
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Attributes$width(
																												_mdgriffith$style_elements$Element_Attributes$percent(50)),
																											_1: {
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																												_1: {
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
																													_1: {ctor: '[]'}
																												}
																											}
																										},
																										{
																											ctor: '::',
																											_0: A3(
																												_mdgriffith$style_elements$Element$el,
																												_user$project$Styles$NoStyle,
																												{
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																													_1: {ctor: '[]'}
																												},
																												A3(
																													_mdgriffith$style_elements$Element$image,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$height(
																															_mdgriffith$style_elements$Element_Attributes$px(12)),
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$width(
																																_mdgriffith$style_elements$Element_Attributes$px(12)),
																															_1: {ctor: '[]'}
																														}
																													},
																													{src: './images/radioBtnUndef.svg', caption: 'undefined'})),
																											_1: {
																												ctor: '::',
																												_0: A3(
																													_mdgriffith$style_elements$Element$el,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(5),
																															_1: {ctor: '[]'}
																														}
																													},
																													_mdgriffith$style_elements$Element$text(labelTrue)),
																												_1: {ctor: '[]'}
																											}
																										});
																								}),
																							_1: {
																								ctor: '::',
																								_0: A2(
																									_mdgriffith$style_elements$Element_Input$styledChoice,
																									false,
																									function (selected) {
																										return A3(
																											_mdgriffith$style_elements$Element$row,
																											_user$project$Styles$NoStyle,
																											{
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$width(
																													_mdgriffith$style_elements$Element_Attributes$percent(50)),
																												_1: {
																													ctor: '::',
																													_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																													_1: {
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
																														_1: {ctor: '[]'}
																													}
																												}
																											},
																											{
																												ctor: '::',
																												_0: A3(
																													_mdgriffith$style_elements$Element$el,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																														_1: {ctor: '[]'}
																													},
																													A3(
																														_mdgriffith$style_elements$Element$image,
																														_user$project$Styles$NoStyle,
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$height(
																																_mdgriffith$style_elements$Element_Attributes$px(12)),
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element_Attributes$width(
																																	_mdgriffith$style_elements$Element_Attributes$px(12)),
																																_1: {ctor: '[]'}
																															}
																														},
																														{src: './images/radioBtnUndef.svg', caption: 'undefined'})),
																												_1: {
																													ctor: '::',
																													_0: A3(
																														_mdgriffith$style_elements$Element$el,
																														_user$project$Styles$NoStyle,
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(5),
																																_1: {ctor: '[]'}
																															}
																														},
																														_mdgriffith$style_elements$Element$text(labelFalse)),
																													_1: {ctor: '[]'}
																												}
																											});
																									}),
																								_1: {ctor: '[]'}
																							}
																						};
																					}
																				}
																			}()
																		}),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: _user$project$Helpers_Views_Form$elPoints(maybePoints),
																_1: {ctor: '[]'}
															}
														}
													}),
												_1: {ctor: '[]'}
											});
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$elRadioBoolWithExpanders = F7(
	function (updateMsg, labelwidth, label, isDisabled, maySelected, maybeInfo, maybePoints) {
		var options = function () {
			var _p19 = isDisabled;
			if (_p19 === true) {
				return {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Input$disabled,
					_1: {ctor: '[]'}
				};
			} else {
				return {ctor: '[]'};
			}
		}();
		var element = {
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$row,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: function () {
						var _p20 = maybeInfo;
						if (_p20.ctor === 'Just') {
							return A2(_user$project$Helpers_Views_Form$elLabelInfo, label, labelwidth);
						} else {
							return A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, labelwidth);
						}
					}(),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$row,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(15),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element_Input$radioRow,
									_user$project$Styles$NoStyle,
									{ctor: '[]'},
									{
										onChange: updateMsg,
										selected: maySelected,
										label: _mdgriffith$style_elements$Element_Input$labelLeft(
											_mdgriffith$style_elements$Element$text('')),
										options: options,
										choices: {
											ctor: '::',
											_0: A2(
												_mdgriffith$style_elements$Element_Input$choice,
												true,
												A3(
													_mdgriffith$style_elements$Element$el,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(
															_mdgriffith$style_elements$Element_Attributes$percent(50)),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$center,
															_1: {ctor: '[]'}
														}
													},
													_mdgriffith$style_elements$Element$text('Oui'))),
											_1: {
												ctor: '::',
												_0: A2(
													_mdgriffith$style_elements$Element_Input$choice,
													false,
													A3(
														_mdgriffith$style_elements$Element$el,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(
																_mdgriffith$style_elements$Element_Attributes$percent(50)),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$center,
																_1: {ctor: '[]'}
															}
														},
														_mdgriffith$style_elements$Element$text('Non'))),
												_1: {ctor: '[]'}
											}
										}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: _user$project$Helpers_Views_Form$elPoints(maybePoints),
							_1: {ctor: '[]'}
						}
					}
				}),
			_1: {ctor: '[]'}
		};
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			A3(_user$project$Helpers_Views_Form$wrapInSummary, element, maybeInfo, false));
	});
var _user$project$Helpers_Views_Form$elInput = F4(
	function (elLabel, updatemsg, inValue, isvalid) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(50)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element_Input$text,
						_user$project$Styles$Input,
						{ctor: '[]'},
						{
							onChange: updatemsg,
							value: inValue,
							label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
							options: isvalid ? {ctor: '[]'} : {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Input$disabled,
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$htmlFLabel = F7(
	function (toUiTxt, elId, elLabel, inValue, divclass, labelclass, inputclass) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(divclass),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$label,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$for(elId),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(labelclass),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							toUiTxt(elLabel)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$label,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id(elId),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class(inputclass),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(inValue),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elNewTab = F3(
	function (elLabel, url, string) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(50)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$percent(50)),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element$newTab,
								url,
								A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$HyperLink,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text(string))),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$htmlTextLabel = F7(
	function (toUiTxt, elId, elLabel, inValue, divclass, labelclass, inputclass) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(divclass),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$label,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$for(elId),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(
								A2(_elm_lang$core$Basics_ops['++'], labelclass, ' align-top')),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							toUiTxt(elLabel)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id(elId),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class(
									A2(_elm_lang$core$Basics_ops['++'], inputclass, ' d-inline-block')),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(inValue),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elTextLabel = F2(
	function (elLabel, inValue) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(50)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$percent(50)),
							_1: {ctor: '[]'}
						},
						_mdgriffith$style_elements$Element$text(inValue)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$htmlLabel = F7(
	function (toUiTxt, elId, elLabel, inValue, divclass, labelclass, inputclass) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(divclass),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$label,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$for(elId),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(labelclass),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							toUiTxt(elLabel)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$label,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id(elId),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class(inputclass),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(inValue),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elLabelTT = F5(
	function (elLabel, inValue, istt, ttmsg, tooltip) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: istt ? A3(
					_mdgriffith$style_elements$Element$column,
					_user$project$Styles$Modal,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$toAttr(
								_elm_lang$html$Html_Attributes$style(
									{
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'position', _1: 'absolute'},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'z-index', _1: '10'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'padding', _1: '10px'},
												_1: {ctor: '[]'}
											}
										}
									})),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Events$onMouseLeave(ttmsg),
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$html(tooltip)),
						_1: {ctor: '[]'}
					}) : _mdgriffith$style_elements$Element$empty,
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$row,
								_user$project$Styles$Label,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$percent(50)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Events$onMouseDown(ttmsg),
											_1: {ctor: '[]'}
										}
									}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$row,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {ctor: '[]'}
											}
										},
										{
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$el,
												_user$project$Styles$NoStyle,
												{ctor: '[]'},
												_mdgriffith$style_elements$Element$text(elLabel)),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$image,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(
													_mdgriffith$style_elements$Element_Attributes$px(12)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(10),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onClick(ttmsg),
														_1: {ctor: '[]'}
													}
												}
											},
											{src: './images/infoblue.svg', caption: 'infoBtn'}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$NoStyle,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$width(
											_mdgriffith$style_elements$Element_Attributes$percent(50)),
										_1: {ctor: '[]'}
									},
									_mdgriffith$style_elements$Element$text(inValue)),
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elLabelSized = F3(
	function (size, elLabel, inValue) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(size)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {ctor: '[]'}
						},
						_mdgriffith$style_elements$Element$text(inValue)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elLabel2 = F5(
	function (label, labelwidth, inValue, maybeUrlLink, maybePoints) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: function () {
					var _p21 = maybeUrlLink;
					if (_p21.ctor === 'Nothing') {
						return A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, 50);
					} else {
						return A2(_user$project$Helpers_Views_Form$elLinkLabel, label, _p21._0);
					}
				}(),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {ctor: '[]'}
						},
						_mdgriffith$style_elements$Element$text(inValue)),
					_1: {
						ctor: '::',
						_0: _user$project$Helpers_Views_Form$elPoints(maybePoints),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Helpers_Views_Form$elLabel = F2(
	function (elLabel, inValue) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(50)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$percent(50)),
							_1: {ctor: '[]'}
						},
						_mdgriffith$style_elements$Element$text(inValue)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$viewOptionStatic = F3(
	function (targVal, optVal, optTxt) {
		var selectedAttr = _elm_lang$core$Native_Utils.eq(targVal, optVal) ? _elm_lang$html$Html_Attributes$selected(true) : _elm_lang$html$Html_Attributes$selected(false);
		return A2(
			_elm_lang$html$Html$option,
			{
				ctor: '::',
				_0: selectedAttr,
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(optVal),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(optTxt),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$viewOption = F4(
	function (mayToUiTxt, targVal, optVal, optTxt) {
		var selectedAttr = _elm_lang$core$Native_Utils.eq(targVal, optVal) ? _elm_lang$html$Html_Attributes$selected(true) : _elm_lang$html$Html_Attributes$selected(false);
		return A2(
			_elm_lang$html$Html$option,
			{
				ctor: '::',
				_0: selectedAttr,
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(optVal),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					A2(_user$project$Helpers_Views_Text$toUiTextOrSelf, mayToUiTxt, optTxt)),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$displayBasicOptions = F4(
	function (toUiTxt, targVal, optVal, optTxt) {
		return A3(
			_elm_lang$core$List$map2,
			A2(
				_user$project$Helpers_Views_Form$viewOption,
				_elm_lang$core$Maybe$Just(toUiTxt),
				targVal),
			optVal,
			optTxt);
	});
var _user$project$Helpers_Views_Form$elSelect = F6(
	function (toUiTxt, elLabel, updatemsg, inValue, options, isvalid) {
		var isValidStyle = function () {
			var _p22 = isvalid;
			if (_p22 === true) {
				return _user$project$Styles$NoStyle;
			} else {
				return _user$project$Styles$NotValid;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(50)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						isValidStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$html(
								A2(
									_elm_lang$html$Html$select,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(_elm_lang$html$Html_Events$on, 'change', updatemsg),
											_1: {ctor: '[]'}
										}
									},
									A4(_user$project$Helpers_Views_Form$displayBasicOptions, toUiTxt, inValue, options, options))),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elSelectTT = F9(
	function (toUiTxt, elLabel, updatemsg, inValue, options, isvalid, istt, ttmsg, tooltip) {
		var isValidStyle = function () {
			var _p23 = isvalid;
			if (_p23 === true) {
				return _user$project$Styles$NoStyle;
			} else {
				return _user$project$Styles$NotValid;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: istt ? A3(
					_mdgriffith$style_elements$Element$column,
					_user$project$Styles$Modal,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$toAttr(
								_elm_lang$html$Html_Attributes$style(
									{
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'position', _1: 'absolute'},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'z-index', _1: '10'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'padding', _1: '10px'},
												_1: {ctor: '[]'}
											}
										}
									})),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Events$onMouseLeave(ttmsg),
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$html(tooltip)),
						_1: {ctor: '[]'}
					}) : _mdgriffith$style_elements$Element$empty,
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$row,
								_user$project$Styles$Label,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$percent(50)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Events$onMouseDown(ttmsg),
											_1: {ctor: '[]'}
										}
									}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$row,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {ctor: '[]'}
											}
										},
										{
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$el,
												_user$project$Styles$NoStyle,
												{ctor: '[]'},
												_mdgriffith$style_elements$Element$text(elLabel)),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$image,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(
													_mdgriffith$style_elements$Element_Attributes$px(12)),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(10),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onClick(ttmsg),
														_1: {ctor: '[]'}
													}
												}
											},
											{src: './images/infoblue.svg', caption: 'infoBtn'}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$row,
									isValidStyle,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element$html(
											A2(
												_elm_lang$html$Html$select,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
															_1: {ctor: '[]'}
														}),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$html$Html_Events$on, 'change', updatemsg),
														_1: {ctor: '[]'}
													}
												},
												A4(_user$project$Helpers_Views_Form$displayBasicOptions, toUiTxt, inValue, options, options))),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elSelectSized = F8(
	function (toUiTxt, size, elLabel, updatemsg, inValue, options, isvalid, isDisabled) {
		var isValidStyle = function () {
			var _p24 = isvalid;
			if (_p24 === true) {
				return _user$project$Styles$NoStyle;
			} else {
				return _user$project$Styles$NotValid;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(size)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(elLabel)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						isValidStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$html(
								A2(
									_elm_lang$html$Html$select,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(_elm_lang$html$Html_Events$on, 'change', updatemsg),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$disabled(isDisabled),
												_1: {ctor: '[]'}
											}
										}
									},
									A4(_user$project$Helpers_Views_Form$displayBasicOptions, toUiTxt, inValue, options, options))),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$htmlSelect = function (toUiTxt) {
	return function (elId) {
		return function (elLabel) {
			return function (updatemsg) {
				return function (inValue) {
					return function (options) {
						return function (isvalid) {
							return function (divclass) {
								return function (labelclass) {
									return function (selectclass) {
										return A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class(divclass),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$label,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$for(elId),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class(labelclass),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text(
															toUiTxt(elLabel)),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$select,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$id(elId),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class(
																	isvalid ? selectclass : A2(_elm_lang$core$Basics_ops['++'], selectclass, ' is-invalid')),
																_1: {
																	ctor: '::',
																	_0: A2(_elm_lang$html$Html_Events$on, 'change', updatemsg),
																	_1: {ctor: '[]'}
																}
															}
														},
														A4(_user$project$Helpers_Views_Form$displayBasicOptions, toUiTxt, inValue, options, options)),
													_1: {ctor: '[]'}
												}
											});
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$elComboList = function (toUiTxt) {
	return function (key) {
		return function (invalue) {
			return function (updatemsg) {
				return function (options) {
					return function (isvalid) {
						return function (items) {
							return function (targetview) {
								return function (onclick) {
									return function (placeholder) {
										return A3(
											_mdgriffith$style_elements$Element$column,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element_Keyed$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: key,
															_1: _mdgriffith$style_elements$Element$html(
																A2(
																	_elm_lang$html$Html$select,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$style(
																			{
																				ctor: '::',
																				_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
																				_1: {ctor: '[]'}
																			}),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_elm_lang$html$Html_Events$on,
																				'change',
																				A2(_elm_lang$core$Json_Decode$map, updatemsg, _elm_lang$html$Html_Events$targetValue)),
																			_1: {ctor: '[]'}
																		}
																	},
																	A4(_user$project$Helpers_Views_Form$displayBasicOptions, toUiTxt, invalue, options, options)))
														},
														_1: {
															ctor: '::',
															_0: {
																ctor: '_Tuple2',
																_0: 'button',
																_1: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: isvalid ? A3(
																			_mdgriffith$style_elements$Element$image,
																			_user$project$Styles$DocAddBtn,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$height(
																					_mdgriffith$style_elements$Element_Attributes$px(20)),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$px(20)),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Events$onClick(onclick),
																						_1: {ctor: '[]'}
																					}
																				}
																			},
																			{src: './images/add.svg', caption: 'add'}) : A3(
																			_mdgriffith$style_elements$Element$image,
																			_user$project$Styles$DocDisabledBtn,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$height(
																					_mdgriffith$style_elements$Element_Attributes$px(20)),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$px(20)),
																					_1: {ctor: '[]'}
																				}
																			},
																			{src: './images/add.svg', caption: 'add'}),
																		_1: {ctor: '[]'}
																	})
															},
															_1: {ctor: '[]'}
														}
													}),
												_1: {
													ctor: '::',
													_0: _elm_lang$core$List$isEmpty(items) ? _mdgriffith$style_elements$Element$empty : A3(
														_mdgriffith$style_elements$Element$column,
														_user$project$Styles$NoStyle,
														{ctor: '[]'},
														A2(_elm_lang$core$List$map, targetview, items)),
													_1: {ctor: '[]'}
												}
											});
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$displayBasicAndStaticOptions = F4(
	function (toUiTxt, targVal, uiOptions, staticOptions) {
		var htmlStaticOptions = A3(
			_elm_lang$core$List$map2,
			_user$project$Helpers_Views_Form$viewOptionStatic(targVal),
			staticOptions,
			staticOptions);
		var htmlUiOptions = A3(
			_elm_lang$core$List$map2,
			A2(
				_user$project$Helpers_Views_Form$viewOption,
				_elm_lang$core$Maybe$Just(toUiTxt),
				targVal),
			uiOptions,
			uiOptions);
		return _elm_lang$core$List$concat(
			{
				ctor: '::',
				_0: htmlUiOptions,
				_1: {
					ctor: '::',
					_0: htmlStaticOptions,
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$datepickerSettings = _elm_lang$core$Native_Utils.update(
	_elm_community$elm_datepicker$DatePicker$defaultSettings,
	{
		inputId: _elm_lang$core$Maybe$Just('elmdatepicker'),
		inputClassList: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'w-100', _1: true},
			_1: {ctor: '[]'}
		},
		placeholder: 'jj.mm.aaaa',
		dateFormatter: function (d) {
			return _user$project$Helpers_Views_Text$dateToString(d);
		},
		parser: function (s) {
			return _user$project$Helpers_Views_Text$toDateFromString(s);
		}
	});
var _user$project$Helpers_Views_Form$elDatePicker = F6(
	function (toUiTxt, elLabel, docdate, datePicker, setDatePicker, isvalid) {
		var isValidStyle = function () {
			var _p25 = isvalid;
			if (_p25 === true) {
				return _user$project$Styles$NoStyle;
			} else {
				return _user$project$Styles$NotValid;
			}
		}();
		var datePickClass = {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'w-100', _1: true},
			_1: {ctor: '[]'}
		};
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$Label,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$percent(50)),
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$text(elLabel)),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$el,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$percent(50)),
									_1: {ctor: '[]'}
								},
								_mdgriffith$style_elements$Element$html(
									A2(
										_elm_lang$html$Html$map,
										setDatePicker,
										A3(
											_elm_community$elm_datepicker$DatePicker$view,
											docdate,
											_elm_lang$core$Native_Utils.update(
												_user$project$Helpers_Views_Form$datepickerSettings,
												{
													placeholder: toUiTxt('gen_date_placeholder'),
													inputClassList: datePickClass
												}),
											datePicker)))),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$htmlDatePicker = F8(
	function (toUiTxt, elId, elLabel, docdate, datePicker, setDatePicker, divclass, labelclass) {
		var dpclasses = (!_elm_lang$core$Native_Utils.eq(docdate, _elm_lang$core$Maybe$Nothing)) ? {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'form-control', _1: true},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'col-sm-7', _1: true},
				_1: {ctor: '[]'}
			}
		} : {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'form-control', _1: true},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'col-sm-7', _1: true},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'is-invalid', _1: true},
					_1: {ctor: '[]'}
				}
			}
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(divclass),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$label,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$for(elId),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(labelclass),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							toUiTxt(elLabel)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						setDatePicker,
						A3(
							_elm_community$elm_datepicker$DatePicker$view,
							docdate,
							_elm_lang$core$Native_Utils.update(
								_user$project$Helpers_Views_Form$datepickerSettings,
								{inputClassList: dpclasses}),
							datePicker)),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('invalid-feedback'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									toUiTxt('gen_select_invalid_help')),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Helpers_Views_Form$invalidColor = 'rgb(255,220,220)';
var _user$project$Helpers_Views_Form$elSelect2 = function (toUiTxt) {
	return function (label) {
		return function (labelwidth) {
			return function (onchangemsg) {
				return function (isvalid) {
					return function (isDisabled) {
						return function (options) {
							return function (placeholder) {
								return function (maySize) {
									return function (maybevalue) {
										return function (maybeUrlLink) {
											return function (maybePoints) {
												var optSize = function () {
													var _p26 = maySize;
													if (_p26.ctor === 'Just') {
														return {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html_Attributes$attribute,
																'size',
																_elm_lang$core$Basics$toString(_p26._0)),
															_1: {ctor: '[]'}
														};
													} else {
														return {ctor: '[]'};
													}
												}();
												var _p27 = function () {
													var _p28 = maybevalue;
													if (_p28.ctor === 'Nothing') {
														return isvalid ? {
															ctor: '_Tuple3',
															_0: '',
															_1: true,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														} : {
															ctor: '_Tuple3',
															_0: '',
															_1: true,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: _user$project$Helpers_Views_Form$invalidColor},
																		_1: {ctor: '[]'}
																	}
																})
														};
													} else {
														var _p29 = _p28._0;
														return isvalid ? (isDisabled ? {
															ctor: '_Tuple3',
															_0: _p29,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														} : {
															ctor: '_Tuple3',
															_0: _p29,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'black'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														}) : (isDisabled ? {
															ctor: '_Tuple3',
															_0: _p29,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														} : {
															ctor: '_Tuple3',
															_0: _p29,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'black'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: _user$project$Helpers_Views_Form$invalidColor},
																		_1: {ctor: '[]'}
																	}
																})
														});
													}
												}();
												var value = _p27._0;
												var isEmptySelected = _p27._1;
												var htmlStyle = _p27._2;
												var selOptions = function () {
													var _p30 = placeholder;
													if (_p30.ctor === 'Nothing') {
														return A2(
															_elm_lang$core$List$map,
															A2(_user$project$Helpers_Views_Form$elSelect2Option, toUiTxt, value),
															options);
													} else {
														return {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$option,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$selected(isEmptySelected),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$disabled(true),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$hidden(true),
																			_1: {ctor: '[]'}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html$text(
																		toUiTxt(_p30._0)),
																	_1: {ctor: '[]'}
																}),
															_1: A2(
																_elm_lang$core$List$map,
																A2(_user$project$Helpers_Views_Form$elSelect2Option, toUiTxt, value),
																options)
														};
													}
												}();
												var selAttribs = A2(
													_elm_lang$core$List$append,
													optSize,
													{
														ctor: '::',
														_0: htmlStyle,
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'border', _1: '1px solid lightgrey'},
																		_1: {
																			ctor: '::',
																			_0: {ctor: '_Tuple2', _0: 'border-radius', _1: '2px'},
																			_1: {ctor: '[]'}
																		}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html_Events$on,
																	'change',
																	A2(_elm_lang$core$Json_Decode$map, onchangemsg, _elm_lang$html$Html_Events$targetValue)),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$disabled(isDisabled),
																	_1: {ctor: '[]'}
																}
															}
														}
													});
												return A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: function () {
															var _p31 = maybeUrlLink;
															if (_p31.ctor === 'Nothing') {
																return A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, labelwidth);
															} else {
																return A2(_user$project$Helpers_Views_Form$elLinkLabel, label, _p31._0);
															}
														}(),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$Input,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
																		_1: {ctor: '[]'}
																	}
																},
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element$html(
																		A2(_elm_lang$html$Html$select, selAttribs, selOptions)),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: _user$project$Helpers_Views_Form$elPoints(maybePoints),
																_1: {ctor: '[]'}
															}
														}
													});
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$elSelectWithExpanders = function (toUiTxt) {
	return function (label) {
		return function (labelwidth) {
			return function (onchangemsg) {
				return function (isvalid) {
					return function (isDisabled) {
						return function (options) {
							return function (placeholder) {
								return function (maySize) {
									return function (maybevalue) {
										return function (maybeInfo) {
											return function (maybePoints) {
												var optSize = function () {
													var _p32 = maySize;
													if (_p32.ctor === 'Just') {
														return {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html_Attributes$attribute,
																'size',
																_elm_lang$core$Basics$toString(_p32._0)),
															_1: {ctor: '[]'}
														};
													} else {
														return {ctor: '[]'};
													}
												}();
												var _p33 = function () {
													var _p34 = maybevalue;
													if (_p34.ctor === 'Nothing') {
														return isvalid ? {
															ctor: '_Tuple3',
															_0: '',
															_1: true,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														} : {
															ctor: '_Tuple3',
															_0: '',
															_1: true,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: _user$project$Helpers_Views_Form$invalidColor},
																		_1: {ctor: '[]'}
																	}
																})
														};
													} else {
														var _p35 = _p34._0;
														return isvalid ? (isDisabled ? {
															ctor: '_Tuple3',
															_0: _p35,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														} : {
															ctor: '_Tuple3',
															_0: _p35,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'black'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														}) : (isDisabled ? {
															ctor: '_Tuple3',
															_0: _p35,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'grey'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(246 245 244)'},
																		_1: {ctor: '[]'}
																	}
																})
														} : {
															ctor: '_Tuple3',
															_0: _p35,
															_1: false,
															_2: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'color', _1: 'black'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'background-color', _1: _user$project$Helpers_Views_Form$invalidColor},
																		_1: {ctor: '[]'}
																	}
																})
														});
													}
												}();
												var value = _p33._0;
												var isEmptySelected = _p33._1;
												var htmlStyle = _p33._2;
												var selOptions = function () {
													var _p36 = placeholder;
													if (_p36.ctor === 'Nothing') {
														return A2(
															_elm_lang$core$List$map,
															A2(_user$project$Helpers_Views_Form$elSelect2Option, toUiTxt, value),
															options);
													} else {
														return {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$option,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$selected(isEmptySelected),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$disabled(true),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$hidden(true),
																			_1: {ctor: '[]'}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html$text(
																		toUiTxt(_p36._0)),
																	_1: {ctor: '[]'}
																}),
															_1: A2(
																_elm_lang$core$List$map,
																A2(_user$project$Helpers_Views_Form$elSelect2Option, toUiTxt, value),
																options)
														};
													}
												}();
												var selAttribs = A2(
													_elm_lang$core$List$append,
													optSize,
													{
														ctor: '::',
														_0: htmlStyle,
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$style(
																{
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'border', _1: '1px solid lightgrey'},
																		_1: {
																			ctor: '::',
																			_0: {ctor: '_Tuple2', _0: 'border-radius', _1: '2px'},
																			_1: {ctor: '[]'}
																		}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html_Events$on,
																	'change',
																	A2(_elm_lang$core$Json_Decode$map, onchangemsg, _elm_lang$html$Html_Events$targetValue)),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$disabled(isDisabled),
																	_1: {ctor: '[]'}
																}
															}
														}
													});
												var element = {
													ctor: '::',
													_0: function () {
														var _p37 = maybeInfo;
														if (_p37.ctor === 'Just') {
															return A2(_user$project$Helpers_Views_Form$elLabelInfo, label, labelwidth);
														} else {
															return A2(_user$project$Helpers_Views_Form$elDefaultLabel, label, labelwidth);
														}
													}(),
													_1: {
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$row,
															_user$project$Styles$Input,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
																	_1: {ctor: '[]'}
																}
															},
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element$html(
																	A2(_elm_lang$html$Html$select, selAttribs, selOptions)),
																_1: {ctor: '[]'}
															}),
														_1: {
															ctor: '::',
															_0: _user$project$Helpers_Views_Form$elPoints(maybePoints),
															_1: {ctor: '[]'}
														}
													}
												};
												return A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {ctor: '[]'}
													},
													A3(_user$project$Helpers_Views_Form$wrapInSummary, element, maybeInfo, true));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Helpers_Views_Form$htmlTextarea2 = F8(
	function (label, labelwidth, updatemsg, isvalid, isDisabled, nbchar, placeholder, maybevalue) {
		var nbrows = function () {
			var _p38 = maybevalue;
			if (_p38.ctor === 'Nothing') {
				return 3;
			} else {
				var _p39 = _p38._0;
				var charlines = _elm_lang$core$Basics$round(
					_elm_lang$core$Basics$toFloat(
						_elm_lang$core$Basics$round(
							_elm_lang$core$Basics$toFloat(
								_elm_lang$core$String$length(_p39)) / nbchar)) / 2);
				var nblines = _elm_lang$core$List$length(
					_elm_lang$core$String$lines(_p39));
				var minValue = A2(_elm_lang$core$Basics$max, 3, nblines + charlines);
				return A2(_elm_lang$core$Basics$min, minValue, 12);
			}
		}();
		var inValue = function () {
			var _p40 = maybevalue;
			if (_p40.ctor === 'Nothing') {
				return '';
			} else {
				return _p40._0;
			}
		}();
		var attributes = function () {
			var disabled = isDisabled ? {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'color', _1: 'black'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'border-color', _1: 'lightgrey'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'resize', _1: 'none'},
									_1: {ctor: '[]'}
								}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$disabled(isDisabled),
					_1: {ctor: '[]'}
				}
			} : {ctor: '[]'};
			var valid = isvalid ? {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			} : {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'background-color', _1: _user$project$Helpers_Views_Form$invalidColor},
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			};
			var base = {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$value(inValue),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$rows(nbrows),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$style(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'padding', _1: '4px 2px'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'border', _1: '1px solid lightgrey'},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'border-radius', _1: '2px'},
											_1: {ctor: '[]'}
										}
									}
								}
							}),
						_1: {ctor: '[]'}
					}
				}
			};
			var _p41 = updatemsg;
			if (_p41.ctor === 'Nothing') {
				return _elm_lang$core$List$concat(
					{
						ctor: '::',
						_0: base,
						_1: {
							ctor: '::',
							_0: valid,
							_1: {
								ctor: '::',
								_0: disabled,
								_1: {ctor: '[]'}
							}
						}
					});
			} else {
				return _elm_lang$core$List$concat(
					{
						ctor: '::',
						_0: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onInput(_p41._0),
							_1: {ctor: '[]'}
						},
						_1: {
							ctor: '::',
							_0: base,
							_1: {
								ctor: '::',
								_0: valid,
								_1: {
									ctor: '::',
									_0: disabled,
									_1: {ctor: '[]'}
								}
							}
						}
					});
			}
		}();
		var isValidStyle = function () {
			var _p42 = isvalid;
			if (_p42 === true) {
				return _user$project$Styles$NoStyle;
			} else {
				return _user$project$Styles$NotValid;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: (_elm_lang$core$Native_Utils.cmp(labelwidth, 75) > 0) ? A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(label)) : A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$Label,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$percent(labelwidth)),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(label)),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$row,
						isValidStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$html(
								A2(
									_elm_lang$html$Html$textarea,
									attributes,
									{ctor: '[]'})),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_Form$elDatePicker2 = F8(
	function (label, labelwidth, datePicker, setDatePicker, isvalid, isDisabled, placeholder, date) {
		var isValidStyle = function () {
			var _p43 = isvalid;
			if (_p43 === true) {
				return {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(
						{
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'rgb(238,236,234)'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'border', _1: '1px solid lightgrey'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'border-radius', _1: '2px'},
									_1: {ctor: '[]'}
								}
							}
						}),
					_1: {ctor: '[]'}
				};
			} else {
				return {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(
						{
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'background-color', _1: _user$project$Helpers_Views_Form$invalidColor},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'border', _1: '1px solid lightgrey'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'border-radius', _1: '2px'},
									_1: {ctor: '[]'}
								}
							}
						}),
					_1: {ctor: '[]'}
				};
			}
		}();
		var datePickClass = {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'w-100', _1: true},
			_1: {ctor: '[]'}
		};
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$Label,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$percent(labelwidth)),
								_1: {ctor: '[]'}
							},
							_mdgriffith$style_elements$Element$text(label)),
						_1: {
							ctor: '::',
							_0: isDisabled ? A3(
								_mdgriffith$style_elements$Element$el,
								_user$project$Styles$Input,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 4, 0),
										_1: {ctor: '[]'}
									}
								},
								_mdgriffith$style_elements$Element$text('')) : A3(
								_mdgriffith$style_elements$Element$el,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {ctor: '[]'}
								},
								_mdgriffith$style_elements$Element$html(
									A2(
										_elm_lang$html$Html$map,
										setDatePicker,
										A3(
											_elm_community$elm_datepicker$DatePicker$view,
											date,
											_elm_lang$core$Native_Utils.update(
												_user$project$Helpers_Views_Form$datepickerSettings,
												{placeholder: placeholder, inputClassList: datePickClass, inputAttributes: isValidStyle}),
											datePicker)))),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Form$isValid = F2(
	function (unsetOption, value) {
		return !_elm_lang$core$Native_Utils.eq(value, unsetOption);
	});
var _user$project$Helpers_Views_Form$ExtraInfo = F2(
	function (a, b) {
		return {content: a, mayLink: b};
	});

var _user$project$Ports$storeSession = _elm_lang$core$Native_Platform.outgoingPort(
	'storeSession',
	function (v) {
		return (v.ctor === 'Nothing') ? null : v._0;
	});
var _user$project$Ports$openLink = _elm_lang$core$Native_Platform.outgoingPort(
	'openLink',
	function (v) {
		return {
			token: (v.token.ctor === 'Nothing') ? null : v.token._0,
			url: v.url
		};
	});
var _user$project$Ports$onSessionChange = _elm_lang$core$Native_Platform.incomingPort('onSessionChange', _elm_lang$core$Json_Decode$string);
var _user$project$Ports$getAreaAndPlace = _elm_lang$core$Native_Platform.outgoingPort(
	'getAreaAndPlace',
	function (v) {
		return v;
	});
var _user$project$Ports$inboundArea = _elm_lang$core$Native_Platform.incomingPort('inboundArea', _elm_lang$core$Json_Decode$float);
var _user$project$Ports$inboundPlace = _elm_lang$core$Native_Platform.incomingPort('inboundPlace', _elm_lang$core$Json_Decode$string);
var _user$project$Ports$getPlaces = _elm_lang$core$Native_Platform.outgoingPort(
	'getPlaces',
	function (v) {
		return v;
	});
var _user$project$Ports$inboundPlaces = _elm_lang$core$Native_Platform.incomingPort(
	'inboundPlaces',
	_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string));
var _user$project$Ports$getZone = _elm_lang$core$Native_Platform.outgoingPort(
	'getZone',
	function (v) {
		return v;
	});
var _user$project$Ports$inboundZone = _elm_lang$core$Native_Platform.incomingPort('inboundZone', _elm_lang$core$Json_Decode$string);
var _user$project$Ports$getPlotData = _elm_lang$core$Native_Platform.outgoingPort(
	'getPlotData',
	function (v) {
		return {x: v.x, y: v.y};
	});
var _user$project$Ports$inboundPlot = _elm_lang$core$Native_Platform.incomingPort(
	'inboundPlot',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (canton) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (url) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (geom) {
							return _elm_lang$core$Json_Decode$succeed(
								{canton: canton, url: url, geom: geom});
						},
						A2(_elm_lang$core$Json_Decode$field, 'geom', _elm_lang$core$Json_Decode$value));
				},
				A2(_elm_lang$core$Json_Decode$field, 'url', _elm_lang$core$Json_Decode$string));
		},
		A2(_elm_lang$core$Json_Decode$field, 'canton', _elm_lang$core$Json_Decode$string)));
var _user$project$Ports$getExtent = _elm_lang$core$Native_Platform.outgoingPort(
	'getExtent',
	function (v) {
		return {
			geoObjs: _elm_lang$core$Native_List.toArray(v.geoObjs).map(
				function (v) {
					return {
						id: v.id,
						obj: (v.obj.ctor === 'Nothing') ? null : v.obj._0,
						layerKey: v.layerKey
					};
				}),
			geoZones: _elm_lang$core$Native_List.toArray(v.geoZones).map(
				function (v) {
					return {name: v.name, geoZone: v.geoZone};
				})
		};
	});
var _user$project$Ports$inboundInitParams = _elm_lang$core$Native_Platform.incomingPort(
	'inboundInitParams',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (extent) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (center) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (zoom) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (geoZones) {
									return _elm_lang$core$Json_Decode$succeed(
										{extent: extent, center: center, zoom: zoom, geoZones: geoZones});
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'geoZones',
									_elm_lang$core$Json_Decode$list(
										A2(
											_elm_lang$core$Json_Decode$andThen,
											function (name) {
												return A2(
													_elm_lang$core$Json_Decode$andThen,
													function (geoZone) {
														return _elm_lang$core$Json_Decode$succeed(
															{name: name, geoZone: geoZone});
													},
													A2(_elm_lang$core$Json_Decode$field, 'geoZone', _elm_lang$core$Json_Decode$value));
											},
											A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string)))));
						},
						A2(_elm_lang$core$Json_Decode$field, 'zoom', _elm_lang$core$Json_Decode$float));
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'center',
					A2(
						_elm_lang$core$Json_Decode$andThen,
						function (x) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (y) {
									return _elm_lang$core$Json_Decode$succeed(
										{x: x, y: y});
								},
								A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float));
						},
						A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float))));
		},
		A2(
			_elm_lang$core$Json_Decode$field,
			'extent',
			A2(
				_elm_lang$core$Json_Decode$andThen,
				function (minx) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (miny) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (maxx) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (maxy) {
											return _elm_lang$core$Json_Decode$succeed(
												{minx: minx, miny: miny, maxx: maxx, maxy: maxy});
										},
										A2(_elm_lang$core$Json_Decode$field, 'maxy', _elm_lang$core$Json_Decode$float));
								},
								A2(_elm_lang$core$Json_Decode$field, 'maxx', _elm_lang$core$Json_Decode$float));
						},
						A2(_elm_lang$core$Json_Decode$field, 'miny', _elm_lang$core$Json_Decode$float));
				},
				A2(_elm_lang$core$Json_Decode$field, 'minx', _elm_lang$core$Json_Decode$float)))));
var _user$project$Ports$exportData = _elm_lang$core$Native_Platform.outgoingPort(
	'exportData',
	function (v) {
		return {target: v.target, filename: v.filename, dataset: v.dataset};
	});
var _user$project$Ports$PlotData = F3(
	function (a, b, c) {
		return {canton: a, url: b, geom: c};
	});
var _user$project$Ports$GeoObjData = F3(
	function (a, b, c) {
		return {id: a, obj: b, layerKey: c};
	});
var _user$project$Ports$InitParams = F4(
	function (a, b, c, d) {
		return {extent: a, center: b, zoom: c, geoZones: d};
	});
var _user$project$Ports$GeoZone = F2(
	function (a, b) {
		return {name: a, geoZone: b};
	});

var _user$project$Requests_Variety$find = F5(
	function (baseUrl, mayToken, queryString, filterField, mayLimit) {
		var strLimit = function () {
			var _p0 = mayLimit;
			if (_p0.ctor === 'Nothing') {
				return '';
			} else {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'&$limit=',
					_elm_lang$core$Basics$toString(_p0._0));
			}
		}();
		var finalUrl = _elm_lang$core$String$concat(
			{
				ctor: '::',
				_0: baseUrl,
				_1: {
					ctor: '::',
					_0: 'variety?',
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							filterField,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'[$ilike]=',
								A2(_elm_lang$core$Basics_ops['++'], queryString, '%25'))),
						_1: {
							ctor: '::',
							_0: strLimit,
							_1: {ctor: '[]'}
						}
					}
				}
			});
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: finalUrl,
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(
					_elm_lang$core$Json_Decode$list(_user$project$Data_Variety$decoder)),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});

var _user$project$Helpers_Views_DataSearch$dataSearchInputStyle = _elm_lang$html$Html_Attributes$style(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'width', _1: '210px'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'bottom', _1: '8px'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
				_1: {ctor: '[]'}
			}
		}
	});
var _user$project$Helpers_Views_DataSearch$dataListItemStyle = _elm_lang$html$Html_Attributes$style(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'margin', _1: '0px 2px'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'width', _1: '180px'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'height', _1: '16px'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'white-space', _1: 'nowrap'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'overflow', _1: 'hidden'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'text-overflow', _1: 'ellipsis'},
							_1: {ctor: '[]'}
						}
					}
				}
			}
		}
	});
var _user$project$Helpers_Views_DataSearch$dataListStyle = _elm_lang$html$Html_Attributes$style(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'margin', _1: '0px'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'padding', _1: '0px'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'list-style-type', _1: 'none'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: '185px'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'height', _1: 'auto'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'max-height', _1: '400px'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'white-space', _1: 'nowrap'},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'overflow-x', _1: 'hidden'},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'overflow-y', _1: 'auto'},
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var _user$project$Helpers_Views_DataSearch$dataListDivStyle = _elm_lang$html$Html_Attributes$style(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'position', _1: 'absolute'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'top', _1: '12px'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'padding', _1: '8px 2px'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'background', _1: 'white'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'border', _1: '2px solid darkgrey'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'border-radius', _1: '3px'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'width', _1: '190px'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'resize', _1: 'horizontal'},
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}
		}
	});
var _user$project$Helpers_Views_DataSearch$dataSearchContainerStyle = _elm_lang$html$Html_Attributes$style(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'float', _1: 'left'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'position', _1: 'relative'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'cursor', _1: 'default'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '0px'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'margin-top', _1: '8px'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'height', _1: '14px'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'z-index', _1: '100'},
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		}
	});

var _user$project$Helpers_Views_DatalistElement$delay = F2(
	function (time, msg) {
		return A2(
			_elm_lang$core$Task$perform,
			function (_p0) {
				return msg;
			},
			_elm_lang$core$Process$sleep(time));
	});
var _user$project$Helpers_Views_DatalistElement$getPartialItemAsString = F3(
	function (variety, isLatin, isLowerKey) {
		var strVariety = isLatin ? variety.latinName : variety.commonName;
		var _p1 = isLowerKey;
		if (_p1 === true) {
			return _elm_lang$core$String$toLower(strVariety);
		} else {
			return strVariety;
		}
	});
var _user$project$Helpers_Views_DatalistElement$viewSearchEntry = F4(
	function (toMsg, toUiTxt, isLatin, item) {
		return _elm_lang$html$Html$text(
			A3(_user$project$Helpers_Views_DatalistElement$getPartialItemAsString, item, isLatin, false));
	});
var _user$project$Helpers_Views_DatalistElement$defaultSearchData = {
	listItem: {ctor: '[]'},
	queryString: '',
	isSearchListVisible: false,
	highLightedSearchPoint: _elm_lang$core$Maybe$Nothing
};
var _user$project$Helpers_Views_DatalistElement$Model = function (a) {
	return {mode: a};
};
var _user$project$Helpers_Views_DatalistElement$SearchData = F4(
	function (a, b, c, d) {
		return {listItem: a, queryString: b, isSearchListVisible: c, highLightedSearchPoint: d};
	});
var _user$project$Helpers_Views_DatalistElement$Search = function (a) {
	return {ctor: 'Search', _0: a};
};
var _user$project$Helpers_Views_DatalistElement$Visualization = function (a) {
	return {ctor: 'Visualization', _0: a};
};
var _user$project$Helpers_Views_DatalistElement$init = function (mayVariety) {
	var mode = function () {
		var _p2 = mayVariety;
		if (_p2.ctor === 'Just') {
			return _user$project$Helpers_Views_DatalistElement$Visualization(_p2._0);
		} else {
			return _user$project$Helpers_Views_DatalistElement$Search(_user$project$Helpers_Views_DatalistElement$defaultSearchData);
		}
	}();
	return {mode: mode};
};
var _user$project$Helpers_Views_DatalistElement$RemoveItem = {ctor: 'RemoveItem'};
var _user$project$Helpers_Views_DatalistElement$viewVisualization = F4(
	function (toMsg, toUiTxt, isLatin, item) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(
						A3(_user$project$Helpers_Views_DatalistElement$getPartialItemAsString, item, isLatin, false))),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$image,
						_user$project$Styles$DocDeleteBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(
								_mdgriffith$style_elements$Element_Attributes$px(20)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(20)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										toMsg(_user$project$Helpers_Views_DatalistElement$RemoveItem)),
									_1: {ctor: '[]'}
								}
							}
						},
						{src: './images/delete.svg', caption: 'remove'}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_DatalistElement$ItemsReceived = function (a) {
	return {ctor: 'ItemsReceived', _0: a};
};
var _user$project$Helpers_Views_DatalistElement$SearchItemMouseDown = {ctor: 'SearchItemMouseDown'};
var _user$project$Helpers_Views_DatalistElement$SearchItemMouseOver = function (a) {
	return {ctor: 'SearchItemMouseOver', _0: a};
};
var _user$project$Helpers_Views_DatalistElement$SearchItemSelected = function (a) {
	return {ctor: 'SearchItemSelected', _0: a};
};
var _user$project$Helpers_Views_DatalistElement$SearchInputBlured = {ctor: 'SearchInputBlured'};
var _user$project$Helpers_Views_DatalistElement$SearchInputFocused = {ctor: 'SearchInputFocused'};
var _user$project$Helpers_Views_DatalistElement$SearchChanged = F2(
	function (a, b) {
		return {ctor: 'SearchChanged', _0: a, _1: b};
	});
var _user$project$Helpers_Views_DatalistElement$viewSearch = F4(
	function (toMsg, toUiTxt, isLatin, searchData) {
		var sortedList = isLatin ? A2(
			_elm_lang$core$List$sortBy,
			function (_) {
				return _.latinName;
			},
			searchData.listItem) : A2(
			_elm_lang$core$List$sortBy,
			function (_) {
				return _.commonName;
			},
			searchData.listItem);
		var listItemsHtml = A2(
			_elm_lang$core$List$map,
			function (item) {
				return A2(
					_elm_lang$html$Html$li,
					{
						ctor: '::',
						_0: _user$project$Helpers_Views_DataSearch$dataListItemStyle,
						_1: {
							ctor: '::',
							_0: A3(
								_elm_lang$html$Html_Events$onWithOptions,
								'mousedown',
								{stopPropagation: false, preventDefault: true},
								_elm_lang$core$Json_Decode$succeed(
									toMsg(_user$project$Helpers_Views_DatalistElement$SearchItemMouseDown))),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									toMsg(
										_user$project$Helpers_Views_DatalistElement$SearchItemSelected(item))),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onMouseOver(
										toMsg(
											_user$project$Helpers_Views_DatalistElement$SearchItemMouseOver(
												_elm_lang$core$Maybe$Just(item.id)))),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: function () {
												var _p3 = searchData.highLightedSearchPoint;
												if (_p3.ctor === 'Nothing') {
													return _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
															_1: {ctor: '[]'}
														});
												} else {
													return _elm_lang$core$Native_Utils.eq(
														_elm_lang$core$Maybe$Just(_p3._0),
														_elm_lang$core$Maybe$Just(item.id)) ? _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'lightgrey'},
															_1: {ctor: '[]'}
														}) : _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
															_1: {ctor: '[]'}
														});
												}
											}(),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					},
					{
						ctor: '::',
						_0: A4(_user$project$Helpers_Views_DatalistElement$viewSearchEntry, toMsg, toUiTxt, isLatin, item),
						_1: {ctor: '[]'}
					});
			},
			sortedList);
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$html(
						A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _user$project$Helpers_Views_DataSearch$dataSearchContainerStyle,
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _user$project$Helpers_Views_DataSearch$dataListDivStyle,
										_1: {
											ctor: '::',
											_0: searchData.isSearchListVisible ? _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'visible'},
													_1: {ctor: '[]'}
												}) : _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'collapse'},
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$ul,
											{
												ctor: '::',
												_0: _user$project$Helpers_Views_DataSearch$dataListStyle,
												_1: {ctor: '[]'}
											},
											listItemsHtml),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}))),
				_1: {
					ctor: '::',
					_0: A6(
						_user$project$Helpers_Views_Form$elSearch2,
						function (_p4) {
							return toMsg(
								A2(_user$project$Helpers_Views_DatalistElement$SearchChanged, isLatin, _p4));
						},
						toMsg(_user$project$Helpers_Views_DatalistElement$SearchInputFocused),
						toMsg(_user$project$Helpers_Views_DatalistElement$SearchInputBlured),
						true,
						false,
						toUiTxt('data_search')),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_DatalistElement$view = F4(
	function (toMsg, toUiTxt, isLatin, model) {
		var _p5 = model.mode;
		if (_p5.ctor === 'Visualization') {
			return A4(_user$project$Helpers_Views_DatalistElement$viewVisualization, toMsg, toUiTxt, isLatin, _p5._0);
		} else {
			return A4(_user$project$Helpers_Views_DatalistElement$viewSearch, toMsg, toUiTxt, isLatin, _p5._0);
		}
	});
var _user$project$Helpers_Views_DatalistElement$ItemSelected = function (a) {
	return {ctor: 'ItemSelected', _0: a};
};
var _user$project$Helpers_Views_DatalistElement$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Helpers_Views_DatalistElement$update = F5(
	function (toMsg, session, msg, model, baseUrl) {
		var currentSearchData = function () {
			var _p6 = model.mode;
			if (_p6.ctor === 'Search') {
				return _p6._0;
			} else {
				return _user$project$Helpers_Views_DatalistElement$defaultSearchData;
			}
		}();
		var _p7 = msg;
		switch (_p7.ctor) {
			case 'SearchChanged':
				var _p10 = _p7._1;
				var findItemsCmd = _p7._0 ? A2(
					_elm_lang$http$Http$send,
					function (_p8) {
						return toMsg(
							_user$project$Helpers_Views_DatalistElement$ItemsReceived(_p8));
					},
					A5(
						_user$project$Requests_Variety$find,
						baseUrl,
						session.token,
						_p10,
						'latin_name',
						_elm_lang$core$Maybe$Just(12))) : A2(
					_elm_lang$http$Http$send,
					function (_p9) {
						return toMsg(
							_user$project$Helpers_Views_DatalistElement$ItemsReceived(_p9));
					},
					A5(
						_user$project$Requests_Variety$find,
						baseUrl,
						session.token,
						_p10,
						'common_name',
						_elm_lang$core$Maybe$Just(12)));
				var newSearchData = _elm_lang$core$Native_Utils.update(
					currentSearchData,
					{queryString: _p10});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistElement$Search(newSearchData)
						}),
					_1: findItemsCmd,
					_2: _user$project$Helpers_Views_DatalistElement$NoOutMsg
				};
			case 'SearchInputFocused':
				var newSearchData = _elm_lang$core$Native_Utils.update(
					currentSearchData,
					{isSearchListVisible: true});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistElement$Search(newSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Helpers_Views_DatalistElement$NoOutMsg
				};
			case 'SearchInputBlured':
				var _p11 = model.mode;
				if (_p11.ctor === 'Search') {
					var newSearchData = _elm_lang$core$Native_Utils.update(
						currentSearchData,
						{isSearchListVisible: false, queryString: ''});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								mode: _user$project$Helpers_Views_DatalistElement$Search(newSearchData)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Helpers_Views_DatalistElement$NoOutMsg
					};
				} else {
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistElement$NoOutMsg};
				}
			case 'SearchItemSelected':
				var _p12 = _p7._0;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistElement$Visualization(_p12)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Helpers_Views_DatalistElement$ItemSelected(
						_elm_lang$core$Maybe$Just(_p12))
				};
			case 'SearchItemMouseOver':
				var _p13 = model.mode;
				if (_p13.ctor === 'Search') {
					var newSearchData = _elm_lang$core$Native_Utils.update(
						currentSearchData,
						{highLightedSearchPoint: _p7._0});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								mode: _user$project$Helpers_Views_DatalistElement$Search(newSearchData)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Helpers_Views_DatalistElement$NoOutMsg
					};
				} else {
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistElement$NoOutMsg};
				}
			case 'SearchItemMouseDown':
				return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistElement$NoOutMsg};
			case 'ItemsReceived':
				if (_p7._0.ctor === 'Ok') {
					var newSearchData = _elm_lang$core$Native_Utils.update(
						currentSearchData,
						{listItem: _p7._0._0});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								mode: _user$project$Helpers_Views_DatalistElement$Search(newSearchData)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Helpers_Views_DatalistElement$NoOutMsg
					};
				} else {
					var _p14 = A2(_elm_lang$core$Debug$log, 'Error: Coudn\'t get items -', _p7._0._0);
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistElement$NoOutMsg};
				}
			default:
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistElement$Search(_user$project$Helpers_Views_DatalistElement$defaultSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Helpers_Views_DatalistElement$ItemSelected(_elm_lang$core$Maybe$Nothing)
				};
		}
	});

var _user$project$Requests_IsolatedTree$openLink = F4(
	function (mayToken, baseUrl, fileId, fileName) {
		var tokenStr = _user$project$Helpers_Data_JwtToken$toString(mayToken);
		var urlStr = A2(
			_elm_lang$core$Basics_ops['++'],
			baseUrl,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'filesservice/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					fileId,
					A2(_elm_lang$core$Basics_ops['++'], '/?filename=', fileName))));
		return _user$project$Ports$openLink(
			{token: tokenStr, url: urlStr});
	});
var _user$project$Requests_IsolatedTree$save = F3(
	function (baseUrl, mayToken, data) {
		var saveBaseUrl = A2(_elm_lang$core$Basics_ops['++'], baseUrl, 'isolatedtree/');
		var _p0 = function () {
			var _p1 = data.id;
			if (_p1.ctor === 'Nothing') {
				return {ctor: '_Tuple2', _0: 'POST', _1: saveBaseUrl};
			} else {
				return {
					ctor: '_Tuple2',
					_0: 'PATCH',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						saveBaseUrl,
						_elm_lang$core$Basics$toString(_p1._0))
				};
			}
		}();
		var method = _p0._0;
		var url = _p0._1;
		return _elm_lang$http$Http$request(
			{
				method: method,
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: url,
				body: _elm_lang$http$Http$jsonBody(
					A2(_user$project$Data_Tree$encoder, false, data)),
				expect: _elm_lang$http$Http$expectJson(_user$project$Data_Tree$idDecoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});
var _user$project$Requests_IsolatedTree$getById = F3(
	function (baseUrl, mayToken, id) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: A2(
					_elm_lang$core$Basics_ops['++'],
					baseUrl,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'isolatedtree/',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(id),
							'?$eager=[variety,documents]&$modify={\"formatGeom\":[\"GeoJSON\",2]}'))),
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(_user$project$Data_Tree$decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});

var _user$project$Requests_Contact$save = F3(
	function (baseUrl, mayToken, data) {
		var saveBaseUrl = A2(_elm_lang$core$Basics_ops['++'], baseUrl, 'contact/');
		var _p0 = function () {
			var _p1 = data.id;
			if (_p1.ctor === 'Nothing') {
				return {ctor: '_Tuple2', _0: 'POST', _1: saveBaseUrl};
			} else {
				return {
					ctor: '_Tuple2',
					_0: 'PATCH',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						saveBaseUrl,
						_elm_lang$core$Basics$toString(_p1._0))
				};
			}
		}();
		var method = _p0._0;
		var url = _p0._1;
		return _elm_lang$http$Http$request(
			{
				method: method,
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: url,
				body: _elm_lang$http$Http$jsonBody(
					_user$project$Data_Contact$encoder(data)),
				expect: _elm_lang$http$Http$expectJson(_user$project$Data_Contact$decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});
var _user$project$Requests_Contact$getAll = function (mayToken) {
	return _elm_lang$http$Http$request(
		{
			method: 'GET',
			headers: A2(
				_user$project$Helpers_Data_JwtToken$addAuthHeader,
				{ctor: '[]'},
				mayToken),
			url: './contact?',
			body: _elm_lang$http$Http$emptyBody,
			expect: _elm_lang$http$Http$expectJson(
				_elm_lang$core$Json_Decode$list(_user$project$Data_Contact$decoder)),
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: true
		});
};
var _user$project$Requests_Contact$getById = F3(
	function (baseUrl, mayToken, id) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: A2(
					_elm_lang$core$Basics_ops['++'],
					baseUrl,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'contact/',
						_elm_lang$core$Basics$toString(id))),
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(_user$project$Data_Contact$decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});

var _user$project$Requests_ComputeScore$byAttributes = F4(
	function (baseUrl, mayToken, treeForm, mayTreeAge) {
		var mayVarietyId = A2(
			_elm_lang$core$Maybe$map,
			function ($var) {
				return $var.id;
			},
			treeForm.variety);
		var toMaybeString = _elm_lang$core$Maybe$map(
			function (val) {
				return _elm_lang$core$Basics$toString(val);
			});
		var withDefault = _elm_lang$core$Maybe$withDefault('null');
		var params = A2(
			_elm_lang$core$String$join,
			'&',
			{
				ctor: '::',
				_0: _elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: 'variety_id=',
						_1: {
							ctor: '::',
							_0: withDefault(
								toMaybeString(mayVarietyId)),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$String$concat(
						{
							ctor: '::',
							_0: 'circumference=',
							_1: {
								ctor: '::',
								_0: withDefault(
									toMaybeString(treeForm.circumference)),
								_1: {ctor: '[]'}
							}
						}),
					_1: {
						ctor: '::',
						_0: _elm_lang$core$String$concat(
							{
								ctor: '::',
								_0: 'is_multitrunk=',
								_1: {
									ctor: '::',
									_0: withDefault(
										toMaybeString(treeForm.isMultiTrunk)),
									_1: {ctor: '[]'}
								}
							}),
						_1: {
							ctor: '::',
							_0: _elm_lang$core$String$concat(
								{
									ctor: '::',
									_0: 'crown_development=',
									_1: {
										ctor: '::',
										_0: withDefault(treeForm.crownDevelopment),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: _elm_lang$core$String$concat(
									{
										ctor: '::',
										_0: 'age=',
										_1: {
											ctor: '::',
											_0: withDefault(
												toMaybeString(mayTreeAge)),
											_1: {ctor: '[]'}
										}
									}),
								_1: {
									ctor: '::',
									_0: _elm_lang$core$String$concat(
										{
											ctor: '::',
											_0: 'is_more_than_100_years=',
											_1: {
												ctor: '::',
												_0: withDefault(
													toMaybeString(treeForm.isMoreThan100Years)),
												_1: {ctor: '[]'}
											}
										}),
									_1: {
										ctor: '::',
										_0: _elm_lang$core$String$concat(
											{
												ctor: '::',
												_0: 'has_socio_historical_interest=',
												_1: {
													ctor: '::',
													_0: withDefault(
														toMaybeString(treeForm.hasSocioHistoricalInterest)),
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: _elm_lang$core$String$concat(
												{
													ctor: '::',
													_0: 'has_landscape_interest=',
													_1: {
														ctor: '::',
														_0: withDefault(
															toMaybeString(treeForm.hasLandscapeInterest)),
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _elm_lang$core$String$concat(
													{
														ctor: '::',
														_0: 'ecosystem_situation=',
														_1: {
															ctor: '::',
															_0: withDefault(treeForm.ecosystemSituation),
															_1: {ctor: '[]'}
														}
													}),
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				}
			});
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: A2(
					_elm_lang$core$Basics_ops['++'],
					baseUrl,
					A2(_elm_lang$core$Basics_ops['++'], 'compute_score?', params)),
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(_user$project$Data_Tree$decoderAttributesScore),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});

var _user$project$Requests_File$upload = F3(
	function (uploadUrl, headers, file) {
		return _elm_lang$http$Http$request(
			{
				method: 'POST',
				headers: headers,
				url: uploadUrl,
				body: _elm_lang$http$Http$multipartBody(
					{
						ctor: '::',
						_0: A2(_simonh1000$file_reader$FileReader$filePart, 'upload', file),
						_1: {ctor: '[]'}
					}),
				expect: _elm_lang$http$Http$expectString,
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});

var _user$project$Views_Document$viewGetFileLink = F4(
	function (dwnldUrl, queryParams, fileId, fileName) {
		return A2(
			_elm_lang$html$Html$a,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$href(
					A2(
						_elm_lang$core$Basics_ops['++'],
						dwnldUrl,
						A2(
							_elm_lang$core$Basics_ops['++'],
							fileId,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'/?filename=',
								A2(
									_elm_lang$core$Basics_ops['++'],
									fileName,
									A2(_elm_lang$core$Basics_ops['++'], '&', queryParams)))))),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$target('_blank'),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(fileName),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_Document$viewVis = F5(
	function (toMsg, toUiTxt, style, state, document) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			style,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 10),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_user$project$Helpers_Views_Form$elLabel,
					toUiTxt('data_document_file'),
					A2(_user$project$Helpers_Views_Text$toTextOrDefault, '', document.filename)),
				_1: {
					ctor: '::',
					_0: A2(
						_user$project$Helpers_Views_Form$elLabel,
						toUiTxt('data_document_content'),
						toUiTxt(document.contentType)),
					_1: {
						ctor: '::',
						_0: A2(
							_user$project$Helpers_Views_Form$elLabel,
							toUiTxt('data_document_name'),
							A2(_user$project$Helpers_Views_Text$toTextOrDefault, '', document.name)),
						_1: {
							ctor: '::',
							_0: A2(
								_user$project$Helpers_Views_Form$elLabel,
								toUiTxt('data_document_description'),
								A2(_user$project$Helpers_Views_Text$toTextOrDefault, '', document.description)),
							_1: {
								ctor: '::',
								_0: A2(
									_user$project$Helpers_Views_Form$elLabel,
									toUiTxt('data_document_date'),
									A2(_user$project$Helpers_Views_Text$toDateString, document.date, '')),
								_1: {
									ctor: '::',
									_0: A2(
										_user$project$Helpers_Views_Form$elLabel,
										toUiTxt('data_document_author'),
										A2(_user$project$Helpers_Views_Text$toTextOrDefault, '', document.author)),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			});
	});
var _user$project$Views_Document$delay = F2(
	function (time, msg) {
		return A2(
			_elm_lang$core$Task$perform,
			function (_p0) {
				return msg;
			},
			_elm_lang$core$Process$sleep(time));
	});
var _user$project$Views_Document$State = F3(
	function (a, b, c) {
		return {datePicker: a, file: b, mode: c};
	});
var _user$project$Views_Document$MainEditMode = {ctor: 'MainEditMode'};
var _user$project$Views_Document$startEditing = function (state) {
	return _elm_lang$core$Native_Utils.update(
		state,
		{mode: _user$project$Views_Document$MainEditMode});
};
var _user$project$Views_Document$Visualization = {ctor: 'Visualization'};
var _user$project$Views_Document$CancelClicked = {ctor: 'CancelClicked'};
var _user$project$Views_Document$UploadDone = function (a) {
	return {ctor: 'UploadDone', _0: a};
};
var _user$project$Views_Document$UploadAndSubmitClicked = {ctor: 'UploadAndSubmitClicked'};
var _user$project$Views_Document$AuthorChanged = function (a) {
	return {ctor: 'AuthorChanged', _0: a};
};
var _user$project$Views_Document$DescChanged = function (a) {
	return {ctor: 'DescChanged', _0: a};
};
var _user$project$Views_Document$NameChanged = function (a) {
	return {ctor: 'NameChanged', _0: a};
};
var _user$project$Views_Document$ContentTypeChanged = function (a) {
	return {ctor: 'ContentTypeChanged', _0: a};
};
var _user$project$Views_Document$FilesSelect = F2(
	function (a, b) {
		return {ctor: 'FilesSelect', _0: a, _1: b};
	});
var _user$project$Views_Document$SetDatePicker = function (a) {
	return {ctor: 'SetDatePicker', _0: a};
};
var _user$project$Views_Document$init = F2(
	function (toMsg, isEdit) {
		var _p1 = _elm_community$elm_datepicker$DatePicker$init;
		var datePicker = _p1._0;
		var datePickerCmd = _p1._1;
		var state = A3(
			_user$project$Views_Document$State,
			datePicker,
			_elm_lang$core$Maybe$Nothing,
			isEdit ? _user$project$Views_Document$MainEditMode : _user$project$Views_Document$Visualization);
		var cmds = A2(
			_elm_lang$core$Platform_Cmd$map,
			function (_p2) {
				return toMsg(
					_user$project$Views_Document$SetDatePicker(_p2));
			},
			datePickerCmd);
		return {ctor: '_Tuple2', _0: state, _1: cmds};
	});
var _user$project$Views_Document$viewEdit = F4(
	function (toMsg, toUiTxt, state, document) {
		var isfilevalid = function () {
			var _p3 = document.filename;
			if (_p3.ctor === 'Nothing') {
				return false;
			} else {
				return true;
			}
		}();
		var isdoccontentvalid = A2(_elm_lang$core$List$member, document.contentType, _user$project$Data_Document$contentTypeOptions);
		var isValid = isdoccontentvalid && isfilevalid;
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$mainContent,
					_user$project$Styles$SmallFont,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(5),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$yScrollbar,
								_1: {ctor: '[]'}
							}
						}
					},
					A3(
						_mdgriffith$style_elements$Element$column,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
									_1: {ctor: '[]'}
								}
							}
						},
						{
							ctor: '::',
							_0: A3(
								_user$project$Helpers_Views_Form$elFile,
								toUiTxt,
								'data_document_loadfile',
								function (_p4) {
									return toMsg(
										A2(_user$project$Views_Document$FilesSelect, false, _p4));
								}),
							_1: {
								ctor: '::',
								_0: (!isfilevalid) ? _mdgriffith$style_elements$Element$empty : A3(
									_mdgriffith$style_elements$Element$column,
									_user$project$Styles$NoStyle,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: A2(
											_user$project$Helpers_Views_Form$elLabel,
											toUiTxt('data_document_selectedfile'),
											A2(_user$project$Helpers_Views_Text$toTextOrDefault, 'data_document_nofileselected', document.filename)),
										_1: {
											ctor: '::',
											_0: _user$project$Helpers_Views_Form$elSelect2(toUiTxt)(
												toUiTxt('data_document_content'))(50)(
												function (_p5) {
													return toMsg(
														_user$project$Views_Document$ContentTypeChanged(_p5));
												})(isdoccontentvalid)(false)(_user$project$Data_Document$contentTypeOptions)(
												_elm_lang$core$Maybe$Just('gen_select'))(_elm_lang$core$Maybe$Nothing)(
												_elm_lang$core$Maybe$Just(document.contentType))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
											_1: {
												ctor: '::',
												_0: A4(
													_user$project$Helpers_Views_Form$elInput,
													toUiTxt('data_document_name'),
													function (_p6) {
														return toMsg(
															_user$project$Views_Document$NameChanged(_p6));
													},
													A2(_user$project$Helpers_Views_Text$toTextOrDefault, '', document.name),
													true),
												_1: {
													ctor: '::',
													_0: A4(
														_user$project$Helpers_Views_Form$elTextarea,
														toUiTxt('data_document_description'),
														function (_p7) {
															return toMsg(
																_user$project$Views_Document$DescChanged(_p7));
														},
														A2(_user$project$Helpers_Views_Text$toTextOrDefault, '', document.description),
														true),
													_1: {
														ctor: '::',
														_0: A6(
															_user$project$Helpers_Views_Form$elDatePicker,
															toUiTxt,
															toUiTxt('data_document_date'),
															document.date,
															state.datePicker,
															function (_p8) {
																return toMsg(
																	_user$project$Views_Document$SetDatePicker(_p8));
															},
															true),
														_1: {
															ctor: '::',
															_0: A4(
																_user$project$Helpers_Views_Form$elInput,
																toUiTxt('data_document_author'),
																function (_p9) {
																	return toMsg(
																		_user$project$Views_Document$AuthorChanged(_p9));
																},
																A2(_user$project$Helpers_Views_Text$toTextOrDefault, '', document.author),
																true),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										}
									}),
								_1: {ctor: '[]'}
							}
						})),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$footer,
						_user$project$Styles$Footer,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
								_1: {ctor: '[]'}
							}
						},
						A7(
							_user$project$Helpers_Views_Form$elOkCancel,
							isValid,
							toUiTxt('gen_validate'),
							_user$project$Styles$EditBtn,
							toMsg(_user$project$Views_Document$UploadAndSubmitClicked),
							toUiTxt('gen_cancel'),
							_user$project$Styles$CancelBtn,
							toMsg(_user$project$Views_Document$CancelClicked))),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_Document$view = F6(
	function (toMsg, toUiTxt, state, isFtypeVisible, viewStyle, document) {
		var _p10 = state.mode;
		if (_p10.ctor === 'Visualization') {
			return A5(_user$project$Views_Document$viewVis, toMsg, toUiTxt, viewStyle, state, document);
		} else {
			return A4(_user$project$Views_Document$viewEdit, toMsg, toUiTxt, state, document);
		}
	});
var _user$project$Views_Document$DocErrored = function (a) {
	return {ctor: 'DocErrored', _0: a};
};
var _user$project$Views_Document$DocCancelled = {ctor: 'DocCancelled'};
var _user$project$Views_Document$DocDoneOk = {ctor: 'DocDoneOk'};
var _user$project$Views_Document$FileSelectMsg = function (a) {
	return {ctor: 'FileSelectMsg', _0: a};
};
var _user$project$Views_Document$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Views_Document$update = F6(
	function (toMsg, upldUrl, headers, msg, state, document) {
		var _p11 = msg;
		switch (_p11.ctor) {
			case 'SetDatePicker':
				var _p12 = A3(_elm_community$elm_datepicker$DatePicker$update, _user$project$Helpers_Views_Form$datepickerSettings, _p11._0, state.datePicker);
				var newDatePicker = _p12._0;
				var datePickerCmd = _p12._1;
				var dateEvent = _p12._2;
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{datePicker: newDatePicker});
				var _p13 = dateEvent;
				if (_p13.ctor === 'NoChange') {
					return {
						ctor: '_Tuple4',
						_0: newState,
						_1: document,
						_2: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (_p14) {
								return toMsg(
									_user$project$Views_Document$SetDatePicker(_p14));
							},
							datePickerCmd),
						_3: _user$project$Views_Document$NoOutMsg
					};
				} else {
					var newDoc = _elm_lang$core$Native_Utils.update(
						document,
						{date: _p13._0});
					return {
						ctor: '_Tuple4',
						_0: newState,
						_1: newDoc,
						_2: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (_p15) {
								return toMsg(
									_user$project$Views_Document$SetDatePicker(_p15));
							},
							datePickerCmd),
						_3: _user$project$Views_Document$NoOutMsg
					};
				}
			case 'FilesSelect':
				var _p20 = _p11._0;
				var _p16 = _elm_lang$core$List$head(_p11._1);
				if (_p16.ctor === 'Nothing') {
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							state,
							{file: _elm_lang$core$Maybe$Nothing}),
						_1: document,
						_2: _elm_lang$core$Platform_Cmd$none,
						_3: _user$project$Views_Document$NoOutMsg
					};
				} else {
					var _p19 = _p16._0;
					var fileCmd = function () {
						var _p17 = _p20;
						if (_p17 === true) {
							return _elm_lang$core$Platform_Cmd$batch(
								{
									ctor: '::',
									_0: A2(
										_user$project$Views_Document$delay,
										_elm_lang$core$Time$second * 0,
										toMsg(_user$project$Views_Document$UploadAndSubmitClicked)),
									_1: {ctor: '[]'}
								});
						} else {
							return _elm_lang$core$Platform_Cmd$none;
						}
					}();
					var newDoc = function () {
						var _p18 = _p20;
						if (_p18 === true) {
							return _elm_lang$core$Native_Utils.update(
								document,
								{
									name: _elm_lang$core$Maybe$Just(_p19.name),
									contentType: 'data_document_dcontent_image',
									filename: _elm_lang$core$Maybe$Just(_p19.name)
								});
						} else {
							return _elm_lang$core$Native_Utils.update(
								document,
								{
									name: _elm_lang$core$Maybe$Just(_p19.name),
									filename: _elm_lang$core$Maybe$Just(_p19.name)
								});
						}
					}();
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							state,
							{
								file: _elm_lang$core$Maybe$Just(_p19)
							}),
						_1: newDoc,
						_2: fileCmd,
						_3: _user$project$Views_Document$FileSelectMsg(newDoc)
					};
				}
			case 'ContentTypeChanged':
				var newDoc = _elm_lang$core$Native_Utils.update(
					document,
					{contentType: _p11._0});
				return {ctor: '_Tuple4', _0: state, _1: newDoc, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_Document$NoOutMsg};
			case 'NameChanged':
				var newDoc = _elm_lang$core$Native_Utils.update(
					document,
					{
						name: _elm_lang$core$Maybe$Just(_p11._0)
					});
				return {ctor: '_Tuple4', _0: state, _1: newDoc, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_Document$NoOutMsg};
			case 'DescChanged':
				var newDoc = _elm_lang$core$Native_Utils.update(
					document,
					{
						description: _elm_lang$core$Maybe$Just(_p11._0)
					});
				return {ctor: '_Tuple4', _0: state, _1: newDoc, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_Document$NoOutMsg};
			case 'AuthorChanged':
				var newDoc = _elm_lang$core$Native_Utils.update(
					document,
					{
						author: _elm_lang$core$Maybe$Just(_p11._0)
					});
				return {ctor: '_Tuple4', _0: state, _1: newDoc, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_Document$NoOutMsg};
			case 'UploadAndSubmitClicked':
				var _p21 = state.file;
				if (_p21.ctor === 'Nothing') {
					return {ctor: '_Tuple4', _0: state, _1: document, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_Document$DocDoneOk};
				} else {
					var uploadCmd = A2(
						_elm_lang$http$Http$send,
						_user$project$Views_Document$UploadDone,
						A3(_user$project$Requests_File$upload, upldUrl, headers, _p21._0));
					return {
						ctor: '_Tuple4',
						_0: state,
						_1: document,
						_2: A2(_elm_lang$core$Platform_Cmd$map, toMsg, uploadCmd),
						_3: _user$project$Views_Document$NoOutMsg
					};
				}
			case 'UploadDone':
				if (_p11._0.ctor === 'Err') {
					var logOutMsg = A2(
						_elm_lang$core$Debug$log,
						'Error while uploading: ',
						_user$project$Views_Document$DocErrored(_p11._0._0));
					return {ctor: '_Tuple4', _0: state, _1: document, _2: _elm_lang$core$Platform_Cmd$none, _3: logOutMsg};
				} else {
					var newDoc = _elm_lang$core$Native_Utils.update(
						document,
						{
							file: _elm_lang$core$Maybe$Just(_p11._0._0)
						});
					return {ctor: '_Tuple4', _0: state, _1: newDoc, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_Document$DocDoneOk};
				}
			default:
				return {ctor: '_Tuple4', _0: state, _1: document, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_Document$DocCancelled};
		}
	});

var _user$project$Views_DocTable$viewDate = function (date) {
	return A2(
		_evancz$elm_sortable_table$Table$HtmlDetails,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'float', _1: 'right'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'margin-right', _1: '6px'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'margin-top', _1: '4px'},
							_1: {ctor: '[]'}
						}
					}
				}),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text(date),
			_1: {ctor: '[]'}
		});
};
var _user$project$Views_DocTable$dateColumn = function (toUiTxt) {
	var mayDateToTime = function (mayDate) {
		var _p0 = mayDate;
		if (_p0.ctor === 'Nothing') {
			return 0;
		} else {
			return _elm_lang$core$Date$toTime(_p0._0);
		}
	};
	var mayDateToString = function (mayDate) {
		var _p1 = mayDate;
		if (_p1.ctor === 'Nothing') {
			return '';
		} else {
			return _user$project$Helpers_Views_Text$dateToString(_p1._0);
		}
	};
	return _evancz$elm_sortable_table$Table$veryCustomColumn(
		{
			name: toUiTxt('data_document_date'),
			viewData: function (_p2) {
				return _user$project$Views_DocTable$viewDate(
					mayDateToString(
						function (_) {
							return _.date;
						}(_p2)));
			},
			sorter: _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy(
				function (_p3) {
					return mayDateToTime(
						function (_) {
							return _.date;
						}(_p3));
				})
		});
};
var _user$project$Views_DocTable$viewFileNameOrLink = F4(
	function (toUiTxt, dwnldUrl, queryParams, doc) {
		var docName = function () {
			var _p4 = doc.name;
			if (_p4.ctor === 'Nothing') {
				return toUiTxt('gen_undefined');
			} else {
				return _p4._0;
			}
		}();
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: '65%'},
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			function () {
				var _p5 = doc.file;
				if (_p5.ctor === 'Nothing') {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(docName),
						_1: {ctor: '[]'}
					};
				} else {
					return {
						ctor: '::',
						_0: A4(_user$project$Views_Document$viewGetFileLink, dwnldUrl, queryParams, _p5._0, docName),
						_1: {ctor: '[]'}
					};
				}
			}());
	});
var _user$project$Views_DocTable$fileColumn = F3(
	function (toUiTxt, dwnldUrl, queryParams) {
		var mayNameToString = function (mayName) {
			var _p6 = mayName;
			if (_p6.ctor === 'Nothing') {
				return '';
			} else {
				return _p6._0;
			}
		};
		return _evancz$elm_sortable_table$Table$veryCustomColumn(
			{
				name: toUiTxt('data_document_name'),
				viewData: function (data) {
					return A4(_user$project$Views_DocTable$viewFileNameOrLink, toUiTxt, dwnldUrl, queryParams, data);
				},
				sorter: _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy(
					function (_p7) {
						return mayNameToString(
							function (_) {
								return _.name;
							}(_p7));
					})
			});
	});
var _user$project$Views_DocTable$viewIcon = function (contentType) {
	var iconSrc = A2(_elm_lang$core$String$dropLeft, 23, contentType);
	var path = './images/icones-doc/';
	return A2(
		_evancz$elm_sortable_table$Table$HtmlDetails,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '10%'},
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$img,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('iconSrc'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$src(
							A2(
								_elm_lang$core$Basics_ops['++'],
								path,
								A2(_elm_lang$core$Basics_ops['++'], iconSrc, '.png'))),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$alt('icon'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$width(24),
								_1: {ctor: '[]'}
							}
						}
					}
				},
				{ctor: '[]'}),
			_1: {ctor: '[]'}
		});
};
var _user$project$Views_DocTable$iconColumn = _evancz$elm_sortable_table$Table$veryCustomColumn(
	{
		name: '',
		viewData: function (_p8) {
			return _user$project$Views_DocTable$viewIcon(
				function (_) {
					return _.contentType;
				}(_p8));
		},
		sorter: _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy(
			function (_) {
				return _.contentType;
			})
	});
var _user$project$Views_DocTable$toRowAttrs = F3(
	function (toMsg, isEdit, document) {
		return {
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'backgroundColor', _1: 'lightGrey'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'border-top', _1: '1px white solid'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'border-bottom', _1: '1px white solid'},
							_1: {ctor: '[]'}
						}
					}
				}),
			_1: {ctor: '[]'}
		};
	});
var _user$project$Views_DocTable$toTbodyAttrs = {ctor: '[]'};
var _user$project$Views_DocTable$createThead = function (_p9) {
	var _p10 = _p9;
	var _p14 = _p10._2;
	var _p13 = _p10._0;
	var itemstyle = function () {
		var _p11 = _p13;
		switch (_p11) {
			case 'Name':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '58%'},
					_1: {ctor: '[]'}
				};
			case 'Date':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '20%'},
					_1: {ctor: '[]'}
				};
			case 'Icon':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '10%'},
					_1: {ctor: '[]'}
				};
			default:
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '6%'},
					_1: {ctor: '[]'}
				};
		}
	}();
	var path = './images/';
	var content = function () {
		var _p12 = _p10._1;
		switch (_p12.ctor) {
			case 'Unsortable':
				return {
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p13),
					_1: {ctor: '[]'}
				};
			case 'Sortable':
				return {
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p13),
					_1: {
						ctor: '::',
						_0: _p12._0 ? A2(
							_elm_lang$html$Html$img,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$src(
									A2(_elm_lang$core$Basics_ops['++'], path, 'sortDownW.svg')),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$width(14),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: _p14,
											_1: {ctor: '[]'}
										}
									}
								}
							},
							{ctor: '[]'}) : A2(
							_elm_lang$html$Html$img,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$src(
									A2(_elm_lang$core$Basics_ops['++'], path, 'sortDownG.svg')),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$width(14),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: _p14,
											_1: {ctor: '[]'}
										}
									}
								}
							},
							{ctor: '[]'}),
						_1: {ctor: '[]'}
					}
				};
			default:
				if (_p12._0.ctor === 'Nothing') {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p13),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$img,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$src(
										A2(_elm_lang$core$Basics_ops['++'], path, 'sortBothG.svg')),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$width(14),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _p14,
												_1: {ctor: '[]'}
											}
										}
									}
								},
								{ctor: '[]'}),
							_1: {ctor: '[]'}
						}
					};
				} else {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p13),
						_1: {
							ctor: '::',
							_0: _p12._0._0 ? A2(
								_elm_lang$html$Html$img,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$src(
										A2(_elm_lang$core$Basics_ops['++'], path, 'sortUpW.svg')),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$width(14),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _p14,
												_1: {ctor: '[]'}
											}
										}
									}
								},
								{ctor: '[]'}) : A2(
								_elm_lang$html$Html$img,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$src(
										A2(_elm_lang$core$Basics_ops['++'], path, 'sortDownW.svg')),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$width(14),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _p14,
												_1: {ctor: '[]'}
											}
										}
									}
								},
								{ctor: '[]'}),
							_1: {ctor: '[]'}
						}
					};
				}
		}
	}();
	return A2(
		_elm_lang$html$Html$th,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(itemstyle),
			_1: {ctor: '[]'}
		},
		content);
};
var _user$project$Views_DocTable$toNoThead = function (headers) {
	return A2(
		_evancz$elm_sortable_table$Table$HtmlDetails,
		{ctor: '[]'},
		{ctor: '[]'});
};
var _user$project$Views_DocTable$toThead = function (headers) {
	return A2(
		_evancz$elm_sortable_table$Table$HtmlDetails,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'backgroundColor', _1: 'grey'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'color', _1: 'white'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'border-top', _1: '2px white solid'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'border-bottom', _1: '2px white solid'},
								_1: {ctor: '[]'}
							}
						}
					}
				}),
			_1: {ctor: '[]'}
		},
		A2(_elm_lang$core$List$map, _user$project$Views_DocTable$createThead, headers));
};
var _user$project$Views_DocTable$toTableAttrs = {
	ctor: '::',
	_0: _elm_lang$html$Html_Attributes$style(
		{
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'margin', _1: '0%'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
				_1: {ctor: '[]'}
			}
		}),
	_1: {ctor: '[]'}
};
var _user$project$Views_DocTable$toTypeIcon = F4(
	function (toMsg, typelist, item, filtermsg) {
		var mgright = function () {
			var _p15 = item;
			switch (_p15) {
				case 'file':
					return 2;
				case 'hyperlink':
					return 2;
				case 'reference':
					return 2;
				default:
					return 0;
			}
		}();
		var path = './images/icones-doc/';
		return A3(
			_mdgriffith$style_elements$Element$image,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Events$onClick(
					toMsg(
						filtermsg(item))),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(
						_mdgriffith$style_elements$Element_Attributes$px(24)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(
							_mdgriffith$style_elements$Element_Attributes$px(24)),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(mgright),
							_1: {ctor: '[]'}
						}
					}
				}
			},
			{
				src: A2(_elm_lang$core$List$member, item, typelist) ? A2(
					_elm_lang$core$Basics_ops['++'],
					path,
					A2(_elm_lang$core$Basics_ops['++'], item, 'D.png')) : A2(
					_elm_lang$core$Basics_ops['++'],
					path,
					A2(_elm_lang$core$Basics_ops['++'], item, '.png')),
				caption: item
			});
	});
var _user$project$Views_DocTable$State = F8(
	function (a, b, c, d, e, f, g, h) {
		return {idCounter: a, currentDate: b, tableState: c, tableQuery: d, hiddenDocTypes: e, hiddenContentTypes: f, isTableSplit: g, mode: h};
	});
var _user$project$Views_DocTable$EditDocMode = F3(
	function (a, b, c) {
		return {ctor: 'EditDocMode', _0: a, _1: b, _2: c};
	});
var _user$project$Views_DocTable$ViewDocMode = F3(
	function (a, b, c) {
		return {ctor: 'ViewDocMode', _0: a, _1: b, _2: c};
	});
var _user$project$Views_DocTable$MainEditMode = {ctor: 'MainEditMode'};
var _user$project$Views_DocTable$startEditing = function (state) {
	return _elm_lang$core$Native_Utils.update(
		state,
		{mode: _user$project$Views_DocTable$MainEditMode});
};
var _user$project$Views_DocTable$Visualization = {ctor: 'Visualization'};
var _user$project$Views_DocTable$SetModeVisualization = {ctor: 'SetModeVisualization'};
var _user$project$Views_DocTable$SwitchTableSplit = {ctor: 'SwitchTableSplit'};
var _user$project$Views_DocTable$UpDateHiddenContents = function (a) {
	return {ctor: 'UpDateHiddenContents', _0: a};
};
var _user$project$Views_DocTable$UpDateHiddenDocs = function (a) {
	return {ctor: 'UpDateHiddenDocs', _0: a};
};
var _user$project$Views_DocTable$SetTableState = function (a) {
	return {ctor: 'SetTableState', _0: a};
};
var _user$project$Views_DocTable$SetTableQuery = function (a) {
	return {ctor: 'SetTableQuery', _0: a};
};
var _user$project$Views_DocTable$StartEditDoc = function (a) {
	return {ctor: 'StartEditDoc', _0: a};
};
var _user$project$Views_DocTable$StartViewDoc = function (a) {
	return {ctor: 'StartViewDoc', _0: a};
};
var _user$project$Views_DocTable$viewModif = F3(
	function (toMsg, isEdit, doc) {
		var _p16 = isEdit ? {
			ctor: '_Tuple4',
			_0: toMsg(
				_user$project$Views_DocTable$StartEditDoc(doc)),
			_1: _user$project$Styles$DocEditBtn,
			_2: './images/edit.svg',
			_3: 'éditer'
		} : {
			ctor: '_Tuple4',
			_0: toMsg(
				_user$project$Views_DocTable$StartViewDoc(doc)),
			_1: _user$project$Styles$NoStyle,
			_2: './images/view.svg',
			_3: 'voir'
		};
		var viewOrEditMsg = _p16._0;
		var viewOrEditStyle = _p16._1;
		var viewOrEditIcon = _p16._2;
		var viewOrEditCaption = _p16._3;
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: '8%'},
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Element$layout,
					_user$project$Styles$stylesheet,
					A3(
						_mdgriffith$style_elements$Element$image,
						viewOrEditStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(
								_mdgriffith$style_elements$Element_Attributes$px(20)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(20)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(viewOrEditMsg),
									_1: {ctor: '[]'}
								}
							}
						},
						{src: viewOrEditIcon, caption: viewOrEditCaption})),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_DocTable$modifColumn = F2(
	function (toMsg, isEdit) {
		return _evancz$elm_sortable_table$Table$veryCustomColumn(
			{
				name: '',
				viewData: function (data) {
					return A3(_user$project$Views_DocTable$viewModif, toMsg, isEdit, data);
				},
				sorter: _evancz$elm_sortable_table$Table$unsortable
			});
	});
var _user$project$Views_DocTable$DeleteDocument = function (a) {
	return {ctor: 'DeleteDocument', _0: a};
};
var _user$project$Views_DocTable$viewDelete = F2(
	function (toMsg, doc) {
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: '8%'},
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_mdgriffith$style_elements$Element$layout,
					_user$project$Styles$stylesheet,
					A3(
						_mdgriffith$style_elements$Element$image,
						_user$project$Styles$DocDeleteBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(
								_mdgriffith$style_elements$Element_Attributes$px(20)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(20)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										toMsg(
											_user$project$Views_DocTable$DeleteDocument(doc))),
									_1: {ctor: '[]'}
								}
							}
						},
						{src: './images/delete.svg', caption: 'delete'})),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_DocTable$delColumn = function (toMsg) {
	return _evancz$elm_sortable_table$Table$veryCustomColumn(
		{
			name: '',
			viewData: function (data) {
				return A2(_user$project$Views_DocTable$viewDelete, toMsg, data);
			},
			sorter: _evancz$elm_sortable_table$Table$unsortable
		});
};
var _user$project$Views_DocTable$tableConfig = F5(
	function (toMsg, toUiTxt, dwnldUrl, queryParams, isEdit) {
		var mayNameToString = function (mayName) {
			var _p17 = mayName;
			if (_p17.ctor === 'Nothing') {
				return '';
			} else {
				return _p17._0;
			}
		};
		return _evancz$elm_sortable_table$Table$customConfig(
			{
				toId: function (_p18) {
					return mayNameToString(
						function (_) {
							return _.name;
						}(_p18));
				},
				toMsg: function (_p19) {
					return toMsg(
						_user$project$Views_DocTable$SetTableState(_p19));
				},
				columns: isEdit ? {
					ctor: '::',
					_0: A2(_user$project$Views_DocTable$modifColumn, toMsg, isEdit),
					_1: {
						ctor: '::',
						_0: _user$project$Views_DocTable$iconColumn,
						_1: {
							ctor: '::',
							_0: A3(_user$project$Views_DocTable$fileColumn, toUiTxt, dwnldUrl, queryParams),
							_1: {
								ctor: '::',
								_0: _user$project$Views_DocTable$dateColumn(toUiTxt),
								_1: {
									ctor: '::',
									_0: _user$project$Views_DocTable$delColumn(toMsg),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				} : {
					ctor: '::',
					_0: A2(_user$project$Views_DocTable$modifColumn, toMsg, isEdit),
					_1: {
						ctor: '::',
						_0: _user$project$Views_DocTable$iconColumn,
						_1: {
							ctor: '::',
							_0: A3(_user$project$Views_DocTable$fileColumn, toUiTxt, dwnldUrl, queryParams),
							_1: {
								ctor: '::',
								_0: _user$project$Views_DocTable$dateColumn(toUiTxt),
								_1: {ctor: '[]'}
							}
						}
					}
				},
				customizations: _elm_lang$core$Native_Utils.update(
					_evancz$elm_sortable_table$Table$defaultCustomizations,
					{
						tableAttrs: _user$project$Views_DocTable$toTableAttrs,
						thead: _user$project$Views_DocTable$toThead,
						tbodyAttrs: _user$project$Views_DocTable$toTbodyAttrs,
						rowAttrs: A2(_user$project$Views_DocTable$toRowAttrs, toMsg, isEdit)
					})
			});
	});
var _user$project$Views_DocTable$AddDocument = {ctor: 'AddDocument'};
var _user$project$Views_DocTable$viewVis = F7(
	function (toMsg, toUiTxt, dwnldUrl, queryParams, state, isSplitEnabled, alldocuments) {
		var parentMeaspoint = true;
		var isEdit = function () {
			var _p20 = state.mode;
			if (_p20.ctor === 'MainEditMode') {
				return true;
			} else {
				return false;
			}
		}();
		var mayNameToString = function (mayName) {
			var _p21 = mayName;
			if (_p21.ctor === 'Nothing') {
				return '';
			} else {
				return _p21._0;
			}
		};
		var hasDocs = !_elm_lang$core$List$isEmpty(
			A2(
				_elm_lang$core$List$filter,
				function (list) {
					return !_elm_lang$core$List$isEmpty(list);
				},
				alldocuments));
		var lowerQuery = _elm_lang$core$String$toLower(state.tableQuery);
		var filteredDocs = A2(
			_elm_lang$core$List$filter,
			function (_p22) {
				return A2(
					_elm_lang$core$String$contains,
					lowerQuery,
					_elm_lang$core$String$toLower(
						mayNameToString(
							function (_) {
								return _.name;
							}(_p22))));
			},
			A2(
				_elm_lang$core$List$filter,
				function (d) {
					return !A2(
						_elm_lang$core$List$member,
						A2(_elm_lang$core$String$dropLeft, 23, d.contentType),
						state.hiddenContentTypes);
				},
				A2(
					_elm_lang$core$Maybe$withDefault,
					{ctor: '[]'},
					A2(
						_elm_lang$core$Array$get,
						0,
						_elm_lang$core$Array$fromList(alldocuments)))));
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$row,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: isEdit ? A3(
							_mdgriffith$style_elements$Element$row,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$image,
									_user$project$Styles$DocAddBtn,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$height(
											_mdgriffith$style_elements$Element_Attributes$px(20)),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(
												_mdgriffith$style_elements$Element_Attributes$px(20)),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Events$onClick(
													toMsg(_user$project$Views_DocTable$AddDocument)),
												_1: {ctor: '[]'}
											}
										}
									},
									{src: './images/add.svg', caption: 'add'}),
								_1: {ctor: '[]'}
							}) : _mdgriffith$style_elements$Element$empty,
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: hasDocs ? A3(
						_mdgriffith$style_elements$Element$row,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$html(
								A3(
									_evancz$elm_sortable_table$Table$view,
									A5(_user$project$Views_DocTable$tableConfig, toMsg, toUiTxt, dwnldUrl, queryParams, isEdit),
									state.tableState,
									filteredDocs)),
							_1: {ctor: '[]'}
						}) : _mdgriffith$style_elements$Element$empty,
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_DocTable$MsgFromDoc = function (a) {
	return {ctor: 'MsgFromDoc', _0: a};
};
var _user$project$Views_DocTable$view = F8(
	function (toMsg, toUiTxt, dwnldUrl, queryParams, state, viewstyle, isSplitEnabled, alldocuments) {
		var _p23 = state.mode;
		switch (_p23.ctor) {
			case 'Visualization':
				return A7(_user$project$Views_DocTable$viewVis, toMsg, toUiTxt, dwnldUrl, queryParams, state, isSplitEnabled, alldocuments);
			case 'MainEditMode':
				return A7(_user$project$Views_DocTable$viewVis, toMsg, toUiTxt, dwnldUrl, queryParams, state, false, alldocuments);
			case 'ViewDocMode':
				return A5(
					_user$project$Views_Document$viewVis,
					function (_p24) {
						return toMsg(
							_user$project$Views_DocTable$MsgFromDoc(_p24));
					},
					toUiTxt,
					viewstyle,
					_p23._1,
					_p23._0);
			default:
				return A4(
					_user$project$Views_Document$viewEdit,
					function (_p25) {
						return toMsg(
							_user$project$Views_DocTable$MsgFromDoc(_p25));
					},
					toUiTxt,
					_p23._1,
					_p23._0);
		}
	});
var _user$project$Views_DocTable$SetDate = function (a) {
	return {ctor: 'SetDate', _0: a};
};
var _user$project$Views_DocTable$init = F2(
	function (toMsg, isEdit) {
		var cmd = A2(
			_elm_lang$core$Platform_Cmd$map,
			toMsg,
			A2(_elm_lang$core$Task$perform, _user$project$Views_DocTable$SetDate, _elm_lang$core$Date$now));
		var state = A8(
			_user$project$Views_DocTable$State,
			0,
			_elm_lang$core$Maybe$Nothing,
			_evancz$elm_sortable_table$Table$initialSort('date'),
			'',
			{ctor: '[]'},
			{ctor: '[]'},
			false,
			isEdit ? _user$project$Views_DocTable$MainEditMode : _user$project$Views_DocTable$Visualization);
		return {ctor: '_Tuple2', _0: state, _1: _elm_lang$core$Platform_Cmd$none};
	});
var _user$project$Views_DocTable$EditDocErrored = function (a) {
	return {ctor: 'EditDocErrored', _0: a};
};
var _user$project$Views_DocTable$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Views_DocTable$update = F6(
	function (toMsg, upldUrl, headers, msg, state, documents) {
		var _p26 = msg;
		switch (_p26.ctor) {
			case 'SetDate':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{
							currentDate: _elm_lang$core$Maybe$Just(_p26._0)
						}),
					_1: documents,
					_2: _elm_lang$core$Platform_Cmd$none,
					_3: _user$project$Views_DocTable$NoOutMsg
				};
			case 'MsgFromDoc':
				var _p35 = _p26._0;
				var _p27 = state.mode;
				switch (_p27.ctor) {
					case 'ViewDocMode':
						var _p28 = A6(
							_user$project$Views_Document$update,
							function (_p29) {
								return toMsg(
									_user$project$Views_DocTable$MsgFromDoc(_p29));
							},
							upldUrl,
							headers,
							_p35,
							_p27._1,
							_p27._0);
						var newDocState = _p28._0;
						var updDoc = _p28._1;
						var docCmd = _p28._2;
						var docOutMsg = _p28._3;
						var newState = _elm_lang$core$Native_Utils.update(
							state,
							{
								mode: A3(_user$project$Views_DocTable$ViewDocMode, updDoc, newDocState, _p27._2)
							});
						var _p30 = docOutMsg;
						if (_p30.ctor === 'DocCancelled') {
							return {
								ctor: '_Tuple4',
								_0: _elm_lang$core$Native_Utils.update(
									state,
									{mode: _user$project$Views_DocTable$Visualization}),
								_1: documents,
								_2: docCmd,
								_3: _user$project$Views_DocTable$NoOutMsg
							};
						} else {
							return {ctor: '_Tuple4', _0: newState, _1: documents, _2: docCmd, _3: _user$project$Views_DocTable$NoOutMsg};
						}
					case 'EditDocMode':
						var _p34 = _p27._2;
						var _p31 = A6(
							_user$project$Views_Document$update,
							function (_p32) {
								return toMsg(
									_user$project$Views_DocTable$MsgFromDoc(_p32));
							},
							upldUrl,
							headers,
							_p35,
							_p27._1,
							_p27._0);
						var newDocState = _p31._0;
						var updDoc = _p31._1;
						var docCmd = _p31._2;
						var docOutMsg = _p31._3;
						var newState = _elm_lang$core$Native_Utils.update(
							state,
							{
								mode: A3(_user$project$Views_DocTable$EditDocMode, updDoc, newDocState, _p34)
							});
						var _p33 = docOutMsg;
						switch (_p33.ctor) {
							case 'NoOutMsg':
								return {ctor: '_Tuple4', _0: newState, _1: documents, _2: docCmd, _3: _user$project$Views_DocTable$NoOutMsg};
							case 'DocErrored':
								return {
									ctor: '_Tuple4',
									_0: newState,
									_1: documents,
									_2: docCmd,
									_3: _user$project$Views_DocTable$EditDocErrored(_p33._0)
								};
							case 'DocCancelled':
								return {
									ctor: '_Tuple4',
									_0: _elm_lang$core$Native_Utils.update(
										newState,
										{mode: _user$project$Views_DocTable$MainEditMode}),
									_1: documents,
									_2: docCmd,
									_3: _user$project$Views_DocTable$NoOutMsg
								};
							case 'DocDoneOk':
								var updDocs = _p34 ? {ctor: '::', _0: updDoc, _1: documents} : A2(
									_elm_lang$core$List$map,
									function (d) {
										return _elm_lang$core$Native_Utils.eq(d.id, updDoc.id) ? updDoc : d;
									},
									documents);
								return {
									ctor: '_Tuple4',
									_0: _elm_lang$core$Native_Utils.update(
										newState,
										{mode: _user$project$Views_DocTable$MainEditMode}),
									_1: updDocs,
									_2: docCmd,
									_3: _user$project$Views_DocTable$NoOutMsg
								};
							default:
								return {ctor: '_Tuple4', _0: newState, _1: documents, _2: docCmd, _3: _user$project$Views_DocTable$NoOutMsg};
						}
					default:
						return {ctor: '_Tuple4', _0: state, _1: documents, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_DocTable$NoOutMsg};
				}
			case 'AddDocument':
				var _p36 = A2(
					_user$project$Views_Document$init,
					function (_p37) {
						return toMsg(
							_user$project$Views_DocTable$MsgFromDoc(_p37));
					},
					true);
				var newDocState = _p36._0;
				var docCmd = _p36._1;
				var newCount = state.idCounter + 1;
				var newDoc = A8(
					_user$project$Data_Document$Document,
					_elm_lang$core$Maybe$Just(newCount),
					'gen_undefined',
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing);
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{
						idCounter: newCount,
						mode: A3(_user$project$Views_DocTable$EditDocMode, newDoc, newDocState, true)
					});
				return {ctor: '_Tuple4', _0: newState, _1: documents, _2: docCmd, _3: _user$project$Views_DocTable$NoOutMsg};
			case 'DeleteDocument':
				var updDocs = A2(
					_elm_lang$core$List$filter,
					function (d) {
						return !_elm_lang$core$Native_Utils.eq(d.id, _p26._0.id);
					},
					documents);
				return {ctor: '_Tuple4', _0: state, _1: updDocs, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_DocTable$NoOutMsg};
			case 'StartViewDoc':
				var _p38 = A2(
					_user$project$Views_Document$init,
					function (_p39) {
						return toMsg(
							_user$project$Views_DocTable$MsgFromDoc(_p39));
					},
					false);
				var newDocState = _p38._0;
				var docCmd = _p38._1;
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{
						mode: A3(_user$project$Views_DocTable$ViewDocMode, _p26._0, newDocState, false)
					});
				return {ctor: '_Tuple4', _0: newState, _1: documents, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_DocTable$NoOutMsg};
			case 'StartEditDoc':
				var _p40 = A2(
					_user$project$Views_Document$init,
					function (_p41) {
						return toMsg(
							_user$project$Views_DocTable$MsgFromDoc(_p41));
					},
					true);
				var newDocState = _p40._0;
				var docCmd = _p40._1;
				var newState = _elm_lang$core$Native_Utils.update(
					state,
					{
						mode: A3(_user$project$Views_DocTable$EditDocMode, _p26._0, newDocState, false)
					});
				return {ctor: '_Tuple4', _0: newState, _1: documents, _2: docCmd, _3: _user$project$Views_DocTable$NoOutMsg};
			case 'SetTableQuery':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{tableQuery: _p26._0}),
					_1: documents,
					_2: _elm_lang$core$Platform_Cmd$none,
					_3: _user$project$Views_DocTable$NoOutMsg
				};
			case 'SetTableState':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{tableState: _p26._0}),
					_1: documents,
					_2: _elm_lang$core$Platform_Cmd$none,
					_3: _user$project$Views_DocTable$NoOutMsg
				};
			case 'UpDateHiddenDocs':
				var _p42 = _p26._0;
				if (A2(_elm_lang$core$List$member, _p42, state.hiddenDocTypes)) {
					var newState = _elm_lang$core$Native_Utils.update(
						state,
						{
							hiddenDocTypes: A2(
								_elm_lang$core$List$filter,
								function (t) {
									return !_elm_lang$core$Native_Utils.eq(t, _p42);
								},
								state.hiddenDocTypes)
						});
					return {ctor: '_Tuple4', _0: newState, _1: documents, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_DocTable$NoOutMsg};
				} else {
					var newState = _elm_lang$core$Native_Utils.update(
						state,
						{
							hiddenDocTypes: {ctor: '::', _0: _p42, _1: state.hiddenDocTypes}
						});
					return {ctor: '_Tuple4', _0: newState, _1: documents, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_DocTable$NoOutMsg};
				}
			case 'UpDateHiddenContents':
				var _p43 = _p26._0;
				if (A2(_elm_lang$core$List$member, _p43, state.hiddenContentTypes)) {
					var newState = _elm_lang$core$Native_Utils.update(
						state,
						{
							hiddenContentTypes: A2(
								_elm_lang$core$List$filter,
								function (t) {
									return !_elm_lang$core$Native_Utils.eq(t, _p43);
								},
								state.hiddenContentTypes)
						});
					return {ctor: '_Tuple4', _0: newState, _1: documents, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_DocTable$NoOutMsg};
				} else {
					var newState = _elm_lang$core$Native_Utils.update(
						state,
						{
							hiddenContentTypes: {ctor: '::', _0: _p43, _1: state.hiddenContentTypes}
						});
					return {ctor: '_Tuple4', _0: newState, _1: documents, _2: _elm_lang$core$Platform_Cmd$none, _3: _user$project$Views_DocTable$NoOutMsg};
				}
			case 'SwitchTableSplit':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{isTableSplit: !state.isTableSplit}),
					_1: documents,
					_2: _elm_lang$core$Platform_Cmd$none,
					_3: _user$project$Views_DocTable$NoOutMsg
				};
			default:
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						state,
						{mode: _user$project$Views_DocTable$Visualization}),
					_1: documents,
					_2: _elm_lang$core$Platform_Cmd$none,
					_3: _user$project$Views_DocTable$NoOutMsg
				};
		}
	});

var _user$project$Views_Contact$fromContactForm = function (contactForm) {
	var _p0 = {ctor: '_Tuple3', _0: contactForm.firstname, _1: contactForm.lastname, _2: contactForm.unit};
	if (((_p0._0.ctor === 'Just') && (_p0._1.ctor === 'Just')) && (_p0._2.ctor === 'Just')) {
		return _elm_lang$core$Maybe$Just(
			{id: contactForm.id, firstname: _p0._0._0, lastname: _p0._1._0, unit: _p0._2._0, mail: contactForm.mail, phone: contactForm.phone});
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Views_Contact$toContactForm = function (mayContact) {
	var _p1 = mayContact;
	if (_p1.ctor === 'Just') {
		var _p2 = _p1._0;
		return {
			id: _p2.id,
			firstname: _elm_lang$core$Maybe$Just(_p2.firstname),
			lastname: _elm_lang$core$Maybe$Just(_p2.lastname),
			unit: _elm_lang$core$Maybe$Just(_p2.unit),
			mail: _p2.mail,
			phone: _p2.phone
		};
	} else {
		return {id: _elm_lang$core$Maybe$Nothing, firstname: _elm_lang$core$Maybe$Nothing, lastname: _elm_lang$core$Maybe$Nothing, unit: _elm_lang$core$Maybe$Nothing, mail: _elm_lang$core$Maybe$Nothing, phone: _elm_lang$core$Maybe$Nothing};
	}
};
var _user$project$Views_Contact$resetModel = F2(
	function (model, newMode) {
		return _elm_lang$core$Native_Utils.update(
			model,
			{
				contactForm: _user$project$Views_Contact$toContactForm(_elm_lang$core$Maybe$Nothing),
				mode: newMode
			});
	});
var _user$project$Views_Contact$Model = F2(
	function (a, b) {
		return {contactForm: a, mode: b};
	});
var _user$project$Views_Contact$ContactForm = F6(
	function (a, b, c, d, e, f) {
		return {id: a, firstname: b, lastname: c, unit: d, mail: e, phone: f};
	});
var _user$project$Views_Contact$Edit = {ctor: 'Edit'};
var _user$project$Views_Contact$startAddMode = function (model) {
	return {
		ctor: '_Tuple2',
		_0: A2(_user$project$Views_Contact$resetModel, model, _user$project$Views_Contact$Edit),
		_1: _elm_lang$core$Platform_Cmd$none
	};
};
var _user$project$Views_Contact$Hidden = {ctor: 'Hidden'};
var _user$project$Views_Contact$init = {
	ctor: '_Tuple2',
	_0: {
		contactForm: _user$project$Views_Contact$toContactForm(_elm_lang$core$Maybe$Nothing),
		mode: _user$project$Views_Contact$Hidden
	},
	_1: _elm_lang$core$Platform_Cmd$none
};
var _user$project$Views_Contact$Cancel = function (a) {
	return {ctor: 'Cancel', _0: a};
};
var _user$project$Views_Contact$Saved = function (a) {
	return {ctor: 'Saved', _0: a};
};
var _user$project$Views_Contact$ContactReceived = function (a) {
	return {ctor: 'ContactReceived', _0: a};
};
var _user$project$Views_Contact$startUpdateMode = F5(
	function (model, toMsg, baseUrl, session, contactId) {
		var getContactByIdCmd = A2(
			_elm_lang$http$Http$send,
			function (_p3) {
				return toMsg(
					_user$project$Views_Contact$ContactReceived(_p3));
			},
			A3(_user$project$Requests_Contact$getById, baseUrl, session.token, contactId));
		return {
			ctor: '_Tuple2',
			_0: A2(_user$project$Views_Contact$resetModel, model, _user$project$Views_Contact$Edit),
			_1: getContactByIdCmd
		};
	});
var _user$project$Views_Contact$TrySaving = {ctor: 'TrySaving'};
var _user$project$Views_Contact$PhoneChanged = function (a) {
	return {ctor: 'PhoneChanged', _0: a};
};
var _user$project$Views_Contact$MailChanged = function (a) {
	return {ctor: 'MailChanged', _0: a};
};
var _user$project$Views_Contact$UnitChanged = function (a) {
	return {ctor: 'UnitChanged', _0: a};
};
var _user$project$Views_Contact$LastnameChanged = function (a) {
	return {ctor: 'LastnameChanged', _0: a};
};
var _user$project$Views_Contact$FirstnameChanged = function (a) {
	return {ctor: 'FirstnameChanged', _0: a};
};
var _user$project$Views_Contact$viewEditForm = F3(
	function (toMsg, toUiTxt, contactForm) {
		var phoneValidation = A4(
			_user$project$Helpers_Data_InputValidation$validate,
			false,
			_elm_lang$core$Maybe$Just(_user$project$Helpers_Data_InputValidation$phoneValidator),
			_elm_lang$core$Maybe$Just(
				toUiTxt('validation_phone')),
			contactForm.phone);
		var mailValidation = A4(
			_user$project$Helpers_Data_InputValidation$validate,
			false,
			_elm_lang$core$Maybe$Just(_user$project$Helpers_Data_InputValidation$emailValidator),
			_elm_lang$core$Maybe$Just(
				toUiTxt('validation_email')),
			contactForm.mail);
		var unitValidation = A4(_user$project$Helpers_Data_InputValidation$validate, true, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, contactForm.unit);
		var lastnameValidation = A4(_user$project$Helpers_Data_InputValidation$validate, true, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, contactForm.lastname);
		var firstnameValidation = A4(_user$project$Helpers_Data_InputValidation$validate, true, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, contactForm.firstname);
		var isFormValid = _user$project$Helpers_Data_InputValidation$validateForm(
			{
				ctor: '::',
				_0: firstnameValidation,
				_1: {
					ctor: '::',
					_0: lastnameValidation,
					_1: {
						ctor: '::',
						_0: unitValidation,
						_1: {
							ctor: '::',
							_0: mailValidation,
							_1: {
								ctor: '::',
								_0: phoneValidation,
								_1: {ctor: '[]'}
							}
						}
					}
				}
			});
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$mainContent,
					_user$project$Styles$SmallFont,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(5),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$yScrollbar,
								_1: {ctor: '[]'}
							}
						}
					},
					A3(
						_mdgriffith$style_elements$Element$column,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
									_1: {ctor: '[]'}
								}
							}
						},
						{
							ctor: '::',
							_0: A9(
								_user$project$Helpers_Views_Form$elInput2,
								toUiTxt('data_contact_firstname'),
								50,
								function (_p4) {
									return toMsg(
										_user$project$Views_Contact$FirstnameChanged(_p4));
								},
								firstnameValidation,
								false,
								'',
								contactForm.firstname,
								_elm_lang$core$Maybe$Nothing,
								_elm_lang$core$Maybe$Nothing),
							_1: {
								ctor: '::',
								_0: A9(
									_user$project$Helpers_Views_Form$elInput2,
									toUiTxt('data_contact_lastname'),
									50,
									function (_p5) {
										return toMsg(
											_user$project$Views_Contact$LastnameChanged(_p5));
									},
									lastnameValidation,
									false,
									'',
									contactForm.lastname,
									_elm_lang$core$Maybe$Nothing,
									_elm_lang$core$Maybe$Nothing),
								_1: {
									ctor: '::',
									_0: A9(
										_user$project$Helpers_Views_Form$elInput2,
										toUiTxt('data_contact_unit'),
										50,
										function (_p6) {
											return toMsg(
												_user$project$Views_Contact$UnitChanged(_p6));
										},
										unitValidation,
										false,
										'',
										contactForm.unit,
										_elm_lang$core$Maybe$Nothing,
										_elm_lang$core$Maybe$Nothing),
									_1: {
										ctor: '::',
										_0: A9(
											_user$project$Helpers_Views_Form$elInput2,
											toUiTxt('data_contact_mail'),
											50,
											function (_p7) {
												return toMsg(
													_user$project$Views_Contact$MailChanged(_p7));
											},
											mailValidation,
											false,
											toUiTxt('placeholders_email'),
											contactForm.mail,
											_elm_lang$core$Maybe$Nothing,
											_elm_lang$core$Maybe$Nothing),
										_1: {
											ctor: '::',
											_0: A9(
												_user$project$Helpers_Views_Form$elInput2,
												toUiTxt('data_contact_phone'),
												50,
												function (_p8) {
													return toMsg(
														_user$project$Views_Contact$PhoneChanged(_p8));
												},
												phoneValidation,
												false,
												toUiTxt('placeholders_phone'),
												contactForm.phone,
												_elm_lang$core$Maybe$Nothing,
												_elm_lang$core$Maybe$Nothing),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						})),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$footer,
						_user$project$Styles$Footer,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
								_1: {ctor: '[]'}
							}
						},
						A7(
							_user$project$Helpers_Views_Form$elOkCancel,
							isFormValid,
							toUiTxt('gen_validate'),
							_user$project$Styles$EditBtn,
							toMsg(_user$project$Views_Contact$TrySaving),
							toUiTxt('gen_cancel'),
							_user$project$Styles$CancelBtn,
							toMsg(
								_user$project$Views_Contact$Cancel(contactForm.id)))),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_Contact$view = F3(
	function (toMsg, toUiTxt, model) {
		return A3(_user$project$Views_Contact$viewEditForm, toMsg, toUiTxt, model.contactForm);
	});
var _user$project$Views_Contact$Cancelled = function (a) {
	return {ctor: 'Cancelled', _0: a};
};
var _user$project$Views_Contact$ResponsePayloadMismatched = function (a) {
	return {ctor: 'ResponsePayloadMismatched', _0: a};
};
var _user$project$Views_Contact$SavingFailed = function (a) {
	return {ctor: 'SavingFailed', _0: a};
};
var _user$project$Views_Contact$SavedContact = function (a) {
	return {ctor: 'SavedContact', _0: a};
};
var _user$project$Views_Contact$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Views_Contact$update = F5(
	function (toMsg, session, msg, model, baseUrl) {
		var contactForm = model.contactForm;
		var _p9 = msg;
		switch (_p9.ctor) {
			case 'FirstnameChanged':
				var newContactForm = _elm_lang$core$Native_Utils.update(
					contactForm,
					{
						firstname: _elm_lang$core$Maybe$Just(_p9._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{contactForm: newContactForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_Contact$NoOutMsg
				};
			case 'LastnameChanged':
				var newContactForm = _elm_lang$core$Native_Utils.update(
					contactForm,
					{
						lastname: _elm_lang$core$Maybe$Just(_p9._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{contactForm: newContactForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_Contact$NoOutMsg
				};
			case 'UnitChanged':
				var newContactForm = _elm_lang$core$Native_Utils.update(
					contactForm,
					{
						unit: _elm_lang$core$Maybe$Just(_p9._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{contactForm: newContactForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_Contact$NoOutMsg
				};
			case 'MailChanged':
				var newContactForm = _elm_lang$core$Native_Utils.update(
					contactForm,
					{
						mail: _elm_lang$core$Maybe$Just(_p9._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{contactForm: newContactForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_Contact$NoOutMsg
				};
			case 'PhoneChanged':
				var newContactForm = _elm_lang$core$Native_Utils.update(
					contactForm,
					{
						phone: _elm_lang$core$Maybe$Just(_p9._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{contactForm: newContactForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_Contact$NoOutMsg
				};
			case 'TrySaving':
				var mayContact = _user$project$Views_Contact$fromContactForm(model.contactForm);
				var createContactCmd = function () {
					var _p10 = mayContact;
					if (_p10.ctor === 'Just') {
						return A2(
							_elm_lang$http$Http$send,
							function (_p11) {
								return toMsg(
									_user$project$Views_Contact$Saved(_p11));
							},
							A3(_user$project$Requests_Contact$save, baseUrl, session.token, _p10._0));
					} else {
						var _p12 = _elm_lang$core$Debug$log('Validation Error : Coudn\'t send create request.');
						return _elm_lang$core$Platform_Cmd$none;
					}
				}();
				return {ctor: '_Tuple3', _0: model, _1: createContactCmd, _2: _user$project$Views_Contact$NoOutMsg};
			case 'ContactReceived':
				if (_p9._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								contactForm: _user$project$Views_Contact$toContactForm(
									_elm_lang$core$Maybe$Just(_p9._0._0))
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_Contact$NoOutMsg
					};
				} else {
					var _p13 = A2(_elm_lang$core$Debug$log, 'Error: Coudn\'t retrieve contact', _p9._0._0);
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_Contact$NoOutMsg};
				}
			case 'Saved':
				if (_p9._0.ctor === 'Ok') {
					var newMode = _user$project$Views_Contact$Hidden;
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{mode: newMode}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_Contact$SavedContact(_p9._0._0)
					};
				} else {
					var testContact = {id: _elm_lang$core$Maybe$Nothing, firstname: 'Test-firstname', lastname: 'Test-lastname', unit: 'Test-unit', mail: _elm_lang$core$Maybe$Nothing, phone: _elm_lang$core$Maybe$Nothing};
					var newMode = _user$project$Views_Contact$Hidden;
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{mode: newMode}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_Contact$SavedContact(testContact)
					};
				}
			default:
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{mode: _user$project$Views_Contact$Hidden}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_Contact$Cancelled(_p9._0)
				};
		}
	});

var _user$project$Views_ContactSelection$addToListContact = F2(
	function (model, newContact) {
		var newListContact = {ctor: '::', _0: newContact, _1: model.listContact};
		return _elm_lang$core$Native_Utils.update(
			model,
			{listContact: newListContact});
	});
var _user$project$Views_ContactSelection$updateListContactEntry = F3(
	function (model, contactId, newContact) {
		var listDeletedEntry = A2(
			_elm_lang$core$List$filter,
			function (contact) {
				return !_elm_lang$core$Native_Utils.eq(
					contact.id,
					_elm_lang$core$Maybe$Just(contactId));
			},
			model.listContact);
		var newListContact = {ctor: '::', _0: newContact, _1: listDeletedEntry};
		return _elm_lang$core$Native_Utils.update(
			model,
			{listContact: newListContact});
	});
var _user$project$Views_ContactSelection$updateListContact = F2(
	function (model, listContact) {
		return _elm_lang$core$Native_Utils.update(
			model,
			{listContact: listContact});
	});
var _user$project$Views_ContactSelection$getContactAsPrettyString = function (contact) {
	var strOptionalAtt = function () {
		var _p0 = {ctor: '_Tuple2', _0: contact.mail, _1: contact.phone};
		if (_p0._0.ctor === 'Just') {
			if (_p0._1.ctor === 'Just') {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_p0._0._0,
					A2(_elm_lang$core$Basics_ops['++'], ', ', _p0._1._0));
			} else {
				return _p0._0._0;
			}
		} else {
			if (_p0._1.ctor === 'Just') {
				return _p0._1._0;
			} else {
				return '';
			}
		}
	}();
	var strRequiredAtt = A2(
		_elm_lang$core$Basics_ops['++'],
		contact.firstname,
		A2(
			_elm_lang$core$Basics_ops['++'],
			' ',
			A2(
				_elm_lang$core$Basics_ops['++'],
				contact.lastname,
				A2(_elm_lang$core$Basics_ops['++'], ', ', contact.unit))));
	return _elm_lang$core$Native_Utils.eq(strOptionalAtt, '') ? strRequiredAtt : A2(
		_elm_lang$core$Basics_ops['++'],
		strRequiredAtt,
		A2(_elm_lang$core$Basics_ops['++'], ' | ', strOptionalAtt));
};
var _user$project$Views_ContactSelection$getContactAsString = F2(
	function (contact, isLowerKey) {
		var toDefault = function (string) {
			return A2(_elm_lang$core$Maybe$withDefault, '', string);
		};
		var contactString = A2(
			_elm_lang$core$Basics_ops['++'],
			contact.firstname,
			A2(
				_elm_lang$core$Basics_ops['++'],
				' ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					contact.lastname,
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							contact.unit,
							A2(
								_elm_lang$core$Basics_ops['++'],
								' ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									toDefault(contact.mail),
									A2(
										_elm_lang$core$Basics_ops['++'],
										' ',
										toDefault(contact.phone)))))))));
		var _p1 = isLowerKey;
		if (_p1 === true) {
			return _elm_lang$core$String$toLower(contactString);
		} else {
			return contactString;
		}
	});
var _user$project$Views_ContactSelection$getPartialContactAsString = F2(
	function (contact, isLowerKey) {
		var contactString = A2(
			_elm_lang$core$Basics_ops['++'],
			contact.firstname,
			A2(
				_elm_lang$core$Basics_ops['++'],
				' ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					contact.lastname,
					A2(_elm_lang$core$Basics_ops['++'], ' ', contact.unit))));
		var _p2 = isLowerKey;
		if (_p2 === true) {
			return _elm_lang$core$String$toLower(contactString);
		} else {
			return contactString;
		}
	});
var _user$project$Views_ContactSelection$viewSearchEntry = F3(
	function (toMsg, toUiTxt, contact) {
		return _elm_lang$html$Html$text(
			A2(_user$project$Views_ContactSelection$getPartialContactAsString, contact, false));
	});
var _user$project$Views_ContactSelection$defaultSearchData = {queryString: '', isSearchListVisible: false, highLightedSearchPoint: _elm_lang$core$Maybe$Nothing};
var _user$project$Views_ContactSelection$Model = F3(
	function (a, b, c) {
		return {listContact: a, isForUpdate: b, mode: c};
	});
var _user$project$Views_ContactSelection$SearchData = F3(
	function (a, b, c) {
		return {queryString: a, isSearchListVisible: b, highLightedSearchPoint: c};
	});
var _user$project$Views_ContactSelection$Edit = function (a) {
	return {ctor: 'Edit', _0: a};
};
var _user$project$Views_ContactSelection$Search = function (a) {
	return {ctor: 'Search', _0: a};
};
var _user$project$Views_ContactSelection$init = function (toMsg) {
	return {
		ctor: '_Tuple2',
		_0: {
			listContact: {ctor: '[]'},
			isForUpdate: false,
			mode: _user$project$Views_ContactSelection$Search(_user$project$Views_ContactSelection$defaultSearchData)
		},
		_1: _elm_lang$core$Platform_Cmd$none
	};
};
var _user$project$Views_ContactSelection$Visualization = function (a) {
	return {ctor: 'Visualization', _0: a};
};
var _user$project$Views_ContactSelection$updateMode = F2(
	function (model, mayContact) {
		var _p3 = mayContact;
		if (_p3.ctor === 'Just') {
			return _elm_lang$core$Native_Utils.update(
				model,
				{
					mode: _user$project$Views_ContactSelection$Visualization(_p3._0)
				});
		} else {
			return _elm_lang$core$Native_Utils.update(
				model,
				{
					mode: _user$project$Views_ContactSelection$Search(_user$project$Views_ContactSelection$defaultSearchData)
				});
		}
	});
var _user$project$Views_ContactSelection$ContactReceived = function (a) {
	return {ctor: 'ContactReceived', _0: a};
};
var _user$project$Views_ContactSelection$AddNewClicked = {ctor: 'AddNewClicked'};
var _user$project$Views_ContactSelection$UpdateContact = function (a) {
	return {ctor: 'UpdateContact', _0: a};
};
var _user$project$Views_ContactSelection$RemoveContact = {ctor: 'RemoveContact'};
var _user$project$Views_ContactSelection$viewVisualization = F3(
	function (toMsg, toUiTxt, contact) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$moveLeft(26),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
							_1: {ctor: '[]'}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$image,
					_user$project$Styles$DocEditBtn,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(
							_mdgriffith$style_elements$Element_Attributes$px(20)),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$px(20)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Events$onClick(
									toMsg(
										_user$project$Views_ContactSelection$UpdateContact(contact))),
								_1: {ctor: '[]'}
							}
						}
					},
					{src: './images/edit.svg', caption: 'edit'}),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$px(210)),
							_1: {ctor: '[]'}
						},
						_mdgriffith$style_elements$Element$text(
							_user$project$Views_ContactSelection$getContactAsPrettyString(contact))),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$image,
							_user$project$Styles$DocDeleteBtn,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$height(
									_mdgriffith$style_elements$Element_Attributes$px(20)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$px(20)),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Events$onClick(
											toMsg(_user$project$Views_ContactSelection$RemoveContact)),
										_1: {ctor: '[]'}
									}
								}
							},
							{src: './images/delete.svg', caption: 'remove'}),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Views_ContactSelection$SearchContactMouseDown = {ctor: 'SearchContactMouseDown'};
var _user$project$Views_ContactSelection$SearchContactMouseOver = function (a) {
	return {ctor: 'SearchContactMouseOver', _0: a};
};
var _user$project$Views_ContactSelection$SearchContactSelected = function (a) {
	return {ctor: 'SearchContactSelected', _0: a};
};
var _user$project$Views_ContactSelection$SearchInputBlured = {ctor: 'SearchInputBlured'};
var _user$project$Views_ContactSelection$SearchInputFocused = {ctor: 'SearchInputFocused'};
var _user$project$Views_ContactSelection$SearchChanged = function (a) {
	return {ctor: 'SearchChanged', _0: a};
};
var _user$project$Views_ContactSelection$viewSearch = F5(
	function (toMsg, toUiTxt, listContact, searchData, isValid) {
		var staticAddOptionId = -1;
		var staticAddOption = A2(
			_elm_lang$html$Html$li,
			{
				ctor: '::',
				_0: _user$project$Helpers_Views_DataSearch$dataListItemStyle,
				_1: {
					ctor: '::',
					_0: A3(
						_elm_lang$html$Html_Events$onWithOptions,
						'mousedown',
						{stopPropagation: false, preventDefault: true},
						_elm_lang$core$Json_Decode$succeed(
							toMsg(_user$project$Views_ContactSelection$SearchContactMouseDown))),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							toMsg(_user$project$Views_ContactSelection$AddNewClicked)),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onMouseOver(
								toMsg(
									_user$project$Views_ContactSelection$SearchContactMouseOver(
										_elm_lang$core$Maybe$Just(staticAddOptionId)))),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$style(
									{
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$style(
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'font-style', _1: 'italic'},
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: function () {
											var _p4 = searchData.highLightedSearchPoint;
											if (_p4.ctor === 'Nothing') {
												return _elm_lang$html$Html_Attributes$style(
													{
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
														_1: {ctor: '[]'}
													});
											} else {
												return _elm_lang$core$Native_Utils.eq(_p4._0, staticAddOptionId) ? _elm_lang$html$Html_Attributes$style(
													{
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'lightgrey'},
														_1: {ctor: '[]'}
													}) : _elm_lang$html$Html_Attributes$style(
													{
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
														_1: {ctor: '[]'}
													});
											}
										}(),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					toUiTxt('data_contact_add')),
				_1: {ctor: '[]'}
			});
		var filterContacts = A2(
			_elm_lang$core$List$take,
			5,
			A2(
				_elm_lang$core$List$filter,
				function (contact) {
					return A2(
						_elm_lang$core$String$contains,
						_elm_lang$core$String$toLower(searchData.queryString),
						A2(_user$project$Views_ContactSelection$getContactAsString, contact, true));
				},
				listContact));
		var filterListContacts = A2(
			_elm_lang$core$List$map,
			function (contact) {
				return A2(
					_elm_lang$html$Html$li,
					{
						ctor: '::',
						_0: _user$project$Helpers_Views_DataSearch$dataListItemStyle,
						_1: {
							ctor: '::',
							_0: A3(
								_elm_lang$html$Html_Events$onWithOptions,
								'mousedown',
								{stopPropagation: false, preventDefault: true},
								_elm_lang$core$Json_Decode$succeed(
									toMsg(_user$project$Views_ContactSelection$SearchContactMouseDown))),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									toMsg(
										_user$project$Views_ContactSelection$SearchContactSelected(contact))),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onMouseOver(
										toMsg(
											_user$project$Views_ContactSelection$SearchContactMouseOver(contact.id))),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: function () {
												var _p5 = searchData.highLightedSearchPoint;
												if (_p5.ctor === 'Nothing') {
													return _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
															_1: {ctor: '[]'}
														});
												} else {
													return _elm_lang$core$Native_Utils.eq(
														_elm_lang$core$Maybe$Just(_p5._0),
														contact.id) ? _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'lightgrey'},
															_1: {ctor: '[]'}
														}) : _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
															_1: {ctor: '[]'}
														});
												}
											}(),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					},
					{
						ctor: '::',
						_0: A3(_user$project$Views_ContactSelection$viewSearchEntry, toMsg, toUiTxt, contact),
						_1: {ctor: '[]'}
					});
			},
			filterContacts);
		var filterListItems = A2(
			_elm_lang$core$List$append,
			filterListContacts,
			{
				ctor: '::',
				_0: staticAddOption,
				_1: {ctor: '[]'}
			});
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$html(
						A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _user$project$Helpers_Views_DataSearch$dataSearchContainerStyle,
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _user$project$Helpers_Views_DataSearch$dataListDivStyle,
										_1: {
											ctor: '::',
											_0: searchData.isSearchListVisible ? _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'visible'},
													_1: {ctor: '[]'}
												}) : _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'collapse'},
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$ul,
											{
												ctor: '::',
												_0: _user$project$Helpers_Views_DataSearch$dataListStyle,
												_1: {ctor: '[]'}
											},
											filterListItems),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}))),
				_1: {
					ctor: '::',
					_0: A6(
						_user$project$Helpers_Views_Form$elSearch2,
						function (_p6) {
							return toMsg(
								_user$project$Views_ContactSelection$SearchChanged(_p6));
						},
						toMsg(_user$project$Views_ContactSelection$SearchInputFocused),
						toMsg(_user$project$Views_ContactSelection$SearchInputBlured),
						isValid,
						false,
						toUiTxt('data_search')),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_ContactSelection$MsgFromContact = function (a) {
	return {ctor: 'MsgFromContact', _0: a};
};
var _user$project$Views_ContactSelection$viewEdit = F3(
	function (toMsg, toUiTxt, model) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$Section,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
							_1: {ctor: '[]'}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$SubTitle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
							_1: {ctor: '[]'}
						}
					},
					_mdgriffith$style_elements$Element$text(
						toUiTxt('data_contact_add'))),
				_1: {
					ctor: '::',
					_0: A3(
						_user$project$Views_Contact$view,
						function (_p7) {
							return toMsg(
								_user$project$Views_ContactSelection$MsgFromContact(_p7));
						},
						toUiTxt,
						model),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_ContactSelection$view = F4(
	function (toMsg, toUiTxt, model, mayIsSearchValid) {
		var _p8 = model.mode;
		switch (_p8.ctor) {
			case 'Visualization':
				return A3(_user$project$Views_ContactSelection$viewVisualization, toMsg, toUiTxt, _p8._0);
			case 'Search':
				var partApplyedSearchView = A4(_user$project$Views_ContactSelection$viewSearch, toMsg, toUiTxt, model.listContact, _p8._0);
				var _p9 = mayIsSearchValid;
				if (_p9.ctor === 'Just') {
					return partApplyedSearchView(_p9._0);
				} else {
					return partApplyedSearchView(false);
				}
			default:
				return A3(_user$project$Views_ContactSelection$viewEdit, toMsg, toUiTxt, _p8._0);
		}
	});
var _user$project$Views_ContactSelection$RetrievingFailed = function (a) {
	return {ctor: 'RetrievingFailed', _0: a};
};
var _user$project$Views_ContactSelection$ContactRemoved = {ctor: 'ContactRemoved'};
var _user$project$Views_ContactSelection$ContactSelected = function (a) {
	return {ctor: 'ContactSelected', _0: a};
};
var _user$project$Views_ContactSelection$ContactUpdated = function (a) {
	return {ctor: 'ContactUpdated', _0: a};
};
var _user$project$Views_ContactSelection$ContactAdded = function (a) {
	return {ctor: 'ContactAdded', _0: a};
};
var _user$project$Views_ContactSelection$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Views_ContactSelection$update = F5(
	function (toMsg, session, msg, model, baseUrl) {
		var currentSearchData = function () {
			var _p10 = model.mode;
			if (_p10.ctor === 'Search') {
				return _p10._0;
			} else {
				return _user$project$Views_ContactSelection$defaultSearchData;
			}
		}();
		var _p11 = msg;
		switch (_p11.ctor) {
			case 'MsgFromContact':
				var _p12 = model.mode;
				if (_p12.ctor === 'Edit') {
					var _p13 = A5(
						_user$project$Views_Contact$update,
						function (_p14) {
							return toMsg(
								_user$project$Views_ContactSelection$MsgFromContact(_p14));
						},
						session,
						_p11._0,
						_p12._0,
						baseUrl);
					var newContactModel = _p13._0;
					var contactCmd = _p13._1;
					var contactOutMsg = _p13._2;
					var _p15 = contactOutMsg;
					switch (_p15.ctor) {
						case 'SavedContact':
							var _p17 = _p15._0;
							var _p16 = model.isForUpdate;
							if (_p16 === true) {
								return {
									ctor: '_Tuple3',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{
											mode: _user$project$Views_ContactSelection$Visualization(_p17)
										}),
									_1: contactCmd,
									_2: _user$project$Views_ContactSelection$ContactUpdated(_p17)
								};
							} else {
								return {
									ctor: '_Tuple3',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{
											mode: _user$project$Views_ContactSelection$Visualization(_p17)
										}),
									_1: contactCmd,
									_2: _user$project$Views_ContactSelection$ContactAdded(_p17)
								};
							}
						case 'Cancelled':
							var _p18 = _p15._0;
							if (_p18.ctor === 'Just') {
								var getContactByIdCmd = A2(
									_elm_lang$http$Http$send,
									function (_p19) {
										return toMsg(
											_user$project$Views_ContactSelection$ContactReceived(_p19));
									},
									A3(_user$project$Requests_Contact$getById, baseUrl, session.token, _p18._0));
								return {ctor: '_Tuple3', _0: model, _1: getContactByIdCmd, _2: _user$project$Views_ContactSelection$NoOutMsg};
							} else {
								return {
									ctor: '_Tuple3',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{
											mode: _user$project$Views_ContactSelection$Search(_user$project$Views_ContactSelection$defaultSearchData)
										}),
									_1: contactCmd,
									_2: _user$project$Views_ContactSelection$NoOutMsg
								};
							}
						default:
							return {
								ctor: '_Tuple3',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										mode: _user$project$Views_ContactSelection$Edit(newContactModel)
									}),
								_1: contactCmd,
								_2: _user$project$Views_ContactSelection$NoOutMsg
							};
					}
				} else {
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_ContactSelection$NoOutMsg};
				}
			case 'SearchChanged':
				var newSearchData = _elm_lang$core$Native_Utils.update(
					currentSearchData,
					{queryString: _p11._0});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Views_ContactSelection$Search(newSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_ContactSelection$NoOutMsg
				};
			case 'SearchInputFocused':
				var newSearchData = _elm_lang$core$Native_Utils.update(
					currentSearchData,
					{isSearchListVisible: true});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Views_ContactSelection$Search(newSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_ContactSelection$NoOutMsg
				};
			case 'SearchInputBlured':
				var newMode = function () {
					var _p20 = model.mode;
					switch (_p20.ctor) {
						case 'Search':
							return _user$project$Views_ContactSelection$Search(
								_elm_lang$core$Native_Utils.update(
									_p20._0,
									{isSearchListVisible: false}));
						case 'Visualization':
							return _user$project$Views_ContactSelection$Visualization(_p20._0);
						default:
							return _user$project$Views_ContactSelection$Edit(_p20._0);
					}
				}();
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{mode: newMode}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_ContactSelection$NoOutMsg
				};
			case 'SearchContactSelected':
				var _p21 = _p11._0;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Views_ContactSelection$Visualization(_p21)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_ContactSelection$ContactSelected(_p21)
				};
			case 'SearchContactMouseOver':
				var newSearchData = _elm_lang$core$Native_Utils.update(
					currentSearchData,
					{highLightedSearchPoint: _p11._0});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Views_ContactSelection$Search(newSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_ContactSelection$NoOutMsg
				};
			case 'SearchContactMouseDown':
				return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_ContactSelection$NoOutMsg};
			case 'AddNewClicked':
				var _p22 = _user$project$Views_Contact$init;
				var initalContactModel = _p22._0;
				var initContactCmd = _p22._1;
				var _p23 = _user$project$Views_Contact$startAddMode(initalContactModel);
				var newContactModel = _p23._0;
				var contactCmd = _p23._1;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Views_ContactSelection$Edit(newContactModel),
							isForUpdate: false
						}),
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: initContactCmd,
							_1: {
								ctor: '::',
								_0: contactCmd,
								_1: {ctor: '[]'}
							}
						}),
					_2: _user$project$Views_ContactSelection$NoOutMsg
				};
			case 'RemoveContact':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Views_ContactSelection$Search(_user$project$Views_ContactSelection$defaultSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_ContactSelection$ContactRemoved
				};
			case 'UpdateContact':
				var _p24 = _user$project$Views_Contact$init;
				var initalContactModel = _p24._0;
				var initContactCmd = _p24._1;
				var _p25 = function () {
					var _p26 = _p11._0.id;
					if (_p26.ctor === 'Just') {
						return A5(
							_user$project$Views_Contact$startUpdateMode,
							initalContactModel,
							function (_p27) {
								return toMsg(
									_user$project$Views_ContactSelection$MsgFromContact(_p27));
							},
							baseUrl,
							session,
							_p26._0);
					} else {
						return A2(
							_elm_lang$core$Debug$log,
							'Error: The contact has no id.',
							{ctor: '_Tuple2', _0: initalContactModel, _1: _elm_lang$core$Platform_Cmd$none});
					}
				}();
				var newContactModel = _p25._0;
				var contactCmd = _p25._1;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Views_ContactSelection$Edit(newContactModel),
							isForUpdate: true
						}),
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: initContactCmd,
							_1: {
								ctor: '::',
								_0: contactCmd,
								_1: {ctor: '[]'}
							}
						}),
					_2: _user$project$Views_ContactSelection$ContactRemoved
				};
			default:
				if (_p11._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								mode: _user$project$Views_ContactSelection$Visualization(_p11._0._0)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_ContactSelection$NoOutMsg
					};
				} else {
					return {
						ctor: '_Tuple3',
						_0: model,
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_ContactSelection$RetrievingFailed(_p11._0._0)
					};
				}
		}
	});

var _user$project$Views_IsolatedTree$delay = F2(
	function (time, msg) {
		return A2(
			_elm_lang$core$Task$perform,
			function (_p0) {
				return msg;
			},
			_elm_lang$core$Process$sleep(time));
	});
var _user$project$Views_IsolatedTree$fromJust = F2(
	function (propName, x) {
		var _p1 = x;
		if (_p1.ctor === 'Just') {
			return _p1._0;
		} else {
			return _elm_lang$core$Native_Utils.crashCase(
				'Views.IsolatedTree',
				{
					start: {line: 1170, column: 3},
					end: {line: 1173, column: 77}
				},
				_p1)(
				A2(_elm_lang$core$Basics_ops['++'], 'Error: the mandatory property is missing ', propName));
		}
	});
var _user$project$Views_IsolatedTree$circumferenceMsg = F2(
	function (cc, variety) {
		var _p3 = cc;
		if (_p3.ctor === 'Nothing') {
			return 'data_isolatedTree_nothreshold';
		} else {
			var _p6 = _p3._0;
			var _p4 = variety;
			if (_p4.ctor === 'Nothing') {
				return 'data_isolatedTree_nothreshold';
			} else {
				var _p5 = _p4._0;
				return (_elm_lang$core$Native_Utils.cmp(
					_p6,
					_elm_lang$core$Basics$toFloat(_p5.initialThreshold)) > -1) ? ((_elm_lang$core$Native_Utils.cmp(
					_p6,
					_elm_lang$core$Basics$toFloat(_p5.cantonalThreshold)) > -1) ? ((_elm_lang$core$Native_Utils.cmp(
					_p6,
					_elm_lang$core$Basics$toFloat(_p5.federalThreshold)) > -1) ? 'data_isolatedTree_federalthreshold' : 'data_isolatedTree_cantonalthreshold') : 'data_isolatedTree_initialthreshold') : 'data_isolatedTree_nothreshold';
			}
		}
	});
var _user$project$Views_IsolatedTree$getAge = F2(
	function (mayCurrentDate, isolatedTree) {
		var _p7 = isolatedTree.yearOfPlanting;
		if (_p7.ctor === 'Nothing') {
			var _p8 = isolatedTree.isMoreThan100Years;
			if (_p8.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Just('');
			} else {
				return _p8._0 ? _elm_lang$core$Maybe$Just('> 100 ans') : _elm_lang$core$Maybe$Just('< 100 ans');
			}
		} else {
			var mayNewAge = A2(
				_elm_lang$core$Maybe$map,
				function (date) {
					return _elm_lang$core$Date$year(date) - _p7._0;
				},
				mayCurrentDate);
			return A2(_elm_lang$core$Maybe$map, _elm_lang$core$Basics$toString, mayNewAge);
		}
	});
var _user$project$Views_IsolatedTree$fromPoint = F2(
	function (_p9, mayGeom) {
		var _p10 = _p9;
		var mayPointData = function () {
			var _p11 = mayGeom;
			if (_p11.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Result$toMaybe(
					A2(_elm_lang$core$Json_Decode$decodeValue, _user$project$Map_Data_GeoJSON$pointDecoder, _p11._0));
			}
		}();
		var _p12 = mayPointData;
		if (_p12.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var newPointData = _elm_lang$core$Native_Utils.update(
				_p12._0,
				{
					coordinates: _elm_lang$core$Maybe$Just(
						{
							ctor: '::',
							_0: _p10._0,
							_1: {
								ctor: '::',
								_0: _p10._1,
								_1: {ctor: '[]'}
							}
						})
				});
			return _elm_lang$core$Maybe$Just(
				_user$project$Map_Data_GeoJSON$pointEncoder(newPointData));
		}
	});
var _user$project$Views_IsolatedTree$toPoint = function (geom) {
	var mayPointData = _elm_lang$core$Result$toMaybe(
		A2(_elm_lang$core$Json_Decode$decodeValue, _user$project$Map_Data_GeoJSON$pointDecoder, geom));
	var _p13 = mayPointData;
	if (_p13.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		var _p14 = function () {
			var _p15 = _p13._0.coordinates;
			if (_p15.ctor === 'Nothing') {
				return {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Maybe$Nothing};
			} else {
				var coords = _elm_lang$core$Array$fromList(_p15._0);
				return {
					ctor: '_Tuple2',
					_0: A2(_elm_lang$core$Array$get, 0, coords),
					_1: A2(_elm_lang$core$Array$get, 1, coords)
				};
			}
		}();
		var mayX = _p14._0;
		var mayY = _p14._1;
		var _p16 = {ctor: '_Tuple2', _0: mayX, _1: mayY};
		if (((_p16.ctor === '_Tuple2') && (_p16._0.ctor === 'Just')) && (_p16._1.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				{
					ctor: '_Tuple2',
					_0: _elm_lang$core$Basics$toFloat(
						_elm_lang$core$Basics$round(_p16._0._0)),
					_1: _elm_lang$core$Basics$toFloat(
						_elm_lang$core$Basics$round(_p16._1._0))
				});
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	}
};
var _user$project$Views_IsolatedTree$fromIsolatedTreeForm = F3(
	function (mayCurrentYear, dataForm, point) {
		var mayGeom = function () {
			var _p17 = dataForm.geometry;
			if (_p17.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return A2(
					_user$project$Views_IsolatedTree$fromPoint,
					point,
					_elm_lang$core$Maybe$Just(_p17._0));
			}
		}();
		var mayModeratorId = A2(
			_elm_lang$core$Maybe$andThen,
			function (_) {
				return _.id;
			},
			dataForm.moderator);
		var _p18 = mayGeom;
		if (_p18.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			return _elm_lang$core$Maybe$Just(
				{
					id: dataForm.id,
					name: dataForm.name,
					collectionDate: A2(_user$project$Views_IsolatedTree$fromJust, 'collectionDate', dataForm.collectionDate),
					commune: A2(_user$project$Views_IsolatedTree$fromJust, 'commune', dataForm.commune),
					plotNb: A2(_user$project$Views_IsolatedTree$fromJust, 'plot_nb', dataForm.plotNb),
					variety: A2(_user$project$Views_IsolatedTree$fromJust, 'variety', dataForm.variety),
					isVarietyCertain: dataForm.isVarietyCertain,
					circumference: A2(_user$project$Views_IsolatedTree$fromJust, 'circumference', dataForm.circumference),
					isMultiTrunk: A2(_user$project$Views_IsolatedTree$fromJust, 'isMultiTrunk', dataForm.isMultiTrunk),
					crownDevelopment: A2(_user$project$Views_IsolatedTree$fromJust, 'crownDevelopment', dataForm.crownDevelopment),
					yearOfPlanting: dataForm.yearOfPlanting,
					isMoreThan100Years: dataForm.isMoreThan100Years,
					hasSocioHistoricalInterest: A2(_user$project$Views_IsolatedTree$fromJust, 'hasSocioHistoricalInterest', dataForm.hasSocioHistoricalInterest),
					socioHistoricalInterest: dataForm.socioHistoricalInterest,
					hasLandscapeInterest: A2(_user$project$Views_IsolatedTree$fromJust, 'hasLandscapeInterest', dataForm.hasLandscapeInterest),
					ecosystemSituation: A2(_user$project$Views_IsolatedTree$fromJust, 'ecosystemSituation', dataForm.ecosystemSituation),
					isMentioned: A2(_user$project$Views_IsolatedTree$fromJust, 'IsMentioned', dataForm.isMentioned),
					isOfRegionalImportance: A2(_user$project$Views_IsolatedTree$fromJust, 'isOfRegionalImportance', dataForm.isOfRegionalImportance),
					comments: dataForm.comments,
					documents: dataForm.documents,
					isRanked: dataForm.isRanked,
					justificationOfRanking: dataForm.justificationOfRanking,
					isPartOfAGroup: A2(_user$project$Views_IsolatedTree$fromJust, 'isPartOfAGroup', dataForm.isPartOfAGroup),
					isCandidate: A2(_user$project$Views_IsolatedTree$fromJust, 'isCandidate', dataForm.isCandidate),
					candidacyComment: dataForm.candidacyComment,
					isOfLocalInterest: A2(_user$project$Views_IsolatedTree$fromJust, 'isOfLocalInterest', dataForm.isOfLocalInterest),
					moderatorId: mayModeratorId,
					totalScore: 0,
					geometry: _p18._0,
					createdBy: dataForm.createdBy,
					updatedBy: dataForm.updatedBy,
					createdAt: dataForm.createdAt,
					updatedAt: dataForm.updatedAt
				});
		}
	});
var _user$project$Views_IsolatedTree$toIsolatedTreeForm = F3(
	function (mayCurrentDate, mayContact, mayIsolatedTree) {
		var _p19 = mayIsolatedTree;
		if (_p19.ctor === 'Just') {
			var _p21 = _p19._0;
			return {
				id: _p21.id,
				name: _p21.name,
				collectionDate: _elm_lang$core$Maybe$Just(_p21.collectionDate),
				commune: _elm_lang$core$Maybe$Just(_p21.commune),
				plotNb: _elm_lang$core$Maybe$Just(_p21.plotNb),
				variety: _elm_lang$core$Maybe$Just(_p21.variety),
				isVarietyCertain: _p21.isVarietyCertain,
				circumference: _elm_lang$core$Maybe$Just(_p21.circumference),
				isMultiTrunk: _elm_lang$core$Maybe$Just(_p21.isMultiTrunk),
				crownDevelopment: _elm_lang$core$Maybe$Just(_p21.crownDevelopment),
				isyearOfPlantingKnown: function () {
					var _p20 = _p21.yearOfPlanting;
					if (_p20.ctor === 'Nothing') {
						return _elm_lang$core$Maybe$Just(false);
					} else {
						return _elm_lang$core$Maybe$Just(true);
					}
				}(),
				yearOfPlanting: _p21.yearOfPlanting,
				isMoreThan100Years: _p21.isMoreThan100Years,
				age: A2(_user$project$Views_IsolatedTree$getAge, mayCurrentDate, _p21),
				hasSocioHistoricalInterest: _elm_lang$core$Maybe$Just(_p21.hasSocioHistoricalInterest),
				socioHistoricalInterest: _p21.socioHistoricalInterest,
				hasLandscapeInterest: _elm_lang$core$Maybe$Just(_p21.hasLandscapeInterest),
				ecosystemSituation: _elm_lang$core$Maybe$Just(_p21.ecosystemSituation),
				isMentioned: _elm_lang$core$Maybe$Just(_p21.isMentioned),
				isOfRegionalImportance: _elm_lang$core$Maybe$Just(_p21.isOfRegionalImportance),
				comments: _p21.comments,
				documents: _p21.documents,
				isRanked: _p21.isRanked,
				justificationOfRanking: _p21.justificationOfRanking,
				isPartOfAGroup: _elm_lang$core$Maybe$Just(_p21.isPartOfAGroup),
				isCandidate: _elm_lang$core$Maybe$Just(_p21.isCandidate),
				candidacyComment: _p21.candidacyComment,
				isOfLocalInterest: _elm_lang$core$Maybe$Just(_p21.isOfLocalInterest),
				moderator: mayContact,
				totalScore: _elm_lang$core$Maybe$Just(_p21.totalScore),
				geometry: _elm_lang$core$Maybe$Just(_p21.geometry),
				createdBy: _p21.createdBy,
				updatedBy: _p21.updatedBy,
				createdAt: _p21.createdAt,
				updatedAt: _p21.updatedAt
			};
		} else {
			return {
				id: _elm_lang$core$Maybe$Nothing,
				name: _elm_lang$core$Maybe$Nothing,
				collectionDate: _elm_lang$core$Maybe$Nothing,
				commune: _elm_lang$core$Maybe$Nothing,
				plotNb: _elm_lang$core$Maybe$Nothing,
				variety: _elm_lang$core$Maybe$Nothing,
				isVarietyCertain: true,
				circumference: _elm_lang$core$Maybe$Nothing,
				isMultiTrunk: _elm_lang$core$Maybe$Nothing,
				crownDevelopment: _elm_lang$core$Maybe$Nothing,
				isyearOfPlantingKnown: _elm_lang$core$Maybe$Nothing,
				yearOfPlanting: _elm_lang$core$Maybe$Nothing,
				isMoreThan100Years: _elm_lang$core$Maybe$Nothing,
				age: _elm_lang$core$Maybe$Nothing,
				hasSocioHistoricalInterest: _elm_lang$core$Maybe$Nothing,
				socioHistoricalInterest: _elm_lang$core$Maybe$Nothing,
				hasLandscapeInterest: _elm_lang$core$Maybe$Nothing,
				ecosystemSituation: _elm_lang$core$Maybe$Nothing,
				isMentioned: _elm_lang$core$Maybe$Nothing,
				isOfRegionalImportance: _elm_lang$core$Maybe$Nothing,
				comments: _elm_lang$core$Maybe$Nothing,
				documents: {ctor: '[]'},
				isRanked: _elm_lang$core$Maybe$Nothing,
				justificationOfRanking: _elm_lang$core$Maybe$Nothing,
				isPartOfAGroup: _elm_lang$core$Maybe$Nothing,
				isCandidate: _elm_lang$core$Maybe$Nothing,
				candidacyComment: _elm_lang$core$Maybe$Nothing,
				isOfLocalInterest: _elm_lang$core$Maybe$Nothing,
				moderator: _elm_lang$core$Maybe$Nothing,
				totalScore: _elm_lang$core$Maybe$Nothing,
				geometry: _elm_lang$core$Maybe$Nothing,
				createdBy: _elm_lang$core$Maybe$Nothing,
				updatedBy: _elm_lang$core$Maybe$Nothing,
				createdAt: _elm_lang$core$Maybe$Nothing,
				updatedAt: _elm_lang$core$Maybe$Nothing
			};
		}
	});
var _user$project$Views_IsolatedTree$yearOfPlantationValidator = function (mayYear) {
	var _p22 = mayYear;
	if (_p22.ctor === 'Nothing') {
		return false;
	} else {
		var _p23 = _p22._0;
		return (_elm_lang$core$Native_Utils.cmp(_p23, 1000) < 0) ? false : ((_elm_lang$core$Native_Utils.cmp(_p23, 2100) > 0) ? false : true);
	}
};
var _user$project$Views_IsolatedTree$inputValidation = {
	validateName: A2(_user$project$Helpers_Data_InputValidation$validate, false, _elm_lang$core$Maybe$Nothing),
	validateCircumference: A2(_user$project$Helpers_Data_InputValidation$validate, true, _elm_lang$core$Maybe$Nothing),
	validateYearOfPlantation: A2(
		_user$project$Helpers_Data_InputValidation$validate,
		true,
		_elm_lang$core$Maybe$Just(_user$project$Views_IsolatedTree$yearOfPlantationValidator)),
	validateCoordX: A2(_user$project$Helpers_Data_InputValidation$validate, true, _elm_lang$core$Maybe$Nothing),
	validateCoordY: A2(_user$project$Helpers_Data_InputValidation$validate, true, _elm_lang$core$Maybe$Nothing)
};
var _user$project$Views_IsolatedTree$plotReqDecoder = A2(
	_elm_lang$core$Json_Decode$field,
	'features',
	A2(
		_elm_lang$core$Json_Decode$index,
		0,
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'attributes',
				_1: {
					ctor: '::',
					_0: 'NUMERO',
					_1: {ctor: '[]'}
				}
			},
			_elm_lang$core$Json_Decode$string)));
var _user$project$Views_IsolatedTree$getTreeAndMayModerator = F3(
	function (baseUrl, session, treeId) {
		var moderatorReqTaskFromId = function (modId) {
			return _elm_lang$http$Http$toTask(
				A3(_user$project$Requests_Contact$getById, baseUrl, session.token, modId));
		};
		var treeReqTask = _elm_lang$http$Http$toTask(
			A3(_user$project$Requests_IsolatedTree$getById, baseUrl, session.token, treeId));
		return A2(
			_elm_lang$core$Task$andThen,
			function (tree) {
				if (A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$ContactReader) || A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$ContactEditor)) {
					var _p24 = tree.moderatorId;
					if (_p24.ctor === 'Nothing') {
						return _elm_lang$core$Task$succeed(
							{ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: tree});
					} else {
						return A2(
							_elm_lang$core$Task$map,
							function (contact) {
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Maybe$Just(contact),
									_1: tree
								};
							},
							moderatorReqTaskFromId(_p24._0));
					}
				} else {
					return _elm_lang$core$Task$succeed(
						{ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: tree});
				}
			},
			treeReqTask);
	});
var _user$project$Views_IsolatedTree$ContactSelectionModelContact = F2(
	function (a, b) {
		return {model: a, contact: b};
	});
var _user$project$Views_IsolatedTree$InputValidation = F5(
	function (a, b, c, d, e) {
		return {validateName: a, validateCircumference: b, validateYearOfPlantation: c, validateCoordX: d, validateCoordY: e};
	});
var _user$project$Views_IsolatedTree$Point = F3(
	function (a, b, c) {
		return {attribute: a, score: b, isAddedToSum: c};
	});
var _user$project$Views_IsolatedTree$Model = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return {mode: a, eventMsgs: b, isolatedTree: c, isolatedTreeForm: d, currentYear: e, docTableState: f, datePickerCollection: g, datePickerPlanting: h, datalistNameState: i, moderatorSelectionModel: j, infoSectionHidden: k, keySectionHidden: l, decisionSectionHidden: m, docSectionHidden: n, attributeScore: o, sliderPosition: p, showPoints: q, isLatin: r, treeCoordX: s, treeCoordY: t};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Views_IsolatedTree$MainEdit = {ctor: 'MainEdit'};
var _user$project$Views_IsolatedTree$Visualization = {ctor: 'Visualization'};
var _user$project$Views_IsolatedTree$ExportPDFMode = {ctor: 'ExportPDFMode'};
var _user$project$Views_IsolatedTree$NoMsg = function (a) {
	return {ctor: 'NoMsg', _0: a};
};
var _user$project$Views_IsolatedTree$SwitchVariety = {ctor: 'SwitchVariety'};
var _user$project$Views_IsolatedTree$ShowPointsChanged = function (a) {
	return {ctor: 'ShowPointsChanged', _0: a};
};
var _user$project$Views_IsolatedTree$ImageSliderMore = F2(
	function (a, b) {
		return {ctor: 'ImageSliderMore', _0: a, _1: b};
	});
var _user$project$Views_IsolatedTree$ImageSliderLess = F2(
	function (a, b) {
		return {ctor: 'ImageSliderLess', _0: a, _1: b};
	});
var _user$project$Views_IsolatedTree$viewImageSlider = F5(
	function (toMsg, dwnldUrl, queryParams, documents, sliderPosition) {
		var images = A2(
			_elm_lang$core$List$filter,
			function (d) {
				return A2(
					_elm_lang$core$List$member,
					A2(_elm_lang$core$String$dropLeft, 23, d.contentType),
					{
						ctor: '::',
						_0: 'image',
						_1: {ctor: '[]'}
					});
			},
			documents);
		var curImage = A2(
			_elm_lang$core$Array$get,
			sliderPosition,
			_elm_lang$core$Array$fromList(images));
		var file = function () {
			var _p25 = curImage;
			if (_p25.ctor === 'Nothing') {
				return '';
			} else {
				var _p26 = _p25._0.file;
				if (_p26.ctor === 'Nothing') {
					return '';
				} else {
					return _p26._0;
				}
			}
		}();
		var filename = function () {
			var _p27 = curImage;
			if (_p27.ctor === 'Nothing') {
				return '';
			} else {
				var _p28 = _p27._0.filename;
				if (_p28.ctor === 'Nothing') {
					return '';
				} else {
					return _p28._0;
				}
			}
		}();
		var sliderMax = _elm_lang$core$List$length(images) - 1;
		var sliderCount = function () {
			var _p29 = _elm_lang$core$Native_Utils.cmp(sliderPosition, sliderMax) < 1;
			if (_p29 === true) {
				return sliderPosition;
			} else {
				return 0;
			}
		}();
		var mayNameToString = function (mayName) {
			var _p30 = mayName;
			if (_p30.ctor === 'Nothing') {
				return '';
			} else {
				return _p30._0;
			}
		};
		return _elm_lang$core$List$isEmpty(images) ? _mdgriffith$style_elements$Element$empty : A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$center,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								toMsg(
									A2(_user$project$Views_IsolatedTree$ImageSliderLess, sliderCount, sliderMax))),
							_1: {ctor: '[]'}
						}
					},
					A3(
						_mdgriffith$style_elements$Element$image,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$px(24)),
							_1: {ctor: '[]'}
						},
						{
							src: _elm_lang$core$Native_Utils.eq(sliderCount, 0) ? './images/chevronLG.svg' : './images/chevronL.svg',
							caption: 'arrowBtn'
						})),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$image,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$px(360)),
							_1: {ctor: '[]'}
						},
						{
							src: A2(
								_elm_lang$core$Basics_ops['++'],
								dwnldUrl,
								A2(
									_elm_lang$core$Basics_ops['++'],
									file,
									A2(
										_elm_lang$core$Basics_ops['++'],
										'/?filename=',
										A2(
											_elm_lang$core$Basics_ops['++'],
											filename,
											A2(_elm_lang$core$Basics_ops['++'], '&', queryParams))))),
							caption: 'en cours de chargement...'
						}),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$button,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										toMsg(
											A2(_user$project$Views_IsolatedTree$ImageSliderMore, sliderCount, sliderMax))),
									_1: {ctor: '[]'}
								}
							},
							A3(
								_mdgriffith$style_elements$Element$image,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$px(24)),
									_1: {ctor: '[]'}
								},
								{
									src: _elm_lang$core$Native_Utils.eq(sliderCount, sliderMax) ? './images/chevronRG.svg' : './images/chevronR.svg',
									caption: 'arrowBtn'
								})),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Views_IsolatedTree$ReceivedPlace = function (a) {
	return {ctor: 'ReceivedPlace', _0: a};
};
var _user$project$Views_IsolatedTree$subscriptions = _user$project$Ports$inboundPlace(_user$project$Views_IsolatedTree$ReceivedPlace);
var _user$project$Views_IsolatedTree$ReceivedTreeAndMayModerator = F2(
	function (a, b) {
		return {ctor: 'ReceivedTreeAndMayModerator', _0: a, _1: b};
	});
var _user$project$Views_IsolatedTree$ReceivedPlotNb = function (a) {
	return {ctor: 'ReceivedPlotNb', _0: a};
};
var _user$project$Views_IsolatedTree$getPlotNbReq = F3(
	function (toMsg, x, y) {
		var vdPlotUrl = A2(
			_elm_lang$core$Basics_ops['++'],
			'https://www.ogc.vd.ch/public/rest/services/OGC/wmsVD/MapServer/272/query?',
			A2(
				_elm_lang$core$Basics_ops['++'],
				'geometry=',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(x),
					A2(
						_elm_lang$core$Basics_ops['++'],
						'%2C',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(y),
							A2(
								_elm_lang$core$Basics_ops['++'],
								'&time=current&geometryType=esriGeometryPoint&spatialRel=esriSpatialRelIntersects&units=esriSRUnit_Foot',
								A2(_elm_lang$core$Basics_ops['++'], '&returnGeometry=false&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&returnZ=false', '&returnM=false&returnDistinctValues=false&returnExtentOnly=false&featureEncoding=esriDefault&f=json')))))));
		return A2(
			_elm_lang$http$Http$send,
			function (_p31) {
				return toMsg(
					_user$project$Views_IsolatedTree$ReceivedPlotNb(_p31));
			},
			A2(_elm_lang$http$Http$get, vdPlotUrl, _user$project$Views_IsolatedTree$plotReqDecoder));
	});
var _user$project$Views_IsolatedTree$ReceivedContacts = function (a) {
	return {ctor: 'ReceivedContacts', _0: a};
};
var _user$project$Views_IsolatedTree$ReceivedUpdatedPoints = function (a) {
	return {ctor: 'ReceivedUpdatedPoints', _0: a};
};
var _user$project$Views_IsolatedTree$SwitchDocSectionHidden = {ctor: 'SwitchDocSectionHidden'};
var _user$project$Views_IsolatedTree$SwitchDecisionSectionHidden = {ctor: 'SwitchDecisionSectionHidden'};
var _user$project$Views_IsolatedTree$SwitchKeySectionHidden = {ctor: 'SwitchKeySectionHidden'};
var _user$project$Views_IsolatedTree$SwitchInfoSectionHidden = {ctor: 'SwitchInfoSectionHidden'};
var _user$project$Views_IsolatedTree$MsgFromDatalistName = function (a) {
	return {ctor: 'MsgFromDatalistName', _0: a};
};
var _user$project$Views_IsolatedTree$MsgFromModeratorSelection = function (a) {
	return {ctor: 'MsgFromModeratorSelection', _0: a};
};
var _user$project$Views_IsolatedTree$MsgFromDocTable = function (a) {
	return {ctor: 'MsgFromDocTable', _0: a};
};
var _user$project$Views_IsolatedTree$viewDocEditForm = F6(
	function (toMsg, toUiTxt, dwnldUrl, queryParams, docTableState, documents) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$Section,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
							_1: {ctor: '[]'}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$SubTitle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
							_1: {ctor: '[]'}
						}
					},
					_mdgriffith$style_elements$Element$text(
						toUiTxt('data_documents_isolatedTree'))),
				_1: {
					ctor: '::',
					_0: A8(
						_user$project$Views_DocTable$view,
						function (_p32) {
							return toMsg(
								_user$project$Views_IsolatedTree$MsgFromDocTable(_p32));
						},
						toUiTxt,
						dwnldUrl,
						queryParams,
						docTableState,
						_user$project$Styles$NoStyle,
						false,
						{
							ctor: '::',
							_0: documents,
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_IsolatedTree$JustificationOfRankingChanged = function (a) {
	return {ctor: 'JustificationOfRankingChanged', _0: a};
};
var _user$project$Views_IsolatedTree$IsRankedChanged = function (a) {
	return {ctor: 'IsRankedChanged', _0: a};
};
var _user$project$Views_IsolatedTree$CommentsChanged = function (a) {
	return {ctor: 'CommentsChanged', _0: a};
};
var _user$project$Views_IsolatedTree$CandidacyCommentChanged = function (a) {
	return {ctor: 'CandidacyCommentChanged', _0: a};
};
var _user$project$Views_IsolatedTree$IsCandidateChanged = function (a) {
	return {ctor: 'IsCandidateChanged', _0: a};
};
var _user$project$Views_IsolatedTree$IsOfLocalInterestChanged = function (a) {
	return {ctor: 'IsOfLocalInterestChanged', _0: a};
};
var _user$project$Views_IsolatedTree$IsOfRegionalImportanceChanged = function (a) {
	return {ctor: 'IsOfRegionalImportanceChanged', _0: a};
};
var _user$project$Views_IsolatedTree$IsMentionedChanged = function (a) {
	return {ctor: 'IsMentionedChanged', _0: a};
};
var _user$project$Views_IsolatedTree$EcosystemSituationChanged = function (a) {
	return {ctor: 'EcosystemSituationChanged', _0: a};
};
var _user$project$Views_IsolatedTree$HasLandscapeInterestChanged = function (a) {
	return {ctor: 'HasLandscapeInterestChanged', _0: a};
};
var _user$project$Views_IsolatedTree$SocioHistoricalInterestChanged = function (a) {
	return {ctor: 'SocioHistoricalInterestChanged', _0: a};
};
var _user$project$Views_IsolatedTree$HasSocioHistoricalInterestChanged = function (a) {
	return {ctor: 'HasSocioHistoricalInterestChanged', _0: a};
};
var _user$project$Views_IsolatedTree$IsMoreThan100Years = function (a) {
	return {ctor: 'IsMoreThan100Years', _0: a};
};
var _user$project$Views_IsolatedTree$IsyearOfPlantingKnown = function (a) {
	return {ctor: 'IsyearOfPlantingKnown', _0: a};
};
var _user$project$Views_IsolatedTree$PlantingYearChanged = F2(
	function (a, b) {
		return {ctor: 'PlantingYearChanged', _0: a, _1: b};
	});
var _user$project$Views_IsolatedTree$IsPartOfAGroupChanged = function (a) {
	return {ctor: 'IsPartOfAGroupChanged', _0: a};
};
var _user$project$Views_IsolatedTree$CrownDevelopmentChanged = function (a) {
	return {ctor: 'CrownDevelopmentChanged', _0: a};
};
var _user$project$Views_IsolatedTree$IsMultiTrunkChanged = function (a) {
	return {ctor: 'IsMultiTrunkChanged', _0: a};
};
var _user$project$Views_IsolatedTree$CoordYChanged = function (a) {
	return {ctor: 'CoordYChanged', _0: a};
};
var _user$project$Views_IsolatedTree$CoordXChanged = function (a) {
	return {ctor: 'CoordXChanged', _0: a};
};
var _user$project$Views_IsolatedTree$CircumferenceChanged = function (a) {
	return {ctor: 'CircumferenceChanged', _0: a};
};
var _user$project$Views_IsolatedTree$updateAllPointsCmd = F2(
	function (toMsg, isolatedTreeForm) {
		var performTask = F2(
			function (mayValue, msg) {
				var _p33 = mayValue;
				if (_p33.ctor === 'Nothing') {
					return _elm_lang$core$Platform_Cmd$none;
				} else {
					return A2(
						_elm_lang$core$Task$perform,
						function (_p34) {
							return toMsg(
								msg(_p34));
						},
						_elm_lang$core$Task$succeed(_p33._0));
				}
			});
		var toMayString = function (mayValue) {
			var _p35 = mayValue;
			if (_p35.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					_elm_lang$core$Basics$toString(_p35._0));
			}
		};
		return _elm_lang$core$Platform_Cmd$batch(
			{
				ctor: '::',
				_0: A2(
					performTask,
					toMayString(isolatedTreeForm.circumference),
					_user$project$Views_IsolatedTree$CircumferenceChanged),
				_1: {
					ctor: '::',
					_0: A2(performTask, isolatedTreeForm.crownDevelopment, _user$project$Views_IsolatedTree$CrownDevelopmentChanged),
					_1: {
						ctor: '::',
						_0: A2(performTask, isolatedTreeForm.ecosystemSituation, _user$project$Views_IsolatedTree$EcosystemSituationChanged),
						_1: {
							ctor: '::',
							_0: A2(performTask, isolatedTreeForm.comments, _user$project$Views_IsolatedTree$CommentsChanged),
							_1: {
								ctor: '::',
								_0: A2(performTask, isolatedTreeForm.justificationOfRanking, _user$project$Views_IsolatedTree$JustificationOfRankingChanged),
								_1: {
									ctor: '::',
									_0: A2(performTask, isolatedTreeForm.isyearOfPlantingKnown, _user$project$Views_IsolatedTree$IsyearOfPlantingKnown),
									_1: {
										ctor: '::',
										_0: A2(performTask, isolatedTreeForm.hasSocioHistoricalInterest, _user$project$Views_IsolatedTree$HasSocioHistoricalInterestChanged),
										_1: {
											ctor: '::',
											_0: A2(performTask, isolatedTreeForm.hasLandscapeInterest, _user$project$Views_IsolatedTree$HasLandscapeInterestChanged),
											_1: {
												ctor: '::',
												_0: A2(performTask, isolatedTreeForm.isMentioned, _user$project$Views_IsolatedTree$IsMentionedChanged),
												_1: {
													ctor: '::',
													_0: A2(performTask, isolatedTreeForm.isOfRegionalImportance, _user$project$Views_IsolatedTree$IsOfRegionalImportanceChanged),
													_1: {
														ctor: '::',
														_0: A2(performTask, isolatedTreeForm.isRanked, _user$project$Views_IsolatedTree$IsRankedChanged),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			});
	});
var _user$project$Views_IsolatedTree$IsVarietyCertainChanged = function (a) {
	return {ctor: 'IsVarietyCertainChanged', _0: a};
};
var _user$project$Views_IsolatedTree$SetDatePickerCollection = function (a) {
	return {ctor: 'SetDatePickerCollection', _0: a};
};
var _user$project$Views_IsolatedTree$NameChanged = function (a) {
	return {ctor: 'NameChanged', _0: a};
};
var _user$project$Views_IsolatedTree$GetCurrentDateFor = function (a) {
	return {ctor: 'GetCurrentDateFor', _0: a};
};
var _user$project$Views_IsolatedTree$SetCurrentYear = function (a) {
	return {ctor: 'SetCurrentYear', _0: a};
};
var _user$project$Views_IsolatedTree$init = F5(
	function (toMsg, session, mayId, isEdit, baseUrl) {
		var getContactsCmd = A2(
			_elm_lang$http$Http$send,
			function (_p36) {
				return toMsg(
					_user$project$Views_IsolatedTree$ReceivedContacts(_p36));
			},
			_user$project$Requests_Contact$getAll(session.token));
		var getItemByIdCmd = function () {
			var _p37 = mayId;
			if (_p37.ctor === 'Just') {
				return A2(
					_elm_lang$core$Task$attempt,
					function (_p38) {
						return toMsg(
							_user$project$Views_IsolatedTree$GetCurrentDateFor(
								_user$project$Views_IsolatedTree$ReceivedTreeAndMayModerator(_p38)));
					},
					A3(_user$project$Views_IsolatedTree$getTreeAndMayModerator, baseUrl, session, _p37._0));
			} else {
				return _elm_lang$core$Platform_Cmd$none;
			}
		}();
		var datalistNameState = _user$project$Helpers_Views_DatalistElement$init(_elm_lang$core$Maybe$Nothing);
		var _p39 = _elm_community$elm_datepicker$DatePicker$init;
		var datePickerPlanting = _p39._0;
		var datePickerPlantingCmd = _p39._1;
		var _p40 = _elm_community$elm_datepicker$DatePicker$init;
		var datePickerCollection = _p40._0;
		var datePickerCollectionCmd = _p40._1;
		var _p41 = A2(
			_user$project$Views_DocTable$init,
			function (_p42) {
				return toMsg(
					_user$project$Views_IsolatedTree$MsgFromDocTable(_p42));
			},
			isEdit);
		var docTableState = _p41._0;
		var docTableCmd = _p41._1;
		var _p43 = _user$project$Views_ContactSelection$init(
			function (_p44) {
				return toMsg(
					_user$project$Views_IsolatedTree$MsgFromModeratorSelection(_p44));
			});
		var moderatorSelectionModel = _p43._0;
		var moderatorSelectionCmd = _p43._1;
		return {
			ctor: '_Tuple2',
			_0: {
				mode: isEdit ? _user$project$Views_IsolatedTree$MainEdit : _user$project$Views_IsolatedTree$Visualization,
				eventMsgs: {ctor: '[]'},
				isolatedTree: _elm_lang$core$Maybe$Nothing,
				isolatedTreeForm: A3(_user$project$Views_IsolatedTree$toIsolatedTreeForm, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing),
				currentYear: _elm_lang$core$Maybe$Nothing,
				docTableState: docTableState,
				datePickerCollection: datePickerCollection,
				datePickerPlanting: datePickerPlanting,
				datalistNameState: datalistNameState,
				moderatorSelectionModel: moderatorSelectionModel,
				infoSectionHidden: false,
				keySectionHidden: false,
				decisionSectionHidden: true,
				docSectionHidden: true,
				attributeScore: _elm_lang$core$Maybe$Nothing,
				sliderPosition: 0,
				showPoints: false,
				isLatin: true,
				treeCoordX: _elm_lang$core$Maybe$Nothing,
				treeCoordY: _elm_lang$core$Maybe$Nothing
			},
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: A2(
						_elm_lang$core$Task$perform,
						function (_p45) {
							return toMsg(
								_user$project$Views_IsolatedTree$SetCurrentYear(_p45));
						},
						_elm_lang$core$Date$now),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (_p46) {
								return toMsg(
									_user$project$Views_IsolatedTree$SetDatePickerCollection(_p46));
							},
							datePickerCollectionCmd),
						_1: {
							ctor: '::',
							_0: getItemByIdCmd,
							_1: {
								ctor: '::',
								_0: (A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$ContactReader) || A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$ContactEditor)) ? getContactsCmd : _elm_lang$core$Platform_Cmd$none,
								_1: {
									ctor: '::',
									_0: docTableCmd,
									_1: {
										ctor: '::',
										_0: moderatorSelectionCmd,
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				})
		};
	});
var _user$project$Views_IsolatedTree$initNew = F4(
	function (toMsg, session, geom, baseUrl) {
		var _p47 = function () {
			var _p48 = _user$project$Views_IsolatedTree$toPoint(geom);
			if (_p48.ctor === 'Nothing') {
				return {ctor: '_Tuple3', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Maybe$Nothing, _2: _elm_lang$core$Platform_Cmd$none};
			} else {
				var _p50 = _p48._0._1;
				var _p49 = _p48._0._0;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Maybe$Just(_p49),
					_1: _elm_lang$core$Maybe$Just(_p50),
					_2: A3(_user$project$Views_IsolatedTree$getPlotNbReq, toMsg, _p49, _p50)
				};
			}
		}();
		var coordX = _p47._0;
		var coordY = _p47._1;
		var getPlotNbCmd = _p47._2;
		var getPlaceCmd = _user$project$Ports$getAreaAndPlace(geom);
		var _p51 = A5(_user$project$Views_IsolatedTree$init, toMsg, session, _elm_lang$core$Maybe$Nothing, true, baseUrl);
		var blankModel = _p51._0;
		var initCmd = _p51._1;
		var isolatedTreeForm = blankModel.isolatedTreeForm;
		var newIsolatedTreeForm = _elm_lang$core$Native_Utils.update(
			isolatedTreeForm,
			{
				geometry: _elm_lang$core$Maybe$Just(geom)
			});
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				blankModel,
				{isolatedTreeForm: newIsolatedTreeForm, treeCoordX: coordX, treeCoordY: coordY}),
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: initCmd,
					_1: {
						ctor: '::',
						_0: getPlaceCmd,
						_1: {
							ctor: '::',
							_0: getPlotNbCmd,
							_1: {ctor: '[]'}
						}
					}
				})
		};
	});
var _user$project$Views_IsolatedTree$Saved = function (a) {
	return {ctor: 'Saved', _0: a};
};
var _user$project$Views_IsolatedTree$SaveClicked = function (a) {
	return {ctor: 'SaveClicked', _0: a};
};
var _user$project$Views_IsolatedTree$viewMainForm = F7(
	function (toMsg, toUiTxt, closeMsg, fileServiceUrl, queryParams, session, model) {
		var hasLimitedExtendedReaderRights = A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$Guest);
		var hasCantonEditRights = A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeEditor) && (!A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeLocalEditor));
		var isDocEdit = function () {
			var _p52 = model.docTableState.mode;
			if (_p52.ctor === 'EditDocMode') {
				return true;
			} else {
				return false;
			}
		}();
		var ecosystemSituationPoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.ecosystemSituationScore;
			},
			model.attributeScore);
		var hasLandscapeInterestPoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.landscapeInterestScore;
			},
			model.attributeScore);
		var hasSocioHistoricalInterestPoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.socioHistoricalInterestScore;
			},
			model.attributeScore);
		var ecologicalInterestPoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.ecologicalInterestScore;
			},
			model.attributeScore);
		var agePoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.ageScore;
			},
			model.attributeScore);
		var crownDevelopmentPoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.crownDevelopmentScore;
			},
			model.attributeScore);
		var isMultiTrunkPoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.multitrunkScore;
			},
			model.attributeScore);
		var circumferencePoints = A2(
			_elm_lang$core$Maybe$map,
			function (attSco) {
				return attSco.circumferenceScore;
			},
			model.attributeScore);
		var pointsSum = A2(
			_elm_lang$core$Maybe$withDefault,
			0,
			A2(
				_elm_lang$core$Maybe$map,
				function (attSco) {
					return attSco.totalScore;
				},
				model.attributeScore));
		var coordYValidation = A2(_user$project$Views_IsolatedTree$inputValidation.validateCoordY, _elm_lang$core$Maybe$Nothing, model.treeCoordY);
		var coordXValidation = A2(_user$project$Views_IsolatedTree$inputValidation.validateCoordX, _elm_lang$core$Maybe$Nothing, model.treeCoordX);
		var formData = model.isolatedTreeForm;
		var nameValidation = A2(_user$project$Views_IsolatedTree$inputValidation.validateName, _elm_lang$core$Maybe$Nothing, formData.name);
		var circumferenceValidation = A2(
			_user$project$Views_IsolatedTree$inputValidation.validateCircumference,
			_elm_lang$core$Maybe$Just(
				toUiTxt('data_isolatedTree_circumference_validation')),
			formData.circumference);
		var yearOfPlantingValidation = A2(_user$project$Views_IsolatedTree$inputValidation.validateYearOfPlantation, _elm_lang$core$Maybe$Nothing, formData.yearOfPlanting);
		var yearOfPlantingStr = A2(_elm_lang$core$Maybe$map, _elm_lang$core$Basics$toString, formData.yearOfPlanting);
		var isCrownDevelopmentValid = A2(
			_elm_lang$core$List$member,
			formData.crownDevelopment,
			A2(_elm_lang$core$List$map, _elm_lang$core$Maybe$Just, _user$project$Data_Tree$crownDevelopmentOptions));
		var isEcosystemSituationValid = A2(
			_elm_lang$core$List$member,
			formData.ecosystemSituation,
			A2(_elm_lang$core$List$map, _elm_lang$core$Maybe$Just, _user$project$Data_Tree$ecosystemSituationOptions));
		var isSocioHistoricalInterestValid = A2(
			_elm_lang$core$List$member,
			formData.socioHistoricalInterest,
			A2(_elm_lang$core$List$map, _elm_lang$core$Maybe$Just, _user$project$Data_Tree$socioHistoricalInterestOptions));
		var isCollectionDateValid = function () {
			var _p53 = formData.collectionDate;
			if (_p53.ctor === 'Just') {
				return true;
			} else {
				return false;
			}
		}();
		var isPlantingDataValid = function () {
			var _p54 = formData.isyearOfPlantingKnown;
			if (_p54.ctor === 'Nothing') {
				return false;
			} else {
				if (_p54._0 === true) {
					return yearOfPlantingValidation.isValid;
				} else {
					return !_elm_lang$core$Native_Utils.eq(formData.isMoreThan100Years, _elm_lang$core$Maybe$Nothing);
				}
			}
		}();
		var isSocioHistoricalDataValid = function () {
			var _p55 = formData.hasSocioHistoricalInterest;
			if (_p55.ctor === 'Nothing') {
				return false;
			} else {
				if (_p55._0 === false) {
					return true;
				} else {
					return isSocioHistoricalInterestValid;
				}
			}
		}();
		var isFormValid = nameValidation.isValid && (isCollectionDateValid && ((!_elm_lang$core$Native_Utils.eq(formData.variety, _elm_lang$core$Maybe$Nothing)) && (circumferenceValidation.isValid && (coordXValidation.isValid && (coordYValidation.isValid && ((!_elm_lang$core$Native_Utils.eq(formData.isMultiTrunk, _elm_lang$core$Maybe$Nothing)) && (isCrownDevelopmentValid && (isPlantingDataValid && (isSocioHistoricalDataValid && ((!_elm_lang$core$Native_Utils.eq(formData.hasLandscapeInterest, _elm_lang$core$Maybe$Nothing)) && (isEcosystemSituationValid && ((!_elm_lang$core$Native_Utils.eq(formData.isMentioned, _elm_lang$core$Maybe$Nothing)) && ((!_elm_lang$core$Native_Utils.eq(formData.isOfRegionalImportance, _elm_lang$core$Maybe$Nothing)) && ((!_elm_lang$core$Native_Utils.eq(formData.isPartOfAGroup, _elm_lang$core$Maybe$Nothing)) && ((!_elm_lang$core$Native_Utils.eq(formData.isCandidate, _elm_lang$core$Maybe$Nothing)) && (!_elm_lang$core$Native_Utils.eq(formData.isOfLocalInterest, _elm_lang$core$Maybe$Nothing)))))))))))))))));
		var latinName = function () {
			var _p56 = formData.variety;
			if (_p56.ctor === 'Nothing') {
				return '';
			} else {
				return _p56._0.latinName;
			}
		}();
		var commonName = function () {
			var _p57 = formData.variety;
			if (_p57.ctor === 'Nothing') {
				return '';
			} else {
				return _p57._0.commonName;
			}
		}();
		var commune = function () {
			var _p58 = formData.commune;
			if (_p58.ctor === 'Nothing') {
				return toUiTxt('data_isolatedTree_commune_unavailable');
			} else {
				return _p58._0;
			}
		}();
		var plotNb = function () {
			var _p59 = formData.plotNb;
			if (_p59.ctor === 'Nothing') {
				return toUiTxt('data_isolatedTree_plotNb_unavailable');
			} else {
				return _p59._0;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$mainContent,
					_user$project$Styles$SmallFont,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(5),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$yScrollbar,
									_1: {ctor: '[]'}
								}
							}
						}
					},
					A3(
						_mdgriffith$style_elements$Element$column,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
									_1: {ctor: '[]'}
								}
							}
						},
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$column,
								_user$project$Styles$Section,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$row,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
												_1: {ctor: '[]'}
											}
										},
										{
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$el,
												_user$project$Styles$SubTitle,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
														_1: {ctor: '[]'}
													}
												},
												_mdgriffith$style_elements$Element$text(
													toUiTxt('data_isolatedTree_general_info'))),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$row,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$column,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {
															ctor: '::',
															_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																_1: {ctor: '[]'}
															}
														}
													},
													{
														ctor: '::',
														_0: function () {
															var _p60 = formData.id;
															if (_p60.ctor === 'Just') {
																return A2(
																	_user$project$Helpers_Views_Form$elLabel,
																	toUiTxt('data_isolatedTree_id'),
																	_elm_lang$core$Basics$toString(_p60._0));
															} else {
																return _mdgriffith$style_elements$Element$empty;
															}
														}(),
														_1: {
															ctor: '::',
															_0: A2(
																_user$project$Helpers_Views_Form$elLabel,
																toUiTxt('data_isolatedTree_commune'),
																commune),
															_1: {
																ctor: '::',
																_0: A2(
																	_user$project$Helpers_Views_Form$elLabel,
																	toUiTxt('data_isolatedTree_plotNb'),
																	plotNb),
																_1: {
																	ctor: '::',
																	_0: A8(
																		_user$project$Helpers_Views_Form$elDatePicker2,
																		toUiTxt('data_isolatedTree_collectionDate'),
																		50,
																		model.datePickerCollection,
																		function (_p61) {
																			return toMsg(
																				_user$project$Views_IsolatedTree$SetDatePickerCollection(_p61));
																		},
																		isCollectionDateValid,
																		false,
																		toUiTxt('gen_date_placeholder'),
																		formData.collectionDate),
																	_1: {
																		ctor: '::',
																		_0: A9(
																			_user$project$Helpers_Views_Form$elInput2,
																			toUiTxt('data_isolatedTree_name'),
																			50,
																			function (_p62) {
																				return toMsg(
																					_user$project$Views_IsolatedTree$NameChanged(_p62));
																			},
																			nameValidation,
																			false,
																			'',
																			formData.name,
																			_elm_lang$core$Maybe$Nothing,
																			_elm_lang$core$Maybe$Nothing),
																		_1: {
																			ctor: '::',
																			_0: A9(
																				_user$project$Helpers_Views_Form$elInput2,
																				toUiTxt('data_isolatedTree_geom_x'),
																				50,
																				function (_p63) {
																					return toMsg(
																						_user$project$Views_IsolatedTree$CoordXChanged(_p63));
																				},
																				coordXValidation,
																				false,
																				'',
																				_user$project$Helpers_Data_InputValidation$mayValueToMayString(model.treeCoordX),
																				_elm_lang$core$Maybe$Nothing,
																				_elm_lang$core$Maybe$Nothing),
																			_1: {
																				ctor: '::',
																				_0: A9(
																					_user$project$Helpers_Views_Form$elInput2,
																					toUiTxt('data_isolatedTree_geom_y'),
																					50,
																					function (_p64) {
																						return toMsg(
																							_user$project$Views_IsolatedTree$CoordYChanged(_p64));
																					},
																					coordYValidation,
																					false,
																					'',
																					_user$project$Helpers_Data_InputValidation$mayValueToMayString(model.treeCoordY),
																					_elm_lang$core$Maybe$Nothing,
																					_elm_lang$core$Maybe$Nothing),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															}
														}
													}),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$column,
									_user$project$Styles$Section,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
												_1: {ctor: '[]'}
											}
										}
									},
									{
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$row,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
													_1: {ctor: '[]'}
												}
											},
											{
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$el,
															_user$project$Styles$SubTitle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																	_1: {ctor: '[]'}
																}
															},
															_mdgriffith$style_elements$Element$text(
																toUiTxt('data_isolatedTree_keys'))),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: (!hasLimitedExtendedReaderRights) ? A3(
														_mdgriffith$style_elements$Element_Input$checkbox,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(20),
																_1: {ctor: '[]'}
															}
														},
														{
															onChange: function (_p65) {
																return toMsg(
																	_user$project$Views_IsolatedTree$ShowPointsChanged(_p65));
															},
															checked: model.showPoints,
															label: _mdgriffith$style_elements$Element$text(
																toUiTxt('data_isolatedTree_showScores')),
															options: {ctor: '[]'}
														}) : _mdgriffith$style_elements$Element$empty,
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$column,
												_user$project$Styles$NoStyle,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
													_1: {
														ctor: '::',
														_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
															_1: {ctor: '[]'}
														}
													}
												},
												{
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$el,
																_user$project$Styles$Label,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(
																		_mdgriffith$style_elements$Element_Attributes$percent(50)),
																	_1: {ctor: '[]'}
																},
																_mdgriffith$style_elements$Element$text(
																	toUiTxt('data_isolatedTree_variety'))),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element_Input$checkbox,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {ctor: '[]'}
																	},
																	{
																		onChange: function (_p66) {
																			return toMsg(
																				_user$project$Views_IsolatedTree$IsVarietyCertainChanged(_p66));
																		},
																		checked: !formData.isVarietyCertain,
																		label: _mdgriffith$style_elements$Element$text(
																			toUiTxt('data_isolatedTree_notcertain')),
																		options: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}
														}),
													_1: {
														ctor: '::',
														_0: model.isLatin ? A3(
															_mdgriffith$style_elements$Element$column,
															_user$project$Styles$Section,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																	_1: {ctor: '[]'}
																}
															},
															{
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(8),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$Label,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(50)),
																				_1: {ctor: '[]'}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_isolatedTree_latinName'))),
																		_1: {
																			ctor: '::',
																			_0: A4(
																				_user$project$Helpers_Views_DatalistElement$view,
																				function (_p67) {
																					return toMsg(
																						_user$project$Views_IsolatedTree$MsgFromDatalistName(_p67));
																				},
																				toUiTxt,
																				model.isLatin,
																				model.datalistNameState),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$row,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(4.5),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(7.5),
																							_1: {
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Events$onClick(
																									toMsg(_user$project$Views_IsolatedTree$SwitchVariety)),
																								_1: {ctor: '[]'}
																							}
																						}
																					}
																				}
																			}
																		},
																		{
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$Label,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(50)),
																					_1: {ctor: '[]'}
																				},
																				_mdgriffith$style_elements$Element$text(
																					toUiTxt('data_isolatedTree_commonName'))),
																			_1: {
																				ctor: '::',
																				_0: A3(
																					_mdgriffith$style_elements$Element$el,
																					_user$project$Styles$NoStyle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$width(
																							_mdgriffith$style_elements$Element_Attributes$percent(50)),
																						_1: {ctor: '[]'}
																					},
																					_mdgriffith$style_elements$Element$text(commonName)),
																				_1: {ctor: '[]'}
																			}
																		}),
																	_1: {ctor: '[]'}
																}
															}) : A3(
															_mdgriffith$style_elements$Element$column,
															_user$project$Styles$Section,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																	_1: {ctor: '[]'}
																}
															},
															{
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(8),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Events$onClick(
																							toMsg(_user$project$Views_IsolatedTree$SwitchVariety)),
																						_1: {ctor: '[]'}
																					}
																				}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$Label,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(50)),
																				_1: {ctor: '[]'}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_isolatedTree_latinName'))),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(50)),
																					_1: {ctor: '[]'}
																				},
																				_mdgriffith$style_elements$Element$text(latinName)),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$row,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(2),
																							_1: {ctor: '[]'}
																						}
																					}
																				}
																			}
																		},
																		{
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$Label,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(50)),
																					_1: {ctor: '[]'}
																				},
																				_mdgriffith$style_elements$Element$text(
																					toUiTxt('data_isolatedTree_commonName'))),
																			_1: {
																				ctor: '::',
																				_0: A4(
																					_user$project$Helpers_Views_DatalistElement$view,
																					function (_p68) {
																						return toMsg(
																							_user$project$Views_IsolatedTree$MsgFromDatalistName(_p68));
																					},
																					toUiTxt,
																					model.isLatin,
																					model.datalistNameState),
																				_1: {ctor: '[]'}
																			}
																		}),
																	_1: {ctor: '[]'}
																}
															}),
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$column,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {
															ctor: '::',
															_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																_1: {ctor: '[]'}
															}
														}
													},
													{
														ctor: '::',
														_0: A9(
															_user$project$Helpers_Views_Form$elInput2,
															toUiTxt('data_isolatedTree_circumference'),
															50,
															function (_p69) {
																return toMsg(
																	_user$project$Views_IsolatedTree$CircumferenceChanged(_p69));
															},
															circumferenceValidation,
															false,
															'',
															_user$project$Helpers_Data_InputValidation$mayValueToMayString(formData.circumference),
															_elm_lang$core$Maybe$Just('./documents/trees/dimension.pdf'),
															model.showPoints ? circumferencePoints : _elm_lang$core$Maybe$Nothing),
														_1: {
															ctor: '::',
															_0: _user$project$Helpers_Views_Form$elRadioBool(
																function (_p70) {
																	return toMsg(
																		_user$project$Views_IsolatedTree$IsMultiTrunkChanged(_p70));
																})(50)(
																toUiTxt('data_isolatedTree_trunk'))(
																toUiTxt('data_option_simple'))(
																toUiTxt('data_option_multitrunk'))(true)(false)(formData.isMultiTrunk)(_elm_lang$core$Maybe$Nothing)(
																model.showPoints ? isMultiTrunkPoints : _elm_lang$core$Maybe$Nothing),
															_1: {ctor: '[]'}
														}
													}),
												_1: {
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {
																ctor: '::',
																_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: _user$project$Helpers_Views_Form$elSelect2(toUiTxt)(
																toUiTxt('data_isolatedTree_crownDevelopment'))(50)(
																function (_p71) {
																	return toMsg(
																		_user$project$Views_IsolatedTree$CrownDevelopmentChanged(_p71));
																})(isCrownDevelopmentValid)(false)(_user$project$Data_Tree$crownDevelopmentOptions)(
																_elm_lang$core$Maybe$Just('gen_select'))(_elm_lang$core$Maybe$Nothing)(formData.crownDevelopment)(
																_elm_lang$core$Maybe$Just('./documents/trees/couronne.pdf'))(
																model.showPoints ? crownDevelopmentPoints : _elm_lang$core$Maybe$Nothing),
															_1: {ctor: '[]'}
														}),
													_1: {
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$row,
															_user$project$Styles$NoStyle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																_1: {
																	ctor: '::',
																	_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																	_1: {ctor: '[]'}
																}
															},
															{
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$el,
																	_user$project$Styles$Label,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(
																			_mdgriffith$style_elements$Element_Attributes$percent(50)),
																		_1: {ctor: '[]'}
																	},
																	_mdgriffith$style_elements$Element$text(
																		toUiTxt('data_isolatedTree_partofagroup'))),
																_1: {
																	ctor: '::',
																	_0: function () {
																		var _p72 = formData.isPartOfAGroup;
																		if (_p72.ctor === 'Nothing') {
																			return A3(
																				_mdgriffith$style_elements$Element_Input$styledCheckbox,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																					_1: {ctor: '[]'}
																				},
																				{
																					onChange: function (_p73) {
																						return toMsg(
																							_user$project$Views_IsolatedTree$IsPartOfAGroupChanged(_p73));
																					},
																					checked: true,
																					label: A3(
																						_mdgriffith$style_elements$Element$el,
																						_user$project$Styles$InputNotValid,
																						{ctor: '[]'},
																						_mdgriffith$style_elements$Element$text(
																							toUiTxt('data_isolatedTree_ispartofagroup'))),
																					options: {ctor: '[]'},
																					icon: function (checked) {
																						return A3(
																							_mdgriffith$style_elements$Element$image,
																							_user$project$Styles$NoStyle,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$height(
																									_mdgriffith$style_elements$Element_Attributes$px(12)),
																								_1: {
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$width(
																										_mdgriffith$style_elements$Element_Attributes$px(12)),
																									_1: {ctor: '[]'}
																								}
																							},
																							{src: './images/checkboxNothing.svg', caption: 'selected'});
																					}
																				});
																		} else {
																			return A3(
																				_mdgriffith$style_elements$Element_Input$checkbox,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																					_1: {ctor: '[]'}
																				},
																				{
																					onChange: function (_p74) {
																						return toMsg(
																							_user$project$Views_IsolatedTree$IsPartOfAGroupChanged(_p74));
																					},
																					checked: A2(_elm_lang$core$Maybe$withDefault, false, formData.isPartOfAGroup),
																					label: _mdgriffith$style_elements$Element$text(
																						toUiTxt('data_isolatedTree_ispartofagroup')),
																					options: {ctor: '[]'}
																				});
																		}
																	}(),
																	_1: {ctor: '[]'}
																}
															}),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$column,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {
																		ctor: '::',
																		_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																			_1: {ctor: '[]'}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: A5(
																		_user$project$Helpers_Views_Form$elLabel2,
																		toUiTxt('data_isolatedTree_age'),
																		50,
																		A2(
																			_elm_lang$core$Maybe$withDefault,
																			toUiTxt('gen_undefined'),
																			formData.age),
																		_elm_lang$core$Maybe$Just('./documents/trees/age.pdf'),
																		model.showPoints ? agePoints : _elm_lang$core$Maybe$Nothing),
																	_1: {
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$column,
																			_user$project$Styles$Section,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																				_1: {
																					ctor: '::',
																					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 6, 10),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																						_1: {ctor: '[]'}
																					}
																				}
																			},
																			{
																				ctor: '::',
																				_0: _user$project$Helpers_Views_Form$elRadioBool(
																					function (_p75) {
																						return toMsg(
																							_user$project$Views_IsolatedTree$IsyearOfPlantingKnown(_p75));
																					})(50)(
																					toUiTxt('data_isolatedTree_yearOfPlanting'))(
																					toUiTxt('data_option_known'))(
																					toUiTxt('data_option_unknown'))(true)(false)(formData.isyearOfPlantingKnown)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																				_1: {
																					ctor: '::',
																					_0: function () {
																						var _p76 = formData.isyearOfPlantingKnown;
																						if (_p76.ctor === 'Nothing') {
																							return _mdgriffith$style_elements$Element$empty;
																						} else {
																							return _p76._0 ? A9(
																								_user$project$Helpers_Views_Form$elInput2,
																								'',
																								50,
																								function (_p77) {
																									return toMsg(
																										_user$project$Views_IsolatedTree$GetCurrentDateFor(
																											_user$project$Views_IsolatedTree$PlantingYearChanged(_p77)));
																								},
																								yearOfPlantingValidation,
																								false,
																								'AAAA',
																								yearOfPlantingStr,
																								_elm_lang$core$Maybe$Nothing,
																								_elm_lang$core$Maybe$Nothing) : _user$project$Helpers_Views_Form$elRadioBool(
																								function (_p78) {
																									return toMsg(
																										_user$project$Views_IsolatedTree$IsMoreThan100Years(_p78));
																								})(50)(
																								toUiTxt('data_isolatedTree_isMoreThan100Years'))(
																								toUiTxt('data_option_yes'))(
																								toUiTxt('data_option_no'))(true)(false)(formData.isMoreThan100Years)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing);
																						}
																					}(),
																					_1: {ctor: '[]'}
																				}
																			}),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$column,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {
																			ctor: '::',
																			_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																				_1: {ctor: '[]'}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: A5(
																			_user$project$Helpers_Views_Form$elLabel2,
																			toUiTxt('data_isolatedTree_hasEcologicalInterest'),
																			50,
																			_elm_lang$core$Tuple$second(
																				A2(
																					_elm_lang$core$Maybe$withDefault,
																					{ctor: '_Tuple2', _0: 0, _1: ''},
																					A2(_elm_lang$core$Maybe$map, _user$project$Data_Tree$getEcologicalInterest, formData.variety))),
																			_elm_lang$core$Maybe$Just('./documents/trees/intEcoloPaysager.pdf'),
																			model.showPoints ? ecologicalInterestPoints : _elm_lang$core$Maybe$Nothing),
																		_1: {
																			ctor: '::',
																			_0: _user$project$Helpers_Views_Form$elRadioBool(
																				function (_p79) {
																					return toMsg(
																						_user$project$Views_IsolatedTree$HasSocioHistoricalInterestChanged(_p79));
																				})(50)(
																				toUiTxt('data_isolatedTree_hasSocioHistoricalInterest'))(
																				toUiTxt('data_option_strong'))(
																				toUiTxt('data_option_common'))(true)(false)(formData.hasSocioHistoricalInterest)(
																				_elm_lang$core$Maybe$Just('./documents/trees/intEcoloPaysager.pdf'))(
																				model.showPoints ? hasSocioHistoricalInterestPoints : _elm_lang$core$Maybe$Nothing),
																			_1: {
																				ctor: '::',
																				_0: function () {
																					var _p80 = formData.hasSocioHistoricalInterest;
																					if (_p80.ctor === 'Nothing') {
																						return _mdgriffith$style_elements$Element$empty;
																					} else {
																						return _p80._0 ? _user$project$Helpers_Views_Form$elSelect2(toUiTxt)(
																							toUiTxt(''))(50)(
																							function (_p81) {
																								return toMsg(
																									_user$project$Views_IsolatedTree$SocioHistoricalInterestChanged(_p81));
																							})(isSocioHistoricalInterestValid)(false)(_user$project$Data_Tree$socioHistoricalInterestOptions)(
																							_elm_lang$core$Maybe$Just('gen_select'))(_elm_lang$core$Maybe$Nothing)(formData.socioHistoricalInterest)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing) : _mdgriffith$style_elements$Element$empty;
																					}
																				}(),
																				_1: {
																					ctor: '::',
																					_0: _user$project$Helpers_Views_Form$elRadioBool(
																						function (_p82) {
																							return toMsg(
																								_user$project$Views_IsolatedTree$HasLandscapeInterestChanged(_p82));
																						})(50)(
																						toUiTxt('data_isolatedTree_hasLandscapeInterest'))(
																						toUiTxt('data_option_strong'))(
																						toUiTxt('data_option_common'))(true)(false)(formData.hasLandscapeInterest)(
																						_elm_lang$core$Maybe$Just('./documents/trees/intEcoloPaysager.pdf'))(
																						model.showPoints ? hasLandscapeInterestPoints : _elm_lang$core$Maybe$Nothing),
																					_1: {
																						ctor: '::',
																						_0: _user$project$Helpers_Views_Form$elSelect2(toUiTxt)(
																							toUiTxt('data_isolatedTree_ecosystemSituation'))(50)(
																							function (_p83) {
																								return toMsg(
																									_user$project$Views_IsolatedTree$EcosystemSituationChanged(_p83));
																							})(isEcosystemSituationValid)(false)(_user$project$Data_Tree$ecosystemSituationOptions)(
																							_elm_lang$core$Maybe$Just('gen_select'))(_elm_lang$core$Maybe$Nothing)(formData.ecosystemSituation)(
																							_elm_lang$core$Maybe$Just('./documents/trees/intEcoSystemique.pdf'))(
																							model.showPoints ? ecosystemSituationPoints : _elm_lang$core$Maybe$Nothing),
																						_1: {ctor: '[]'}
																					}
																				}
																			}
																		}
																	}),
																_1: {
																	ctor: '::',
																	_0: function () {
																		var _p84 = model.showPoints;
																		if (_p84 === false) {
																			return _mdgriffith$style_elements$Element$empty;
																		} else {
																			var pointsStyle = _user$project$Styles$FormFooterPointsOK;
																			return A3(
																				_mdgriffith$style_elements$Element$row,
																				_user$project$Styles$FormFooter,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
																						_1: {ctor: '[]'}
																					}
																				},
																				{
																					ctor: '::',
																					_0: A2(_user$project$Helpers_Views_Form$elLinkLabel, '', './documents/trees/Annexe_C12.pdf'),
																					_1: {
																						ctor: '::',
																						_0: A3(
																							_mdgriffith$style_elements$Element$el,
																							_user$project$Styles$FormFooterText,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																								_1: {
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
																									_1: {
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
																										_1: {ctor: '[]'}
																									}
																								}
																							},
																							_mdgriffith$style_elements$Element$text(
																								(_elm_lang$core$Native_Utils.cmp(pointsSum, 15) > -1) ? toUiTxt('data_isolatedTree_noticeable') : '')),
																						_1: {
																							ctor: '::',
																							_0: A3(
																								_mdgriffith$style_elements$Element$el,
																								pointsStyle,
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$width(
																										_mdgriffith$style_elements$Element_Attributes$percent(40)),
																									_1: {
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																										_1: {
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(20),
																											_1: {ctor: '[]'}
																										}
																									}
																								},
																								_mdgriffith$style_elements$Element$text(
																									_elm_lang$core$String$concat(
																										{
																											ctor: '::',
																											_0: toUiTxt('data_isolatedTree_generalTotal'),
																											_1: {
																												ctor: '::',
																												_0: '   ',
																												_1: {
																													ctor: '::',
																													_0: _elm_lang$core$Basics$toString(pointsSum),
																													_1: {
																														ctor: '::',
																														_0: ' Pts',
																														_1: {ctor: '[]'}
																													}
																												}
																											}
																										}))),
																							_1: {ctor: '[]'}
																						}
																					}
																				});
																		}
																	}(),
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										}
									}),
								_1: {
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$column,
										_user$project$Styles$Section,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
													_1: {ctor: '[]'}
												}
											}
										},
										{
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$row,
												_user$project$Styles$NoStyle,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$el,
														_user$project$Styles$SubTitle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																_1: {ctor: '[]'}
															}
														},
														_mdgriffith$style_elements$Element$text(
															toUiTxt('data_isolatedTree_extraInfo'))),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$column,
															_user$project$Styles$NoStyle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																_1: {
																	ctor: '::',
																	_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 10),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																		_1: {ctor: '[]'}
																	}
																}
															},
															{
																ctor: '::',
																_0: _user$project$Helpers_Views_Form$elRadioBool(
																	function (_p85) {
																		return toMsg(
																			_user$project$Views_IsolatedTree$IsMentionedChanged(_p85));
																	})(75)(
																	toUiTxt('data_isolatedTree_isMentioned'))(
																	toUiTxt('data_option_yes'))(
																	toUiTxt('data_option_no'))(true)(false)(formData.isMentioned)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																_1: {
																	ctor: '::',
																	_0: _user$project$Helpers_Views_Form$elRadioBool(
																		function (_p86) {
																			return toMsg(
																				_user$project$Views_IsolatedTree$IsOfRegionalImportanceChanged(_p86));
																		})(75)(
																		toUiTxt('data_isolatedTree_isOfRegionalImportance'))(
																		toUiTxt('data_option_yes'))(
																		toUiTxt('data_option_no'))(true)(false)(formData.isOfRegionalImportance)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																	_1: {
																		ctor: '::',
																		_0: A4(
																			_user$project$Helpers_Views_Form$elMultilineLabelTextarea,
																			toUiTxt('data_isolatedTree_comments'),
																			function (_p87) {
																				return toMsg(
																					_user$project$Views_IsolatedTree$CommentsChanged(_p87));
																			},
																			formData.comments,
																			true),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$Label,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																					_1: {ctor: '[]'}
																				},
																				_mdgriffith$style_elements$Element$text(
																					toUiTxt('data_isolatedTree_documents'))),
																			_1: {
																				ctor: '::',
																				_0: A8(
																					_user$project$Views_DocTable$view,
																					function (_p88) {
																						return toMsg(
																							_user$project$Views_IsolatedTree$MsgFromDocTable(_p88));
																					},
																					toUiTxt,
																					fileServiceUrl,
																					queryParams,
																					model.docTableState,
																					_user$project$Styles$NoStyle,
																					false,
																					{
																						ctor: '::',
																						_0: model.isolatedTreeForm.documents,
																						_1: {ctor: '[]'}
																					}),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															}),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}
										}),
									_1: {
										ctor: '::',
										_0: hasLimitedExtendedReaderRights ? _mdgriffith$style_elements$Element$empty : A3(
											_mdgriffith$style_elements$Element$column,
											_user$project$Styles$Section,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
														_1: {ctor: '[]'}
													}
												}
											},
											{
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$el,
															_user$project$Styles$SubTitle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																	_1: {ctor: '[]'}
																}
															},
															_mdgriffith$style_elements$Element$text(
																toUiTxt('data_isolatedTree_inventory'))),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$column,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element_Input$multiline,
																		_user$project$Styles$FormNotice,
																		{
																			ctor: '::',
																			_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 10, 4),
																			_1: {ctor: '[]'}
																		},
																		{
																			onChange: function (_p89) {
																				return toMsg(
																					_user$project$Views_IsolatedTree$NoMsg(_p89));
																			},
																			value: toUiTxt(
																				A2(_user$project$Views_IsolatedTree$circumferenceMsg, formData.circumference, formData.variety)),
																			label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
																			options: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Input$disabled,
																				_1: {ctor: '[]'}
																			}
																		}),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element_Input$multiline,
																			_user$project$Styles$FormNotice,
																			{
																				ctor: '::',
																				_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 10, 4),
																				_1: {ctor: '[]'}
																			},
																			{
																				onChange: function (_p90) {
																					return toMsg(
																						_user$project$Views_IsolatedTree$NoMsg(_p90));
																				},
																				value: toUiTxt(
																					(_elm_lang$core$Native_Utils.cmp(pointsSum, 15) < 0) ? 'data_isolatedTree_notnoticeablemsg' : 'data_isolatedTree_noticeablemsg'),
																				label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
																				options: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Input$disabled,
																					_1: {ctor: '[]'}
																				}
																			}),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}
														}),
													_1: {
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$row,
															_user$project$Styles$NoStyle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: _user$project$Helpers_Views_Form$elSeparator,
																_1: {ctor: '[]'}
															}),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																		_1: {ctor: '[]'}
																	}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$el,
																		_user$project$Styles$SubTitle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																				_1: {ctor: '[]'}
																			}
																		},
																		_mdgriffith$style_elements$Element$text(
																			toUiTxt('data_isolatedTree_candidacy'))),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$column,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																				_1: {
																					ctor: '::',
																					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 10),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																						_1: {ctor: '[]'}
																					}
																				}
																			},
																			{
																				ctor: '::',
																				_0: _user$project$Helpers_Views_Form$elRadioBool(
																					function (_p91) {
																						return toMsg(
																							_user$project$Views_IsolatedTree$IsOfLocalInterestChanged(_p91));
																					})(75)(
																					toUiTxt('data_isolatedTree_isOfLocalInterest'))(
																					toUiTxt('data_option_yes'))(
																					toUiTxt('data_option_no'))(true)(false)(formData.isOfLocalInterest)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																				_1: {
																					ctor: '::',
																					_0: _user$project$Helpers_Views_Form$elRadioBool(
																						function (_p92) {
																							return toMsg(
																								_user$project$Views_IsolatedTree$IsCandidateChanged(_p92));
																						})(75)(
																						toUiTxt('data_isolatedTree_isCandidate'))(
																						toUiTxt('data_option_yes'))(
																						toUiTxt('data_option_no'))(true)(false)(formData.isCandidate)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																					_1: {
																						ctor: '::',
																						_0: A4(
																							_user$project$Helpers_Views_Form$elMultilineLabelTextarea,
																							toUiTxt('data_isolatedTree_candidacyComment'),
																							function (_p93) {
																								return toMsg(
																									_user$project$Views_IsolatedTree$CandidacyCommentChanged(_p93));
																							},
																							formData.candidacyComment,
																							true),
																						_1: {ctor: '[]'}
																					}
																				}
																			}),
																		_1: {ctor: '[]'}
																	}),
																_1: {
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$row,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
																			_1: {ctor: '[]'}
																		},
																		{
																			ctor: '::',
																			_0: _user$project$Helpers_Views_Form$elSeparator,
																			_1: {ctor: '[]'}
																		}),
																	_1: {
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$row,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																					_1: {ctor: '[]'}
																				}
																			},
																			{
																				ctor: '::',
																				_0: A3(
																					_mdgriffith$style_elements$Element$el,
																					_user$project$Styles$SubTitle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																							_1: {ctor: '[]'}
																						}
																					},
																					_mdgriffith$style_elements$Element$text(
																						toUiTxt('data_isolatedTree_decision'))),
																				_1: {ctor: '[]'}
																			}),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$row,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																					_1: {ctor: '[]'}
																				},
																				{
																					ctor: '::',
																					_0: A3(
																						_mdgriffith$style_elements$Element$column,
																						_user$project$Styles$NoStyle,
																						{
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																							_1: {
																								ctor: '::',
																								_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 10),
																								_1: {
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																									_1: {ctor: '[]'}
																								}
																							}
																						},
																						{
																							ctor: '::',
																							_0: _user$project$Helpers_Views_Form$elRadioBool(
																								function (_p94) {
																									return toMsg(
																										_user$project$Views_IsolatedTree$IsRankedChanged(_p94));
																								})(75)(
																								toUiTxt('data_isolatedTree_isRanked'))(
																								toUiTxt('data_option_yes'))(
																								toUiTxt('data_option_no'))(false)(!hasCantonEditRights)(formData.isRanked)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																							_1: {
																								ctor: '::',
																								_0: A4(
																									_user$project$Helpers_Views_Form$elMultilineLabelTextarea,
																									toUiTxt('data_isolatedTree_justificationOfRanking'),
																									function (_p95) {
																										return toMsg(
																											_user$project$Views_IsolatedTree$JustificationOfRankingChanged(_p95));
																									},
																									formData.justificationOfRanking,
																									hasCantonEditRights),
																								_1: {ctor: '[]'}
																							}
																						}),
																					_1: {ctor: '[]'}
																				}),
																			_1: {
																				ctor: '::',
																				_0: hasCantonEditRights ? A3(
																					_mdgriffith$style_elements$Element$row,
																					_user$project$Styles$NoStyle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																						_1: {
																							ctor: '::',
																							_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 8, 10),
																							_1: {
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																								_1: {ctor: '[]'}
																							}
																						}
																					},
																					{
																						ctor: '::',
																						_0: A3(
																							_mdgriffith$style_elements$Element$el,
																							_user$project$Styles$Label,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$width(
																									_mdgriffith$style_elements$Element_Attributes$percent(38)),
																								_1: {ctor: '[]'}
																							},
																							_mdgriffith$style_elements$Element$text(
																								toUiTxt('data_isolatedTree_moderator'))),
																						_1: {
																							ctor: '::',
																							_0: A3(
																								_mdgriffith$style_elements$Element$el,
																								_user$project$Styles$NoStyle,
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$width(
																										_mdgriffith$style_elements$Element_Attributes$percent(62)),
																									_1: {ctor: '[]'}
																								},
																								A4(
																									_user$project$Views_ContactSelection$view,
																									function (_p96) {
																										return toMsg(
																											_user$project$Views_IsolatedTree$MsgFromModeratorSelection(_p96));
																									},
																									toUiTxt,
																									model.moderatorSelectionModel,
																									_elm_lang$core$Maybe$Just(true))),
																							_1: {ctor: '[]'}
																						}
																					}) : _mdgriffith$style_elements$Element$empty,
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}),
										_1: {ctor: '[]'}
									}
								}
							}
						})),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$footer,
						_user$project$Styles$Footer,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
								_1: {ctor: '[]'}
							}
						},
						A7(
							_user$project$Helpers_Views_Form$elOkCancel,
							isFormValid,
							toUiTxt('gen_save'),
							_user$project$Styles$SaveBtn,
							toMsg(
								_user$project$Views_IsolatedTree$GetCurrentDateFor(_user$project$Views_IsolatedTree$SaveClicked)),
							toUiTxt('gen_close'),
							_user$project$Styles$CancelBtn,
							closeMsg)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_IsolatedTree$StartEditing = {ctor: 'StartEditing'};
var _user$project$Views_IsolatedTree$viewVis = F7(
	function (toMsg, toUiTxt, closeMsg, fileServiceUrl, queryParams, session, model) {
		var hasLimitedExtendedReaderRights = A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$Guest);
		var moderator = function () {
			var _p97 = model.isolatedTreeForm.moderator;
			if (_p97.ctor === 'Nothing') {
				return '';
			} else {
				var _p98 = _p97._0;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_p98.lastname,
					A2(_elm_lang$core$Basics_ops['++'], ' ', _p98.firstname));
			}
		}();
		var pointsSum = A2(
			_elm_lang$core$Maybe$withDefault,
			0,
			A2(
				_elm_lang$core$Maybe$map,
				function (attSco) {
					return attSco.totalScore;
				},
				model.attributeScore));
		var defaultStr = '';
		var docAttr = model.docSectionHidden ? {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$hidden,
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var decisionAttr = model.decisionSectionHidden ? {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$hidden,
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var keyAttr = model.keySectionHidden ? {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$hidden,
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var infoAttr = model.infoSectionHidden ? {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$hidden,
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var mayIsolatedTree = model.isolatedTree;
		var _p99 = mayIsolatedTree;
		if (_p99.ctor === 'Nothing') {
			return _mdgriffith$style_elements$Element$empty;
		} else {
			var _p112 = _p99._0;
			return A3(
				_mdgriffith$style_elements$Element$column,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$header,
						_user$project$Styles$Header,
						{ctor: '[]'},
						A3(
							_mdgriffith$style_elements$Element$column,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
								_1: {
									ctor: '::',
									_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 14, 10),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$h1,
									_user$project$Styles$MainTitle,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text(
										A2(_elm_lang$core$Maybe$withDefault, _p112.variety.commonName, _p112.name))),
								_1: {ctor: '[]'}
							})),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$mainContent,
							_user$project$Styles$SmallFont,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(5),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$yScrollbar,
											_1: {ctor: '[]'}
										}
									}
								}
							},
							A3(
								_mdgriffith$style_elements$Element$column,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
											_1: {ctor: '[]'}
										}
									}
								},
								{
									ctor: '::',
									_0: A5(_user$project$Views_IsolatedTree$viewImageSlider, toMsg, fileServiceUrl, queryParams, _p112.documents, model.sliderPosition),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$column,
											_user$project$Styles$Section,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
													_1: {ctor: '[]'}
												}
											},
											{
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$button,
															_user$project$Styles$NoStyle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Events$onClick(
																		toMsg(_user$project$Views_IsolatedTree$SwitchInfoSectionHidden)),
																	_1: {ctor: '[]'}
																}
															},
															A3(
																_mdgriffith$style_elements$Element$image,
																_user$project$Styles$NoStyle,
																{ctor: '[]'},
																{
																	src: model.infoSectionHidden ? './images/arrowBtnR.svg' : './images/arrowBtnD.svg',
																	caption: 'arrowBtn'
																})),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$el,
																_user$project$Styles$SubTitle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																		_1: {ctor: '[]'}
																	}
																},
																_mdgriffith$style_elements$Element$text(
																	toUiTxt('data_isolatedTree_general_info'))),
															_1: {ctor: '[]'}
														}
													}),
												_1: {
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														A2(
															_elm_lang$core$Basics_ops['++'],
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																_1: {ctor: '[]'}
															},
															infoAttr),
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$column,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {
																		ctor: '::',
																		_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																			_1: {ctor: '[]'}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: function () {
																		var _p100 = _p112.id;
																		if (_p100.ctor === 'Just') {
																			return A2(
																				_user$project$Helpers_Views_Form$elLabel,
																				toUiTxt('data_isolatedTree_id'),
																				_elm_lang$core$Basics$toString(_p100._0));
																		} else {
																			return _mdgriffith$style_elements$Element$empty;
																		}
																	}(),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_user$project$Helpers_Views_Form$elLabel,
																			toUiTxt('data_isolatedTree_commune'),
																			_p112.commune),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_user$project$Helpers_Views_Form$elLabel,
																				toUiTxt('data_isolatedTree_plotNb'),
																				_p112.plotNb),
																			_1: {
																				ctor: '::',
																				_0: A2(
																					_user$project$Helpers_Views_Form$elLabel,
																					toUiTxt('data_isolatedTree_collectionDate'),
																					_user$project$Helpers_Views_Text$dateToString(_p112.collectionDate)),
																				_1: {
																					ctor: '::',
																					_0: A2(
																						_user$project$Helpers_Views_Form$elLabel,
																						toUiTxt('data_isolatedTree_name'),
																						A2(_elm_lang$core$Maybe$withDefault, '', _p112.name)),
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	}
																}),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$column,
												_user$project$Styles$Section,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$button,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Events$onClick(
																			toMsg(_user$project$Views_IsolatedTree$SwitchKeySectionHidden)),
																		_1: {ctor: '[]'}
																	}
																},
																A3(
																	_mdgriffith$style_elements$Element$image,
																	_user$project$Styles$NoStyle,
																	{ctor: '[]'},
																	{
																		src: model.keySectionHidden ? './images/arrowBtnR.svg' : './images/arrowBtnD.svg',
																		caption: 'arrowBtn'
																	})),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$el,
																	_user$project$Styles$SubTitle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																			_1: {ctor: '[]'}
																		}
																	},
																	_mdgriffith$style_elements$Element$text(
																		toUiTxt('data_isolatedTree_elements'))),
																_1: {ctor: '[]'}
															}
														}),
													_1: {
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$column,
															_user$project$Styles$NoStyle,
															A2(
																_elm_lang$core$Basics_ops['++'],
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {ctor: '[]'}
																},
																keyAttr),
															{
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$column,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {
																			ctor: '::',
																			_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																				_1: {ctor: '[]'}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$SubTitle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(6),
																					_1: {ctor: '[]'}
																				}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_isolatedTree_keys'))),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$Label,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(50)),
																					_1: {ctor: '[]'}
																				},
																				_mdgriffith$style_elements$Element$text(
																					A2(
																						_elm_lang$core$Basics_ops['++'],
																						toUiTxt('data_isolatedTree_variety'),
																						(!_p112.isVarietyCertain) ? A2(
																							_elm_lang$core$Basics_ops['++'],
																							' ',
																							toUiTxt('data_isolatedTree_tovalidate')) : ''))),
																			_1: {
																				ctor: '::',
																				_0: A3(
																					_mdgriffith$style_elements$Element$column,
																					_user$project$Styles$NoStyle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(4),
																							_1: {ctor: '[]'}
																						}
																					},
																					{
																						ctor: '::',
																						_0: A3(
																							_mdgriffith$style_elements$Element$row,
																							_user$project$Styles$NoStyle,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																								_1: {
																									ctor: '::',
																									_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
																									_1: {ctor: '[]'}
																								}
																							},
																							{
																								ctor: '::',
																								_0: A3(
																									_mdgriffith$style_elements$Element$el,
																									_user$project$Styles$Label,
																									{
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																										_1: {
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
																											_1: {ctor: '[]'}
																										}
																									},
																									_mdgriffith$style_elements$Element$text(
																										toUiTxt('data_isolatedTree_latinName'))),
																								_1: {
																									ctor: '::',
																									_0: A3(
																										_mdgriffith$style_elements$Element$el,
																										_user$project$Styles$NoStyle,
																										{
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Attributes$width(
																												_mdgriffith$style_elements$Element_Attributes$percent(50)),
																											_1: {ctor: '[]'}
																										},
																										_mdgriffith$style_elements$Element$text(_p112.variety.latinName)),
																									_1: {ctor: '[]'}
																								}
																							}),
																						_1: {
																							ctor: '::',
																							_0: A3(
																								_mdgriffith$style_elements$Element$row,
																								_user$project$Styles$NoStyle,
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																									_1: {
																										ctor: '::',
																										_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 4),
																										_1: {ctor: '[]'}
																									}
																								},
																								{
																									ctor: '::',
																									_0: A3(
																										_mdgriffith$style_elements$Element$el,
																										_user$project$Styles$Label,
																										{
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																											_1: {
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
																												_1: {ctor: '[]'}
																											}
																										},
																										_mdgriffith$style_elements$Element$text(
																											toUiTxt('data_isolatedTree_commonName'))),
																									_1: {
																										ctor: '::',
																										_0: A3(
																											_mdgriffith$style_elements$Element$el,
																											_user$project$Styles$NoStyle,
																											{
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$width(
																													_mdgriffith$style_elements$Element_Attributes$percent(50)),
																												_1: {ctor: '[]'}
																											},
																											_mdgriffith$style_elements$Element$text(_p112.variety.commonName)),
																										_1: {ctor: '[]'}
																									}
																								}),
																							_1: {ctor: '[]'}
																						}
																					}),
																				_1: {
																					ctor: '::',
																					_0: A5(
																						_user$project$Helpers_Views_Form$elLabel2,
																						toUiTxt('data_isolatedTree_circumference'),
																						50,
																						_elm_lang$core$Basics$toString(_p112.circumference),
																						_elm_lang$core$Maybe$Just('./documents/trees/dimension.pdf'),
																						_elm_lang$core$Maybe$Nothing),
																					_1: {
																						ctor: '::',
																						_0: _user$project$Helpers_Views_Form$elRadioBool(
																							function (_p101) {
																								return toMsg(
																									_user$project$Views_IsolatedTree$IsMultiTrunkChanged(_p101));
																							})(50)(
																							toUiTxt('data_isolatedTree_trunk'))(
																							toUiTxt('data_option_simple'))(
																							toUiTxt('data_option_multitrunk'))(true)(true)(
																							_elm_lang$core$Maybe$Just(_p112.isMultiTrunk))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																						_1: {
																							ctor: '::',
																							_0: A5(
																								_user$project$Helpers_Views_Form$elLabel2,
																								toUiTxt('data_isolatedTree_crownDevelopment'),
																								50,
																								toUiTxt(_p112.crownDevelopment),
																								_elm_lang$core$Maybe$Just('./documents/trees/couronne.pdf'),
																								_elm_lang$core$Maybe$Nothing),
																							_1: {
																								ctor: '::',
																								_0: A3(
																									_mdgriffith$style_elements$Element$row,
																									_user$project$Styles$NoStyle,
																									{
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																										_1: {
																											ctor: '::',
																											_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																											_1: {ctor: '[]'}
																										}
																									},
																									{
																										ctor: '::',
																										_0: A3(
																											_mdgriffith$style_elements$Element$el,
																											_user$project$Styles$Label,
																											{
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$width(
																													_mdgriffith$style_elements$Element_Attributes$percent(50)),
																												_1: {ctor: '[]'}
																											},
																											_mdgriffith$style_elements$Element$text(
																												toUiTxt('data_isolatedTree_partofagroup'))),
																										_1: {
																											ctor: '::',
																											_0: _user$project$Helpers_Views_Form$elRadioBool(
																												function (_p102) {
																													return toMsg(
																														_user$project$Views_IsolatedTree$IsPartOfAGroupChanged(_p102));
																												})(50)(
																												toUiTxt('data_isolatedTree_ispartofagroup'))(
																												toUiTxt('data_option_yes'))(
																												toUiTxt('data_option_no'))(true)(true)(
																												_elm_lang$core$Maybe$Just(_p112.isPartOfAGroup))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																											_1: {ctor: '[]'}
																										}
																									}),
																								_1: {
																									ctor: '::',
																									_0: A5(
																										_user$project$Helpers_Views_Form$elLabel2,
																										toUiTxt('data_isolatedTree_age'),
																										50,
																										A2(
																											_elm_lang$core$Maybe$withDefault,
																											toUiTxt('gen_undefined'),
																											model.isolatedTreeForm.age),
																										_elm_lang$core$Maybe$Just('./documents/trees/age.pdf'),
																										_elm_lang$core$Maybe$Nothing),
																									_1: {
																										ctor: '::',
																										_0: A5(
																											_user$project$Helpers_Views_Form$elLabel2,
																											toUiTxt('data_isolatedTree_hasEcologicalInterest'),
																											50,
																											_elm_lang$core$Tuple$second(
																												_user$project$Data_Tree$getEcologicalInterest(_p112.variety)),
																											_elm_lang$core$Maybe$Just('./documents/trees/intEcologique.pdf'),
																											_elm_lang$core$Maybe$Nothing),
																										_1: {
																											ctor: '::',
																											_0: _user$project$Helpers_Views_Form$elRadioBool(
																												function (_p103) {
																													return toMsg(
																														_user$project$Views_IsolatedTree$HasSocioHistoricalInterestChanged(_p103));
																												})(50)(
																												toUiTxt('data_isolatedTree_hasSocioHistoricalInterest'))(
																												toUiTxt('data_option_strong'))(
																												toUiTxt('data_option_common'))(true)(true)(
																												_elm_lang$core$Maybe$Just(_p112.hasSocioHistoricalInterest))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																											_1: {
																												ctor: '::',
																												_0: _p112.hasSocioHistoricalInterest ? A5(
																													_user$project$Helpers_Views_Form$elLabel2,
																													toUiTxt(''),
																													50,
																													toUiTxt(
																														A2(_elm_lang$core$Maybe$withDefault, 'gen_undefined', _p112.socioHistoricalInterest)),
																													_elm_lang$core$Maybe$Nothing,
																													_elm_lang$core$Maybe$Nothing) : _mdgriffith$style_elements$Element$empty,
																												_1: {
																													ctor: '::',
																													_0: _user$project$Helpers_Views_Form$elRadioBool(
																														function (_p104) {
																															return toMsg(
																																_user$project$Views_IsolatedTree$HasLandscapeInterestChanged(_p104));
																														})(50)(
																														toUiTxt('data_isolatedTree_hasLandscapeInterest'))(
																														toUiTxt('data_option_strong'))(
																														toUiTxt('data_option_common'))(true)(true)(
																														_elm_lang$core$Maybe$Just(_p112.hasLandscapeInterest))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																													_1: {
																														ctor: '::',
																														_0: A5(
																															_user$project$Helpers_Views_Form$elLabel2,
																															toUiTxt('data_isolatedTree_ecosystemSituation'),
																															50,
																															toUiTxt(_p112.ecosystemSituation),
																															_elm_lang$core$Maybe$Just('./documents/trees/intEcoSystemique.pdf'),
																															_elm_lang$core$Maybe$Nothing),
																														_1: {ctor: '[]'}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}),
																_1: {
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$column,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																			_1: {
																				ctor: '::',
																				_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																					_1: {ctor: '[]'}
																				}
																			}
																		},
																		{
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$SubTitle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(6),
																						_1: {ctor: '[]'}
																					}
																				},
																				_mdgriffith$style_elements$Element$text(
																					toUiTxt('data_isolatedTree_extraInfo'))),
																			_1: {
																				ctor: '::',
																				_0: A3(
																					_mdgriffith$style_elements$Element$column,
																					_user$project$Styles$NoStyle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
																							_1: {ctor: '[]'}
																						}
																					},
																					{
																						ctor: '::',
																						_0: _user$project$Helpers_Views_Form$elRadioBool(
																							function (_p105) {
																								return toMsg(
																									_user$project$Views_IsolatedTree$IsMentionedChanged(_p105));
																							})(75)(
																							toUiTxt('data_isolatedTree_isMentioned'))(
																							toUiTxt('data_option_yes'))(
																							toUiTxt('data_option_no'))(true)(true)(
																							_elm_lang$core$Maybe$Just(_p112.isMentioned))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																						_1: {
																							ctor: '::',
																							_0: _user$project$Helpers_Views_Form$elRadioBool(
																								function (_p106) {
																									return toMsg(
																										_user$project$Views_IsolatedTree$IsOfRegionalImportanceChanged(_p106));
																								})(75)(
																								toUiTxt('data_isolatedTree_isOfRegionalImportance'))(
																								toUiTxt('data_option_yes'))(
																								toUiTxt('data_option_no'))(true)(true)(
																								_elm_lang$core$Maybe$Just(_p112.isOfRegionalImportance))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																							_1: {
																								ctor: '::',
																								_0: A8(
																									_user$project$Helpers_Views_Form$htmlTextarea2,
																									toUiTxt('data_isolatedTree_comments'),
																									50,
																									_elm_lang$core$Maybe$Nothing,
																									true,
																									true,
																									24,
																									'',
																									_p112.comments),
																								_1: {ctor: '[]'}
																							}
																						}
																					}),
																				_1: {ctor: '[]'}
																			}
																		}),
																	_1: {ctor: '[]'}
																}
															}),
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$column,
													_user$project$Styles$Section,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$row,
															_user$project$Styles$NoStyle,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																	_1: {ctor: '[]'}
																}
															},
															{
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$button,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Events$onClick(
																				toMsg(_user$project$Views_IsolatedTree$SwitchDocSectionHidden)),
																			_1: {ctor: '[]'}
																		}
																	},
																	_elm_lang$core$List$isEmpty(_p112.documents) ? A3(
																		_mdgriffith$style_elements$Element$image,
																		_user$project$Styles$NoStyle,
																		{ctor: '[]'},
																		{src: './images/arrowBtnRD.svg', caption: 'arrowBtn'}) : A3(
																		_mdgriffith$style_elements$Element$image,
																		_user$project$Styles$NoStyle,
																		{ctor: '[]'},
																		{
																			src: model.docSectionHidden ? './images/arrowBtnR.svg' : './images/arrowBtnD.svg',
																			caption: 'arrowBtn'
																		})),
																_1: {
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$el,
																		_user$project$Styles$SubTitle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																				_1: {ctor: '[]'}
																			}
																		},
																		_mdgriffith$style_elements$Element$text(
																			toUiTxt('data_isolatedTree_documents'))),
																	_1: {ctor: '[]'}
																}
															}),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																A2(
																	_elm_lang$core$Basics_ops['++'],
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {ctor: '[]'}
																	},
																	docAttr),
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$column,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																			_1: {ctor: '[]'}
																		},
																		{
																			ctor: '::',
																			_0: _elm_lang$core$List$isEmpty(_p112.documents) ? _mdgriffith$style_elements$Element$empty : A3(
																				_mdgriffith$style_elements$Element$column,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																					_1: {
																						ctor: '::',
																						_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																							_1: {ctor: '[]'}
																						}
																					}
																				},
																				{
																					ctor: '::',
																					_0: A8(
																						_user$project$Views_DocTable$view,
																						function (_p107) {
																							return toMsg(
																								_user$project$Views_IsolatedTree$MsgFromDocTable(_p107));
																						},
																						toUiTxt,
																						fileServiceUrl,
																						queryParams,
																						model.docTableState,
																						_user$project$Styles$NoStyle,
																						false,
																						{
																							ctor: '::',
																							_0: _p112.documents,
																							_1: {ctor: '[]'}
																						}),
																					_1: {ctor: '[]'}
																				}),
																			_1: {ctor: '[]'}
																		}),
																	_1: {ctor: '[]'}
																}),
															_1: {ctor: '[]'}
														}
													}),
												_1: {
													ctor: '::',
													_0: hasLimitedExtendedReaderRights ? _mdgriffith$style_elements$Element$empty : A3(
														_mdgriffith$style_elements$Element$column,
														_user$project$Styles$Section,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																		_1: {ctor: '[]'}
																	}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$button,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Events$onClick(
																					toMsg(_user$project$Views_IsolatedTree$SwitchDecisionSectionHidden)),
																				_1: {ctor: '[]'}
																			}
																		},
																		A3(
																			_mdgriffith$style_elements$Element$image,
																			_user$project$Styles$NoStyle,
																			{ctor: '[]'},
																			{
																				src: model.decisionSectionHidden ? './images/arrowBtnR.svg' : './images/arrowBtnD.svg',
																				caption: 'arrowBtn'
																			})),
																	_1: {
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$SubTitle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																					_1: {ctor: '[]'}
																				}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_isolatedTree_inventory'))),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	A2(
																		_elm_lang$core$Basics_ops['++'],
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																			_1: {ctor: '[]'}
																		},
																		decisionAttr),
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$column,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																				_1: {
																					ctor: '::',
																					_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 20, 10),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$spacing(8),
																						_1: {ctor: '[]'}
																					}
																				}
																			},
																			{
																				ctor: '::',
																				_0: A3(
																					_mdgriffith$style_elements$Element$column,
																					_user$project$Styles$NoStyle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(10),
																							_1: {ctor: '[]'}
																						}
																					},
																					{
																						ctor: '::',
																						_0: A3(
																							_mdgriffith$style_elements$Element$row,
																							_user$project$Styles$NoStyle,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																								_1: {ctor: '[]'}
																							},
																							{
																								ctor: '::',
																								_0: A3(
																									_mdgriffith$style_elements$Element_Input$multiline,
																									_user$project$Styles$FormNotice,
																									{ctor: '[]'},
																									{
																										onChange: function (_p108) {
																											return toMsg(
																												_user$project$Views_IsolatedTree$NoMsg(_p108));
																										},
																										value: toUiTxt(
																											A2(
																												_user$project$Views_IsolatedTree$circumferenceMsg,
																												_elm_lang$core$Maybe$Just(_p112.circumference),
																												_elm_lang$core$Maybe$Just(_p112.variety))),
																										label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
																										options: {
																											ctor: '::',
																											_0: _mdgriffith$style_elements$Element_Input$disabled,
																											_1: {ctor: '[]'}
																										}
																									}),
																								_1: {ctor: '[]'}
																							}),
																						_1: {
																							ctor: '::',
																							_0: A3(
																								_mdgriffith$style_elements$Element$row,
																								_user$project$Styles$NoStyle,
																								{
																									ctor: '::',
																									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																									_1: {ctor: '[]'}
																								},
																								{
																									ctor: '::',
																									_0: A3(
																										_mdgriffith$style_elements$Element_Input$multiline,
																										_user$project$Styles$FormNotice,
																										{ctor: '[]'},
																										{
																											onChange: function (_p109) {
																												return toMsg(
																													_user$project$Views_IsolatedTree$NoMsg(_p109));
																											},
																											value: toUiTxt(
																												(_elm_lang$core$Native_Utils.cmp(pointsSum, 15) < 0) ? 'data_isolatedTree_notnoticeablemsg' : 'data_isolatedTree_noticeablemsg'),
																											label: _mdgriffith$style_elements$Element_Input$hiddenLabel(''),
																											options: {
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Input$disabled,
																												_1: {ctor: '[]'}
																											}
																										}),
																									_1: {ctor: '[]'}
																								}),
																							_1: {ctor: '[]'}
																						}
																					}),
																				_1: {
																					ctor: '::',
																					_0: _user$project$Helpers_Views_Form$elSeparator,
																					_1: {
																						ctor: '::',
																						_0: A3(
																							_mdgriffith$style_elements$Element$row,
																							_user$project$Styles$NoStyle,
																							{
																								ctor: '::',
																								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																								_1: {ctor: '[]'}
																							},
																							{
																								ctor: '::',
																								_0: A3(
																									_mdgriffith$style_elements$Element$el,
																									_user$project$Styles$SubTitle,
																									{
																										ctor: '::',
																										_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																										_1: {ctor: '[]'}
																									},
																									_mdgriffith$style_elements$Element$text(
																										toUiTxt('data_isolatedTree_candidacy'))),
																								_1: {ctor: '[]'}
																							}),
																						_1: {
																							ctor: '::',
																							_0: _user$project$Helpers_Views_Form$elRadioBool(
																								function (_p110) {
																									return toMsg(
																										_user$project$Views_IsolatedTree$IsCandidateChanged(_p110));
																								})(75)(
																								toUiTxt('data_isolatedTree_isCandidate'))(
																								toUiTxt('data_option_yes'))(
																								toUiTxt('data_option_no'))(false)(true)(
																								_elm_lang$core$Maybe$Just(_p112.isCandidate))(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																							_1: {
																								ctor: '::',
																								_0: A8(
																									_user$project$Helpers_Views_Form$htmlTextarea2,
																									toUiTxt('data_isolatedTree_candidacyComment'),
																									50,
																									_elm_lang$core$Maybe$Nothing,
																									true,
																									true,
																									24,
																									'',
																									_p112.candidacyComment),
																								_1: {
																									ctor: '::',
																									_0: _user$project$Helpers_Views_Form$elSeparator,
																									_1: {
																										ctor: '::',
																										_0: A3(
																											_mdgriffith$style_elements$Element$row,
																											_user$project$Styles$NoStyle,
																											{
																												ctor: '::',
																												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																												_1: {ctor: '[]'}
																											},
																											{
																												ctor: '::',
																												_0: A3(
																													_mdgriffith$style_elements$Element$el,
																													_user$project$Styles$SubTitle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																														_1: {ctor: '[]'}
																													},
																													_mdgriffith$style_elements$Element$text(
																														toUiTxt('data_isolatedTree_decision'))),
																												_1: {ctor: '[]'}
																											}),
																										_1: {
																											ctor: '::',
																											_0: _user$project$Helpers_Views_Form$elRadioBool(
																												function (_p111) {
																													return toMsg(
																														_user$project$Views_IsolatedTree$IsRankedChanged(_p111));
																												})(75)(
																												toUiTxt('data_isolatedTree_isRanked'))(
																												toUiTxt('data_option_yes'))(
																												toUiTxt('data_option_no'))(false)(true)(_p112.isRanked)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing),
																											_1: {
																												ctor: '::',
																												_0: A8(
																													_user$project$Helpers_Views_Form$htmlTextarea2,
																													toUiTxt('data_isolatedTree_justificationOfRanking'),
																													50,
																													_elm_lang$core$Maybe$Nothing,
																													true,
																													true,
																													24,
																													'',
																													_p112.justificationOfRanking),
																												_1: {
																													ctor: '::',
																													_0: A5(
																														_user$project$Helpers_Views_Form$elLabel2,
																														toUiTxt('data_isolatedTree_moderator'),
																														50,
																														moderator,
																														_elm_lang$core$Maybe$Nothing,
																														_elm_lang$core$Maybe$Nothing),
																													_1: {ctor: '[]'}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}
														}),
													_1: {ctor: '[]'}
												}
											}
										}
									}
								})),
						_1: {
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$footer,
								_user$project$Styles$Footer,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {ctor: '[]'}
								},
								A3(
									_mdgriffith$style_elements$Element$row,
									_user$project$Styles$NoStyle,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(8),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(4),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(10),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									},
									{
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$el,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
													_1: {ctor: '[]'}
												}
											},
											A3(
												_mdgriffith$style_elements$Element$button,
												_user$project$Styles$ExportBtn,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(
														_mdgriffith$style_elements$Element_Attributes$px(100)),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Events$onClick(
																toMsg(_user$project$Views_IsolatedTree$ExportPDFMode)),
															_1: {ctor: '[]'}
														}
													}
												},
												_mdgriffith$style_elements$Element$text(
													toUiTxt('gen_export_pdf')))),
										_1: {
											ctor: '::',
											_0: A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeLocalEditor) ? _mdgriffith$style_elements$Element$empty : (A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeEditor) ? A3(
												_mdgriffith$style_elements$Element$button,
												_user$project$Styles$EditBtn,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(
														_mdgriffith$style_elements$Element_Attributes$px(100)),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Events$onClick(
																toMsg(_user$project$Views_IsolatedTree$StartEditing)),
															_1: {ctor: '[]'}
														}
													}
												},
												_mdgriffith$style_elements$Element$text(
													toUiTxt('gen_edit'))) : _mdgriffith$style_elements$Element$empty),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$button,
													_user$project$Styles$CancelBtn,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(
															_mdgriffith$style_elements$Element_Attributes$px(100)),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Events$onClick(closeMsg),
																_1: {ctor: '[]'}
															}
														}
													},
													_mdgriffith$style_elements$Element$text(
														toUiTxt('gen_close'))),
												_1: {ctor: '[]'}
											}
										}
									})),
							_1: {ctor: '[]'}
						}
					}
				});
		}
	});
var _user$project$Views_IsolatedTree$view = F5(
	function (toMsg, closeMsg, toUiTxt, session, model) {
		var isDocEdit = function () {
			var _p113 = model.docTableState.mode;
			if (_p113.ctor === 'EditDocMode') {
				return true;
			} else {
				return false;
			}
		}();
		var getIsContactEdit = function (mode) {
			var _p114 = mode;
			if (_p114.ctor === 'Edit') {
				return true;
			} else {
				return false;
			}
		};
		var isModeratorEdit = getIsContactEdit(model.moderatorSelectionModel.mode);
		var queryParams = A2(
			_elm_lang$core$String$append,
			'jwt=',
			A2(
				_elm_lang$core$Maybe$withDefault,
				'',
				_user$project$Helpers_Data_JwtToken$toString(session.token)));
		var inputClass = 'col-sm-7 form-control';
		var labelClass = 'col-sm-5 form-control-label';
		var divClass = 'form-group row justify-content-start';
		return A2(
			_mdgriffith$style_elements$Element$viewport,
			_user$project$Styles$stylesheet,
			A3(
				_mdgriffith$style_elements$Element$column,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element$html(
						A2(
							_elm_lang$html$Html$ol,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('breadcrumb'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$li,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('breadcrumb-item active'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(
											toUiTxt('data_isolatedTree_title')),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							})),
					_1: {
						ctor: '::',
						_0: function () {
							var _p115 = model.mode;
							if (_p115.ctor === 'Visualization') {
								return A7(_user$project$Views_IsolatedTree$viewVis, toMsg, toUiTxt, closeMsg, _user$project$Data_Tree$fileServiceUrl, queryParams, session, model);
							} else {
								return isDocEdit ? A6(_user$project$Views_IsolatedTree$viewDocEditForm, toMsg, toUiTxt, _user$project$Data_Tree$fileServiceUrl, queryParams, model.docTableState, model.isolatedTreeForm.documents) : (isModeratorEdit ? A4(
									_user$project$Views_ContactSelection$view,
									function (_p116) {
										return toMsg(
											_user$project$Views_IsolatedTree$MsgFromModeratorSelection(_p116));
									},
									toUiTxt,
									model.moderatorSelectionModel,
									_elm_lang$core$Maybe$Nothing) : A7(_user$project$Views_IsolatedTree$viewMainForm, toMsg, toUiTxt, closeMsg, _user$project$Data_Tree$fileServiceUrl, queryParams, session, model));
							}
						}(),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$html(
								A2(_user$project$Helpers_Views_EventMsg$viewList, toUiTxt, model.eventMsgs)),
							_1: {ctor: '[]'}
						}
					}
				}));
	});
var _user$project$Views_IsolatedTree$RemoveSaveMsg = {ctor: 'RemoveSaveMsg'};
var _user$project$Views_IsolatedTree$LaunchExporter = function (a) {
	return {ctor: 'LaunchExporter', _0: a};
};
var _user$project$Views_IsolatedTree$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Views_IsolatedTree$handleSavedOk = F4(
	function (toMsg, parentSavedOk, mayId, model) {
		var notifyParent = A2(
			_elm_lang$core$Task$perform,
			_elm_lang$core$Basics$identity,
			_elm_lang$core$Task$succeed(parentSavedOk));
		var currentIsolatedTreeForm = model.isolatedTreeForm;
		var updIsolatedTreeForm = _elm_lang$core$Native_Utils.update(
			currentIsolatedTreeForm,
			{id: mayId});
		var currentIsolatedTree = model.isolatedTree;
		var updIsolatedTree = A2(
			_elm_lang$core$Maybe$map,
			function (isoTree) {
				return _elm_lang$core$Native_Utils.update(
					isoTree,
					{id: mayId});
			},
			currentIsolatedTree);
		return {
			ctor: '_Tuple3',
			_0: _elm_lang$core$Native_Utils.update(
				model,
				{
					eventMsgs: {
						ctor: '::',
						_0: _user$project$Helpers_Data_EventMsg$Success('gen_save_ok'),
						_1: {ctor: '[]'}
					},
					isolatedTree: updIsolatedTree,
					isolatedTreeForm: updIsolatedTreeForm
				}),
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: notifyParent,
					_1: {
						ctor: '::',
						_0: A2(
							_user$project$Views_IsolatedTree$delay,
							_elm_lang$core$Time$second * 1,
							toMsg(_user$project$Views_IsolatedTree$RemoveSaveMsg)),
						_1: {ctor: '[]'}
					}
				}),
			_2: _user$project$Views_IsolatedTree$NoOutMsg
		};
	});
var _user$project$Views_IsolatedTree$handleSavedError = F2(
	function (toMsg, model) {
		return {
			ctor: '_Tuple3',
			_0: _elm_lang$core$Native_Utils.update(
				model,
				{
					eventMsgs: {
						ctor: '::',
						_0: _user$project$Helpers_Data_EventMsg$Error('gen_save_error'),
						_1: {ctor: '[]'}
					}
				}),
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: A2(
						_user$project$Views_IsolatedTree$delay,
						_elm_lang$core$Time$second * 1,
						toMsg(_user$project$Views_IsolatedTree$RemoveSaveMsg)),
					_1: {ctor: '[]'}
				}),
			_2: _user$project$Views_IsolatedTree$NoOutMsg
		};
	});
var _user$project$Views_IsolatedTree$update = F6(
	function (toMsg, parentSavedOk, baseUrl, session, msg, model) {
		var updateScoreCmdWithShowPoints = F2(
			function (dataForm, showPoints) {
				if (showPoints) {
					var mayAge = function () {
						var _p117 = {ctor: '_Tuple2', _0: dataForm.yearOfPlanting, _1: model.currentYear};
						if ((_p117._0.ctor === 'Just') && (_p117._1.ctor === 'Just')) {
							return _elm_lang$core$Maybe$Just(_p117._1._0 - _p117._0._0);
						} else {
							return _elm_lang$core$Maybe$Nothing;
						}
					}();
					return A2(
						_elm_lang$http$Http$send,
						function (_p118) {
							return toMsg(
								_user$project$Views_IsolatedTree$ReceivedUpdatedPoints(_p118));
						},
						A4(_user$project$Requests_ComputeScore$byAttributes, baseUrl, session.token, dataForm, mayAge));
				} else {
					return _elm_lang$core$Platform_Cmd$none;
				}
			});
		var updateScoreCmd = function (dataForm) {
			return A2(updateScoreCmdWithShowPoints, dataForm, model.showPoints);
		};
		var uploadUrl = A2(_elm_lang$core$Basics_ops['++'], _user$project$Data_Tree$fileServiceUrl, 'upload');
		var isolatedTreeForm = model.isolatedTreeForm;
		var _p119 = msg;
		switch (_p119.ctor) {
			case 'RemoveSaveMsg':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							eventMsgs: {ctor: '[]'}
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'StartEditing':
				var newDocTableState = _user$project$Views_DocTable$startEditing(model.docTableState);
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{mode: _user$project$Views_IsolatedTree$MainEdit, docTableState: newDocTableState}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SaveClicked':
				var currentTreeForm = model.isolatedTreeForm;
				var updatedTreeForm = function () {
					var _p120 = currentTreeForm.id;
					if (_p120.ctor === 'Nothing') {
						return _elm_lang$core$Native_Utils.update(
							currentTreeForm,
							{createdBy: session.user, updatedBy: session.user});
					} else {
						return _elm_lang$core$Native_Utils.update(
							currentTreeForm,
							{updatedBy: session.user});
					}
				}();
				var mayItemToSave = function () {
					var _p121 = {ctor: '_Tuple2', _0: model.treeCoordX, _1: model.treeCoordY};
					if (((_p121.ctor === '_Tuple2') && (_p121._0.ctor === 'Just')) && (_p121._1.ctor === 'Just')) {
						return A3(
							_user$project$Views_IsolatedTree$fromIsolatedTreeForm,
							_elm_lang$core$Maybe$Just(
								_elm_lang$core$Date$year(_p119._0)),
							updatedTreeForm,
							{ctor: '_Tuple2', _0: _p121._0._0, _1: _p121._1._0});
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				var _p122 = mayItemToSave;
				if (_p122.ctor === 'Just') {
					var saveCmd = A2(
						_elm_lang$http$Http$send,
						function (_p123) {
							return toMsg(
								_user$project$Views_IsolatedTree$Saved(_p123));
						},
						A3(_user$project$Requests_IsolatedTree$save, baseUrl, session.token, _p122._0));
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{isolatedTreeForm: updatedTreeForm}),
						_1: saveCmd,
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				} else {
					return {
						ctor: '_Tuple3',
						_0: A2(_elm_lang$core$Debug$log, 'Could not convert dataForm to data', model),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				}
			case 'Saved':
				if (_p119._0.ctor === 'Ok') {
					return A4(_user$project$Views_IsolatedTree$handleSavedOk, toMsg, parentSavedOk, _p119._0._0, model);
				} else {
					var _p124 = A2(_elm_lang$core$Debug$log, 'error', _p119._0._0);
					return A2(_user$project$Views_IsolatedTree$handleSavedError, toMsg, model);
				}
			case 'SetCurrentYear':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							currentYear: _elm_lang$core$Maybe$Just(
								_elm_lang$core$Date$year(_p119._0))
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'GetCurrentDateFor':
				var cmd = A2(
					_elm_lang$core$Task$perform,
					function (_p125) {
						return toMsg(
							_p119._0(_p125));
					},
					_elm_lang$core$Date$now);
				return {ctor: '_Tuple3', _0: model, _1: cmd, _2: _user$project$Views_IsolatedTree$NoOutMsg};
			case 'NameChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						name: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsVarietyCertainChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{isVarietyCertain: !_p119._0});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SetDatePickerCollection':
				var _p126 = A3(_elm_community$elm_datepicker$DatePicker$update, _user$project$Helpers_Views_Form$datepickerSettings, _p119._0, model.datePickerCollection);
				var newDatePicker = _p126._0;
				var datePickerCmd = _p126._1;
				var dateEvent = _p126._2;
				var newModel = _elm_lang$core$Native_Utils.update(
					model,
					{datePickerCollection: newDatePicker});
				var _p127 = dateEvent;
				if (_p127.ctor === 'NoChange') {
					return {
						ctor: '_Tuple3',
						_0: newModel,
						_1: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (_p128) {
								return toMsg(
									_user$project$Views_IsolatedTree$SetDatePickerCollection(_p128));
							},
							datePickerCmd),
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				} else {
					var newDataForm = _elm_lang$core$Native_Utils.update(
						isolatedTreeForm,
						{collectionDate: _p127._0});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							newModel,
							{isolatedTreeForm: newDataForm}),
						_1: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (_p129) {
								return toMsg(
									_user$project$Views_IsolatedTree$SetDatePickerCollection(_p129));
							},
							datePickerCmd),
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				}
			case 'CircumferenceChanged':
				var mayFloat = function () {
					var _p130 = _elm_lang$core$String$toFloat(_p119._0);
					if (_p130.ctor === 'Ok') {
						return _elm_lang$core$Maybe$Just(_p130._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{circumference: mayFloat});
				var validation = A2(_user$project$Views_IsolatedTree$inputValidation.validateCircumference, _elm_lang$core$Maybe$Nothing, mayFloat);
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'CoordXChanged':
				var mayFloat = function () {
					var _p131 = _elm_lang$core$String$toFloat(_p119._0);
					if (_p131.ctor === 'Ok') {
						return _elm_lang$core$Maybe$Just(_p131._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{treeCoordX: mayFloat}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'CoordYChanged':
				var mayFloat = function () {
					var _p132 = _elm_lang$core$String$toFloat(_p119._0);
					if (_p132.ctor === 'Ok') {
						return _elm_lang$core$Maybe$Just(_p132._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{treeCoordY: mayFloat}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsMultiTrunkChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isMultiTrunk: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'CrownDevelopmentChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						crownDevelopment: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsPartOfAGroupChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isPartOfAGroup: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'PlantingYearChanged':
				var mayNewYear = function (_p133) {
					return _elm_lang$core$Result$toMaybe(
						_elm_lang$core$String$toInt(_p133));
				}(_p119._0);
				var mayNewAge = A2(
					_elm_lang$core$Maybe$map,
					function (newYear) {
						return _elm_lang$core$Date$year(_p119._1) - newYear;
					},
					mayNewYear);
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						yearOfPlanting: mayNewYear,
						age: A2(_elm_lang$core$Maybe$map, _elm_lang$core$Basics$toString, mayNewAge)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsyearOfPlantingKnown':
				var _p135 = _p119._0;
				var newAge = function () {
					if (!_p135) {
						var _p134 = isolatedTreeForm.isMoreThan100Years;
						if (_p134.ctor === 'Nothing') {
							return '';
						} else {
							return _p134._0 ? '> 100 ans' : '< 100 ans';
						}
					} else {
						return A2(_elm_lang$core$Maybe$withDefault, '', isolatedTreeForm.age);
					}
				}();
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isyearOfPlantingKnown: _elm_lang$core$Maybe$Just(_p135),
						isMoreThan100Years: (!_p135) ? isolatedTreeForm.isMoreThan100Years : _elm_lang$core$Maybe$Nothing,
						yearOfPlanting: _p135 ? isolatedTreeForm.yearOfPlanting : _elm_lang$core$Maybe$Nothing,
						age: _elm_lang$core$Maybe$Just(newAge)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsMoreThan100Years':
				var _p136 = _p119._0;
				var newAge = _p136 ? '> 100 ans' : '< 100 ans';
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isMoreThan100Years: _elm_lang$core$Maybe$Just(_p136),
						age: _elm_lang$core$Maybe$Just(newAge)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'HasSocioHistoricalInterestChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						hasSocioHistoricalInterest: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SocioHistoricalInterestChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						socioHistoricalInterest: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'HasLandscapeInterestChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						hasLandscapeInterest: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'EcosystemSituationChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						ecosystemSituation: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: updateScoreCmd(newDataForm),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsMentionedChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isMentioned: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsOfRegionalImportanceChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isOfRegionalImportance: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'CandidacyCommentChanged':
				var trimmedNewVal = _elm_lang$core$String$trim(_p119._0);
				var mayNewVal = function () {
					var _p137 = trimmedNewVal;
					if (_p137 === '') {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						return _elm_lang$core$Maybe$Just(trimmedNewVal);
					}
				}();
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{candidacyComment: mayNewVal});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsOfLocalInterestChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isOfLocalInterest: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsCandidateChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isCandidate: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'CommentsChanged':
				var trimmedNewVal = _elm_lang$core$String$trim(_p119._0);
				var mayNewVal = function () {
					var _p138 = trimmedNewVal;
					if (_p138 === '') {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						return _elm_lang$core$Maybe$Just(trimmedNewVal);
					}
				}();
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{comments: mayNewVal});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'IsRankedChanged':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						isRanked: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'JustificationOfRankingChanged':
				var trimmedNewVal = _elm_lang$core$String$trim(_p119._0);
				var mayNewVal = function () {
					var _p139 = trimmedNewVal;
					if (_p139 === '') {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						return _elm_lang$core$Maybe$Just(trimmedNewVal);
					}
				}();
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{justificationOfRanking: mayNewVal});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'MsgFromDocTable':
				var _p140 = A6(
					_user$project$Views_DocTable$update,
					function (_p141) {
						return toMsg(
							_user$project$Views_IsolatedTree$MsgFromDocTable(_p141));
					},
					uploadUrl,
					_user$project$Helpers_Data_Session$headers(session),
					_p119._0,
					model.docTableState,
					isolatedTreeForm.documents);
				var newDocTableState = _p140._0;
				var updDocs = _p140._1;
				var docTableCmd = _p140._2;
				var docTableOutMsg = _p140._3;
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{documents: updDocs});
				var _p142 = docTableOutMsg;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{docTableState: newDocTableState, isolatedTreeForm: newDataForm}),
					_1: docTableCmd,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'MsgFromModeratorSelection':
				var dataForm = model.isolatedTreeForm;
				var _p143 = A5(
					_user$project$Views_ContactSelection$update,
					function (_p144) {
						return toMsg(
							_user$project$Views_IsolatedTree$MsgFromModeratorSelection(_p144));
					},
					session,
					_p119._0,
					model.moderatorSelectionModel,
					baseUrl);
				var newModeratorSelectionModel = _p143._0;
				var moderatorSelectionCmd = _p143._1;
				var outMsg = _p143._2;
				var furtherUpdateNewModeratorSelectionModel = function () {
					var _p145 = outMsg;
					switch (_p145.ctor) {
						case 'ContactAdded':
							return A2(_user$project$Views_ContactSelection$addToListContact, newModeratorSelectionModel, _p145._0);
						case 'ContactUpdated':
							var _p147 = _p145._0;
							var _p146 = _p147.id;
							if (_p146.ctor === 'Just') {
								return A3(_user$project$Views_ContactSelection$updateListContactEntry, newModeratorSelectionModel, _p146._0, _p147);
							} else {
								return newModeratorSelectionModel;
							}
						default:
							return newModeratorSelectionModel;
					}
				}();
				var newdataForm = function () {
					var _p148 = outMsg;
					switch (_p148.ctor) {
						case 'ContactAdded':
							return _elm_lang$core$Native_Utils.update(
								dataForm,
								{
									moderator: _elm_lang$core$Maybe$Just(_p148._0)
								});
						case 'ContactSelected':
							return _elm_lang$core$Native_Utils.update(
								dataForm,
								{
									moderator: _elm_lang$core$Maybe$Just(_p148._0)
								});
						case 'ContactRemoved':
							return _elm_lang$core$Native_Utils.update(
								dataForm,
								{moderator: _elm_lang$core$Maybe$Nothing});
						default:
							return dataForm;
					}
				}();
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newdataForm, moderatorSelectionModel: furtherUpdateNewModeratorSelectionModel}),
					_1: moderatorSelectionCmd,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'MsgFromDatalistName':
				var _p149 = A5(
					_user$project$Helpers_Views_DatalistElement$update,
					function (_p150) {
						return toMsg(
							_user$project$Views_IsolatedTree$MsgFromDatalistName(_p150));
					},
					session,
					_p119._0,
					model.datalistNameState,
					baseUrl);
				var newDatalistState = _p149._0;
				var datalistCmd = _p149._1;
				var datalistOutMsg = _p149._2;
				var newVariety = function () {
					var _p151 = datalistOutMsg;
					if (_p151.ctor === 'ItemSelected') {
						return _p151._0;
					} else {
						return model.isolatedTreeForm.variety;
					}
				}();
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{variety: newVariety});
				var cmds = _elm_lang$core$Platform_Cmd$batch(
					{
						ctor: '::',
						_0: datalistCmd,
						_1: {
							ctor: '::',
							_0: function () {
								var _p152 = datalistOutMsg;
								if (_p152.ctor === 'ItemSelected') {
									return updateScoreCmd(newDataForm);
								} else {
									return _elm_lang$core$Platform_Cmd$none;
								}
							}(),
							_1: {ctor: '[]'}
						}
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{datalistNameState: newDatalistState, isolatedTreeForm: newDataForm}),
					_1: cmds,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SwitchInfoSectionHidden':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{infoSectionHidden: !model.infoSectionHidden}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SwitchKeySectionHidden':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{keySectionHidden: !model.keySectionHidden}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SwitchDecisionSectionHidden':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{decisionSectionHidden: !model.decisionSectionHidden}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SwitchDocSectionHidden':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{docSectionHidden: !model.docSectionHidden}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'ReceivedTreeAndMayModerator':
				if (_p119._0.ctor === 'Ok') {
					var _p157 = _p119._0._0._1;
					var _p153 = function () {
						var _p154 = _user$project$Views_IsolatedTree$toPoint(_p157.geometry);
						if (_p154.ctor === 'Nothing') {
							return {ctor: '_Tuple3', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Maybe$Nothing, _2: _elm_lang$core$Platform_Cmd$none};
						} else {
							var _p156 = _p154._0._1;
							var _p155 = _p154._0._0;
							return {
								ctor: '_Tuple3',
								_0: _elm_lang$core$Maybe$Just(_p155),
								_1: _elm_lang$core$Maybe$Just(_p156),
								_2: A3(_user$project$Views_IsolatedTree$getPlotNbReq, toMsg, _p155, _p156)
							};
						}
					}();
					var coordX = _p153._0;
					var coordY = _p153._1;
					var getPlotNbCmd = _p153._2;
					var getPlaceCmd = _user$project$Ports$getAreaAndPlace(_p157.geometry);
					var newdatalistNameState = _user$project$Helpers_Views_DatalistElement$init(
						_elm_lang$core$Maybe$Just(_p157.variety));
					var newIsolatedTreeForm = A3(
						_user$project$Views_IsolatedTree$toIsolatedTreeForm,
						_elm_lang$core$Maybe$Just(_p119._1),
						_p119._0._0._0,
						_elm_lang$core$Maybe$Just(_p157));
					var newModeratorSelectionModel = (A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$ContactReader) || A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$ContactEditor)) ? A2(_user$project$Views_ContactSelection$updateMode, model.moderatorSelectionModel, newIsolatedTreeForm.moderator) : model.moderatorSelectionModel;
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								isolatedTree: _elm_lang$core$Maybe$Just(_p157),
								isolatedTreeForm: newIsolatedTreeForm,
								moderatorSelectionModel: newModeratorSelectionModel,
								datalistNameState: newdatalistNameState,
								treeCoordX: coordX,
								treeCoordY: coordY
							}),
						_1: _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: A2(_user$project$Views_IsolatedTree$updateAllPointsCmd, toMsg, newIsolatedTreeForm),
								_1: {
									ctor: '::',
									_0: getPlaceCmd,
									_1: {
										ctor: '::',
										_0: getPlotNbCmd,
										_1: {ctor: '[]'}
									}
								}
							}),
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				} else {
					var _p158 = A2(_elm_lang$core$Debug$log, 'Error while receiving isolated tree', _p119._0._0);
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_IsolatedTree$NoOutMsg};
				}
			case 'ReceivedUpdatedPoints':
				if (_p119._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								attributeScore: _elm_lang$core$Maybe$Just(_p119._0._0)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				} else {
					var _p159 = A2(_elm_lang$core$Debug$log, 'Error while fetching the updated points: ', _p119._0._0);
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_IsolatedTree$NoOutMsg};
				}
			case 'ReceivedContacts':
				if (_p119._0.ctor === 'Ok') {
					var newModeratorSelectionModel = A2(_user$project$Views_ContactSelection$updateListContact, model.moderatorSelectionModel, _p119._0._0);
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{moderatorSelectionModel: newModeratorSelectionModel}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				} else {
					var _p160 = A2(_elm_lang$core$Debug$log, 'Error while fetching the contacts: ', _p119._0._0);
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_IsolatedTree$NoOutMsg};
				}
			case 'ReceivedPlotNb':
				if (_p119._0.ctor === 'Ok') {
					var newDataForm = _elm_lang$core$Native_Utils.update(
						isolatedTreeForm,
						{
							plotNb: _elm_lang$core$Maybe$Just(_p119._0._0)
						});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{isolatedTreeForm: newDataForm}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Views_IsolatedTree$NoOutMsg
					};
				} else {
					var _p161 = A2(_elm_lang$core$Debug$log, 'Error while fetching the plot nb: ', _p119._0._0);
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_IsolatedTree$NoOutMsg};
				}
			case 'ReceivedPlace':
				var newDataForm = _elm_lang$core$Native_Utils.update(
					isolatedTreeForm,
					{
						commune: _elm_lang$core$Maybe$Just(_p119._0)
					});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isolatedTreeForm: newDataForm}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'ImageSliderLess':
				var _p162 = _p119._0;
				var newPosition = _elm_lang$core$Native_Utils.eq(_p162, 0) ? 0 : (_p162 - 1);
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{sliderPosition: newPosition}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'ImageSliderMore':
				var _p163 = _p119._0;
				var newPosition = _elm_lang$core$Native_Utils.eq(_p163, _p119._1) ? _p163 : (_p163 + 1);
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{sliderPosition: newPosition}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'ShowPointsChanged':
				var _p164 = _p119._0;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{showPoints: _p164}),
					_1: A2(updateScoreCmdWithShowPoints, model.isolatedTreeForm, _p164),
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'SwitchVariety':
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isLatin: !model.isLatin}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Views_IsolatedTree$NoOutMsg
				};
			case 'NoMsg':
				return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Views_IsolatedTree$NoOutMsg};
			default:
				var outMsg = function () {
					var _p165 = model.isolatedTree;
					if (_p165.ctor === 'Nothing') {
						return _user$project$Views_IsolatedTree$NoOutMsg;
					} else {
						return _user$project$Views_IsolatedTree$LaunchExporter(_p165._0);
					}
				}();
				return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: outMsg};
		}
	});

var _user$project$Export_TreePDFExporter$viewOpLoading = function (txt) {
	return A3(
		_mdgriffith$style_elements$Element$column,
		_user$project$Styles$NoStyle,
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
			_1: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(20),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$el,
				_user$project$Styles$NoStyle,
				{ctor: '[]'},
				_mdgriffith$style_elements$Element$text(txt)),
			_1: {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$image,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$center,
						_1: {ctor: '[]'}
					},
					{src: './images/circles.gif', caption: 'En cours d\'exportation'}),
				_1: {ctor: '[]'}
			}
		});
};
var _user$project$Export_TreePDFExporter$ExpOpInitData = F2(
	function (a, b) {
		return {mapState: a, session: b};
	});
var _user$project$Export_TreePDFExporter$ExpOpData = {};
var _user$project$Export_TreePDFExporter$InvokeJSOp = {ctor: 'InvokeJSOp'};
var _user$project$Export_TreePDFExporter$TransformOp = function (a) {
	return {ctor: 'TransformOp', _0: a};
};
var _user$project$Export_TreePDFExporter$SelectImageOp = function (a) {
	return {ctor: 'SelectImageOp', _0: a};
};
var _user$project$Export_TreePDFExporter$MapCaptureOp = function (a) {
	return {ctor: 'MapCaptureOp', _0: a};
};
var _user$project$Export_TreePDFExporter$MapPanAndZoomOp = {ctor: 'MapPanAndZoomOp'};
var _user$project$Export_TreePDFExporter$MapSelectOp = function (a) {
	return {ctor: 'MapSelectOp', _0: a};
};
var _user$project$Export_TreePDFExporter$InvokeJSOpKey = {ctor: 'InvokeJSOpKey'};
var _user$project$Export_TreePDFExporter$TransformOpKey = {ctor: 'TransformOpKey'};
var _user$project$Export_TreePDFExporter$SelectImageOpKey = {ctor: 'SelectImageOpKey'};
var _user$project$Export_TreePDFExporter$getImageFromEndedOps = function (endedOperations) {
	var _p0 = _elm_lang$core$List$head(
		A2(_user$project$OpsHandler$getEndedOpsByOpKey, _user$project$Export_TreePDFExporter$SelectImageOpKey, endedOperations));
	if ((_p0.ctor === 'Just') && (_p0._0.ctor === 'SelectImageOp')) {
		return _p0._0._0.maySelectedImage;
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Export_TreePDFExporter$MapCaptureOpKey = {ctor: 'MapCaptureOpKey'};
var _user$project$Export_TreePDFExporter$MapPanAndZoomOpKey = function (a) {
	return {ctor: 'MapPanAndZoomOpKey', _0: a};
};
var _user$project$Export_TreePDFExporter$MapSelectOpKey = {ctor: 'MapSelectOpKey'};
var _user$project$Export_TreePDFExporter$getSelectedIsolatedTreeFromEndedOps = function (endedOperations) {
	var _p1 = _elm_lang$core$List$head(
		A2(_user$project$OpsHandler$getEndedOpsByOpKey, _user$project$Export_TreePDFExporter$MapSelectOpKey, endedOperations));
	if ((_p1.ctor === 'Just') && (_p1._0.ctor === 'MapSelectOp')) {
		return _elm_lang$core$List$head(
			A2(
				_elm_lang$core$Maybe$withDefault,
				{ctor: '[]'},
				_p1._0._0.maySelectedItems));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Export_TreePDFExporter$extractExpOpsData = F2(
	function (toUiTxt, endedOps) {
		var toModel = function (mapCaptureModel) {
			var _p2 = mapCaptureModel;
			if (_p2.ctor === 'MapCaptureOp') {
				return _elm_lang$core$Maybe$Just(_p2._0);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		var mayMapCaptureModel = _elm_lang$core$List$head(
			A2(
				_elm_lang$core$List$filterMap,
				toModel,
				A2(_user$project$OpsHandler$getEndedOpsByOpKey, _user$project$Export_TreePDFExporter$MapCaptureOpKey, endedOps)));
		var _p3 = function () {
			var _p4 = _user$project$Export_TreePDFExporter$getSelectedIsolatedTreeFromEndedOps(endedOps);
			if (_p4.ctor === 'Nothing') {
				return {ctor: '_Tuple2', _0: _elm_lang$core$Json_Encode$null, _1: 0};
			} else {
				return {
					ctor: '_Tuple2',
					_0: A2(_user$project$Data_Tree$encoder, true, _p4._0),
					_1: 12
				};
			}
		}();
		var encodedIsolatedTree = _p3._0;
		var points = _p3._1;
		return {
			isolatedTree: encodedIsolatedTree,
			mapCaptureModel: mayMapCaptureModel,
			image: _user$project$Export_TreePDFExporter$getImageFromEndedOps(endedOps),
			points: points
		};
	});
var _user$project$Export_TreePDFExporter$identifyNextExpOp = function (identifyNextOpData) {
	var _p5 = identifyNextOpData.currentOpKey;
	if (_p5.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Just(_user$project$Export_TreePDFExporter$MapSelectOpKey);
	} else {
		switch (_p5._0.ctor) {
			case 'MapSelectOpKey':
				return _elm_lang$core$Maybe$Just(
					_user$project$Export_TreePDFExporter$MapPanAndZoomOpKey(19));
			case 'MapPanAndZoomOpKey':
				return _elm_lang$core$Maybe$Just(_user$project$Export_TreePDFExporter$MapCaptureOpKey);
			case 'MapCaptureOpKey':
				return _elm_lang$core$Maybe$Just(_user$project$Export_TreePDFExporter$SelectImageOpKey);
			case 'SelectImageOpKey':
				return _elm_lang$core$Maybe$Just(_user$project$Export_TreePDFExporter$TransformOpKey);
			case 'TransformOpKey':
				return _elm_lang$core$Maybe$Just(_user$project$Export_TreePDFExporter$InvokeJSOpKey);
			default:
				return _elm_lang$core$Maybe$Nothing;
		}
	}
};
var _user$project$Export_TreePDFExporter$InvokeJSOpMsg = function (a) {
	return {ctor: 'InvokeJSOpMsg', _0: a};
};
var _user$project$Export_TreePDFExporter$subscriptions = A2(_elm_lang$core$Platform_Sub$map, _user$project$Export_TreePDFExporter$InvokeJSOpMsg, _user$project$OpsHandler_Ops_InvokeJSOp$subscription);
var _user$project$Export_TreePDFExporter$SelectImageOpMsg = function (a) {
	return {ctor: 'SelectImageOpMsg', _0: a};
};
var _user$project$Export_TreePDFExporter$manageExpOpUpdates = F3(
	function (expOpData, custOpMsg, custOp) {
		var _p6 = {ctor: '_Tuple2', _0: custOpMsg, _1: custOp};
		_v5_4:
		do {
			switch (_p6._0.ctor) {
				case 'MapSelectOpMsg':
					if (_p6._1.ctor === 'MapSelectOp') {
						var _p7 = A3(_user$project$OpsHandler_Ops_Map_SelectOp$update, _p6._0._0, _p6._1._0, _user$project$Data_Tree$decoder);
						var newMapSelectOpModel = _p7._0;
						var inMsg = _p7._1;
						return {
							ctor: '_Tuple4',
							_0: _user$project$Export_TreePDFExporter$MapSelectOp(newMapSelectOpModel),
							_1: _elm_lang$core$Platform_Cmd$none,
							_2: inMsg,
							_3: _user$project$Action$none
						};
					} else {
						break _v5_4;
					}
				case 'MapCaptureOpMsg':
					if (_p6._1.ctor === 'MapCaptureOp') {
						var _p8 = A2(_user$project$OpsHandler_Ops_Map_CaptureOp$update, _p6._0._0, _p6._1._0);
						var newMapCaptureOpModel = _p8._0;
						var inMsg = _p8._1;
						return {
							ctor: '_Tuple4',
							_0: _user$project$Export_TreePDFExporter$MapCaptureOp(newMapCaptureOpModel),
							_1: _elm_lang$core$Platform_Cmd$none,
							_2: inMsg,
							_3: _user$project$Action$none
						};
					} else {
						break _v5_4;
					}
				case 'SelectImageOpMsg':
					if (_p6._1.ctor === 'SelectImageOp') {
						var _p9 = A2(_user$project$OpsHandler_Ops_SelectImageOp$update, _p6._0._0, _p6._1._0);
						var newSelectImageOpModel = _p9._0;
						var cmd = _p9._1;
						var inMsg = _p9._2;
						return {
							ctor: '_Tuple4',
							_0: _user$project$Export_TreePDFExporter$SelectImageOp(newSelectImageOpModel),
							_1: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Export_TreePDFExporter$SelectImageOpMsg, cmd),
							_2: inMsg,
							_3: _user$project$Action$none
						};
					} else {
						break _v5_4;
					}
				case 'InvokeJSOpMsg':
					if (_p6._1.ctor === 'InvokeJSOp') {
						var inMsg = _user$project$OpsHandler_Ops_InvokeJSOp$updateExpectNoRes(_p6._0._0);
						return {ctor: '_Tuple4', _0: _user$project$Export_TreePDFExporter$InvokeJSOp, _1: _elm_lang$core$Platform_Cmd$none, _2: inMsg, _3: _user$project$Action$none};
					} else {
						break _v5_4;
					}
				default:
					break _v5_4;
			}
		} while(false);
		return {ctor: '_Tuple4', _0: custOp, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$OpsHandler_OpOutMsg$NoOpOutMsg, _3: _user$project$Action$none};
	});
var _user$project$Export_TreePDFExporter$manageViews = function (custOp) {
	var _p10 = custOp;
	switch (_p10.ctor) {
		case 'MapSelectOp':
			return A2(_user$project$OpsHandler$InstructionView, 'Sélection de l\'objet', 'Veuillez suivre les instructions de la carte');
		case 'MapPanAndZoomOp':
			return A2(_user$project$OpsHandler$InstructionView, 'Préparation de la vue avant capture', 'Ajuster la vue selon vos préférences');
		case 'MapCaptureOp':
			return _user$project$OpsHandler$WizardView(
				_user$project$Export_TreePDFExporter$viewOpLoading('Capture de la vue en cours...'));
		case 'SelectImageOp':
			return _user$project$OpsHandler$WizardView(
				A4(
					_mdgriffith$style_elements$Element$mapAll,
					_user$project$Export_TreePDFExporter$SelectImageOpMsg,
					_user$project$Styles$StylesFromOpsHandler,
					_user$project$Styles$VariationsFromOpsHandler,
					_user$project$OpsHandler_Ops_SelectImageOp$view(_p10._0)));
		case 'TransformOp':
			return A2(_user$project$OpsHandler$InstructionView, 'Formatage des données', 'Formatage en cours...');
		default:
			return _user$project$OpsHandler$WizardView(
				_user$project$Export_TreePDFExporter$viewOpLoading('Génération du PDF en cours...'));
	}
};
var _user$project$Export_TreePDFExporter$MapCaptureOpMsg = function (a) {
	return {ctor: 'MapCaptureOpMsg', _0: a};
};
var _user$project$Export_TreePDFExporter$MapPanAndZoomOpMsg = function (a) {
	return {ctor: 'MapPanAndZoomOpMsg', _0: a};
};
var _user$project$Export_TreePDFExporter$MapSelectOpMsg = function (a) {
	return {ctor: 'MapSelectOpMsg', _0: a};
};
var _user$project$Export_TreePDFExporter$manageExpOpInits = F6(
	function (toMapMsg, toExporterMsg, toUiTxt, expOpInitData, endedOperations, opKey) {
		var _p11 = opKey;
		switch (_p11.ctor) {
			case 'MapSelectOpKey':
				var _p12 = A3(
					_user$project$OpsHandler_Ops_Map_SelectOp$init,
					toMapMsg,
					function (_p13) {
						return toExporterMsg(
							_user$project$OpsHandler$OpMsg(
								_user$project$Export_TreePDFExporter$MapSelectOpMsg(_p13)));
					},
					{
						layers: {
							ctor: '::',
							_0: 'trees',
							_1: {ctor: '[]'}
						},
						min: 1,
						max: 1,
						geoZone: _elm_lang$core$Maybe$Nothing
					});
				var mapSelectOpModel = _p12._0;
				var mapSelectOpAction = _p12._1;
				return {
					ctor: '_Tuple4',
					_0: _user$project$Export_TreePDFExporter$MapSelectOp(mapSelectOpModel),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$OpsHandler_OpOutMsg$NoOpOutMsg,
					_3: mapSelectOpAction
				};
			case 'MapPanAndZoomOpKey':
				var geoObjs = function () {
					var _p14 = _user$project$Export_TreePDFExporter$getSelectedIsolatedTreeFromEndedOps(endedOperations);
					if (_p14.ctor === 'Nothing') {
						return {ctor: '[]'};
					} else {
						var _p15 = _p14._0.id;
						if (_p15.ctor === 'Nothing') {
							return {ctor: '[]'};
						} else {
							return {
								ctor: '::',
								_0: {
									id: _elm_lang$core$Basics$toString(_p15._0),
									obj: _elm_lang$core$Maybe$Nothing,
									layerKey: 'trees'
								},
								_1: {ctor: '[]'}
							};
						}
					}
				}();
				var mapPanAndZoomOpCmd = A3(_user$project$OpsHandler_Ops_Map_PanAndZoomOp$init, expOpInitData.mapState, geoObjs, _p11._0);
				return {
					ctor: '_Tuple4',
					_0: _user$project$Export_TreePDFExporter$MapPanAndZoomOp,
					_1: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Export_TreePDFExporter$MapPanAndZoomOpMsg, mapPanAndZoomOpCmd),
					_2: _user$project$OpsHandler_OpOutMsg$OpStateChanged(_user$project$OpsHandler_OpOutMsg$DoneManual),
					_3: _user$project$Action$none
				};
			case 'MapCaptureOpKey':
				var _p16 = A2(
					_user$project$OpsHandler_Ops_Map_CaptureOp$init,
					toMapMsg,
					function (_p17) {
						return toExporterMsg(
							_user$project$OpsHandler$OpMsg(
								_user$project$Export_TreePDFExporter$MapCaptureOpMsg(_p17)));
					});
				var captureModel = _p16._0;
				var mapCaptureOpAction = _p16._1;
				return {
					ctor: '_Tuple4',
					_0: _user$project$Export_TreePDFExporter$MapCaptureOp(captureModel),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$OpsHandler_OpOutMsg$NoOpOutMsg,
					_3: mapCaptureOpAction
				};
			case 'SelectImageOpKey':
				var treeImageIds = function () {
					var _p18 = _user$project$Export_TreePDFExporter$getSelectedIsolatedTreeFromEndedOps(endedOperations);
					if (_p18.ctor === 'Nothing') {
						return {ctor: '[]'};
					} else {
						return A2(
							_elm_lang$core$List$filterMap,
							function (doc) {
								return _elm_lang$core$Native_Utils.eq(doc.contentType, _user$project$Data_Document$contentTypeImage) ? doc.file : _elm_lang$core$Maybe$Nothing;
							},
							_p18._0.documents);
					}
				}();
				var jwtParam = A2(
					_elm_lang$core$String$append,
					'jwt=',
					A2(
						_elm_lang$core$Maybe$withDefault,
						'',
						_user$project$Helpers_Data_JwtToken$toString(expOpInitData.session.token)));
				var treeImagesUrls = A2(
					_elm_lang$core$List$map,
					function (id) {
						return A2(
							_elm_lang$core$Basics_ops['++'],
							_user$project$Data_Tree$fileServiceUrl,
							A2(
								_elm_lang$core$Basics_ops['++'],
								id,
								A2(_elm_lang$core$Basics_ops['++'], '?', jwtParam)));
					},
					treeImageIds);
				var _p19 = _user$project$OpsHandler_Ops_SelectImageOp$init(
					{ctor: '::', _0: '/images/no_image.jpg', _1: treeImagesUrls});
				var model = _p19._0;
				var cmd = _p19._1;
				return {
					ctor: '_Tuple4',
					_0: _user$project$Export_TreePDFExporter$SelectImageOp(model),
					_1: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Export_TreePDFExporter$SelectImageOpMsg, cmd),
					_2: _user$project$OpsHandler_OpOutMsg$NoOpOutMsg,
					_3: _user$project$Action$none
				};
			case 'TransformOpKey':
				var _p20 = A2(
					_user$project$OpsHandler_Ops_TransformOp$init,
					_user$project$Export_TreePDFExporter$extractExpOpsData(toUiTxt),
					endedOperations);
				var model = _p20._0;
				var opOutMsg = _p20._1;
				return {
					ctor: '_Tuple4',
					_0: _user$project$Export_TreePDFExporter$TransformOp(model),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: opOutMsg,
					_3: _user$project$Action$none
				};
			default:
				var mayData = function () {
					var _p21 = _elm_lang$core$List$head(
						A2(_user$project$OpsHandler$getEndedOpsByOpKey, _user$project$Export_TreePDFExporter$TransformOpKey, endedOperations));
					if ((_p21.ctor === 'Just') && (_p21._0.ctor === 'TransformOp')) {
						return _elm_lang$core$Maybe$Just(_p21._0._0.transformedData);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				var cmd = function () {
					var _p22 = mayData;
					if (_p22.ctor === 'Nothing') {
						return _elm_lang$core$Platform_Cmd$none;
					} else {
						return A3(_user$project$OpsHandler_Ops_InvokeJSOp$initExpectNoRes, _p22._0, 'exportPDFWithElmData', _user$project$Data_Tree$exportDataEncoder);
					}
				}();
				return {
					ctor: '_Tuple4',
					_0: _user$project$Export_TreePDFExporter$InvokeJSOp,
					_1: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Export_TreePDFExporter$InvokeJSOpMsg, cmd),
					_2: _user$project$OpsHandler_OpOutMsg$NoOpOutMsg,
					_3: _user$project$Action$none
				};
		}
	});
var _user$project$Export_TreePDFExporter$updateConfig = F3(
	function (toUiTxt, toMapMsg, toExporterMsg) {
		return {
			identifyNextOp: _user$project$Export_TreePDFExporter$identifyNextExpOp,
			manageOpInits: A3(_user$project$Export_TreePDFExporter$manageExpOpInits, toMapMsg, toExporterMsg, toUiTxt),
			manageOpRestarts: _user$project$OpsHandler$restartOpsAsTheyWere(
				A3(_user$project$Export_TreePDFExporter$manageExpOpInits, toMapMsg, toExporterMsg, toUiTxt)),
			manageOpUpdates: _user$project$Export_TreePDFExporter$manageExpOpUpdates
		};
	});

var _user$project$Requests_Place$find = F5(
	function (baseUrl, mayToken, queryString, filterField, mayLimit) {
		var strLimit = function () {
			var _p0 = mayLimit;
			if (_p0.ctor === 'Nothing') {
				return '';
			} else {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'&$limit=',
					_elm_lang$core$Basics$toString(_p0._0));
			}
		}();
		var finalUrl = _elm_lang$core$String$concat(
			{
				ctor: '::',
				_0: baseUrl,
				_1: {
					ctor: '::',
					_0: 'place?',
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							filterField,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'[$ilike]=',
								A2(_elm_lang$core$Basics_ops['++'], queryString, '%25'))),
						_1: {
							ctor: '::',
							_0: strLimit,
							_1: {ctor: '[]'}
						}
					}
				}
			});
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: finalUrl,
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(
					_elm_lang$core$Json_Decode$list(_user$project$Data_Place$decoder)),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});

var _user$project$Helpers_Views_DatalistPlace$delay = F2(
	function (time, msg) {
		return A2(
			_elm_lang$core$Task$perform,
			function (_p0) {
				return msg;
			},
			_elm_lang$core$Process$sleep(time));
	});
var _user$project$Helpers_Views_DatalistPlace$getPartialItemAsString = F2(
	function (place, isLowerKey) {
		var _p1 = isLowerKey;
		if (_p1 === true) {
			return _elm_lang$core$String$toLower(place.name);
		} else {
			return place.name;
		}
	});
var _user$project$Helpers_Views_DatalistPlace$viewSearchEntry = F3(
	function (toMsg, toUiTxt, item) {
		return _elm_lang$html$Html$text(
			A2(_user$project$Helpers_Views_DatalistPlace$getPartialItemAsString, item, false));
	});
var _user$project$Helpers_Views_DatalistPlace$defaultSearchData = {
	listItem: {ctor: '[]'},
	queryString: '',
	isSearchListVisible: false,
	highLightedSearchPoint: _elm_lang$core$Maybe$Nothing
};
var _user$project$Helpers_Views_DatalistPlace$Model = function (a) {
	return {mode: a};
};
var _user$project$Helpers_Views_DatalistPlace$SearchData = F4(
	function (a, b, c, d) {
		return {listItem: a, queryString: b, isSearchListVisible: c, highLightedSearchPoint: d};
	});
var _user$project$Helpers_Views_DatalistPlace$Search = function (a) {
	return {ctor: 'Search', _0: a};
};
var _user$project$Helpers_Views_DatalistPlace$Visualization = function (a) {
	return {ctor: 'Visualization', _0: a};
};
var _user$project$Helpers_Views_DatalistPlace$init = function (mayPlace) {
	var mode = function () {
		var _p2 = mayPlace;
		if (_p2.ctor === 'Just') {
			return _user$project$Helpers_Views_DatalistPlace$Visualization(_p2._0);
		} else {
			return _user$project$Helpers_Views_DatalistPlace$Search(_user$project$Helpers_Views_DatalistPlace$defaultSearchData);
		}
	}();
	return {mode: mode};
};
var _user$project$Helpers_Views_DatalistPlace$RemoveItem = {ctor: 'RemoveItem'};
var _user$project$Helpers_Views_DatalistPlace$viewVisualization = F3(
	function (toMsg, toUiTxt, item) {
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
						_1: {ctor: '[]'}
					},
					_mdgriffith$style_elements$Element$text(
						A2(_user$project$Helpers_Views_DatalistPlace$getPartialItemAsString, item, false))),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$image,
						_user$project$Styles$DocDeleteBtn,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(
								_mdgriffith$style_elements$Element_Attributes$px(20)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(20)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Events$onClick(
										toMsg(_user$project$Helpers_Views_DatalistPlace$RemoveItem)),
									_1: {ctor: '[]'}
								}
							}
						},
						{src: './images/delete.svg', caption: 'remove'}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_DatalistPlace$ItemsReceived = function (a) {
	return {ctor: 'ItemsReceived', _0: a};
};
var _user$project$Helpers_Views_DatalistPlace$SearchItemMouseDown = {ctor: 'SearchItemMouseDown'};
var _user$project$Helpers_Views_DatalistPlace$SearchItemMouseOver = function (a) {
	return {ctor: 'SearchItemMouseOver', _0: a};
};
var _user$project$Helpers_Views_DatalistPlace$SearchItemSelected = function (a) {
	return {ctor: 'SearchItemSelected', _0: a};
};
var _user$project$Helpers_Views_DatalistPlace$SearchInputBlured = {ctor: 'SearchInputBlured'};
var _user$project$Helpers_Views_DatalistPlace$SearchInputFocused = {ctor: 'SearchInputFocused'};
var _user$project$Helpers_Views_DatalistPlace$SearchChanged = function (a) {
	return {ctor: 'SearchChanged', _0: a};
};
var _user$project$Helpers_Views_DatalistPlace$viewSearch = F3(
	function (toMsg, toUiTxt, searchData) {
		var sortedList = A2(
			_elm_lang$core$List$sortBy,
			function (_) {
				return _.name;
			},
			searchData.listItem);
		var listItemsHtml = A2(
			_elm_lang$core$List$map,
			function (item) {
				return A2(
					_elm_lang$html$Html$li,
					{
						ctor: '::',
						_0: _user$project$Helpers_Views_DataSearch$dataListItemStyle,
						_1: {
							ctor: '::',
							_0: A3(
								_elm_lang$html$Html_Events$onWithOptions,
								'mousedown',
								{stopPropagation: false, preventDefault: true},
								_elm_lang$core$Json_Decode$succeed(
									toMsg(_user$project$Helpers_Views_DatalistPlace$SearchItemMouseDown))),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									toMsg(
										_user$project$Helpers_Views_DatalistPlace$SearchItemSelected(item))),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onMouseOver(
										toMsg(
											_user$project$Helpers_Views_DatalistPlace$SearchItemMouseOver(
												_elm_lang$core$Maybe$Just(item.id)))),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: function () {
												var _p3 = searchData.highLightedSearchPoint;
												if (_p3.ctor === 'Nothing') {
													return _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
															_1: {ctor: '[]'}
														});
												} else {
													return _elm_lang$core$Native_Utils.eq(
														_elm_lang$core$Maybe$Just(_p3._0),
														_elm_lang$core$Maybe$Just(item.id)) ? _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'lightgrey'},
															_1: {ctor: '[]'}
														}) : _elm_lang$html$Html_Attributes$style(
														{
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'background-color', _1: 'white'},
															_1: {ctor: '[]'}
														});
												}
											}(),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					},
					{
						ctor: '::',
						_0: A3(_user$project$Helpers_Views_DatalistPlace$viewSearchEntry, toMsg, toUiTxt, item),
						_1: {ctor: '[]'}
					});
			},
			sortedList);
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$el,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					_mdgriffith$style_elements$Element$html(
						A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _user$project$Helpers_Views_DataSearch$dataSearchContainerStyle,
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _user$project$Helpers_Views_DataSearch$dataListDivStyle,
										_1: {
											ctor: '::',
											_0: searchData.isSearchListVisible ? _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'visible'},
													_1: {ctor: '[]'}
												}) : _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'visibility', _1: 'collapse'},
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$ul,
											{
												ctor: '::',
												_0: _user$project$Helpers_Views_DataSearch$dataListStyle,
												_1: {ctor: '[]'}
											},
											listItemsHtml),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}))),
				_1: {
					ctor: '::',
					_0: A6(
						_user$project$Helpers_Views_Form$elSearch2,
						function (_p4) {
							return toMsg(
								_user$project$Helpers_Views_DatalistPlace$SearchChanged(_p4));
						},
						toMsg(_user$project$Helpers_Views_DatalistPlace$SearchInputFocused),
						toMsg(_user$project$Helpers_Views_DatalistPlace$SearchInputBlured),
						true,
						false,
						toUiTxt('data_allF')),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Helpers_Views_DatalistPlace$view = F3(
	function (toMsg, toUiTxt, model) {
		var _p5 = model.mode;
		if (_p5.ctor === 'Visualization') {
			return A3(_user$project$Helpers_Views_DatalistPlace$viewVisualization, toMsg, toUiTxt, _p5._0);
		} else {
			return A3(_user$project$Helpers_Views_DatalistPlace$viewSearch, toMsg, toUiTxt, _p5._0);
		}
	});
var _user$project$Helpers_Views_DatalistPlace$ItemSelected = function (a) {
	return {ctor: 'ItemSelected', _0: a};
};
var _user$project$Helpers_Views_DatalistPlace$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Helpers_Views_DatalistPlace$update = F5(
	function (toMsg, session, msg, model, baseUrl) {
		var currentSearchData = function () {
			var _p6 = model.mode;
			if (_p6.ctor === 'Search') {
				return _p6._0;
			} else {
				return _user$project$Helpers_Views_DatalistPlace$defaultSearchData;
			}
		}();
		var _p7 = msg;
		switch (_p7.ctor) {
			case 'SearchChanged':
				var _p9 = _p7._0;
				var findItemsCmd = A2(
					_elm_lang$http$Http$send,
					function (_p8) {
						return toMsg(
							_user$project$Helpers_Views_DatalistPlace$ItemsReceived(_p8));
					},
					A5(
						_user$project$Requests_Place$find,
						baseUrl,
						session.token,
						_p9,
						'name',
						_elm_lang$core$Maybe$Just(12)));
				var newSearchData = _elm_lang$core$Native_Utils.update(
					currentSearchData,
					{queryString: _p9});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistPlace$Search(newSearchData)
						}),
					_1: findItemsCmd,
					_2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg
				};
			case 'SearchInputFocused':
				var newSearchData = _elm_lang$core$Native_Utils.update(
					currentSearchData,
					{isSearchListVisible: true});
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistPlace$Search(newSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg
				};
			case 'SearchInputBlured':
				var _p10 = model.mode;
				if (_p10.ctor === 'Search') {
					var newSearchData = _elm_lang$core$Native_Utils.update(
						currentSearchData,
						{isSearchListVisible: false, queryString: ''});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								mode: _user$project$Helpers_Views_DatalistPlace$Search(newSearchData)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg
					};
				} else {
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg};
				}
			case 'SearchItemSelected':
				var _p11 = _p7._0;
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistPlace$Visualization(_p11)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Helpers_Views_DatalistPlace$ItemSelected(
						_elm_lang$core$Maybe$Just(_p11))
				};
			case 'SearchItemMouseOver':
				var _p12 = model.mode;
				if (_p12.ctor === 'Search') {
					var newSearchData = _elm_lang$core$Native_Utils.update(
						currentSearchData,
						{highLightedSearchPoint: _p7._0});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								mode: _user$project$Helpers_Views_DatalistPlace$Search(newSearchData)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg
					};
				} else {
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg};
				}
			case 'SearchItemMouseDown':
				return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg};
			case 'ItemsReceived':
				if (_p7._0.ctor === 'Ok') {
					var newSearchData = _elm_lang$core$Native_Utils.update(
						currentSearchData,
						{listItem: _p7._0._0});
					return {
						ctor: '_Tuple3',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								mode: _user$project$Helpers_Views_DatalistPlace$Search(newSearchData)
							}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg
					};
				} else {
					var _p13 = A2(_elm_lang$core$Debug$log, 'Error: Coudn\'t get items -', _p7._0._0);
					return {ctor: '_Tuple3', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Helpers_Views_DatalistPlace$NoOutMsg};
				}
			default:
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _user$project$Helpers_Views_DatalistPlace$Search(_user$project$Helpers_Views_DatalistPlace$defaultSearchData)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: _user$project$Helpers_Views_DatalistPlace$ItemSelected(_elm_lang$core$Maybe$Nothing)
				};
		}
	});

var _user$project$Helpers_Views_Errored$view = function (_p0) {
	var _p1 = _p0;
	return A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$h1,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('Error Loading Page'),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('row'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$p,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(_p1._0.errorMessage),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		});
};
var _user$project$Helpers_Views_Errored$Model = function (a) {
	return {errorMessage: a};
};
var _user$project$Helpers_Views_Errored$PageLoadError = function (a) {
	return {ctor: 'PageLoadError', _0: a};
};
var _user$project$Helpers_Views_Errored$pageLoadError = function (errorMessage) {
	return _user$project$Helpers_Views_Errored$PageLoadError(
		{errorMessage: errorMessage});
};

var _user$project$Helpers_Views_Language$mayDispLangDropItem = F3(
	function (toMsg, curLang, langToDisp) {
		return _elm_lang$core$Native_Utils.eq(curLang, langToDisp) ? _elm_lang$html$Html$text('') : A2(
			_elm_lang$html$Html$button,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$type_('button'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('dropdown-item'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							toMsg(langToDisp)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					_user$project$Helpers_Data_Language$langToString(langToDisp)),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Language$viewDropdown = F3(
	function (toMsg, curLang, langs) {
		return {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$button,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$type_('button'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('btn btn-secondary dropdown-toggle'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id('dropdownLangButton'),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-toggle', 'dropdown'),
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-haspopup', 'true'),
									_1: {
										ctor: '::',
										_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-expanded', 'false'),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						_user$project$Helpers_Data_Language$langToString(curLang)),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('dropdown-menu'),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-labelledby', 'dropdownLangButton'),
							_1: {ctor: '[]'}
						}
					},
					A2(
						_elm_lang$core$List$map,
						A2(_user$project$Helpers_Views_Language$mayDispLangDropItem, toMsg, curLang),
						langs)),
				_1: {ctor: '[]'}
			}
		};
	});
var _user$project$Helpers_Views_Language$mayDispLangBtn = F3(
	function (toMsg, curLang, langToDisp) {
		return _elm_lang$core$Native_Utils.eq(curLang, langToDisp) ? _elm_lang$html$Html$text('') : A2(
			_elm_lang$html$Html$button,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$type_('button'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('btn btn-secondary'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							toMsg(langToDisp)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					_user$project$Helpers_Data_Language$langToString(langToDisp)),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Helpers_Views_Language$viewButtons = F3(
	function (toMsg, curLang, langs) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('btn-group'),
				_1: {ctor: '[]'}
			},
			A2(
				_elm_lang$core$List$map,
				A2(_user$project$Helpers_Views_Language$mayDispLangBtn, toMsg, curLang),
				langs));
	});

var _user$project$Views_Page$viewUserManuel = function (manuelUrl) {
	return A2(
		_elm_lang$html$Html$li,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('nav-item active'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$a,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('nav-link'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$href(manuelUrl),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$target('_blank'),
							_1: {ctor: '[]'}
						}
					}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$img,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$src('images/access_user_manuel.svg'),
							_1: {ctor: '[]'}
						},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _user$project$Views_Page$toTextOrUndef = function (mayTitle) {
	return A2(_user$project$Helpers_Views_Text$toTextOrDefault, 'gen_undefined', mayTitle);
};
var _user$project$Views_Page$viewLogout = A2(
	_elm_lang$html$Html$li,
	{
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$class('nav-item active'),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$a,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('nav-link'),
				_1: {
					ctor: '::',
					_0: _user$project$Routing$href(_user$project$Routing$Logout),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$img,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$src('images/logout.svg'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			}),
		_1: {ctor: '[]'}
	});
var _user$project$Views_Page$availLangs = {
	ctor: '::',
	_0: _user$project$Helpers_Data_Language$FR,
	_1: {
		ctor: '::',
		_0: _user$project$Helpers_Data_Language$DE,
		_1: {ctor: '[]'}
	}
};
var _user$project$Views_Page$viewLangButtons = F2(
	function (langToMsg, curLang) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('row justify-content-end mt-3'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('col-2'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A3(_user$project$Helpers_Views_Language$viewButtons, langToMsg, curLang, _user$project$Views_Page$availLangs),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_Page$viewLangWidget = F2(
	function (langToMsg, curLang) {
		return A2(
			_elm_lang$html$Html$li,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('nav-item dropdown'),
				_1: {ctor: '[]'}
			},
			A3(_user$project$Helpers_Views_Language$viewDropdown, langToMsg, curLang, _user$project$Views_Page$availLangs));
	});
var _user$project$Views_Page$mayDisplayPage = F5(
	function (toUiTxt, session, reqRole, pageName, route) {
		return A2(_user$project$Data_Role$hasRole, session.token, reqRole) ? A2(
			_elm_lang$html$Html$a,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('dropdown-item'),
				_1: {
					ctor: '::',
					_0: _user$project$Routing$href(route),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					toUiTxt(pageName)),
				_1: {ctor: '[]'}
			}) : _elm_lang$html$Html$text('');
	});
var _user$project$Views_Page$viewPagesNav = F2(
	function (toUiTxt, session) {
		return A2(
			_elm_lang$html$Html$li,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('nav-item dropdown'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('dropdown-menu'),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-labelledby', 'dropdownMenuButton'),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A5(_user$project$Views_Page$mayDisplayPage, toUiTxt, session, _user$project$Data_Role$TreeReader, 'page_treemap', _user$project$Routing$TreeMap),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_Page$viewHeader = F6(
	function (toUiTxt, session, langToMsg, curLang, mayTitle, mayManuelUrl) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('row'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('col-12'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$nav,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('navbar navbar-expand-md navbar-light'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$style(
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'background-color', _1: '#e3f2fd'},
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('navbar-brand font-weight-bold'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(
											toUiTxt(
												_user$project$Views_Page$toTextOrUndef(mayTitle))),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$button,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('navbar-toggler'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$type_('button'),
												_1: {
													ctor: '::',
													_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-toggle', 'collapse'),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-target', '#navbarSupportedContent'),
														_1: {
															ctor: '::',
															_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-controls', 'navbarSupportedContent'),
															_1: {
																ctor: '::',
																_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-expanded', 'false'),
																_1: {
																	ctor: '::',
																	_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-label', 'Toggle navigation'),
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$span,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('navbar-toggler-icon'),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('collapse navbar-collapse'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$id('navbarSupportedContent'),
													_1: {ctor: '[]'}
												}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$ul,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('navbar-nav mr-auto'),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A2(_user$project$Views_Page$viewPagesNav, toUiTxt, session),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$ul,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('navbar-nav ml-auto'),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: function () {
																var _p0 = mayManuelUrl;
																if (_p0.ctor === 'Just') {
																	return _user$project$Views_Page$viewUserManuel(_p0._0);
																} else {
																	return A2(
																		_elm_lang$html$Html$span,
																		{ctor: '[]'},
																		{ctor: '[]'});
																}
															}(),
															_1: {
																ctor: '::',
																_0: _user$project$Views_Page$viewLogout,
																_1: {ctor: '[]'}
															}
														}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {ctor: '[]'}
									}
								}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_Page$PageConfig = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {toUiTxt: a, session: b, langToMsg: c, curLang: d, mayTitle: e, pageType: f, device: g, content: h, mayManuelUrl: i};
	});
var _user$project$Views_Page$TreeMap = {ctor: 'TreeMap'};
var _user$project$Views_Page$UsersMng = {ctor: 'UsersMng'};
var _user$project$Views_Page$Profile = {ctor: 'Profile'};
var _user$project$Views_Page$Login = {ctor: 'Login'};
var _user$project$Views_Page$Form = {ctor: 'Form'};
var _user$project$Views_Page$NoHeader = {ctor: 'NoHeader'};
var _user$project$Views_Page$viewPage = function (_p1) {
	var _p2 = _p1;
	var _p5 = _p2.pageType;
	var _p4 = _p2.device;
	var _p3 = _p2.content;
	var layoutContent = ((!_elm_lang$core$Native_Utils.eq(_p5, _user$project$Views_Page$Form)) || (_p4.tablet || _p4.phone)) ? _p3 : A3(
		_mdgriffith$style_elements$Element$row,
		_user$project$Styles$NoStyle,
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
			_1: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$center,
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$column,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$padding(30),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$Form,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$minWidth(
								_mdgriffith$style_elements$Element_Attributes$px(700)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$padding(24),
								_1: {ctor: '[]'}
							}
						},
						_p3),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
	var header = ((!_elm_lang$core$Native_Utils.eq(_p5, _user$project$Views_Page$NoHeader)) && (!_elm_lang$core$Native_Utils.eq(_p5, _user$project$Views_Page$Login))) ? A6(_user$project$Views_Page$viewHeader, _p2.toUiTxt, _p2.session, _p2.langToMsg, _p2.curLang, _p2.mayTitle, _p2.mayManuelUrl) : _elm_lang$html$Html$text('');
	return A2(
		_mdgriffith$style_elements$Element$viewport,
		_user$project$Styles$stylesheet,
		A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element$html(header),
				_1: {
					ctor: '::',
					_0: layoutContent,
					_1: {ctor: '[]'}
				}
			}));
};

var _user$project$Pages_Login$Model = function (a) {
	return {authState: a};
};
var _user$project$Pages_Login$init = function (loginUrl) {
	var _p0 = _user$project$Auth$initState(loginUrl);
	var initAuthState = _p0._0;
	var initAuthCmd = _p0._1;
	return _user$project$Pages_Login$Model(initAuthState);
};
var _user$project$Pages_Login$GuestAccessClicked = {ctor: 'GuestAccessClicked'};
var _user$project$Pages_Login$MsgFromAuth = function (a) {
	return {ctor: 'MsgFromAuth', _0: a};
};
var _user$project$Pages_Login$update = F2(
	function (msg, model) {
		var _p1 = msg;
		if (_p1.ctor === 'MsgFromAuth') {
			var _p2 = A3(_user$project$Auth$update, _p1._0, _user$project$Pages_Login$MsgFromAuth, model.authState);
			var newAuthState = _p2._0;
			var authCmd = _p2._1;
			var authOutMsg = _p2._2;
			return {
				ctor: '_Tuple3',
				_0: _elm_lang$core$Native_Utils.update(
					model,
					{authState: newAuthState}),
				_1: authCmd,
				_2: authOutMsg
			};
		} else {
			var curAuthState = model.authState;
			var authStateWithGuestCreds = _elm_lang$core$Native_Utils.update(
				curAuthState,
				{username: 'guest', password: 'guestPassword'});
			var sendAuthCmd = A2(_user$project$Auth$sendAuth, _user$project$Pages_Login$MsgFromAuth, authStateWithGuestCreds);
			return {
				ctor: '_Tuple3',
				_0: _elm_lang$core$Native_Utils.update(
					model,
					{authState: authStateWithGuestCreds}),
				_1: sendAuthCmd,
				_2: _user$project$Auth$NoOutMsg
			};
		}
	});
var _user$project$Pages_Login$view = F2(
	function (toUiTxt, model) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('row justify-content-center align-items-center mt-5'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('col-9'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('row'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('col text-center'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$h1,
											{ctor: '[]'},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(
													toUiTxt('ofr_login_title')),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('row justify-content-center mt-5'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('col-8'),
											_1: {ctor: '[]'}
										},
										A2(
											_elm_lang$core$List$append,
											A3(_user$project$Auth$view, _user$project$Pages_Login$MsgFromAuth, model.authState, toUiTxt),
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$div,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('form-group row'),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$div,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('col-lg-8 ml-auto'),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$button,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$type_('submit'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('btn btn-secondary'),
																			_1: {
																				ctor: '::',
																				_0: A3(
																					_elm_lang$html$Html_Events$onWithOptions,
																					'click',
																					{preventDefault: true, stopPropagation: true},
																					_elm_lang$core$Json_Decode$succeed(_user$project$Pages_Login$GuestAccessClicked)),
																				_1: {ctor: '[]'}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(
																			toUiTxt('auth_nolog_bttn')),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											})),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_GenVector$svsTreePopup = F2(
	function (strToElem, svstree) {
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$SmallFont,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: A5(
					_user$project$Helpers_Views_Form$elLabel2,
					'Numéro',
					20,
					_elm_lang$core$Basics$toString(svstree.id),
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing),
				_1: {
					ctor: '::',
					_0: A5(_user$project$Helpers_Views_Form$elLabel2, 'Genre', 20, svstree.latinName, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing),
					_1: {
						ctor: '::',
						_0: A5(_user$project$Helpers_Views_Form$elLabel2, 'Nom', 20, svstree.commonName, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing),
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _user$project$Pages_MapHelper$germanGenStrsDict = _elm_lang$core$Dict$fromList(
	{
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'gen_see',
			_1: _mdgriffith$style_elements$Element$text('Sehen')
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'map_layer_tree',
				_1: _mdgriffith$style_elements$Element$text('Baustelle')
			},
			_1: {ctor: '[]'}
		}
	});
var _user$project$Pages_MapHelper$germanGenStrsToElem = function (str) {
	var _p0 = A2(_elm_lang$core$Dict$get, str, _user$project$Pages_MapHelper$germanGenStrsDict);
	if (_p0.ctor === 'Nothing') {
		return _mdgriffith$style_elements$Element$text(
			A2(_elm_lang$core$Basics_ops['++'], 'Schlüssel nicht gefunden: ', str));
	} else {
		return _p0._0;
	}
};
var _user$project$Pages_MapHelper$germanGenBitsToElem = function (bit) {
	var _p1 = bit;
	if (_p1.ctor === 'Groups') {
		var _p2 = _p1._0;
		if (_p2.ctor === 'GroupBackground') {
			return _mdgriffith$style_elements$Element$text('Basis Layers');
		} else {
			return _mdgriffith$style_elements$Element$empty;
		}
	} else {
		var _p3 = _p1._0;
		switch (_p3.ctor) {
			case 'WmtsTopoGrey':
				return _mdgriffith$style_elements$Element$text('Landeskarte-grau');
			case 'WmtsTopoGreyInfo':
				return A3(
					_mdgriffith$style_elements$Element$paragraph,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element$text('Graue Landeskarte von '),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element$newTab,
								'https://www.swisstopo.admin.ch/de/karten-daten-online/karten-geodaten-online.html',
								A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$Link,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text('Swisstopo'))),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element$text(' bereitgeschtellt'),
								_1: {ctor: '[]'}
							}
						}
					});
			case 'WmtsTopoColor':
				return _mdgriffith$style_elements$Element$text('Landeskarte-farbig');
			case 'WmtsTopoColorInfo':
				return A3(
					_mdgriffith$style_elements$Element$paragraph,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element$text('Farben Landeskarte Karte von '),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element$newTab,
								'https://www.swisstopo.admin.ch/de/karten-daten-online/karten-geodaten-online.html',
								A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$Link,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text('Swisstopo'))),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element$text(' bereitgeschtellt'),
								_1: {ctor: '[]'}
							}
						}
					});
			case 'WmtsAerialColor':
				return _mdgriffith$style_elements$Element$text('Luftbild');
			case 'WmtsAerialColorInfo':
				return A3(
					_mdgriffith$style_elements$Element$paragraph,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element$text('Swissimage Daten von '),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element$newTab,
								'https://www.swisstopo.admin.ch/de/karten-daten-online/karten-geodaten-online.html',
								A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$Link,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text('Swisstopo'))),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element$text(' bereitgeschtellt'),
								_1: {ctor: '[]'}
							}
						}
					});
			case 'GeoZoneRight':
				var _p4 = _p3._0;
				if (_p4 === 'tree_editor') {
					return _mdgriffith$style_elements$Element$text('Bäume Gebiet');
				} else {
					return _mdgriffith$style_elements$Element$text('GeoZoneRight - Name nicht gefunden');
				}
			default:
				return _mdgriffith$style_elements$Element$empty;
		}
	}
};
var _user$project$Pages_MapHelper$frenchGenStrsDict = _elm_lang$core$Dict$fromList(
	{
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'gen_see',
			_1: _mdgriffith$style_elements$Element$text('Voir')
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'map_layer_tree',
				_1: _mdgriffith$style_elements$Element$text('Arbre')
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'map_isolatedTree_isRanked',
					_1: _mdgriffith$style_elements$Element$text('Statut')
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'map_isolatedTree_isRanked_candidate',
						_1: _mdgriffith$style_elements$Element$text('Proposé à l\'inventaire')
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'map_isolatedTree_isRanked_true',
							_1: _mdgriffith$style_elements$Element$text('Retenu, arbre d\'importance cantonale')
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'map_isolatedTree_isRanked_false',
								_1: _mdgriffith$style_elements$Element$text('Non retenu')
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'map_isolatedTree_isRanked_nomore',
									_1: _mdgriffith$style_elements$Element$text('Arbre mort ou disparu')
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'map_isolatedTree_score',
										_1: _mdgriffith$style_elements$Element$text('Score')
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'map_isolatedTree_not_eligible_not_proposed',
											_1: _mdgriffith$style_elements$Element$text('Non éligible, non proposé')
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'map_isolatedTree_not_eligible_proposed',
												_1: _mdgriffith$style_elements$Element$text('Non éligible, proposé')
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'map_isolatedTree_eligible_not_proposed',
													_1: _mdgriffith$style_elements$Element$text('Éligible, non proposé')
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'map_isolatedTree_eligible_proposed',
														_1: _mdgriffith$style_elements$Element$text('Éligible proposé')
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'map_isolatedTree_score_isRanked',
															_1: _mdgriffith$style_elements$Element$text('Classé')
														},
														_1: {
															ctor: '::',
															_0: {
																ctor: '_Tuple2',
																_0: 'map_isolatedTree_circumference',
																_1: _mdgriffith$style_elements$Element$text('Dimension')
															},
															_1: {
																ctor: '::',
																_0: {
																	ctor: '_Tuple2',
																	_0: 'map_isolatedTree_circumference_federal',
																	_1: _mdgriffith$style_elements$Element$text('> Seuil fédéral')
																},
																_1: {
																	ctor: '::',
																	_0: {
																		ctor: '_Tuple2',
																		_0: 'map_isolatedTree_circumference_cantonal',
																		_1: _mdgriffith$style_elements$Element$text('> Seuil cantonal')
																	},
																	_1: {
																		ctor: '::',
																		_0: {
																			ctor: '_Tuple2',
																			_0: 'map_isolatedTree_circumference_start',
																			_1: _mdgriffith$style_elements$Element$text('> Seuil de départ')
																		},
																		_1: {
																			ctor: '::',
																			_0: {
																				ctor: '_Tuple2',
																				_0: 'map_isolatedTree_circumference_doesnt_comply',
																				_1: _mdgriffith$style_elements$Element$text('Pas la Circonférence requise')
																			},
																			_1: {
																				ctor: '::',
																				_0: {
																					ctor: '_Tuple2',
																					_0: 'map_isolatedTree_has_sh_interest',
																					_1: _mdgriffith$style_elements$Element$text('Intérêt Socio-historique')
																				},
																				_1: {
																					ctor: '::',
																					_0: {
																						ctor: '_Tuple2',
																						_0: 'map_isolatedTree_has_sh_interest_true',
																						_1: _mdgriffith$style_elements$Element$text('Intérêt')
																					},
																					_1: {
																						ctor: '::',
																						_0: {
																							ctor: '_Tuple2',
																							_0: 'map_isolatedTree_has_sh_interest_false',
																							_1: _mdgriffith$style_elements$Element$text('Pas d\'intérêt')
																						},
																						_1: {
																							ctor: '::',
																							_0: {
																								ctor: '_Tuple2',
																								_0: 'map_isolatedTree_isConsult',
																								_1: _mdgriffith$style_elements$Element$text('En consultation')
																							},
																							_1: {
																								ctor: '::',
																								_0: {
																									ctor: '_Tuple2',
																									_0: 'map_isolatedTree_isConsult_true',
																									_1: _mdgriffith$style_elements$Element$text('Oui')
																								},
																								_1: {
																									ctor: '::',
																									_0: {
																										ctor: '_Tuple2',
																										_0: 'map_isolatedTree_isConsult_false',
																										_1: _mdgriffith$style_elements$Element$text('Non')
																									},
																									_1: {
																										ctor: '::',
																										_0: {
																											ctor: '_Tuple2',
																											_0: 'tree_editor',
																											_1: _mdgriffith$style_elements$Element$text('Zone de droits d\'édition')
																										},
																										_1: {
																											ctor: '::',
																											_0: {
																												ctor: '_Tuple2',
																												_0: '30-60m',
																												_1: A3(
																													_mdgriffith$style_elements$Element$row,
																													_user$project$Styles$NoStyle,
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element_Attributes$width(
																															_mdgriffith$style_elements$Element_Attributes$px(50)),
																														_1: {
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
																															_1: {ctor: '[]'}
																														}
																													},
																													{
																														ctor: '::',
																														_0: _mdgriffith$style_elements$Element$text('30-60m'),
																														_1: {ctor: '[]'}
																													})
																											},
																											_1: {
																												ctor: '::',
																												_0: {
																													ctor: '_Tuple2',
																													_0: '20-30m',
																													_1: A3(
																														_mdgriffith$style_elements$Element$row,
																														_user$project$Styles$NoStyle,
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element_Attributes$width(
																																_mdgriffith$style_elements$Element_Attributes$px(50)),
																															_1: {
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
																																_1: {ctor: '[]'}
																															}
																														},
																														{
																															ctor: '::',
																															_0: _mdgriffith$style_elements$Element$text('20-30m'),
																															_1: {ctor: '[]'}
																														})
																												},
																												_1: {
																													ctor: '::',
																													_0: {
																														ctor: '_Tuple2',
																														_0: '6-20m',
																														_1: A3(
																															_mdgriffith$style_elements$Element$row,
																															_user$project$Styles$NoStyle,
																															{
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element_Attributes$width(
																																	_mdgriffith$style_elements$Element_Attributes$px(50)),
																																_1: {
																																	ctor: '::',
																																	_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
																																	_1: {ctor: '[]'}
																																}
																															},
																															{
																																ctor: '::',
																																_0: _mdgriffith$style_elements$Element$text('6-20m'),
																																_1: {ctor: '[]'}
																															})
																													},
																													_1: {
																														ctor: '::',
																														_0: {
																															ctor: '_Tuple2',
																															_0: '3-6m',
																															_1: A3(
																																_mdgriffith$style_elements$Element$row,
																																_user$project$Styles$NoStyle,
																																{
																																	ctor: '::',
																																	_0: _mdgriffith$style_elements$Element_Attributes$width(
																																		_mdgriffith$style_elements$Element_Attributes$px(50)),
																																	_1: {
																																		ctor: '::',
																																		_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
																																		_1: {ctor: '[]'}
																																	}
																																},
																																{
																																	ctor: '::',
																																	_0: _mdgriffith$style_elements$Element$text('3-6m'),
																																	_1: {ctor: '[]'}
																																})
																														},
																														_1: {
																															ctor: '::',
																															_0: {
																																ctor: '_Tuple2',
																																_0: '0-3m',
																																_1: A3(
																																	_mdgriffith$style_elements$Element$row,
																																	_user$project$Styles$NoStyle,
																																	{
																																		ctor: '::',
																																		_0: _mdgriffith$style_elements$Element_Attributes$width(
																																			_mdgriffith$style_elements$Element_Attributes$px(50)),
																																		_1: {
																																			ctor: '::',
																																			_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
																																			_1: {ctor: '[]'}
																																		}
																																	},
																																	{
																																		ctor: '::',
																																		_0: _mdgriffith$style_elements$Element$text('0-3m'),
																																		_1: {ctor: '[]'}
																																	})
																															},
																															_1: {
																																ctor: '::',
																																_0: {
																																	ctor: '_Tuple2',
																																	_0: 'Elevée',
																																	_1: _mdgriffith$style_elements$Element$text('Elevée')
																																},
																																_1: {
																																	ctor: '::',
																																	_0: {
																																		ctor: '_Tuple2',
																																		_0: 'Très élevée',
																																		_1: _mdgriffith$style_elements$Element$text('Très élevée')
																																	},
																																	_1: {
																																		ctor: '::',
																																		_0: {
																																			ctor: '_Tuple2',
																																			_0: 'Extrêmement élevée',
																																			_1: _mdgriffith$style_elements$Element$text('Extrêmement élevée')
																																		},
																																		_1: {
																																			ctor: '::',
																																			_0: {
																																				ctor: '_Tuple2',
																																				_0: 'svstrees',
																																				_1: _mdgriffith$style_elements$Element$text('Inventaire SVS')
																																			},
																																			_1: {
																																				ctor: '::',
																																				_0: {
																																					ctor: '_Tuple2',
																																					_0: '5',
																																					_1: _mdgriffith$style_elements$Element$text('5')
																																				},
																																				_1: {
																																					ctor: '::',
																																					_0: {
																																						ctor: '_Tuple2',
																																						_0: '10',
																																						_1: _mdgriffith$style_elements$Element$text('10')
																																					},
																																					_1: {
																																						ctor: '::',
																																						_0: {
																																							ctor: '_Tuple2',
																																							_0: '15',
																																							_1: _mdgriffith$style_elements$Element$text('15')
																																						},
																																						_1: {
																																							ctor: '::',
																																							_0: {
																																								ctor: '_Tuple2',
																																								_0: '20',
																																								_1: _mdgriffith$style_elements$Element$text('20')
																																							},
																																							_1: {
																																								ctor: '::',
																																								_0: {
																																									ctor: '_Tuple2',
																																									_0: '25',
																																									_1: _mdgriffith$style_elements$Element$text('25')
																																								},
																																								_1: {
																																									ctor: '::',
																																									_0: {
																																										ctor: '_Tuple2',
																																										_0: '30',
																																										_1: _mdgriffith$style_elements$Element$text('30')
																																									},
																																									_1: {
																																										ctor: '::',
																																										_0: {
																																											ctor: '_Tuple2',
																																											_0: '35',
																																											_1: _mdgriffith$style_elements$Element$text('35')
																																										},
																																										_1: {
																																											ctor: '::',
																																											_0: {
																																												ctor: '_Tuple2',
																																												_0: '40',
																																												_1: _mdgriffith$style_elements$Element$text('40')
																																											},
																																											_1: {ctor: '[]'}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var _user$project$Pages_MapHelper$frenchGenStrsToElem = function (str) {
	var _p5 = A2(_elm_lang$core$Dict$get, str, _user$project$Pages_MapHelper$frenchGenStrsDict);
	if (_p5.ctor === 'Nothing') {
		return _mdgriffith$style_elements$Element$text(
			A2(_elm_lang$core$Basics_ops['++'], 'Clé non trouvée: ', str));
	} else {
		return _p5._0;
	}
};
var _user$project$Pages_MapHelper$frenchGenBitsToElem = function (bit) {
	var _p6 = bit;
	if (_p6.ctor === 'Groups') {
		var _p7 = _p6._0;
		if (_p7.ctor === 'GroupBackground') {
			return _mdgriffith$style_elements$Element$text('Fonds de plan & éléments généraux');
		} else {
			return _mdgriffith$style_elements$Element$empty;
		}
	} else {
		var _p8 = _p6._0;
		switch (_p8.ctor) {
			case 'WmtsTopoGrey':
				return _mdgriffith$style_elements$Element$text('Topographie noir-blanc');
			case 'WmtsTopoGreyInfo':
				return A3(
					_mdgriffith$style_elements$Element$paragraph,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element$text('Carte topographique noir-blanc fournie par '),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element$newTab,
								'https://www.swisstopo.admin.ch/fr/cartes-donnees-en-ligne/cartes-geodonnees-en-ligne.html',
								A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$Link,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text('Swisstopo'))),
							_1: {ctor: '[]'}
						}
					});
			case 'WmtsTopoColor':
				return _mdgriffith$style_elements$Element$text('Topographie couleur');
			case 'WmtsTopoColorInfo':
				return A3(
					_mdgriffith$style_elements$Element$paragraph,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element$text('Carte topographique couleur fournie par '),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element$newTab,
								'https://www.swisstopo.admin.ch/fr/cartes-donnees-en-ligne/cartes-geodonnees-en-ligne.html',
								A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$Link,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text('Swisstopo'))),
							_1: {ctor: '[]'}
						}
					});
			case 'WmtsAerialColor':
				return _mdgriffith$style_elements$Element$text('Vue aérienne');
			case 'WmtsAerialColorInfo':
				return A3(
					_mdgriffith$style_elements$Element$paragraph,
					_user$project$Styles$NoStyle,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element$text('Données Swissimage fournies par '),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$style_elements$Element$newTab,
								'https://www.swisstopo.admin.ch/fr/cartes-donnees-en-ligne/cartes-geodonnees-en-ligne.html',
								A3(
									_mdgriffith$style_elements$Element$el,
									_user$project$Styles$Link,
									{ctor: '[]'},
									_mdgriffith$style_elements$Element$text('Swisstopo'))),
							_1: {ctor: '[]'}
						}
					});
			case 'GeoZoneRight':
				var _p9 = _p8._0;
				if (_p9 === 'tree_editor') {
					return _mdgriffith$style_elements$Element$text('Droits d\'édition');
				} else {
					return _mdgriffith$style_elements$Element$text('Zone de droits d\'édition de l\'utilisateur connecté');
				}
			default:
				return _mdgriffith$style_elements$Element$empty;
		}
	}
};
var _user$project$Pages_MapHelper$viewGenPopupInfo = F4(
	function (strToElem, decoder, toElement, fdata) {
		var mayPopData = _elm_lang$core$Result$toMaybe(
			A2(
				_elm_lang$core$Result$mapError,
				function (err) {
					return A2(
						_elm_lang$core$Debug$log,
						_elm_lang$core$Basics$toString(err),
						err);
				},
				A2(_elm_lang$core$Json_Decode$decodeValue, decoder, fdata.data)));
		var _p10 = mayPopData;
		if (_p10.ctor === 'Nothing') {
			return _mdgriffith$style_elements$Element$text(
				A2(
					_elm_lang$core$Basics_ops['++'],
					'Could not decode ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						fdata.layerKey,
						A2(
							_elm_lang$core$Basics_ops['++'],
							' value: ',
							_elm_lang$core$Basics$toString(fdata.data)))));
		} else {
			return A3(
				_mdgriffith$style_elements$Element$column,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
							_1: {ctor: '[]'}
						}
					}
				},
				{
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$PopupHeader,
						{ctor: '[]'},
						strToElem(fdata.layerKey)),
					_1: {
						ctor: '::',
						_0: toElement(_p10._0),
						_1: {ctor: '[]'}
					}
				});
		}
	});
var _user$project$Pages_MapHelper$viewGenPopupInfos = F3(
	function (lang, session, posInfo) {
		var strToElem = function () {
			var _p11 = lang;
			if (_p11.ctor === 'DE') {
				return _user$project$Pages_MapHelper$germanGenStrsToElem;
			} else {
				return _user$project$Pages_MapHelper$frenchGenStrsToElem;
			}
		}();
		var fdataToEl = function (fdata) {
			var _p12 = A2(_elm_lang$core$Debug$log, 'key', fdata.layerKey);
			if (_p12 === 'svstrees') {
				return _elm_lang$core$Maybe$Just(
					A4(
						_user$project$Pages_MapHelper$viewGenPopupInfo,
						strToElem,
						_user$project$Data_GenVector$svsTreeDecoder,
						_user$project$Views_GenVector$svsTreePopup(strToElem),
						fdata));
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		return A2(_elm_lang$core$List$filterMap, fdataToEl, posInfo.featuresData);
	});
var _user$project$Pages_MapHelper$mapSettings = _user$project$Map$settingsFromCoreParams(
	{
		projection: {code: 'EPSG:2056', proj4String: '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs'},
		extent: {minx: 2420000, miny: 130000, maxx: 2900000, maxy: 1350000},
		center: {x: 2540000, y: 1180000},
		zoom: 10,
		geolocAndBlink: {ctor: '_Tuple3', _0: false, _1: 20, _2: false}
	});
var _user$project$Pages_MapHelper$onPageEnter = F3(
	function (toMsg, session, mapModel) {
		var _p13 = A3(
			_user$project$Map$restore,
			toMsg,
			_user$project$Helpers_Data_Session$headers(session),
			mapModel.mapState);
		var newMapState = _p13._0;
		var mapCmd = _p13._1;
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				mapModel,
				{mapState: newMapState}),
			_1: mapCmd
		};
	});
var _user$project$Pages_MapHelper$CadasterPopup = function (a) {
	return {ctor: 'CadasterPopup', _0: a};
};
var _user$project$Pages_MapHelper$Layers = function (a) {
	return {ctor: 'Layers', _0: a};
};
var _user$project$Pages_MapHelper$Groups = function (a) {
	return {ctor: 'Groups', _0: a};
};
var _user$project$Pages_MapHelper$GroupBackgroundInfo = {ctor: 'GroupBackgroundInfo'};
var _user$project$Pages_MapHelper$GroupBackground = {ctor: 'GroupBackground'};
var _user$project$Pages_MapHelper$GeoZoneRightInfo = {ctor: 'GeoZoneRightInfo'};
var _user$project$Pages_MapHelper$GeoZoneRight = function (a) {
	return {ctor: 'GeoZoneRight', _0: a};
};
var _user$project$Pages_MapHelper$geoZonelocalVector = F2(
	function (toUibit, _p14) {
		var _p15 = _p14;
		var _p16 = _p15.name;
		return _user$project$Map$vectorLayerFromAllParams(
			{
				key: _p16,
				name: toUibit(
					_user$project$Pages_MapHelper$Layers(
						_user$project$Pages_MapHelper$GeoZoneRight(_p16))),
				info: toUibit(
					_user$project$Pages_MapHelper$Layers(_user$project$Pages_MapHelper$GeoZoneRightInfo)),
				isVisible: false,
				opacity: 0.5,
				isInfoExpanded: false,
				loadMethod: _user$project$Map$vectorLocalLoadMethod(
					_elm_lang$core$Json_Encode$list(
						{
							ctor: '::',
							_0: _elm_lang$core$Json_Encode$object(
								{
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'id',
										_1: _elm_lang$core$Json_Encode$string(_p16)
									},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'geometry', _1: _p15.geoZone},
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						})),
				format: _user$project$Map$geoJsonFormat,
				clusterOptions: _user$project$Map$vectorNoCluster,
				minResolution: _elm_lang$core$Maybe$Nothing,
				maxResolution: _elm_lang$core$Maybe$Nothing,
				select: false,
				style: _user$project$Map$vectorUniqueStyle(
					A2(_elm_lang$core$Basics_ops['++'], _p16, 'Style')),
				urlRequest: _elm_lang$core$Maybe$Nothing
			});
	});
var _user$project$Pages_MapHelper$WmtsAerialColorInfo = {ctor: 'WmtsAerialColorInfo'};
var _user$project$Pages_MapHelper$WmtsAerialColor = {ctor: 'WmtsAerialColor'};
var _user$project$Pages_MapHelper$wmtsBackgroundAerial = F2(
	function (toUibit, isVisible) {
		return _user$project$Map$wmtsLayerFromParams(
			{
				key: 'aerial_bckgd',
				name: toUibit(
					_user$project$Pages_MapHelper$Layers(_user$project$Pages_MapHelper$WmtsAerialColor)),
				info: toUibit(
					_user$project$Pages_MapHelper$Layers(_user$project$Pages_MapHelper$WmtsAerialColorInfo)),
				isVisible: isVisible,
				opacity: 1,
				url: 'https://wmts{5-9}.geo.admin.ch/1.0.0/{Layer}/default/current/21781/{TileMatrix}/{TileRow}/{TileCol}.jpeg',
				layerName: 'ch.swisstopo.swissimage',
				urlRequest: _elm_lang$core$Maybe$Nothing
			});
	});
var _user$project$Pages_MapHelper$WmtsTopoColorInfo = {ctor: 'WmtsTopoColorInfo'};
var _user$project$Pages_MapHelper$WmtsTopoColor = {ctor: 'WmtsTopoColor'};
var _user$project$Pages_MapHelper$wmtsBackgroundColor = F2(
	function (toUibit, isVisible) {
		return _user$project$Map$wmtsLayerFromParams(
			{
				key: 'color_bckgd',
				name: toUibit(
					_user$project$Pages_MapHelper$Layers(_user$project$Pages_MapHelper$WmtsTopoColor)),
				info: toUibit(
					_user$project$Pages_MapHelper$Layers(_user$project$Pages_MapHelper$WmtsTopoColorInfo)),
				isVisible: isVisible,
				opacity: 0.3,
				url: 'https://wmts{5-9}.geo.admin.ch/1.0.0/{Layer}/default/current/21781/{TileMatrix}/{TileRow}/{TileCol}.jpeg',
				layerName: 'ch.swisstopo.pixelkarte-farbe',
				urlRequest: _elm_lang$core$Maybe$Nothing
			});
	});
var _user$project$Pages_MapHelper$WmtsTopoGreyInfo = {ctor: 'WmtsTopoGreyInfo'};
var _user$project$Pages_MapHelper$WmtsTopoGrey = {ctor: 'WmtsTopoGrey'};
var _user$project$Pages_MapHelper$wmtsBackgroundGrey = F2(
	function (toUibit, isVisible) {
		return _user$project$Map$wmtsLayerFromParams(
			{
				key: 'grey_bckgd',
				name: toUibit(
					_user$project$Pages_MapHelper$Layers(_user$project$Pages_MapHelper$WmtsTopoGrey)),
				info: toUibit(
					_user$project$Pages_MapHelper$Layers(_user$project$Pages_MapHelper$WmtsTopoGreyInfo)),
				isVisible: isVisible,
				opacity: 0.3,
				url: 'https://wmts{5-9}.geo.admin.ch/1.0.0/{Layer}/default/current/21781/{TileMatrix}/{TileRow}/{TileCol}.jpeg',
				layerName: 'ch.swisstopo.pixelkarte-grau',
				urlRequest: _elm_lang$core$Maybe$Nothing
			});
	});
var _user$project$Pages_MapHelper$backgroundGroup = F4(
	function (toUibit, session, defaultBackground, namedGeoZones) {
		var isAerialVisible = function () {
			var _p17 = defaultBackground;
			if (_p17 === 'wmtsBackgroundAerial') {
				return true;
			} else {
				return false;
			}
		}();
		var isColorVisible = function () {
			var _p18 = defaultBackground;
			if (_p18 === 'wmtsBackgroundColor') {
				return true;
			} else {
				return false;
			}
		}();
		var isGreyVisible = function () {
			var _p19 = defaultBackground;
			if (_p19 === 'wmtsBackgroundGrey') {
				return true;
			} else {
				return false;
			}
		}();
		var baseLayers = {
			ctor: '::',
			_0: A2(_user$project$Pages_MapHelper$wmtsBackgroundAerial, toUibit, isAerialVisible),
			_1: {
				ctor: '::',
				_0: A2(_user$project$Pages_MapHelper$wmtsBackgroundGrey, toUibit, isGreyVisible),
				_1: {
					ctor: '::',
					_0: A2(_user$project$Pages_MapHelper$wmtsBackgroundColor, toUibit, isColorVisible),
					_1: {ctor: '[]'}
				}
			}
		};
		var allLayers = A2(
			_elm_lang$core$Basics_ops['++'],
			A2(
				_elm_lang$core$List$map,
				_user$project$Pages_MapHelper$geoZonelocalVector(toUibit),
				namedGeoZones),
			baseLayers);
		return _user$project$Map$layerGroupFromParams(
			{
				key: 'bckgd_group',
				name: toUibit(
					_user$project$Pages_MapHelper$Groups(_user$project$Pages_MapHelper$GroupBackground)),
				info: toUibit(
					_user$project$Pages_MapHelper$Groups(_user$project$Pages_MapHelper$GroupBackgroundInfo)),
				isVisible: true,
				opacity: 1,
				isExpanded: false,
				reverseLayerListDisp: true,
				layers: allLayers
			});
	});
var _user$project$Pages_MapHelper$genLayers = F4(
	function (toUibit, session, defaultBackground, namedGeoZones) {
		return {
			ctor: '::',
			_0: A4(_user$project$Pages_MapHelper$backgroundGroup, toUibit, session, defaultBackground, namedGeoZones),
			_1: {ctor: '[]'}
		};
	});

var _user$project$Requests_SortFilter$getAgeFilter = F3(
	function (mayMinAge, mayMaxAge, currentYear) {
		var _p0 = mayMinAge;
		if (_p0.ctor === 'Nothing') {
			var _p1 = mayMaxAge;
			if (_p1.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p2 = _p1._0;
				return (_elm_lang$core$Native_Utils.cmp(_p2, 100) > -1) ? _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'$or[0][year_of_planting][$gte]=',
							_elm_lang$core$Basics$toString(currentYear - _p2)),
						_1: {
							ctor: '::',
							_0: '$or[1][is_more_than_100_years]=true',
							_1: {ctor: '[]'}
						}
					}) : _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'year_of_planting[$gte]=',
							_elm_lang$core$Basics$toString(currentYear - _p2)),
						_1: {ctor: '[]'}
					});
			}
		} else {
			var _p5 = _p0._0;
			var _p3 = mayMaxAge;
			if (_p3.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'$or[0][year_of_planting][$lt]=',
							_elm_lang$core$Basics$toString(currentYear - _p5)),
						_1: {
							ctor: '::',
							_0: '$or[1][is_more_than_100_years]=true',
							_1: {ctor: '[]'}
						}
					});
			} else {
				var _p4 = _p3._0;
				return (_elm_lang$core$Native_Utils.cmp(_p4, 100) > -1) ? _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'$or[0][ $and[0][year_of_planting][$lt]=',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(currentYear - _p5),
								A2(
									_elm_lang$core$Basics_ops['++'],
									'&$and[1][year_of_planting][$gte]=',
									_elm_lang$core$Basics$toString(currentYear - _p4)))),
						_1: {
							ctor: '::',
							_0: '$or[1][is_more_than_100_years]=true',
							_1: {ctor: '[]'}
						}
					}) : _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'year_of_planting[$lt]=',
							_elm_lang$core$Basics$toString(currentYear - _p5)),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								'year_of_planting[$gte]=',
								_elm_lang$core$Basics$toString(currentYear - _p4)),
							_1: {ctor: '[]'}
						}
					});
			}
		}
	});
var _user$project$Requests_SortFilter$getVarietyFilter = function (maySelVariety) {
	return A2(
		_elm_lang$core$Maybe$map,
		function (selVariety) {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Basics_ops['++'],
					'variety_id=',
					_elm_lang$core$Basics$toString(selVariety.id)),
				_1: {ctor: '[]'}
			};
		},
		maySelVariety);
};
var _user$project$Requests_SortFilter$getScoreFilter = F2(
	function (mayMinScore, mayMaxScore) {
		var _p6 = mayMinScore;
		if (_p6.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p8 = _p6._0;
			var _p7 = mayMaxScore;
			if (_p7.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'total_score[$gte]=',
							_elm_lang$core$Basics$toString(_p8)),
						_1: {ctor: '[]'}
					});
			} else {
				return _elm_lang$core$Maybe$Just(
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							'total_score[$gte]=',
							_elm_lang$core$Basics$toString(_p8)),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								'total_score[$lte]=',
								_elm_lang$core$Basics$toString(_p7._0)),
							_1: {ctor: '[]'}
						}
					});
			}
		}
	});
var _user$project$Requests_SortFilter$getCandidacyFilter = function (selCandidacy) {
	var _p9 = selCandidacy;
	switch (_p9.ctor) {
		case 'CandidateAll':
			return _elm_lang$core$Maybe$Nothing;
		case 'CandidateYes':
			return _elm_lang$core$Maybe$Just(
				{
					ctor: '::',
					_0: 'is_candidate=true',
					_1: {ctor: '[]'}
				});
		default:
			return _elm_lang$core$Maybe$Just(
				{
					ctor: '::',
					_0: 'is_candidate=false',
					_1: {ctor: '[]'}
				});
	}
};
var _user$project$Requests_SortFilter$getCandidacyAndScoreFilter = F3(
	function (selCandidacy, mayMinScore, mayMaxScore) {
		var _p10 = selCandidacy;
		if (_p10.ctor === 'CandidateAll') {
			return A2(_user$project$Requests_SortFilter$getScoreFilter, mayMinScore, mayMaxScore);
		} else {
			var scoreItem = function () {
				var _p11 = mayMinScore;
				if (_p11.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					var _p13 = _p11._0;
					var _p12 = mayMaxScore;
					if (_p12.ctor === 'Nothing') {
						return {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								'$or[1][total_score][$gte]=',
								_elm_lang$core$Basics$toString(_p13)),
							_1: {ctor: '[]'}
						};
					} else {
						return {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								'$or[1][total_score][$gte]=',
								_elm_lang$core$Basics$toString(_p13)),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$core$Basics_ops['++'],
									'$or[1][total_score][$lte]=',
									_elm_lang$core$Basics$toString(_p12._0)),
								_1: {ctor: '[]'}
							}
						};
					}
				}
			}();
			var candidacyItem = function () {
				var _p14 = selCandidacy;
				switch (_p14.ctor) {
					case 'CandidateYes':
						return {
							ctor: '::',
							_0: '$or[0][is_candidate]=true',
							_1: {ctor: '[]'}
						};
					case 'CandidateNo':
						return {
							ctor: '::',
							_0: '$or[0][is_candidate]=False',
							_1: {ctor: '[]'}
						};
					default:
						return {ctor: '[]'};
				}
			}();
			return _elm_lang$core$Maybe$Just(
				A2(_elm_lang$core$List$append, candidacyItem, scoreItem));
		}
	});
var _user$project$Requests_SortFilter$getPlaceFilter = function (maySelPlace) {
	return A2(
		_elm_lang$core$Maybe$map,
		function (selPlace) {
			return {
				ctor: '::',
				_0: A2(_elm_lang$core$Basics_ops['++'], 'commune=', selPlace.name),
				_1: {ctor: '[]'}
			};
		},
		maySelPlace);
};
var _user$project$Requests_SortFilter$buildQueryFilters = F9(
	function (mayPlace, candidacy, andOrScore, mayMinScore, mayMaxScore, mayVariety, mayMinAge, mayMaxAge, currentYear) {
		return A2(
			_elm_lang$core$String$join,
			'&',
			A2(
				_elm_lang$core$List$filter,
				function (item) {
					return !_elm_lang$core$Native_Utils.eq(item, '');
				},
				A2(
					_elm_lang$core$List$map,
					function (item) {
						return A2(_elm_lang$core$String$join, '&', item);
					},
					A2(
						_elm_lang$core$List$map,
						function (mayItem) {
							return A2(
								_elm_lang$core$Maybe$withDefault,
								{ctor: '[]'},
								mayItem);
						},
						{
							ctor: '::',
							_0: _user$project$Requests_SortFilter$getPlaceFilter(mayPlace),
							_1: {
								ctor: '::',
								_0: _user$project$Requests_SortFilter$getVarietyFilter(mayVariety),
								_1: {
									ctor: '::',
									_0: andOrScore ? _user$project$Requests_SortFilter$getCandidacyFilter(candidacy) : A3(_user$project$Requests_SortFilter$getCandidacyAndScoreFilter, candidacy, mayMinScore, mayMaxScore),
									_1: {
										ctor: '::',
										_0: andOrScore ? A2(_user$project$Requests_SortFilter$getScoreFilter, mayMinScore, mayMaxScore) : _elm_lang$core$Maybe$Nothing,
										_1: {
											ctor: '::',
											_0: A3(_user$project$Requests_SortFilter$getAgeFilter, mayMinAge, mayMaxAge, currentYear),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}))));
	});
var _user$project$Requests_SortFilter$boolToString = function (bool) {
	return _elm_lang$core$String$toLower(
		_elm_lang$core$Basics$toString(bool));
};
var _user$project$Requests_SortFilter$exportSelection = F3(
	function (baseUrl, mayToken, params) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: A2(
					_elm_lang$core$Basics_ops['++'],
					baseUrl,
					A2(_elm_lang$core$Basics_ops['++'], 'export-to-pdf?', params)),
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectString,
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});
var _user$project$Requests_SortFilter$getAllWithFilters = F3(
	function (baseUrl, mayToken, filters) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: A2(
					_elm_lang$core$Basics_ops['++'],
					baseUrl,
					A2(_elm_lang$core$Basics_ops['++'], 'isolatedtree?$eager=[variety,documents]&$modify={\"formatGeom\":[\"GeoJSON\",2]}&', filters)),
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(
					_elm_lang$core$Json_Decode$list(_user$project$Data_Tree$decoder)),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});
var _user$project$Requests_SortFilter$getAll = F2(
	function (baseUrl, mayToken) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: A2(
					_user$project$Helpers_Data_JwtToken$addAuthHeader,
					{ctor: '[]'},
					mayToken),
				url: A2(_elm_lang$core$Basics_ops['++'], baseUrl, 'isolatedtree?$eager=[variety,documents]&$modify={\"formatGeom\":[\"GeoJSON\",2]}'),
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(
					_elm_lang$core$Json_Decode$list(_user$project$Data_Tree$decoder)),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: true
			});
	});
var _user$project$Requests_SortFilter$GotText = function (a) {
	return {ctor: 'GotText', _0: a};
};

var _user$project$Views_SortFilter$scoreColumnView = F2(
	function (txt, width) {
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: width},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'word-break', _1: 'break-word'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'padding', _1: '8px'},
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					_elm_lang$core$Basics$toString(txt)),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_SortFilter$scoreColumn = function () {
	var toValue = function (_p0) {
		return function (_) {
			return _.totalScore;
		}(
			function (_) {
				return _.isolatedTree;
			}(_p0));
	};
	return _evancz$elm_sortable_table$Table$veryCustomColumn(
		{
			name: 'Score',
			viewData: function (data) {
				return A2(
					_user$project$Views_SortFilter$scoreColumnView,
					toValue(data),
					'6%');
			},
			sorter: _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy(toValue)
		});
}();
var _user$project$Views_SortFilter$placeColumnView = F2(
	function (txt, width) {
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: width},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'word-break', _1: 'break-word'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'padding', _1: '8px'},
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(txt),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_SortFilter$placeColumn = function () {
	var toValue = function (_p1) {
		return function (_) {
			return _.commune;
		}(
			function (_) {
				return _.isolatedTree;
			}(_p1));
	};
	return _evancz$elm_sortable_table$Table$veryCustomColumn(
		{
			name: 'Commune',
			viewData: function (data) {
				return A2(
					_user$project$Views_SortFilter$placeColumnView,
					toValue(data),
					'30%');
			},
			sorter: _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy(toValue)
		});
}();
var _user$project$Views_SortFilter$varietyColumnView = F2(
	function (txt, width) {
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: width},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'word-break', _1: 'break-word'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'padding', _1: '8px'},
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(txt),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_SortFilter$varietyColumn = function () {
	var toValue = function (_p2) {
		return function (_) {
			return _.latinName;
		}(
			function (_) {
				return _.variety;
			}(
				function (_) {
					return _.isolatedTree;
				}(_p2)));
	};
	return _evancz$elm_sortable_table$Table$veryCustomColumn(
		{
			name: 'Essence',
			viewData: function (data) {
				return A2(
					_user$project$Views_SortFilter$varietyColumnView,
					toValue(data),
					'40%');
			},
			sorter: _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy(toValue)
		});
}();
var _user$project$Views_SortFilter$idColumnView = F2(
	function (txt, width) {
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: width},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'word-break', _1: 'break-word'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'padding', _1: '8px'},
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					_elm_lang$core$Basics$toString(txt)),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_SortFilter$idColumn = function () {
	var toValue = function (_p3) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			0,
			function (_) {
				return _.id;
			}(
				function (_) {
					return _.isolatedTree;
				}(_p3)));
	};
	return _evancz$elm_sortable_table$Table$veryCustomColumn(
		{
			name: 'Id',
			viewData: function (data) {
				return A2(
					_user$project$Views_SortFilter$idColumnView,
					toValue(data),
					'12%');
			},
			sorter: _evancz$elm_sortable_table$Table$decreasingOrIncreasingBy(toValue)
		});
}();
var _user$project$Views_SortFilter$columnView = F2(
	function (txt, width) {
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: width},
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(txt),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_SortFilter$toStringWithFloor = function (val) {
	return _elm_lang$core$Basics$toString(
		_elm_lang$core$Basics$floor(val));
};
var _user$project$Views_SortFilter$toMayStringDate = function (mayDate) {
	var toMonthNum = function (month) {
		var _p4 = month;
		switch (_p4.ctor) {
			case 'Jan':
				return '01';
			case 'Feb':
				return '02';
			case 'Mar':
				return '03';
			case 'Apr':
				return '04';
			case 'May':
				return '05';
			case 'Jun':
				return '06';
			case 'Jul':
				return '07';
			case 'Aug':
				return '08';
			case 'Sep':
				return '09';
			case 'Oct':
				return '10';
			case 'Nov':
				return '11';
			default:
				return '12';
		}
	};
	var toDayDoubleDigit = function (day) {
		var strDay = _elm_lang$core$Basics$toString(day);
		return _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$String$length(strDay),
			1) ? A2(_elm_lang$core$Basics_ops['++'], '0', strDay) : strDay;
	};
	var _p5 = mayDate;
	if (_p5.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		var _p6 = _p5._0;
		return _elm_lang$core$Maybe$Just(
			_elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: A2(
						_elm_lang$core$Basics_ops['++'],
						toDayDoubleDigit(
							_elm_lang$core$Date$day(_p6)),
						'.'),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							toMonthNum(
								_elm_lang$core$Date$month(_p6)),
							'.'),
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Basics$toString(
								_elm_lang$core$Date$year(_p6)),
							_1: {ctor: '[]'}
						}
					}
				}));
	}
};
var _user$project$Views_SortFilter$toMayString = function (mayVal) {
	var _p7 = mayVal;
	if (_p7.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			_elm_lang$core$Basics$toString(_p7._0));
	}
};
var _user$project$Views_SortFilter$nothingString = '';
var _user$project$Views_SortFilter$taskNamesOptions = {
	ctor: '::',
	_0: 'data_management_type_extensivemeadow',
	_1: {
		ctor: '::',
		_0: 'data_management_type_lowyieldmeadow',
		_1: {
			ctor: '::',
			_0: 'data_management_type_extensivepasture',
			_1: {
				ctor: '::',
				_0: 'data_management_type_woodedpasture',
				_1: {
					ctor: '::',
					_0: 'data_management_type_litterarea',
					_1: {
						ctor: '::',
						_0: 'data_management_type_hedge',
						_1: {
							ctor: '::',
							_0: 'data_management_type_rivermeadow',
							_1: {
								ctor: '::',
								_0: 'data_management_type_floralfallow',
								_1: {
									ctor: '::',
									_0: 'data_management_type_rotatingfallow',
									_1: {
										ctor: '::',
										_0: 'data_management_type_extensivestripe',
										_1: {
											ctor: '::',
											_0: 'data_management_type_hemming',
											_1: {
												ctor: '::',
												_0: 'data_management_type_highrodfruittree',
												_1: {
													ctor: '::',
													_0: 'data_management_type_walnuttree',
													_1: {
														ctor: '::',
														_0: 'data_management_type_isolatedtree',
														_1: {
															ctor: '::',
															_0: 'data_management_type_vineyard',
															_1: {
																ctor: '::',
																_0: 'data_management_type_grassland',
																_1: {
																	ctor: '::',
																	_0: 'data_management_type_biodiversity',
																	_1: {
																		ctor: '::',
																		_0: 'data_management_type_permanentwater',
																		_1: {
																			ctor: '::',
																			_0: 'data_management_type_lowland',
																			_1: {
																				ctor: '::',
																				_0: 'data_management_type_aquaticvegetation',
																				_1: {
																					ctor: '::',
																					_0: 'data_management_type_rockpile',
																					_1: {
																						ctor: '::',
																						_0: 'data_management_type_ruderalarea',
																						_1: {
																							ctor: '::',
																							_0: 'data_management_type_stonewall',
																							_1: {
																								ctor: '::',
																								_0: 'data_management_type_variousforests',
																								_1: {
																									ctor: '::',
																									_0: 'data_management_type_gardenedforest',
																									_1: {
																										ctor: '::',
																										_0: 'data_management_type_bushland',
																										_1: {
																											ctor: '::',
																											_0: 'data_management_type_edge',
																											_1: {
																												ctor: '::',
																												_0: 'data_management_type_bushes',
																												_1: {
																													ctor: '::',
																													_0: 'data_management_type_fence',
																													_1: {
																														ctor: '::',
																														_0: 'data_management_type_summeringpasture',
																														_1: {
																															ctor: '::',
																															_0: 'data_management_type_specialdescription',
																															_1: {
																																ctor: '::',
																																_0: 'data_management_type_meadowintensive',
																																_1: {
																																	ctor: '::',
																																	_0: 'data_management_type_meadowextensive',
																																	_1: {
																																		ctor: '::',
																																		_0: 'data_management_type_restareas',
																																		_1: {
																																			ctor: '::',
																																			_0: 'data_management_type_woodyvegetation',
																																			_1: {
																																				ctor: '::',
																																				_0: 'data_management_type_centraldivider',
																																				_1: {
																																					ctor: '::',
																																					_0: 'data_management_type_replacementandcrossing',
																																					_1: {
																																						ctor: '::',
																																						_0: 'data_management_type_specialplantings',
																																						_1: {
																																							ctor: '::',
																																							_0: 'data_management_type_other',
																																							_1: {ctor: '[]'}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _user$project$Views_SortFilter$enumDefaultOption = 'data_default_enum';
var _user$project$Views_SortFilter$toRowAttrs = function (selIsolatedTree) {
	var backgroundColor = selIsolatedTree.isSelected ? '#CEFAF8' : 'lightgray';
	return {
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$style(
			{
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'backgroundColor', _1: backgroundColor},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'border-top', _1: '1px white solid'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'border-bottom', _1: '1px white solid'},
						_1: {ctor: '[]'}
					}
				}
			}),
		_1: {ctor: '[]'}
	};
};
var _user$project$Views_SortFilter$toTbodyAttrs = {ctor: '[]'};
var _user$project$Views_SortFilter$createThead = function (_p8) {
	var _p9 = _p8;
	var _p13 = _p9._2;
	var _p12 = _p9._0;
	var itemstyle = function () {
		var _p10 = _p12;
		switch (_p10) {
			case 'Id':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '12%'},
					_1: {ctor: '[]'}
				};
			case 'Essence':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '40%'},
					_1: {ctor: '[]'}
				};
			case 'Commune':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '30%'},
					_1: {ctor: '[]'}
				};
			case 'Score':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '12%'},
					_1: {ctor: '[]'}
				};
			default:
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'width', _1: '6%'},
					_1: {ctor: '[]'}
				};
		}
	}();
	var path = './images/';
	var content = function () {
		var _p11 = _p9._1;
		switch (_p11.ctor) {
			case 'Unsortable':
				return {
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p12),
					_1: {ctor: '[]'}
				};
			case 'Sortable':
				return {
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p12),
					_1: {
						ctor: '::',
						_0: _p11._0 ? A2(
							_elm_lang$html$Html$img,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$src(
									A2(_elm_lang$core$Basics_ops['++'], path, 'sortDownW.svg')),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$width(14),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: _p13,
											_1: {ctor: '[]'}
										}
									}
								}
							},
							{ctor: '[]'}) : A2(
							_elm_lang$html$Html$img,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$src(
									A2(_elm_lang$core$Basics_ops['++'], path, 'sortDownG.svg')),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$width(14),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											{
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: _p13,
											_1: {ctor: '[]'}
										}
									}
								}
							},
							{ctor: '[]'}),
						_1: {ctor: '[]'}
					}
				};
			default:
				if (_p11._0.ctor === 'Nothing') {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p12),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$img,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$src(
										A2(_elm_lang$core$Basics_ops['++'], path, 'sortBothG.svg')),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$width(14),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _p13,
												_1: {ctor: '[]'}
											}
										}
									}
								},
								{ctor: '[]'}),
							_1: {ctor: '[]'}
						}
					};
				} else {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p12),
						_1: {
							ctor: '::',
							_0: _p11._0._0 ? A2(
								_elm_lang$html$Html$img,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$src(
										A2(_elm_lang$core$Basics_ops['++'], path, 'sortUpW.svg')),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$width(14),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _p13,
												_1: {ctor: '[]'}
											}
										}
									}
								},
								{ctor: '[]'}) : A2(
								_elm_lang$html$Html$img,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$src(
										A2(_elm_lang$core$Basics_ops['++'], path, 'sortDownW.svg')),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$width(14),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$style(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'margin-left', _1: '3px'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'margin-bottom', _1: '2px'},
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _p13,
												_1: {ctor: '[]'}
											}
										}
									}
								},
								{ctor: '[]'}),
							_1: {ctor: '[]'}
						}
					};
				}
		}
	}();
	return A2(
		_elm_lang$html$Html$th,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(itemstyle),
			_1: {ctor: '[]'}
		},
		content);
};
var _user$project$Views_SortFilter$toThead = function (headers) {
	return A2(
		_evancz$elm_sortable_table$Table$HtmlDetails,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'backgroundColor', _1: 'grey'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'color', _1: 'white'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'border-top', _1: '2px white solid'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'border-bottom', _1: '2px white solid'},
								_1: {ctor: '[]'}
							}
						}
					}
				}),
			_1: {ctor: '[]'}
		},
		A2(_elm_lang$core$List$map, _user$project$Views_SortFilter$createThead, headers));
};
var _user$project$Views_SortFilter$toTableAttrs = {
	ctor: '::',
	_0: _elm_lang$html$Html_Attributes$style(
		{
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'margin', _1: '0%'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'width', _1: '100%'},
				_1: {ctor: '[]'}
			}
		}),
	_1: {ctor: '[]'}
};
var _user$project$Views_SortFilter$treePropertiesEncode = F2(
	function (toUiTxt, isolatedTree) {
		var eclogicalInterest = _elm_lang$core$Tuple$second(
			A2(
				_elm_lang$core$Maybe$withDefault,
				{ctor: '_Tuple2', _0: 0, _1: ''},
				A2(
					_elm_lang$core$Maybe$map,
					_user$project$Data_Tree$getEcologicalInterest,
					_elm_lang$core$Maybe$Just(isolatedTree.variety))));
		return _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'Identifiant',
					_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$int, isolatedTree.id)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'Commune',
						_1: _elm_lang$core$Json_Encode$string(isolatedTree.commune)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'No de parcelle',
							_1: _elm_lang$core$Json_Encode$string(isolatedTree.plotNb)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'Date de relevé',
								_1: _elm_lang$core$Json_Encode$string(
									_justinmimbs$elm_date_extra$Date_Extra$toIsoString(isolatedTree.collectionDate))
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'Appelation locale',
									_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.name)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'Essence (nom latin)',
										_1: _elm_lang$core$Json_Encode$string(isolatedTree.variety.latinName)
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'Essence (nom commun)',
											_1: _elm_lang$core$Json_Encode$string(isolatedTree.variety.commonName)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'Détermination à valider',
												_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isVarietyCertain)
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'Circonférence [cm]',
													_1: _elm_lang$core$Json_Encode$float(isolatedTree.circumference)
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'Tronc multiple',
														_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isMultiTrunk)
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'Couronne',
															_1: _elm_lang$core$Json_Encode$string(
																toUiTxt(isolatedTree.crownDevelopment))
														},
														_1: {
															ctor: '::',
															_0: {
																ctor: '_Tuple2',
																_0: 'Fait partie d\'un ensemble',
																_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isPartOfAGroup)
															},
															_1: {
																ctor: '::',
																_0: {
																	ctor: '_Tuple2',
																	_0: 'Plus de 100 ans',
																	_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$bool, isolatedTree.isMoreThan100Years)
																},
																_1: {
																	ctor: '::',
																	_0: {
																		ctor: '_Tuple2',
																		_0: 'Année de plantation',
																		_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$int, isolatedTree.yearOfPlanting)
																	},
																	_1: {
																		ctor: '::',
																		_0: {
																			ctor: '_Tuple2',
																			_0: 'Intérêt écologique',
																			_1: _elm_lang$core$Json_Encode$string(eclogicalInterest)
																		},
																		_1: {
																			ctor: '::',
																			_0: {
																				ctor: '_Tuple2',
																				_0: 'Intérêt socio-historique',
																				_1: _elm_lang$core$Json_Encode$bool(isolatedTree.hasSocioHistoricalInterest)
																			},
																			_1: {
																				ctor: '::',
																				_0: {
																					ctor: '_Tuple2',
																					_0: 'Motif socio-historique',
																					_1: A2(
																						_elm_community$json_extra$Json_Encode_Extra$maybe,
																						_elm_lang$core$Json_Encode$string,
																						A2(_elm_lang$core$Maybe$map, toUiTxt, isolatedTree.socioHistoricalInterest))
																				},
																				_1: {
																					ctor: '::',
																					_0: {
																						ctor: '_Tuple2',
																						_0: 'Intérêt paysager',
																						_1: _elm_lang$core$Json_Encode$bool(isolatedTree.hasLandscapeInterest)
																					},
																					_1: {
																						ctor: '::',
																						_0: {
																							ctor: '_Tuple2',
																							_0: 'Intérêt écosystémique',
																							_1: _elm_lang$core$Json_Encode$string(
																								toUiTxt(isolatedTree.ecosystemSituation))
																						},
																						_1: {
																							ctor: '::',
																							_0: {
																								ctor: '_Tuple2',
																								_0: 'Score',
																								_1: _elm_lang$core$Json_Encode$int(isolatedTree.totalScore)
																							},
																							_1: {
																								ctor: '::',
																								_0: {
																									ctor: '_Tuple2',
																									_0: 'Mentions',
																									_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isMentioned)
																								},
																								_1: {
																									ctor: '::',
																									_0: {
																										ctor: '_Tuple2',
																										_0: 'Seul arbre d\'importance',
																										_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isOfRegionalImportance)
																									},
																									_1: {
																										ctor: '::',
																										_0: {
																											ctor: '_Tuple2',
																											_0: 'Commentaire général',
																											_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.comments)
																										},
																										_1: {
																											ctor: '::',
																											_0: {
																												ctor: '_Tuple2',
																												_0: 'documents',
																												_1: _elm_lang$core$Json_Encode$list(
																													A2(_elm_lang$core$List$map, _user$project$Data_Document$docEncode, isolatedTree.documents))
																											},
																											_1: {
																												ctor: '::',
																												_0: {
																													ctor: '_Tuple2',
																													_0: 'D\'intérêt communal',
																													_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isOfLocalInterest)
																												},
																												_1: {
																													ctor: '::',
																													_0: {
																														ctor: '_Tuple2',
																														_0: 'Candidat',
																														_1: _elm_lang$core$Json_Encode$bool(isolatedTree.isCandidate)
																													},
																													_1: {
																														ctor: '::',
																														_0: {
																															ctor: '_Tuple2',
																															_0: 'Commentaire candidature',
																															_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.candidacyComment)
																														},
																														_1: {
																															ctor: '::',
																															_0: {
																																ctor: '_Tuple2',
																																_0: 'A l\'inventaire',
																																_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$bool, isolatedTree.isRanked)
																															},
																															_1: {
																																ctor: '::',
																																_0: {
																																	ctor: '_Tuple2',
																																	_0: 'Justification',
																																	_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$string, isolatedTree.justificationOfRanking)
																																},
																																_1: {
																																	ctor: '::',
																																	_0: {
																																		ctor: '_Tuple2',
																																		_0: 'Modérateur',
																																		_1: A2(_elm_community$json_extra$Json_Encode_Extra$maybe, _elm_lang$core$Json_Encode$int, isolatedTree.moderatorId)
																																	},
																																	_1: {ctor: '[]'}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			});
	});
var _user$project$Views_SortFilter$treeGeojsonEncode = F2(
	function (toUiTxt, tree) {
		return _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'type',
					_1: _elm_lang$core$Json_Encode$string('Feature')
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'properties',
						_1: A2(_user$project$Views_SortFilter$treePropertiesEncode, toUiTxt, tree)
					},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'geometry', _1: tree.geometry},
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Views_SortFilter$getTreeDataToExport = F2(
	function (toUiTxt, model) {
		var dataset = A2(
			_elm_lang$core$Json_Encode$encode,
			0,
			_elm_lang$core$Json_Encode$list(
				A2(
					_elm_lang$core$List$map,
					function (tree) {
						return _elm_lang$core$Native_Utils.eq(model.exportType, '.geojson') ? A2(_user$project$Views_SortFilter$treeGeojsonEncode, toUiTxt, tree) : A2(_user$project$Views_SortFilter$treePropertiesEncode, toUiTxt, tree);
					},
					A2(
						_elm_lang$core$List$map,
						function (sel) {
							return sel.isolatedTree;
						},
						A2(
							_elm_lang$core$Maybe$withDefault,
							{ctor: '[]'},
							model.selIsolatedTrees)))));
		return dataset;
	});
var _user$project$Views_SortFilter$export = F2(
	function (toUiTxt, model) {
		var footer = '}';
		var dataset = A2(_user$project$Views_SortFilter$getTreeDataToExport, toUiTxt, model);
		var filename = A2(
			_elm_lang$core$Basics_ops['++'],
			_user$project$Helpers_Views_Text$maybeDateToShortString(model.currentDate),
			'_arbrem');
		var header = A2(
			_elm_lang$core$Basics_ops['++'],
			'{\"type\": \"FeatureCollection\",\"name\": \"',
			A2(_elm_lang$core$Basics_ops['++'], filename, '\",\"crs\": { \"type\": \"name\",\"properties\": { \"name\": \"urn:ogc:def:crs:EPSG::2056\" } },\"features\":'));
		var dataToExport = ((!_elm_lang$core$Native_Utils.eq(model.exportType, '.csv')) && (!_elm_lang$core$Native_Utils.eq(model.exportType, '.xlsx'))) ? A2(
			_elm_lang$core$Basics_ops['++'],
			header,
			A2(_elm_lang$core$Basics_ops['++'], dataset, footer)) : dataset;
		return _elm_lang$core$Native_Utils.eq(model.exportType, '.geojson') ? _user$project$Ports$exportData(
			{target: '.geojson', filename: filename, dataset: dataToExport}) : (_elm_lang$core$Native_Utils.eq(model.exportType, '.csv') ? _user$project$Ports$exportData(
			{target: '.csv', filename: filename, dataset: dataToExport}) : _user$project$Ports$exportData(
			{target: '.xlsx', filename: filename, dataset: dataToExport}));
	});
var _user$project$Views_SortFilter$getPdfExportParams = function (model) {
	var params = A2(
		_elm_lang$core$Basics_ops['++'],
		'email=',
		A2(
			_elm_lang$core$Basics_ops['++'],
			A2(_elm_lang$core$Maybe$withDefault, '', model.pdfMail),
			function () {
				var _p14 = model.selPlace;
				if (_p14.ctor === 'Nothing') {
					return '&communes=*';
				} else {
					return A2(
						_elm_lang$core$Basics_ops['++'],
						'&communes=',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_p14._0.name,
							function () {
								if (_elm_lang$core$Native_Utils.eq(model.selCandidacy, _user$project$Data_Tree$CandidateYes) && (model.andOrScore && (_elm_lang$core$Native_Utils.eq(
									model.selMinScore,
									_elm_lang$core$Maybe$Just(15)) && _elm_lang$core$Native_Utils.eq(model.selMaxScore, _elm_lang$core$Maybe$Nothing)))) {
									return '&hasScoreOrCandidacy=true';
								} else {
									if (_elm_lang$core$Native_Utils.eq(model.selCandidacy, _user$project$Data_Tree$CandidateAll) && (_elm_lang$core$Native_Utils.eq(model.selMinScore, _elm_lang$core$Maybe$Nothing) && _elm_lang$core$Native_Utils.eq(model.selMaxScore, _elm_lang$core$Maybe$Nothing))) {
										return '';
									} else {
										var idsString = A2(
											_elm_lang$core$String$join,
											',',
											A2(
												_elm_lang$core$List$map,
												_elm_lang$core$Basics$toString,
												A2(
													_elm_lang$core$List$filterMap,
													_elm_lang$core$Basics$identity,
													A2(
														_elm_lang$core$List$map,
														function (sel) {
															return sel.isolatedTree.id;
														},
														A2(
															_elm_lang$core$Maybe$withDefault,
															{ctor: '[]'},
															model.selIsolatedTrees)))));
										return A2(_elm_lang$core$Basics_ops['++'], '&ids=', idsString);
									}
								}
							}()));
				}
			}()));
	return params;
};
var _user$project$Views_SortFilter$delay = F2(
	function (time, msg) {
		return A2(
			_elm_lang$core$Task$perform,
			function (_p15) {
				return msg;
			},
			_elm_lang$core$Process$sleep(time));
	});
var _user$project$Views_SortFilter$syncSelection = F2(
	function (model, treesData) {
		var isNotInCurSelection = F2(
			function (selList, newSel) {
				return A2(
					_elm_lang$core$List$all,
					function (sel) {
						var _p16 = newSel.id;
						if (_p16.ctor === 'Nothing') {
							return false;
						} else {
							var _p17 = sel.isolatedTree.id;
							if (_p17.ctor === 'Nothing') {
								return false;
							} else {
								return !_elm_lang$core$Native_Utils.eq(_p17._0, _p16._0);
							}
						}
					},
					selList);
			});
		var filterDecode = function (data) {
			return _elm_lang$core$Result$toMaybe(
				A2(
					_elm_lang$core$Result$mapError,
					function (err) {
						return A2(
							_elm_lang$core$Debug$log,
							_elm_lang$core$Basics$toString(err),
							err);
					},
					A2(_elm_lang$core$Json_Decode$decodeValue, _user$project$Data_Tree$decoder, data)));
		};
		var newSelectionList = A2(_elm_lang$core$List$filterMap, filterDecode, treesData);
		var isInNewSelection = function (sel) {
			return A2(
				_elm_lang$core$List$any,
				function (newS) {
					var _p18 = newS.id;
					if (_p18.ctor === 'Nothing') {
						return false;
					} else {
						var _p19 = sel.isolatedTree.id;
						if (_p19.ctor === 'Nothing') {
							return false;
						} else {
							return _elm_lang$core$Native_Utils.eq(_p18._0, _p19._0);
						}
					}
				},
				newSelectionList);
		};
		var updateIsSelected = function (sel) {
			return _elm_lang$core$Native_Utils.update(
				sel,
				{
					isSelected: isInNewSelection(sel)
				});
		};
		var updatedSelList = A2(
			_elm_lang$core$List$map,
			updateIsSelected,
			A2(
				_elm_lang$core$Maybe$withDefault,
				{ctor: '[]'},
				model.selIsolatedTrees));
		var newSelsNotPresentInCurList = function (selList) {
			return A2(
				_elm_lang$core$List$filterMap,
				function (newSel) {
					return A2(isNotInCurSelection, selList, newSel) ? _elm_lang$core$Maybe$Just(
						{isSelected: true, isolatedTree: newSel}) : _elm_lang$core$Maybe$Nothing;
				},
				newSelectionList);
		};
		var addedSelList = A2(
			_elm_lang$core$List$append,
			newSelsNotPresentInCurList(updatedSelList),
			updatedSelList);
		var finalNewSelList = _elm_lang$core$List$isEmpty(addedSelList) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(addedSelList);
		return _elm_lang$core$Native_Utils.update(
			model,
			{selIsolatedTrees: finalNewSelList});
	});
var _user$project$Views_SortFilter$optionsToBool = function (mayOption) {
	var _p20 = mayOption;
	if (_p20.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		var _p21 = _p20._0;
		switch (_p21) {
			case 'Oui':
				return _elm_lang$core$Maybe$Just(true);
			case 'Non':
				return _elm_lang$core$Maybe$Just(false);
			default:
				return _elm_lang$core$Maybe$Nothing;
		}
	}
};
var _user$project$Views_SortFilter$optionNull = 'Indéfini';
var _user$project$Views_SortFilter$optionNo = 'Non';
var _user$project$Views_SortFilter$optionYes = 'Oui';
var _user$project$Views_SortFilter$defaultFormat = {decimals: 0, thousandSeparator: '\'', decimalSeparator: '.', negativePrefix: '−', negativeSuffix: '', positivePrefix: '', positiveSuffix: ''};
var _user$project$Views_SortFilter$toMayStringWithFormat = function (mayVal) {
	var _p22 = mayVal;
	if (_p22.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			A2(_cuducos$elm_format_number$FormatNumber$format, _user$project$Views_SortFilter$defaultFormat, _p22._0));
	}
};
var _user$project$Views_SortFilter$Model = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return {tableState: a, eventMsgs: b, mode: c, currentDate: d, currentYear: e, isLoading: f, selIsolatedTrees: g, selPlace: h, selCandidacy: i, selMinScore: j, selMaxScore: k, selVariety: l, searchedNames: m, filterSectionHidden: n, statSectionHidden: o, datalistNameState: p, isLatin: q, datalistPlaceState: r, minAge: s, maxAge: t, filterEventHidden: u, eventTypeFilters: v, exportType: w, pdfMail: x, andOrScore: y, totalNumber: z};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Views_SortFilter$SelIsolatedTree = F2(
	function (a, b) {
		return {isSelected: a, isolatedTree: b};
	});
var _user$project$Views_SortFilter$syncLists = F2(
	function (selIsolatedTreeList, isolatedTreeList) {
		return _elm_lang$core$Maybe$Just(
			A2(
				_elm_lang$core$List$map,
				function (tree) {
					var filteredList = A2(
						_elm_lang$core$List$filter,
						function (sel) {
							var selIolatedTree = sel.isolatedTree;
							var _p23 = selIolatedTree.id;
							if (_p23.ctor === 'Nothing') {
								return false;
							} else {
								var _p24 = tree.id;
								if (_p24.ctor === 'Nothing') {
									return false;
								} else {
									return _elm_lang$core$Native_Utils.eq(_p24._0, _p23._0) && sel.isSelected;
								}
							}
						},
						A2(
							_elm_lang$core$Maybe$withDefault,
							{ctor: '[]'},
							selIsolatedTreeList));
					var isSelected = !_elm_lang$core$List$isEmpty(filteredList);
					return A2(_user$project$Views_SortFilter$SelIsolatedTree, isSelected, tree);
				},
				isolatedTreeList));
	});
var _user$project$Views_SortFilter$Filters = function (a) {
	return {eventFilter: a};
};
var _user$project$Views_SortFilter$NormalMode = {ctor: 'NormalMode'};
var _user$project$Views_SortFilter$RemoveSentMsg = {ctor: 'RemoveSentMsg'};
var _user$project$Views_SortFilter$PdfExportSent = function (a) {
	return {ctor: 'PdfExportSent', _0: a};
};
var _user$project$Views_SortFilter$AndOrScoreChanged = function (a) {
	return {ctor: 'AndOrScoreChanged', _0: a};
};
var _user$project$Views_SortFilter$PdfMailChanged = function (a) {
	return {ctor: 'PdfMailChanged', _0: a};
};
var _user$project$Views_SortFilter$ExportTypeSwitch = function (a) {
	return {ctor: 'ExportTypeSwitch', _0: a};
};
var _user$project$Views_SortFilter$ExportData = F2(
	function (a, b) {
		return {ctor: 'ExportData', _0: a, _1: b};
	});
var _user$project$Views_SortFilter$ReceivedIsolatedTree = function (a) {
	return {ctor: 'ReceivedIsolatedTree', _0: a};
};
var _user$project$Views_SortFilter$getFilterQueryCmd = function (baseUrl) {
	return function (session) {
		return function (toMsg) {
			return function (maySelPlace) {
				return function (selCandidacy) {
					return function (andOrScore) {
						return function (mayMinScore) {
							return function (mayMaxScore) {
								return function (maySelVariety) {
									return function (mayMinAge) {
										return function (mayMaxAge) {
											return function (currentYear) {
												return function (maySearchedNames) {
													var queryFilters = A9(_user$project$Requests_SortFilter$buildQueryFilters, maySelPlace, selCandidacy, andOrScore, mayMinScore, mayMaxScore, maySelVariety, mayMinAge, mayMaxAge, currentYear);
													var mayEnumToMayString = function (mayStr) {
														var _p25 = mayStr;
														if (_p25.ctor === 'Nothing') {
															return _elm_lang$core$Maybe$Nothing;
														} else {
															var _p26 = _p25._0;
															return _elm_lang$core$Native_Utils.eq(_p26, _user$project$Views_SortFilter$enumDefaultOption) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(_p26);
														}
													};
													var mayStringToMayInt = function (mayStr) {
														var _p27 = mayStr;
														if (_p27.ctor === 'Nothing') {
															return _elm_lang$core$Maybe$Nothing;
														} else {
															return _elm_lang$core$Result$toMaybe(
																_elm_lang$core$String$toInt(_p27._0));
														}
													};
													return A2(
														_elm_lang$core$Task$attempt,
														function (_p28) {
															return toMsg(
																_user$project$Views_SortFilter$ReceivedIsolatedTree(_p28));
														},
														_elm_lang$http$Http$toTask(
															A3(_user$project$Requests_SortFilter$getAllWithFilters, baseUrl, session.token, queryFilters)));
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$Views_SortFilter$MsgFromDatalistPlace = function (a) {
	return {ctor: 'MsgFromDatalistPlace', _0: a};
};
var _user$project$Views_SortFilter$MsgFromDatalistName = function (a) {
	return {ctor: 'MsgFromDatalistName', _0: a};
};
var _user$project$Views_SortFilter$SwitchStatSectionHidden = {ctor: 'SwitchStatSectionHidden'};
var _user$project$Views_SortFilter$SwitchFilterEventHidden = {ctor: 'SwitchFilterEventHidden'};
var _user$project$Views_SortFilter$FilterEventCheck = F2(
	function (a, b) {
		return {ctor: 'FilterEventCheck', _0: a, _1: b};
	});
var _user$project$Views_SortFilter$filterEventCheckbox = F4(
	function (toMsg, label, filter, eventTypeFilters) {
		return A3(
			_mdgriffith$style_elements$Element_Input$checkbox,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				onChange: function (_p29) {
					return toMsg(
						A2(_user$project$Views_SortFilter$FilterEventCheck, filter, _p29));
				},
				checked: A2(_elm_lang$core$List$member, filter, eventTypeFilters),
				label: _mdgriffith$style_elements$Element$text(label),
				options: {ctor: '[]'}
			});
	});
var _user$project$Views_SortFilter$ToggleSelected = function (a) {
	return {ctor: 'ToggleSelected', _0: a};
};
var _user$project$Views_SortFilter$viewCheckbox = F2(
	function (toMsg, selection) {
		return A2(
			_evancz$elm_sortable_table$Table$HtmlDetails,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'width', _1: '6%'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'padding', _1: '0px 5px'},
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$input,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$type_('checkbox'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$checked(selection.isSelected),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									toMsg(
										_user$project$Views_SortFilter$ToggleSelected(selection.isolatedTree.id))),
								_1: {ctor: '[]'}
							}
						}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			});
	});
var _user$project$Views_SortFilter$checkboxColumn = function (toMsg) {
	return _evancz$elm_sortable_table$Table$veryCustomColumn(
		{
			name: '',
			viewData: _user$project$Views_SortFilter$viewCheckbox(toMsg),
			sorter: _evancz$elm_sortable_table$Table$unsortable
		});
};
var _user$project$Views_SortFilter$SearchButtonClicked = {ctor: 'SearchButtonClicked'};
var _user$project$Views_SortFilter$SearchNamesChanged = function (a) {
	return {ctor: 'SearchNamesChanged', _0: a};
};
var _user$project$Views_SortFilter$MaxAgeChanged = function (a) {
	return {ctor: 'MaxAgeChanged', _0: a};
};
var _user$project$Views_SortFilter$MinAgeChanged = function (a) {
	return {ctor: 'MinAgeChanged', _0: a};
};
var _user$project$Views_SortFilter$SelMaxScoreChanged = function (a) {
	return {ctor: 'SelMaxScoreChanged', _0: a};
};
var _user$project$Views_SortFilter$SelMinScoreChanged = function (a) {
	return {ctor: 'SelMinScoreChanged', _0: a};
};
var _user$project$Views_SortFilter$SelCandidacyChanged = function (a) {
	return {ctor: 'SelCandidacyChanged', _0: a};
};
var _user$project$Views_SortFilter$SelPlaceChanged = function (a) {
	return {ctor: 'SelPlaceChanged', _0: a};
};
var _user$project$Views_SortFilter$SelVarietyChanged = function (a) {
	return {ctor: 'SelVarietyChanged', _0: a};
};
var _user$project$Views_SortFilter$SwitchVariety = {ctor: 'SwitchVariety'};
var _user$project$Views_SortFilter$SetDate = function (a) {
	return {ctor: 'SetDate', _0: a};
};
var _user$project$Views_SortFilter$init = F4(
	function (toMsg, baseUrl, session, mapState) {
		var _p30 = A3(
			_user$project$Map$startSelectObjsModeNoEnd,
			mapState,
			_elm_lang$core$Maybe$Just('selecting_objects'),
			{
				ctor: '::',
				_0: 'object',
				_1: {ctor: '[]'}
			});
		var newMapState = _p30._0;
		var mapCmd = _p30._1;
		var getItemsCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(_elm_lang$core$Maybe$Nothing)(_user$project$Data_Tree$CandidateAll)(true)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing)(_elm_lang$core$Maybe$Nothing)(0)(_elm_lang$core$Maybe$Nothing);
		return {
			ctor: '_Tuple3',
			_0: {
				tableState: _evancz$elm_sortable_table$Table$initialSort('Objet'),
				eventMsgs: {ctor: '[]'},
				mode: _user$project$Views_SortFilter$NormalMode,
				currentDate: _elm_lang$core$Maybe$Nothing,
				currentYear: 0,
				isLoading: true,
				selIsolatedTrees: _elm_lang$core$Maybe$Nothing,
				selPlace: _elm_lang$core$Maybe$Nothing,
				selCandidacy: _user$project$Data_Tree$CandidateAll,
				selMinScore: _elm_lang$core$Maybe$Nothing,
				selMaxScore: _elm_lang$core$Maybe$Nothing,
				selVariety: _elm_lang$core$Maybe$Nothing,
				searchedNames: _elm_lang$core$Maybe$Nothing,
				filterSectionHidden: true,
				statSectionHidden: true,
				datalistNameState: _user$project$Helpers_Views_DatalistElement$init(_elm_lang$core$Maybe$Nothing),
				isLatin: true,
				datalistPlaceState: _user$project$Helpers_Views_DatalistPlace$init(_elm_lang$core$Maybe$Nothing),
				minAge: _elm_lang$core$Maybe$Nothing,
				maxAge: _elm_lang$core$Maybe$Nothing,
				filterEventHidden: true,
				eventTypeFilters: {
					ctor: '::',
					_0: _user$project$Data_Tree$EventAll,
					_1: {ctor: '[]'}
				},
				exportType: '.geojson',
				pdfMail: _elm_lang$core$Maybe$Nothing,
				andOrScore: true,
				totalNumber: _elm_lang$core$Maybe$Nothing
			},
			_1: newMapState,
			_2: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: getItemsCmd,
					_1: {
						ctor: '::',
						_0: mapCmd,
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Task$perform,
								function (_p31) {
									return toMsg(
										_user$project$Views_SortFilter$SetDate(_p31));
								},
								_elm_lang$core$Date$now),
							_1: {ctor: '[]'}
						}
					}
				})
		};
	});
var _user$project$Views_SortFilter$SetTableState = function (a) {
	return {ctor: 'SetTableState', _0: a};
};
var _user$project$Views_SortFilter$tableConfig = F2(
	function (toMsg, toUiTxt) {
		return _evancz$elm_sortable_table$Table$customConfig(
			{
				toId: function (_p32) {
					return _elm_lang$core$Basics$toString(
						function (_) {
							return _.id;
						}(
							function (_) {
								return _.isolatedTree;
							}(_p32)));
				},
				toMsg: function (_p33) {
					return toMsg(
						_user$project$Views_SortFilter$SetTableState(_p33));
				},
				columns: {
					ctor: '::',
					_0: _user$project$Views_SortFilter$checkboxColumn(toMsg),
					_1: {
						ctor: '::',
						_0: _user$project$Views_SortFilter$idColumn,
						_1: {
							ctor: '::',
							_0: _user$project$Views_SortFilter$varietyColumn,
							_1: {
								ctor: '::',
								_0: _user$project$Views_SortFilter$placeColumn,
								_1: {
									ctor: '::',
									_0: _user$project$Views_SortFilter$scoreColumn,
									_1: {ctor: '[]'}
								}
							}
						}
					}
				},
				customizations: _elm_lang$core$Native_Utils.update(
					_evancz$elm_sortable_table$Table$defaultCustomizations,
					{tableAttrs: _user$project$Views_SortFilter$toTableAttrs, thead: _user$project$Views_SortFilter$toThead, tbodyAttrs: _user$project$Views_SortFilter$toTbodyAttrs, rowAttrs: _user$project$Views_SortFilter$toRowAttrs})
			});
	});
var _user$project$Views_SortFilter$viewIsolatedTreeTable = F5(
	function (toMsg, toUiTxt, onCloseMsg, session, model) {
		var pdfMailValidation = A4(
			_user$project$Helpers_Data_InputValidation$validate,
			_elm_lang$core$Native_Utils.eq(model.exportType, '.pdfs') ? true : false,
			_elm_lang$core$Maybe$Just(_user$project$Helpers_Data_InputValidation$emailValidator),
			_elm_lang$core$Maybe$Just(
				toUiTxt('validation_email')),
			model.pdfMail);
		var pdfValidStyle = function () {
			var _p34 = pdfMailValidation.isValid;
			if (_p34 === true) {
				return _user$project$Styles$Input;
			} else {
				return _user$project$Styles$InputNotValid;
			}
		}();
		var exportOptions = {
			ctor: '::',
			_0: '.geojson',
			_1: {
				ctor: '::',
				_0: '.xlsx',
				_1: {
					ctor: '::',
					_0: '.csv',
					_1: {
						ctor: '::',
						_0: '.pdfs',
						_1: {ctor: '[]'}
					}
				}
			}
		};
		var isStillLoading = false;
		var maxScore = function () {
			var _p35 = model.selMaxScore;
			if (_p35.ctor === 'Nothing') {
				return '';
			} else {
				return _elm_lang$core$Basics$toString(_p35._0);
			}
		}();
		var filterEventAttr = model.filterEventHidden ? {
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$hidden,
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var eventTypeFilters = model.eventTypeFilters;
		var commonName = function () {
			var _p36 = model.selVariety;
			if (_p36.ctor === 'Nothing') {
				return '';
			} else {
				return _p36._0.commonName;
			}
		}();
		var latinName = function () {
			var _p37 = model.selVariety;
			if (_p37.ctor === 'Nothing') {
				return '';
			} else {
				return _p37._0.latinName;
			}
		}();
		return A3(
			_mdgriffith$style_elements$Element$column,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$header,
					_user$project$Styles$Header,
					{ctor: '[]'},
					A3(
						_mdgriffith$style_elements$Element$column,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: A3(
								_mdgriffith$style_elements$Element$h1,
								_user$project$Styles$MainTitle,
								{ctor: '[]'},
								_mdgriffith$style_elements$Element$text(
									toUiTxt('data_sortfilter_title'))),
							_1: {
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$row,
									_user$project$Styles$NoStyle,
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$el,
											_user$project$Styles$Label,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(
													_mdgriffith$style_elements$Element_Attributes$percent(50)),
												_1: {ctor: '[]'}
											},
											_mdgriffith$style_elements$Element$text(
												toUiTxt('data_isolatedTree_commune'))),
										_1: {
											ctor: '::',
											_0: A3(
												_user$project$Helpers_Views_DatalistPlace$view,
												function (_p38) {
													return toMsg(
														_user$project$Views_SortFilter$MsgFromDatalistPlace(_p38));
												},
												toUiTxt,
												model.datalistPlaceState),
											_1: {ctor: '[]'}
										}
									}),
								_1: {
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$column,
										_user$project$Styles$Section,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
											_1: {
												ctor: '::',
												_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 6, 8),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
													_1: {ctor: '[]'}
												}
											}
										},
										{
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$row,
												_user$project$Styles$NoStyle,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$el,
														_user$project$Styles$Label,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(
																_mdgriffith$style_elements$Element_Attributes$percent(60)),
															_1: {ctor: '[]'}
														},
														_mdgriffith$style_elements$Element$text(
															toUiTxt('data_isolatedTree_isCandidate'))),
													_1: {
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element_Input$radioRow,
															_user$project$Styles$NoStyle,
															{ctor: '[]'},
															{
																onChange: function (_p39) {
																	return toMsg(
																		_user$project$Views_SortFilter$SelCandidacyChanged(_p39));
																},
																selected: _elm_lang$core$Maybe$Just(model.selCandidacy),
																label: _mdgriffith$style_elements$Element_Input$labelLeft(
																	_mdgriffith$style_elements$Element$text('')),
																options: {ctor: '[]'},
																choices: {
																	ctor: '::',
																	_0: A2(
																		_mdgriffith$style_elements$Element_Input$choice,
																		_user$project$Data_Tree$CandidateAll,
																		A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(33)),
																				_1: {ctor: '[]'}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_option_all')))),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_mdgriffith$style_elements$Element_Input$choice,
																			_user$project$Data_Tree$CandidateYes,
																			A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(33)),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																						_1: {ctor: '[]'}
																					}
																				},
																				_mdgriffith$style_elements$Element$text(
																					toUiTxt('data_option_yes')))),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_mdgriffith$style_elements$Element_Input$choice,
																				_user$project$Data_Tree$CandidateNo,
																				A3(
																					_mdgriffith$style_elements$Element$el,
																					_user$project$Styles$NoStyle,
																					{
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$width(
																							_mdgriffith$style_elements$Element_Attributes$percent(33)),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																							_1: {ctor: '[]'}
																						}
																					},
																					_mdgriffith$style_elements$Element$text(
																						toUiTxt('data_option_no')))),
																			_1: {ctor: '[]'}
																		}
																	}
																}
															}),
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element_Input$radioRow,
															_user$project$Styles$NoStyle,
															{ctor: '[]'},
															{
																onChange: function (_p40) {
																	return toMsg(
																		_user$project$Views_SortFilter$AndOrScoreChanged(_p40));
																},
																selected: _elm_lang$core$Maybe$Just(model.andOrScore),
																label: _mdgriffith$style_elements$Element_Input$labelLeft(
																	_mdgriffith$style_elements$Element$text('')),
																options: {ctor: '[]'},
																choices: {
																	ctor: '::',
																	_0: A2(
																		_mdgriffith$style_elements$Element_Input$choice,
																		true,
																		A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(50)),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																					_1: {ctor: '[]'}
																				}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_option_and')))),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_mdgriffith$style_elements$Element_Input$choice,
																			false,
																			A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(50)),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																						_1: {ctor: '[]'}
																					}
																				},
																				_mdgriffith$style_elements$Element$text(
																					toUiTxt('data_option_or')))),
																		_1: {ctor: '[]'}
																	}
																}
															}),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$el,
																_user$project$Styles$Label,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(
																		_mdgriffith$style_elements$Element_Attributes$percent(50)),
																	_1: {ctor: '[]'}
																},
																_mdgriffith$style_elements$Element$text(
																	toUiTxt('data_sortfilter_score'))),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element_Input$text,
																			_user$project$Styles$Input,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(50)),
																				_1: {ctor: '[]'}
																			},
																			{
																				onChange: function (_p41) {
																					return toMsg(
																						_user$project$Views_SortFilter$SelMinScoreChanged(_p41));
																				},
																				value: A2(
																					_elm_lang$core$Maybe$withDefault,
																					'',
																					A2(_elm_lang$core$Maybe$map, _elm_lang$core$Basics$toString, model.selMinScore)),
																				label: _mdgriffith$style_elements$Element_Input$labelLeft(
																					_mdgriffith$style_elements$Element$text('min')),
																				options: {ctor: '[]'}
																			}),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element_Input$text,
																				_user$project$Styles$Input,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(50)),
																					_1: {ctor: '[]'}
																				},
																				{
																					onChange: function (_p42) {
																						return toMsg(
																							_user$project$Views_SortFilter$SelMaxScoreChanged(_p42));
																					},
																					value: maxScore,
																					label: _mdgriffith$style_elements$Element_Input$labelLeft(
																						_mdgriffith$style_elements$Element$text('max')),
																					options: {ctor: '[]'}
																				}),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {ctor: '[]'}
															}
														}),
													_1: {ctor: '[]'}
												}
											}
										}),
									_1: {
										ctor: '::',
										_0: A3(
											_mdgriffith$style_elements$Element$column,
											_user$project$Styles$NoStyle,
											{
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(8),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
															_1: {ctor: '[]'}
														}
													}
												}
											},
											{
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A3(
															_mdgriffith$style_elements$Element$el,
															_user$project$Styles$Label,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(
																	_mdgriffith$style_elements$Element_Attributes$percent(50)),
																_1: {ctor: '[]'}
															},
															_mdgriffith$style_elements$Element$text(
																toUiTxt('data_isolatedTree_variety'))),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: model.isLatin ? A3(
														_mdgriffith$style_elements$Element$column,
														_user$project$Styles$Section,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(8),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$el,
																		_user$project$Styles$Label,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(
																				_mdgriffith$style_elements$Element_Attributes$percent(50)),
																			_1: {ctor: '[]'}
																		},
																		_mdgriffith$style_elements$Element$text(
																			toUiTxt('data_isolatedTree_latinName'))),
																	_1: {
																		ctor: '::',
																		_0: A4(
																			_user$project$Helpers_Views_DatalistElement$view,
																			function (_p43) {
																				return toMsg(
																					_user$project$Views_SortFilter$MsgFromDatalistName(_p43));
																			},
																			toUiTxt,
																			model.isLatin,
																			model.datalistNameState),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(4.5),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(7.5),
																						_1: {
																							ctor: '::',
																							_0: _mdgriffith$style_elements$Element_Events$onClick(
																								toMsg(_user$project$Views_SortFilter$SwitchVariety)),
																							_1: {ctor: '[]'}
																						}
																					}
																				}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$Label,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(50)),
																				_1: {ctor: '[]'}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_isolatedTree_commonName'))),
																		_1: {
																			ctor: '::',
																			_0: A3(
																				_mdgriffith$style_elements$Element$el,
																				_user$project$Styles$NoStyle,
																				{
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$width(
																						_mdgriffith$style_elements$Element_Attributes$percent(50)),
																					_1: {ctor: '[]'}
																				},
																				_mdgriffith$style_elements$Element$text(commonName)),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {ctor: '[]'}
															}
														}) : A3(
														_mdgriffith$style_elements$Element$column,
														_user$project$Styles$Section,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(8),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Events$onClick(
																						toMsg(_user$project$Views_SortFilter$SwitchVariety)),
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$el,
																		_user$project$Styles$Label,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(
																				_mdgriffith$style_elements$Element_Attributes$percent(50)),
																			_1: {ctor: '[]'}
																		},
																		_mdgriffith$style_elements$Element$text(
																			toUiTxt('data_isolatedTree_latinName'))),
																	_1: {
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$NoStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(50)),
																				_1: {ctor: '[]'}
																			},
																			_mdgriffith$style_elements$Element$text(latinName)),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(6),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
																				_1: {
																					ctor: '::',
																					_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(6),
																					_1: {
																						ctor: '::',
																						_0: _mdgriffith$style_elements$Element_Attributes$paddingBottom(2),
																						_1: {ctor: '[]'}
																					}
																				}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element$el,
																			_user$project$Styles$Label,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(50)),
																				_1: {ctor: '[]'}
																			},
																			_mdgriffith$style_elements$Element$text(
																				toUiTxt('data_isolatedTree_commonName'))),
																		_1: {
																			ctor: '::',
																			_0: A4(
																				_user$project$Helpers_Views_DatalistElement$view,
																				function (_p44) {
																					return toMsg(
																						_user$project$Views_SortFilter$MsgFromDatalistName(_p44));
																				},
																				toUiTxt,
																				model.isLatin,
																				model.datalistNameState),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {ctor: '[]'}
															}
														}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$column,
												_user$project$Styles$VerySmallFont,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: A2(_mdgriffith$style_elements$Element_Attributes$paddingXY, 0, 8),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element$text(
																		toUiTxt('data_sortfilter_nbtrees')),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element$text(
																			A2(
																				_cuducos$elm_format_number$FormatNumber$format,
																				_user$project$Views_SortFilter$defaultFormat,
																				_elm_lang$core$Basics$toFloat(
																					_elm_lang$core$List$length(
																						A2(
																							_elm_lang$core$Maybe$withDefault,
																							{ctor: '[]'},
																							model.selIsolatedTrees))))),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element$text(
																				toUiTxt('data_sortfilter_on')),
																			_1: {
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element$text(
																					A2(
																						_elm_lang$core$Maybe$withDefault,
																						'',
																						A2(
																							_elm_lang$core$Maybe$map,
																							_cuducos$elm_format_number$FormatNumber$format(_user$project$Views_SortFilter$defaultFormat),
																							A2(_elm_lang$core$Maybe$map, _elm_lang$core$Basics$toFloat, model.totalNumber)))),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						})),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$mainContent,
						_user$project$Styles$SmallFont,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$paddingRight(5),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$yScrollbar,
										_1: {ctor: '[]'}
									}
								}
							}
						},
						A3(
							_mdgriffith$style_elements$Element$column,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$paddingTop(10),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
											_1: {ctor: '[]'}
										}
									}
								}
							},
							{
								ctor: '::',
								_0: function () {
									if (model.isLoading) {
										return _mdgriffith$style_elements$Element$text('Chargement des arbres en cours...');
									} else {
										var _p45 = model.selIsolatedTrees;
										if (_p45.ctor === 'Nothing') {
											return _mdgriffith$style_elements$Element$text('Sélectionnez un arbre dans la carte');
										} else {
											var _p46 = _p45._0;
											return _elm_lang$core$List$isEmpty(_p46) ? _mdgriffith$style_elements$Element$text('Aucun résultat trouvé') : A3(
												_mdgriffith$style_elements$Element$column,
												_user$project$Styles$NoStyle,
												{ctor: '[]'},
												{
													ctor: '::',
													_0: A3(
														_mdgriffith$style_elements$Element$row,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element$html(
																A3(
																	_evancz$elm_sortable_table$Table$view,
																	A2(_user$project$Views_SortFilter$tableConfig, toMsg, toUiTxt),
																	model.tableState,
																	_p46)),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												});
										}
									}
								}(),
								_1: {ctor: '[]'}
							})),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$footer,
							_user$project$Styles$Footer,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
									_1: {ctor: '[]'}
								}
							},
							A3(
								_mdgriffith$style_elements$Element$column,
								_user$project$Styles$NoStyle,
								{
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element_Attributes$spacing(10),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A3(
										_mdgriffith$style_elements$Element$row,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
													_1: {ctor: '[]'}
												}
											}
										},
										{
											ctor: '::',
											_0: (A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeEditor) || A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeLocalEditor)) ? A3(
												_mdgriffith$style_elements$Element$el,
												_user$project$Styles$NoStyle,
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$alignLeft,
														_1: {ctor: '[]'}
													}
												},
												A3(
													_mdgriffith$style_elements$Element$row,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: (isStillLoading || (_elm_lang$core$Native_Utils.eq(model.exportType, '.pdfs') && (!pdfMailValidation.isValid))) ? A3(
															_mdgriffith$style_elements$Element$button,
															_user$project$Styles$CancelBtn,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																_1: {ctor: '[]'}
															},
															A3(
																_mdgriffith$style_elements$Element$image,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$height(
																			_mdgriffith$style_elements$Element_Attributes$px(24)),
																		_1: {
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$width(
																				_mdgriffith$style_elements$Element_Attributes$px(24)),
																			_1: {ctor: '[]'}
																		}
																	}
																},
																{src: './images/exportDisabled.svg', caption: 'Export'})) : A3(
															_mdgriffith$style_elements$Element$button,
															_user$project$Styles$CancelBtn,
															{
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
																_1: {
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Events$onClick(
																		toMsg(
																			A2(_user$project$Views_SortFilter$ExportData, toUiTxt, true))),
																	_1: {ctor: '[]'}
																}
															},
															A3(
																_mdgriffith$style_elements$Element$image,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$height(
																		_mdgriffith$style_elements$Element_Attributes$px(24)),
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$width(
																			_mdgriffith$style_elements$Element_Attributes$px(24)),
																		_1: {ctor: '[]'}
																	}
																},
																{src: './images/export.svg', caption: 'Export'})),
														_1: {
															ctor: '::',
															_0: A3(
																_mdgriffith$style_elements$Element$row,
																_user$project$Styles$NoStyle,
																{
																	ctor: '::',
																	_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
																	_1: {
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(10),
																		_1: {ctor: '[]'}
																	}
																},
																{
																	ctor: '::',
																	_0: A3(
																		_mdgriffith$style_elements$Element$row,
																		_user$project$Styles$NoStyle,
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element_Attributes$padding(0),
																			_1: {ctor: '[]'}
																		},
																		{
																			ctor: '::',
																			_0: _mdgriffith$style_elements$Element$html(
																				A2(
																					_elm_lang$html$Html$select,
																					{
																						ctor: '::',
																						_0: _elm_lang$html$Html_Attributes$style(
																							{ctor: '[]'}),
																						_1: {
																							ctor: '::',
																							_0: A2(
																								_elm_lang$html$Html_Events$on,
																								'change',
																								A2(
																									_elm_lang$core$Json_Decode$map,
																									function (_p47) {
																										return toMsg(
																											_user$project$Views_SortFilter$ExportTypeSwitch(_p47));
																									},
																									_elm_lang$html$Html_Events$targetValue)),
																							_1: {ctor: '[]'}
																						}
																					},
																					A4(_user$project$Helpers_Views_Form$displayBasicOptions, _elm_lang$core$Basics$identity, model.exportType, exportOptions, exportOptions))),
																			_1: {ctor: '[]'}
																		}),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: _elm_lang$core$Native_Utils.eq(model.exportType, '.pdfs') ? A3(
																	_mdgriffith$style_elements$Element$row,
																	_user$project$Styles$NoStyle,
																	{
																		ctor: '::',
																		_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(4),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A3(
																			_mdgriffith$style_elements$Element_Input$text,
																			pdfValidStyle,
																			{
																				ctor: '::',
																				_0: _mdgriffith$style_elements$Element_Attributes$width(
																					_mdgriffith$style_elements$Element_Attributes$percent(70)),
																				_1: {ctor: '[]'}
																			},
																			{
																				onChange: function (_p48) {
																					return toMsg(
																						_user$project$Views_SortFilter$PdfMailChanged(_p48));
																				},
																				value: A2(_elm_lang$core$Maybe$withDefault, '', model.pdfMail),
																				label: _mdgriffith$style_elements$Element_Input$labelLeft(
																					_mdgriffith$style_elements$Element$text('email')),
																				options: {ctor: '[]'}
																			}),
																		_1: {ctor: '[]'}
																	}) : _mdgriffith$style_elements$Element$empty,
																_1: {ctor: '[]'}
															}
														}
													})) : _mdgriffith$style_elements$Element$empty,
											_1: {
												ctor: '::',
												_0: A3(
													_mdgriffith$style_elements$Element$button,
													_user$project$Styles$CancelBtn,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Events$onClick(onCloseMsg),
															_1: {ctor: '[]'}
														}
													},
													_mdgriffith$style_elements$Element$text(
														toUiTxt('gen_close'))),
												_1: {ctor: '[]'}
											}
										}),
									_1: {
										ctor: '::',
										_0: _mdgriffith$style_elements$Element$html(
											A2(_user$project$Helpers_Views_EventMsg$viewList, toUiTxt, model.eventMsgs)),
										_1: {ctor: '[]'}
									}
								})),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Views_SortFilter$view = F5(
	function (toMsg, closeMsg, toUiTxt, session, model) {
		var queryParams = A2(
			_elm_lang$core$String$append,
			'jwt=',
			A2(
				_elm_lang$core$Maybe$withDefault,
				'',
				_user$project$Helpers_Data_JwtToken$toString(session.token)));
		var _p49 = model.mode;
		return A5(_user$project$Views_SortFilter$viewIsolatedTreeTable, toMsg, toUiTxt, closeMsg, session, model);
	});
var _user$project$Views_SortFilter$NoOutMsg = {ctor: 'NoOutMsg'};
var _user$project$Views_SortFilter$update = F7(
	function (toMsg, parentSavedOk, baseUrl, session, msg, model, mapState) {
		var _p50 = msg;
		switch (_p50.ctor) {
			case 'SetTableState':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{tableState: _p50._0}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SetDate':
				var _p51 = _p50._0;
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							currentDate: _elm_lang$core$Maybe$Just(_p51),
							currentYear: _elm_lang$core$Date$year(_p51)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SwitchVariety':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{isLatin: !model.isLatin}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SelVarietyChanged':
				var _p52 = _p50._0;
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(
					_elm_lang$core$Maybe$Just(_p52))(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							selVariety: _elm_lang$core$Maybe$Just(_p52)
						}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SelPlaceChanged':
				var _p53 = _p50._0;
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(
					_elm_lang$core$Maybe$Just(_p53))(model.selCandidacy)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(model.selVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							selPlace: _elm_lang$core$Maybe$Just(_p53)
						}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SelCandidacyChanged':
				var _p54 = _p50._0;
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(_p54)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(model.selVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{selCandidacy: _p54}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'AndOrScoreChanged':
				var _p55 = _p50._0;
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(_p55)(model.selMinScore)(model.selMaxScore)(model.selVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{andOrScore: _p55}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SelMinScoreChanged':
				var newMinScore = _elm_lang$core$Result$toMaybe(
					_elm_lang$core$String$toInt(_p50._0));
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(model.andOrScore)(newMinScore)(model.selMaxScore)(model.selVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{selMinScore: newMinScore}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SelMaxScoreChanged':
				var newMaxScore = _elm_lang$core$Result$toMaybe(
					_elm_lang$core$String$toInt(_p50._0));
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(model.andOrScore)(model.selMinScore)(newMaxScore)(model.selVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{selMaxScore: newMaxScore}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'MinAgeChanged':
				var newMin = function () {
					var _p56 = _elm_lang$core$String$toInt(_p50._0);
					if (_p56.ctor === 'Ok') {
						return _elm_lang$core$Maybe$Just(_p56._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(model.selVariety)(newMin)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{minAge: newMin}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'MaxAgeChanged':
				var newMax = function () {
					var _p57 = _elm_lang$core$String$toInt(_p50._0);
					if (_p57.ctor === 'Ok') {
						return _elm_lang$core$Maybe$Just(_p57._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				var queryFilterCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(model.selVariety)(model.minAge)(newMax)(model.currentYear)(model.searchedNames);
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{maxAge: newMax}),
					_1: queryFilterCmd,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'ToggleSelected':
				var _p58 = model.selIsolatedTrees;
				if (_p58.ctor === 'Nothing') {
					return {ctor: '_Tuple4', _0: model, _1: _elm_lang$core$Platform_Cmd$none, _2: mapState, _3: _user$project$Views_SortFilter$NoOutMsg};
				} else {
					var selToGeoObj = function (selIt) {
						return (!selIt.isSelected) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
							{
								id: _elm_lang$core$Basics$toString(selIt.isolatedTree.id),
								obj: _elm_lang$core$Maybe$Just(
									A2(_user$project$Data_Tree$encoder, false, selIt.isolatedTree)),
								layerKey: 'trees'
							});
					};
					var toggleSel = function (selIt) {
						return _elm_lang$core$Native_Utils.eq(selIt.isolatedTree.id, _p50._0) ? _elm_lang$core$Native_Utils.update(
							selIt,
							{isSelected: !selIt.isSelected}) : selIt;
					};
					var updSelIsolatedTrees = A2(_elm_lang$core$List$map, toggleSel, _p58._0);
					var _p59 = _user$project$Map$startSelectObjsModeNoEndWithGeoObjs(
						{
							mapState: mapState,
							name: _elm_lang$core$Maybe$Just('selecting_trees'),
							layerKeys: {
								ctor: '::',
								_0: 'trees',
								_1: {ctor: '[]'}
							},
							geoObjs: A2(_elm_lang$core$List$filterMap, selToGeoObj, updSelIsolatedTrees),
							panAndZoom: true
						});
					var newMapState = _p59._0;
					var mapCmd = _p59._1;
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								selIsolatedTrees: _elm_lang$core$Maybe$Just(updSelIsolatedTrees)
							}),
						_1: mapCmd,
						_2: newMapState,
						_3: _user$project$Views_SortFilter$NoOutMsg
					};
				}
			case 'FilterEventCheck':
				var _p62 = _p50._0;
				var _p61 = _p50._1;
				var newEventTypeFilters = function () {
					var _p60 = _p62;
					switch (_p60.ctor) {
						case 'EventAll':
							return _p61 ? {
								ctor: '::',
								_0: _user$project$Data_Tree$EventAll,
								_1: {ctor: '[]'}
							} : A2(
								_elm_lang$core$List$filter,
								function (item) {
									return !_elm_lang$core$Native_Utils.eq(item, _user$project$Data_Tree$EventNone);
								},
								A2(
									_elm_lang$core$List$filter,
									function (item) {
										return !_elm_lang$core$Native_Utils.eq(item, _user$project$Data_Tree$EventAll);
									},
									_user$project$Data_Tree$eventTypeFilterList));
						case 'EventNone':
							return _p61 ? {
								ctor: '::',
								_0: _user$project$Data_Tree$EventNone,
								_1: {ctor: '[]'}
							} : {
								ctor: '::',
								_0: _user$project$Data_Tree$EventAll,
								_1: {ctor: '[]'}
							};
						default:
							return _p61 ? A2(
								_elm_lang$core$List$filter,
								function (item) {
									return !_elm_lang$core$Native_Utils.eq(item, _user$project$Data_Tree$EventNone);
								},
								A2(
									_elm_lang$core$List$filter,
									function (item) {
										return !_elm_lang$core$Native_Utils.eq(item, _user$project$Data_Tree$EventAll);
									},
									{ctor: '::', _0: _p62, _1: model.eventTypeFilters})) : A2(
								_elm_lang$core$List$filter,
								function (item) {
									return !_elm_lang$core$Native_Utils.eq(item, _user$project$Data_Tree$EventNone);
								},
								A2(
									_elm_lang$core$List$filter,
									function (item) {
										return !_elm_lang$core$Native_Utils.eq(item, _user$project$Data_Tree$EventAll);
									},
									A2(
										_elm_lang$core$List$filter,
										function (d) {
											return !_elm_lang$core$Native_Utils.eq(d, _p62);
										},
										model.eventTypeFilters)));
					}
				}();
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{eventTypeFilters: newEventTypeFilters}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SearchNamesChanged':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							searchedNames: _elm_lang$core$Maybe$Just(_p50._0)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SearchButtonClicked':
				var queryCmd = _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(model.selVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
				return {ctor: '_Tuple4', _0: model, _1: queryCmd, _2: mapState, _3: _user$project$Views_SortFilter$NoOutMsg};
			case 'SwitchFilterEventHidden':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{filterEventHidden: !model.filterEventHidden}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'SwitchStatSectionHidden':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{statSectionHidden: !model.statSectionHidden}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'MsgFromDatalistName':
				var _p63 = A5(
					_user$project$Helpers_Views_DatalistElement$update,
					function (_p64) {
						return toMsg(
							_user$project$Views_SortFilter$MsgFromDatalistName(_p64));
					},
					session,
					_p50._0,
					model.datalistNameState,
					baseUrl);
				var newDatalistState = _p63._0;
				var datalistCmd = _p63._1;
				var datalistOutMsg = _p63._2;
				var newVariety = function () {
					var _p65 = datalistOutMsg;
					if (_p65.ctor === 'ItemSelected') {
						return _p65._0;
					} else {
						return model.selVariety;
					}
				}();
				var cmds = _elm_lang$core$Platform_Cmd$batch(
					{
						ctor: '::',
						_0: datalistCmd,
						_1: {
							ctor: '::',
							_0: function () {
								var _p66 = datalistOutMsg;
								if (_p66.ctor === 'ItemSelected') {
									return _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(model.selPlace)(model.selCandidacy)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(newVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
								} else {
									return _elm_lang$core$Platform_Cmd$none;
								}
							}(),
							_1: {ctor: '[]'}
						}
					});
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{datalistNameState: newDatalistState, selVariety: newVariety}),
					_1: cmds,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'MsgFromDatalistPlace':
				var _p67 = A5(
					_user$project$Helpers_Views_DatalistPlace$update,
					function (_p68) {
						return toMsg(
							_user$project$Views_SortFilter$MsgFromDatalistPlace(_p68));
					},
					session,
					_p50._0,
					model.datalistPlaceState,
					baseUrl);
				var newDatalistState = _p67._0;
				var datalistCmd = _p67._1;
				var datalistOutMsg = _p67._2;
				var newPlace = function () {
					var _p69 = datalistOutMsg;
					if (_p69.ctor === 'ItemSelected') {
						return _p69._0;
					} else {
						return model.selPlace;
					}
				}();
				var cmds = _elm_lang$core$Platform_Cmd$batch(
					{
						ctor: '::',
						_0: datalistCmd,
						_1: {
							ctor: '::',
							_0: function () {
								var _p70 = datalistOutMsg;
								if (_p70.ctor === 'ItemSelected') {
									return _user$project$Views_SortFilter$getFilterQueryCmd(baseUrl)(session)(toMsg)(newPlace)(model.selCandidacy)(model.andOrScore)(model.selMinScore)(model.selMaxScore)(model.selVariety)(model.minAge)(model.maxAge)(model.currentYear)(model.searchedNames);
								} else {
									return _elm_lang$core$Platform_Cmd$none;
								}
							}(),
							_1: {ctor: '[]'}
						}
					});
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{datalistPlaceState: newDatalistState, selPlace: newPlace}),
					_1: cmds,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'ReceivedIsolatedTree':
				if (_p50._0.ctor === 'Ok') {
					var _p72 = _p50._0._0;
					var newSelIsolatedTrees = A2(_user$project$Views_SortFilter$syncLists, model.selIsolatedTrees, _p72);
					var totalNbTrees = function () {
						var _p71 = model.totalNumber;
						if (_p71.ctor === 'Nothing') {
							return _elm_lang$core$Maybe$Just(
								_elm_lang$core$List$length(_p72));
						} else {
							return _elm_lang$core$Maybe$Just(_p71._0);
						}
					}();
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{selIsolatedTrees: newSelIsolatedTrees, isLoading: false, totalNumber: totalNbTrees}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: mapState,
						_3: _user$project$Views_SortFilter$NoOutMsg
					};
				} else {
					var _p73 = A2(_elm_lang$core$Debug$log, 'Error while receiving isolatedTrees', _p50._0._0);
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{isLoading: false}),
						_1: _elm_lang$core$Platform_Cmd$none,
						_2: mapState,
						_3: _user$project$Views_SortFilter$NoOutMsg
					};
				}
			case 'ExportData':
				var extractCmd = function () {
					if (_elm_lang$core$Native_Utils.eq(model.exportType, '.pdfs')) {
						var params = _user$project$Views_SortFilter$getPdfExportParams(model);
						return A2(
							_elm_lang$http$Http$send,
							function (_p74) {
								return toMsg(
									_user$project$Views_SortFilter$PdfExportSent(_p74));
							},
							A3(_user$project$Requests_SortFilter$exportSelection, baseUrl, session.token, params));
					} else {
						return A2(_user$project$Views_SortFilter$export, _p50._0, model);
					}
				}();
				return {ctor: '_Tuple4', _0: model, _1: extractCmd, _2: mapState, _3: _user$project$Views_SortFilter$NoOutMsg};
			case 'ExportTypeSwitch':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{exportType: _p50._0}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'PdfMailChanged':
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							pdfMail: _elm_lang$core$Maybe$Just(_p50._0)
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
			case 'PdfExportSent':
				if (_p50._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								eventMsgs: {
									ctor: '::',
									_0: _user$project$Helpers_Data_EventMsg$Success('gen_sent_ok'),
									_1: {ctor: '[]'}
								}
							}),
						_1: _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: A2(
									_user$project$Views_SortFilter$delay,
									_elm_lang$core$Time$second * 3,
									toMsg(_user$project$Views_SortFilter$RemoveSentMsg)),
								_1: {ctor: '[]'}
							}),
						_2: mapState,
						_3: _user$project$Views_SortFilter$NoOutMsg
					};
				} else {
					var xxx = A2(
						_elm_lang$core$Debug$log,
						'Could not send pdfs: ',
						_elm_lang$core$Basics$toString(_p50._0._0));
					return {
						ctor: '_Tuple4',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								eventMsgs: {
									ctor: '::',
									_0: _user$project$Helpers_Data_EventMsg$Error('gen_sent_error'),
									_1: {ctor: '[]'}
								}
							}),
						_1: _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: A2(
									_user$project$Views_SortFilter$delay,
									_elm_lang$core$Time$second * 3,
									toMsg(_user$project$Views_SortFilter$RemoveSentMsg)),
								_1: {ctor: '[]'}
							}),
						_2: mapState,
						_3: _user$project$Views_SortFilter$NoOutMsg
					};
				}
			default:
				return {
					ctor: '_Tuple4',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							eventMsgs: {ctor: '[]'}
						}),
					_1: _elm_lang$core$Platform_Cmd$none,
					_2: mapState,
					_3: _user$project$Views_SortFilter$NoOutMsg
				};
		}
	});

var _user$project$Pages_TreeMap$bitsToElem = function (treeUiBits) {
	var _p0 = treeUiBits;
	if (_p0.ctor === 'TreeUiBits') {
		var _p1 = _p0._0;
		if (_p1.ctor === 'Groups') {
			var _p2 = _p1._0;
			switch (_p2.ctor) {
				case 'GroupTree':
					return _mdgriffith$style_elements$Element$text('Objets d\'inventaire');
				case 'GroupTreeInfo':
					return _mdgriffith$style_elements$Element$empty;
				case 'GroupCanopy':
					return _mdgriffith$style_elements$Element$text('Données de base');
				default:
					return _mdgriffith$style_elements$Element$empty;
			}
		} else {
			var _p3 = _p1._0;
			switch (_p3.ctor) {
				case 'VectorTree':
					return _mdgriffith$style_elements$Element$text('Arbres remarquables');
				case 'VectorTreeInfo':
					return _mdgriffith$style_elements$Element$empty;
				case 'VectorSvsTree':
					return _mdgriffith$style_elements$Element$text('Ancien inventaire SVS');
				case 'VectorSvsTreeInfo':
					return _mdgriffith$style_elements$Element$empty;
				case 'TreeHeight':
					return _mdgriffith$style_elements$Element$text('Arbres isolés (TLM3D)');
				case 'TreeHeightInfo':
					return _mdgriffith$style_elements$Element$empty;
				case 'Ndvi':
					return _mdgriffith$style_elements$Element$text('Indice de végétation (NDVI)');
				case 'NdviInfo':
					return _mdgriffith$style_elements$Element$empty;
				case 'Lst':
					return _mdgriffith$style_elements$Element$text('Température de surface (LST)');
				case 'LstInfo':
					return _mdgriffith$style_elements$Element$empty;
				case 'WmsWoodsVD':
					return _mdgriffith$style_elements$Element$text('Surfaces boisées');
				case 'WmsWoodsVDInfo':
					return A3(
						_mdgriffith$style_elements$Element$paragraph,
						_user$project$Styles$NoStyle,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$text('Géodonnées fournies par '),
							_1: {
								ctor: '::',
								_0: A2(
									_mdgriffith$style_elements$Element$newTab,
									'https://www.ogc.vd.ch',
									A3(
										_mdgriffith$style_elements$Element$el,
										_user$project$Styles$Link,
										{ctor: '[]'},
										_mdgriffith$style_elements$Element$text('Guichet cartographique VD'))),
								_1: {ctor: '[]'}
							}
						});
				case 'WmtsCadaster':
					return _mdgriffith$style_elements$Element$text('Biens-fonds');
				case 'WmtsCadasterInfo':
					return A3(
						_mdgriffith$style_elements$Element$paragraph,
						_user$project$Styles$NoStyle,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$text('Données cadastrales fournies par '),
							_1: {
								ctor: '::',
								_0: A2(
									_mdgriffith$style_elements$Element$newTab,
									'https://www.ogc.vd.ch',
									A3(
										_mdgriffith$style_elements$Element$el,
										_user$project$Styles$Link,
										{ctor: '[]'},
										_mdgriffith$style_elements$Element$text('Guichet cartographique VD'))),
								_1: {ctor: '[]'}
							}
						});
				case 'WmtsCadasterNo':
					return _mdgriffith$style_elements$Element$text('No de biens-fonds');
				case 'WmtsCadasterNoInfo':
					return A3(
						_mdgriffith$style_elements$Element$paragraph,
						_user$project$Styles$NoStyle,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element$text('Données cadastrales fournies par '),
							_1: {
								ctor: '::',
								_0: A2(
									_mdgriffith$style_elements$Element$newTab,
									'https://www.ogc.vd.ch',
									A3(
										_mdgriffith$style_elements$Element$el,
										_user$project$Styles$Link,
										{ctor: '[]'},
										_mdgriffith$style_elements$Element$text('Guichet cartographique VD'))),
								_1: {ctor: '[]'}
							}
						});
				case 'WmtsAerial1974':
					return _mdgriffith$style_elements$Element$text('SwissImage 1974');
				default:
					return _mdgriffith$style_elements$Element$empty;
			}
		}
	} else {
		return _user$project$Pages_MapHelper$frenchGenBitsToElem(_p0._0);
	}
};
var _user$project$Pages_TreeMap$frenchStrsDict = function () {
	var dict = _elm_lang$core$Dict$fromList(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'tree',
				_1: _mdgriffith$style_elements$Element$text('Arbres remarquables')
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'gen_undefined',
					_1: _mdgriffith$style_elements$Element$text('Indéfini')
				},
				_1: {ctor: '[]'}
			}
		});
	return A2(_elm_lang$core$Dict$union, dict, _user$project$Pages_MapHelper$frenchGenStrsDict);
}();
var _user$project$Pages_TreeMap$strsToElem = function (str) {
	var _p4 = A2(_elm_lang$core$Dict$get, str, _user$project$Pages_TreeMap$frenchStrsDict);
	if (_p4.ctor === 'Nothing') {
		return _mdgriffith$style_elements$Element$text(
			A2(_elm_lang$core$Basics_ops['++'], 'Clé non trouvée: ', str));
	} else {
		return _p4._0;
	}
};
var _user$project$Pages_TreeMap$mapStyling = _user$project$Map$stylesDefault(_user$project$Styles$StyleFromMap);
var _user$project$Pages_TreeMap$namedGeoZones = function (session) {
	var localEditGeoZone = A2(_user$project$Data_Role$getRoleGeom, session.token, _user$project$Data_Role$TreeLocalEditor);
	var addLocalEdit = function (namedGeoZones) {
		var _p5 = localEditGeoZone;
		if (_p5.ctor === 'Nothing') {
			return namedGeoZones;
		} else {
			return {
				ctor: '::',
				_0: {name: 'tree_localeditor', geoZone: _p5._0},
				_1: namedGeoZones
			};
		}
	};
	var geomEditGeoZone = A2(_user$project$Data_Role$getRoleGeom, session.token, _user$project$Data_Role$TreeEditor);
	var addGeomEdit = function (namedGeoZones) {
		var _p6 = geomEditGeoZone;
		if (_p6.ctor === 'Nothing') {
			return namedGeoZones;
		} else {
			return {
				ctor: '::',
				_0: {name: 'tree_editor', geoZone: _p6._0},
				_1: namedGeoZones
			};
		}
	};
	return addLocalEdit(
		addGeomEdit(
			{ctor: '[]'}));
};
var _user$project$Pages_TreeMap$createExpOpInitData = F2(
	function (mapState, session) {
		return {mapState: mapState, session: session};
	});
var _user$project$Pages_TreeMap$geoZone2geoObj = function (geoz) {
	return {
		id: geoz.name,
		obj: _elm_lang$core$Maybe$Just(geoz.geoZone),
		layerKey: 'maintenance_sectors'
	};
};
var _user$project$Pages_TreeMap$Model = F4(
	function (a, b, c, d) {
		return {mapState: a, sideBar: b, notSmallDevice: c, opsHandlerModel: d};
	});
var _user$project$Pages_TreeMap$GeoZone = F2(
	function (a, b) {
		return {name: a, geoZone: b};
	});
var _user$project$Pages_TreeMap$InitParams = F4(
	function (a, b, c, d) {
		return {extent: a, center: b, zoom: c, geoZones: d};
	});
var _user$project$Pages_TreeMap$decodeInitParams = A2(
	_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
	A2(
		_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
		A2(
			_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				_elm_lang$core$Json_Decode$succeed(_user$project$Pages_TreeMap$InitParams),
				A2(
					_elm_lang$core$Json_Decode$field,
					'extent',
					A2(
						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
						A2(
							_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
							A2(
								_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
								A2(
									_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
									_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_Utils$Extent),
									A2(_elm_lang$core$Json_Decode$field, 'minx', _elm_lang$core$Json_Decode$float)),
								A2(_elm_lang$core$Json_Decode$field, 'miny', _elm_lang$core$Json_Decode$float)),
							A2(_elm_lang$core$Json_Decode$field, 'mxx', _elm_lang$core$Json_Decode$float)),
						A2(_elm_lang$core$Json_Decode$field, 'maxy', _elm_lang$core$Json_Decode$float)))),
			A2(
				_elm_lang$core$Json_Decode$field,
				'center',
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					A2(
						_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
						_elm_lang$core$Json_Decode$succeed(_user$project$Map_Data_Utils$Point),
						A2(_elm_lang$core$Json_Decode$field, 'x', _elm_lang$core$Json_Decode$float)),
					A2(_elm_lang$core$Json_Decode$field, 'y', _elm_lang$core$Json_Decode$float)))),
		A2(_elm_lang$core$Json_Decode$field, 'zoom', _elm_lang$core$Json_Decode$float)),
	A2(
		_elm_lang$core$Json_Decode$field,
		'geoZones',
		_elm_lang$core$Json_Decode$list(
			A2(
				_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
				A2(
					_elm_community$json_extra$Json_Decode_Extra_ops['|:'],
					_elm_lang$core$Json_Decode$succeed(_user$project$Pages_TreeMap$GeoZone),
					A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string)),
				A2(_elm_lang$core$Json_Decode$field, 'geoZone', _elm_lang$core$Json_Decode$value)))));
var _user$project$Pages_TreeMap$SortFilterBar = function (a) {
	return {ctor: 'SortFilterBar', _0: a};
};
var _user$project$Pages_TreeMap$IsolatedTreeBar = function (a) {
	return {ctor: 'IsolatedTreeBar', _0: a};
};
var _user$project$Pages_TreeMap$NoBar = {ctor: 'NoBar'};
var _user$project$Pages_TreeMap$ExportDone = function (a) {
	return {ctor: 'ExportDone', _0: a};
};
var _user$project$Pages_TreeMap$ExportPDFMode = function (a) {
	return {ctor: 'ExportPDFMode', _0: a};
};
var _user$project$Pages_TreeMap$OpsHandlerMsg = function (a) {
	return {ctor: 'OpsHandlerMsg', _0: a};
};
var _user$project$Pages_TreeMap$StartDeleteMode = {ctor: 'StartDeleteMode'};
var _user$project$Pages_TreeMap$StartModifyMode = {ctor: 'StartModifyMode'};
var _user$project$Pages_TreeMap$StartAddMode = {ctor: 'StartAddMode'};
var _user$project$Pages_TreeMap$SideBarClosed = {ctor: 'SideBarClosed'};
var _user$project$Pages_TreeMap$SideBarSaved = {ctor: 'SideBarSaved'};
var _user$project$Pages_TreeMap$MsgFromSortFilterBar = function (a) {
	return {ctor: 'MsgFromSortFilterBar', _0: a};
};
var _user$project$Pages_TreeMap$OpenSortFilterBar = {ctor: 'OpenSortFilterBar'};
var _user$project$Pages_TreeMap$editToolsBar = function (session) {
	var buttonSz = 24;
	var planningBtn = A3(
		_mdgriffith$style_elements$Element$button,
		_user$project$Styles$StyleFromMap(_user$project$Map_Data_Styles$TrspBtn),
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Events$onClick(_user$project$Pages_TreeMap$OpenSortFilterBar),
			_1: {ctor: '[]'}
		},
		A3(
			_mdgriffith$style_elements$Element$image,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(
					_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {ctor: '[]'}
				}
			},
			{src: './images/planning.svg', caption: 'Planning'}));
	var editionBtns = {
		ctor: '::',
		_0: A3(
			_mdgriffith$style_elements$Element$button,
			_user$project$Styles$StyleFromMap(_user$project$Map_Data_Styles$TrspBtn),
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Events$onClick(_user$project$Pages_TreeMap$StartAddMode),
				_1: {ctor: '[]'}
			},
			A3(
				_mdgriffith$style_elements$Element$image,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(
						_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$width(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {ctor: '[]'}
					}
				},
				{src: './images/add.svg', caption: 'Ajouter'})),
		_1: {
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$button,
				_user$project$Styles$StyleFromMap(_user$project$Map_Data_Styles$TrspBtn),
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Events$onClick(_user$project$Pages_TreeMap$StartModifyMode),
					_1: {ctor: '[]'}
				},
				A3(
					_mdgriffith$style_elements$Element$image,
					_user$project$Styles$NoStyle,
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$height(
							_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$width(
								_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
							_1: {ctor: '[]'}
						}
					},
					{src: './images/edit.svg', caption: 'Modifier'})),
			_1: {
				ctor: '::',
				_0: A3(
					_mdgriffith$style_elements$Element$button,
					_user$project$Styles$StyleFromMap(_user$project$Map_Data_Styles$TrspBtn),
					{
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Events$onClick(_user$project$Pages_TreeMap$StartDeleteMode),
						_1: {ctor: '[]'}
					},
					A3(
						_mdgriffith$style_elements$Element$image,
						_user$project$Styles$NoStyle,
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$height(
								_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
							_1: {
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(
									_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
								_1: {ctor: '[]'}
							}
						},
						{src: './images/delete.svg', caption: 'Supprimer'})),
				_1: {
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$button,
						_user$project$Styles$StyleFromMap(_user$project$Map_Data_Styles$TrspBtn),
						{
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Events$onClick(
								_user$project$Pages_TreeMap$ExportPDFMode(_elm_lang$core$Maybe$Nothing)),
							_1: {ctor: '[]'}
						},
						A3(
							_mdgriffith$style_elements$Element$image,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$height(
									_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
								_1: {
									ctor: '::',
									_0: _mdgriffith$style_elements$Element_Attributes$width(
										_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
									_1: {ctor: '[]'}
								}
							},
							{src: './images/export_pdf.svg', caption: 'Export PDF'})),
					_1: {ctor: '[]'}
				}
			}
		}
	};
	var btns = (A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeEditor) || A2(_user$project$Data_Role$hasRole, session.token, _user$project$Data_Role$TreeLocalEditor)) ? {ctor: '::', _0: planningBtn, _1: editionBtns} : {
		ctor: '::',
		_0: planningBtn,
		_1: {ctor: '[]'}
	};
	return A3(
		_mdgriffith$style_elements$Element$row,
		_user$project$Styles$NoStyle,
		{
			ctor: '::',
			_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
			_1: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$paddingLeft(20),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$verticalCenter,
						_1: {ctor: '[]'}
					}
				}
			}
		},
		{
			ctor: '::',
			_0: A3(
				_mdgriffith$style_elements$Element$row,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(
						_mdgriffith$style_elements$Element_Attributes$percent(60)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$center,
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$spacing(4),
							_1: {ctor: '[]'}
						}
					}
				},
				btns),
			_1: {ctor: '[]'}
		});
};
var _user$project$Pages_TreeMap$mapUiElements = F3(
	function (toUiTxt, session, model) {
		return {
			bitToElem: _user$project$Pages_TreeMap$bitsToElem,
			strToElem: _user$project$Pages_TreeMap$strsToElem,
			bits: A2(
				_user$project$Map$uiBitsContentFrenchDefault,
				_user$project$Pages_TreeMap$mapStyling,
				_user$project$Pages_TreeMap$editToolsBar(session))
		};
	});
var _user$project$Pages_TreeMap$MsgFromIsolatedTreeBar = function (a) {
	return {ctor: 'MsgFromIsolatedTreeBar', _0: a};
};
var _user$project$Pages_TreeMap$barSubscriptions = A2(_elm_lang$core$Platform_Sub$map, _user$project$Pages_TreeMap$MsgFromIsolatedTreeBar, _user$project$Views_IsolatedTree$subscriptions);
var _user$project$Pages_TreeMap$viewSideBar = F4(
	function (toUiTxt, device, session, model) {
		var _p7 = model.sideBar;
		switch (_p7.ctor) {
			case 'NoBar':
				return _mdgriffith$style_elements$Element$empty;
			case 'IsolatedTreeBar':
				return _mdgriffith$style_elements$Element$html(
					A5(_user$project$Views_IsolatedTree$view, _user$project$Pages_TreeMap$MsgFromIsolatedTreeBar, _user$project$Pages_TreeMap$SideBarClosed, toUiTxt, session, _p7._0));
			default:
				return A5(_user$project$Views_SortFilter$view, _user$project$Pages_TreeMap$MsgFromSortFilterBar, _user$project$Pages_TreeMap$SideBarClosed, toUiTxt, session, _p7._0);
		}
	});
var _user$project$Pages_TreeMap$OpenIsolatedTreeBar = F2(
	function (a, b) {
		return {ctor: 'OpenIsolatedTreeBar', _0: a, _1: b};
	});
var _user$project$Pages_TreeMap$OnInitParamsReceived = function (a) {
	return {ctor: 'OnInitParamsReceived', _0: a};
};
var _user$project$Pages_TreeMap$MsgFromMap = function (a) {
	return {ctor: 'MsgFromMap', _0: a};
};
var _user$project$Pages_TreeMap$onEnter = F2(
	function (session, model) {
		var _p8 = model.mapState;
		if (_p8.ctor === 'Nothing') {
			return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
		} else {
			var _p9 = A3(
				_user$project$Pages_MapHelper$onPageEnter,
				_user$project$Pages_TreeMap$MsgFromMap,
				session,
				{mapState: _p8._0});
			var mapModel = _p9._0;
			var mapCmd = _p9._1;
			return {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Native_Utils.update(
					model,
					{
						mapState: _elm_lang$core$Maybe$Just(mapModel.mapState)
					}),
				_1: mapCmd
			};
		}
	});
var _user$project$Pages_TreeMap$subscriptions = _elm_lang$core$Platform_Sub$batch(
	{
		ctor: '::',
		_0: A2(_elm_lang$core$Platform_Sub$map, _user$project$Pages_TreeMap$MsgFromMap, _user$project$Map$subscriptions),
		_1: {
			ctor: '::',
			_0: _user$project$Ports$inboundInitParams(_user$project$Pages_TreeMap$OnInitParamsReceived),
			_1: {
				ctor: '::',
				_0: _user$project$Pages_TreeMap$barSubscriptions,
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$core$Platform_Sub$map,
						_user$project$Pages_TreeMap$OpsHandlerMsg,
						A2(_elm_lang$core$Platform_Sub$map, _user$project$OpsHandler$OpMsg, _user$project$Export_TreePDFExporter$subscriptions)),
					_1: {ctor: '[]'}
				}
			}
		}
	});
var _user$project$Pages_TreeMap$onEditDone = F4(
	function (session, model, closeSideBar, layerKeys) {
		var _p10 = model.mapState;
		if (_p10.ctor === 'Nothing') {
			return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
		} else {
			var _p11 = A4(
				_user$project$Map$resetMapAndLayers,
				_user$project$Pages_TreeMap$MsgFromMap,
				_user$project$Helpers_Data_Session$headers(session),
				_p10._0,
				layerKeys);
			var newMapState = _p11._0;
			var mapCmds = _p11._1;
			var newModel = closeSideBar ? _elm_lang$core$Native_Utils.update(
				model,
				{
					sideBar: _user$project$Pages_TreeMap$NoBar,
					mapState: _elm_lang$core$Maybe$Just(newMapState)
				}) : _elm_lang$core$Native_Utils.update(
				model,
				{
					mapState: _elm_lang$core$Maybe$Just(newMapState)
				});
			return {ctor: '_Tuple2', _0: newModel, _1: mapCmds};
		}
	});
var _user$project$Pages_TreeMap$resetAndCloseOpsHandler = F3(
	function (model, cmd, session) {
		var _p12 = A4(
			_user$project$Pages_TreeMap$onEditDone,
			session,
			model,
			false,
			{
				ctor: '::',
				_0: 'trees',
				_1: {ctor: '[]'}
			});
		var newModel = _p12._0;
		var newCmd = _p12._1;
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				newModel,
				{opsHandlerModel: _elm_lang$core$Maybe$Nothing}),
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: newCmd,
					_1: {
						ctor: '::',
						_0: cmd,
						_1: {ctor: '[]'}
					}
				})
		};
	});
var _user$project$Pages_TreeMap$MapGen = function (a) {
	return {ctor: 'MapGen', _0: a};
};
var _user$project$Pages_TreeMap$TreeUiBits = function (a) {
	return {ctor: 'TreeUiBits', _0: a};
};
var _user$project$Pages_TreeMap$Layers = function (a) {
	return {ctor: 'Layers', _0: a};
};
var _user$project$Pages_TreeMap$Groups = function (a) {
	return {ctor: 'Groups', _0: a};
};
var _user$project$Pages_TreeMap$GroupCanopyInfo = {ctor: 'GroupCanopyInfo'};
var _user$project$Pages_TreeMap$GroupCanopy = {ctor: 'GroupCanopy'};
var _user$project$Pages_TreeMap$GroupTreeInfo = {ctor: 'GroupTreeInfo'};
var _user$project$Pages_TreeMap$GroupTree = {ctor: 'GroupTree'};
var _user$project$Pages_TreeMap$WmtsAerial1974Info = {ctor: 'WmtsAerial1974Info'};
var _user$project$Pages_TreeMap$WmtsAerial1974 = {ctor: 'WmtsAerial1974'};
var _user$project$Pages_TreeMap$wmtsAerial1974 = _user$project$Map$wmtsLayerFromParams(
	{
		key: 'aerial_1974',
		name: _user$project$Pages_TreeMap$TreeUiBits(
			_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmtsAerial1974)),
		info: _user$project$Pages_TreeMap$TreeUiBits(
			_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmtsAerial1974Info)),
		isVisible: false,
		opacity: 1,
		url: 'https://wmts{5-9}.geo.admin.ch/1.0.0/{Layer}/default/1974/21781/{TileMatrix}/{TileRow}/{TileCol}.jpeg',
		layerName: 'ch.swisstopo.swissimage-product',
		urlRequest: _elm_lang$core$Maybe$Nothing
	});
var _user$project$Pages_TreeMap$WmtsCadasterNoInfo = {ctor: 'WmtsCadasterNoInfo'};
var _user$project$Pages_TreeMap$WmtsCadasterNo = {ctor: 'WmtsCadasterNo'};
var _user$project$Pages_TreeMap$tileOgcCadastreNoVd = function () {
	var infoFormat = 'application/geojson';
	var crs = 'EPSG:2056';
	var layerKeys = {
		ctor: '::',
		_0: 'vd.bien_fond_no',
		_1: {ctor: '[]'}
	};
	var url = 'https://www.ogc.vd.ch/public/services/OGC/wmsVD/Mapserver/WmsServer';
	return _user$project$Map$wmsTileLayerFromParamsWithScale(
		{
			key: 'cadastrevdno',
			name: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmtsCadasterNo)),
			info: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmtsCadasterNoInfo)),
			isVisible: false,
			opacity: 1,
			url: url,
			layerName: A2(_elm_lang$core$String$join, ',', layerKeys),
			minScale: _elm_lang$core$Maybe$Nothing,
			maxScale: _elm_lang$core$Maybe$Nothing,
			legendRequest: _elm_lang$core$Maybe$Just(
				{version: '1.3.0', format: 'image/png', legendOptions: _elm_lang$core$Maybe$Nothing}),
			urlRequest: _elm_lang$core$Maybe$Just(
				_user$project$Map_Data_Layer_URLRequest$createWMSUrlRequest(
					{
						baseURL: url,
						version: '1.3.0',
						layerKeys: layerKeys,
						width: 4096,
						height: 4096,
						crs: crs,
						styles: '',
						bbox: {minx: 2495198.353782, miny: 1116340.32, maxx: 2584350.0, maxy: 1202410.226},
						queryLayers: A2(_elm_lang$core$String$join, ',', layerKeys),
						infoFormat: infoFormat
					}))
		});
}();
var _user$project$Pages_TreeMap$WmtsCadasterInfo = {ctor: 'WmtsCadasterInfo'};
var _user$project$Pages_TreeMap$WmtsCadaster = {ctor: 'WmtsCadaster'};
var _user$project$Pages_TreeMap$tileOgcCadastreVd = function () {
	var infoFormat = 'application/geojson';
	var crs = 'EPSG:2056';
	var layerKeys = {
		ctor: '::',
		_0: 'vd.bien_fond',
		_1: {ctor: '[]'}
	};
	var url = 'https://www.ogc.vd.ch/public/services/OGC/wmsVD/Mapserver/WmsServer';
	return _user$project$Map$wmsTileLayerFromParamsWithScale(
		{
			key: 'cadastrevd',
			name: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmtsCadaster)),
			info: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmtsCadasterInfo)),
			isVisible: false,
			opacity: 1,
			url: url,
			layerName: A2(_elm_lang$core$String$join, ',', layerKeys),
			minScale: _elm_lang$core$Maybe$Nothing,
			maxScale: _elm_lang$core$Maybe$Nothing,
			legendRequest: _elm_lang$core$Maybe$Just(
				{version: '1.3.0', format: 'image/png', legendOptions: _elm_lang$core$Maybe$Nothing}),
			urlRequest: _elm_lang$core$Maybe$Just(
				_user$project$Map_Data_Layer_URLRequest$createWMSUrlRequest(
					{
						baseURL: url,
						version: '1.3.0',
						layerKeys: layerKeys,
						width: 4096,
						height: 4096,
						crs: crs,
						styles: '',
						bbox: {minx: 2495198.353782, miny: 1116340.32, maxx: 2584350.0, maxy: 1202410.226},
						queryLayers: A2(_elm_lang$core$String$join, ',', layerKeys),
						infoFormat: infoFormat
					}))
		});
}();
var _user$project$Pages_TreeMap$WmsWoodsVDInfo = {ctor: 'WmsWoodsVDInfo'};
var _user$project$Pages_TreeMap$WmsWoodsVD = {ctor: 'WmsWoodsVD'};
var _user$project$Pages_TreeMap$tileOgcWoodsVd = function () {
	var infoFormat = 'application/geojson';
	var crs = 'EPSG:2056';
	var layerKeys = {
		ctor: '::',
		_0: 'vd.surface_boisee',
		_1: {ctor: '[]'}
	};
	var url = 'https://www.ogc.vd.ch/public/services/OGC/wmsVD/Mapserver/WmsServer';
	return _user$project$Map$wmsTileLayerFromParamsWithScale(
		{
			key: 'foretsvd',
			name: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmsWoodsVD)),
			info: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$WmsWoodsVDInfo)),
			isVisible: false,
			opacity: 1,
			url: url,
			layerName: A2(_elm_lang$core$String$join, ',', layerKeys),
			minScale: _elm_lang$core$Maybe$Nothing,
			maxScale: _elm_lang$core$Maybe$Nothing,
			legendRequest: _elm_lang$core$Maybe$Just(
				{version: '1.3.0', format: 'image/png', legendOptions: _elm_lang$core$Maybe$Nothing}),
			urlRequest: _elm_lang$core$Maybe$Just(
				_user$project$Map_Data_Layer_URLRequest$createWMSUrlRequest(
					{
						baseURL: url,
						version: '1.3.0',
						layerKeys: layerKeys,
						width: 4096,
						height: 4096,
						crs: crs,
						styles: '',
						bbox: {minx: 2495198.353782, miny: 1116340.32, maxx: 2584350.0, maxy: 1202410.226},
						queryLayers: A2(_elm_lang$core$String$join, ',', layerKeys),
						infoFormat: infoFormat
					}))
		});
}();
var _user$project$Pages_TreeMap$LstInfo = {ctor: 'LstInfo'};
var _user$project$Pages_TreeMap$Lst = {ctor: 'Lst'};
var _user$project$Pages_TreeMap$lst = function (headerStrings) {
	var stroke = 'rgba(254,254,254,1)';
	var legend = _user$project$Map_Data_Layer_Legend$Rectangles(
		{
			ctor: '::',
			_0: {label: 'Elevée', fill: 'rgba(252,164,135,1)', stroke: stroke, strokeWidth: 0.0},
			_1: {
				ctor: '::',
				_0: {label: 'Très élevée', fill: 'rgba(235,54,42,1)', stroke: stroke, strokeWidth: 0.0},
				_1: {
					ctor: '::',
					_0: {label: 'Extrêmement élevée', fill: 'rgba(103,0,13,1)', stroke: stroke, strokeWidth: 0.0},
					_1: {ctor: '[]'}
				}
			}
		});
	return A2(
		_user$project$Map$addLegendToRasterLayer,
		legend,
		_user$project$Map$xyzTilesLayerFromParams(
			{
				key: 'lst',
				name: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$Lst)),
				info: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$LstInfo)),
				isVisible: false,
				opacity: 1,
				url: './lst/{z}/{x}/{y}.png',
				headers: headerStrings,
				urlRequest: _elm_lang$core$Maybe$Nothing
			}));
};
var _user$project$Pages_TreeMap$NdviInfo = {ctor: 'NdviInfo'};
var _user$project$Pages_TreeMap$Ndvi = {ctor: 'Ndvi'};
var _user$project$Pages_TreeMap$ndvi = function (headerStrings) {
	var stroke = 'rgba(254,254,254,1)';
	var legend = _user$project$Map_Data_Layer_Legend$Rectangles(
		{
			ctor: '::',
			_0: {label: 'Elevée', fill: 'rgba(43,131,186,1)', stroke: stroke, strokeWidth: 0.0},
			_1: {
				ctor: '::',
				_0: {label: 'Très élevée', fill: 'rgba(171,221,174,1)', stroke: stroke, strokeWidth: 0.0},
				_1: {ctor: '[]'}
			}
		});
	return A2(
		_user$project$Map$addLegendToRasterLayer,
		legend,
		_user$project$Map$xyzTilesLayerFromParams(
			{
				key: 'ndvi',
				name: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$Ndvi)),
				info: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$NdviInfo)),
				isVisible: false,
				opacity: 1,
				url: './ndvi/{z}/{x}/{y}.png',
				headers: headerStrings,
				urlRequest: _elm_lang$core$Maybe$Nothing
			}));
};
var _user$project$Pages_TreeMap$TreeHeightInfo = {ctor: 'TreeHeightInfo'};
var _user$project$Pages_TreeMap$TreeHeight = {ctor: 'TreeHeight'};
var _user$project$Pages_TreeMap$treeHeight = F2(
	function (headerStrings, baseUrl) {
		return _user$project$Map$mapBoxVectorTilesLayerFromParams(
			{
				key: 'treeHeight',
				name: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$TreeHeight)),
				info: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$TreeHeightInfo)),
				isVisible: false,
				opacity: 0.6,
				url: './treeheight/{z}/{x}/{y}.pbf',
				headers: headerStrings,
				style: _user$project$Map$vectorUniqueStyle('treeHeightStyle'),
				urlRequest: _elm_lang$core$Maybe$Nothing
			});
	});
var _user$project$Pages_TreeMap$VectorSvsTreeInfo = {ctor: 'VectorSvsTreeInfo'};
var _user$project$Pages_TreeMap$VectorSvsTree = {ctor: 'VectorSvsTree'};
var _user$project$Pages_TreeMap$svsTrees = function (baseUrl) {
	return _user$project$Map$vectorLayerFromAllParams(
		{
			key: 'svstrees',
			name: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$VectorSvsTree)),
			info: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$VectorSvsTreeInfo)),
			isVisible: false,
			opacity: 1,
			isInfoExpanded: false,
			loadMethod: _user$project$Map$vectorBatchLoadMethod('./protected/data/svs.json'),
			format: _user$project$Map$geoJsonFormatWithParams(
				{
					idPath: _elm_lang$core$Maybe$Just(
						{
							ctor: '::',
							_0: 'properties',
							_1: {
								ctor: '::',
								_0: 'Numéro',
								_1: {ctor: '[]'}
							}
						}),
					subObjPath: _elm_lang$core$Maybe$Nothing,
					subObjIdPath: _elm_lang$core$Maybe$Nothing
				}),
			clusterOptions: _user$project$Map$vectorNoCluster,
			minResolution: _elm_lang$core$Maybe$Nothing,
			maxResolution: _elm_lang$core$Maybe$Nothing,
			select: true,
			style: _user$project$Map$vectorUniqueStyle('svsTreeStyle'),
			urlRequest: _elm_lang$core$Maybe$Nothing
		});
};
var _user$project$Pages_TreeMap$canopyGroup = F2(
	function (session, baseUrl) {
		var canopyLayers = {
			ctor: '::',
			_0: _user$project$Pages_TreeMap$wmtsAerial1974,
			_1: {
				ctor: '::',
				_0: _user$project$Pages_TreeMap$tileOgcCadastreVd,
				_1: {
					ctor: '::',
					_0: _user$project$Pages_TreeMap$tileOgcCadastreNoVd,
					_1: {
						ctor: '::',
						_0: _user$project$Pages_TreeMap$tileOgcWoodsVd,
						_1: {
							ctor: '::',
							_0: A2(
								_user$project$Pages_TreeMap$treeHeight,
								_user$project$Helpers_Data_Session$headerStrings(session),
								baseUrl),
							_1: {
								ctor: '::',
								_0: _user$project$Pages_TreeMap$lst(
									_user$project$Helpers_Data_Session$headerStrings(session)),
								_1: {
									ctor: '::',
									_0: _user$project$Pages_TreeMap$ndvi(
										_user$project$Helpers_Data_Session$headerStrings(session)),
									_1: {
										ctor: '::',
										_0: _user$project$Pages_TreeMap$svsTrees(baseUrl),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			}
		};
		return _user$project$Map$layerGroupFromParams(
			{
				key: 'canopy_group',
				name: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Groups(_user$project$Pages_TreeMap$GroupCanopy)),
				info: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Groups(_user$project$Pages_TreeMap$GroupCanopyInfo)),
				isVisible: true,
				opacity: 1,
				isExpanded: false,
				reverseLayerListDisp: true,
				layers: canopyLayers
			});
	});
var _user$project$Pages_TreeMap$VectorTreeInfo = {ctor: 'VectorTreeInfo'};
var _user$project$Pages_TreeMap$VectorTree = {ctor: 'VectorTree'};
var _user$project$Pages_TreeMap$viewIsolatedTreePopup = F4(
	function (toUiTxt, session, isWithinGeoZoneList, value) {
		var mayObj = _elm_lang$core$Result$toMaybe(
			A2(
				_elm_lang$core$Result$mapError,
				function (err) {
					return A2(
						_elm_lang$core$Debug$log,
						_elm_lang$core$Basics$toString(err),
						err);
				},
				A2(_elm_lang$core$Json_Decode$decodeValue, _user$project$Data_Tree$decoder, value)));
		var buttonSz = 24;
		var _p13 = mayObj;
		if (_p13.ctor === 'Nothing') {
			return _mdgriffith$style_elements$Element$empty;
		} else {
			var _p16 = _p13._0;
			return A3(
				_mdgriffith$style_elements$Element$column,
				_user$project$Styles$NoStyle,
				{
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A3(
						_mdgriffith$style_elements$Element$el,
						_user$project$Styles$PopupHeader,
						{ctor: '[]'},
						_user$project$Pages_TreeMap$bitsToElem(
							_user$project$Pages_TreeMap$TreeUiBits(
								_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$VectorTree)))),
					_1: {
						ctor: '::',
						_0: A3(
							_mdgriffith$style_elements$Element$textLayout,
							_user$project$Styles$NoStyle,
							{
								ctor: '::',
								_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A3(
									_mdgriffith$style_elements$Element$paragraph,
									_user$project$Styles$NoStyle,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _mdgriffith$style_elements$Element$text('Variété: '),
										_1: {
											ctor: '::',
											_0: _mdgriffith$style_elements$Element$text(_p16.variety.latinName),
											_1: {ctor: '[]'}
										}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: function () {
								var _p14 = _p16.id;
								if (_p14.ctor === 'Nothing') {
									return _mdgriffith$style_elements$Element$empty;
								} else {
									var _p15 = _p14._0;
									return A3(
										_mdgriffith$style_elements$Element$row,
										_user$project$Styles$NoStyle,
										{
											ctor: '::',
											_0: _mdgriffith$style_elements$Element_Attributes$alignRight,
											_1: {
												ctor: '::',
												_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
												_1: {
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Attributes$padding(4),
													_1: {
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$spacing(6),
														_1: {ctor: '[]'}
													}
												}
											}
										},
										{
											ctor: '::',
											_0: A3(
												_mdgriffith$style_elements$Element$button,
												_user$project$Styles$StyleFromMap(_user$project$Map_Data_Styles$TrspBtn),
												{
													ctor: '::',
													_0: _mdgriffith$style_elements$Element_Events$onClick(
														A2(_user$project$Pages_TreeMap$OpenIsolatedTreeBar, _p15, false)),
													_1: {ctor: '[]'}
												},
												A3(
													_mdgriffith$style_elements$Element$image,
													_user$project$Styles$NoStyle,
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Attributes$height(
															_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
														_1: {
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$width(
																_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
															_1: {ctor: '[]'}
														}
													},
													{src: './images/next.svg', caption: 'voir'})),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$core$List$any,
													function (_) {
														return _.isWithin;
													},
													isWithinGeoZoneList) ? A3(
													_mdgriffith$style_elements$Element$button,
													_user$project$Styles$StyleFromMap(_user$project$Map_Data_Styles$TrspBtn),
													{
														ctor: '::',
														_0: _mdgriffith$style_elements$Element_Events$onClick(
															A2(_user$project$Pages_TreeMap$OpenIsolatedTreeBar, _p15, true)),
														_1: {ctor: '[]'}
													},
													A3(
														_mdgriffith$style_elements$Element$image,
														_user$project$Styles$NoStyle,
														{
															ctor: '::',
															_0: _mdgriffith$style_elements$Element_Attributes$height(
																_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
															_1: {
																ctor: '::',
																_0: _mdgriffith$style_elements$Element_Attributes$width(
																	_mdgriffith$style_elements$Element_Attributes$px(buttonSz)),
																_1: {ctor: '[]'}
															}
														},
														{src: './images/edit.svg', caption: 'éditer'})) : _mdgriffith$style_elements$Element$empty,
												_1: {ctor: '[]'}
											}
										});
								}
							}(),
							_1: {ctor: '[]'}
						}
					}
				});
		}
	});
var _user$project$Pages_TreeMap$toPopup = F4(
	function (toUiTxt, lang, session, posInfo) {
		var mayFeatureData = _elm_lang$core$List$head(
			A2(
				_elm_lang$core$List$filterMap,
				function (f) {
					return (_elm_lang$core$Native_Utils.eq(f.layerKey, 'trees') || _elm_lang$core$Native_Utils.eq(f.layerKey, 'svsTrees')) ? _elm_lang$core$Maybe$Just(f) : _elm_lang$core$Maybe$Nothing;
				},
				posInfo.featuresData));
		var _p17 = mayFeatureData;
		if (_p17.ctor === 'Just') {
			return {
				ctor: '::',
				_0: A4(_user$project$Pages_TreeMap$viewIsolatedTreePopup, toUiTxt, session, posInfo.checkedNamedGeoZones, _p17._0.data),
				_1: {ctor: '[]'}
			};
		} else {
			return A3(_user$project$Pages_MapHelper$viewGenPopupInfos, lang, session, posInfo);
		}
	});
var _user$project$Pages_TreeMap$mapViewConfig = F3(
	function (toUiTxt, session, model) {
		return _user$project$Map$config(
			{
				msgFromMap: _user$project$Pages_TreeMap$MsgFromMap,
				toPopup: A3(_user$project$Pages_TreeMap$toPopup, toUiTxt, _user$project$Helpers_Data_Language$FR, session),
				uiBits: A3(_user$project$Pages_TreeMap$mapUiElements, toUiTxt, session, model),
				styling: _user$project$Pages_TreeMap$mapStyling
			});
	});
var _user$project$Pages_TreeMap$view = F5(
	function (lang, toUiTxt, device, session, model) {
		var sideBar = A4(_user$project$Pages_TreeMap$viewSideBar, toUiTxt, device, session, model);
		var _p18 = ((device.phone || device.tablet) && (!_elm_lang$core$Native_Utils.eq(sideBar, _mdgriffith$style_elements$Element$empty))) ? {
			ctor: '_Tuple2',
			_0: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$hidden,
						_1: {ctor: '[]'}
					}
				}
			},
			_1: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
						_1: {
							ctor: '::',
							_0: _mdgriffith$style_elements$Element_Attributes$scrollbars,
							_1: {ctor: '[]'}
						}
					}
				}
			}
		} : ((!_elm_lang$core$Native_Utils.eq(sideBar, _mdgriffith$style_elements$Element$empty)) ? {
			ctor: '_Tuple2',
			_0: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				}
			},
			_1: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$width(
						_mdgriffith$style_elements$Element_Attributes$px(460)),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$padding(10),
						_1: {ctor: '[]'}
					}
				}
			}
		} : {
			ctor: '_Tuple2',
			_0: {
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {ctor: '[]'}
				}
			},
			_1: {ctor: '[]'}
		});
		var mapAttrs = _p18._0;
		var sideBarAttrs = _p18._1;
		return A3(
			_mdgriffith$style_elements$Element$row,
			_user$project$Styles$NoStyle,
			{
				ctor: '::',
				_0: _mdgriffith$style_elements$Element_Attributes$width(_mdgriffith$style_elements$Element_Attributes$fill),
				_1: {
					ctor: '::',
					_0: _mdgriffith$style_elements$Element_Attributes$height(_mdgriffith$style_elements$Element_Attributes$fill),
					_1: {
						ctor: '::',
						_0: _mdgriffith$style_elements$Element_Attributes$clipY,
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: function () {
					var _p19 = model.mapState;
					if (_p19.ctor === 'Nothing') {
						return _mdgriffith$style_elements$Element$empty;
					} else {
						return A3(
							_mdgriffith$style_elements$Element$el,
							_user$project$Styles$NoStyle,
							mapAttrs,
							A3(
								_user$project$Map$view,
								A3(_user$project$Pages_TreeMap$mapViewConfig, toUiTxt, session, model),
								460,
								_p19._0));
					}
				}(),
				_1: {
					ctor: '::',
					_0: A3(_mdgriffith$style_elements$Element$el, _user$project$Styles$NoStyle, sideBarAttrs, sideBar),
					_1: {
						ctor: '::',
						_0: function () {
							var _p20 = model.opsHandlerModel;
							if (_p20.ctor === 'Nothing') {
								return _mdgriffith$style_elements$Element$empty;
							} else {
								return A5(_user$project$OpsHandler$view, _user$project$Pages_TreeMap$OpsHandlerMsg, _user$project$Styles$StylesFromOpsHandler, _user$project$Styles$VariationsFromOpsHandler, _user$project$Export_TreePDFExporter$manageViews, _p20._0);
							}
						}(),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Pages_TreeMap$isolatedTreesLayer = function (baseUrl) {
	var defaultStyle = 'isolatedTreeStyleIsRanked';
	var key = 'trees';
	return _user$project$Map$vectorLayerFromAllParams(
		{
			key: key,
			name: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$VectorTree)),
			info: _user$project$Pages_TreeMap$TreeUiBits(
				_user$project$Pages_TreeMap$Layers(_user$project$Pages_TreeMap$VectorTreeInfo)),
			isVisible: true,
			opacity: 1,
			isInfoExpanded: false,
			loadMethod: _user$project$Map$vectorBatchLoadMethod('./isolatedtree?$eager=[variety,documents]&$modify={\"formatGeom\":[\"GeoJSON\",2]}'),
			format: _user$project$Map$geoJsonFormatWithParams(
				{
					idPath: _elm_lang$core$Maybe$Just(
						{
							ctor: '::',
							_0: 'id',
							_1: {ctor: '[]'}
						}),
					subObjPath: _elm_lang$core$Maybe$Nothing,
					subObjIdPath: _elm_lang$core$Maybe$Nothing
				}),
			clusterOptions: _user$project$Map$vectorNoCluster,
			minResolution: _elm_lang$core$Maybe$Nothing,
			maxResolution: _elm_lang$core$Maybe$Nothing,
			select: true,
			style: A4(
				_user$project$Map$vectorChoiceBasedStyles,
				_user$project$Pages_TreeMap$MsgFromMap,
				key,
				defaultStyle,
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'map_isolatedTree_isRanked', _1: defaultStyle},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'map_isolatedTree_circumference', _1: 'isolatedTreeStyleCircumference'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'map_isolatedTree_has_sh_interest', _1: 'isolatedTreeStyleHasSHInterest'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'map_isolatedTree_score', _1: 'isolatedTreeStyleScore'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'map_isolatedTree_isConsult', _1: 'isolatedTreeStyleIsConsult'},
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}),
			urlRequest: _elm_lang$core$Maybe$Nothing
		});
};
var _user$project$Pages_TreeMap$treeGroup = F2(
	function (session, baseUrl) {
		var treeLayers = {
			ctor: '::',
			_0: _user$project$Pages_TreeMap$isolatedTreesLayer(baseUrl),
			_1: {ctor: '[]'}
		};
		return _user$project$Map$layerGroupFromParams(
			{
				key: 'tree_group',
				name: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Groups(_user$project$Pages_TreeMap$GroupTree)),
				info: _user$project$Pages_TreeMap$TreeUiBits(
					_user$project$Pages_TreeMap$Groups(_user$project$Pages_TreeMap$GroupTreeInfo)),
				isVisible: true,
				opacity: 1,
				isExpanded: false,
				reverseLayerListDisp: true,
				layers: treeLayers
			});
	});
var _user$project$Pages_TreeMap$customLayers = F2(
	function (session, baseUrl) {
		return {
			ctor: '::',
			_0: A2(_user$project$Pages_TreeMap$canopyGroup, session, baseUrl),
			_1: {
				ctor: '::',
				_0: A2(_user$project$Pages_TreeMap$treeGroup, session, baseUrl),
				_1: {ctor: '[]'}
			}
		};
	});
var _user$project$Pages_TreeMap$init = F3(
	function (baseUrl, session, device) {
		var notSmallDevice = !(device.phone || device.tablet);
		var geoZones = _user$project$Pages_TreeMap$namedGeoZones(session);
		var geoObjs = A2(_elm_lang$core$List$map, _user$project$Pages_TreeMap$geoZone2geoObj, geoZones);
		if (!_elm_lang$core$List$isEmpty(geoObjs)) {
			return {
				ctor: '_Tuple2',
				_0: {mapState: _elm_lang$core$Maybe$Nothing, sideBar: _user$project$Pages_TreeMap$NoBar, notSmallDevice: notSmallDevice, opsHandlerModel: _elm_lang$core$Maybe$Nothing},
				_1: _user$project$Ports$getExtent(
					{geoObjs: geoObjs, geoZones: geoZones})
			};
		} else {
			var layers = A2(
				_elm_lang$core$List$append,
				A4(_user$project$Pages_MapHelper$genLayers, _user$project$Pages_TreeMap$MapGen, session, 'wmtsBackgroundGrey', geoZones),
				A2(_user$project$Pages_TreeMap$customLayers, session, baseUrl));
			var _p21 = A5(_user$project$Map$init, _user$project$Pages_TreeMap$MsgFromMap, 'treemap', _user$project$Pages_MapHelper$mapSettings, layers, notSmallDevice);
			var initMapState = _p21._0;
			var initMapCmd = _p21._1;
			return {
				ctor: '_Tuple2',
				_0: {
					mapState: _elm_lang$core$Maybe$Just(initMapState),
					sideBar: _user$project$Pages_TreeMap$NoBar,
					notSmallDevice: notSmallDevice,
					opsHandlerModel: _elm_lang$core$Maybe$Nothing
				},
				_1: initMapCmd
			};
		}
	});
var _user$project$Pages_TreeMap$update = F5(
	function (toUiTxt, baseUrl, session, msg, model) {
		update:
		while (true) {
			var treeAdded = 'add_tree';
			var treesLayer = 'trees';
			var geomEditGeoZone = A2(_user$project$Data_Role$getRoleGeom, session.token, _user$project$Data_Role$TreeEditor);
			var _p22 = msg;
			switch (_p22.ctor) {
				case 'MsgFromMap':
					var _p23 = model.mapState;
					if (_p23.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					} else {
						var _p29 = _p23._0;
						var _p24 = A5(
							_user$project$Map$update,
							_user$project$Pages_TreeMap$MsgFromMap,
							_user$project$Helpers_Data_Session$headers(session),
							_user$project$Pages_TreeMap$namedGeoZones(session),
							_p22._0,
							_p29);
						var newMapState = _p24._0;
						var mapCmd = _p24._1;
						var mapOutMsg = _p24._2;
						var action = _p24._3;
						var _p25 = A4(
							_user$project$Action$execute,
							A3(_user$project$Pages_TreeMap$toActionExecCfg, toUiTxt, baseUrl, session),
							action,
							_elm_lang$core$Native_Utils.update(
								model,
								{
									mapState: _elm_lang$core$Maybe$Just(newMapState)
								}),
							mapCmd);
						var newModel = _p25._0;
						var cmd = _p25._1;
						var _p26 = mapOutMsg;
						if (((_p26.ctor === 'Mode') && (_p26._0.ctor === 'AddGeomEnded')) && (_p26._0._1.ctor === 'Just')) {
							var _p27 = A2(_elm_lang$core$Maybe$withDefault, 'noName', _p26._0._0);
							if (_p27 === 'add_tree') {
								var disableDrawAICmd = _user$project$Map$disableDrawIA(
									{map: _p29.map});
								var _p28 = A4(_user$project$Views_IsolatedTree$initNew, _user$project$Pages_TreeMap$MsgFromIsolatedTreeBar, session, _p26._0._1._0.geom, baseUrl);
								var newFormModel = _p28._0;
								var formCmd = _p28._1;
								var cmds = _elm_lang$core$Platform_Cmd$batch(
									{
										ctor: '::',
										_0: disableDrawAICmd,
										_1: {
											ctor: '::',
											_0: _user$project$Map$resize(_p29),
											_1: {
												ctor: '::',
												_0: formCmd,
												_1: {
													ctor: '::',
													_0: cmd,
													_1: {ctor: '[]'}
												}
											}
										}
									});
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										newModel,
										{
											sideBar: _user$project$Pages_TreeMap$IsolatedTreeBar(newFormModel)
										}),
									_1: cmds
								};
							} else {
								return {ctor: '_Tuple2', _0: newModel, _1: cmd};
							}
						} else {
							return {ctor: '_Tuple2', _0: newModel, _1: cmd};
						}
					}
				case 'OnInitParamsReceived':
					var _p31 = _p22._0;
					var layers = A2(
						_elm_lang$core$List$append,
						A4(_user$project$Pages_MapHelper$genLayers, _user$project$Pages_TreeMap$MapGen, session, 'wmtsBackgroundGrey', _p31.geoZones),
						A2(_user$project$Pages_TreeMap$customLayers, session, baseUrl));
					var mapSettings = _user$project$Map$settingsFromCoreParams(
						{
							projection: {code: 'EPSG:2056', proj4String: '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs'},
							extent: {minx: 2420000, miny: 130000, maxx: 2900000, maxy: 1350000},
							center: _p31.center,
							zoom: _p31.zoom,
							geolocAndBlink: {ctor: '_Tuple3', _0: false, _1: 10, _2: false}
						});
					var _p30 = A5(_user$project$Map$init, _user$project$Pages_TreeMap$MsgFromMap, 'treemap', mapSettings, layers, model.notSmallDevice);
					var initMapState = _p30._0;
					var initMapCmd = _p30._1;
					var newModel = _elm_lang$core$Native_Utils.update(
						model,
						{
							mapState: _elm_lang$core$Maybe$Just(initMapState)
						});
					return {ctor: '_Tuple2', _0: newModel, _1: initMapCmd};
				case 'OpenIsolatedTreeBar':
					var _p32 = model.mapState;
					if (_p32.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					} else {
						var _p33 = A5(
							_user$project$Views_IsolatedTree$init,
							_user$project$Pages_TreeMap$MsgFromIsolatedTreeBar,
							session,
							_elm_lang$core$Maybe$Just(_p22._0),
							_p22._1,
							baseUrl);
						var formModel = _p33._0;
						var formCmd = _p33._1;
						var cmds = _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: _user$project$Map$resize(_p32._0),
								_1: {
									ctor: '::',
									_0: formCmd,
									_1: {ctor: '[]'}
								}
							});
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									sideBar: _user$project$Pages_TreeMap$IsolatedTreeBar(formModel)
								}),
							_1: cmds
						};
					}
				case 'MsgFromIsolatedTreeBar':
					var _p34 = model.sideBar;
					if (_p34.ctor === 'IsolatedTreeBar') {
						var _p35 = A6(_user$project$Views_IsolatedTree$update, _user$project$Pages_TreeMap$MsgFromIsolatedTreeBar, _user$project$Pages_TreeMap$SideBarSaved, baseUrl, session, _p22._0, _p34._0);
						var newFormModel = _p35._0;
						var formCmd = _p35._1;
						var viewsOutMsg = _p35._2;
						var _p36 = viewsOutMsg;
						if (_p36.ctor === 'LaunchExporter') {
							var newModel = _elm_lang$core$Native_Utils.update(
								model,
								{
									sideBar: _user$project$Pages_TreeMap$IsolatedTreeBar(newFormModel)
								});
							var _v22 = toUiTxt,
								_v23 = baseUrl,
								_v24 = session,
								_v25 = _user$project$Pages_TreeMap$ExportPDFMode(
								_elm_lang$core$Maybe$Just(_p36._0)),
								_v26 = newModel;
							toUiTxt = _v22;
							baseUrl = _v23;
							session = _v24;
							msg = _v25;
							model = _v26;
							continue update;
						} else {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										sideBar: _user$project$Pages_TreeMap$IsolatedTreeBar(newFormModel)
									}),
								_1: formCmd
							};
						}
					} else {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					}
				case 'OpenSortFilterBar':
					var _p37 = model.mapState;
					if (_p37.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					} else {
						var _p39 = _p37._0;
						var _p38 = A4(_user$project$Views_SortFilter$init, _user$project$Pages_TreeMap$MsgFromSortFilterBar, baseUrl, session, _p39);
						var formModel = _p38._0;
						var formMapState = _p38._1;
						var formCmd = _p38._2;
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									sideBar: _user$project$Pages_TreeMap$SortFilterBar(formModel),
									mapState: _elm_lang$core$Maybe$Just(formMapState)
								}),
							_1: _elm_lang$core$Platform_Cmd$batch(
								{
									ctor: '::',
									_0: formCmd,
									_1: {
										ctor: '::',
										_0: _user$project$Map$resize(_p39),
										_1: {ctor: '[]'}
									}
								})
						};
					}
				case 'MsgFromSortFilterBar':
					var _p40 = model.mapState;
					if (_p40.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					} else {
						var _p41 = model.sideBar;
						if (_p41.ctor === 'SortFilterBar') {
							var _p42 = A7(_user$project$Views_SortFilter$update, _user$project$Pages_TreeMap$MsgFromSortFilterBar, _user$project$Pages_TreeMap$SideBarSaved, baseUrl, session, _p22._0, _p41._0, _p40._0);
							var newFormModel = _p42._0;
							var formCmd = _p42._1;
							var formMapState = _p42._2;
							var viewsOutMsg = _p42._3;
							var _p43 = viewsOutMsg;
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										sideBar: _user$project$Pages_TreeMap$SortFilterBar(newFormModel),
										mapState: _elm_lang$core$Maybe$Just(formMapState)
									}),
								_1: formCmd
							};
						} else {
							return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
						}
					}
				case 'SideBarClosed':
					return A4(
						_user$project$Pages_TreeMap$onEditDone,
						session,
						model,
						true,
						{
							ctor: '::',
							_0: 'trees',
							_1: {ctor: '[]'}
						});
				case 'SideBarSaved':
					return A4(
						_user$project$Pages_TreeMap$onEditDone,
						session,
						model,
						false,
						{
							ctor: '::',
							_0: 'trees',
							_1: {ctor: '[]'}
						});
				case 'StartAddMode':
					var _p44 = model.mapState;
					if (_p44.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					} else {
						var _p46 = _p44._0;
						var _p45 = A5(
							_user$project$Map$startAddPointMode,
							_p46,
							_elm_lang$core$Maybe$Just(treeAdded),
							treesLayer,
							true,
							geomEditGeoZone);
						var newMapState = _p45._0;
						var mapCmd = _p45._1;
						var cmds = _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: mapCmd,
								_1: {
									ctor: '::',
									_0: _user$project$Map$resize(_p46),
									_1: {ctor: '[]'}
								}
							});
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									mapState: _elm_lang$core$Maybe$Just(newMapState),
									sideBar: _user$project$Pages_TreeMap$NoBar
								}),
							_1: cmds
						};
					}
				case 'StartModifyMode':
					var _p47 = model.mapState;
					if (_p47.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					} else {
						var _p49 = _p47._0;
						var _p48 = A4(_user$project$Map$startModifyGeomsMode, _p49, treesLayer, true, _elm_lang$core$Maybe$Nothing);
						var newMapState = _p48._0;
						var mapCmd = _p48._1;
						var cmds = _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: mapCmd,
								_1: {
									ctor: '::',
									_0: _user$project$Map$resize(_p49),
									_1: {ctor: '[]'}
								}
							});
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									mapState: _elm_lang$core$Maybe$Just(newMapState),
									sideBar: _user$project$Pages_TreeMap$NoBar
								}),
							_1: cmds
						};
					}
				case 'StartDeleteMode':
					var _p50 = model.mapState;
					if (_p50.ctor === 'Nothing') {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					} else {
						var _p52 = _p50._0;
						var _p51 = A3(_user$project$Map$startDeleteObjsMode, _p52, treesLayer, _elm_lang$core$Maybe$Nothing);
						var newMapState = _p51._0;
						var mapCmd = _p51._1;
						var cmds = _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: mapCmd,
								_1: {
									ctor: '::',
									_0: _user$project$Map$resize(_p52),
									_1: {ctor: '[]'}
								}
							});
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									mapState: _elm_lang$core$Maybe$Just(newMapState),
									sideBar: _user$project$Pages_TreeMap$NoBar
								}),
							_1: cmds
						};
					}
				case 'OpsHandlerMsg':
					var _p53 = function () {
						var _p54 = {ctor: '_Tuple2', _0: model.opsHandlerModel, _1: model.mapState};
						if ((_p54._0.ctor === 'Just') && (_p54._1.ctor === 'Just')) {
							var _p55 = A6(
								_user$project$OpsHandler$update,
								_user$project$Pages_TreeMap$OpsHandlerMsg,
								A3(_user$project$Export_TreePDFExporter$updateConfig, toUiTxt, _user$project$Pages_TreeMap$MsgFromMap, _user$project$Pages_TreeMap$OpsHandlerMsg),
								A2(_user$project$Pages_TreeMap$createExpOpInitData, _p54._1._0, session),
								{},
								_p22._0,
								_p54._0._0);
							var newOpsHandlerModel = _p55._0;
							var opsHandlerCmds = _p55._1;
							var opsHandlerOutMsg = _p55._2;
							var action = _p55._3;
							return {
								ctor: '_Tuple4',
								_0: _elm_lang$core$Maybe$Just(newOpsHandlerModel),
								_1: opsHandlerCmds,
								_2: opsHandlerOutMsg,
								_3: action
							};
						} else {
							return {ctor: '_Tuple4', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$OpsHandler$NoOutMsg, _3: _user$project$Action$none};
						}
					}();
					var newMayOpsHandlerModel = _p53._0;
					var opsHandlerCmds = _p53._1;
					var opsHandlerOutMsg = _p53._2;
					var action = _p53._3;
					var newModel = _elm_lang$core$Native_Utils.update(
						model,
						{opsHandlerModel: newMayOpsHandlerModel});
					var _p56 = opsHandlerOutMsg;
					switch (_p56.ctor) {
						case 'Canceled':
							return A3(_user$project$Pages_TreeMap$resetAndCloseOpsHandler, model, _elm_lang$core$Platform_Cmd$none, session);
						case 'Done':
							return A3(_user$project$Pages_TreeMap$resetAndCloseOpsHandler, model, _elm_lang$core$Platform_Cmd$none, session);
						default:
							return A4(
								_user$project$Action$execute,
								A3(_user$project$Pages_TreeMap$toActionExecCfg, toUiTxt, baseUrl, session),
								action,
								newModel,
								opsHandlerCmds);
					}
				case 'ExportPDFMode':
					var _p57 = function () {
						var _p58 = model.mapState;
						if (_p58.ctor === 'Just') {
							var _p61 = _p58._0;
							var _p59 = function () {
								var _p60 = _p22._0;
								if (_p60.ctor === 'Just') {
									var selectOpModel = _user$project$Export_TreePDFExporter$MapSelectOp(
										{
											maySelectedItems: _elm_lang$core$Maybe$Just(
												{
													ctor: '::',
													_0: _p60._0,
													_1: {ctor: '[]'}
												})
										});
									return A5(
										_user$project$OpsHandler$initWithOpData,
										_user$project$Pages_TreeMap$OpsHandlerMsg,
										A3(_user$project$Export_TreePDFExporter$manageExpOpInits, _user$project$Pages_TreeMap$MsgFromMap, _user$project$Pages_TreeMap$OpsHandlerMsg, toUiTxt),
										A2(_user$project$Pages_TreeMap$createExpOpInitData, _p61, session),
										{
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: _user$project$Export_TreePDFExporter$MapSelectOpKey, _1: selectOpModel},
											_1: {ctor: '[]'}
										},
										_user$project$Export_TreePDFExporter$MapPanAndZoomOpKey(18));
								} else {
									return A5(
										_user$project$OpsHandler$initWithOpData,
										_user$project$Pages_TreeMap$OpsHandlerMsg,
										A3(_user$project$Export_TreePDFExporter$manageExpOpInits, _user$project$Pages_TreeMap$MsgFromMap, _user$project$Pages_TreeMap$OpsHandlerMsg, toUiTxt),
										A2(_user$project$Pages_TreeMap$createExpOpInitData, _p61, session),
										{ctor: '[]'},
										_user$project$Export_TreePDFExporter$MapSelectOpKey);
								}
							}();
							var opsHandlerModel = _p59._0;
							var opsHandlerCmd = _p59._1;
							var action = _p59._2;
							return {
								ctor: '_Tuple3',
								_0: _elm_lang$core$Maybe$Just(opsHandlerModel),
								_1: opsHandlerCmd,
								_2: action
							};
						} else {
							return {ctor: '_Tuple3', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Platform_Cmd$none, _2: _user$project$Action$none};
						}
					}();
					var opsHandlerModel = _p57._0;
					var opsHandlerCmd = _p57._1;
					var action = _p57._2;
					var newModel = _elm_lang$core$Native_Utils.update(
						model,
						{opsHandlerModel: opsHandlerModel});
					return A4(
						_user$project$Action$execute,
						A3(_user$project$Pages_TreeMap$toActionExecCfg, toUiTxt, baseUrl, session),
						action,
						newModel,
						opsHandlerCmd);
				default:
					return A3(_user$project$Pages_TreeMap$resetAndCloseOpsHandler, model, _elm_lang$core$Platform_Cmd$none, session);
			}
		}
	});
var _user$project$Pages_TreeMap$toActionExecCfg = F3(
	function (toUiTxt, baseUrl, session) {
		return {
			execCustAction: F2(
				function (action, model) {
					return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
				}),
			sendMsg: A3(_user$project$Pages_TreeMap$update, toUiTxt, baseUrl, session)
		};
	});

var _user$project$Main$clearSession = function (model) {
	var session = model.session;
	return {
		ctor: '_Tuple2',
		_0: _elm_lang$core$Native_Utils.update(
			model,
			{
				session: _elm_lang$core$Native_Utils.update(
					session,
					{token: _elm_lang$core$Maybe$Nothing})
			}),
		_1: _user$project$Ports$storeSession(_elm_lang$core$Maybe$Nothing)
	};
};
var _user$project$Main$getPage = function (pageState) {
	var _p0 = pageState;
	if (_p0.ctor === 'Ready') {
		return _p0._0;
	} else {
		return _p0._0;
	}
};
var _user$project$Main$sessionChange = _user$project$Ports$onSessionChange(_user$project$Helpers_Data_JwtToken$fromString);
var _user$project$Main$Flags = F4(
	function (a, b, c, d) {
		return {language: a, uiKeyVals: b, baseUrl: c, authToken: d};
	});
var _user$project$Main$Model = F7(
	function (a, b, c, d, e, f, g) {
		return {session: a, pageState: b, baseUrl: c, language: d, langDict: e, device: f, treeMapModel: g};
	});
var _user$project$Main$TreeMap = function (a) {
	return {ctor: 'TreeMap', _0: a};
};
var _user$project$Main$Login = F2(
	function (a, b) {
		return {ctor: 'Login', _0: a, _1: b};
	});
var _user$project$Main$Errored = function (a) {
	return {ctor: 'Errored', _0: a};
};
var _user$project$Main$None = {ctor: 'None'};
var _user$project$Main$TransitioningFrom = function (a) {
	return {ctor: 'TransitioningFrom', _0: a};
};
var _user$project$Main$Ready = function (a) {
	return {ctor: 'Ready', _0: a};
};
var _user$project$Main$redirectToLogin = F2(
	function (mayRouteAfterLogin, model) {
		var mayRouteAfterLoginWithoutLoginRoute = function () {
			var _p1 = mayRouteAfterLogin;
			if ((_p1.ctor === 'Just') && (_p1._0.ctor === 'Login')) {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return mayRouteAfterLogin;
			}
		}();
		var newPageState = _user$project$Main$Ready(
			A2(
				_user$project$Main$Login,
				mayRouteAfterLoginWithoutLoginRoute,
				_user$project$Pages_Login$init(
					A2(_elm_lang$core$Basics_ops['++'], model.baseUrl, 'authservice/login'))));
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				model,
				{pageState: newPageState}),
			_1: _user$project$Routing$modifyUrl(_user$project$Routing$Login)
		};
	});
var _user$project$Main$pageErrored = F2(
	function (model, errorMessage) {
		var error = _user$project$Helpers_Views_Errored$pageLoadError(errorMessage);
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Native_Utils.update(
				model,
				{
					pageState: _user$project$Main$Ready(
						_user$project$Main$Errored(error))
				}),
			_1: _elm_lang$core$Platform_Cmd$none
		};
	});
var _user$project$Main$TreeMapMsg = function (a) {
	return {ctor: 'TreeMapMsg', _0: a};
};
var _user$project$Main$pageSubscriptions = function (page) {
	var _p2 = page;
	if (_p2.ctor === 'TreeMap') {
		return A2(_elm_lang$core$Platform_Sub$map, _user$project$Main$TreeMapMsg, _user$project$Pages_TreeMap$subscriptions);
	} else {
		return _elm_lang$core$Platform_Sub$none;
	}
};
var _user$project$Main$setPage = F2(
	function (maybeRoute, model) {
		var errored = function (activePage) {
			return _user$project$Main$pageErrored(model);
		};
		var transition = F2(
			function (toMsg, task) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							pageState: _user$project$Main$TransitioningFrom(
								_user$project$Main$getPage(model.pageState))
						}),
					_1: A2(_elm_lang$core$Task$attempt, toMsg, task)
				};
			});
		var _p3 = maybeRoute;
		if (_p3.ctor === 'Nothing') {
			return A2(errored, _user$project$Views_Page$NoHeader, 'Not found');
		} else {
			switch (_p3._0.ctor) {
				case 'Login':
					var newPageState = function () {
						var _p4 = model.pageState;
						if ((_p4.ctor === 'Ready') && (_p4._0.ctor === 'Login')) {
							return model.pageState;
						} else {
							return _user$project$Main$Ready(
								A2(
									_user$project$Main$Login,
									_elm_lang$core$Maybe$Nothing,
									_user$project$Pages_Login$init(
										A2(_elm_lang$core$Basics_ops['++'], model.baseUrl, 'authservice/login'))));
						}
					}();
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{pageState: newPageState}),
						_1: _elm_lang$core$Platform_Cmd$none
					};
				case 'Logout':
					var _p5 = _user$project$Main$clearSession(model);
					var clearSessionModel = _p5._0;
					var clearSessionCmd = _p5._1;
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							clearSessionModel,
							{
								pageState: _user$project$Main$Ready(
									A2(
										_user$project$Main$Login,
										_elm_lang$core$Maybe$Nothing,
										_user$project$Pages_Login$init(
											A2(_elm_lang$core$Basics_ops['++'], model.baseUrl, 'authservice/login'))))
							}),
						_1: _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: clearSessionCmd,
								_1: {
									ctor: '::',
									_0: _user$project$Routing$modifyUrl(_user$project$Routing$Login),
									_1: {ctor: '[]'}
								}
							})
					};
				case 'TreeMap':
					var _p6 = model.session.token;
					if (_p6.ctor === 'Just') {
						var _p7 = function () {
							var _p8 = model.treeMapModel;
							if (_p8.ctor === 'Nothing') {
								return A3(_user$project$Pages_TreeMap$init, model.baseUrl, model.session, model.device);
							} else {
								return A2(_user$project$Pages_TreeMap$onEnter, model.session, _p8._0);
							}
						}();
						var pageModel = _p7._0;
						var pageCmd = _p7._1;
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									pageState: _user$project$Main$Ready(
										_user$project$Main$TreeMap(pageModel))
								}),
							_1: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Main$TreeMapMsg, pageCmd)
						};
					} else {
						return A2(errored, _user$project$Views_Page$NoHeader, 'Invalid access rights to this page');
					}
				case 'ViewFile':
					var _p9 = _user$project$Helpers_Data_JwtToken$toString(model.session.token);
					if (_p9.ctor === 'Nothing') {
						return A2(errored, _user$project$Views_Page$NoHeader, 'JWT non trouvé; essayez de vous logger à nouveau s\'il vous plait.');
					} else {
						var partFileUrl = A2(
							_elm_lang$core$Basics_ops['++'],
							model.baseUrl,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'tree-filesservice/',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p3._0._0,
									A2(_elm_lang$core$Basics_ops['++'], '?jwt=', _p9._0))));
						var fileUrl = function () {
							var _p10 = _p3._0._1;
							if (_p10.ctor === 'Nothing') {
								return partFileUrl;
							} else {
								return A2(
									_elm_lang$core$Basics_ops['++'],
									partFileUrl,
									A2(_elm_lang$core$Basics_ops['++'], '&filename=', _p10._0));
							}
						}();
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _elm_lang$navigation$Navigation$load(fileUrl)
						};
					}
				default:
					var _p11 = _user$project$Helpers_Data_JwtToken$toString(model.session.token);
					if (_p11.ctor === 'Nothing') {
						return A2(errored, _user$project$Views_Page$NoHeader, 'JWT non trouvé; essayez de vous logger à nouveau s\'il vous plait.');
					} else {
						var fileUrl = A2(
							_elm_lang$core$Basics_ops['++'],
							model.baseUrl,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'files-with-expiration/',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p3._0._0,
									A2(_elm_lang$core$Basics_ops['++'], '?jwt=', _p11._0))));
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _elm_lang$navigation$Navigation$load(fileUrl)
						};
					}
			}
		}
	});
var _user$project$Main$LoginMsg = function (a) {
	return {ctor: 'LoginMsg', _0: a};
};
var _user$project$Main$updatePage = F3(
	function (page, msg, model) {
		var session = model.session;
		var updateModelCmd = F5(
			function (toPage, toMsg, subUpdate, subMsg, subModel) {
				var _p12 = A4(subUpdate, model.baseUrl, session, subMsg, subModel);
				var pageModel = _p12._0;
				var pageCmd = _p12._1;
				var newPage = toPage(pageModel);
				var modifModel = function () {
					var _p13 = newPage;
					if (_p13.ctor === 'TreeMap') {
						return _elm_lang$core$Native_Utils.update(
							model,
							{
								treeMapModel: _elm_lang$core$Maybe$Just(_p13._0)
							});
					} else {
						return model;
					}
				}();
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						modifModel,
						{
							pageState: _user$project$Main$Ready(newPage)
						}),
					_1: A2(_elm_lang$core$Platform_Cmd$map, toMsg, pageCmd)
				};
			});
		var getTxt = A2(_user$project$Helpers_Data_Language$getTxt, model.langDict, model.language);
		var _p14 = msg;
		switch (_p14.ctor) {
			case 'WindowResized':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							device: _mdgriffith$style_elements$Element$classifyDevice(_p14._0)
						}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'CheckTokenCompleted':
				var _p17 = _p14._0;
				if (_p14._1) {
					return A2(_user$project$Main$setPage, _p17, model);
				} else {
					var _p15 = _user$project$Main$clearSession(model);
					var clearSessionModel = _p15._0;
					var clearSessionCmd = _p15._1;
					var _p16 = A2(_user$project$Main$redirectToLogin, _p17, clearSessionModel);
					var rrtlModel = _p16._0;
					var rrtlCmd = _p16._1;
					return {
						ctor: '_Tuple2',
						_0: rrtlModel,
						_1: _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: clearSessionCmd,
								_1: {
									ctor: '::',
									_0: rrtlCmd,
									_1: {ctor: '[]'}
								}
							})
					};
				}
			case 'SetPage':
				return A2(_user$project$Main$setPage, _p14._0, model);
			case 'LanguageChanged':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{language: _p14._0}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SetToken':
				var session = model.session;
				var homePage = _user$project$Helpers_Data_JwtToken$getClaim(session.token);
				var cmd = _elm_lang$core$Native_Utils.eq(session.token, _elm_lang$core$Maybe$Nothing) ? _user$project$Routing$modifyUrl(_user$project$Routing$Login) : _elm_lang$core$Platform_Cmd$none;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							session: _elm_lang$core$Native_Utils.update(
								session,
								{token: _p14._0})
						}),
					_1: cmd
				};
			case 'LoginMsg':
				var _p18 = page;
				if (_p18.ctor === 'Login') {
					var _p24 = _p18._0;
					var _p19 = A2(_user$project$Pages_Login$update, _p14._0, _p18._1);
					var newPageModel = _p19._0;
					var cmd = _p19._1;
					var msgFromPage = _p19._2;
					var _p20 = function () {
						var _p21 = msgFromPage;
						if (_p21.ctor === 'NoOutMsg') {
							return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
						} else {
							var _p23 = _p21._1;
							var token = _user$project$Helpers_Data_JwtToken$fromString(_p23);
							var hasRole = _user$project$Data_Role$hasRole(token);
							var firstPageRoute = function () {
								var _p22 = _p24;
								if (_p22.ctor === 'Just') {
									return _p22._0;
								} else {
									return (hasRole(_user$project$Data_Role$TreeEditor) || (hasRole(_user$project$Data_Role$TreeReader) || hasRole(_user$project$Data_Role$TreeLocalEditor))) ? _user$project$Routing$TreeMap : _user$project$Routing$Login;
								}
							}();
							var session = model.session;
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										session: {
											token: token,
											user: _elm_lang$core$Maybe$Just(_p21._0)
										}
									}),
								_1: _elm_lang$core$Platform_Cmd$batch(
									{
										ctor: '::',
										_0: _user$project$Ports$storeSession(
											_elm_lang$core$Maybe$Just(_p23)),
										_1: {
											ctor: '::',
											_0: _user$project$Routing$modifyUrl(firstPageRoute),
											_1: {ctor: '[]'}
										}
									})
							};
						}
					}();
					var newModel = _p20._0;
					var newCmd = _p20._1;
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							newModel,
							{
								pageState: _user$project$Main$Ready(
									A2(_user$project$Main$Login, _p24, newPageModel))
							}),
						_1: _elm_lang$core$Platform_Cmd$batch(
							{
								ctor: '::',
								_0: newCmd,
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Main$LoginMsg, cmd),
									_1: {ctor: '[]'}
								}
							})
					};
				} else {
					return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
				}
			default:
				var _p25 = page;
				if (_p25.ctor === 'TreeMap') {
					return A5(
						updateModelCmd,
						_user$project$Main$TreeMap,
						_user$project$Main$TreeMapMsg,
						_user$project$Pages_TreeMap$update(getTxt),
						_p14._0,
						_p25._0);
				} else {
					return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
				}
		}
	});
var _user$project$Main$update = F2(
	function (msg, model) {
		return A3(
			_user$project$Main$updatePage,
			_user$project$Main$getPage(model.pageState),
			msg,
			model);
	});
var _user$project$Main$SetToken = function (a) {
	return {ctor: 'SetToken', _0: a};
};
var _user$project$Main$LanguageChanged = function (a) {
	return {ctor: 'LanguageChanged', _0: a};
};
var _user$project$Main$viewPage = F3(
	function (model, isLoading, page) {
		var getTxt = A2(_user$project$Helpers_Data_Language$getTxt, model.langDict, model.language);
		var buildPage = F4(
			function (mayTitle, mayManuelUrl, pageType, content) {
				return _user$project$Views_Page$viewPage(
					{toUiTxt: getTxt, session: model.session, langToMsg: _user$project$Main$LanguageChanged, curLang: model.language, mayTitle: mayTitle, pageType: pageType, device: model.device, content: content, mayManuelUrl: mayManuelUrl});
			});
		var _p26 = page;
		switch (_p26.ctor) {
			case 'None':
				return A4(
					buildPage,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_user$project$Views_Page$NoHeader,
					_mdgriffith$style_elements$Element$text('No such page'));
			case 'Errored':
				return A4(
					buildPage,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_user$project$Views_Page$NoHeader,
					_mdgriffith$style_elements$Element$html(
						_user$project$Helpers_Views_Errored$view(_p26._0)));
			case 'Login':
				return A4(
					buildPage,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_user$project$Views_Page$Login,
					_mdgriffith$style_elements$Element$html(
						A2(
							_elm_lang$html$Html$map,
							_user$project$Main$LoginMsg,
							A2(_user$project$Pages_Login$view, getTxt, _p26._1))));
			default:
				return A4(
					buildPage,
					_elm_lang$core$Maybe$Just('page_treemap'),
					_elm_lang$core$Maybe$Just('./documents/trees/manuelUtilisateur.pdf'),
					_user$project$Views_Page$TreeMap,
					A2(
						_mdgriffith$style_elements$Element$map,
						_user$project$Main$TreeMapMsg,
						A5(_user$project$Pages_TreeMap$view, model.language, getTxt, model.device, model.session, _p26._0)));
		}
	});
var _user$project$Main$view = function (model) {
	var _p27 = model.pageState;
	if (_p27.ctor === 'Ready') {
		return A3(_user$project$Main$viewPage, model, false, _p27._0);
	} else {
		return A3(_user$project$Main$viewPage, model, true, _p27._0);
	}
};
var _user$project$Main$SetPage = function (a) {
	return {ctor: 'SetPage', _0: a};
};
var _user$project$Main$CheckTokenCompleted = F2(
	function (a, b) {
		return {ctor: 'CheckTokenCompleted', _0: a, _1: b};
	});
var _user$project$Main$WindowResized = function (a) {
	return {ctor: 'WindowResized', _0: a};
};
var _user$project$Main$init = F2(
	function (flags, location) {
		var initWinSize = A2(_elm_lang$core$Task$perform, _user$project$Main$WindowResized, _elm_lang$window$Window$size);
		var mayRoute = _user$project$Routing$fromLocation(location);
		var mayToken = _user$project$Helpers_Data_JwtToken$fromString(flags.authToken);
		var baseModel = {
			session: {token: mayToken, user: _elm_lang$core$Maybe$Nothing},
			pageState: _user$project$Main$Ready(_user$project$Main$None),
			baseUrl: flags.baseUrl,
			language: A2(_user$project$Helpers_Data_Language$fromStringWithDefault, _user$project$Helpers_Data_Language$FR, flags.language),
			langDict: _user$project$Helpers_Data_Language$dictFromKeyVals(flags.uiKeyVals),
			device: _mdgriffith$style_elements$Element$classifyDevice(
				{width: 500, height: 800}),
			treeMapModel: _elm_lang$core$Maybe$Nothing
		};
		var _p28 = function () {
			var _p29 = mayToken;
			if (_p29.ctor === 'Nothing') {
				var _p30 = A2(_user$project$Main$redirectToLogin, mayRoute, baseModel);
				var setPageModel = _p30._0;
				var setPageCmd = _p30._1;
				return {
					ctor: '_Tuple2',
					_0: setPageModel,
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: initWinSize,
							_1: {
								ctor: '::',
								_0: setPageCmd,
								_1: {ctor: '[]'}
							}
						})
				};
			} else {
				var checkTokenCmd = A3(
					_user$project$Helpers_Data_JwtToken$checkToken,
					_p29._0,
					A2(_elm_lang$core$Basics_ops['++'], baseModel.baseUrl, 'protected/test-token.json'),
					_user$project$Main$CheckTokenCompleted(mayRoute));
				return {
					ctor: '_Tuple2',
					_0: baseModel,
					_1: _elm_lang$core$Platform_Cmd$batch(
						{
							ctor: '::',
							_0: initWinSize,
							_1: {
								ctor: '::',
								_0: checkTokenCmd,
								_1: {ctor: '[]'}
							}
						})
				};
			}
		}();
		var initModel = _p28._0;
		var initCmd = _p28._1;
		return {ctor: '_Tuple2', _0: initModel, _1: initCmd};
	});
var _user$project$Main$subscriptions = function (model) {
	return _elm_lang$core$Platform_Sub$batch(
		{
			ctor: '::',
			_0: _elm_lang$window$Window$resizes(_user$project$Main$WindowResized),
			_1: {
				ctor: '::',
				_0: _user$project$Main$pageSubscriptions(
					_user$project$Main$getPage(model.pageState)),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$core$Platform_Sub$map, _user$project$Main$SetToken, _user$project$Main$sessionChange),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _user$project$Main$main = A2(
	_elm_lang$navigation$Navigation$programWithFlags,
	function (_p31) {
		return _user$project$Main$SetPage(
			_user$project$Routing$fromLocation(_p31));
	},
	{init: _user$project$Main$init, view: _user$project$Main$view, update: _user$project$Main$update, subscriptions: _user$project$Main$subscriptions})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (authToken) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (baseUrl) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (language) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (uiKeyVals) {
									return _elm_lang$core$Json_Decode$succeed(
										{authToken: authToken, baseUrl: baseUrl, language: language, uiKeyVals: uiKeyVals});
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'uiKeyVals',
									_elm_lang$core$Json_Decode$list(
										A2(
											_elm_lang$core$Json_Decode$andThen,
											function (x0) {
												return A2(
													_elm_lang$core$Json_Decode$andThen,
													function (x1) {
														return _elm_lang$core$Json_Decode$succeed(
															{ctor: '_Tuple2', _0: x0, _1: x1});
													},
													A2(
														_elm_lang$core$Json_Decode$index,
														1,
														_elm_lang$core$Json_Decode$list(
															A2(
																_elm_lang$core$Json_Decode$andThen,
																function (x0) {
																	return A2(
																		_elm_lang$core$Json_Decode$andThen,
																		function (x1) {
																			return _elm_lang$core$Json_Decode$succeed(
																				{ctor: '_Tuple2', _0: x0, _1: x1});
																		},
																		A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string));
																},
																A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string)))));
											},
											A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string)))));
						},
						A2(_elm_lang$core$Json_Decode$field, 'language', _elm_lang$core$Json_Decode$string));
				},
				A2(_elm_lang$core$Json_Decode$field, 'baseUrl', _elm_lang$core$Json_Decode$string));
		},
		A2(_elm_lang$core$Json_Decode$field, 'authToken', _elm_lang$core$Json_Decode$string)));

var Elm = {};
Elm['Main'] = Elm['Main'] || {};
if (typeof _user$project$Main$main !== 'undefined') {
    _user$project$Main$main(Elm['Main'], 'Main', undefined);
}

if (typeof define === "function" && define['amd'])
{
  define([], function() { return Elm; });
  return;
}

if (typeof module === "object")
{
  module['exports'] = Elm;
  return;
}

var globalElm = this['Elm'];
if (typeof globalElm === "undefined")
{
  this['Elm'] = Elm;
  return;
}

for (var publicModule in Elm)
{
  if (publicModule in globalElm)
  {
    throw new Error('There are two Elm modules called `' + publicModule + '` on this page! Rename one of them.');
  }
  globalElm[publicModule] = Elm[publicModule];
}

}).call(this);

